webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.20.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            __webpack_require__(462)("./" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, expectedWeekday, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString(keepOffset) {
    if (!this.isValid()) {
        return null;
    }
    var utc = keepOffset !== true;
    var m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
            return this.toDate().toISOString();
        } else {
            return new Date(this._d.valueOf()).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
    }
    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.20.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

// currently HTML5 input type only supports 24-hour formats
hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',                             // <input type="date" />
    TIME: 'HH:mm',                                  // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
    MONTH: 'YYYY-MM'                                // <input type="month" />
};

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(105)(module)))

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_service_auth_service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_service_movie_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_service_movie_meta_service__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_service_region_service__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_service_seat_grid_service__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_service_order_service__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_service_loyalty_card_service__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_service_error_description_service__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_service_contact_us_service__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_service_page_service__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_service_film_festival_service__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_service_error_handler__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_service_preview_service__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_service_ecom_tracking_service__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_service_adumo_service__ = __webpack_require__(476);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_service_auth_service__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__src_service_movie_service__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_3__src_service_region_service__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__src_service_movie_meta_service__["a"]; });
/* unused harmony reexport SeatGridService */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__src_service_order_service__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__src_service_loyalty_card_service__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__src_service_error_description_service__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__src_service_contact_us_service__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_9__src_service_page_service__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_10__src_service_film_festival_service__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_11__src_service_error_handler__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__src_service_preview_service__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_13__src_service_ecom_tracking_service__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__src_service_adumo_service__["a"]; });


















/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			currentURL: "https://www.sterkinekor.com" + (window.location.path != undefined ? window.location.path : ''),
			metaTitle: '',
			metaImage: '' || 'https://www.sterkinekor.com/static/img/sk-logo.png',
			metaDescription: '',
			schemaDataSrc: '',
			metaCanonicalURL: "https://www.sterkinekor.com" + this.$route.fullPath
		};
	},


	head: {
		title: function title() {
			return {
				inner: this.metaTitle
			};
		},
		meta: function meta() {

			return [{ name: 'title', content: this.metaTitle }, { name: 'description', content: this.metaDescription }, { name: 'og:title', content: this.metaTitle }, { name: 'og:type', content: 'website' }, { name: 'og:url', content: this.currentURL }, { name: 'og:image', content: this.metaImage }, { name: 'og:description', content: this.metaDescription }, { name: 'og:site_name', content: 'Ster-Kinekor' }];
		},
		script: function script() {
			return [{
				type: 'application/ld+json', inner: this.schemaDataSrc ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.schemaDataSrc) : ''
			}];
		},
		link: function link() {
			return [{ rel: 'canonical', href: this.metaCanonicalURL }];
		}
	}
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseModel = function BaseModel() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    _classCallCheck(this, BaseModel);
};

/* harmony default export */ __webpack_exports__["a"] = (BaseModel);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["SKCoreUi"] = factory();
	else
		root["SKCoreUi"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 294);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.20.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            __webpack_require__(138)("./" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, expectedWeekday, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString(keepOffset) {
    if (!this.isValid()) {
        return null;
    }
    var utc = keepOffset !== true;
    var m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
            return this.toDate().toISOString();
        } else {
            return new Date(this._d.valueOf()).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
    }
    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.20.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

// currently HTML5 input type only supports 24-hour formats
hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',                             // <input type="date" />
    TIME: 'HH:mm',                                  // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
    MONTH: 'YYYY-MM'                                // <input type="month" />
};

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(293)(module)))

/***/ },
/* 1 */
/***/ function(module, exports) {

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = options.computed || (options.computed = {})
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony default export */ exports["a"] = {
  data: function data () {
    return {
      isActive: !!this.value
    }
  },

  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value (val) {

       this.isActive = val;
    },
    isActive: function isActive (val) {
      this.$emit('input', val)
    }
  }
};


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ exports["b"] = createSimpleFunctional;
/* harmony export (immutable) */ exports["c"] = closestParentTag;
/* harmony export (immutable) */ exports["a"] = createSimpleTransition;
/* harmony export (immutable) */ exports["d"] = addOnceEventListener;
/* unused harmony export prefixedTransform */
/* harmony export (immutable) */ exports["f"] = debounce;
/* harmony export (immutable) */ exports["e"] = findChildComponents;
/* harmony export (immutable) */ exports["g"] = MonthMeta;
/* unused harmony export deepClone */

function createSimpleFunctional (c, el) {
  if ( el === void 0 ) el = 'div';

  return {
    functional: true,

    render: function (h, ref) {
      var data = ref.data;
      var children = ref.children;

      data.staticClass = data.staticClass ? (c + " " + (data.staticClass)) : c;

      return h(el, data, children)
    }
  }
}

function closestParentTag (tag) {
  var parent = this.$parent

  while (parent) {
    if (!parent.$options._componentTag) { return null }
    if (parent.$options._componentTag === tag) { return parent }

    parent = parent.$parent
  }

  return null
}

function createSimpleTransition (name) {
  return {
    functional: true,

    render: function render (h, context) {
      var origin = (context.data.attrs || context.data.props || {}).origin || 'top center 0'
      context.data = context.data || {}
      context.data.props = { name: name }
      context.data.on = context.data.on || {}

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin
        el.style.webkitTransformOrigin = origin
      }

      return h('transition', context.data, context.children)
    }
  }
}

function addOnceEventListener (el, event, cb) {
  var once = function () {
    cb()
    el.removeEventListener(event, once, false)
  }

  el.addEventListener(event, once, false)
}

var cachedTransformResult = null;
function prefixedTransform() {
  if(cachedTransformResult) { return cachedTransformResult; }

  var t = 'transform';
  var testEl = document.createElement('div');
  if(testEl.style.transform == null) {
    var vendors = ['Webkit', 'Moz', 'ms'];
    for(var i in vendors) {
      if(testEl.style[ vendors[i] + 'Transform' ] !== undefined) {
        t = vendors[i] + 'Transform';
        break;
      }
    }
  }

  cachedTransformResult = t;
  return cachedTransformResult;
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `execAsap` is passed, trigger the function on the
// leading edge, instead of the trailing.
//
// Example:
// var calculateLayout = function () { ... }
// window.addEventListner('resize', debounce(calculateLayout, 300)
function debounce (func, threshold, execAsap) {
  var timeout

  return function debounced () {
    var obj = this
    var args = arguments

    function delayed () {
      if (!execAsap) { func.apply(obj, args) }
      timeout = null
    }

    if (timeout) {
      clearTimeout(timeout)
    } else if (execAsap) {
      func.apply(obj, args)
    }
    timeout = setTimeout(delayed, threshold || 100)
  }
}

function findChildComponents(component, filter, result) {
  if ( result === void 0 ) result = [];

  for (var i = 0; i < component.$children.length; i++) {
    var child = component.$children[i];
    if (!filter || filter(child) === true) {
      result.push(child);
    }
    if (child.$children) {
      findChildComponents(child, filter, result)
    }
  }
  return result;
}

function MonthMeta() {

  return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}

function deepClone (obj) {
  if (Array.isArray(obj)) {
    return obj.map(deepClone)
  } else if (obj && typeof obj === 'object') {
    var cloned = {}
    var keys = Object.keys(obj)
    for (var i = 0, l = keys.length; i < l; i++) {
      var key = keys[i]
      cloned[key] = deepClone(obj[key])
    }
    return cloned
  } else {
    return obj
  }
}


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
var control_uid_generator = 0

/* harmony default export */ exports["a"] = {

  props: {
    value: { required: true },
    label: String,
    light: Boolean
  },

  data: function data () {
    return {
      control_id: ("control-" + (control_uid_generator++)),
      hasAppendContent: false,
      hasPrependContent: false,
      hasHelpContent: false,
      hasStyledHelpContent: false
    }
  },

  computed: {
    form_group_classes: function form_group_classes() {
      return Object.assign({
        'form-group': true,
        'form-control--light': this.light,
        'input-help': this.hasHelpContent || this.hasStyledHelpContent
      }, this.validation_classes)
    },

    isGroup: function isGroup() {
      return this.hasAppendContent || this.hasPrependContent || this.show_error || this.show_success
    },

  },

  mounted: function mounted() {
    this.checkSlotContent()
  },

  updated: function updated() {
    this.checkSlotContent()
  },

  methods: {
    checkSlotContent: function checkSlotContent () {
      this.hasAppendContent = this.$slots['append'] != null
      this.hasPrependContent = this.$slots['prepend'] != null
      this.hasHelpContent = this.$slots['help'] != null
      this.hasStyledHelpContent = this.$slots['helpStyled'] != null
    }
  }
};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(3);

/* harmony default export */ exports["a"] = {


    props: {
        errorMessage: {type: Object, default: function () { return ({}); }},
        // Custom validation properties
        'creditCard': {type: Boolean, default: undefined},
        'idNumber': {type: Boolean, default: undefined},
        'exactly': [String, Number],
        'startsWith': [String, Number],
        'endsWith': [String, Number],
        'exactLength': Number,
    },

    data: function data () {
        return {
            _isValidatable: true,
            nativeInvalid: false, // browser dispatched an "invalid" event from the <input>
            inputLeftDirty: false, // the input was modified, and then lost focus
            first_run: true,
            valid: true,
            errors: [],
            originalValue: this.value,
            timeout:null,
        }
    },

    mounted: function mounted() {
        if (!this.$refs.controlEl) { console.warn('The validatable mixin requires a control element reference') }
        this.validate()
    },

    updated: function updated() {
        if (this.first_run) { // After the first update, validate the initial value of the input
            this.first_run = false;
            this.validate();
        }
    },

    watch: {
        //not ideal fix but implemented for sk-combo-select
        value: function value(value$1, oldValue) {
            var this$1 = this;

            if (value$1 != oldValue) {
                if(this.timeout) { clearTimeout(this.timeout); }
                this.timeout = setTimeout(function (){
                    this$1.validate();
                },500)

            }

        },

        errors: function errors() {
            this.$emit('errors', this.errors)
        }
    },

    computed: {
        validation_classes: function validation_classes() {
            return {
                'has-error': this.show_error,
                'is-valid': this.show_success,
            }
        },

        show_error: function show_error() {
            var showError = !this.valid && (this.nativeInvalid || this.inputLeftDirty)
            this.$emit('showerror', showError)
            return showError
        },
    },

    methods: {

        onBlur: function onBlur(event) {
            var dirty = this.originalValue != this.value;
            if (dirty) { this.inputLeftDirty = true; }
            this.validate();
        },

        onInvalid: function onInvalid(event) {
            this.nativeInvalid = true;
            this.validate();
        },

        validate: function validate() {
            var this$1 = this;

            if (this._isDestroyed) { return; }

            this.errors = [];

            // Check if standard HTML rules pass
            if (this.$refs.controlEl.validity.valid === false) {
                var state = this.$refs.controlEl.validity;
                for (var prop in state) {
                    if (state[prop] === true) {
                        this$1.errors.push(generateError(this$1, prop));
                    }
                }
            }

            // Check if custom rules pass
            for (var rule in validators) {
                if (this$1[rule] !== undefined) {
                    var passed = validators[rule](this$1, this$1[rule]);
                    if (passed === false) {
                        this$1.errors.push(generateError(this$1, rule));
                    }
                }
            }

            this.valid = this.errors.length === 0;
        }
    }
};

function generateError(field, errorType) {
    // Handle special 'typeMismatch' error cases
    if (errorType === 'typeMismatch') {
        var type = field.$refs.controlEl.getAttribute('type')
        switch (type) {
            case 'email':
                return getErrorMessage(field, 'emailMismatch');
                break;
            case 'url':
                return getErrorMessage(field, 'urlMismatch');
                break;
            case 'number':
                return getErrorMessage(field, 'numberMismatch');
                break;
        }
    }
    // All other error types
    else {
        return getErrorMessage(field, errorType);
    }
}

function getErrorMessage(field, errorType) {
    var controlEl = field.$refs.controlEl
    if (field.errorMessage[errorType]) { return field.errorMessage[errorType] }
    var name = field.label || 'Field';
    return {
        // Standard validation
        badInput: "Bad input",
        valueMissing: (name + " is required"),
        tooShort: (name + " is too short. It must be at least " + (controlEl.getAttribute('minlength')) + " characters long"),
        tooLong: (name + " is too long. It can only be " + (controlEl.getAttribute('maxlength')) + " characters long"),
        typeMismatch: (name + " must match requested format."),
        emailMismatch: "Please make sure your email address follows this format: example@email.com",
        urlMismatch: (name + " must be a valid url."),
        numberMismatch: (name + " must be a valid number."),
        rangeOverflow: (name + " must be less than or equal to " + (controlEl.getAttribute('max')) + "."),
        rangeUnderflow: (name + " must be greater than or equal to " + (controlEl.getAttribute('min')) + "."),
        stepMismatch: (name + " must match requested format."),
        patternMismatch: (name + " must match requested format."),

        // Custom validation
        creditCard: (name + " must be a valid credit card number."),
        idNumber: (name + " must be a valid ID number."),
        startsWith: (name + " must start with " + (field.startsWith) + "."),
        endsWith: (name + " must end with " + (field.endsWith) + "."),
        exactly: (name + " must be equal to " + (field.exactly) + "."),
        exactLength: (name + " must contain exactly " + (field.exactLength) + " characters."),

    }[errorType];
}

var validators = {

    creditCard: function creditCard(input) {
        return creditCardTest.test(input.value)
    },

    saMobile: function saMobile(input) {
        return saMobileTest.test(input.value)
    },

    idNumber: function idNumber(input) {
        return this.exactLength(input, 13)
    },

    exactly: function exactly(input, condition) {
        return input.value === condition;
    },

    startsWith: function startsWith(input, condition) {
        return input.value.startsWith(condition);
    },

    endsWith: function endsWith(input, condition) {
        return input.value.endsWith(condition);
    },

    exactLength: function exactLength(input, condition) {
        var val = input.value ? String(input.value) : null;
        return val && val.length === condition;
    },
}

var creditCardTest = new RegExp(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/);

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.VueMultiselect=e():t.VueMultiselect=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/",e(e.s=60)}([function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e,n){var i=n(49)("wks"),r=n(30),o=n(0).Symbol,s="function"==typeof o;(t.exports=function(t){return i[t]||(i[t]=s&&o[t]||(s?o:r)("Symbol."+t))}).store=i},function(t,e,n){var i=n(5);t.exports=function(t){if(!i(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){var i=n(0),r=n(10),o=n(8),s=n(6),u=n(11),a=function(t,e,n){var l,c,f,p,h=t&a.F,d=t&a.G,v=t&a.S,g=t&a.P,y=t&a.B,m=d?i:v?i[e]||(i[e]={}):(i[e]||{}).prototype,b=d?r:r[e]||(r[e]={}),_=b.prototype||(b.prototype={});d&&(n=e);for(l in n)c=!h&&m&&void 0!==m[l],f=(c?m:n)[l],p=y&&c?u(f,i):g&&"function"==typeof f?u(Function.call,f):f,m&&s(m,l,f,t&a.U),b[l]!=f&&o(b,l,p),g&&_[l]!=f&&(_[l]=f)};i.core=r,a.F=1,a.G=2,a.S=4,a.P=8,a.B=16,a.W=32,a.U=64,a.R=128,t.exports=a},function(t,e,n){t.exports=!n(7)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){var i=n(0),r=n(8),o=n(12),s=n(30)("src"),u=Function.toString,a=(""+u).split("toString");n(10).inspectSource=function(t){return u.call(t)},(t.exports=function(t,e,n,u){var l="function"==typeof n;l&&(o(n,"name")||r(n,"name",e)),t[e]!==n&&(l&&(o(n,s)||r(n,s,t[e]?""+t[e]:a.join(String(e)))),t===i?t[e]=n:u?t[e]?t[e]=n:r(t,e,n):(delete t[e],r(t,e,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[s]||u.call(this)})},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var i=n(13),r=n(25);t.exports=n(4)?function(t,e,n){return i.f(t,e,r(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){var n=t.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(t,e,n){var i=n(14);t.exports=function(t,e,n){if(i(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,i){return t.call(e,n,i)};case 3:return function(n,i,r){return t.call(e,n,i,r)}}return function(){return t.apply(e,arguments)}}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var i=n(2),r=n(41),o=n(29),s=Object.defineProperty;e.f=n(4)?Object.defineProperty:function(t,e,n){if(i(t),e=o(e,!0),i(n),r)try{return s(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){t.exports={}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){"use strict";var i=n(7);t.exports=function(t,e){return!!t&&i(function(){e?t.call(null,function(){},1):t.call(null)})}},function(t,e,n){var i=n(23),r=n(16);t.exports=function(t){return i(r(t))}},function(t,e,n){var i=n(53),r=Math.min;t.exports=function(t){return t>0?r(i(t),9007199254740991):0}},function(t,e,n){var i=n(11),r=n(23),o=n(28),s=n(19),u=n(64);t.exports=function(t,e){var n=1==t,a=2==t,l=3==t,c=4==t,f=6==t,p=5==t||f,h=e||u;return function(e,u,d){for(var v,g,y=o(e),m=r(y),b=i(u,d,3),_=s(m.length),x=0,w=n?h(e,_):a?h(e,0):void 0;_>x;x++)if((p||x in m)&&(v=m[x],g=b(v,x,y),t))if(n)w[x]=g;else if(g)switch(t){case 3:return!0;case 5:return v;case 6:return x;case 2:w.push(v)}else if(c)return!1;return f?-1:l||c?c:w}}},function(t,e,n){var i=n(5),r=n(0).document,o=i(r)&&i(r.createElement);t.exports=function(t){return o?r.createElement(t):{}}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){var i=n(9);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==i(t)?t.split(""):Object(t)}},function(t,e){t.exports=!1},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var i=n(13).f,r=n(12),o=n(1)("toStringTag");t.exports=function(t,e,n){t&&!r(t=n?t:t.prototype,o)&&i(t,o,{configurable:!0,value:e})}},function(t,e,n){var i=n(49)("keys"),r=n(30);t.exports=function(t){return i[t]||(i[t]=r(t))}},function(t,e,n){var i=n(16);t.exports=function(t){return Object(i(t))}},function(t,e,n){var i=n(5);t.exports=function(t,e){if(!i(t))return t;var n,r;if(e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;if("function"==typeof(n=t.valueOf)&&!i(r=n.call(t)))return r;if(!e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;throw TypeError("Can't convert object to primitive value")}},function(t,e){var n=0,i=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+i).toString(36))}},function(t,e,n){"use strict";var i=n(0),r=n(12),o=n(9),s=n(67),u=n(29),a=n(7),l=n(77).f,c=n(45).f,f=n(13).f,p=n(51).trim,h=i.Number,d=h,v=h.prototype,g="Number"==o(n(44)(v)),y="trim"in String.prototype,m=function(t){var e=u(t,!1);if("string"==typeof e&&e.length>2){e=y?e.trim():p(e,3);var n,i,r,o=e.charCodeAt(0);if(43===o||45===o){if(88===(n=e.charCodeAt(2))||120===n)return NaN}else if(48===o){switch(e.charCodeAt(1)){case 66:case 98:i=2,r=49;break;case 79:case 111:i=8,r=55;break;default:return+e}for(var s,a=e.slice(2),l=0,c=a.length;l<c;l++)if((s=a.charCodeAt(l))<48||s>r)return NaN;return parseInt(a,i)}}return+e};if(!h(" 0o1")||!h("0b1")||h("+0x1")){h=function(t){var e=arguments.length<1?0:t,n=this;return n instanceof h&&(g?a(function(){v.valueOf.call(n)}):"Number"!=o(n))?s(new d(m(e)),n,h):m(e)};for(var b,_=n(4)?l(d):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),x=0;_.length>x;x++)r(d,b=_[x])&&!r(h,b)&&f(h,b,c(d,b));h.prototype=v,v.constructor=h,n(6)(i,"Number",h)}},function(t,e,n){"use strict";function i(t){return 0!==t&&(!(!Array.isArray(t)||0!==t.length)||!t)}function r(t){return function(){return!t.apply(void 0,arguments)}}function o(t,e){return void 0===t&&(t="undefined"),null===t&&(t="null"),!1===t&&(t="false"),-1!==t.toString().toLowerCase().indexOf(e.trim())}function s(t,e,n,i){return t.filter(function(t){return o(i(t,n),e)})}function u(t){return t.filter(function(t){return!t.$isLabel})}function a(t,e){return function(n){return n.reduce(function(n,i){return i[t]&&i[t].length?(n.push({$groupLabel:i[e],$isLabel:!0}),n.concat(i[t])):n},[])}}function l(t,e,i,r,o){return function(u){return u.map(function(u){var a;if(!u[i])return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."),[];var l=s(u[i],t,e,o);return l.length?(a={},n.i(d.a)(a,r,u[r]),n.i(d.a)(a,i,l),a):[]})}}var c=n(59),f=n(54),p=(n.n(f),n(95)),h=(n.n(p),n(31)),d=(n.n(h),n(58)),v=n(91),g=(n.n(v),n(98)),y=(n.n(g),n(92)),m=(n.n(y),n(88)),b=(n.n(m),n(97)),_=(n.n(b),n(89)),x=(n.n(_),n(96)),w=(n.n(x),n(93)),S=(n.n(w),n(90)),O=(n.n(S),function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return function(t){return e.reduce(function(t,e){return e(t)},t)}});e.a={data:function(){return{search:"",isOpen:!1,preferredOpenDirection:"below",optimizedHeight:this.maxHeight}},props:{internalSearch:{type:Boolean,default:!0},options:{type:Array,required:!0},multiple:{type:Boolean,default:!1},value:{type:null,default:function(){return[]}},trackBy:{type:String},label:{type:String},searchable:{type:Boolean,default:!0},clearOnSelect:{type:Boolean,default:!0},hideSelected:{type:Boolean,default:!1},placeholder:{type:String,default:"Select option"},allowEmpty:{type:Boolean,default:!0},resetAfter:{type:Boolean,default:!1},closeOnSelect:{type:Boolean,default:!0},customLabel:{type:Function,default:function(t,e){return i(t)?"":e?t[e]:t}},taggable:{type:Boolean,default:!1},tagPlaceholder:{type:String,default:"Press enter to create a tag"},tagPosition:{type:String,default:"top"},max:{type:[Number,Boolean],default:!1},id:{default:null},optionsLimit:{type:Number,default:1e3},groupValues:{type:String},groupLabel:{type:String},groupSelect:{type:Boolean,default:!1},blockKeys:{type:Array,default:function(){return[]}},preserveSearch:{type:Boolean,default:!1},preselectFirst:{type:Boolean,default:!1}},mounted:function(){!this.multiple&&this.max&&console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."),this.preselectFirst&&!this.internalValue.length&&this.options.length&&this.select(this.filteredOptions[0])},computed:{internalValue:function(){return this.value||0===this.value?Array.isArray(this.value)?this.value:[this.value]:[]},filteredOptions:function(){var t=this.search||"",e=t.toLowerCase().trim(),n=this.options.concat();return n=this.internalSearch?this.groupValues?this.filterAndFlat(n,e,this.label):s(n,e,this.label,this.customLabel):this.groupValues?a(this.groupValues,this.groupLabel)(n):n,n=this.hideSelected?n.filter(r(this.isSelected)):n,this.taggable&&e.length&&!this.isExistingOption(e)&&("bottom"===this.tagPosition?n.push({isTag:!0,label:t}):n.unshift({isTag:!0,label:t})),n.slice(0,this.optionsLimit)},valueKeys:function(){var t=this;return this.trackBy?this.internalValue.map(function(e){return e[t.trackBy]}):this.internalValue},optionKeys:function(){var t=this;return(this.groupValues?this.flatAndStrip(this.options):this.options).map(function(e){return t.customLabel(e,t.label).toString().toLowerCase()})},currentOptionLabel:function(){return this.multiple?this.searchable?"":this.placeholder:this.internalValue.length?this.getOptionLabel(this.internalValue[0]):this.searchable?"":this.placeholder}},watch:{internalValue:function(){this.resetAfter&&this.internalValue.length&&(this.search="",this.$emit("input",this.multiple?[]:null))},search:function(){this.$emit("search-change",this.search,this.id)}},methods:{getValue:function(){return this.multiple?this.internalValue:0===this.internalValue.length?null:this.internalValue[0]},filterAndFlat:function(t,e,n){return O(l(e,n,this.groupValues,this.groupLabel,this.customLabel),a(this.groupValues,this.groupLabel))(t)},flatAndStrip:function(t){return O(a(this.groupValues,this.groupLabel),u)(t)},updateSearch:function(t){this.search=t},isExistingOption:function(t){return!!this.options&&this.optionKeys.indexOf(t)>-1},isSelected:function(t){var e=this.trackBy?t[this.trackBy]:t;return this.valueKeys.indexOf(e)>-1},isOptionDisabled:function(t){return!!t.$isDisabled},getOptionLabel:function(t){if(i(t))return"";if(t.isTag)return t.label;if(t.$isLabel)return t.$groupLabel;var e=this.customLabel(t,this.label);return i(e)?"":e},select:function(t,e){if(t.$isLabel&&this.groupSelect)return void this.selectGroup(t);if(!(-1!==this.blockKeys.indexOf(e)||this.disabled||t.$isDisabled||t.$isLabel)&&(!this.max||!this.multiple||this.internalValue.length!==this.max)&&("Tab"!==e||this.pointerDirty)){if(t.isTag)this.$emit("tag",t.label,this.id),this.search="",this.closeOnSelect&&!this.multiple&&this.deactivate();else{if(this.isSelected(t))return void("Tab"!==e&&this.removeElement(t));this.$emit("select",t,this.id),this.multiple?this.$emit("input",this.internalValue.concat([t]),this.id):this.$emit("input",t,this.id),this.clearOnSelect&&(this.search="")}this.closeOnSelect&&this.deactivate()}},selectGroup:function(t){var e=this,n=this.options.find(function(n){return n[e.groupLabel]===t.$groupLabel});if(n)if(this.wholeGroupSelected(n)){this.$emit("remove",n[this.groupValues],this.id);var i=this.internalValue.filter(function(t){return-1===n[e.groupValues].indexOf(t)});this.$emit("input",i,this.id)}else{var r=n[this.groupValues].filter(function(t){return!(e.isOptionDisabled(t)||e.isSelected(t))});this.$emit("select",r,this.id),this.$emit("input",this.internalValue.concat(r),this.id)}},wholeGroupSelected:function(t){var e=this;return t[this.groupValues].every(function(t){return e.isSelected(t)||e.isOptionDisabled(t)})},wholeGroupDisabled:function(t){return t[this.groupValues].every(this.isOptionDisabled)},removeElement:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(!this.disabled&&!t.$isDisabled){if(!this.allowEmpty&&this.internalValue.length<=1)return void this.deactivate();var i="object"===n.i(c.a)(t)?this.valueKeys.indexOf(t[this.trackBy]):this.valueKeys.indexOf(t);if(this.$emit("remove",t,this.id),this.multiple){var r=this.internalValue.slice(0,i).concat(this.internalValue.slice(i+1));this.$emit("input",r,this.id)}else this.$emit("input",null,this.id);this.closeOnSelect&&e&&this.deactivate()}},removeLastElement:function(){-1===this.blockKeys.indexOf("Delete")&&0===this.search.length&&Array.isArray(this.internalValue)&&this.internalValue.length&&this.removeElement(this.internalValue[this.internalValue.length-1],!1)},activate:function(){var t=this;this.isOpen||this.disabled||(this.adjustPosition(),this.groupValues&&0===this.pointer&&this.filteredOptions.length&&(this.pointer=1),this.isOpen=!0,this.searchable?(this.preserveSearch||(this.search=""),this.$nextTick(function(){return t.$refs.search.focus()})):this.$el.focus(),this.$emit("open",this.id))},deactivate:function(){this.isOpen&&(this.isOpen=!1,this.searchable?this.$refs.search.blur():this.$el.blur(),this.preserveSearch||(this.search=""),this.$emit("close",this.getValue(),this.id))},toggle:function(){this.isOpen?this.deactivate():this.activate()},adjustPosition:function(){if("undefined"!=typeof window){var t=this.$el.getBoundingClientRect().top,e=window.innerHeight-this.$el.getBoundingClientRect().bottom;e>this.maxHeight||e>t||"below"===this.openDirection||"bottom"===this.openDirection?(this.preferredOpenDirection="below",this.optimizedHeight=Math.min(e-40,this.maxHeight)):(this.preferredOpenDirection="above",this.optimizedHeight=Math.min(t-40,this.maxHeight))}}}}},function(t,e,n){"use strict";var i=n(54),r=(n.n(i),n(31));n.n(r);e.a={data:function(){return{pointer:0,pointerDirty:!1}},props:{showPointer:{type:Boolean,default:!0},optionHeight:{type:Number,default:40}},computed:{pointerPosition:function(){return this.pointer*this.optionHeight},visibleElements:function(){return this.optimizedHeight/this.optionHeight}},watch:{filteredOptions:function(){this.pointerAdjust()},isOpen:function(){this.pointerDirty=!1}},methods:{optionHighlight:function(t,e){return{"multiselect__option--highlight":t===this.pointer&&this.showPointer,"multiselect__option--selected":this.isSelected(e)}},groupHighlight:function(t,e){var n=this;if(!this.groupSelect)return["multiselect__option--group","multiselect__option--disabled"];var i=this.options.find(function(t){return t[n.groupLabel]===e.$groupLabel});return i&&!this.wholeGroupDisabled(i)?["multiselect__option--group",{"multiselect__option--highlight":t===this.pointer&&this.showPointer},{"multiselect__option--group-selected":this.wholeGroupSelected(i)}]:"multiselect__option--disabled"},addPointerElement:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"Enter",e=t.key;this.filteredOptions.length>0&&this.select(this.filteredOptions[this.pointer],e),this.pointerReset()},pointerForward:function(){this.pointer<this.filteredOptions.length-1&&(this.pointer++,this.$refs.list.scrollTop<=this.pointerPosition-(this.visibleElements-1)*this.optionHeight&&(this.$refs.list.scrollTop=this.pointerPosition-(this.visibleElements-1)*this.optionHeight),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()),this.pointerDirty=!0},pointerBackward:function(){this.pointer>0?(this.pointer--,this.$refs.list.scrollTop>=this.pointerPosition&&(this.$refs.list.scrollTop=this.pointerPosition),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerBackward()):this.filteredOptions[this.pointer]&&this.filteredOptions[0].$isLabel&&!this.groupSelect&&this.pointerForward(),this.pointerDirty=!0},pointerReset:function(){this.closeOnSelect&&(this.pointer=0,this.$refs.list&&(this.$refs.list.scrollTop=0))},pointerAdjust:function(){this.pointer>=this.filteredOptions.length-1&&(this.pointer=this.filteredOptions.length?this.filteredOptions.length-1:0),this.filteredOptions.length>0&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()},pointerSet:function(t){this.pointer=t,this.pointerDirty=!0}}}},function(t,e,n){"use strict";var i=n(36),r=n(74),o=n(15),s=n(18);t.exports=n(72)(Array,"Array",function(t,e){this._t=s(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,r(1)):"keys"==e?r(0,n):"values"==e?r(0,t[n]):r(0,[n,t[n]])},"values"),o.Arguments=o.Array,i("keys"),i("values"),i("entries")},function(t,e,n){"use strict";var i=n(31),r=(n.n(i),n(32)),o=n(33);e.a={name:"vue-multiselect",mixins:[r.a,o.a],props:{name:{type:String,default:""},selectLabel:{type:String,default:"Press enter to select"},selectGroupLabel:{type:String,default:"Press enter to select group"},selectedLabel:{type:String,default:"Selected"},deselectLabel:{type:String,default:"Press enter to remove"},deselectGroupLabel:{type:String,default:"Press enter to deselect group"},showLabels:{type:Boolean,default:!0},limit:{type:Number,default:99999},maxHeight:{type:Number,default:300},limitText:{type:Function,default:function(t){return"and ".concat(t," more")}},loading:{type:Boolean,default:!1},disabled:{type:Boolean,default:!1},openDirection:{type:String,default:""},showNoOptions:{type:Boolean,default:!0},showNoResults:{type:Boolean,default:!0},tabindex:{type:Number,default:0}},computed:{isSingleLabelVisible:function(){return(this.singleValue||0===this.singleValue)&&(!this.isOpen||!this.searchable)&&!this.visibleValues.length},isPlaceholderVisible:function(){return!(this.internalValue.length||this.searchable&&this.isOpen)},visibleValues:function(){return this.multiple?this.internalValue.slice(0,this.limit):[]},singleValue:function(){return this.internalValue[0]},deselectLabelText:function(){return this.showLabels?this.deselectLabel:""},deselectGroupLabelText:function(){return this.showLabels?this.deselectGroupLabel:""},selectLabelText:function(){return this.showLabels?this.selectLabel:""},selectGroupLabelText:function(){return this.showLabels?this.selectGroupLabel:""},selectedLabelText:function(){return this.showLabels?this.selectedLabel:""},inputStyle:function(){if(this.searchable||this.multiple&&this.value&&this.value.length)return this.isOpen?{width:"100%"}:{width:"0",position:"absolute",padding:"0"}},contentStyle:function(){return this.options.length?{display:"inline-block"}:{display:"block"}},isAbove:function(){return"above"===this.openDirection||"top"===this.openDirection||"below"!==this.openDirection&&"bottom"!==this.openDirection&&"above"===this.preferredOpenDirection},showSearchInput:function(){return this.searchable&&(!this.hasSingleSelectedSlot||!this.visibleSingleValue&&0!==this.visibleSingleValue||this.isOpen)}}}},function(t,e,n){var i=n(1)("unscopables"),r=Array.prototype;void 0==r[i]&&n(8)(r,i,{}),t.exports=function(t){r[i][t]=!0}},function(t,e,n){var i=n(18),r=n(19),o=n(85);t.exports=function(t){return function(e,n,s){var u,a=i(e),l=r(a.length),c=o(s,l);if(t&&n!=n){for(;l>c;)if((u=a[c++])!=u)return!0}else for(;l>c;c++)if((t||c in a)&&a[c]===n)return t||c||0;return!t&&-1}}},function(t,e,n){var i=n(9),r=n(1)("toStringTag"),o="Arguments"==i(function(){return arguments}()),s=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,n,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=s(e=Object(t),r))?n:o?i(e):"Object"==(u=i(e))&&"function"==typeof e.callee?"Arguments":u}},function(t,e,n){"use strict";var i=n(2);t.exports=function(){var t=i(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},function(t,e,n){var i=n(0).document;t.exports=i&&i.documentElement},function(t,e,n){t.exports=!n(4)&&!n(7)(function(){return 7!=Object.defineProperty(n(21)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var i=n(9);t.exports=Array.isArray||function(t){return"Array"==i(t)}},function(t,e,n){"use strict";function i(t){var e,n;this.promise=new t(function(t,i){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=i}),this.resolve=r(e),this.reject=r(n)}var r=n(14);t.exports.f=function(t){return new i(t)}},function(t,e,n){var i=n(2),r=n(76),o=n(22),s=n(27)("IE_PROTO"),u=function(){},a=function(){var t,e=n(21)("iframe"),i=o.length;for(e.style.display="none",n(40).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),a=t.F;i--;)delete a.prototype[o[i]];return a()};t.exports=Object.create||function(t,e){var n;return null!==t?(u.prototype=i(t),n=new u,u.prototype=null,n[s]=t):n=a(),void 0===e?n:r(n,e)}},function(t,e,n){var i=n(79),r=n(25),o=n(18),s=n(29),u=n(12),a=n(41),l=Object.getOwnPropertyDescriptor;e.f=n(4)?l:function(t,e){if(t=o(t),e=s(e,!0),a)try{return l(t,e)}catch(t){}if(u(t,e))return r(!i.f.call(t,e),t[e])}},function(t,e,n){var i=n(12),r=n(18),o=n(37)(!1),s=n(27)("IE_PROTO");t.exports=function(t,e){var n,u=r(t),a=0,l=[];for(n in u)n!=s&&i(u,n)&&l.push(n);for(;e.length>a;)i(u,n=e[a++])&&(~o(l,n)||l.push(n));return l}},function(t,e,n){var i=n(46),r=n(22);t.exports=Object.keys||function(t){return i(t,r)}},function(t,e,n){var i=n(2),r=n(5),o=n(43);t.exports=function(t,e){if(i(t),r(e)&&e.constructor===t)return e;var n=o.f(t);return(0,n.resolve)(e),n.promise}},function(t,e,n){var i=n(10),r=n(0),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});(t.exports=function(t,e){return o[t]||(o[t]=void 0!==e?e:{})})("versions",[]).push({version:i.version,mode:n(24)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(t,e,n){var i=n(2),r=n(14),o=n(1)("species");t.exports=function(t,e){var n,s=i(t).constructor;return void 0===s||void 0==(n=i(s)[o])?e:r(n)}},function(t,e,n){var i=n(3),r=n(16),o=n(7),s=n(84),u="["+s+"]",a="​",l=RegExp("^"+u+u+"*"),c=RegExp(u+u+"*$"),f=function(t,e,n){var r={},u=o(function(){return!!s[t]()||a[t]()!=a}),l=r[t]=u?e(p):s[t];n&&(r[n]=l),i(i.P+i.F*u,"String",r)},p=f.trim=function(t,e){return t=String(r(t)),1&e&&(t=t.replace(l,"")),2&e&&(t=t.replace(c,"")),t};t.exports=f},function(t,e,n){var i,r,o,s=n(11),u=n(68),a=n(40),l=n(21),c=n(0),f=c.process,p=c.setImmediate,h=c.clearImmediate,d=c.MessageChannel,v=c.Dispatch,g=0,y={},m=function(){var t=+this;if(y.hasOwnProperty(t)){var e=y[t];delete y[t],e()}},b=function(t){m.call(t.data)};p&&h||(p=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return y[++g]=function(){u("function"==typeof t?t:Function(t),e)},i(g),g},h=function(t){delete y[t]},"process"==n(9)(f)?i=function(t){f.nextTick(s(m,t,1))}:v&&v.now?i=function(t){v.now(s(m,t,1))}:d?(r=new d,o=r.port2,r.port1.onmessage=b,i=s(o.postMessage,o,1)):c.addEventListener&&"function"==typeof postMessage&&!c.importScripts?(i=function(t){c.postMessage(t+"","*")},c.addEventListener("message",b,!1)):i="onreadystatechange"in l("script")?function(t){a.appendChild(l("script")).onreadystatechange=function(){a.removeChild(this),m.call(t)}}:function(t){setTimeout(s(m,t,1),0)}),t.exports={set:p,clear:h}},function(t,e){var n=Math.ceil,i=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?i:n)(t)}},function(t,e,n){"use strict";var i=n(3),r=n(20)(5),o=!0;"find"in[]&&Array(1).find(function(){o=!1}),i(i.P+i.F*o,"Array",{find:function(t){return r(this,t,arguments.length>1?arguments[1]:void 0)}}),n(36)("find")},function(t,e,n){"use strict";var i,r,o,s,u=n(24),a=n(0),l=n(11),c=n(38),f=n(3),p=n(5),h=n(14),d=n(61),v=n(66),g=n(50),y=n(52).set,m=n(75)(),b=n(43),_=n(80),x=n(86),w=n(48),S=a.TypeError,O=a.process,L=O&&O.versions,k=L&&L.v8||"",P=a.Promise,T="process"==c(O),V=function(){},E=r=b.f,A=!!function(){try{var t=P.resolve(1),e=(t.constructor={})[n(1)("species")]=function(t){t(V,V)};return(T||"function"==typeof PromiseRejectionEvent)&&t.then(V)instanceof e&&0!==k.indexOf("6.6")&&-1===x.indexOf("Chrome/66")}catch(t){}}(),C=function(t){var e;return!(!p(t)||"function"!=typeof(e=t.then))&&e},D=function(t,e){if(!t._n){t._n=!0;var n=t._c;m(function(){for(var i=t._v,r=1==t._s,o=0;n.length>o;)!function(e){var n,o,s,u=r?e.ok:e.fail,a=e.resolve,l=e.reject,c=e.domain;try{u?(r||(2==t._h&&$(t),t._h=1),!0===u?n=i:(c&&c.enter(),n=u(i),c&&(c.exit(),s=!0)),n===e.promise?l(S("Promise-chain cycle")):(o=C(n))?o.call(n,a,l):a(n)):l(i)}catch(t){c&&!s&&c.exit(),l(t)}}(n[o++]);t._c=[],t._n=!1,e&&!t._h&&j(t)})}},j=function(t){y.call(a,function(){var e,n,i,r=t._v,o=N(t);if(o&&(e=_(function(){T?O.emit("unhandledRejection",r,t):(n=a.onunhandledrejection)?n({promise:t,reason:r}):(i=a.console)&&i.error&&i.error("Unhandled promise rejection",r)}),t._h=T||N(t)?2:1),t._a=void 0,o&&e.e)throw e.v})},N=function(t){return 1!==t._h&&0===(t._a||t._c).length},$=function(t){y.call(a,function(){var e;T?O.emit("rejectionHandled",t):(e=a.onrejectionhandled)&&e({promise:t,reason:t._v})})},F=function(t){var e=this;e._d||(e._d=!0,e=e._w||e,e._v=t,e._s=2,e._a||(e._a=e._c.slice()),D(e,!0))},M=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw S("Promise can't be resolved itself");(e=C(t))?m(function(){var i={_w:n,_d:!1};try{e.call(t,l(M,i,1),l(F,i,1))}catch(t){F.call(i,t)}}):(n._v=t,n._s=1,D(n,!1))}catch(t){F.call({_w:n,_d:!1},t)}}};A||(P=function(t){d(this,P,"Promise","_h"),h(t),i.call(this);try{t(l(M,this,1),l(F,this,1))}catch(t){F.call(this,t)}},i=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},i.prototype=n(81)(P.prototype,{then:function(t,e){var n=E(g(this,P));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=T?O.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&D(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),o=function(){var t=new i;this.promise=t,this.resolve=l(M,t,1),this.reject=l(F,t,1)},b.f=E=function(t){return t===P||t===s?new o(t):r(t)}),f(f.G+f.W+f.F*!A,{Promise:P}),n(26)(P,"Promise"),n(83)("Promise"),s=n(10).Promise,f(f.S+f.F*!A,"Promise",{reject:function(t){var e=E(this);return(0,e.reject)(t),e.promise}}),f(f.S+f.F*(u||!A),"Promise",{resolve:function(t){return w(u&&this===s?P:this,t)}}),f(f.S+f.F*!(A&&n(73)(function(t){P.all(t).catch(V)})),"Promise",{all:function(t){var e=this,n=E(e),i=n.resolve,r=n.reject,o=_(function(){var n=[],o=0,s=1;v(t,!1,function(t){var u=o++,a=!1;n.push(void 0),s++,e.resolve(t).then(function(t){a||(a=!0,n[u]=t,--s||i(n))},r)}),--s||i(n)});return o.e&&r(o.v),n.promise},race:function(t){var e=this,n=E(e),i=n.reject,r=_(function(){v(t,!1,function(t){e.resolve(t).then(n.resolve,i)})});return r.e&&i(r.v),n.promise}})},function(t,e,n){"use strict";var i=n(3),r=n(10),o=n(0),s=n(50),u=n(48);i(i.P+i.R,"Promise",{finally:function(t){var e=s(this,r.Promise||o.Promise),n="function"==typeof t;return this.then(n?function(n){return u(e,t()).then(function(){return n})}:t,n?function(n){return u(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){"use strict";function i(t){n(99)}var r=n(35),o=n(101),s=n(100),u=i,a=s(r.a,o.a,!1,u,null,null);e.a=a.exports},function(t,e,n){"use strict";function i(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}e.a=i},function(t,e,n){"use strict";function i(t){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function r(t){return(r="function"==typeof Symbol&&"symbol"===i(Symbol.iterator)?function(t){return i(t)}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":i(t)})(t)}e.a=r},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=n(34),r=(n.n(i),n(55)),o=(n.n(r),n(56)),s=(n.n(o),n(57)),u=n(32),a=n(33);n.d(e,"Multiselect",function(){return s.a}),n.d(e,"multiselectMixin",function(){return u.a}),n.d(e,"pointerMixin",function(){return a.a}),e.default=s.a},function(t,e){t.exports=function(t,e,n,i){if(!(t instanceof e)||void 0!==i&&i in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var i=n(14),r=n(28),o=n(23),s=n(19);t.exports=function(t,e,n,u,a){i(e);var l=r(t),c=o(l),f=s(l.length),p=a?f-1:0,h=a?-1:1;if(n<2)for(;;){if(p in c){u=c[p],p+=h;break}if(p+=h,a?p<0:f<=p)throw TypeError("Reduce of empty array with no initial value")}for(;a?p>=0:f>p;p+=h)p in c&&(u=e(u,c[p],p,l));return u}},function(t,e,n){var i=n(5),r=n(42),o=n(1)("species");t.exports=function(t){var e;return r(t)&&(e=t.constructor,"function"!=typeof e||e!==Array&&!r(e.prototype)||(e=void 0),i(e)&&null===(e=e[o])&&(e=void 0)),void 0===e?Array:e}},function(t,e,n){var i=n(63);t.exports=function(t,e){return new(i(t))(e)}},function(t,e,n){"use strict";var i=n(8),r=n(6),o=n(7),s=n(16),u=n(1);t.exports=function(t,e,n){var a=u(t),l=n(s,a,""[t]),c=l[0],f=l[1];o(function(){var e={};return e[a]=function(){return 7},7!=""[t](e)})&&(r(String.prototype,t,c),i(RegExp.prototype,a,2==e?function(t,e){return f.call(t,this,e)}:function(t){return f.call(t,this)}))}},function(t,e,n){var i=n(11),r=n(70),o=n(69),s=n(2),u=n(19),a=n(87),l={},c={},e=t.exports=function(t,e,n,f,p){var h,d,v,g,y=p?function(){return t}:a(t),m=i(n,f,e?2:1),b=0;if("function"!=typeof y)throw TypeError(t+" is not iterable!");if(o(y)){for(h=u(t.length);h>b;b++)if((g=e?m(s(d=t[b])[0],d[1]):m(t[b]))===l||g===c)return g}else for(v=y.call(t);!(d=v.next()).done;)if((g=r(v,m,d.value,e))===l||g===c)return g};e.BREAK=l,e.RETURN=c},function(t,e,n){var i=n(5),r=n(82).set;t.exports=function(t,e,n){var o,s=e.constructor;return s!==n&&"function"==typeof s&&(o=s.prototype)!==n.prototype&&i(o)&&r&&r(t,o),t}},function(t,e){t.exports=function(t,e,n){var i=void 0===n;switch(e.length){case 0:return i?t():t.call(n);case 1:return i?t(e[0]):t.call(n,e[0]);case 2:return i?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return i?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return i?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var i=n(15),r=n(1)("iterator"),o=Array.prototype;t.exports=function(t){return void 0!==t&&(i.Array===t||o[r]===t)}},function(t,e,n){var i=n(2);t.exports=function(t,e,n,r){try{return r?e(i(n)[0],n[1]):e(n)}catch(e){var o=t.return;throw void 0!==o&&i(o.call(t)),e}}},function(t,e,n){"use strict";var i=n(44),r=n(25),o=n(26),s={};n(8)(s,n(1)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=i(s,{next:r(1,n)}),o(t,e+" Iterator")}},function(t,e,n){"use strict";var i=n(24),r=n(3),o=n(6),s=n(8),u=n(15),a=n(71),l=n(26),c=n(78),f=n(1)("iterator"),p=!([].keys&&"next"in[].keys()),h=function(){return this};t.exports=function(t,e,n,d,v,g,y){a(n,e,d);var m,b,_,x=function(t){if(!p&&t in L)return L[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},w=e+" Iterator",S="values"==v,O=!1,L=t.prototype,k=L[f]||L["@@iterator"]||v&&L[v],P=k||x(v),T=v?S?x("entries"):P:void 0,V="Array"==e?L.entries||k:k;if(V&&(_=c(V.call(new t)))!==Object.prototype&&_.next&&(l(_,w,!0),i||"function"==typeof _[f]||s(_,f,h)),S&&k&&"values"!==k.name&&(O=!0,P=function(){return k.call(this)}),i&&!y||!p&&!O&&L[f]||s(L,f,P),u[e]=P,u[w]=h,v)if(m={values:S?P:x("values"),keys:g?P:x("keys"),entries:T},y)for(b in m)b in L||o(L,b,m[b]);else r(r.P+r.F*(p||O),e,m);return m}},function(t,e,n){var i=n(1)("iterator"),r=!1;try{var o=[7][i]();o.return=function(){r=!0},Array.from(o,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!r)return!1;var n=!1;try{var o=[7],s=o[i]();s.next=function(){return{done:n=!0}},o[i]=function(){return s},t(o)}catch(t){}return n}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){var i=n(0),r=n(52).set,o=i.MutationObserver||i.WebKitMutationObserver,s=i.process,u=i.Promise,a="process"==n(9)(s);t.exports=function(){var t,e,n,l=function(){var i,r;for(a&&(i=s.domain)&&i.exit();t;){r=t.fn,t=t.next;try{r()}catch(i){throw t?n():e=void 0,i}}e=void 0,i&&i.enter()};if(a)n=function(){s.nextTick(l)};else if(!o||i.navigator&&i.navigator.standalone)if(u&&u.resolve){var c=u.resolve(void 0);n=function(){c.then(l)}}else n=function(){r.call(i,l)};else{var f=!0,p=document.createTextNode("");new o(l).observe(p,{characterData:!0}),n=function(){p.data=f=!f}}return function(i){var r={fn:i,next:void 0};e&&(e.next=r),t||(t=r,n()),e=r}}},function(t,e,n){var i=n(13),r=n(2),o=n(47);t.exports=n(4)?Object.defineProperties:function(t,e){r(t);for(var n,s=o(e),u=s.length,a=0;u>a;)i.f(t,n=s[a++],e[n]);return t}},function(t,e,n){var i=n(46),r=n(22).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return i(t,r)}},function(t,e,n){var i=n(12),r=n(28),o=n(27)("IE_PROTO"),s=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=r(t),i(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?s:null}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){var i=n(6);t.exports=function(t,e,n){for(var r in e)i(t,r,e[r],n);return t}},function(t,e,n){var i=n(5),r=n(2),o=function(t,e){if(r(t),!i(e)&&null!==e)throw TypeError(e+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,e,i){try{i=n(11)(Function.call,n(45).f(Object.prototype,"__proto__").set,2),i(t,[]),e=!(t instanceof Array)}catch(t){e=!0}return function(t,n){return o(t,n),e?t.__proto__=n:i(t,n),t}}({},!1):void 0),check:o}},function(t,e,n){"use strict";var i=n(0),r=n(13),o=n(4),s=n(1)("species");t.exports=function(t){var e=i[t];o&&e&&!e[s]&&r.f(e,s,{configurable:!0,get:function(){return this}})}},function(t,e){t.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"},function(t,e,n){var i=n(53),r=Math.max,o=Math.min;t.exports=function(t,e){return t=i(t),t<0?r(t+e,0):o(t,e)}},function(t,e,n){var i=n(0),r=i.navigator;t.exports=r&&r.userAgent||""},function(t,e,n){var i=n(38),r=n(1)("iterator"),o=n(15);t.exports=n(10).getIteratorMethod=function(t){if(void 0!=t)return t[r]||t["@@iterator"]||o[i(t)]}},function(t,e,n){"use strict";var i=n(3),r=n(20)(2);i(i.P+i.F*!n(17)([].filter,!0),"Array",{filter:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(37)(!1),o=[].indexOf,s=!!o&&1/[1].indexOf(1,-0)<0;i(i.P+i.F*(s||!n(17)(o)),"Array",{indexOf:function(t){return s?o.apply(this,arguments)||0:r(this,t,arguments[1])}})},function(t,e,n){var i=n(3);i(i.S,"Array",{isArray:n(42)})},function(t,e,n){"use strict";var i=n(3),r=n(20)(1);i(i.P+i.F*!n(17)([].map,!0),"Array",{map:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(62);i(i.P+i.F*!n(17)([].reduce,!0),"Array",{reduce:function(t){return r(this,t,arguments.length,arguments[1],!1)}})},function(t,e,n){var i=Date.prototype,r=i.toString,o=i.getTime;new Date(NaN)+""!="Invalid Date"&&n(6)(i,"toString",function(){var t=o.call(this);return t===t?r.call(this):"Invalid Date"})},function(t,e,n){n(4)&&"g"!=/./g.flags&&n(13).f(RegExp.prototype,"flags",{configurable:!0,get:n(39)})},function(t,e,n){n(65)("search",1,function(t,e,n){return[function(n){"use strict";var i=t(this),r=void 0==n?void 0:n[e];return void 0!==r?r.call(n,i):new RegExp(n)[e](String(i))},n]})},function(t,e,n){"use strict";n(94);var i=n(2),r=n(39),o=n(4),s=/./.toString,u=function(t){n(6)(RegExp.prototype,"toString",t,!0)};n(7)(function(){return"/a/b"!=s.call({source:"a",flags:"b"})})?u(function(){var t=i(this);return"/".concat(t.source,"/","flags"in t?t.flags:!o&&t instanceof RegExp?r.call(t):void 0)}):"toString"!=s.name&&u(function(){return s.call(this)})},function(t,e,n){"use strict";n(51)("trim",function(t){return function(){return t(this,3)}})},function(t,e,n){for(var i=n(34),r=n(47),o=n(6),s=n(0),u=n(8),a=n(15),l=n(1),c=l("iterator"),f=l("toStringTag"),p=a.Array,h={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},d=r(h),v=0;v<d.length;v++){var g,y=d[v],m=h[y],b=s[y],_=b&&b.prototype;if(_&&(_[c]||u(_,c,p),_[f]||u(_,f,y),a[y]=p,m))for(g in i)_[g]||o(_,g,i[g],!0)}},function(t,e){},function(t,e){t.exports=function(t,e,n,i,r,o){var s,u=t=t||{},a=typeof t.default;"object"!==a&&"function"!==a||(s=t,u=t.default);var l="function"==typeof u?u.options:u;e&&(l.render=e.render,l.staticRenderFns=e.staticRenderFns,l._compiled=!0),n&&(l.functional=!0),r&&(l._scopeId=r);var c;if(o?(c=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},l._ssrRegister=c):i&&(c=i),c){var f=l.functional,p=f?l.render:l.beforeCreate;f?(l._injectStyles=c,l.render=function(t,e){return c.call(e),p(t,e)}):l.beforeCreate=p?[].concat(p,c):[c]}return{esModule:s,exports:u,options:l}}},function(t,e,n){"use strict";var i=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"multiselect",class:{"multiselect--active":t.isOpen,"multiselect--disabled":t.disabled,"multiselect--above":t.isAbove},attrs:{tabindex:t.searchable?-1:t.tabindex},on:{focus:function(e){t.activate()},blur:function(e){!t.searchable&&t.deactivate()},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerForward()):null},function(e){return"button"in e||!t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerBackward()):null}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")||!t._k(e.keyCode,"tab",9,e.key,"Tab")?(e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()}}},[t._t("caret",[n("div",{staticClass:"multiselect__select",on:{mousedown:function(e){e.preventDefault(),e.stopPropagation(),t.toggle()}}})],{toggle:t.toggle}),t._v(" "),t._t("clear",null,{search:t.search}),t._v(" "),n("div",{ref:"tags",staticClass:"multiselect__tags"},[t._t("selection",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.visibleValues.length>0,expression:"visibleValues.length > 0"}],staticClass:"multiselect__tags-wrap"},[t._l(t.visibleValues,function(e,i){return[t._t("tag",[n("span",{key:i,staticClass:"multiselect__tag"},[n("span",{domProps:{textContent:t._s(t.getOptionLabel(e))}}),t._v(" "),n("i",{staticClass:"multiselect__tag-icon",attrs:{"aria-hidden":"true",tabindex:"1"},on:{keypress:function(n){if(!("button"in n)&&t._k(n.keyCode,"enter",13,n.key,"Enter"))return null;n.preventDefault(),t.removeElement(e)},mousedown:function(n){n.preventDefault(),t.removeElement(e)}}})])],{option:e,search:t.search,remove:t.removeElement})]})],2),t._v(" "),t.internalValue&&t.internalValue.length>t.limit?[t._t("limit",[n("strong",{staticClass:"multiselect__strong",domProps:{textContent:t._s(t.limitText(t.internalValue.length-t.limit))}})])]:t._e()],{search:t.search,remove:t.removeElement,values:t.visibleValues,isOpen:t.isOpen}),t._v(" "),n("transition",{attrs:{name:"multiselect__loading"}},[t._t("loading",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.loading,expression:"loading"}],staticClass:"multiselect__spinner"})])],2),t._v(" "),t.searchable?n("input",{ref:"search",staticClass:"multiselect__input",style:t.inputStyle,attrs:{name:t.name,id:t.id,type:"text",autocomplete:"nope",placeholder:t.placeholder,disabled:t.disabled,tabindex:t.tabindex},domProps:{value:t.search},on:{input:function(e){t.updateSearch(e.target.value)},focus:function(e){e.preventDefault(),t.activate()},blur:function(e){e.preventDefault(),t.deactivate()},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()},keydown:[function(e){if(!("button"in e)&&t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"]))return null;e.preventDefault(),t.pointerForward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"]))return null;e.preventDefault(),t.pointerBackward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"delete",[8,46],e.key,["Backspace","Delete"]))return null;e.stopPropagation(),t.removeLastElement()}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")?(e.preventDefault(),e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null}}}):t._e(),t._v(" "),t.isSingleLabelVisible?n("span",{staticClass:"multiselect__single",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("singleLabel",[[t._v(t._s(t.currentOptionLabel))]],{option:t.singleValue})],2):t._e(),t._v(" "),t.isPlaceholderVisible?n("span",{staticClass:"multiselect__placeholder",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("placeholder",[t._v("\n          "+t._s(t.placeholder)+"\n        ")])],2):t._e()],2),t._v(" "),n("transition",{attrs:{name:"multiselect"}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.isOpen,expression:"isOpen"}],ref:"list",staticClass:"multiselect__content-wrapper",style:{maxHeight:t.optimizedHeight+"px"},attrs:{tabindex:"-1"},on:{focus:t.activate,mousedown:function(t){t.preventDefault()}}},[n("ul",{staticClass:"multiselect__content",style:t.contentStyle},[t._t("beforeList"),t._v(" "),t.multiple&&t.max===t.internalValue.length?n("li",[n("span",{staticClass:"multiselect__option"},[t._t("maxElements",[t._v("Maximum of "+t._s(t.max)+" options selected. First remove a selected option to select another.")])],2)]):t._e(),t._v(" "),!t.max||t.internalValue.length<t.max?t._l(t.filteredOptions,function(e,i){return n("li",{key:i,staticClass:"multiselect__element"},[e&&(e.$isLabel||e.$isDisabled)?t._e():n("span",{staticClass:"multiselect__option",class:t.optionHighlight(i,e),attrs:{"data-select":e&&e.isTag?t.tagPlaceholder:t.selectLabelText,"data-selected":t.selectedLabelText,"data-deselect":t.deselectLabelText},on:{click:function(n){n.stopPropagation(),t.select(e)},mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.pointerSet(i)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2),t._v(" "),e&&(e.$isLabel||e.$isDisabled)?n("span",{staticClass:"multiselect__option",class:t.groupHighlight(i,e),attrs:{"data-select":t.groupSelect&&t.selectGroupLabelText,"data-deselect":t.groupSelect&&t.deselectGroupLabelText},on:{mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.groupSelect&&t.pointerSet(i)},mousedown:function(n){n.preventDefault(),t.selectGroup(e)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2):t._e()])}):t._e(),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoResults&&0===t.filteredOptions.length&&t.search&&!t.loading,expression:"showNoResults && (filteredOptions.length === 0 && search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noResult",[t._v("No elements found. Consider changing the search query.")],{search:t.search})],2)]),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoOptions&&0===t.options.length&&!t.search&&!t.loading,expression:"showNoOptions && (options.length === 0 && !search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noOptions",[t._v("List is empty.")])],2)]),t._v(" "),t._t("afterList")],2)])])],2)},r=[],o={render:i,staticRenderFns:r};e.a=o}])});

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

var Utils = __webpack_require__(8)
  , _browser = 'unknown'
  ;

// http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
if (/*@cc_on!@*/false || !!document.documentMode) { // internet explorer
  _browser = 'ie';
}

module.exports = {
  svgNS:  'http://www.w3.org/2000/svg'
, xmlNS:  'http://www.w3.org/XML/1998/namespace'
, xmlnsNS:  'http://www.w3.org/2000/xmlns/'
, xlinkNS:  'http://www.w3.org/1999/xlink'
, evNS:  'http://www.w3.org/2001/xml-events'

  /**
   * Get svg dimensions: width and height
   *
   * @param  {SVGSVGElement} svg
   * @return {Object}     {width: 0, height: 0}
   */
, getBoundingClientRectNormalized: function(svg) {
    if (svg.clientWidth && svg.clientHeight) {
      return {width: svg.clientWidth, height: svg.clientHeight}
    } else if (!!svg.getBoundingClientRect()) {
      return svg.getBoundingClientRect();
    } else {
      throw new Error('Cannot get BoundingClientRect for SVG.');
    }
  }

  /**
   * Gets g element with class of "viewport" or creates it if it doesn't exist
   *
   * @param  {SVGSVGElement} svg
   * @return {SVGElement}     g (group) element
   */
, getOrCreateViewport: function(svg, selector) {
    var viewport = null

    if (Utils.isElement(selector)) {
      viewport = selector
    } else {
      viewport = svg.querySelector(selector)
    }

    // Check if there is just one main group in SVG
    if (!viewport) {
      var childNodes = Array.prototype.slice.call(svg.childNodes || svg.children).filter(function(el){
        return el.nodeName !== 'defs' && el.nodeName !== '#text'
      })

      // Node name should be SVGGElement and should have no transform attribute
      // Groups with transform are not used as viewport because it involves parsing of all transform possibilities
      if (childNodes.length === 1 && childNodes[0].nodeName === 'g' && childNodes[0].getAttribute('transform') === null) {
        viewport = childNodes[0]
      }
    }

    // If no favorable group element exists then create one
    if (!viewport) {
      var viewportId = 'viewport-' + new Date().toISOString().replace(/\D/g, '');
      viewport = document.createElementNS(this.svgNS, 'g');
      viewport.setAttribute('id', viewportId);

      // Internet Explorer (all versions?) can't use childNodes, but other browsers prefer (require?) using childNodes
      var svgChildren = svg.childNodes || svg.children;
      if (!!svgChildren && svgChildren.length > 0) {
        for (var i = svgChildren.length; i > 0; i--) {
          // Move everything into viewport except defs
          if (svgChildren[svgChildren.length - i].nodeName !== 'defs') {
            viewport.appendChild(svgChildren[svgChildren.length - i]);
          }
        }
      }
      svg.appendChild(viewport);
    }

    // Parse class names
    var classNames = [];
    if (viewport.getAttribute('class')) {
      classNames = viewport.getAttribute('class').split(' ')
    }

    // Set class (if not set already)
    if (!~classNames.indexOf('svg-pan-zoom_viewport')) {
      classNames.push('svg-pan-zoom_viewport')
      viewport.setAttribute('class', classNames.join(' '))
    }

    return viewport
  }

  /**
   * Set SVG attributes
   *
   * @param  {SVGSVGElement} svg
   */
  , setupSvgAttributes: function(svg) {
    // Setting default attributes
    svg.setAttribute('xmlns', this.svgNS);
    svg.setAttributeNS(this.xmlnsNS, 'xmlns:xlink', this.xlinkNS);
    svg.setAttributeNS(this.xmlnsNS, 'xmlns:ev', this.evNS);

    // Needed for Internet Explorer, otherwise the viewport overflows
    if (svg.parentNode !== null) {
      var style = svg.getAttribute('style') || '';
      if (style.toLowerCase().indexOf('overflow') === -1) {
        svg.setAttribute('style', 'overflow: hidden; ' + style);
      }
    }
  }

/**
 * How long Internet Explorer takes to finish updating its display (ms).
 */
, internetExplorerRedisplayInterval: 300

/**
 * Forces the browser to redisplay all SVG elements that rely on an
 * element defined in a 'defs' section. It works globally, for every
 * available defs element on the page.
 * The throttling is intentionally global.
 *
 * This is only needed for IE. It is as a hack to make markers (and 'use' elements?)
 * visible after pan/zoom when there are multiple SVGs on the page.
 * See bug report: https://connect.microsoft.com/IE/feedback/details/781964/
 * also see svg-pan-zoom issue: https://github.com/ariutta/svg-pan-zoom/issues/62
 */
, refreshDefsGlobal: Utils.throttle(function() {
    var allDefs = document.querySelectorAll('defs');
    var allDefsCount = allDefs.length;
    for (var i = 0; i < allDefsCount; i++) {
      var thisDefs = allDefs[i];
      thisDefs.parentNode.insertBefore(thisDefs, thisDefs);
    }
  }, this ? this.internetExplorerRedisplayInterval : null)

  /**
   * Sets the current transform matrix of an element
   *
   * @param {SVGElement} element
   * @param {SVGMatrix} matrix  CTM
   * @param {SVGElement} defs
   */
, setCTM: function(element, matrix, defs) {
    var that = this
      , s = 'matrix(' + matrix.a + ',' + matrix.b + ',' + matrix.c + ',' + matrix.d + ',' + matrix.e + ',' + matrix.f + ')';

    element.setAttributeNS(null, 'transform', s);
    if ('transform' in element.style) {
      element.style.transform = s;
    } else if ('-ms-transform' in element.style) {
      element.style['-ms-transform'] = s;
    } else if ('-webkit-transform' in element.style) {
      element.style['-webkit-transform'] = s;
    }

    // IE has a bug that makes markers disappear on zoom (when the matrix "a" and/or "d" elements change)
    // see http://stackoverflow.com/questions/17654578/svg-marker-does-not-work-in-ie9-10
    // and http://srndolha.wordpress.com/2013/11/25/svg-line-markers-may-disappear-in-internet-explorer-11/
    if (_browser === 'ie' && !!defs) {
      // this refresh is intended for redisplaying the SVG during zooming
      defs.parentNode.insertBefore(defs, defs);
      // this refresh is intended for redisplaying the other SVGs on a page when panning a given SVG
      // it is also needed for the given SVG itself, on zoomEnd, if the SVG contains any markers that
      // are located under any other element(s).
      window.setTimeout(function() {
        that.refreshDefsGlobal();
      }, that.internetExplorerRedisplayInterval);
    }
  }

  /**
   * Instantiate an SVGPoint object with given event coordinates
   *
   * @param {Event} evt
   * @param  {SVGSVGElement} svg
   * @return {SVGPoint}     point
   */
, getEventPoint: function(evt, svg) {
    var point = svg.createSVGPoint()

    Utils.mouseAndTouchNormalize(evt, svg)

    point.x = evt.clientX
    point.y = evt.clientY

    return point
  }

  /**
   * Get SVG center point
   *
   * @param  {SVGSVGElement} svg
   * @return {SVGPoint}
   */
, getSvgCenterPoint: function(svg, width, height) {
    return this.createSVGPoint(svg, width / 2, height / 2)
  }

  /**
   * Create a SVGPoint with given x and y
   *
   * @param  {SVGSVGElement} svg
   * @param  {Number} x
   * @param  {Number} y
   * @return {SVGPoint}
   */
, createSVGPoint: function(svg, x, y) {
    var point = svg.createSVGPoint()
    point.x = x
    point.y = y

    return point
  }
}


/***/ },
/* 8 */
/***/ function(module, exports) {

module.exports = {
  /**
   * Extends an object
   *
   * @param  {Object} target object to extend
   * @param  {Object} source object to take properties from
   * @return {Object}        extended object
   */
  extend: function(target, source) {
    target = target || {};
    for (var prop in source) {
      // Go recursively
      if (this.isObject(source[prop])) {
        target[prop] = this.extend(target[prop], source[prop])
      } else {
        target[prop] = source[prop]
      }
    }
    return target;
  }

  /**
   * Checks if an object is a DOM element
   *
   * @param  {Object}  o HTML element or String
   * @return {Boolean}   returns true if object is a DOM element
   */
, isElement: function(o){
    return (
      o instanceof HTMLElement || o instanceof SVGElement || o instanceof SVGSVGElement || //DOM2
      (o && typeof o === 'object' && o !== null && o.nodeType === 1 && typeof o.nodeName === 'string')
    );
  }

  /**
   * Checks if an object is an Object
   *
   * @param  {Object}  o Object
   * @return {Boolean}   returns true if object is an Object
   */
, isObject: function(o){
    return Object.prototype.toString.call(o) === '[object Object]';
  }

  /**
   * Checks if variable is Number
   *
   * @param  {Integer|Float}  n
   * @return {Boolean}   returns true if variable is Number
   */
, isNumber: function(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  /**
   * Search for an SVG element
   *
   * @param  {Object|String} elementOrSelector DOM Element or selector String
   * @return {Object|Null}                   SVG or null
   */
, getSvg: function(elementOrSelector) {
    var element
      , svg;

    if (!this.isElement(elementOrSelector)) {
      // If selector provided
      if (typeof elementOrSelector === 'string' || elementOrSelector instanceof String) {
        // Try to find the element
        element = document.querySelector(elementOrSelector)

        if (!element) {
          throw new Error('Provided selector did not find any elements. Selector: ' + elementOrSelector)
          return null
        }
      } else {
        throw new Error('Provided selector is not an HTML object nor String')
        return null
      }
    } else {
      element = elementOrSelector
    }

    if (element.tagName.toLowerCase() === 'svg') {
      svg = element;
    } else {
      if (element.tagName.toLowerCase() === 'object') {
        svg = element.contentDocument.documentElement;
      } else {
        if (element.tagName.toLowerCase() === 'embed') {
          svg = element.getSVGDocument().documentElement;
        } else {
          if (element.tagName.toLowerCase() === 'img') {
            throw new Error('Cannot script an SVG in an "img" element. Please use an "object" element or an in-line SVG.');
          } else {
            throw new Error('Cannot get SVG.');
          }
          return null
        }
      }
    }

    return svg
  }

  /**
   * Attach a given context to a function
   * @param  {Function} fn      Function
   * @param  {Object}   context Context
   * @return {Function}           Function with certain context
   */
, proxy: function(fn, context) {
    return function() {
      return fn.apply(context, arguments)
    }
  }

  /**
   * Returns object type
   * Uses toString that returns [object SVGPoint]
   * And than parses object type from string
   *
   * @param  {Object} o Any object
   * @return {String}   Object type
   */
, getType: function(o) {
    return Object.prototype.toString.apply(o).replace(/^\[object\s/, '').replace(/\]$/, '')
  }

  /**
   * If it is a touch event than add clientX and clientY to event object
   *
   * @param  {Event} evt
   * @param  {SVGSVGElement} svg
   */
, mouseAndTouchNormalize: function(evt, svg) {
    // If no clientX then fallback
    if (evt.clientX === void 0 || evt.clientX === null) {
      // Fallback
      evt.clientX = 0
      evt.clientY = 0

      // If it is a touch event
      if (evt.touches !== void 0 && evt.touches.length) {
        if (evt.touches[0].clientX !== void 0) {
          evt.clientX = evt.touches[0].clientX
          evt.clientY = evt.touches[0].clientY
        } else if (evt.touches[0].pageX !== void 0) {
          var rect = svg.getBoundingClientRect();

          evt.clientX = evt.touches[0].pageX - rect.left
          evt.clientY = evt.touches[0].pageY - rect.top
        }
      // If it is a custom event
      } else if (evt.originalEvent !== void 0) {
        if (evt.originalEvent.clientX !== void 0) {
          evt.clientX = evt.originalEvent.clientX
          evt.clientY = evt.originalEvent.clientY
        }
      }
    }
  }

  /**
   * Check if an event is a double click/tap
   * TODO: For touch gestures use a library (hammer.js) that takes in account other events
   * (touchmove and touchend). It should take in account tap duration and traveled distance
   *
   * @param  {Event}  evt
   * @param  {Event}  prevEvt Previous Event
   * @return {Boolean}
   */
, isDblClick: function(evt, prevEvt) {
    // Double click detected by browser
    if (evt.detail === 2) {
      return true;
    }
    // Try to compare events
    else if (prevEvt !== void 0 && prevEvt !== null) {
      var timeStampDiff = evt.timeStamp - prevEvt.timeStamp // should be lower than 250 ms
        , touchesDistance = Math.sqrt(Math.pow(evt.clientX - prevEvt.clientX, 2) + Math.pow(evt.clientY - prevEvt.clientY, 2))

      return timeStampDiff < 250 && touchesDistance < 10
    }

    // Nothing found
    return false;
  }

  /**
   * Returns current timestamp as an integer
   *
   * @return {Number}
   */
, now: Date.now || function() {
    return new Date().getTime();
  }

  // From underscore.
  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
// jscs:disable
// jshint ignore:start
, throttle: function(func, wait, options) {
    var that = this;
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : that.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = that.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        clearTimeout(timeout);
        timeout = null;
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  }
// jshint ignore:end
// jscs:enable

  /**
   * Create a requestAnimationFrame simulation
   *
   * @param  {Number|String} refreshRate
   * @return {Function}
   */
, createRequestAnimationFrame: function(refreshRate) {
    var timeout = null

    // Convert refreshRate to timeout
    if (refreshRate !== 'auto' && refreshRate < 60 && refreshRate > 1) {
      timeout = Math.floor(1000 / refreshRate)
    }

    if (timeout === null) {
      return window.requestAnimationFrame || requestTimeout(33)
    } else {
      return requestTimeout(timeout)
    }
  }
}

/**
 * Create a callback that will execute after a given timeout
 *
 * @param  {Function} timeout
 * @return {Function}
 */
function requestTimeout(timeout) {
  return function(callback) {
    window.setTimeout(callback, timeout)
  }
}


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__click_outside__ = __webpack_require__(214);


/* harmony default export */ exports["a"] = {
  ClickOutside: __WEBPACK_IMPORTED_MODULE_0__click_outside__["a" /* default */],
};


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        ss : '%d sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        ss : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        ss : '%d ثانية',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        ss : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        ss : '%d saniyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        ss : '%d секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

// Language contact person : Abdoufata Kane : https://github.com/abdoufata

var bm = moment.defineLocale('bm', {
    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'MMMM [tile] D [san] YYYY',
        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
    },
    calendar : {
        sameDay : '[Bi lɛrɛ] LT',
        nextDay : '[Sini lɛrɛ] LT',
        nextWeek : 'dddd [don lɛrɛ] LT',
        lastDay : '[Kunu lɛrɛ] LT',
        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s kɔnɔ',
        past : 'a bɛ %s bɔ',
        s : 'sanga dama dama',
        ss : 'sekondi %d',
        m : 'miniti kelen',
        mm : 'miniti %d',
        h : 'lɛrɛ kelen',
        hh : 'lɛrɛ %d',
        d : 'tile kelen',
        dd : 'tile %d',
        M : 'kalo kelen',
        MM : 'kalo %d',
        y : 'san kelen',
        yy : 'san %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return bm;

})));


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
};
var numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        ss : '%d সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
};
var numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        ss : '%d སྐར་ཆ།',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        ss : '%d eilenn',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            if (number === 1) {
                result += 'sekunda';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
            } else {
                result += 'sekundi';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        ss     : translate,
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : 'D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        ss : '%d segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekund');
            } else {
                return result + 'sekundami';
            }
            break;
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        ss : '%d ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        ss: '%d eiliad',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        ss : '%d sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
];
var weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        ss : 'd% ސިކުންތު',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        ss : '%d δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        ss : '%d sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse: monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esUs = moment.defineLocale('es-us', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'MM/DD/YYYY',
        LL : 'MMMM [de] D [de] YYYY',
        LLL : 'MMMM [de] D [de] YYYY h:mm A',
        LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return esUs;

})));


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex : monthsRegex,
    monthsShortRegex : monthsRegex,
    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'ss': [number + 'sekundi', number + 'sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        ss     : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        ss : '%d segundo',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
};
var numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        ss : 'ثانیه d%',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'ss':
            return isFuture ? 'sekunnin' : 'sekuntia';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        ss : '%d sekundir',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        ss : '%d sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        ss : '%d diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'ss': [number + ' secondanim', number + ' second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        ss : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
        '1': '૧',
        '2': '૨',
        '3': '૩',
        '4': '૪',
        '5': '૫',
        '6': '૬',
        '7': '૭',
        '8': '૮',
        '9': '૯',
        '0': '૦'
    };
var numberMap = {
        '૧': '1',
        '૨': '2',
        '૩': '3',
        '૪': '4',
        '૫': '5',
        '૬': '6',
        '૭': '7',
        '૮': '8',
        '૯': '9',
        '૦': '0'
    };

var gu = moment.defineLocale('gu', {
    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
    monthsParseExact: true,
    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
    longDateFormat: {
        LT: 'A h:mm વાગ્યે',
        LTS: 'A h:mm:ss વાગ્યે',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
    },
    calendar: {
        sameDay: '[આજ] LT',
        nextDay: '[કાલે] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[ગઇકાલે] LT',
        lastWeek: '[પાછલા] dddd, LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%s મા',
        past: '%s પેહલા',
        s: 'અમુક પળો',
        ss: '%d સેકંડ',
        m: 'એક મિનિટ',
        mm: '%d મિનિટ',
        h: 'એક કલાક',
        hh: '%d કલાક',
        d: 'એક દિવસ',
        dd: '%d દિવસ',
        M: 'એક મહિનો',
        MM: '%d મહિનો',
        y: 'એક વર્ષ',
        yy: '%d વર્ષ'
    },
    preparse: function (string) {
        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'રાત') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'સવાર') {
            return hour;
        } else if (meridiem === 'બપોર') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'સાંજ') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'રાત';
        } else if (hour < 10) {
            return 'સવાર';
        } else if (hour < 17) {
            return 'બપોર';
        } else if (hour < 20) {
            return 'સાંજ';
        } else {
            return 'રાત';
        }
    },
    week: {
        dow: 0, // Sunday is the first day of the week.
        doy: 6 // The week that contains Jan 1st is the first week of the year.
    }
});

return gu;

})));


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        ss : '%d שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        ss : '%d सेकंड',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            if (number === 1) {
                result += 'sekunda';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
            } else {
                result += 'sekundi';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        ss     : translate,
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'ss':
            return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        ss : '%d վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        ss : '%d detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'ss':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
            }
            return result + 'sekúnda';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        ss : '%d secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        ss : '%d秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        ss : '%d detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        ss : '%d წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        ss : '%d секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        ss: '%d វិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
};
var numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        ss : '%d ಸೆಕೆಂಡುಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '일';
            case 'M':
                return number + '월';
            case 'w':
            case 'W':
                return number + '주';
            default:
                return number;
        }
    },
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        ss : '%d секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        ss : '%d Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        ss : '%d ວິນາທີ' ,
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'ss' : 'sekundė_sekundžių_sekundes',
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        ss : translate,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        ss : relativeTimeWithPlural,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['sekund', 'sekunda', 'sekundi'],
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        ss: '%d hēkona',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        ss : '%d секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        ss : '%d സെക്കൻഡ്',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'ss': output = '%d सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'ss': output = '%d सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        ss: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        ss : '%d saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        ss : '%d saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mt = moment.defineLocale('mt', {
    months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
    monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
    weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
    weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
    weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Illum fil-]LT',
        nextDay : '[Għada fil-]LT',
        nextWeek : 'dddd [fil-]LT',
        lastDay : '[Il-bieraħ fil-]LT',
        lastWeek : 'dddd [li għadda] [fil-]LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'f’ %s',
        past : '%s ilu',
        s : 'ftit sekondi',
        ss : '%d sekondi',
        m : 'minuta',
        mm : '%d minuti',
        h : 'siegħa',
        hh : '%d siegħat',
        d : 'ġurnata',
        dd : '%d ġranet',
        M : 'xahar',
        MM : '%d xhur',
        y : 'sena',
        yy : '%d sni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mt;

})));


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
};
var numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        ss : '%d စက္ကန့်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        ss : '%d sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        ss : '%d सेकेण्ड',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        ss : '%d seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        ss : '%d seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        ss : '%d sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
};
var numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        ss : '%d ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            return result + (plural(number) ? 'sekundy' : 'sekund');
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W niedzielę o] LT';

                case 2:
                    return '[We wtorek o] LT';

                case 3:
                    return '[W środę o] LT';

                case 6:
                    return '[W sobotę o] LT';

                default:
                    return '[W] dddd [o] LT';
            }
        },
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'ss': 'secunde',
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        ss : relativeTimeWithPlural,
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., H:mm',
        LLLL : 'dddd, D MMMM YYYY г., H:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ru;

})));


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        ss : '%d سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        ss: '%d sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        ss : 'තත්පර %d',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekúnd');
            } else {
                return result + 'sekundami';
            }
            break;
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'ss':
            if (number === 1) {
                result += withoutSuffix ? 'sekundo' : 'sekundi';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
            } else {
                result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        ss     : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        ss : '%d sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['секунда', 'секунде', 'секунди'],
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['sekunda', 'sekunde', 'sekundi'],
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        ss : '%d mzuzwana',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        ss : '%d sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        ss : 'sekunde %d',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
};
var numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        ss : '%d விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        ss : '%d సెకన్లు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        ss : 'minutu %d',
        m : 'minutu ida',
        mm : 'minutus %d',
        h : 'horas ida',
        hh : 'horas %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        ss : '%d วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        ss : '%d segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'ss':
            return numberNoun + ' lup';
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        ss : translate,
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[gelecek] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        ss : '%d saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '\'ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        ss : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'ss': [number + ' secunds', '' + number + ' secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        ss : '%d imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        ss : '%d ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        ss : '%d سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        ss : '%d soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        ss : '%d фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        ss : '%d giây' ,
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        ss : '%d s~écóñ~ds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        ss :'aayá %d',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日Ah点mm分',
        LLLL : 'YYYY年M月D日ddddAh点mm分',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        ss : '%d 秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日dddd HH:mm',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        ss : '%d 秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日dddd HH:mm',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        ss : '%d 秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony default export */ exports["a"] = {
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    ripple: Boolean,
    router: Boolean,
    tag: String,
    target: String
  },

  computed: {
    trackingData: function trackingData() {
      
      var dataTrack = {
        context: this.$slots.default[0].text,
        value: this.$slots.default[0].text
      }
      return dataTrack
    }
  },

  methods: {
    click: function click () {},
    generateRouteLink: function generateRouteLink (isButton) {
      var exact = this.exact
      var tag
      var options = this.to || this.href

      var data = {
        attrs: {},
        class: this.classes,
        props: {},
      }


      if (!this.exact) {
        exact = this.href === '/' ||
          this.to === '/' ||
          (this.href === Object(this.href) && this.href.path === '/') ||
          (this.to === Object(this.to) && this.to.path === '/')
      }

      if (options && this.router) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link'
        data.props.to = options
        data.props.exact = exact
        data.props.activeClass = this.activeClass
        data.props.append = this.append
        data.props.replace = this.replace
        data.nativeOn = { click: this.click }
      } else {
        tag = this.tag || 'a'

        if (tag === 'a') {
          data.attrs.href = options || 'javascript:;'
          if (this.target) { data.attrs.target = this.target }
        }

        data.on = { click: this.click }
      }

      if (isButton === true) {
        // console.log(this.$slots.default)
        data.attrs['data-track-context'] = this.trackingData.context
        data.attrs['data-track-value'] = this.trackingData.value
      }
      return { tag: tag, data: data }
    }
  }
};


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return GoogleMapsApiConfig; });
var GoogleMapsApiConfig = {
  api_key: null,
  libraries: null,
  version: null,
  callback_name: '__googleMapsApiOnLoadCallback',
  timeout: 20000
}

var GoogleMapsApiLoader = function GoogleMapsApiLoader() {
  this._apiPromise = null;
};

GoogleMapsApiLoader.prototype.getApi = function getApi () {

  if(!this._apiPromise) {
    this._apiPromise = new Promise(function (resolve, reject) {
      if (!GoogleMapsApiConfig.api_key) {
        return reject(new Error('No API key found for GoogleMapsApiLoader. This service must be configured using the GoogleMapsApiConfig export'));
      }

      // Check whether API is already loaded.
      if (window.google && window.google.maps) {
        resolve(window.google.maps);
      }
      else {
        // Prepare the `script` tag to be inserted into the page.
        var scriptElement = document.createElement('script');
        var params = [
          ("callback=" + (GoogleMapsApiConfig.callback_name)),
          ("key=" + (GoogleMapsApiConfig.api_key))
        ];
        var libraries = GoogleMapsApiConfig.libraries || [];
        if (libraries.length) { params.push('libraries=' + libraries.join(',')); }
        if (GoogleMapsApiConfig.version) { params.push('v=' + GoogleMapsApiConfig.version); }
        scriptElement.src = 'https://maps.googleapis.com/maps/api/js?' + params.join('&');

        // Timeout if necessary.
        var timeoutId = null;
        if (GoogleMapsApiConfig.timeout) {
          timeoutId = window.setTimeout(function () {
            window[GoogleMapsApiConfig.callback_name] = function () {}; // Set the on load callback to a no-op.
            reject(new Error('Time out - Could not load the Google Maps API'));
          }, GoogleMapsApiConfig.timeout);
        }

        // Hook up the on load callback.
        window[GoogleMapsApiConfig.callback_name] = function () {
          if (timeoutId !== null) {
            window.clearTimeout(timeoutId);
          }
          resolve(window.google.maps);
          delete window[GoogleMapsApiConfig.callback_name];
        };

        // Insert the `script` tag.
        document.body.appendChild(scriptElement);
      }
    });
  }

  return this._apiPromise;
};

/* harmony default export */ exports["a"] = new GoogleMapsApiLoader();

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(283),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__carousel__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dialog__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__list__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icon__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__movie__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__video__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__snackbars__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__toasts__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__layout__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__title_heading__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__progress__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__seat__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__seat_grid__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__transitions__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tooltip__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__accordian__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__counter_box__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__quantity__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ticket_seats__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ticket_item__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ticket_movie__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__tabs__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__social_share__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__divider__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__google_ad__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__counter_box_fan__ = __webpack_require__(153);






























/* harmony default export */ exports["a"] = Object.assign({},
    __WEBPACK_IMPORTED_MODULE_0__carousel__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_1__colors__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_2__form__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_3__button__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_4__dialog__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_5__list__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_6__icon__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_7__movie__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_8__video__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_16__transitions__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_9__snackbars__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_10__toasts__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_17__tooltip__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_11__layout__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_13__progress__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_14__seat__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_12__title_heading__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_19__counter_box__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_20__quantity__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_21__ticket_seats__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_22__ticket_item__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_23__ticket_movie__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_18__accordian__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_24__tabs__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_15__seat_grid__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_26__divider__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_25__social_share__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_27__google_ad__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_28__counter_box_fan__["a" /* default */]
);


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__truncate__ = __webpack_require__(215);


/* harmony default export */ exports["a"] = {
	truncate: __WEBPACK_IMPORTED_MODULE_0__truncate__["a" /* default */]
};

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
var defaults = {
  units: 'px',

  breakpoints: [
    { name: 'xs', value: 0 },
    { name: 'sm', value: 768 },
    { name: 'md', value: 1024 },
    { name: 'lg', value: 1440 },
    { name: 'xl', value: 1920 } ],
}

// state will end up looking something like this {xs:false, sm:true, md: false...}
var state = {
  current: null,
  get smUp() { return this.sm || this.md || this.lg || this.xl },
  get mdUp() { return this.md || this.lg || this.xl },
  get lgUp() { return this.lg || this.xl },

  get lgDown() { return this.xs || this.sm || this.md || this.lg },
  get mdDown() { return this.xs || this.sm || this.md },
  get smDown() { return this.xs || this.sm },
};

/* harmony default export */ exports["a"] = function (Vue, options) {

  var settings = Object.assign({}, defaults, options);

  // Set up MediaQueryList listeners to update state
  settings.breakpoints
    .sort(function (a, b) { return a.value - b.value; })
    .forEach(function (bp, index) {
      var next = settings.breakpoints[index + 1];
      var mq = "(min-width: " + (bp.value) + (settings.units) + ")";
      if(next) { mq += " and (max-width: " + (next.value - 1) + (settings.units) + ")"; }

      var mqList = window.matchMedia(mq);
      mqList.addListener(function (e) {
        state[bp.name] = e.matches
        if(state[bp.name]) { state.current = bp.name }
      });

      // Set initial state
      state[bp.name] = mqList.matches;
      if(state[bp.name]) { state.current = bp.name }
    });    

  // Mixin state into all components as "$breakpoints"
  Object.defineProperty(Vue.prototype, '$breakpoints', {
    get: function get () { return this.$root._breakpoints }
  });

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      Vue.util.defineReactive(this, '_breakpoints', state);
    },
  });

  Vue.component('breakpoints', {
    functional: true,
    abstract: true,
    render: function (h, ref) {
      var children = ref.children;
      var props = ref.props;

      if(props[state.current] === "" || props[state.current] === true) {
        return children.length === 1 ? children[0] : h('div', children)
      }
    },
    props: settings.breakpoints.map(function (bp) { return bp.name; })
  })
};

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_toasts_toast_vue__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_toasts_toast_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_toasts_toast_vue__);


/* harmony default export */ exports["a"] = function (Vue, options) {

  var TOAST_CONSTRUCTOR = Vue.extend(__WEBPACK_IMPORTED_MODULE_0__components_toasts_toast_vue___default.a);

  var Toaster = function Toaster() {
  };

  Toaster.prototype.show = function show (message, options, element) {
      var this$1 = this;

    var container = null
    if (element == undefined) {
      container = document.body.querySelector('#site-header');
    } else {
      container = element
    }
    var props = Object.assign({
      message: message,
      value: true,
      closedCallback:function (toast) { this$1.onToastClosed(toast) }
    }, options)
    var toast = new TOAST_CONSTRUCTOR({propsData: props}).$mount();

    container.prepend(toast.$el);
    if (element == undefined) {
      var mainView = document.querySelector('.main-view'),
          computedStyle = getComputedStyle(mainView),
          toastOffsetHeight = parseInt(computedStyle.marginTop) + toast.$el.offsetHeight
      document.querySelector('.main-view').setAttribute('style', 'margin-top:' + toastOffsetHeight + 'px')
    }
  };

  Toaster.prototype.onToastClosed = function onToastClosed (toast) {
    setTimeout(function () {
      toast.$destroy(true);
      document.querySelector('.main-view').removeAttribute('style');
      toast.$el.parentNode.removeChild(toast.$el);
    }, 500 /*wait for animation to finish*/);
  };

  Vue.prototype.$toaster = new Toaster();
};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__google_maps_api_loader__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scroll_spy__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(3);





/* harmony default export */ exports["a"] = {
  GoogleMapsApiLoader: __WEBPACK_IMPORTED_MODULE_0__google_maps_api_loader__["a" /* default */], GoogleMapsApiConfig: __WEBPACK_IMPORTED_MODULE_0__google_maps_api_loader__["b" /* GoogleMapsApiConfig */],
  createSimpleFunctional: __WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* createSimpleFunctional */], createSimpleTransition: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* createSimpleTransition */], findChildComponents: __WEBPACK_IMPORTED_MODULE_3__helpers__["e" /* findChildComponents */], debounce: __WEBPACK_IMPORTED_MODULE_3__helpers__["f" /* debounce */], MonthMeta: __WEBPACK_IMPORTED_MODULE_3__helpers__["g" /* MonthMeta */],
  moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a,
  ScrollSpy: __WEBPACK_IMPORTED_MODULE_2__scroll_spy__["a" /* default */]
};

/***/ },
/* 137 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

var map = {
	"./af": 10,
	"./af.js": 10,
	"./ar": 17,
	"./ar-dz": 11,
	"./ar-dz.js": 11,
	"./ar-kw": 12,
	"./ar-kw.js": 12,
	"./ar-ly": 13,
	"./ar-ly.js": 13,
	"./ar-ma": 14,
	"./ar-ma.js": 14,
	"./ar-sa": 15,
	"./ar-sa.js": 15,
	"./ar-tn": 16,
	"./ar-tn.js": 16,
	"./ar.js": 17,
	"./az": 18,
	"./az.js": 18,
	"./be": 19,
	"./be.js": 19,
	"./bg": 20,
	"./bg.js": 20,
	"./bm": 21,
	"./bm.js": 21,
	"./bn": 22,
	"./bn.js": 22,
	"./bo": 23,
	"./bo.js": 23,
	"./br": 24,
	"./br.js": 24,
	"./bs": 25,
	"./bs.js": 25,
	"./ca": 26,
	"./ca.js": 26,
	"./cs": 27,
	"./cs.js": 27,
	"./cv": 28,
	"./cv.js": 28,
	"./cy": 29,
	"./cy.js": 29,
	"./da": 30,
	"./da.js": 30,
	"./de": 33,
	"./de-at": 31,
	"./de-at.js": 31,
	"./de-ch": 32,
	"./de-ch.js": 32,
	"./de.js": 33,
	"./dv": 34,
	"./dv.js": 34,
	"./el": 35,
	"./el.js": 35,
	"./en-au": 36,
	"./en-au.js": 36,
	"./en-ca": 37,
	"./en-ca.js": 37,
	"./en-gb": 38,
	"./en-gb.js": 38,
	"./en-ie": 39,
	"./en-ie.js": 39,
	"./en-nz": 40,
	"./en-nz.js": 40,
	"./eo": 41,
	"./eo.js": 41,
	"./es": 44,
	"./es-do": 42,
	"./es-do.js": 42,
	"./es-us": 43,
	"./es-us.js": 43,
	"./es.js": 44,
	"./et": 45,
	"./et.js": 45,
	"./eu": 46,
	"./eu.js": 46,
	"./fa": 47,
	"./fa.js": 47,
	"./fi": 48,
	"./fi.js": 48,
	"./fo": 49,
	"./fo.js": 49,
	"./fr": 52,
	"./fr-ca": 50,
	"./fr-ca.js": 50,
	"./fr-ch": 51,
	"./fr-ch.js": 51,
	"./fr.js": 52,
	"./fy": 53,
	"./fy.js": 53,
	"./gd": 54,
	"./gd.js": 54,
	"./gl": 55,
	"./gl.js": 55,
	"./gom-latn": 56,
	"./gom-latn.js": 56,
	"./gu": 57,
	"./gu.js": 57,
	"./he": 58,
	"./he.js": 58,
	"./hi": 59,
	"./hi.js": 59,
	"./hr": 60,
	"./hr.js": 60,
	"./hu": 61,
	"./hu.js": 61,
	"./hy-am": 62,
	"./hy-am.js": 62,
	"./id": 63,
	"./id.js": 63,
	"./is": 64,
	"./is.js": 64,
	"./it": 65,
	"./it.js": 65,
	"./ja": 66,
	"./ja.js": 66,
	"./jv": 67,
	"./jv.js": 67,
	"./ka": 68,
	"./ka.js": 68,
	"./kk": 69,
	"./kk.js": 69,
	"./km": 70,
	"./km.js": 70,
	"./kn": 71,
	"./kn.js": 71,
	"./ko": 72,
	"./ko.js": 72,
	"./ky": 73,
	"./ky.js": 73,
	"./lb": 74,
	"./lb.js": 74,
	"./lo": 75,
	"./lo.js": 75,
	"./lt": 76,
	"./lt.js": 76,
	"./lv": 77,
	"./lv.js": 77,
	"./me": 78,
	"./me.js": 78,
	"./mi": 79,
	"./mi.js": 79,
	"./mk": 80,
	"./mk.js": 80,
	"./ml": 81,
	"./ml.js": 81,
	"./mr": 82,
	"./mr.js": 82,
	"./ms": 84,
	"./ms-my": 83,
	"./ms-my.js": 83,
	"./ms.js": 84,
	"./mt": 85,
	"./mt.js": 85,
	"./my": 86,
	"./my.js": 86,
	"./nb": 87,
	"./nb.js": 87,
	"./ne": 88,
	"./ne.js": 88,
	"./nl": 90,
	"./nl-be": 89,
	"./nl-be.js": 89,
	"./nl.js": 90,
	"./nn": 91,
	"./nn.js": 91,
	"./pa-in": 92,
	"./pa-in.js": 92,
	"./pl": 93,
	"./pl.js": 93,
	"./pt": 95,
	"./pt-br": 94,
	"./pt-br.js": 94,
	"./pt.js": 95,
	"./ro": 96,
	"./ro.js": 96,
	"./ru": 97,
	"./ru.js": 97,
	"./sd": 98,
	"./sd.js": 98,
	"./se": 99,
	"./se.js": 99,
	"./si": 100,
	"./si.js": 100,
	"./sk": 101,
	"./sk.js": 101,
	"./sl": 102,
	"./sl.js": 102,
	"./sq": 103,
	"./sq.js": 103,
	"./sr": 105,
	"./sr-cyrl": 104,
	"./sr-cyrl.js": 104,
	"./sr.js": 105,
	"./ss": 106,
	"./ss.js": 106,
	"./sv": 107,
	"./sv.js": 107,
	"./sw": 108,
	"./sw.js": 108,
	"./ta": 109,
	"./ta.js": 109,
	"./te": 110,
	"./te.js": 110,
	"./tet": 111,
	"./tet.js": 111,
	"./th": 112,
	"./th.js": 112,
	"./tl-ph": 113,
	"./tl-ph.js": 113,
	"./tlh": 114,
	"./tlh.js": 114,
	"./tr": 115,
	"./tr.js": 115,
	"./tzl": 116,
	"./tzl.js": 116,
	"./tzm": 118,
	"./tzm-latn": 117,
	"./tzm-latn.js": 117,
	"./tzm.js": 118,
	"./uk": 119,
	"./uk.js": 119,
	"./ur": 120,
	"./ur.js": 120,
	"./uz": 122,
	"./uz-latn": 121,
	"./uz-latn.js": 121,
	"./uz.js": 122,
	"./vi": 123,
	"./vi.js": 123,
	"./x-pseudo": 124,
	"./x-pseudo.js": 124,
	"./yo": 125,
	"./yo.js": 125,
	"./zh-cn": 126,
	"./zh-cn.js": 126,
	"./zh-hk": 127,
	"./zh-hk.js": 127,
	"./zh-tw": 128,
	"./zh-tw.js": 128
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 138;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(292)(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)os/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , osname: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , osname: 'Chrome OS'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , osname: 'Sailfish OS'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
        result.osname = 'Firefox OS'
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , osname: 'BlackBerry OS'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , osname: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , osname: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , osname: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && (android || result.silk)) {
      result.android = t
      result.osname = 'Android'
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t
      result.ios = t
      result.osname = 'iOS'
    } else if (mac) {
      result.mac = t
      result.osname = 'macOS'
    } else if (xbox) {
      result.xbox = t
      result.osname = 'Xbox'
    } else if (windows) {
      result.windows = t
      result.osname = 'Windows'
    } else if (linux) {
      result.linux = t
      result.osname = 'Linux'
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  /*
   * Set our detect public method to the main bowser object
   * This is needed to implement bowser in server side
   */
  bowser.detect = detect;
  return bowser
});


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

var this$1 = this;
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ exports["default"] = {

  props: {
    button: Boolean,
    primary: Boolean,
    secondary:Boolean,

    fill: {
      type: String,
      default: function () { return this$1.indeterminate ? 'none' : 'transparent'; }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize () {
      var size = Number(this.size)

      if (this.button) {
        size += 8
      }

      return size
    },

    circumference: function circumference () {
      return 2 * Math.PI * this.radius
    },

    classes: function classes () {
      return {
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button,
        'primary--text': this.primary,
        'secondary--text': this.secondary,
      }
    },

    cxy: function cxy () {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2
    },

    normalizedValue: function normalizedValue () {
      if (this.value < 0) {
        return 0
      }

      if (this.value > 100) {
        return 100
      }

      return this.value
    },

    radius: function radius () {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2
    },

    strokeDashArray: function strokeDashArray () {
      return Math.round(this.circumference * 1000) / 1000
    },

    strokeDashOffset: function strokeDashOffset () {
      return ((100 - this.normalizedValue) / 100) * this.circumference + 'px'
    },

    styles: function styles () {
      return {
        height: ((this.calculatedSize) + "px"),
        width: ((this.calculatedSize) + "px")
      }
    },

    svgSize: function svgSize () {
      return this.indeterminate ? false : this.calculatedSize
    },

    svgStyles: function svgStyles () {
      return {
        transform: ("rotate(" + (this.rotate) + "deg)")
      }
    },

    viewBox: function viewBox () {
      return this.indeterminate ? '25 25 50 50' : false
    }
  }
};


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ exports["default"] = {

  props: {
    active: {
      type: Boolean,
      default: true
    },

    buffer: Boolean,

    bufferValue: Number,

    height: {
      type: [Number, String],
      default: 2
    },

    indeterminate: Boolean,

    query: Boolean,

    value: {
      type: [Number, String],
      default: 0
    }
  },

  computed: {
    classes: function classes () {
      return {
        'progress-linear--query': this.query,
      }
    },

    styles: function styles () {
      var styles = {}

      if (!this.active) {
        styles.height = 0
      }

      if (this.buffer) {
        styles.width = (this.bufferValue) + "%"
      }

      return styles
    },

    bufferStyles: function bufferStyles () {
      var styles = {}

      if (!this.active) {
        styles.height = 0
      }

      return styles
    }
  }
};


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ exports["default"] = {
	props: {
		item: String
	}
};


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ exports["default"] = {
	props: {
		flat: Boolean
	},

	computed: {
		classes: function classes() {
			return {
				'tabs--flat': this.flat
			}
		}
	}
};


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);

/* harmony default export */ exports["a"] = {
    name: 'accordian',

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

    props: {
        active: false,
        disabled: false,
        clickOutside: false,
        select: false,
        autoExpandFirst: Boolean,
    },

    computed: {
        classes: function classes(){
            return {
                'accordian': true,
                'accordian--active': this.isActive,
                'accordian--inactive': !this.isActive,
                'accordian--disabled': this.disabled == true,
                'accordian--select':this.select
            }
        },
        computedTransition: function computedTransition(){
            return this.isActive ? 'sk-slide-y-transition' : 'sk-slide-y-reverse-transition'
        }
    },

    created: function created(){
        this.isActive = this.active;
    },

    mounted: function mounted(){
        if(this.autoExpandFirst) {
            this.isActive = true
        }
    },

    watch:{
        active: function active(){
            this.isActive = this.active;
        }
    },

    render: function render(h){
        var this$1 = this;


        var children = [];
        var headerTmpl = {
            class: 'accordian__header',
            on: {
                click: function (el){
                    if (!this$1.disabled) {
                        if (this$1.isActive) {
                            this$1.isActive = !this$1.isActive
                        } else {
                            this$1.$parent.$children.forEach(function (el){
                                el.isActive = false
                            })
                            this$1.isActive = !this$1.isActive;
                        }
                    }
                }
            }
        };
        if(this.clickOutside){

            headerTmpl.directives = [ { name: 'click-outside', value: this.isActive }]
        }
        var header =
            h('div',headerTmpl , [this.$slots.header, h('div', {class: 'accordian__select'})])
        if (this.isActive) {


            children.push(h('div', {
                class: 'accordian__content'
            }, [this.$slots.content]))
        }
        return h('div', {
            'class': this.classes,

        }, [header, h(this.computedTransition, {}, children)])
    }
};

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accordian_js__ = __webpack_require__(144);


/* harmony default export */ exports["a"] = {Accordian: __WEBPACK_IMPORTED_MODULE_0__accordian_js__["a" /* default */]};

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_route_link__ = __webpack_require__(129);



/* harmony default export */ exports["a"] = {

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    primary: Boolean,
    secondary: Boolean,
    tertiary: Boolean,
    light: Boolean,
    quickBtn: Boolean,
    block: Boolean,
    inlineBlock: Boolean,
    default: Boolean,
    icon: Boolean,
    large: Boolean,
    link: Boolean,
    flat: Boolean,
    dark: Boolean,
    loading: Boolean,
    small: Boolean,
    contextValue: String,
    dataValue: String,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes () {
      return {
        'btn': true,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--inline-block': this.inlineBlock,
        'btn--disabled': this.disabled,
        'btn--link': this.link,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--flat': this.flat,
        'btn--loader': this.loading,
        'btn--small': this.small,
        'btn--dark': this.dark,
        'btn--primary': this.primary,
        'btn--secondary': this.secondary,
        'btn--tertiary': this.tertiary,
        'btn--light': this.light,
        'btn--quick-book': this.quickBtn,
      }
    },

  },

  methods: {
    genContent: function genContent (h) {
      return h('span', { 'class': 'btn__content' }, [this.$slots.default])
    },
    genLoader: function genLoader (h) {
      var children = []

      if (!this.$slots.loader) {
        children.push(h('sk-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }))
      } else {
        children.push(this.$slots.loader)
      }

      return h('span', { 'class': 'btn__loading' }, children)
    },

  },

  mounted: function mounted() {
    if(this.contextValue != null && this.contextValue != undefined) {
      this.$el.setAttribute('data-track-context', this.contextValue);
    }
    else if (this.$el) {
      var contextEl = this.$el.closest('[context]')
      if (contextEl) {
        this.$el.setAttribute('data-track-context', contextEl.getAttribute('context'))
      }else {
        if (this.$route) { this.$el.setAttribute('data-track-context', this.$route.name) }
      }
    }

    if(this.dataValue != null && this.dataValue != undefined) {
        this.$el.setAttribute('data-track-value', this.dataValue)
    }

  },

  render: function render (h) {
    var ref = this.generateRouteLink(true);
    var tag = ref.tag;
    var data = ref.data;
    var children = []

    if (tag === 'button') {
      data.attrs.type = this.type
    }

    if(this.dataValue != null && this.dataValue != undefined) {
        data['data-track-value'] = this.dataValue;
    }

    children.push(this.genContent(h))


    if (this.loading) {
      children.push(this.genLoader(h))
    }

    return h(tag, data, children)
  },

};


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button_js__ = __webpack_require__(146);


/* harmony default export */ exports["a"] = { Button: __WEBPACK_IMPORTED_MODULE_0__button_js__["a" /* default */] };


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prefTransform = getPrefixedTransform();
function getPrefixedTransform() {
    var testEl = document.createElement('div');
    if (testEl.style.transform == null) {
        var vendors = ['Webkit', 'Moz', 'ms'];
        for (var i in vendors) {
            if (testEl.style[vendors[i] + 'Transform'] !== undefined) {
                return vendors[i] + 'Transform';
            }
        }
    }
    return 'transform';
}
/* harmony default export */ exports["default"] = {
    name: 'carousel',

    props: {
        autoAdvance: Boolean,
        advanceTime: {type: [Number, String], default: 5000},
        slidesPerPage: {type: Number, default: 1},
        pageMarkers: {type: Boolean, default: false},
        controlBtns: {type: Boolean, default: true},
        wrap: {type: Boolean, default: true},
    },

    data: function data() {
        return {
            numSlides: 0,
            slides: [],
            currentSlideGroup: 0,
            timerId: 0,
            containerWidth: 0,
            slidesWrapper: null,
            dragSens: 0.7,
            startDragX: 0,
            draggedDistX: 0,
            slideWrapperWidth: 0
        }
    },


    computed: {

        numPages: function numPages() {
            return Math.ceil(this.numSlides / this.slidesPerPage);
        },

        slideWidth: function slideWidth() {
            return Math.ceil(this.containerWidth / (Math.min(this.slidesPerPage, this.numSlides)));
        },

        slideWrapperStyles: function slideWrapperStyles() {
            // Update slide wrapper position, so that the active slide is on screen
            var wrapperWidth = 0
            if (this.$el) {
                wrapperWidth = getComputedStyle(this.$el.firstChild)
            }
            var width = (this.numSlides * this.slideWidth)
            var offset = this.currentSlideGroup * this.containerWidth;
            // Make sure that we don't advance the carousel too far if the last page contains only a few items( not enough to fill the container)
            offset = Math.min(offset, width - this.containerWidth);
            return {
                width: (width + "px"),
                transform: ("translate3d(" + (-offset) + "px, 0, 0)"),
            }
        }
    },

    mounted: function mounted() {
        // let computedStyle = getComputedStyle(this.$el);
        // this.containerWidth = this.$el.offsetWidth - parseFloat(computedStyle.paddingLeft) - parseFloat(computedStyle.paddingRight);
        // var slot_slides = this.$slots.slides || [];
        // this.slides = slot_slides.map(vnode => vnode.elm);
        // this.slideWrapperWidth = this.slides.length * this.slideWidth
        this.computedContainerWidth()
        this.processSlides()

        window.addEventListener('resize', this.onWindowResize)

        if (this.$breakpoints.xs) {
            this.slidesWrapper = this.$el.firstChild.firstChild
            this.slidesWrapper.addEventListener('touchstart', this.onTouchStart);
        }

    },

    updated: function updated() {
        this.processSlides()
    },

    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.onWindowResize)
        window.removeEventListener('touchmove', this.onTouchMove, true);
    },

    methods: {
        computedContainerWidth: function computedContainerWidth() {
            var computedStyle = getComputedStyle(this.$el)
            this.containerWidth = this.$el.firstChild.offsetWidth - parseFloat(computedStyle.paddingLeft) - parseFloat(computedStyle.paddingRight)
        },

        processSlides: function processSlides() {
            this.slides = (this.$slots.slides && this.$slots.slides.map(function (vnode) { return vnode.elm; })) || []
            this.numSlides = this.slides.length
            this.slideWrapperWidth = this.slides.length * this.slideWidth
        },

        startTimer: function startTimer() {
            this.timerId = setInterval(this.onTimerTick, this.advanceTime);
        },

        stopTimer: function stopTimer() {
            if (this.timerId) { clearInterval(this.timerId); }
        },

        resetTimer: function resetTimer() {
            this.stopTimer();
            this.startTimer();
        },

        onTimerTick: function onTimerTick() {
            this.currentSlideGroup++;
        },

        clampSlideGroup: function clampSlideGroup(allowWrapping) {
            if (allowWrapping !== false) {
                if (this.currentSlideGroup >= this.numPages) { this.currentSlideGroup = 0 }
                if (this.currentSlideGroup < 0) { this.currentSlideGroup = this.numPages - 1 }
            }
            else {
                this.currentSlideGroup = Math.min(Math.max(this.currentSlideGroup, 0), this.numPages - 1)
            }
        },

		onTouchStart: function(e) {
			this.startDragX = e.touches[0].clientX;
			this.slidesWrapper.style.transition = 'none'; // disable default transition on wrapper el
			this.stopTimer();
			document.body.addEventListener('touchmove', this.onTouchMove, false);
			document.body.addEventListener('touchend', this.onTouchEnd, true);
			
		},

        onTouchMove: function (e) {
            this.draggedDistX = e.touches[0].clientX - this.startDragX;
            // Calculate the offset for the wrapper to display the current page on-screen
            var offset = this.currentSlideGroup * this.containerWidth;
            // Make sure that we don't advance the carousel too far if the last page contains only a few items( not enough to fill the container)
            offset = Math.min(offset, this.slideWrapperWidth - this.containerWidth);

            // Add the dragged amount onto the calculated starting offset
            // This value is not clamped to allow for "over-scroll"
            var final = offset - (this.draggedDistX * this.dragSens);

            this.slidesWrapper.style[prefTransform] = 'translate3d(' + -final + 'px, 0, 0)';
        },

        onTouchEnd: function (e) {
            var minDrag = this.slideWidth * 0.2;
            this.slidesWrapper.style.transition = '';

            if (this.draggedDistX > minDrag)
                { this.currentSlideGroup--; }
            else if (this.draggedDistX < -minDrag)
                { this.currentSlideGroup++; }

            this.clampSlideGroup(false);

            var width = this.numSlides * this.slideWidth;
            var offset = this.currentSlideGroup * this.containerWidth;
            // Make sure that we don't advance the carousel too far if the last page contains only a few items( not enough to fill the container)
            offset = Math.min(offset, width - this.containerWidth);
            this.slidesWrapper.style[prefTransform] = 'translate3d(' + -offset + 'px, 0, 0)';
            this.draggedDistX = 0;

            if (this.autoAdvance) { this.resetTimer(); }

            // Clean up drag stuff
            document.body.removeEventListener('touchmove', this.onTouchMove, false);
            document.body.removeEventListener('touchend', this.onTouchEnd, true);

            // this.updateCarousel();
        },

        onWindowResize: function onWindowResize(e) {
            this.computedContainerWidth()
        }

    },

    watch: {
        //FROM RICHARD: added the if statement and slideWidth calcs here to handle the event where the slide length changes
        slides: function slides(n, o){
            var this$1 = this;

            if (n.length !== o.length) {
                var computedStyle = getComputedStyle(this.$el);
                this.containerWidth = this.$el.firstChild.offsetWidth - parseFloat(computedStyle.paddingLeft) - parseFloat(computedStyle.paddingRight);
                this.slides.forEach(function (slide) { return slide.style.width = (this$1.slideWidth) + "px"; })
            }
        },

		currentSlideGroup: function currentSlideGroup() {
			this.clampSlideGroup()
			if(this.autoAdvance) { this.resetTimer() }
		},

		slideWidth: function slideWidth() {
			var this$1 = this;

			this.slides.forEach(function (slide) { return slide.style.width = (this$1.slideWidth) + "px"; })
		},

		autoAdvance: {
			immediate: true,
			handler: function handler (newVal) {
				if(newVal == true) {
					this.resetTimer()
				}
				else {
					this.stopTimer()
				}
			},
		}
	}

};


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__carousel_vue__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__carousel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__carousel_vue__);


/* harmony default export */ exports["a"] = { Carousel: __WEBPACK_IMPORTED_MODULE_0__carousel_vue___default.a };


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony default export */ exports["a"] = {
  name: 'colours',
  props: {
    primary: Boolean,
    secondary: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'colour-block': true,
        'colour-primary': this.primary,
        'colour-secondary': this.secondary
      }
    }
  },

  render: function render(h) {
    return h('div', {class:this.classes})
  }
};


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(150);


/* harmony default export */ exports["a"] = {
	Color: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]
};


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony default export */ exports["default"] = {

    props: {
        type: String,
        concession: Object,
        smallCounter: Boolean,
        showRandValue: Boolean,
        card: Object,
    },

    data: function data() {
        return {
            count: this.concession.selected,
            title: this.concession.title,
            Description: this.concession.title,
            available: this.concession.available,
            selected: this.concession.selected,
            hasCombo: false,
        }
    },

    computed: {
        classes: function classes() {
            return {
                'icon--large': this.isLarge,
                'icon--medium': this.isRegular,
                'icon--small': this.isSmall,
            }
        }
    },

    methods: {
        increment: function increment() {
            if(this.concession.Quantity < this.available) {
                this.concession.available--
                this.available = this.concession.available
                this.concession.selected++
                this.selected = this.concession.selected
                this.$emit('addFanCombo', this.card)
                this.count = this.concession.Quantity;
            }
        },

        decrement: function decrement() {
            if (this.concession.Quantity > 0) {
                
                this.concession.available++
                this.available = this.concession.available
                this.concession.selected--
                this.selected = this.concession.selected
                this.$emit('removeFanCombo', this.card)
                this.count = this.concession.Quantity;
            }
        },

        addCombo: function addCombo() {
            this.$emit('addFanCombo', this.card)
        },

        removeCombo: function removeCombo() {
            this.$emit('removeFanCombo', this.card)
        }
    },

    created: function created() {

        if(this.card != undefined && this.card != null) {
            if(this.card.TicketType.Description.includes("Combo")) {
                this.hasCombo = true
            }
        }
        // console.log("card", this.card)
        // console.log(this.Description, this.concession)
    }
};


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__counter_box_fan_vue__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__counter_box_fan_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__counter_box_fan_vue__);


/* harmony default export */ exports["a"] = {
	CounterBoxFan: __WEBPACK_IMPORTED_MODULE_0__counter_box_fan_vue___default.a
};


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony default export */ exports["default"] = {

    props: {
        type: String,
        concession: Object,
        smallCounter: Boolean,
        showRandValue: Boolean,
    },

    data: function data() {
        return {
            count: this.concession.Quantity,
            isLarge: this.concession.Description.toLowerCase().includes('large'),
            isRegular: this.concession.Description.toLowerCase().includes('regular'),
            isSmall: this.concession.Description.toLowerCase().includes('small'),
        }
    },

    computed: {


        classes: function classes() {
            return {
                'icon--large': this.isLarge,
                'icon--medium': this.isRegular,
                'icon--small': this.isSmall,
            }
        }
    },

    methods: {
        increment: function increment() {
            this.$emit('concessionChange', this.concession, this.concession.Quantity + 1)
            this.count = this.concession.Quantity;
        },

        decrement: function decrement() {
            if (this.concession.Quantity > 0) {
                this.$emit('concessionChange', this.concession, this.concession.Quantity - 1)
                this.count = this.concession.Quantity;
            }
        }
    },


};


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__counter_box_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__counter_box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__counter_box_vue__);


/* harmony default export */ exports["a"] = {
	CounterBox: __WEBPACK_IMPORTED_MODULE_0__counter_box_vue___default.a
};


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_overlayable_js__ = __webpack_require__(219);



/* harmony default export */ exports["a"] = {

	mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_overlayable_js__["a" /* default */]],

	data: function data () {
		return {
			app: null
		}
	},

	props: {
	  disabled: Boolean,
	  persistent: Boolean,
	  fullscreen: Boolean,
	  lazy: Boolean,
    light: Boolean,
	  origin: {
	    type: String,
	    default: 'center center'
	  },
	  width: {
	    type: [String, Number],
	    default: 290
	  },
	  transition: {
	    type: [String, Boolean],
	    default: 'sk-slide-y-reverse-transition'
	  }
	},

	computed: {
    classes: function classes () {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--light': this.light,
      }
    },
    computedTransition: function computedTransition () {
      return !this.transition
        ? 'transition'
        : this.transition
    }
  },
  watch: {
    isActive: function isActive (val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay()
        this.fullscreen && this.hideScroll()
      } else {
        this.removeOverlay()
        this.showScroll()
      }
    }
  },

	mounted: function mounted () {
    var this$1 = this;

    this.app = document.getElementById('#app')
    this.$nextTick(function () {
      this$1.app && this$1.app.appendChild(this$1.$refs.dialog_content)
    })
  },

  beforeDestroy: function beforeDestroy () {
    this.removeOverlay();
      this.app &&
      this.app.contains(this.$refs.content) &&
      this.app.removeChild(this.$refs.content)
  },

  methods: {
    closeConditional: function closeConditional (e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent
    }
  },

	render: function render (h) {
    var this$1 = this;

    var classes = Object.keys(this.classes).filter(function (k) { return this$1.classes[k]; }).join(' ')
    classes += ' ' + this.$vnode.data.staticClass

    var children = []
    var data = {
      'class': classes,
      ref: 'dialog',
      directives: [
        { name: 'click-outside', value: this.closeConditional },
        { name: 'show', value: this.isActive }
      ]
    }

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : ((this.width) + "px")
      }
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function (e) {
            e.stopPropagation()
            if (!this$1.disabled) { this$1.isActive = !this$1.isActive }
          }
        }
      }, [this.$slots.activator]))
    }


    var dialog = h(this.computedTransition, {
      props: { origin: this.origin }
    }, [h('div', data, [this.$slots.default])])

    children.push(h('div', {
      'class': 'dialog__content',
      ref: 'content'
    }, [dialog]))

    return h('div', {
      'class': 'dialog__container'
    }, children)
  }
};


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dialog_js__ = __webpack_require__(156);


/* harmony default export */ exports["a"] = { Dialog: __WEBPACK_IMPORTED_MODULE_0__dialog_js__["a" /* default */] };


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony default export */ exports["a"] = {

  render: function render(compile){
      return compile('div',{class:{
          "divider":true
      }})
  }
};


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__divider__ = __webpack_require__(158);


/* harmony default export */ exports["a"] = {
	Divider: __WEBPACK_IMPORTED_MODULE_0__divider__["a" /* default */]
};


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_validatable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_form_control__ = __webpack_require__(4);
// TODO:: Support multiple checkboxes, bound to the same Array'



/* harmony default export */ exports["default"] = {
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_form_control__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_validatable__["a" /* default */]],

  methods: {
    onChange: function onChange () {
      this.$emit('input', this.$refs.controlEl.checked)
    },
  }
};

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_combo_select__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_pointer__ = __webpack_require__(220);



/* harmony default export */ exports["default"] = {
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_combo_select__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_pointer__["a" /* default */]],

    props: {

        /**
         * name attribute to match optional label element
         * @default ''
         * @type {String}
         */
        name: {
            type: String,
            default: ''
        },
        /**
         * String to show when pointing to an option
         * @default 'Press enter to select'
         * @type {String}
         */
        selectLabel: {
            type: String,
            default: 'Press enter to select'
        },
        /**
         * String to show next to selected option
         * @default 'Selected'
         * @type {String}
         */
        selectedLabel: {
            type: String,
            default: 'Selected'
        },
        /**
         * String to show when pointing to an alredy selected option
         * @default 'Press enter to remove'
         * @type {String}
         */
        deselectLabel: {
            type: String,
            default: 'Remove'
        },
        /**
         * Decide whether to show pointer labels
         * @default true
         * @type {Boolean}
         */
        showLabels: {
            type: Boolean,
            default: true
        },
        /**
         * Limit the display of selected options. The rest will be hidden within the limitText string.
         * @default 'label'
         * @type {String}
         */
        limit: {
            type: Number,
            default: 99999
        },
        /**
         * Sets maxHeight style value of the dropdown
         * @default 300
         * @type {Integer}
         */
        maxHeight: {
            type: Number,
            default: 300
        },
        /**
         * Function that process the message shown when selected
         * elements pass the defined limit.
         * @default 'and * more'
         * @param {Int} count Number of elements more than limit
         * @type {Function}
         */
        limitText: {
            type: Function,
            default: function (count) { return ("and " + count + " more"); }
        },
        /**
         * Set true to trigger the loading spinner.
         * @default False
         * @type {Boolean}
         */
        loading: {
            type: Boolean,
            default: false
        },
        /**
         * Disables the comboselect if true.
         * @default false
         * @type {Boolean}
         */
        disabled: {
            type: Boolean,
            default: false
        },
        /**
         * Fixed opening direction
         * @default ''
         * @type {String}
         */
        openDirection: {
            type: String,
            default: ''
        },
        showNoResults: {
            type: Boolean,
            default: true
        },
        tabindex: {
            type: Number,
            default: 0
        },
        validationType: {
            type: String,
            default: ''
        },
        validationValue: {
            type: String,
            default: ''
        },
        errorMessage: {
            type: String,
            default: ''
        }
    },
    
    computed: {
        visibleValue: function visibleValue () {
            return this.multiple
                ? this.internalValue.slice(0, this.limit)
                : []
        },
        deselectLabelText: function deselectLabelText () {
            return this.showLabels
                ? this.deselectLabel
                : ''
        },
        selectLabelText: function selectLabelText () {
            return this.showLabels
                ? this.selectLabel
                : ''
        },
        selectedLabelText: function selectedLabelText () {
            return this.showLabels
                ? this.selectedLabel
                : ''
        },
        inputStyle: function inputStyle () {
            if (this.multiple && this.value && this.value.length) {
                return this.isOpen ? { 'width': 'auto' } : { 'display': 'none' }
            }
        },
        contentStyle: function contentStyle () {
            return this.options.length
                ? { 'display': 'inline-block' }
                : { 'display': 'block' }
        },
        isAbove: function isAbove () {
            if (this.openDirection === 'above' || this.openDirection === 'top') {
                return true
            } else if (this.openDirection === 'below' || this.openDirection === 'bottom') {
                return false
            } else {
                return this.prefferedOpenDirection === 'above'
            }
        }
    }
};

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_timer_utils__ = __webpack_require__(224);



/* harmony default export */ exports["default"] = {

  props: {
    inline: { type: Boolean, default: false }
  },

  data: function data() {
    return {
      reseting: false
    }
  },

  computed: {
    classes: function classes() {
      return {
        'form': true,
        'form--inline': this.inline,
      }
    }
  },

  methods: {

    reset: function reset() {
      var this$1 = this;

      this.reseting = true
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_timer_utils__["a" /* nextTick */])(function () { return this$1.reseting = false; });
    },

    submit: function submit() {
      return this.onSubmit();
    },

    onSubmit: function onSubmit() {
      this.$el.checkValidity();

      var invalidControls = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["e" /* findChildComponents */])(this, function (child) { return child.$data._isValidatable; })
        .filter(function (control) { return control.valid === false; })
        .filter(function (control) { return control._isDestroyed === false; })

      if(invalidControls.length === 0) {
        this.$emit('submit');
      }
      else {
        invalidControls[0].$refs.controlEl.focus();
        return false;
      }
    }
  }
};

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_google_maps_api_loader__ = __webpack_require__(130);


/* harmony default export */ exports["default"] = {

    props: {
        value: {required: true},
        fullStreetAddressOnly: {type: Boolean, default: false},
        geolocation: {type: Boolean, default: false},
        pinOnly: Boolean,

    },

    data: function () {
        return {
            autocomplete: null,
            geocoder: null,
            geolocationInProgress: false,
            place: null,
            error: null,
            noLocation: false,
        }
    },

    computed: {
        resultTypes: function resultTypes() {
            return this.fullStreetAddressOnly
                ? ['address']
                : []
        }
    },

    mounted: function mounted() {
        // GoogleMapsApiLoader.getApi()
        //     .then(() => {
        //         this.setUpPlacesInputInstance()
        //         this.findUserLocation(false);
        //     });
    },

    methods: {

        setUpPlacesInputInstance: function setUpPlacesInputInstance() {
            var this$1 = this;

            if (!this.pinOnly) {
                // console.log("SETTING AUTOCOMPLETE")
                var options = {componentRestrictions: {country: 'ZA'}, types: this.resultTypes}
                this.autocomplete = new google.maps.places.Autocomplete(this.$el.querySelector('input'), options);

                this.autocomplete.addListener('place_changed', function () {
                    this$1.error = null;
                    var result = this$1.autocomplete.getPlace();
                    if (result.geometry) {
                        this$1.place = result;
                    }
                    else {
                        this$1.error = {code: 'PLACE_RESULT_NOT_SELECTED'}
                    }
                });
            }
        },

        findUserLocation: function findUserLocation(openSelect) {
            if ( openSelect === void 0 ) openSelect = true;

            this.geolocationInProgress = true;
            if (!navigator.geolocation && openSelect) {
                this.noLocation = true;
                this.geolocationInProgress = false;
                return;
            }

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(this.setPositionPlace);
                if (openSelect) {
                    if (this.$breakpoints.xs) { this.$el.nextElementSibling.querySelector('select') }
                    else { this.$el.nextElementSibling.querySelector('input').focus() }
                }
            } else {
              this.noLocation = true;
              this.geolocationInProgress = false;
              this.place = {};
            }
        },

        setPositionPlace: function setPositionPlace(position) {
          var j={
                  "name": null,
                  "formatted_address": null,
                  "geometry":{
                      "location":{
                          "lat": position.coords.latitude,
                          "lng": position.coords.longitude
                      }
                  },
                  "address_components": null,
                };
                this.place = j
                this.geolocationInProgress = false;
                
          localStorage.setItem("place", JSON.stringify(j));
        }
    },

    watch: {

        fullStreetAddressOnly: function fullStreetAddressOnly() {
            if (this.autocomplete) { this.autocomplete.setTypes(this.resultTypes) }
        },

        // Whenever place changes, emit an updated address
        place: function place() {
            var address = getAddressFromPlace(this.place);

            if (this.fullStreetAddressOnly == false || isValidStreetAddress(address)) {
                this.$emit('place-selected', address);
            }
            else {
                this.error = {code: 'NON_STREET_ADDRESS'}
            }

            // Emit an 'input' event to make sure any v-model associated with this component get updated
            this.$emit('input', address.formattedAddress);
        }
    },

    beforeDestroy: function beforeDestroy() {
        if (this.autocomplete) {
            this.autocomplete.unbindAll();
            google.maps.event.clearInstanceListeners(this.autocomplete);
        }
    }
};

function getAddressFromPlace(place) {
    return {
        name: place.name,
        latitude: place.geometry.location.lat,
        longitude: place.geometry.location.lng,
        formattedAddress: place.formatted_address,

        streetNumber: findPlaceComponent(place, 'street_number'),
        street: findPlaceComponent(place, 'route'),
        city: findPlaceComponent(place, ['sublocality', 'locality']),
        postalCode: findPlaceComponent(place, 'postal_code'),
        country: findPlaceComponent(place, 'country'),
    }
}

function findPlaceComponent(place, searchItems) {
    searchItems = [].concat(searchItems);
    for (var i = 0; i < searchItems.length; i++) {
        var searchItem = searchItems[i];
        var matched = false
        if (matched) { return matched.long_name; }
    }
}

function isValidStreetAddress(address) {
    return address.streetNumber && address.street && address.city && address.country;
}

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_vue__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__form_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input_vue__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__input_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkbox_vue__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__select_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__select_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__select_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__radio_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__radio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__radio_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__google_places_input_vue__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__google_places_input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__google_places_input_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__combo_select_vue__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__combo_select_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__combo_select_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__textarea_vue__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__textarea_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__textarea_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__multi_select_regions_vue__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__multi_select_regions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__multi_select_regions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__multi_select_types_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__multi_select_types_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__multi_select_types_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__multi_select_genres_vue__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__multi_select_genres_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__multi_select_genres_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__multi_select_times_vue__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__multi_select_times_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__multi_select_times_vue__);













/* harmony default export */ exports["a"] = {
    Form: __WEBPACK_IMPORTED_MODULE_0__form_vue___default.a,
    Input: __WEBPACK_IMPORTED_MODULE_1__input_vue___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_2__checkbox_vue___default.a,
    Select: __WEBPACK_IMPORTED_MODULE_3__select_vue___default.a,
    Radio: __WEBPACK_IMPORTED_MODULE_4__radio_vue___default.a,
    GooglePlacesInput: __WEBPACK_IMPORTED_MODULE_5__google_places_input_vue___default.a,
    ComboSelect: __WEBPACK_IMPORTED_MODULE_6__combo_select_vue___default.a,
    Textarea: __WEBPACK_IMPORTED_MODULE_7__textarea_vue___default.a,
    MultiSelectRegions: __WEBPACK_IMPORTED_MODULE_8__multi_select_regions_vue___default.a,
    MultiSelectTypes: __WEBPACK_IMPORTED_MODULE_9__multi_select_types_vue___default.a,
    MultiSelectGenres: __WEBPACK_IMPORTED_MODULE_10__multi_select_genres_vue___default.a,
    MultiSelectTimes: __WEBPACK_IMPORTED_MODULE_11__multi_select_times_vue___default.a,
};


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_validatable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_form_control__ = __webpack_require__(4);



/* harmony default export */ exports["default"] = {
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_form_control__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_validatable__["a" /* default */]],

  props: {
    type: { type: String, default: 'text' },
    height: String,
    list: String,
    light: Boolean,
    role: String,
  },

  methods: {
    onInput: function onInput (event) {
      this.$emit('input', event.target.value)
    },

    onFocus: function onFocus() {
      this.$emit('focus', {controlEl: this.$refs.controlEl});
    },

    togglePassword: function togglePassword() {
      this.$refs.controlEl.type == 'password' ? this.$refs.controlEl.type = 'text' : this.$refs.controlEl.type = 'password'
    }
  },

  computed: {
    isPassword: function isPassword() {
      if (this.type == 'password' && this.value) { return true }
    }
  }
};

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_form_control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);



/* harmony default export */ exports["default"] = {
	components: {
		Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a,
		FormControl: __WEBPACK_IMPORTED_MODULE_0__mixins_form_control__["a" /* default */]
	},

	props : {
		items: Array,
		val: {type:[Object,Array], default:function (){ return null; }},
		multiple: Boolean
	},

	data: function data() {
		return {
			value: this.val,
			options: this.items
		}
	},
	watch: {
		value: function value (val) {
			this.$emit('input', val)
		},

		val: function val() {
			this.value = this.val
		},

		items: function items() {
			this.options = this.items
		}
	},

	created: function created() {
		this.value = this.val
	}
};

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_form_control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);



/* harmony default export */ exports["default"] = {
	components: {
		Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a,
		FormControl: __WEBPACK_IMPORTED_MODULE_0__mixins_form_control__["a" /* default */]
	},

	props : {
		items: Array,
		val: {type:[Object,Array], default:function (){ return null; }},
	},

	data: function data() {
		return {
			value: this.val,
			options: this.items
		}
	},
	watch: {
		value: function value (val) {
			this.$emit('input', val)
		},

		val: function val () {
			this.value = this.val
		},

		items: function items() {
			this.options = this.items
		}
	},

	created: function created() {
		this.value = this.val
	}
};

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_form_control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);



/* harmony default export */ exports["default"] = {
	components: {
		Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a,
		FormControl: __WEBPACK_IMPORTED_MODULE_0__mixins_form_control__["a" /* default */]
	},

	props : {
		items: Array,
		val: {type:[Object], default:function (){ return null; }},
	},

	data: function data() {
		return {
			value: this.val,
			options: this.items
		}
	},
	watch: {
		value: function value (val) {
			this.$emit('input', val)
		},

		val: function val () {
			this.value = this.val
		},

		items: function items() {
			this.options = this.items
		}
	},

	created: function created() {
		this.value = this.val
	}
};

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_form_control__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);



/* harmony default export */ exports["default"] = {
	components: {
		Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a,
		FormControl: __WEBPACK_IMPORTED_MODULE_0__mixins_form_control__["a" /* default */]
	},

	props : {
		items: Array,
		val: {type:[Object,Array], default:function (){ return null; }},
		multiple: Boolean
	},

	data: function data() {
		return {
			value: this.val,
			options: this.items
		}
	},
	watch: {
		value: function value (val) {
			this.$emit('input', val)
		},

		val: function val() {
			this.value = this.val
		},

		items: function items() {
			this.options = this.items
		}
	},

	created: function created() {
		this.value = this.val
	}
};

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_validatable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_form_control__ = __webpack_require__(4);



/* harmony default export */ exports["default"] = {
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_form_control__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_validatable__["a" /* default */]],

  props: {
    radioValue: { required: true},
  },

  computed: {
    checked: function checked() {
      return this.value === this.radioValue
    }
  },

  methods: {
    onChange: function onChange () {
      this.$emit('input', this.radioValue)
    },
  }
};

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_validatable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_form_control__ = __webpack_require__(4);



/* harmony default export */ exports["default"] = {
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_form_control__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_validatable__["a" /* default */]],

  props: {
    multiple: Boolean
  },

  data: function data() {
    return {
      model: this.value
    }
  },

  mounted: function mounted() {
    if(this.model == undefined) { this.model = [] }
  },

  watch: {
    value: function value (val) {
      this.model = val
      if (val != undefined && this.$refs.labelEl) { this.$refs.labelEl.setAttribute('style', 'display:none') }
    },
    model: function model (val) {
      this.$emit('input', val)
      if (val != undefined && this.$refs.labelEl) { this.$refs.labelEl.setAttribute('style', 'display:none') }
    },
  },
};

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_validatable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_form_control__ = __webpack_require__(4);



/* harmony default export */ exports["default"] = {
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_form_control__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_validatable__["a" /* default */]],

  props: {
    rows: { type: [String, Number], default: 3 },
  },

  methods: {
    onInput: function onInput (event) {
      this.$emit('input', event.target.value)
    },

    onFocus: function onFocus() {
      this.$emit('focus', {controlEl: this.$refs.controlEl});
    },
  }
};

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_google_ads_api_loader__ = __webpack_require__(222);


var ad_uid_generator = 0

/* harmony default export */ exports["a"] = {

    props: {
        advertId: {required: true},
        width: {required: true},
        height: {required: true},
    },

    data: function data() {
        return {
            elementId: ("google-ad-" + (ad_uid_generator++)),
            adInstance: null,
        }
    },

    watch: {
        advertId: function advertId() {
            this.destroyAd()
            this.createAd()
        }
    },

    render: function render(h) {
        return h(
            'div',
            { attrs: { id: this.elementId, class: "google-ad" } })
    },

    mounted: function mounted() {
        this.createAd()
    },

    methods: {
        createAd: function createAd() {
            var this$1 = this;

            Promise.resolve(
                __WEBPACK_IMPORTED_MODULE_0__utils_google_ads_api_loader__["a" /* default */].getApi()
                    .then(function (googletag) {
                        this$1.adInstance = googletag
                            .defineSlot(this$1.advertId, [this$1.width, this$1.height], this$1.elementId)
                            .addService(googletag.pubads());

                        googletag.display(this$1.adInstance);
                        googletag.pubads().refresh()
                })
            ).then(function (data) {
                var adElement = document.getElementById("google_ads_iframe_"+ this$1.advertId + "_0")

                if(adElement) {
                    adElement.width = "100%";
                }
            })
        },

        destroyAd: function destroyAd() {
            if(this.adInstance) { googletag.destroySlots([this.adInstance]); }
            this.adInstance = null        
        }
    },

    beforeDestroy: function beforeDestroy() {
        this.destroyAd()
    }
};

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__google_ad_js__ = __webpack_require__(173);


/* harmony default export */ exports["a"] = { GoogleAd: __WEBPACK_IMPORTED_MODULE_0__google_ad_js__["a" /* default */] };

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony default export */ exports["default"] = {
	name: 'icon',
	
	props: {
		facebook: Boolean,
		geoLocation: Boolean,
		instagram: Boolean,
		locationPin: Boolean,
		menu: Boolean,
		play: Boolean,
		playButton: Boolean,
		quickBook: Boolean,
		share: Boolean,
		tickCheck: Boolean,
		twitter: Boolean,
		youtube: Boolean,
		arrowDown: Boolean,
		arrowLeft: Boolean,
		arrowRight: Boolean,
		arrowUp: Boolean,
		close: Boolean,
		currentLocation: Boolean,
		email: Boolean,
		search: Boolean,
		combo: Boolean,
		popcorn: Boolean,
		ticket: Boolean,
		ticket2d: Boolean,
		ticket3d: Boolean,
		ticketBirthday: Boolean,
		ticketImax: Boolean,
		combo2: Boolean,
		questionMark: Boolean,
		warning: Boolean,
		glasses3d: Boolean,
		edit: Boolean,
		downOpen: Boolean,
		upOpen: Boolean,
		cardFlip: Boolean,
		lock: Boolean,
		flame: Boolean,
		freeMovieticket: Boolean,
		prestigeMovieticket: Boolean,
		pinch: Boolean,
		type:String,
		icon:String,
	},

	computed: {
		classes: function classes() {
			return { // itemClassCode seems to group concessions so added it here
				'icon': true,
				'icon-facebook': this.facebook || this.icon === 'facebook',
				'icon-geo-location': this.geoLocation || this.icon === 'geo-location',
				'icon-instagram': this.instagram || this.icon === 'instagram',
				'icon-location-pin': this.locationPin || this.icon === 'location-pin',
				'icon-menu': this.menu || this.icon === 'menu',
				'icon-play': this.play || this.icon === 'play',
				'icon-play-button': this.playButton || this.icon === 'play-button',
				'icon-quick-book': this.quickBook || this.icon === 'quick-book',
				'icon-share': this.share || this.icon === 'share',
				'icon-tick-check': this.tickCheck || this.icon === 'tick-check',
				'icon-twitter': this.twitter || this.icon === 'twitter',
				'icon-youtube': this.youtube || this.icon === 'youtube',
				'icon-arrow-down': this.arrowDown || this.icon === 'arrow-down',
				'icon-arrow-left': this.arrowLeft || this.icon === 'arrow-left',
				'icon-arrow-right': this.arrowRight || this.icon === 'arrow-right',
				'icon-arrow-up': this.arrowUp || this.icon === 'arrow-up',
				'icon-close': this.close || this.icon === 'close',
				'icon-current-location': this.currentLocation || this.icon === 'current-location',
				'icon-email': this.email || this.icon === 'email',
				'icon-search': this.search || this.icon === 'search',
				'icon-combo': this.combo || this.icon === 'combo',
				'icon-popcorn': this.popcorn || this.icon === 'popcorn',
				'icon-ticket': this.ticket || this.icon === 'ticket',
				'icon-ticket-2d': this.ticket2d || this.icon === 'ticket-2d',
				'icon-ticket-3d': this.ticket3d || this.icon === 'ticket-3d',
				'icon-ticket-birthday': this.ticketBirthday || this.icon === 'birthday',
				'icon-ticket-imax': this.ticketImax || this.icon === 'ticket-imax',
				'icon-combo-2': this.combo2 || this.icon === 'combo-2' || this.type =='0014',
				'icon-question-mark': this.questionMark || this.icon === 'question-mark',
				'icon-warning': this.warning || this.icon === 'warning',
				'icon-3d-glasses': this.glasses3d || this.icon === 'glasses-3d' || this.type  =='0025',
				'icon-edit': this.edit || this.icon === 'edit',
				'icon-down-open' : this.downOpen || this.icon === 'down-open',
				'icon-up-open' : this.upOpen || this.icon === 'up-open',
				'icon-card-flip' : this.cardFlip || this.icon === 'card-flip',
				'icon-vision-mission' : this.vision_mission || this.icon === 'vision-mission' || this.type == '0029',
				'icon-lock': this.lock || this.icon === 'icon-lock',
				'icon-flame': this.flame || this.icon === 'icon-flame',
				'icon-free-movieticket': this.freeMovieticket || this.icon === 'free-movieticket' || this.type == '0028',
				'icon-prestige-movieticket': this.prestigeMovieticket || this.icon === 'prestige-movieticket',
				'icon-pinch': this.pinch || this.icon === 'pinch',
			}
		}
	}
};

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__icon_vue__);


/* harmony default export */ exports["a"] = { Icon: __WEBPACK_IMPORTED_MODULE_0__icon_vue___default.a };

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(3);


var Flex = {
  functional: true,

  render: function (h, ref) {
    var data = ref.data;
    var children = ref.children;

    data.staticClass = data.staticClass ? ("flex " + (data.staticClass)) : 'flex'
    data.staticClass += " " + (Object.keys(data.attrs).join(' '))
    delete data.attrs

    return h('div', data, children)
  }
}

var Layout = {
  functional: true,

  render: function (h, ref) {
    var data = ref.data;
    var children = ref.children;

    data.staticClass = data.staticClass ? ("layout " + (data.staticClass)) : 'layout'

    if (data.attrs) {
      data.staticClass += " " + (Object.keys(data.attrs).join(' '))
      delete data.attrs
    }

    return h('div', data, children)
  }
}

var Container = {
  functional: true,

  props: {
    fluid: Boolean
  },

  render: function render (h, ref) {
    var props = ref.props;
    var data = ref.data;
    var children = ref.children;

    data.staticClass = data.staticClass ? ("container " + (data.staticClass)) : 'container'

    if (props.fluid) { data.staticClass += ' container--fluid' }

    return h('div', data, children)
  }
}

var Panel = {
  functional: true,

  props: {
    fluid: Boolean,
    light: Boolean,
    black: Boolean,
    transparent: Boolean
  },

  render: function render (h, ref) {
    var props = ref.props;
    var data = ref.data;
    var children = ref.children;

    data.staticClass = data.staticClass ? ("panel " + (data.staticClass)) : 'panel'

    if (props.fluid) { data.staticClass += ' panel--fluid' }
    if (props.light) { data.staticClass += ' panel--light' }
    if (props.black) { data.staticClass += ' panel--black' }
    if (props.transparent) { data.staticClass += ' panel--transparent' }

    return h('div', data, children)
  }
}

var Spacer = {
  functional: true,

  props: {
    height: {
      type: [Number, String]
    }
  },

  render: function (h, ref) {
    var props = ref.props;
    var data = ref.data;
    var children = ref.children;

    data.staticClass = data.staticClass ? ("spacer " + (data.staticClass)) : 'spacer';
    if (props.height) { data.attrs.style = "height:" + (props.height) + "px" }

    return h('div', data, children)
  }
}

/* harmony default export */ exports["a"] = {
  Flex: Flex,
  Container: Container,
  Spacer: Spacer,
  Layout: Layout,
  Panel: Panel
};


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__grid_js__ = __webpack_require__(177);


/* harmony default export */ exports["a"] = Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__grid_js__["a" /* default */]);

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__list__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__list_group__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__list_tile__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__list_tile_action__ = __webpack_require__(181);







var ListItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["b" /* createSimpleFunctional */])('list__item', 'li')
var ListSubheader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["b" /* createSimpleFunctional */])('list__subheader', 'li')
var ListTileActionText = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["b" /* createSimpleFunctional */])('list__tile__action-text', 'span')
var ListTileContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["b" /* createSimpleFunctional */])('list__tile__content', 'div')
var ListTileTitle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["b" /* createSimpleFunctional */])('list__tile__title', 'div')
var ListTileSubTitle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["b" /* createSimpleFunctional */])('list__tile__sub-title', 'div')

/* harmony default export */ exports["a"] = {
	List: __WEBPACK_IMPORTED_MODULE_1__list__["a" /* default */],
	ListItem: ListItem,
	ListGroup: __WEBPACK_IMPORTED_MODULE_2__list_group__["a" /* default */],
	ListSubheader: ListSubheader,
	ListTile: __WEBPACK_IMPORTED_MODULE_3__list_tile__["a" /* default */],
	ListTileAction: __WEBPACK_IMPORTED_MODULE_4__list_tile_action__["a" /* default */],
	ListTileActionText: ListTileActionText,
	ListTileContent: ListTileContent,
	ListTileTitle: ListTileTitle,
	ListTileSubTitle: ListTileSubTitle,
};


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_expand_transition__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__ = __webpack_require__(2);




/* harmony default export */ exports["a"] = {
  name: 'list-group',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_expand_transition__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__["a" /* default */]],

  data: function data () {
    return {
      isBooted: this.value,
      height: 0,
    }
  },

  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes () {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      }
    },

    list: function list () {
      return __WEBPACK_IMPORTED_MODULE_0__utils_helpers__["c" /* closestParentTag */].call(this, 'sk-list')
    },
    
    styles: function styles () {
      return {
        height: ((this.height) + "px")
      }
    }
  },

  watch: {
    isActive: function isActive () {
      this.isBooted = true

      if (!this.isActive) {
        this.list.listClose(this._uid)
      }
    },
    '$route': function $route (to) {
      var isActive = this.matchRoute(to.path)

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.list.listClick(this._uid)
        }
        this.isActive = isActive
      }
    }
  },

  mounted: function mounted () {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path)
    }

    if (this.isActive) {
      this.list.listClick(this._uid)
    }

    this.height = this.$refs.group.scrollHeight
  },

  methods: {
    click: function click () {
      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        this.list.listClick(this._uid)
      }
    },
    toggle: function toggle (uid) {
      this.isActive = this._uid === uid
    },
    matchRoute: function matchRoute (to) {
      if (!this.group) { return false }
      return to.match(this.group) !== null
    }
  },

  render: function render (h) {
    var group = h('ul', {
      'class': 'list list--group',
      style: this.styles,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default])

    var item = h('div', {
      'class': this.classes,
      on: { click: this.click },
      ref: 'item'
    }, [this.$slots.item])

    var transition = h('transition', {
      on: {
        enter: this.enter,
        afterEnter: this.afterEnter,
        leave: this.leave
      }
    }, [group])

    return h('div', { 'class': 'list--group__container' }, [item, transition])
  }
};

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony default export */ exports["a"] = {
  functional: true,

  name: 'list-tile-action',

  render: function render (h, context) {
    var data = {
      'class': {
        'list__tile__action': true,
        'list__tile__action--stack': (context.children || []).length > 1
      }
    }

    return h('div', data, context.children)
  }
};

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ exports["a"] = {
  name: 'list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
  },

  computed: {
    classes: function classes () {
      return {
        'list__tile': true,
        'list__tile--active': this.isActive,
        'list__tile--disabled': this.disabled
      }
    }
  },

  render: function render (h) {
    var ref = this.generateRouteLink();
    var tag = ref.tag;
    var data = ref.data;

    return h(tag, data, [this.$slots.default])
  }
};

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony default export */ exports["a"] = {
  name: 'list',

  data: function data () {
    return {
      uid: null,
      groups: []
    }
  },

  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean,
    inline: Boolean
  },

  computed: {
    classes: function classes () {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'list--inline': this.inline
      }
    }
  },

  watch: {
    uid: function uid () {
      var this$1 = this;

      this.$children.filter(function (i) { return i.$options._componentTag === 'sk-list-group'; }).forEach(function (i) { return i.toggle(this$1.uid); })
    }
  },

  methods: {
    listClick: function listClick (uid, force) {
      if (force) {
        this.uid = uid
      } else {
        this.uid = this.uid === uid ? null : uid
      }
    },

    listClose: function listClose (uid) {
      if (this.uid === uid) {
        this.uid = null
      }
    }
  },

  render: function render (h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    }

    return h('ul', data, [this.$slots.default])
  }
};

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__movie_thumbnail_vue__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__movie_thumbnail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__movie_thumbnail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movie_detail_vue__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movie_detail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__movie_detail_vue__);



/* harmony default export */ exports["a"] = {
	MovieThumbnail: __WEBPACK_IMPORTED_MODULE_0__movie_thumbnail_vue___default.a,
	MovieDetail: __WEBPACK_IMPORTED_MODULE_1__movie_detail_vue___default.a
};


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony default export */ exports["default"] = {
	props: {
		movie: Object,
		buttons: Boolean
	},

	data: function data() {
		return {
			truncAmount: 500,
			dialogActive: false
		}
	},

	methods: {
		truncToggle: function truncToggle(el) {
		    if (this.truncAmount < this.movie.synopsis.length) {
		        this.truncAmount = this.movie.synopsis.length;
		        el.innerHTML = 'Read less'
		    } else {
		        this.truncAmount = 500
		        el.innerHTML = 'Read more'
		    }
		}
	}
};

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable_js__ = __webpack_require__(2);


/* harmony default export */ exports["default"] = {
	mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable_js__["a" /* default */]],

	data: function data () {
		return {
			currentTimeStamp: null,
		}
	},

	props: {
		nowShowing: Boolean,
		comingSoon: Boolean,
		content: Object,
		hideCaption: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		classes: function classes() {
			return {
				'movie-thumbnail': true,
				'movie-thumbnail__now-showing': this.nowShowing,
				'movie-thumbnail__coming-soon': this.comingSoon
			}
		}
	},

	created: function created() {
		var now = new Date();
        this.currentTimeStamp = now;
        // console.log(this.content, this.content.genres)
        // console.log(this.content.opening_date.date._d, this.currentTimeStamp, (this.content.opening_date.date._d > this.currentTimeStamp))
	}
};


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_circular_vue__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_circular_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__progress_circular_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_linear_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_linear_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_linear_vue__);



/* harmony default export */ exports["a"] = {
	ProgressCircular: __WEBPACK_IMPORTED_MODULE_0__progress_circular_vue___default.a,
  ProgressLinear: __WEBPACK_IMPORTED_MODULE_1__progress_linear_vue___default.a
};


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quantity_vue__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quantity_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__quantity_vue__);


/* harmony default export */ exports["a"] = {
	Quantity: __WEBPACK_IMPORTED_MODULE_0__quantity_vue___default.a
};


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony default export */ exports["default"] = {

	props: {

	},

	data: function data () {
		return {

		}
	}
};


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__seatGrid_js__ = __webpack_require__(191);


/* harmony default export */ exports["a"] = {
    SeatGrid: __WEBPACK_IMPORTED_MODULE_0__seatGrid_js__["a" /* default */]
};

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_pan_zoom__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_pan_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_pan_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hammerjs__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hammerjs__);



var uid = 0;
/* harmony default export */ exports["a"] = {

    data: function data(){
        return {
            hammer: null,
            zoomManager: null,
        };
    },
    props: {
        seatGrid: Array,
        columnSpacing: 5,
        rowSpacing: 5,
        validateChangefn: Function
    },

    computed: {},
    methods: {
        seat: function seat(compiler, seatData, x, y, empty,aisle, colSpan, spanWidth, text){
            var this$1 = this;
            if ( empty === void 0 ) empty = false;
            if ( colSpan === void 0 ) colSpan = 1;
            if ( spanWidth === void 0 ) spanWidth = 40;

            var seatHeadSpacer = 2,
                offset = 2,
                seatHeight = 29,
                seatWidth = Math.round(spanWidth * colSpan),
                // seatRatio = 4.83333,
                // seatWidthRatio = 1.17647,
                seatHeadHeight = 6,
                seatHeadWidth = 34,
                seatMainHeight = seatHeight - seatHeadHeight,
                centered = (seatWidth - (seatHeadWidth * colSpan) ) / 2,
                seatHeadMargin = colSpan == 2 ? 5 : 0,
                fontSize = 12,
                kidsFontSize = 12



                var ua = window.navigator.userAgent;
                /* MSIE used to detect old browsers and Trident used to newer ones*/
                var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;



                // let seatHead =

                // let shapes = !aisle ?  [
                //     compiler('rect', {
                //         attrs: {
                //             class: "seat-main",
                //             x: offset,
                //             y: offset,
                //             ry: 3,
                //             width: `${seatWidth}px`,
                //             height: `${seatMainHeight}px`,
                //             // style: "fill:rgba(121, 0, 121, 0.03);stroke-width:1;stroke:#808285;"
                //         }
                //     }),
                //     compiler('text', {
                //         class: {
                //             'seat-text--wheelchair': seatData.wheelchair,
                //             'seat-text--companion': seatData.companion,
                //             'seat-text--seatname': !seatData.wheelchair && !seatData.companion
                //         },
                //         attrs: {
                //             class: "seat-text",
                //             "text-anchor": "middle",
                //             "dominant-baseline": "central",
                //             x: (seatWidth / 2) + offset + 'px',
                //             y: (seatMainHeight / 2) + offset + 'px',
                //             "font-size": fontSize + 'px',
                //             fill: '#000',
                //         }
                //     }, seatData.companion ? 'C' : (seatData.wheelchair ? `` : seatData.seatNameCombinedString)),

                //     compiler('rect', {
                //         attrs: {
                //             class: "seat-head",
                //             x: offset + (centered - seatHeadMargin),
                //             y: 24 + seatHeadSpacer + offset,
                //             ry: 2,
                //             width: `${seatHeadWidth}px`,
                //             height: `${seatHeadHeight}px`,
                //             // style: "fill:rgba(121, 0, 121, 0.03);stroke-width:1;stroke:#808285;"
                //         }
                //     })

                // ] : [];

            var shapes = []
            // console.log(seatData)

            if(!aisle) {
                if(!seatData.kids || seatData.dBox || seatData.companion) {
                    // console.log("seatData - seatGrid (!aisle, (!kids || dbox || companion)", seatData.seatName, seatData)
                    shapes = [
                        compiler('rect', {
                            attrs: {
                                class: "seat-main",
                                x: offset,
                                y: offset,
                                ry: 3,
                                width: (seatWidth + "px"),
                                height: (seatMainHeight + "px"),
                                // style: "fill:rgba(121, 0, 121, 0.03);stroke-width:1;stroke:#808285;"
                            }
                        }),
                        compiler('text', {
                            class: {
                                'seat-text--wheelchair': seatData.wheelchair,
                                'seat-text--companion': seatData.companion,
                                'seat-text--seatname': !seatData.wheelchair && !seatData.companion
                            },
                            attrs: {
                                class: "seat-text",
                                "text-anchor": "middle",
                                "dominant-baseline": "central",
                                x: (seatWidth / 2) + offset + 'px',
                                y: (seatMainHeight / 2) + offset + 'px',
                                "font-size": fontSize + 'px',
                                fill: '#000',
                            }
                        }, seatData.companion ? 'C' : (seatData.wheelchair ? "" : seatData.seatNameCombinedString)),

                        compiler('rect', {
                            attrs: {
                                class: "seat-head",
                                x: offset + (centered - seatHeadMargin),
                                y: 24 + seatHeadSpacer + offset,
                                ry: 2,
                                width: (seatHeadWidth + "px"),
                                height: (seatHeadHeight + "px"),
                                // style: "fill:rgba(121, 0, 121, 0.03);stroke-width:1;stroke:#808285;"
                            }
                        })
                    ]
                    // console.log("seatData - seatGrid (!aisle, (!kids || dbox || companion)", seatData.seatName, seatData, shapes,x,y)
                } else if(seatData.kids && !seatData.dBox && !seatData.companion){
                    var row = ''
                    var number = ''
                    var ar = []
                    var seatString = ''

                    if(seatData != undefined && seatData.seatNameCombinedString != undefined) {
                        ar = seatData.seatNameCombinedString.split('')
                    }

                    for(var i in ar) {
                        if(ar[i] != undefined && typeof ar[i] == "string") {
                            if(/\d/.test(ar[i])) {
                                number = number + ar[i]
                            } else {
                                row = row + ar[i]
                            }
                        }
                    }

                    if(number == undefined || number == null || row == undefined || row == null) {
                        number = seatData.seatNameCombinedString
                    }
                    var additional_offset = 5
                    if(is_ie) {
                        additional_offset = 18
                    }

                    shapes = [
                        compiler('text', {
                            class: {
                                'seat-icon--kids seat-index--kids': seatData.kids
                            },
                            attrs: {
                                class: "seat-icon",
                                "text-anchor": "middle",
                                "dominant-baseline": "central",
                                x: (seatWidth / 2) + offset + 'px',
                                y: ((seatMainHeight / 2) + additional_offset) + offset + 'px',
                                fill: '#000',
                            }
                        }, ""),

                        compiler('text', {
                            class: {
                                'seat-text--wheelchair': seatData.wheelchair,
                                'seat-text--companion': seatData.companion,
                                'seat-text--seatname': !seatData.wheelchair && !seatData.companion
                            },
                            attrs: {
                                class: "seat-text",
                                "text-anchor": "middle",
                                "dominant-baseline": "central",
                                x: ((seatWidth / 2) - 8) + offset + 'px',
                                y: ((seatMainHeight / 2) + 1) + offset + 'px',
                                "font-size": kidsFontSize + 'px',
                                fill: '#000',
                            }
                        }, row),

                        compiler('text', {
                            class: {
                                'seat-text--wheelchair': seatData.wheelchair,
                                'seat-text--companion': seatData.companion,
                                'seat-text--seatname': !seatData.wheelchair && !seatData.companion
                            },
                            attrs: {
                                class: "seat-text",
                                "text-anchor": "middle",
                                "dominant-baseline": "central",
                                x: ((seatWidth / 2) + 8) + offset + 'px',
                                y: ((seatMainHeight / 2) + 1) + offset + 'px',
                                "font-size": kidsFontSize + 'px',
                                fill: '#000',
                            }
                        }, number)

                        
                    ]

                    // console.log("seatData - seatGrid (!aisle, (kids || !dbox || !companion)", seatData.seatName, seatData, shapes,x,y)
                }
            } else {
                shapes = []
            }

            for (var i$1 = 1; i$1 < colSpan; i$1++) {

                shapes.push(compiler('rect', {
                    attrs: {
                        class: "seat-head",
                        x: ((offset + centered) + (seatHeadWidth * i$1)) + (seatHeadMargin * i$1),
                        y: 24 + seatHeadSpacer + offset,
                        ry: 2,
                        width: (seatHeadWidth + "px"),
                        height: (seatHeadHeight + "px"),
                        // style: "fill:rgba(121, 0, 121, 0.03);stroke-width:1;stroke:#808285;"
                    }
                }))

            }

            // console.log("seatData",seatData)

            var containerAttributes = {
                class: {
                    'seat': true,
                    'seat--available': seatData.available && !seatData.broken,
                    'seat--empty': (!seatData.type || seatData.empty || seatData.broken),
                    'seat--aisle': seatData.aisle,
                    'seat--love-nest': seatData.loveNest,
                    'seat--wheelchair': seatData.wheelchair,
                    'seat--companion': seatData.companion,
                    'seat--kids' : (seatData.kids && !seatData.dBox && !seatData.companion && seatData.available),
                    'seat--kids--sold': (seatData.kids && !seatData.dBox && !seatData.companion && !seatData.available),
                    'seat--dbox': seatData.dBox,
                    'seat--sold': !seatData.empty && !seatData.available,
                    'seat--selected': seatData.selected,
                    'seat--selected-unavailable': seatData.selected_unavailable
                },
                attrs: {
                    class: 'seat',
                    x: x,
                    y: y,
                    seatHeight: seatHeight + seatHeadSpacer + offset,
                    seatWidth: seatWidth + offset
                },
            };

            if (seatData.available && !seatData.empty && !seatData.broken) { containerAttributes.on = {
                click: function (){
                    if (!this$1.validateChangefn || this$1.validateChangefn(seatData) || seatData.selected) {
                        seatData.selected = !seatData.selected;
                        var canceller = function (){
                            seatData.selected = !seatData.selected;
                        };
                        this$1.$emit('seatChange', seatData, seatData.selected, canceller)
                    }
                }
            }; }

            // if(!seatData.kids) {
            //     // return []
            //     return compiler('svg', containerAttributes, shapes)
            // }
            // else
            //     return shapes

            var ret = true

            // console.log("seatData before return", ret, seatData.Position.AreaCategoryCode, seatData.type, seatData.style, seatData)
            if(seatData.style == 7 && seatData.Position.AreaCategoryCode == "0000000005") {

                // if(seatData.type == 1) {
                    ret = false
                // }
            }

            // 
            if(ret)
                { return compiler('svg', containerAttributes, shapes) }
        },

        text: function text(compiler, x, y, text$1, fontSize){
            if ( fontSize === void 0 ) fontSize = 20;

            text$1 = text$1.toString()

            var textSvg = compiler('text', {
                attrs: {
                    class: "row-text",
                    x: x + 2,
                    y: y + 2,
                    fontSize: 20,
                    // fill:'white'
                }
            }, text$1)

            return textSvg
        },

        generateSeatPlan: function generateSeatPlan(compiler){
            var this$1 = this;

            var colMargin = 10;
            var rowMargin = 10;
            var rowY = 30;
            var rowX = 0;
            var seats = [];

            var width = 0;
            if (this.seatGrid)
                { this.seatGrid.forEach(function (row, index){
                    var rowHeight = 0;
                    if (row.PhysicalName) {
                        var rowName = this$1.text(compiler, rowX, rowY + 20, row.PhysicalName, 20)
                        rowX += rowName.data.attrs.fontSize + colMargin;
                        seats.push(rowName);
                    }

                    row.Seats.forEach(function (seat, sIndex){

                        if (index == 0) {
                            var text = (sIndex + 1).toString();
                            // let seatNumber = this.text(compiler, rowX + (20 / text.length), 10, text);
                            // seats.push(seatNumber)
                        }


                        var colSpan = !seat.empty && seat.type == 2 ? 2 : 1,
                            spanWidth = seat.type == 2 ? 40 + (colMargin / 2) : 40,
                            empty = seat.empty,
                            aisle = seat.aisle,
                            thisSeat = this$1.seat(compiler, seat, rowX, rowY, empty,aisle, colSpan, spanWidth);
                        // if (seat.type == 2) alert('here');

                        if(thisSeat != undefined) {
                            rowHeight = thisSeat.data.attrs.seatHeight > rowHeight ? thisSeat.data.attrs.seatHeight : rowHeight;
                            seats.push(thisSeat);
                            // console.log("thisSeat", thisSeat)
                            // console.log("seat", seat)
                            rowX += thisSeat.data.attrs.seatWidth + colMargin
                        }
                    });
                    if (row.PhysicalName) {
                        var rowName$1 = this$1.text(compiler, rowX, rowY + 20, row.PhysicalName)
                        rowX += rowName$1.data.attrs.fontSize + colMargin
                        seats.push(rowName$1);
                    }
                    width = width < rowX ? rowX : width;
                    rowY += rowHeight + rowMargin //todo row height
                    rowX = 0;


                }); }
            var height = rowY;
            return {width: width, height: height, seats: seats}
        },

        windowResized: function windowResized(){
                var height =this.getHeightFromRatio()
                this.$el.setAttribute('height', height);
                this.zoomManager.resize(); // update SVG cached size and controls positions
                this.zoomManager.updateBBox();
                this.zoomManager.fit();
                this.zoomManager.center();
        },

        getHeightFromRatio: function getHeightFromRatio(){
            var newWidth =this.$el.width.baseVal.value;
            var seatPlanWidth = this.$el.getAttribute('seatPlanWidth');
            var seatPlanHeight = this.$el.getAttribute('seatPlanHeight');

            var newHeight = (seatPlanHeight / seatPlanWidth) * newWidth;

            return newHeight + 50;
        }
    },

    beforeDestroy: function beforeDestroy(){
        this.zoomManager.destroy();
        window.removeEventListener('resize', this.windowResized);
    },
    mounted: function mounted(){
        var element = this.$el;
        if (element) {
            var zoomOptions = {
                viewportSelector: '.svg-pan-zoom_viewport',
                panEnabled: false,
                minZoom: 1,
                center: false,
                preventMouseEventsDefault: false,
                // contain: true,
                fit: true,
                controlIconsEnabled: false,
                dblClickZoomEnabled: false,
                mouseWheelZoomEnabled: false,
                beforePan: function(oldPan, newPan) {
                  var stopHorizontal = false,
                    stopVertical = false,
                    gutterWidth = 150,
                    gutterHeight = 150,
                    sizes = this.getSizes(),
                    leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth,
                    rightLimit = sizes.width - gutterWidth - (sizes.viewBox.x * sizes.realZoom),
                    topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight,
                    bottomLimit = sizes.height - gutterHeight - (sizes.viewBox.y * sizes.realZoom)


                    return {
                      x: Math.max(leftLimit, Math.min(rightLimit, newPan.x)),
                      y: Math.max(topLimit, Math.min(bottomLimit, newPan.y))
                    }
                },
                customEventsHandler: {
                    haltEventListeners: [],// ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
                    init: function (options) {
                        var instance = options.instance
                            , initialScale = 1
                            , pannedX = 0
                            , pannedY = 0,
                            preventScroll = false;
                        // Init Hammer
                        // Listen only for pointer and touch events
                        this.hammer = __WEBPACK_IMPORTED_MODULE_2_hammerjs___default()(options.svgElement, {
                            touchAction: 'auto',
                            inputClass: __WEBPACK_IMPORTED_MODULE_2_hammerjs___default.a.SUPPORT_POINTER_EVENTS ? __WEBPACK_IMPORTED_MODULE_2_hammerjs___default.a.PointerEventInput : __WEBPACK_IMPORTED_MODULE_2_hammerjs___default.a.TouchInput
                        })

                        // Enable pinch
                        this.hammer.get('pinch').set({enable: true})

                        // // Handle double tap

                        this.hammer.on('doubletap', function (ev) {
                            ev.preventDefault()
                            var zoom = instance.getZoom() <= 1 ? 3 : 1;
                            if (zoom > 1) { preventScroll = true; }
                            else {
                                preventScroll = false;
                                instance.zoom(1);
                                instance.resetPan();
                            }

                            var zoomX = ev.center.x ? ev.center.x - element.getBoundingClientRect().x : 0;
                            var zoomY = ev.center.y ? ev.center.y - element.getBoundingClientRect().y : 0;
                            instance.zoomAtPointBy(zoom, {x: zoomX, y: zoomY})
                        }, true)
                        //
                        // // Handle pan
                        this.hammer.on('panstart panmove', function (ev) {
                            if (!preventScroll) { return; }

                            // On pan start reset panned letiables
                            if (ev.type === 'panstart') {
                                pannedX = 0;
                                pannedY = 0
                            }

                            // Pan only the difference
                            instance.panBy({x: ev.deltaX - pannedX, y: ev.deltaY - pannedY})
                            pannedX = ev.deltaX
                            pannedY = ev.deltaY
                        }, true)

                        // Handle pinch
                        this.hammer.on('pinchstart pinchmove', function (ev) {
                            // On pinch start remember initial zoom
                            if (ev.type === 'pinchstart') {
                                initialScale = instance.getZoom()
                            }
                            var zoom = initialScale * ev.scale
                            if (zoom <= 1 && preventScroll) {
                                options.svgElement.classList.add("seat-grid--hidden");
                                preventScroll = false;
                                zoom = 1;
                                instance.zoom(1);
                                instance.resetPan();
                                instance.fit();
                            } else {
                                if (!preventScroll)
                                    { options.svgElement.classList.remove("seat-grid--hidden"); }

                                preventScroll = true;
                                var zoomX = ev.center.x - element.getBoundingClientRect().x;
                                var zoomY = ev.center.y - element.getBoundingClientRect().y;
                                instance.zoomAtPoint(zoom, {x: zoomX, y: zoomY})
                            }


                        }, true)

                        // Prevent moving the page on some devices when panning over SVG
                        options.svgElement.addEventListener('touchmove', function (e) {
                            if (preventScroll)
                                { e.preventDefault(); }
                        }, true);


                    }
                    , destroy: function () {
                        this.hammer.destroy()
                    }
                },
            };



            this.zoomManager = this.zoomManager || __WEBPACK_IMPORTED_MODULE_1_svg_pan_zoom___default()(element, zoomOptions);
            var viewport = document.getElementsByClassName('svg-pan-zoom_viewport')[0].getBoundingClientRect();
            this.$el.setAttribute('height', this.getHeightFromRatio());
            this.zoomManager.resize(); // update SVG cached size and controls positions
            this.zoomManager.updateBBox();
            this.zoomManager.fit();
            this.zoomManager.center();

            window.addEventListener('resize', this.windowResized);

        }
        // })
    },

    render: function render(h)
    {
        var seatPlan = this.generateSeatPlan(h);

        var seatGridAttributes = {

            attrs: {
                class: 'seat-grid seat-grid--hidden',
                id: uid++,
                width: '100%',
                seatPlanWidth: seatPlan.width,
                seatPlanHeight: seatPlan.height,
                // height:seatPlan.height,
                preserveAspectRatio: "xMinYMin  meet",
                viewBox: ("0 0 " + (seatPlan.width) + " " + (seatPlan.height)),
            },
        };
        var svg = h('svg', seatGridAttributes, [h('g', {attrs: {class: "svg-pan-zoom-viewport"}}, seatPlan.seats)]);

        return svg;
    }
};

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__seat_js__ = __webpack_require__(193);


/* harmony default export */ exports["a"] = {
	Seat: __WEBPACK_IMPORTED_MODULE_0__seat_js__["a" /* default */]
};

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ exports["a"] = {

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

    props: {
        type: Number,
        empty: false,
        available: Boolean,
        sold: Boolean,
        num:Number,
        loveNest: Boolean,
        wheelchair: Boolean,
        dbox: Boolean,
        companion: Boolean,
        selected:Boolean,
        seatSelectable: false,
        kids: Boolean,
        selected_unavailable: false
    },

    methods:{
        seat: function seat(compiler, seatData, x, y, empty, colSpan, spanWidth, text){
            var this$1 = this;
            if ( empty === void 0 ) empty = false;
            if ( colSpan === void 0 ) colSpan = 1;
            if ( spanWidth === void 0 ) spanWidth = 23;

            var seatHeadSpacer = 2,
                offset = 0,
                seatHeight = 19,
                seatWidth = Math.round(spanWidth * colSpan),
                // seatRatio = 4.83333,
                // seatWidthRatio = 1.17647,
                seatHeadHeight = 4,
                seatHeadWidth = 34,
                seatMainHeight = seatHeight - seatHeadHeight,
                centered = (seatWidth - (seatHeadWidth * colSpan) ) / 2,
                seatHeadMargin = colSpan == 2 ? 5 : 0,
                fontSize = 10,
                kidsFontSize = 10

                // var seatHead =

                var shapes = []
            // console.log(seatData)

            if(!empty) {
                if(!seatData.kids || seatData.dBox) {
                    // console.log(seatWidth)
                    shapes = [
                        compiler('rect', {
                            attrs: {
                                class: "seat-main",
                                x: offset,
                                y: offset,
                                ry: 3,
                                width: (seatWidth + "px"),
                                height: (seatMainHeight + "px"),
                                // style: "fill:rgba(121, 0, 121, 0.03);stroke-width:1;stroke:#808285;"
                            }
                        }),
                        compiler('text', {
                            class: {
                                'seat-text--wheelchair': seatData.wheelchair,
                                'seat-text--companion': seatData.companion,
                                'seat-text--seatname': !seatData.wheelchair && !seatData.companion
                            },
                            attrs: {
                                class: "seat-text",
                                "text-anchor": "middle",
                                "dominant-baseline": "central",
                                x: (seatWidth / 2) + offset + 'px',
                                y: (seatMainHeight / 2) + offset + 'px',
                                "font-size": fontSize + 'px',
                                fill: '#000',
                            }
                        }, seatData.companion ? 'C' : (seatData.wheelchair ? "" : (seatData.kids ? "" :seatData.seatNameCombinedString))),

                        compiler('rect', {
                            attrs: {
                                class: "seat-head",
                                x: 0,
                                y: 15 + seatHeadSpacer + offset,
                                ry: 2,
                                width: (seatWidth + "px"),
                                height: (seatHeadHeight + "px"),
                                // style: "fill:rgba(121, 0, 121, 0.03);stroke-width:1;stroke:#808285;"
                            }
                        })
                    ]
                } else if(seatData.kids && !seatData.dBox){
                    var row = ''
                    var number = ''
                    var ar = []
                    // if(seatData != undefined) {
                    //     if(seatData.seatNameCombinedString != undefined) {
                    //         ar = seatData.seatNameCombinedString.split('')
                    //     }
                    // }

                    // for(let i in ar) {
                    //     if(/\d/.test(ar[i])) {
                    //         number = number + ar[i]
                    //     } else {
                    //         row = row + ar[i]
                    //     }
                    // }

                    // let row_span = document.createElement('span');
                    // row_span.setAttribute('style', 'float:left');
                    // row_span.textContent = row;

                    // let number_span = document.createElement('span');
                    // number_span.setAttribute('style', 'float:right');
                    // number_span.textContent = number;

                    shapes = [
                        compiler('text', {
                            class: {
                                'seat-icon--kids': seatData.kids
                            },
                            attrs: {
                                class: "seat-icon",
                                "text-anchor": "middle",
                                "dominant-baseline": "central",
                                x: ((seatWidth / 2) + 4) + offset + 'px',
                                y: ((seatMainHeight / 2) + 9) + offset + 'px',
                                fill: '#000',
                                width: ((seatWidth / 2) + 3) + offset + 'px',
                                height: ((seatMainHeight / 2) + 2) + offset + 'px',
                            }
                        }, ""),

                        compiler('text', {
                            class: {
                                'seat-text--wheelchair': seatData.wheelchair,
                                'seat-text--companion': seatData.companion,
                                'seat-text--seatname': !seatData.wheelchair && !seatData.companion
                            },
                            attrs: {
                                class: "seat-text",
                                "text-anchor": "middle",
                                "dominant-baseline": "central",
                                x: ((seatWidth / 2) - 6) + offset + 'px',
                                y: ((seatMainHeight / 2) - 1) + offset + 'px',
                                "font-size": kidsFontSize + 'px',
                                fill: '#000',
                            }
                        }, row),

                        compiler('text', {
                            class: {
                                'seat-text--wheelchair': seatData.wheelchair,
                                'seat-text--companion': seatData.companion,
                                'seat-text--seatname': !seatData.wheelchair && !seatData.companion
                            },
                            attrs: {
                                class: "seat-text",
                                "text-anchor": "middle",
                                "dominant-baseline": "central",
                                x: ((seatWidth / 2) + 6) + offset + 'px',
                                y: ((seatMainHeight / 2) - 1) + offset + 'px',
                                "font-size": kidsFontSize + 'px',
                                fill: '#000',
                            }
                        }, number)

                        
                    ]
                }
            } else {
                shapes = []
            }

            // for (var i = 1; i < colSpan; i++) {

            //     shapes.push(compiler('rect', {
            //         attrs: {
            //             class: "seat-head",
            //             x: ((offset + centered) + (seatHeadWidth * i)) + (seatHeadMargin * i),
            //             y: 15 + seatHeadSpacer + offset,
            //             ry: 2,
            //             width: `${seatHeadWidth}px`,
            //             height: `${seatHeadHeight}px`,
            //             // style: "fill:rgba(121, 0, 121, 0.03);stroke-width:1;stroke:#808285;"
            //         }
            //     }))

            // }

            if(seatData.kids) {
                seatHeight = seatHeight + 10;
                seatWidth = seatHeight
            }

            var containerAttributes = {
                class: {
                    'seat': true,
                    'seat--available': seatData.available,
                    'seat--sold': seatData.sold,
                    'seat--empty': false,
                    'seat--love-nest': seatData.loveNest,
                    'seat--wheelchair': seatData.wheelchair,
                    'seat--companion': seatData.companion,
                    'seat--dbox': seatData.dbox,
                    'seat--selected': seatData.selected,
                    'seat--kids' : seatData.kids,
                    'seat--selected-unavailable': seatData.selected_unavailable
                },
                attrs: {
                    class: 'seat',

                    width:seatWidth + offset + 3,
                    height:seatHeight + seatHeadSpacer + offset + 2,
                    seatHeight: seatHeight + seatHeadSpacer + offset,
                    seatWidth: seatWidth + offset
                },
            };

            if (seatData.available && !seatData.empty) { containerAttributes.on = {
                click: function (){
                    if (!this$1.validateChangefn || this$1.validateChangefn(seatData) || seatData.selected) {
                        seatData.selected = !seatData.selected;
                        var canceller = function (){
                            seatData.selected = !seatData.selected;
                        };
                        this$1.$emit('seatChange', seatData, seatData.selected, canceller)
                    }
                }
            }; }

            return compiler('svg', containerAttributes, shapes)
        },
    },

    computed: {
        classes: function classes () {
            return {
                'seat': true,
                'seat--selected': this.isActive,
                'seat--available': this.available,
                'seat--sold': this.sold,
                'seat--empty': !this.type || this.empty,
                'seat--love-nest': this.type === 2,
                'seat--wheelchair': this.type === 3,
                'seat--companion': this.type === 4,
                'seat--kids': this.kids,
                'seat--selected-unavailable': this.selected_unavailable
            }
        },

        selectable: function selectable() {
            return !this.sold && !this.empty && (this.isActive || this.seatSelectable)
        }
    },

    render: function render(h) {
        var children = [
            h('div', {'class': 'seat-top'} ),
            h('div', {'class': 'seat-bottom'})
        ]



        return this.seat(h,this.$props,0,0,false,(this.loveNest ? 2 : 1))
    }
};

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__snackbar__ = __webpack_require__(195);


/* harmony default export */ exports["a"] = {
  Snackbar: __WEBPACK_IMPORTED_MODULE_0__snackbar__["a" /* default */]
};


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_positionable__ = __webpack_require__(221);




/* harmony default export */ exports["a"] = {
  name: 'snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  data: function data () {
    return {
      activeTimeout: {}
    }
  },

  props: {
    multiLine: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean,
    fullwidth: Boolean
  },

  computed: {
    classes: function classes () {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--fixed': this.fixed,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--vertical': this.vertical,
        'snack--full': this.fullwidth,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      }
    },
    computedTransition: function computedTransition () {
      return this.top ? 'sk-dialog-transition' : 'sk-slide-y-reverse-transition'
    }
  },

  watch: {
    isActive: {
      handler: function handler() {
        var this$1 = this;

        clearTimeout(this.activeTimeout)
        if (this.isActive && this.timeout) {
          this.activeTimeout = setTimeout(function () { return (this$1.isActive = false); }, this.timeout)
        }
      },
      immediate: true
    }
  },

  render: function render (h) {
    var children = []

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, [this.$slots.default]))
    }
    return h('div', {
      'class': this.classes
    }, [h(this.computedTransition, {}, children)])
  }
};


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__social_share_vue__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__social_share_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__social_share_vue__);


/* harmony default export */ exports["a"] = {
	SocialShare: __WEBPACK_IMPORTED_MODULE_0__social_share_vue___default.a
};

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony default export */ exports["default"] = {
	props: {
		id: String,
		movieTitle: String,
		twitterText: String,
		email: String
	},

	data: function data() {
		return {
			isActive: false
		}
	},

	computed: {
		url: function url() {
			var url
			if (this.id) { url = window.location.origin + '/details/' + this.id }
			return url				
		}
	},

	mounted: function mounted() {
		(function(d, s, id) {
		  var js, fjs = d.getElementsByTagName(s)[0];
		  if (d.getElementById(id)) { return; }
		  js = d.createElement(s); js.id = id;
		  js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.11&appId=117514801674706';
		  fjs.parentNode.insertBefore(js, fjs);
		}(document, 'script', 'facebook-jssdk'));
	}
};

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabs_vue__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tabs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tab_vue__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tab_vue__);



/* harmony default export */ exports["a"] = {
	Tabs: __WEBPACK_IMPORTED_MODULE_0__tabs_vue___default.a,
	Tab: __WEBPACK_IMPORTED_MODULE_1__tab_vue___default.a
};

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ticket_item_vue__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ticket_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ticket_item_vue__);


/* harmony default export */ exports["a"] = {
	TicketItem: __WEBPACK_IMPORTED_MODULE_0__ticket_item_vue___default.a
};


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony default export */ exports["default"] = {

	props: {

	},

	data: function data () {
		return {

		}
	},

  methods: {

  }
};


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ticket_movie_vue__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ticket_movie_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ticket_movie_vue__);


/* harmony default export */ exports["a"] = {
	TicketMovie: __WEBPACK_IMPORTED_MODULE_0__ticket_movie_vue___default.a
};


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony default export */ exports["default"] = {
    
        props: {
           
        },
    
        data: function data () {
            return {
                ticketMovie : true
            }
        },
    
      methods: {
    
      }
    };
    

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ticket_seats_vue__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ticket_seats_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ticket_seats_vue__);


/* harmony default export */ exports["a"] = {
	TicketSeats: __WEBPACK_IMPORTED_MODULE_0__ticket_seats_vue___default.a
};


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony default export */ exports["default"] = {

    props: {
        ticketObj: Object,
        ticketType: String,
		seat: String,
        addQuantity:Boolean,
        currency: String
	},

    computed: {
        priceString: function priceString(){
            //console.log("ticketObj",this.ticketObj)

            if(!this.ticketObj) { return this.currency+'0.00'; }
            if(isNaN(this.ticketObj.PriceInCents)) { return this.currency+'0.00'; }

            var priceFormatted = (((this.ticketObj.PriceInCents * (this.addQuantity ? this.ticketObj.Quantity : 1)) / 100)).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            return this.currency+"" + priceFormatted
        }
    },

    methods: {}
};


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__title_heading_vue__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__title_heading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__title_heading_vue__);


/* harmony default export */ exports["a"] = {
	TitleHeading: __WEBPACK_IMPORTED_MODULE_0__title_heading_vue___default.a
};

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony default export */ exports["default"] = {

	props: {
		h1: Boolean,
		h2: Boolean,
		h3: Boolean,
		h4: Boolean,
		h5: Boolean,
		h6: Boolean,
		label: String,
		noBorder :Boolean
	},

	data: function data() {
		return {
			hasAppendContent: false,
		}
	},

	computed: {
		classes: function classes() {
			return {
				'title__wrapper--no-border':this.noBorder
			}
		}
	},

	mounted: function mounted() {
    this.checkSlotContent()
  },

  updated: function updated() {
    this.checkSlotContent()
  },

  methods: {
    checkSlotContent: function checkSlotContent () {
      this.hasAppendContent = this.$slots['append'] != null
    }
  }
};

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toast_vue__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toast_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__toast_vue__);


/* harmony default export */ exports["a"] = {
  Toast: __WEBPACK_IMPORTED_MODULE_0__toast_vue___default.a,
};


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ exports["default"] = {  

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    message: String,
    timeout: Number,
    fullwidth: Boolean,
    top: Boolean,
    fixed: Boolean,
    dismissable: { type: Boolean, default: true },
    closedCallback: { type: Function, default: function default$1() {} }
  },

  methods: {
    close: function close() {
      // console.log(isActive)
    }
  },

  watch: {
    isActive: function isActive(val) {
      if(!val) { this.closedCallback(this); }
    }
  }

};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tooltip_vue__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tooltip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tooltip_vue__);


/* harmony default export */ exports["a"] = {
	Tooltip: __WEBPACK_IMPORTED_MODULE_0__tooltip_vue___default.a
};

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives__ = __webpack_require__(9);


/* harmony default export */ exports["default"] = {

  directives: {name: 'click-outside'},

	props: {
		content: String,
		actionText: String,
		icon: Boolean,
		btn: Boolean,
    standalone: Boolean,
    arrowBottom: Boolean
	},

  data: function data() {
    return {
      isActive: false
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tooltip': true,
        'standalone': this.standalone,
        'arrow-bottom': this.arrowBottom
      }
    }
  },

  methods: {
  	toggle: function toggle() {
  		if (this.isActive) { this.isActive = false } 
  		else { this.isActive = true }
  	}
  }
};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(3);


var ScaleTransition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["a" /* createSimpleTransition */])('scale-transition')
var DialogTransition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["a" /* createSimpleTransition */])('dialog-transition')
var DialogBottomTransition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["a" /* createSimpleTransition */])('dialog-bottom-transition')
var SlideYTransition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["a" /* createSimpleTransition */])('slide-y-transition')
var SlideYReverseTransition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["a" /* createSimpleTransition */])('slide-y-reverse-transition')
var SlideXTransition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["a" /* createSimpleTransition */])('slide-x-transition')
var SlideXReverseTransition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["a" /* createSimpleTransition */])('slide-x-reverse-transition')
var SlideMarginDownTransition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["a" /* createSimpleTransition */])('slide-margin-down-transition')
var FadeTransition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["a" /* createSimpleTransition */])('fade-transition')

/* harmony default export */ exports["a"] = {
	ScaleTransition: ScaleTransition,
  DialogTransition: DialogTransition,
  DialogBottomTransition: DialogBottomTransition,
  SlideYTransition: SlideYTransition,
  SlideYReverseTransition: SlideYReverseTransition,
  SlideXTransition: SlideXTransition,
  SlideXReverseTransition: SlideXReverseTransition,
  SlideMarginDownTransition: SlideMarginDownTransition,
  FadeTransition: FadeTransition
};


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__video_vue__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__video_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__video_vue__);


/* harmony default export */ exports["a"] = {
	Video: __WEBPACK_IMPORTED_MODULE_0__video_vue___default.a
};

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable_js__ = __webpack_require__(2);


/* harmony default export */ exports["default"] = {
	mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable_js__["a" /* default */]],

	computed: {
		content: function content(el) {
			return this.$attrs.content
		}
	},

	watch: {
		isActive: function isActive(val) {
			if (!val) {
				this.$attrs.content = ''
			}
		}
	}
};


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
function directive (e, el, binding, v) {
  var cb = function () { return true; }
  if (binding.value) { cb = binding.value }
  if (v.context.isActive &&
    (e && e.target) &&
    (e.target !== el && !el.contains(e.target)) &&
    cb(e)
  ) {
    v.context.isActive = false
  }
}

/* harmony default export */ exports["a"] = {
  bind: function bind (el, binding, v) {
      setTimeout(function () {
        var outside = document.getElementById('app') || document.body
        var click = function (e) { return directive(e, el, binding, v); }
        outside.addEventListener('click', click, false)
        el._clickOutside = click;
      }, 0);
  },

  unbind: function unbind (el) {
    var outside = document.getElementById('app') || document.body
    outside.removeEventListener('click', el._clickOutside, false)
  }
};


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony default export */ exports["a"] = function(text, length, clamp){
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(3);


function isEmpty(opt) {
    if (opt === 0) { return false }
    if (Array.isArray(opt) && opt.length === 0) { return true }
    return !opt
}

function includes(str, query) {
    /* istanbul ignore else */
    if (str === undefined) { str = 'undefined' }
    if (str === null) { str = 'null' }
    if (str === false) { str = 'false' }
    var text = str.toString().toLowerCase()
    return text.indexOf(query.trim()) !== -1
}

function filterOptions(options, search, label, customLabel) {
    return options.filter(function (option) { return includes(customLabel(option, label), search); })
}

function stripGroups(options) {
    return options.filter(function (option) { return !option.$isLabel; })
}

function flattenOptions(values, label) {
    return function (options) { return options.reduce(function (prev, curr) {
            /* istanbul ignore else */
            if (curr[values] && curr[values].length) {
                prev.push({
                    $groupLabel: curr[label],
                    $isLabel: true
                })
                return prev.concat(curr[values])
            }
            return prev
        }, []); }
}

function filterGroups(search, label, values, groupLabel, customLabel) {
    return function (groups) { return groups.map(function (group) {
            /* istanbul ignore else */
            if (!group[values]) {
                console.warn("Options passed to vue-comboselect do not contain groups, despite the config.")
                return []
            }
            var groupOptions = filterOptions(group[values], search, label, customLabel)

            return groupOptions.length
                ? ( obj = {}, obj[groupLabel] = group[groupLabel], obj[values] = groupOptions, obj )
                : []
            var obj;
        }); }
}

var flow = function () {
    var fns = [], len = arguments.length;
    while ( len-- ) fns[ len ] = arguments[ len ];

    return function (x) { return fns.reduce(function (v, f) { return f(v); }, x); };
}

/* harmony default export */ exports["a"] = {

    directives: {
        'click-outside': {
            bind: function(el, binding, vNode) {
                if (typeof binding.value !== 'function') {
                    var compName = vNode.context.name
                    var warn = "[Vue-click-outside:] provided expression '" + (binding.expression) + "' is not a function, but has to be"
                    if (compName) { warn += "Found in component '" + compName + "'" }

                    console.warn(warn)
                }
                 // Define Handler and cache it on the element
                var bubble = binding.modifiers.bubble
                var handler = function (e) {
                  if (bubble || (!el.contains(e.target) && el !== e.target)) {
                      binding.value(e)
                  }
                }
                el.__vueClickOutside__ = handler

                // add Event Listeners
                document.addEventListener('click', handler)
            },
            unbind: function(el, binding) {
                // Remove Event Listeners
                document.removeEventListener('click', el.__vueClickOutside__)
                el.__vueClickOutside__ = null

            }
        }
    },

    data: function data () {
        return {
            search: '',
            locationData: '',
            isOpen: false,
            prefferedOpenDirection: 'below',
            optimizedHeight: this.maxHeight,
            tempVal: [],
            showError: false,
            internalValue: this.value || this.value === 0
                ? (Array.isArray(this.value) ? this.value : [this.value])
                : []
        }
    },
    props: {
        /**
         * Decide whether to filter the results based on search query.
         * Useful for async filtering, where we search through more complex data.
         * @type {Boolean}
         */
        internalSearch: {
            type: Boolean,
            default: true
        },
        /**
         * Array of available options: Objects, Strings or Integers.
         * If array of objects, visible label will default to option.label.
         * If `labal` prop is passed, label will equal option['label']
         * @type {Array}
         */
        options: {
            type: Array,
            required: true
        },
        /**
         * Equivalent to the `multiple` attribute on a `<select>` input.
         * @default false
         * @type {Boolean}
         */
        multiple: {
            type: Boolean,
            default: false
        },
        /**
         * Presets the selected options value.
         * @type {Object||Array||String||Integer}
         */
        value: {
            type: null,
            default: function default$1 () {
                return []
            }
        },
        /**
         * Key to compare objects
         * @default 'id'
         * @type {String}
         */
        trackBy: {
            type: String
        },
        /**
         * Label to look for in option Object
         * @default 'label'
         * @type {String}
         */
        label: {
            type: String
        },
        /**
         * Enable/disable search in options
         * @default true
         * @type {Boolean}
         */
        searchable: {
            type: Boolean,
            default: true
        },
        /**
         * Clear the search input after select()
         * @default true
         * @type {Boolean}
         */
        clearOnSelect: {
            type: Boolean,
            default: true
        },
        /**
         * Hide already selected options
         * @default false
         * @type {Boolean}
         */
        hideSelected: {
            type: Boolean,
            default: false
        },
        /**
         * Equivalent to the `placeholder` attribute on a `<select>` input.
         * @default 'Select option'
         * @type {String}
         */
        placeholder: {
            type: String,
            default: 'Select option'
        },
        /**
         * Allow to remove all selected values
         * @default true
         * @type {Boolean}
         */
        allowEmpty: {
            type: Boolean,
            default: true
        },
        /**
         * Reset this.internalValue, this.search after this.internalValue changes.
         * Useful if want to create a stateless dropdown.
         * @default false
         * @type {Boolean}
         */
        resetAfter: {
            type: Boolean,
            default: false
        },
        /**
         * Enable/disable closing after selecting an option
         * @default true
         * @type {Boolean}
         */
        closeOnSelect: {
            type: Boolean,
            default: true
        },
        /**
         * Function to interpolate the custom label
         * @default false
         * @type {Function}
         */
        customLabel: {
            type: Function,
            default: function default$2 (option, label) {
                if (isEmpty(option)) { return ''; }
                return label ? option[label] : option
            }
        },
        /**
         * Disable / Enable tagging
         * @default false
         * @type {Boolean}
         */
        taggable: {
            type: Boolean,
            default: false
        },
        /**
         * String to show when highlighting a potential tag
         * @default 'Press enter to create a tag'
         * @type {String}
         */
        tagPlaceholder: {
            type: String,
            default: 'Press enter to create a tag'
        },
        /**
         * Number of allowed selected options. No limit if false.
         * @default False
         * @type {Number}
         */
        max: {
            type: Number
        },
        /**
         * Will be passed with all events as second param.
         * Useful for identifying events origin.
         * @default null
         * @type {String|Integer}
         */
        id: {
            default: null
        },
        /**
         * Limits the options displayed in the dropdown
         * to the first X options.
         * @default 1000
         * @type {Integer}
         */
        optionsLimit: {
            type: Number,
            default: 1000
        },

        returnOptionKey: {
            type: String
        },
        /**
         * Name of the property containing
         * the group values
         * @default 1000
         * @type {String}
         */
        groupValues: {
            type: String
        },
        /**
         * Name of the property containing
         * the group label
         * @default 1000
         * @type {String}
         */
        groupLabel: {
            type: String
        },
        /**
         * Name of the property containing
         * the group label
         * @default 1000
         * @type {String}
         */
        groupDistance: {
            type: String
        },
        /**
         * Array of keyboard keys to block
         * when selecting
         * @default 1000
         * @type {String}
         */
        blockKeys: {
            type: Array,
            default: function default$3 () {
                return []
            }
        },
        preserveSearch: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    mounted: function mounted () {
        /* istanbul ignore else */
        if(this.value){
            this.internalValue = this.getInternalValue(this.value)
        }
        if (!this.multiple && !this.clearOnSelect) {
            console.warn('[Vue-comboselect warn]: ClearOnSelect and Multiple props can’t be both set to false.')
        }
    },
    computed: {
        filteredOptions: function filteredOptions () {
            var search = this.search || ''
            var normalizedSearch = search.toLowerCase()

            var options = this.options.concat()

            /* istanbul ignore else */
            if (this.internalSearch) {
                options = this.groupValues
                    ? this.filterAndFlat(options, normalizedSearch, this.label)
                    : filterOptions(options, normalizedSearch, this.label, this.customLabel)

                options = this.hideSelected
                    ? options.filter(this.isNotSelected)
                    : options
            } else {
                options = this.groupValues ? flattenOptions(this.groupValues, this.groupLabel)(options) : options
            }

            /* istanbul ignore else */
            if (this.taggable && normalizedSearch.length && !this.isExistingOption(normalizedSearch)) {
                options.unshift({isTag: true, label: search})
            }
            if (this.$breakpoints.xs) {
                var groupedOptions = []
                var optGroup = {
                    label: String,
                    items: []
                }
                var optionsLength = options.length
                if (options.length > 0) {
                    options.forEach(function (e, index) {
                        if (e.$isLabel){
                            if ((index+1) == optionsLength) { optGroup.items.push(e) }
                            if (index > 0){
                                groupedOptions.push(Object.assign({},optGroup))
                                optGroup.items = [];
                            }
                            optGroup.label = e.$groupLabel
                        } else if ((index+1) == optionsLength) {
                            optGroup.items.push(e)
                            groupedOptions.push(Object.assign({},optGroup))
                        } else {
                            optGroup.items.push(e)
                        }
                    })
                    options = groupedOptions;
                }
            }

            return options.slice(0, this.optionsLimit)
        },
        valueKeys: function valueKeys () {
            var this$1 = this;

            if (this.trackBy) {
                return this.internalValue.map(function (element) { return element[this$1.trackBy]; })
            } else {
                return this.internalValue
            }
        },
        optionKeys: function optionKeys () {
            var this$1 = this;

            var options = this.groupValues ? this.flatAndStrip(this.options) : this.options
            return options.map(function (element) { return this$1.customLabel(element, this$1.label).toString().toLowerCase(); })
        },
        currentOptionLabel: function currentOptionLabel () {
            return this.multiple
                ? this.searchable ? '' : this.placeholder
                : this.internalValue[0]
                ? this.getOptionLabel(this.internalValue[0])
                : this.searchable ? '' : this.placeholder
        }
    },
    watch: {
        'internalValue': function internalValue (newVal, oldVal) {
            /* istanbul ignore else */
            if (this.resetAfter && this.internalValue.length) {
                this.search = ''
                this.internalValue = []
            }
        },
        'search': function search () {
            this.$emit('search-change', this.search, this.id)
        },
        'value': function value (value) {
            this.internalValue = this.getInternalValue(value)
        }
    },
    methods: {
        /**
         * Converts the internal value to the external value
         * @returns {Object||Array||String||Integer} returns the external value
         */
        getValue: function getValue () {
            return this.multiple
                ? (this.internalValue)
                : this.internalValue.length === 0
                ? null
                : (this.internalValue[0])
        },
        /**
         * Converts the external value to the internal value
         * @returns {Array} returns the internal value
         */
        getInternalValue: function getInternalValue (value) {
            var this$1 = this;

            if (value === null || value === undefined) {
                return []
            } else {
                if (this.returnOptionKey) {
                    if (this.groupValues)
                        { value = this.options.reduce(function (c, r){ return c.concat(r[this$1.groupValues]); }, []).find(function (option) { return ( option && String(option[this$1.returnOptionKey]) === String(value)); }) || '' }
                    else
                    { value = this.options.find(function (option) { return ( option && String(option[this$1.returnOptionKey]) === String(value)); }) || '' }
                }
                return this.multiple
                    ? (value)
                    : ([value])
            }
        },
        /**
         * Filters and then flattens the options list
         * @param  {Array}
         * @returns {Array} returns a filtered and flat options list
         */
        filterAndFlat: function filterAndFlat (options, search, label) {
            return flow(
                filterGroups(search, label, this.groupValues, this.groupLabel, this.customLabel),
                flattenOptions(this.groupValues, this.groupLabel)
            )(options)
        },
        /**
         * Flattens and then strips the group labels from the options list
         * @param  {Array}
         * @returns {Array} returns a flat options list without group labels
         */
        flatAndStrip: function flatAndStrip (options) {
            return flow(
                flattenOptions(this.groupValues, this.groupLabel),
                stripGroups
            )(options)
        },
        /**
         * Updates the search value
         * @param  {String}
         */
        updateSearch: function updateSearch (query) {
            this.search = query
        },
        /**
         * Finds out if the given query is already present
         * in the available options
         * @param  {String}
         * @returns {Boolean} returns true if element is available
         */
        isExistingOption: function isExistingOption (query) {
            return !this.options
                ? false
                : this.optionKeys.indexOf(query) > -1
        },
        /**
         * Finds out if the given element is already present
         * in the result value
         * @param  {Object||String||Integer} option passed element to check
         * @returns {Boolean} returns true if element is selected
         */
        isSelected: function isSelected (option) {
            var opt = this.trackBy
                ? option[this.trackBy]
                : option
            return this.valueKeys.indexOf(opt) > -1
        },
        /**
         * Finds out if the given element is NOT already present
         * in the result value. Negated isSelected method.
         * @param  {Object||String||Integer} option passed element to check
         * @returns {Boolean} returns true if element is not selected
         */
        isNotSelected: function isNotSelected (option) {
            return !this.isSelected(option)
        },
        /**
         * Returns empty string when options is null/undefined
         * Returns tag query if option is tag.
         * Returns the customLabel() results and casts it to string.
         *
         * @param  {Object||String||Integer} Passed option
         * @returns {Object||String}
         */
        getOptionLabel: function getOptionLabel (option) {
            /* istanbul ignore else */
            if (isEmpty(option)) { return '' }
            /* istanbul ignore else */
            if (option.isTag) { return option.label }
            /* istanbul ignore else */
            if (option.$isLabel) { return option.$groupLabel }

            return this.customLabel(option, this.label) || ''
        },
        /**
         * Returns empty string when options is null/undefined
         * Returns tag query if option is tag.
         * Returns the customLabel() results and casts it to string.
         *
         * @param  {Object||String||Integer} Passed option
         * @returns {Object||String}
         */
        getOptionDistance: function getOptionDistance (option) {
            /* istanbul ignore else */
            if (isEmpty(option)) { return '' }
            /* istanbul ignore else */
            if (option.isTag) { return option.label }
            /* istanbul ignore else */
            if (option.$isLabel) { return option.$groupDistance }

            return this.customLabel(option, this.groupDistance) + 'km' || ''
        },
        /**
         * Add the given option to the list of selected options
         * or sets the option as the selected option.
         * If option is already selected -> remove it from the results.
         *
         * @param  {Object||String||Integer} option to select/deselect
         * @param  {Boolean} block removing
         */
        select: function select (option, key) {
            if (option.target == undefined) {
               this.deactivate()
            } else {
               return
            }
            /* istanbul ignore else */
            if (this.blockKeys.indexOf(key) !== -1 || this.disabled || option.$isLabel || option.$isDisabled) { return }
            /* istanbul ignore else */
            if (this.max && this.multiple && this.internalValue.length === this.max) { return }
            if (option.isTag) {
                this.$emit('tag', option.label, this.id)
                this.search = ''
                if (this.closeOnSelect && !this.multiple) { this.deactivate() }
            } else {
                var isSelected = this.isSelected(option)
                if (key == 'Tab')  { isSelected = true }
                      
                if (isSelected && key != 'mobile') {
                    if (key !== 'Tab') { this.removeElement(option) }
                    return
                } else if (this.multiple) {
                    if(key == 'mobile') { this.internalValue = [] }
                    this.internalValue.push(option)
                } else {
                    this.internalValue = [option]
                }
                this.$emit('select', (option), this.id)
                var value = this.getValue()
                value = this.returnOptionKey ? value[this.returnOptionKey] : value;
                this.$emit('input', value, this.id);

                /* istanbul ignore else */
                if (this.clearOnSelect) { this.search = '' }
            }
            /* istanbul ignore else */
            if (this.closeOnSelect) { this.deactivate() }
        },
        /**
         * Removes the given option from the selected options.
         * Additionally checks this.allowEmpty prop if option can be removed when
         * it is the last selected option.
         *
         * @param  {type} option description
         * @returns {type}        description
         */
        removeElement: function removeElement (option, shouldClose) {
            if ( shouldClose === void 0 ) shouldClose = true;

            /* istanbul ignore else */
            if (this.disabled) { return }
            /* istanbul ignore else */
            if (!this.allowEmpty && this.internalValue.length <= 1) {
                this.deactivate()
                return
            }

            var index = typeof option === 'object'
                ? this.valueKeys.indexOf(option[this.trackBy])
                : this.valueKeys.indexOf(option)

            this.internalValue.splice(index, 1)
            this.$emit('remove', (option), this.id)
            this.$emit('input', this.getValue(), this.id)

            /* istanbul ignore else */
            if (this.closeOnSelect && shouldClose) { this.deactivate() }
        },
        /**
         * Calls this.removeElement() with the last element
         * from this.internalValue (selected element Array)
         *
         * @fires this#removeElement
         */
        removeLastElement: function removeLastElement () {
            /* istanbul ignore else */
            if (this.blockKeys.indexOf('Delete') !== -1) { return }
            /* istanbul ignore else */
            if (this.search.length === 0 && Array.isArray(this.internalValue)) {
                this.removeElement(this.internalValue[this.internalValue.length - 1], false)
            }
        },
        /**
         * Opens the comboselect’s dropdown.
         * Sets this.isOpen to TRUE
         */
        activate: function activate () {
            var this$1 = this;

            /* istanbul ignore else */
            if (this.isOpen || this.disabled) { return }

            this.adjustPosition()
            /* istanbul ignore else  */
            if (this.groupValues && this.pointer === 0 && this.filteredOptions.length) {
                this.pointer = 1
            }

            this.isOpen = true
            /* istanbul ignore else  */
            if (this.searchable) {
                if (!this.preserveSearch) { this.search = '' }
                this.$nextTick(function () { return this$1.$refs.search.focus(); })
            } else {
                this.$el.focus()
            }
            this.$emit('open', this.id)
        },
        /**
         * Closes the comboselect’s dropdown.
         * Sets this.isOpen to FALSE
         */
        deactivate: function deactivate (e) {
            /* istanbul ignore else */
            if (!this.isOpen) { return }

            this.isOpen = false
            /* istanbul ignore else  */
            if (this.searchable) {
                this.$refs.search.blur()
            } else {
                this.$el.blur()
            }
            if (!this.preserveSearch) { this.search = '' }
            
        },
        /**
         * Call this.activate() or this.deactivate()
         * depending on this.isOpen value.
         *
         * @fires this#activate || this#deactivate
         * @property {Boolean} isOpen indicates if dropdown is open
         */
        toggle: function toggle () {
            this.isOpen
                ? this.deactivate()
                : this.activate()
        },
        /**
         * Updates the hasEnoughSpace variable used for
         * detecting where to expand the dropdown
         */
        adjustPosition: function adjustPosition () {
            if (typeof window === 'undefined') { return }

            var spaceAbove = this.$el.getBoundingClientRect().top
            var spaceBelow = window.innerHeight - this.$el.getBoundingClientRect().bottom
            var hasEnoughSpaceBelow = spaceBelow > this.maxHeight

            if (hasEnoughSpaceBelow || spaceBelow > spaceAbove || this.openDirection === 'below' || this.openDirection === 'bottom') {
                this.prefferedOpenDirection = 'below'
                this.optimizedHeight = Math.min(spaceBelow, this.maxHeight) - 40
            } else {
                this.prefferedOpenDirection = 'above'
                this.optimizedHeight = Math.min(spaceAbove, this.maxHeight) - 40
            }
        }
    }
};


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony default export */ exports["a"] = {
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
};


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(3);


/* harmony default export */ exports["a"] = {
  methods: {
    enter: function enter (el, done) {
      el.style.overflow = 'hidden'
      el.style.height = null
      el.style.display = 'block'
      var height = (el.clientHeight) + "px"
      el.style.height = 0

      setTimeout(function () {
        el.style.height = height
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["d" /* addOnceEventListener */])(el, 'transitionend', done)
      }, 50)
    },
    afterEnter: function afterEnter (el) {
      el.style.height = 'auto'
      el.style.overflow = null
    },
    leave: function leave (el, done) {
      el.style.overflow = 'hidden'
      el.style.height = (el.clientHeight) + "px"

      setTimeout(function () { return (el.style.height = 0); }, 50)

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["d" /* addOnceEventListener */])(el, 'transitionend', done)
    }
  }
};

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bowser__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bowser__);



/* harmony default export */ exports["a"] = {
  data: function data () {
    return {
      overlay: null
    }
  },

  props: {
    hideOverlay: Boolean
  },

  methods: {
    genOverlay: function genOverlay () {
      var this$1 = this;

      if (!this.isActive || this.hideOverlay) { return }

      var overlay = document.createElement('div')
      overlay.className = 'overlay'
      overlay.onclick = function () {
        if (this$1.permanet) { return }
        else if (!this$1.persistent) { this$1.isActive = false }
        else if (this$1.isMobile) { this$1.isActive = false }
      }

      if (this.absolute) { overlay.className += ' overlay--absolute' }

      this.hideScroll()

      var app = this.$el.closest('#app')
      app &&
        app.appendChild(overlay) ||
        document.body.appendChild(overlay)

      setTimeout(function () {
        overlay.className += ' overlay--active'
        this$1.overlay = overlay
      }, 0)
    },
    removeOverlay: function removeOverlay () {
      if (!this.overlay) { return }

      if(__WEBPACK_IMPORTED_MODULE_1_bowser___default.a.msie || __WEBPACK_IMPORTED_MODULE_1_bowser___default.a.msedge) { // transitionend event isn't being fired in IE 11 and Edge
        this.destroyOverlay()
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["d" /* addOnceEventListener */])(this.overlay, 'transitionend', this.destroyOverlay)
        this.overlay.classList.remove('overlay--active')
      }
    },
    destroyOverlay: function destroyOverlay() {
      if(this.overlay) {
        this.overlay.parentNode.removeChild(this.overlay)
        this.overlay = null
      }
      this.showScroll()
    },
    hideScroll: function hideScroll () {
      if (!this.$breakpoints.xs) { document.documentElement.style.overflowY = 'hidden' }
    },
    showScroll: function showScroll () {
      document.documentElement.style.overflowY = ''
    }
  }
};


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony default export */ exports["a"] = {
  data: function data () {
    return {
      pointer: 0,
      visibleElements: this.maxHeight / this.optionHeight
    }
  },
  props: {
    /**
     * Enable/disable highlighting of the pointed value.
     * @type {Boolean}
     * @default true
     */
    showPointer: {
      type: Boolean,
      default: true
    },
    optionHeight: {
      type: Number,
      default: 40
    }
  },
  computed: {
    pointerPosition: function pointerPosition () {
      return this.pointer * this.optionHeight
    }
  },
  watch: {
    filteredOptions: function filteredOptions () {
      this.pointerAdjust()
    }
  },
  methods: {
    optionHighlight: function optionHighlight (index, option) {
      return {
        'comboselect__option--highlight': index === this.pointer && this.showPointer,
        'comboselect__option--selected': this.isSelected(option)
      }
    },
    addPointerElement: function addPointerElement (ref) {
      if ( ref === void 0 ) ref = 'Enter';
      var key = ref.key;

      /* istanbul ignore else */
      if (this.filteredOptions.length > 0) {
        this.select(this.filteredOptions[this.pointer], key)
      }
      this.pointerReset()
    },
    pointerForward: function pointerForward () {
      /* istanbul ignore else */
      if (this.pointer < this.filteredOptions.length - 1) {
        this.pointer++
        /* istanbul ignore next */
        if (this.$refs.list.scrollTop <= this.pointerPosition - this.visibleElements * this.optionHeight) {
          this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight
        }
        /* istanbul ignore else */
        if (this.filteredOptions[this.pointer].$isLabel) { this.pointerForward() }
      }
    },
    pointerBackward: function pointerBackward () {
      if (this.pointer > 0) {
        this.pointer--
        /* istanbul ignore else */
        if (this.$refs.list.scrollTop >= this.pointerPosition) {
          this.$refs.list.scrollTop = this.pointerPosition
        }
        /* istanbul ignore else */
        if (this.filteredOptions[this.pointer].$isLabel) { this.pointerBackward() }
      } else {
        /* istanbul ignore else */
        if (this.filteredOptions[0].$isLabel) { this.pointerForward() }
      }
    },
    pointerReset: function pointerReset () {
      /* istanbul ignore else */
      if (!this.closeOnSelect) { return }
      this.pointer = 0
      /* istanbul ignore else */
      if (this.$refs.list) {
        this.$refs.list.scrollTop = 0
      }
    },
    pointerAdjust: function pointerAdjust () {
      /* istanbul ignore else */
      if (this.pointer >= this.filteredOptions.length - 1) {
        this.pointer = this.filteredOptions.length
          ? this.filteredOptions.length - 1
          : 0
      }
    },
    pointerSet: function pointerSet (index) {
      this.pointer = index
    }
  }
};


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony default export */ exports["a"] = {
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
};

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
var GoogleAdsApiLoader = function GoogleAdsApiLoader() {
  this._sdkLoadStarted = false;
  this._apiPromise = null;

  window.googletag = window.googletag || {};
  googletag.cmd = googletag.cmd || [];

  googletag.cmd.push(function () {
      googletag.pubads().enableSingleRequest();
      googletag.pubads().disableInitialLoad();
      googletag.enableServices();
  });

  this._maxLoadTime = 1000 * 20
  this._timerId = null
};

GoogleAdsApiLoader.prototype._loadSDK = function _loadSDK () {
    this._startTime = performance.now()
    var useSSL = 'https:' == document.location.protocol;
    var src = (useSSL ? 'https:' : 'https:') + '//www.googletagservices.com/tag/js/gpt.js';
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.head.appendChild(script);
};

GoogleAdsApiLoader.prototype._isAPIReady = function _isAPIReady () {
  return googletag.apiReady
};

GoogleAdsApiLoader.prototype.getApi = function getApi () {
    var this$1 = this;


  if(this._sdkLoadStarted == false) {
      this._loadSDK()
      this._sdkLoadStarted = true
  }

  if(!this._apiPromise) {
    this._apiPromise = new Promise(function (resolve, reject) {
      this$1._timerId = setInterval(function () {
          if(googletag.apiReady) {
              resolve(window.googletag)
              clearInterval(this$1._timerId)
          }
          else if (performance.now() - this$1._startTime >= this$1._maxLoadTime) {
              reject(new Error('Time out - Could not load the Google Ad\'s SDK'))
              clearInterval(this$1._timerId)
          }
      }, 500)
    });
  }

  return this._apiPromise;
};

/* harmony default export */ exports["a"] = new GoogleAdsApiLoader();

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
var ScrollSpy = function ScrollSpy(el, cb) {
  this.onScroll = this.onScroll.bind(this);
  this.update = this.update.bind(this);

  this.el = el;
  this.callback = cb;
  this.currentScrollY = this.prevScrollY = this.el.scrollY;
  this.ticking = false;

  this.el.addEventListener('scroll', this.onScroll, false);
};

ScrollSpy.prototype.onScroll = function onScroll () {
  this.currentScrollY = this.el.scrollY || this.el.pageYOffset;
  this.requestTick();
};

ScrollSpy.prototype.requestTick = function requestTick () {
  if( ! this.ticking ) { requestAnimationFrame(this.update); }
  this.ticking = true;
};

ScrollSpy.prototype.update = function update () {
  this.ticking = false;

  // Trigger the callback, passing in latest scroll values
  var scrollDirection = this.currentScrollY > this.prevScrollY ? 'positive' : 'negative';
  this.callback(this.currentScrollY, scrollDirection);

  this.prevScrollY = this.currentScrollY;
};

ScrollSpy.prototype.destroy = function destroy () {
  this.el.removeEventListener('scroll', this.onScroll);
};

/* harmony default export */ exports["a"] = ScrollSpy;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* unused harmony export requestInterval */
/* unused harmony export clearRequestInterval */
/* harmony export (immutable) */ exports["a"] = nextTick;
/**
 * Behaves the same as setInterval except uses requestAnimationFrame() where possible for better performance
 * @param {function} fn The callback function
 * @param {int} delay The delay in milliseconds
 */
function requestInterval (fn, delay) {
  if (!window.requestAnimationFrame) {
    return window.setInterval(fn, delay)
  }

  var start = performance ? performance.now() : Date.now()
  var handle = {}
  var delta

  function loop (time) {
    time = time || Date.now()
    delta = time - start

    if (delta >= delay) {
      fn.call()
      start = performance ? performance.now() : Date.now()
    }

    handle.value = requestAnimationFrame(loop)
  };

  handle.value = requestAnimationFrame(loop)
  return handle
}

/**
 * Behaves the same as clearInterval except uses cancelRequestAnimationFrame() where possible for better performance
 * @param {int|object} fn The callback function
 */
function clearRequestInterval (handle) {
  cancelAnimationFrame ? cancelAnimationFrame(handle.value) : clearInterval(handle)
}

function nextTick (fn) {
  setTimeout(fn, 0)
}

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return Hammer;
    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

var SvgPanZoom = __webpack_require__(229);

module.exports = SvgPanZoom;


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

var SvgUtils = __webpack_require__(7);

module.exports = {
  enable: function(instance) {
    // Select (and create if necessary) defs
    var defs = instance.svg.querySelector('defs')
    if (!defs) {
      defs = document.createElementNS(SvgUtils.svgNS, 'defs')
      instance.svg.appendChild(defs)
    }

    // Check for style element, and create it if it doesn't exist
    var styleEl = defs.querySelector('style#svg-pan-zoom-controls-styles');
    if (!styleEl) {
      var style = document.createElementNS(SvgUtils.svgNS, 'style')
      style.setAttribute('id', 'svg-pan-zoom-controls-styles')
      style.setAttribute('type', 'text/css')
      style.textContent = '.svg-pan-zoom-control { cursor: pointer; fill: black; fill-opacity: 0.333; } .svg-pan-zoom-control:hover { fill-opacity: 0.8; } .svg-pan-zoom-control-background { fill: white; fill-opacity: 0.5; } .svg-pan-zoom-control-background { fill-opacity: 0.8; }'
      defs.appendChild(style)
    }

    // Zoom Group
    var zoomGroup = document.createElementNS(SvgUtils.svgNS, 'g');
    zoomGroup.setAttribute('id', 'svg-pan-zoom-controls');
    zoomGroup.setAttribute('transform', 'translate(' + ( instance.width - 70 ) + ' ' + ( instance.height - 76 ) + ') scale(0.75)');
    zoomGroup.setAttribute('class', 'svg-pan-zoom-control');

    // Control elements
    zoomGroup.appendChild(this._createZoomIn(instance))
    zoomGroup.appendChild(this._createZoomReset(instance))
    zoomGroup.appendChild(this._createZoomOut(instance))

    // Finally append created element
    instance.svg.appendChild(zoomGroup)

    // Cache control instance
    instance.controlIcons = zoomGroup
  }

, _createZoomIn: function(instance) {
    var zoomIn = document.createElementNS(SvgUtils.svgNS, 'g');
    zoomIn.setAttribute('id', 'svg-pan-zoom-zoom-in');
    zoomIn.setAttribute('transform', 'translate(30.5 5) scale(0.015)');
    zoomIn.setAttribute('class', 'svg-pan-zoom-control');
    zoomIn.addEventListener('click', function() {instance.getPublicInstance().zoomIn()}, false)
    zoomIn.addEventListener('touchstart', function() {instance.getPublicInstance().zoomIn()}, false)

    var zoomInBackground = document.createElementNS(SvgUtils.svgNS, 'rect'); // TODO change these background space fillers to rounded rectangles so they look prettier
    zoomInBackground.setAttribute('x', '0');
    zoomInBackground.setAttribute('y', '0');
    zoomInBackground.setAttribute('width', '1500'); // larger than expected because the whole group is transformed to scale down
    zoomInBackground.setAttribute('height', '1400');
    zoomInBackground.setAttribute('class', 'svg-pan-zoom-control-background');
    zoomIn.appendChild(zoomInBackground);

    var zoomInShape = document.createElementNS(SvgUtils.svgNS, 'path');
    zoomInShape.setAttribute('d', 'M1280 576v128q0 26 -19 45t-45 19h-320v320q0 26 -19 45t-45 19h-128q-26 0 -45 -19t-19 -45v-320h-320q-26 0 -45 -19t-19 -45v-128q0 -26 19 -45t45 -19h320v-320q0 -26 19 -45t45 -19h128q26 0 45 19t19 45v320h320q26 0 45 19t19 45zM1536 1120v-960 q0 -119 -84.5 -203.5t-203.5 -84.5h-960q-119 0 -203.5 84.5t-84.5 203.5v960q0 119 84.5 203.5t203.5 84.5h960q119 0 203.5 -84.5t84.5 -203.5z');
    zoomInShape.setAttribute('class', 'svg-pan-zoom-control-element');
    zoomIn.appendChild(zoomInShape);

    return zoomIn
  }

, _createZoomReset: function(instance){
    // reset
    var resetPanZoomControl = document.createElementNS(SvgUtils.svgNS, 'g');
    resetPanZoomControl.setAttribute('id', 'svg-pan-zoom-reset-pan-zoom');
    resetPanZoomControl.setAttribute('transform', 'translate(5 35) scale(0.4)');
    resetPanZoomControl.setAttribute('class', 'svg-pan-zoom-control');
    resetPanZoomControl.addEventListener('click', function() {instance.getPublicInstance().reset()}, false);
    resetPanZoomControl.addEventListener('touchstart', function() {instance.getPublicInstance().reset()}, false);

    var resetPanZoomControlBackground = document.createElementNS(SvgUtils.svgNS, 'rect'); // TODO change these background space fillers to rounded rectangles so they look prettier
    resetPanZoomControlBackground.setAttribute('x', '2');
    resetPanZoomControlBackground.setAttribute('y', '2');
    resetPanZoomControlBackground.setAttribute('width', '182'); // larger than expected because the whole group is transformed to scale down
    resetPanZoomControlBackground.setAttribute('height', '58');
    resetPanZoomControlBackground.setAttribute('class', 'svg-pan-zoom-control-background');
    resetPanZoomControl.appendChild(resetPanZoomControlBackground);

    var resetPanZoomControlShape1 = document.createElementNS(SvgUtils.svgNS, 'path');
    resetPanZoomControlShape1.setAttribute('d', 'M33.051,20.632c-0.742-0.406-1.854-0.609-3.338-0.609h-7.969v9.281h7.769c1.543,0,2.701-0.188,3.473-0.562c1.365-0.656,2.048-1.953,2.048-3.891C35.032,22.757,34.372,21.351,33.051,20.632z');
    resetPanZoomControlShape1.setAttribute('class', 'svg-pan-zoom-control-element');
    resetPanZoomControl.appendChild(resetPanZoomControlShape1);

    var resetPanZoomControlShape2 = document.createElementNS(SvgUtils.svgNS, 'path');
    resetPanZoomControlShape2.setAttribute('d', 'M170.231,0.5H15.847C7.102,0.5,0.5,5.708,0.5,11.84v38.861C0.5,56.833,7.102,61.5,15.847,61.5h154.384c8.745,0,15.269-4.667,15.269-10.798V11.84C185.5,5.708,178.976,0.5,170.231,0.5z M42.837,48.569h-7.969c-0.219-0.766-0.375-1.383-0.469-1.852c-0.188-0.969-0.289-1.961-0.305-2.977l-0.047-3.211c-0.03-2.203-0.41-3.672-1.142-4.406c-0.732-0.734-2.103-1.102-4.113-1.102h-7.05v13.547h-7.055V14.022h16.524c2.361,0.047,4.178,0.344,5.45,0.891c1.272,0.547,2.351,1.352,3.234,2.414c0.731,0.875,1.31,1.844,1.737,2.906s0.64,2.273,0.64,3.633c0,1.641-0.414,3.254-1.242,4.84s-2.195,2.707-4.102,3.363c1.594,0.641,2.723,1.551,3.387,2.73s0.996,2.98,0.996,5.402v2.32c0,1.578,0.063,2.648,0.19,3.211c0.19,0.891,0.635,1.547,1.333,1.969V48.569z M75.579,48.569h-26.18V14.022h25.336v6.117H56.454v7.336h16.781v6H56.454v8.883h19.125V48.569z M104.497,46.331c-2.44,2.086-5.887,3.129-10.34,3.129c-4.548,0-8.125-1.027-10.731-3.082s-3.909-4.879-3.909-8.473h6.891c0.224,1.578,0.662,2.758,1.316,3.539c1.196,1.422,3.246,2.133,6.15,2.133c1.739,0,3.151-0.188,4.236-0.562c2.058-0.719,3.087-2.055,3.087-4.008c0-1.141-0.504-2.023-1.512-2.648c-1.008-0.609-2.607-1.148-4.796-1.617l-3.74-0.82c-3.676-0.812-6.201-1.695-7.576-2.648c-2.328-1.594-3.492-4.086-3.492-7.477c0-3.094,1.139-5.664,3.417-7.711s5.623-3.07,10.036-3.07c3.685,0,6.829,0.965,9.431,2.895c2.602,1.93,3.966,4.73,4.093,8.402h-6.938c-0.128-2.078-1.057-3.555-2.787-4.43c-1.154-0.578-2.587-0.867-4.301-0.867c-1.907,0-3.428,0.375-4.565,1.125c-1.138,0.75-1.706,1.797-1.706,3.141c0,1.234,0.561,2.156,1.682,2.766c0.721,0.406,2.25,0.883,4.589,1.43l6.063,1.43c2.657,0.625,4.648,1.461,5.975,2.508c2.059,1.625,3.089,3.977,3.089,7.055C108.157,41.624,106.937,44.245,104.497,46.331z M139.61,48.569h-26.18V14.022h25.336v6.117h-18.281v7.336h16.781v6h-16.781v8.883h19.125V48.569z M170.337,20.14h-10.336v28.43h-7.266V20.14h-10.383v-6.117h27.984V20.14z');
    resetPanZoomControlShape2.setAttribute('class', 'svg-pan-zoom-control-element');
    resetPanZoomControl.appendChild(resetPanZoomControlShape2);

    return resetPanZoomControl
  }

, _createZoomOut: function(instance){
    // zoom out
    var zoomOut = document.createElementNS(SvgUtils.svgNS, 'g');
    zoomOut.setAttribute('id', 'svg-pan-zoom-zoom-out');
    zoomOut.setAttribute('transform', 'translate(30.5 70) scale(0.015)');
    zoomOut.setAttribute('class', 'svg-pan-zoom-control');
    zoomOut.addEventListener('click', function() {instance.getPublicInstance().zoomOut()}, false);
    zoomOut.addEventListener('touchstart', function() {instance.getPublicInstance().zoomOut()}, false);

    var zoomOutBackground = document.createElementNS(SvgUtils.svgNS, 'rect'); // TODO change these background space fillers to rounded rectangles so they look prettier
    zoomOutBackground.setAttribute('x', '0');
    zoomOutBackground.setAttribute('y', '0');
    zoomOutBackground.setAttribute('width', '1500'); // larger than expected because the whole group is transformed to scale down
    zoomOutBackground.setAttribute('height', '1400');
    zoomOutBackground.setAttribute('class', 'svg-pan-zoom-control-background');
    zoomOut.appendChild(zoomOutBackground);

    var zoomOutShape = document.createElementNS(SvgUtils.svgNS, 'path');
    zoomOutShape.setAttribute('d', 'M1280 576v128q0 26 -19 45t-45 19h-896q-26 0 -45 -19t-19 -45v-128q0 -26 19 -45t45 -19h896q26 0 45 19t19 45zM1536 1120v-960q0 -119 -84.5 -203.5t-203.5 -84.5h-960q-119 0 -203.5 84.5t-84.5 203.5v960q0 119 84.5 203.5t203.5 84.5h960q119 0 203.5 -84.5 t84.5 -203.5z');
    zoomOutShape.setAttribute('class', 'svg-pan-zoom-control-element');
    zoomOut.appendChild(zoomOutShape);

    return zoomOut
  }

, disable: function(instance) {
    if (instance.controlIcons) {
      instance.controlIcons.parentNode.removeChild(instance.controlIcons)
      instance.controlIcons = null
    }
  }
}


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

var SvgUtils = __webpack_require__(7)
  , Utils = __webpack_require__(8)
  ;

var ShadowViewport = function(viewport, options){
  this.init(viewport, options)
}

/**
 * Initialization
 *
 * @param  {SVGElement} viewport
 * @param  {Object} options
 */
ShadowViewport.prototype.init = function(viewport, options) {
  // DOM Elements
  this.viewport = viewport
  this.options = options

  // State cache
  this.originalState = {zoom: 1, x: 0, y: 0}
  this.activeState = {zoom: 1, x: 0, y: 0}

  this.updateCTMCached = Utils.proxy(this.updateCTM, this)

  // Create a custom requestAnimationFrame taking in account refreshRate
  this.requestAnimationFrame = Utils.createRequestAnimationFrame(this.options.refreshRate)

  // ViewBox
  this.viewBox = {x: 0, y: 0, width: 0, height: 0}
  this.cacheViewBox()

  // Process CTM
  var newCTM = this.processCTM()

  // Update viewport CTM and cache zoom and pan
  this.setCTM(newCTM)

  // Update CTM in this frame
  this.updateCTM()
}

/**
 * Cache initial viewBox value
 * If no viewBox is defined, then use viewport size/position instead for viewBox values
 */
ShadowViewport.prototype.cacheViewBox = function() {
  var svgViewBox = this.options.svg.getAttribute('viewBox')

  if (svgViewBox) {
    var viewBoxValues = svgViewBox.split(/[\s\,]/).filter(function(v){return v}).map(parseFloat)

    // Cache viewbox x and y offset
    this.viewBox.x = viewBoxValues[0]
    this.viewBox.y = viewBoxValues[1]
    this.viewBox.width = viewBoxValues[2]
    this.viewBox.height = viewBoxValues[3]

    var zoom = Math.min(this.options.width / this.viewBox.width, this.options.height / this.viewBox.height)

    // Update active state
    this.activeState.zoom = zoom
    this.activeState.x = (this.options.width - this.viewBox.width * zoom) / 2
    this.activeState.y = (this.options.height - this.viewBox.height * zoom) / 2

    // Force updating CTM
    this.updateCTMOnNextFrame()

    this.options.svg.removeAttribute('viewBox')
  } else {
    this.simpleViewBoxCache()
  }
}

/**
 * Recalculate viewport sizes and update viewBox cache
 */
ShadowViewport.prototype.simpleViewBoxCache = function() {
  var bBox = this.viewport.getBBox()

  this.viewBox.x = bBox.x
  this.viewBox.y = bBox.y
  this.viewBox.width = bBox.width
  this.viewBox.height = bBox.height
}

/**
 * Returns a viewbox object. Safe to alter
 *
 * @return {Object} viewbox object
 */
ShadowViewport.prototype.getViewBox = function() {
  return Utils.extend({}, this.viewBox)
}

/**
 * Get initial zoom and pan values. Save them into originalState
 * Parses viewBox attribute to alter initial sizes
 *
 * @return {CTM} CTM object based on options
 */
ShadowViewport.prototype.processCTM = function() {
  var newCTM = this.getCTM()

  if (this.options.fit || this.options.contain) {
    var newScale;
    if (this.options.fit) {
      newScale = Math.min(this.options.width/this.viewBox.width, this.options.height/this.viewBox.height);
    } else {
      newScale = Math.max(this.options.width/this.viewBox.width, this.options.height/this.viewBox.height);
    }

    newCTM.a = newScale; //x-scale
    newCTM.d = newScale; //y-scale
    newCTM.e = -this.viewBox.x * newScale; //x-transform
    newCTM.f = -this.viewBox.y * newScale; //y-transform
  }

  if (this.options.center) {
    var offsetX = (this.options.width - (this.viewBox.width + this.viewBox.x * 2) * newCTM.a) * 0.5
      , offsetY = (this.options.height - (this.viewBox.height + this.viewBox.y * 2) * newCTM.a) * 0.5

    newCTM.e = offsetX
    newCTM.f = offsetY
  }

  // Cache initial values. Based on activeState and fix+center opitons
  this.originalState.zoom = newCTM.a
  this.originalState.x = newCTM.e
  this.originalState.y = newCTM.f

  return newCTM
}

/**
 * Return originalState object. Safe to alter
 *
 * @return {Object}
 */
ShadowViewport.prototype.getOriginalState = function() {
  return Utils.extend({}, this.originalState)
}

/**
 * Return actualState object. Safe to alter
 *
 * @return {Object}
 */
ShadowViewport.prototype.getState = function() {
  return Utils.extend({}, this.activeState)
}

/**
 * Get zoom scale
 *
 * @return {Float} zoom scale
 */
ShadowViewport.prototype.getZoom = function() {
  return this.activeState.zoom
}

/**
 * Get zoom scale for pubilc usage
 *
 * @return {Float} zoom scale
 */
ShadowViewport.prototype.getRelativeZoom = function() {
  return this.activeState.zoom / this.originalState.zoom
}

/**
 * Compute zoom scale for pubilc usage
 *
 * @return {Float} zoom scale
 */
ShadowViewport.prototype.computeRelativeZoom = function(scale) {
  return scale / this.originalState.zoom
}

/**
 * Get pan
 *
 * @return {Object}
 */
ShadowViewport.prototype.getPan = function() {
  return {x: this.activeState.x, y: this.activeState.y}
}

/**
 * Return cached viewport CTM value that can be safely modified
 *
 * @return {SVGMatrix}
 */
ShadowViewport.prototype.getCTM = function() {
  var safeCTM = this.options.svg.createSVGMatrix()

  // Copy values manually as in FF they are not itterable
  safeCTM.a = this.activeState.zoom
  safeCTM.b = 0
  safeCTM.c = 0
  safeCTM.d = this.activeState.zoom
  safeCTM.e = this.activeState.x
  safeCTM.f = this.activeState.y

  return safeCTM
}

/**
 * Set a new CTM
 *
 * @param {SVGMatrix} newCTM
 */
ShadowViewport.prototype.setCTM = function(newCTM) {
  var willZoom = this.isZoomDifferent(newCTM)
    , willPan = this.isPanDifferent(newCTM)

  if (willZoom || willPan) {
    // Before zoom
    if (willZoom) {
      // If returns false then cancel zooming
      if (this.options.beforeZoom(this.getRelativeZoom(), this.computeRelativeZoom(newCTM.a)) === false) {
        newCTM.a = newCTM.d = this.activeState.zoom
        willZoom = false
      } else {
        this.updateCache(newCTM);
        this.options.onZoom(this.getRelativeZoom())
      }
    }

    // Before pan
    if (willPan) {
      var preventPan = this.options.beforePan(this.getPan(), {x: newCTM.e, y: newCTM.f})
          // If prevent pan is an object
        , preventPanX = false
        , preventPanY = false

      // If prevent pan is Boolean false
      if (preventPan === false) {
        // Set x and y same as before
        newCTM.e = this.getPan().x
        newCTM.f = this.getPan().y

        preventPanX = preventPanY = true
      } else if (Utils.isObject(preventPan)) {
        // Check for X axes attribute
        if (preventPan.x === false) {
          // Prevent panning on x axes
          newCTM.e = this.getPan().x
          preventPanX = true
        } else if (Utils.isNumber(preventPan.x)) {
          // Set a custom pan value
          newCTM.e = preventPan.x
        }

        // Check for Y axes attribute
        if (preventPan.y === false) {
          // Prevent panning on x axes
          newCTM.f = this.getPan().y
          preventPanY = true
        } else if (Utils.isNumber(preventPan.y)) {
          // Set a custom pan value
          newCTM.f = preventPan.y
        }
      }

      // Update willPan flag
      // Check if newCTM is still different
      if ((preventPanX && preventPanY) || !this.isPanDifferent(newCTM)) {
        willPan = false
      } else {
        this.updateCache(newCTM);
        this.options.onPan(this.getPan());
      }
    }

    // Check again if should zoom or pan
    if (willZoom || willPan) {
      this.updateCTMOnNextFrame()
    }
  }
}

ShadowViewport.prototype.isZoomDifferent = function(newCTM) {
  return this.activeState.zoom !== newCTM.a
}

ShadowViewport.prototype.isPanDifferent = function(newCTM) {
  return this.activeState.x !== newCTM.e || this.activeState.y !== newCTM.f
}


/**
 * Update cached CTM and active state
 *
 * @param {SVGMatrix} newCTM
 */
ShadowViewport.prototype.updateCache = function(newCTM) {
  this.activeState.zoom = newCTM.a
  this.activeState.x = newCTM.e
  this.activeState.y = newCTM.f
}

ShadowViewport.prototype.pendingUpdate = false

/**
 * Place a request to update CTM on next Frame
 */
ShadowViewport.prototype.updateCTMOnNextFrame = function() {
  if (!this.pendingUpdate) {
    // Lock
    this.pendingUpdate = true

    // Throttle next update
    this.requestAnimationFrame.call(window, this.updateCTMCached)
  }
}

/**
 * Update viewport CTM with cached CTM
 */
ShadowViewport.prototype.updateCTM = function() {
  var ctm = this.getCTM()

  // Updates SVG element
  SvgUtils.setCTM(this.viewport, ctm, this.defs)

  // Free the lock
  this.pendingUpdate = false

  // Notify about the update
  if(this.options.onUpdatedCTM) {
    this.options.onUpdatedCTM(ctm)
  }
}

module.exports = function(viewport, options){
  return new ShadowViewport(viewport, options)
}


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

var Wheel = __webpack_require__(230)
, ControlIcons = __webpack_require__(227)
, Utils = __webpack_require__(8)
, SvgUtils = __webpack_require__(7)
, ShadowViewport = __webpack_require__(228)

var SvgPanZoom = function(svg, options) {
  this.init(svg, options)
}

var optionsDefaults = {
  viewportSelector: '.svg-pan-zoom_viewport' // Viewport selector. Can be querySelector string or SVGElement
, panEnabled: true // enable or disable panning (default enabled)
, controlIconsEnabled: false // insert icons to give user an option in addition to mouse events to control pan/zoom (default disabled)
, zoomEnabled: true // enable or disable zooming (default enabled)
, dblClickZoomEnabled: true // enable or disable zooming by double clicking (default enabled)
, mouseWheelZoomEnabled: true // enable or disable zooming by mouse wheel (default enabled)
, preventMouseEventsDefault: true // enable or disable preventDefault for mouse events
, zoomScaleSensitivity: 0.1 // Zoom sensitivity
, minZoom: 0.5 // Minimum Zoom level
, maxZoom: 10 // Maximum Zoom level
, fit: true // enable or disable viewport fit in SVG (default true)
, contain: false // enable or disable viewport contain the svg (default false)
, center: true // enable or disable viewport centering in SVG (default true)
, refreshRate: 'auto' // Maximum number of frames per second (altering SVG's viewport)
, beforeZoom: null
, onZoom: null
, beforePan: null
, onPan: null
, customEventsHandler: null
, eventsListenerElement: null
, onUpdatedCTM: null
}

SvgPanZoom.prototype.init = function(svg, options) {
  var that = this

  this.svg = svg
  this.defs = svg.querySelector('defs')

  // Add default attributes to SVG
  SvgUtils.setupSvgAttributes(this.svg)

  // Set options
  this.options = Utils.extend(Utils.extend({}, optionsDefaults), options)

  // Set default state
  this.state = 'none'

  // Get dimensions
  var boundingClientRectNormalized = SvgUtils.getBoundingClientRectNormalized(svg)
  this.width = boundingClientRectNormalized.width
  this.height = boundingClientRectNormalized.height

  // Init shadow viewport
  this.viewport = ShadowViewport(SvgUtils.getOrCreateViewport(this.svg, this.options.viewportSelector), {
    svg: this.svg
  , width: this.width
  , height: this.height
  , fit: this.options.fit
  , contain: this.options.contain
  , center: this.options.center
  , refreshRate: this.options.refreshRate
  // Put callbacks into functions as they can change through time
  , beforeZoom: function(oldScale, newScale) {
      if (that.viewport && that.options.beforeZoom) {return that.options.beforeZoom(oldScale, newScale)}
    }
  , onZoom: function(scale) {
      if (that.viewport && that.options.onZoom) {return that.options.onZoom(scale)}
    }
  , beforePan: function(oldPoint, newPoint) {
      if (that.viewport && that.options.beforePan) {return that.options.beforePan(oldPoint, newPoint)}
    }
  , onPan: function(point) {
      if (that.viewport && that.options.onPan) {return that.options.onPan(point)}
    }
  , onUpdatedCTM: function(ctm) {
      if (that.viewport && that.options.onUpdatedCTM) {return that.options.onUpdatedCTM(ctm)}
    }
  })

  // Wrap callbacks into public API context
  var publicInstance = this.getPublicInstance()
  publicInstance.setBeforeZoom(this.options.beforeZoom)
  publicInstance.setOnZoom(this.options.onZoom)
  publicInstance.setBeforePan(this.options.beforePan)
  publicInstance.setOnPan(this.options.onPan)
  publicInstance.setOnUpdatedCTM(this.options.onUpdatedCTM)

  if (this.options.controlIconsEnabled) {
    ControlIcons.enable(this)
  }

  // Init events handlers
  this.lastMouseWheelEventTime = Date.now()
  this.setupHandlers()
}

/**
 * Register event handlers
 */
SvgPanZoom.prototype.setupHandlers = function() {
  var that = this
    , prevEvt = null // use for touchstart event to detect double tap
    ;

  this.eventListeners = {
    // Mouse down group
    mousedown: function(evt) {
      var result = that.handleMouseDown(evt, prevEvt);
      prevEvt = evt
      return result;
    }
  , touchstart: function(evt) {
      var result = that.handleMouseDown(evt, prevEvt);
      prevEvt = evt
      return result;
    }

    // Mouse up group
  , mouseup: function(evt) {
      return that.handleMouseUp(evt);
    }
  , touchend: function(evt) {
      return that.handleMouseUp(evt);
    }

    // Mouse move group
  , mousemove: function(evt) {
      return that.handleMouseMove(evt);
    }
  , touchmove: function(evt) {
      return that.handleMouseMove(evt);
    }

    // Mouse leave group
  , mouseleave: function(evt) {
      return that.handleMouseUp(evt);
    }
  , touchleave: function(evt) {
      return that.handleMouseUp(evt);
    }
  , touchcancel: function(evt) {
      return that.handleMouseUp(evt);
    }
  }

  // Init custom events handler if available
  if (this.options.customEventsHandler != null) { // jshint ignore:line
    this.options.customEventsHandler.init({
      svgElement: this.svg
    , eventsListenerElement: this.options.eventsListenerElement
    , instance: this.getPublicInstance()
    })

    // Custom event handler may halt builtin listeners
    var haltEventListeners = this.options.customEventsHandler.haltEventListeners
    if (haltEventListeners && haltEventListeners.length) {
      for (var i = haltEventListeners.length - 1; i >= 0; i--) {
        if (this.eventListeners.hasOwnProperty(haltEventListeners[i])) {
          delete this.eventListeners[haltEventListeners[i]]
        }
      }
    }
  }

  // Bind eventListeners
  for (var event in this.eventListeners) {
    // Attach event to eventsListenerElement or SVG if not available
    (this.options.eventsListenerElement || this.svg)
      .addEventListener(event, this.eventListeners[event], false)
  }

  // Zoom using mouse wheel
  if (this.options.mouseWheelZoomEnabled) {
    this.options.mouseWheelZoomEnabled = false // set to false as enable will set it back to true
    this.enableMouseWheelZoom()
  }
}

/**
 * Enable ability to zoom using mouse wheel
 */
SvgPanZoom.prototype.enableMouseWheelZoom = function() {
  if (!this.options.mouseWheelZoomEnabled) {
    var that = this

    // Mouse wheel listener
    this.wheelListener = function(evt) {
      return that.handleMouseWheel(evt);
    }

    // Bind wheelListener
    Wheel.on(this.options.eventsListenerElement || this.svg, this.wheelListener, false)

    this.options.mouseWheelZoomEnabled = true
  }
}

/**
 * Disable ability to zoom using mouse wheel
 */
SvgPanZoom.prototype.disableMouseWheelZoom = function() {
  if (this.options.mouseWheelZoomEnabled) {
    Wheel.off(this.options.eventsListenerElement || this.svg, this.wheelListener, false)
    this.options.mouseWheelZoomEnabled = false
  }
}

/**
 * Handle mouse wheel event
 *
 * @param  {Event} evt
 */
SvgPanZoom.prototype.handleMouseWheel = function(evt) {
  if (!this.options.zoomEnabled || this.state !== 'none') {
    return;
  }

  if (this.options.preventMouseEventsDefault){
    if (evt.preventDefault) {
      evt.preventDefault();
    } else {
      evt.returnValue = false;
    }
  }

  // Default delta in case that deltaY is not available
  var delta = evt.deltaY || 1
    , timeDelta = Date.now() - this.lastMouseWheelEventTime
    , divider = 3 + Math.max(0, 30 - timeDelta)

  // Update cache
  this.lastMouseWheelEventTime = Date.now()

  // Make empirical adjustments for browsers that give deltaY in pixels (deltaMode=0)
  if ('deltaMode' in evt && evt.deltaMode === 0 && evt.wheelDelta) {
    delta = evt.deltaY === 0 ? 0 :  Math.abs(evt.wheelDelta) / evt.deltaY
  }

  delta = -0.3 < delta && delta < 0.3 ? delta : (delta > 0 ? 1 : -1) * Math.log(Math.abs(delta) + 10) / divider

  var inversedScreenCTM = this.svg.getScreenCTM().inverse()
    , relativeMousePoint = SvgUtils.getEventPoint(evt, this.svg).matrixTransform(inversedScreenCTM)
    , zoom = Math.pow(1 + this.options.zoomScaleSensitivity, (-1) * delta); // multiplying by neg. 1 so as to make zoom in/out behavior match Google maps behavior

  this.zoomAtPoint(zoom, relativeMousePoint)
}

/**
 * Zoom in at a SVG point
 *
 * @param  {SVGPoint} point
 * @param  {Float} zoomScale    Number representing how much to zoom
 * @param  {Boolean} zoomAbsolute Default false. If true, zoomScale is treated as an absolute value.
 *                                Otherwise, zoomScale is treated as a multiplied (e.g. 1.10 would zoom in 10%)
 */
SvgPanZoom.prototype.zoomAtPoint = function(zoomScale, point, zoomAbsolute) {
  var originalState = this.viewport.getOriginalState()

  if (!zoomAbsolute) {
    // Fit zoomScale in set bounds
    if (this.getZoom() * zoomScale < this.options.minZoom * originalState.zoom) {
      zoomScale = (this.options.minZoom * originalState.zoom) / this.getZoom()
    } else if (this.getZoom() * zoomScale > this.options.maxZoom * originalState.zoom) {
      zoomScale = (this.options.maxZoom * originalState.zoom) / this.getZoom()
    }
  } else {
    // Fit zoomScale in set bounds
    zoomScale = Math.max(this.options.minZoom * originalState.zoom, Math.min(this.options.maxZoom * originalState.zoom, zoomScale))
    // Find relative scale to achieve desired scale
    zoomScale = zoomScale/this.getZoom()
  }

  var oldCTM = this.viewport.getCTM()
    , relativePoint = point.matrixTransform(oldCTM.inverse())
    , modifier = this.svg.createSVGMatrix().translate(relativePoint.x, relativePoint.y).scale(zoomScale).translate(-relativePoint.x, -relativePoint.y)
    , newCTM = oldCTM.multiply(modifier)

  if (newCTM.a !== oldCTM.a) {
    this.viewport.setCTM(newCTM)
  }
}

/**
 * Zoom at center point
 *
 * @param  {Float} scale
 * @param  {Boolean} absolute Marks zoom scale as relative or absolute
 */
SvgPanZoom.prototype.zoom = function(scale, absolute) {
  this.zoomAtPoint(scale, SvgUtils.getSvgCenterPoint(this.svg, this.width, this.height), absolute)
}

/**
 * Zoom used by public instance
 *
 * @param  {Float} scale
 * @param  {Boolean} absolute Marks zoom scale as relative or absolute
 */
SvgPanZoom.prototype.publicZoom = function(scale, absolute) {
  if (absolute) {
    scale = this.computeFromRelativeZoom(scale)
  }

  this.zoom(scale, absolute)
}

/**
 * Zoom at point used by public instance
 *
 * @param  {Float} scale
 * @param  {SVGPoint|Object} point    An object that has x and y attributes
 * @param  {Boolean} absolute Marks zoom scale as relative or absolute
 */
SvgPanZoom.prototype.publicZoomAtPoint = function(scale, point, absolute) {
  if (absolute) {
    // Transform zoom into a relative value
    scale = this.computeFromRelativeZoom(scale)
  }

  // If not a SVGPoint but has x and y then create a SVGPoint
  if (Utils.getType(point) !== 'SVGPoint') {
    if('x' in point && 'y' in point) {
      point = SvgUtils.createSVGPoint(this.svg, point.x, point.y)
    } else {
      throw new Error('Given point is invalid')
    }
  }

  this.zoomAtPoint(scale, point, absolute)
}

/**
 * Get zoom scale
 *
 * @return {Float} zoom scale
 */
SvgPanZoom.prototype.getZoom = function() {
  return this.viewport.getZoom()
}

/**
 * Get zoom scale for public usage
 *
 * @return {Float} zoom scale
 */
SvgPanZoom.prototype.getRelativeZoom = function() {
  return this.viewport.getRelativeZoom()
}

/**
 * Compute actual zoom from public zoom
 *
 * @param  {Float} zoom
 * @return {Float} zoom scale
 */
SvgPanZoom.prototype.computeFromRelativeZoom = function(zoom) {
  return zoom * this.viewport.getOriginalState().zoom
}

/**
 * Set zoom to initial state
 */
SvgPanZoom.prototype.resetZoom = function() {
  var originalState = this.viewport.getOriginalState()

  this.zoom(originalState.zoom, true);
}

/**
 * Set pan to initial state
 */
SvgPanZoom.prototype.resetPan = function() {
  this.pan(this.viewport.getOriginalState());
}

/**
 * Set pan and zoom to initial state
 */
SvgPanZoom.prototype.reset = function() {
  this.resetZoom()
  this.resetPan()
}

/**
 * Handle double click event
 * See handleMouseDown() for alternate detection method
 *
 * @param {Event} evt
 */
SvgPanZoom.prototype.handleDblClick = function(evt) {
  if (this.options.preventMouseEventsDefault) {
    if (evt.preventDefault) {
      evt.preventDefault()
    } else {
      evt.returnValue = false
    }
  }

  // Check if target was a control button
  if (this.options.controlIconsEnabled) {
    var targetClass = evt.target.getAttribute('class') || ''
    if (targetClass.indexOf('svg-pan-zoom-control') > -1) {
      return false
    }
  }

  var zoomFactor

  if (evt.shiftKey) {
    zoomFactor = 1/((1 + this.options.zoomScaleSensitivity) * 2) // zoom out when shift key pressed
  } else {
    zoomFactor = (1 + this.options.zoomScaleSensitivity) * 2
  }

  var point = SvgUtils.getEventPoint(evt, this.svg).matrixTransform(this.svg.getScreenCTM().inverse())
  this.zoomAtPoint(zoomFactor, point)
}

/**
 * Handle click event
 *
 * @param {Event} evt
 */
SvgPanZoom.prototype.handleMouseDown = function(evt, prevEvt) {
  if (this.options.preventMouseEventsDefault) {
    if (evt.preventDefault) {
      evt.preventDefault()
    } else {
      evt.returnValue = false
    }
  }

  Utils.mouseAndTouchNormalize(evt, this.svg)

  // Double click detection; more consistent than ondblclick
  if (this.options.dblClickZoomEnabled && Utils.isDblClick(evt, prevEvt)){
    this.handleDblClick(evt)
  } else {
    // Pan mode
    this.state = 'pan'
    this.firstEventCTM = this.viewport.getCTM()
    this.stateOrigin = SvgUtils.getEventPoint(evt, this.svg).matrixTransform(this.firstEventCTM.inverse())
  }
}

/**
 * Handle mouse move event
 *
 * @param  {Event} evt
 */
SvgPanZoom.prototype.handleMouseMove = function(evt) {
  if (this.options.preventMouseEventsDefault) {
    if (evt.preventDefault) {
      evt.preventDefault()
    } else {
      evt.returnValue = false
    }
  }

  if (this.state === 'pan' && this.options.panEnabled) {
    // Pan mode
    var point = SvgUtils.getEventPoint(evt, this.svg).matrixTransform(this.firstEventCTM.inverse())
      , viewportCTM = this.firstEventCTM.translate(point.x - this.stateOrigin.x, point.y - this.stateOrigin.y)

    this.viewport.setCTM(viewportCTM)
  }
}

/**
 * Handle mouse button release event
 *
 * @param {Event} evt
 */
SvgPanZoom.prototype.handleMouseUp = function(evt) {
  if (this.options.preventMouseEventsDefault) {
    if (evt.preventDefault) {
      evt.preventDefault()
    } else {
      evt.returnValue = false
    }
  }

  if (this.state === 'pan') {
    // Quit pan mode
    this.state = 'none'
  }
}

/**
 * Adjust viewport size (only) so it will fit in SVG
 * Does not center image
 */
SvgPanZoom.prototype.fit = function() {
  var viewBox = this.viewport.getViewBox()
    , newScale = Math.min(this.width/viewBox.width, this.height/viewBox.height)

  this.zoom(newScale, true)
}

/**
 * Adjust viewport size (only) so it will contain the SVG
 * Does not center image
 */
SvgPanZoom.prototype.contain = function() {
  var viewBox = this.viewport.getViewBox()
    , newScale = Math.max(this.width/viewBox.width, this.height/viewBox.height)

  this.zoom(newScale, true)
}

/**
 * Adjust viewport pan (only) so it will be centered in SVG
 * Does not zoom/fit/contain image
 */
SvgPanZoom.prototype.center = function() {
  var viewBox = this.viewport.getViewBox()
    , offsetX = (this.width - (viewBox.width + viewBox.x * 2) * this.getZoom()) * 0.5
    , offsetY = (this.height - (viewBox.height + viewBox.y * 2) * this.getZoom()) * 0.5

  this.getPublicInstance().pan({x: offsetX, y: offsetY})
}

/**
 * Update content cached BorderBox
 * Use when viewport contents change
 */
SvgPanZoom.prototype.updateBBox = function() {
  this.viewport.simpleViewBoxCache()
}

/**
 * Pan to a rendered position
 *
 * @param  {Object} point {x: 0, y: 0}
 */
SvgPanZoom.prototype.pan = function(point) {
  var viewportCTM = this.viewport.getCTM()
  viewportCTM.e = point.x
  viewportCTM.f = point.y
  this.viewport.setCTM(viewportCTM)
}

/**
 * Relatively pan the graph by a specified rendered position vector
 *
 * @param  {Object} point {x: 0, y: 0}
 */
SvgPanZoom.prototype.panBy = function(point) {
  var viewportCTM = this.viewport.getCTM()
  viewportCTM.e += point.x
  viewportCTM.f += point.y
  this.viewport.setCTM(viewportCTM)
}

/**
 * Get pan vector
 *
 * @return {Object} {x: 0, y: 0}
 */
SvgPanZoom.prototype.getPan = function() {
  var state = this.viewport.getState()

  return {x: state.x, y: state.y}
}

/**
 * Recalculates cached svg dimensions and controls position
 */
SvgPanZoom.prototype.resize = function() {
  // Get dimensions
  var boundingClientRectNormalized = SvgUtils.getBoundingClientRectNormalized(this.svg)
  this.width = boundingClientRectNormalized.width
  this.height = boundingClientRectNormalized.height

  // Recalculate original state
  var viewport = this.viewport
  viewport.options.width = this.width
  viewport.options.height = this.height
  viewport.processCTM()

  // Reposition control icons by re-enabling them
  if (this.options.controlIconsEnabled) {
    this.getPublicInstance().disableControlIcons()
    this.getPublicInstance().enableControlIcons()
  }
}

/**
 * Unbind mouse events, free callbacks and destroy public instance
 */
SvgPanZoom.prototype.destroy = function() {
  var that = this

  // Free callbacks
  this.beforeZoom = null
  this.onZoom = null
  this.beforePan = null
  this.onPan = null
  this.onUpdatedCTM = null

  // Destroy custom event handlers
  if (this.options.customEventsHandler != null) { // jshint ignore:line
    this.options.customEventsHandler.destroy({
      svgElement: this.svg
    , eventsListenerElement: this.options.eventsListenerElement
    , instance: this.getPublicInstance()
    })
  }

  // Unbind eventListeners
  for (var event in this.eventListeners) {
    (this.options.eventsListenerElement || this.svg)
      .removeEventListener(event, this.eventListeners[event], false)
  }

  // Unbind wheelListener
  this.disableMouseWheelZoom()

  // Remove control icons
  this.getPublicInstance().disableControlIcons()

  // Reset zoom and pan
  this.reset()

  // Remove instance from instancesStore
  instancesStore = instancesStore.filter(function(instance){
    return instance.svg !== that.svg
  })

  // Delete options and its contents
  delete this.options

  // Delete viewport to make public shadow viewport functions uncallable
  delete this.viewport

  // Destroy public instance and rewrite getPublicInstance
  delete this.publicInstance
  delete this.pi
  this.getPublicInstance = function(){
    return null
  }
}

/**
 * Returns a public instance object
 *
 * @return {Object} Public instance object
 */
SvgPanZoom.prototype.getPublicInstance = function() {
  var that = this

  // Create cache
  if (!this.publicInstance) {
    this.publicInstance = this.pi = {
      // Pan
      enablePan: function() {that.options.panEnabled = true; return that.pi}
    , disablePan: function() {that.options.panEnabled = false; return that.pi}
    , isPanEnabled: function() {return !!that.options.panEnabled}
    , pan: function(point) {that.pan(point); return that.pi}
    , panBy: function(point) {that.panBy(point); return that.pi}
    , getPan: function() {return that.getPan()}
      // Pan event
    , setBeforePan: function(fn) {that.options.beforePan = fn === null ? null : Utils.proxy(fn, that.publicInstance); return that.pi}
    , setOnPan: function(fn) {that.options.onPan = fn === null ? null : Utils.proxy(fn, that.publicInstance); return that.pi}
      // Zoom and Control Icons
    , enableZoom: function() {that.options.zoomEnabled = true; return that.pi}
    , disableZoom: function() {that.options.zoomEnabled = false; return that.pi}
    , isZoomEnabled: function() {return !!that.options.zoomEnabled}
    , enableControlIcons: function() {
        if (!that.options.controlIconsEnabled) {
          that.options.controlIconsEnabled = true
          ControlIcons.enable(that)
        }
        return that.pi
      }
    , disableControlIcons: function() {
        if (that.options.controlIconsEnabled) {
          that.options.controlIconsEnabled = false;
          ControlIcons.disable(that)
        }
        return that.pi
      }
    , isControlIconsEnabled: function() {return !!that.options.controlIconsEnabled}
      // Double click zoom
    , enableDblClickZoom: function() {that.options.dblClickZoomEnabled = true; return that.pi}
    , disableDblClickZoom: function() {that.options.dblClickZoomEnabled = false; return that.pi}
    , isDblClickZoomEnabled: function() {return !!that.options.dblClickZoomEnabled}
      // Mouse wheel zoom
    , enableMouseWheelZoom: function() {that.enableMouseWheelZoom(); return that.pi}
    , disableMouseWheelZoom: function() {that.disableMouseWheelZoom(); return that.pi}
    , isMouseWheelZoomEnabled: function() {return !!that.options.mouseWheelZoomEnabled}
      // Zoom scale and bounds
    , setZoomScaleSensitivity: function(scale) {that.options.zoomScaleSensitivity = scale; return that.pi}
    , setMinZoom: function(zoom) {that.options.minZoom = zoom; return that.pi}
    , setMaxZoom: function(zoom) {that.options.maxZoom = zoom; return that.pi}
      // Zoom event
    , setBeforeZoom: function(fn) {that.options.beforeZoom = fn === null ? null : Utils.proxy(fn, that.publicInstance); return that.pi}
    , setOnZoom: function(fn) {that.options.onZoom = fn === null ? null : Utils.proxy(fn, that.publicInstance); return that.pi}
      // Zooming
    , zoom: function(scale) {that.publicZoom(scale, true); return that.pi}
    , zoomBy: function(scale) {that.publicZoom(scale, false); return that.pi}
    , zoomAtPoint: function(scale, point) {that.publicZoomAtPoint(scale, point, true); return that.pi}
    , zoomAtPointBy: function(scale, point) {that.publicZoomAtPoint(scale, point, false); return that.pi}
    , zoomIn: function() {this.zoomBy(1 + that.options.zoomScaleSensitivity); return that.pi}
    , zoomOut: function() {this.zoomBy(1 / (1 + that.options.zoomScaleSensitivity)); return that.pi}
    , getZoom: function() {return that.getRelativeZoom()}
      // CTM update
    , setOnUpdatedCTM: function(fn) {that.options.onUpdatedCTM = fn === null ? null : Utils.proxy(fn, that.publicInstance); return that.pi}
      // Reset
    , resetZoom: function() {that.resetZoom(); return that.pi}
    , resetPan: function() {that.resetPan(); return that.pi}
    , reset: function() {that.reset(); return that.pi}
      // Fit, Contain and Center
    , fit: function() {that.fit(); return that.pi}
    , contain: function() {that.contain(); return that.pi}
    , center: function() {that.center(); return that.pi}
      // Size and Resize
    , updateBBox: function() {that.updateBBox(); return that.pi}
    , resize: function() {that.resize(); return that.pi}
    , getSizes: function() {
        return {
          width: that.width
        , height: that.height
        , realZoom: that.getZoom()
        , viewBox: that.viewport.getViewBox()
        }
      }
      // Destroy
    , destroy: function() {that.destroy(); return that.pi}
    }
  }

  return this.publicInstance
}

/**
 * Stores pairs of instances of SvgPanZoom and SVG
 * Each pair is represented by an object {svg: SVGSVGElement, instance: SvgPanZoom}
 *
 * @type {Array}
 */
var instancesStore = []

var svgPanZoom = function(elementOrSelector, options){
  var svg = Utils.getSvg(elementOrSelector)

  if (svg === null) {
    return null
  } else {
    // Look for existent instance
    for(var i = instancesStore.length - 1; i >= 0; i--) {
      if (instancesStore[i].svg === svg) {
        return instancesStore[i].instance.getPublicInstance()
      }
    }

    // If instance not found - create one
    instancesStore.push({
      svg: svg
    , instance: new SvgPanZoom(svg, options)
    })

    // Return just pushed instance
    return instancesStore[instancesStore.length - 1].instance.getPublicInstance()
  }
}

module.exports = svgPanZoom;


/***/ },
/* 230 */
/***/ function(module, exports) {

// uniwheel 0.1.2 (customized)
// A unified cross browser mouse wheel event handler
// https://github.com/teemualap/uniwheel

module.exports = (function(){

  //Full details: https://developer.mozilla.org/en-US/docs/Web/Reference/Events/wheel

  var prefix = "", _addEventListener, _removeEventListener, onwheel, support, fns = [];

  // detect event model
  if ( window.addEventListener ) {
    _addEventListener = "addEventListener";
    _removeEventListener = "removeEventListener";
  } else {
    _addEventListener = "attachEvent";
    _removeEventListener = "detachEvent";
    prefix = "on";
  }

  // detect available wheel event
  support = "onwheel" in document.createElement("div") ? "wheel" : // Modern browsers support "wheel"
            document.onmousewheel !== undefined ? "mousewheel" : // Webkit and IE support at least "mousewheel"
            "DOMMouseScroll"; // let's assume that remaining browsers are older Firefox


  function createCallback(element,callback,capture) {

    var fn = function(originalEvent) {

      !originalEvent && ( originalEvent = window.event );

      // create a normalized event object
      var event = {
        // keep a ref to the original event object
        originalEvent: originalEvent,
        target: originalEvent.target || originalEvent.srcElement,
        type: "wheel",
        deltaMode: originalEvent.type == "MozMousePixelScroll" ? 0 : 1,
        deltaX: 0,
        delatZ: 0,
        preventDefault: function() {
          originalEvent.preventDefault ?
            originalEvent.preventDefault() :
            originalEvent.returnValue = false;
        }
      };

      // calculate deltaY (and deltaX) according to the event
      if ( support == "mousewheel" ) {
        event.deltaY = - 1/40 * originalEvent.wheelDelta;
        // Webkit also support wheelDeltaX
        originalEvent.wheelDeltaX && ( event.deltaX = - 1/40 * originalEvent.wheelDeltaX );
      } else {
        event.deltaY = originalEvent.detail;
      }

      // it's time to fire the callback
      return callback( event );

    };

    fns.push({
      element: element,
      fn: fn,
      capture: capture
    });

    return fn;
  }

  function getCallback(element,capture) {
    for (var i = 0; i < fns.length; i++) {
      if (fns[i].element === element && fns[i].capture === capture) {
        return fns[i].fn;
      }
    }
    return function(){};
  }

  function removeCallback(element,capture) {
    for (var i = 0; i < fns.length; i++) {
      if (fns[i].element === element && fns[i].capture === capture) {
        return fns.splice(i,1);
      }
    }
  }

  function _addWheelListener( elem, eventName, callback, useCapture ) {

    var cb;

    if (support === "wheel") {
      cb = callback;
    } else {
      cb = createCallback(elem,callback,useCapture);
    }

    elem[ _addEventListener ]( prefix + eventName, cb, useCapture || false );

  }

  function _removeWheelListener( elem, eventName, callback, useCapture ) {

    var cb;

    if (support === "wheel") {
      cb = callback;
    } else {
      cb = getCallback(elem,useCapture);
    }

    elem[ _removeEventListener ]( prefix + eventName, cb, useCapture || false );

    removeCallback(elem,useCapture);

  }

  function addWheelListener( elem, callback, useCapture ) {
    _addWheelListener( elem, support, callback, useCapture );

    // handle MozMousePixelScroll in older Firefox
    if( support == "DOMMouseScroll" ) {
        _addWheelListener( elem, "MozMousePixelScroll", callback, useCapture);
    }
  }

  function removeWheelListener(elem,callback,useCapture){
    _removeWheelListener(elem,support,callback,useCapture);

    // handle MozMousePixelScroll in older Firefox
    if( support == "DOMMouseScroll" ) {
        _removeWheelListener(elem, "MozMousePixelScroll", callback, useCapture);
    }
  }

  return {
    on: addWheelListener,
    off: removeWheelListener
  };

})();


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(263),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(269),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(282),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(277),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(284),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(276),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(288),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(268),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(286),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(266),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(279),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(287),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(285),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(289),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(273),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(261),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(262),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(291),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(290),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(275),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(267),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(264),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(265),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(274),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(281),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(272),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(271),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(270),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ },
/* 261 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.movie) ? _c('div', {
    staticClass: "movie-detail"
  }, [_c('sk-panel', [_c('sk-layout', {
    class: (!_vm.$breakpoints.xs ? 'gutter-40' : ''),
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs5": "",
      "sm4": "",
      "md3": "",
      "lg2": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogActive = true
      }
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [(_vm.movie) ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.poster,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-icon', {
    staticClass: "movie-detail__poster-play",
    attrs: {
      "play": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.movie && _vm.movie.youtube_id) ? _c('sk-video', {
    staticClass: "dialog-video",
    attrs: {
      "content": _vm.movie.youtube_id
    },
    model: {
      value: (_vm.dialogActive),
      callback: function($$v) {
        _vm.dialogActive = $$v
      },
      expression: "dialogActive"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs7": "",
      "sm8": "",
      "md7": "",
      "lg8": ""
    }
  }, [_c('h3', {
    staticClass: "movie-detail__releasing"
  }, [(_vm.movie && _vm.movie.now_showing) ? [_vm._v("\n                        Now Showing\n                    ")] : (_vm.movie && _vm.movie.opening_date) ? [_vm._v("\n                        Releasing: " + _vm._s(_vm.movie.opening_date.additional.string_nth_day) + "\n                        " + _vm._s(_vm.movie.opening_date.additional.string_long_month) + " " + _vm._s(_vm.movie.opening_date.additional.year) + "\n                    ")] : _vm._e()], 2), _vm._v(" "), (_vm.movie && _vm.movie.title) ? _c('h1', {
    staticClass: "movie-detail__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.movie.title) + "\n\n                    "), _c('sk-social-share', {
    attrs: {
      "id": _vm.movie.id,
      "movie-title": _vm.movie.title,
      "twitter-text": "Let's go watch this movie at Ster-Kinekor!"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$breakpoints.xs) ? _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogActive = true
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "play-button": ""
    }
  }), _vm._v(" Play Trailer\n                ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs"
  }, [_c('div', {
    staticClass: "list-inline movie-detail__labels"
  }, [_c('span', {
    staticClass: "label label--invert"
  }, [_vm._v(_vm._s(_vm.movie.rating))]), _vm._v(" "), _vm._l((_vm.movie.genres), function(genre) {
    return _c('span', {
      key: genre.id
    }, [_vm._v(_vm._s(genre.name))])
  }), _vm._v(" "), _c('span', [_vm._v("• " + _vm._s(_vm.movie.runtime_hour_minute.hours + 'h') + " " + _vm._s(_vm.movie.runtime_hour_minute.minutes + 'm'))])], 2), _vm._v(" "), _c('div', {
    staticClass: "list-inline movie-detail__labels"
  }, [_vm._l((_vm.movie.experiences), function(experience) {
    return [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(experience))])]
  }), _vm._v(" "), _vm._l((_vm.movie.flags), function(flags) {
    return [_c('span', {
      staticClass: "label "
    }, [_vm._v(_vm._s(flags))])]
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "movie-detail__synopsis "
  }, [_vm._v("\n                        " + _vm._s(_vm._f("truncate")(_vm.movie.synopsis, _vm.truncAmount, '...')) + "\n\n                        "), (_vm.movie.synopsis.length >= _vm.truncAmount) ? _c('sk-button', {
    attrs: {
      "link": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.truncToggle($event.currentTarget)
      }
    }
  }, [_vm._v("\n                            Read more\n                        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.movie.cast.actors.length > 0) ? [_c('div', {
    staticClass: "list-inline white--text"
  }, [_c('span', [_vm._v("ACTORS: ")]), _vm._v(" "), _vm._l((_vm.movie.cast.actors), function(actor, index) {
    return _c('span', [_vm._v("\n                                " + _vm._s(actor.FirstName) + " " + _vm._s(actor.LastName) + "\n\n                                "), ((index + 1) < _vm.movie.cast.actors.length) ? _c('span', [_vm._v(",")]) : _vm._e()])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.movie.cast.directors.length > 0) ? [_c('div', {
    staticClass: "list-inline white--text"
  }, [_c('span', [_vm._v("DIRECTORS: ")]), _vm._v(" "), _vm._l((_vm.movie.cast.directors), function(director, index) {
    return _c('span', [_vm._v("\n                                " + _vm._s(director.FirstName) + " " + _vm._s(director.LastName) + "\n                                \n                                "), ((index + 1) < _vm.movie.cast.directors.length) ? _c('span', [_vm._v(",")]) : _vm._e()])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.buttons) ? _c('div', {
    staticClass: "movie-detail__buttons"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'Movie Details',
        params: {
          id: _vm.movie.id
        }
      }
    }
  }, [_vm._v("\n                            Book to win\n                        ")])], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('sk-spacer')], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "visible-xs"
  }, [_c('sk-spacer', {
    attrs: {
      "height": "20"
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "list-inline movie-detail__labels"
  }, [_c('span', {
    staticClass: "label label--invert"
  }, [_vm._v(_vm._s(_vm.movie.rating))]), _vm._v(" "), _vm._l((_vm.movie.genres), function(genre) {
    return _c('span', {
      key: genre.id
    }, [_vm._v(_vm._s(genre.name))])
  }), _vm._v(" "), _c('span', [_vm._v("• " + _vm._s(_vm.movie.runtime_hour_minute.hours) + "h " + _vm._s(_vm.movie.runtime_hour_minute.minutes) + "m")])], 2), _vm._v(" "), _c('div', {
    staticClass: "list-inline movie-detail__labels"
  }, [_vm._l((_vm.movie.experiences), function(experience) {
    return [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(experience))])]
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "movie-detail__synopsis"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("truncate")(_vm.movie.synopsis, _vm.truncAmount, '...')) + "\n\n                    "), (_vm.movie.synopsis.length >= _vm.truncAmount) ? _c('sk-button', {
    attrs: {
      "link": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.truncToggle($event.currentTarget)
      }
    }
  }, [_vm._v("\n                        Read more\n                    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.movie.cast.actors.length > 0) ? [_c('div', {
    staticClass: "list-inline white--text"
  }, [_c('span', [_vm._v("ACTORS: ")]), _vm._v(" "), _vm._l((_vm.movie.cast.actors), function(actor, index) {
    return _c('span', [_vm._v("\n                            " + _vm._s(actor.FirstName) + " " + _vm._s(actor.LastName) + "\n\n                            "), ((index + 1) < _vm.movie.cast.actors.length) ? _c('span', [_vm._v(",")]) : _vm._e()])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.movie.cast.directors.length > 0) ? [_c('div', {
    staticClass: "list-inline white--text"
  }, [_c('span', [_vm._v("DIRECTORS: ")]), _vm._v(" "), _vm._l((_vm.movie.cast.directors), function(director, index) {
    return _c('span', [_vm._v("\n                            " + _vm._s(director.FirstName) + " " + _vm._s(director.LastName) + "\n                            \n                            "), ((index + 1) < _vm.movie.cast.directors.length) ? _c('span', [_vm._v(",")]) : _vm._e()])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.buttons) ? _c('div', {
    staticClass: "movie-detail__buttons"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'Movie Details',
        params: {
          id: _vm.movie.id
        }
      }
    }
  }, [_vm._v("\n                        Book to win\n                    ")])], 1) : _vm._e()], 2)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ },
/* 262 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((typeof _vm.content === 'object') && _vm.content.images != undefined && _vm.content.images != null) ? _c('div', {
    class: _vm.classes
  }, [_c('div', [_c('div', {
    staticClass: "movie-thumbnail__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.content.images.standard.desktop.url,
      "alt": _vm.content.images.standard.desktop.alt
    }
  }), _vm._v(" "), (_vm.content.rating) ? _c('span', {
    staticClass: "label label--invert"
  }, [_vm._v(_vm._s(_vm.content.rating))]) : _vm._e()]), _vm._v(" "), (!_vm.hideCaption) ? _c('div', {
    staticClass: "movie-thumbnail__caption"
  }, [_vm._t("caption", [(_vm.content.opening_date.date._d > _vm.currentTimeStamp) ? _c('div', {
    staticStyle: {
      "width": "95%",
      "padding": "5px",
      "margin": "10px auto 3px",
      "background-color": "#007cbd",
      "color": "#ffffff",
      "text-align": "center"
    }
  }, [_vm._v("PRE-BOOK NOW")]) : _vm._e(), _vm._v(" "), (_vm.content.opening_date.date._d > _vm.currentTimeStamp) ? [_c('span', {
    staticClass: "caption__release"
  }, [_vm._v("\n\t\t\t\t\t\tReleases " + _vm._s(_vm.content.opening_date.additional.day) + " " + _vm._s(_vm.content.opening_date.additional.string_long_month) + "\n\t\t\t\t\t")])] : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "movie-thumbnail__title"
  }, [_vm._v(_vm._s(_vm.content.title))]), _vm._v(" "), _c('ul', {
    staticClass: "movie-thumbnail__subtitle"
  }, _vm._l((_vm.content.genres), function(genre) {
    return _c('li', [_vm._v(_vm._s(genre.name.toLowerCase()))])
  }))])], 2) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ },
/* 263 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carousel-wrapper"
  }, [_c('div', {
    staticClass: "carousel-slides-wrapper",
    style: (_vm.slideWrapperStyles),
    attrs: {
      "slidesWrapper": ""
    }
  }, [_vm._t("slides")], 2)]), _vm._v(" "), (_vm.wrap || _vm.currentSlideGroup > 0) ? _c('div', {
    staticClass: "control-btn control-btn-prev text-secondary bounce-h icon icon-arrow-left visible-sm visible-md visible-lg",
    on: {
      "click": function($event) {
        _vm.currentSlideGroup--
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.wrap || _vm.currentSlideGroup < _vm.numPages - 1) ? _c('div', {
    staticClass: "control-btn control-btn-next text-secondary bounce-h icon icon-arrow-right visible-sm visible-md visible-lg",
    on: {
      "click": function($event) {
        _vm.currentSlideGroup++
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageMarkers && _vm.numPages > 1) ? [_c('ul', {
    staticClass: "page-markers list-unstyled list-inline"
  }, _vm._l((_vm.numPages), function(i) {
    return _c('li', {
      staticClass: "page-marker",
      class: {
        active: _vm.currentSlideGroup == i - 1
      },
      on: {
        "click": function($event) {
          _vm.currentSlideGroup = i - 1
        }
      }
    })
  }))] : _vm._e(), _vm._v(" "), _vm._t("footer")], 2)
},staticRenderFns: []}

/***/ },
/* 264 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-list-item', [_c('sk-list-tile', [_vm._v(_vm._s(_vm.item))])], 1)
},staticRenderFns: []}

/***/ },
/* 265 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tabs",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "tabs__header"
  }, [_c('sk-list', {
    attrs: {
      "inline": ""
    }
  }, [_vm._t("tab-title")], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "tabs__content"
  }, [_vm._t("tab-content")], 2), _vm._v(" "), _c('div', {
    staticClass: "tabs__footer"
  }, [_vm._t("footer")], 2)])
},staticRenderFns: []}

/***/ },
/* 266 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.options,
      "group-values": "cinemas",
      "group-label": "name",
      "placeholder": "Cinemas",
      "label": "name",
      "track-by": "id",
      "selectLabel": "",
      "search": _vm.search,
      "deselectLabel": ""
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.$groupLabel) ? [_vm._v("\n                    " + _vm._s(props.option.$groupLabel) + "\n                ")] : [_c('span', {
          staticClass: "option__title",
          attrs: {
            "value": props.option.id
          }
        }, [_vm._v(_vm._s(props.option.name) + " "), (props.option.distance) ? [_vm._v("- " + _vm._s(props.option.distance) + "KM")] : _vm._e()], 2)]]
      }
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No Show Times found.")])])], 1)
},staticRenderFns: []}

/***/ },
/* 267 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-share"
  }, [_c('div', {
    attrs: {
      "id": "fb-root"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-reverse-transition"
    }
  }, [(!_vm.isActive) ? _c('div', {
    staticClass: "social-share__icon"
  }, [_c('sk-icon', {
    attrs: {
      "share": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isActive = true
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.isActive) ? _c('div', {
    staticClass: "social-share__buttons"
  }, [(_vm.$breakpoints.xs) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "no-gutter": "",
      "reverse": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.isActive = false
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "close": ""
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": ("https://www.facebook.com/sharer/sharer.php?u=" + _vm.url)
    }
  }, [_c('sk-icon', {
    attrs: {
      "facebook": ""
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": ("https://twitter.com/intent/tweet?url=" + _vm.url + "&text=" + _vm.twitterText)
    }
  }, [_c('sk-icon', {
    attrs: {
      "twitter": ""
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('a', {
    attrs: {
      "href": ("mailto:?subject=" + _vm.movieTitle + " at Ster-Kinekor&body=Let's go watch this movie " + _vm.url)
    }
  }, [_c('sk-icon', {
    attrs: {
      "email": ""
    }
  })], 1)])], 1)] : [_c('sk-layout', {
    attrs: {
      "row": "",
      "no-gutter": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.isActive = false
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "close": ""
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": ("https://www.facebook.com/sharer/sharer.php?u=" + _vm.url)
    }
  }, [_c('sk-icon', {
    attrs: {
      "facebook": ""
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": ("https://twitter.com/intent/tweet?url=" + _vm.url + "&text=" + _vm.twitterText)
    }
  }, [_c('sk-icon', {
    attrs: {
      "twitter": ""
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('a', {
    attrs: {
      "href": ("mailto:?subject=" + _vm.movieTitle + " at Ster-Kinekor&body=Let's go watch this movie " + _vm.url)
    }
  }, [_c('sk-icon', {
    attrs: {
      "email": ""
    }
  })], 1)])], 1)]], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ },
/* 268 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.form_group_classes
  }, [(_vm.label) ? _c('label', {
    attrs: {
      "for": _vm.control_id
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control-group",
    class: {
      'input-group': _vm.isGroup, 'type-password': _vm.isPassword
    },
    style: ({
      'height': _vm.height
    })
  }, [_c('input', _vm._b({
    ref: "controlEl",
    staticClass: "form-control",
    class: {
      'form-control--light': _vm.light
    },
    attrs: {
      "id": _vm.control_id,
      "type": _vm.type,
      "list": _vm.control_id,
      "aria-label": _vm.role ? _vm.role : false
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.onInput($event)
      },
      "focus": function($event) {
        _vm.onFocus($event)
      },
      "blur": function($event) {
        _vm.onBlur($event)
      },
      "invalid": function($event) {
        _vm.onInvalid($event)
      }
    }
  }, 'input', _vm.$attrs, false)), _vm._v(" "), (_vm.hasAppendContent) ? _c('div', {
    staticClass: "input-group-addon input-group-addon--append"
  }, [_vm._t("append")], 2) : _vm._e(), _vm._v(" "), (_vm.list) ? _c('datalist', {
    attrs: {
      "id": _vm.control_id
    }
  }, [_vm._t("datalist")], 2) : _vm._e(), _vm._v(" "), (_vm.hasPrependContent) ? _c('div', {
    staticClass: "input-group-addon input-group-addon--prepend"
  }, [_vm._t("prepend")], 2) : _vm._e(), _vm._v(" "), (_vm.show_error) ? _c('div', {
    staticClass: "form-group__validation-icon--error"
  }) : _vm._e(), _vm._v(" "), (_vm.isPassword) ? _c('div', {
    staticClass: "form-group__eye",
    on: {
      "click": _vm.togglePassword
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/password-eye.png",
      "alt": "All seeing EYE!"
    }
  })]) : _vm._e()]), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.hasHelpContent) ? _c('div', {
    staticClass: "form-group__help-text grey--text"
  }, [_vm._t("help")], 2) : _vm._e(), _vm._v(" "), (_vm.show_error) ? _c('div', {
    staticClass: "form-group__error"
  }, [_vm._t("error", [_vm._v("\n      " + _vm._s(_vm.errors[0]) + "\n    ")])], 2) : _vm._e(), _vm._v(" "), (_vm.hasStyledHelpContent) ? _c('div', {
    staticClass: "form-group__help-text styled grey--text"
  }, [_vm._t("helpStyled")], 2) : _vm._e()], 2)
},staticRenderFns: []}

/***/ },
/* 269 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "counter-box-wrapper"
  }, [(!_vm.smallCounter) ? _c('div', {
    staticClass: "counter-box"
  }, [_c('span', {
    staticClass: "counter-box__movie_info",
    class: (_vm.concession.movie && _vm.concession.movie.hasPromos) ? '' : ''
  }, [_c('sk-icon', {
    attrs: {
      "card-flip": ""
    }
  })], 1), _vm._v(" "), (_vm.concession.movie && _vm.concession.movie.hasPromos) ? _c('div', {
    staticClass: "counter-box__movie_image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.concession.movie.poster,
      "width": "100px",
      "height": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "counter-box__icon icon--large",
    class: _vm.classes
  }, [_c('i', {
    staticClass: "icon--large icon-combo"
  })]), _vm._v(" "), _c('div', {
    staticClass: "counter-box__back"
  }, [_vm._t("back", [
    [_vm._v("\n\t\t\t\t\tCoke & Popcorn\n\t\t\t\t")]
  ])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "counter-box__quantity"
  }, [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.selected > 0) ? _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "counter-box__quantity-icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.decrement($event)
      }
    }
  }, [_c('span', {
    staticClass: "counter-box__quantity-icon-decrement"
  }, [_vm._v("-")])])]) : _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "counter-box__quantity-icon"
  }, [_c('span', {
    staticClass: "counter-box__quantity-icon-decrement"
  }, [_vm._v("-")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [(!_vm.showRandValue) ? _c('div', {
    staticClass: "counter-box__quantity-number"
  }, [_vm._v(_vm._s(_vm.count))]) : _vm._e(), _vm._v(" "), (_vm.showRandValue) ? _c('div', {
    staticClass: "counter-box__quantity-number"
  }, [_vm._v("R" + _vm._s(((_vm.concession.PriceInCents / 100) * _vm.count).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')))]) : _vm._e()]), _vm._v(" "), (_vm.available > 0) ? _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "counter-box__quantity-icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.increment($event)
      }
    }
  }, [_c('span', {
    staticClass: "counter-box__quantity-icon-increment"
  }, [_vm._v("+")])])]) : _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "counter-box__quantity-icon"
  }, [_c('span', {
    staticClass: "counter-box__quantity-icon-increment"
  }, [_vm._v("+")])])])], 1)], 1), _vm._v(" "), _c('h6', {
    staticClass: "counter-box__name"
  }, [_vm._v(_vm._s(_vm.Description))])])
},staticRenderFns: []}

/***/ },
/* 270 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-dialog', {
    staticClass: "video",
    attrs: {
      "width": "80%",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": false
    },
    model: {
      value: (_vm.isActive),
      callback: function($$v) {
        _vm.isActive = $$v
      },
      expression: "isActive"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isActive = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isActive = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [(_vm.content) ? _c('iframe', {
    ref: "video",
    attrs: {
      "src": ("//www.youtube.com/embed/" + _vm.content),
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ },
/* 271 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside"
    }],
    class: _vm.classes
  }, [(_vm.actionText) ? [_c('sk-button', {
    staticClass: "tooltip-action-link btn--link",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isActive = true
      }
    }
  }, [_vm._v(_vm._s(_vm.actionText))])] : [_c('sk-icon', {
    attrs: {
      "questionMark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isActive = true
      }
    }
  })], _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isActive) ? _c('div', {
    staticClass: "tooltip-text",
    class: _vm.actionText ? 'action-text' : 'action-icon'
  }, [_c('div', [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('sk-icon', {
    staticClass: "tooltip-text--close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isActive = false
      }
    }
  })], 1) : _vm._e()])], 2)
},staticRenderFns: []}

/***/ },
/* 272 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title__wrapper",
    class: _vm.classes
  }, [(_vm.h1) ? _c('h1', {
    staticClass: "title__heading"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), (_vm.h2) ? _c('h2', {
    staticClass: "title__heading"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), (_vm.h3) ? _c('h3', {
    staticClass: "title__heading"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), (_vm.h4) ? _c('h4', {
    staticClass: "title__heading"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), (_vm.h5) ? _c('h5', {
    staticClass: "title__heading"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), (_vm.h6) ? _c('h6', {
    staticClass: "title__heading"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), (_vm.hasAppendContent) ? _c('div', {
    staticClass: "title__append list"
  }, [_vm._t("append")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ },
/* 273 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.form_group_classes
  }, [(_vm.label) ? _c('label', {
    attrs: {
      "for": _vm.control_id
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'input-group': _vm.isGroup
    },
    style: ({
      'height': _vm.height
    })
  }, [_c('textarea', _vm._b({
    ref: "controlEl",
    staticClass: "form-control",
    attrs: {
      "id": _vm.control_id,
      "rows": _vm.rows
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.onInput($event)
      },
      "focus": function($event) {
        _vm.onFocus($event)
      },
      "blur": function($event) {
        _vm.onBlur($event)
      },
      "invalid": function($event) {
        _vm.onInvalid($event)
      }
    }
  }, 'textarea', _vm.$attrs, false)), _vm._v(" "), (_vm.hasAppendContent) ? _c('div', {
    staticClass: "input-group-addon input-group-addon--append"
  }, [_vm._t("append")], 2) : _vm._e(), _vm._v(" "), (_vm.hasPrependContent) ? _c('div', {
    staticClass: "input-group-addon input-group-addon--prepend"
  }, [_vm._t("prepend")], 2) : _vm._e()]), _vm._v(" "), (_vm.hasHelpContent) ? _c('div', {
    staticClass: "form-group__help-text grey--text"
  }, [_vm._t("help")], 2) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.show_error) ? _c('div', {
    staticClass: "form-group__error"
  }, [_vm._v(_vm._s(_vm.errors[0]))]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ },
/* 274 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.ticketMovie) ? _c('div', {
    staticClass: "ticket-movie"
  }, [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', {
    staticClass: "movie-poster"
  }, [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', {
    staticClass: "movie-details"
  }, [_c('div', {
    staticClass: "movie-details--content"
  }, [_c('h3', {
    staticClass: "movie-name"
  }, [_vm._v(" ratione qui neque debitis.")]), _vm._v(" "), _c('p', [_vm._v("5 x Tickets")]), _vm._v(" "), _c('p', [_vm._v("Sandton City")]), _vm._v(" "), _c('p', [_vm._v("Today 5 August")]), _vm._v(" "), _c('p', [_vm._v("5:30 Pm - 7:00 PM")]), _vm._v(" "), _c('sk-button', {
    staticClass: "btn--link",
    attrs: {
      "tag": "a"
    }
  }, [_vm._v("\n                            See more\n                        ")])], 1)])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('div', {
    staticClass: "remove-icon"
  }, [_c('span', {
    staticClass: "line",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        (_vm.ticketMovie = false)
      }
    }
  })])])], 1)], 1) : _vm._e()])
},staticRenderFns: []}

/***/ },
/* 275 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quantity"
  }, [_c('p', [_vm._v("hey there im quantity")])])
}]}

/***/ },
/* 276 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.reseting) ? _c('form', {
    class: _vm.classes,
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}

/***/ },
/* 277 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox",
    class: _vm.form_group_classes
  }, [_c('input', _vm._b({
    ref: "controlEl",
    staticClass: "form-control ",
    attrs: {
      "id": _vm.control_id,
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": function($event) {
        _vm.onChange($event)
      },
      "blur": function($event) {
        _vm.onBlur($event)
      },
      "invalid": function($event) {
        _vm.onInvalid($event)
      }
    }
  }, 'input', _vm.$attrs, false)), _vm._v(" "), (_vm.label) ? _c('label', {
    attrs: {
      "for": _vm.control_id
    }
  }, [_vm._t("label", [_vm._v(_vm._s(_vm.label))])], 2) : _vm._e(), _vm._v(" "), (_vm.hasAppendContent) ? _c('div', {
    staticClass: "input-group-addon input-group-addon--append"
  }, [_vm._t("append")], 2) : _vm._e(), _vm._v(" "), (_vm.hasPrependContent) ? _c('div', {
    staticClass: "input-group-addon input-group-addon--prepend"
  }, [_vm._t("prepend")], 2) : _vm._e(), _vm._v(" "), (_vm.show_error) ? _c('div', {
    staticClass: "form-group__error"
  }, [_vm._v(_vm._s(_vm.errors[0]))]) : _vm._e()])
},staticRenderFns: []}

/***/ },
/* 278 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {}, [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('div', {
    staticClass: "ticket-description"
  }, [_vm._t("description")], 2)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('div', {
    staticClass: "ticket-description"
  }, [_vm._t("amount")], 2)])], 1)], 1)])
},staticRenderFns: []}

/***/ },
/* 279 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.options,
      "multiple": false,
      "group-values": "items",
      "group-label": "name",
      "placeholder": "Show Time",
      "label": "range",
      "track-by": "id",
      "selectLabel": "",
      "search": _vm.search,
      "deselectLabel": ""
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.$groupLabel) ? [_vm._v("\n                    " + _vm._s(props.option.$groupLabel) + "\n                ")] : [_c('span', {
          staticClass: "option__title",
          class: {
            'time': props.option.range
          }
        }, [_vm._v(_vm._s(props.option.range))])]]
      }
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No Show Times found.")])])], 1)
},staticRenderFns: []}

/***/ },
/* 280 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: _vm.classes
  })
},staticRenderFns: []}

/***/ },
/* 281 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs9": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "ticket-description"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.ticketObj.Quantity || 1) + "x " + _vm._s(_vm.ticketType || '-') + "\n\t\t")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "ticket-price"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.priceString) + "\n\t\t")])])], 1)
},staticRenderFns: []}

/***/ },
/* 282 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "counter-box-wrapper"
  }, [(!_vm.smallCounter) ? _c('div', {
    staticClass: "counter-box"
  }, [_c('span', {
    staticClass: "counter-box__movie_info",
    class: (_vm.concession.movie && _vm.concession.movie.hasPromos) ? '' : ''
  }, [_c('sk-icon', {
    attrs: {
      "card-flip": ""
    }
  })], 1), _vm._v(" "), (_vm.concession.movie && _vm.concession.movie.hasPromos) ? _c('div', {
    staticClass: "counter-box__movie_image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.concession.movie.poster
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "counter-box__icon",
    class: _vm.classes
  }, [_c('sk-icon', {
    attrs: {
      "type": _vm.type
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "counter-box__back"
  }, [_vm._t("back", [(_vm.concession.ExtendedDescription) ? [_vm._v(_vm._s(_vm.concession.ExtendedDescription))] : [_vm._v(_vm._s(_vm.concession.Description))]])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "counter-box__quantity"
  }, [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "counter-box__quantity-icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.decrement($event)
      }
    }
  }, [_c('span', {
    staticClass: "counter-box__quantity-icon-decrement"
  }, [_vm._v("-")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [(!_vm.showRandValue) ? _c('div', {
    staticClass: "counter-box__quantity-number"
  }, [_vm._v(_vm._s(_vm.count))]) : _vm._e(), _vm._v(" "), (_vm.showRandValue) ? _c('div', {
    staticClass: "counter-box__quantity-number"
  }, [_vm._v("R" + _vm._s(((_vm.concession.PriceInCents / 100) * _vm.count).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')))]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "counter-box__quantity-icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.increment($event)
      }
    }
  }, [_c('span', {
    staticClass: "counter-box__quantity-icon-increment"
  }, [_vm._v("+")])])])], 1)], 1), _vm._v(" "), (!_vm.showRandValue) ? _c('h6', {
    staticClass: "counter-box__name"
  }, [(!_vm.concession.cmsData) ? [_vm._v(_vm._s(_vm.concession.Description))] : [_vm._v(_vm._s(_vm.concession.cmsData.title))]], 2) : _vm._e(), _vm._v(" "), (!_vm.showRandValue) ? _c('p', {
    staticClass: "counter-box__price"
  }, [_vm._v("R" + _vm._s((_vm.concession.PriceInCents / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')))]) : _vm._e()])
},staticRenderFns: []}

/***/ },
/* 283 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-snackbar', {
    attrs: {
      "top": _vm.top,
      "fixed": _vm.fixed,
      "multi-line": "",
      "fullwidth": _vm.fullwidth,
      "timeout": _vm.timeout
    },
    model: {
      value: (_vm.isActive),
      callback: function($$v) {
        _vm.isActive = $$v
      },
      expression: "isActive"
    }
  }, [_c('sk-container', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs10": "",
      "grow": ""
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]), _vm._v(" "), (!_vm.timeout || _vm.dismissable) ? _c('sk-flex', {
    staticClass: "text-right",
    attrs: {
      "xs2": ""
    }
  }, [(_vm.dismissable) ? _c('sk-button', {
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isActive = false
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "close": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "close_text"
  }, [_vm._v("Close")])], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ },
/* 284 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.deactivate),
      expression: "deactivate"
    }]
  }, [(!_vm.$breakpoints.xs) ? [_c('div', {
    staticClass: "comboselect",
    class: {
      'comboselect--active': _vm.isOpen, 'comboselect--disabled': _vm.disabled, 'comboselect--above': _vm.isAbove, 'has-error': _vm.showError
    },
    attrs: {
      "tabindex": _vm.tabindex
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activate()
      },
      "blur": function($event) {
        _vm.searchable ? false : _vm.deactivate()
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key)) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.pointerForward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key)) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.pointerBackward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key) && _vm._k($event.keyCode, "tab", 9, $event.key)) { return null; }
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.addPointerElement($event)
      }],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key)) { return null; }
        _vm.deactivate()
      }
    }
  }, [(_vm.required) ? _c('sk-input', {
    staticClass: "hidden",
    attrs: {
      "title": _vm.validationValue,
      "type": "text",
      "required": ""
    },
    on: {
      "showerror": function($event) {
        _vm.showError = $event
      }
    },
    model: {
      value: (_vm.validationValue),
      callback: function($$v) {
        _vm.validationValue = $$v
      },
      expression: "validationValue"
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("carret", [_c('div', {
    staticClass: "comboselect__select",
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  })]), _vm._v(" "), _vm._t("clear", null, {
    search: _vm.search
  }), _vm._v(" "), _c('div', {
    ref: "tags",
    staticClass: "comboselect__tags"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visibleValue.length > 0),
      expression: "visibleValue.length > 0"
    }],
    staticClass: "comboselect__tags-wrap"
  }, [_vm._l((_vm.visibleValue), function(option) {
    return [_vm._t("tag", [_c('span', {
      staticClass: "comboselect__tag"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.getOptionLabel(option))
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "comboselect__tag-icon",
      attrs: {
        "aria-hidden": "true",
        "tabindex": "1"
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
          $event.preventDefault();
          _vm.removeElement(option)
        },
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.removeElement(option)
        }
      }
    })])], {
      option: option,
      search: _vm.search,
      remove: _vm.removeElement
    })]
  })], 2), _vm._v(" "), (_vm.internalValue && _vm.internalValue.length > _vm.limit) ? [_c('strong', {
    staticClass: "comboselect__strong",
    domProps: {
      "textContent": _vm._s(_vm.limitText(_vm.internalValue.length - _vm.limit))
    }
  })] : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "comboselect__loading"
    }
  }, [_vm._t("loading", [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "comboselect__spinner"
  })])], 2), _vm._v(" "), (_vm.searchable) ? _c('input', {
    ref: "search",
    staticClass: "comboselect__input",
    style: (_vm.inputStyle),
    attrs: {
      "name": _vm.name,
      "id": _vm.id,
      "type": "text",
      "autocomplete": "off",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.isOpen ? _vm.search : _vm.currentOptionLabel
    },
    on: {
      "input": function($event) {
        _vm.updateSearch($event.target.value)
      },
      "focus": function($event) {
        $event.preventDefault();
        _vm.activate()
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key)) { return null; }
        _vm.deactivate()
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key)) { return null; }
        $event.preventDefault();
        _vm.pointerForward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key)) { return null; }
        $event.preventDefault();
        _vm.pointerBackward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.addPointerElement($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key)) { return null; }
        $event.stopPropagation();
        _vm.removeLastElement()
      }]
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.searchable) ? _c('span', {
    staticClass: "comboselect__single"
  }, [_vm._t("preLabel", null, {
    option: _vm.internalValue
  }), _vm._v("\n                    " + _vm._s(_vm.currentOptionLabel) + "\n                ")], 2) : _vm._e()], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "comboselect"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    ref: "list",
    staticClass: "comboselect__content-wrapper",
    style: ({
      maxHeight: _vm.optimizedHeight + 'px'
    })
  }, [_vm._t("beforeList"), _vm._v(" "), _c('ul', {
    staticClass: "comboselect__content",
    style: (_vm.contentStyle)
  }, [(_vm.multiple && _vm.max === _vm.internalValue.length) ? _c('li', [_c('span', {
    staticClass: "comboselect__option"
  }, [_vm._t("maxElements", [_vm._v("Maximum of " + _vm._s(_vm.max) + " options selected. First remove a selected option to select another.")])], 2)]) : _vm._e(), _vm._v(" "), (!_vm.max || _vm.internalValue.length < _vm.max) ? _vm._l((_vm.filteredOptions), function(option, index) {
    return _c('li', {
      key: index,
      staticClass: "comboselect__element",
      class: (_vm.groupValues ? 'comboselect__element--grouped' : '')
    }, [(!(option && (option.$isLabel || option.$isDisabled))) ? _c('span', {
      staticClass: "comboselect__option",
      class: _vm.optionHighlight(index, option),
      attrs: {
        "data-select": option && option.isTag ? _vm.tagPlaceholder : _vm.selectLabelText,
        "data-selected": _vm.selectedLabelText,
        "data-deselect": _vm.deselectLabelText
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.select(option)
        },
        "mouseenter": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.pointerSet(index)
        }
      }
    }, [_vm._t("option", [_c('span', {
      staticClass: "option__title"
    }, [_vm._v(_vm._s(_vm.getOptionLabel(option)))])], {
      option: option,
      search: _vm.search
    })], 2) : _vm._e(), _vm._v(" "), (option && (option.$isLabel || option.$isDisabled)) ? _c('span', {
      staticClass: "comboselect__option comboselect__option--disabled",
      class: _vm.optionHighlight(index, option)
    }, [_vm._t("option", [_c('span', [_vm._v(_vm._s(_vm.getOptionLabel(option)))])], {
      option: option,
      search: _vm.search
    })], 2) : _vm._e()])
  }) : _vm._e(), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNoResults && (_vm.filteredOptions.length === 0 && _vm.search && !_vm.loading)),
      expression: "showNoResults && (filteredOptions.length === 0 && search && !loading)"
    }]
  }, [_c('span', {
    staticClass: "comboselect__option"
  }, [_vm._t("noResult", [_vm._v("No elements found. Consider changing the search query.")])], 2)]), _vm._v(" "), _vm._t("afterList")], 2)], 2)])], 2), _vm._v(" "), (_vm.showError) ? _c('div', {
    staticClass: "form-group__error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()] : [_c('sk-select', {
    attrs: {
      "label": _vm.placeholder,
      "multiple": _vm.multiple,
      "tabIndex": "0",
      "required": _vm.required
    },
    on: {
      "input": function($event) {
        _vm.select(_vm.tempVal, 'mobile')
      }
    },
    model: {
      value: (_vm.tempVal),
      callback: function($$v) {
        _vm.tempVal = $$v
      },
      expression: "tempVal"
    }
  }, [_vm._l((_vm.filteredOptions), function(group, index) {
    return (_vm.filteredOptions.length > 1) ? _c('optgroup', {
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.items), function(option, index) {
      return _c('option', {
        domProps: {
          "value": option
        }
      }, [(option.range) ? [_vm._v(_vm._s(option.range))] : _vm._e(), _vm._v(" "), (option.name) ? [_vm._v(_vm._s(option.name))] : _vm._e(), _vm._v(" "), (option.title) ? [_vm._v(_vm._s(option.title))] : _vm._e(), _vm._v(" "), (option.distance) ? _c('span', [_vm._v(" - " + _vm._s(option.distance) + "km")]) : _vm._e()], 2)
    })) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.filteredOptions), function(option, index) {
    return (_vm.filteredOptions.length === 1) ? [_c('option', {
      attrs: {
        "disabled": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.placeholder))]), _vm._v(" "), _vm._l((option.items), function(item, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": item
        }
      }, [_vm._v(_vm._s(_vm.getOptionLabel(item)))])
    })] : _vm._e()
  })], 2)]], 2)
},staticRenderFns: []}

/***/ },
/* 285 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio",
    class: _vm.form_group_classes
  }, [_c('input', _vm._b({
    ref: "controlEl",
    staticClass: "form-control",
    attrs: {
      "id": _vm.control_id,
      "type": "radio"
    },
    domProps: {
      "checked": _vm.checked
    },
    on: {
      "change": function($event) {
        _vm.onChange($event)
      },
      "blur": function($event) {
        _vm.onBlur($event)
      },
      "invalid": function($event) {
        _vm.onInvalid($event)
      }
    }
  }, 'input', _vm.$attrs, false)), _vm._v(" "), (_vm.label) ? _c('label', {
    attrs: {
      "for": _vm.control_id
    }
  }, [_vm._t("label", [_vm._v(_vm._s(_vm.label))])], 2) : _vm._e(), _vm._v(" "), (_vm.hasAppendContent) ? _c('div', {
    staticClass: "input-group-addon input-group-addon--append"
  }, [_vm._t("append")], 2) : _vm._e(), _vm._v(" "), (_vm.hasHelpContent) ? _c('div', {
    staticClass: "form_group__help-text grey--text"
  }, [_vm._t("help")], 2) : _vm._e(), _vm._v(" "), (_vm.show_error) ? _c('div', {
    staticClass: "form-group__error"
  }, [_vm._v(_vm._s(_vm.errors[0]))]) : _vm._e()])
},staticRenderFns: []}

/***/ },
/* 286 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.items,
      "multiple": _vm.multiple,
      "group-values": "items",
      "group-label": "label",
      "placeholder": "Genres",
      "label": "name",
      "track-by": "id",
      "selectLabel": "",
      "deselectLabel": ""
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.$groupLabel) ? [_vm._v("\n                    " + _vm._s(props.option.$groupLabel) + "\n                ")] : [_c('span', {
          staticClass: "option__title",
          attrs: {
            "value": props.option.id
          }
        }, [_vm._v(_vm._s(props.option.name))])]]
      }
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Consider changing the search query.")])])], 1)
},staticRenderFns: []}

/***/ },
/* 287 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.items,
      "multiple": _vm.multiple,
      "group-values": "items",
      "group-label": "label",
      "placeholder": "Cinema Type",
      "label": "name",
      "track-by": "name",
      "selectLabel": "",
      "deselectLabel": ""
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.$groupLabel) ? [_vm._v("\n                    " + _vm._s(props.option.$groupLabel) + "\n                ")] : [_c('span', {
          staticClass: "option__title",
          attrs: {
            "value": props.option.id
          }
        }, [_vm._v(_vm._s(props.option.name))])]]
      }
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Consider changing the search query.")])])], 1)
},staticRenderFns: []}

/***/ },
/* 288 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sk-dialog', {
    staticClass: "video",
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.noLocation),
      callback: function($$v) {
        _vm.noLocation = $$v
      },
      expression: "noLocation"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.noLocation = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.noLocation = false
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("We can't find you!")]), _vm._v(" "), _c('p', [_vm._v("We can't get your location - either your broswer does not support this or you have blocked location services for us.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.noLocation = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), (_vm.pinOnly) ? [_c('div', {
    staticClass: "location-pin",
    attrs: {
      "title": "Use my current location"
    },
    on: {
      "click": _vm.findUserLocation
    }
  }, [(_vm.geolocationInProgress) ? _c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "15"
    }
  }) : _c('sk-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.geolocation),
      expression: "geolocation"
    }],
    attrs: {
      "location-pin": ""
    }
  }), _vm._v(" "), (_vm.$breakpoints.xs) ? _c('span', [_vm._v("\n        Use my current location\n      ")]) : _vm._e()], 1)] : [_c('sk-input', _vm._b({
    attrs: {
      "value": _vm.value,
      "name": "location-search",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      },
      "focus": function($event) {
        $event.controlEl.select()
      },
      "blur": function($event) {
        _vm.$emit('blur', $event)
      }
    }
  }, 'sk-input', _vm.$attrs, false), [_c('sk-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.geolocation),
      expression: "geolocation"
    }],
    attrs: {
      "slot": "append",
      "location-pin": "",
      "title": "Use my current location"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.findUserLocation($event)
      }
    },
    slot: "append"
  }, [(_vm.geolocationInProgress) ? _c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "24"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "form-group__error"
  }, [(_vm.error.code === 'PLACE_RESULT_NOT_SELECTED') ? [_vm._v("\n          You must choose an item from the dropdown list.\n        ")] : (_vm.error.code === 'NON_STREET_ADDRESS') ? [_vm._v("\n          The chicken doesn't know which road to cross. Please enter a valid street address (number, street, suburb).\n        ")] : _vm._e()], 2) : _vm._e()], 1)]], 2)
},staticRenderFns: []}

/***/ },
/* 289 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select",
    class: _vm.form_group_classes
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.hasHelpContent) ? [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "select-wrapper",
    class: {
      'select-wrapper--multiple': _vm.multiple
    }
  }, [_c('select', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    ref: "controlEl",
    staticClass: "form-control",
    attrs: {
      "id": _vm.control_id,
      "multiple": _vm.multiple
    },
    on: {
      "blur": function($event) {
        _vm.onBlur($event)
      },
      "invalid": function($event) {
        _vm.onInvalid($event)
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, 'select', _vm.$attrs, false), [_vm._t("default")], 2), _vm._v(" "), (_vm.label) ? _c('label', {
    ref: "labelEl",
    attrs: {
      "for": _vm.control_id
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(_vm.hasHelpContent) ? _c('div', {
    staticClass: "form_group__help-text grey--text"
  }, [_vm._t("help")], 2) : _vm._e()])] : [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "select-wrapper",
    class: {
      'select-wrapper--multiple': _vm.multiple
    }
  }, [_c('select', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    ref: "controlEl",
    staticClass: "form-control",
    attrs: {
      "id": _vm.control_id,
      "multiple": _vm.multiple
    },
    on: {
      "blur": function($event) {
        _vm.onBlur($event)
      },
      "invalid": function($event) {
        _vm.onInvalid($event)
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, 'select', _vm.$attrs, false), [_vm._t("default")], 2), _vm._v(" "), (_vm.label) ? _c('label', {
    ref: "labelEl",
    attrs: {
      "for": _vm.control_id
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()])])]], 2), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.show_error) ? _c('div', {
    staticClass: "form-group__error"
  }, [_vm._v(_vm._s(_vm.errors[0]))]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}

/***/ },
/* 290 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-linear",
    class: _vm.classes,
    style: ({
      height: _vm.height + 'px'
    })
  }, [_c('div', {
    staticClass: "progress-linear__bar",
    style: (_vm.styles)
  }, [_c('sk-fade-transition', [(_vm.indeterminate) ? _c('div', {
    staticClass: "progress-linear__bar__indeterminate"
  }) : _vm._e()]), _vm._v(" "), _c('sk-slide-x-transition', [(!_vm.indeterminate) ? _c('div', {
    staticClass: "progress-linear__bar__determinate",
    style: ({
      width: _vm.value + '%'
    })
  }) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ },
/* 291 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-circular",
    class: _vm.classes,
    style: (_vm.styles)
  }, [_c('svg', {
    style: (_vm.svgStyles),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "height": _vm.svgSize,
      "width": _vm.svgSize,
      "viewBox": _vm.viewBox
    }
  }, [(!_vm.indeterminate) ? _c('circle', {
    staticClass: "progress-circular__underlay",
    attrs: {
      "fill": "transparent",
      "cx": _vm.cxy,
      "cy": _vm.cxy,
      "r": _vm.radius,
      "stroke-width": _vm.width,
      "stroke-dasharray": _vm.strokeDashArray,
      "stroke-dashoffset": 0
    }
  }) : _vm._e(), _vm._v(" "), _c('circle', {
    staticClass: "progress-circular__overlay",
    attrs: {
      "fill": _vm.fill,
      "cx": _vm.cxy,
      "cy": _vm.cxy,
      "r": _vm.radius,
      "stroke-width": _vm.width,
      "stroke-dasharray": _vm.strokeDashArray,
      "stroke-dashoffset": _vm.strokeDashOffset
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "progress-circular__info"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ },
/* 292 */
/***/ function(module, exports) {

module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 293 */
/***/ function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			configurable: false,
			get: function() { return module.l; }
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			configurable: false,
			get: function() { return module.i; }
		});
		module.webpackPolyfill = 1;
	}
	return module;
}


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filters__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_breakpoints_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_toaster_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(136);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "Utils", function() { return __WEBPACK_IMPORTED_MODULE_5__utils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "Toaster", function() { return __WEBPACK_IMPORTED_MODULE_4__plugins_toaster_js__["a"]; });
__webpack_require__(137)










/* harmony default export */ exports["default"] = function (Vue) {

  Object.keys(__WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */]).forEach(function (key) {
    Vue.component(("Sk" + key), __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */][key])
  })

  Object.keys(__WEBPACK_IMPORTED_MODULE_1__directives__["a" /* default */]).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_1__directives__["a" /* default */][key])
  })

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__filters__["a" /* default */]).forEach(function (key) {
    Vue.filter(key, __WEBPACK_IMPORTED_MODULE_2__filters__["a" /* default */][key])
  })


  // Install our breakpoints plugin
  Vue.use(__WEBPACK_IMPORTED_MODULE_3__plugins_breakpoints_js__["a" /* default */])

  // Install our toast plugin
  Vue.use(__WEBPACK_IMPORTED_MODULE_4__plugins_toaster_js__["a" /* default */])

};


/***/ }
/******/ ]);
});

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interceptors__ = __webpack_require__(461);



var TOKEN_MIN_VALIDITY_BEFORE_REFRESH = 3 * 60 * 1000;

var ApiHttp = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create();

__WEBPACK_IMPORTED_MODULE_1__Interceptors__["a" /* default */].start(ApiHttp);

var in_flight_get_requests = new Map();
var _get = ApiHttp.get;

function formatPromise(request) {

    return request.then(function (response) {
        var newResponse = response && response.data ? response.data : {};
        newResponse.request = response.request;
        newResponse.config = response.config;
        return newResponse;
    }, function (e) {

        var newResponse = e.request && e.request.response ? JSON.parse(e.request.response) : e;
        try {
            newResponse.httpResponse = e.response;
        } catch (e) {}
        return Promise.reject(newResponse);
    });
}

ApiHttp.get = function (url, _filters) {
    var external = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!~url.indexOf(ApiHttp.defaults.baseURL) && !external) {
        url = '' + ApiHttp.defaults.baseURL + url;
    }
    var key = url;
    var filters = _filters && _filters.filters ? { params: _filters.filters } : _filters;
    if (in_flight_get_requests.has(key)) {
        return in_flight_get_requests.get(key);
    } else {
        var request = _get(url, filters);
        in_flight_get_requests.set(key, request);

        request.then(function () {
            in_flight_get_requests.clear(key);
        }).catch(function () {
            return in_flight_get_requests.clear(key);
        });

        return formatPromise(request);
    }
};

ApiHttp.getBaseLink = function (url, _filters) {
    var external = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!~url.indexOf(ApiHttp.defaults.baseLinkURL) && !external) {
        url = '' + ApiHttp.defaults.baseLinkURL + url;
    }
    var key = url;
    var filters = _filters && _filters.filters ? { params: _filters.filters } : _filters;
    if (in_flight_get_requests.has(key)) {
        return in_flight_get_requests.get(key);
    } else {
        var request = _get(url, filters);
        in_flight_get_requests.set(key, request);

        request.then(function () {
            in_flight_get_requests.clear(key);
        }).catch(function () {
            return in_flight_get_requests.clear(key);
        });

        return formatPromise(request);
    }
};

var _post = ApiHttp.post;

ApiHttp.post = function (url, _filters) {
    var external = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!~url.indexOf(ApiHttp.defaults.baseURL) && !external) {
        url = '' + ApiHttp.defaults.baseURL + url;
    }

    var request = _post(url, _filters);

    return formatPromise(request);
};

var _put = ApiHttp.put;

ApiHttp.put = function (url, _filters) {
    var external = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!~url.indexOf(ApiHttp.defaults.baseURL) && !external) {
        url = '' + ApiHttp.defaults.baseURL + url;
    }
    var request = _put(url, _filters);

    return formatPromise(request);
};

var _delete = ApiHttp.delete;

ApiHttp.delete = function (url, _filters) {
    var external = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!~url.indexOf(ApiHttp.defaults.baseURL) && !external) {
        url = '' + ApiHttp.defaults.baseURL + url;
    }

    var request = _delete(url, _filters);

    return formatPromise(request);
};

/* harmony default export */ __webpack_exports__["a"] = (ApiHttp);

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModelArray = function (_Array) {
    _inherits(ModelArray, _Array);

    function ModelArray() {
        var _ref;

        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var Model = arguments[1];

        _classCallCheck(this, ModelArray);

        var models = data && typeof data.map === 'function' ? data.map(function (d) {
            return !(d instanceof Model) ? new Model(d) : d;
        }) : [];
        return _possibleConstructorReturn(this, (_ref = ModelArray.__proto__ || Object.getPrototypeOf(ModelArray)).call.apply(_ref, [this].concat(_toConsumableArray(models))));
    }

    return ModelArray;
}(Array);

/* harmony default export */ __webpack_exports__["a"] = (ModelArray);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(98);
var isBuffer = __webpack_require__(444);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_model_BaseModel__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_model_Movies__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_model_Regions__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_model_MovieImage__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_model_VistaDate__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_model_Cinema__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_model_Genre__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_model_Flag__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_model_Experience__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_model_Seat__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_model_MovieSession__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_model_User__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_model_SeatGroups__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_model_ConcessionItem__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_model_Ticket__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_model_Transaction__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_model_LoyaltyCard__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_model_FeaturedContent__ = __webpack_require__(230);
/* unused harmony reexport BaseModel */
/* unused harmony reexport Movie */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__src_model_Movies__["b"]; });
/* unused harmony reexport Region */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__src_model_Regions__["a"]; });
/* unused harmony reexport VistaDate */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__src_model_Genre__["a"]; });
/* unused harmony reexport MovieImage */
/* unused harmony reexport Cinema */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__src_model_Flag__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__src_model_Seat__["a"]; });
/* unused harmony reexport SeatGroup */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_12__src_model_SeatGroups__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__src_model_Experience__["a"]; });
/* unused harmony reexport MovieSession */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_11__src_model_User__["a"]; });
/* unused harmony reexport ConcessionItem */
/* unused harmony reexport Ticket */
/* unused harmony reexport Transaction */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_16__src_model_LoyaltyCard__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_17__src_model_FeaturedContent__["a"]; });




















/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var MovieService = function () {
    function MovieService() {
        _classCallCheck(this, MovieService);

        this.movies = undefined;
        this.sessions = undefined;
        this.filters = undefined;
        this.movieSessions = undefined;
    }

    _createClass(MovieService, [{
        key: 'getMovieDetail',
        value: function getMovieDetail(id) {
            var withRelated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return this.getMovies().then(function (movies) {
                var movie = movies.findById(id);
                return withRelated ? { movie: movie, related: movies.related(movie) } : movie;
            });
        }
    }, {
        key: 'getPrerenderedMovieDetails',
        value: function getPrerenderedMovieDetails(movies, id) {
            var withRelated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var movie = movies.findById(id);
            return withRelated ? { movie: movie, related: movies.related(movie) } : movie;
        }
    }, {
        key: 'findBySessionId',
        value: function findBySessionId(SessionId, CinemaId) {
            return this.getMovies().then(function (movies) {
                var movie = movies.findBySessionId(SessionId, CinemaId);
                return movie;
            });
        }
    }, {
        key: 'findByName',
        value: function findByName(Name) {
            return this.getMovies().then(function (movies) {
                var movie = movies.findByName(Name);
                return movie;
            });
        }
    }, {
        key: 'findById',
        value: function findById(Id) {
            return this.getMovies().then(function (movies) {
                var movie = movies.findById(Id);
                return movie;
            });
        }
    }, {
        key: 'setPreRenderMovies',
        value: function setPreRenderMovies(movies) {
            if (movies && movies != undefined) {
                this.sessions = movies.sessions;
                this.movies = new __WEBPACK_IMPORTED_MODULE_1__model__["f" /* Movies */](movies.movies);
            } else {
                this.movies = undefined;
            }

            return this.movies;
        }
    }, {
        key: 'getMovies',
        value: function getMovies() {
            var _this = this;

            var noCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this.movies = this.movies || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/movies' + (noCache ? '?noCache=' + noCache : '')).then(function (response) {
                _this.sessions = response.data.sessions;
                return new __WEBPACK_IMPORTED_MODULE_1__model__["f" /* Movies */](response.data.movies);
            }, function (error) {
                _this.movies = undefined;
                return Promise.reject(error);
            });
        }
    }, {
        key: 'getSessionsDictionary',
        value: function getSessionsDictionary() {
            var _this2 = this;

            var noCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this.movieSessions = this.movieSessions || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/movies' + (noCache ? '?noCache=' + noCache : '')).then(function (response) {
                return response.data.sessions;
            }, function (error) {
                _this2.movieSessions = undefined;
                return Promise.reject(error);
            });
        }
    }, {
        key: 'getSessions',
        value: function getSessions(movie_id) {
            var cinema_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var groupedByCinema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/movies/sessions/' + movie_id + '/' + cinema_id + '/' + groupedByCinema);
        }
    }, {
        key: 'getFeaturedMovies',
        value: function getFeaturedMovies() {
            return this.getMovies().then(function (movies) {
                return movies.featured();
            });
        }
    }, {
        key: 'getMoviesByRelease',
        value: function getMoviesByRelease() {
            return this.getMovies().then(function (movies) {
                return movies.byRelease();
            });
        }
    }, {
        key: 'getRelatedMoviesById',
        value: function getRelatedMoviesById(id) {
            return this.getMovies().then(function (movies) {
                var thisMovie = movies.find(id);
                return movies.related(thisMovie);
            });
        }
    }, {
        key: 'getRelatedMovies',
        value: function getRelatedMovies(movie) {
            return this.getMovies().then(function (movies) {
                return movies.related(movie);
            });
        }
    }, {
        key: 'getFilteredMovies',
        value: function getFilteredMovies(filterObj) {
            return this.getMovies().then(function (movies) {
                return new __WEBPACK_IMPORTED_MODULE_1__model__["f" /* Movies */](movies.filter(filterObj));
            });
        }
    }, {
        key: 'openingDateDesc',
        value: function openingDateDesc(a, b) {
            if (a.opening_date != null && a.opening_date != undefined && b.opening_date != null && b.opening_date != undefined) {
                if (a.opening_date.timestamp < b.opening_date.timestamp) return -1;
            }

            return 0;
        }
    }, {
        key: 'moviesByRelease',
        value: function moviesByRelease(movies) {
            var data = {
                now_showing: [],
                coming_soon: []
            };
            for (var m in movies) {
                if (movies[m] != undefined && movies[m] != null) {
                    if (movies[m].now_showing === true) {
                        data.now_showing.push(movies[m]);
                    } else {
                        data.coming_soon.push(movies[m]);
                    }
                }
            }

            data.coming_soon.sort(this.openingDateDesc);

            return data;
        }
    }, {
        key: 'sortfilteredCinemasByDistance',
        value: function sortfilteredCinemasByDistance(filter_cinemas) {

            return filter_cinemas.sort(function (a, b) {
                if (a.distance && b.distance) {
                    if (a.distance != null && b.distance != null) {
                        if (a.distance < b.distance) {
                            return -1;
                        }
                    }
                }

                return 0;
            });
        }
    }, {
        key: 'sortRegionsByDistance',
        value: function sortRegionsByDistance(regions) {
            for (var r in regions) {
                if (regions[r].cinemas != undefined && regions[r].cinemas != null && _typeof(regions[r].cinemas) == "object") {
                    var region = regions[r].cinemas;
                    region.sort(function (a, b) {
                        if (a.distance && b.distance) {
                            if (a.distance != null && b.distance != null) {
                                if (a.distance < b.distance) {
                                    return -1;
                                }
                            }
                        }

                        return 0;
                    });

                    if (region[0].distance && region[0].distance != null && region[0].distance != undefined) {
                        regions[r].distance = region[0].distance;
                        regions[r].cinemas = region;
                    }
                }
            }

            regions.sort(function (a, b) {
                if (a.distance && b.distance) {
                    if (a.distance != null && b.distance != null) {
                        if (a.distance < b.distance) {
                            return -1;
                        }
                    }
                }

                return 0;
            });

            return regions;
        }
    }, {
        key: 'filterCinemasToRegionModel',
        value: function filterCinemasToRegionModel(filter_cinemas, regions) {
            var filtered = [];
            for (var r in regions) {
                if (regions[r] != undefined && regions[r] != null && _typeof(regions[r]) == "object") {
                    if (regions[r].cinemas != undefined && regions[r].cinemas != null) {
                        for (var c in regions[r].cinemas) {
                            if (regions[r].cinemas[c] != undefined && regions[r].cinemas[c] != null && _typeof(regions[r].cinemas[c]) == "object") {
                                for (var fc in filter_cinemas) {
                                    if (filter_cinemas[fc] != undefined && filter_cinemas[fc] != null && _typeof(filter_cinemas[fc]) == "object") {
                                        if (filter_cinemas[fc].id != undefined && filter_cinemas[fc].id != null) {
                                            if (regions[r].cinemas[c].id != null && regions[r].cinemas[c].id != undefined) {
                                                if (filter_cinemas[fc].id == regions[r].cinemas[c].id) {
                                                    filtered.push(regions[r].cinemas[c]);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return filtered;
        }
    }, {
        key: 'filter',
        value: function filter(criteria) {
            var _this3 = this;

            var result = {};
            result.movies = {};
            result.cinemas = [];
            result.genres = {};
            result.types = {};
            result.times = {};

            return this.getMovies().then(function (movies_data) {
                return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__service__["n" /* RegionService */].getRegionsDictionary()).then(function (regions) {
                    var movies = movies_data.data;
                    var doNoSessionMatch = false;

                    if (criteria.title != null && criteria.title || criteria.genres && criteria.genres != null) {
                        if (!criteria.cinema_id && !criteria.types && !criteria.dates) {
                            doNoSessionMatch = true;
                        }
                    } else {
                        if (!criteria.title && !criteria.genres && !criteria.cinema_id && !criteria.types && !criteria.dates) {
                            doNoSessionMatch = true;
                        }
                    }

                    for (var m in movies) {
                        var movie = movies[m];
                        var _doNoSessionMatch = true;

                        for (var c in movies[m].cinemas) {
                            if (movies[m].cinemas[c] != undefined && movies[m].cinemas[c] != null) {
                                for (var s in movies[m].cinemas[c]) {
                                    var session = null;
                                    if (movies[m].cinemas[c][s] != undefined && movies[m].cinemas[c][s] != null) {
                                        _doNoSessionMatch = false;
                                    }
                                }
                            }
                        }

                        if (!_doNoSessionMatch) {
                            for (var _c in movies[m].cinemas) {
                                if (movies[m].cinemas[_c] != undefined && movies[m].cinemas[_c] != null) {
                                    for (var _s in movies[m].cinemas[_c]) {
                                        var _session = null;
                                        if (movies[m].cinemas[_c][_s] != undefined && movies[m].cinemas[_c][_s] != null) {
                                            _session = movies[m].cinemas[_c][_s];

                                            if (_this3.isMatch(criteria, _session, movie)) {
                                                result.movies[m] = movie;

                                                if (_session != undefined && _session != null) {
                                                    if (_session.cinema_id && _session.cinema_id != undefined) {
                                                        result.cinemas[_session.cinema_id] = regions[_session.cinema_id];
                                                    }

                                                    for (var e in _session.experiences) {
                                                        if (_session.experiences[e] != undefined && _session.experiences[e] != null) {
                                                            if (_session.experiences[e].name != undefined && _session.experiences[e] != null && typeof _session.experiences[e].name == "string") {
                                                                result.types[_session.experiences[e].name] = _session.experiences[e].name;
                                                            }
                                                        }
                                                    }

                                                    if (_session.time_tag != undefined && _session.time_tag != null && typeof _session.time_tag == "string") {
                                                        result.times[_session.time_tag] = _session.time_tag;
                                                    }
                                                }

                                                for (var g in movie.genres) {
                                                    if (movie.genres[g] != undefined && movie.genres[g] != null) {
                                                        if (movie.genres[g].id != undefined && movie.genres[g].id != null && typeof movie.genres[g].id == "string") {
                                                            result.genres[movie.genres[g].id] = movie.genres[g].id;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            if (_this3.isMatch(criteria, null, movie)) {
                                result.movies[m] = movie;

                                if (movie.genres != undefined && movie.genres != null) {
                                    for (var _g in movie.genres) {
                                        if (movie.genres[_g] != undefined && movie.genres[_g] != null) {
                                            if (movie.genres[_g].id != undefined && movie.genres[_g].id != null && typeof movie.genres[_g].id == "string") {

                                                result.genres[movie.genres[_g].id] = movie.genres[_g].id;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    return result;
                });
            });
        }
    }, {
        key: 'isMatch',
        value: function isMatch(criteria) {
            var session = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var movie = arguments[2];

            var session_time_match = false;

            if (criteria.time_range) {
                for (var r in criteria.time_range) {
                    if (criteria.time_raneg[r] != undefined && criteria.time_range[r] != null) {
                        if (session != undefined && session != null && (typeof session === 'undefined' ? 'undefined' : _typeof(session)) == "object") {
                            if (session.time_tag.includes(criteria.time_range[r])) {
                                session_time_match = true;
                            }
                        }
                    }
                }
            }

            var session_dates_match = false;

            if (criteria.dates) {
                if (movie.coming_soon) {
                    if (movie.opening_date && movie.opening_date.date) {
                        if (movie.opening_date.date.format('YYYY-MM-DD').toString() === criteria.dates) {
                            session_dates_match = true;
                        }
                    }
                } else {
                    for (var d in movie.date_tags) {
                        if (movie.date_tags[d].includes(criteria.dates)) {
                            session_dates_match = true;
                            break;
                        }
                    }
                }
            }

            var session_genre_match = false;
            if (criteria.genres != undefined) {
                if (movie.genres != undefined && movie.genres != null) {
                    var match_genres = movie.genres.find(function (g) {
                        if (g.id != undefined && g.id != null && typeof g.id == "string") {
                            if (g.id in criteria.genres) {
                                return true;
                            }
                        }
                        return false;
                    });
                    if (match_genres != undefined && match_genres != null) {
                        session_genre_match = true;
                    }
                }
            }

            var session_title_match = false;
            if (criteria.title && movie != undefined) {
                if (movie.title != undefined && movie.title != null) {
                    var search = new RegExp(criteria.title.replace(/[^\w\s]/gi, '').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "").replace(' ', '').toLowerCase(), "i");

                    var mTitle = movie.title.replace(/[^\w\s]/gi, '').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "").replace(' ', '').toLowerCase();
                    if (search.test(mTitle)) {
                        session_title_match = true;
                    }
                }
            }

            var match_experiences = false;
            var match_cinema = false;

            if (session != undefined && session != null && (typeof session === 'undefined' ? 'undefined' : _typeof(session)) == "object") {

                match_experiences = this.matchExperienceCriteria(session.experiences, criteria.types);


                if (session.cinema_id == criteria.cinema_id) {
                    match_cinema = true;
                }
            } else if (session == null || session == undefined) {

                if (movie.experiences != null && movie.experiences != undefined) {
                    if (movie.experiences.length > 0) {
                        match_experiences = this.matchExperienceCriteria(movie.experiences, criteria.types);
                    }
                }
            }

            return (!criteria.cinema_id || match_cinema) && (!criteria.dates || session_dates_match) && (!criteria.time_range || session_time_match) && (!criteria.types || match_experiences) && (!criteria.genres || session_genre_match) && (!criteria.title || session_title_match);
        }
    }, {
        key: 'matchExperienceCriteria',
        value: function matchExperienceCriteria(experiences, criteria) {
            if (criteria && criteria != undefined && criteria != null && experiences != undefined && experiences != null) {

                var match_experiences = false;

                match_experiences = experiences.find(function (e) {
                    if (e.name != undefined && e.name != null && typeof e.name == "string") {
                        if (e.name.trim() in criteria) {
                            return true;
                        }
                    }
                    return false;
                });

                if (match_experiences) {
                    return true;
                }

                if (!match_experiences) {
                    match_experiences = experiences.find(function (e) {
                        if (e in criteria) {
                            return true;
                        }

                        return false;
                    });
                    if (match_experiences != undefined && match_experiences != null) {

                        return true;
                    }
                }

                if (match_experiences != undefined && match_experiences != null) {
                    return true;
                }
            }

            return false;
        }
    }, {
        key: 'generateTimeRanges',
        value: function generateTimeRanges() {
            var _this4 = this;

            return this.getMovies().then(function (movies_raw) {
                var movies = movies_raw.data;
                var time_tags = [];
                for (var m in movies) {
                    if (movies[m] != undefined && movies[m] != null) {
                        for (var t in movies[m].time_tags) {
                            time_tags[movies[m].time_tags[t]] = movies[m].time_tags[t];
                        }
                    }
                }

                var unique = time_tags;
                var time_ranges = [];

                for (var i = 1; i <= 24; i++) {
                    var hour = 0;
                    var next_hour = 0;
                    if (i < 10) {
                        hour = "0" + i;
                        if (i < 9) {
                            next_hour = "0" + (i + 1);
                        } else {
                            next_hour = i + 1;
                        }
                    } else {
                        hour = i;
                        if (i == 23) {
                            next_hour = "00";
                        } else if (i == 24) {
                            hour = "00";
                            next_hour = "01";
                        } else {
                            next_hour = i + 1;
                        }
                    }

                    var partial_time = hour + ":";
                    var range = hour + ":00 - " + next_hour + ":00";
                    var has_time_slot = false;
                    for (var _t in unique) {
                        if (unique[_t] != null && unique[_t] != undefined && typeof unique[_t] === 'string') {
                            if (unique[_t].includes(partial_time)) {
                                has_time_slot = true;
                            }
                        }
                    }

                    if (has_time_slot) {
                        time_ranges.push({ "range": range, "hour": hour });
                    }
                }

                return Promise.resolve(_this4.generateRangeGroups(time_ranges)).then(function (groups) {
                    var groupRanges = { name: "Time", items: groups };

                    return groupRanges;
                });
            });
        }
    }, {
        key: 'generateRangeGroups',
        value: function generateRangeGroups(time_ranges) {

            var groups = [{
                range: "Between 9:00 and 10:00",
                id: "9am-10am",
                config_ranges: ["09:", "10:"],
                ranges: []
            }, {
                range: "Between 11:30 and 12:30",
                id: "11:30am-12:30pm",
                config_ranges: ["11:", "12:"],
                ranges: []
            }, {
                range: "Between 14:00 and 15:15",
                id: "2pm-3:15pm",
                config_ranges: ["14:", "15:"],
                ranges: []
            }, {
                range: "Between 17:00 and 18:00",
                id: "5pm-6pm",
                config_ranges: ["17:", "18:"],
                ranges: []
            }, {
                range: "Between 19:30 and 20:30",
                id: "7:30pm-8:30pm",
                config_ranges: ["19:", "20:"],
                ranges: []
            }, {
                range: "Between 22:00 and 22:45",
                id: "10pm-10:45pm",
                config_ranges: ["22:"],
                ranges: []
            }];

            for (var t in time_ranges) {
                if (time_ranges[t] != undefined && time_ranges[t] != null) {
                    for (var g in groups) {
                        if (groups[g] != undefined && groups[g] != null) {
                            for (var cr in groups[g].config_ranges) {
                                if (groups[g].config_ranges[cr] != undefined && groups[g].config_ranges[cr] != null && time_ranges[t].hour != undefined && time_ranges[t].hour != null) {
                                    if (groups[g].config_ranges[cr] == time_ranges[t].hour + ":") {
                                        groups[g].ranges.push(time_ranges[t]);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return groups;
        }
    }, {
        key: 'generateExperienceGroups',
        value: function generateExperienceGroups(experiences) {
            var group_config = [{
                name: "2D",
                types: ["2D", "2D DBOX OR 2D", "2D DBOX", "2D Prestige"]
            }, {
                name: "3D",
                types: ["3D", "3D IMAX", "3D Prestige", "3D DBOX OR 3D", "3D DBOX"]
            }, {
                name: "IMAX",
                types: ["3D IMAX", "2D IMAX"]
            }, {
                name: "Prestige",
                types: ["2D Prestige", "3D Prestige"]
            }, {
                name: "Kids",
                types: ["2D Kids", "3D Kids"]
            }, {
                name: "DBOX",
                types: ["2D DBOX OR 2D", "3D DBOX OR 3D", "2D DBOX", "3D DBOX"]
            }, {
                name: "Nouveau",
                types: ["Nouveau", "nouveau", "Nouveau 2D"]
            }];

            var groups = [];

            for (var gc in group_config) {
                var group = { name: group_config[gc].name, types: [] };
                for (var t in group_config[gc].types) {
                    for (var e in experiences) {
                        if (experiences[e] != undefined && experiences[e] != null) {
                            if (experiences[e].name != undefined && experiences[e].name != null && typeof experiences[e].name == "string") {
                                if (group_config[gc].types[t] != undefined && group_config[gc].types[t] != null && typeof group_config[gc].types[t] == "string") {
                                    if (experiences[e].name.trim() == group_config[gc].types[t].trim()) {
                                        group.types.push(experiences[e]);
                                    }
                                }
                            }
                        }
                    }
                }

                var exists = false;
                for (var g in groups) {
                    if (groups[g].name == group.name) {
                        exists = true;
                    }
                }

                if (!exists) {
                    groups.push(group);
                }
            }

            return groups;
        }
    }, {
        key: 'filterExperienceGroups',
        value: function filterExperienceGroups(type_groups, types) {

            var availableGroups = [];
            var otherGroups = [];

            for (var tg in type_groups) {
                if (type_groups[tg] != undefined && type_groups[tg] != null) {
                    for (var tgt in type_groups[tg].types) {
                        if (type_groups[tg].types[tgt] != undefined && type_groups[tg].types[tgt] != null) {
                            if (types[type_groups[tg].types[tgt].name] != undefined && types[type_groups[tg].types[tgt].name] != null) {
                                var exists = false;

                                if (availableGroups.length > 0) {
                                    for (var ag in availableGroups) {
                                        if (availableGroups[ag] != undefined && availableGroups[ag] != null) {
                                            if (availableGroups[ag].name == type_groups[tg].name) {
                                                exists = true;
                                            }
                                        }
                                    }
                                }

                                if (!exists) {
                                    availableGroups.push(type_groups[tg]);
                                }
                            } else {
                                var _exists = false;
                                if (otherGroups.length > 0) {
                                    for (var og in otherGroups) {
                                        if (otherGroups[og] != undefined && otherGroups[og] != null) {
                                            if (otherGroups[og].name == type_groups[tg].name) {
                                                _exists = true;
                                            }
                                        }
                                    }
                                }

                                if (!_exists) {
                                    otherGroups.push(type_groups[tg]);
                                }
                            }
                        }
                    }
                }
            }

            var result = {
                other: [],
                available: availableGroups
            };

            for (var _og in otherGroups) {
                var inAvailable = false;
                if (otherGroups[_og] != undefined && otherGroups[_og] != null) {
                    for (var _ag in availableGroups) {
                        if (availableGroups[_ag] != undefined && availableGroups[_ag] != null) {
                            if (otherGroups[_og].name == availableGroups[_ag].name) {
                                inAvailable = true;
                            }
                        }
                    }
                }

                if (!inAvailable) {
                    result.other.push(otherGroups[_og]);
                }
            }

            return result;
        }
    }]);

    return MovieService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new MovieService());

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var VistaDate = function VistaDate(data) {
    var _this = this;

    _classCallCheck(this, VistaDate);

    if (!__WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(data)) {

        if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' || typeof data === 'array') {
            this.timestamp = parseInt(data.timestamp);
            this.date = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(parseInt(data.timestamp));
        } else {
            this.timestamp = data;
            this.date = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(parseInt(data));
        }
    } else {
        this.date = data;
    }
    this.additional = {
        is_passed: this.date.isBefore(__WEBPACK_IMPORTED_MODULE_0_moment___default()()),
        is_future: this.date.isAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()()),
        no_zero_hour_long: this.date.format('H'),
        no_zero_hour_24: this.date.format('H'),
        minute: this.date.format('mm'),
        am_pm: this.date.format('a'),
        string_short_day_of_week: this.date.format('ddd'),
        string_long_day_of_week: function () {
            if (_this.date.isSame(__WEBPACK_IMPORTED_MODULE_0_moment___default()(), 'day')) {
                return 'Today';
            } else if (_this.date.isSame(__WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1, 'day'), 'day')) {
                return 'Tomorrow';
            }
            return _this.date.format('dddd');
        }(),
        string_nth_day: this.date.format('Do'),
        day: this.date.format('DD'),
        string_short_month: this.date.format('MMM'),
        string_long_month: this.date.format('MMMM'),
        month: this.date.format('MM'),
        year: this.date.format('YYYY')
    };
};

/* harmony default export */ __webpack_exports__["a"] = (VistaDate);

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AUTH_CHANGED */
/* unused harmony export TOKEN_CHANGED */
/* unused harmony export PROFILE_CHANGED */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_observable__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_User__ = __webpack_require__(103);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var TOKEN_KEY = 'sk-session-info';
var STORED_ORDER_USER = 'sk-session-user-info';

var AUTH_CHANGED = 'AUTH_CHANGED';
var TOKEN_CHANGED = 'TOKEN_CHANGED';
var PROFILE_CHANGED = 'UserProfileChanged';

var AuthService = function (_Observable) {
    _inherits(AuthService, _Observable);

    _createClass(AuthService, [{
        key: 'PROFILE_CHANGED',
        get: function get() {
            return PROFILE_CHANGED;
        }
    }]);

    function AuthService() {
        _classCallCheck(this, AuthService);

        var _this = _possibleConstructorReturn(this, (AuthService.__proto__ || Object.getPrototypeOf(AuthService)).call(this));

        _this._token = null;
        _this._userPromise = null;
        _this._user = null;
        _this.orderUser = null;
        _this._tokenRefreshInProgress = false;
        _this._cachedTokenPromise = null;
        _this._tokenRequestUri = '/member/session';
        _this._rewards_promise = null;
        _this.firstLogin = false;

        return _this;
    }

    _createClass(AuthService, [{
        key: 'authToken',
        value: function authToken() {
            if (!this._token) {
                try {
                    this._token = JSON.parse(localStorage.getItem(TOKEN_KEY));
                } catch (e) {
                    console.info("authToken: Failed to retrieve token from local storage", e);
                }
            }
            return this._token;
        }
    }, {
        key: 'retrieveAuthToken',
        value: function retrieveAuthToken() {
            var _this2 = this;

            if (this._cachedTokenPromise) return this._cachedTokenPromise;

            this._cachedTokenPromise = __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this._tokenRequestUri);
            this._cachedTokenPromise.then(function (r) {
                if (r.data && r.data.session_token) {
                    _this2._processTokenRetrievedResponse(r);
                }
            });

            return this._cachedTokenPromise;
        }
    }, {
        key: '_processTokenRetrievedResponse',
        value: function _processTokenRetrievedResponse(r) {
            if (r.data.session_token) {
                this._setToken(r.data.session_token);
                this.notifyObservers(TOKEN_CHANGED);
            }
        }
    }, {
        key: '_setToken',
        value: function _setToken(token) {
            this._token = token;
            try {
                localStorage.setItem(TOKEN_KEY, JSON.stringify(this._token));
            } catch (e) {}
        }
    }, {
        key: 'updateUser',
        value: function updateUser(user) {
            var _this3 = this;

            this._userPromise = undefined;
            return this._userPromise = __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/member', user).then(function (response) {
                return new __WEBPACK_IMPORTED_MODULE_2__model_User__["a" /* default */](response.data);
            }, function (error) {
                _this3._userPromise = undefined;
                return Promise.reject(error);
            });
        }
    }, {
        key: 'updateUserCards',
        value: function updateUserCards(cardsList) {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/member/cards', cardsList).then(function (response) {
                return response.data;
            }, function (error) {
                _this4._userPromise = undefined;
                return Promise.reject(error);
            });
        }
    }, {
        key: 'signUp',
        value: function signUp(user) {
            var _this5 = this;

            if (!user instanceof __WEBPACK_IMPORTED_MODULE_2__model_User__["a" /* default */]) throw Error("Signup Requires a valid user instance.");
            return this._userPromise = __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/member', user).then(function (response) {
                var token = response.request.getResponseHeader("X-SET-SESSION");
                if (token) _this5._setToken(token);

                _this5.notifyObservers("UserProfileChanged");

                return new __WEBPACK_IMPORTED_MODULE_2__model_User__["a" /* default */](response.data);
            }, function (error) {
                _this5._userPromise = undefined;
                return Promise.reject(error);
            });
        }
    }, {
        key: 'signIn',
        value: function signIn(Email, Password) {
            var _this6 = this;

            return this._userPromise = __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/member/sign-in', {
                Email: Email,
                Password: Password
            }).then(function (response) {
                var token = response.request.getResponseHeader("X-SET-SESSION");
                if (token) {
                    _this6._setToken(token);
                    _this6.notifyObservers(PROFILE_CHANGED);
                }
            }, function (error) {
                localStorage.removeItem('sk-session-info');
                var token = error.request.getResponseHeader("X-SET-SESSION");
                if (token) {
                    _this6._setToken(token);
                    Promise.resolve(new __WEBPACK_IMPORTED_MODULE_2__model_User__["a" /* default */]()).then(function (user) {
                        _this6.signOut();

                        return user;
                    });
                }

                _this6._userPromise = undefined;
                return Promise.reject(error);
            });
        }
    }, {
        key: 'user',
        value: function user() {
            var _this7 = this;

            return this._userPromise = this._userPromise || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/member').then(function (response) {
                var user = new __WEBPACK_IMPORTED_MODULE_2__model_User__["a" /* default */](response.data);


                var memberId = "Guest";
                if (user.MemberId != null) {
                    memberId = user.MemberId;
                }

                dataLayer.push({
                    'event': 'login',
                    'userID': memberId
                });

                return user;
            }, function (error) {
                if (error.request) {
                    var token = error.request.getResponseHeader("X-SET-SESSION");
                    if (token) {
                        _this7._setToken(token);
                        Promise.resolve(new __WEBPACK_IMPORTED_MODULE_2__model_User__["a" /* default */]()).then(function (user) {
                            _this7.signOut();

                            var memberId = "Guest";
                            if (user.MemberId != null) {
                                memberId = user.MemberId;
                            }
                            dataLayer.push({
                                'event': 'login',
                                'userID': memberId
                            });
                            return user;
                        });
                    }
                }
                _this7._userPromise = undefined;
                dataLayer.push({
                    'event': 'login',
                    'userID': "Guest"
                });

                return Promise.reject(error);
            });
        }
    }, {
        key: 'getRewards',
        value: function getRewards() {
            var _this8 = this;

            return this._rewards_promise = this._rewards_promise || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/member/rewards').then(function (resp) {
                return resp.data;
            }, function (error) {
                if (error.request) {
                    var token = error.request.getResponseHeader("X-SET-SESSION");
                    if (token) {
                        _this8._setToken(token);
                        return Promise.resolve(new __WEBPACK_IMPORTED_MODULE_2__model_User__["a" /* default */]());
                    }
                }
                _this8._userPromise = undefined;
                return Promise.reject(error);
            });
        }
    }, {
        key: 'isGuestUser',
        value: function isGuestUser() {
            return this.user().then(function (user) {
                return user.isGuest();
            }, function () {
                return true;
            });
        }
    }, {
        key: '_getLocalUserOrderInfo',
        value: function _getLocalUserOrderInfo() {
            if (!this.orderUser) {
                try {

                    this.orderUser = JSON.parse(localStorage.getItem("ORDER_USER_TEMP") || localStorage.getItem("ORDER_USER"));
                    this.orderUser.fromUser = false;
                } catch (e) {}
            }
            return this.orderUser;
        }
    }, {
        key: 'getUserOrderInfo',
        value: function getUserOrderInfo() {
            var _this9 = this;

            return this.user().then(function (user) {
                if (!user.isGuest() && !_this9._getLocalUserOrderInfo()) {
                    return {
                        FullName: user.FullName,
                        MobilePhone: user.MobilePhone,
                        Email: user.Email,
                        fromUser: true,
                        isTemp: false
                    };
                } else {
                    return _this9._getLocalUserOrderInfo();
                }
                return {};
            });
        }
    }, {
        key: 'storeLocalUserOrderInfo',
        value: function storeLocalUserOrderInfo(orderUser) {
            var temp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (!orderUser) return;
            this.orderUser = {
                FullName: orderUser.FullName,
                LastName: orderUser.LastName,
                Email: orderUser.Email,
                MobilePhone: orderUser.MobilePhone,
                isTemp: temp
            };
            try {
                localStorage.setItem(temp ? "ORDER_USER_TEMP" : "ORDER_USER", JSON.stringify(orderUser));
            } catch (e) {
                console.log('localStorage not available');
            }
        }
    }, {
        key: 'clearTempLocalUserOrderInfo',
        value: function clearTempLocalUserOrderInfo() {

            try {
                localStorage.removeItem('ORDER_USER_TEMP');
            } catch (e) {}
        }
    }, {
        key: 'signOut',
        value: function signOut() {
            localStorage.removeItem('sk-session-info');
            this._token = null;
            this._userPromise = null;
            this.notifyObservers("UserProfileChanged");
        }
    }, {
        key: 'subscribeToNewsletter',
        value: function subscribeToNewsletter(email) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/member/subscribe', { email: email });
        }
    }, {
        key: 'initiatePasswordReset',
        value: function initiatePasswordReset(email) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/member/initiate-password-reset', { Email: email }).then(function (result) {
                return result;
            }, function (error) {
                return Promise.reject(error);
            });
        }
    }, {
        key: 'validateResetCode',
        value: function validateResetCode() {
            var resetCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (resetCode) {
                return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/member/validate-password-reset', { resetCode: resetCode }).then(function (result) {
                    return result;
                }, function (error) {
                    return Promise.reject(error);
                });
            } else {
                return false;
            }
        }
    }, {
        key: 'completePasswordReset',
        value: function completePasswordReset(newPassword, resetCode, memberId) {
            if (resetCode && newPassword) {
                return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/member/complete-password-reset', { resetCode: resetCode, newPassword: newPassword, MemberId: memberId }).then(function (result) {
                    return result;
                }, function (error) {
                    return Promise.reject(error);
                });
            } else {
                return false;
            }
        }
    }, {
        key: 'facebookSignUp',
        value: function facebookSignUp(fbObject) {
            var _this10 = this;

            return this._userPromise = __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/member/facebook-signup', fbObject).then(function (response) {
                var token = response.request.getResponseHeader("X-SET-SESSION");
                if (token) {
                    _this10._setToken(token);
                    _this10.notifyObservers(PROFILE_CHANGED);
                }
                return new __WEBPACK_IMPORTED_MODULE_2__model_User__["a" /* default */](response.data);
            }, function (error) {
                return Promise.reject(error);
            });
        }
    }, {
        key: 'initiateEmailChange',
        value: function initiateEmailChange(email, memberid) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/member/initiate-email-change', { Email: email, MemberId: memberid }).then(function (result) {
                return result;
            }, function (error) {
                return Promise.reject(error);
            });
        }
    }, {
        key: 'validateChangeEmail',
        value: function validateChangeEmail(validateCode) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/member/validate-email-change', { validateCode: validateCode }).then(function (result) {
                return result;
            }, function (error) {
                return Promise.reject(error);
            });
        }
    }, {
        key: 'resendActivation',
        value: function resendActivation() {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/member/resend-activation');
        }
    }, {
        key: 'activateMember',
        value: function activateMember(activationCode) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/member/activate', { activationCode: activationCode }).then(function (response) {
                return response.data;
            }, function (error) {
                return Promise.reject(error);
            });
        }
    }, {
        key: 'replaceCard',
        value: function replaceCard(CardNumber) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/member/next-card', { CardNumber: CardNumber }).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'deleteAccount',
        value: function deleteAccount() {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/member/delete-member', {}).then(function (response) {
                return response.data;
            });
        }
    }]);

    return AuthService;
}(__WEBPACK_IMPORTED_MODULE_1__util_observable__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new AuthService());

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Collection = function () {
    function Collection() {
        var dataKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data';

        _classCallCheck(this, Collection);

        this._dataKey = dataKey;
    }

    _createClass(Collection, [{
        key: 'length',
        get: function get() {
            return this[this._dataKey].length;
        }
    }]);

    return Collection;
}();

/* harmony default export */ __webpack_exports__["a"] = (Collection);

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model__ = __webpack_require__(19);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var RegionService = function () {
    function RegionService() {
        _classCallCheck(this, RegionService);

        this.regions = undefined;
        this.regionsDictionary = undefined;
    }

    _createClass(RegionService, [{
        key: 'setPreRenderRegions',
        value: function setPreRenderRegions(raw_data) {
            if (raw_data && raw_data != undefined) {
                this.regions = new __WEBPACK_IMPORTED_MODULE_1__model__["g" /* Regions */](raw_data);
            } else {
                this.regions = undefined;
            }

            return this.regions;
        }
    }, {
        key: 'setPreRenderRegionsDictionary',
        value: function setPreRenderRegionsDictionary(raw_data) {
            if (raw_data && raw_data != undefined) {
                this.regionsDictionary = raw_data;
            } else {
                this.regionsDictionary = undefined;
            }

            return this.regionsDictionary;
        }
    }, {
        key: 'getRegions',
        value: function getRegions() {
            var _this = this;

            return this.regions = this.regions || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/regions').then(function (response) {
                return new __WEBPACK_IMPORTED_MODULE_1__model__["g" /* Regions */](response.data);
            }, function (error) {
                _this.regions = undefined;
                return Promise.reject(error);
            });
        }
    }, {
        key: 'getRegionsDictionary',
        value: function getRegionsDictionary() {
            var _this2 = this;

            return this.regionsDictionary = this.regionsDictionary || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/regions/cinemas').then(function (response) {
                return response.data;
            }, function (error) {
                _this2.regionsDictionary = undefined;
                return Promise.reject(error);
            });
        }
    }, {
        key: 'getCinemasNearBy',
        value: function getCinemasNearBy(lat, long) {
            return this.getRegions().then(function (regions) {
                return regions.cinemasCloseTo(lat, long);
            }).then(function (regions) {
                return regions;
            });
        }
    }, {
        key: 'getCinema',
        value: function getCinema(id) {
            return this.getRegions().then(function (regions) {
                return regions.findCimema(id);
            });
        }
    }, {
        key: 'getCinemaBySlug',
        value: function getCinemaBySlug(slug) {
            if (slug && slug.length > 0) return this.getRegions().then(function (regions) {
                return regions.findCinemaBySlug(slug);
            });else return null;
        }
    }, {
        key: 'getPrerederedCinemaBySlug',
        value: function getPrerederedCinemaBySlug(regions, slug) {
            if (slug && slug.length > 0) return regions.findCinemaBySlug(slug);else return null;
        }
    }, {
        key: 'getRegionsForSelectedCinemaType',
        value: function getRegionsForSelectedCinemaType(regions, movies, selected_types) {

            if (!selected_types || selected_types.length == 0) {
                return { cinemas: regions, movies: movies };
            }

            var moviesWithTypes = [];
            for (var t in selected_types) {
                for (var m in movies) {

                    if (movies[m].experiences.includes(selected_types[t].name)) {

                        var exists = false;
                        if (moviesWithTypes.length > 0) {
                            for (var mt in moviesWithTypes) {
                                if (movies[m].id == moviesWithTypes[mt].id) {
                                    exists = true;
                                }
                            }
                        }

                        if (!exists) {
                            moviesWithTypes.push(movies[m]);
                        }
                    }
                }
            }

            var cinemasWithType = [];
            for (var _m in moviesWithTypes) {
                for (var c in moviesWithTypes[_m].cinemas) {
                    for (var _t in selected_types) {
                        for (var s in moviesWithTypes[_m].cinemas[c]) {
                            for (var e in moviesWithTypes[_m].cinemas[c][s].experiences) {

                                var _exists = false;
                                if (selected_types[_t].name == moviesWithTypes[_m].cinemas[c][s].experiences[e].name) {
                                    if (cinemasWithType.length > 0) {
                                        for (var ct in cinemasWithType) {
                                            if (c == cinemasWithType[ct]) {
                                                _exists = true;
                                            }
                                        }
                                    }

                                    if (!_exists) {
                                        cinemasWithType.push(c);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { cinemas: cinemasWithType, movies: moviesWithTypes };
        }
    }, {
        key: 'getRegionsForSelectedTime',
        value: function getRegionsForSelectedTime(regions, movies, selected_time) {
            if (!selected_time) {
                return { cinemas: regions, movies: movies };
            }

            var moviesWithTime = [];
            for (var m in movies) {
                for (var t in movies[m].time_tags) {

                    if (movies[m].time_tags[t].includes(selected_time.hour + ":")) {
                        var exists = false;
                        if (moviesWithTime.length > 0) {
                            for (var mt in moviesWithTime) {
                                if (movies[m].id == moviesWithTime[mt].id) {
                                    exists = true;
                                }
                            }
                        }

                        if (!exists) {
                            moviesWithTime.push(movies[m]);
                        }
                    }
                }
            }

            var cinemasWithTime = [];
            for (var _m2 in moviesWithTime) {
                for (var c in moviesWithTime[_m2].cinemas) {
                    for (var s in moviesWithTime[_m2].cinemas[c]) {

                        var _exists2 = false;
                        if (moviesWithTime[_m2].cinemas[c][s].time_tag.includes(selected_time.hour + ":")) {
                            if (cinemasWithTime.length > 0) {
                                for (var ct in cinemasWithTime) {
                                    if (c == cinemasWithTime[ct]) {
                                        _exists2 = true;
                                    }
                                }
                            }

                            if (!_exists2) {
                                cinemasWithTime.push(c);
                            }
                        }
                    }
                }
            }

            return { cinemas: cinemasWithTime, movies: moviesWithTime };
        }
    }, {
        key: 'getCinemasFromIds',
        value: function getCinemasFromIds(ids) {
            return Promise.resolve(this.getRegions()).then(function (region_data) {
                var regions = region_data.data;
                var available_cinemas = [];
                for (var r in regions) {
                    for (var c in regions[r].cinemas) {
                        for (var i in ids) {
                            var exists = false;
                            if (ids[i] == regions[r].cinemas[c].id) {

                                if (available_cinemas.length > 0) {
                                    for (var a in available_cinemas) {
                                        if (available_cinemas[a].id == regions[r].cinemas[c].id) {
                                            exists = true;
                                        }
                                    }
                                }

                                if (!exists) {
                                    available_cinemas.push(regions[r].cinemas[c]);
                                }
                            }
                        }
                    }
                }

                return available_cinemas;
            });
        }
    }, {
        key: 'strictMergeCinemaIds',
        value: function strictMergeCinemaIds(cinemasByType, cinemasByTime) {

            var cinemas = [];
            if (cinemasByType.length > 0 && cinemasByTime.length > 0) {
                for (var ty in cinemasByType) {
                    for (var ti in cinemasByTime) {
                        var exists = false;
                        if (cinemasByTime[ti].id == cinemasByType[ty].id) {
                            if (cinemas.length > 0) {
                                for (var c in cinemas) {
                                    if (cinemas[c].id == cinemasByType[ty].id) {
                                        exists = true;
                                    }
                                }
                            }

                            if (!exists) {
                                cinemas.push(cinemasByType[ty]);
                            }
                        }
                    }
                }
            } else if (cinemasByType.length == 0 && cinemasByTime.length > 0) {
                cinemas = cinemasByTime;
            } else if (cinemasByType.length > 0 && cinemasByTime.length == 0) {
                cinemas = cinemasByType;
            }

            return cinemas;
        }
    }, {
        key: 'getAllCinemas',
        value: function getAllCinemas(regions, movies) {
            var cinema_ids = [];
            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        var exists = false;

                        if (cinema_ids.length > 0) {
                            for (var ci in cinema_ids) {
                                if (cinema_ids[ci] == movies[m].cinemas[c][s].cinema_id) {
                                    exists = true;
                                }
                            }
                        }

                        if (!exists) {
                            cinema_ids.push(movies[m].cinemas[c][s].cinema_id);
                        }
                    }
                }
            }

            var cinemas = [];
            for (var r in regions) {
                for (var _c in regions[r].cinemas) {
                    for (var _ci in cinema_ids) {
                        if (regions[r].cinemas[_c].id == cinema_ids[_ci]) {
                            var _exists3 = false;

                            if (cinemas.length > 0) {
                                for (var cc in cinemas) {
                                    if (cinemas[cc] == regions[r].cinemas[_c].id) {
                                        _exists3 = true;
                                    }
                                }
                            }

                            if (!_exists3) {
                                cinemas.push(regions[r].cinemas[_c]);
                            }
                        }
                    }
                }
            }

            return cinemas;
        }
    }, {
        key: 'getRegionsForSelectedGenres',
        value: function getRegionsForSelectedGenres(cinemas, movies, selected_genres) {
            if (!selected_genres || selected_genres.length == 0) {
                return { cinemas: cinemas, movies: movies };
            }

            var moviesWithGenres = [];
            for (var m in movies) {
                for (var g in movies[m].genres) {
                    for (var sg in selected_genres) {
                        var exists = false;
                        if (selected_genres[sg].id == movies[m].genres[g].id) {
                            if (moviesWithGenres.length > 0) {
                                for (var mwg in moviesWithGenres) {
                                    if (moviesWithGenres[mwg].id == movies[m].id) {
                                        exists = true;
                                    }
                                }
                            }

                            if (!exists) {
                                moviesWithGenres.push(movies[m]);
                            }
                        }
                    }
                }
            }

            var cinemasWithGenres = [];
            for (var c in cinemas) {
                for (var _m3 in moviesWithGenres) {
                    for (var mc in moviesWithGenres[_m3].cinemas) {
                        for (var s in moviesWithGenres[_m3].cinemas[mc]) {
                            var _exists4 = false;

                            if (moviesWithGenres[_m3].cinemas[mc][s].cinema_id == cinemas[c]) {
                                if (cinemasWithGenres.length > 0) {
                                    for (var cg in cinemasWithGenres) {
                                        if (cinemasWithGenres[cg] == cinemas[c]) {
                                            _exists4 = true;
                                        }
                                    }
                                }

                                if (!_exists4) {
                                    cinemasWithGenres.push(cinemas[c]);
                                }
                            }
                        }
                    }
                }
            }

            return { cinemas: cinemasWithGenres, movies: moviesWithGenres };
        }
    }, {
        key: 'getAvailableRegionsForFilterSelection',
        value: function getAvailableRegionsForFilterSelection(movies, selected_cinema, selected_types, selected_genres, selected_time) {
            var _this3 = this;

            return Promise.resolve(this.getRegions()).then(function (regions) {
                return Promise.resolve(_this3.getAllCinemas(regions.data, movies)).then(function (all_cinemas) {
                    return Promise.resolve(_this3.getRegionsForSelectedTime(all_cinemas, movies, selected_time)).then(function (data_with_time) {

                        return Promise.resolve(_this3.getRegionsForSelectedGenres(data_with_time.cinemas, data_with_time.movies, selected_genres)).then(function (data_with_genres) {

                            return Promise.resolve(_this3.getRegionsForSelectedCinemaType(data_with_genres.cinemas, data_with_genres.movies, selected_types)).then(function (data_with_type) {
                                return Promise.resolve(_this3.getCinemasFromIds(data_with_type.cinemas)).then(function (cinemas) {
                                    return cinemas;
                                });
                            });
                        });
                    });
                });
            });
        }
    }, {
        key: 'generateTimeRanges',
        value: function generateTimeRanges(movies) {

            var time_tags = [];
            for (var m in movies) {
                for (var t in movies[m].time_tags) {
                    time_tags.push(movies[m].time_tags[t]);
                }
            }

            var unique = [].concat(_toConsumableArray(new Set(time_tags)));
            var time_ranges = [];

            for (var i = 1; i <= 24; i++) {
                var hour = 0;
                var next_hour = 0;
                if (i < 10) {
                    hour = "0" + i;
                    if (i < 9) {
                        next_hour = "0" + (i + 1);
                    } else {
                        next_hour = i + 1;
                    }
                } else {
                    hour = i;
                    if (i == 23) {
                        next_hour = "00";
                    } else if (i == 24) {
                        hour = "00";
                        next_hour = "01";
                    } else {
                        next_hour = i + 1;
                    }
                }

                var partial_time = hour + ":";
                var range = hour + ":00 - " + next_hour + ":00";
                var has_time_slot = false;
                for (var _t2 in unique) {
                    if (unique[_t2].includes(partial_time)) {
                        has_time_slot = true;
                        break;
                    }
                }

                if (has_time_slot) {
                    time_ranges.push({ "range": range, "hour": hour });
                }
            }

            var timeRanges = { name: "Times available for selection:", items: time_ranges };
            return timeRanges;
        }
    }, {
        key: 'getMoviesWithSelectedCinema',
        value: function getMoviesWithSelectedCinema(movies, cinema) {

            if (!cinema) {
                return { movies: movies };
            }

            var moviesWithCinema = [];
            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {

                        var exists = false;
                        if (movies[m].cinemas[c][s].cinema_id == cinema.id) {
                            if (moviesWithCinema.length > 0) {
                                for (var mc in moviesWithCinema) {
                                    if (moviesWithCinema[mc].id == movies[m].id) {
                                        exists = true;
                                    }
                                }
                            }

                            if (!exists) {
                                moviesWithCinema.push(movies[m]);
                            }
                        }
                    }
                }
            }

            return { movies: moviesWithCinema };
        }
    }, {
        key: 'getMoviesWithSelectedCinemaTypes',
        value: function getMoviesWithSelectedCinemaTypes(movies, types) {

            if (!types || types.length == 0) {
                return { movies: movies };
            }

            var moviesWithTypes = [];
            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        for (var e in movies[m].cinemas[c][s].experiences) {
                            for (var t in types) {
                                var exists = false;
                                if (types[t].name == movies[m].cinemas[c][s].experiences[e].name) {
                                    if (moviesWithTypes.length > 0) {
                                        for (var mt in moviesWithTypes) {
                                            if (moviesWithTypes[mt].id == movies[m].id) {
                                                exists = true;
                                            }
                                        }
                                    }

                                    if (!exists) {
                                        moviesWithTypes.push(movies[m]);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { movies: moviesWithTypes };
        }
    }, {
        key: 'getMoviesWithSelectedTime',
        value: function getMoviesWithSelectedTime(movies, selected_time) {

            if (!selected_time || selected_time.length == 0) {
                return { movies: movies };
            }

            var moviesWithTime = [];
            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        var exists = false;
                        if (movies[m].cinemas[c][s].time_tag.includes(selected_time.hour + ":")) {
                            if (moviesWithTime.length > 0) {
                                for (var mt in moviesWithTime) {
                                    if (moviesWithTime[mt].id == movies[m].id) {
                                        exists = true;
                                    }
                                }
                            }

                            if (!exists) {
                                moviesWithTime.push(movies[m]);
                            }
                        }
                    }
                }
            }

            return { movies: moviesWithTime };
        }
    }, {
        key: 'getMoviesWithSelectedGenres',
        value: function getMoviesWithSelectedGenres(movies, selected_genres) {
            if (!selected_genres || selected_genres.length == 0) {
                return { movies: movies };
            }

            var moviesWithGenres = [];
            for (var m in movies) {
                for (var g in movies[m].genres) {
                    for (var sg in selected_genres) {
                        var exists = false;
                        if (selected_genres[sg].id == movies[m].genres[g].id) {
                            if (moviesWithGenres.length > 0) {
                                for (var mwg in moviesWithGenres) {
                                    if (moviesWithGenres[mwg].id == movies[m].id) {
                                        exists = true;
                                    }
                                }
                            }

                            if (!exists) {
                                moviesWithGenres.push(movies[m]);
                            }
                        }
                    }
                }
            }

            return { movies: moviesWithGenres };
        }
    }, {
        key: 'getCinemaTypesFromMovies',
        value: function getCinemaTypesFromMovies(movies, meta) {
            var mtypes = meta.experiences;
            var cinemaTypes = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        for (var e in movies[m].cinemas[c][s].experiences) {
                            for (var mt in mtypes) {
                                var exists = false;

                                if (mtypes[mt].name == movies[m].cinemas[c][s].experiences[e].name) {
                                    if (cinemaTypes.length > 0) {
                                        for (var ct in cinemaTypes) {
                                            if (cinemaTypes[ct].name == mtypes[mt].name) {
                                                exists = true;
                                            }
                                        }
                                    }

                                    if (!exists) {
                                        cinemaTypes.push(movies[m].cinemas[c][s].experiences[e]);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return cinemaTypes;
        }
    }, {
        key: 'getGenresFromMovies',
        value: function getGenresFromMovies(movies, meta) {
            var mgenres = meta.genres;
            var genres = [];

            for (var m in movies) {
                for (var g in movies[m].genres) {
                    for (var mg in mgenres) {
                        var exists = false;

                        if (mgenres[mg].name == movies[m].genres[g].name) {
                            if (genres.length > 0) {
                                for (var ag in genres) {
                                    if (genres[ag].name == mgenres[mg].name) {
                                        exists = true;
                                    }
                                }
                            }

                            if (!exists) {
                                genres.push(movies[m].genres[g]);
                            }
                        }
                    }
                }
            }

            return genres;
        }
    }, {
        key: 'generateAvailableTimeRangesForFilterSelection',
        value: function generateAvailableTimeRangesForFilterSelection(movies, selected_cinema, selected_types, selected_genres, time_ranges) {
            var _this4 = this;

            return Promise.resolve(this.getMoviesWithSelectedCinema(movies, selected_cinema)).then(function (data_with_cinema) {
                return Promise.resolve(_this4.getMoviesWithSelectedCinemaTypes(data_with_cinema.movies, selected_types)).then(function (data_with_type) {
                    return Promise.resolve(_this4.getMoviesWithSelectedGenres(data_with_type.movies, selected_genres)).then(function (data_with_genres) {
                        return Promise.resolve(_this4.generateTimeRanges(data_with_genres.movies)).then(function (time_ranges) {
                            return time_ranges;
                        });
                    });
                });
            });
        }
    }, {
        key: 'getTypesFromMoviesWithSelectedCinema',
        value: function getTypesFromMoviesWithSelectedCinema(movies, selected_cinema, selected_time, selected_genres) {
            var typesWithCinema = [];
            if (selected_cinema) {
                for (var m in movies) {
                    for (var c in movies[m].cinemas) {
                        for (var s in movies[m].cinemas[c]) {

                            var exists = false;
                            if (!selected_time) {
                                if (!selected_genre || selected_genre.length == 0) {
                                    if (movies[m].cinemas[c][s].cinema_id == selected_cinema.id) {
                                        if (typesWithCinema.length > 0) {
                                            for (var mc in typesWithCinema) {
                                                if (typesWithCinema[mc].name == movies[m].cinemas[c][s].experiences[0].name) {
                                                    exists = true;
                                                }
                                            }
                                        }

                                        if (!exists) {
                                            typesWithCinema.push(movies[m].cinemas[c][s].experiences[0]);
                                        }
                                    }
                                } else {
                                    if (movies[m].cinemas[c][s].cinema_id == selected_cinema.id) {
                                        for (var g in selected_genres) {
                                            for (var mg in movies[m].genres) {
                                                if (movies[m].genres[mg].id == selected_genres[g].id) {
                                                    if (typesWithCinema.length > 0) {
                                                        for (var _mc in typesWithCinema) {
                                                            if (typesWithCinema[_mc].name == movies[m].cinemas[c][s].experiences[0].name) {
                                                                exists = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }

                                        if (!exists) {
                                            typesWithCinema.push(movies[m].cinemas[c][s].experiences[0]);
                                        }
                                    }
                                }
                            } else {
                                if (!selected_genre || selected_genre.length == 0) {
                                    if (movies[m].cinemas[c][s].cinema_id == selected_cinema.id && movies[m].cinemas[c][s].time_tag.includes(selected_time.hour + ":")) {
                                        if (typesWithCinema.length > 0) {
                                            for (var _mc2 in typesWithCinema) {
                                                if (typesWithCinema[_mc2].name == movies[m].cinemas[c][s].experiences[0].name) {
                                                    exists = true;
                                                }
                                            }
                                        }

                                        if (!exists) {
                                            typesWithCinema.push(movies[m].cinemas[c][s].experiences[0]);
                                        }
                                    }
                                } else {
                                    if (movies[m].cinemas[c][s].cinema_id == selected_cinema.id && movies[m].cinemas[c][s].time_tag.includes(selected_time.hour + ":")) {
                                        for (var _g in selected_genres) {
                                            for (var _mg in movies[m].genres) {
                                                if (movies[m].genres[_mg].id == selected_genres[_g].id) {
                                                    if (typesWithCinema.length > 0) {
                                                        for (var _mc3 in typesWithCinema) {
                                                            if (typesWithCinema[_mc3].name == movies[m].cinemas[c][s].experiences[0].name) {
                                                                exists = true;
                                                            }
                                                        }
                                                    }

                                                    if (!exists) {
                                                        typesWithCinema.push(movies[m].cinemas[c][s].experiences[0]);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                for (var _m4 in movies) {
                    for (var _c2 in movies[_m4].cinemas) {
                        for (var _s in movies[_m4].cinemas[_c2]) {

                            var _exists5 = false;
                            if (selected_time) {
                                if (!selected_genres || selected_genres.length == 0) {
                                    if (movies[_m4].cinemas[_c2][_s].time_tag.includes(selected_time.hour + ":")) {
                                        if (typesWithCinema.length > 0) {
                                            for (var _mc4 in typesWithCinema) {
                                                if (typesWithCinema[_mc4].name == movies[_m4].cinemas[_c2][_s].experiences[0].name) {
                                                    _exists5 = true;
                                                }
                                            }
                                        }

                                        if (!_exists5) {
                                            typesWithCinema.push(movies[_m4].cinemas[_c2][_s].experiences[0]);
                                        }
                                    }
                                } else {
                                    if (movies[_m4].cinemas[_c2][_s].time_tag.includes(selected_time.hour + ":")) {
                                        for (var _g2 in selected_genres) {
                                            for (var _mg2 in movies[_m4].genres) {
                                                if (movies[_m4].genres[_mg2].id == selected_genres[_g2].id) {
                                                    if (typesWithCinema.length > 0) {
                                                        for (var _mc5 in typesWithCinema) {
                                                            if (typesWithCinema[_mc5].name == movies[_m4].cinemas[_c2][_s].experiences[0].name) {
                                                                _exists5 = true;
                                                            }
                                                        }
                                                    }

                                                    if (!_exists5) {
                                                        typesWithCinema.push(movies[_m4].cinemas[_c2][_s].experiences[0]);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            } else {
                                if (!selected_genres || selected_genres.length == 0) {
                                    if (typesWithCinema.length > 0) {
                                        for (var _mc6 in typesWithCinema) {
                                            if (typesWithCinema[_mc6].name == movies[_m4].cinemas[_c2][_s].experiences[0].name) {
                                                _exists5 = true;
                                            }
                                        }
                                    }

                                    if (!_exists5) {
                                        typesWithCinema.push(movies[_m4].cinemas[_c2][_s].experiences[0]);
                                    }
                                } else {
                                    for (var _g3 in selected_genres) {
                                        for (var _mg3 in movies[_m4].genres) {
                                            if (movies[_m4].genres[_mg3].id == selected_genres[_g3].id) {
                                                if (typesWithCinema.length > 0) {
                                                    for (var _mc7 in typesWithCinema) {
                                                        if (typesWithCinema[_mc7].name == movies[_m4].cinemas[_c2][_s].experiences[0].name) {
                                                            _exists5 = true;
                                                        }
                                                    }
                                                }

                                                if (!_exists5) {
                                                    typesWithCinema.push(movies[_m4].cinemas[_c2][_s].experiences[0]);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return typesWithCinema;
        }
    }, {
        key: 'getTypesFromMoviesWithSelectedTime',
        value: function getTypesFromMoviesWithSelectedTime(movies, types, selected_time) {
            if (!selected_time) {
                return types;
            }

            var typesWithCinema = [];
            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {

                        var exists = false;
                        if (movies[m].cinemas[c][s].time_tag.includes(selected_time.hour + ":")) {
                            if (typesWithCinema.length > 0) {
                                for (var mc in typesWithCinema) {
                                    if (typesWithCinema[mc].name == movies[m].cinemas[c][s].experiences[0].name) {
                                        exists = true;
                                    }
                                }
                            }

                            if (!exists) {
                                typesWithCinema.push(movies[m].cinemas[c][s].experiences[0]);
                            }
                        }
                    }
                }
            }

            return typesWithCinema;
        }
    }, {
        key: 'getTypesWithSelectedTime',
        value: function getTypesWithSelectedTime(movies, types, selected_time) {
            if (!selected_time) {
                return types;
            }

            return Promise.resolve(this.getTypesFromMoviesWithSelectedTime(movies, types, selected_time)).then(function (types_with_time) {
                var time_cinema_types = [];
                if (types.length > 0) {
                    for (var t in types) {
                        for (var tt in types_with_time) {
                            var exists = [];
                            if (types[t].name == types_with_time[tt].name) {
                                var _exists6 = false;
                                if (time_cinema_types.length > 0) {
                                    for (var tc in time_cinema_types) {
                                        if (time_cinema_types[tc].name == types[t].name) {
                                            _exists6 = true;
                                        }
                                    }
                                }

                                if (!_exists6) {
                                    time_cinema_types.push(types[t]);
                                }
                            }
                        }
                    }

                    return time_cinema_types;
                } else {
                    return types_with_time;
                }
            });
        }
    }, {
        key: 'getTypesFromMoviesWithSelectedGenres',
        value: function getTypesFromMoviesWithSelectedGenres(movies, types, selected_genres) {
            if (!selected_genres || selected_genres.length == 0) {
                return types;
            }

            var types_with_genres = [];
            for (var m in movies) {
                for (var g in movies[m].genres) {
                    for (var sg in selected_genres) {
                        if (movies[m].genres[g].name == selected_genres[sg].name) {

                            for (var c in movies[m].cinemas) {
                                for (var s in movies[m].cinemas[c]) {
                                    for (var e in movies[m].cinemas[c][s].experiences) {
                                        var exists = false;
                                        if (types_with_genres.length > 0) {
                                            for (var tg in types_with_genres) {
                                                if (types_with_genres[tg].name == movies[m].cinemas[c][s].experiences[e].name) {
                                                    exists = true;
                                                }
                                            }
                                        }

                                        if (!exists) {
                                            types_with_genres.push(movies[m].cinemas[c][s].experiences[e]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return types_with_genres;
        }
    }, {
        key: 'getTypesWithSelectedGenre',
        value: function getTypesWithSelectedGenre(movies, types, selected_genres) {
            if (!selected_genres || selected_genres.length == 0) {
                return types;
            }

            return Promise.resolve(this.getTypesFromMoviesWithSelectedGenres(movies, types, selected_genres)).then(function (types_with_genres) {

                var genre_types = [];
                if (types.length > 0) {
                    for (var twg in types_with_genres) {
                        for (var t in types) {
                            var exists = false;
                            if (types[t].name == types_with_genres[twg].name) {
                                if (genre_types.length > 0) {
                                    for (var gt in genre_types) {
                                        if (genre_types[gt].name == types_with_genres[twg].name) {
                                            exists = true;
                                        }
                                    }
                                }

                                if (!exists) {
                                    genre_types.push(types_with_genres[twg]);
                                }
                            }
                        }
                    }

                    return genre_types;
                } else {
                    return types_with_genres;
                }
            });
        }
    }, {
        key: 'getGenresFromMoviesWithFilters',
        value: function getGenresFromMoviesWithFilters(movies, selected_cinema, selected_time, selected_types) {}
    }, {
        key: 'getCinemaTypesFromMoviesFromSelectedCinema',
        value: function getCinemaTypesFromMoviesFromSelectedCinema(movies, selected_cinema) {
            var filteredCinemaTypes = [];
            var filteredMovies = [];
            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        for (var e in movies[m].cinemas[c][s].experiences) {
                            if (selected_cinema.id == movies[m].cinemas[c][s].cinema_id) {
                                var type_exists = false;
                                var movie_exists = false;
                                if (filteredCinemaTypes.length > 0) {
                                    for (var fc in filteredCinemaTypes) {
                                        if (filteredCinemaTypes[fc].name == movies[m].cinemas[c][s].experiences[e].name) {
                                            type_exists = true;
                                        }
                                    }
                                }

                                if (filteredMovies.length > 0) {
                                    for (var fm in filteredMovies) {
                                        if (filteredMovies[fm].id == movies[m].id) {
                                            movie_exists = true;
                                        }
                                    }
                                }

                                if (!type_exists) {
                                    filteredCinemaTypes.push(movies[m].cinemas[c][s].experiences[e]);
                                }

                                if (!movie_exists) {
                                    filteredMovies.push(movies[m]);
                                }
                            }
                        }
                    }
                }
            }

            return { movies: filteredMovies, types: filteredCinemaTypes };
        }
    }, {
        key: 'getCinemaTypesFromMoviesFromSelectedCinemaAndTime',
        value: function getCinemaTypesFromMoviesFromSelectedCinemaAndTime(movies, selected_cinema, selected_time) {
            var filteredCinemaTypes = [];
            var filteredMovies = [];
            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        for (var e in movies[m].cinemas[c][s].experiences) {
                            for (var st in selected_time.ranges) {
                                if (movies[m].cinemas[c][s].time_tag != undefined && movies[m].cinemas[c][s].time_tag != null) {
                                    if (selected_cinema.id == movies[m].cinemas[c][s].cinema_id && movies[m].cinemas[c][s].time_tag.includes(selected_time.ranges[st].hour + ":")) {
                                        var type_exists = false;
                                        var movie_exists = false;
                                        if (filteredCinemaTypes.length > 0) {
                                            for (var fc in filteredCinemaTypes) {
                                                if (filteredCinemaTypes[fc].name == movies[m].cinemas[c][s].experiences[e].name) {
                                                    type_exists = true;
                                                }
                                            }
                                        }

                                        if (filteredMovies.length > 0) {
                                            for (var fm in filteredMovies) {
                                                if (filteredMovies[fm].id == movies[m].id) {
                                                    movie_exists = true;
                                                }
                                            }
                                        }

                                        if (!type_exists) {
                                            filteredCinemaTypes.push(movies[m].cinemas[c][s].experiences[e]);
                                        }

                                        if (!movie_exists) {
                                            filteredMovies.push(movies[m]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { movies: filteredMovies, types: filteredCinemaTypes };
        }
    }, {
        key: 'getCinemaTypesFromMoviesFromSelectedCinemaAndTimeAndGenres',
        value: function getCinemaTypesFromMoviesFromSelectedCinemaAndTimeAndGenres(movies, selected_cinema, selected_time, selected_genres) {
            var filteredCinemaTypes = [];
            var filteredMovies = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        for (var e in movies[m].cinemas[c][s].experiences) {
                            for (var st in selected_time.ranges) {
                                if (movies[m].cinemas[c][s].time_tag != undefined && movies[m].cinemas[c][s].time_tag != null) {
                                    if (selected_cinema.id == movies[m].cinemas[c][s].cinema_id && movies[m].cinemas[c][s].time_tag.includes(selected_time.ranges[st].hour + ":")) {
                                        for (var g in movies[m].genres) {
                                            for (var sg in selected_genres) {
                                                if (movies[m].genres[g].id == selected_genres[sg].id) {
                                                    var type_exists = false;
                                                    var movie_exists = false;
                                                    if (filteredCinemaTypes.length > 0) {
                                                        for (var fc in filteredCinemaTypes) {
                                                            if (filteredCinemaTypes[fc].name == movies[m].cinemas[c][s].experiences[e].name) {
                                                                type_exists = true;
                                                            }
                                                        }
                                                    }

                                                    if (filteredMovies.length > 0) {
                                                        for (var fm in filteredMovies) {
                                                            if (filteredMovies[fm].id == movies[m].id) {
                                                                movie_exists = true;
                                                            }
                                                        }
                                                    }

                                                    if (!type_exists) {
                                                        filteredCinemaTypes.push(movies[m].cinemas[c][s].experiences[e]);
                                                    }

                                                    if (!movie_exists) {
                                                        filteredMovies.push(movies[m]);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { movies: filteredMovies, types: filteredCinemaTypes };
        }
    }, {
        key: 'getCinemaTypesFromMoviesFromSelectedCinemaAndGenres',
        value: function getCinemaTypesFromMoviesFromSelectedCinemaAndGenres(movies, selected_genres, selected_cinema) {
            var filteredCinemaTypes = [];
            var filteredMovies = [];
            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        for (var e in movies[m].cinemas[c][s].experiences) {
                            if (selected_cinema.id == movies[m].cinemas[c][s].cinema_id) {
                                for (var g in movies[m].genres) {
                                    for (var sg in selected_genres) {
                                        if (movies[m].genres[g].id == selected_genres[sg].id) {
                                            var type_exists = false;
                                            var movie_exists = false;
                                            if (filteredCinemaTypes.length > 0) {
                                                for (var fc in filteredCinemaTypes) {
                                                    if (filteredCinemaTypes[fc].name == movies[m].cinemas[c][s].experiences[e].name) {
                                                        type_exists = true;
                                                    }
                                                }
                                            }

                                            if (filteredMovies.length > 0) {
                                                for (var fm in filteredMovies) {
                                                    if (filteredMovies[fm].id == movies[m].id) {
                                                        movie_exists = true;
                                                    }
                                                }
                                            }

                                            if (!type_exists) {
                                                filteredCinemaTypes.push(movies[m].cinemas[c][s].experiences[e]);
                                            }

                                            if (!movie_exists) {
                                                filteredMovies.push(movies[m]);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { movies: filteredMovies, types: filteredCinemaTypes };
        }
    }, {
        key: 'getCinemaTypesFromMoviesFromSelectedTime',
        value: function getCinemaTypesFromMoviesFromSelectedTime(movies, selected_time) {
            var filteredCinemaTypes = [];
            var filteredMovies = [];
            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        for (var e in movies[m].cinemas[c][s].experiences) {
                            for (var st in selected_time.ranges) {
                                if (movies[m].cinemas[c][s].time_tag != undefined && movies[m].cinemas[c][s].time_tag != null) {
                                    if (movies[m].cinemas[c][s].time_tag.includes(selected_time.ranges[st].hour + ":")) {
                                        var type_exists = false;
                                        var movie_exists = false;
                                        if (filteredCinemaTypes.length > 0) {
                                            for (var fc in filteredCinemaTypes) {
                                                if (filteredCinemaTypes[fc].name == movies[m].cinemas[c][s].experiences[e].name) {
                                                    type_exists = true;
                                                }
                                            }
                                        }

                                        if (filteredMovies.length > 0) {
                                            for (var fm in filteredMovies) {
                                                if (filteredMovies[fm].id == movies[m].id) {
                                                    movie_exists = true;
                                                }
                                            }
                                        }

                                        if (!type_exists) {
                                            filteredCinemaTypes.push(movies[m].cinemas[c][s].experiences[e]);
                                        }

                                        if (!movie_exists) {
                                            filteredMovies.push(movies[m]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { movies: filteredMovies, types: filteredCinemaTypes };
        }
    }, {
        key: 'getCinemaTypesFromMoviesFromSelectedTimeAndGenres',
        value: function getCinemaTypesFromMoviesFromSelectedTimeAndGenres(movies, selected_time, selected_genres) {
            var filteredCinemaTypes = [];
            var filteredMovies = [];
            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        for (var e in movies[m].cinemas[c][s].experiences) {
                            for (var st in selected_time.ranges) {
                                if (movies[m].cinemas[c][s].time_tag != undefined && movies[m].cinemas[c][s].time_tag != null) {
                                    if (movies[m].cinemas[c][s].time_tag.includes(selected_time.ranges[st].hour + ":")) {
                                        for (var g in movies[m].genres) {
                                            for (var sg in selected_genres) {
                                                if (movies[m].genres[g].id == selected_genres[sg].id) {
                                                    var type_exists = false;
                                                    var movie_exists = false;
                                                    if (filteredCinemaTypes.length > 0) {
                                                        for (var fc in filteredCinemaTypes) {
                                                            if (filteredCinemaTypes[fc].name == movies[m].cinemas[c][s].experiences[e].name) {
                                                                type_exists = true;
                                                            }
                                                        }
                                                    }

                                                    if (filteredMovies.length > 0) {
                                                        for (var fm in filteredMovies) {
                                                            if (filteredMovies[fm].id == movies[m].id) {
                                                                movie_exists = true;
                                                            }
                                                        }
                                                    }

                                                    if (!type_exists) {
                                                        filteredCinemaTypes.push(movies[m].cinemas[c][s].experiences[e]);
                                                    }

                                                    if (!movie_exists) {
                                                        filteredMovies.push(movies[m]);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { movies: filteredMovies, types: filteredCinemaTypes };
        }
    }, {
        key: 'getCinemaTypesFromMoviesFromSelectedGenres',
        value: function getCinemaTypesFromMoviesFromSelectedGenres(movies, selected_genres) {
            var filteredCinemaTypes = [];
            var filteredMovies = [];
            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        for (var e in movies[m].cinemas[c][s].experiences) {

                            for (var g in movies[m].genres) {
                                for (var sg in selected_genres) {
                                    if (movies[m].genres[g].id == selected_genres[sg].id) {
                                        var type_exists = false;
                                        var movie_exists = false;
                                        if (filteredCinemaTypes.length > 0) {
                                            for (var fc in filteredCinemaTypes) {
                                                if (filteredCinemaTypes[fc].name == movies[m].cinemas[c][s].experiences[e].name) {
                                                    type_exists = true;
                                                }
                                            }
                                        }

                                        if (filteredMovies.length > 0) {
                                            for (var fm in filteredMovies) {
                                                if (filteredMovies[fm].id == movies[m].id) {
                                                    movie_exists = true;
                                                }
                                            }
                                        }

                                        if (!type_exists) {
                                            filteredCinemaTypes.push(movies[m].cinemas[c][s].experiences[e]);
                                        }

                                        if (!movie_exists) {
                                            filteredMovies.push(movies[m]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { movies: filteredMovies, types: filteredCinemaTypes };
        }
    }, {
        key: 'getCinemaTypesFromFilters',
        value: function getCinemaTypesFromFilters(movies, selected_cinema, selected_genres, selected_time) {

            switch (true) {
                case selected_cinema && selected_time && selected_genres != null && selected_genres.length > 0:
                    return Promise.resolve(this.getCinemaTypesFromMoviesFromSelectedCinemaAndTimeAndGenres(movies, selected_cinema, selected_time, selected_genres)).then(function (data) {
                        return data;
                    });
                    break;
                case selected_cinema && selected_time && (selected_genres == null || selected_genres.length == 0):
                    return Promise.resolve(this.getCinemaTypesFromMoviesFromSelectedCinemaAndTime(movies, selected_cinema, selected_time)).then(function (data) {
                        return data;
                    });
                    break;
                case selected_cinema && !selected_time && selected_genres != null && selected_genres.length > 0:
                    return Promise.resolve(this.getCinemaTypesFromMoviesFromSelectedCinemaAndGenres(movies, selected_genres, selected_cinema)).then(function (data) {
                        return data;
                    });
                    break;
                case selected_cinema && !selected_time && (selected_genres == null || selected_genres.length == 0):
                    return Promise.resolve(this.getCinemaTypesFromMoviesFromSelectedCinema(movies, selected_cinema)).then(function (data) {
                        return data;
                    });

                    break;
                case !selected_cinema && selected_time && (selected_genres == null || selected_genres.length == 0):
                    return Promise.resolve(this.getCinemaTypesFromMoviesFromSelectedTime(movies, selected_time)).then(function (data) {
                        return data;
                    });

                    break;
                case !selected_cinema && selected_time && selected_genres != null && selected_genres.length > 0:
                    return Promise.resolve(this.getCinemaTypesFromMoviesFromSelectedTimeAndGenres(movies, selected_time, selected_genres)).then(function (data) {
                        return data;
                    });

                    break;
                case !selected_cinema && !selected_time && selected_genres != null && selected_genres.length > 0:
                    return Promise.resolve(this.getCinemaTypesFromMoviesFromSelectedGenres(movies, selected_genres)).then(function (data) {
                        return data;
                    });

                    break;
                case !selected_cinema && !selected_time && (selected_genres == null || selected_genres.length == 0):
                    return { movies: movies, types: [] };
                    break;
            }
        }
    }, {
        key: 'separateDuplicateCinemaTypes',
        value: function separateDuplicateCinemaTypes(fitlered_types, all_types) {

            var otherTypes = [];
            if (fitlered_types.length > 0) {

                for (var at in all_types) {
                    var in_filtered_types = false;
                    for (var ft in fitlered_types) {
                        if (all_types[at].name == fitlered_types[ft].name) {
                            in_filtered_types = true;
                        }
                    }

                    var exists = false;
                    if (otherTypes.length > 0) {
                        for (var ot in otherTypes) {
                            if (otherTypes[ot].name == all_types[at].name) {
                                exists = true;
                            }
                        }
                    }

                    if (!exists && !in_filtered_types) {
                        otherTypes.push(all_types[at]);
                    }
                }

                return { filtered: fitlered_types, other: otherTypes };
            }

            return { filtered: [], other: all_types };
        }
    }, {
        key: 'getGenresFromMoviesFromSelectedCinemaAndTimeAndTypes',
        value: function getGenresFromMoviesFromSelectedCinemaAndTimeAndTypes(movies, selected_cinema, selected_time, selected_types) {
            var filteredGenres = [];
            var filteredMovies = [];

            for (var m in movies) {
                for (var g in movies[m].genres) {
                    for (var c in movies[m].cinemas) {
                        for (var s in movies[m].cinemas[c]) {
                            if (movies[m].cinemas[c][s].cinema_id == selected_cinema.id && movies[m].cinemas[c][s].time_tag.includes(selected_time.hour + ":")) {
                                for (var t in selected_types) {
                                    for (var e in movies[m].cinemas[c][s].experiences) {
                                        if (selected_types[t].name == movies[m].cinemas[c][s].experiences[e].name) {
                                            var genre_exists = false;
                                            var movie_exists = false;

                                            if (filteredGenres.length > 0) {
                                                for (var fg in filteredGenres) {
                                                    if (filteredGenres[fg].id == movies[m].genres[g].id) {
                                                        genre_exists = true;
                                                    }
                                                }
                                            }

                                            if (filteredMovies.length > 0) {
                                                for (var fm in filteredMovies) {
                                                    if (filteredMovies[fm].id == movies[m].id) {
                                                        movie_exists = true;
                                                    }
                                                }
                                            }

                                            if (!genre_exists) {
                                                filteredGenres.push(movies[m].genres[g]);
                                            }

                                            if (!movie_exists) {
                                                filteredMovies.push(movies[m]);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { genres: filteredGenres, movies: filteredMovies };
        }
    }, {
        key: 'getGenresFromMoviesFromSelectedCinemaAndTime',
        value: function getGenresFromMoviesFromSelectedCinemaAndTime(movies, selected_cinema, selected_time) {
            var filteredGenres = [];
            var filteredMovies = [];

            for (var m in movies) {
                for (var g in movies[m].genres) {
                    for (var c in movies[m].cinemas) {
                        for (var s in movies[m].cinemas[c]) {
                            if (movies[m].cinemas[c][s].cinema_id == selected_cinema.id && movies[m].cinemas[c][s].time_tag.includes(selected_time.hour + ":")) {
                                var genre_exists = false;
                                var movie_exists = false;

                                if (filteredGenres.length > 0) {
                                    for (var fg in filteredGenres) {
                                        if (filteredGenres[fg].id == movies[m].genres[g].id) {
                                            genre_exists = true;
                                        }
                                    }
                                }

                                if (filteredMovies.length > 0) {
                                    for (var fm in filteredMovies) {
                                        if (filteredMovies[fm].id == movies[m].id) {
                                            movie_exists = true;
                                        }
                                    }
                                }

                                if (!genre_exists) {
                                    filteredGenres.push(movies[m].genres[g]);
                                }

                                if (!movie_exists) {
                                    filteredMovies.push(movies[m]);
                                }
                            }
                        }
                    }
                }
            }

            return { genres: filteredGenres, movies: filteredMovies };
        }
    }, {
        key: 'getGenresFromMoviesFromSelectedCinemaAndTypes',
        value: function getGenresFromMoviesFromSelectedCinemaAndTypes(movies, selected_types, selected_cinema) {
            var filteredGenres = [];
            var filteredMovies = [];

            for (var m in movies) {
                for (var g in movies[m].genres) {
                    for (var c in movies[m].cinemas) {
                        for (var s in movies[m].cinemas[c]) {
                            if (movies[m].cinemas[c][s].cinema_id == selected_cinema.id) {
                                for (var t in selected_types) {
                                    for (var e in movies[m].cinemas[c][s].experiences) {
                                        if (selected_types[t].name == movies[m].cinemas[c][s].experiences[e].name) {
                                            var genre_exists = false;
                                            var movie_exists = false;

                                            if (filteredGenres.length > 0) {
                                                for (var fg in filteredGenres) {
                                                    if (filteredGenres[fg].id == movies[m].genres[g].id) {
                                                        genre_exists = true;
                                                    }
                                                }
                                            }

                                            if (filteredMovies.length > 0) {
                                                for (var fm in filteredMovies) {
                                                    if (filteredMovies[fm].id == movies[m].id) {
                                                        movie_exists = true;
                                                    }
                                                }
                                            }

                                            if (!genre_exists) {
                                                filteredGenres.push(movies[m].genres[g]);
                                            }

                                            if (!movie_exists) {
                                                filteredMovies.push(movies[m]);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { genres: filteredGenres, movies: filteredMovies };
        }
    }, {
        key: 'getGenresFromMoviesFromSelectedCinema',
        value: function getGenresFromMoviesFromSelectedCinema(movies, selected_cinema) {
            var filteredGenres = [];
            var filteredMovies = [];

            for (var m in movies) {
                for (var g in movies[m].genres) {
                    for (var c in movies[m].cinemas) {
                        for (var s in movies[m].cinemas[c]) {
                            if (movies[m].cinemas[c][s].cinema_id) {
                                var genre_exists = false;
                                var movie_exists = false;

                                if (filteredGenres.length > 0) {
                                    for (var fg in filteredGenres) {
                                        if (filteredGenres[fg].id == movies[m].genres[g].id) {
                                            genre_exists = true;
                                        }
                                    }
                                }

                                if (filteredMovies.length > 0) {
                                    for (var fm in filteredMovies) {
                                        if (filteredMovies[fm].id == movies[m].id) {
                                            movie_exists = true;
                                        }
                                    }
                                }

                                if (!genre_exists) {
                                    filteredGenres.push(movies[m].genres[g]);
                                }

                                if (!movie_exists) {
                                    filteredMovies.push(movies[m]);
                                }
                            }
                        }
                    }
                }
            }

            return { genres: filteredGenres, movies: filteredMovies };
        }
    }, {
        key: 'getGenresFromMoviesFromSelectedTime',
        value: function getGenresFromMoviesFromSelectedTime(movies, selected_time) {
            var filteredGenres = [];
            var filteredMovies = [];

            for (var m in movies) {
                for (var g in movies[m].genres) {
                    for (var c in movies[m].cinemas) {
                        for (var s in movies[m].cinemas[c]) {
                            if (movies[m].cinemas[c][s].time_tag.includes(selected_time.hour + ":")) {
                                var genre_exists = false;
                                var movie_exists = false;

                                if (filteredGenres.length > 0) {
                                    for (var fg in filteredGenres) {
                                        if (filteredGenres[fg].id == movies[m].genres[g].id) {
                                            genre_exists = true;
                                        }
                                    }
                                }

                                if (filteredMovies.length > 0) {
                                    for (var fm in filteredMovies) {
                                        if (filteredMovies[fm].id == movies[m].id) {
                                            movie_exists = true;
                                        }
                                    }
                                }

                                if (!genre_exists) {
                                    filteredGenres.push(movies[m].genres[g]);
                                }

                                if (!movie_exists) {
                                    filteredMovies.push(movies[m]);
                                }
                            }
                        }
                    }
                }
            }

            return { genres: filteredGenres, movies: filteredMovies };
        }
    }, {
        key: 'getGenresFromMoviesFromSelectedTimeAndTypes',
        value: function getGenresFromMoviesFromSelectedTimeAndTypes(movies, selected_time, selected_types) {
            var filteredGenres = [];
            var filteredMovies = [];

            for (var m in movies) {
                for (var g in movies[m].genres) {
                    for (var c in movies[m].cinemas) {
                        for (var s in movies[m].cinemas[c]) {
                            if (movies[m].cinemas[c][s].time_tag.includes(selected_time.hour + ":")) {
                                for (var t in selected_types) {
                                    for (var e in movies[m].cinemas[c][s].experiences) {
                                        if (selected_types[t].name == movies[m].cinemas[c][s].experiences[e].name) {
                                            var genre_exists = false;
                                            var movie_exists = false;

                                            if (filteredGenres.length > 0) {
                                                for (var fg in filteredGenres) {
                                                    if (filteredGenres[fg].id == movies[m].genres[g].id) {
                                                        genre_exists = true;
                                                    }
                                                }
                                            }

                                            if (filteredMovies.length > 0) {
                                                for (var fm in filteredMovies) {
                                                    if (filteredMovies[fm].id == movies[m].id) {
                                                        movie_exists = true;
                                                    }
                                                }
                                            }

                                            if (!genre_exists) {
                                                filteredGenres.push(movies[m].genres[g]);
                                            }

                                            if (!movie_exists) {
                                                filteredMovies.push(movies[m]);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { genres: filteredGenres, movies: filteredMovies };
        }
    }, {
        key: 'getGenresFromMoviesFromSelectedTypes',
        value: function getGenresFromMoviesFromSelectedTypes(movies, selected_types) {
            var filteredGenres = [];
            var filteredMovies = [];

            for (var m in movies) {
                for (var g in movies[m].genres) {
                    for (var c in movies[m].cinemas) {
                        for (var s in movies[m].cinemas[c]) {
                            for (var t in selected_types) {
                                for (var e in movies[m].cinemas[c][s].experiences) {
                                    if (selected_types[t].name == movies[m].cinemas[c][s].experiences[e].name) {
                                        var genre_exists = false;
                                        var movie_exists = false;

                                        if (filteredGenres.length > 0) {
                                            for (var fg in filteredGenres) {
                                                if (filteredGenres[fg].id == movies[m].genres[g].id) {
                                                    genre_exists = true;
                                                }
                                            }
                                        }

                                        if (filteredMovies.length > 0) {
                                            for (var fm in filteredMovies) {
                                                if (filteredMovies[fm].id == movies[m].id) {
                                                    movie_exists = true;
                                                }
                                            }
                                        }

                                        if (!genre_exists) {
                                            filteredGenres.push(movies[m].genres[g]);
                                        }

                                        if (!movie_exists) {
                                            filteredMovies.push(movies[m]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { genres: filteredGenres, movies: filteredMovies };
        }
    }, {
        key: 'getGenresFromFilters',
        value: function getGenresFromFilters(movies, selected_cinema, selected_types, selected_time) {

            var filteredMoviesByCinema = [];
            if (selected_cinema && selected_cinema.id > 0) {
                for (var m in movies) {
                    for (var c in movies[m].cinemas) {
                        for (var s in movies[m].cinemas[c]) {
                            if (movies[m].cinemas[c][s].cinema_id == selected_cinema.id) {
                                var exists = false;

                                if (filteredMoviesByCinema.length > 0) {
                                    for (var fmc in filteredMoviesByCinema) {
                                        if (filteredMoviesByCinema[fmc].id == movies[m].id) {
                                            exists = true;
                                        }
                                    }
                                }

                                if (!exists) {
                                    filteredMoviesByCinema.push(movies[m]);
                                }
                            }
                        }
                    }
                }

                movies = filteredMoviesByCinema;
            }

            var filteredMoviesByTypes = [];
            if (selected_types && selected_types.length > 0) {
                for (var _m5 in movies) {
                    for (var _c3 in movies[_m5].cinemas) {
                        for (var _s2 in movies[_m5].cinemas[_c3]) {
                            for (var e in movies[_m5].cinemas[_c3][_s2].experiences) {
                                for (var tg in selected_types) {
                                    for (var t in selected_types[tg].types) {
                                        var _exists7 = false;
                                        if (selected_types[tg].types[t].name == movies[_m5].cinemas[_c3][_s2].experiences[e].name) {
                                            if (filteredMoviesByTypes.length > 0) {
                                                for (var fm in filteredMoviesByTypes) {
                                                    if (filteredMoviesByTypes[fm].id == movies[_m5].id) {
                                                        _exists7 = true;
                                                    }
                                                }
                                            }

                                            if (!_exists7) {
                                                filteredMoviesByTypes.push(movies[_m5]);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                movies = filteredMoviesByTypes;
            }

            var filteredMoviesByTimes = [];
            if (selected_time) {
                for (var _m6 in movies) {
                    for (var _c4 in movies[_m6].cinemas) {
                        for (var _s3 in movies[_m6].cinemas[_c4]) {
                            for (var st in selected_time.ranges) {
                                if (movies[_m6].cinemas[_c4][_s3].time_tag != undefined && movies[_m6].cinemas[_c4][_s3].time_tag != null) {
                                    if (movies[_m6].cinemas[_c4][_s3].time_tag.includes(selected_time.ranges[st].hour + ":")) {
                                        var _exists8 = false;
                                        if (filteredMoviesByTimes.length > 0) {
                                            for (var fmt in filteredMoviesByTimes) {
                                                if (filteredMoviesByTimes[fmt].id == movies[_m6].id) {
                                                    _exists8 = true;
                                                }
                                            }
                                        }

                                        if (!_exists8) {
                                            filteredMoviesByTimes.push(movies[_m6]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                movies = filteredMoviesByTimes;
            }

            var genres = [];
            for (var _m7 in movies) {
                for (var g in movies[_m7].genres) {
                    var _exists9 = false;
                    if (genres.length > 0) {
                        for (var gg in genres) {
                            if (genres[gg].id == movies[_m7].genres[g].id) {
                                _exists9 = true;
                            }
                        }
                    }

                    if (!_exists9) {
                        genres.push(movies[_m7].genres[g]);
                    }
                }
            }

            return genres;
        }
    }, {
        key: 'separateDuplicateGenres',
        value: function separateDuplicateGenres(filtered_genres, all_genres) {
            var otherGenres = [];
            if (filtered_genres.length > 0) {

                for (var at in all_genres) {
                    var in_filtered_genres = false;
                    for (var ft in filtered_genres) {
                        if (all_genres[at].id == filtered_genres[ft].id) {
                            in_filtered_genres = true;
                        }
                    }

                    var exists = false;
                    if (otherGenres.length > 0) {
                        for (var ot in otherGenres) {
                            if (otherGenres[ot].id == all_genres[at].id) {
                                exists = true;
                            }
                        }
                    }

                    if (!exists && !in_filtered_genres) {
                        otherGenres.push(all_genres[at]);
                    }
                }

                return { filtered: filtered_genres, other: otherGenres };
            }

            return { filtered: [], other: all_genres };
        }
    }, {
        key: 'generateAvailableTypesAndGenres',
        value: function generateAvailableTypesAndGenres(movies, meta, selected_cinema, selected_types, selected_genres, selected_time, type_groups) {
            var _this5 = this;

            var cinema_selection_for_types = null;
            if (selected_cinema) {
                if (selected_cinema.id > 0) {
                    cinema_selection_for_types = selected_cinema;
                }
            }
            return Promise.all([this.getCinemaTypesFromFilters(movies, cinema_selection_for_types, selected_genres, selected_time), this.getGenresFromFilters(movies, selected_cinema, selected_types, selected_time)]).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    types_from_filters = _ref2[0],
                    genres_from_filters = _ref2[1];

                return Promise.all([_this5.separateDuplicateCinemaTypes(types_from_filters.types, meta.experiences), _this5.separateDuplicateGenres(genres_from_filters, meta.genres)]).then(function (_ref3) {
                    var _ref4 = _slicedToArray(_ref3, 2),
                        types = _ref4[0],
                        genres = _ref4[1];

                    var typeOptions = [];
                    var typeOptionsFiltered = [];
                    var typeOptionsOther = [];

                    for (var tg in type_groups) {
                        for (var t in type_groups[tg].types) {
                            for (var tf in types.filtered) {
                                var exists = false;
                                if (types.filtered[tf].name == type_groups[tg].types[t].name) {
                                    if (typeOptionsFiltered.length > 0) {
                                        for (var tof in typeOptionsFiltered) {
                                            if (typeOptionsFiltered[tof].name == type_groups[tg].name) {
                                                exists = true;
                                            }
                                        }
                                    }

                                    if (!exists) {
                                        typeOptionsFiltered.push(type_groups[tg]);
                                    }
                                }
                            }

                            for (var to in types.other) {
                                var _exists10 = false;
                                if (types.other[to].name == type_groups[tg].types[t].name) {
                                    if (typeOptionsOther.length > 0) {
                                        for (var too in typeOptionsOther) {
                                            if (typeOptionsOther[too].name == type_groups[tg].name) {
                                                _exists10 = true;
                                            }
                                        }
                                    }

                                    if (!_exists10) {
                                        typeOptionsOther.push(type_groups[tg]);
                                    }
                                }
                            }
                        }
                    }

                    var otherTypes = [];

                    for (var _to in typeOptionsOther) {
                        var existsInFitlered = false;
                        for (var ft in typeOptionsFiltered) {
                            if (typeOptionsOther[_to].name == typeOptionsFiltered[ft].name) {
                                existsInFitlered = true;
                            }
                        }

                        if (!existsInFitlered) {
                            otherTypes.push(typeOptionsOther[_to]);
                        }
                    }

                    typeOptionsOther = otherTypes;

                    typeOptions = [{ label: "Cinema types based on your filter", items: typeOptionsFiltered }, { label: "Other Cinema Types", items: typeOptionsOther }];
                    var genreOptions = [{ label: "Genres based on your filter", items: genres.filtered }, { label: "Other Genres", items: genres.other }];
                    var combined = [{ label: "Cinema types based on your filter", items: types.filtered }, { label: "Other Cinema Types", items: types.other }, { label: "Genres based on your filter", items: genres.filtered }, { label: "Other Genres", items: genres.other }];

                    return { types: typeOptions, genres: genreOptions, combined: combined };
                });
            });
        }
    }, {
        key: 'getCinemasFromMoviesForSelectedTimeAndTypesAndGenres',
        value: function getCinemasFromMoviesForSelectedTimeAndTypesAndGenres(movies, selected_time, selected_types, selected_genres) {
            var filteredMovies = [];
            var filteredCinemas = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        if (movies[m].cinemas[c][s].time_tag.includes(selected_time.hour + ":")) {
                            for (var e in movies[m].cinemas[c][s].experiences) {
                                for (var st in selected_types) {
                                    if (movies[m].cinemas[c][s].experiences[e].name == selected_types[st].name) {
                                        for (var g in movies[m].genres) {
                                            for (var sg in selected_genres) {
                                                var movie_exists = false;
                                                var cinema_exists = false;
                                                if (selected_genres[sg].id == movies[m].genres[g].id) {
                                                    if (filteredCinemas.length > 0) {
                                                        for (var fc in filteredCinemas) {
                                                            if (movies[m].cinemas[c][s].cinema != undefined) {
                                                                if (filteredCinemas[fc].id == movies[m].cinemas[c][s].cinema.id) {
                                                                    cinema_exists = true;
                                                                }
                                                            }
                                                        }
                                                    }

                                                    if (filteredMovies.length > 0) {
                                                        for (var fm in filteredMovies) {
                                                            if (filteredMovies[fm].id == movies[m].id) {
                                                                movie_exists = true;
                                                            }
                                                        }
                                                    }

                                                    if (!cinema_exists) {
                                                        filteredCinemas.push(movies[m].cinemas[c][s].cinema);
                                                    }

                                                    if (!movie_exists) {
                                                        filteredMovies.push(movies[m]);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { cinemas: filteredCinemas, movies: filteredMovies };
        }
    }, {
        key: 'getCinemasFromMoviesForSelectedTimeAndTypes',
        value: function getCinemasFromMoviesForSelectedTimeAndTypes(movies, selected_time, selected_types) {
            var filteredMovies = [];
            var filteredCinemas = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        if (movies[m].cinemas[c][s].time_tag.includes(selected_time.hour + ":")) {
                            for (var e in movies[m].cinemas[c][s].experiences) {
                                for (var st in selected_types) {
                                    var movie_exists = false;
                                    var cinema_exists = false;
                                    if (movies[m].cinemas[c][s].experiences[e].name == selected_types[st].name) {

                                        if (filteredCinemas.length > 0) {
                                            for (var fc in filteredCinemas) {
                                                if (movies[m].cinemas[c][s].cinema != undefined) {
                                                    if (filteredCinemas[fc].id == movies[m].cinemas[c][s].cinema.id) {
                                                        cinema_exists = true;
                                                    }
                                                }
                                            }
                                        }

                                        if (filteredMovies.length > 0) {
                                            for (var fm in filteredMovies) {
                                                if (filteredMovies[fm].id == movies[m].id) {
                                                    movie_exists = true;
                                                }
                                            }
                                        }

                                        if (!cinema_exists) {
                                            filteredCinemas.push(movies[m].cinemas[c][s].cinema);
                                        }

                                        if (!movie_exists) {
                                            filteredMovies.push(movies[m]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { cinemas: filteredCinemas, movies: filteredMovies };
        }
    }, {
        key: 'getCinemasFromMoviesForSelectedTimeAndGenres',
        value: function getCinemasFromMoviesForSelectedTimeAndGenres(movies, selected_time, selected_genres) {
            var filteredMovies = [];
            var filteredCinemas = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        if (movies[m].cinemas[c][s].time_tag.includes(selected_time.hour + ":")) {
                            for (var g in movies[m].genres) {
                                for (var sg in selected_genres) {
                                    var movie_exists = false;
                                    var cinema_exists = false;
                                    if (selected_genres[sg].id == movies[m].genres[g].id) {
                                        if (filteredCinemas.length > 0) {
                                            for (var fc in filteredCinemas) {
                                                if (movies[m].cinemas[c][s].cinema != undefined) {
                                                    if (filteredCinemas[fc].id == movies[m].cinemas[c][s].cinema.id) {
                                                        cinema_exists = true;
                                                    }
                                                }
                                            }
                                        }

                                        if (filteredMovies.length > 0) {
                                            for (var fm in filteredMovies) {
                                                if (filteredMovies[fm].id == movies[m].id) {
                                                    movie_exists = true;
                                                }
                                            }
                                        }

                                        if (!cinema_exists) {
                                            filteredCinemas.push(movies[m].cinemas[c][s].cinema);
                                        }

                                        if (!movie_exists) {
                                            filteredMovies.push(movies[m]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { cinemas: filteredCinemas, movies: filteredMovies };
        }
    }, {
        key: 'getCinemasFromMoviesForSelectedTypesAndGenres',
        value: function getCinemasFromMoviesForSelectedTypesAndGenres(movies, selected_types, selected_genres) {
            var filteredMovies = [];
            var filteredCinemas = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        for (var e in movies[m].cinemas[c][s].experiences) {
                            for (var st in selected_types) {
                                if (movies[m].cinemas[c][s].experiences[e].name == selected_types[st].name) {
                                    for (var g in movies[m].genres) {
                                        for (var sg in selected_genres) {
                                            var movie_exists = false;
                                            var cinema_exists = false;
                                            if (selected_genres[sg].id == movies[m].genres[g].id) {
                                                if (filteredCinemas.length > 0) {
                                                    for (var fc in filteredCinemas) {
                                                        if (movies[m].cinemas[c][s].cinema != undefined) {
                                                            if (filteredCinemas[fc].id == movies[m].cinemas[c][s].cinema.id) {
                                                                cinema_exists = true;
                                                            }
                                                        }
                                                    }
                                                }

                                                if (filteredMovies.length > 0) {
                                                    for (var fm in filteredMovies) {
                                                        if (filteredMovies[fm].id == movies[m].id) {
                                                            movie_exists = true;
                                                        }
                                                    }
                                                }

                                                if (!cinema_exists) {
                                                    filteredCinemas.push(movies[m].cinemas[c][s].cinema);
                                                }

                                                if (!movie_exists) {
                                                    filteredMovies.push(movies[m]);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { cinemas: filteredCinemas, movies: filteredMovies };
        }
    }, {
        key: 'getCinemasFromMoviesForSelectedTime',
        value: function getCinemasFromMoviesForSelectedTime(movies, selected_time) {
            var filteredMovies = [];
            var filteredCinemas = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        if (movies[m].cinemas[c][s].time_tag.includes(selected_time.hour + ":")) {
                            var movie_exists = false;
                            var cinema_exists = false;

                            if (filteredCinemas.length > 0) {
                                for (var fc in filteredCinemas) {
                                    if (movies[m].cinemas[c][s].cinema != undefined) {
                                        if (filteredCinemas[fc].id == movies[m].cinemas[c][s].cinema.id) {
                                            cinema_exists = true;
                                        }
                                    }
                                }
                            }

                            if (filteredMovies.length > 0) {
                                for (var fm in filteredMovies) {
                                    if (filteredMovies[fm].id == movies[m].id) {
                                        movie_exists = true;
                                    }
                                }
                            }

                            if (!cinema_exists) {
                                filteredCinemas.push(movies[m].cinemas[c][s].cinema);
                            }

                            if (!movie_exists) {
                                filteredMovies.push(movies[m]);
                            }
                        }
                    }
                }
            }

            return { cinemas: filteredCinemas, movies: filteredMovies };
        }
    }, {
        key: 'getCinemasFromMoviesForSelectedTypes',
        value: function getCinemasFromMoviesForSelectedTypes(movies, selected_types) {
            var filteredMovies = [];
            var filteredCinemas = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        for (var e in movies[m].cinemas[c][s].experiences) {
                            for (var st in selected_types) {
                                var movie_exists = false;
                                var cinema_exists = false;
                                if (movies[m].cinemas[c][s].experiences[e].name == selected_types[st].name) {

                                    if (filteredCinemas.length > 0) {
                                        for (var fc in filteredCinemas) {
                                            if (movies[m].cinemas[c][s].cinema != undefined) {
                                                if (filteredCinemas[fc].id == movies[m].cinemas[c][s].cinema.id) {
                                                    cinema_exists = true;
                                                }
                                            }
                                        }
                                    }

                                    if (filteredMovies.length > 0) {
                                        for (var fm in filteredMovies) {
                                            if (filteredMovies[fm].id == movies[m].id) {
                                                movie_exists = true;
                                            }
                                        }
                                    }

                                    if (!cinema_exists) {
                                        filteredCinemas.push(movies[m].cinemas[c][s].cinema);
                                    }

                                    if (!movie_exists) {
                                        filteredMovies.push(movies[m]);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { cinemas: filteredCinemas, movies: filteredMovies };
        }
    }, {
        key: 'getCinemasFromMoviesForSelectedGenres',
        value: function getCinemasFromMoviesForSelectedGenres(movies, selected_genres) {
            var filteredMovies = [];
            var filteredCinemas = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        for (var g in movies[m].genres) {
                            for (var sg in selected_genres) {
                                var movie_exists = false;
                                var cinema_exists = false;
                                if (selected_genres[sg].id == movies[m].genres[g].id) {
                                    if (filteredCinemas.length > 0) {
                                        for (var fc in filteredCinemas) {
                                            if (movies[m].cinemas[c][s].cinema != undefined) {
                                                if (filteredCinemas[fc].id == movies[m].cinemas[c][s].cinema.id) {
                                                    cinema_exists = true;
                                                }
                                            }
                                        }
                                    }

                                    if (filteredMovies.length > 0) {
                                        for (var fm in filteredMovies) {
                                            if (filteredMovies[fm].id == movies[m].id) {
                                                movie_exists = true;
                                            }
                                        }
                                    }

                                    if (!cinema_exists) {
                                        filteredCinemas.push(movies[m].cinemas[c][s].cinema);
                                    }

                                    if (!movie_exists) {
                                        filteredMovies.push(movies[m]);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { cinemas: filteredCinemas, movies: filteredMovies };
        }
    }, {
        key: 'sortCinemasAlphaAsc',
        value: function sortCinemasAlphaAsc(cinemas) {
            if (cinemas.length > 0) {
                cinemas.sort(function (a, b) {
                    return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
                });

                return cinemas;
            }
            return cinemas;
        }
    }, {
        key: 'getRegionsBasedOnFilterSelection',
        value: function getRegionsBasedOnFilterSelection(movies, selected_types, selected_genres, selected_time) {
            var checked_types = false;
            var checked_genres = false;
            var checked_time = false;
            var filteredMoviesByTypes = [];
            if (selected_types && selected_types.length > 0) {
                for (var m in movies) {
                    for (var c in movies[m].cinemas) {
                        for (var s in movies[m].cinemas[c]) {
                            for (var e in movies[m].cinemas[c][s].experiences) {
                                for (var tg in selected_types) {
                                    for (var t in selected_types[tg].types) {
                                        var exists = false;
                                        if (selected_types[tg].types[t].name == movies[m].cinemas[c][s].experiences[e].name) {
                                            if (filteredMoviesByTypes.length > 0) {
                                                for (var fm in filteredMoviesByTypes) {
                                                    if (filteredMoviesByTypes[fm].id == movies[m].id) {
                                                        exists = true;
                                                    }
                                                }
                                            }

                                            if (!exists) {
                                                filteredMoviesByTypes.push(movies[m]);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                checked_types = true;
                movies = filteredMoviesByTypes;
            }

            var filteredMoviesByTimes = [];
            if (selected_time && selected_time != null && (typeof selected_time === 'undefined' ? 'undefined' : _typeof(selected_time)) == "object") {
                for (var _m8 in movies) {
                    for (var _c5 in movies[_m8].cinemas) {
                        for (var _s4 in movies[_m8].cinemas[_c5]) {
                            for (var st in selected_time.ranges) {
                                if (movies[_m8].cinemas[_c5][_s4].time_tag != undefined && movies[_m8].cinemas[_c5][_s4].time_time != null) {
                                    if (movies[_m8].cinemas[_c5][_s4].time_tag.includes(selected_time.ranges[st].hour + ":")) {
                                        var _exists11 = false;
                                        if (filteredMoviesByTimes.length > 0) {
                                            for (var fmt in filteredMoviesByTimes) {
                                                if (filteredMoviesByTimes[fmt].id == movies[_m8].id) {
                                                    _exists11 = true;
                                                }
                                            }
                                        }

                                        if (!_exists11) {
                                            filteredMoviesByTimes.push(movies[_m8]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                checked_time = true;
                movies = filteredMoviesByTimes;
            }

            var filteredMoviesByGenres = [];
            if (selected_genres && selected_genres.length > 0) {
                for (var _m9 in movies) {
                    for (var g in movies[_m9].genres) {
                        for (var sg in selected_genres) {
                            var _exists12 = false;
                            if (selected_genres[sg].id == movies[_m9].genres[g].id) {
                                if (filteredMoviesByGenres.length > 0) {
                                    for (var fmg in filteredMoviesByGenres) {
                                        if (filteredMoviesByGenres[fmg].id == movies[_m9].id) {
                                            _exists12 = true;
                                        }
                                    }
                                }

                                if (!_exists12) {
                                    filteredMoviesByGenres.push(movies[_m9]);
                                }
                            }
                        }
                    }
                }
                checked_genres = true;
                movies = filteredMoviesByGenres;
            }

            var cinemas = [];

            if (checked_types || checked_genres || checked_time) {
                for (var _m10 in movies) {
                    for (var _c6 in movies[_m10].cinemas) {
                        for (var _s5 in movies[_m10].cinemas[_c6]) {
                            var _exists13 = false;

                            if (cinemas.length > 0) {
                                for (var ci in cinemas) {
                                    if (movies[_m10].cinemas[_c6][_s5].cinema != undefined && cinemas[ci] != undefined && _typeof(cinemas[ci]) == "object") {
                                        if (cinemas[ci].id == movies[_m10].cinemas[_c6][_s5].cinema.id) {
                                            _exists13 = true;
                                        }
                                    }
                                }
                            }

                            if (movies[_m10].cinemas[_c6][_s5].cinema != undefined && movies[_m10].cinemas[_c6][_s5].cinema != null) {
                                if (!_exists13) {
                                    cinemas.push(movies[_m10].cinemas[_c6][_s5].cinema);
                                }
                            }
                        }
                    }
                }

                return Promise.resolve(this.sortCinemasAlphaAsc(cinemas)).then(function (sorted_cinemas) {
                    return { cinemas: sorted_cinemas, movies: movies };
                });
            }

            return { cinemas: cinemas, movies: movies };
        }
    }, {
        key: 'separateTimeRanges',
        value: function separateTimeRanges(time_tags, time_ranges) {
            var filteredTimes = [];
            var otherTimes = [];

            if (time_tags.length > 0) {
                for (var tr in time_ranges) {
                    for (var tt in time_tags) {
                        var tag_exists = false;
                        var other_exists = false;
                        if (time_tags[tt].includes(time_ranges[tr].hour + ":")) {
                            if (filteredTimes.length > 0) {
                                for (var ft in filteredTimes) {
                                    if (filteredTimes[ft].hour == time_ranges[tr].hour) {
                                        tag_exists = true;
                                    }
                                }
                            }

                            if (!tag_exists) {
                                filteredTimes.push(time_ranges[tr]);
                            }
                        } else {
                            var add_to_other = true;
                            if (otherTimes.length > 0) {
                                for (var ot in otherTimes) {

                                    if (otherTimes[ot].hour == time_ranges[tr].hour) {
                                        other_exists = true;
                                    }
                                }
                            }

                            if (filteredTimes.length > 0) {
                                for (var _ft in filteredTimes) {
                                    if (filteredTimes[_ft].hour == time_ranges[tr].hour) {
                                        add_to_other = false;
                                    }
                                }
                            }

                            if (add_to_other) {
                                if (!other_exists) {
                                    otherTimes.push(time_ranges[tr]);
                                }
                            }
                        }
                    }
                }
            } else {
                otherTimes = time_ranges;
            }

            for (var _ft2 in filteredTimes) {
                for (var _ot in otherTimes) {
                    if (filteredTimes[_ft2].hour == otherTimes[_ot].hour) {
                        otherTimes.splice(_ot, 1);
                    }
                }
            }

            return [{ name: "Time ranges based on your filter", items: filteredTimes }, { name: "Other time ranges", items: otherTimes }];
        }
    }, {
        key: 'getTimesFromMoviesForSelectedCinemaAndTypesAndGenres',
        value: function getTimesFromMoviesForSelectedCinemaAndTypesAndGenres(movies, selected_cinema, selected_types, selected_genres) {
            var filteredMovies = [];
            var filteredTimes = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        if (movies[m].cinemas[c][s].cinema.id == selected_cinema.id) {
                            for (var e in movies[m].cinemas[c][s].experiences) {
                                for (var st in selected_types) {
                                    if (movies[m].cinemas[c][s].experiences[e].name == selected_types[st].name) {
                                        for (var g in movies[m].genres) {
                                            for (var sg in selected_genres) {
                                                var movie_exists = false;
                                                var time_exists = false;

                                                if (selected_genres[sg].id == movies[m].genres[g].id) {
                                                    if (filteredTimes.length > 0) {
                                                        for (var fc in filteredTimes) {
                                                            if (filteredTimes[fc] == movies[m].cinemas[c][s].time_tag) {
                                                                time_exists = true;
                                                            }
                                                        }
                                                    }

                                                    if (filteredMovies.length > 0) {
                                                        for (var fm in filteredMovies) {
                                                            if (filteredMovies[fm].id == movies[m].id) {
                                                                movie_exists = true;
                                                            }
                                                        }
                                                    }

                                                    if (!time_exists) {
                                                        filteredTimes.push(movies[m].cinemas[c][s].time_tag);
                                                    }

                                                    if (!movie_exists) {
                                                        filteredMovies.push(movies[m]);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { time_tags: filteredTimes, movies: movies };
        }
    }, {
        key: 'getTimesFromMoviesForSelectedCinemaAndGenres',
        value: function getTimesFromMoviesForSelectedCinemaAndGenres(movies, selected_cinema, selected_genres) {
            var filteredMovies = [];
            var filteredTimes = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        if (movies[m].cinemas[c][s].cinema.id == selected_cinema.id) {
                            for (var g in movies[m].genres) {
                                for (var sg in selected_genres) {
                                    var movie_exists = false;
                                    var time_exists = false;

                                    if (selected_genres[sg].id == movies[m].genres[g].id) {
                                        if (filteredTimes.length > 0) {
                                            for (var fc in filteredTimes) {
                                                if (filteredTimes[fc] == movies[m].cinemas[c][s].time_tag) {
                                                    time_exists = true;
                                                }
                                            }
                                        }

                                        if (filteredMovies.length > 0) {
                                            for (var fm in filteredMovies) {
                                                if (filteredMovies[fm].id == movies[m].id) {
                                                    movie_exists = true;
                                                }
                                            }
                                        }

                                        if (!time_exists) {
                                            filteredTimes.push(movies[m].cinemas[c][s].time_tag);
                                        }

                                        if (!movie_exists) {
                                            filteredMovies.push(movies[m]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { time_tags: filteredTimes, movies: movies };
        }
    }, {
        key: 'getTimesFromMoviesForSelectedCinemaAndTypes',
        value: function getTimesFromMoviesForSelectedCinemaAndTypes(movies, selected_cinema, selected_types) {
            var filteredMovies = [];
            var filteredTimes = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        if (movies[m].cinemas[c][s].cinema.id == selected_cinema.id) {
                            for (var e in movies[m].cinemas[c][s].experiences) {
                                for (var st in selected_types) {
                                    if (movies[m].cinemas[c][s].experiences[e].name == selected_types[st].name) {
                                        var movie_exists = false;
                                        var time_exists = false;
                                        if (filteredTimes.length > 0) {
                                            for (var fc in filteredTimes) {
                                                if (filteredTimes[fc] == movies[m].cinemas[c][s].time_tag) {
                                                    time_exists = true;
                                                }
                                            }
                                        }

                                        if (filteredMovies.length > 0) {
                                            for (var fm in filteredMovies) {
                                                if (filteredMovies[fm].id == movies[m].id) {
                                                    movie_exists = true;
                                                }
                                            }
                                        }

                                        if (!time_exists) {
                                            filteredTimes.push(movies[m].cinemas[c][s].time_tag);
                                        }

                                        if (!movie_exists) {
                                            filteredMovies.push(movies[m]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { time_tags: filteredTimes, movies: movies };
        }
    }, {
        key: 'getTimesFromMoviesForSelectedCinema',
        value: function getTimesFromMoviesForSelectedCinema(movies, selected_cinema) {
            var filteredMovies = [];
            var filteredTimes = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        if (movies[m].cinemas[c][s].cinema.id == selected_cinema.id) {

                            var movie_exists = false;
                            var time_exists = false;
                            if (filteredTimes.length > 0) {
                                for (var fc in filteredTimes) {
                                    if (filteredTimes[fc] == movies[m].cinemas[c][s].time_tag) {
                                        time_exists = true;
                                    }
                                }
                            }

                            if (filteredMovies.length > 0) {
                                for (var fm in filteredMovies) {
                                    if (filteredMovies[fm].id == movies[m].id) {
                                        movie_exists = true;
                                    }
                                }
                            }

                            if (!time_exists) {
                                filteredTimes.push(movies[m].cinemas[c][s].time_tag);
                            }

                            if (!movie_exists) {
                                filteredMovies.push(movies[m]);
                            }
                        }
                    }
                }
            }

            return { time_tags: filteredTimes, movies: movies };
        }
    }, {
        key: 'getTimesFromMoviesForSelectedTypesAndGenres',
        value: function getTimesFromMoviesForSelectedTypesAndGenres(movies, selected_types, selected_genres) {
            var filteredMovies = [];
            var filteredTimes = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        for (var e in movies[m].cinemas[c][s].experiences) {
                            for (var st in selected_types) {
                                if (movies[m].cinemas[c][s].experiences[e].name == selected_types[st].name) {
                                    for (var g in movies[m].genres) {
                                        for (var sg in selected_genres) {
                                            var movie_exists = false;
                                            var time_exists = false;

                                            if (selected_genres[sg].id == movies[m].genres[g].id) {
                                                if (filteredTimes.length > 0) {
                                                    for (var fc in filteredTimes) {
                                                        if (filteredTimes[fc] == movies[m].cinemas[c][s].time_tag) {
                                                            time_exists = true;
                                                        }
                                                    }
                                                }

                                                if (filteredMovies.length > 0) {
                                                    for (var fm in filteredMovies) {
                                                        if (filteredMovies[fm].id == movies[m].id) {
                                                            movie_exists = true;
                                                        }
                                                    }
                                                }

                                                if (!time_exists) {
                                                    filteredTimes.push(movies[m].cinemas[c][s].time_tag);
                                                }

                                                if (!movie_exists) {
                                                    filteredMovies.push(movies[m]);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { time_tags: filteredTimes, movies: movies };
        }
    }, {
        key: 'getTimesFromMoviesForSelectedTypes',
        value: function getTimesFromMoviesForSelectedTypes(movies, selected_types) {
            var filteredMovies = [];
            var filteredTimes = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        for (var e in movies[m].cinemas[c][s].experiences) {
                            for (var st in selected_types) {
                                if (movies[m].cinemas[c][s].experiences[e].name == selected_types[st].name) {
                                    var movie_exists = false;
                                    var time_exists = false;
                                    if (filteredTimes.length > 0) {
                                        for (var fc in filteredTimes) {
                                            if (filteredTimes[fc] == movies[m].cinemas[c][s].time_tag) {
                                                time_exists = true;
                                            }
                                        }
                                    }

                                    if (filteredMovies.length > 0) {
                                        for (var fm in filteredMovies) {
                                            if (filteredMovies[fm].id == movies[m].id) {
                                                movie_exists = true;
                                            }
                                        }
                                    }

                                    if (!time_exists) {
                                        filteredTimes.push(movies[m].cinemas[c][s].time_tag);
                                    }

                                    if (!movie_exists) {
                                        filteredMovies.push(movies[m]);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { time_tags: filteredTimes, movies: movies };
        }
    }, {
        key: 'getTimesFromMoviesForSelectedGenres',
        value: function getTimesFromMoviesForSelectedGenres(movies, selected_genres) {
            var filteredMovies = [];
            var filteredTimes = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        for (var g in movies[m].genres) {
                            for (var sg in selected_genres) {
                                var movie_exists = false;
                                var time_exists = false;

                                if (selected_genres[sg].id == movies[m].genres[g].id) {
                                    if (filteredTimes.length > 0) {
                                        for (var fc in filteredTimes) {
                                            if (filteredTimes[fc] == movies[m].cinemas[c][s].time_tag) {
                                                time_exists = true;
                                            }
                                        }
                                    }

                                    if (filteredMovies.length > 0) {
                                        for (var fm in filteredMovies) {
                                            if (filteredMovies[fm].id == movies[m].id) {
                                                movie_exists = true;
                                            }
                                        }
                                    }

                                    if (!time_exists) {
                                        filteredTimes.push(movies[m].cinemas[c][s].time_tag);
                                    }

                                    if (!movie_exists) {
                                        filteredMovies.push(movies[m]);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return { time_tags: filteredTimes, movies: movies };
        }
    }, {
        key: 'getTimesBasedOnFilterSelection',
        value: function getTimesBasedOnFilterSelection(movies, selected_cinema, selected_types, selected_genres, all_time_ranges) {
            var _this6 = this;

            switch (true) {
                case selected_cinema && selected_types != null && selected_types.length > 0 && selected_genres != null && selected_genres.length > 0:
                    return Promise.resolve(this.getTimesFromMoviesForSelectedCinemaAndTypesAndGenres(movies, selected_cinema, selected_types, selected_genres)).then(function (data) {
                        return Promise.resolve(_this6.separateTimeRanges(data.time_tags, all_time_ranges.items)).then(function (times) {
                            return times;
                        });
                    });

                    break;

                case selected_cinema && (!selected_types || selected_types.length == 0) && selected_genres != null && selected_genres.length > 0:
                    return Promise.resolve(this.getTimesFromMoviesForSelectedCinemaAndGenres(movies, selected_cinema, selected_genres)).then(function (data) {
                        return Promise.resolve(_this6.separateTimeRanges(data.time_tags, all_time_ranges.items)).then(function (times) {
                            return times;
                        });
                    });
                    break;

                case selected_cinema && selected_types != null && selected_types.length > 0 && (!selected_genres || selected_genres.length == 0):

                    return Promise.resolve(this.getTimesFromMoviesForSelectedCinemaAndTypes(movies, selected_cinema, selected_types)).then(function (data) {
                        return Promise.resolve(_this6.separateTimeRanges(data.time_tags, all_time_ranges.items)).then(function (times) {
                            return times;
                        });
                    });
                    break;

                case selected_cinema && (!selected_types || selected_types.length == 0) && (!selected_genres || selected_genres.length == 0):
                    return Promise.resolve(this.getTimesFromMoviesForSelectedCinema(movies, selected_cinema)).then(function (data) {
                        return Promise.resolve(_this6.separateTimeRanges(data.time_tags, all_time_ranges.items)).then(function (times) {
                            return times;
                        });
                    });
                    break;

                case !selected_cinema && selected_types != null && selected_types.length > 0 && selected_genres != null && selected_genres.length > 0:
                    return Promise.resolve(this.getTimesFromMoviesForSelectedTypesAndGenres(movies, selected_types, selected_genres)).then(function (data) {
                        return Promise.resolve(_this6.separateTimeRanges(data.time_tags, all_time_ranges.items)).then(function (times) {
                            return times;
                        });
                    });
                    break;

                case !selected_cinema && selected_types != null && selected_types.length > 0 && (!selected_genres || selected_genres.length == 0):
                    return Promise.resolve(this.getTimesFromMoviesForSelectedTypes(movies, selected_types)).then(function (data) {
                        return Promise.resolve(_this6.separateTimeRanges(data.time_tags, all_time_ranges.items)).then(function (times) {
                            return times;
                        });
                    });
                    break;

                case !selected_cinema && (!selected_types || selected_types.length == 0) && selected_genres != null && selected_genres.length > 0:
                    return Promise.resolve(this.getTimesFromMoviesForSelectedGenres(movies, selected_genres)).then(function (data) {
                        return Promise.resolve(_this6.separateTimeRanges(data.time_tags, all_time_ranges.items)).then(function (times) {
                            return times;
                        });
                    });
                    break;

                case !selected_cinema && (!selected_types || selected_types.length == 0) && (!selected_genres || selected_genres.length == 0):
                    return Promise.resolve(this.separateTimeRanges([], all_time_ranges.items)).then(function (times) {
                        return times;
                    });
                    break;
            }
        }
    }]);

    return RegionService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new RegionService());

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_http__ = __webpack_require__(11);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_http__["a"]; });
/* unused harmony reexport requests_in_flight */




/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(15);
var normalizeHeaderName = __webpack_require__(446);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(99);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(99);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(97)))

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Observable = function () {
	function Observable() {
		_classCallCheck(this, Observable);

		this.observers = {};
	}

	_createClass(Observable, [{
		key: 'addObserver',
		value: function addObserver(context, key, behavior) {
			if (!context) throw new Error('addObserver:: Missing 1st argument - context can\'t be null');
			if (!key) throw new Error('addObserver:: Missing 2nd argument - key can\'t be null');
			if (!behavior) throw new Error('addObserver:: Missing 3rd argument - behavior can\'t be null');

			if (!this.observers[key]) {
				this.observers[key] = [];
			}
			this.observers[key].push({ context: context, behavior: behavior });
		}
	}, {
		key: 'removeObserver',
		value: function removeObserver(context, key) {
			if (!this.observers[key]) return;
			this.observers[key] = this.observers[key].filter(function (item) {
				return item.context !== context;
			});
			if (this.observers[key].length == 0) {
				delete this.observers[key];
			}
		}
	}, {
		key: 'removeAllObservers',
		value: function removeAllObservers() {
			this.observers = {};
		}
	}, {
		key: 'notifyAllObservers',
		value: function notifyAllObservers() {
			var _this = this,
			    _arguments = arguments;

			Object.keys(this.observers).forEach(function (key) {
				_this.notifyObservers.apply(_this, [key].concat(Array.prototype.slice.call(_arguments)));
			});
		}
	}, {
		key: 'notifyObservers',
		value: function notifyObservers(key) {
			var _arguments2 = arguments;

			if (this.observers[key]) {
				this.observers[key].forEach(function (item) {
					return item.behavior.apply(item, _arguments2);
				});
			}
		}
	}, {
		key: 'notifyMultipleObservers',
		value: function notifyMultipleObservers(keysArray) {
			for (var i = 0; i < keysArray.length; i++) {
				var args = arguments;
				args = new Array(args).splice(0, 1);
				this.notifyObservers.apply(this, [keysArray[i]].concat(_toConsumableArray(args)));
			}
		}
	}]);

	return Observable;
}();

/* harmony default export */ __webpack_exports__["a"] = (Observable);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Movies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Movie; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_BaseModel__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Genre__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_VistaDate__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_MovieSession__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_MovieImage__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__service_movie_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__service_preview_service__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModelArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Collection__ = __webpack_require__(41);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var Movies = function (_Collection) {
    _inherits(Movies, _Collection);

    function Movies(data) {
        _classCallCheck(this, Movies);

        var _this = _possibleConstructorReturn(this, (Movies.__proto__ || Object.getPrototypeOf(Movies)).call(this));

        _this.data = new __WEBPACK_IMPORTED_MODULE_7__ModelArray__["a" /* default */](data, Movie);
        _this._movies_cache = undefined;
        return _this;
    }

    _createClass(Movies, [{
        key: 'featured',
        value: function featured() {
            return this.data.filter(function (m) {
                return m.featured === true;
            });
        }
    }, {
        key: 'openingDateDesc',
        value: function openingDateDesc(a, b) {
            if (a.opening_date.timestamp < b.opening_date.timestamp) return -1;


            return 0;
        }
    }, {
        key: 'byRelease',
        value: function byRelease() {
            var data = this.data.reduce(function (c, m) {
                if (m.now_showing === true) c.now_showing.push(m);else c.coming_soon.push(m);
                return c;
            }, {
                now_showing: [],
                coming_soon: []
            });

            data.coming_soon.sort(this.openingDateDesc);
            return data;
        }
    }, {
        key: 'byHasSessions',
        value: function byHasSessions() {
            return this.data.reduce(function (c, m) {
                if (m.has_sessions_available === true) c.now_showing.push(m);
                return c;
            }, {
                now_showing: [],
                coming_soon: []
            });
        }
    }, {
        key: 'related',
        value: function related(movie) {
            return this._filterGenres(movie.genres.map(function (g) {
                if (g && g != undefined) return g.id;
            }));
        }
    }, {
        key: 'findById',
        value: function findById(id) {
            return this.data.find(function (m) {
                return m.id == id;
            });
        }
    }, {
        key: 'findByName',
        value: function findByName(name) {
            return this.data.find(function (m) {
                return m.title.toLowerCase() === name.toLowerCase();
            });
        }
    }, {
        key: 'getCinemaIds',
        value: function getCinemaIds() {

            if (!this._movies_cache) {
                this._movies_cache = {};
                for (var m in __WEBPACK_IMPORTED_MODULE_5__service_movie_service__["a" /* default */].sessions) {
                    for (var s in __WEBPACK_IMPORTED_MODULE_5__service_movie_service__["a" /* default */].sessions[m]) {
                        this._movies_cache[s] = s;
                    }
                }
            }

            return Object.keys(this._movies_cache);
        }
    }, {
        key: 'findBySessionId',
        value: function findBySessionId(SessionId, CinemaID) {
            return this.data.find(function (m) {
                return m.cinemas[CinemaID] ? ~m.cinemas[CinemaID].findIndex(function (s) {
                    return s.id === SessionId.toString();
                }) : false;
            });
        }
    }, {
        key: 'getNames',
        value: function getNames() {
            return this.data.map(function (m) {
                return m.title;
            });
        }
    }, {
        key: '_filterTitle',
        value: function _filterTitle(title) {
            var movies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.data;

            return movies.filter(function (m) {
                var search = new RegExp(title.replace(/[^\w\s]/gi, '').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "").replace(' ', '').toLowerCase(), "i");
                var mTitle = m.title.replace(/[^\w\s]/gi, '').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "").replace(' ', '').toLowerCase();
                return search.test(mTitle);
            });
        }
    }, {
        key: '_filterCinemas',
        value: function _filterCinemas(cinema_id) {
            var movies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.data;

            var filteredMovies = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        if (movies[m].cinemas[c][s].cinema_id == cinema_id) {
                            var exists = false;

                            if (filteredMovies.length > 0) {
                                for (var fm in filteredMovies) {
                                    if (filteredMovies[fm].id == movies[m].id) {
                                        exists = true;
                                    }
                                }
                            }

                            if (!exists) {
                                filteredMovies.push(movies[m]);
                            }
                        }
                    }
                }
            }

            return filteredMovies;
        }
    }, {
        key: '_filterExperiences',
        value: function _filterExperiences(array_of_experiences, cinema_id) {
            var movies = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.data;
            var time_range = arguments[3];

            var filteredMovies = [];

            for (var m in movies) {
                for (var c in movies[m].cinemas) {
                    for (var s in movies[m].cinemas[c]) {
                        for (var e in movies[m].cinemas[c][s].experiences) {
                            for (var ae in array_of_experiences) {
                                if (movies[m].cinemas[c][s].experiences[e] != undefined && movies[m].cinemas[c][s].experiences[e] != null && array_of_experiences[ae] != undefined && array_of_experiences[ae] != null) {
                                    if (movies[m].cinemas[c][s].experiences[e].name == array_of_experiences[ae]) {
                                        if (cinema_id != null) {
                                            if (movies[m].cinemas[c][s].cinema != undefined && movies[m].cinemas[c][s].cinema != null) {
                                                if (cinema_id == movies[m].cinemas[c][s].cinema.id) {
                                                    var exists = false;

                                                    if (filteredMovies.length > 0) {
                                                        for (var fm in filteredMovies) {
                                                            if (filteredMovies[fm].id == movies[m].id) {
                                                                exists = true;
                                                            }
                                                        }
                                                    }

                                                    if (!exists) {
                                                        filteredMovies.push(movies[m]);
                                                    }
                                                }
                                            }
                                        } else {
                                            var _exists = false;

                                            if (filteredMovies.length > 0) {
                                                for (var _fm in filteredMovies) {
                                                    if (filteredMovies[_fm].id == movies[m].id) {
                                                        _exists = true;
                                                    }
                                                }
                                            }

                                            if (!_exists) {
                                                filteredMovies.push(movies[m]);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return filteredMovies;
        }
    }, {
        key: '_filterGenres',
        value: function _filterGenres(array_of_genres) {
            var movies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.data;

            var filteredMovies = [];

            for (var m in movies) {
                for (var g in movies[m].genres) {
                    for (var ag in array_of_genres) {
                        if (movies[m] != undefined && movies[m] != null) {
                            if (movies[m].genres[g] != undefined && movies[m].genres[g] != null && array_of_genres[ag] != undefined) {
                                if (movies[m].genres[g].id == array_of_genres[ag]) {
                                    var exists = false;

                                    if (filteredMovies.length > 0) {
                                        for (var fm in filteredMovies) {
                                            if (filteredMovies[fm] != undefined && filteredMovies[fm] != null) {
                                                if (filteredMovies[fm].id == movies[m].id) {
                                                    exists = true;
                                                }
                                            }
                                        }
                                    }

                                    if (!exists) {
                                        filteredMovies.push(movies[m]);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return filteredMovies;
        }
    }, {
        key: '_filterByTime',
        value: function _filterByTime(time_range) {
            var movies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.data;
            var cinema_id = arguments[2];
            var selected_types = arguments[3];


            var filteredMovies = [];

            for (var m in movies) {
                if (movies[m].cinemas != undefined && movies[m].cinemas != null) {
                    if (_typeof(movies[m].cinemas) == "object") {
                        for (var c in movies[m].cinemas) {
                            if (movies[m].cinemas[c] != undefined && movies[m].cinemas[c] != null) {

                                if (_typeof(movies[m].cinemas[c]) == "object") {
                                    for (var s in movies[m].cinemas[c]) {
                                        if (movies[m].cinemas[c][s] != undefined && movies[m].cinemas[c][s] != null) {
                                            if (_typeof(movies[m].cinemas[c][s]) == "object") {
                                                for (var t in time_range.ranges) {
                                                    if (time_range.ranges[t] != undefined && time_range.ranges != null) {

                                                        if (_typeof(time_range.ranges[t]) == "object") {

                                                            if (cinema_id > 0) {
                                                                if (movies[m].cinemas[c][s].time_tag != undefined && movies[m].cinemas[c][s].time_tag != null) {
                                                                    if (movies[m].cinemas[c][s].cinema != null && movies[m].cinemas[c][s].cinema != undefined) {
                                                                        if (movies[m].cinemas[c][s].time_tag.includes(time_range.ranges[t].hour + ":") && movies[m].cinemas[c][s].cinema.id == cinema_id) {
                                                                            if (selected_types.length > 0) {
                                                                                for (var _t in selected_types) {
                                                                                    if (selected_types[_t] != undefined && selected_types[_t] != null) {
                                                                                        if (movies[m].cinemas[c][s].experiences != undefined && movies[m].cinemas[c][s].experiences != null) {
                                                                                            for (var e in movies[m].cinemas[c][s].experiences) {
                                                                                                if (movies[m].cinemas[c][s].experiences[e] != undefined && movies[m].cinemas[c][s].experiences[e] != null) {

                                                                                                    if (movies[m].cinemas[c][s].experiences[e].name == selected_types[_t]) {

                                                                                                        var exists = false;

                                                                                                        if (filteredMovies.length > 0) {
                                                                                                            if (filteredMovies != undefined && filteredMovies != null) {

                                                                                                                for (var fm in filteredMovies) {
                                                                                                                    if (filteredMovies[fm] != undefined && filteredMovies[fm] != null) {
                                                                                                                        if (movies[m].id != undefined && movies[m].id != null) {
                                                                                                                            if (filteredMovies[fm].id == movies[m].id) {
                                                                                                                                exists = true;
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }

                                                                                                        if (!exists) {
                                                                                                            filteredMovies.push(movies[m]);
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            } else {
                                                                                var _exists2 = false;

                                                                                if (filteredMovies != undefined && filteredMovies != null) {
                                                                                    if (filteredMovies.length > 0) {
                                                                                        for (var _fm2 in filteredMovies) {
                                                                                            if (filteredMovies[_fm2] != undefined && filteredMovies[_fm2] != null) {
                                                                                                if (filteredMovies[_fm2].id == movies[m].id) {
                                                                                                    _exists2 = true;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }

                                                                                    if (!_exists2) {
                                                                                        filteredMovies.push(movies[m]);
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            } else {

                                                                if (movies[m].cinemas[c][s].time_tag != undefined && movies[m].cinemas[c][s].time_tag != null) {
                                                                    if (movies[m].cinemas[c][s].time_tag.includes(time_range.ranges[t].hour + ":")) {
                                                                        if (selected_types.length > 0) {
                                                                            for (var _t2 in selected_types) {
                                                                                if (selected_types[_t2] != undefined && selected_types[_t2] != null) {
                                                                                    if (movies[m].cinemas[c][s].experiences != undefined && movies[m].cinemas[c][s].experiences != null) {
                                                                                        for (var _e in movies[m].cinemas[c][s].experiences) {
                                                                                            if (movies[m].cinemas[c][s].experiences[_e] != undefined && movies[m].cinemas[c][s].experiences[_e] != null) {
                                                                                                if (movies[m].cinemas[c][s].experiences[_e].name == selected_types[_t2]) {
                                                                                                    var _exists3 = false;
                                                                                                    if (filteredMovies.length > 0) {
                                                                                                        if (filteredMovies != undefined && filteredMovies != null) {
                                                                                                            for (var _fm3 in filteredMovies) {
                                                                                                                if (filteredMovies[_fm3] != undefined && filteredMovies[_fm3] != null) {
                                                                                                                    if (movies[m].id != undefined && movies[m].id != null) {
                                                                                                                        if (filteredMovies[_fm3].id == movies[m].id) {
                                                                                                                            _exists3 = true;
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }

                                                                                                    if (!_exists3) {
                                                                                                        filteredMovies.push(movies[m]);
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        } else {
                                                                            var _exists4 = false;

                                                                            if (filteredMovies != undefined && filteredMovies != null) {
                                                                                if (filteredMovies.length > 0) {
                                                                                    for (var _fm4 in filteredMovies) {
                                                                                        if (filteredMovies[_fm4] != undefined && filteredMovies[_fm4] != null) {
                                                                                            if (filteredMovies[_fm4].id == movies[m].id) {
                                                                                                _exists4 = true;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }

                                                                                if (!_exists4) {
                                                                                    filteredMovies.push(movies[m]);
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return filteredMovies;
        }
    }, {
        key: 'filter',
        value: function filter(_filter) {
            if (_filter != undefined) {
                if (typeof _filter === 'string') return this._filterTitle(_filter);else {

                    var movies = this.data;

                    if (_filter.cinemas) {
                        movies = this._filterCinemas(_filter.cinemas, movies);
                    }

                    if (_filter.cinemas && _filter.experiences && _filter.experiences.length > 0) {
                        movies = this._filterExperiences(_filter.experiences, _filter.cinemas, movies, _filter.time_range);
                    } else if (_filter.experiences && _filter.experiences.length > 0) {
                        movies = this._filterExperiences(_filter.experiences, null, movies, _filter.cinemas);
                    }

                    if (_filter.genres != undefined && _filter.genres != null) {
                        if (_filter.genres && _filter.genres.length > 0) {
                            movies = this._filterGenres(_filter.genres, movies);
                        }
                    }

                    if (_filter.time_range && _filter.time_range != undefined && _filter.time_range != null && _typeof(_filter.time_range) == "object") {
                        movies = this._filterByTime(_filter.time_range, movies, _filter.cinemas, _filter.experiences);
                    } else {}

                    if (_filter.title) {
                        movies = this._filterTitle(_filter.title, movies);
                    }

                    return movies;
                }
            }
        }
    }]);

    return Movies;
}(__WEBPACK_IMPORTED_MODULE_8__Collection__["a" /* default */]);



var Movie = function (_BaseModel) {
    _inherits(Movie, _BaseModel);

    function Movie(data) {
        _classCallCheck(this, Movie);

        var _this2 = _possibleConstructorReturn(this, (Movie.__proto__ || Object.getPrototypeOf(Movie)).call(this, data));

        _this2.id = data.id;
        _this2.title = data.title;
        _this2.title_slug = data.title_slug;
        _this2.search_title = data.search_title;
        _this2.runtime = data.runtime;
        _this2.runtime_hour_minute = {
            hours: data.runtime ? Math.floor(data.runtime / 60) : 0,
            minutes: data.runtime ? data.runtime % 60 : 0
        };
        _this2.runtime_string = _this2.runtime_hour_minute.hours + 'h' + _this2.runtime_hour_minute.minutes;
        _this2.trailer_url = data.trailer_url;
        _this2.youtube_id = data.youtube_id;
        _this2.images = new __WEBPACK_IMPORTED_MODULE_4__model_MovieImage__["a" /* default */](data.images || {});
        _this2.poster = _this2.images.standard.desktop.url;
        _this2.synopsis = data.synopsis;
        _this2.short_synopsis = data.short_synopsis;
        _this2.genres = data.genres && new __WEBPACK_IMPORTED_MODULE_7__ModelArray__["a" /* default */](data.genres, __WEBPACK_IMPORTED_MODULE_1__Genre__["a" /* default */]) || [];
        _this2.coming_soon = Boolean(data.coming_soon);
        _this2.now_showing = Boolean(data.now_showing);
        _this2.has_sessions_available = Boolean(data.has_sessions_available);
        _this2.allow_ticket_sales = Boolean(data.allow_ticket_sales);
        _this2.film_festivals = data.film_festivals || [];
        _this2.experiences = data.experiences || [];
        _this2.sessions = data.sessions || [];
        _this2.time_tags = data.time_tags || [];
        _this2.date_tags = data.date_tags || [];
        _this2.flags = data.flags || [];
        _this2.opening_date = new __WEBPACK_IMPORTED_MODULE_2__model_VistaDate__["a" /* default */](data.opening_date);
        _this2.advance_booking_date = new __WEBPACK_IMPORTED_MODULE_2__model_VistaDate__["a" /* default */](data.advance_booking_date);
        _this2.loyalty_advance_booking_date = new __WEBPACK_IMPORTED_MODULE_2__model_VistaDate__["a" /* default */](data.loyalty_advance_booking_date);
        _this2.cinemas_cache = null;

        _this2.expiry_time = data.expiry_time;
        _this2.rating = data.rating;

        _this2.promoMeta = data.promoMeta;
        _this2.eventMeta = data.eventMeta;
        _this2.featured = Boolean(data.featured);
        _this2.hasPromos = Boolean(data.hasPromos);
        _this2.hasEvents = Boolean(data.hasEvents);
        _this2.floodlight_tag = data.floodlight_tag;
        _this2.floodlight_pixel = data.floodlight_pixel;
        _this2.cast = data.cast;

        if (__WEBPACK_IMPORTED_MODULE_6__service_preview_service__["a" /* default */].hasPreviewContentForRelatedMovie('promotion', _this2.id)) {
            var PreviewPromo = __WEBPACK_IMPORTED_MODULE_6__service_preview_service__["a" /* default */].getPreviewContent('promotion');
            _this2.images.setPromo(PreviewPromo.images);
            _this2.hasPromos = true;
            _this2.promoMeta = {
                title: PreviewPromo.title || null,
                strapline: PreviewPromo.strapline || null,
                button_text: PreviewPromo.button_text || null,
                button_link: PreviewPromo.button_link || null,
                button_2_link: PreviewPromo.button_2_link || null,
                button_2_text: PreviewPromo.button_2_text || null,
                nid: PreviewPromo.nid || null,
                use_movie_poster: Boolean(PreviewPromo.use_movie_poster)
            };
        }

        if (__WEBPACK_IMPORTED_MODULE_6__service_preview_service__["a" /* default */].hasPreviewContentForRelatedMovie('event', _this2.id)) {
            var PreviewEvent = __WEBPACK_IMPORTED_MODULE_6__service_preview_service__["a" /* default */].getPreviewContent('event');
            _this2.images.setEvent(PreviewEvent.images);
            _this2.hasEvents = true;
        }
        return _this2;
    }

    _createClass(Movie, [{
        key: 'getExperienceForCinema',
        value: function getExperienceForCinema(cinema_id) {
            return this.cinemas[cinema_id] ? this.cinemas[cinema_id].reduce(function (c, s) {
                var exp = s.experiences.length == 1 ? s.experiences[0].name : undefined;
                if (exp && !~c.indexOf(exp)) c.push(exp);
                return c;
            }, []) : [];
        }
    }, {
        key: 'getSessions',
        value: function getSessions() {
            var cinemaId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


            return this.cinemas;
        }
    }, {
        key: 'getSession',
        value: function getSession(sessionId) {
            var _this3 = this;

            return Object.keys(this.cinemas).reduce(function (arr, key) {
                return arr.concat(_this3.cinemas[key]);
            }, []).find(function (session) {
                return session.id == sessionId.toString();
            });
        }
    }, {
        key: 'details',
        value: function details() {
            return __WEBPACK_IMPORTED_MODULE_5__service_movie_service__["a" /* default */].getMovieDetail(this.id);
        }
    }, {
        key: 'getRelatedMovies',
        value: function getRelatedMovies() {
            return __WEBPACK_IMPORTED_MODULE_5__service_movie_service__["a" /* default */].getRelatedMovies(this);
        }
    }, {
        key: 'cinemas',
        get: function get() {
            var _this4 = this;

            if (!this.cinemas_cache) {
                var movieSessions = __WEBPACK_IMPORTED_MODULE_5__service_movie_service__["a" /* default */].sessions[this.id];
                if (movieSessions) {
                    this.cinemas_cache = {};
                    Object.keys(movieSessions).map(function (key) {
                        return _this4.cinemas_cache[key] = new __WEBPACK_IMPORTED_MODULE_7__ModelArray__["a" /* default */](movieSessions[key], __WEBPACK_IMPORTED_MODULE_3__model_MovieSession__["a" /* default */]);
                    });
                }
            }

            return this.cinemas_cache;
        }
    }, {
        key: 'genresString',
        get: function get() {
            return this.genres.map(function (g) {
                return g.name;
            }).join('/');
        }
    }, {
        key: 'experiencesString',
        get: function get() {
            return this.experiences.join(' ');
        }
    }]);

    return Movie;
}(__WEBPACK_IMPORTED_MODULE_0__model_BaseModel__["a" /* default */]);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModel__ = __webpack_require__(8);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Cinema = function (_BaseModel) {
    _inherits(Cinema, _BaseModel);

    function Cinema(data) {
        _classCallCheck(this, Cinema);

        var _this = _possibleConstructorReturn(this, (Cinema.__proto__ || Object.getPrototypeOf(Cinema)).call(this));

        _this.id = data.id;
        _this.name = data.name;
        _this.slug = data.slug;
        _this.original_name = data.original_name;
        _this.latitude = data.latitude;
        _this.longitude = data.longitude;
        _this.loyalty_cinema_id = data.loyalty_cinema_id;
        _this.distance = "";
        _this.address_1 = data.address_1;
        _this.address_2 = data.address_2;
        _this.city = data.city;
        _this.phone = data.phone;
        return _this;
    }

    return Cinema;
}(__WEBPACK_IMPORTED_MODULE_0__BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Cinema);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model__ = __webpack_require__(19);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var SeatGridService = function () {
    function SeatGridService() {
        _classCallCheck(this, SeatGridService);

        this.seatGrid = undefined;
    }

    _createClass(SeatGridService, [{
        key: 'getSeatGrid',
        value: function getSeatGrid(cinema_id, session_id) {
            var _this = this;

            var tickets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


            return this.seatGrid = __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/seats/' + cinema_id + '/' + session_id).then(function (result) {
                return _this._generateGrid(result.data, tickets);
            }, function (error) {
                return _this.seatGrid = undefined;
            });
        }
    }, {
        key: '_generateGrid',
        value: function _generateGrid(SeatData) {
            var tickets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var grid = [];
            var selectedSeats = [];

            for (var i = 0; i < SeatData.Areas.length; i++) {
                var area = SeatData.Areas[i];

                if (i > 0) grid.push({
                    PhysicalName: undefined, Seats: [{
                        seatNumber: 0,
                        empty: true,
                        size: 1,
                        Position: {
                            AreaNumber: area.Number,
                            AreaCategoryCode: SeatData.AreaCategories[0].AreaCategoryCode,
                            ColumnIndex: null,
                            RowIndex: null
                        },
                        seats: [{ empty: true }]
                    }]
                });

                var numSeatsPerRow = Math.max.apply(Math, area.Rows.map(function (a) {
                    var maxColIndex = Math.max.apply(Math, a.Seats.map(function (s) {
                        return s.Position.ColumnIndex;
                    }));
                    return a.Seats.length > maxColIndex ? a.Seats.length : maxColIndex;
                }));

                for (var j = area.Rows.length - 1; j >= 0; j--) {
                    var row = area.Rows[j],
                        rowSeats = [],
                        seats = row.Seats.reduce(function (col, seat) {
                        col[seat.Position.ColumnIndex] = seat;
                        return col;
                    }, []);

                    for (var k = numSeatsPerRow; k >= 0; k--) {
                        var seat = seats[k],
                            seatObj = {
                            seatNumber: Number(seat && seat.Id || 0),
                            seatNumberCombined: [numSeatsPerRow - (k - 1)],
                            seatName: row.PhysicalName + (seat && seat.Id || 0),
                            seatNameCombined: [row.PhysicalName + (seat && seat.Id || 0)],
                            selected: false,
                            Position: {
                                AreaCategoryCode: area.AreaCategoryCode,
                                AreaNumber: area.Number,
                                ColumnIndex: seat && seat.Position.ColumnIndex || null,
                                RowIndex: seat && seat.Position.RowIndex || null
                            },
                            empty: !seat || !!~[2, 4, 5, 6].indexOf(seat.Status),
                            available: seat && !~[1, 2, 4, 5, 6].indexOf(seat.Status),
                            loveNest: seat && (seat.SeatStyle === 1 || seat.SeatStyle === 2 || seat.SeatStyle === 3),
                            companion: seat && seat.Status === 7,
                            wheelchair: seat && seat.Status === 3,
                            size: seat && seat.SeatsInGroup && seat.SeatsInGroup.length || 1,
                            seats: []

                        };

                        if (seatObj.empty) {
                            seatObj.type = 0;
                        } else if (seatObj.loveNest) {
                            seatObj.type = 2;
                        } else if (seatObj.wheelchair) {
                            seatObj.type = 3;
                        } else if (seatObj.companion) {
                            seatObj.type = 4;
                        } else {
                            seatObj.type = 1;
                        }

                        if (seat && seat.Position) {
                            seat.Position.AreaCategoryCode = area.AreaCategoryCode;
                        }


                        var ticket = tickets.find(function (ticket) {
                            return ticket.SeatData === seatObj.seatName;
                        });
                        if (ticket) {
                            seatObj.available = true;
                            seatObj.selected = true;
                            seatObj.price = ticket.PriceCents / 100;
                            seat.ticket = ticket;
                            ticket.Position = seat.Position;
                            selectedSeats.push(seatObj);
                        }

                        seatObj.seats.push(seat);

                        if (seat && seat.SeatStyle == 1) {
                            var m = k - 1;

                            while (seats[m] && seats[m].SeatStyle > 1) {
                                var seatName = row.PhysicalName + seats[m].Id;
                                var ticket = tickets.find(function (ticket) {
                                    return ticket.SeatData === seatName;
                                });
                                if (ticket) {
                                    seat.ticket = ticket;
                                    ticket.Position = seat.Position;
                                }
                                seatObj.seats.push(seats[m]);
                                seatObj.seatNumberCombined.push(Number(seats[m].Id));
                                seatObj.seatNameCombined.push(seatName);
                                m--;
                            }

                            k = m + 1;
                        }

                        rowSeats.push(seatObj);
                    }

                    grid.push({ PhysicalName: row.PhysicalName, Seats: rowSeats, rowData: row });
                }
            }

            return { grid: grid, selectedSeats: selectedSeats };
        }
    }, {
        key: '_drawGrid',
        value: function _drawGrid(areaObj) {
            var areaGrids = [];

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = areaObj.Areas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var area = _step.value;

                    var grid = [];
                    for (var r = 0; r < area.RowCount; r++) {
                        var row = { data: [], PhysicalName: null };
                        for (var c = 0; c < area.ColumnCount; c++) {
                            row.data.push([]);
                        }

                        grid.push(row);
                    }
                    var mappedGrid = this._mapGrid(grid, area);
                    areaGrids.push(mappedGrid);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return areaGrids.reverse();
        }
    }, {
        key: '_mapGrid',
        value: function _mapGrid(grid, area) {
            var rows = area.Rows;
            var Seats = [];
            for (var r = 0; r < grid.length; r++) {
                var seats = area.Rows[r].Seats;
                if (area.Rows[r] != undefined) grid[r].PhysicalName = area.Rows[r].PhysicalName;

                for (var c = 0; c < grid[r].data.length; c++) {
                    var hasSeat = false;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = seats[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var seat = _step2.value;

                            if (seat.Position.ColumnIndex == c && seat.Position.RowIndex == r) {

                                var SeatData = new __WEBPACK_IMPORTED_MODULE_1__model__["h" /* Seat */](seat);
                                Seats.push(SeatData);
                                var SeatGroup = this._groupSeat(SeatData, Seats);

                                var seatData = { empty: false, data: SeatGroup };
                                hasSeat = true;
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    if (!hasSeat) {
                        var seatData = { empty: true, data: [] };
                    }
                    grid[r].data[c] = seatData;
                }

                grid[r].data.reverse();
            }

            return grid.reverse();
        }
    }, {
        key: '_groupSeat',
        value: function _groupSeat(Seat, Seats) {

            var active = true;
            var type = 1;
            var addToGroup = true;
            var size = 1;

            if (Seat.Status === 0) {
                active = true;
            } else if (Seat.Status === 1) {
                active = false;
            } else if (Seat.Status === 2) {
                active = false;
            } else if (Seat.Status === 3) {
                active = true;
                type = 3;
            } else if (Seat.Status === 4) {
                active = false;
            } else if (Seat.Status === 5) {
                active = false;
            } else if (Seat.Status === 6) {
                active = false;
            } else if (Seat.Status === 7) {
                active = true;
                type = 4;
            }

            if (Seat.SeatStyle > 0) {

                if (Seat.SeatStyle === 1 || Seat.SeatStyle === 2 || Seat.SeatStyle === 3) {
                    type = 2;

                    if (Seat.SeatStyle === 1) {
                        size = Seat.SeatsInGroup.length;
                    }
                }

                if (Seat.SeatStyle > 1) {
                    addToGroup = false;
                }
            }

            if (addToGroup) {
                var seatGroup = {};
                seatGroup.Size = size;
                seatGroup.Empty = true;
                seatGroup.Active = active;
                seatGroup.SeatType = type;
                seatGroup.SeatData = Seat;
                seatGroup.Selected = false;
                seatGroup.SeatsInGroup = Seat.SeatsInGroup || [];
                seatGroup.ColumnIndex = Seat.Position.ColumnIndex;
                seatGroup.RowIndex = Seat.Position.RowIndex;
                seatGroup.AreaNumber = Seat.Position.AreaNumber;

                var Seat_Group = new __WEBPACK_IMPORTED_MODULE_1__model__["i" /* SeatGroups */](seatGroup);

                return Seat_Group;
            }
        }
    }, {
        key: 'checkGapSeats',
        value: function checkGapSeats(selectedSeats, areaGrid) {
            var rows = [];
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = selectedSeats.data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var selectedSeat = _step3.value;

                    rows.push({
                        ColumnIndex: selectedSeat.ColumnIndex,
                        RowIndex: selectedSeat.RowIndex,
                        AreaNumber: selectedSeat.AreaNumber,
                        SeatType: selectedSeat.SeatType,
                        Size: selectedSeat.Size
                    });
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return this._checkAvailableGapSeats(rows.reverse(), this._flattenGrid(areaGrid));
        }
    }, {
        key: '_checkAvailableGapSeats',
        value: function _checkAvailableGapSeats(rows, flatGrid) {
            var nextSeat = {};
            var seat = {};
            var hasGapSeat = false;

            for (var i = 0; i < rows.length; i++) {
                seat = rows[i];

                if (i < rows.length) nextSeat = rows[i - 1];else nextSeat = null;

                if (nextSeat != null) {
                    if (nextSeat.RowIndex == seat.RowIndex && nextSeat.AreaNumber == seat.AreaNumber) {
                        if (seat.ColumnIndex - nextSeat.ColumnIndex > seat.Size) {
                            hasGapSeat = this._gapHasActiveSeats(seat, nextSeat, flatGrid);
                            if (hasGapSeat) return hasGapSeat;
                        }
                    }
                }
            }
        }
    }, {
        key: '_flattenGrid',
        value: function _flattenGrid(areaGrid) {
            var grid = [];

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = areaGrid[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var area = _step4.value;
                    var _iteratorNormalCompletion5 = true;
                    var _didIteratorError5 = false;
                    var _iteratorError5 = undefined;

                    try {
                        for (var _iterator5 = area[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                            var row = _step5.value;
                            var _iteratorNormalCompletion6 = true;
                            var _didIteratorError6 = false;
                            var _iteratorError6 = undefined;

                            try {
                                for (var _iterator6 = row.data[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                    var seat = _step6.value;

                                    if (!seat.empty) {
                                        if (seat.data != undefined) {
                                            if (seat.data.data != undefined) {
                                                grid.push({
                                                    AreaNumber: seat.data.data.AreaNumber,
                                                    RowIndex: seat.data.data.RowIndex,
                                                    ColumnIndex: seat.data.data.ColumnIndex,
                                                    data: seat.data.data
                                                });
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError6 = true;
                                _iteratorError6 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                        _iterator6.return();
                                    }
                                } finally {
                                    if (_didIteratorError6) {
                                        throw _iteratorError6;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                _iterator5.return();
                            }
                        } finally {
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            return grid;
        }
    }, {
        key: '_gapHasActiveSeats',
        value: function _gapHasActiveSeats(seat, nextSeat, flatGrid) {
            var hasActiveSeats = false;
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = flatGrid[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var gridSeat = _step7.value;


                    if (gridSeat.AreaNumber == seat.AreaNumber && gridSeat.RowIndex == seat.RowIndex && gridSeat.AreaNumber == nextSeat.AreaNumber && gridSeat.RowIndex == nextSeat.RowIndex) {
                        if (gridSeat.ColumnIndex < seat.ColumnIndex && gridSeat.ColumnIndex > nextSeat.ColumnIndex) {
                            if (gridSeat.data.Active) return gridSeat.data.Active;
                        }
                    }
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }

            return false;
        }
    }, {
        key: '_seatsInGap',
        value: function _seatsInGap(seat, nextSeat, flatGrid) {
            var seatsInGap = [];

            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
                for (var _iterator8 = flatGrid[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var gridSeat = _step8.value;

                    if (gridSeat.AreaNumber == seat.AreaNumber && gridSeat.RowIndex == seat.RowIndex && gridSeat.AreaNumber == nextSeat.AreaNumber && gridSeat.RowIndex == nextSeat.RowIndex) {
                        if (gridSeat.ColumnIndex > seat.ColumnIndex && gridSeat.ColumnIndex < nextSeat.ColumnIndex) {
                            seatsInGap.push(gridSeat);
                        }
                    }
                }
            } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                        _iterator8.return();
                    }
                } finally {
                    if (_didIteratorError8) {
                        throw _iteratorError8;
                    }
                }
            }

            return seatsInGap;
        }
    }]);

    return SeatGridService;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (new SeatGridService());

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_BaseModel__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Ticket = function (_BaseModel) {
    _inherits(Ticket, _BaseModel);

    function Ticket(data) {
        _classCallCheck(this, Ticket);

        var _this = _possibleConstructorReturn(this, (Ticket.__proto__ || Object.getPrototypeOf(Ticket)).call(this));

        _this.Id = data.Id;
        _this.Description = data.Description;
        _this.IsTicketPackage = data.IsTicketPackage;
        _this.PackageId = data.PackageId;
        _this.PackageTicket = data.PackageTicket;
        _this.PackageTickets = data.PackageTickets;
        _this.PriceCents = data.PriceCents || 0;
        _this.LoyaltyRecognitionSequence = data.LoyaltyRecognitionSequence;
        _this.LoyaltyRecognitionId = data.LoyaltyRecognitionId;
        _this.SeatData = data.SeatData;
        _this.SeatNumber = data.SeatNumber;
        _this.SeatRowId = data.SeatRowId;
        _this.SeatNumberCombined = data.SeatNumberCombined;
        _this.SeatId = Number(data.SeatId);
        _this.TicketTypeCode = data.TicketTypeCode;
        _this.Position = data.Position;
        _this.ThirdPartyMemberScheme = data.ThirdPartyMemberScheme || null;
        _this.Barcode = data.Barcode || null;
        _this._status = {};

        return _this;
    }

    _createClass(Ticket, [{
        key: 'status',
        get: function get() {
            return this._status;
        },
        set: function set(value) {
            this._status = value;
        }
    }, {
        key: 'price',
        get: function get() {
            return this.PriceCents / 100;
        }
    }, {
        key: 'priceString',
        get: function get() {
            var priceFormatted = this.price.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            return 'R' + priceFormatted;
        }
    }]);

    return Ticket;
}(__WEBPACK_IMPORTED_MODULE_0__model_BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Ticket);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_observable__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Order__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_LoyaltyCard__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_SeatGrid__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_Transaction__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_Booking__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_ModelArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth_service__ = __webpack_require__(40);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ORDER_CHANGED_EVENT = "ORDER_CHANGED";

var SESSION_KEY = "PendingOrder";
var SESSION_EXPIRY = 900;
var OrderService = function (_Observable) {
    _inherits(OrderService, _Observable);

    _createClass(OrderService, [{
        key: 'ORDER_CHANGED_EVENT',
        get: function get() {
            return ORDER_CHANGED_EVENT;
        }
    }]);

    function OrderService() {
        _classCallCheck(this, OrderService);

        var _this = _possibleConstructorReturn(this, (OrderService.__proto__ || Object.getPrototypeOf(OrderService)).call(this));

        _this._order_promise = undefined;
        _this._history_promise = undefined;
        _this.concessions_promises = {};
        _this.booking = undefined;
        _this._order = undefined;
        _this.seatGrid = [];
        _this.CinemaId = undefined;
        _this.SessionId = undefined;
        return _this;
    }

    _createClass(OrderService, [{
        key: '_handleRejection',
        value: function _handleRejection(rejection) {
            var cancelOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            this._order_promise = cancelOrder ? undefined : this._order_promise;
            return Promise.reject(rejection);
        }
    }, {
        key: '_processOrder',
        value: function _processOrder(order) {

            if (!this._order) {
                this._order = new __WEBPACK_IMPORTED_MODULE_2__model_Order__["a" /* default */](order);
            } else {
                this._order.setOrder(order);
            }

            this.notifyObservers(this.ORDER_CHANGED_EVENT, this._order);

            return this._order;
        }
    }, {
        key: 'getConsessionsByCinemaId',
        value: function getConsessionsByCinemaId(cinema_id) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/order/concessions/' + cinema_id).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'getConcessionsForCinema',
        value: function getConcessionsForCinema() {
            var CinemaId = this.CinemaId || this.pendingSession().CinemaId;
            return this.getConsessionsByCinemaId(CinemaId);
        }
    }, {
        key: 'newOrder',
        value: function newOrder(SessionId, CinemaId, MovieId) {
            var _this2 = this;

            this.tearDown();
            if (this._order_promise) {
                this._order_promise._clearTracking();
            }
            __WEBPACK_IMPORTED_MODULE_8__auth_service__["a" /* default */].clearTempLocalUserOrderInfo();
            return this._order_promise = __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/order', {
                SessionId: SessionId,
                CinemaId: CinemaId
            }).then(function (response) {
                _this2.setCurrentPendingSession(SessionId, CinemaId, MovieId);
                return _this2._processOrder(response.data);
            }, function (e) {
                return _this2._handleRejection(e);
            });
        }
    }, {
        key: 'restartOrder',
        value: function restartOrder() {
            this._order = undefined;
            var pendingSession = this.pendingSession();
            return this.newOrder(pendingSession.SessionId, pendingSession.CinemaId, pendingSession.MovieId);
        }
    }, {
        key: 'addToOrder',
        value: function addToOrder(SessionId, CinemaId, MovieId) {
            var _this3 = this;

            return this._order_promise = __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/order/add', {
                SessionId: SessionId,
                CinemaId: CinemaId
            }).then(function (response) {
                _this3.setCurrentPendingSession(SessionId, CinemaId, MovieId);
                return _this3._processOrder(response.data);
            }, function (e) {
                return _this3._handleRejection(e);
            });
        }
    }, {
        key: 'getOrder',
        value: function getOrder() {
            var _this4 = this;

            var SessionId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pendingSession() ? this.pendingSession().SessionId : null;

            return this._order_promise = this._order_promise || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/order' + (SessionId && '/' + SessionId || '')).then(function (response) {
                return _this4._processOrder(response.data);
            }, function (rejection) {
                return _this4._handleRejection(rejection);
            });
        }
    }, {
        key: 'saveOrder',
        value: function saveOrder() {
            var _this5 = this;

            return this._order_promise = __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/order', {
                Order: this._order
            }).then(function (response) {
                return _this5._processOrder(response.data);
            }, function (rejection) {
                return _this5._handleRejection(rejection);
            });
        }
    }, {
        key: 'cancelOrder',
        value: function cancelOrder(session_id, cinema_id) {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/order/cancel", { SessionId: session_id, CinemaId: cinema_id }).then(function (response) {
                _this6.clearPendingSessions();
                _this6.clearLoyalties();
                __WEBPACK_IMPORTED_MODULE_8__auth_service__["a" /* default */].clearTempLocalUserOrderInfo();
                return response;
            }, function (error) {
                _this6.clearPendingSessions();
                _this6.clearLoyalties();
                __WEBPACK_IMPORTED_MODULE_8__auth_service__["a" /* default */].clearTempLocalUserOrderInfo();
                return Promise.reject(error);
            });
        }
    }, {
        key: 'saveTickets',
        value: function saveTickets() {
            var _this7 = this;

            if (!this._order.Tickets || this._order.Tickets.length == 0) {
                return Promise.reject("Order Missing Tickets");
            }
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/order/tickets', {
                Order: this._order
            }).then(function (response) {
                return _this7._processOrder(response.data);
            }, function (rejection) {
                return _this7._handleRejection(rejection);
            });
        }
    }, {
        key: 'validateLoyaltyForOrder',
        value: function validateLoyaltyForOrder(card) {
            var _this8 = this;

            return new Promise(function (resolve, reject) {
                if (!card instanceof __WEBPACK_IMPORTED_MODULE_3__model_LoyaltyCard__["a" /* default */]) card = new __WEBPACK_IMPORTED_MODULE_3__model_LoyaltyCard__["a" /* default */](card);

                card.setSessionInfo(_this8.pendingSession().SessionId, _this8.pendingSession().CinemaId);
                if (card.isPopulated) {
                    __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/cards/validate', card).then(function (result) {

                        resolve(result.data);
                    }, function (error) {
                        return reject(error);
                    });
                } else {
                    reject("Card Validation Failed, please ensure Card Number, and Loyalty Type have been selected.");
                }
            });
        }
    }, {
        key: 'toggleRewardForOrder',
        value: function toggleRewardForOrder(card, originalTicket) {
            var _this9 = this;

            return new Promise(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/order/toggle-reward-for-order', { card: card, SessionId: _this9.pendingSession().SessionId, CinemaId: _this9.pendingSession().CinemaId, originalTicket: originalTicket }).then(function (result) {

                    resolve(result.data);
                }, function (error) {
                    return reject(error);
                });
            });
        }
    }, {
        key: 'pendingSession',
        value: function pendingSession() {
            if (!this._pendingSession || this._pendingSession.length == 0) {
                try {
                    this._pendingSession = JSON.parse(localStorage.getItem(SESSION_KEY));
                } catch (e) {}
            }
            return this._pendingSession;
        }
    }, {
        key: 'setCurrentPendingSession',
        value: function setCurrentPendingSession(SessionId, CinemaId, MovieId) {

            this._pendingSession = { SessionId: SessionId, CinemaId: CinemaId, expiry: Date.now(), MovieId: MovieId };
            try {
                localStorage.setItem(SESSION_KEY, JSON.stringify(this._pendingSession));
            } catch (e) {}
        }
    }, {
        key: 'log',
        value: function log() {}
    }, {
        key: '_generateGrid',
        value: function _generateGrid(SeatData) {
            var tickets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            var areas = SeatData.Areas;
            var seats = {},
                grid = {};

            for (var i = 0; i < areas.length; i++) {
                var area = areas[i];
                var rows = area.Rows.reverse();

                for (var j = 0; j < area.RowCount; j++) {
                    var row = rows[j],
                        seatsFormatted = [];
                    var seatsLength = row.Seats.length;
                    var rowIndexZeroBased = row.RowIndexZeroBased;

                    if (row && row.PhysicalName) {
                        grid[row.PhysicalName] = grid[row.PhysicalName] || [];
                        var _seats = row.Seats;

                        var tmpSeats = [];
                        var excluded = [];

                        var _loop = function _loop(_k) {

                            var seat = _seats.find(function (s) {
                                return s.Position.ColumnIndex == _k;
                            });

                            var seatObj = {};

                            if (!seat) {
                                seatObj = {
                                    seatNumber: Number(_k),
                                    seatName: row.PhysicalName + _k,
                                    seatNameCombined: [row.PhysicalName + _k],
                                    seatNameCombinedString: row.PhysicalName + _k,
                                    seatNumberComined: [Number(_k)],
                                    selected: false,
                                    Position: {
                                        AreaCategoryCode: area.AreaCategoryCode,
                                        ColumnIndex: _k,
                                        RowIndex: j
                                    },
                                    empty: true,
                                    broken: false,
                                    aisle: true,
                                    available: false,
                                    loveNest: false,
                                    companion: false,
                                    wheelchair: false,
                                    selected_unavailable: false,
                                    size: 1,
                                    dBox: false,
                                    kids: false,
                                    seats: false,
                                    style: undefined,
                                    rowIndexZeroBased: rowIndexZeroBased
                                };

                                if (Number(_k) >= seatsLength) {
                                    seatObj.style = 0;
                                } else {
                                    seatObj.style = 0;
                                }
                            } else {
                                seatObj = {
                                    seatNumber: Number(seat && seat.Id || _k),
                                    seatName: row.PhysicalName + (seat && seat.Id || _k),
                                    seatNameCombined: [row.PhysicalName + (seat && seat.Id || _k)],
                                    seatNameCombinedString: row.PhysicalName + (seat && seat.Id || _k),
                                    seatNumberComined: [Number(seat && seat.Id || _k)],
                                    selected: false,
                                    Position: {
                                        AreaCategoryCode: area.AreaCategoryCode,
                                        ColumnIndex: seat ? seat.Position.ColumnIndex : null,
                                        RowIndex: seat ? seat.Position.RowIndex : null
                                    },
                                    empty: !seat || !!~[2, 4, 5, 6].indexOf(seat.Status),
                                    broken: seat && !seat.Id,
                                    aisle: !seat,
                                    loveNest: seat && (seat.SeatStyle === 1 || seat.SeatStyle === 2 || seat.SeatStyle === 3),
                                    companion: seat && seat.Status === 7,
                                    wheelchair: seat && seat.Status === 3,
                                    size: seat && seat.SeatsInGroup && seat.SeatsInGroup.length || 1,
                                    dBox: area.AreaCategoryCode == '0000000005',
                                    kids: seat && seat.Priority === 2 ? true : false,
                                    available: seat && !~[1, 2, 4, 5, 6].indexOf(seat.Status),
                                    selected_unavailable: false,
                                    seats: [seat],
                                    style: seat.SeatStyle,
                                    rowIndexZeroBased: rowIndexZeroBased
                                };
                            }

                            if (seat) {
                                seat.Position.AreaCategoryCode = area.AreaCategoryCode;
                                if (seat.SeatStyle == 1) {
                                    (function () {
                                        var m = _k - 1,
                                            previousSeat = _seats.find(function (s) {
                                            return s.Position.ColumnIndex == m;
                                        });
                                        var seatName = '';

                                        while (previousSeat && previousSeat.SeatStyle > 1) {
                                            seatName = row.PhysicalName + previousSeat.Id;
                                            previousSeat.Position.AreaCategoryCode = area.AreaCategoryCode;

                                            if (~[1, 2, 4, 5, 6].indexOf(previousSeat.Status)) {
                                                seatObj.sold = true;
                                                seatObj.empty = false;
                                                seatObj.available = false;
                                            }
                                            previousSeat.Position.AreaCategoryCode = area.AreaCategoryCode;
                                            seatObj.seats.push(previousSeat);

                                            seatObj.seatNameCombined.push(seatName);
                                            seatObj.seatNumberComined.push(Number(previousSeat.Id));
                                            m--;
                                            previousSeat = _seats.find(function (s) {
                                                return s.Position.ColumnIndex == m;
                                            });
                                        }
                                        seatObj.seatNameCombinedString += ' - ' + seatName;

                                        _k = m + 1;
                                    })();
                                }
                            }

                            if (seatObj.empty) {
                                seatObj.type = 0;
                            } else if (seatObj.loveNest) {
                                seatObj.type = 2;
                            } else if (seatObj.wheelchair) {
                                seatObj.type = 3;
                            } else if (seatObj.companion) {
                                seatObj.type = 4;
                            } else {

                                seatObj.type = 1;
                            }

                            if (grid[row.PhysicalName][_k]) {
                                if (grid[row.PhysicalName][_k].empty) {
                                    grid[row.PhysicalName][_k] = seatObj;
                                } else {
                                    excluded.push(seatObj);
                                }
                            } else {
                                grid[row.PhysicalName][_k] = seatObj;
                            }

                            tmpSeats.push(seatObj);
                            k = _k;
                        };

                        for (var k = area.ColumnCount; k >= 0; k--) {
                            _loop(k);
                        }
                    }
                }
            }

            var gridFormatted = Object.keys(grid).reduce(function (collection, key) {
                var seats = grid[key];
                var rowIndex = grid[key][0]['rowIndexZeroBased'];
                collection.push({ PhysicalName: key, RowIndex: rowIndex, Seats: Object.keys(seats).map(function (k) {
                        return seats[k];
                    }).reverse() });
                return collection;
            }, []);

            var sortedGridFormatted = gridFormatted.sort(function (a, b) {
                var x = a.RowIndex;
                var y = b.RowIndex;

                if (x > y) return -1;
                if (x < y) return 1;
                return 0;
            });

            grid = new __WEBPACK_IMPORTED_MODULE_4__model_SeatGrid__["a" /* default */](gridFormatted);
            if (tickets.length) grid.mapTicketsToGrid(tickets);

            for (var g = 0; g < grid.grid.length; g++) {
                if (grid.grid[g] != undefined) {
                    if (grid.grid[g].Seats != undefined) {
                        for (var s = 0; s < grid.grid[g].Seats.length; s++) {
                            if (grid.grid[g].Seats[s] != undefined) {
                                if (grid.grid[g].Seats[s].seatNameCombined.length > 1) {

                                    var prevIndex = s - 1;
                                    if (grid.grid[g].Seats[prevIndex] != undefined) {

                                        if (grid.grid[g].Seats[prevIndex].Position.AreaCategoryCode == "0000000005") {
                                            grid.grid[g].Seats.splice(prevIndex, 1);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return grid;
        }
    }, {
        key: 'getSeatGrid',
        value: function getSeatGrid(SessionId, CinemaId) {
            var _this10 = this;

            var tickets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

            return this.seatGrid[SessionId] = this.seatGrid[SessionId] || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/seats/' + CinemaId + '/' + SessionId).then(function (result) {
                return _this10._generateGrid(result.data, tickets);
            }, function (error) {
                _this10.seatGrid[SessionId] = undefined;
                return Promise.reject(error);
            });
        }
    }, {
        key: 'pollPayment',
        value: function pollPayment() {
            var _this11 = this;

            var requestNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;


            var delay = function delay() {
                var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3000;

                return new Promise(function (resolve) {
                    setTimeout(function () {
                        return resolve();
                    }, time);
                });
            };

            var retries = 40;
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/payment/poll-payment', {}).then(function (response) {
                if (response.data.OrderIdentifiers.IsCompletedOrder === true && response.data.OrderWebPaymentData.PaymentStatus === "P") {
                    return Promise.resolve(response.data);
                } else if (response.data.OrderWebPaymentData.PaymentStatus === "P" && requestNumber < retries) {
                    return delay(1000).then(function () {
                        return _this11.pollPayment(requestNumber + 1);
                    });
                } else {
                    return Promise.reject(response.data);
                }
            });
        }
    }, {
        key: 'pollTJPayment',
        value: function pollTJPayment(sessionId) {
            var _this12 = this;

            var requestNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


            var delay = function delay() {
                var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3000;

                return new Promise(function (resolve) {
                    setTimeout(function () {
                        return resolve();
                    }, time);
                });
            };

            var retries = 40;
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/payment/poll-tj-payment?sessionId=' + sessionId, {}).then(function (response) {

                if (response.data.Booking.IsPaid === true) {
                    return Promise.resolve(response.data.Booking);
                } else if (response.data.Booking.IsPaid === false && requestNumber < retries) {
                    return delay(1000).then(function () {
                        return _this12.pollTJPayment(sessionId, requestNumber + 1);
                    });
                } else {
                    return Promise.reject(undefined);
                }
            });
        }
    }, {
        key: 'completeTJOrder',
        value: function completeTJOrder(sessionId) {
            var _this13 = this;

            return this.pollTJPayment(sessionId).then(function (r) {
                var bookingState = r.OrderIdentifiers;
                _this13.tearDown();
                return { bookingNumber: bookingState.VistaBookingNumber, bookingId: bookingState.VistaBookingId, CinemaId: bookingState.CinemaId };
            }, function (r) {
                return Promise.reject(r);
            }).catch(function (e) {});
        }
    }, {
        key: 'completeOrder',
        value: function completeOrder(orderPayload) {
            var _this14 = this;

            return this.pollPayment().then(function (r) {
                var bookingState = r.OrderIdentifiers;
                _this14.tearDown();
                return { bookingNumber: bookingState.VistaBookingNumber, bookingId: bookingState.VistaBookingId, CinemaId: bookingState.CinemaId };
            }, function (r) {
                return Promise.reject(r);
            }).catch(function (e) {});
        }
    }, {
        key: 'tearDown',
        value: function tearDown() {
            this.clearPendingSessions();
            this.clearLoyalties();
            __WEBPACK_IMPORTED_MODULE_8__auth_service__["a" /* default */].clearTempLocalUserOrderInfo();
            this._order = undefined;
            this._order_promise = undefined;
        }
    }, {
        key: 'getTimeToPendingSessionxpiration',
        value: function getTimeToPendingSessionxpiration() {
            return this.pendingSession() ? this.pendingSession().expiry - Date.now() : 0;
        }
    }, {
        key: '_refreshPendingSession',
        value: function _refreshPendingSession() {
            var session = this.pendingSession();
            session.expiry = this._getNewPendingSessionExpiryDate();
        }
    }, {
        key: '_getNewPendingSessionExpiryDate',
        value: function _getNewPendingSessionExpiryDate() {
            var date = Date.now();
            session.expiry = date.setSeconds(date.getSeconds() + SESSION_EXPIRY);
        }
    }, {
        key: 'setPendingSession',
        value: function setPendingSession(SessionId, CinemaId, MovieId) {
            this._order.SessionId = SessionId;
            this._order.CinemaId = CinemaId;
            this._pendingSession = { SessionId: SessionId, CinemaId: CinemaId, expiry: Date.now(), MovieId: MovieId };
            try {
                localStorage.setItem(SESSION_KEY, JSON.stringify(this._pendingSession));
                this.notifyObservers(this.ORDER_CHANGED_EVENT, this._order);
            } catch (e) {}
            return this._order;
        }
    }, {
        key: 'setOrderLoadingState',
        value: function setOrderLoadingState(order, state) {
            if (order) {
                this._order = order;
                if (state) {
                    this._order.loading = state;
                }

                this.notifyObservers(this.ORDER_CHANGED_EVENT, this._order);
            }

            return this._order;
        }
    }, {
        key: 'clearPendingSessions',
        value: function clearPendingSessions() {
            this._pendingSession = undefined;
            try {
                localStorage.removeItem(SESSION_KEY);
            } catch (e) {}
        }
    }, {
        key: 'clearLoyalties',
        value: function clearLoyalties() {
            try {
                localStorage.removeItem('loyalties');
            } catch (e) {}
        }
    }, {
        key: 'getBookings',
        value: function getBookings() {
            if (!this.booking) {
                try {

                    this.booking = JSON.parse(localStorage.getItem("CURRENT_BOOKING"));
                } catch (e) {}
            }
            return this.booking;
        }
    }, {
        key: 'setBooking',
        value: function setBooking(booking) {
            if (!booking) return;
            this.booking = booking;
            try {
                localStorage.setItem("CURRENT_BOOKING", JSON.stringify(booking));
            } catch (e) {}
        }
    }, {
        key: 'getAllOrders',
        value: function getAllOrders() {}
    }, {
        key: 'getOrderAndSeatData',
        value: function getOrderAndSeatData() {
            var _this15 = this;

            var SessionId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.SessionId;
            var CinemaId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.CinemaId;

            return this.getOrder(SessionId).then(function (order) {
                return _this15.getSeatGrid(SessionId, CinemaId, order.TicketsForSeating);
            });
        }
    }, {
        key: 'saveOrderTicketsOnly',
        value: function saveOrderTicketsOnly() {
            var _this16 = this;

            var Order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._order;

            if (!Order) throw new Error('OrderService.saveOrder:: Missing 1st argument - Order can\'t be null');

            return this._order_promise = __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/order/tickets', {
                Order: Order
            }).then(function (response) {
                return _this16._processOrder(response.data);
            }, function (rejection) {
                return _this16._handleRejection(rejection);
            });
        }
    }, {
        key: 'saveOrderConcessionsOnly',
        value: function saveOrderConcessionsOnly() {
            var _this17 = this;

            var Order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._order;

            if (!Order) throw new Error('OrderService.saveOrderConcessionsOnly:: Missing 1st argument - Order can\'t be null');

            return this._order_promise = __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/order/concessions', {
                Order: Order
            }).then(function (response) {
                return _this17._processOrder(response.data);
            }, function (rejection) {
                return _this17._handleRejection(rejection);
            });
        }
    }, {
        key: 'saveTicket',
        value: function saveTicket(Ticket, SessionId, CinemaId) {}
    }, {
        key: 'removeTicket',
        value: function removeTicket(Ticket, SessionId, CinemaId) {}
    }, {
        key: 'refreshSeatGrid',
        value: function refreshSeatGrid() {}
    }, {
        key: 'getRefUrl',
        value: function getRefUrl() {
            var refUrl = document.location.hostname;
            var refPort = document.location.port;
            if (refPort > 0) {
                refUrl = document.location.hostname + ":" + document.location.port;
            }
            return refUrl;
        }
    }, {
        key: 'makePayment',
        value: function makePayment() {
            var _this18 = this;

            var EFT = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var orderUser = arguments[1];

            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/payment/prepare', {
                ref: this.getRefUrl(),
                isEFTPayment: EFT,
                orderUser: orderUser
            }).then(function (response) {
                if (response != undefined && response != null) {
                    if (response.data != undefined && response.data != null) {
                        if (response.data.url) {
                            _this18.setGenreCount().then(function () {
                                window.location.href = response.data.url;
                            });
                        } else {
                            response.success = false;
                            return response;
                        }
                    }
                }
            }, function (error) {
                error.success = false;
                return error;
            });
        }
    }, {
        key: 'makePaymentConcessions',
        value: function makePaymentConcessions(orderUser) {
            var _this19 = this;

            if (!this._order) throw Error("ORDERSERVICE::MAKECONCESSIONPAYMENT No Order supplied");
            var refUrl = document.location.hostname;
            var refPort = document.location.port;
            if (refPort > 0) {
                refUrl = document.location.hostname + ":" + document.location.port;
            }
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/payment/prepare', {
                ref: refUrl,
                amount: this._order.totalInCents,
                isDonationOrder: true,
                orderUser: orderUser
            }).then(function (response) {
                if (response.data.url) {
                    window.location.href = response.data.url;
                } else {}
            }, function (error) {
                _this19.seatGrid = undefined;
                return Promise.reject(error);
            });
        }
    }, {
        key: 'getTransactionHistory',
        value: function getTransactionHistory() {
            return this._history_promise = this._history_promise || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/member/transactions').then(function (response) {
                return new __WEBPACK_IMPORTED_MODULE_7__model_ModelArray__["a" /* default */](response.data, __WEBPACK_IMPORTED_MODULE_5__model_Transaction__["a" /* default */]);
            }, function (error) {
                return Promise.reject(error);
            });
        }
    }, {
        key: 'getBooking',
        value: function getBooking(BookingNumber, BookingId) {
            var CinemaId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/order/booking/' + BookingNumber + '/' + BookingId + '/' + CinemaId).then(function (r) {
                return new __WEBPACK_IMPORTED_MODULE_7__model_ModelArray__["a" /* default */](r.data, __WEBPACK_IMPORTED_MODULE_6__model_Booking__["a" /* default */]);
            });
        }
    }, {
        key: 'getBookingHistory',
        value: function getBookingHistory() {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/member/bookings').then(function (response) {
                var bookings = new __WEBPACK_IMPORTED_MODULE_7__model_ModelArray__["a" /* default */](response.data, __WEBPACK_IMPORTED_MODULE_6__model_Booking__["a" /* default */]);
                return bookings;
            }, function (error) {
                return Promise.reject(error);
            });
        }
    }, {
        key: 'cancelOrder',
        value: function cancelOrder() {
            var session_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var cinema_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/order/cancel", { SessionId: session_id, CinemaId: cinema_id }).then(function (response) {
                localStorage.removeItem("humanzTracking");
                return response;
            }, function (error) {
                return Promise.reject(error);
            });
        }
    }, {
        key: 'continueOrder',
        value: function continueOrder() {
            var _this20 = this;

            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/order/continue").then(function (response) {
                Object.assign(_this20._order, response.data);
                _this20._order.setDates(response.data.ExpiryDate, response.data.LastUpdated);

                _this20.notifyObservers(_this20.ORDER_CHANGED_EVENT, _this20._order);
                return response.data;
            }, function (error) {
                Promise.reject(error);
            });
        }
    }, {
        key: 'newConcessionOrder',
        value: function newConcessionOrder(concession, cinema_id) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/concession/order", {
                concessions: [concession],
                CinemaId: cinema_id
            }).then(function (response) {
                return response;
            }, function (error) {
                Promise.reject(error);
            });
        }
    }, {
        key: 'cancelConcessionOrder',
        value: function cancelConcessionOrder(cinema_id) {
            if (this._order) {
                return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/order/cancel", { CinemaId: cinema_id }).then(function (response) {
                    return response;
                }, function (error) {
                    return Promise.reject(error);
                });
            }

            return true;
        }
    }, {
        key: 'getConcessionOrder',
        value: function getConcessionOrder() {
            var _this21 = this;

            return this._order_promise = __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/order').then(function (response) {
                return _this21._processOrder(response.data);
            }, this._handleRejection);
        }
    }, {
        key: 'getPaymentConfig',
        value: function getPaymentConfig() {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/payment/config').then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'generateConfirmationPDF',
        value: function generateConfirmationPDF(booking_base_id, booking_number, cinema_id) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].defaults.baseLinkURL + ('/storage/pdf/' + booking_base_id + '/' + booking_number + '/' + cinema_id);
        }
    }, {
        key: 'removeSession',
        value: function removeSession(session_id) {
            var _this22 = this;

            return this.cancelOrder(session_id).then(function (response) {
                _this22._order.setDates(response.data.ExpiryDate, response.data.LastUpdated);
                _this22._order.removeSession(session_id);
                return _this22._order;
            });
        }
    }, {
        key: 'setGenreCount',
        value: function setGenreCount() {
            var _this23 = this;

            if (!this._order.Session) return new Promise(function (resolve) {
                return resolve();
            });

            return Promise.all([__WEBPACK_IMPORTED_MODULE_8__auth_service__["a" /* default */].user(), this._order.Session.MoviePromise]).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    user = _ref2[0],
                    movie = _ref2[1];

                if (user.isGuest()) return;
                try {
                    var genres = _this23._order.Genres;
                    var storedGenlocalStorage = localStorage.getItem('genres');
                    storedGenlocalStorage = storedGenlocalStorage ? JSON.parse(storedGenlocalStorage) : {};
                    for (var i = 0; i < genres.length; i++) {
                        var genre = genres[i];
                        if (!~user.PreferredGenres.indexOf(parseInt(genre.id))) {
                            if (!storedGenlocalStorage.hasOwnProperty(genre.id)) {

                                storedGenlocalStorage[genre.id] = 1;
                            } else {
                                storedGenlocalStorage[genre.id] = parseInt(storedGenlocalStorage[genre.id]) + 1;
                            }
                        } else delete storedGenlocalStorage[genre.id];
                    }

                    localStorage.setItem("genres", JSON.stringify(storedGenlocalStorage));
                } catch (e) {}
                return true;
            });
        }
    }, {
        key: 'commitGenreCount',
        value: function commitGenreCount() {
            return __WEBPACK_IMPORTED_MODULE_8__auth_service__["a" /* default */].user().then(function (user) {
                if (user.isGuest()) return;
                try {
                    var storedGenlocalStorage = localStorage.getItem('genres');
                    storedGenlocalStorage = storedGenlocalStorage ? JSON.parse(storedGenlocalStorage) : {};
                    for (var i = 0; i < Object.keys(storedGenlocalStorage).length; i++) {
                        var key = Object.keys(storedGenlocalStorage)[i];
                        if (storedGenlocalStorage[key] > 1 && !~user.PreferredGenres.indexOf(parseInt(key))) {
                            user.PreferredGenres.push(parseInt(key));
                            user.save();
                            delete storedGenlocalStorage[key];
                        }
                    }
                    localStorage.setItem("genres", JSON.stringify(storedGenlocalStorage));
                } catch (e) {}
                return true;
            });
        }
    }, {
        key: 'getStandAloneCinemaId',
        value: function getStandAloneCinemaId(cinema_type) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/order/standalone-cinema-id').then(function (response) {
                return response.data.CinemaId;
            });
        }
    }, {
        key: 'prepareSubs',
        value: function prepareSubs(card, item, user, pin) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/payment/prepare-subs", { 'card': card, 'item': item, 'userDetails': user, 'pin': pin }).then(function (response) {
                return response;
            }, function (error) {
                return Promise.reject(error);
            });
        }
    }, {
        key: 'prepareSubsUpdateDetails',
        value: function prepareSubsUpdateDetails(card) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/payment/prepare-subs-update-details", { 'card': card }).then(function (response) {
                return response;
            }, function (error) {
                return Promise.reject(error);
            });
        }
    }, {
        key: 'updateSubsPaymentDetails',
        value: function updateSubsPaymentDetails(card) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/payment/update-details", { card: card }).then(function (response) {
                return response;
            }, function (error) {
                return Promise.reject(error);
            });
        }
    }, {
        key: 'getApiHttpDefaultBaseLinkUrl',
        value: function getApiHttpDefaultBaseLinkUrl() {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].defaults.baseLinkURL;
        }
    }, {
        key: 'getSessionAvailableSeatCount',
        value: function getSessionAvailableSeatCount(session_id) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/order/get-session-available-seat-count/" + session_id).then(function (response) {
                return response;
            });
        }
    }, {
        key: 'addVistaVoucherTicket',
        value: function addVistaVoucherTicket(sessionId, Qty, NewTicketTypeCode, OriginalTicketTypeCode, AreaCategoryCode, Barcode) {
            var _this24 = this;

            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/order/add-vista-voucher-ticket', {
                qty: Qty,
                newTicketTypeCode: NewTicketTypeCode,
                originalTicketTypeCode: OriginalTicketTypeCode,
                areaCategoryCode: AreaCategoryCode,
                sessionId: sessionId,
                barcode: Barcode
            }).then(function (response) {
                return _this24._processOrder(response.data);
            }, function (rejection) {
                return _this24._handleRejection(rejection);
            });
        }
    }, {
        key: 'removeVistaVoucherTicket',
        value: function removeVistaVoucherTicket(sessionId, cinemaId, ticket) {
            var _this25 = this;

            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/order/remove-vista-voucher-ticket', {
                sessionId: sessionId,
                cinemaId: cinemaId,
                ticket: ticket
            }).then(function (response) {
                return _this25._processOrder(response.data);
            }, function (rejection) {
                return _this25._handleRejection(rejection);
            });
        }
    }, {
        key: 'removeVistaLoyaltyTicket',
        value: function removeVistaLoyaltyTicket(sessionId, cinemaId, ticket) {
            var _this26 = this;

            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/order/remove-vista-loyalty-ticket', {
                sessionId: sessionId,
                cinemaId: cinemaId,
                ticket: ticket
            }).then(function (response) {
                return _this26._processOrder(response.data);
            }, function (rejection) {
                return _this26._handleRejection(rejection);
            });
        }
    }, {
        key: 'addVistaSeatsForLoyaltyCard',
        value: function addVistaSeatsForLoyaltyCard(sessionId, Qty, NewTicketTypeCode, OriginalTicketTypeCode, AreaCategoryCode, MemberCard) {
            var _this27 = this;

            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/order/add-vista-seat-for-ticket-type', {
                qty: Qty,
                newTicketTypeCode: NewTicketTypeCode,
                originalTicketTypeCode: OriginalTicketTypeCode,
                areaCategoryCode: AreaCategoryCode,
                sessionId: sessionId,
                memberCard: MemberCard
            }).then(function (response) {}, function (rejection) {
                return _this27._handleRejection(rejection);
            });
        }
    }, {
        key: 'addVistaSeatsForTicket',
        value: function addVistaSeatsForTicket(ticket, sessionId) {
            var _this28 = this;

            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/order/add-vista-ticket', {
                ticket: ticket,
                sessionId: sessionId
            }).then(function (response) {
                return _this28._processOrder(response.data);
            }, function (rejection) {
                return _this28._handleRejection(rejection);
            });
        }
    }, {
        key: 'removeVistaSeatsForTicket',
        value: function removeVistaSeatsForTicket(position, status, ticketTypeCode, sessionId) {
            var _this29 = this;

            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/order/remove-vista-ticket', {
                position: position,
                status: status,
                ticketTypeCode: ticketTypeCode,
                sessionId: sessionId
            }).then(function (response) {
                return _this29._processOrder(response.data);
            }, function (rejection) {
                return _this29._handleRejection(rejection);
            });
        }
    }, {
        key: 'getDefaultTicketTypeForSession',
        value: function getDefaultTicketTypeForSession(session_id, cinema_id, areaCategoryCode) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/order/get-default-ticket-type-for-session/' + session_id + '/' + cinema_id + '/' + areaCategoryCode).then(function (response) {
                return response;
            });
        }
    }, {
        key: 'getDefaultTicketTypeForSessionAndCinema',
        value: function getDefaultTicketTypeForSessionAndCinema(session_id, cinema_id) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/order/get-default-ticket-type-by-session-and-cinema/' + session_id + '/' + cinema_id).then(function (response) {
                return response;
            });
        }
    }]);

    return OrderService;
}(__WEBPACK_IMPORTED_MODULE_1__util_observable__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new OrderService());

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_home_vue__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__faqs_faq_vue__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__faqs_faq_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__faqs_faq_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__legal_legal_vue__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__legal_legal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__legal_legal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__details_details_vue__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__details_details_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__details_details_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__booking_booking_vue__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__booking_booking_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__booking_booking_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_user_vue__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_user_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__user_user_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_activate_vue__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_activate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__user_activate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_password_reset_vue__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_password_reset_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__user_password_reset_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__user_password_validate_vue__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__user_password_validate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__user_password_validate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_profile_vue__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_profile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__user_profile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__seats_seats_vue__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__seats_seats_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__seats_seats_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__payment_payment_vue__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__payment_payment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__payment_payment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__payment_donation_vue__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__payment_donation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__payment_donation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__contact_us_contact_us_vue__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__contact_us_contact_us_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__contact_us_contact_us_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__promo_promo_vue__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__promo_promo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__promo_promo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__event_event_vue__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__event_event_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__event_event_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__about_about_vue__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__about_about_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__about_about_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__news_news_vue__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__news_news_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__news_news_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__vouchers_voucher_vue__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__vouchers_voucher_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__vouchers_voucher_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__careers_careers_vue__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__careers_careers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__careers_careers_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__procurement_procurement_vue__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__procurement_procurement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__procurement_procurement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__vision_mission_vision_mission_vue__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__vision_mission_vision_mission_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__vision_mission_vision_mission_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__discovery_vitality_discovery_vitality_vue__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__discovery_vitality_discovery_vitality_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__discovery_vitality_discovery_vitality_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__club_loyalty_info_club_loyalty_info_vue__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__club_loyalty_info_club_loyalty_info_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__club_loyalty_info_club_loyalty_info_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__club_loyalty_club_loyalty_vue__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__club_loyalty_club_loyalty_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__club_loyalty_club_loyalty_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__content_content_vue__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__content_content_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__content_content_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__content_preview__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__exclusive_to_sk_exclusive_to_sk_vue__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__exclusive_to_sk_exclusive_to_sk_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__exclusive_to_sk_exclusive_to_sk_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__film_festivals_film_festivals_vue__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__film_festivals_film_festivals_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__film_festivals_film_festivals_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__sales_at_sk_sales_at_sk_vue__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__sales_at_sk_sales_at_sk_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__sales_at_sk_sales_at_sk_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__competitions_competitions_vue__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__competitions_competitions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__competitions_competitions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__competitions_competition_vue__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__competitions_competition_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__competitions_competition_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__page_not_found_page_not_found_vue__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__page_not_found_page_not_found_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__page_not_found_page_not_found_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__donate_donate_vue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__donate_donate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__donate_donate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__confirm_email_change_confirm_email_change_vue__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__confirm_email_change_confirm_email_change_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__confirm_email_change_confirm_email_change_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__subs_club_subs_club_vue__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__subs_club_subs_club_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__subs_club_subs_club_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__subscribe_subscribe_vue__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__subscribe_subscribe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__subscribe_subscribe_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__subscribe_process_subscribe_process_vue__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__subscribe_process_subscribe_process_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__subscribe_process_subscribe_process_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__subscribe_failure_subscribe_failure_vue__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__subscribe_failure_subscribe_failure_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__subscribe_failure_subscribe_failure_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__cinemas_cinemas_vue__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__cinemas_cinemas_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__cinemas_cinemas_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Home", function() { return __WEBPACK_IMPORTED_MODULE_0__home_home_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FAQ", function() { return __WEBPACK_IMPORTED_MODULE_1__faqs_faq_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Legal", function() { return __WEBPACK_IMPORTED_MODULE_2__legal_legal_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "User", function() { return __WEBPACK_IMPORTED_MODULE_5__user_user_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PasswordReset", function() { return __WEBPACK_IMPORTED_MODULE_7__user_password_reset_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PasswordValidate", function() { return __WEBPACK_IMPORTED_MODULE_8__user_password_validate_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Profile", function() { return __WEBPACK_IMPORTED_MODULE_9__user_profile_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Details", function() { return __WEBPACK_IMPORTED_MODULE_3__details_details_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Booking", function() { return __WEBPACK_IMPORTED_MODULE_4__booking_booking_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Seats", function() { return __WEBPACK_IMPORTED_MODULE_10__seats_seats_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Payment", function() { return __WEBPACK_IMPORTED_MODULE_11__payment_payment_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PaymentDonation", function() { return __WEBPACK_IMPORTED_MODULE_12__payment_donation_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "About", function() { return __WEBPACK_IMPORTED_MODULE_16__about_about_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "News", function() { return __WEBPACK_IMPORTED_MODULE_17__news_news_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Vouchers", function() { return __WEBPACK_IMPORTED_MODULE_18__vouchers_voucher_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Careers", function() { return __WEBPACK_IMPORTED_MODULE_19__careers_careers_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Procurement", function() { return __WEBPACK_IMPORTED_MODULE_20__procurement_procurement_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "VisionMission", function() { return __WEBPACK_IMPORTED_MODULE_21__vision_mission_vision_mission_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContactUs", function() { return __WEBPACK_IMPORTED_MODULE_13__contact_us_contact_us_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Promo", function() { return __WEBPACK_IMPORTED_MODULE_14__promo_promo_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ClubLoyalty", function() { return __WEBPACK_IMPORTED_MODULE_24__club_loyalty_club_loyalty_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ClubLoyaltyInfo", function() { return __WEBPACK_IMPORTED_MODULE_23__club_loyalty_info_club_loyalty_info_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DiscoveryVitality", function() { return __WEBPACK_IMPORTED_MODULE_22__discovery_vitality_discovery_vitality_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Content", function() { return __WEBPACK_IMPORTED_MODULE_25__content_content_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ExclusiveToSK", function() { return __WEBPACK_IMPORTED_MODULE_27__exclusive_to_sk_exclusive_to_sk_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FilmFestivalDetails", function() { return __WEBPACK_IMPORTED_MODULE_28__film_festivals_film_festivals_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SalesAtSk", function() { return __WEBPACK_IMPORTED_MODULE_29__sales_at_sk_sales_at_sk_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Event", function() { return __WEBPACK_IMPORTED_MODULE_15__event_event_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Competitions", function() { return __WEBPACK_IMPORTED_MODULE_30__competitions_competitions_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PageNotFound", function() { return __WEBPACK_IMPORTED_MODULE_32__page_not_found_page_not_found_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "VisionMissionDonate", function() { return __WEBPACK_IMPORTED_MODULE_33__donate_donate_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Competition", function() { return __WEBPACK_IMPORTED_MODULE_31__competitions_competition_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Donate", function() { return __WEBPACK_IMPORTED_MODULE_33__donate_donate_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ConfirmEmailChange", function() { return __WEBPACK_IMPORTED_MODULE_34__confirm_email_change_confirm_email_change_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Activate", function() { return __WEBPACK_IMPORTED_MODULE_6__user_activate_vue___default.a; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Preview", function() { return __WEBPACK_IMPORTED_MODULE_26__content_preview__["a"]; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SubsClub", function() { return __WEBPACK_IMPORTED_MODULE_35__subs_club_subs_club_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SubsClubSubscribe", function() { return __WEBPACK_IMPORTED_MODULE_36__subscribe_subscribe_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SubscribeProcess", function() { return __WEBPACK_IMPORTED_MODULE_37__subscribe_process_subscribe_process_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SubscribeFailure", function() { return __WEBPACK_IMPORTED_MODULE_38__subscribe_failure_subscribe_failure_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CinemasPage", function() { return __WEBPACK_IMPORTED_MODULE_39__cinemas_cinemas_vue___default.a; });












































/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    title: "400 Points",
    description: "Free Regular Popcorn",
    available: true,
    points: 400,
    nextPoints: 800,
    color: null,
    icon: 'popcorn',
    test: function test(reward) {
        return ~reward.Description.toLowerCase().indexOf("400 points");
    }
}, {
    title: "800 Points",
    description: "Free Coke & Popcorn Combo",
    available: true,
    points: 800,
    nextPoints: 1000,
    color: 'green',
    icon: 'combo',
    test: function test(reward) {
        return ~reward.Description.toLowerCase().indexOf("800 points");
    }
}, {
    title: "1000 Points",
    description: "Free Movie Ticket",
    available: true,
    points: 1000,
    nextPoints: 1200,
    redirect: '/?filter=reward',
    color: 'yellow',
    icon: 'free-movieticket',
    test: function test(reward) {
        return ~reward.Description.toLowerCase().indexOf("1000 points");
    }
}, {
    title: "1200 Points",
    description: "Free 3D Movie Ticket",
    redirect: '/?filter=3D',
    available: false,
    points: 1200,
    nextPoints: 1500,
    color: 'orange',
    icon: 'ticket-3d',
    test: function test(reward) {
        return ~reward.Description.toLowerCase().indexOf("1200 points");
    }
}, {
    title: "1500 Points",
    points: 1500,
    available: true,
    nextPoints: 0,
    description: "Free Cine Prestige Movie Ticket",
    redirect: '/?filter=prestige',
    color: 'red',
    icon: 'prestige-movieticket',
    test: function test(reward) {
        return ~reward.Description.toLowerCase().indexOf("1500 points");
    }
}, {
    title: "Birthday",
    description: "Birthday Movie Ticket",
    available: true,
    color: 'purple',
    redirect: '/?filter=reward',
    icon: 'birthday',
    test: function test(reward) {
        return ~reward.Description.toLowerCase().indexOf("birthday");
    }
}]);

/***/ }),
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'cardSkClub',
    props: {
        onLink: Function,
        onActivate: Function,
        isLinked: Boolean,
        isJoined: Boolean,
        CardNumber: String,
        linking: Boolean,
        activating: Boolean,
        activationLink: String,
        moreInfoLink: String,
        disabled: Boolean,
        genericMessage: String
    },
    data: function data() {
        return {
            showConfirmReplaceCard: false,
            thisCardNumber: null,
            showCardAdder: false,
            joining: false
        };
    },


    methods: {},

    watch: {
        linking: function linking(nw, old) {
            if (nw == false && this.isLinked && this.thisCardNumber == this.CardNumber) {
                this.showCardAdder = false;
            }

            if (nw == false) this.joining = false;
        }
    }

});

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(15);
var settle = __webpack_require__(447);
var buildURL = __webpack_require__(449);
var parseHeaders = __webpack_require__(450);
var isURLSameOrigin = __webpack_require__(451);
var createError = __webpack_require__(100);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(452);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(453);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(448);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModel__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_auth_service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_region_service__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Membership__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

var User = function (_BaseModel) {
    _inherits(User, _BaseModel);

    function User() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, User);

        var date = data.DateOfBirth ? new Date(parseInt(data.DateOfBirth)) : undefined;

        var _this = _possibleConstructorReturn(this, (User.__proto__ || Object.getPrototypeOf(User)).call(this));

        _this.MemberId = data.MemberId;
        _this.FirstName = data.FirstName;
        _this.LastName = data.LastName;
        _this.CardNumber = data.CardNumber;
        _this.MobilePhone = data.MobilePhone;
        _this.HomePhone = data.HomePhone || false;
        _this.Email = data.Email;
        _this.ClubID = data.ClubID;
        _this.CardList = data.CardList || [];
        _this.MembershipActivated = Boolean(data.MembershipActivated);
        _this.ExpiryPointsList = data.ExpiryPointsList || [];
        _this.MemberLevelId = data.MemberLevelId || 19;
        _this.BalanceList = data.BalanceList || [];
        _this.SendNewsletter = Boolean(data.SendNewsletter);
        _this._DobYear = date ? date.getFullYear() : undefined;
        _this._DobMonth = date ? Months[date.getMonth()] : undefined;
        _this._DobDay = date ? date.getDate() : undefined;
        _this.CreatedDate = data.ExpiryDate ? __WEBPACK_IMPORTED_MODULE_4_moment___default.a.unix(parseInt(data.ExpiryDate) / 1000).subtract(100, 'years') : null;
        _this.PreferredComplexList = data.PreferredComplexList || [];
        _this.PreferenceList = data.PreferenceList || [];
        _this.PreferredGenres = data.PreferredGenres || [];
        _this.PreferredComplex = undefined;
        _this.PersonsInHousehold = data.PersonsInHousehold || 1;
        _this.Gender = data.Gender || undefined;
        _this.NationalID = data.NationalID || undefined;
        _this.StandardBankBenefit = data.StandardBankBenefit || false;
        _this.UserSessionId = data.UserSessionId;
        _this.WorkZipCode = data.WorkZipCode || undefined;
        _this.ZipCode = data.ZipCode || "False";

        if (data.PreferredComplex) {
            _this.PreferredComplex = {};
            __WEBPACK_IMPORTED_MODULE_2__service_region_service__["a" /* default */].getRegions().then(function (regions) {
                for (var r = 0; r < regions.data.length; r++) {
                    for (var c = 0; c < regions.data[r].cinemas.length; c++) {

                        if (data.PreferredComplex == regions.data[r].cinemas[c].loyalty_cinema_id) {
                            _this.PreferredComplex = regions.data[r].cinemas[c];
                        }
                    }
                }
            });
        }

        return _this;
    }

    _createClass(User, [{
        key: 'setActivated',
        value: function setActivated(activated) {
            this.MembershipActivated = Boolean(activated);
            __WEBPACK_IMPORTED_MODULE_1__service_auth_service__["a" /* default */].notifyObservers(__WEBPACK_IMPORTED_MODULE_1__service_auth_service__["a" /* default */].PROFILE_CHANGED);
        }
    }, {
        key: 'isVip',
        value: function isVip() {
            return this.MemberLevelId === 2;
        }
    }, {
        key: 'isGuest',
        value: function isGuest() {
            return !this.MemberId;
        }
    }, {
        key: 'addCard',
        value: function addCard(CardNumber, Type) {
            if (!~this.CardList.findIndex(function (m) {
                return m.CardNumber == CardNumber;
            })) {
                this.CardList = [];
                this.CardList.push(new __WEBPACK_IMPORTED_MODULE_3__Membership__["a" /* default */]({ CardNumber: CardNumber, Type: Type }));
            }
            return this.CardList;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            return (this.MemberId ? __WEBPACK_IMPORTED_MODULE_1__service_auth_service__["a" /* default */].updateUser(this) : __WEBPACK_IMPORTED_MODULE_1__service_auth_service__["a" /* default */].signUp(this)).then(function (user) {
                if (user) {
                    Object.assign(_this2, user);
                }
                return _this2;
            });
        }
    }, {
        key: 'saveCards',
        value: function saveCards() {
            var _this3 = this;

            return new Promise(function (resolver, rejector) {
                if (_this3.MemberId) __WEBPACK_IMPORTED_MODULE_1__service_auth_service__["a" /* default */].updateUserCards({ CardList: _this3.CardList }).then(function (response) {
                    resolver(response);
                }, function (er) {
                    return rejector(er);
                });else {
                    rejector('attempting to modify an anonymous user!');
                }
            });
        }
    }, {
        key: '_cardListAsStringArray',
        value: function _cardListAsStringArray() {
            return this.CardList.map(function (item) {
                return JSON.stringify(item);
            });
        }
    }, {
        key: 'toJSON',
        value: function toJSON() {
            return {
                FirstName: this.FirstName,
                LastName: this.LastName,
                Email: this.Email,
                Password: this.Password || undefined,
                MobilePhone: this.MobilePhone,
                DateOfBirth: this.DateOfBirth,
                Memberships: this.Memberships,
                SendNewsletter: this.SendNewsletter,
                PreferenceList: this.PreferenceList,
                PreferredGenres: this.PreferredGenres,
                PreferredComplexList: this.PreferredComplexList,
                PreferredComplex: this.PreferredComplex,
                PersonsInHousehold: this.PersonsInHousehold,
                Gender: this.Gender,
                NationalID: this.NationalID,
                MemberLevelId: this.MemberLevelId,
                CardNumber: this.CardNumber,
                _DobMonth: this._DobMonth,
                _DobDay: this._DobDay,
                _DobYear: this._DobYear,
                StandardBankBenefit: this.StandardBankBenefit,
                UserSessionId: this.UserSessionId,
                WorkZipCode: this.WorkZipCode,
                ZipCode: this.ZipCode
            };
        }
    }, {
        key: 'DateOfBirth',
        get: function get() {
            var hasDob = this._DobYear && this._DobMonth != undefined && this._DobDay;
            var month = hasDob ? Months.indexOf(this._DobMonth) : null;
            return hasDob ? new Date(this._DobYear, month, this._DobDay, 0, 0, 0, 0) : undefined;
        }
    }, {
        key: 'FullName',
        get: function get() {
            return this.FirstName ? this.FirstName + (this.LastName ? ' ' + this.LastName : undefined) : undefined;
        }
    }, {
        key: 'PointsBalance',
        get: function get() {
            return this.BalanceList.reduce(function (val, balObj) {
                return val += balObj.PointsRemaining;
            }, 0) || 0;
        }
    }, {
        key: 'LifeTimePoints',
        get: function get() {
            return this.BalanceList.reduce(function (val, balObj) {
                return val += balObj.LifetimePointsBalanceDisplay;
            }, 0) || 0;
        }
    }, {
        key: 'isGuestUser',
        get: function get() {
            return this.isGuest();
        }
    }]);

    return User;
}(__WEBPACK_IMPORTED_MODULE_0__BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModel__ = __webpack_require__(8);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Genre = function (_BaseModel) {
    _inherits(Genre, _BaseModel);

    function Genre(data) {
        _classCallCheck(this, Genre);

        var _this = _possibleConstructorReturn(this, (Genre.__proto__ || Object.getPrototypeOf(Genre)).call(this, data));

        _this.id = data.id || data.ID;
        _this.name = data.name || data.Name;
        _this.description = data.description || data.Description;
        return _this;
    }

    return Genre;
}(__WEBPACK_IMPORTED_MODULE_0__BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Genre);

/***/ }),
/* 105 */,
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        ss : '%d sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        ss : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        ss : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        ss : '%d ثانية',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        ss : '%d saniyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        ss : '%d секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

// Language contact person : Abdoufata Kane : https://github.com/abdoufata

var bm = moment.defineLocale('bm', {
    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'MMMM [tile] D [san] YYYY',
        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
    },
    calendar : {
        sameDay : '[Bi lɛrɛ] LT',
        nextDay : '[Sini lɛrɛ] LT',
        nextWeek : 'dddd [don lɛrɛ] LT',
        lastDay : '[Kunu lɛrɛ] LT',
        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s kɔnɔ',
        past : 'a bɛ %s bɔ',
        s : 'sanga dama dama',
        ss : 'sekondi %d',
        m : 'miniti kelen',
        mm : 'miniti %d',
        h : 'lɛrɛ kelen',
        hh : 'lɛrɛ %d',
        d : 'tile kelen',
        dd : 'tile %d',
        M : 'kalo kelen',
        MM : 'kalo %d',
        y : 'san kelen',
        yy : 'san %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return bm;

})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
};
var numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        ss : '%d সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
};
var numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        ss : '%d སྐར་ཆ།',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        ss : '%d eilenn',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            if (number === 1) {
                result += 'sekunda';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
            } else {
                result += 'sekundi';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        ss     : translate,
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : 'D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        ss : '%d segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekund');
            } else {
                return result + 'sekundami';
            }
            break;
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        ss : '%d ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        ss: '%d eiliad',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        ss : '%d sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
];
var weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        ss : 'd% ސިކުންތު',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        ss : '%d δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        ss : '%d sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex : monthsRegex,
    monthsShortRegex : monthsRegex,
    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse: monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esUs = moment.defineLocale('es-us', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'MM/DD/YYYY',
        LL : 'MMMM [de] D [de] YYYY',
        LLL : 'MMMM [de] D [de] YYYY h:mm A',
        LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return esUs;

})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'ss': [number + 'sekundi', number + 'sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        ss     : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        ss : '%d segundo',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
};
var numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        ss : 'ثانیه d%',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'ss':
            return isFuture ? 'sekunnin' : 'sekuntia';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        ss : '%d sekundir',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        ss : '%d sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        ss : '%d diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'ss': [number + ' secondanim', number + ' second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        ss : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
        '1': '૧',
        '2': '૨',
        '3': '૩',
        '4': '૪',
        '5': '૫',
        '6': '૬',
        '7': '૭',
        '8': '૮',
        '9': '૯',
        '0': '૦'
    };
var numberMap = {
        '૧': '1',
        '૨': '2',
        '૩': '3',
        '૪': '4',
        '૫': '5',
        '૬': '6',
        '૭': '7',
        '૮': '8',
        '૯': '9',
        '૦': '0'
    };

var gu = moment.defineLocale('gu', {
    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
    monthsParseExact: true,
    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
    longDateFormat: {
        LT: 'A h:mm વાગ્યે',
        LTS: 'A h:mm:ss વાગ્યે',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
    },
    calendar: {
        sameDay: '[આજ] LT',
        nextDay: '[કાલે] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[ગઇકાલે] LT',
        lastWeek: '[પાછલા] dddd, LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%s મા',
        past: '%s પેહલા',
        s: 'અમુક પળો',
        ss: '%d સેકંડ',
        m: 'એક મિનિટ',
        mm: '%d મિનિટ',
        h: 'એક કલાક',
        hh: '%d કલાક',
        d: 'એક દિવસ',
        dd: '%d દિવસ',
        M: 'એક મહિનો',
        MM: '%d મહિનો',
        y: 'એક વર્ષ',
        yy: '%d વર્ષ'
    },
    preparse: function (string) {
        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'રાત') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'સવાર') {
            return hour;
        } else if (meridiem === 'બપોર') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'સાંજ') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'રાત';
        } else if (hour < 10) {
            return 'સવાર';
        } else if (hour < 17) {
            return 'બપોર';
        } else if (hour < 20) {
            return 'સાંજ';
        } else {
            return 'રાત';
        }
    },
    week: {
        dow: 0, // Sunday is the first day of the week.
        doy: 6 // The week that contains Jan 1st is the first week of the year.
    }
});

return gu;

})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        ss : '%d שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        ss : '%d सेकंड',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            if (number === 1) {
                result += 'sekunda';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
            } else {
                result += 'sekundi';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        ss     : translate,
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'ss':
            return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        ss : '%d վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        ss : '%d detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'ss':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
            }
            return result + 'sekúnda';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        ss : '%d secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        ss : '%d秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        ss : '%d detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        ss : '%d წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        ss : '%d секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        ss: '%d វិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
};
var numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        ss : '%d ಸೆಕೆಂಡುಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '일';
            case 'M':
                return number + '월';
            case 'w':
            case 'W':
                return number + '주';
            default:
                return number;
        }
    },
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        ss : '%d секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        ss : '%d Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        ss : '%d ວິນາທີ' ,
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'ss' : 'sekundė_sekundžių_sekundes',
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        ss : translate,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        ss : relativeTimeWithPlural,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['sekund', 'sekunda', 'sekundi'],
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        ss: '%d hēkona',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        ss : '%d секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        ss : '%d സെക്കൻഡ്',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'ss': output = '%d सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'ss': output = '%d सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        ss: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        ss : '%d saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        ss : '%d saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mt = moment.defineLocale('mt', {
    months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
    monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
    weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
    weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
    weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Illum fil-]LT',
        nextDay : '[Għada fil-]LT',
        nextWeek : 'dddd [fil-]LT',
        lastDay : '[Il-bieraħ fil-]LT',
        lastWeek : 'dddd [li għadda] [fil-]LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'f’ %s',
        past : '%s ilu',
        s : 'ftit sekondi',
        ss : '%d sekondi',
        m : 'minuta',
        mm : '%d minuti',
        h : 'siegħa',
        hh : '%d siegħat',
        d : 'ġurnata',
        dd : '%d ġranet',
        M : 'xahar',
        MM : '%d xhur',
        y : 'sena',
        yy : '%d sni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mt;

})));


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
};
var numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        ss : '%d စက္ကန့်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        ss : '%d sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        ss : '%d सेकेण्ड',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        ss : '%d seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        ss : '%d seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        ss : '%d sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
};
var numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        ss : '%d ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            return result + (plural(number) ? 'sekundy' : 'sekund');
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W niedzielę o] LT';

                case 2:
                    return '[We wtorek o] LT';

                case 3:
                    return '[W środę o] LT';

                case 6:
                    return '[W sobotę o] LT';

                default:
                    return '[W] dddd [o] LT';
            }
        },
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'ss': 'secunde',
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        ss : relativeTimeWithPlural,
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., H:mm',
        LLLL : 'dddd, D MMMM YYYY г., H:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ru;

})));


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        ss : '%d سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        ss: '%d sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        ss : 'තත්පර %d',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekúnd');
            } else {
                return result + 'sekundami';
            }
            break;
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'ss':
            if (number === 1) {
                result += withoutSuffix ? 'sekundo' : 'sekundi';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
            } else {
                result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        ss     : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        ss : '%d sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['sekunda', 'sekunde', 'sekundi'],
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['секунда', 'секунде', 'секунди'],
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        ss : '%d mzuzwana',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        ss : '%d sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        ss : 'sekunde %d',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
};
var numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        ss : '%d விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        ss : '%d సెకన్లు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        ss : 'minutu %d',
        m : 'minutu ida',
        mm : 'minutus %d',
        h : 'horas ida',
        hh : 'horas %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        ss : '%d วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        ss : '%d segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'ss':
            return numberNoun + ' lup';
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        ss : translate,
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[gelecek] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        ss : '%d saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '\'ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        ss : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'ss': [number + ' secunds', '' + number + ' secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        ss : '%d ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        ss : '%d imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        ss : '%d سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        ss : '%d фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        ss : '%d soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        ss : '%d giây' ,
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        ss : '%d s~écóñ~ds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        ss :'aayá %d',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日Ah点mm分',
        LLLL : 'YYYY年M月D日ddddAh点mm分',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        ss : '%d 秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日dddd HH:mm',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        ss : '%d 秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日dddd HH:mm',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        ss : '%d 秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModel__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModelArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Experience__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VistaDate__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Flag__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__service_region_service__ = __webpack_require__(48);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var MovieSession = function (_BaseModel) {
    _inherits(MovieSession, _BaseModel);

    function MovieSession(data) {
        _classCallCheck(this, MovieSession);

        var _this = _possibleConstructorReturn(this, (MovieSession.__proto__ || Object.getPrototypeOf(MovieSession)).call(this));

        _this.id = data.id;
        _this.cinema_id = data.cinema_id, _this.experiences = data.experiences ? new __WEBPACK_IMPORTED_MODULE_1__ModelArray__["a" /* default */](data.experiences, __WEBPACK_IMPORTED_MODULE_2__Experience__["a" /* default */]) : [];
        _this.flags = data.flags ? new __WEBPACK_IMPORTED_MODULE_1__ModelArray__["a" /* default */](data.flags, __WEBPACK_IMPORTED_MODULE_4__Flag__["a" /* default */]) : [];
        _this.screen_name = data.screen_name;
        _this.seats_available = data.seats_available;
        _this.show_time = new __WEBPACK_IMPORTED_MODULE_3__VistaDate__["a" /* default */](data.show_time);
        _this.time_tag = data.time_tag;
        _this.cinema = {};
        if (data.cinema_id) {
            __WEBPACK_IMPORTED_MODULE_5__service_region_service__["a" /* default */].getCinema(data.cinema_id).then(function (c) {
                _this.cinema = c;
            });
        }
        return _this;
    }

    _createClass(MovieSession, [{
        key: 'experiencesString',
        get: function get() {
            return this.experiences.map(function (e) {
                return e.name;
            }).join(' ');
        }
    }]);

    return MovieSession;
}(__WEBPACK_IMPORTED_MODULE_0__BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MovieSession);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModel__ = __webpack_require__(8);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Experience = function (_BaseModel) {
    _inherits(Experience, _BaseModel);

    function Experience(data) {
        _classCallCheck(this, Experience);

        var _this = _possibleConstructorReturn(this, (Experience.__proto__ || Object.getPrototypeOf(Experience)).call(this));

        _this.name = data;
        return _this;
    }

    return Experience;
}(__WEBPACK_IMPORTED_MODULE_0__BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Experience);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModel__ = __webpack_require__(8);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Flag = function (_BaseModel) {
    _inherits(Flag, _BaseModel);

    function Flag(data) {
        _classCallCheck(this, Flag);

        var _this = _possibleConstructorReturn(this, (Flag.__proto__ || Object.getPrototypeOf(Flag)).call(this));

        _this.name = data;
        return _this;
    }

    return Flag;
}(__WEBPACK_IMPORTED_MODULE_0__BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Flag);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContentImage = function () {
    function ContentImage(data) {
        _classCallCheck(this, ContentImage);

        this.update(data);
    }

    _createClass(ContentImage, [{
        key: "update",
        value: function update(data) {
            this.mobile = data.mobile;
            this.desktop = data.desktop;
            this.banner = data.banner;
            this.banner_mobile = data.banner_mobile;
            this.background = data.background;
            this.background_mobile = data.background_mobile;
            this.alt = data.alt;
        }
    }]);

    return ContentImage;
}();

var MovieImage = function () {
    function MovieImage(data) {
        _classCallCheck(this, MovieImage);

        this.featured = new ContentImage(data.featured || {});
        this.event = new ContentImage(data.event || {});
        this.promo = new ContentImage(data.promo || {});
        this.standard = new ContentImage(data.standard || {});
    }

    _createClass(MovieImage, [{
        key: "setPromo",
        value: function setPromo(promoImages) {
            this.promo.update(promoImages);
        }
    }, {
        key: "setEvent",
        value: function setEvent(eventImages) {
            this.event.update(eventImages);
        }
    }]);

    return MovieImage;
}();

/* harmony default export */ __webpack_exports__["a"] = (MovieImage);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_FeaturedContent__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__movie_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_service__ = __webpack_require__(231);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var TABBEDPAGETYPES = {
    "About Ster-Kinekor": "about-ster-kinekor"
};

var PREVIEW_SETTINGS = {
    promotion: {
        primary_route: "/exclusive-to-sk/promotions",
        availableroutes: [{ name: "Promotion Listing", route: "/exclusive-to-sk/promotions" }, { name: "Promotion Detail", route: "/promotion/:nid" }, {
            name: "Home Page",
            route: "/",
            test: function test(promo) {
                return promo.related_movie !== undefined || promo.next_to_movie !== undefined;
            }
        }, {
            name: "Related Movie",
            route: "/details/:related_movie",
            test: function test(promo) {
                return promo.related_movie !== undefined || promo.next_to_movie !== undefined;
            }
        }],
        formatter: '_formatPromoOrEvent'
    },
    featured_content: {
        primary_route: "/",
        availableroutes: [{ name: "Home Page", route: "/" }],
        formatter: '_formatFeaturedContent',
        formatterIsPromise: true
    },
    competition: {
        primary_route: "/competitions",
        availableroutes: [{ name: "Competitions", route: "/competitions" }, { name: "Competition Detail", route: "/competition/:nid" }],
        formatter: '_formatCompetition'
    },
    event: {
        primary_route: "/exclusive-to-sk/events",
        availableroutes: [{ name: "Event Listing", route: "/exclusive-to-sk/events" }, { name: "Event Detail", route: "/event/:nid" }, {
            name: "Related Movie",
            route: "/details/:related_movie",
            test: function test(promo) {
                return promo.related_movie !== undefined || promo.next_to_movie !== undefined;
            }
        }],
        formatter: '_formatPromoOrEvent'
    },
    general_page: {
        primary_route: "/content:route",
        availableroutes: [{
            name: "Tabbed View",
            route: "/content/:tabbedPage:route",
            routeReplace: function routeReplace(previewContent, route) {
                return route.replace(new RegExp(':tabbedPage', 'g'), TABBEDPAGETYPES[previewContent.page_type]);
            },
            test: function test(previewContent) {
                return TABBEDPAGETYPES[previewContent.page_type] !== undefined;
            }
        }, {
            name: "Static View",
            route: "/content:route"
        }],
        formatter: '_formatGeneralPage'
    },
    accolades: {
        primary_route: "/content/preview-:nid",
        availableroutes: [{ name: "Accolade Only", route: "/content/preview-:nid" }, { name: "In Vision Mission (if Published)", route: "/content/vision-mission/our-success" }],
        formatter: '_formatContentTypeForGeneralPage',
        formatterIsPromise: true
    },
    partners: {
        primary_route: "/content/preview-:nid",
        availableroutes: [{ name: "Partners Only", route: "/content/preview-:nid" }, { name: "In About (if Published)", route: "/content/vision-mission/our-partners" }],
        formatter: '_formatContentTypeForGeneralPage',
        formatterIsPromise: true
    },
    person: {
        primary_route: "/content/preview-:nid",
        availableroutes: [{ name: "Persons Only", route: "/content/preview-:nid" }, {
            name: "In About (if Published)", route: "/content/vision-mission/:t",
            routeReplace: function routeReplace(previewContent, route) {
                return route.replace(new RegExp(':t', 'g'), previewContent.original_item.person_type == 'Management_Team' ? 'management-team' : 'shareholders');
            }
        }],
        formatter: '_formatContentTypeForGeneralPage',
        formatterIsPromise: true
    },
    news: {
        primary_route: "/news",
        availableroutes: [{ name: "News Listing", route: "/news" }, { name: "News Detail", route: "/news/detail/:nid" }],
        formatter: '_formatNews'

    }
};

var PreviewService = function () {
    function PreviewService() {
        _classCallCheck(this, PreviewService);

        this._previewContent = sessionStorage.getItem("_previewContent") ? JSON.parse(sessionStorage.getItem("_previewContent")) : {};
        this.available = true;
        this.cms_url = sessionStorage.getItem("cms_url") || undefined;
        this._previewSection = sessionStorage.getItem("_previewSection") || undefined;
        this.promise = undefined;
    }

    _createClass(PreviewService, [{
        key: 'hasPreviewContent',
        value: function hasPreviewContent() {
            var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._previewSection;

            return this._previewSection === section && this._previewContent && Object.keys(this._previewContent).length > 0;
        }
    }, {
        key: 'hasPreviewContentForRelatedMovie',
        value: function hasPreviewContentForRelatedMovie() {
            var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._previewSection;
            var movieID = arguments[1];

            return this._previewSection === section && this._previewContent && Object.keys(this._previewContent).length > 0 && (this._previewContent.related_movie && this._previewContent.related_movie === movieID || this._previewContent.next_to_movie && this._previewContent.next_to_movie === movieID);
        }
    }, {
        key: 'getPreviewContent',
        value: function getPreviewContent() {
            var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._previewSection;

            return this.hasPreviewContent(section) ? this._previewContent : {};
        }
    }, {
        key: '_formatPromoOrEvent',
        value: function _formatPromoOrEvent(item) {
            return {
                nid: item.nid || undefined,
                big_title: item.big_title || undefined,
                title: item.title || undefined,
                strapline: item.strapline || undefined,
                detail: item.detail || undefined,
                related_movie: item.related_movie ? item.related_movie.vista_movie_id : undefined,
                next_to_movie: item.promo_poster_placement_mov ? item.promo_poster_placement_mov.vista_movie_id : undefined,
                button_link: item.button_link || undefined,
                button_text: item.button_text || undefined,
                button_2_link: item.button_2_link || item.additional_button_link || undefined,
                button_2_text: item.button_2_text || item.additional_button_text || undefined,
                questions: item.questions || undefined,
                images: {
                    desktop: item.image_desktop || {},
                    mobile: !item.image_mobile ? item.image_desktop || [] : item.image_mobile,
                    banner: item.image_banner || {},
                    banner_mobile: item.image_mobile_banner || item.image_banner,
                    background: item.image_background || {},
                    background_mobile: item.image_mobile_background || {},
                    poster: item.poster_image || item.image_poster || {}
                },

                use_movie_poster: item.use_movie_poster || (item.related_movie ? "1" : "0") || "0"
            };
        }
    }, {
        key: '_formatFeaturedContent',
        value: function _formatFeaturedContent(featuredContent) {
            return new Promise(function (resolve, reject) {
                featuredContent.image = featuredContent.featured_image ? featuredContent.featured_image.url : undefined;
                featuredContent.mobile_image = featuredContent.mobile_image ? featuredContent.mobile_image.url : featuredContent.image;
                featuredContent.logo_image = featuredContent.logo ? featuredContent.logo.image.url : undefined;
                featuredContent.button_1_url = featuredContent.section_1_button_link ? featuredContent.section_1_button_link : undefined;
                featuredContent.button_1_text = featuredContent.section_1_button_text ? featuredContent.section_1_button_text : undefined;
                featuredContent.button_2_url = featuredContent.section_2_button_link ? featuredContent.section_2_button_link : undefined;
                featuredContent.button_2_text = featuredContent.section_2_button_text ? featuredContent.section_2_button_text : undefined;
                var item = new __WEBPACK_IMPORTED_MODULE_1__model_FeaturedContent__["a" /* default */](featuredContent);

                if (featuredContent.related_movie && featuredContent.related_movie.vista_movie_id) {
                    __WEBPACK_IMPORTED_MODULE_2__movie_service__["a" /* default */].findById(featuredContent.related_movie.vista_movie_id).then(function (m) {
                        item.movie = m;
                        resolve(item);
                    }, function () {
                        return resolve(item);
                    });
                } else resolve(item);
            });
        }
    }, {
        key: '_formatCompetition',
        value: function _formatCompetition(featuredContent) {
            featuredContent.image = featuredContent.image_background ? featuredContent.image_background : undefined;
            featuredContent.mobile_image = featuredContent.image_mobile_background ? featuredContent.image_mobile_background : featuredContent.image;
            featuredContent.related_movie = featuredContent.related_movie ? featuredContent.related_movie.vista_movie_id : undefined;
            return featuredContent;
        }
    }, {
        key: '_formatGeneralPage',
        value: function _formatGeneralPage(page) {
            return {
                nid: page.nid,
                meta_description: page.meta_description,
                meta_title: page.meta_title,
                page_title: page.title,
                title: page.title,
                page_type: page.page_type,
                published: page.published,
                sections: page.sections,
                route: page.route
            };
        }
    }, {
        key: '_formatContentTypeForGeneralPage',
        value: function _formatContentTypeForGeneralPage(contentItem) {
            var _this = this;

            var sectionLayout = '';
            var sectionLayoutTwo = undefined;
            var page_layout_content = this._previewSection;
            switch (this._previewSection) {
                case 'accolades':
                    sectionLayout = 'accolades_block';
                    break;
                case 'person':
                    sectionLayout = undefined;
                    if (contentItem.person_type == 'Management_Team') {
                        sectionLayoutTwo = ['person_management_team', 'person_management_team_block'];
                    } else {
                        sectionLayoutTwo = ['person_shareholders', 'person_shareholders_block'];
                    }
                    break;
                case 'partners':
                    sectionLayout = 'partners_block';

                    break;

            }
            return __WEBPACK_IMPORTED_MODULE_3__page_service__["a" /* default */].getContentType(this._previewSection).then(function (contentItems) {
                var sections = [];

                if (sectionLayout) sections = [{
                    section_layout: sectionLayout,
                    page_content: contentItems,
                    name: null,
                    additional_button_link: null,
                    additional_button_text: null,
                    body: null,
                    body_2: null,
                    button_link: null,
                    button_text: null,
                    file_link: null,
                    file_link_2: null,
                    heading: null,
                    heading_2: null,
                    image: null,
                    mobile_image: null,
                    video_link: null
                }];

                if (sectionLayoutTwo) {
                    for (var i = 0; i < sectionLayoutTwo.length; i++) {
                        var obj = sectionLayoutTwo[i];
                        sections.push({
                            section_layout: obj,
                            page_content: contentItems,
                            name: null,
                            additional_button_link: null,
                            additional_button_text: null,
                            body: null,
                            body_2: null,
                            button_link: null,
                            button_text: null,
                            file_link: null,
                            file_link_2: null,
                            heading: null,
                            heading_2: null,
                            image: null,
                            mobile_image: null,
                            video_link: null
                        });
                    }
                }
                return {
                    title: "Accolades",
                    meta_description: 'none',
                    meta_title: 'none',
                    nid: contentItem.nid,
                    original_item: contentItem,
                    page_description: '<h2>Preview Content Type Test Page</h2>',
                    page_title: 'Preview Content Type: ' + _this._previewSection,
                    page_type: 'General Page',
                    route: '/preview-' + contentItem.nid,
                    published: false,
                    sections: sections

                };
            });
        }
    }, {
        key: '_formatNews',
        value: function _formatNews(contentItem) {
            return {
                general: {
                    id: contentItem.nid,
                    title: contentItem.title,
                    author: contentItem.author,
                    date: contentItem.news_date,
                    expires: contentItem.expiry_date,
                    featured: contentItem.featured,
                    override_link: contentItem.button_link_override,
                    override_text: contentItem.button_text_override,
                    related_movie: contentItem.related_movie.vista_movie_id,
                    type: contentItem.news_taxonomy_type
                },
                top_section: {
                    copy: contentItem.copy_section,
                    summary: contentItem.copy_section.replace(/<(?:.|\n)*?>/gm, ''),
                    image: contentItem.news_image ? contentItem.news_image : null
                },
                feature_section: {
                    title: contentItem.youtube_title,
                    link: contentItem.news_youtube_link,
                    image: contentItem.youtube_image ? contentItem.youtube_image : null,
                    description: contentItem.youtube_description
                },
                bottom_section: {
                    title: contentItem.section_2_title,
                    copy: contentItem.bottom_copy_section,
                    image: contentItem.bottom_section_image ? contentItem.bottom_section_image : null,
                    image_2: contentItem.bottom_section_image_2 ? contentItem.bottom_section_image_2 : null
                },
                more_info_section: {
                    title: contentItem.more_info_title,
                    copy: contentItem.more_info_copy_section
                },
                title: contentItem.title,
                nid: contentItem.nid
            };
        }
    }, {
        key: 'clear',
        value: function clear() {
            this._previewSection = undefined;
            this._previewContent = {};
            sessionStorage.clear();
            this.available = false;
        }
    }, {
        key: 'addPreviewToContentArrayIfAvailable',
        value: function addPreviewToContentArrayIfAvailable(section, contentArrayToMergeWith) {
            var content = contentArrayToMergeWith;
            if (this.hasPreviewContent(section)) content = [this._previewContent].concat(_toConsumableArray(contentArrayToMergeWith));

            return content;
        }
    }, {
        key: 'mergePreviewWithExistingContentIfAvailable',
        value: function mergePreviewWithExistingContentIfAvailable(section, contentObject) {
            var content = contentObject;
            if (this.hasPreviewContent(section)) Object.assign(content, this._previewContent);

            return content;
        }
    }, {
        key: '_setPreviewContent',
        value: function _setPreviewContent(content, original) {
            this._previewContent = content;

            if (original.cmsUrl) {
                this.cms_url = original.cmsUrl + '/node/' + original.nid + '/edit';
                sessionStorage.setItem('cms_url', this.cms_url);
            }

            sessionStorage.setItem('_previewContent', JSON.stringify(this._previewContent));
        }
    }, {
        key: 'setContent',
        value: function setContent(section, contentObject) {
            var _this2 = this;

            this.available = false;
            sessionStorage.clear();
            this._previewSection = section;
            sessionStorage.setItem('_previewSection', this._previewSection);

            if (PREVIEW_SETTINGS[section] && PREVIEW_SETTINGS[section].formatterIsPromise) {
                this.promise = this[PREVIEW_SETTINGS[section].formatter](contentObject).then(function (content) {
                    _this2._setPreviewContent(content, contentObject);
                });
            } else {
                this._setPreviewContent(PREVIEW_SETTINGS[section] && PREVIEW_SETTINGS[section].formatter ? this[PREVIEW_SETTINGS[section].formatter](contentObject) : contentObject, contentObject);
            }
            this.available = true;
        }
    }, {
        key: 'loadPimaryRoute',
        value: function loadPimaryRoute(router) {
            var _this3 = this;

            if (this.promise) {
                this.promise.then(function () {
                    _this3.promise = undefined;
                    _this3.loadPimaryRoute(router);
                });
                return;
            }
            if (this.hasPreviewContent() && PREVIEW_SETTINGS[this._previewSection]) {
                var route = PREVIEW_SETTINGS[this._previewSection].primary_route;
                for (var j = 0; j < Object.keys(this._previewContent).length; j++) {
                    var key = Object.keys(this._previewContent)[j];
                    route = route.replace(new RegExp(':' + key, 'g'), this._previewContent[key]);
                }
                router.push(route);
            }
        }
    }, {
        key: 'getPreviewConfig',
        value: function getPreviewConfig() {
            if (!this.hasPreviewContent()) return false;
            var section = PREVIEW_SETTINGS[this._previewSection];
            if (!section) return false;
            var routes = [];
            for (var i = 0; i < section.availableroutes.length; i++) {
                var route = section.availableroutes[i];

                for (var j = 0; j < Object.keys(this._previewContent).length; j++) {
                    var key = Object.keys(this._previewContent)[j];
                    route.route = route.route.replace(new RegExp(':' + key, 'g'), this._previewContent[key]);
                }

                if (!route.test || route.test(this._previewContent)) {
                    if (route.routeReplace) {
                        route.route = route.routeReplace(this._previewContent, route.route);
                    }
                    routes.push(route);
                }
            }

            return {
                section: this._previewSection.replace(new RegExp("_", 'g'), ' ').replace(/\b\w/g, function (l) {
                    return l.toUpperCase();
                }),
                routes: routes,
                title: this._previewContent.title,
                cms_url: this.cms_url
            };
        }
    }, {
        key: 'getPreviewUrl',
        value: function getPreviewUrl() {
            return 'preview-' + this._previewContent.nid;
        }
    }]);

    return PreviewService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new PreviewService());

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModel__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Movies__ = __webpack_require__(65);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var FeaturedContent = function (_BaseModel) {
    _inherits(FeaturedContent, _BaseModel);

    function FeaturedContent(data) {
        _classCallCheck(this, FeaturedContent);

        var _this = _possibleConstructorReturn(this, (FeaturedContent.__proto__ || Object.getPrototypeOf(FeaturedContent)).call(this));

        _this.add_trailer = data.add_trailer;
        _this.banner_category = data.banner_category;
        _this.button_1_external_url = data.button_1_external_url;
        _this.button_1_text = data.button_1_text;
        _this.button_1_url = data.button_1_url;
        _this.button_2_external_url = data.button_2_external_url;
        _this.button_2_text = data.button_2_text;
        _this.button_2_url = data.button_2_url;
        _this.description = data.description;
        _this.dont_display_title = data.dont_display_title;
        _this.image = data.image;
        _this.logo_image = data.logo_image;
        _this.mobile_image = data.mobile_image;
        _this.movie = data.movie ? new __WEBPACK_IMPORTED_MODULE_1__Movies__["a" /* Movie */](data.movie) : null;
        _this.strapline = data.strapline;
        _this.title = data.title;
        _this.appears_in = data.field_appears_in || 'BOTH';
        _this.ad_tag = data.field_ad_tag;
        _this.ad_tag_mobile = data.field_ad_tag_mobile;
        return _this;
    }

    return FeaturedContent;
}(__WEBPACK_IMPORTED_MODULE_0__BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (FeaturedContent);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movie_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_FilmVestival__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_ModelArray__ = __webpack_require__(14);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var PageService = function () {
    function PageService() {
        _classCallCheck(this, PageService);

        this.news = undefined;
        this.page = [];
        this.people = undefined;
        this.cinemaPrices = undefined;
        this.competitions = undefined;
        this.event = undefined;
        this.faq = undefined;
        this.promo = undefined;
    }

    _createClass(PageService, [{
        key: 'getNews',
        value: function getNews(preview, id) {
            var _this = this;

            var previewLnk = preview ? '/preview/' + (preview === true ? 'all' : preview) : '';
            return this.news = this.news || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/news/' + (id || 'all') + previewLnk).then(function (response) {
                return response.data;
            }, function (error) {
                Promise.reject(error);
                _this.news = undefined;
            });
        }
    }, {
        key: 'getNewsArticle',
        value: function getNewsArticle(id) {
            return this.getNews().then(function (news) {
                var article = news.find(function (newsItem) {
                    return newsItem.general.id == id;
                });
                if (article.related_movie) {
                    article.movie = {};
                    __WEBPACK_IMPORTED_MODULE_1__movie_service__["a" /* default */].getMovieDetail(article.related_movie).then(function (movie) {
                        return article.movie = movie;
                    });
                }
                return article;
            });
        }
    }, {
        key: 'getPromo',
        value: function getPromo(preview) {
            var previewLnk = preview ? preview === true ? 'all' : preview : '';
            return this.promo = this.promo || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/promo');
        }
    }, {
        key: 'getEvent',
        value: function getEvent(preview) {
            var _this2 = this;

            var previewLnk = preview ? preview === true ? 'all' : preview : '';
            return this.event = this.event || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/event').then(function (response) {
                return response.data;
            }, function (error) {
                Promise.reject(error);
                _this2.event = undefined;
            });
        }
    }, {
        key: 'getFilmFestivals',
        value: function getFilmFestivals() {
            var _this3 = this;

            return this.filmfestivals = this.filmfestivals || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/film-festivals').then(function (response) {
                return new __WEBPACK_IMPORTED_MODULE_3__model_ModelArray__["a" /* default */](response.data, __WEBPACK_IMPORTED_MODULE_2__model_FilmVestival__["a" /* default */]);
            }, function (error) {
                _this3.filmfestivals = undefined;
                return Promise.reject(error);
            });
        }
    }, {
        key: 'getProcurement',
        value: function getProcurement(preview) {
            var _this4 = this;

            var previewLnk = preview ? preview === true ? 'all' : preview : '';

            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/procurement');

            return this.procurement = this.procurement || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/procurement').then(function (response) {
                return response.data;
            }, function (error) {
                Promise.reject(error);
                _this4.procurement = undefined;
            });
        }
    }, {
        key: 'getPeople',
        value: function getPeople(type, preview) {
            var _this5 = this;

            var previewLnk = preview ? preview === true ? 'all' : preview : '';

            return this.people = __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/people').then(function (response) {
                return response.data;
            }, function (error) {
                Promise.reject(error);
                _this5.people = undefined;
            });
        }
    }, {
        key: 'getGeneralPage',
        value: function getGeneralPage(page_type, preview) {
            var _this6 = this;

            var previewLnk = preview ? preview === true ? 'all' : preview : '';

            return this.page[page_type] = this.page[page_type] || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/generalPage/' + page_type).then(function (response) {
                return response.data;
            }, function (error) {
                Promise.reject(error);
                _this6.page = undefined;
            });
        }
    }, {
        key: 'getPage',
        value: function getPage(page_url, preview) {
            var _this7 = this;

            var previewLnk = preview ? preview === true ? 'all' : preview : '';

            return this.page['url:' + page_url] = this.page['url:' + page_url] || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/page/' + page_url).then(function (response) {
                return response.data;
            }, function (error) {
                Promise.reject(error);
                _this7.page = undefined;
            });
        }
    }, {
        key: 'getFAQ',
        value: function getFAQ(preview) {
            var _this8 = this;

            var previewLnk = preview ? preview === true ? 'all' : preview : '';
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/faq');

            return this.faq = this.faq || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/faq').then(function (response) {
                return response;
            }, function (error) {
                Promise.reject(error);
                _this8.faq = undefined;
            });
        }
    }, {
        key: 'getCinemaPrices',
        value: function getCinemaPrices(preview) {
            var _this9 = this;

            var previewLnk = preview ? preview === true ? 'all' : preview : '';
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/cinemaPrices');

            return this.cinemaPrices = this.cinemaPrices || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/cinemaPrices').then(function (response) {
                return response;
            }, function (error) {
                Promise.reject(error);
                _this9.cinemaPrices = undefined;
            });
        }
    }, {
        key: 'getCompetitions',
        value: function getCompetitions(preview) {
            var _this10 = this;

            var previewLnk = preview ? preview === true ? 'all' : preview : '';
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/competitions');

            return this.competitions = this.competitions || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/competitions').then(function (response) {
                return response;
            }, function (error) {
                Promise.reject(error);
                _this10.competitions = undefined;
            });
        }
    }, {
        key: 'getNode',
        value: function getNode(nodeId) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/node/' + nodeId).then(function (response) {
                return response.data;
            }, function (error) {
                Promise.reject(error);
            });
        }
    }, {
        key: 'getContentType',
        value: function getContentType(type) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/content/content-type/' + type).then(function (response) {
                return response.data;
            }, function (error) {
                Promise.reject(error);
            });
        }
    }]);

    return PageService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new PageService());

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModel__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Movies__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModelArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Cinema__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var FilmFestival = function (_BaseModel) {
    _inherits(FilmFestival, _BaseModel);

    function FilmFestival(data) {
        _classCallCheck(this, FilmFestival);

        var _this = _possibleConstructorReturn(this, (FilmFestival.__proto__ || Object.getPrototypeOf(FilmFestival)).call(this));

        Object.assign(_this, data);
        _this.Movies = _this.Movies ? new __WEBPACK_IMPORTED_MODULE_2__ModelArray__["a" /* default */](_this.Movies, __WEBPACK_IMPORTED_MODULE_1__Movies__["a" /* Movie */]) : [];
        _this.Cinemas = _this.Cinemas ? new __WEBPACK_IMPORTED_MODULE_2__ModelArray__["a" /* default */](_this.Cinemas, __WEBPACK_IMPORTED_MODULE_3__Cinema__["a" /* default */]) : [];

        _this.StartDate = _this.StartDate ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this.StartDate) : {
            format: function format() {
                return null;
            }
        };

        return _this;
    }

    return FilmFestival;
}(__WEBPACK_IMPORTED_MODULE_0__BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (FilmFestival);

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_BaseModel__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_seat_grid_service__ = __webpack_require__(67);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Seat = function (_BaseModel) {
    _inherits(Seat, _BaseModel);

    function Seat(data) {
        _classCallCheck(this, Seat);

        var _this = _possibleConstructorReturn(this, (Seat.__proto__ || Object.getPrototypeOf(Seat)).call(this, data));

        _this.Id = data.Id;
        _this.OriginalStatus = data.OriginalStatus;
        _this.Position = data.Position;
        _this.Priority = data.Priority;
        _this.SeatStyle = data.SeatStyle;
        _this.SeatsInGroup = data.SeatsInGroup;
        _this.Status = data.Status;
        return _this;
    }

    return Seat;
}(__WEBPACK_IMPORTED_MODULE_0__model_BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Seat);

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_BaseModel__ = __webpack_require__(8);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ConcessionItem = function (_BaseModel) {
    _inherits(ConcessionItem, _BaseModel);

    function ConcessionItem(data) {
        _classCallCheck(this, ConcessionItem);

        var _this = _possibleConstructorReturn(this, (ConcessionItem.__proto__ || Object.getPrototypeOf(ConcessionItem)).call(this));

        _this.Id = data.ItemId || data.Id;
        _this.ItemId = data.ItemId || data.Id;
        _this.Description = data.Description;
        _this.Quantity = data.Quantity;
        _this.PriceInCents = data.PriceInCents;
        _this.RecognitionId = data.RecognitionId;
        _this.RecognitionSequenceNumber = data.RecognitionSequenceNumber;

        return _this;
    }

    return ConcessionItem;
}(__WEBPACK_IMPORTED_MODULE_0__model_BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ConcessionItem);

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModel__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModelArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransactionItem__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VistaDate__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_movie_service__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Transaction = function (_BaseModel) {
    _inherits(Transaction, _BaseModel);

    function Transaction() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

        _classCallCheck(this, Transaction);

        var _this = _possibleConstructorReturn(this, (Transaction.__proto__ || Object.getPrototypeOf(Transaction)).call(this, data));

        _this.CinemaId = data.CinemaId;
        _this.CinemaName = data.CinemaName;
        _this.MovieId = data.MovieId;
        _this.MovieName = data.MovieName;
        _this.ItemName = data.ItemName;

        _this.SessionTime = data.SessionTime ? new __WEBPACK_IMPORTED_MODULE_3__VistaDate__["a" /* default */](data.SessionTime) : null;
        _this.TransactionDate = data.TransactionDate ? new __WEBPACK_IMPORTED_MODULE_3__VistaDate__["a" /* default */](data.TransactionDate) : null;
        _this.TransactionId = data.TransactionId;
        _this.VistaTransactionId = data.VistaTransactionId;
        _this.Items = new __WEBPACK_IMPORTED_MODULE_1__ModelArray__["a" /* default */](data.Items, __WEBPACK_IMPORTED_MODULE_2__TransactionItem__["a" /* default */]);
        return _this;
    }

    _createClass(Transaction, [{
        key: 'PointsEarned',
        get: function get() {
            return this.Items ? this.Items.reduce(function (t, i) {
                return t = t + i.PointsEarned;
            }, 0) : 0;
        }
    }, {
        key: 'PointsRedeemed',
        get: function get() {
            return this.Items ? this.Items.reduce(function (t, i) {
                return t = t + i.PointsRedeemed;
            }, 0) : 0;
        }
    }, {
        key: 'year',
        get: function get() {
            return this.TransactionDate ? this.TransactionDate.additional.year : null;
        }
    }, {
        key: 'month',
        get: function get() {
            return this.TransactionDate ? this.TransactionDate.additional.string_long_month : null;
        }
    }]);

    return Transaction;
}(__WEBPACK_IMPORTED_MODULE_0__BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Transaction);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModel__ = __webpack_require__(8);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var TransactionItem = function (_BaseModel) {
    _inherits(TransactionItem, _BaseModel);

    function TransactionItem() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

        _classCallCheck(this, TransactionItem);

        var _this = _possibleConstructorReturn(this, (TransactionItem.__proto__ || Object.getPrototypeOf(TransactionItem)).call(this, data));

        _this.Price = data.BoxOfficeValue;
        _this.Description = data.Description;
        _this.PointsEarned = data.PointsEarned;
        _this.PointsRedeemed = data.PointsRedeemed;
        return _this;
    }

    return TransactionItem;
}(__WEBPACK_IMPORTED_MODULE_0__BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TransactionItem);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_BaseModel__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var LoyaltyCard = function (_BaseModel) {
    _inherits(LoyaltyCard, _BaseModel);

    function LoyaltyCard(data) {
        _classCallCheck(this, LoyaltyCard);

        var _this = _possibleConstructorReturn(this, (LoyaltyCard.__proto__ || Object.getPrototypeOf(LoyaltyCard)).call(this, data));

        _this.SessionId = data ? data.SessionId : undefined;
        _this.CinemaId = data ? data.CinemaId : undefined;
        _this.TicketType = data ? data.TicketType : undefined;
        _this.CardNumber = data ? data.MemberCard : undefined;
        _this.MemberCard = data ? data.MemberCard : undefined;
        _this.Qty = data && data.Qty ? data.Qty : 1;
        _this.MemberProviderName = data ? data.MemberProviderName : undefined;
        _this.RecognitionID = data ? data.RecognitionID : undefined;
        _this.SequenceNumber = data ? data.SequenceNumber : undefined;
        _this.Barcode = data ? data.Barcode : undefined;
        _this.Error = undefined;
        return _this;
    }

    _createClass(LoyaltyCard, [{
        key: 'clear',
        value: function clear() {
            this.SessionId = undefined;
            this.CinemaId = undefined;
            this.TicketType = undefined;
            this.MemberCard = undefined;
            this.Qty = 1;
            this.Name = undefined;
            this.Error = undefined;
        }
    }, {
        key: 'setSessionInfo',
        value: function setSessionInfo(SessionId, CinemaId) {
            this.SessionId = SessionId;
            this.CinemaId = CinemaId;
        }
    }, {
        key: 'toJSON',
        value: function toJSON() {
            return {
                SessionId: this.SessionId,
                CinemaId: this.CinemaId,
                TicketTypeCode: this.TicketTypeCode,
                MemberCard: this.MemberCard,
                TicketType: this.TicketType,
                Qty: this.Qty
            };
        }
    }, {
        key: 'TicketTypeCode',
        get: function get() {
            return this.TicketType ? this.TicketType.TicketTypeCode : undefined;
        }
    }, {
        key: 'isPopulated',
        get: function get() {
            var hasTicketTypeCode = !!this.TicketTypeCode;
            var hasNumber = !!(this.MemberCard && this.MemberCard != '');
            return hasTicketTypeCode && hasNumber;
        }
    }]);

    return LoyaltyCard;
}(__WEBPACK_IMPORTED_MODULE_0__model_BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (LoyaltyCard);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModel__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModelArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransactionItem__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VistaDate__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_movie_service__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Booking = function (_BaseModel) {
    _inherits(Booking, _BaseModel);

    function Booking() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

        _classCallCheck(this, Booking);

        var _this = _possibleConstructorReturn(this, (Booking.__proto__ || Object.getPrototypeOf(Booking)).call(this, data));

        _this.CinemaId = data.CinemaId;
        _this.CinemaName = data.CinemaName;
        _this.SessionId = data.SessionId;
        _this.BookingNumber = data.BookingNumber;
        _this.BaseBookingNumber = data.BaseBookingNumber;
        _this.BookingRef = data.BookingRef;
        _this.MovieName = data.MovieName;
        _this.loadingPdf = false;
        _this.Barcode = data.Barcode;
        _this.DateBooked = data.DateBooked ? new __WEBPACK_IMPORTED_MODULE_3__VistaDate__["a" /* default */](data.DateBooked) : null;
        _this.BookingDate = data.BookingDate ? new __WEBPACK_IMPORTED_MODULE_3__VistaDate__["a" /* default */](data.BookingDate) : null;
        _this.Movie = {};
        _this.EndDate = data.BookingDate ? new __WEBPACK_IMPORTED_MODULE_3__VistaDate__["a" /* default */](data.BookingDate) : null;
        _this.VistaTransactionId = data.VistaTransactionId;
        _this.Tickets = data.Tickets || [];
        _this.MovieSession = {};
        if (_this.SessionId) {
            __WEBPACK_IMPORTED_MODULE_4__service_movie_service__["a" /* default */].findBySessionId(_this.SessionId, _this.CinemaId).then(function (movie) {
                if (!movie && _this.MovieName) {
                    __WEBPACK_IMPORTED_MODULE_4__service_movie_service__["a" /* default */].findByName(_this.MovieName).then(function (movie) {
                        _this.Movie = movie;
                        _this.MovieSession = _this.getSession() || {};
                        _this.EndDate = new __WEBPACK_IMPORTED_MODULE_3__VistaDate__["a" /* default */](_this.BookingDate.date.clone().add(movie.runtime, 'minutes'));
                    });
                } else {
                    _this.Movie = movie;
                    _this.MovieSession = _this.getSession() || {};
                    _this.EndDate = new __WEBPACK_IMPORTED_MODULE_3__VistaDate__["a" /* default */](_this.BookingDate.date.clone().add(movie.runtime, 'minutes'));
                }
            });
        }
        _this.Concessions = data.Concessions || [];
        _this.BookingId = data.BookingId;
        return _this;
    }

    _createClass(Booking, [{
        key: 'getSession',
        value: function getSession() {
            if (this.Movie.cinemas) {
                return this.Movie.getSession(this.SessionId);
            }
            return {};
        }
    }, {
        key: 'Seats',
        get: function get() {
            return this.Tickets.map(function (ticket) {
                return ticket.SeatRowId + ticket.SeatNumber;
            });
        }
    }, {
        key: 'SeatString',
        get: function get() {

            var string = this.Tickets.reduce(function (arr, ticket) {
                arr[ticket.SeatRowId] = arr[ticket.SeatRowId] || { min: ticket.SeatNumber, max: ticket.SeatNumber };
                arr[ticket.SeatRowId].min = arr[ticket.SeatRowId].min > ticket.SeatNumber ? ticket.SeatNumber : arr[ticket.SeatRowId].min;
                arr[ticket.SeatRowId].max = arr[ticket.SeatRowId].max < ticket.SeatNumber ? ticket.SeatNumber : arr[ticket.SeatRowId].max;
                arr[ticket.SeatRowId].key = ticket.SeatRowId;
                return arr;
            }, {});
            string = Object.keys(string).map(function (key) {
                var ticket = string[key];
                if (ticket.min == ticket.max) {
                    return '' + ticket.key + ticket.min;
                }
                return '' + ticket.key + ticket.min + ' - ' + ticket.key + ticket.max;
            }).join(',');

            return string;
        }
    }]);

    return Booking;
}(__WEBPACK_IMPORTED_MODULE_0__BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Booking);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var EcomTrackingService = function () {
    function EcomTrackingService() {
        _classCallCheck(this, EcomTrackingService);
    }

    _createClass(EcomTrackingService, [{
        key: 'buildImpressionsQuery',
        value: function buildImpressionsQuery(products) {
            dataLayer.push({
                'event': 'productImpressions',
                'ecommerce': {
                    'impressions': products
                }
            });
        }
    }, {
        key: 'buildProductClickQuery',
        value: function buildProductClickQuery(product) {
            dataLayer.push({
                'event': 'productClick',
                'ecommerce': {
                    'click': {
                        'products': [product]
                    }
                }
            });
        }
    }, {
        key: 'buildProductDetailViewQuery',
        value: function buildProductDetailViewQuery(product) {
            dataLayer.push({
                'event': 'productView',
                'ecommerce': {
                    'detail': {
                        'products': [product]
                    }
                }
            });
        }
    }, {
        key: 'buildAddTicketToBasketQuery',
        value: function buildAddTicketToBasketQuery(product) {
            dataLayer.push({
                'event': 'addToCart',
                'ecommerce': {
                    'add': {
                        'products': [product]
                    }
                }
            });
        }
    }, {
        key: 'buildRemoveTicketFromBasketQuery',
        value: function buildRemoveTicketFromBasketQuery(product) {
            dataLayer.push({
                'event': 'removeFromCart',
                'ecommerce': {
                    'remove': {
                        'products': [product]
                    }
                }
            });
        }
    }, {
        key: 'buildCheckoutProductsBasketQuery',
        value: function buildCheckoutProductsBasketQuery(products) {
            dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': { 'step': 1 },
                        'products': products
                    }
                }
            });
        }
    }, {
        key: 'buildCheckoutBasketStepTwo',
        value: function buildCheckoutBasketStepTwo() {

            dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': { 'step': 2 }
                    }
                }
            });
        }
    }, {
        key: 'buildSuccessfulTransactionQuery',
        value: function buildSuccessfulTransactionQuery(total, transactionId, products, cinemaName) {
            dataLayer.push({
                'event': 'purchase',
                'ecommerce': {
                    'purchase': {
                        'actionField': {
                            'id': transactionId,
                            'revenue': total,
                            'affiliation': cinemaName
                        },
                        'products': products
                    }
                }
            });
        }
    }, {
        key: 'buildProductViewQuery',
        value: function buildProductViewQuery(product) {
            dataLayer.push({
                'event': 'productView',
                'ecommerce': {
                    'detail': {
                        'products': [product]
                    }
                }
            });
        }
    }, {
        key: 'doDataLayerImpression',
        value: function doDataLayerImpression(movie, position) {

            var product = {
                name: movie.title,
                id: movie.id,
                category: movie.coming_soon ? 'Coming Soon' : 'Now Showing',
                list: 'Home',
                position: position
            };

            this.buildImpressionsQuery([product]);
        }
    }, {
        key: 'doDataLayerProductClick',
        value: function doDataLayerProductClick(movie, movies, now_showing, coming_soon) {
            var list = (now_showing ? movies.now_showing : movies.coming_soon) || [];
            var position = list.indexOf(movie) + 1;

            var product = {
                name: movie.title,
                id: movie.id,
                category: movie.coming_soon ? 'Coming Soon' : 'Now Showing',
                list: 'Home',
                position: position
            };

            this.buildProductClickQuery(product);
        }
    }, {
        key: 'doDataLayerProductDetailView',
        value: function doDataLayerProductDetailView(movie) {
            var product = { "name": movie.title,
                "id": movie.id, "category": movie.coming_soon ? "Coming Soon" : "Now Showing" };
            this.buildProductViewQuery(product);
        }
    }, {
        key: 'addTicketToHumanzTracking',
        value: function addTicketToHumanzTracking(item) {
            var humanzItems = localStorage.getItem("humanzTracking");
            if (humanzItems != undefined && humanzItems != null) {
                if (humanzItems.length > 0) {
                    var items = JSON.parse(humanzItems);
                    items.push(item);
                    localStorage.setItem("humanzTracking", JSON.stringify(items));
                } else {
                    var _items = [];
                    _items.push(item);
                    localStorage.setItem("humanzTracking", JSON.stringify(_items));
                }
            } else {
                var _items2 = [];
                _items2.push(item);
                humanzItems = _items2;
                localStorage.setItem("humanzTracking", JSON.stringify(humanzItems));
            }
        }
    }, {
        key: 'removeTicketToHumanzTracking',
        value: function removeTicketToHumanzTracking(item) {
            var humanzItems = localStorage.getItem("humanzTracking");
            if (humanzItems != undefined && humanzItems != null) {
                var items = JSON.parse(humanzItems);
                var index = items.findIndex(function (i) {
                    return i.id = item.id;
                });
                items.splice(index, 1);
                localStorage.setItem("humanzTracking", JSON.stringify(items));
            }
        }
    }, {
        key: 'doDataLayerAddTicketToBasket',
        value: function doDataLayerAddTicketToBasket(product) {
            console.log("doDataLayerAddTicketToBasket", product);
            if (product != undefined && product != null) {
                var item = { "name": product.FilmTitle, "id": product.TicketTypeCode, "price": product.PriceCents ? parseFloat(product.PriceCents / 100).toFixed(2) : parseFloat(product.PriceInCents / 100).toFixed(2), "category": "Ticket", quantity: 1, "variant": product.Description };
            }
            console.log("item", item);
            this.addTicketToHumanzTracking(item);
            this.buildAddTicketToBasketQuery(item);
        }
    }, {
        key: 'doDataLayerRemoveTicketFromBasket',
        value: function doDataLayerRemoveTicketFromBasket(product) {
            console.log("doDataLayerRemoveTicketFromBasket", product);
            if (product != undefined && product != null) {
                var item = { "name": product.FilmTitle, "id": product.TicketTypeCode, "price": product.PriceCents ? parseFloat(product.PriceCents / 100).toFixed(2) : parseFloat(product.PriceInCents / 100).toFixed(2), "category": "Ticket", quantity: 1, "variant": product.Description };
            }

            this.removeTicketToHumanzTracking(item);
            this.buildRemoveTicketFromBasketQuery(item);
        }
    }, {
        key: 'doDataLayerRemoveConcessionFromBasket',
        value: function doDataLayerRemoveConcessionFromBasket(product) {
            console.log("doDataLayerRemoveConcessionFromBasket", product);
            var item = { "name": product.FilmTitle, "id": product.Id, "price": product.PriceCents ? parseFloat(product.PriceCents / 100).toFixed(2) : parseFloat(product.PriceInCents / 100).toFixed(2), "category": "Extras", quantity: 1, "variant": product.Description };
            this.buildRemoveTicketFromBasketQuery(item);
        }
    }, {
        key: 'doDataLayerAddConcessionToBasket',
        value: function doDataLayerAddConcessionToBasket(product) {
            console.log("doDataLayerAddConcessionToBasket", product);
            var item = { "name": product.FilmTitle, "id": product.Id, "price": product.PriceCents ? parseFloat(product.PriceCents / 100).toFixed(2) : parseFloat(product.PriceInCents / 100).toFixed(2), "category": "Extras", quantity: 1, "variant": product.Description };
            this.buildAddTicketToBasketQuery(item);
        }
    }, {
        key: 'doDataLayerCommitBasket',
        value: function doDataLayerCommitBasket(products, filmTitle) {
            var items = [];

            if (products.tickets.added.length > 0) {
                for (var ta in products.tickets.added) {
                    var item = { "name": filmTitle, "id": products.tickets.added[ta].TicketTypeCode, "price": products.tickets.added[ta].PriceCents ? parseFloat(products.tickets.added[ta].PriceCents / 100).toFixed(2) : parseFloat(products.tickets.added[ta].PriceInCents / 100).toFixed(2), "category": "Ticket", quantity: 1, "variant": products.tickets.added[ta].Description };
                    items.push(item);
                }
            }

            if (products.loyalties.added.length > 0) {
                for (var la in products.loyalties.added) {
                    if (products.loyalties.added[la].TicketType != undefined && products.loyalties.added[la].TicketType != null) {
                        var item = { "name": filmTitle, "id": products.loyalties.added[la].TicketType.TicketTypeCode, "price": products.loyalties.added[la].TicketType.PriceCents ? parseFloat(products.loyalties.added[la].TicketType.PriceCents / 100).toFixed(2) : parseFloat(products.loyalties.added[la].TicketType.PriceInCents / 100).toFixed(2), "category": "Ticket", quantity: 1, "variant": products.loyalties.added[la].TicketType.Description };
                        items.push(item);
                    } else {
                        var item = { "name": filmTitle, "id": products.loyalties.added[la].TicketTypeCode, "price": products.loyalties.added[la].PriceCents ? parseFloat(products.loyalties.added[la].PriceCents / 100).toFixed(2) : parseFloat(products.loyalties.added[la].PriceInCents / 100).toFixed(2), "category": "Ticket", quantity: 1, "variant": products.loyalties.added[la].Description };
                        items.push(item);
                    }
                }
            }

            if (products.concessions.added.length > 0) {
                for (var ca in products.concessions.added) {
                    var item = { "name": filmTitle, "id": products.concessions.added[ca].Id, "price": products.concessions.added[ca].PriceCents ? parseFloat(products.concessions.added[ca].PriceCents / 100).toFixed(2) : parseFloat(products.concessions.added[ca].PriceInCents / 100).toFixed(2), "category": "Extras", quantity: 1, "variant": products.concessions.added[ca].Description };
                    items.push(item);
                }
            }

            if (items.length > 0) {
                localStorage.setItem('EcomItems', JSON.stringify(items));
                this.buildCheckoutProductsBasketQuery(items);
            }
        }
    }, {
        key: 'doCheckoutBasketStepTwo',
        value: function doCheckoutBasketStepTwo() {
            this.buildCheckoutBasketStepTwo();
        }
    }, {
        key: 'doSuccessfulTransaction',
        value: function doSuccessfulTransaction(booking) {
            var _this = this;

            var total = 0;
            var items = JSON.parse(localStorage.getItem('EcomItems'));
            var cinemaName = "";
            var movieName = "";


            var transactionId = "";

            for (var b in booking) {
                transactionId = booking[0].BookingId;
                cinemaName = booking[0].CinemaName;
                movieName = booking[0].MovieName;
            }

            for (var i in items) {
                total = total + parseFloat(items[i].price);
                items[i].name = movieName;
            }

            Promise.resolve(this.buildSuccessfulTransactionQuery(total, transactionId, items, cinemaName)).then(function (result) {
                _this.doHumanzSuccessfulTransactionTracking(transactionId);
                localStorage.removeItem("EcomItems");
            });
        }
    }, {
        key: 'lHzpAsy',
        value: function lHzpAsy(u, c) {
            var d = document,
                t = 'script',
                o = d.createElement(t),
                s = d.getElementsByTagName(t)[0];
            o.src = u;
            if (c) {
                o.addEventListener('load', function (e) {
                    c(null, e);
                }, false);
            }
            s.parentNode.insertBefore(o, s);
        }
    }, {
        key: 'doHumanzSuccessfulTransactionTracking',
        value: function doHumanzSuccessfulTransactionTracking(transactionId) {
            var humanzItems = localStorage.getItem("humanzTracking");
            if (humanzItems != undefined && humanzItems != null) {
                if (humanzItems.length > 0) {
                    var items = JSON.parse(humanzItems);

                    this.lHzpAsy("https://assets.humanz.com/2633024/humanz-gtm.js", function () {
                        try {
                            var hmz = new window.hzi("2633024");
                            var h = window.hzp;
                            var products = items || [];
                            var coupon = "";
                            var orderId = transactionId || "";
                            if (h) {
                                h.gtmPurchaseKey(products, coupon, orderId);
                                localStorage.removeItem("humanzTracking");
                            }
                        } catch (e) {}
                    });
                }
            }
        }
    }]);

    return EcomTrackingService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new EcomTrackingService());

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_booking__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_exclusive_to_sk__ = __webpack_require__(393);




var filterfacets = function filterfacets(parentName) {
    return [{
        path: 'cinema/:cinema_name',
        name: parentName + '-cinema',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"]
    }, {
        path: 'cinema/:cinema_name/type/:cinema_type',
        name: parentName + '-cinema-type',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"]
    }, {
        path: 'cinema/:cinema_name/type/:cinema_type/genres/:genres',
        name: parentName + '-cinema-type-genre',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"]
    }, {
        path: 'cinema/:cinema_name/type/:cinema_type/genres/:genres/dates/:dates',
        name: parentName + '-cinema-type-genre-dates',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"]
    }, {
        path: 'type/:cinema_type',
        name: parentName + '-type',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"]
    }, {
        path: 'type/:cinema_type/genres/:genres',
        name: parentName + '-type-genre',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"]
    }, {
        path: 'type/:cinema_type/genres/:genres/dates/:dates',
        name: parentName + '-type-genre-dates',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"]
    }, {
        path: 'genres/:genres',
        name: parentName + '-genre',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"]
    }, {
        path: 'genres/:genres/dates/:dates',
        name: parentName + '-genre-dates',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"]
    }, {
        path: 'dates/:dates',
        name: parentName + '-dates',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"],
        hash: "#filter"
    }, {
        path: 'type/:cinema_type/dates/:dates',
        name: parentName + '-type-dates',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"]
    }, {
        path: 'cinema/:cinema_name/dates/:dates',
        name: parentName + '-cinema-dates',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"]
    }, {
        path: 'cinema/:cinema_name/genres/:genres/dates/:dates',
        name: parentName + '-cinema-genre-dates',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"]
    }, {
        path: 'cinema/:cinema_name/genres/:genres',
        name: parentName + '-cinema-genre',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"]
    }, {
        path: 'cinema/:cinema_name/type/:cinema_type/dates/:dates',
        name: parentName + '-cinema-type-dates',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"]
    }];
};

/* harmony default export */ __webpack_exports__["a"] = ([{ path: "*", component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["PageNotFound"], redirectParams: { responseCode: 404 } }, {
    path: '/',
    name: 'Home',
    topNav: true,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"],
    children: filterfacets('Home')
}, {
    path: '/now-showing',
    name: 'Now Showing',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"],
    children: filterfacets('Now-showing')
}, {
    path: '/coming-soon',
    name: 'Coming Soon',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"],
    children: filterfacets('Coming-soon')
}, {
    path: '/competitions',
    name: 'Competitions',
    topNav: true,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Competitions"]
}, {
    path: '/club-loyalty',
    name: 'SK Club & Movie Cards',
    topNav: true,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["ClubLoyalty"]
}, {
    path: '/subscription-club',
    name: 'SK Subscription Club',
    topNav: true,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["SubsClub"]
}, {
    path: '/club-loyalty/:card_name',
    name: 'SK Club & loyalty Info',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["ClubLoyaltyInfo"]
}, {
    path: '/news',
    name: 'Articles',
    topNav: true,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["News"]
}, {
    path: '/exclusive-to-sk',
    name: 'Exclusive to SK',
    topNav: true,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["ExclusiveToSK"],
    redirect: 'exclusive-to-sk/promotions',
    children: [{
        path: 'promotions',
        name: 'Promotions',
        component: __WEBPACK_IMPORTED_MODULE_2__components_exclusive_to_sk__["Promotions"]
    }, {
        path: 'events',
        name: 'Events',
        component: __WEBPACK_IMPORTED_MODULE_2__components_exclusive_to_sk__["Events"]
    }, {
        path: 'film-festivals',
        name: 'Film Festivals & Live',
        component: __WEBPACK_IMPORTED_MODULE_2__components_exclusive_to_sk__["FilmFestivals"]
    }]
}, {
    path: '/type/Nouveau',
    name: 'Cinema Nouveau',
    topNav: true,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"]
}, {
    path: '/film-festival-details/:id',
    name: 'Film Festival Details',
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["FilmFestivalDetails"]
}, {
    path: '/details/:id',
    name: 'Movie Details',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"],
    children: [{
        path: '/details/:id/session/:session_id',
        name: 'Movie Details with Session',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
    }, {
        path: '/details/:id/cinema/:cinema_id',
        name: 'details_cinema',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
    }, {
        path: '/details/:id/cinema/:cinema_id/types/:types/date/:date',
        name: 'details_cinema_types_date',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
    }, {
        path: '/details/:id/cinema/:cinema_id/types/:types',
        name: 'details_cinema_types',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
    }, {
        path: '/details/:id/cinema/:cinema_id/date/:date',
        name: 'details_cinema_date',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
    }, {
        path: '/details/:id/types/:types/date/:date',
        name: 'details_types_date',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
    }, {
        path: '/details/:id/types/:types',
        name: 'details_types',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
    }, {
        path: '/details/:id/date/:date',
        name: 'details_date',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
    }]
}, {
    path: '/details/:id/:title',
    name: 'details_title',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"],
    children: [{
        path: '/details/:id/session/:session_id/:title',
        name: 'details_session_title',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
    }, {
        path: '/details/:id/cinema/:cinema_id/:title',
        name: 'details_cinema_title',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
    }, {
        path: '/details/:id/cinema/:cinema_id/types/:types/date/:date/:title',
        name: 'details_cinema_types_date_title',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
    }, {
        path: '/details/:id/cinema/:cinema_id/types/:types/:title',
        name: 'details_cinema_types_title',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
    }, {
        path: '/details/:id/cinema/:cinema_id/date/:date/:title',
        name: 'details_cinema_date_title',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
    }, {
        path: '/details/:id/types/:types/date/:date/:title',
        name: 'details_types_date_title',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
    }, {
        path: '/details/:id/types/:types/:title',
        name: 'details_types_title',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
    }, {
        path: '/details/:id/date/:date/:title',
        name: 'details_date_title',
        topNav: false,
        component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
    }]
}, {
    path: '/user/profile/manage-payment/:managepayment',
    name: 'profileManage',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Profile"]
}, {
    path: '/user/profile',
    name: 'profile',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Profile"]
}, {
    path: '/user/activate/:activationCode',
    name: 'useractivate',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Activate"]
}, {
    path: '/user/:signInType',
    name: 'user',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["User"]
}, {
    path: '/user/password-validate/:resetCode',
    name: 'passwordvalidate',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["PasswordValidate"]
}, {
    path: '/user/request-card/:resetCode',
    name: 'requestcard',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["PasswordReset"]
}, {
    path: '/user/password-reset/:resetCode',
    name: 'passwordreset',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["PasswordReset"]
}, {
    path: '/details/:id/cinema/:cinema_id/session/:session_id',
    name: 'details_cinema_session',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
}, {
    path: '/details/:id/film-festival/:festival_id',
    name: 'details_cinema_festival',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
}, {
    path: '/details/:id/film-festival/:festival_id/session/:session_id',
    name: 'details_cinema_festival_session',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Details"]
}, {
    path: '/booking',
    name: 'booking',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Booking"],

    children: [{
        path: '1',
        component: __WEBPACK_IMPORTED_MODULE_1__components_booking__["Seating"]
    }, {
        path: '2',
        component: __WEBPACK_IMPORTED_MODULE_1__components_booking__["Extras"]
    }, {
        path: '3',
        component: __WEBPACK_IMPORTED_MODULE_1__components_booking__["CheckTicket"]
    }, {
        path: '4',
        component: __WEBPACK_IMPORTED_MODULE_1__components_booking__["Checkout"]
    }, {
        path: '1/film-festival/:festival_id',
        component: __WEBPACK_IMPORTED_MODULE_1__components_booking__["Seating"]
    }, {
        path: '2/film-festival/:festival_id',
        component: __WEBPACK_IMPORTED_MODULE_1__components_booking__["Extras"]
    }, {
        path: '3/film-festival/:festival_id',
        component: __WEBPACK_IMPORTED_MODULE_1__components_booking__["CheckTicket"]
    }, {
        path: '4/film-festival/:festival_id',
        component: __WEBPACK_IMPORTED_MODULE_1__components_booking__["Checkout"]
    }]
}, {
    path: '/booking-successful/:booking_number/:booking_id/:cinema_id',
    name: 'bookingSuccess',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_1__components_booking__["BookingSuccessful"]
}, {
    path: '/booking-unsuccessful',
    name: 'bookingFailure',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_1__components_booking__["BookingUnsuccessful"]
}, {
    path: '/seats/:cinema_id/:session_id',
    name: 'seats',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Seats"]
}, {
    path: '/promotion/:id',
    name: 'Promo',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Promo"]
}, {
    path: '/event/:id',
    name: 'Event',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Event"]
}, {
    path: '/competition/:id',
    name: 'Competition',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Competition"]
}, {
    path: '/payment/donation/:paymentType',
    name: '<PaymentDonation></PaymentDonation>',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["PaymentDonation"]
}, {
    path: '/payment/:paymentType',
    name: 'Payment',
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Payment"]
}, {
    path: '/user/confirm-email-change/:changeCode',
    name: 'ConfirmEmailChange',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["ConfirmEmailChange"]
}, {
    path: '/content/:content_url/:content_url_two?/:content_url_three?/:content_url_four?',
    name: 'content',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Content"]
}, {
    path: '/preview/:content_type/id/:node_id',
    name: 'content type',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Preview"]
}, {
    path: '/genre/:genres',
    name: 'Genre Landing',
    topNav: false,
    component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["Home"]
}]);

/***/ }),
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_vue__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sections_vue__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__sections_vue___default.a);

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(695),
  /* template */
  __webpack_require__(696),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */,
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_steps_progress_steps_vue__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_steps_progress_steps_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__progress_steps_progress_steps_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__seating_seating_vue__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__seating_seating_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__seating_seating_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extras_extras_vue__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extras_extras_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__extras_extras_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__check_ticket_check_ticket_vue__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__check_ticket_check_ticket_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__check_ticket_check_ticket_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__checkout_checkout_vue__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__checkout_checkout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__checkout_checkout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__countdown_countdown_vue__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__countdown_countdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__countdown_countdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyalty_loyalty_vue__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyalty_loyalty_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyalty_loyalty_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyalty_loyalty_card_vue__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyalty_loyalty_card_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyalty_loyalty_card_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__quick_book_quick_book_vue__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__quick_book_quick_book_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__quick_book_quick_book_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__booking_successful_booking_succesful_vue__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__booking_successful_booking_succesful_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__booking_successful_booking_succesful_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__booking_unsuccessful_booking_unsuccesful_vue__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__booking_unsuccessful_booking_unsuccesful_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__booking_unsuccessful_booking_unsuccesful_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ticket_ticket_vue__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ticket_ticket_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ticket_ticket_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__preview_footer_preview_footer_vue__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__preview_footer_preview_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__preview_footer_preview_footer_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ProgressSteps", function() { return __WEBPACK_IMPORTED_MODULE_0__progress_steps_progress_steps_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Seating", function() { return __WEBPACK_IMPORTED_MODULE_1__seating_seating_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Extras", function() { return __WEBPACK_IMPORTED_MODULE_2__extras_extras_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CheckTicket", function() { return __WEBPACK_IMPORTED_MODULE_3__check_ticket_check_ticket_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Checkout", function() { return __WEBPACK_IMPORTED_MODULE_4__checkout_checkout_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Countdown", function() { return __WEBPACK_IMPORTED_MODULE_5__countdown_countdown_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Loyalty", function() { return __WEBPACK_IMPORTED_MODULE_6__loyalty_loyalty_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "LoyaltyCard", function() { return __WEBPACK_IMPORTED_MODULE_7__loyalty_loyalty_card_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "QuickBook", function() { return __WEBPACK_IMPORTED_MODULE_8__quick_book_quick_book_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "BookingSuccessful", function() { return __WEBPACK_IMPORTED_MODULE_9__booking_successful_booking_succesful_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "BookingUnsuccessful", function() { return __WEBPACK_IMPORTED_MODULE_10__booking_unsuccessful_booking_unsuccesful_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ticket", function() { return __WEBPACK_IMPORTED_MODULE_11__ticket_ticket_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PreviewFooter", function() { return __WEBPACK_IMPORTED_MODULE_12__preview_footer_preview_footer_vue___default.a; });
















/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exclusive_list_vue__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exclusive_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exclusive_list_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__promotions_promotions_vue__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__promotions_promotions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__promotions_promotions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_events_vue__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_events_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__events_events_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__film_festivals_film_festivals_vue__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__film_festivals_film_festivals_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__film_festivals_film_festivals_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__film_festivals_film_festival_list_item_vue__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__film_festivals_film_festival_list_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__film_festivals_film_festival_list_item_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ExclusiveList", function() { return __WEBPACK_IMPORTED_MODULE_0__exclusive_list_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Promotions", function() { return __WEBPACK_IMPORTED_MODULE_1__promotions_promotions_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Events", function() { return __WEBPACK_IMPORTED_MODULE_2__events_events_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FilmFestivals", function() { return __WEBPACK_IMPORTED_MODULE_3__film_festivals_film_festivals_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FilmFestivalListItem", function() { return __WEBPACK_IMPORTED_MODULE_4__film_festivals_film_festival_list_item_vue___default.a; });








/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_news__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_donate__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_subs_club__ = __webpack_require__(798);





/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/contact-us',
  name: 'Contact Us',
  footer: '1',
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["ContactUs"]
}, {
  path: '/contact-us/:type',
  name: 'Contact Us Type',
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["ContactUs"]
}, {
  path: '/find-cinemas/:cinema',
  name: 'Find a Cinema Selected',
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["CinemasPage"]
}, {
  path: '/find-cinemas',
  name: 'Find a Cinema',
  footer: '1',
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["CinemasPage"]
}, {
  path: '/faq',
  name: 'FAQ',
  footer: '1',
  redirect: '/content/faq',
  redirectParams: {
    responseCode: 301
  },
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["FAQ"]
}, {
  url: '/content/sales-at-sk',
  name: 'Sales at SK',
  footer: '2',
  children: [{
    url: '/content/sales-at-sk/advertising',
    name: 'Advertising'
  }, {
    url: '/content/sales-at-sk/conferencing-and-venue-hire',
    name: 'Conferencing and Venue Hire'
  }, {
    url: '/content/sales-at-sk/private-screening',
    name: 'Private Screenings'
  }, {
    url: '/content/sales-at-sk/promotions-and-incentive',
    name: 'Promotions and Incentives'
  }, {
    url: '/content/sales-at-sk/cannes-lions',
    name: 'Cannes Lions'
  }]
}, {
  url: '/content/about-ster-kinekor',
  name: 'About',
  footer: '3'
}, {
  url: '/content/careers',
  name: 'Careers',
  footer: '3'
}, {
  url: '/content/procurement',
  name: 'Procurement',
  footer: '3'
}, {
  url: '/content/vision-mission',
  name: 'Vision Mission',
  footer: '3'
}, {
  path: '/news/:filter',
  name: 'NewsFiltered',
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["News"]
}, {
  path: '/news',
  name: 'News Footer',
  footer: '3',
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["News"]
}, {
  path: '/news/detail/:nid',
  name: 'NewsDetailOld',
  component: __WEBPACK_IMPORTED_MODULE_1__components_news__["NewsDetail"]
}, {
  path: '/news/detail/:nid/:slug',
  name: 'NewsDetail',
  component: __WEBPACK_IMPORTED_MODULE_1__components_news__["NewsDetail"]
}, {
  path: '/news/blogs/detail/:nid/:slug',
  name: 'NewsBlogDetail',
  component: __WEBPACK_IMPORTED_MODULE_1__components_news__["NewsDetail"]
}, {
  path: '/news/genres/detail/:nid/:slug',
  name: 'NewsGenresDetail',
  component: __WEBPACK_IMPORTED_MODULE_1__components_news__["NewsDetail"]
}, {
  path: '/sk-club',
  name: 'SK Club',
  footer: '4',
  redirect: '/club-loyalty/SK_Club',
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["ClubLoyaltyInfo"]
}, {
  path: '/subs-club',
  name: 'SK Subs Club',
  footer: '4',
  redirect: '/subscription-club',
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["ClubLoyaltyInfo"]
}, {
  path: '/discovery-vitality',
  name: 'Discovery Vitality',
  footer: '4',
  redirect: '/club-loyalty/Discovery_Vitality',
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["ClubLoyaltyInfo"]
}, {
  path: '/edgars-club',
  name: 'Edgars Club Movie Benefit',
  footer: '4',
  redirect: '/club-loyalty/Edgars_Club',
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["ClubLoyaltyInfo"]
}, {
  path: '/donate',
  name: 'Donate',
  footer: '5',
  redirect: '/donate/1',
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["VisionMissionDonate"],

  children: [{
    path: '1',
    name: 'DonateStep',
    footer: '5',
    component: __WEBPACK_IMPORTED_MODULE_2__components_donate__["b" /* Donate */]
  }, {
    path: '2',
    name: 'ConfirmDetails',
    component: __WEBPACK_IMPORTED_MODULE_2__components_donate__["a" /* ConfirmDetails */]
  }, {
    path: '3',
    name: 'MakeDonation',
    component: __WEBPACK_IMPORTED_MODULE_2__components_donate__["e" /* MakeDonation */]
  }]
}, {
  path: '/donation-successful/:booking_number/:booking_id',
  name: 'donationSuccess',
  component: __WEBPACK_IMPORTED_MODULE_2__components_donate__["c" /* DonationSuccessful */]
}, {
  path: '/donation-unsuccessful',
  name: 'donationFailure',
  component: __WEBPACK_IMPORTED_MODULE_2__components_donate__["d" /* DonationUnsuccessful */]
}, {
  url: '/content/legal',
  name: 'Legal',
  footer: '6',

  children: [{
    url: '/content/legal/online-booking-terms-and-conditions',
    name: 'Online Booking T\'s & C\'s',
    footer: '6'
  }, {
    url: '/content/legal/club-terms-and-conditions',
    name: 'SK Club T\'s & C\'s',
    footer: '6'
  }, {
    url: '/content/legal/SK%20SUBSCRIPTION%20CLUB%20T\'S%20&%20C\'S',
    name: 'SK Subscription Club T\'s & C\'s',
    footer: '6'
  }, {
    url: '/content/legal/privacy-policy',
    name: 'Privacy Policy',
    footer: '6'
  }, {
    url: '/content/legal/cookie-policy',
    name: 'Cookie Policy',
    footer: '6'
  }, {
    url: '/static/popi-act-disclaimer.pdf?v=1',
    name: 'POPI Act',
    footer: '6',
    target: "blank"
  }, {
    url: '/static/paia-manual.pdf?v=1',
    name: 'PAIA Manual',
    footer: '6',
    target: "blank"
  }, {
    url: '/middleware/sitemap/movies',
    name: 'Sitemap',
    target: "blank",
    footer: '6'
  }]
}, {
  path: '/subscribe',
  name: 'Subscribe',
  redirect: '/subscribe/1',
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["SubsClubSubscribe"],

  children: [{
    path: '1',
    name: 'SubscriptionSummary',
    component: __WEBPACK_IMPORTED_MODULE_3__components_subs_club__["c" /* SubscriptionSummary */]
  }, {
    path: '2',
    name: 'SubsConfirmDetails',
    component: __WEBPACK_IMPORTED_MODULE_3__components_subs_club__["a" /* SubsConfirmDetails */]
  }, {
    path: '3',
    name: 'SubsMakePayment',
    component: __WEBPACK_IMPORTED_MODULE_3__components_subs_club__["b" /* SubsMakePayment */]
  }]
}, {
  path: '/subscribe-success/:psRef/:transactionId',
  name: 'SubscribeProcess',
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["SubscribeProcess"]
}, {
  path: '/subscribe-failure',
  name: 'SubscribeFailure',
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages__["SubscribeFailure"]
}]);

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__detail_vue__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__detail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__detail_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NewsDetail", function() { return __WEBPACK_IMPORTED_MODULE_0__detail_vue___default.a; });



/***/ }),
/* 396 */,
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url_polyfill__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_url_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mdn_polyfills_Object_assign__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mdn_polyfills_Object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mdn_polyfills_Object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mdn_polyfills_Array_prototype_find__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mdn_polyfills_Array_prototype_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mdn_polyfills_Array_prototype_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mdn_polyfills_Array_prototype_includes__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mdn_polyfills_Array_prototype_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mdn_polyfills_Array_prototype_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mdn_polyfills_Array_prototype_findIndex__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mdn_polyfills_Array_prototype_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mdn_polyfills_Array_prototype_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mdn_polyfills_Array_from__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mdn_polyfills_Array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mdn_polyfills_Array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mdn_polyfills_String_prototype_includes__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mdn_polyfills_String_prototype_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mdn_polyfills_String_prototype_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mdn_polyfills_String_prototype_startsWith__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mdn_polyfills_String_prototype_startsWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mdn_polyfills_String_prototype_startsWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mdn_polyfills_Element_prototype_closest__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mdn_polyfills_Element_prototype_closest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mdn_polyfills_Element_prototype_closest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_object_values__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_promise_polyfill__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_promise_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__app_vue__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__app_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__app_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__router__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_head__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_hasta_la_vista_middleware_api_http__ = __webpack_require__(53);


__webpack_require__(407);













(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('prepend')) {
            return;
        }
        Object.defineProperty(item, 'prepend', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function prepend() {
                var argArr = Array.prototype.slice.call(arguments),
                    docFrag = document.createDocumentFragment();

                argArr.forEach(function (argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });

                this.insertBefore(docFrag, this.firstChild);
            }
        });
    });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default.a) __WEBPACK_IMPORTED_MODULE_11_object_values___default.a.shim();


if (!window.Promise) window.Promise = __WEBPACK_IMPORTED_MODULE_12_promise_polyfill___default.a;

__webpack_require__(438).polyfill();









__WEBPACK_IMPORTED_MODULE_13_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_19_hasta_la_vista_middleware_api_http__["a" /* default */].defaults.baseURL = "https://www.sterkinekor.com/middleware/api/v2";
__WEBPACK_IMPORTED_MODULE_19_hasta_la_vista_middleware_api_http__["a" /* default */].defaults.baseLinkURL = "https://www.sterkinekor.com/middleware";

__WEBPACK_IMPORTED_MODULE_18_hasta_la_vista_ui_core__["Utils"].GoogleMapsApiConfig.api_key = "AIzaSyDiT0ZTMHK3h9SoIBd7p8RM8Q0s4gviQKY";
__WEBPACK_IMPORTED_MODULE_18_hasta_la_vista_ui_core__["Utils"].GoogleMapsApiConfig.libraries = ['places'];
__WEBPACK_IMPORTED_MODULE_13_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_16_vue_head___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_18_hasta_la_vista_ui_core___default.a);
var componentPrefix = 'Sk';

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_17__components__["a" /* default */]).forEach(function (key) {
    __WEBPACK_IMPORTED_MODULE_13_vue__["a" /* default */].component('' + componentPrefix + key, __WEBPACK_IMPORTED_MODULE_17__components__["a" /* default */][key]);
});

__WEBPACK_IMPORTED_MODULE_15__router__["a" /* default */].beforeEach(function (to, from, next) {
    if (from.query.noCache && !to.query.noCache) next({ path: to.path, query: { noCache: from.query.noCache } });

    next();
});

new __WEBPACK_IMPORTED_MODULE_13_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_15__router__["a" /* default */],
    template: '<app></app>',
    components: { App: __WEBPACK_IMPORTED_MODULE_14__app_vue___default.a },
    mounted: function mounted() {
        document.dispatchEvent(new Event('app.rendered'));
    }
}).$mount('#app');

/***/ }),
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(440)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(477),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            toggleDialog: false,
            sysError: '',
            loading: true,
            activationDialog: false,
            showGoogleTagManager: false,
            foo: "no"
        };
    },


    methods: {
        okay: function okay(to, from) {
            this.toggleDialog = false;
        },
        resendActivation: function resendActivation() {
            this.activationDialog = true;
        },
        googleTagManager: function googleTagManager() {

            this.showGoogleTagManager = true;

            return this.showGoogleTagManager;
        },
        humanzScript: function humanzScript() {
            function lHzpAsy(u, c) {
                var d = document,
                    t = 'script',
                    o = d.createElement(t),
                    s = d.getElementsByTagName(t)[0];
                o.src = u;
                if (c) {
                    o.addEventListener('load', function (e) {
                        c(null, e);
                    }, false);
                }
                s.parentNode.insertBefore(o, s);
            }
            lHzpAsy("https://assets.humanz.com/2633024/humanz-gtm.js", function () {
                try {
                    var hmz = new window.hzi("2633024");
                } catch (e) {}
            });
        }
    },

    created: function created() {
        var _this = this;

        window.scroll({ top: 0, left: 0 });

        this.googleTagManager();
        this.humanzScript();

        __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["f" /* ErrorHandler */].handle(function (r) {
            return r;
        }, function (error) {
            var errorMessage = 'unknown error';

            var showErrorMessages = true;

            if (window.__PRERENDER_INJECTED) {
                showErrorMessages = false;
            }

            if (error && showErrorMessages) {
                if (error.response) {
                    errorMessage = JSON.parse(error.response.request.responseText);
                } else {
                    if (showErrorMessages) {

                        errorMessage = {
                            error_code: 0,
                            error_type: "Unknown",
                            error: ["Sorry, but we're unable to connect right now. Please try again a bit later."],
                            error_string: "Sorry, but we're unable to connect right now. Please try again a bit later."
                        };
                    }
                }

                if (errorMessage.error_string != "Unable to Update Order") {
                    var skErrorDesc = __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["e" /* ErrorDescriptionService */].getErrorFromCode(errorMessage.error_code, errorMessage.error_type, errorMessage);

                    if (skErrorDesc) {
                        errorMessage.error_string = skErrorDesc.errorDescription;
                        errorMessage.dialog = skErrorDesc.dialog;
                    } else {
                        errorMessage.dialog = true;
                    }
                    if (errorMessage.dialog) {
                        _this.toggleDialog = true;
                        _this.sysError = errorMessage.error_string;
                    } else {
                        _this.toastOptions = _this.$breakpoints.xs ? { fixed: true, timeout: null } : {
                            top: true,
                            fullwidth: true,
                            timeout: null
                        };
                        _this.$toaster.show(errorMessage.error_string, _this.toastOptions);
                    }

                    return errorMessage;
                }
            }
        });

        this.loading = false;
    },
    mounted: function mounted() {
        if (window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.foo) {
            this.foo = window.__PRERENDER_INJECTED.foo;
        }
    }
});

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(443);

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(15);
var bind = __webpack_require__(98);
var Axios = __webpack_require__(445);
var defaults = __webpack_require__(63);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(102);
axios.CancelToken = __webpack_require__(459);
axios.isCancel = __webpack_require__(101);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(460);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 444 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(63);
var utils = __webpack_require__(15);
var InterceptorManager = __webpack_require__(454);
var dispatchRequest = __webpack_require__(455);
var isAbsoluteURL = __webpack_require__(457);
var combineURLs = __webpack_require__(458);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(15);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(100);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(15);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(15);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(15);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(15);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(15);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(15);
var transformData = __webpack_require__(456);
var isCancel = __webpack_require__(101);
var defaults = __webpack_require__(63);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(15);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(102);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_auth_service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__http__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Interceptors = function () {
    function Interceptors(AxiosInstance) {
        _classCallCheck(this, Interceptors);

        this._httpInstance = function () {
            return AxiosInstance;
        };

        this.interceptors = {
            request: [],
            response: []
        };

        this.in_flight_requests = { length: 0 };
    }

    _createClass(Interceptors, [{
        key: 'request',
        value: function request(config) {
            if (!__WEBPACK_IMPORTED_MODULE_0__service_auth_service__["a" /* default */].authToken() && !(config.url == __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].defaults.baseURL + __WEBPACK_IMPORTED_MODULE_0__service_auth_service__["a" /* default */]._tokenRequestUri)) {
                var error = new Error('No Session Token for user');
                error.response = {
                    config: config,
                    data: { error: { code: 'SESSION_TOKEN:NO_TOKEN' } }
                };

                throw error;
            }

            config.headers['Authorization'] = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0__service_auth_service__["a" /* default */].authToken();
            config.headers['X-SESSION'] = __WEBPACK_IMPORTED_MODULE_0__service_auth_service__["a" /* default */].authToken();
            config.headers["Accept"] = "application/json, text/html, text/plain, */*";
            this.in_flight_requests.length++;
            return config;
        }
    }, {
        key: 'response',
        value: function response(_response) {
            this.in_flight_requests.length--;
            return _response;
        }
    }, {
        key: 'responseError',
        value: function responseError(error) {
            var _this = this;

            this.in_flight_requests.length--;
            try {
                var reason = error.response.data.error.code;
            } catch (e) {}

            switch (reason) {
                case 'SESSION_TOKEN:NO_TOKEN':
                case 'SESSION_TOKEN:EXPIRED':
                case 'SESSION_TOKEN:INVALID':
                case 'SESSION_TOKEN:USER_NOT_FOUND':
                    this.in_flight_requests.length++;
                    return __WEBPACK_IMPORTED_MODULE_0__service_auth_service__["a" /* default */].retrieveAuthToken().then(function () {
                        _this.in_flight_requests.length--;
                        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].request(error.response.config);
                    }, function (error) {
                        _this.in_flight_requests.length--;
                    });
                    break;

            }

            var errorResponse = error;
            if (errorResponse.response && errorResponse.response.data) {
                errorResponse.response.data = errorResponse.response.data.data || errorResponse.data;
                errorResponse.response.success = errorResponse.response.success || false;
            }

            return Promise.reject(errorResponse);
        }
    }, {
        key: 'registerRequestInterceptors',
        value: function registerRequestInterceptors() {
            this.interceptors.request.push(this._httpInstance().interceptors.request.use(this.request.bind(this)));
        }
    }, {
        key: 'registerResponseInterceptors',
        value: function registerResponseInterceptors() {
            this.interceptors.response.push(this._httpInstance().interceptors.response.use(this.response.bind(this), this.responseError.bind(this)));
        }
    }, {
        key: 'stopRequests',
        value: function stopRequests() {
            for (var i = 0; i < this.interceptors.request.length; i++) {
                var interceptor = this.interceptors.request[i];
                this._httpInstance().interceptors.request.eject(interceptor);
            }
            return true;
        }
    }, {
        key: 'stopResponse',
        value: function stopResponse() {
            for (var i = 0; i < this.interceptors.response.length; i++) {
                var interceptor = this.interceptors.response[i];
                this._httpInstance().interceptors.response.eject(interceptor);
            }
            return true;
        }
    }, {
        key: 'stopInterceptors',
        value: function stopInterceptors() {
            return this.stopRequests() && this.stopResponse();
        }
    }], [{
        key: 'start',
        value: function start(AxiosInstance) {
            var instance = new Interceptors(AxiosInstance);
            instance.registerRequestInterceptors();
            instance.registerResponseInterceptors();
            return instance;
        }
    }, {
        key: 'stop',
        value: function stop(InterceptorInstance) {
            return InterceptorInstance.stopInterceptors();
        }
    }]);

    return Interceptors;
}();

/* harmony default export */ __webpack_exports__["a"] = (Interceptors);

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 106,
	"./af.js": 106,
	"./ar": 107,
	"./ar-dz": 108,
	"./ar-dz.js": 108,
	"./ar-kw": 109,
	"./ar-kw.js": 109,
	"./ar-ly": 110,
	"./ar-ly.js": 110,
	"./ar-ma": 111,
	"./ar-ma.js": 111,
	"./ar-sa": 112,
	"./ar-sa.js": 112,
	"./ar-tn": 113,
	"./ar-tn.js": 113,
	"./ar.js": 107,
	"./az": 114,
	"./az.js": 114,
	"./be": 115,
	"./be.js": 115,
	"./bg": 116,
	"./bg.js": 116,
	"./bm": 117,
	"./bm.js": 117,
	"./bn": 118,
	"./bn.js": 118,
	"./bo": 119,
	"./bo.js": 119,
	"./br": 120,
	"./br.js": 120,
	"./bs": 121,
	"./bs.js": 121,
	"./ca": 122,
	"./ca.js": 122,
	"./cs": 123,
	"./cs.js": 123,
	"./cv": 124,
	"./cv.js": 124,
	"./cy": 125,
	"./cy.js": 125,
	"./da": 126,
	"./da.js": 126,
	"./de": 127,
	"./de-at": 128,
	"./de-at.js": 128,
	"./de-ch": 129,
	"./de-ch.js": 129,
	"./de.js": 127,
	"./dv": 130,
	"./dv.js": 130,
	"./el": 131,
	"./el.js": 131,
	"./en-au": 132,
	"./en-au.js": 132,
	"./en-ca": 133,
	"./en-ca.js": 133,
	"./en-gb": 134,
	"./en-gb.js": 134,
	"./en-ie": 135,
	"./en-ie.js": 135,
	"./en-nz": 136,
	"./en-nz.js": 136,
	"./eo": 137,
	"./eo.js": 137,
	"./es": 138,
	"./es-do": 139,
	"./es-do.js": 139,
	"./es-us": 140,
	"./es-us.js": 140,
	"./es.js": 138,
	"./et": 141,
	"./et.js": 141,
	"./eu": 142,
	"./eu.js": 142,
	"./fa": 143,
	"./fa.js": 143,
	"./fi": 144,
	"./fi.js": 144,
	"./fo": 145,
	"./fo.js": 145,
	"./fr": 146,
	"./fr-ca": 147,
	"./fr-ca.js": 147,
	"./fr-ch": 148,
	"./fr-ch.js": 148,
	"./fr.js": 146,
	"./fy": 149,
	"./fy.js": 149,
	"./gd": 150,
	"./gd.js": 150,
	"./gl": 151,
	"./gl.js": 151,
	"./gom-latn": 152,
	"./gom-latn.js": 152,
	"./gu": 153,
	"./gu.js": 153,
	"./he": 154,
	"./he.js": 154,
	"./hi": 155,
	"./hi.js": 155,
	"./hr": 156,
	"./hr.js": 156,
	"./hu": 157,
	"./hu.js": 157,
	"./hy-am": 158,
	"./hy-am.js": 158,
	"./id": 159,
	"./id.js": 159,
	"./is": 160,
	"./is.js": 160,
	"./it": 161,
	"./it.js": 161,
	"./ja": 162,
	"./ja.js": 162,
	"./jv": 163,
	"./jv.js": 163,
	"./ka": 164,
	"./ka.js": 164,
	"./kk": 165,
	"./kk.js": 165,
	"./km": 166,
	"./km.js": 166,
	"./kn": 167,
	"./kn.js": 167,
	"./ko": 168,
	"./ko.js": 168,
	"./ky": 169,
	"./ky.js": 169,
	"./lb": 170,
	"./lb.js": 170,
	"./lo": 171,
	"./lo.js": 171,
	"./lt": 172,
	"./lt.js": 172,
	"./lv": 173,
	"./lv.js": 173,
	"./me": 174,
	"./me.js": 174,
	"./mi": 175,
	"./mi.js": 175,
	"./mk": 176,
	"./mk.js": 176,
	"./ml": 177,
	"./ml.js": 177,
	"./mr": 178,
	"./mr.js": 178,
	"./ms": 179,
	"./ms-my": 180,
	"./ms-my.js": 180,
	"./ms.js": 179,
	"./mt": 181,
	"./mt.js": 181,
	"./my": 182,
	"./my.js": 182,
	"./nb": 183,
	"./nb.js": 183,
	"./ne": 184,
	"./ne.js": 184,
	"./nl": 185,
	"./nl-be": 186,
	"./nl-be.js": 186,
	"./nl.js": 185,
	"./nn": 187,
	"./nn.js": 187,
	"./pa-in": 188,
	"./pa-in.js": 188,
	"./pl": 189,
	"./pl.js": 189,
	"./pt": 190,
	"./pt-br": 191,
	"./pt-br.js": 191,
	"./pt.js": 190,
	"./ro": 192,
	"./ro.js": 192,
	"./ru": 193,
	"./ru.js": 193,
	"./sd": 194,
	"./sd.js": 194,
	"./se": 195,
	"./se.js": 195,
	"./si": 196,
	"./si.js": 196,
	"./sk": 197,
	"./sk.js": 197,
	"./sl": 198,
	"./sl.js": 198,
	"./sq": 199,
	"./sq.js": 199,
	"./sr": 200,
	"./sr-cyrl": 201,
	"./sr-cyrl.js": 201,
	"./sr.js": 200,
	"./ss": 202,
	"./ss.js": 202,
	"./sv": 203,
	"./sv.js": 203,
	"./sw": 204,
	"./sw.js": 204,
	"./ta": 205,
	"./ta.js": 205,
	"./te": 206,
	"./te.js": 206,
	"./tet": 207,
	"./tet.js": 207,
	"./th": 208,
	"./th.js": 208,
	"./tl-ph": 209,
	"./tl-ph.js": 209,
	"./tlh": 210,
	"./tlh.js": 210,
	"./tr": 211,
	"./tr.js": 211,
	"./tzl": 212,
	"./tzl.js": 212,
	"./tzm": 213,
	"./tzm-latn": 214,
	"./tzm-latn.js": 214,
	"./tzm.js": 213,
	"./uk": 215,
	"./uk.js": 215,
	"./ur": 216,
	"./ur.js": 216,
	"./uz": 217,
	"./uz-latn": 218,
	"./uz-latn.js": 218,
	"./uz.js": 217,
	"./vi": 219,
	"./vi.js": 219,
	"./x-pseudo": 220,
	"./x-pseudo.js": 220,
	"./yo": 221,
	"./yo.js": 221,
	"./zh-cn": 222,
	"./zh-cn.js": 222,
	"./zh-hk": 223,
	"./zh-hk.js": 223,
	"./zh-tw": 224,
	"./zh-tw.js": 224
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 462;

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Regions; });
/* unused harmony export Region */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_BaseModel__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModelArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cinema__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Collection__ = __webpack_require__(41);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var MAX_LOCATION_RADIUS = 20;

var Regions = function (_Collection) {
    _inherits(Regions, _Collection);

    function Regions(data) {
        _classCallCheck(this, Regions);

        var _this = _possibleConstructorReturn(this, (Regions.__proto__ || Object.getPrototypeOf(Regions)).call(this));

        _this.data = new __WEBPACK_IMPORTED_MODULE_1__ModelArray__["a" /* default */](data, Region);
        return _this;
    }

    _createClass(Regions, [{
        key: '_getDistanceFromLatLongs',
        value: function _getDistanceFromLatLongs(latStart, longStart, latFind, longFind) {
            var deg2rad = function deg2rad(deg) {
                return deg * (Math.PI / 180);
            },
                R = 6371,
                dLat = deg2rad(latFind - latStart),
                dLon = deg2rad(longFind - longStart),
                a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(latStart)) * Math.cos(deg2rad(latFind)) * Math.sin(dLon / 2) * Math.sin(dLon / 2),
                c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)),
                d = R * c;
            return Math.round(d * 100) / 100;
        }
    }, {
        key: 'cinemasCloseTo',
        value: function cinemasCloseTo(lat, long) {
            var _this2 = this;

            return this.cinemas.filter(function (c, i, self) {
                var distance = _this2._getDistanceFromLatLongs(lat, long, c.latitude, c.longitude);
                c.distance = distance;
                return distance <= MAX_LOCATION_RADIUS && self.findIndex(function (c2) {
                    return c2.name === c.name;
                }) === i;
            }).sort(function (c, c2) {
                return c.distance - c2.distance;
            });
        }
    }, {
        key: 'findByCinemas',
        value: function findByCinemas(arrayOfCinemaIds) {
            var regions = [];
            for (var i = 0; i < this.data.length; i++) {
                var region = Object.assign({}, this.data[i]);
                region.cinemas = region.cinemas.filter(function (c) {
                    return ~arrayOfCinemaIds.indexOf(c.id);
                });
                if (region.cinemas.length > 0) regions.push(region);
            }
            return regions;
        }
    }, {
        key: 'findCimema',
        value: function findCimema(id) {
            return this.cinemas.find(function (c) {
                return c.id == id;
            });
        }
    }, {
        key: 'findCinemaBySlug',
        value: function findCinemaBySlug(slug) {
            return this.cinemas.find(function (c) {
                return c.slug == slug;
            });
        }
    }, {
        key: 'cinemas',
        get: function get() {
            return this.data.reduce(function (c, r) {
                return c.concat(r.cinemas);
            }, []);
        }
    }]);

    return Regions;
}(__WEBPACK_IMPORTED_MODULE_3__Collection__["a" /* default */]);

var Region = function (_BaseModel) {
    _inherits(Region, _BaseModel);

    function Region(data) {
        _classCallCheck(this, Region);

        var _this3 = _possibleConstructorReturn(this, (Region.__proto__ || Object.getPrototypeOf(Region)).call(this));

        _this3.id = data.id;
        _this3.name = data.name;
        _this3.cinemas = data.cinemas && new __WEBPACK_IMPORTED_MODULE_1__ModelArray__["a" /* default */](data.cinemas, __WEBPACK_IMPORTED_MODULE_2__Cinema__["a" /* default */]);
        _this3.distance = "";
        return _this3;
    }

    return Region;
}(__WEBPACK_IMPORTED_MODULE_0__model_BaseModel__["a" /* default */]);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SeatGroups; });
/* unused harmony export SeatGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_BaseModel__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_movie_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Seat__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModelArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Collection__ = __webpack_require__(41);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SeatGroups = function (_Collection) {
    _inherits(SeatGroups, _Collection);

    function SeatGroups(data) {
        _classCallCheck(this, SeatGroups);

        var _this = _possibleConstructorReturn(this, (SeatGroups.__proto__ || Object.getPrototypeOf(SeatGroups)).call(this));

        _this.data = new SeatGroup(data);
        return _this;
    }

    return SeatGroups;
}(__WEBPACK_IMPORTED_MODULE_4__Collection__["a" /* default */]);

var SeatGroup = function (_BaseModel) {
    _inherits(SeatGroup, _BaseModel);

    function SeatGroup(data) {
        _classCallCheck(this, SeatGroup);

        var _this2 = _possibleConstructorReturn(this, (SeatGroup.__proto__ || Object.getPrototypeOf(SeatGroup)).call(this, data));

        _this2.Size = data.Size;
        _this2.Active = data.Active;
        _this2.SeatType = data.SeatType;
        _this2.SeatData = data.SeatData;
        _this2.Selected = data.Selected;
        _this2.SeatsInGroup = data.SeatsInGroup || [];
        _this2.ColumnIndex = data.ColumnIndex;
        _this2.RowIndex = data.RowIndex;
        _this2.AreaNumber = data.AreaNumber;
        _this2.SelectedButNotChangeable = data.SelectedButNotChangeable || false;
        return _this2;
    }

    return SeatGroup;
}(__WEBPACK_IMPORTED_MODULE_0__model_BaseModel__["a" /* default */]);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModel__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModelArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_auth_service__ = __webpack_require__(40);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Membership = function (_BaseModel) {
    _inherits(Membership, _BaseModel);

    function Membership(data) {
        _classCallCheck(this, Membership);

        var _this = _possibleConstructorReturn(this, (Membership.__proto__ || Object.getPrototypeOf(Membership)).call(this));

        _this.CardNumber = data.CardNumber;
        _this.Type = data.Type;
        return _this;
    }

    return Membership;
}(__WEBPACK_IMPORTED_MODULE_0__BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Membership);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_ModelArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model__ = __webpack_require__(19);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var MovieMetaService = function () {
    function MovieMetaService() {
        _classCallCheck(this, MovieMetaService);

        this.meta = undefined;
    }

    _createClass(MovieMetaService, [{
        key: '_processExperiences',
        value: function _processExperiences(data) {
            return new __WEBPACK_IMPORTED_MODULE_1__model_ModelArray__["a" /* default */](data, __WEBPACK_IMPORTED_MODULE_2__model__["a" /* Experience */]);
        }
    }, {
        key: '_processGenres',
        value: function _processGenres(data) {
            return new __WEBPACK_IMPORTED_MODULE_1__model_ModelArray__["a" /* default */](data, __WEBPACK_IMPORTED_MODULE_2__model__["d" /* Genre */]);
        }
    }, {
        key: '_processFlags',
        value: function _processFlags(data) {
            return new __WEBPACK_IMPORTED_MODULE_1__model_ModelArray__["a" /* default */](data, __WEBPACK_IMPORTED_MODULE_2__model__["c" /* Flag */]);
        }
    }, {
        key: '_processFeatured',
        value: function _processFeatured(data) {
            return new __WEBPACK_IMPORTED_MODULE_1__model_ModelArray__["a" /* default */](data, __WEBPACK_IMPORTED_MODULE_2__model__["b" /* FeaturedContent */]);
        }
    }, {
        key: '_processMovieMeta',
        value: function _processMovieMeta(data) {
            return {
                genres: data.genres ? this._processGenres(data.genres.sort(function (a, b) {
                    return a.Name < b.Name ? -1 : a.Name > b.Name ? 1 : 0;
                })) : [],
                experiences: data.experiences ? this._processExperiences(data.experiences.sort()) : [],
                flags: data.flags ? this._processFlags(data.flags.sort()) : [],
                featured_content: data.featured_content ? this._processFeatured(data.featured_content) : [],
                expired_movies: data.expired_movies,
                last_available_date: data.last_available_date || null,
                extended_regions: data.extended_regions || null,
                extended_regions_data: data.extended_regions_data || null
            };
        }
    }, {
        key: 'setPreRenderMovieMeta',
        value: function setPreRenderMovieMeta(meta) {
            if (meta && meta != undefined) {
                return this.meta = this._processMovieMeta(meta);
            } else {
                this.meta = undefined;
            }

            return this.meta;
        }
    }, {
        key: 'getMovieMeta',
        value: function getMovieMeta(noCache) {
            var _this = this;

            return this.meta = this.meta || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/movies/meta' + (noCache ? '?noCache=' + noCache : '')).then(function (response) {
                return _this._processMovieMeta(response.data);
            }, function (error) {
                _this.meta = undefined;
                return Promise.reject(error);
            });
        }
    }, {
        key: 'getExperiences',
        value: function getExperiences(movie) {
            var noCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return this.getMovieMeta(noCache).then(function (meta) {
                return meta.experiences;
            });
        }
    }, {
        key: 'getGenres',
        value: function getGenres() {
            var noCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this.getMovieMeta(noCache).then(function (meta) {
                return meta.genres;
            });
        }
    }, {
        key: 'getFeaturedContent',
        value: function getFeaturedContent() {
            var noCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this.getMovieMeta(noCache).then(function (meta) {
                return meta.featured_content;
            });
        }
    }, {
        key: 'getGenresBySlugs',
        value: function getGenresBySlugs(slugs) {
            var noCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var genres = [];
            if (slugs && slugs.length > 0) {
                this.getMovieMeta(noCache).then(function (meta) {
                    for (var s in slugs) {
                        for (var g in meta.genres) {
                            if (slugs[s] == meta.genres[g].name.toLowerCase()) {
                                genres.push(meta.genres[g]);
                            }
                        }
                    }
                });
            }

            return genres;
        }
    }]);

    return MovieMetaService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new MovieMetaService());

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_ObservableBaseModel__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Session__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModelArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Booking__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Ticket__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConcessionItem__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VistaDate__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__service_order_service__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__service_ecom_tracking_service__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service_region_service__ = __webpack_require__(48);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }












var Order = function () {
    function Order() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

        _classCallCheck(this, Order);

        this.SessionId = undefined;
        this.CinemaId = undefined;
        this.Concessions = undefined;
        this.Sessions = [];
        this.Loyalties = [];
        this.modified = false;
        this.defaultTicketType = undefined;
        this.LastUpdated = undefined;
        this.ExpiryDate = undefined;
        this._loading = false;
        this.VistaBookingNumber = undefined;
        this.VistaTransactionNumber = undefined;
        this.seatGridLoaded = false;
        this._ticketFlow = {
            tickets: { add: [], remove: [], added: [], added_as_loyalty: [] },
            loyalties: { add: [], remove: [], added: [] },
            concessions: { add: [], remove: [], added: [] }
        };
        this.toggleMaxAmountPurchaseDialog = false;

        if (data) {
            this.setOrder(data);
        }

        this.confirmAndReconfigureOrderSession();

        this.MaxTotal = 500000;
        this.getMaxTotal();
    }

    _createClass(Order, [{
        key: 'getMaxTotal',
        value: function getMaxTotal() {
            var _this = this;

            Promise.resolve(__WEBPACK_IMPORTED_MODULE_7__service_order_service__["a" /* default */].getPaymentConfig()).then(function (result) {
                if (result.data) {
                    var maxTotal = parseInt(result.data[0].max_amount);
                    _this.MaxTotal = maxTotal * 100;
                }
            });
        }
    }, {
        key: 'confirmAndReconfigureOrderSession',
        value: function confirmAndReconfigureOrderSession() {
            var _this2 = this;

            if (!this.Session && this.Sessions.length > 0) {
                this.SessionId = this.Sessions[0].SessionId;
                if (this.Session.MoviePromise) this.Session.MoviePromise.then(function (m) {
                    __WEBPACK_IMPORTED_MODULE_7__service_order_service__["a" /* default */].setPendingSession(_this2.SessionId, _this2.CinemaId, m ? m.id : null);
                });else __WEBPACK_IMPORTED_MODULE_7__service_order_service__["a" /* default */].setPendingSession(this.SessionId, this.CinemaId, null);
                this.loadSeatGrid();
            }
        }
    }, {
        key: 'getSessionLoyalties',
        value: function getSessionLoyalties(session) {
            return session && session.Loyalties && session.Loyalties.length > 0 ? session.Loyalties.reduce(function (collection, loyalty) {
                if (loyalty.TicketType && loyalty.TicketType.PackageContent && loyalty.TicketType.PackageContent.Tickets) {
                    loyalty.PackageTicket = false;

                    var added = false;

                    if (loyalty.TicketType.PackageContent != undefined && loyalty.TicketType.PackageContent != null) {
                        if (loyalty.TicketType.PackageContent.Tickets != undefined && loyalty.TicketType.PackageContent.Tickets != null) {
                            for (var i = 0; i < loyalty.TicketType.PackageContent.Tickets.length; i++) {
                                var ticket = loyalty.TicketType.PackageContent.Tickets[i];

                                for (var j = 1; j <= ticket.Quantity; j++) {
                                    var loyaltyClone = Object.assign({}, loyalty);
                                    loyaltyClone.TicketType = Object.assign({}, loyaltyClone.TicketType);
                                    loyaltyClone.TicketType.PriceInCents = 0;
                                    loyaltyClone.PackageTicket = true;
                                    collection.push(loyaltyClone);
                                    added = true;
                                }
                            }
                        }
                    }

                    if (!added) {
                        collection.push(loyalty);
                    }
                }

                return collection;
            }, []) : [];
        }
    }, {
        key: 'getDefaultTicketTypeForArea',
        value: function getDefaultTicketTypeForArea(AreaCategoryCode) {
            return this.TicketTypes.find(function (type) {
                return type.default === true && type.AreaCategoryCode === AreaCategoryCode;
            });
        }
    }, {
        key: 'setOrder',
        value: function setOrder(data) {
            if (data instanceof Order) {
                Object.assign(this, data);
                return this;
            }

            if (!data) return this;
            this.SessionId = data.SessionId;
            this.CinemaId = data.CinemaId;

            this.Concessions = data.Concessions ? new __WEBPACK_IMPORTED_MODULE_2__ModelArray__["a" /* default */](data.Concessions, __WEBPACK_IMPORTED_MODULE_5__ConcessionItem__["a" /* default */]) : [];
            this.Sessions = data.Sessions ? new __WEBPACK_IMPORTED_MODULE_2__ModelArray__["a" /* default */](data.Sessions, __WEBPACK_IMPORTED_MODULE_1__Session__["a" /* default */]) : [];
            this.modified = false;
            this.defaultTicketType = data.defaultTicketType;
            this._loading = data.loading || false;
            this.VistaBookingNumber = data.VistaBookingNumber;
            this.VistaTransactionNumber = data.VistaTransactionNumber;

            this.LastUpdated = data.LastUpdated ? new __WEBPACK_IMPORTED_MODULE_6__VistaDate__["a" /* default */](data.LastUpdated / 1000) : this.LastUpdated;
            this.ExpiryDate = data.ExpiryDate ? new __WEBPACK_IMPORTED_MODULE_6__VistaDate__["a" /* default */](data.ExpiryDate / 1000) : this.ExpiryDate;
            return this;
        }
    }, {
        key: 'setDates',
        value: function setDates(Expiry, Updated) {
            this.LastUpdated = new __WEBPACK_IMPORTED_MODULE_6__VistaDate__["a" /* default */](Updated / 1000) || false;
            this.ExpiryDate = new __WEBPACK_IMPORTED_MODULE_6__VistaDate__["a" /* default */](Expiry / 1000) || false;
        }
    }, {
        key: 'addTicket',
        value: function addTicket(seat, seatProps) {
            var TicketType = this.getDefaultTicketTypeForArea(seat.Position.AreaCategoryCode);
            if (this.totalInCents + TicketType.PriceInCents > this.MaxTotal) {
                this.toggleMaxAmountPurchaseDialog = true;
            } else {
                this.modified = true;
                var ticket = new __WEBPACK_IMPORTED_MODULE_4__Ticket__["a" /* default */]({
                    Position: seat.Position,
                    SeatData: seat.seatName,
                    SeatName: seat.seatName,
                    SeatNumber: seat.seatNumber || seatProps.seatNumber,
                    SeatId: seat.Id,
                    SeatNumberCombined: seatProps.SeatNumberCombined,
                    PriceCents: TicketType.PriceInCents,
                    TicketTypeCode: TicketType.TicketTypeCode,
                    isPackageTicket: TicketType.IsPackageTicket,
                    Description: TicketType.Description,

                    Barcode: null
                });
                ticket.status = {
                    companion: seatProps.companion,
                    loveNest: seatProps.loveNest,
                    dBox: seatProps.dBox,
                    wheelchair: seatProps.wheelchair
                };
                this.Session.Tickets.push(ticket);
                this._ticketFlow.tickets.add.push(ticket);
                this._processEcomTrackingCart();


                return ticket;
            }
        }
    }, {
        key: 'addVistaVoucherTicket',
        value: function addVistaVoucherTicket(LoyaltyCard) {
            var Qty = 1;
            var TicketTypeCode = LoyaltyCard.TicketTypeCode;
            var AreaCategoryCode = LoyaltyCard.TicketType.AreaCategoryCode;
            var TicketType = this.getDefaultTicketTypeForArea(AreaCategoryCode);
            var OriginalTicketTypeCode = TicketType.TicketTypeCode;
            var sessionId = this.SessionId;
            var Barcode = LoyaltyCard.Barcode;

            return __WEBPACK_IMPORTED_MODULE_7__service_order_service__["a" /* default */].addVistaVoucherTicket(sessionId, Qty, TicketTypeCode, OriginalTicketTypeCode, AreaCategoryCode, Barcode);
        }
    }, {
        key: 'removeVistaVoucherTicket',
        value: function removeVistaVoucherTicket(ticket) {
            var sessionId = this.SessionId;
            var cinemaId = this.SessionId;
            return __WEBPACK_IMPORTED_MODULE_7__service_order_service__["a" /* default */].removeVistaVoucherTicket(sessionId, cinemaId, ticket);
        }
    }, {
        key: 'addVistaSeatsForTicket',
        value: function addVistaSeatsForTicket(seat, seatProps) {
            var _this3 = this;

            var SuppliedTicketType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

            return __WEBPACK_IMPORTED_MODULE_7__service_order_service__["a" /* default */].getDefaultTicketTypeForSession(this.SessionId, this.CinemaId, seat.Position.AreaCategoryCode).then(function (TicketType) {
                if (_this3.totalInCents + TicketType.PriceInCents > _this3.MaxTotal) {
                    _this3.toggleMaxAmountPurchaseDialog = true;
                } else {
                    _this3.modified = true;
                    var ticket = new __WEBPACK_IMPORTED_MODULE_4__Ticket__["a" /* default */]({
                        Position: seat.Position,
                        SeatData: seat.seatName,
                        SeatName: seat.seatName,
                        SeatNumber: seat.seatNumber || seatProps.seatNumber,
                        SeatId: seat.Id,
                        SeatNumberCombined: seatProps.SeatNumberCombined,
                        PriceCents: TicketType.PriceInCents,
                        TicketTypeCode: TicketType.TicketTypeCode,
                        isPackageTicket: TicketType.IsPackageTicket,
                        Description: TicketType.Description,
                        Barcode: null
                    });
                    ticket.status = {
                        companion: seatProps.companion,
                        loveNest: seatProps.loveNest,
                        dBox: seatProps.dBox,
                        wheelchair: seatProps.wheelchair
                    };
                }
                return __WEBPACK_IMPORTED_MODULE_7__service_order_service__["a" /* default */].addVistaSeatsForTicket(ticket, _this3.SessionId);
            });
        }
    }, {
        key: 'removeVistaSeatsForTicket',
        value: function removeVistaSeatsForTicket(seat, seatProps, ticketTypeCode) {
            var position = seat.Position;
            var status = {
                companion: seatProps.companion,
                loveNest: seatProps.loveNest,
                dBox: seatProps.dBox,
                wheelchair: seatProps.wheelchair
            };

            console.log("Order::removeVistaTicket", position, ticketTypeCode, this.SessionId);
            return __WEBPACK_IMPORTED_MODULE_7__service_order_service__["a" /* default */].removeVistaSeatsForTicket(position, status, ticketTypeCode, this.SessionId);
        }
    }, {
        key: 'addLoyalty',
        value: function addLoyalty(LoyaltyCard) {
            var validCardResponse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            for (var i = 0; i < this.Tickets.length; i++) {
                var ticket = this.Tickets[i];
                if (ticket.Id) {
                    this.UnassignedTickets.push(Object.assign({}, ticket));
                    delete ticket.Id;
                }
            }

            try {
                var loyalties = [];
                try {
                    loyalties = JSON.parse(localStorage.getItem("loyalties")) || [];
                } catch (e) {}
                var thisLoyalty = {
                    "SessionId": this.SessionId,
                    "MemberCard": LoyaltyCard.MemberCard,
                    "CardNumber": LoyaltyCard.CardNumber,
                    "TicketTypeCode": LoyaltyCard.TicketTypeCode,
                    "Name": LoyaltyCard.Name,
                    "MemberProviderName": LoyaltyCard.MemberProviderName
                };
                if (!~loyalties.indexOf(thisLoyalty)) loyalties.push(thisLoyalty);
                localStorage.setItem("loyalties", JSON.stringify(loyalties));
            } catch (e) {}
            this.modified = true;
            this.Session.Loyalties.push(LoyaltyCard);

            this._ticketFlow.loyalties.add.push(LoyaltyCard);
            this._processEcomTrackingCart();
        }
    }, {
        key: 'removeLoyalty',
        value: function removeLoyalty(LoyaltyCard) {
            var index = this.Session.Loyalties.indexOf(LoyaltyCard);
            this.Session.Loyalties.splice(index, 1);

            try {
                var loyalties = [];
                try {
                    loyalties = JSON.parse(localStorage.getItem("loyalties")) || [];
                } catch (e) {}

                var lIndex = loyalties.findIndex(function (l) {
                    return l.MemberCard == LoyaltyCard.MemberCard && l.Name == LoyaltyCard.Name;
                });
                if (~lIndex) loyalties.splice(lIndex, 1);
                localStorage.setItem("loyalties", JSON.stringify(loyalties));

                this._ticketFlow.loyalties.remove.push(LoyaltyCard);
                this._processEcomTrackingCart();
            } catch (e) {}
        }
    }, {
        key: 'removeTicket',
        value: function removeTicket(ticket) {

            this.modified = true;
            if (ticket.Id) {
                this.UnassignedTickets.push(ticket);
            }
            if (ticket.PackageId && ticket.PackageId > 0 && ticket.Id == "0") {
                var parentTicket = this.Tickets.find(function (t) {
                    return parseInt(t.Id) > 0 && t.PackageId == ticket.PackageId;
                });
                if (parentTicket) {

                    this.UnassignedTickets.push(Object.assign({}, parentTicket));

                    delete parentTicket.Id;
                }
            }
            var index = this.Session.Tickets.indexOf(ticket);
            if (~index) {
                this.Session.Tickets.splice(index, 1);

                this._ticketFlow.tickets.remove.push(ticket);
                this._processEcomTrackingCart();
                return true;
            }

            return false;
        }
    }, {
        key: '_processEcomAddLinkLoyaltyToNewTicket',
        value: function _processEcomAddLinkLoyaltyToNewTicket(loyalty) {
            return false;
            for (var t in this._ticketFlow.tickets.add) {
                if (this._ticketFlow.tickets.add[t].TicketTypeCode == "0022" || this._ticketFlow.tickets.add[t].TicketTypeCode == "0008" || this._ticketFlow.tickets.add[t].Description.includes("Full Price")) {
                    var ticket = loyalty.TicketType;
                    var b_ticket = this._ticketFlow.tickets.add[t];
                    var session = this.Sessions[0];
                    ticket.FilmTitle = session.FilmTitle;
                    b_ticket.FilmTitle = session.FilmTitle;
                    __WEBPACK_IMPORTED_MODULE_8__service_ecom_tracking_service__["a" /* default */].doDataLayerAddTicketToBasket(ticket);
                    this._ticketFlow.loyalties.added.push(loyalty);
                    this._ticketFlow.tickets.added_as_loyalty.push(b_ticket);
                    this._ticketFlow.tickets.add.splice(t, 1);

                    return true;
                }
            }

            return false;
        }
    }, {
        key: '_processEcomAddLinkLoyaltyToAddedTicket',
        value: function _processEcomAddLinkLoyaltyToAddedTicket(loyalty) {
            return false;
            for (var t in this._ticketFlow.tickets.added) {
                if (this._ticketFlow.tickets.added[t].TicketTypeCode == "0022" || this._ticketFlow.tickets.added[t].TicketTypeCode == "0008" || this._ticketFlow.tickets.added[t].Description.includes("Full Price")) {
                    var ticket = loyalty.TicketType;
                    var b_ticket = this._ticketFlow.tickets.added[t];
                    var session = this.Sessions[0];
                    ticket.FilmTitle = session.FilmTitle;
                    b_ticket.FilmTitle = session.FilmTitle;

                    __WEBPACK_IMPORTED_MODULE_8__service_ecom_tracking_service__["a" /* default */].doDataLayerAddTicketToBasket(ticket);
                    this._ticketFlow.loyalties.added.push(ticket);

                    this._ticketFlow.tickets.added_as_loyalty.push(b_ticket);

                    __WEBPACK_IMPORTED_MODULE_8__service_ecom_tracking_service__["a" /* default */].doDataLayerRemoveTicketFromBasket(b_ticket);
                    this._ticketFlow.tickets.added.splice(t, 1);

                    return true;
                }
            }

            return false;
        }
    }, {
        key: '_processEcomRemoveLinkLoyaltyFromTicket',
        value: function _processEcomRemoveLinkLoyaltyFromTicket(loyalty) {
            return false;
            for (var t in this._ticketFlow.tickets.added_as_loyalty) {
                if (this._ticketFlow.tickets.added_as_loyalty[t].TicketTypeCode == "0022") {
                    var ticket = loyalty.TicketType;
                    var b_ticket = this._ticketFlow.tickets.added_as_loyalty[t];
                    var session = this.Sessions[0];
                    ticket.FilmTitle = session.FilmTitle;
                    b_ticket.FilmTitle = session.FilmTitle;
                    __WEBPACK_IMPORTED_MODULE_8__service_ecom_tracking_service__["a" /* default */].doDataLayerRemoveTicketFromBasket(ticket);
                    __WEBPACK_IMPORTED_MODULE_8__service_ecom_tracking_service__["a" /* default */].doDataLayerAddTicketToBasket(b_ticket);
                    this._ticketFlow.tickets.added.push(b_ticket);
                    this._ticketFlow.tickets.added_as_loyalty.splice(t, 1);

                    for (var al in this._ticketFlow.loyalties.added) {
                        if (loyalty == this._ticketFlow.loyalties.added[al]) {
                            this._ticketFlow.loyalties.added.splice(al, 1);
                        }
                    }

                    return true;
                }
            }
        }
    }, {
        key: '_processEcomAddNewTicket',
        value: function _processEcomAddNewTicket(ticket) {
            return false;
            var session = this.Sessions[0];
            ticket.FilmTitle = session.FilmTitle;
            __WEBPACK_IMPORTED_MODULE_8__service_ecom_tracking_service__["a" /* default */].doDataLayerAddTicketToBasket(ticket);
            this._ticketFlow.tickets.added.push(ticket);
            return true;
        }
    }, {
        key: '_processEcomRemoveAddedTicket',
        value: function _processEcomRemoveAddedTicket(ticket) {
            return false;
            for (var t in this._ticketFlow.tickets.added) {
                if (ticket == this._ticketFlow.tickets.added[t]) {
                    __WEBPACK_IMPORTED_MODULE_8__service_ecom_tracking_service__["a" /* default */].doDataLayerRemoveTicketFromBasket(ticket);
                    this._ticketFlow.tickets.added.splice(t, 1);
                    return true;
                }
            }
        }
    }, {
        key: '_processEcomTrackingCart',
        value: function _processEcomTrackingCart() {
            var _this4 = this;

            return false;

            for (var l in this._ticketFlow.loyalties.add) {
                Promise.resolve(this._processEcomAddLinkLoyaltyToNewTicket(this._ticketFlow.loyalties.add[l])).then(function (result) {
                    if (result) {
                        _this4._ticketFlow.loyalties.add.splice(l, 1);
                    } else {
                        Promise.resolve(_this4._processEcomAddLinkLoyaltyToAddedTicket(_this4._ticketFlow.loyalties.add[l])).then(function (result) {
                            if (result) {
                                _this4._ticketFlow.loyalties.add.splice(l, 1);
                            }
                        });
                    }
                });
            }

            for (var rl in this._ticketFlow.loyalties.remove) {
                Promise.resolve(this._processEcomRemoveLinkLoyaltyFromTicket(this._ticketFlow.loyalties.remove[rl])).then(function (result) {
                    if (result) {
                        _this4._ticketFlow.loyalties.remove.splice(rl, 1);
                    }
                });
            }

            for (var t in this._ticketFlow.tickets.add) {
                Promise.resolve(this._processEcomAddNewTicket(this._ticketFlow.tickets.add[t])).then(function (result) {
                    if (result) {
                        _this4._ticketFlow.tickets.add.splice(t, 1);
                    }
                });
            }

            for (var rt in this._ticketFlow.tickets.remove) {
                Promise.resolve(this._processEcomRemoveAddedTicket(this._ticketFlow.tickets.remove[rt])).then(function (result) {
                    if (result) {
                        _this4._ticketFlow.tickets.remove.splice(rt, 1);
                    }
                });
            }
        }
    }, {
        key: 'removeSession',
        value: function removeSession(SessionId) {
            var foundIndex = this.Sessions.findIndex(function (s) {
                return parseInt(s.SessionId) === parseInt(SessionId);
            });
            if (~foundIndex) {
                this.Sessions.splice(foundIndex, 1);
                this.confirmAndReconfigureOrderSession();
            }
        }
    }, {
        key: 'setConcession',
        value: function setConcession(concession, Quantity) {
            var _this5 = this;

            var session = this.Sessions[0];
            concession.FilmTitle = session.FilmTitle;

            this.modified = true;
            if (this.totalInCents + concession.PriceInCents > this.MaxTotal && concession.Quantity < Quantity) {
                this.toggleMaxAmountPurchaseDialog = true;
            } else {

                var index = this.Concessions.findIndex(function (c) {
                    return c.Id == concession.Id && c.Description == concession.Description;
                });
                if (~index) {
                    if (Quantity == 0) {
                        Promise.resolve(__WEBPACK_IMPORTED_MODULE_8__service_ecom_tracking_service__["a" /* default */].doDataLayerRemoveConcessionFromBasket(concession)).then(function (result) {
                            _this5.Concessions.splice(index, 1);
                            _this5._ticketFlow.concessions.remove.push(concession);
                            for (var rc in _this5._ticketFlow.concessions.added) {
                                if (_this5._ticketFlow.concessions.added[rc].Id == concession.Id) {
                                    _this5._ticketFlow.concessions.added.splice(rc, 1);
                                    break;
                                }
                            }
                        });
                    } else {
                        if (this.Concessions[index].Quantity > Quantity) {
                            Promise.resolve(__WEBPACK_IMPORTED_MODULE_8__service_ecom_tracking_service__["a" /* default */].doDataLayerRemoveConcessionFromBasket(concession)).then(function (result) {
                                _this5._ticketFlow.concessions.remove.push(concession);
                                for (var rc in _this5._ticketFlow.concessions.added) {
                                    _this5.Concessions[index].Quantity = Quantity;
                                    if (_this5._ticketFlow.concessions.added[rc].Id == concession.Id) {
                                        _this5._ticketFlow.concessions.added.splice(rc, 1);
                                        break;
                                    }
                                }
                            });
                        } else {
                            Promise.resolve(__WEBPACK_IMPORTED_MODULE_8__service_ecom_tracking_service__["a" /* default */].doDataLayerAddConcessionToBasket(concession)).then(function (result) {
                                _this5._ticketFlow.concessions.added.push(concession);
                                _this5.Concessions[index].Quantity = Quantity;
                            });
                        }
                    }
                } else {
                    Promise.resolve(__WEBPACK_IMPORTED_MODULE_8__service_ecom_tracking_service__["a" /* default */].doDataLayerAddConcessionToBasket(concession)).then(function (result) {
                        _this5._ticketFlow.concessions.added.push(concession);
                        _this5.Concessions.push(new __WEBPACK_IMPORTED_MODULE_5__ConcessionItem__["a" /* default */]({
                            Id: concession.Id,
                            Quantity: Quantity,
                            Description: concession.Description,
                            PriceInCents: concession.PriceInCents,
                            RecognitionId: concession.RecognitionId,
                            RecognitionSequenceNumber: concession.RecognitionSequenceNumber
                        }));
                    });
                }
                concession.Quantity = Quantity;
            }
        }
    }, {
        key: 'asBookings',
        value: function asBookings() {
            if (this.Sessions) {
                for (var i = 0; i < this.Sessions.length; i++) {
                    var session = this.Sessions[i];
                }
            }
        }
    }, {
        key: 'loadSeatGrid',
        value: function loadSeatGrid() {
            var _this6 = this;

            this.seatGridLoaded = false;
            return this.Session ? this.Session.getSeatGrid().then(function (r) {
                _this6.seatGridLoaded = true;
                return r;
            }, function (e) {
                return Promise.reject(e);
            }) : Promise.reject("No Order");
        }
    }, {
        key: '_clearTracking',
        value: function _clearTracking() {
            this._ticketFlow = {
                tickets: { add: [], remove: [], added: [], added_as_loyalty: [] },
                loyalties: { add: [], remove: [], added: [] }
            };
        }
    }, {
        key: 'save',
        value: function save() {
            return __WEBPACK_IMPORTED_MODULE_7__service_order_service__["a" /* default */].saveOrder(this);
        }
    }, {
        key: 'toJSON',
        value: function toJSON() {
            return {
                CinemaId: this.CinemaId,
                SessionId: this.SessionId,
                Tickets: this.Tickets,
                UnassignedTickets: this.UnassignedTickets,
                Concessions: this.Concessions
            };
        }
    }, {
        key: 'loading',
        get: function get() {
            return this._loading || this.Session && this.Session._loadingGrid;
        }
    }, {
        key: 'ORDER_MODIFIED',
        get: function get() {
            return "ORDER_MODIFIED";
        }
    }, {
        key: 'ORDER_TICKET_MODIFIED',
        get: function get() {
            return "ORDER_TICKET_MODIFIED";
        }
    }, {
        key: 'ORDER_CONCESSION_MODIFIED',
        get: function get() {
            return "ORDER_CONCESSION_MODIFIED";
        }
    }, {
        key: 'hasTickets',
        get: function get() {
            return this.Tickets.length > 0 && this.Session.Tickets.length > 0;
        }
    }, {
        key: 'Session',
        get: function get() {
            var _this7 = this;

            return this.Sessions ? this.Sessions.find(function (s) {
                return s.SessionId === parseInt(_this7.SessionId);
            }) : {};
        }
    }, {
        key: 'Experiences',
        get: function get() {
            return this.Sessions ? this.Sessions.reduce(function (c, s) {
                c = c.concat(s.MovieSession.experiences);
                return c;
            }, []) : [];
        }
    }, {
        key: 'Genres',
        get: function get() {
            return this.Sessions ? this.Sessions.reduce(function (c, s) {
                c = c.concat(s.movie.genres);
                return c;
            }, []) : [];
        }
    }, {
        key: 'AllLoyalties',
        get: function get() {
            return this.getSessionLoyalties(this.Session);
        }
    }, {
        key: 'Tickets',
        get: function get() {
            var _this8 = this;

            var loyaltyIndex = {};

            var tickets = this.Session && this.Session.Tickets ? this.Session.Tickets.map(function (ticket) {
                if (ticket.Position) {
                    var tAreaCat = ticket.Position.AreaCategoryCode;
                    loyaltyIndex[tAreaCat] = loyaltyIndex[tAreaCat] === undefined ? 0 : loyaltyIndex[tAreaCat] + 1;
                    ticket.index = loyaltyIndex[tAreaCat];
                    var loyalty = _this8.AllLoyalties.length > 0 ? _this8.AllLoyalties.filter(function (l) {
                        return l.TicketType.AreaCategoryCode == tAreaCat;
                    })[loyaltyIndex[tAreaCat]] || undefined : undefined;

                    if (loyalty && loyalty.TicketType && (!ticket.Id || ticket.Description != loyalty.TicketType.Description)) {

                        var maskedTicket = Object.assign({}, ticket);

                        maskedTicket.PriceCents = !ticket.Id ? loyalty.TicketType.PriceInCents : maskedTicket.PriceCents;
                        if (loyalty.TicketType.IsPackageTicket) {
                            maskedTicket.PriceCents = loyalty.ApprovedPriceInCents;
                            maskedTicket.PriceInCents = loyalty.ApprovedPriceInCents;
                            ticket.PriceInCenters = loyalty.ApprovedPriceInCents;
                            ticket.PriceCents = loyalty.ApprovedPriceInCents;
                        }
                        maskedTicket.PackageTicket = loyalty.PackageTicket;
                        maskedTicket.TicketTypeCode = loyalty.TicketType.TicketTypeCode;
                        maskedTicket.Description = loyalty.TicketType.Description;
                        maskedTicket.ThirdPartyMemberScheme = { MemberCard: loyalty.CardNumber };
                        if (loyalty.Barcode) {
                            maskedTicket.Barcode = loyalty.Barcode;
                        }
                        if (loyalty.RecognitionID) {
                            maskedTicket.LoyaltyRecognitionId = loyalty.RecognitionID;
                            maskedTicket.LoyaltyRecognitionSequence = loyalty.SequenceNumber;
                        }
                        return maskedTicket;
                    }
                }
                return ticket;
            }) : [];
            return tickets;
        }
    }, {
        key: 'TicketTypes',
        get: function get() {
            return this.Session ? this.Session.TicketTypes : [];
        }
    }, {
        key: 'AllTickets',
        get: function get() {

            var Tickets = [];
            for (var i = 0; i < this.Sessions.length; i++) {
                var Session = this.Sessions[i];
                var AllLoyalties = this.getSessionLoyalties(Session);
                var loyaltyIndex = {};
                var formattedTickets = Session.Tickets.map(function (ticket) {
                    if (ticket.Position) {
                        var tAreaCat = ticket.Position.AreaCategoryCode;
                        loyaltyIndex[tAreaCat] = loyaltyIndex[tAreaCat] === undefined ? 0 : loyaltyIndex[tAreaCat] + 1;
                        ticket.index = loyaltyIndex[tAreaCat];
                        var loyalty = AllLoyalties.length > 0 ? AllLoyalties.filter(function (l) {
                            return l.TicketType.AreaCategoryCode == tAreaCat;
                        })[loyaltyIndex[tAreaCat]] || undefined : undefined;
                        if (loyalty && loyalty.TicketType && (!ticket.Id || ticket.Description != loyalty.TicketType.Description)) {
                            var maskedTicket = Object.assign({}, ticket);
                            maskedTicket.PriceCents = !ticket.Id ? loyalty.TicketType.PriceInCents : maskedTicket.PriceCents;
                            maskedTicket.PackageTicket = loyalty.PackageTicket;
                            maskedTicket.TicketTypeCode = loyalty.TicketType.TicketTypeCode;
                            maskedTicket.Description = loyalty.TicketType.Description;
                            maskedTicket.ThirdPartyMemberScheme = { MemberCard: loyalty.CardNumber };
                            if (loyalty.Barcode) {
                                maskedTicket.Barcode = loyalty.Barcode;
                            }
                            if (loyalty.RecognitionID) {
                                maskedTicket.LoyaltyRecognitionId = loyalty.RecognitionID;
                                maskedTicket.LoyaltyRecognitionSequence = loyalty.SequenceNumber;
                            }
                            return maskedTicket;
                        }
                    }
                    return ticket;
                });
                Tickets = Tickets.concat(formattedTickets);
            }
            return Tickets;
        }
    }, {
        key: 'UnassignedTickets',
        get: function get() {
            return this.Session ? this.Session.UnassignedTickets : [];
        }
    }, {
        key: 'SessionDate',
        get: function get() {
            if (this.Session) {
                return this.Session.ShowingRealDateTime;
            }
        }
    }, {
        key: 'SessionEndDate',
        get: function get() {
            if (this.SessionDate && this.Session.movie) {
                return new __WEBPACK_IMPORTED_MODULE_6__VistaDate__["a" /* default */](this.SessionDate.date.clone().add(this.Session.movie.runtime, 'minutes'));
            }
        }
    }, {
        key: 'totalInCents',
        get: function get() {

            var ticketTotal = this.AllTickets ? this.AllTickets.reduce(function (c, t) {
                return c += t.PriceCents;
            }, 0) : 0;
            var ConcessionTotal = this.Concessions ? this.Concessions.reduce(function (c, t) {
                return c += t.PriceInCents * t.Quantity;
            }, 0) : 0;

            return ticketTotal + ConcessionTotal;
        }
    }, {
        key: 'total',
        get: function get() {
            var ticketTotal = this.AllTickets ? this.AllTickets.reduce(function (c, t) {
                return c += t.PriceCents;
            }, 0) : 0;
            var ConcessionTotal = this.Concessions ? this.Concessions.reduce(function (c, t) {
                return c += t.PriceInCents * t.Quantity;
            }, 0) : 0;

            var priceFormatted = ((ticketTotal + ConcessionTotal) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            return 'R' + priceFormatted;
        }
    }, {
        key: 'TicketsForSeating',
        get: function get() {
            var tickets = [];
            if (this.Session && this.Session.Tickets) {
                for (var i = 0; i < this.Session.Tickets.length; i++) {
                    var ticket = this.Session.Tickets[i];

                    if (ticket.IsTicketPackage) {
                        if (ticket.PackageTickets) {
                            for (var p = 0; p < ticket.PackageTickets.length; p++) {
                                var p_ticket = ticket.PackageTickets[p];
                                if (ticket.Barcode !== null) {
                                    p_ticket.Barcode == ticket.Barcode;
                                    p_ticket.SelectedButNotChangeable = true;
                                }

                                tickets.push(p_ticket);
                            }
                        }
                    } else {
                        ticket.SelectedButNotChangeable = false;
                        tickets.push(ticket);
                    }
                }
            }
            var ticketTypes = this.TicketTypes;
            for (var t = 0; t < tickets.length; t++) {
                for (var k = 0; k < ticketTypes.length; k++) {
                    var ticketType = ticketTypes[k];
                    if (ticketType.TicketTypeCode == tickets[t].TicketTypeCode) {
                        if (ticketType.IsThirdPartyMemberTicket || ticketType.IsRedemptionTicket && tickets[t].SelectedButNotChangeable == false) {
                            tickets[t].SelectedButNotChangeable = true;
                        }
                    }
                }
            }

            return tickets;
        }
    }]);

    return Order;
}();

/* harmony default export */ __webpack_exports__["a"] = (Order);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_observable__ = __webpack_require__(64);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ObservableBaseModel = function (_Observable) {
    _inherits(ObservableBaseModel, _Observable);

    function ObservableBaseModel() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

        _classCallCheck(this, ObservableBaseModel);

        return _possibleConstructorReturn(this, (ObservableBaseModel.__proto__ || Object.getPrototypeOf(ObservableBaseModel)).call(this));
    }

    return ObservableBaseModel;
}(__WEBPACK_IMPORTED_MODULE_0__util_observable__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (ObservableBaseModel);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_BaseModel__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Collection__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VistaDate__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Ticket__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModelArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__service_movie_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__service_order_service__ = __webpack_require__(69);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Session = function (_BaseModel) {
    _inherits(Session, _BaseModel);

    function Session(data) {
        _classCallCheck(this, Session);

        var _this = _possibleConstructorReturn(this, (Session.__proto__ || Object.getPrototypeOf(Session)).call(this));

        _this.SessionId = data.SessionId;
        _this.CinemaId = data.CinemaId;
        _this.FilmTitle = data.FilmTitle;
        _this.ShowingRealDateTime = data.ShowingRealDateTime ? new __WEBPACK_IMPORTED_MODULE_2__VistaDate__["a" /* default */](data.ShowingRealDateTime) : data.ShowingRealDateTime;
        _this.Tickets = data.Tickets ? new __WEBPACK_IMPORTED_MODULE_4__ModelArray__["a" /* default */](data.Tickets, __WEBPACK_IMPORTED_MODULE_3__Ticket__["a" /* default */]) : [];
        _this.TicketTypes = data.TicketTypes;
        _this.UnassignedTickets = data.UnassignedTickets;
        _this.movie = undefined;
        _this.SeatGrid = [];
        _this.MoviePromise = __WEBPACK_IMPORTED_MODULE_5__service_movie_service__["a" /* default */].findBySessionId(_this.SessionId, _this.CinemaId).then(function (movie) {
            _this.movie = movie;
        });
        _this.SeatGridPromise = undefined;
        _this.Loyalties = data.Loyalties || [];
        _this._loadingGrid = false;

        if (_this.Loyalties) {
            try {
                var loyalties = JSON.parse(localStorage.getItem("loyalties")) || [];
                for (var i = 0; i < _this.Loyalties.length; i++) {
                    var loyalty = _this.Loyalties[i];
                    var localLoyalty = loyalties.find(function (l) {
                        return l.SessionId == _this.SessionId && l.TicketTypeCode == loyalty.TicketType.TicketTypeCode && !l.processed;
                    });
                    if (localLoyalty) {
                        Object.assign(loyalty, localLoyalty);
                        localLoyalty.processed = true;
                    }
                }
            } catch (e) {
                console.warn(e);
            }
            _this.Loyalties = data.Loyalties;
        }

        return _this;
    }

    _createClass(Session, [{
        key: 'getSeatGrid',
        value: function getSeatGrid() {
            var _this2 = this;

            this._loadingGrid = true;

            this.SeatGridPromise = this.SeatGridPromise || __WEBPACK_IMPORTED_MODULE_6__service_order_service__["a" /* default */].getSeatGrid(this.SessionId, this.CinemaId, this.Tickets);

            return this.SeatGridPromise.then(function (seatGrid) {
                _this2._loadingGrid = false;
                seatGrid.mapTicketsToGrid(_this2.Tickets);
                return _this2.SeatGrid = seatGrid;
            }, function (e) {
                _this2._loadingGrid = false;
                _this2.SeatGridPromise = undefined;
                _this2.SeatGrid = [];
                return Promise.reject(e);
            });
        }
    }, {
        key: 'loadingGrid',
        get: function get() {
            return this._loadingGrid;
        }
    }, {
        key: 'positions',
        get: function get() {
            return this.Tickets ? this.Tickets.reduce(function (c, t) {
                c[t.Position.RowIndex] = c[t.Position.RowIndex] || [];
                var seatId = !isNaN(t.SeatId) ? t.SeatId : Number(t.SeatNumber);
                c[t.Position.RowIndex].push(seatId);
                c[t.Position.RowIndex] = c[t.Position.RowIndex].sort();
                return c;
            }, {}) : {};
        }
    }, {
        key: 'MovieSession',
        get: function get() {
            var _this3 = this;

            return this.movie ? this.movie.cinemas[this.CinemaId].find(function (session) {
                return session.id == _this3.SessionId;
            }) : {};
        }
    }, {
        key: 'SessionDate',
        get: function get() {
            return this.ShowingRealDateTime;
        }
    }, {
        key: 'SessionEndDate',
        get: function get() {
            if (this.SessionDate && this.movie) {
                return new __WEBPACK_IMPORTED_MODULE_2__VistaDate__["a" /* default */](this.SessionDate.date.clone().add(this.movie.runtime, 'minutes'));
            }
        }
    }, {
        key: 'SeatString',
        get: function get() {

            var string = this.Tickets.reduce(function (arr, ticket) {
                arr[ticket.SeatRowId] = arr[ticket.SeatRowId] || { min: 10, max: 0 };
                arr[ticket.SeatRowId].min = arr[ticket.SeatRowId].min > ticket.SeatNumber ? ticket.SeatNumber : arr[ticket.SeatRowId].min;
                arr[ticket.SeatRowId].max = arr[ticket.SeatRowId].max < ticket.SeatNumber ? ticket.SeatNumber : arr[ticket.SeatRowId].max;
                arr[ticket.SeatRowId].key = ticket.SeatRowId;
                return arr;
            }, {});
            string = Object.keys(string).map(function (key) {
                var ticket = string[key];
                if (ticket.min == ticket.max) {
                    return '' + ticket.key + ticket.min;
                }
                return '' + ticket.key + ticket.min + ' - ' + ticket.key + ticket.max;
            }).join(',');

            return string;
        }
    }]);

    return Session;
}(__WEBPACK_IMPORTED_MODULE_0__model_BaseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Session);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collection__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_seat_grid_service__ = __webpack_require__(67);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var SeatGrid = function (_Collection) {
    _inherits(SeatGrid, _Collection);

    function SeatGrid(data) {
        _classCallCheck(this, SeatGrid);

        var _this = _possibleConstructorReturn(this, (SeatGrid.__proto__ || Object.getPrototypeOf(SeatGrid)).call(this, 'grid'));

        _this.grid = data || [];
        return _this;
    }

    _createClass(SeatGrid, [{
        key: 'mapTicketsToGrid',
        value: function mapTicketsToGrid(tickets) {
            for (var i = 0; i < this.grid.length; i++) {
                var row = this.grid[i];

                for (var j = 0; j < row.Seats.length; j++) {
                    var seatGroup = row.Seats[j];
                    seatGroup.selected = false;
                    seatGroup.ticket = undefined;
                    for (var k = 0; k < seatGroup.seats.length; k++) {
                        var seat = seatGroup.seats[k];
                        if (seat && seat.Id) {
                            var seatName = row.PhysicalName + seat.Id;
                            var ticket = tickets.find(function (ticket) {
                                return ticket.SeatData === seatName;
                            });
                            if (ticket) {
                                seatGroup.available = true;

                                ticket.Position = seat.Position;
                                seat.ticket = ticket;
                                seatGroup.ticket = ticket;
                                seatGroup.selected = true;
                                ticket.SeatRowId = row.PhysicalName;

                                if (ticket.SelectedButNotChangeable === true) {
                                    seat.selected_unavailable = true;
                                    seat.available = false;
                                    seatGroup.available = false;
                                    seatGroup.selected_unavailable = true;
                                } else {
                                    seat.selected_unavailable = false;
                                    seatGroup.selected_unavailable = false;
                                    seat.available = true;
                                    seatGroup.available = true;
                                }
                            } else {
                                seat.ticket = undefined;
                                seatGroup.ticket = undefined;
                                seatGroup.selected = false;
                            }
                        }
                    }
                }
            }
        }
    }]);

    return SeatGrid;
}(__WEBPACK_IMPORTED_MODULE_0__Collection__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SeatGrid);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var LoyaltyCardService = function () {
    function LoyaltyCardService() {
        _classCallCheck(this, LoyaltyCardService);

        this.cardResult = undefined;
        this.ticketTypes = undefined;
    }

    _createClass(LoyaltyCardService, [{
        key: 'validateCard',
        value: function validateCard(cinema_id, session_id, card) {
            var _this = this;

            if (card.type != 'voucher') {
                return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/cards/validate', {
                    SessionId: session_id,
                    CinemaId: cinema_id,
                    TicketTypeCode: card.type,
                    MemberCard: card.number,
                    Qty: 1
                }).then(function (result) {
                    return _this.cardResult = result;
                }, function (error) {
                    return _this.cardResult = undefined;
                });
            } else {
                return { success: true, data: [{ CardNumber: card.number, TicketTypeCode: card.type, error: undefined, name: "Voucher", ApprovedQty: 1, MemberProviderName: "Voucher" }] };
            }
        }
    }, {
        key: '_parseResult',
        value: function _parseResult(result) {}
    }, {
        key: 'fetchTicketTypes',
        value: function fetchTicketTypes(cinema_id, session_id) {
            var _this2 = this;

            return this.ticketTypes = this.ticketTypes || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/cards/ticket-types/" + cinema_id + "/" + session_id).then(function (result) {
                return _this2.ticketTypes = result;
            }, function (error) {
                _this2.ticketTypes = undefined;
                return Promise.reject(error);
            });
        }
    }, {
        key: 'activateVitalityCard',
        value: function activateVitalityCard(dateOfBirth, accountNumber, gender, name) {
            var _this3 = this;

            return this.activateCard = __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/cards/activate/vitality", { dateOfBirth: dateOfBirth, accountNumber: accountNumber, gender: gender, initial: name }).then(function (result) {
                return _this3.activateCard = result;
            }, function (error) {
                _this3.activateCard = undefined;
                return Promise.reject(error);
            });
        }
    }]);

    return LoyaltyCardService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new LoyaltyCardService());

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ErrorDescriptionService = function () {
	function ErrorDescriptionService() {
		_classCallCheck(this, ErrorDescriptionService);

		this.errors = [{ dialog: true, errorType: "ErrorException", errorCode: 0, errorDescription: "Unspecified error!" }, { dialog: true, errorType: "User", errorCode: 3, errorDescription: "Sorry! We're currently experiencing a few problems on our end. Please try signing in later." }, { dialog: true, errorType: "Cinema", errorCode: 5, errorDescription: "Looks like this cinema is currently unavailble! Please use your location to find the nearest cinema to you or try again later." }, { dialog: true, errorType: "Payment", errorCode: 12, errorDescription: "Payment Status: We’re sorry, but this payment could not be processed. Please contact your financial institution and try again or try a different card." }, { dialog: true, errorType: "VistaApiException", errorCode: 1002, errorDescription: "Looks like this email is already in use. <a href='/user/login'>Sign in</a> or <a href='/user/password-reset/email'>reset your password</a>." }, { dialog: true, errorType: "VistaApiException", errorCode: 1003, errorDescription: "Sorry! Looks like your membership details couldn't be found. Please double check you've entered the correct card number or call Customer Care on 0861 668 437 for further assistance." }, { dialog: true, errorType: "VistaApiException", errorCode: 1004, errorDescription: "Sorry! Looks like this movie can't be booked right now" }, { dialog: true, errorType: "FatalErrorException", errorCode: 1005, errorDescription: "Hmm, looks like the card number you've entered is invalid. Please double check you’ve entered the right number." }, { dialog: true, errorType: "VistaAuthenticationException", errorCode: 17, errorDescription: "Hmm, we can't seem to recognise you. Please double check your email and password are correct. If you've forgotten your password, <a href='/user/password-reset/email'>reset it now</a> and if you've forgotten your email address contact Customer Care on 0861 668 437 for further assistance." }, { dialog: true, errorType: "Payment", errorCode: 28, errorDescription: "Payment status: We're sorry, but this payment could not be processed. Please contact your financial institution and try again or use a different card." }, { dialog: true, errorType: "Payment", errorCode: 47, errorDescription: "Your booking session is about to expire! Please click continue to carry on." }, { dialog: true, errorType: "Payment", errorCode: 49, errorDescription: "Looks like your booking session has expired. Don't worry, it's easy to start again." }, { dialog: true, errorType: "Payment", errorCode: 554, errorDescription: "The Payment gateway could not be contacted, please try again." }, { dialog: true, errorType: "Voucher", errorCode: 60, errorDescription: "Sorry! This voucher has already been used." }, { dialog: false, errorType: "VistaAPIError", errorCode: 43, errorDescription: "This email already exists" }, { dialog: true, errorType: "VistaValidateError", errorCode: 5541, errorDescription: "Could not validate, please try again later." }];

		this.errorsByStringContains = [{ stringContains: "This member already exists in this club as member", error: this.errors[4] }, { stringContains: "Email address already in use", error: this.errors[4] }, { stringContains: "DB Exception", error: this.errors[15] }];
	}

	_createClass(ErrorDescriptionService, [{
		key: "getErrorFromCode",
		value: function getErrorFromCode(errorCode, errorType, error) {

			if (error.error && Array.isArray(error.error) && error.error.length > 0) {
				for (var i = 0; i < this.errorsByStringContains.length; i++) {
					var errorTest = this.errorsByStringContains[i];
					if (~error.error[0].indexOf(errorTest.stringContains)) {
						return errorTest.error;
					}
				}
			}

			for (var i = 0; i < this.errors.length; i++) {
				if (this.errors[i].errorCode == errorCode && this.errors[i].errorType == errorType) {
					return this.errors[i];
				}
			}
		}
	}]);

	return ErrorDescriptionService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new ErrorDescriptionService());

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var ContactUsService = function () {
    function ContactUsService() {
        _classCallCheck(this, ContactUsService);
    }

    _createClass(ContactUsService, [{
        key: "sendContactUs",
        value: function sendContactUs(formData) {
            if (formData) {
                return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/contact-us/send", { formData: formData }).then(function (result) {
                    return console.log(result);
                }, function (error) {
                    return Promise.reject(error);
                });
            }
        }
    }, {
        key: "sendWelcomeMailFan",
        value: function sendWelcomeMailFan(formData) {
            if (formData) {
                return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/welcome/fan", { formData: formData }).then(function (result) {
                    return console.log(result);
                }, function (error) {
                    return Promise.reject(error);
                });
            }
        }
    }, {
        key: "sendWelcomeMailMORvies",
        value: function sendWelcomeMailMORvies(formData) {
            if (formData) {
                return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/welcome/morvies", { formData: formData }).then(function (result) {
                    return console.log(result);
                }, function (error) {
                    return Promise.reject(error);
                });
            }
        }
    }]);

    return ContactUsService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new ContactUsService());

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_FilmVestival__ = __webpack_require__(232);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var FilmFestivalService = function () {
    function FilmFestivalService() {
        _classCallCheck(this, FilmFestivalService);

        this.filmfestivals = undefined;
        this.filmFestival = undefined;
    }

    _createClass(FilmFestivalService, [{
        key: 'getFilmFestivals',
        value: function getFilmFestivals() {
            var _this = this;

            return this.filmfestivals = this.filmfestivals || __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/film-festivals').then(function (response) {
                return response.data;
            }, function (error) {
                _this.filmfestivals = undefined;
                return Promise.reject(error);
            });
        }
    }, {
        key: 'getFilmFestivalById',
        value: function getFilmFestivalById(id) {
            var _this2 = this;

            return this.filmFestival = __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/film-festivals').then(function (response) {
                var FilmFestivals = response.data;

                for (var i = 0; i < FilmFestivals.length; i++) {
                    if (id == FilmFestivals[i].ID) {
                        _this2.filmFestival = FilmFestivals[i];
                    }
                }
                return new __WEBPACK_IMPORTED_MODULE_2__model_FilmVestival__["a" /* default */](_this2.filmFestival);
            }, function (error) {
                return Promise.reject(error);
            });
        }
    }]);

    return FilmFestivalService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new FilmFestivalService());

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var ErrorHandler = function () {
    function ErrorHandler() {
        _classCallCheck(this, ErrorHandler);

        this._ignoreError = false;
        this._ignoreSuccess = false;
    }

    _createClass(ErrorHandler, [{
        key: 'ignoreNextError',
        value: function ignoreNextError() {
            this._ignoreError = true;
        }
    }, {
        key: 'ignoreNextResponse',
        value: function ignoreNextResponse() {
            this._ignoreSuccess = true;
        }
    }, {
        key: 'ignoreNextRequest',
        value: function ignoreNextRequest() {
            this.ignoreNextError();
            this.ignoreNextResponse();
        }
    }, {
        key: 'handle',
        value: function handle(responseCallback, ErrorCallback) {
            var _this = this;

            var callbackError = function callbackError(e) {
                var canRun = !_this._ignoreError;
                _this._ignoreError = false;
                _this._ignoreSuccess = false;
                return Promise.reject(canRun ? ErrorCallback(e) : e);
            };

            var callbackSuccess = function callbackSuccess(r) {
                var canRun = !_this._ignoreSuccess;

                _this._ignoreError = false;
                _this._ignoreSuccess = false;

                return canRun ? responseCallback(r) : r;
            };

            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].interceptors.response.use(callbackSuccess, callbackError);
        }
    }]);

    return ErrorHandler;
}();

/* harmony default export */ __webpack_exports__["a"] = (new ErrorHandler());

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var AdumoService = function () {
    function AdumoService() {
        _classCallCheck(this, AdumoService);
    }

    _createClass(AdumoService, [{
        key: 'prepareSubscription',
        value: function prepareSubscription(user) {
            if (!user) throw Error('User no defined');
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/adumo/prepare', user);
        }
    }, {
        key: 'cancelSubscription',
        value: function cancelSubscription(id, UserSessionId) {
            if (!id) throw Error('member id is required');
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/content/subscription?type=cancelSub&vistaMemberID=' + id + '&VARIABLE4=' + UserSessionId);
        }
    }, {
        key: 'checkCancelSubscription',
        value: function checkCancelSubscription(id) {
            if (!id) throw Error('member id is required');
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/content/subscription?type=cancelSub&vistaMemberID=' + id + '&check=true');
        }
    }, {
        key: 'updateCardSubscription',
        value: function updateCardSubscription(id, card) {
            if (!card) throw Error('member card is required');
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/content/subscription?type=updateCard&vistaMemberID=' + id, card);
        }
    }, {
        key: 'updateCardSubscriptionTokens',
        value: function updateCardSubscriptionTokens(id) {
            if (!id) throw Error('member id is required');
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/content/subscription?type=updateTokens&vistaMemberID=' + id);
        }
    }]);

    return AdumoService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new AdumoService());

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "inject_foo"
    }
  }, [_vm._v(_vm._s(_vm.foo))]), _vm._v(" "), _c('sk-site-header', {
    ref: "site-header",
    staticClass: "no-print",
    on: {
      "change": _vm.resendActivation
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), _c('router-view', {
    staticClass: "main-view"
  }), _vm._v(" "), _c('sk-site-footer', {
    staticClass: "no-print"
  }), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleDialog),
      callback: function($$v) {
        _vm.toggleDialog = $$v
      },
      expression: "toggleDialog"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sysError)
    }
  }), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": 20
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.okay($event)
      }
    }
  }, [_vm._v("Ok")])], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.activationDialog),
      callback: function($$v) {
        _vm.activationDialog = $$v
      },
      expression: "activationDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.activationDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.activationDialog = false
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Activation Code Sent")]), _vm._v(" "), _c('p', [_vm._v("Please check your mail in order to activate your account.")]), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.activationDialog = false
      }
    }
  }, [_vm._v("Dismiss")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_nav__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer_nav__ = __webpack_require__(394);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = __WEBPACK_IMPORTED_MODULE_2__main_nav__["a" /* default */].concat(__WEBPACK_IMPORTED_MODULE_3__footer_nav__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'active',
  routes: routes.filter(function (r) {
    return r.path !== undefined;
  })
}));

/***/ }),
/* 479 */,
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(513),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_object_fit_images__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_object_fit_images___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_object_fit_images__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_meta_data_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_observe_visibility__ = __webpack_require__(512);













__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_observe_visibility__["a" /* default */]);

var ecomTrackedMovies = [];

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'home',

    mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_meta_data_js__["a" /* default */]],

    data: function data() {
        return {
            loading: true,
            previewMode: false,
            top: 0,

            featuredData: null,
            form_data: {
                count: 0,
                place_query: null,
                keyword: null,
                selected_cinema: null,
                genres: null,
                cinema_types: [],
                filter_group: {
                    genres: null,
                    cinema_types: null
                },
                dates: null,
                doInitialSearch: false
            },
            filter: {
                filter_group: {},
                keyword: null,
                place_query: null,
                selected_cinema: {
                    id: null,
                    latitude: null,
                    longitude: null,
                    name: null,
                    original_name: null
                },
                experiences: null,
                genres: null
            },

            movies: null,
            availableCinemas: [],
            activeMovie: null,
            movieSummary: null,
            bottomOffset: null,
            tabNowShowing: null,
            tabComingSoon: null,
            predictiveText: [],

            activeDialog: false,
            dialogData: null,
            selected_cinema_id: null,
            selected_experiences: [],
            selected_cinema: null,
            selected_dates: null,
            toastOptions: null,
            doSearch: true,
            skclubAlert: false,
            leftAd: null,
            rightAd: null,
            featureCarouselHeight: 0,
            user: null,
            showLoadMoreNowShowing: this.$breakpoints.xs ? true : false,
            showLoadMoreComingSoon: this.$breakpoints.xs ? true : false,
            loadMoreLimitNowShowing: 16,
            loadMoreLimitComingSoon: 16,
            loadMoreIncrement: 16,
            isVisible: false,
            scrollY: 0,
            visibleMovies: [],
            cinemasByRegion: [],
            cinemaTypes: [],
            movieGenres: [],
            filterOptions: null,
            searchResultCount: null,
            cinemasNearby: null,
            summary_data: {
                types: null,
                dates: null
            },
            summary_types: null,
            summary_dates: null,
            summary_cinema_slug: null,
            onNouveau: false,
            regions: {},
            cinemaTypeGroups: [],
            movieMeta: null,
            lastAvailableDate: null,
            type_groups: null,
            result_cinemas: null,
            countNS: 0,
            countCS: 0,
            currentTimeStamp: null,
            foo: "no",
            injected_movies: "{data:'none'}",
            injected_meta: "{data:'none'}",
            injected_regions: "{data:'none'}",
            injected_cinemas: "{data:'none'}",
            prerender: false,
            googleAds:  true ? {
                classic: {
                    left: '/40862963/SK-HomeP-Wallpaper-Right',
                    right: '/40862963/SK-HomeP-Wallpaper-Left',
                    top: '/40862963/SK-HomeP-320x50',
                    topLg: '/40862963/SK-HomeP-728x90'
                },
                nouveau: {
                    left: '/40862963/SK-EventsAndExperiences-Nouveau-Wallpaper-Left',
                    right: '/40862963/SK-EventsAndExperiences-Nouveau-Wallpaper-Right',
                    top: '/40862963/SK-EventsAndExperiences-Nouveau-320x50',
                    topLg: '/40862963/SK-EventsAndExperiences-Nouveau-728x90'
                }
            } : {
                classic: {
                    left: '/40862963/SK-HomeP-Wallpaper-Right',
                    right: '/40862963/SK-HomeP-Wallpaper-Left',
                    top: '/40862963/SK-HomeP-320x50',
                    topLg: '/40862963/SK-HomeP-728x90'
                },
                nouveau: {
                    left: '/40862963/SK-EventsAndExperiences-Nouveau-Wallpaper-Left',
                    right: '/40862963/SK-EventsAndExperiences-Nouveau-Wallpaper-Right',
                    top: '/40862963/SK-EventsAndExperiences-Nouveau-320x50',
                    topLg: '/40862963/SK-EventsAndExperiences-Nouveau-728x90'
                }
            }
        };
    },


    methods: {
        visibilityChanged: function visibilityChanged(isVisible, entry, movie) {
            if (isVisible && !ecomTrackedMovies.includes(movie.id)) {
                var position = 0;
                if (this.tabNowShowing && !movie.coming_soon) {
                    for (var n in this.movies.now_showing) {
                        if (movie.id == this.movies.now_showing[n]) {
                            position = n + 1;
                        }
                    }
                }

                if (this.tabComingSoon && movie.coming_soon) {
                    for (var _n in this.movies.coming_soon) {
                        if (movie.id == this.movies.coming_soon[_n]) {
                            position = _n + 1;
                        }
                    }
                }

                __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["d" /* EcomTrackingService */].doDataLayerImpression(movie, position);
                ecomTrackedMovies.push(movie.id);
            }
        },
        showMovieDetail: function showMovieDetail(movie, clickedThumb) {
            var url = "/details/";
            url += movie.id;

            if (this.$route.params.cinema_name != undefined) {
                url += "/cinema/" + this.$route.params.cinema_name;
            }

            if (this.$route.params.cinema_type) {
                url += "/types/" + this.$route.params.cinema_type;
            }

            if (this.$route.params.dates) {
                url += "/date/" + this.$route.params.dates;
            }

            url += "/" + movie.title_slug;

            location.href = url;
        },
        openVideoDialog: function openVideoDialog(feature) {
            this.activeDialog = true;
            this.dialogData = feature;
        },
        checkNouveauGenres: function checkNouveauGenres(form_data, url) {
            var goToClassic = false;
            var goToNouveau = false;
            var hasNouveau = false;
            if (this.onNouveau) {
                if (form_data.cinema_types == undefined || form_data.cinema_types == null) {
                    goToClassic = true;
                } else {
                    if (form_data.cinema_types.length == 0) {
                        goToClassic = true;
                    } else {

                        for (var g in form_data.cinema_types) {
                            if (form_data.cinema_types[g].name == "Nouveau") {
                                hasNouveau = true;
                                goToClassic = true;
                            }
                        }
                    }
                }

                if (goToClassic && !hasNouveau) {
                    window.location.href = url;
                }
            } else {
                if (form_data.cinema_types == undefined || form_data.cinema_types == null) {
                    goToNouveau = false;
                } else {
                    if (form_data.cinema_types.length == 0) {
                        goToNouveau = false;
                    } else {

                        for (var _g in form_data.cinema_types) {
                            if (form_data.cinema_types[_g].name == "Nouveau" && !this.onNouveau) {
                                hasNouveau = true;
                                goToNouveau = true;
                            }
                        }
                    }
                }

                if (goToNouveau && hasNouveau && !this.onNouveau) {
                    window.location.href = url;
                }
            }
        },
        getFilteredMovies: function getFilteredMovies(filter) {
            var _this = this;

            var criteria = {
                cinema_id: false,
                types: false,
                genres: false,
                dates: false,
                title: false
            };

            if (this.form_data.selected_cinema != undefined && this.form_data.selected_cinema.id > 0) {
                criteria.cinema_id = this.form_data.selected_cinema.id;
            }
            var url = this.setUrlFromFilter(this.form_data);
            var checkNouveauGenres = this.checkNouveauGenres(this.form_data, url);

            var types = this.filterTypes(this.form_data.cinema_types);
            var genres = this.filterGenres(this.form_data.genres);
            var dates = this.filterDates(this.form_data.dates);

            criteria.types = types;
            criteria.genres = genres;
            criteria.dates = dates;
            criteria.title = this.form_data.keyword;

            var anyCriteriaApplied = criteria.types || criteria.genres || criteria.dates || criteria.title;

            __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["j" /* MovieService */].filter(criteria).then(function (result) {
                if (result) {
                    _this.filterResult = result;

                    if (result.types && !criteria.types && (criteria.cinema_id || criteria.genres || criteria.dates || criteria.title)) {
                        _this.setTypeOptions(_this.type_groups, result.types);
                    } else {
                        _this.setTypeOptions(_this.type_groups, null);
                    }

                    if (result.cinemas && result.cinemas.length > 0 && (criteria.cinema_id || criteria.types) && anyCriteriaApplied) {
                        _this.result_cinemas = result.cinemas;

                        _this.setCinemasByRegion(_this.regions, result.cinemas);
                    } else {
                        _this.setCinemasByRegion(_this.regions, null);
                    }

                    if (result.genres) {
                        if (_this.movieMeta != undefined && _this.movieMeta != null && !criteria.genres && (criteria.cinema_id || criteria.genres || criteria.dates || criteria.types)) {
                            _this.setGenreOptions(_this.movieMeta.genres, result.genres);
                        } else {
                            _this.setGenreOptions(_this.movieMeta.genres, null);
                        }
                    }

                    if (result.movies) {
                        _this.searchResultCount = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(result.movies).length;
                        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["j" /* MovieService */].moviesByRelease(result.movies)).then(function (movies) {
                            _this.movies = movies;
                            _this.countNS = 0;
                            _this.countCS = 0;
                            for (var ns in _this.movies.now_showing) {
                                if (_this.movies.now_showing[ns] != null && _this.movies.now_showing[ns] != undefined && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_this.movies.now_showing[ns]) == "object") {
                                    _this.countNS++;
                                }
                            }

                            for (var _ns in _this.movies.coming_soon) {
                                if (_this.movies.coming_soon[_ns] != null && _this.movies.coming_soon[_ns] != undefined && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_this.movies.coming_soon[_ns]) == "object") {
                                    _this.countCS++;
                                }
                            }
                            _this.activeMovie = null;
                        });
                    }
                }
            });
        },
        filterTypes: function filterTypes(selected_types) {
            var types = {};
            for (var st in selected_types) {
                for (var t in selected_types[st].types) {
                    if (selected_types[st].types[t] != undefined) {
                        if (selected_types[st].types[t].name != undefined && selected_types[st].types[t].name != null) {
                            var type = selected_types[st].types[t].name.trim();
                            types[type] = type;
                        }
                    }
                }
            }

            if (!__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(types).length > 0) {
                types = false;
            }

            return types;
        },
        filterGenres: function filterGenres(selected_genres) {
            var genres = {};
            for (var g in selected_genres) {
                if (selected_genres[g] != undefined && selected_genres[g] != null) {
                    if (selected_genres[g].id != undefined && selected_genres[g].id != null) {
                        var genre = selected_genres[g].id;
                        genres[genre] = genre;
                    }
                }
            }
            if (!__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(genres).length) {
                genres = null;
            }

            return genres;
        },
        filterDates: function filterDates(selected_dates) {
            if (selected_dates) {
                return __WEBPACK_IMPORTED_MODULE_9_moment___default()(selected_dates).format('YYYY-MM-DD').toString();
            } else {
                return null;
            }
        },
        scrollDown: function scrollDown() {
            window.scroll({ top: this.$refs.search_filter.$el.offsetTop / 1.2, left: 0, behavior: 'smooth' });
        },
        showAlerts: function showAlerts() {
            if (window.scrollY > document.body.offsetHeight / 3) {
                var currentDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('YYYYMMDD');
                var newDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(currentDate).add('1', 'month');
                if (localStorage.getItem('skclubAlert') == null) {
                    this.skclubAlert = true;
                    localStorage.setItem('skclubAlert', newDate);
                }
            }
        },
        setVisibleTab: function setVisibleTab(clickedTab) {
            this.activeMovie = null;

            var tabToggledState = this.$route.path.match(/^(\/coming-soon)|(\/now-showing)/);
            var newPath = this.$route.path;

            if (clickedTab === 'coming-soon') {
                this.tabNowShowing = false;
                this.tabComingSoon = true;
                newPath = tabToggledState ? this.$route.path.replace('now-showing', 'coming-soon') : '/coming-soon' + this.$route.path;
            } else {
                this.tabNowShowing = true;
                this.tabComingSoon = false;
                newPath = tabToggledState ? this.$route.path.replace('coming-soon', 'now-showing') : '/now-showing' + this.$route.path;
            }
            this.$router.push(newPath);
        },
        setCinemasByRegion: function setCinemasByRegion(raw_regions) {
            var _this2 = this;

            var filter_cinemas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var allowedRegions = [];

            if (raw_regions && raw_regions != null && raw_regions != undefined && !this.allowedRegions) {

                if ((typeof raw_regions === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(raw_regions)) == "object" && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(raw_regions).length) {

                    allowedRegions = raw_regions.map(function (r) {
                        var cinemas = r.cinemas.filter(function (c) {
                            return ~_this2.availableCinemas.indexOf(c.id.toString()) || _this2.availableCinemas.length == 0;
                        });
                        return {
                            id: r.id,
                            name: r.name,
                            cinemas: cinemas
                        };
                    }).filter(function (r) {
                        return r.cinemas.length > 0;
                    });
                }
            }

            var regions = [];
            if (filter_cinemas != null) {
                if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(filter_cinemas).length > 0) {
                    var sorted_filter_cineams = null;
                    var sorted_regions = null;
                    filter_cinemas = __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["j" /* MovieService */].filterCinemasToRegionModel(filter_cinemas, allowedRegions);
                    sorted_filter_cineams = __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["j" /* MovieService */].sortfilteredCinemasByDistance(filter_cinemas);
                    sorted_regions = __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["j" /* MovieService */].sortRegionsByDistance(allowedRegions);
                    if (sorted_filter_cineams != null && sorted_filter_cineams != undefined) {
                        regions = [{ name: 'Cinemas', cinemas: sorted_filter_cineams }];
                    }

                    if (this.cinemasNearby != null) {
                        regions = [{ name: 'Cinemas Nearby', cinemas: this.cinemasNearby }].concat(regions);
                    }
                }
            } else {
                regions = allowedRegions;
                if (this.cinemasNearby != null) {
                    regions = [{ name: 'Cinemas Nearby', cinemas: this.cinemasNearby }].concat(regions);
                }
            }

            this.cinemasByRegion = regions;
        },
        setTypeGroups: function setTypeGroups(types) {
            var _this3 = this;

            if (types && types != undefined && types != null) {
                if (this.type_groups == null) {
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["j" /* MovieService */].generateExperienceGroups(types)).then(function (groups) {
                        _this3.type_groups = groups;
                        return groups;
                    });
                } else {
                    return this.type_groups;
                }
            }
        },
        setTypeOptions: function setTypeOptions(types, filter_types) {
            var _this4 = this;

            if (types && types != undefined && types != null) {
                __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(this.setTypeGroups(types)).then(function (type_groups) {
                    if (_this4.type_groups != null) {
                        var typeData = {};
                        if (_this4.type_groups && _this4.type_groups != undefined && _this4.type_groups != null) {
                            typeData = [{ label: 'Cinema Types', items: type_groups }];

                            if (filter_types) {
                                __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["j" /* MovieService */].filterExperienceGroups(_this4.type_groups, filter_types)).then(function (groups) {
                                    if (groups.available != null && groups.available != undefined) {
                                        typeData = [{ label: 'Cinema Types', items: groups.available }];
                                    } else {
                                        typeData = [{ label: 'Cinema Types', items: groups.other }];
                                    }

                                    _this4.cinemaTypes = typeData;
                                });
                            } else {
                                _this4.cinemaTypes = typeData;
                            }
                        }
                    }
                });
            }
        },
        setGenreOptions: function setGenreOptions(genres, filter_genres) {
            var genreData = {};

            var availableGenres = [];
            var otherGenres = [];

            if (genres && genres != undefined && genres != null) {
                if (filter_genres && filter_genres != null && filter_genres != undefined) {
                    for (var fg in filter_genres) {
                        for (var g in genres) {
                            if (genres[g] != undefined && genres[g] != null) {
                                if (filter_genres[genres[g].id] != null && filter_genres[genres[g].id] != undefined) {
                                    var exists = false;

                                    for (var ag in availableGenres) {
                                        if (availableGenres[ag] != undefined && availableGenres[ag] != null) {
                                            if (availableGenres[ag].id == genres[g].id) {
                                                exists = true;
                                            }
                                        }
                                    }

                                    if (!exists) {
                                        availableGenres.push(genres[g]);
                                    }
                                }
                            }
                        }
                    }

                    for (var _g2 in genres) {
                        var inAvailable = false;
                        if (genres[_g2] != undefined && genres[_g2] != null) {
                            for (var _ag in availableGenres) {
                                if (availableGenres[_ag] != undefined && availableGenres[_ag] != null) {
                                    if (availableGenres[_ag].id == genres[_g2].id) {
                                        inAvailable = true;
                                    }
                                }
                            }
                        }

                        if (!inAvailable) {
                            var _exists = false;
                            for (var og in otherGenres) {
                                if (otherGenres[og] != undefined && otherGenres[og] != null) {
                                    if (otherGenres[og].id == genres[_g2].id) {
                                        _exists = true;
                                    }
                                }
                            }

                            if (!_exists) {
                                otherGenres.push(genres[_g2]);
                            }
                        }
                    }
                    if (availableGenres != null && availableGenres != undefined) {
                        genreData = [{ label: "Genres", items: availableGenres }];
                    } else {
                        genreData = [{ label: "Genres", items: otherGenres }];
                    }
                } else {
                    genreData = [{ label: 'Genres', items: genres }];
                }
            }

            this.movieGenres = genreData;
        },
        setUrlFromFilter: function setUrlFromFilter(criteria) {
            var url = "";

            if (this.$route.matched.length >= 1) {
                url = this.$route.matched[0].path;
            }

            if (criteria && criteria != undefined && criteria != null) {

                if (criteria.selected_cinema != undefined && criteria.selected_cinema != null) {
                    if (criteria.selected_cinema.slug != undefined && criteria.selected_cinema.slug != null) {
                        url = url + "/cinema/" + criteria.selected_cinema.slug;
                        this.summary_cinema_slug = this.form_data.selected_cinema.slug;
                    }
                }

                if (criteria.cinema_types != undefined && criteria.cinema_types != null) {
                    if (criteria.cinema_types.length > 0) {
                        var types = criteria.cinema_types;
                        var typeDict = [];
                        for (var t in types) {
                            if (types[t] != undefined && types[t] != null) {
                                typeDict.push(types[t].name);
                            }
                        }

                        if (typeDict.length > 0) {
                            var type_string = typeDict.join();

                            url = url + "/type/" + type_string;
                            this.summary_types = type_string;
                        }
                    }
                }

                if (criteria.genres && criteria.genres != undefined && criteria.genres != null) {
                    if (criteria.genres.length > 0) {
                        var genres = criteria.genres;
                        var genreDict = [];

                        for (var g in genres) {
                            if (genres[g] != undefined && genres[g] != null) {
                                genreDict.push(genres[g].name);
                            }
                        }

                        if (genreDict.length > 0) {
                            var genre_string = genreDict.join();
                            url = url + "/genres/" + genre_string;
                        }
                    }
                }

                if (criteria.dates && criteria.dates != undefined && criteria.dates != null) {
                    if (criteria.dates) {
                        url = url + "/dates/" + __WEBPACK_IMPORTED_MODULE_9_moment___default()(criteria.dates).format('D-MM-YYYY');
                        this.summary_dates = __WEBPACK_IMPORTED_MODULE_9_moment___default()(criteria.dates).format('D-MM-YYYY');
                    }
                }
            }

            if (url.length == 0) {
                url = this.$route.matched[0].path;
            }
            window.history.pushState({}, null, url);
            this.$router.push(url);
            return url;
        },
        setFormDataFromRoute: function setFormDataFromRoute() {
            var _this5 = this;

            var route_params_set = false;
            if (this.$route.params.cinema_name && this.$route.params.cinema_name != undefined && this.$route.params.cinema_name != null) {
                var cinema_slug = this.$route.params.cinema_name;
                __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getCinemaBySlug(cinema_slug)).then(function (cinema) {
                    if (cinema != undefined && cinema != null) {
                        _this5.form_data.selected_cinema = cinema;
                        route_params_set = true;
                    }
                });
            }

            if (this.$route.params.cinema_type && this.$route.params.cinema_type != undefined && this.$route.params.cinema_type != null) {
                var route_types = this.$route.params.cinema_type.split(",");

                if (this.type_groups && this.type_groups != undefined && this.type_groups != null) {
                    var type_groups = this.type_groups;

                    var selected_types = [];

                    for (var tg in type_groups) {
                        if (type_groups[tg] != undefined && type_groups[tg] != null) {
                            for (var rt in route_types) {
                                if (route_types[rt] && route_types[rt] != undefined && route_types[rt] != null) {
                                    if (route_types[rt] == type_groups[tg].name) {
                                        selected_types.push(type_groups[tg]);
                                    }
                                }
                            }
                        }
                    }
                    if (selected_types.length > 0) {
                        this.form_data.cinema_types = selected_types;
                    }
                }
            }

            if (this.$route.params.genres && this.$route.params.genres != undefined && this.$route.params.genres != null) {
                var route_genres = this.$route.params.genres.split(",");

                if (this.movieMeta && this.movieMeta != undefined && this.movieMeta != null) {
                    if (this.movieMeta.genres && this.movieMeta.genres != undefined && this.movieMeta.genres != null) {
                        var genres = this.movieMeta.genres;
                        var selected_genres = [];

                        for (var g in genres) {
                            if (genres[g] != undefined && genres[g] != null) {
                                for (var rg in route_genres) {
                                    if (route_genres[rg] != undefined && route_genres[rg] != null) {
                                        if (route_genres[rg] == genres[g].name) {
                                            selected_genres.push(genres[g]);
                                        }
                                    }
                                }
                            }
                        }

                        if (selected_genres.length > 0) {
                            this.form_data.genres = selected_genres;
                        }
                    }
                }
            }

            if (this.$route.params.dates && this.$route.params.dates != undefined && this.$route.params.dates != null) {
                var newDate = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$route.params.dates));

                this.form_data.dates = new Date(__WEBPACK_IMPORTED_MODULE_9_moment___default()(newDate, 'D-MM-YYYY').format('D MMMM YYYY').toString());
            }

            return route_params_set;
        },
        doLoadMoreNowShowing: function doLoadMoreNowShowing(totalLength) {
            this.loadMoreLimitNowShowing = this.loadMoreLimitNowShowing + this.loadMoreIncrement;

            if (this.loadMoreLimitNowShowing >= totalLength) {
                this.showLoadMoreNowShowing = false;
            }
        },
        doLoadMoreComingSoon: function doLoadMoreComingSoon(totalLength) {
            this.showLoadMoreComingSoon = false;
            this.loadMoreLimitComingSoon = this.loadMoreLimitComingSoon + this.loadMoreIncrement;

            if (this.loadMoreLimitComingSoon >= totalLength) {
                this.showLoadMoreComingSoon = false;
            }
        },
        doDataLayerImpressions: function doDataLayerImpressions(movie, position) {
            __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["d" /* EcomTrackingService */].doDataLayerImpressionsOnScroll(movie, position);
        },
        setGoogleAdPosition: function setGoogleAdPosition(scrollPos) {
            if (!this.$refs.googleAdLeft || !this.$refs.googleAdRight) return;

            var headerHeight = 80;
            var padding = 20;
            var carouselHeight = this.$refs.featureCarousel ? this.$refs.featureCarousel.$el.offsetHeight : 0;
            var leftAd = this.$refs.googleAdLeft.$el;
            var rightAd = this.$refs.googleAdRight.$el;

            var top = Math.max(scrollPos + headerHeight + padding, carouselHeight + headerHeight);
            leftAd.setAttribute('style', 'left: -' + (leftAd.offsetWidth + 20) + 'px; top: ' + top + 'px');
            rightAd.setAttribute('style', 'right: -' + (rightAd.offsetWidth + 20) + 'px; top: ' + top + 'px');
        },
        onPageScrolled: function onPageScrolled(scrollPos, direction) {
            this.setGoogleAdPosition(scrollPos);
        },
        onResize: function onResize(e) {
            this.setGoogleAdPosition(window.scrollY || window.pageYOffset);
        },
        setCinemaOptions: function setCinemaOptions(cinemasByRegion) {
            this.cinemasByRegion = cinemasByRegion;
        },
        setCinemaTypeOptions: function setCinemaTypeOptions(CinemaTypeOptions) {
            this.cinemaTypes = CinemaTypeOptions;
        },
        setFilterOptions: function setFilterOptions(filterOptions) {
            this.filterOptions = filterOptions;
        },
        setCinemasNearby: function setCinemasNearby(cinemasNearby) {
            this.cinemasNearby = cinemasNearby;
            this.setCinemasByRegion(this.regions, this.result_cinemas);
        },
        summaryOptions: function summaryOptions(summary_data) {
            this.summary_data = summary_data;
            this.summary_types = summary_data.types;
            this.summary_dates = summary_data.dates;
            if (this.form_data.selected_cinema) {
                this.summary_cinema_slug = this.form_data.selected_cinema.slug;
            }
        },
        setLoading: function setLoading(loading) {
            this.loading = loading;
        },
        setCinemaTypeGroups: function setCinemaTypeGroups(cinemaTypeGroups) {
            this.cinemaTypeGroups = cinemaTypeGroups;
        },
        adsrvrPixel: function adsrvrPixel() {
            ttd_dom_ready(function () {
                if (typeof TTDUniversalPixelApi === 'function') {
                    var universalPixelApi = new TTDUniversalPixelApi();
                    universalPixelApi.init("mxyqca6", ["ytaat3z"], "https://insight.adsrvr.org/track/up");
                }
            });
        }
    },

    computed: {
        expireDate: function expireDate() {
            return localStorage.getItem('skclubAlert') ? localStorage.getItem('skclubAlert') : null;
        },
        isNouveau: function isNouveau() {
            if (this.form_data.cinemas_types != undefined && this.form_data.cinema_types != null) {
                if (this.form_data.cinema_types.length == 1) {
                    if (this.form_data.cinema_types[0].name == "Nouveau") {
                        this.$root.$el.classList.add('nouveau');
                        return true;
                    } else {
                        this.$root.$el.classList.remove('nouveau');
                    }
                } else {
                    this.$root.$el.classList.remove('nouveau');
                }
            } else {
                this.$root.$el.classList.remove('nouveau');
            }
            var isNouveau = this.$route.path.includes('type') && this.$route.path.includes('Nouveau');
            return isNouveau;
        },
        googleAdType: function googleAdType() {
            return this.isNouveau ? 'nouveau' : 'classic';
        }
    },

    created: function created() {
        var _this6 = this;

        this.previewMode = __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].hasPreviewContent();

        if (this.isNouveau) {
            this.onNouveau = true;
        }

        this.adsrvrPixel();

        __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["k" /* OrderService */].tearDown();

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovies(this.$route.query.noCache || false), __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["i" /* MovieMetaService */].getFeaturedContent(this.$route.query.noCache || false), __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getRegions(), __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["i" /* MovieMetaService */].getMovieMeta()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 4),
                movies = _ref2[0],
                featured = _ref2[1],
                regions = _ref2[2],
                meta = _ref2[3];

            _this6.featuredData = __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].addPreviewToContentArrayIfAvailable('featured_content', featured);
            var now = new Date().getTime();

            _this6.currentTimeStamp = now / 1000;

            __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user()).then(function (user) {
                _this6.user = user;
            });

            _this6.regions = regions.data;
            if (regions.data != undefined && regions.data != null) {
                _this6.setCinemasByRegion(_this6.regions);
            }

            _this6.movieMeta = meta;
            _this6.lastAvailableDate = meta.last_available_date;
            if (meta != undefined && meta != null && meta.experiences != undefined && meta.experiences != null && meta.genres != undefined && meta.genres != null) {
                __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([_this6.setTypeOptions(meta.experiences), _this6.setGenreOptions(meta.genres)]).then(function (_ref3) {
                    var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                        types = _ref4[0],
                        genres = _ref4[1];

                    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(_this6.setFormDataFromRoute()).then(function (route_params) {});
                });
            }

            _this6.movies = movies.byRelease();
            for (var ns in _this6.movies.now_showing) {
                if (_this6.movies.now_showing[ns] != null && _this6.movies.now_showing[ns] != undefined && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_this6.movies.now_showing[ns]) == "object") {
                    _this6.countNS++;
                }
            }

            for (var _ns2 in _this6.movies.coming_soon) {
                if (_this6.movies.coming_soon[_ns2] != null && _this6.movies.coming_soon[_ns2] != undefined && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_this6.movies.coming_soon[_ns2]) == "object") {
                    _this6.countCS++;
                }
            }

            _this6.predictiveText = movies.getNames();

            _this6.tabNowShowing = _this6.$route.path.match(/^\/(coming-soon)/g) ? false : true;
            _this6.tabComingSoon = _this6.$route.path.match(/^\/(coming-soon)/g) ? true : false;
            _this6.availableCinemas = movies.getCinemaIds();

            if (_this6.user != null && _this6.user != undefined) {
                if (_this6.user.MemberLevelId != undefined) {
                    if (!_this6.$breakpoints.xs && _this6.user.MemberLevelId == '19') {
                        var todaysDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('YYYYMMDD');
                        if (_this6.expireDate == null) {
                            document.addEventListener('scroll', _this6.showAlerts, false);
                        } else if (__WEBPACK_IMPORTED_MODULE_9_moment___default()(todaysDate).isAfter(_this6.expireDate)) {
                            localStorage.removeItem('skclubAlert');
                            document.addEventListener('scroll', _this6.showAlerts, false);
                        } else {
                            document.removeEventListener('scroll', _this6.showAlerts);
                        }
                    }
                }
            }

            __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].nextTick(function () {
                return _this6.setGoogleAdPosition(window.scrollY || window.pageYOffset);
            });
        });
        if (this.$route.path.includes('/type') && this.$route.path.includes("Nouveau") || this.isNouveau) {
            this.metaTitle = 'Cinema Nouveau Movies | Dedicated Art Cinema';
            this.metaDescription = 'Nouveau is a division of Ster-Kinekor Theatres and holds the prestige of being one of the world’s only dedicated "art cinema" chains, screening independent, alternative and art cinema content from cultures across the globe. Book your tickets today!';
            this.metaImage = '/static/img/nouveau-logo.png';
        } else {
            this.metaTitle = 'Cinema | Movie Showtimes and Online Movie Ticket Bookings';
            this.metaDescription = 'South Africa\'s biggest movie exhibitor. Browse the latest movies, trailers and showtimes. Book your movie tickets online today!';
            this.metaImage = '/static/img/sk-logo.png';
        }
        this.schemaDataSrc = {
            '@context': 'http://schema.org',
            '@type': 'Organization',
            'name': 'Ster-Kinekor',
            'logo': 'https://www.sterkinekor.com/​static/img/sk-logo.png',
            'url': "https://www.sterkinekor.com",
            'sameAs': ['​https://twitter.com/sterkinekor', '​https://www.facebook.com/sterkinekortheatres', '​https://www.instagram.com/sterkinekor/', '​https://www.youtube.com/user/SterKinekorTheatres']
        };
        this.loading = false;
    },
    beforeDestroy: function beforeDestroy() {
        document.removeEventListener('scroll', this.showAlerts);
        window.removeEventListener('resize', this.onResize);
    },
    mounted: function mounted() {
        var _this7 = this;

        if (window.__PRERENDER_INJECTED) {
            this.loading = false;
            this.prerender = true;

            if (window.__PRERENDER_INJECTED.movies) {
                var _injected_movies = __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["j" /* MovieService */].setPreRenderMovies(window.__PRERENDER_INJECTED.movies);
                var _movies = _injected_movies;
                this.injected_movies = _injected_movies.byRelease();
                this.movies = _injected_movies.byRelease();

                for (var ns in this.movies.now_showing) {
                    if (this.movies.now_showing[ns] != null && this.movies.now_showing[ns] != undefined && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.movies.now_showing[ns]) == "object") {
                        this.countNS++;
                    }
                }

                for (var _ns3 in this.movies.coming_soon) {
                    if (this.movies.coming_soon[_ns3] != null && this.movies.coming_soon[_ns3] != undefined && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.movies.coming_soon[_ns3]) == "object") {
                        this.countCS++;
                    }
                }
            } else {
                injected_movies = undefined;
                this.injected_movies = injected_movies;
            }

            if (window.__PRERENDER_INJECTED.regions) {
                var _injected_regions = __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["n" /* RegionService */].setPreRenderRegions(window.__PRERENDER_INJECTED.regions);
                this.injected_regions = _injected_regions;
                this.regions = _injected_regions.data;
                if (this.regions != undefined && this.regions != null) {
                    this.setCinemasByRegion(this.regions);
                }
            } else {
                injected_regions = undefined;
            }

            if (window.__PRERENDER_INJECTED.cinemas) {
                var _injected_cinemas = __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["n" /* RegionService */].setPreRenderRegionsDictionary(window.__PRERENDER_INJECTED.cinemas);
                this.injected_cinemas = window.__PRERENDER_INJECTED.cinemas;
            } else {
                injected_cinemas = undefined;
            }

            if (window.__PRERENDER_INJECTED.meta) {
                var _injected_meta = __WEBPACK_IMPORTED_MODULE_7_hasta_la_vista_middleware_api_service__["i" /* MovieMetaService */].setPreRenderMovieMeta(window.__PRERENDER_INJECTED.meta);
                this.injected_meta = _injected_meta;

                var meta = _injected_meta;
                var featured = meta.featured_content;
                this.featuredData = featured;

                this.movieMeta = meta;
                this.lastAvailableDate = meta.last_available_date;

                if (meta != undefined && meta != null && meta.experiences != undefined && meta.experiences != null && meta.genres != undefined && meta.genres != null) {
                    if (this.setTypeOptions(meta.experiences) && this.setGenreOptions(meta.genres)) {
                        this.setFormDataFromRoute();
                    }
                }
            } else {
                injected_meta = undefined;
                this.injected_meta = undefined;
                var _featured = undefined;
            }

            this.currentTimeStamp = now / 1000;
            this.predictiveText = movies.getNames();

            this.tabNowShowing = this.$route.path.match(/^\/(coming-soon)/g) ? false : true;
            this.tabComingSoon = this.$route.path.match(/^\/(coming-soon)/g) ? true : false;
            this.availableCinemas = movies.getCinemaIds();
        }
        __WEBPACK_IMPORTED_MODULE_8_object_fit_images___default()(document.querySelector('img.obejct-fit-polyfill'));

        __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].nextTick(function () {
            return _this7.setGoogleAdPosition(window.scrollY || window.pageYOffset);
        });
        this.scrollSpy = new __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_ui_core__["Utils"].ScrollSpy(window, this.onPageScrolled);
        window.addEventListener('resize', this.onResize);
    },


    watch: {
        '$route': function $route(to, from) {
            if (this.$route.path.includes("/type") && this.$route.path.includes("Nouveau")) {
                this.metaTitle = 'Cinema Nouveau Movies | Dedicated Art Cinema';
                this.metaDescription = 'Nouveau is a division of Ster-Kinekor Theatres and holds the prestige of being one of the world’s only dedicated "art cinema" chains, screening independent, alternative and art cinema content from cultures across the globe. Book your tickets today!';
                this.metaImage = '/static/img/nouveau-logo.png';
            } else {
                this.metaTitle = 'Cinema | Movie Showtimes and Online Movie Ticket Bookings';
                this.metaDescription = 'South Africa\'s biggest movie exhibitor. Browse the latest movies, trailers and showtimes. Book your movie tickets online today!';
                this.metaImage = '/static/img/sk-logo.png';
            }
            this.$emit('updateHead');
            this.setGoogleAdPosition(window.scrollY || window.pageYOffset);
        }
    }
});

/***/ }),
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 252,
	"./af.js": 252,
	"./ar": 253,
	"./ar-dz": 254,
	"./ar-dz.js": 254,
	"./ar-kw": 255,
	"./ar-kw.js": 255,
	"./ar-ly": 256,
	"./ar-ly.js": 256,
	"./ar-ma": 257,
	"./ar-ma.js": 257,
	"./ar-sa": 258,
	"./ar-sa.js": 258,
	"./ar-tn": 259,
	"./ar-tn.js": 259,
	"./ar.js": 253,
	"./az": 260,
	"./az.js": 260,
	"./be": 261,
	"./be.js": 261,
	"./bg": 262,
	"./bg.js": 262,
	"./bm": 263,
	"./bm.js": 263,
	"./bn": 264,
	"./bn-bd": 265,
	"./bn-bd.js": 265,
	"./bn.js": 264,
	"./bo": 266,
	"./bo.js": 266,
	"./br": 267,
	"./br.js": 267,
	"./bs": 268,
	"./bs.js": 268,
	"./ca": 269,
	"./ca.js": 269,
	"./cs": 270,
	"./cs.js": 270,
	"./cv": 271,
	"./cv.js": 271,
	"./cy": 272,
	"./cy.js": 272,
	"./da": 273,
	"./da.js": 273,
	"./de": 274,
	"./de-at": 275,
	"./de-at.js": 275,
	"./de-ch": 276,
	"./de-ch.js": 276,
	"./de.js": 274,
	"./dv": 277,
	"./dv.js": 277,
	"./el": 278,
	"./el.js": 278,
	"./en-au": 279,
	"./en-au.js": 279,
	"./en-ca": 280,
	"./en-ca.js": 280,
	"./en-gb": 281,
	"./en-gb.js": 281,
	"./en-ie": 282,
	"./en-ie.js": 282,
	"./en-il": 283,
	"./en-il.js": 283,
	"./en-in": 284,
	"./en-in.js": 284,
	"./en-nz": 285,
	"./en-nz.js": 285,
	"./en-sg": 286,
	"./en-sg.js": 286,
	"./eo": 287,
	"./eo.js": 287,
	"./es": 288,
	"./es-do": 289,
	"./es-do.js": 289,
	"./es-mx": 290,
	"./es-mx.js": 290,
	"./es-us": 291,
	"./es-us.js": 291,
	"./es.js": 288,
	"./et": 292,
	"./et.js": 292,
	"./eu": 293,
	"./eu.js": 293,
	"./fa": 294,
	"./fa.js": 294,
	"./fi": 295,
	"./fi.js": 295,
	"./fil": 296,
	"./fil.js": 296,
	"./fo": 297,
	"./fo.js": 297,
	"./fr": 298,
	"./fr-ca": 299,
	"./fr-ca.js": 299,
	"./fr-ch": 300,
	"./fr-ch.js": 300,
	"./fr.js": 298,
	"./fy": 301,
	"./fy.js": 301,
	"./ga": 302,
	"./ga.js": 302,
	"./gd": 303,
	"./gd.js": 303,
	"./gl": 304,
	"./gl.js": 304,
	"./gom-deva": 305,
	"./gom-deva.js": 305,
	"./gom-latn": 306,
	"./gom-latn.js": 306,
	"./gu": 307,
	"./gu.js": 307,
	"./he": 308,
	"./he.js": 308,
	"./hi": 309,
	"./hi.js": 309,
	"./hr": 310,
	"./hr.js": 310,
	"./hu": 311,
	"./hu.js": 311,
	"./hy-am": 312,
	"./hy-am.js": 312,
	"./id": 313,
	"./id.js": 313,
	"./is": 314,
	"./is.js": 314,
	"./it": 315,
	"./it-ch": 316,
	"./it-ch.js": 316,
	"./it.js": 315,
	"./ja": 317,
	"./ja.js": 317,
	"./jv": 318,
	"./jv.js": 318,
	"./ka": 319,
	"./ka.js": 319,
	"./kk": 320,
	"./kk.js": 320,
	"./km": 321,
	"./km.js": 321,
	"./kn": 322,
	"./kn.js": 322,
	"./ko": 323,
	"./ko.js": 323,
	"./ku": 324,
	"./ku.js": 324,
	"./ky": 325,
	"./ky.js": 325,
	"./lb": 326,
	"./lb.js": 326,
	"./lo": 327,
	"./lo.js": 327,
	"./lt": 328,
	"./lt.js": 328,
	"./lv": 329,
	"./lv.js": 329,
	"./me": 330,
	"./me.js": 330,
	"./mi": 331,
	"./mi.js": 331,
	"./mk": 332,
	"./mk.js": 332,
	"./ml": 333,
	"./ml.js": 333,
	"./mn": 334,
	"./mn.js": 334,
	"./mr": 335,
	"./mr.js": 335,
	"./ms": 336,
	"./ms-my": 337,
	"./ms-my.js": 337,
	"./ms.js": 336,
	"./mt": 338,
	"./mt.js": 338,
	"./my": 339,
	"./my.js": 339,
	"./nb": 340,
	"./nb.js": 340,
	"./ne": 341,
	"./ne.js": 341,
	"./nl": 342,
	"./nl-be": 343,
	"./nl-be.js": 343,
	"./nl.js": 342,
	"./nn": 344,
	"./nn.js": 344,
	"./oc-lnc": 345,
	"./oc-lnc.js": 345,
	"./pa-in": 346,
	"./pa-in.js": 346,
	"./pl": 347,
	"./pl.js": 347,
	"./pt": 348,
	"./pt-br": 349,
	"./pt-br.js": 349,
	"./pt.js": 348,
	"./ro": 350,
	"./ro.js": 350,
	"./ru": 351,
	"./ru.js": 351,
	"./sd": 352,
	"./sd.js": 352,
	"./se": 353,
	"./se.js": 353,
	"./si": 354,
	"./si.js": 354,
	"./sk": 355,
	"./sk.js": 355,
	"./sl": 356,
	"./sl.js": 356,
	"./sq": 357,
	"./sq.js": 357,
	"./sr": 358,
	"./sr-cyrl": 359,
	"./sr-cyrl.js": 359,
	"./sr.js": 358,
	"./ss": 360,
	"./ss.js": 360,
	"./sv": 361,
	"./sv.js": 361,
	"./sw": 362,
	"./sw.js": 362,
	"./ta": 363,
	"./ta.js": 363,
	"./te": 364,
	"./te.js": 364,
	"./tet": 365,
	"./tet.js": 365,
	"./tg": 366,
	"./tg.js": 366,
	"./th": 367,
	"./th.js": 367,
	"./tk": 368,
	"./tk.js": 368,
	"./tl-ph": 369,
	"./tl-ph.js": 369,
	"./tlh": 370,
	"./tlh.js": 370,
	"./tr": 371,
	"./tr.js": 371,
	"./tzl": 372,
	"./tzl.js": 372,
	"./tzm": 373,
	"./tzm-latn": 374,
	"./tzm-latn.js": 374,
	"./tzm.js": 373,
	"./ug-cn": 375,
	"./ug-cn.js": 375,
	"./uk": 376,
	"./uk.js": 376,
	"./ur": 377,
	"./ur.js": 377,
	"./uz": 378,
	"./uz-latn": 379,
	"./uz-latn.js": 379,
	"./uz.js": 378,
	"./vi": 380,
	"./vi.js": 380,
	"./x-pseudo": 381,
	"./x-pseudo.js": 381,
	"./yo": 382,
	"./yo.js": 382,
	"./zh-cn": 383,
	"./zh-cn.js": 383,
	"./zh-hk": 384,
	"./zh-hk.js": 384,
	"./zh-mo": 385,
	"./zh-mo.js": 385,
	"./zh-tw": 386,
	"./zh-tw.js": 386
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 511;

/***/ }),
/* 512 */,
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-view"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? [(_vm.$breakpoints.mdUp) ? _c('sk-container', [_c('div', {
    staticClass: "pos-rel"
  }, [_c('sk-google-ad', {
    ref: "googleAdLeft",
    staticClass: "lefty",
    attrs: {
      "advert-id": _vm.googleAds[_vm.googleAdType].left,
      "width": 280,
      "height": 800
    }
  }), _vm._v(" "), _c('sk-google-ad', {
    ref: "googleAdRight",
    staticClass: "righty",
    attrs: {
      "advert-id": _vm.googleAds[_vm.googleAdType].right,
      "width": 280,
      "height": 800
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.featuredData) ? _c('sk-carousel', {
    ref: "featureCarousel",
    staticClass: "feature-carousel",
    attrs: {
      "pageMarkers": "",
      "auto-advance": true
    }
  }, [_vm._l((_vm.featuredData.filter(function (f) { return f.appears_in === 'BOTH' || (f.appears_in === (_vm.isNouveau ? 'NOUVEAU' : 'SK CLASSIC')); })), function(feature) {
    return _c('div', {
      key: feature.title,
      staticClass: "slide",
      attrs: {
        "slot": "slides"
      },
      slot: "slides"
    }, [(feature.ad_tag == undefined || feature.ad_tag == null || feature.ad_tag.length == 0) ? [_c('div', {
      staticClass: "feature-movie"
    }, [(feature.movie) ? _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm4": "",
        "md3": ""
      }
    }, [(feature.button_1_text && feature.button_1_url) ? _c('sk-button', {
      attrs: {
        "href": feature.button_1_url
      }
    }, [_c('img', {
      staticClass: "img-responsive feature-movie__poster",
      attrs: {
        "src": feature.movie.poster,
        "alt": "feature.movie.title"
      }
    })]) : ((feature.movie && feature.movie.id)) ? _c('sk-button', {
      attrs: {
        "router": "",
        "to": {
          name: 'details_title',
          params: {
            id: feature.movie.id,
            title: feature.movie.title_slug
          }
        }
      }
    }, [_c('img', {
      staticClass: "img-responsive feature-movie__poster",
      attrs: {
        "src": feature.movie.poster,
        "alt": "feature.movie.title"
      }
    })]) : _vm._e()], 1), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm8": "",
        "md9": ""
      }
    }, [_c('div', {
      staticClass: "feature-movie-description"
    }, [(feature.logo_image) ? _c('div', {
      staticClass: "feature__experience-type"
    }, [_c('img', {
      staticClass: "img-responsive-height",
      attrs: {
        "src": feature.logo_image,
        "alt": feature.title
      }
    })]) : _vm._e(), _vm._v(" "), (feature.dont_display_title != '1') ? _c('h2', {
      staticClass: "h1 feature-movie-description--title",
      domProps: {
        "innerHTML": _vm._s(feature.title)
      }
    }) : _vm._e(), _vm._v(" "), (feature.strapline) ? [_c('h3', {
      domProps: {
        "innerHTML": _vm._s(feature.strapline)
      }
    })] : [_c('h3', {
      domProps: {
        "innerHTML": _vm._s(feature.banner_category)
      }
    })], _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(feature.description)
      }
    }) : _vm._e()], 2), _vm._v(" "), _c('ul', {
      staticClass: "feature-buttons"
    }, [(feature.button_1_text || (feature.movie && feature.movie.id)) ? _c('li', [(feature.button_1_text && feature.button_1_url) ? _c('sk-button', {
      attrs: {
        "primary": "",
        "target": feature.button_1_external_url ? '_blank' : '',
        "tag": "a",
        "href": feature.button_1_url.replace(/amp;/g, '')
      }
    }, [_vm._v("\n                      " + _vm._s(feature.button_1_text) + "\n                    ")]) : ((feature.movie && feature.movie.id)) ? _c('sk-button', {
      attrs: {
        "primary": "",
        "router": "",
        "to": {
          name: 'details_title',
          params: {
            id: feature.movie.id,
            title: feature.movie.title_slug
          }
        }
      }
    }, [_vm._v("\n                      Book now\n                    ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (feature.button_2_text || (feature.movie && feature.movie.id)) ? _c('li', [(feature.button_2_text && feature.button_2_url) ? _c('sk-button', {
      attrs: {
        "tertiary": "",
        "target": feature.button_2_external_url ? '_blank' : '',
        "tag": "a",
        "href": feature.button_2_url.replace(/amp;/g, '')
      }
    }, [_vm._v("\n                      " + _vm._s(feature.button_2_text) + "\n                    ")]) : ((feature.movie && feature.movie.id && feature.add_trailer != 0)) ? _c('sk-button', {
      attrs: {
        "tertiary": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openVideoDialog(feature.movie.youtube_id)
        }
      }
    }, [(feature.add_trailer === '1') ? _c('sk-icon', {
      attrs: {
        "play-button": ""
      }
    }) : _vm._e(), _vm._v("Play trailer\n                    ")], 1) : _vm._e()], 1) : _vm._e()])])], 1) : [_c('div', {
      staticClass: "feature-movie-description"
    }, [(feature.logo_image) ? _c('div', {
      staticClass: "feature__experience-type"
    }, [_c('img', {
      staticClass: "img-responsive-height",
      attrs: {
        "src": feature.logo_image,
        "alt": feature.title
      }
    })]) : _vm._e(), _vm._v(" "), (feature.dont_display_title == 0) ? _c('h2', {
      staticClass: "h1 feature-movie-description--title",
      domProps: {
        "innerHTML": _vm._s(feature.title)
      }
    }) : _vm._e(), _vm._v(" "), (feature.strapline) ? [_c('h3', {
      domProps: {
        "innerHTML": _vm._s(feature.strapline)
      }
    })] : [_c('h3', {
      domProps: {
        "innerHTML": _vm._s(feature.banner_category)
      }
    })], _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(feature.description)
      }
    })], 2), _vm._v(" "), _c('ul', {
      staticClass: "feature-buttons"
    }, [(feature.button_1_text) ? _c('li', [(feature.button_1_text && feature.button_1_url) ? _c('sk-button', {
      attrs: {
        "primary": "",
        "target": feature.button_1_external_url ? '_blank' : '',
        "tag": "a",
        "href": feature.button_1_url.replace(/amp;/g, '')
      }
    }, [_vm._v("\n                    " + _vm._s(feature.button_1_text) + "\n                  ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (feature.button_2_text) ? _c('li', [(feature.button_2_text && feature.button_2_url) ? _c('sk-button', {
      attrs: {
        "tertiary": "",
        "target": feature.button_2_external_url ? '_blank' : '',
        "tag": "a",
        "href": feature.button_2_url.replace(/amp;/g, '')
      }
    }, [_vm._v("\n                    " + _vm._s(feature.button_2_text) + "\n                  ")]) : _vm._e()], 1) : _vm._e()])]], 2), _vm._v(" "), _c('div', {
      staticClass: "feature-movie-img"
    }, [_c('img', {
      staticClass: "obejct-fit-polyfill",
      attrs: {
        "src": _vm.$breakpoints.xs ? feature.mobile_image : feature.image
      }
    })])] : [_c('sk-google-ad', {
      attrs: {
        "advert-id": _vm.$breakpoints.xs ? feature.ad_tag_mobile : feature.ad_tag,
        "width": _vm.$breakpoints.xs ? 750 : 1920,
        "height": _vm.$breakpoints.xs ? 400 : 640
      }
    })]], 2)
  }), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('div', {
    staticClass: "move-down",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": _vm.scrollDown
    },
    slot: "footer"
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('sk-panel', {
    staticClass: "text-center",
    attrs: {
      "transparent": ""
    }
  }, [(_vm.$breakpoints.mdUp) ? _c('sk-google-ad', {
    attrs: {
      "advert-id": _vm.googleAds[_vm.googleAdType].topLg,
      "width": 728,
      "height": 90
    }
  }) : _c('sk-google-ad', {
    attrs: {
      "advert-id": _vm.googleAds[_vm.googleAdType].top,
      "width": 320,
      "height": 50
    }
  })], 1), _vm._v(" "), _c('sk-video', {
    staticClass: "dialog-video",
    attrs: {
      "content": _vm.dialogData
    },
    model: {
      value: (_vm.activeDialog),
      callback: function($$v) {
        _vm.activeDialog = $$v
      },
      expression: "activeDialog"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "filter"
    }
  }, [_c('div', {
    staticClass: "container filter border--darken-2"
  }, [_c('sk-search-filter', {
    ref: "search_filter",
    staticClass: "search-filter",
    attrs: {
      "available-cinemas": _vm.availableCinemas,
      "cinemasByRegion": _vm.cinemasByRegion,
      "predictiveText": _vm.predictiveText,
      "loading": _vm.loading,
      "cinemaTypes": _vm.cinemaTypes,
      "movieGenres": _vm.movieGenres,
      "filterOptions": _vm.filterOptions,
      "searchResultCount": _vm.searchResultCount,
      "form_data": _vm.form_data,
      "lastAvailableDate": _vm.lastAvailableDate,
      "doSearch": _vm.doSearch,
      "search_filter": _vm.filter,
      "isNouveau": _vm.isNouveau
    },
    on: {
      "changed": _vm.getFilteredMovies,
      "cinemaOptions": _vm.setCinemaOptions,
      "typeOptions": _vm.setCinemaTypeOptions,
      "genreOptions": _vm.setGenreOptions,
      "filterOptions": _vm.setFilterOptions,
      "summaryOptions": _vm.summaryOptions,
      "setIsLoading": _vm.setLoading,
      "setCinemaTypeGroups": _vm.setCinemaTypeGroups,
      "setCinemasNearby": _vm.setCinemasNearby
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "container movie-listing"
  }, [(_vm.movies) ? _c('div', [_c('sk-layout', {
    staticClass: "movie-listing__tabs",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm5": "",
      "md3": "",
      "lg2": ""
    }
  }, [_c('sk-list-tile', {
    attrs: {
      "value": _vm.tabNowShowing == true
    }
  }, [_c('h4', {
    staticClass: "tab-heading",
    on: {
      "click": function($event) {
        _vm.setVisibleTab('now-showing')
      }
    }
  }, [_vm._v("\n                  Now Showing (" + _vm._s(_vm.countNS) + ")\n                ")])])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm4": "",
      "md3": "",
      "lg2": ""
    }
  }, [_c('sk-list-tile', {
    attrs: {
      "value": _vm.tabComingSoon == true
    }
  }, [_c('h4', {
    staticClass: "tab-heading",
    on: {
      "click": function($event) {
        _vm.setVisibleTab('coming-soon')
      }
    }
  }, [_vm._v("\n                  Coming Soon (" + _vm._s(_vm.countCS) + ")\n                ")])])], 1)], 1), _vm._v(" "), _c('sk-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabNowShowing && _vm.movies.now_showing),
      expression: "tabNowShowing && movies.now_showing"
    }],
    staticClass: "movie-listing__list",
    class: (_vm.activeMovie ? 'movie-listing__list--active' : ''),
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.movies.now_showing), function(movie, index) {
    return (_vm.movies.now_showing) ? [(_vm.showLoadMoreNowShowing) ? [(index < _vm.loadMoreLimitNowShowing) ? [_c('sk-flex', {
      key: movie.id,
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": "",
        "lg2": ""
      }
    }, [_c('sk-list-tile', {
      ref: "movie",
      refInFor: true,
      attrs: {
        "value": _vm.activeMovie == movie
      }
    }, [(_vm.movies && _vm.movies.now_showing) ? _c('sk-movie-thumbnail', {
      directives: [{
        name: "observe-visibility",
        rawName: "v-observe-visibility",
        value: (function (isVisible, entry) { return _vm.visibilityChanged(isVisible, entry, movie); }),
        expression: "(isVisible, entry) => visibilityChanged(isVisible, entry, movie)"
      }],
      style: ({
        marginBottom: _vm.activeMovie == movie ? _vm.bottomOffset : ''
      }),
      attrs: {
        "now-showing": "",
        "content": movie
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showMovieDetail(movie, $event.currentTarget)
        }
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), (movie.hasPromos) ? _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": "",
        "lg4": ""
      }
    }, [
      [_c('router-link', {
        staticClass: "movie-listing__promo",
        attrs: {
          "to": {
            path: '/promotion/' + movie.promoMeta.nid
          }
        }
      }, [_c('img', {
        staticClass: "movie-thumbnail__img img-responsive",
        attrs: {
          "src": movie.images.promo.desktop.url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "movie-thumbnail__caption"
      }, [_vm._t("caption", [_c('h5', {
        staticClass: "movie-thumbnail__title",
        domProps: {
          "innerHTML": _vm._s(movie.promoMeta.title)
        }
      }), _vm._v(" "), _c('ul', {
        staticClass: "movie-thumbnail__subtitle"
      }, [_c('li', [_vm._v(_vm._s(_vm._f("truncate")(movie.promoMeta.strapline, 60, '...')))])])]), _vm._v(" "), _c('span', {
        staticClass: "movie-listing__promo--cta"
      }, [_vm._v("Learn More")])], 2)])]
    ], 2) : _vm._e()] : _vm._e()] : [_c('sk-flex', {
      key: movie.id,
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": "",
        "lg2": ""
      }
    }, [_c('sk-list-tile', {
      ref: "movie",
      refInFor: true,
      attrs: {
        "value": _vm.activeMovie == movie
      }
    }, [(_vm.movies && _vm.movies.now_showing) ? _c('sk-movie-thumbnail', {
      directives: [{
        name: "observe-visibility",
        rawName: "v-observe-visibility",
        value: (function (isVisible, entry) { return _vm.visibilityChanged(isVisible, entry, movie); }),
        expression: "(isVisible, entry) => visibilityChanged(isVisible, entry, movie)"
      }],
      style: ({
        marginBottom: _vm.activeMovie == movie ? _vm.bottomOffset : ''
      }),
      attrs: {
        "now-showing": "",
        "content": movie
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showMovieDetail(movie, $event.currentTarget)
        }
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), (movie.hasPromos) ? _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": "",
        "lg4": ""
      }
    }, [
      [_c('router-link', {
        staticClass: "movie-listing__promo",
        attrs: {
          "to": {
            path: '/promotion/' + movie.promoMeta.nid
          }
        }
      }, [_c('img', {
        staticClass: "movie-thumbnail__img img-responsive",
        attrs: {
          "alt": movie.images.promo.desktop.alt,
          "src": movie.images.promo.desktop.url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "movie-thumbnail__caption"
      }, [_vm._t("caption", [_c('h5', {
        staticClass: "movie-thumbnail__title",
        domProps: {
          "innerHTML": _vm._s(movie.promoMeta.title)
        }
      }), _vm._v(" "), _c('ul', {
        staticClass: "movie-thumbnail__subtitle"
      }, [_c('li', [_vm._v(_vm._s(_vm._f("truncate")(movie.promoMeta.strapline, 60, '...')))])])]), _vm._v(" "), _c('span', {
        staticClass: "movie-listing__promo--cta"
      }, [_vm._v("Learn More")])], 2)])]
    ], 2) : _vm._e()]] : _vm._e()
  }), _vm._v(" "), (_vm.movies.now_showing.length <= 0) ? [_c('sk-panel', [_vm._v("\n                Sorry! We don't seem to have the movie you're looking for. Check for more movies in Coming Soon.\n              ")])] : _vm._e(), _vm._v(" "), (_vm.showLoadMoreNowShowing && _vm.movies.now_showing.length > 10) ? _c('sk-flex', {
    attrs: {
      "xs12": "",
      "text-center": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "block": _vm.$breakpoints.xs,
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.doLoadMoreNowShowing(_vm.movies.now_showing.length)
      }
    }
  }, [_vm._v("Load More")])], 1) : _vm._e()], 2), _vm._v(" "), _c('sk-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabComingSoon),
      expression: "tabComingSoon"
    }],
    staticClass: "movie-listing__list",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.movies.coming_soon), function(movie, index) {
    return (_vm.movies.coming_soon) ? [(_vm.showLoadMoreComingSoon) ? [(index < _vm.loadMoreLimitComingSoon) ? [_c('sk-flex', {
      key: movie.id,
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": "",
        "lg2": ""
      }
    }, [_c('sk-list-tile', {
      ref: "movie",
      refInFor: true,
      attrs: {
        "value": _vm.activeMovie == movie
      }
    }, [(_vm.movies.coming_soon && movie != undefined && movie != null && (typeof movie == 'object')) ? _c('sk-movie-thumbnail', {
      directives: [{
        name: "observe-visibility",
        rawName: "v-observe-visibility",
        value: (function (isVisible, entry) { return _vm.visibilityChanged(isVisible, entry, movie); }),
        expression: "(isVisible, entry) => visibilityChanged(isVisible, entry, movie)"
      }],
      style: ({
        marginBottom: _vm.activeMovie == movie ? _vm.bottomOffset : ''
      }),
      attrs: {
        "coming-soon": "",
        "content": movie
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showMovieDetail(movie, $event.currentTarget)
        }
      }
    }, [(movie.opening_date != undefined && movie.opening_date != null) ? _c('div', {
      staticClass: "movie-thumbnail__subtitle",
      attrs: {
        "slot": "caption"
      },
      slot: "caption"
    }, [(movie.has_sessions_available) ? _c('div', {
      staticStyle: {
        "width": "95%",
        "padding": "5px",
        "margin": "10px auto",
        "background-color": "#007cbd",
        "color": "#ffffff",
        "text-align": "center"
      }
    }, [_vm._v("\n                            PRE-BOOK NOW\n                          ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0px 5px",
        "font-size": "10px"
      }
    }, [_vm._v("\n                            Releases " + _vm._s(movie.opening_date.additional.day) + " " + _vm._s(movie.opening_date.additional.string_long_month) + "\n                          ")]), _vm._v(" "), _c('h5', {
      staticClass: "movie-thumbnail__title",
      domProps: {
        "innerHTML": _vm._s(movie.title)
      }
    }), _vm._v(" "), _c('ul', {
      staticClass: "movie-thumbnail__subtitle",
      staticStyle: {
        "padding": "0px 5px"
      }
    }, _vm._l((movie.genres), function(genre) {
      return _c('li', [_vm._v(_vm._s(genre.name.toLowerCase()))])
    }))]) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), (movie.hasPromos) ? _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": "",
        "lg4": ""
      }
    }, [
      [_c('router-link', {
        attrs: {
          "to": {
            path: '/promotion/' + movie.promoMeta.nid
          }
        }
      }, [_c('img', {
        staticClass: "movie-thumbnail__img",
        attrs: {
          "alt": movie.images.promo.desktop.alt,
          "src": movie.images.promo.desktop.url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "movie-thumbnail__caption"
      }, [_vm._t("caption", [_c('h5', {
        staticClass: "movie-thumbnail__title"
      }, [_vm._v(_vm._s(movie.promoMeta.title))]), _vm._v(" "), _c('ul', {
        staticClass: "movie-thumbnail__subtitle"
      }, [_c('li', [_vm._v(_vm._s(_vm._f("truncate")(movie.promoMeta.strapline, 60, '...')))])])])], 2)])]
    ], 2) : _vm._e()] : _vm._e()] : [_c('sk-flex', {
      key: movie.id,
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": "",
        "lg2": ""
      }
    }, [_c('sk-list-tile', {
      ref: "movie",
      refInFor: true,
      attrs: {
        "value": _vm.activeMovie == movie
      }
    }, [(_vm.movies.coming_soon) ? _c('sk-movie-thumbnail', {
      directives: [{
        name: "observe-visibility",
        rawName: "v-observe-visibility",
        value: (function (isVisible, entry) { return _vm.visibilityChanged(isVisible, entry, movie); }),
        expression: "(isVisible, entry) => visibilityChanged(isVisible, entry, movie)"
      }],
      style: ({
        marginBottom: _vm.activeMovie == movie ? _vm.bottomOffset : ''
      }),
      attrs: {
        "coming-soon": "",
        "content": movie
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showMovieDetail(movie, $event.currentTarget)
        }
      }
    }, [(movie.opening_date != undefined && movie.opening_date != null) ? _c('div', {
      staticClass: "movie-thumbnail__subtitle",
      attrs: {
        "slot": "caption"
      },
      slot: "caption"
    }, [(movie.has_sessions_available) ? _c('div', {
      staticStyle: {
        "width": "95%",
        "padding": "5px",
        "margin": "10px auto",
        "background-color": "#007cbd",
        "color": "#ffffff",
        "text-align": "center"
      }
    }, [_vm._v("\n                            PRE-BOOK NOW\n                          ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0px 5px",
        "font-size": "10px"
      }
    }, [_vm._v("\n                            Releases " + _vm._s(movie.opening_date.additional.day) + " " + _vm._s(movie.opening_date.additional.string_long_month) + "\n                          ")]), _vm._v(" "), _c('h5', {
      staticClass: "movie-thumbnail__title",
      domProps: {
        "innerHTML": _vm._s(movie.title)
      }
    }), _vm._v(" "), _c('ul', {
      staticClass: "movie-thumbnail__subtitle",
      staticStyle: {
        "padding": "0px 5px"
      }
    }, _vm._l((movie.genres), function(genre) {
      return _c('li', [_vm._v(_vm._s(genre.name.toLowerCase()))])
    }))]) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), (movie.hasPromos) ? _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": "",
        "lg4": ""
      }
    }, [
      [_c('router-link', {
        attrs: {
          "to": {
            path: '/promotion/' + movie.promoMeta.nid
          }
        }
      }, [_c('img', {
        staticClass: "movie-thumbnail__img",
        attrs: {
          "alt": movie.images.promo.mobile.alt,
          "src": movie.images.promo.mobile.url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "movie-thumbnail__caption"
      }, [_vm._t("caption", [_c('h5', {
        staticClass: "movie-thumbnail__title"
      }, [_vm._v(_vm._s(movie.promoMeta.title))]), _vm._v(" "), _c('ul', {
        staticClass: "movie-thumbnail__subtitle"
      }, [_c('li', [_vm._v(_vm._s(_vm._f("truncate")(movie.promoMeta.strapline, 60, '...')))])])])], 2)])]
    ], 2) : _vm._e()]] : _vm._e()
  }), _vm._v(" "), (_vm.movies.coming_soon.length <= 0) ? [_c('sk-panel', [_vm._v("\n                Sorry! We don't seem to have the movie you're looking for. Check for more movies in Now Showing.\n              ")])] : _vm._e(), _vm._v(" "), (_vm.showLoadMoreComingSoon && _vm.movies.coming_soon.length > 2) ? _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.doLoadMoreComingSoon(_vm.movies.coming_soon.length)
      }
    }
  }, [_vm._v("Load More")])], 1) : _vm._e()], 2)], 1) : _vm._e()]), _vm._v(" "), (!_vm.previewMode) ? [_c('sk-quick-book', {
    ref: "search_filter",
    attrs: {
      "cinema": _vm.selected_cinema,
      "activeMovie": _vm.activeMovie,
      "filter": _vm.filter,
      "filters": _vm.form_data,
      "doSearch": _vm.doSearch
    }
  })] : void 0, _vm._v(" "), _c('sk-snackbar', {
    staticClass: "homepage__alert",
    attrs: {
      "bottom": "",
      "right": "",
      "fixed": "",
      "timeout": null
    },
    model: {
      value: (_vm.skclubAlert),
      callback: function($$v) {
        _vm.skclubAlert = $$v
      },
      expression: "skclubAlert"
    }
  }, [_c('div', [_c('h3', [_vm._v("Join SK Club Today "), _c('sk-icon', {
    staticClass: "homepage__alert-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.skclubAlert = false
      }
    }
  })], 1), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/loyalty-sk-club.png",
      "alt": "Join SK Club"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Join the SK Club to customise your movie preferences and speed up movie bookings.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "router": "",
      "to": {
        path: 'user/signup'
      }
    }
  }, [_vm._v("Join SK Club")])], 1)])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(516),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_meta_data_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(7);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'faq',

  data: function data() {
    return {
      heading: 'Frequently asked questions',
      subheading: 'Find the answers to your questions here',
      tabs: [],
      errors: [],
      loading: true,
      activeTab: false,
      currentIndex: 0,
      related_movies: []
    };
  },
  created: function created() {
    this.getContent();
  },


  methods: {
    isActive: function isActive(index, name) {

      console.log("isActive", index, name);
      console.log(name);

      return index == this.currentIndex;
    },
    getContent: function getContent() {
      var _this = this;

      this.loading = true;
      if (this.$breakpoints.xs || this.$breakpoints.sm) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].nextTick(function () {
          if (_this.$parent.$el != undefined) window.scroll({ top: _this.$parent.$el.offsetTop - 100, left: 0, behavior: 'smooth' });
        });
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["l" /* PageService */].getFAQ(), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovies()]).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            faqs = _ref2[0],
            movies = _ref2[1];

        _this.tabs = faqs.data.reduce(function (collection, tab) {
          var found = collection.findIndex(function (col) {
            return col.name == tab.category;
          });
          if (~found) {
            collection[found].items.push(tab);
          } else {
            collection.push({ name: tab.category, items: [tab] });
          }
          return collection;
        }, []);

        _this.related_movies = movies.byRelease().now_showing;
        _this.loading = false;
      });
    }
  },

  watch: {
    '$route': function $route() {
      this.getContent();
    }
  },

  beforeMounted: function beforeMounted() {
    this.getContent();
  }
});

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', {
    staticClass: "faq__heading"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.subheading))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), (!_vm.loading) ? [(_vm.$breakpoints.xs || _vm.$breakpoints.sm) ? _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-accordian', {
      key: index,
      attrs: {
        "active": _vm.isActive(index, tab.name)
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('h2', {
      staticClass: "faq__cat-title"
    }, [_vm._v(_vm._s(tab.name))])]), _vm._v(" "), _c('template', {
      slot: "content"
    }, [_c('sk-panel', _vm._l((tab.items), function(item, index) {
      return _c('div', {
        key: index
      }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
        staticClass: "faq__answer",
        domProps: {
          "innerHTML": _vm._s(item.body)
        }
      })])
    }))], 1)], 2)
  }) : [_c('sk-tabs', [_c('template', {
    slot: "tab-title"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-tab', {
      key: tab.name,
      class: (_vm.activeTab == index ? 'active' : ''),
      attrs: {
        "item": tab.name
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.activeTab = index
        }
      }
    })
  })), _vm._v(" "), _c('template', {
    slot: "tab-content"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-panel', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeTab == index),
        expression: "activeTab == index"
      }],
      key: index
    }, [_c('h2', {
      staticClass: "faq__cat-title"
    }, [_vm._v(_vm._s(tab.name))]), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm7": ""
      }
    }, [_vm._l((tab.items), function(item) {
      return [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
        staticClass: "faq__answer",
        domProps: {
          "innerHTML": _vm._s(item.body)
        }
      })]
    }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("Not finding the answer you need?")]), _vm._v(" "), _c('p', [_vm._v("Let us know what problem you are experiencing by giving us your feedback. We look forward to helping you")]), _vm._v(" "), _c('sk-button', {
      staticClass: "faq__btn",
      attrs: {
        "primary": "",
        "router": "",
        "to": {
          name: 'Contact Us'
        }
      }
    }, [_vm._v("Contact us")])], 2)], 1)], 1)
  }))], 2)]] : _vm._e(), _vm._v(" "), _c('sk-signin'), _vm._v(" "), _c('sk-related-movies', {
    attrs: {
      "movies": _vm.related_movies,
      "limit": 6
    }
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(519),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_meta_data_js__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            tabHeadings: [],
            tabs: [],
            currentIndex: 0
        };
    },


    methods: {
        computeTabs: function computeTabs() {
            var parentRoute = this.$route.matched.find(function (route) {
                return route.parent == undefined;
            });
            this.tabHeadings = this.$router.options.routes.find(function (r) {
                return r.name === parentRoute.name;
            }).children || [];
            if (this.$breakpoints.xs || this.$breakpoints.sm) {
                this.$children.forEach(function (el) {
                    if (el.isActive) {
                        window.top = 0;
                    }
                });
            }
        },
        isActive: function isActive(index) {
            return index == this.currentIndex;
        },
        pushRoute: function pushRoute(el) {
            this.$router.push({ path: el.path });
        }
    },

    computed: {
        activeTab: {
            get: function get() {
                var _this = this;

                return this.tabHeadings ? this.tabHeadings.findIndex(function (tab) {
                    return tab.name === _this.$route.name;
                }) : 0;
            },
            set: function set($tabIndex) {
                var tab = this.tabHeadings[$tabIndex];
                if (this.$route.name !== tab.name) {
                    this.$router.push({ name: tab.name });
                }
            }
        }
    },

    watch: {
        '$route': function $route() {
            this.computeTabs();
        }
    },

    beforeUpdate: function beforeUpdate() {
        this.computeTabs();
    },
    beforeMount: function beforeMount() {
        this.computeTabs();

        this.tabs = [{
            name: 'Online Booking Terms & Conditions',
            path: 'online-booking-terms-and-conditions',
            copy: 'Sterkinekor.com truly believes in keeping your confidential information just that... confidential!\n        \t\t\t\t\tAny details you post to our site serves only to serve YOU better. The more we know about what you like, where you live and who you are the more we can enhance your movie experience. We have absolutely no interest in selling the information.\n        \t\t\t\t\tSterkinekor.com hereby makes a solid, and lawfully binding promise that your payment details remain YOUR property. We take certain details on payment of tickets only to enable a secure transaction via your banking institution. We have employed the very latest security and encryption technology to protect you and your credit card.\n        \t\t\t\t\t',
            content: [{
                title: '1. Terms and Conditions of Use:',
                summary: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nisi deleniti facilis officiis voluptatibus, velit doloremque, est culpa similique veniam alias pariatur numquam beatae. Necessitatibus id, sit error nesciunt perferendis sunt.',
                points: [{
                    title: '1.1 Please read these terms of use carefully. By using this website you agree to the following terms and conditions:',
                    points1: ['1.1.1 You acknowledge and understand that by accessing and using this Site and/or any of the Services offered on this Site including the purchasing of any ticket, you agree to and are bound by these terms and conditions of use.', '1.1.2 These terms and conditions of use constitute a binding agreement between Sterkinekor, a division of Primedia (Pty) Ltd and you, the user.', '1.1.3 Your use of this Site and any of the services offered on this Site, including without limitation our ticketing services, will be subject to the most current version of these terms of use posted on the Site at the time of such use.', '1.1.4 Ster-Kinekor may at any time revise these Web Site Terms and Conditions by updating this posting. By using the Site, you agree to be bound by any such revisions and you agree to periodically visit this page to determine the then current Web Site Terms and Conditions to which you are bound.', '1.1.5 You agree to use this Site in accordance with these terms of use, and all laws, regulations and codes of conduct (including self-regulatory) applicable to you and your use of the Internet and the services provided to you on this Site. In particular, you agree to use this Site only for lawful purposes and in a manner which does not infringe the rights of, or restrict or inhibit the use of or enjoyment of this Site by any third party. Furthermore you agree not to use the Site in a manner that would bring Sterkinekor, our business and/or any of our affiliates into disrepute.']
                }]
            }, {
                title: '2. Restrictions on Use of Content:',
                points: [{ title: '2.1 The unauthorized copying, displaying or other use of any content from this site is a violation of the law.' }, { title: '2.2 You acknowledge having been advised by Ster-Kinekor that the Content isprotected in South Africa and internationally by a variety of laws, including but not limited to, copyright laws and treaty provisions, trademark laws, patent laws, and other proprietary rights laws (collectively "Rights").' }, { title: '2.3 In addition to Ster-Kinekor\'s Rights in individual elements of the Content, Ster-Kinekor or its licensors own a copyright in the selection, coordination and arrangement of the Content.' }, { title: '2.4 You are hereby granted permission to access the Content from the Site in whole or in part, solely for your personal, NON-COMMERCIAL use of viewing and browsing through the Site or ordering products or services from the Site. This permission terminates automatically if you breach any of the Web Site Terms of Use. Use of the Content is limited to use authorised in terms of the Site. All other use of Content from the Site, including, but not limited to uploading, downloading, modification, publication, transmission, participation in the transfer or sale of, copying, reproduction, republishing, creation of derivative works from, distribution, performance, display, incorporation into another web site, reproducing the Site (whether by linking, framing or any other method), or in any other way exploiting any of the Content, in whole or in part, or downloading and using software repeatedly for uses other than those expressly permitted may not be made without Ster-Kinekor\'s prior express written consent. By posting content on the Site, you are giving Ster-Kinekor the right to display such content on the Service and to use such content for promotional and marketing purposes.' }]
            }, {
                title: '3. Trademarks and Service Marks:',
                points: [{
                    title: 'There are a number of proprietary logos, service marks, trademarks, slogans and product designations found on this Site. By making them available on this Site, Ster-Kinekor is not granting you a license to use them in any fashion. Access to this Site does not confer upon you any license under any of Ster-Kinekor\'s or any third party\'sintellectual property rights.'
                }]
            }, {
                title: '4. Privacy and Security:',
                points: [{
                    title: 'All personal information obtained by Ster-Kinekor through your use of this website isprotected as set out in our privacy policy. Which can be downloaded here.'
                }]
            }, {
                title: '5. Login',
                points: [{
                    title: '5.1 To register with us you may be required to choose a user name and a password. You are responsible for keeping your user name and password secret. You may be required to enter your username and password every time you want to use the services on our Site. Sterkinekor will not be held liable for any loss or damage suffered or liability incurred arising from your failure to keep your account details (such as user names, passwords and access codes) secure or from you permitting anyone else to use your account with us and you indemnify Sterkinekor and hold us harmless in thisregard. You accept that you will be personally liable for all transactions concluded on your account.'
                }]
            }, {
                title: '6. Links:',
                points: [{ title: '6.1 No person, business or web site may link to any page on this site without the prior written permission of Ster-Kinekor.' }, { title: '6.2 This Site a may provide links to other third-party World Wide Web sites or resources. Ster-Kinekor makes no representations whatsoever about any other web site which you may access through this Site. Because Ster-Kinekor has no control over such sites and resources, you acknowledge and agree that Ster-Kinekor is not responsible for the availability of such external sites or resources and is not responsible or liable for any Content, advertising, products, services or other materials on or available from such sites or resources. Ster-Kinekor makes no representation or warranty as to any third party Content, products or services, and you agree that Ster-Kinekor shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such third-party Content, products or services available on or through any such site or resource.' }]
            }, {
                title: '7. Participation in Promotions, Competitions and other Site Activities:',
                points: [{
                    title: 'If you choose to participate in a promotion, competition or other Ster-Kinekorsponsored activity ("Website Activity"), you agree to comply with any rules or regulations governing such Website Activity and to the following:',
                    points: ['7.1 The judges\' decision is final and no correspondence will be entered into.', '7.2 No member or employee of Ster-Kinekor Theatres, a division of Primedia (Pty) Ltd registration number 2005/044403/07 and/or any of their affiliated companies and/or agencies, and members of their immediate family; nor members of the sponsors ofany competition listed on this page, and/or any of their affiliated companies and/or agencies, and members of their immediate family, may enter any of the competitions hosted partly or in whole by Ster-Kinekor Theatres, a division of Primedia (Pty) Ltd registration number 2005/044403/07.', '7.3 Prizes are not transferable and/or negotiable.', '7.4 Subject to sponsor conditions/other agreements, Ster-Kinekor Theatres, a division of Primedia (Pty) Ltd registration number 2005/044403/07 Ltd undertakes to deliver prizes to respective winners only where such winners are located/resident within South Africa.', '7.5 Prizes not collected/claimed within 30 days of being won will be disposed of at the discretion of Ster-Kinekor Theatres, a division of Primedia (Pty) Ltd registration number 2005/044403/07.', '7.6 Winners of specific competitions accept that certain other conditions may apply as prescribed by Ster-Kinekor Theatres, a division of Primedia (Pty) Ltd registration number 2005/044403/07 and/or the respective sponsor of the specific competition.', '7.7 Winners of any Ster-Kinekor Theatres competition accept they cannot be eligiblefor any prizes in any other Ster-Kinekor Theatres competition within a 12 month period.', '7.8 Any violation or attempt to violate any of the above rules will result in the immediate disqualification of the transgressor.', '7.9 By participating in any competition hosted partly or in whole by Ster-KinekorTheatres, a division of Primedia (Pty) Ltd registration number 2005/044403/07, participants further agree to be bound by our Terms and Privacy Policy.', '7.10 SMS entries to the Ster-Kinekor SMS Competition line 33007 cost R1.50 per SMS', '7.11 Free SMS do not apply', '7.12 Calls to Customer Care are charged at standard rates. Free Minutes do not apply.']
                }]
            }, {
                title: '8. Transmitted Material:',
                points: [{ title: 'Internet Transmissions are never completely private or secure. You understand that any message or information you send to the site may be intercepted by others, unless such message or information is encrypted. Sending a message to Ster-Kinekor does not cause Ster-Kinekor to have a special responsibility to you.' }]
            }, {
                title: '9. Disclaimer of Warranty:',
                points: [{ title: '9.1 Ster-Kinekor does not warrant or make any representations regarding the availability, use, timeliness, security, validity, accuracy, or reliability of, or the results of the use of, or otherwise respecting, the content of the site or any other web sites linked to or from the site.' }, { title: '9.2 Although Ster-Kinekor intends to take reasonable steps to prevent the introduction of viruses, worms, "Trojan horses" or other destructive materials to this Site, it does not guarantee or warrant that this Site or materials that may be downloaded from thisService do not contain such destructive features. Any material downloaded or otherwise obtained through the use of the site is done at your own discretion and risk and you are solely responsible for any damage to your computer system or loss ofdata that results from the download of any such material, or use of this site.' }, { title: '9.3 The content of the site is provided "as is" and on an "as available" basis, without warranties of any kind either expressed or implied. The site has not been compiled or supplied to meet the user\'s individual requirements and it is your sole responsibility to satisfy yourself prior to entering into any agreement with Ster-Kinekor that the service available from this website will meet your needs and requirements.' }, { title: '9.4 To the fullest extent possible pursuant to applicable law, Ster-Kinekor disclaims allwarranties, express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or other violation of rights. No advice or information, whether oral or written, obtained by you from Ster-Kinekor shall be deemed to alter this disclaimer of warranty, or to create any warranty.' }]
            }, {
                title: '10. Limitation of Liability:',
                points: [{ title: 'Ster-Kinekor will not be liable for any damages of any kind arising out of or relating to the use or the inability to use this site, its content or links, including but not limited to damages caused by or related to errors, omissions, interruptions, defects, delay inoperation or transmission, computer virus, line failure, and all other direct, indirect, special, incidental or consequential damages even if Ster-Kinekor has been advised ofthe possibility of such damages.' }]
            }, {
                title: '11. Indemnity:',
                points: [{ title: 'You agree to indemnify and hold harmless Ster-Kinekor, its directors, officers, shareholders, parents, subsidiaries, affiliates, agents, and licensors, from and against all losses, expenses, damages and costs, including reasonable attorneys\' fees, resulting from any violation of this Agreement.' }]
            }, {
                title: '12. Address for Service:',
                points: [{ title: 'The address for service for all purposes relating to these terms of use including the giving of any notice, the serving of any process, is Ster-Kinekor Theatres, PrimoviePark, 185 Katherine Street, Eastgate Ext 4.' }]
            }, {
                title: '13. General:',
                points: [{ title: '13.1 Ster-Kinekor may modify, suspend, withdraw or discontinue, temporarily or permanently, the Content, in whole or in part, at any time without notice. You agree that Ster-Kinekor shall not be liable to you or to any third party for any modification, suspension, withdrawal or discontinuance of the Content.' }, { title: '13.2 These terms shall be governed by and construed in accordance with the laws ofthe Republic of South Africa without giving effect to any principles of conflict of law.' }, { title: '13.3 You hereby consent to exclusive jurisdiction of the High Court of South Africa inrespect of any disputes arising in connection with the services referred to herein, or the terms or any matter related to or in connection therewith.' }, { title: '13.4 These Terms and Conditions of use together with the applicable terms of the conditions of sale constitute the entire agreement between you and Sterkinekor and supercede any previous agreements, negotiations, representations, arrangements, undertaking or proposals whether written or oral concerning the subject matter hereof.' }, { title: '13.5 Ster-Kinekor\'s failure to enforce any provision of this agreement will not be construed as a waiver of any provision or right. In the event that a portion of thisagreement is held unenforceable or invalid by any competent authority, the unenforceable portion will be construed in accordance with applicable law as nearly as possible to reflect the original intentions of the parties, and the remainder of the provisions will remain in force and effect to the fullest extent permitted by the law.' }, { title: '13.6 Sterkinekor will have the right to cede, delegate, transfer and/or assign its rights, obligations and duties hereunder to any person and/or entity, and you hereby consent to such cession, delegation, assignment and/or transfer.' }, { title: '13.7 Sterkinekor will be excused any failure to perform or delay in performance of any or all of our obligations hereunder as a result of an event of force majeure, including without limitation acts of God (including flood, fire, earthquake or other similar events), riots, war, strikes, lock-outs or other industrial disputes, epidemics, failure oftelecommunications systems, failure of the world wide web, any outages of the internet or connection or communications thereto, governmental restraints and act(s) of legislature or any other cause outside our reasonable control.' }]
            }, {
                title: '14. Full Electronic Communications Disclaimer:',
                points: [{ title: 'Every effort is made to provide accurate and complete information. However, given the substantial amounts of information for our communications at the time ofdissemination, often uploaded within short deadlines, we cannot guarantee that there will be no errors. We therefore accept no responsibility for any loss or damage which may arise from reliance on information contained in any communication sent. Neither Ster-Kinekor Theatres, nor its holding company Primedia(Pty) Ltd, nor their employees and contractors make any warranty with respect to the accuracy of any information expressed or implied in any communication. The information in this communication (which includes any files transmitted with it) is confidential and may be legallyprivileged. It is intended solely for the addressee. Access to this communication by anyone else is unauthorised. If you are not the intended recipient, any disclosure, copying, distribution or any action taken or omitted to be taken in reliance on it, isprohibited and may be unlawful. When addressed to our clients any opinions or advice contained in this communication are subject to the terms and conditions expressed in any governing client engagement letter. The contents of an attachment to this communication may contain software viruses which could damage your own computer system. While Ster-Kinekor has taken every reasonable precaution to minimise this risk, we cannot accept liability for any damage which you sustain as a result of software viruses. You should carry out your own virus checks before opening the attachment. Copyright in this e-mail and any document created by us will be and remain vested in us and will not be transferred to you. We assert the right to be identified as the author of and to object to any misuses of the contents of this communication or such documents.' }]
            }, {
                title: '15. Unsubscribe:',
                points: [{ title: 'We at Ster-Kinekor make it our business to entertain and inform you. However, shouldyou not wish to receive any of our communications, you can <a href="/user/unsubscribe">unsubscribe from this info-mailer</a> or by <a href="user/profile">editing your profile</a>' }]
            }, {
                name: 'TERMS AND CONDITIONS FOR TICKET PURCHASING',
                title: '1. General',
                points: [{
                    title: 'We at Ster-Kinekor make it our business to entertain and inform you. However, shouldyou not wish to receive any of our communications, you can <a href="/user/unsubscribe">unsubscribe from this info-mailer</a> or by <a href="user/profile">editing your profile</a>',
                    points1: ['1.1 Each ticket that you purchase from us is subject to these Terms and Conditions as well as any additional terms and rules applicable to the particular movie and/or event ("the Ticket Terms"). Such Ticket Terms may be referred to or set out on the relevant ticket or may be made available elsewhere on this web site or the venue.', '1.2 The use of any service or the use of any ticket bought from this Web Site is at the purchaser\'s risk. The purchaser / user indemnifies and holds Sterkinekor harmless against any loss, injury or damages which may be sustained as a result of using the service or the ticket sold on the Web Site.', '1.3 Without prejudice to any other rights or remedies in law, Sterkinekor may cancel any one or more of your tickets forthwith if you breach any of your obligations hereunder and we may refuse to accept any further bookings from you.', '1.4 Booking/ Purchasing Procedure', '1.4.1 Tickets may be booked:', '1.4.1.1 via this website by completing the online booking form, submitting your payment details as stipulated;', '1.4.1.2 via the Customer Care call centre on 0861 MOVIES (668437). A booking fee is applicable for all tickets booked through the call centre.', '1.4.1.3 Where applicable, at any one of Ster-Kinekor\'s cinemas.', '1.4.2 It is the purchaser\'s duty to ensure that all booking information is correct and allpayment information is correct. If booking information is incorrect, Sterkinekor is not obliged to rectify any errors.', '1.4.3 Once submitted, your booking request will constitute an offer on the terms and conditions contained herein together with any Ticket Terms. Such offer is open for acceptance by Sterkinekor and/or the Event Organisers to conclude a binding agreement with you. It is your responsibility to review these terms and conditions as well as any Ticket Terms before making a booking. Sterkinekor reserves the right not to accept or process your booking request and we will notify you if this is the case.', '1.4.4 Following receipt of your booking request, Sterkinekor will send you a confirmation notice confirming acceptance or rejection of your booking request containing the relevant booking number. Please note that whilst every effort is made to send you a confirmation notice for every valid booking request Sterkinekor receives from you, we cannot guarantee that such confirmation notice will be received by you, nor that, if same is received by you, that they will be legible and uncorrupted. Your failure to receive such confirmation notice will not affect the validity of the agreement concluded between us or the Event Organisers in respect of a booking.', '1.4.5 It is your duty to confirm with our Call Centre whether or not your order has been received and processed if you do not receive a confirmation notice after submitting your payment information, or if you experience an error message or service interruption after submitting your payment information. Sterkinekor will not be liable for any losses you may incur if you assume that a booking was not processed because you failed to receive our confirmation notice.', '1.4.6 The information you have submitted with your booking request will be processed as you have provided it. If you realise that an error has been made or that you need to make a change to such information, you should immediately contact our CallCentre.', '1.5 Pricing of Tickets and Information about Movies and/or Events', '1.5.1 The details of the movies and/or events (including the venues and seating arrangements) for which tickets are offered are contained on the Web Site and other media. The supply of tickets offered depends upon the availability thereof. Unless otherwise stated, all prices displayed are in South African Rand. Sterkinekor may without prior notice change the price, discontinue the availability or change the description of venues, seating arrangements or events for which tickets are made available. Special promotions may be subject to certain additional terms and conditions.', '1.5.2 Although every effort is made to ensure that the venues, seating arrangements and events are displayed and described completely and accurately, Sterkinekor does not warrant same and disclaim, to the maximum extent permitted by law, any liability arising from any omissions and inaccuracies pertaining to such display and description. In particular, we disclaim any and all warranties as to the occurrence, suitability or quality of the seating arrangements, performances, venues or events and will not be liable for any claims arising in respect thereof, even if Sterkinekor has acted in a negligent or grossly negligent manner.', '1.5.3 All prices indicated with regard to tickets will be exclusive of delivery fees which will be separately charged to you in respect of all deliveries in accordance with the specified rates.', '1.5.4 All prices indicated with regard to tickets on this Web Site will be inclusive ofVAT but exclusive of any other taxes and duties, which, unless otherwise indicated, will be charged separately.', '1.5.5 In the event of a cancellation, exchange, refund or replacement of tickets a stipulated handling fee may also apply.', '1.6 Payment', '1.6.1 You will be required to provide the necessary payment details (such as creditcard details) and to authorise payment of the amounts payable for the tickets ordered when submitting your booking request. Such authorisation will allow Sterkinekor to obtain payment at any time after confirmation of your booking.', '1.6.2 If Sterkinekor is unable to duly effect such payment for any reason your booking may be cancelled and your tickets may be resold to another customer without further notice.', '1.6.3 If the price you paid for a ticket is incorrect for whatever reason, Sterkinekor will have the right to cancel that ticket (or the order for that ticket) and refund to you the full amount that you paid in respect of the ticket. Sterkinekor may similarly cancel any ticket that you were sold that we were not entitled to sell at the time youpurchased and refund to you the full amount that you paid in respect of the ticket.', '1.7 Refunds, cancellations or exchanges', '1.7.1 Please note that generally no refunds, exchanges, or cancellations of tickets purchased are possible, including in respect of bookings being incorrectly processed because of such error. Any refund, cancellation or exchange made will be at the discretion of Sterkinekor.', '1.8 Collection of Tickets', '1.8.1 Tickets purchased online or via the Call Centre can be collected at any Sterkinekor Self Service Terminal or TouchMart kiosk. The credit card with which the ticket was purchased will need to be swiped in order for the ticket to be printed.', '1.9 Age and Age Restriction', '1.9.1 It is your responsibility to be aware of and to adhere to age restrictions that are applied to films and/or events.', '1.9.2 If a person having a valid ticket does not meet the age restriction requirements attached to the film or event, he/she will not be allowed access to the cinema or the event venue and no ticket refunds or readmission tickets will be granted.', '1.9.3 When submitting a booking request you warrant and represent that you are over the age of 18 (eighteen) and that you are authorised to make payment in the stipulated manner.', '1.10 Stolen, Lost or Destroyed Tickets', '1.10.1 Upon receipt of the tickets all risk for loss and damage to the tickets shall pass to you. Tickets that have been stolen, lost or destroyed will not be refunded or replaced for any reason whatsoever.', '1.11 Cancelled and Rescheduled Films and Events', '1.11.1 Occasionally, Films and/or events may be cancelled or rescheduled by Sterkinekor and/or the Event Organiser. In such case, Sterkinekor and/or the Event Organiser may offer a refund or exchange of tickets for which you may be required to follow certain procedures specified. Should this occur, Sterkinekor will usually provide a notice on this Web Site or contact you to inform you of the relevant refund or exchange procedures for that Film and/or event. You may also contact our Call Centre for instructions.', '1.11.2 Any refund issued will be on the ticket\'s face value paid (or, if a discounted ticket, then instead the discounted ticket price paid). No other fees or charges will be refunded. If a refund is issued, it will be issued using the same method of payment that was used to purchase the tickets. If a credit card was used to make the refunded purchase, then only that actual credit card will receive the credit for the refund. We will not be liable for travel or any other expenses that you or anyone else incurs inconnection with a cancelled or postponed event.', '1.12 Right of Admission', '1.12.1 Sterkinekor and/or the Event Organisers reserve all rights in terms ofadmission to cinemas or event venues.', '1.13 Security', '1.13.1 Sterkinekor will endeavour to ensure that necessary safety measures are in place to protect the sensitive payment information (such as your credit card details) which you provide to us.', '1.13.2 Sterkinekor, however, does not guarantee the absolute security of any information you transmit to us or that is transmitted to you and disclaims any liability arising in connection with any unauthorised disclosure of such information.', '1.14 Warranties', '1.14.1 Unless the contrary is stipulated in writing, all tickets are provided without warranty of any kind. Without limiting the aforesaid, Sterkinekor and the Event Organisers do not give any warranties or make any representations regarding the occurrence, timing, suitability, quality or performance of any film or event to which your ticket(s) may relate, or in respect of the venue, admission to such venue or the seating arrangements for such venue.', '1.14.2 By purchasing a ticket from us, you agree to these Terms of Use on behalf of yourself and any person accompanying you. You assume all risks incidental to the filmor event for which a ticket is issued, whether before, during or after show or performance. You agree that we will not be liable for any loss or damage you or anyone accompanying you may incur in the course of attending a film or an event for which you purchased tickets from us and that you will indemnify us against any claims arising in connection therewith.', '1.14.3 In no event will Ster-Kinekor s aggregate liability for all claims in connection with any transaction exceed the total amount of fees received from you pursuant to such transaction, irrespective of the cause of action (whether in contract, statute or delict, including for gross negligence), save to the extent that such liability cannot be excluded by law.', '1.15 These Terms of Use shall override any contrary terms or conditions incorporated by you in your order and any such conflicting terms or conditions will not form part ofany agreement concluded between us in respect of the goods and/or services ordered.', '1.16 If any problems arise in respect of your ticket please contact our Call Centre.']
                }]
            }, {
                title: '2. Booking Tickets offered by Sterkinekor',
                points: [{
                    title: '2.1 Cinema Tickets',
                    points1: ['2.1.1 Each ticket purchased from us is intended to be a revocable license to attend the movie and/or event at the stipulated cinema at the designated time to which the ticket pertains only and will not enable you to attend any other movie and/or event.', '2.1.2 It is the user\'s responsibility to enter their movie club details before completion of the transaction to purchase tickets. This includes, but is not restricted to, benefits offered to members of the Edgars and Vitality rewards programmes. Sterkinekor shallnot be held liable for movie club rewards with any online transactions where you have entered incorrect details.', '2.2 Other Event tickets', '2.2.1 Each ticket purchased from us is intended to be a revocable license to attend the event to which the ticket pertains only and will not enable you to attend any other event.']
                }]
            }, {
                title: '3. Booking Tickets offered by Third Parties',
                points: [{ title: '3.1 Each ticket purchased from us is intended to be a revocable license to attend the event to which the ticket pertains only and will not enable you to attend any other event.' }, { title: '3.2 Sterkinekor merely acts as an agent for the providers, promoters and organisers of events ("Event Organisers"). Sterkinekor sells tickets to you and collects payment from you on behalf of such Event Organisers. You are buying each ticket from the relevant Event Organiser and not from Sterkinekor. You are therefore contracting with the Event Organiser and your rights and obligations under the Ticket Terms are enforceable against and by such Event Organiser only. These Terms and Conditions are however, enforceable against you and by you. Event Organisers may refuse admission to events, alter the program or seating arrangements for events, or even postpone or cancel events in certain circumstances. Sterkinekor cannot accept any liability should any of the aforementioned occur. You can, however, contact our CallCentre to enquire about any relevant refund or exchange procedures that may apply inthese instances.' }, { title: '3.3 Sterkinekor does not determine or control ticket prices or seating availability. There may be many agents selling the Tickets referring to the same seating inventory. Tickets for popular events may therefore sell out quickly.' }, { title: '3.4 Sterkinekor may, in its discretion, limit your purchase of tickets to a specified number of tickets for any event (the "ticket limit") to discourage unfair ticket buying practices. In such event we will not be obliged to supply you any tickets in excess of the relevant ticket limit.' }]
            }, {
                name: 'TERMS AND CONDITIONS FOR D - BOX SEATS',
                points: [{ title: '4.1 By booking and using the D-Box Motion seats, you are agreeing to the terms of use stipulated below' }, { title: '4.2 Users with any of the conditions above are required to consult their physicians before using the D-BOX Motion System.' }, { title: '4.3 Use of the D-BOX Motion System is not recommended for children under 10 years of age without parental supervision. Minimum weight must be at least 20 kgs. Use of the seat by any persons under 20kg may not activate the motion system.' }, { title: '4.5 Use of hot liquids in the vicinity of the D-BOX Motion System must be avoided at all times to prevent spillage which could cause serious injuries to the user.' }, { title: '4.6 Ster-Kinekor Theatres and D-BOX Technologies Inc are not liable for any damages of any kind arising from the use of the D-BOX Motion System. ' }, { title: '4.7 Users of the D-BOX Motion System hereby agree not to hold D-BOX Technologies Inc. and Ster-Kinekor Theatres responsible for all damages of any kind arising from the use of the D-BOX Motion System including, but not limited to, direct or indirect, punitive, incidental, special or consequential damages arising out of, or in any way connected with, the use of the D-BOX Motion System. ' }, {
                    title: 'The D-BOX Motion System may be harmful to:',
                    points1: ['women who are pregnant', 'the elderly', 'people with heart conditions', 'back, head or neck conditions', 'injuries or pre-existing medical conditions']
                }]
            }]
        }, {
            name: 'Ster-Kinekor Club Terms & Conditions',
            path: 'club-terms-and-conditions',
            copy: 'Ster-Kinekor Theatres truly believes in keeping your confidential information just that... confidential! Please click here for our <a href="privacy-policy">Privacy Policy.</a>',
            content: [{
                title: '1. TERMS AND CONDITIONS',
                summary: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit enim, repellat exercitationem harum velit atque explicabo sit dolorum ipsa. Laboriosam quia nesciunt dolor nam esse perferendis nemo voluptatem, reiciendis, sit.',
                points: [{ title: '1.1. These terms and conditions form the basis of the SK CLUB. They are intended to protect both you and Ster-Kinekor Theatres. It is your responsibility to read and understand them. Please pay special attention to all the terms and conditions printed in bold.' }, { title: '1.2. Every member is subject to these terms and conditions, which member is deemed to have read and unconditionally accepted.' }, { title: '1.3. Ster-Kinekor Theatres reserves the right in our sole discretion to withdraw, replace, vary, amend or add to these terms and conditions from time to time (including but not limited to the earning and burning of Points, participating cinemas), in which case the amended terms and conditions will supersede and replace any previous terms and conditions with effect from the date on which it is posted on this website. We will endeavour to give you advance notice of any changes prior to their implementation wherever possible. You will be bound by the latest terms and conditions posted on this website (which will replace any previous terms and conditions) each time you access and/or use this website, the Card, and/or interact or engage with Ster-Kinekor Theatres and your access/use/interaction constitutes acceptance of these terms and conditions as may be modified from time to time.' }, { title: '1.4. The SK CLUB Card may only be used in accordance with these terms and conditions.' }, { title: '1.5. These terms and conditions will prevail notwithstanding any publicity material published by Ster-Kinekor Theatres.' }, { title: '1.6. Please visit these terms and conditions on a regular basis to familiarise yourself with the latest version. We also recommend that you print and keep a copy of these terms and conditions for future reference if you have applied for a SK CLUB Card on Ster-Kinekor Theatres\' website.' }, { title: '1.7. If you do not agree to these terms and conditions or any amendment to these terms and conditions you may terminate your membership at any time by writing to Ster-Kinekor Theatres at PO Box 76461, Wendywood, Johannesburg, South Africa, 2144 or e-mail us at skclub@sterkinekor.com stating that you no longer wish to be a member of the SK CLUB and you will be automatically removed from the SK CLUB.' }, { title: '1.8. Ster-Kinekor Theatres shall be entitled to sell, cede, assign, delegate or in any other way alienate or dispose of any or all of its rights and obligations under the SK CLUB without the prior approval of any member. Members may not sell, cede, assign, delegate or in any other way alienate or dispose of any or all of its rights and obligations under the SK CLUB.' }]
            }, {
                title: '2. DEFINITIONS',
                points: [{ title: 'Unless a contrary intention clearly appears from the context, the following expressions shall have the following meanings:' }, { title: '2.1. "Active member" means a member who has earned or spent Points on their SK CLUB Card within a consecutive 12 (twelve) month period;' }, { title: '2.2. "Base Points" means 100 (one hundred) Points which a member will earn when purchasing one movie ticket per transaction in accordance with these terms and conditions;' }, { title: '2.3. "Bonus Points" means additional Points awarded to members for certain promotional activities at Ster-Kinekor Theatres\' discretion from time to time;' }, { title: '2.4. "Burn" means the spending of Points by redeeming Rewards;' }, { title: '2.5. "Double Points" means twice the Base Points earned for the transaction;' }, { title: '2.6. "The Effective Date" means the 25th of November 2016' }, { title: '2.7. "Free Ticket" means a movie ticket which may be obtained by burning the stipulated amount of accumulated Points in accordance with these terms and conditions;' }, { title: '2.8. "General Terms and Conditions" means Ster-Kinekor Theatres\' general terms and conditions set out on the Ster-Kinekor Theatres\' website, www.sterkinekor.com, which includes our Privacy Policy, applying to customers\' attendance at Ster-Kinekor Theatres\xE2\u20AC\u2122 Cinemas Complexes amended from time to time;' }, { title: '2.9. "Half-Price Tuesday" means 50% off 1 (one) movie ticket purchased by the member for each unique show time on any Tuesday including 3D movies, Cine Prestige, IMAX and movies in their first week of release;' }, { title: '2.10. "Inactive Card" means a Card that has not been used for a period of 12 (twelve) consecutive months and no Points have been burned or earned in such time;' }, { title: '2.11. "Kick-start points" means the number of points earned by members upon sign up, which will be stipulated on the Membership Pack, amended from time to time;' }, { title: '2.12. "Mailer" means the movie mailer as well as other communication sent to SK CLUB Card holders who have subscribed and agreed to receive such movie mailer and communication from Ster-Kinekor Theatres;' }, { title: '2.13. "Member" means a person who has validly consented to join and participate in the SK CLUB by filling in an application form and whose application has been accepted by Ster-Kinekor Theatres;' }, { title: '2.14. "Membership form" means the application form you complete online, at cinema or in your Membership Pack when you sign up to become a member of the SK CLUB;' }, { title: '2.15. "Membership Pack" means either the SK Club 2D, 3D, Seniors + or VIP membership pack;' }, { title: '2.16. "Minor" means a person who is under the age of 18 (eighteen) years and who has not been emancipated and/or is a person lacking capacity;' }, { title: '2.17. "Online" means either Ster-Kinekor Theatres\' website, mobi site or via any Ster-Kinekor Theatres mobile phone application;' }, { title: '2.18. "Parent" means the parent of the minor or a person lacking capacity and includes a legal guardian;' }, { title: '2.19. "Participating Cinemas" means all Ster-Kinekor Theatres\xE2\u20AC\u2122 Cinema Complexes, including Cinema Nouveau and Cinema Prestige in South Africa only, except IMAX cinema\xE2\u20AC\u2122s where burning of Points will not be accepted;' }, { title: '2.20. "Points" means the currency used in the SK CLUB in accordance with these terms and conditions, which points are redeemable against certain stipulated Rewards and are valid for a 12 (twelve) month rolling-period from the date on which they are earned;' }, { title: '2.21. "Promotion" means selected items displayed at discounted prices as a special promotion or marked as being on or part of a promotional offering;' }, { title: '2.22. "Privacy Policy" means Ster-Kinekor Theatres\' Privacy Policy set out at www.sterkinekor.com/privacypolicy which forms part of the General Terms and Conditions;' }, { title: '2.23. "Registered members" are members who have signed up and activated their Card providing Ster-Kinekor Theatres with the minimum information required;' }, { title: '2.24. "Reward" means any of the facilities, discounts, services or arrangements offered or available to a member from time to time as a result of membership in the SK CLUB including earning and spending points;' }, { title: '2.25. "Sign up" means the completion of the member\'s personal information either online or at any Ster-Kinekor Theatres\xE2\u20AC\u2122 Cinema Complex at the Box Office Counter;' }, { title: '2.26. "Activation" means linking your SK CLUB Card to your account;' }, { title: '2.27. "Sign in" means logging in to your SK Club account;' }, { title: '2.28. "Regrading" means movement from any tier in the SK Club to another;' }, { title: '2.29. "Tier" means the existing or future levels within SK Club including, but not limited to Seniors +; VIP and Kids;' }, { title: '2.30. "SK CLUB" means the programme we offer to all qualifying customers who have applied for this programme, on these terms and conditions.' }, { title: '2.31. "SK CLUB Card" or "Card" means the Ster-Kinekor Theatres Club Card operated and issued by Ster-Kinekor Theatres containing a data storage magnetic strip/barcode issued to members of the SK CLUB;' }, { title: '2.32. "SK CLUB Partner" means any company or person who has contracted with Ster-Kinekor to offer Rewards to SK CLUB members from time to time;' }, { title: '2.33. "Ster-Kinekor Theatres" means Ster-Kinekor Theatres, a division of Primedia (Pty) Ltd, Registration number 2005/044403/07, a company incorporated under the laws of South Africa and having its physical address at the Ster-Kinekor Office Park, 185 Katherine Street, Sandton, Johannesburg, 2144.' }, { title: '2.34. "SST" means a Self Service Terminal which are located in all Ster-Kinekor Theatres Cinema Complexes which allows you to book movies and check your Points balance;' }, { title: '2.35. "System" means the computerised system and/or point of sales terminal utilised by Ster-Kinekor Theatres which accepts Cards and calculates Points, prints receipts and updates Ster-Kinekor Theatres\' central computer system;' }, { title: '2.36. "terms and conditions" means these terms and conditions applicable to the SK CLUB, your Card and membership, as amended from time to time, and includes the General Terms and Conditions;' }, { title: '2.37. "Our website" or "Site" means www. sterkinekor.com and includes the site www.sterkinekor.mobi.' }, { title: '2.38. "VAT" means the value-added tax payable in terms of the Value Added Tax Act of 1991, as amended;' }, { title: '2.39. "We", "Us" and "Our" means Ster-Kinekor Theatres;' }, { title: '2.40. "You" and "Your" means the member of the SK CLUB;' }]
            }, {
                title: '3. INTERPRETATION',
                points: [{
                    title: '3.1. In this agreement, unless the context clearly indicates a contrary intention, expressions, which denote:',
                    points1: ['3.1.1. The singular shall include the plural and vice versa;', '3.1.2. Any gender shall include the other genders;', '3.1.3. Natural persons shall include a juristic person and vice versa;']
                }]
            }, {
                title: '4. THE SK CLUB',
                points: [{ title: '4.1. The SK CLUB is owned, operated and promoted by Ster-Kinekor Theatres, a division of Primedia (Pty) Ltd [Registration number 2005/044403/07].' }, { title: '4.2. Ster-Kinekor Theatres may without limitation and unilaterally change, replace, temporarily suspend or terminate the SK CLUB and SK CLUB Card at any time with immediate effect upon notice to the members.' }, { title: '4.3. In the event of termination for any reason whatsoever, members will forfeit any Points which you may have accumulated, without recourse.' }, {
                    title: '4.4. Who qualifies?',
                    points1: ['4.4.1. The SK CLUB Card is available to all adults with a valid SA identity document and all minors with valid legal guardian or parental consent agreed to by signing the application form in the Membership Pack.', '4.4.2. Membership is only available to individuals in their personal capacity and families, groups, companies, trusts, partnerships, other entities, government departments, agencies are not eligible.', '4.4.3. The SK CLUB is not open to permanent or casual employees of Ster-Kinekor and their immediate families.']
                }, {
                    title: '4.5. SK CLUB Membership',
                    points1: ['4.5.1. Membership is in Ster-Kinekor Theatres\' sole discretion and we may accept or reject any membership application.', '4.5.2. Membership will be established in your personal capacity and your name as it appears on the application form and as confirmed and/or amended on registration.', '4.5.3. Only you may earn Points and redeem Rewards on your SK CLUB card.', '4.5.4. Only one SK CLUB Card application per person will be accepted. If more than one Card has been assigned to a member in error, the accounts will be combined and the Points transferred to the new single account, less any duplicated Points from the same activity. If a Card has been assigned to two different members in error, the members will be given new Card numbers and allocated Points according to proven transactions by the member.', '4.5.5. The SK CLUB Card will be issued on acceptance of application for membership.', '4.5.6. Termination by Ster-Kinekor Theatres', '4.5.6.1. Ster-Kinekor Theatres may terminate your membership at any time by written notice to such effect;', '4.5.6.2. Membership shall terminate without notice if the member:-', '4.5.6.2.1. Dies or is sequestrated; or', '4.5.6.2.2. Fails to comply with these terms and conditions; or', '4.5.6.2.3. Fails to sign in within a period of 12 (twelve) months from the date of signing up; or', '4.5.6.2.4. Fails to use his/ her Card for a period of 12 (twelve) consecutive months; or', '4.5.6.2.5. Provides Ster-Kinekor Theatres or its representatives or agents with incorrect or misleading information relating to the SK CLUB; or', '4.5.6.2.6. In any way abuses his membership or the SK CLUB Card; or', '4.5.6.2.7. Miss uses any of the Rewards and/or services which are available to members from time to time; or', '4.5.6.2.8. makes use of threatening, abusive or insulting language or behaving in a threatening, abusive or insulting manner when dealing with any Ster-Kinekor Theatres staff member or a patron of any Ster-Kinekor Theatres\xE2\u20AC\u2122 Cinema Complex.', '4.5.7. Termination by You', '4.5.7.1. You may terminate your membership at any time by giving written notice to Ster-Kinekor Theatres to such effect to skclub@sterkinekor.com or post to Ster-Kinekor Club, P.O. Box 76461, Wendywood, 2144.', '4.5.7.2. If you applied for membership through a SK CLUB representative, you may also terminate your membership by giving written notice to Ster-Kinekor Theatres by e-mail to skclub@sterkinekor.com or post to Ster-Kinekor Club, P.O. Box 76461, Wendywood, 2144 within 5 (five) business days.', '4.5.8. Where membership has been terminated by either Ster-Kinekor Theatres or you:', '4.5.8.1. You/your representative must return the Card to us immediately;', '4.5.8.2. You will forfeit any Points you may have earned on your Card.', '4.5.8.3. In the event of illegal or fraudulent use of the Card, we reserve the right to lay criminal charges.']
                }, {
                    title: '4.6. The Agreement',
                    points1: ['4.6.1. The member and Ster-Kinekor Theatres shall have a contractual relationship on the terms and conditions set out herein as well as our General Terms and Conditions regarding your interaction with us and ours with you. By signing the application form you shall be deemed to have accepted such terms and conditions. A Parent who has given consent to a minor by signing the application form shall be deemed to have accepted and assisted the minor in accepting such terms and conditions.', '4.6.2. This Agreement may be cancelled by us in the circumstances referred to in clause Termination by Ster-Kinekor Theatres and by you in terms of clause Termination by You.', '4.6.3. If any part of this Agreement is disallowed or held to be ineffective by any court or other competent body, the rest of the Agreement will not be affected.']
                }]
            }, {
                title: '5. SIGNING UP FOR THE SK CLUB',
                points: [{
                    title: '5.1. How do I sign up?',
                    points1: ['5.1.1. Membership Packs', '5.1.1.1. Ster-Kinekor Theatres offers Membership Packs to new applicants and Seniors + Membership Packs to applicants 60yrs and above.3D glasses which are required to watch a 3D movie are not included and must be purchased separately by the member at his/her own cost.', '5.1.1.2. VIP Membership Pack - A member who watches 15 (fifteen) different movies in a year will qualify for and be regraded to VIP membership status free of charge. The member will be contacted by SK CLUB and advised of his/her regrade. Arrangements will be made for the member to collect his/her new VIP Card at any Participating Ster-Kinekor Theatres Cinema Complex upon proof of valid identification.', '5.1.1.3. Seniors + Membership Pack - The Card will be supplied to members over the age of 60 who have supplied Ster-Kinekor Theatres with a valid identity number at the time of application. Due to the nature of the Rewards earned by Seniors + members, the Seniors + Membership Pack does not earn points. If a member is in possession of the SK CLUB membership at such time, his/her existing SK CLUB membership will regraded. Any Points accumulated on the SK CLUB Card will have to be redeemed prior to regrading to the Seniors + CLUB programme and any Points not redeemed or unable to be redeemed will be forfeited with the receipt of the new Seniors + Membership Pack.', '5.1.2. Eligibility for Membership Packs', '5.1.2.1. SK CLUB - any new applicant may apply for membership;', '5.1.2.2. Seniors + - any new and or existing member who is 60 years and over may apply for membership;', '5.1.2.3. VIP - any existing member who watches 15 or more movies in a year will qualify for and be regraded to VIP membership status free of charge. The member will have to collect his/her new VIP Card at any Participating Cinema upon proof of valid identification. Your upgrade is calculated from the 1st date of the month you were upgraded to the 1st day of the same month in the next year. Once you are a VIP member you will remain a VIP member for a period of one year. In order to retain VIP member status you will need to watch 15 or more different movies in the VIP membership year. VIP members who retain their status will get double Kick-Start Points within 7 (seven) days of each VIP membership year. If you do not watch the stipulated minimum number of movies during the membership year to retain your VIP membership, you will automatically revert to being a normal SK CLUB member and will subsequently receive the normal SK CLUB rewards.', '5.1.3. Sign Up', '5.1.3.1. If you do not currently hold a SK CLUB Card and would like to become a member, you will need to make an application at any one of the Participating Cinemas.', '5.1.3.1.1. Participating Cinema - complete all the fields in the application form on one of the Membership Packs at any Participating Cinema at the Box Office Counter by filling in your full name, date of birth, and contact details. If you are a minor, your parent is required to produce his/her identity document, contact details and sign the application form giving you consent to become a member. You will receive your Card at the time of joining. The Card will need to be activated by going to the SK website, under Clubs, click activate. Compete the form. You will receive a confirmatory e-mail, which contains a link for activation to be utilised to complete the sign up process for you to be able to receive the rewards.', '5.1.3.2. Online - complete all the fields in the application form online for one of the Membership Packs by filling in your full details (Not available for minors and members applying for a Seniors + Membership Pack). You will receive an e-mail which contains a link for registration online which when selected, will direct you to the website to complete your Club activation Once you receive your Card it will immediately be activated for you to be able to receive the Reward. You will still be required to Sign-In to receive the additional Rewards stipulated in clause.', '5.1.3.3. Only new applicants may fill in the application form in the Membership Pack. Members who want to have their Cards re-issued or replaced will not be eligible to make application for the new Membership Pack.', '5.1.3.4. If you do not receive a SMS within 21 (twenty-one) business days of application to inform you that you have successfully applied for the SK CLUB, please send an e-mail to skclub@sterkinekor.com or contact Customer Care on 0861 MOVIES (668437)*.', '5.1.3.5. On Sign up & Activation you will be entitled to the following Rewards:', '5.1.3.5.1. Half-price Tuesdays', '5.1.4. Sign In', '5.1.4.1. Once you have signed up to be a member you have 3 months (90 days) to activate your Card and start earning Points, failing which, your Card will automatically expire.', '5.1.4.2. Seniors + members DO NOT need to sign in. Seniors + Rewards are automatically available to the member upon sign in.', '5.1.4.3. You can sign in to activate your Card at any one of the Participating Cinemas or online.', '5.1.4.4. Participating Cinema - Upon signing up to be a member, you will receive a confirmatory e-mail, which you have provided containing a reference number and link. To apply in a Participating Cinema, you will require to produce the reference number to register your Card. You will be required to complete the registration with your identity number, and any other details you are requested to provide. The details you submit here will replace or correct your details supplied on the in store Membership Pack application form. Once the sign-in process has been completed, your additional Rewards will be available as detailed in clause The following Rewards will be applicable:', '5.1.4.5. Online - Upon signing up to be a member, you will receive a confirmatory email, to the email address which you have provided. To apply online, you will be required to select the link, which will direct you to a website where your registration can be completed. You will be required to complete the registration with your identity number, and any other details you are requested to provide. The details you submit here will replace or correct your details supplied on the in store Membership Pack application form. Once the sign-in process has been completed, your additional Rewards will be available:', '5.1.4.6. Online Profile', '5.1.4.6.1. If you provide us with more information about yourself, we will be able to personalise our interaction with you and enable us to provide you with information around movies opening and to contact you with SK CLUB invitations and promotions.', '5.1.4.6.2. You will be able to view your Points balance and keep your profile updated.', '5.1.4.7. The following Rewards will be applicable:', '<ol>\n        \t\t\t\t\t\t\t\t<li>\n        \t\t\t\t\t\t\t\t\tSign Up\n        \t\t\t\t\t\t\t\t\t<ul class="table-list">\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">\'Un-redeemable\' Points</li>\n        \t\t\t\t\t\t\t\t\t</ul>\n        \t\t\t\t\t\t\t\t</li>\n        \t\t\t\t\t\t\t\t<li>\n        \t\t\t\t\t\t\t\t\tUn-registered\n        \t\t\t\t\t\t\t\t\t<ul class="table-list">\n        \t\t\t\t\t\t\t\t\t\t<li class="table-list__item">\'Un-redeemable\' Points</li>\n        \t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Membership Expiry</li>\n        \t\t\t\t\t\t\t\t\t</ul>\n        \t\t\t\t\t\t\t\t</li>\n        \t\t\t\t\t\t\t\t<li>\n        \t\t\t\t\t\t\t\t\tSigned In (Registered)\n        \t\t\t\t\t\t\t\t\t<ul class="table-list">\n        \t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Half Price Tuesdays</li>\n        \t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Kick Start Points</li>\n        \t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Double Points Thursdays</li>\n        \t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Redeemable Points</li>\n        \t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Discounted Online and Customer Care booking fees</li>\n        \t\t\t\t\t\t\t\t\t</ul>\n        \t\t\t\t\t\t\t\t</li>\n        \t\t\t\t\t\t\t</ol>', '5.2. Existing CLUB Card Members', '5.2.1. Existing CLUB members will be required to Sign-in in order to qualify for the discounted rate, earning and burning of Points.', '5.2.2. Existing CLUB members can, from the Effective Date, earn and burn Points. Existing CLUB members\' membership can be terminated without notice if the member fails to use his/her card for a period of 12 (twelve) months and may forfeit any Points they may have earned.', '5.3. Replacement Packs', '5.3.1. SK CLUB, Seniors + and VIP members whose Cards have been lost, damaged or stolen or existing SK CLUB members can have their Cards immediately replaced at the Box Office Counter at any Participating Cinema on presentation of positive identification at no Replacement Fee.', '5.4. Personal Details', '5.4.1. It is your duty to ensure that the personal information you provide is accurate and complete and by providing such information, you undertake that you are authorised to provide such personal information. Ster-Kinekor Theatres will endeavour to correctly capture all personal information provided by you but we will not be responsible or liable for errors or omissions in your personal information at any time.', '5.4.2. If you have signed up and signed in with us, you can amend as well as ensure that your personal information is accurate, current and complete, by:', '5.4.2.1. Checking your profile online;', '5.4.2.2. Calling Customer Care on 0861 MOVIES (668437) (Standard rates apply - Free minutes do not apply).', '5.4.2.3. Asking for assistance at the Box Office;', '5.4.3. If your details are not correct you may be excluded from marketing campaigns and promotions with Ster-Kinekor Theatres.', '5.4.4. All personal information gathered or provided to us will be utilised in terms of Ster-Kinekor Theatres\' Privacy Policy, to which you agree.', '5.4.5. You may change your details electronically or at any one of our Participating Cinemas with proof of valid identification.', '5.4.6. You have the legal right at any time upon written notice to:', '5.4.6.1. Obtain access to your personal information being held by Ster-Kinekor Theatres; and', '5.4.6.2. Request the correction of your personal information; or', '5.4.6.3. Object to us using your Personal Information in terms of our Privacy Policy; or', '5.4.6.4. Request the deletion of your personal information being held by us.']
                }]
            }, {
                title: '6. THE SK CLUB CARD',
                points: [{ title: '6.1. The SK CLUB Card is not a credit card, debit card or gift card and can only be used by the registered member. Proof of identity may be requested at any time. You cannot accrue any interest on the Card.' }, { title: '6.2. The Card does not have to be renewed and there are no additional membership fees. However, if you have not used your Card for a period of 12 (twelve) consecutive months, your Card will expire and your membership from the SK CLUB will be automatically terminated. Upon expiry, all Rewards and Points, if any, will be forfeited.' }, { title: '6.3. If you have not signed in and activated your CLUB Card within 12 (twelve) months of signing up (joining) to the CLUB, your Card will also expire and your membership will be automatically terminated.' }, { title: '6.4. The Card does not give preferential rights of access for any movie or presentation; nor does it give access to films or presentations which are not open to the general public.' }, { title: '6.5. Ster-Kinekor Theatres reserves the right to withdraw, suspend or cancel this card for any reason at any time at its discretion, without recourse.' }, { title: '6.6. The member is responsible for the use and safety of the Card. Ster-Kinekor Theatres will not be responsible for lost, stolen or damaged Cards. If your Card is lost or stolen, this must be reported at any Ster-Kinekor Theatres Cinema Complex at the Box Office Counter where the lost or damaged card may be replaced at Ster-Kinekor Theatres\' sole discretion or contact Customer Care* on 0861 MOVIES (668437) to report the Card lost or stolen. Upon receipt of telephonic and written advice of the loss or theft of a Card we will suspend use of the Card and such Card will no longer be valid.' }, { title: '6.7. The member accepts liability for and indemnifies the Company against any loss, cost and expense Ster-Kinekor may sustain from the use of a lost or stolen card.' }, { title: '6.8. The Card remains the property of Ster-Kinekor Theatres to whom it must be returned upon request or if found. If found, please hand in at any Ster-Kinekor cinema or post to Ster-Kinekor Club, P.O. Box 76461, Wendywood, 2144.' }, { title: '6.9. The Card cannot be redeemed for cash in part or in whole, is non-transferable, non-exchangeable and non-refundable and must not be sold or offered for resale or used for advertising, promoting or other commercial purposes or to enhance the demand for other goods and/or services or dealt with in any other manner except as set out in these terms and conditions unless Ster-Kinekor Theatres\' prior written consent is obtained.' }, { title: '6.10. We reserve the right to monitor the transactions and use of your Card at any time, without prior notice.' }]
            }, {
                title: '7. POINTS',
                points: [{ title: '7.1. Points cannot be purchased; they can only be earned. Only activated members can earn Points.' }, {
                    title: '7.2. How do I earn Points?',
                    points1: ['7.2.1. You will earn Base Points from the day you Sign-In with us on each movie ticket purchased by you for each unique show time including 2D, 3D movies, movies in their first week of release and including IMAX & Cine Prestige;', '7.2.2. To earn Points for a transaction at Box Office, you must present your Card at the till before making your purchase. To earn Points for a transaction Online, you must sign in first before processing online transaction. To earn points at Self-service station, you must swipe your card before starting the booking.']
                }, { title: '7.3. To earn points at Food and Beverage, you must present your card to the cashier before placing your order. You will earn:' }, { title: '7.4. 100 points for a Mega combo' }, { title: '7.5. 200 points for a Sharing combo' }, {
                    title: '7.6. 200 points for Promotional / Up Take combo',
                    points1: ['7.6.1. If you do not swipe your Card or provide your details as above, you will not earn Points. No Points will be awarded retrospectively.', '7.6.2. Points can only be earned by the holder of the Card. Points do not have a cash value and cannot be redeemed under any circumstances for cash in part or in whole, are non-transferable, non-exchangeable and non-refundable and cannot be sold.', '7.6.3. The purchase of one movie ticket at any Participating Cinema, will earn you 100 Points.', '7.6.4. The purchase of one movie at Cine Prestige will earn you 200 Points;', '7.6.5. The purchase of one movie at IMAX Theatres will earn you 100 Points.', '7.6.6. Points cannot be earned on the following:', '7.6.6.1. On a Free Ticket purchased with accumulated Points;', '7.6.6.2. On a complimentary ticket or a readmission voucher;', '7.6.6.3. Purchases of tickets of events hosted by third parties;', '* Purchase of HALF price Tuesday tickets (basically, clients who buy HALF Tuesday tickets will not earn points on that movie ticket)', '7.6.6.4. The purchasing of individual (non-combo) confectionary/catering items;', '7.6.6.5. The purchasing of airtime;', '7.6.6.6. The purchasing of 3D glasses;', '7.6.6.7. Error transactions, as a result of fraud, or pursuant to any illegal, ineligible or unauthorised transaction;']
                }, { title: '7.7. Please Note: Your Points will only reflect and be available 24 (twenty-four) hours after earning. You will need to save evidence of your Points entitlement until the Points appear on your Card.' }, {
                    title: '7.8. Members will earn the following Points:',
                    points1: ['7.8.1. Base Points;', '7.8.2. Kick-start Points on Sign-Up;', '7.8.3. Double Points on Thursday when booking a movie ticket;']
                }, { title: '7.9. Extra Points may be earned or awarded at Ster-Kinekor Theatres\' sole discretion.' }, { title: '7.10. If we are offline when you book a ticket and you have presented your Card, we will manually capture your Points and you will still earn Points on the booking.' }, {
                    title: '7.11. Ster-Kinekor Theatres reserves the right to change the earning rate and/or value of Points at any time, at its discretion. Due notice will be given of any changes.',
                    points1: ['7.11.1. Ster-Kinekor Theatres reserves the right to change the conversion value of Points at any time, at its discretion. Notice will be given of any changes.']
                }, {
                    title: '7.12. Statements of Points and Points Balance',
                    points1: ['7.12.1. If you are an active member and you have a Points balance, you can access your statement online.', '7.12.2. You can also check your Points balances online, by calling Customer Care* on 0861 MOVIES (668437), at the Box Office Counter or SST at any Participating Cinema; 7.12.3. It is your duty to check your Points balance. If you find any errors on any of your statements, you must let us know in writing together with documentary evidence as to why you think there is an error within 30 (thirty) days of noticing such error. We will, in our sole discretion, determine whether an error did occur and whether such error will be corrected. We will not be held liable for any undisputed error or omission.']
                }, {
                    title: '7.13. Validity of Points 7.13.1. As mentioned in clause Termination by Ster-Kinekor Theatres and where membership has been terminated by either Ster-Kinekor Theatres or you: above, any inactive and/or unregistered Card will automatically expire at the end of the 12 (twelve) month period and any Points attached to inactive Cards will be forfeited.',
                    points1: ['7.13.2. All Points earned but not redeemed within 12 (twelve) months of being earned will be subject to automatic expiry. Therefore, please ensure you use your points before the 12 (twelve) month period is over. You will receive communication from SK CLUB as a reminder of your Point redemption milestones and expiration timelines. Points balance can also be viewed on an SST or enquiring at any Participating Cinema.', '7.13.3. Points earned where a ticket has been cancelled/refunded for whatever reason will be deducted from your Points balance on your Card.', '7.13.4. Points attached to a lost or damaged Card can be transferred to your new replacement Card provided they have not been spent prior to reporting the lost or damaged Card and obtaining a replacement Card.']
                }, {
                    title: '7.14. Booking a Movie',
                    points1: ['7.14.1. There are many ways to Book a movie and earn Points at Ster-Kinekor Theatres:', '7.14.1.1. At our cinemas (Box Office and SSTs) and swipe your Card; or', '7.14.1.2. Online when entering in your Card number when booking a ticket;', '7.14.1.3. When booking on Customer Care* * on 0861 MOVIES (668437) providing your Card number.', '7.14.2. Certain Booking Fees may be applicable.', '7.14.3. Movie ticket prices differ per Participating Cinema.', '7.14.4. The transaction fee charged for the use of credit cards is between you and your bank and cannot be supplied upfront by Ster-Kinekor Theatres.', '7.14.5. You can Burn Points by booking a movie at Ster-Kinekor Theatres:', '7.14.5.1. At our cinemas (Box Office and SSTs) by simply swiping your Card; or', '7.14.5.2. online when entering in your Card number when booking a ticket. Please note that when burning online, a booking fee is applicable;', '7.14.5.3. Please refer to the below table indicating booking channels, fee\'s applicable and where you burn your Points', '<h4>Booking Channels</h4>\n    \t\t    \t\t\t\t\t<ol>\n        \t\t\t\t\t\t\t\t<li>\n        \t\t\t\t\t\t\t\t\tWebsite\n        \t\t\t\t\t\t\t\t\t<ul class="table-list">\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Booking Fee Applicable</li>\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Member Profile Log In</li>\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Check Points Balance</li>\n        \t\t\t\t\t\t\t\t\t</ul>\n        \t\t\t\t\t\t\t\t</li>\n        \t\t\t\t\t\t\t\t<li>\n        \t\t\t\t\t\t\t\t\tMobi site\n        \t\t\t\t\t\t\t\t\t<ul class="table-list">\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Booking Fee Applicable</li>\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Member Profile Log In</li>\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Check Points Balance</li>\n        \t\t\t\t\t\t\t\t\t</ul>\n        \t\t\t\t\t\t\t\t</li>\n        \t\t\t\t\t\t\t\t<li>\n        \t\t\t\t\t\t\t\t\tApp\n        \t\t\t\t\t\t\t\t\t<ul class="table-list">\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Booking Fee Applicable</li>\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Member Profile Log In</li>\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Check Points Balance</li>\n        \t\t\t\t\t\t\t\t\t</ul>\n        \t\t\t\t\t\t\t\t</li>\n        \t\t\t\t\t\t\t\t<li>\n        \t\t\t\t\t\t\t\t\tCustomer Care\n        \t\t\t\t\t\t\t\t\t<ul class="table-list">\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Booking Fee Applicable</li>\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Check Points Balance</li>\n        \t\t\t\t\t\t\t\t\t</ul>\n        \t\t\t\t\t\t\t\t</li>\n        \t\t\t\t\t\t\t\t<li>\n        \t\t\t\t\t\t\t\t\tFacebook\n        \t\t\t\t\t\t\t\t\t<ul class="table-list">\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Booking Fee Applicable</li>\n        \t\t\t\t\t\t\t\t\t</ul>\n        \t\t\t\t\t\t\t\t</li>\n        \t\t\t\t\t\t\t\t<li>\n        \t\t\t\t\t\t\t\t\tSST\n        \t\t\t\t\t\t\t\t\t<ul class="table-list">\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Complimentary Ticket Redeemable</li>\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Member Profile Log In</li>\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Check Points Balance</li>\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Redeem/Burn Points</li>\n        \t\t\t\t\t\t\t\t\t</ul>\n        \t\t\t\t\t\t\t\t</li>\n        \t\t\t\t\t\t\t\t<li>\n        \t\t\t\t\t\t\t\t\tBox Office\n        \t\t\t\t\t\t\t\t\t<ul class="table-list">\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Complimentary Ticket Redeemable</li>\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Member Profile Log In</li>\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Check Points Balance</li>\n    \t\t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">Redeem/Burn Points</li>\n        \t\t\t\t\t\t\t\t\t</ul>\n        \t\t\t\t\t\t\t\t</li>\n        \t\t\t\t\t\t\t</ol>\n        \t\t\t\t\t\t\tCertain booking fees may be applicable.', '7.14.6. Being a member of the SK CLUB does not guarantee seating or ticket availability.', '7.15. Age restrictions and other terms and conditions related to specific screenings must be adhered to.', '7.15.1. To see the latest movie information, the location of Participating Cinemas, show times and trailers please visit us online.']
                }]
            }, {
                title: '8. SK CLUB REWARDS',
                points: [{
                    title: '8.1. What Rewards are you entitled to?',
                    points1: ['8.1.1. If you sign up as a new member you will be entitled to the following Rewards:', '8.1.1.1. Half price Tuesdays;', '8.1.2. Savings every day on the purchase of movie tickets at any Participating Cinema, including Cine Prestige, Cinema Nouveau, Opera and Live Theatre;', '8.1.3. If you SIGN IN you will be entitled to the following Rewards: (These Rewards do not apply for Seniors + Members)', '8.1.3.1. Half price Tuesdays;', '8.1.3.2. Earn Base Points when you swipe your Card when booking a ticket at a Participating Ster-Kinekor Theatres\xE2\u20AC\u2122 Cinema Complex, including Cine Prestige and IMAX theatre;', '8.1.3.3. Earn Kick-Start Points;', '8.1.3.4. Earn Double Points on Thursdays;', '8.1.3.5. Earn Bonus Points;', '8.1.3.6. Exclusive, Promotions and Competitions;', '8.1.3.7. Exclusive MoviEmail if you agree for us to mail it to you;', '8.1.4. VIP members get the following Rewards:', '8.1.4.1. Half price Tuesdays;', '8.1.4.2. Earn Base Points when you swipe your Card when booking a ticket at a Participating Ster-Kinekor Theatres Cinema Complex, including Cine Prestige;', '8.1.4.3. Earn Kick-Start Points;', '8.1.4.4. Earn Double Points on Thursdays;', '8.1.4.5. Earn Bonus Points;', '8.1.4.6. Exclusive, Promotions and Competitions;', '8.1.4.7. Invitations to Premieres;', '8.1.4.8. A free birthday movie ticket valid on your birthday upon presentation of your ID or automatically when booking via the SST - ONLY for titles a week after release;', '8.1.4.9. Exclusive MoviEmail if you agree for us to mail it to you;', '8.1.5. In order to receive the exclusive rewards, promotions and competitions available monthly to SK CLUB members, you will have to agree to be communicated to in a manner selected on the Membership Pack or online. The Rewards above are only valid on presentation of the Card and are only valid for the member.']
                }]
            }, {
                title: '9. BURNING POINTS AND GETTING REWARDS',
                points: [{ title: '9.1. Only members who produce their Card can burn their Points.' }, { title: '9.2. Once your Points balance reaches a minimum of 1000 Points at any time, you will be able to, but not obliged to burn you\'re Points.' }, {
                    title: '9.3. Points can be burned at Participating cinemas for:',
                    points1: ['9.3.1. Movie tickets including tickets for 3D movies as long has you have enough Points earned. Important note - the price of a 3D ticket excludes the glasses required to watch the movie.']
                }, { title: '9.4. Points can only be burned if you have at least 1000 Points. For more information go online, contact Customer Care* on 0861 MOVIES (668437) or ask our staff at Participating Cinemas.' }, { title: '9.5. Points can be burned at any Participating Cinema irrespective of the movie price, except at IMAX and not for movies during its first week of release;' }, { title: '9.6. All transactions for burning of Points is irrevocable and irreversible.' }, { title: '9.7. If you choose not to burn your Points you can accumulate and save as many as you wish within the Points expiry period of 12 (twelve) months from date of earning.' }, { title: '9.8. You will not be able to burn Points in part and /or combine with any other form of payment i.e. you cannot pay for a ticket with part Points and part cash/credit card payment.' }, { title: '9.9. Your Points balance will be reduced by the equivalent value spent.' }, { title: '9.10. No change will be given on Points burned and used against the purchase of a movie ticket.' }, { title: '9.11. Points and/or the Card cannot be utilised in conjunction with any other special, promotion and/or discount and /or any club or other offerings.' }, { title: '9.12. It is your responsibility to track and redeem your Points balance and activity.' }, { title: '9.13. Ster-Kinekor reserves the right to amend the Rewards from time to time at its sole discretion.' }, { title: '9.14. Points redemption is subject to online system availability. Ster-Kinekor Theatres does not guarantee that its System will always be online and available for Card transactions, and accordingly reserves the right to temporarily reject the tender of any Point redemption if the System is offline.' }]
            }, {
                title: '10. MARKETING AND COMMUNICATION',
                points: [{
                    title: '10.1. Subscribing to communication from Ster-Kinekor Theatres',
                    points1: ['10.1.1. By joining the SK CLUB you give us permission to communicate with you, and you will receive mailers and other communication from Ster-Kinekor Theatres from time to time..', '10.1.2. We will from time to time actively highlight relevant offers for you based on your member profile information. All offers however will be made available to all members through various standard communication channels and platforms.', '10.1.3. Although Ster-Kinekor Theatres will use best endeavours to communicate with you during business hours, by subscribing to receive mailers and other communication from Ster-Kinekor Theatres, you agree that you may receive these at any time of the day or night, specifically, you agree that we may communicate with you on:', '10.1.3.1. Sundays and/or public holidays contemplated in the Public Holidays Act, 1994 (Act No. 36 of 1994);', '10.1.3.2. Saturdays before 09h00 and after 12h00; and', '10.1.3.3. All other days between the hours of 19h00 and 08h00 the following day.', '10.1.4. You hereby confirm that as on the date of joining SK CLUB, you have not registered yourself on any registry in which you have registered a pre-emptive block, either generally or for specific purposes, against any communication that is primarily for the purpose of direct marketing. In the event, that you have registered yourself on such a registry, you hereby confirm that you do not have any objection to receiving mailers and or other communication (promotional or otherwise) from Ster-Kinekor.']
                }, {
                    title: '10.2. Unsubscribing to communication from Ster-Kinekor Theatres',
                    points1: ['10.2.1. If at any time you decide you would rather not receive the mailer and/or other communication from Ster-Kinekor Theatres, please amend this in your profile page or utilise the "unsubscribe" option available at the end of every communication.', '10.2.2. We need to process all unsubscribe communication internally, so you may continue to receive marketing communication for a period of up to 21 (twenty-one) business days after your request.', '10.2.3. Unsubscribing may mean that you won\'t be able to participate fully in the SK CLUB because you won\'t get updates on promotional offers, SK CLUB updates, additional Point earning opportunities and other Rewards that the SK CLUB has to offer.', '10.2.4. If you have received communication in error, please inform us as soon as possible on Customer Care* 0861 MOVIES (668437) so that we can correct the error and prevent any further inconvenience to you.']
                }]
            }, {
                title: '11. LIMITATION OF LIABILITY',
                points: [{ title: '11.1. Subject to the provisions of the Consumer Protection Act number 68 of 2008, Ster-Kinekor Theatres gives no warranties nor do Ster-Kinekor Theatres, and/or each and any of its respective members, employees, contractors, sub-contractors, agents, workmen or representatives (hereinafter referred to as "the Company") accept responsibility or liability for any damage, loss, claim, or other liability or expense of whatever kind or nature, - consequential, special, or otherwise- whether for death, personal injury, loss, damage to property or otherwise, including but not limited to medical claims and legal expenses, or from or in relation to the SK CLUB and/or the use or redemption of any Points and/or any other cause whatsoever and you and any parent and/or guardian of a minor child hereby indemnifies the Company against any such claim as aforementioned and from any cause whatsoever that may be instituted against the Company unless such injury, loss or damage results from the negligence or wilful misconduct of Ster-Kinekor.' }, {
                    title: '11.2. In particular and further to clause Subject to the provisions of the Consumer Protection Act number 68 of 2008, Ster-Kinekor Theatres gives no warranties nor do Ster-Kinekor Theatres, and/or each and any of its respective members, employees, contractors, sub-contractors, agents, workmen or representatives (hereinafter referred to as "the Company") accept responsibility or liability for any damage, loss, claim, or other liability or expense of whatever kind or nature, - consequential, special, or otherwise- whether for death, personal injury, loss, damage to property or otherwise, including but not limited to medical claims and legal expenses, or from or in relation to the SK CLUB and/or the use or redemption of any Points and/or any other cause whatsoever and you and any parent and/or guardian of a minor child hereby indemnifies the Company against any such claim as aforementioned and from any cause whatsoever that may be instituted against the Company unless such injury, loss or damage results from the negligence or wilful misconduct of Ster-Kinekor Theatres. Ster-Kinekor Theatres shall not be liable to any member for:-',
                    points1: ['11.2.1. Termination or suspension of the SK CLUB and/or SK CLUB Card;', '11.2.2. Inability to earn or burn Points due to circumstances beyond its control, such as being off line;', '11.2.3. Any delay in replacing a lost or stolen Card or any unauthorised use of a Card;', '11.2.4. Any failure by you to inform us that a transaction is subject to the SK CLUB;', '11.2.5. The closure of any of our Participating Cinemas on a permanent or temporary basis from time to time for any reason whatsoever;']
                }, { title: '11.3. A force majeure event i.e. any event out of its control;' }, { title: '11.4. Ster-Kinekor Theatres\' total liability for all claims shall not exceed a sum equal to the refund of any unexpired and unused Points on your Card.' }]
            }, {
                title: '12. COMPETITIONS',
                points: [{ title: '12.1. Promotions and Competitions held in terms of the SK CLUB are only open to current members.' }, { title: '12.2. Please see our standard terms and conditions relating to Promotional Competitions as well as the specific terms for each particular Competition.' }]
            }, {
                title: '13. PARTNERS OF THE SK CLUB',
                points: [{ title: '13.1. A SK CLUB Partner may impose additional conditions. Please read each Partner\'s rules regarding the Reward they offer.' }, { title: '13.2. Ster-Kinekor Theatres shall not be bound to or be responsible for any obligations arising from any Rewards offered by a SK CLUB Partner if such SK CLUB Partner breaches its contractual obligations to Ster-Kinekor.' }, { title: '13.3. In order to claim Rewards from SK CLUB Partners, you must present your SK CLUB Card.' }]
            }, {
                title: '14. GENERAL',
                points: [{ title: '14.1. These terms and conditions and any document expressly referred to in them represent the entire agreement between Ster-Kinekor Theatres and you in relation to their subject matter. To the extent permitted by law, all conditions and warranties implied by law, statute or otherwise are expressly excluded. The purchase of any items using the SK Club Card shall be subject to a separate contractual relationship between you and us and is in addition to these terms and conditions.' }, { title: '14.2. The Agreement shall in all respects be governed by and be construed in accordance with the law of the Republic of South Africa and all disputes, actions, and other matters in connection therewith shall be determined in accordance with such law.' }, { title: '14.3. Members shall not have any claim or right of action arising from any undertaking or warranty not included in these terms and conditions. No representations' }, { title: '14.4. Members may not rely on any representation or term express, understood or implied, which allegedly induced them to become a Member of the SK CLUB, unless such representation is recorded herein or in writing and signed by a duly authorised representative on behalf of Ster-Kinekor Theatres.' }, { title: '14.5. If any provision of these terms and conditions is found to be invalid by any Court having competent jurisdiction the invalidity of such provisions shall not affect the validity of the remaining provisions of these terms which shall remain in full force and effect.' }, { title: '14.6. Any indulgence granted by Ster-Kinekor to any member shall not constitute a waiver of its rights against the member and we shall not thereby be precluded from exercising our rights against any member concerned, whether having arisen in the past or arising in the future.' }]
            }, {
                title: '15. QUERIES OR COMPLAINTS',
                points: [{ title: 'If you have any queries or complaints concerning the SK CLUB, your membership, Points, Rewards or your Card please visit your local Participating Ster-Kinekor Theatres Cinema Complex or call Customer Care* on 0861 MOVIES (668437). * Standard Rates Apply - Free Minutes do not apply' }, { title: 'SK CLUB TERMS AND CONDITIONS (Version 2.0 dated NOVEMBER 2016)' }, { title: 'STER-KINEKOR ACTIVATIONS' }, { title: 'SK CLUB ' }, { title: 'SK CLUB SIGN UP ' }]
            }]
        }, {
            name: 'Privacy Policy',
            path: 'privacy-policy',
            copy: 'Primedia Proprietary Limited ("Primedia") and its group companies and any successor operators of its business are sensitive to your privacy interests and believe that the protection of those interests is a significant responsibility. This Privacy Notice explains how we will handle the personal information you provide to us and what we learn about you from your visit to our web site. By using this site, you are agreeing to the terms of this Privacy Notice. If you do not agree to our Privacy Notice then please do not use this site.',
            content: [{
                title: 'What Is Personal Information?',
                points: [{ title: 'In order to provide you with the services offered by Primedia on this site, you may be required by Primedia to provide us with personal information. Personal information is information which identifies you as an individual, including but not limited to, your name, contact details, opinions, IP address, identity number etc.' }]
            }, {
                title: 'How We Obtain Information About You',
                points: [{ title: 'The information we collect about you varies depending upon which part of the website you visit and how you interact with it. Personal information about you may be collected without you being aware of it through your use of the website. In this instance, we do our utmost to ensure that you are aware of the information collected which relates to you, as well as the purpose for which such information is collected.' }]
            }, {
                title: 'Information Which You Are Aware We Collect',
                points: [{ title: 'On our pages you can update personal details, make requests, view information, and submit information and register to receive services or materials. Some of the types of personal information that may be collected on these pages are name; title; place of work; work address; e-mail address; phone number; career category and areas of interest.' }, { title: 'We do not acquire more information about you than is necessary for us to provide our services efficiently.' }]
            }, {
                title: 'What We Do With Your Information',
                summary: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates ex cupiditate, eaque expedita ea ad accusamus assumenda rem. Commodi ratione sunt dolor recusandae, inventore cumque error quod at velit vel!',
                points: [{ title: 'The information which you provide us through the use of our website will be processed purely for the purposes provided to you at the point of collection or in this Privacy Notice, as an example we may use your personal information to contact you regarding career related matters. We ensure all our employees are aware of their responsibilities to protect the privacy of your personal information and we have internal privacy policies and controls in place to safeguard your personal information.' }, { title: 'However, we may on occasion use and transfer your information to our group companies for the following purposes: (a) for business development; (b) market research; (c) to provide you with details of promotions, products, offers and services; (d) to share it between us and our group companies for direct marketing purposes.' }, { title: 'We may need to transfer your information to third parties for purposes of our business operations, however in the instance that the transfer is not for purposes of business operations, we will not transfer your information to other third parties without your consent unless it is required by law.' }, { title: 'Should you provide us with your details on this website and select the option of receiving marketing communication, we accept this as consent for Primedia to utilise your personal information for marketing communication purposes across the group. Each time we send you marketing information by e-mail or SMS text messaging, we will provide an opportunity for you to unsubscribe from receiving further information from us. Please also note that you may have provided your details to any one of our businesses outside of the use of this website, in which instance we may already have permission to provide marketing communications to you.' }]
            }, {
                title: 'Information Which You Are Not Aware We Collect',
                points: [{ title: 'We may use "Cookies" and other types of tracking software in order to personalise your visit to our web site and enhance the experience by gaining a better understanding of your particular interests and customizing our pages for you. A cookie is a message given to a web browser by a web server and which is then stored by Primedia by the browser in a text file. Each time the browser requests a page from the server this message is sent back which enables the user to be identified.' }, { title: 'We may use the information provided by cookies to analyse trends, administer the site, or for research and marketing purposes to help us better serve your interests. If you like, you can set your browser to notify you before you receive a cookie so you have the chance to accept it and you can also set your browser to turn off all cookies. The web site <a href="http://www.allaboutcookies.org">http://www.allaboutcookies.org</a> (run by the Interactive Marketing Bureau) contains step-by-step guidance on how cookies can be switched off by users.' }]
            }, {
                title: 'How We Protect The Information We Process',
                points: [{ title: 'We have implemented privacy and security controls for the purpose of protecting the personal information we collect and to provide for the use thereof within our organisation.' }]
            }, {
                title: 'The Accuracy Of Your Information',
                points: [{ title: 'While we endeavour to ensure that the personal information we hold about you is accurate and, where necessary, kept up to date, we shall assume that in the absence of evidence to the contrary, the personal information you provide us with is accurate. We will provide you with access to your personal information and make every effort to provide you with access to your registration information so that you may view, update or correct your information (see below under heading "Access Rights"). To protect your privacy, we will also take steps to verify your identity before granting you access to your personal information. You may also update or correct your personal information held by Primedia by writing to us at info@Primedia.co.za or at the address provided in the Contact Us section on the site.' }]
            }, {
                title: 'Links',
                points: [{ title: 'Our web-site contains links to other web sites belonging to third parties. We do not control the privacy practices of these other sites. You should therefore ensure, when you leave our site that you have read that third party site\xE2\u20AC\u2122s privacy notice.' }]
            }, {
                title: 'Changes To The Notice',
                points: [{ title: 'We reserve the right, at our sole discretion, to modify, add or remove sections of this Privacy Notice at any time and we will notify you of any changes using the contact details you have provided us or through a publication on this site. Your continued use of this website, following the posting of changes to this Privacy Notice, will be deemed as your acceptance thereof.' }]
            }, {
                title: 'Access Rights',
                points: [{ title: 'You have a right to access the personal data we hold about you. If you wish to obtain a copy of the personal information we retain about you, please contact us on info@sterkinekor.com or 0861 668437.' }]
            }, {
                title: 'Privacy Queries',
                points: [{ title: 'If you have any questions regarding this Privacy Notice, or you wish to update your details, please contact us at info@Primedia.co.za or at the address provided in the Contact Us section on the site.' }]
            }, {
                title: 'Which Laws Apply',
                points: [{ title: 'This Privacy Notice will be governed by the laws of South Africa. You consent to the jurisdiction of the South African courts for any dispute which may arise out of this Privacy Notice.' }]
            }]
        }, {
            name: 'Information Act',
            path: 'information-act',
            content: [{
                title: '1. INTRODUCTION',
                summary: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium sed earum explicabo, quam voluptas nobis, vero maiores deserunt. Illo, natus vitae porro ut nobis sed voluptate doloremque. Illum, fuga, assumenda.',
                points: [{ title: 'This Manual is published in terms of section 51 of the Promotion of Access to Information Act, 2 of 2000. The Act gives effect to the provisions of section 32 of the Constitution, which provides for the right of access to information held by the State and to information held by another person that is required for the exercise and / or protection of any right. ' }, { title: 'The reference to any information in addition to that specifically required in terms of section 51 of the Act does not create any right or entitlement (contractual or otherwise) to receive such information, other than in terms of the Act. ' }, { title: 'This manual applies in respect of each member of the Primedia Group. The Information Officer named below is appointed in respect of the Primedia Group as a whole and in respect of each of the private bodies constituting the Primedia Group. ' }, { title: 'The Primedia Group includes various non-South African entities. Only requests for records of the South African incorporated members of the Primedia Group are covered by the Manual and requests for information or records of, or relating to, nonSouth African entities will not be considered. ' }]
            }, {
                title: '2. DEFINITIONS',
                points: [{
                    title: 'Unless the context clearly indicates otherwise, the following terms shall have the meanings assigned to them hereunder, namely \u2013 ',
                    points1: ['"Act" means the Promotion of Access to Information Act, Act 2 of 2000, as amended from time to time;', '"Data subject" means the person to whom the personal information relates;', '"Information Officer" means the person acting on behalf of the Primedia Group and discharging the duties and responsibilities assigned to the "head" of the Primedia Group by the Act. The Information Officer is duly authorised to act as such and such authorisation has been confirmed by the "head" of the Primedia Group in writing;', '"Manual" means this manual published in compliance with Section 51 of the Act;', '"Primedia Group" means the Primedia Group, comprising of Primedia Holdings Proprietary Limited, Primedia Proprietary Limited and its South African subsidiaries and associated companies and associated entities.  The South African entities comprising the Primedia Group are listed in Annexure 1 to this Manual and this Manual applies to all such South African entities, both jointly and severally, and such entities are referred to both individually and collectively as the "Primedia Group";', '"Personal Information" means information about a data subject\'s race, gender, sex, pregnancy, marital status, nationality, ethnic or social origin, sexual orientation, age, physical or mental health, disability, religion, conscience, belief, culture, language, education, medical information, financial information, criminal or employment history, an identifying number, e-mail address, physical address, telephone number, blood type, biometric information, personal opinions, views or preferences of a data subject; correspondence of a private or confidential nature; and the name of the person if it appears with other Personal Information relating to the data subject;', '"Personnel" means any person who works for or provides services to or on behalf of the Primedia Group and receives or is entitled to receive any remuneration.  This includes, without limitation, directors (both executive and non-executive), all permanent, temporary and part-time staff as well as contract workers;', '"Record" means any recorded information, regardless of form or medium, which is in the possession or under the control of the Primedia Group, irrespective of whether it was created by the Primedia Group;', '"Request" means a request for access to a record of the Primedia Group;', '"Requestor" means any person, including a public body or an official thereof, making a request for access to a record of the  Primedia Group and includes any person acting on behalf of that person; and', '"SAHRC" means the South African Human Rights Commission.', 'Unless a contrary intention clearly appears, words signifying:-', '1. the singular includes the plural and vice versa;', '2. any one gender includes the other genders and vice versa; and', '3. natural persons include juristic person', '"Special Personal Information" means\n        \t\t\t\t\t\t\t\t<ol class="table-list">\n        \t\t\t\t\t\t\t\t\t<li class="table-list__item">the religious or philosophical beliefs, race or ethnic origin, trade union membership, political persuasion, health or sex life or biometric information of a Data Subject; or </li>\n        \t\t\t\t\t\t\t\t\t<li class="table-list__item">the criminal behaviour of a Data Subject to the extent that such information relates  to\u2014 \n        \t\t\t\t\t\t\t\t\t\t<ul class="table-list">\n        \t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">the alleged commission by a Data Subject of any offence; or </li>\n        \t\t\t\t\t\t\t\t\t\t\t<li class="table-list__item">any proceedings in respect of any offence allegedly committed by a Data Subject or the disposal of such proceedings.</li>\n        \t\t\t\t\t\t\t\t\t\t</ul>\n        \t\t\t\t\t\t\t\t\t</li>\n        \t\t\t\t\t\t\t\t</ol>', 'Terms defined in the Act shall have the same meaning in this Manual.']
                }]
            }, {
                title: '3. PRIMEDIA GROUP OVERVIEW',
                points: [{ title: 'The manual was previously filed with the SAHRC in 2003 under the name of Primedia Limited and again in December 2011 following a private equity transaction in 2007. Primedia has undergone a number of restructuring events and the group\'s holding company is now Primedia Holdings Proprietary Limited. Primedia Group is a leading African focused media and advertising Group, targeting premium consumers on the move. It comprises of primary business segments which are constituted on the basis of similar target markets and business models. ' }, { title: 'These business segments are Broadcasting, Out of Home (comprising of Primedia Instore, Primedia Outdoor, Primedia Out of Home Africa, Primedia Unlimited and its businesses) and; Cinema and Entertainment (comprising of Ster-Kinekor Theatres, Ster-Kinekor Entertainment, Primestars Marketing and various Digital assets such as Primedia Online and Spectrum). Under the Primedia For Good banner we have our CSI related business units. ' }, { title: 'The Primedia Group supports the constitutional right of access to information and we are committed to provide you access to our records in accordance with the provisions of the Act, the confidentiality we owe third parties and the principles of our law.' }]
            }, {
                title: '4. AVAILABILITY OF THIS MANUAL',
                points: [{ title: 'A copy of this Manual is available on our website (<a href="http://www.primedia.co.za">www.primedia.co.za</a>) or by sending a request for a copy to the Information Officer by email. The Manual may also be inspected at our head office, subsidiary companies offices and the SAHRC at the respective addresses set out below. This Manual will be updated from time to time, as and when required' }]
            }, {
                title: '5. HOW TO REQUEST ACCESS TO RECORDS HELD BY THE PRIMEDIA GROUP',
                points: [{ title: 'Requests for access to records held by the Primedia Group must be made on the request forms that are available from the SAHRC website (www.sahrc.org.za) or the Department of Justice and Constitutional Development (www.doj.gov.za) (under "regulations"). ' }, { title: 'For the convenience of requestors, copies of such forms are included in the version of this Manual available at our head office and on our website. Please note that requestors are also required to make payment of the prescribed fees. This issue is dealt with more fully below. ' }, { title: 'Requests for access to records must be made to our Information Officer at the address, fax number or electronic mail address provided for below. ' }, { title: 'The requester must provide sufficient detail on the request form to enable the Information Officer to identify the record and the requester. The requester should also indicate which form of access is required and indicate if he or she wishes to be informed in any other manner and state the necessary particulars to be so informed. ' }, { title: 'Requests will be received by the Primedia Group Information Officer as indicated in the prescribed manner detailed below. The requestor will be notified within 30 days of the receipt of the completed request forms. The request will be evaluated by the Primedia Group Information Officer as well as a representative of the business from which the record is being requested. Primedia Group reserves the right to notify the requestor of an extension period that is required to access the requested information. The said notice will include reasons for such extension, the required extension period which will not exceed 60 days as well as the requestor\'s right to approach a court via application proceedings for relief in the event that the requestor is against the extension and/or the procedure. Further to that, the Primedia Group may notify the requestor whether a deposit is required. This deposit will be determined by factors such as, the format and/or volume of the information requested as well as the time required for the searching and preparation of the records. The notice will set out the required deposit amount as well as the requestor\'s right to approach a court via application proceedings for relief in the event that the requestor is against the payment of the required deposit and/or the procedure.' }, { title: 'Where you know which company in the Primedia Group holds the record/s you are requesting, please indicate the name of the company. Where you are unsure which company holds the record/s please provide as much detail as possible about the record to facilitate our search and to avoid any possible delays. Requestors are reminded that Primedia Group can only provide access to records that are in the possession of Primedia Group. ' }, { title: 'The requester must identify the right that he or she is seeking to exercise or protect and provide an explanation of why the requested record is required for the exercise or protection of that right. ' }, { title: 'If a request is made on behalf of a person, the requester must then submit proof, in the form of an affidavit or letter of consent, of the capacity in which the requester is making the request to the satisfaction of the Primedia Group Information Officer. ' }, { title: 'The standard form that must be used for the making of requests is attached as Annexure 2. Not using this form could cause your request to be refused (if you do not provide sufficient information or otherwise) or delayed. ' }, { title: 'The requester is required to pay a fee for evaluating the request and then providing the records requested, including the requirement to pay a deposit in certain circumstances. The list detailing the prescribed fees payable to the Primedia Group in respect of requests and the fees in respect of access to records (if the request is granted) is attached as Annexure 3. ' }, { title: 'Annexures 2 and 3 are included in copies of this Manual available on the Primedia Group website and head office but need not and are not included in the copy of this Manual delivered to the SAHRC. ' }, { title: 'Kindly note that all requests to the Primedia Group or any of its constituent companies will be evaluated and considered in accordance with the Act. Publication of this manual and describing the categories and subject matter of information held by the Primedia Group does not give rise to any rights (in contract or otherwise) to access such information or records except in terms of the Act. ' }, { title: 'If it is reasonably suspected that a requestor has obtained access to the Primedia Group\'s records through the submission of materially false or misleading information, legal proceedings may be instituted against such requestor.' }]
            }, {
                title: '6. Contact details',
                points: [{ title: '<strong>Name of Private Body:</strong> The Primedia Group' }, { title: '<strong>Designated Information Officer:</strong> Essop Sather' }, { title: '<strong>Email address of Information Officer:</strong> info@primedialtd.co.za' }, { title: '<strong>Postal address:</strong>\n        \t\t\t\t\t\t\t\t\t\t<address>\n        \t\t\t\t\t\t\t\t\t\t\t<p>P O Box 652110</p>\n        \t\t\t\t\t\t\t\t\t\t\t<p>Benmore</p>\n        \t\t\t\t\t\t\t\t\t\t\t<p>2010</p>\n        \t\t\t\t\t\t\t\t\t\t</address>\n        \t\t\t\t\t' }, {
                    title: '<strong>Street address:</strong>\n        \t\t\t\t\t\t\t\t\t\t<address>\n        \t\t\t\t\t\t\t\t\t\t\t<p>Primedia Place</p>\n        \t\t\t\t\t\t\t\t\t\t\t<p>5 Gwen Lane (Cnr Fredman Drive)</p>\n        \t\t\t\t\t\t\t\t\t\t\t<p>Sandton</p>\n        \t\t\t\t\t\t\t\t\t\t\t<p>2196</p>\n        \t\t\t\t\t\t\t\t\t\t</address>'
                }, { title: '<strong>Phone number:</strong> 011 506 3136' }, { title: '<strong>Fax number:</strong> 011 506 3185' }]
            }, {
                title: '7. HOW TO ACCESS THE GUIDE AS DESCRIBED IN SECTION 10 OF THE ACT ',
                points: [{ title: 'The Guide can be obtained from the South African Human Rights Commission. Please direct any queries to:   ' }, { title: 'The South African Human Rights Commission: ' }, { title: 'PAIA Unit ' }, { title: 'The Research and Documentation Department' }, {
                    title: '<strong>Postal address:</strong>\n        \t\t\t\t\t\t\t\t\t\t<address>\n        \t\t\t\t\t\t\t\t\t\t\t<p>Private Bag 2700</p>\n        \t\t\t\t\t\t\t\t\t\t\t<p>Houghton</p>\n        \t\t\t\t\t\t\t\t\t\t\t<p>2041</p>\n        \t\t\t\t\t\t\t\t\t\t</address>'
                }, { title: '<strong>Telephone:</strong> +27 11 877-3600' }, { title: '<strong>Fax:</strong> +27 11 403-0625' }, { title: '<strong>Website:</strong> www.sahrc.org.za' }, { title: '<strong>E-mail:</strong> paia@sahrc.org.za' }]
            }, {
                title: '8. VOLUNTARY DISCLOSURE',
                points: [{ title: 'The Primedia Group is not obliged to and has not published a notice in terms of Section 52(2) of the Act. Nevertheless the Primedia Group does make certain information freely available, including the most recent Annual Report of Primedia Holdings Proprietary Limited. Other information relating to the Primedia Group is freely available on the Primedia Group website at www.primedia.co.za. Certain other information relating to the Primedia Group is also made available on such website from time to time as well as on several of the other websites operated by the Primedia Group.' }, { title: 'Certain information is also made available to employees of the Primedia Group, which is not generally made available to the public. To avoid confusion, these items of information are not listed here but may be obtained by Primedia Group employees from any group HR office' }]
            }, {
                title: '9. RECORDS AVAILABLE IN TERMS OF ANY OTHER LEGISLATION',
                points: [{
                    title: 'Information is retained in terms of the following legislation. The information retained in terms of this legislation will only be made available to the persons or entities specified in the legislation:',
                    points1: ['Companies Act 71 of 2008 ', 'Income Tax Act 58 of 1962 ', 'Value Added Tax Act 89 of 1991 ', 'Labour Relations Act 66 of 1995 ', 'Basic Conditions of Employment Act 75 of 1997 ', 'Employment Equity Act 55 of 1998 ', 'Skills Development Act 97 of 1998 ', 'Skills Development Levies Act 9 of 1999 ', 'Unemployment Insurance Act 63 of 2001 ', 'Unemployment Contributions Act 4 of 2002 ', 'Compensation for Occupational Injuries and Health Diseases Act 130 of 1993 ', 'Occupational Health & Safety Act 85 of 1993 ', 'Protection of Businesses Act 99 of 1978 ', 'Regional Services Councils Act 109 of 1985 ', 'Stamp Duties Act 77 of 1968 ', 'Stock Exchanges Control Act 1 of 1985 and the rules and listings requirements of the JSE Securities Exchange authorised in terms thereof ', 'Trade Marks Act 194 of 1993 ', 'The Independent Broadcasting Authority Act 153 of 1993, the Broadcasting Act 4 of 1999 and the licences issued and the regulations prescribed thereunder.']
                }]
            }, {
                title: '10. RECORDS HELD BY THE PRIMEDIA GROUP',
                points: [{ title: 'The Primedia Group maintains records on the following categories and subject matters. However, please note that recording a category or subject matter in this Manual does not imply that a request for access to such records would be granted. ' }, { title: 'All requests for access will be evaluated on a case by case basis in accordance with the provisions of the Act. ' }, { title: 'In the event that there is no extension period or deposit required then the requestor will be notified within 30 days of the outcome of their request. If the request is successful then the requestor will be notified of the access fee payable upon gaining access to the record (if any), an indication of the form in which the access will be granted as well as the a notice of the requestor\'s right to approach a court via application proceedings for relief in the event that the requestor is against the payment of the required access fee and/or the procedure. ' }, { title: 'If the record requested contains information about a third party the Primedia Group is obliged to inform them of such request. This serves to allow the third party the opportunity to respond by either granting consent to the access request or to provide reasons why the request should be denied. The reasons provided by the third party either for consent or denying access will be considered by the Primedia Group Information Officer in making a final decision regarding whether access should be granted or refused. ' }, { title: 'The records are divided into those that are generic to the Primedia Group and those that relate to specific businesses. Notwithstanding that records relate to a specific business, you must still make your request to the Primedia Group Information Officer at the address set out above and not to the business directly. ' }, { title: 'All records in the possession of the Primedia Group that possess Special Personal Information shall only be provided to the person to whom the Personal Information pertains. In the event that the requestor is not the subject of the Special Personal Information then the requestor must submit proof of consent to request such record for their use or on behalf of the data subject. ' }, {
                    title: 'The Primedia Group may legitimately refuse to grant access to records that fall within certain categories. The grounds to refuse access to a particular record/s include: ',
                    points1: ['records contain Personal Information of a third party and must be protected from unreasonable disclosure including records of a deceased person; ', 'records containing third party commercial information that must be protected from unreasonable disclosure; ', 'disclosure of a record would result in a breach of a duty of confidence owed in terms of an agreement to a third party; ', 'disclosure of a record would result in an individual\'s life being endangered; ', 'disclosure of a record would prejudice or impair the security of property; ', 'disclosure of a record would prejudice or impair the protection of a person under witness protection; ', 'disclosure of a record would prejudice or impair public safety; ', 'disclosure of a record is privileged in terms of legal proceedings, unless such privilege has been waived; ', 'disclosure of a record would harm the commercial and financial interests of the group; and ', 'disclosure of a record would put the Primedia Group at a disadvantage in contractual or other negotiations or prejudice it in commercial competition.  ']
                }, { title: 'In the event that the requested record cannot be located and it is believed that the record does not exist or merely cannot be located, then the Primedia Group will inform the requestor by way of affidavit or affirmation of the reason for delay or inability to locate the record.' }]
            }, {
                title: '10.1 GENERIC RECORDS',
                points: [{ title: '10.1.1 Internal records' }, {
                    title: 'The following are records pertaining to the Primedia Group\'s own affairs and those of its constituent companies:',
                    points1: ['Memorandum of Incorporation ', 'Financial records ', 'Operational records ', 'Intellectual property ', 'Marketing records; ', 'Internal correspondence; ', 'Product records; ', 'Statutory records; ', 'Internal policies and procedures; ', 'Records held by officials of the Primedia Group.']
                }, { title: '10.1.2 Personnel records (these records can only be requested by the person the record pertains to)' }, {
                    title: 'Personnel records include the following:',
                    points1: ['Any personal records provided to the Primedia Group by its personnel; ', 'Any records a third party has provided to the Primedia Group about any of its personnel; ', 'Conditions of employment and other personnel-related contractual and quasi-legal records; ', 'Internal evaluation records;  and ', 'Other internal records and correspondence. ']
                }, { title: '10.1.3 Other Parties' }, {
                    title: 'Records are kept in respect of other parties, including without limitation contractors, commercial banks, auditors and consultants, suppliers, joint venture companies and service providers, and general market conditions. In addition, such other parties may possess records which can be said to belong to the Primedia Group. The following records fall under this category:',
                    points1: ['Personnel, customer, or Primedia Group records which are held by another party as opposed to being held by the Primedia Group; and ', 'Records held by the Primedia Group pertaining to other parties, including financial records, correspondence, contractual records, records provided by the other party, and records third parties have provided about the contractors or suppliers.']
                }, { title: '10.1.4 Other Records' }, {
                    title: 'Further records are held including:- ',
                    points1: ['Information relating to the Primedia Group\'s own commercial activities;  and ', 'Research information belonging to the Primedia Group or carried out on behalf of a third party. ']
                }]
            }, {
                title: '10.2 ADVERTISING RELATED RECORDS',
                points: [{ title: '10.2.1 Listener/ Reader/ Viewer-related Records' }, {
                    title: 'Listener/ Reader/ Viewer-related information includes the following:',
                    points1: ['Any records a Listener/Reader/Viewer has provided to the Primedia Group or a third party acting for or on behalf of the Primedia Group; ', 'Any credit records or other research conducted by the Primedia Group in respect of its Listeners/Readers/Viewers or research derived by the Primedia Group from its Listeners/Readers/Viewers and their activities; ', 'Any records a third party has provided to the Primedia Group either directly or indirectly;  and ', 'Records generated by or within the Primedia Group pertaining to the Listeners/Readers/Viewers. ']
                }, { title: '10.2.2 Radio Related Records ' }, {
                    title: 'Specific records are held regarding: ',
                    points1: ['Schedules; ', 'Content; and ', 'Listener provided records.']
                }, { title: '10.2.3 Publishing Related Records' }, {
                    title: 'Specific records are held regarding: ',
                    points1: ['Content (for both own and client publications); and ', 'Subscriber provided information.']
                }]
            }, {
                title: '10.3 CONTENT RELATED RECORDS',
                points: [{ title: '10.3.1 Cinema-attendee-related Records' }, {
                    title: 'Cinema-attendee related information includes the following:',
                    points1: ['Any records a cinema-attendee has provided to the Primedia Group or a third party acting for or on behalf of the Primedia Group; ', 'Any research conducted by the Primedia Group in respect of its cinemaattendees or research derived by the Primedia Group from its cinemaattendees and their activities; ', 'Any records a third party has provided to the Primedia Group either directly or indirectly;  and ', 'Records generated by or within the Primedia Group pertaining to the cinemaattendees. ']
                }, {
                    title: '10.3.2 Filmed Entertainment Related Records',
                    points1: ['Release schedules; ', 'Products; and ', 'Stock.']
                }]
            }, {
                title: 'THE PRIMEDIA GROUP',
                points: [{ title: 'Primedia Holdings Proprietary Limited ' }, { title: 'Primedia (Pty) Limited ' }, { title: 'Prime Talent (Pty) Limited ' }, { title: 'Go Transit (Pty) Limited ' }, { title: 'Primestars Marketing (Pty) Limited ' }, { title: 'Roga Properties (Pty) Limited ' }, { title: 'Xprocure (Pty) Limited ' }, { title: 'Icon Media (Pty) Limited ' }, { title: 'Wideopen Platforms (Pty) Limited ' }, { title: 'Primedia Lifestyle (Pty) Limited ' }, { title: 'Primedia Interactive (Pty) Limited ' }, { title: 'Primall Media (Pty) Limited ' }, { title: 'Primedia Interactive Properties (Pty) Limited ' }, { title: 'Giant Signs (Pty) Limited  ' }, { title: 'Summer Sun Trading (Pty) Limited ' }, { title: 'Primedia Digital (Pty) Limited ' }, { title: 'Primedia Online (Pty) Limited ' }, { title: 'Primedia Events (Pty) Limited ' }, { title: 'New Africa Investments Limited ' }, { title: 'Ruskolor (Pty) Limited ' }, { title: 'Inside Job Productions (Pty) Limited ' }, { title: 'Silly Seasons One (Pty) Limited ' }, { title: 'Silly Seasons Two (Pty) Limited ' }]
            }, {
                title: 'DORMANT',
                points: [{ title: 'Primedia Broadcasting (Proprietary) Limited ' }, { title: 'Cape Talk (Proprietary) Limited ' }, { title: 'Africa On Air (Proprietary) Limited ' }, { title: 'New Africa Media Holdings (Pty) Limited ' }, { title: 'KFM Radio (Pty) Limited ' }, { title: 'Fleetbridge Investments (Pty) Limited ' }, { title: 'WIP Media (Pty) Limited ' }, { title: 'Francolin Investments (Pty) Limited ' }, { title: 'Primedia Outdoor (Proprietary) Limited ' }, { title: 'Cartad In-Store Media (Proprietary) Limited ' }, { title: 'Primedia Face2Face (Proprietary) Limited ' }, { title: 'Primedia Route 2 Marketing (Pty) Limited ' }, { title: 'Primedia Sport (Pty) Limited ' }, { title: 'Signet Licensing & Marketing (Pty) Limited ' }, { title: 'Warwick Hospitality & Events (Pty) Limited ' }, { title: 'Comutanet (Pty) Limited ' }, { title: 'Forecourt Television Networks (Pty) Limited ' }, { title: 'MegaPro Marketing (Pty) Limited ' }, { title: 'Matchworld (Pty) Limited ' }, { title: 'Primovie Management (Pty) Limited ' }, { title: 'Primovie Finance (Pty) Limited ' }, { title: 'Ster-Kinekor Films (Pty) Limited ' }, { title: 'Cinemark (Pty) Limited ' }, { title: 'Beatrixstraat Beleggings (Pty) Limited ' }, { title: 'Primedia Pictures (Pty) Limited ' }, { title: 'Ster Inryteater Vereeniging (Pty) Limited ' }, { title: 'Velskoen Inry-teaters (Edms) Limited ' }, { title: 'Trade Up-Front 151 (Pty) Limited  ' }, { title: 'Workless Data (Pty) Limited  ' }, { title: 'Itransi (Pty) Limited  ' }, { title: 'Fincor Leasing (Pty) Limited  ' }, { title: 'Aconcagua 2 (Pty) Limited ' }, { title: 'Metropolis Transactive Holdings Limited  ' }, { title: 'Wideopen Airports (Pty) Limited ' }, { title: 'Wideopen Leasing (Pty) Limited ' }, { title: 'Primedia Unlimited Middle East (Pty) Limited ' }, { title: 'Mamba Media (Pty) Limited ' }, { title: 'Prezence (Pty) Limited ' }, { title: 'Old Primedia Limited ' }, { title: 'Wild Coast Films (Pty) Limited ' }, { title: 'New Africa Media Films (Pty) Limited ' }, { title: 'New Africa Broadcasting (Pty) Limited ' }, { title: 'ERF 1132 Arcadia (Pty) Limited' }, { title: 'Please note that several of the above named entities are dormant. In some circumstances the Primedia Group continues to trade using the trading name of such dormant entity, but as a division of the Primedia Group or one of its constituents.  When submitting a request, please provide the Information Officer with as much information as possible about the record and the entity to which it relates when making your request to enable the record to be located quickly and efficiently, should your request be granted. ' }]
            }]
        }, {
            name: 'Ster-Kinekor Cookie Policy',
            path: 'cookie-policy',
            copy: 'We use cookies to improve your experience on our site, www.sterkinekor.co.za, and to recommend content that may be of interest to you. You can find out more below about what cookies are, the cookies we use and how to switch them off. Note, by continuing to browse the site, you will be deemed to have accepted our use of cookies (and what we use them for) in accordance with this Privacy Policy and POPI act.',
            content: [{
                title: '1. What are cookies?',
                points: [{ title: 'A cookie is a text file containing small amounts of information which is downloaded to your device when you access a website. The text file is then sent back to our server each time your browser requests a page from the server. This enables us to operate the site more effectively and load the site so that it reflects your personal preferences, based on your previous browsing as well as keywords we may be able to gather from URLs of other websites from which you accessed our website. Cookies can also allow us to do various other things, as explained below.' }]
            }, {
                title: '2. What cookies do we use?',
                summary: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Rem at est nostrum, aut impedit, voluptates sed nesciunt aliquam assumenda placeat ducimus tenetur voluptatem dolore deserunt fuga sequi doloribus aspernatur quis.',
                points: [{
                    title: 'When visiting our site, the following types of cookies may be downloaded to your device:',
                    points1: ['2.a Analytical and Performance Cookies', 'We use analytics service providers for website traffic analysis and reporting. Analytics service providers generate statistical and other information about the use of www.sterkinekor.co.za by using cookies. They allow us to recognise and count the number of visitors and to see how often visitors return to the site, how long they stay and how visitors move around our site when they are using it. This helps us to improve the way our site works.', '2.b Advertising and Targeting Cookies', 'These cookies record your visit to www.sterkinekor.co.za, the pages you have visited and the links you have followed to other sites. We will use this information to try and make our site more relevant to your interests. We may also share this information with our partners, such as other Primedia companies and carefully selected third parties, for this purpose.', 'We also use cookies on our site to help us place relevant Ster-Kinekor Theatres advertising on third party websites when you visit those sites. If you are not happy for us to do this, please see the section of this policy titled "How do I turn cookies off?" below.', '2.c Functionality Cookies', 'We use functional cookies that allow us to remember choices you have made on the site to provide you with a more enhanced user experience by delivering content specific to your interests.', '2.d Third Party Cookies', 'Because we have a strong presence on various social networks, we try and make it as easy as possible to share content and to see what content is popular on those networks. We have added buttons to allow people to easily share to those networks (e.g. Facebook, Twitter and Instagram). When we include these social \'plugins\', it gives those sites the flexibility to use their own cookies. They can\'t read any cookies we set and we can\'t read any cookies they set, however, they allow us to track traffic to and from our website. Although we have enabled a Facebook login function on our site, we never know or track your behaviour as you communicate directly with Facebook, through their plugins on our site.', 'Other sites and services (including, for example, advertising networks and providers of external services like web traffic analysis services) may also use cookies, over which we have no control. These cookies are likely to be analytical/performance cookies or targeting cookies.']
                }]
            }, {
                title: '3. How do I turn cookies off?',
                points: [{ title: 'If you do not wish us to install cookies or you don\'t agree with how we use these cookies, you can change the settings on your internet browser to reject them. For more information please consult the "Help or Settings" section of your browser or visit <a href="http://www.aboutcookies.org">www.aboutcookies.org</a>, <a href="http://www.allaboutcookies.org">www.allaboutcookies.org</a> or <a href="http://optout.aboutads.info/#/">http://optout.aboutads.info</a>. ' }, { title: 'Please note that if you do set your browser to reject cookies, you may not be able to use all of the features on our site.' }]
            }, {
                title: '4. What information do we collect if you sign up for our newsletter?',
                points: [{ title: 'If you want to sign up to receive our newsletter we will collect personal information from you as is necessary for the newsletter service, namely your email address, name and your interests.' }]
            }, {
                title: '5. Will we use your information for marketing?',
                points: [{ title: 'Once you have given your consent to marketing, we may display offers, promotions, products or services on the site which we think will interest you based upon the information we collect from your cookies. ' }, { title: 'However, you may opt-out to direct marketing at any time by contacting us on info@sterkinekor.com  or 0861 668437 or by clicking the unsubscribe link provided in our communications.' }]
            }, {
                title: '6. How else will we use your information?',
                points: [{
                    title: 'We may use your information for the following reasons:',
                    points1: ['To make the website more relevant to you and our other visitors. ', 'To send you our newsletter if you have signed up to receive it', 'To carry out occasional surveys to analyse our user base ', 'To check whether you are eligible for a competition and to contact you if you win', 'To comply with the law', 'As we feel is necessary to prevent illegal activity or to protect our interests']
                }]
            }, {
                title: '7. How long do we keep hold of the information?',
                points: [{ title: 'There are certain reasons that we have to keep hold of some of your information. For instance, we will only keep your information while you are registered with us so that we are able to provide the service to you. ' }, { title: 'The legal obligations in respect of how long we should and can keep your data is always adhered to.' }, { title: 'Note, you can request that we delete your personal information at any time.' }]
            }, {
                title: '8.	Will we share your information with anyone else?',
                points: [{
                    title: 'This will only happen if;',
                    points1: ['We are required to do so to comply with the law or with the directions of the courts or other authorities', 'We feel it is reasonably necessary to prevent illegal activity or to protect our interests', 'We, Primedia Proprietary Limited ("Primedia"), feel that our other companies\u2019 products and services may interest you', 'It helps our trusted third party service providers to provide and improve our service to you or to carry out surveys and user analysis to understand your needs and preferences. ']
                }, { title: 'We contractually require these service providers to keep your personal information safe and secure. These trusted third parties would only be permitted to use your personal information for the purposes we specify.' }]
            }, {
                title: '9.	How will we make sure our site is secure?',
                points: [{ title: 'We follow strict security procedures to manage how your personal information is stored, used, who sees it and to help stop any unauthorised person getting hold of it. All personal information you register with www.sterkinekor.com will be located behind a firewall. ' }, { title: 'We take security extremely seriously but as no system is 100% secure, we can\'t completely guarantee the protection of your personal information, any more than any other organisation can. ' }, { title: 'Therefore, we can\'t accept any liability for the loss, theft or misuse of the personal information which you\'ve registered on our website if there is a security breach. ' }]
            }, {
                title: '10.	Will we transfer any personal information outside of Southern Africa*?',
                points: [{ title: '*Our reference to Southern Africa refers to the following countries; South Africa, Namibia, Zimbabwe & Zambia.' }, { title: 'Countries outside Southern Africa may have a lower standard of protection for personal information than that required by South Africa\u2019s data protection laws (POPI). The information we collect from you may be transferred to, and stored, outside the (including for example in the rest of the African continent, Australasia, EU and the United States) and may also be processed by companies operating outside South Africa who work for us or one of our suppliers. ' }, { title: 'If we need to transfer your data to a company based outside South Africa (e.g. if our hosting company is based in the UK), we\'ll take steps to make sure your personal data is handled in line with the South African POPI act. ' }, { title: 'What about personal information relating to minors?' }, { title: 'Protecting the online privacy of children is especially important to us. If you are under 18 years old, please obtain consent from your parent(s) or guardian before you create your online profile. To find out more, please read our Terms and Conditions.' }]
            }, {
                title: '11.	Are you protected by this policy outside our website?',
                points: [{ title: 'www.sterkinekor.com contains links to other websites. We don\'t have any control over those websites and cannot take any responsibility for any information you give them. Other sites have different privacy and security policies and terms and conditions, so we advise you to read these before using them.' }]
            }, {
                title: '12.	How you can access your information?',
                points: [{ title: 'You have a right to access the personal data we hold about you. If you wish to obtain a copy of the personal information we retain about you, please contact us on info@sterkinekor.com or 0861 668437.' }, { title: 'You are entitled to know whether we or someone else on our behalf is processing the personal information we hold on you; what personal information we hold; details of the purposes for the processing of your personal information; and details of any third party with whom your personal information has been shared. ' }, { title: 'You can also request that we correct any personal information which we hold about you where it is inaccurate.' }, { title: 'We will ask you to provide proof of identity before we show you your personal information so we can prevent unauthorised access.' }]
            }, {
                title: '13.	Talk to us',
                points: [{ title: 'If you have any queries, comments or complaints regarding this Privacy Policy, get in touch with us. You can contact us through the <a href="/contact-us">Contact Us</a> section or at info@sterkinekor.com or 0861 668437.' }]
            }]
        }];
    }
});

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legal"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Legal")])]), _vm._v(" "), (_vm.$breakpoints.xs || _vm.$breakpoints.sm) ? _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-accordian', {
      key: index,
      attrs: {
        "active": _vm.isActive(index)
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.pushRoute(tab)
        }
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('h2', {
      staticClass: "faq__cat-title"
    }, [_vm._v(_vm._s(tab.name))])]), _vm._v(" "), _vm._l((tab.content), function(item, index) {
      return _c('div', {
        key: index,
        attrs: {
          "slot": "content"
        },
        slot: "content"
      }, [_c('sk-panel', _vm._l((tab.content), function(content, index) {
        return _c('sk-layout', {
          key: index,
          attrs: {
            "row": "",
            "wrap": "",
            "reverse": "",
            "align-center": "",
            "gutter-40": ""
          }
        }, [_c('sk-flex', {
          attrs: {
            "xs12": "",
            "sm4": ""
          }
        }, [(content.summary) ? [_c('h3', [_vm._v("Explain in human language")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(content.summary))])] : _vm._e()], 2), _vm._v(" "), _c('sk-flex', {
          class: content.summary ? 'summary' : '',
          attrs: {
            "xs12": "",
            "sm8": ""
          }
        }, [(content.name) ? _c('h2', [_vm._v(_vm._s(content.name))]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(content.title))]), _vm._v(" "), _c('sk-list', {
          staticClass: "legal-list"
        }, _vm._l((content.points), function(point, index) {
          return _c('sk-list-item', {
            key: index
          }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(point.title) + "\n\t\t\t\t\t\t\t\t\t\t\t"), (point.points1) ? _c('sk-list', _vm._l((point.points1), function(item, index) {
            return _c('sk-list-item', {
              key: index
            }, [_vm._v(_vm._s(item))])
          })) : _vm._e()], 1)
        }))], 1)], 1)
      }))], 1)
    })], 2)
  }) : [_c('sk-tabs', [_c('template', {
    slot: "tab-title"
  }, _vm._l((_vm.tabHeadings), function(tab, index) {
    return _c('sk-tab', {
      key: tab.name,
      class: (_vm.activeTab == index ? 'active' : ''),
      attrs: {
        "item": tab.name
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.activeTab = index
        }
      }
    })
  })), _vm._v(" "), _c('template', {
    slot: "tab-content"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return (_vm.activeTab == index) ? _c('sk-panel', {
      key: index
    }, [_c('h2', [_vm._v(_vm._s(tab.name))]), _vm._v(" "), _c('p', {
      staticClass: "legal__copy",
      domProps: {
        "innerHTML": _vm._s(tab.copy)
      }
    }), _vm._v(" "), _vm._l((tab.content), function(content) {
      return _c('sk-layout', {
        key: content.title,
        attrs: {
          "row": "",
          "wrap": "",
          "reverse": "",
          "align-center": "",
          "gutter-40": ""
        }
      }, [_c('sk-flex', {
        attrs: {
          "xs12": "",
          "sm4": ""
        }
      }, [(content.summary) ? [_c('h4', [_vm._v("Explain in human language")]), _vm._v(" "), _c('p', {
        domProps: {
          "innerHTML": _vm._s(content.summary)
        }
      })] : _vm._e()], 2), _vm._v(" "), _c('sk-flex', {
        class: content.summary ? 'summary' : '',
        attrs: {
          "xs12": "",
          "sm8": ""
        }
      }, [(content.name) ? _c('h2', [_vm._v(_vm._s(content.name))]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(content.title))]), _vm._v(" "), _c('sk-list', {
        staticClass: "legal-list"
      }, _vm._l((content.points), function(point, index) {
        return _c('sk-list-item', {
          key: index
        }, [_c('div', {
          domProps: {
            "innerHTML": _vm._s(point.title)
          }
        }), _vm._v(" "), (point.points1) ? _c('sk-list', _vm._l((point.points1), function(item, index) {
          return _c('sk-list-item', {
            key: index,
            domProps: {
              "innerHTML": _vm._s(item)
            }
          })
        })) : _vm._e()], 1)
      }))], 1)], 1)
    })], 2) : _vm._e()
  }))], 2)]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(538),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_meta_data_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);










/* harmony default export */ __webpack_exports__["default"] = ({

    mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_meta_data_js__["a" /* default */]],

    data: function data() {
        return {

            loading: true,
            locationData: null,
            formData: {
                cinema_id: null,
                experienceName: "2D",
                place_query: null,
                selected_time_range: null,
                experiences: [],
                cinema: {},
                experience: {}
            },
            subsCinemas: ["3001", "6121", "6451", "5801", "1691", "1101", "4201", "4231", "1351", "5451", "6101"],
            sessionData: {
                selectedSession: null,
                selectedDate: null
            },
            selectedSessionDate: null,
            regionsRaW: [],
            cinemasNearBy: [],
            movie: null,
            truncAmount: 500,
            signUp: false,
            loadBooking: true,
            festival: null,
            place: '',
            previousCinemaID: null,
            movieCinemas: [],
            loadingContinue: false,
            cancelOrderLoad: false,
            showHandleGenericError: false,
            showHandleNoSeatsAvailableError: false,
            selected_types: [],
            selected_time: null,
            created: true,
            typesForCinemas: [],
            selected_cinema_id: [],
            selected_time_range: null,
            time_tags: [],
            type_groups: [],
            matching_time_tags: [],
            selectedSession: {
                id: null
            },
            dateAndSessionOptionsForSelect: [],
            route_types: [],
            filteredCinemas: [],
            timeRanges: null,
            route_time_range: null,
            first_date_with_time: null,
            first_date_available: null,
            cinemasForTime: null,
            metaExperiences: null,
            first_date_set: false,
            second_date_set: false,
            selectedCinema: null,
            setSelectedType: false,
            selectedDateSet: null,
            user: null,
            guest: true,
            facebookPixelSKShow: false,
            facebookPixelWBShow: false,
            facebookPixelSWShow: false,
            titleSlugSet: false,
            covidConfirm: true,
            injected_movies: "{data:'none'}",
            injected_meta: "{data:'none'}",
            injected_regions: "{data:'none'}",
            injected_cinemas: "{data:'none'}",
            movie_id: null,
            movies: null,
            prerender: false,
            InjectFrontendURL: "https://www.sterkinekor.com",
            blackWidowFloodLightShow: false
        };
    },


    computed: {
        regions: function regions() {
            this.route_types = [];

            if (this.cinemasForTime != null && this.cinemasForTime != undefined) {
                return [{ name: 'Nearby', cinemas: this.cinemasNearBy }, { name: "Cinemas based on your filter", cinemas: this.cinemasForTime }].concat(this.regionsRaW);
            }

            return [{ name: 'Nearby', cinemas: this.cinemasNearBy }].concat(this.regionsRaW);
        },
        selectedCinemaId: function selectedCinemaId() {
            if (this.formData.cinema_id) {
                this.selectedCinema = __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getCinema(this.formData.cinema_id);
            }
            return this.formData.cinema_id ? this.formData.cinema_id : null;
        },
        sessionsForCinema: function sessionsForCinema() {
            var _this = this;

            return this.selectedCinemaId && this.formData.experienceName ? this.movie.cinemas[this.selectedCinemaId].filter(function (s) {
                if (s.show_time != undefined && s.show_time != null) {
                    return ~s.experiences.findIndex(function (e) {
                        return e.name == _this.formData.experienceName.name;
                    }) && !s.show_time.additional.is_passed && (!_this.festival || s.film_festival_id === _this.festival.id);
                } else {
                    return false;
                }
            }) : [];
        },
        experiencesForCinemas: function experiencesForCinemas() {
            return this.movie && this.formData.cinema_id ? this.movie.getExperienceForCinema(this.formData.cinema_id) : [];
        },
        availableDates: function availableDates() {
            var avail = this.sessionsForCinema.reduce(function (c, session) {
                if (session != undefined && session != null) {
                    if (session.show_time != null && session.show_time != undefined) {
                        if (session.show_time.additional != undefined && session.show_time.additional != null) {
                            var obj = {
                                string: session.show_time.additional.string_long_day_of_week + ' ' + session.show_time.additional.string_nth_day + ' ' + session.show_time.additional.string_long_month,
                                show_time: session.show_time
                            };
                            !~c.findIndex(function (c) {
                                return c.string === obj.string;
                            }) && c.push(obj);
                        }
                    }
                }

                return c;
            }, []);

            if (!this.sessionData.selectedDate && avail != undefined && avail != null) {
                if (avail.length > 0) {

                    if (this.formData.experienceName != null && this.formData.experienceName != undefined && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(this.formData.experienceName) == "object") {
                        var dateToSet = this.setAppropriateDate(this.formData.experienceName, avail);
                        if (dateToSet == null) {
                            this.setSelectedDate(__WEBPACK_IMPORTED_MODULE_8_moment___default()(avail[0].show_time.date));
                        }
                    } else {
                        this.setSelectedDate(__WEBPACK_IMPORTED_MODULE_8_moment___default()(avail[0].show_time.date));
                    }
                }
            }

            if (this.$route.params.date) {
                if (avail && avail.length > 0) {
                    var availableDates = [];

                    for (var a = 0; a < avail.length; a++) {
                        availableDates.push(avail[a].show_time.date.format('YYYY-MM-DD').toString());
                    }

                    if (availableDates.indexOf(this.$route.params.date) > -1) {
                        this.setSelectedDate(__WEBPACK_IMPORTED_MODULE_8_moment___default()(this.$route.params.date));
                    } else {
                        this.setSelectedDate(__WEBPACK_IMPORTED_MODULE_8_moment___default()(avail[0].show_time.date));
                    }
                }
            }

            return avail;
        },
        availableSessions: function availableSessions() {
            var _this2 = this;

            var sessions = [];

            sessions = this.sessionsForCinema.filter(function (session) {
                if (session.show_time != undefined && session.show_time != null && _this2.sessionData != null && _this2.sessionData != undefined) {
                    if (session.show_time.date != undefined && session.show_time.date != null && _this2.sessionData.selectedDate != null && _this2.sessionData.selectedDate != undefined) {
                        if (session.show_time.date.format('YYYY-MM-DD') === _this2.sessionData.selectedDate.format('YYYY-MM-DD')) {
                            return true;
                        }

                        return false;
                    }
                }
            });

            return sessions;
        },
        hasSessionSelected: function hasSessionSelected() {
            return !!this.sessionData.selectedSession;
        },
        canBook: function canBook() {
            return !!this.sessionData.selectedSession && this.covidConfirm;
        },
        previousPath: function previousPath() {
            var path = '';

            if (this.$route.params.cinema_id) {
                path += '/cinema/' + this.$route.params.cinema_id;
            }

            if (this.$route.params.types) {
                path += '/type/' + this.$route.params.types;
            }

            if (this.$route.params.date) {
                path += '/dates/' + this.$route.params.date;
            }

            return path !== '' ? path : '/';
        }
    },

    methods: {
        setUser: function setUser() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user().then(function (user) {
                _this3.user = user;
                _this3.guest = user.isGuest();

                if (!user.isGuest() && user.MembershipActivated === false && _this3.first_time) {
                    _this3.cookieActive = false;
                    _this3.showUserActivation = true;
                    _this3.first_time = false;
                } else {
                    _this3.showUserActivation = false;
                }
            });
        },
        truncToggle: function truncToggle(el) {
            if (this.truncAmount < this.movie.synopsis.length) {
                this.truncAmount = this.movie.synopsis.length;
                el.innerHTML = 'Read less';
            } else {
                this.truncAmount = 500;
                el.innerHTML = 'Read more';
            }
        },
        getAsyncData: function getAsyncData() {
            this.metaTitle = this.movie.title;
            this.metaImage = this.movie.poster;
            this.metaDescription = this.movie.synopsis;
            this.metaCanonicalURL = "https://www.sterkinekor.com/details/" + this.movie.id + "/" + this.movie.title_slug;
            var og_url = document.querySelector('meta[name="og:url"]');
            og_url.content = this.metaCanonicalURL;

            var title_tag = document.querySelector('meta[name="title"]');
            title_tag.content = this.movie.title;

            var og_title_tag = document.querySelector('meta[name="og:title"]');
            og_title_tag.content = this.movie.title;

            if (this.movie != undefined && this.movie != null) {
                if (this.movie.opening_date != undefined && this.movie.opening_date != null) {
                    this.schemaDataSrc = {
                        "@context": "http://schema.org",
                        "@type": "Movie",
                        "image": this.movie.poster,
                        "dateCreated": this.movie.opening_date.additional.year + '-' + this.movie.opening_date.additional.month + '-' + this.movie.opening_date.additional.day,
                        "description": this.movie.synopsis,
                        "name": this.movie.title
                    };
                }
            }
            this.$emit('updateHead');
        },


        placeSelected: function placeSelected(place) {
            this.place = place;
            this.getClosestCinema('cinemas/:latitude/:longitude');
        },

        matchClosestCinemas: function matchClosestCinemas(cinemasNearBy) {
            var matchedCineams = [];
            for (var i = 0; i < cinemasNearBy.length; i++) {
                for (var c = 0; c < this.movieCinemas.length; c++) {
                    if (cinemasNearBy[i].id == this.movieCinemas[c]) {
                        matchedCineams.push(cinemasNearBy[i]);
                    }
                }
            }

            return matchedCineams;
        },
        getClosestCinema: function getClosestCinema() {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getCinemasNearBy(this.place.latitude, this.place.longitude).then(function (cinemasNearBy) {

                __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(_this4.matchClosestCinemas(cinemasNearBy)).then(function (cinemas) {
                    if (cinemas != undefined) {
                        _this4.cinemasNearBy = cinemas;
                        _this4.cinemasNearBy.length = 5;
                    }
                });
            });
        },
        getStatus: function getStatus(session) {
            var status = true;
            if (session.seats_available <= 1) {
                status = false;
            }
            return status;
        },
        getStatusString: function getStatusString(session) {
            var status = '';
            if (session.seats_available <= 1) {
                status = 'Sold Out';
            } else if (session.seats_available <= 10) {
                status = 'Limited Seats Available';
            }
            return status;
        },
        resetForm: function resetForm() {
            this.sessionData.selectedDate = null;
            this.sessionData.selectedSession = null;
        },
        setSelectedDateOnRender: function setSelectedDateOnRender(date) {},
        setSelectedDate: function setSelectedDate(date) {
            this.sessionData.selectedDate = this.sessionData.selectedDate === date ? null : date;
            this.selectedSessionDate = null;
            this.sessionData.selectedSession = null;
        },
        setSelectedSession: function setSelectedSession(session) {
            if (this.getStatus(session)) {
                this.sessionData.selectedSession = this.sessionData.selectedSession === session ? null : session;
                this.startOrder();
            }
        },
        startOrder: function startOrder() {
            var _this5 = this;

            this.loading = true;
            window.scroll({ top: 0, left: 0 });

            __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getSessionAvailableSeatCount(this.sessionData.selectedSession.id).then(function (session) {
                var data = session.data;

                if (data.SeatsAvailable != undefined && data.SeatsAvailable > 1) {
                    __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["k" /* OrderService */].newOrder(_this5.sessionData.selectedSession.id, _this5.formData.cinema_id, _this5.$route.params.id).then(function (order) {
                        _this5.$router.push('/booking/1' + (_this5.festival ? '/film-festival/' + _this5.festival.nid : ''));
                    }, function (error) {
                        _this5.showHandleGenericError = true;
                    });
                } else {
                    _this5.showHandleNoSeatsAvailableError = true;
                }
            });
        },
        startDirectOrder: function startDirectOrder(session_id, cinema_id, movie_id) {
            var _this6 = this;

            this.loading = true;
            window.scroll({ top: 0, left: 0 });

            __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getSessionAvailableSeatCount(session_id).then(function (session) {
                var data = session.data;

                if (data.SeatsAvailable != undefined && data.SeatsAvailable > 1) {
                    __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["k" /* OrderService */].newOrder(session_id, cinema_id, movie_id).then(function (order) {
                        _this6.$router.push('/booking/1' + (_this6.festival ? '/film-festival/' + _this6.festival.nid : ''));
                    }, function (error) {
                        _this6.showHandleGenericError = true;
                    });
                } else {
                    _this6.showHandleNoSeatsAvailableError = true;
                }
            });
        },
        toggleSignUp: function toggleSignUp(signUp) {
            this.signUp = signUp[0];
        },
        relatedToMovie: function relatedToMovie(elms, relatedEl, fieldToRelated) {
            var item = null;
            elms.forEach(function (el) {
                if (el[fieldToRelated] == relatedEl.id) {
                    item = el;
                }
                return item;
            });
        },
        getMovies: function getMovies() {
            var _this7 = this;

            this.loading = true;
            window.scroll({ top: 0, left: 0 });
            var cinema_slug = this.$route.params.cinema_id || null;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getRegions(), __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovieDetail(this.$route.params.id, true), __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getCinemaBySlug(cinema_slug)]).then(function (_ref) {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
                    regions = _ref2[0],
                    movieDetails = _ref2[1],
                    region = _ref2[2];

                _this7.formData.cinema = region;
                _this7.selectedCinema = region;
                window.scroll({ top: 0, left: 0 });
                _this7.movie = movieDetails.movie;

                __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["d" /* EcomTrackingService */].doDataLayerProductDetailView(_this7.movie);

                if (region) _this7.formData.cinema_id = region.id;else _this7.formData.cinema_id = 0;
                _this7.related_movies = movieDetails.related.filter(function (m) {
                    return !m.coming_soon && m.id != _this7.movie.id;
                });

                _this7.regionsRaW = regions.findByCinemas(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this7.movie.cinemas));
                _this7.loading = false;


                _this7.getAsyncData();

                if (_this7.movie.promo) {
                    if (_this7.movie.promo.mobile_movie_detail_image) {
                        _this7.movie.promo.srcsets = _this7.movie.promo.mobile_movie_detail_image + ' 700w, ' + _this7.movie.promo.movie_detail_image + ' 2000w';
                    } else {
                        _this7.movie.promo.srcsets = _this7.movie.promo.movie_detail_image + ' 2000w';
                    }
                }

                return _this7.movie;
            });
        },
        backToMovie: function backToMovie() {
            this.showTimeout = false;
            this.loadingContinue = true;
            __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["k" /* OrderService */].tearDown();
            this.showHandleGenericError = false;
            this.$router.go(this.$router.currentRoute);
        },
        goHome: function goHome() {
            this.showTimeout = false;
            this.cancelOrderLoad = true;
            __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["k" /* OrderService */].tearDown();
            this.showHandleGenericError = false;
            this.$router.push('/');
        },
        generateTimeRanges: function generateTimeRanges(movies) {
            var time_tags = [];

            for (var m in movies) {
                for (var t in movies[m].time_tags) {
                    time_tags.push(movies[m].time_tags[t]);
                }
            }

            var unique = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(time_tags)));
            var time_ranges = [];

            for (var i = 1; i <= 24; i++) {
                var hour = 0;
                var next_hour = 0;
                if (i < 10) {
                    hour = "0" + i;
                    if (i < 9) {
                        next_hour = "0" + (i + 1);
                    } else {
                        next_hour = i + 1;
                    }
                } else {
                    hour = i;
                    if (i == 23) {
                        next_hour = "00";
                    } else if (i == 24) {
                        hour = "00";
                        next_hour = "01";
                    } else {
                        next_hour = i + 1;
                    }
                }

                var base_hour = i;

                var partial_time = hour + ":";
                var range = hour + ":00 - " + next_hour + ":00";
                var has_time_slot = false;

                for (var _t in unique) {
                    if (unique[_t] != undefined && typeof unique[_t] === 'string') {
                        if (unique[_t].includes(partial_time)) {
                            has_time_slot = true;
                            break;
                        }
                    }
                }

                if (has_time_slot) {
                    time_ranges.push({ "range": range, "hour": hour, "base_hour": base_hour });
                }
            }

            var groups = this.generateRangeGroups(time_ranges);

            if (this.created) {
                var route_time = this.$route.params.time ? this.$route.params.time : null;

                for (var g in groups) {
                    if (route_time == groups[g].id) {
                        this.selected_time_range = groups[g];
                    }
                }

                this.created = false;
            }

            var groupRanges = { name: "Time", items: groups };

            return groupRanges;
        },
        generateRangeGroups: function generateRangeGroups(time_ranges) {
            var groups = [{
                range: "9:00 to 10:00",
                id: "9am-10am",
                config_ranges: ["09:", "10:"],
                ranges: []
            }, {
                range: "11:30 to 12:30",
                id: "11:30am-12:30pm",
                config_ranges: ["11:", "12:"],
                ranges: []
            }, {
                range: "14:00 to 15:15",
                id: "2pm-3:15pm",
                config_ranges: ["14:", "15:"],
                ranges: []
            }, {
                range: "17:00 to 18:00",
                id: "5pm-6pm",
                config_ranges: ["17:", "18:"],
                ranges: []
            }, {
                range: "19:30 to 20:30",
                id: "7:30pm-8:30pm",
                config_ranges: ["19:", "20:"],
                ranges: []
            }, {
                range: "22:00 to 22:45",
                id: "10pm-10:45pm",
                config_ranges: ["22:"],
                ranges: []
            }];

            for (var t in time_ranges) {
                for (var g in groups) {
                    for (var cr in groups[g].config_ranges) {
                        if (groups[g].config_ranges[cr] == time_ranges[t].hour + ":") {
                            groups[g].ranges.push(time_ranges[t]);
                        }
                    }
                }
            }

            return groups;
        },
        setOptionsFromRoute: function setOptionsFromRoute(movies) {
            var _this8 = this;

            if (this.route_types != undefined && this.route_types != null) {
                if (this.route_types.length > 0) {

                    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([this.gettypesForCinemas()]).then(function (_ref3) {
                        var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref3, 1),
                            types_for_cinemas = _ref4[0];

                        var cinema_type_selected_set = false;
                        for (var tc in types_for_cinemas) {
                            for (var i in types_for_cinemas[tc].items) {
                                for (var rt in _this8.route_types) {
                                    for (var t in _this8.route_types[rt].types) {
                                        if (types_for_cinemas[tc].items[i].name == _this8.route_types[rt].types[t].name) {

                                            if (!cinema_type_selected_set) {
                                                _this8.formData.experienceName = _this8.route_types[rt].types[t];
                                                cinema_type_selected_set = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    });
                }
            }
        },
        generateSelectedRouteCinemaTypes: function generateSelectedRouteCinemaTypes(route_types) {
            var selected_cinema_types = [];
            if (route_types && route_types != undefined && route_types != null) {
                if (route_types.length > 0) {
                    for (var r in route_types) {
                        selected_cinema_types.push({ name: route_types[r].replace("-", " ") });
                    }
                }
            }

            return selected_cinema_types;
        },
        gettypesForCinemas: function gettypesForCinemas() {
            var _this9 = this;

            if (this.movie && this.formData.cinema_id) {
                var selectedType = null;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([this.movie.getExperienceForCinema(this.formData.cinema_id), __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["i" /* MovieMetaService */].getMovieMeta()]).then(function (_ref5) {
                    var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
                        experiences = _ref6[0],
                        meta = _ref6[1];

                    var types = [];

                    for (var e in experiences) {
                        if (experiences[e] != undefined && experiences[e] != null && typeof experiences[e] == "string") {
                            types.push({ name: experiences[e] });
                        }
                    }

                    var route_type_list = [];

                    if (_this9.route_types && _this9.route_types != undefined && _this9.route_types != null && _this9.typesForCinemas != null && _this9.typesForCinemas != undefined) {

                        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["j" /* MovieService */].generateExperienceGroups(meta.experiences)]).then(function (_ref7) {
                            var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref7, 1),
                                groups = _ref8[0];

                            var route_types = [];
                            var set_route_types = [];

                            if (_this9.$route.params.types != null && _this9.$route.params.types != undefined) {
                                route_types = _this9.$route.params.types.split(",");

                                for (var g in groups) {
                                    for (var r in route_types) {
                                        if (groups[g].name == route_types[r]) {
                                            set_route_types.push(groups[g]);
                                        }
                                    }
                                }
                                _this9.route_types = set_route_types;
                            }

                            if (_this9.typesForCinemas.length > 0) {
                                for (var tc in _this9.typesForCinemas) {
                                    if (_this9.typesForCinemas[tc] != undefined && _this9.typesForCinemas[tc] != null) {
                                        for (var t in _this9.typesForCinemas[tc].items) {
                                            if (_this9.typesForCinemas[tc].items[t] != undefined && _this9.typesForCinemas[tc].items[t] != null) {

                                                for (var rt in _this9.route_types) {
                                                    if (_this9.route_types[rt] != undefined && _this9.route_types[rt] != null) {

                                                        for (var ty in _this9.route_types[rt].types) {
                                                            if (_this9.route_types[rt].types[ty] != undefined && _this9.route_types[rt].types[ty] != null) {
                                                                var exists = false;
                                                                if (route_type_list.length > 0) {
                                                                    for (var rtl in route_type_list) {
                                                                        if (route_type_list[rtl] != undefined && route_type_list[rtl] != null) {
                                                                            if (route_type_list[rtl].name == _this9.typesForCinemas[tc].items[t].name) {
                                                                                exists = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }

                                                                if (!exists) {
                                                                    route_type_list.push(_this9.typesForCinemas[tc].items[t]);
                                                                }

                                                                if (_this9.route_types[rt].types[ty].name == _this9.typesForCinemas[tc].items[t].name && selectedType == null) {
                                                                    selectedType = _this9.typesForCinemas[tc].items[t];
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            route_type_list = set_route_types;

                            if (selectedType != null && selectedType != undefined) {
                                _this9.formData.experienceName = selectedType;
                            }

                            if (set_route_types && set_route_types != undefined && set_route_types != null) {
                                var typesBasedOnFilter = [];
                                var otherTypes = [];

                                if (types != undefined && types != null) {
                                    if (types.length > 0) {
                                        for (var tfc in types) {
                                            if (types[tfc] != undefined && types[tfc] != null) {
                                                if (types[tfc].name != undefined && types[tfc].name != null && typeof types[tfc].name == "string") {
                                                    for (var i in set_route_types) {
                                                        if (set_route_types[i] != undefined && set_route_types[i] != null && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(set_route_types[i]) == "object") {
                                                            for (var _g in set_route_types[i].types) {
                                                                if (set_route_types[i].types[_g].name == types[tfc].name) {
                                                                    if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(types[tfc]) == "object") {
                                                                        typesBasedOnFilter.push(types[tfc]);
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }

                                if (typesBasedOnFilter.length > 0 && types != undefined && types != null) {
                                    if (types.length > 0) {
                                        for (var _t2 in types) {
                                            var inTypesBasedOnFilter = false;

                                            if (types[_t2] != undefined && types[_t2] != null) {
                                                for (var tf in typesBasedOnFilter) {
                                                    if (typesBasedOnFilter[tf] != null && typesBasedOnFilter != undefined) {

                                                        if (types[_t2].name == typesBasedOnFilter[tf].name) {
                                                            inTypesBasedOnFilter = true;
                                                        }
                                                    }
                                                }
                                            }

                                            if (!inTypesBasedOnFilter) {
                                                if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(types[_t2]) == "object") {
                                                    var _exists = false;
                                                    if (otherTypes.length > 0) {
                                                        for (var ot in otherTypes) {
                                                            if (otherTypes[ot].name == types[_t2].name) {
                                                                _exists = false;
                                                            }
                                                        }
                                                    }

                                                    if (!_exists) {
                                                        otherTypes.push(types[_t2]);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    otherTypes = types;
                                }

                                if (_this9.route_time_range && _this9.route_time_range != undefined && _this9.route_time_range != null) {
                                    var sessions = [];
                                    var timeMatchedTypes = [];
                                    var timeMatchedTypesOthers = [];
                                    if (_this9.movie.cinemas[_this9.formData.cinema_id] != undefined && _this9.movie.cinemas[_this9.formData.cinema_id] != null) {
                                        sessions = _this9.movie.cinemas[_this9.formData.cinema_id];

                                        if (sessions != undefined && sessions != null) {
                                            if (sessions.length > 0) {
                                                for (var s in sessions) {
                                                    if (sessions[s].time_tag != undefined && sessions[s].time_tag != null && typeof sessions[s].time_tag == "string") {
                                                        if (_this9.route_time_range.config_ranges != undefined && _this9.route_time_range.config_ranges != null) {
                                                            for (var cr in _this9.route_time_range.config_ranges) {

                                                                if (_this9.route_time_range.config_ranges[cr] != undefined && _this9.route_time_range.config_ranges[cr] != null) {
                                                                    if (sessions[s].time_tag.includes(_this9.route_time_range.config_ranges[cr])) {
                                                                        if (route_type_list != null && route_type_list != undefined && route_type_list.length > 0) {

                                                                            for (var _rt in route_type_list) {
                                                                                if (route_type_list[_rt] != undefined && route_type_list[_rt] != undefined) {
                                                                                    for (var rtt in route_type_list[_rt].types) {
                                                                                        if (route_type_list[_rt].types[rtt] != undefined && route_type_list[_rt].types[rtt] != undefined) {
                                                                                            for (var _e in sessions[s].experiences) {
                                                                                                if (sessions[s].experiences[_e] != undefined && sessions[s].experiences[_e] != null) {
                                                                                                    if (route_type_list[_rt].types[rtt].name == sessions[s].experiences[_e].name) {
                                                                                                        timeMatchedTypes[sessions[s].experiences[_e].name] = sessions[s].experiences[_e];
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        } else {
                                                                            for (var _e2 in sessions[s].experiences) {
                                                                                timeMatchedTypes[sessions[s].experiences[_e2].name] = sessions[s].experiences[_e2];
                                                                            }
                                                                        }
                                                                    } else {
                                                                        for (var _e3 in sessions[s].experiences) {
                                                                            var _exists2 = false;
                                                                            if (timeMatchedTypesOthers.length > 0) {
                                                                                for (var tmo in timeMatchedTypesOthers) {
                                                                                    if (timeMatchedTypesOthers[tmo].name == sessions[s].experiences[_e3].name) {
                                                                                        _exists2 = true;
                                                                                    }
                                                                                }
                                                                            }

                                                                            if (!_exists2) {
                                                                                timeMatchedTypesOthers.push(sessions[s].experiences[_e3]);
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }

                                                if (otherTypes.length > 0) {
                                                    for (var _tmo in timeMatchedTypesOthers) {
                                                        var inOtherTypes = false;
                                                        for (var _ot in otherTypes) {
                                                            if (otherTypes[_ot] != null && otherTypes[_ot] != undefined && timeMatchedTypesOthers[_tmo] != undefined && timeMatchedTypesOthers[_tmo] != null) {
                                                                otherTypes[timeMatchedTypesOthers[_tmo].name] = timeMatchedTypesOthers[_tmo];
                                                            }
                                                        }

                                                        if (!inOtherTypes) {
                                                            var _exists3 = false;
                                                            if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(timeMatchedTypesOthers[_tmo]) == "object" && timeMatchedTypesOthers[_tmo] != null && timeMatchedTypesOthers[_tmo] != undefined) {
                                                                for (var _ot2 in otherTypes) {
                                                                    if (otherTypes[_ot2].name == timeMatchedTypesOthers[_tmo].name) {
                                                                        _exists3 = true;
                                                                    }
                                                                }

                                                                if (!_exists3) {
                                                                    otherTypes.push(timeMatchedTypesOthers[_tmo]);
                                                                }
                                                            }
                                                        }
                                                    }
                                                } else {
                                                    otherTypes = timeMatchedTypesOthers;
                                                }

                                                var typesByTimes = [];
                                                var typesByTimesOther = [];

                                                if (typesBasedOnFilter != null && typesBasedOnFilter != undefined && otherTypes != undefined && otherTypes != null) {
                                                    for (var tmt in timeMatchedTypes) {

                                                        if (timeMatchedTypes[tmt] != undefined && timeMatchedTypes[tmt] != null) {
                                                            for (var _ot3 in otherTypes) {
                                                                if (otherTypes[_ot3] != undefined && otherTypes[_ot3] != null) {
                                                                    if (timeMatchedTypes[tmt].name != undefined && timeMatchedTypes[tmt].name != null && typeof timeMatchedTypes[tmt].name == "string") {
                                                                        if (otherTypes[_ot3].name != undefined && otherTypes[_ot3].name != null && typeof otherTypes[_ot3].name == "string") {
                                                                            if (timeMatchedTypes[tmt].name == otherTypes[_ot3].name) {
                                                                                typesByTimes[timeMatchedTypes[tmt].name] = timeMatchedTypes[tmt];
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }

                                                            for (var _ot4 in typesBasedOnFilter) {
                                                                if (typesBasedOnFilter[_ot4] != undefined && typesBasedOnFilter[_ot4] != null) {
                                                                    if (timeMatchedTypes[tmt].name != undefined && timeMatchedTypes[tmt].name != null && typeof timeMatchedTypes[tmt].name == "string") {
                                                                        if (typesBasedOnFilter[_ot4].name != undefined && typesBasedOnFilter[_ot4].name != null && typeof typesBasedOnFilter[_ot4].name == "string") {
                                                                            if (timeMatchedTypes[tmt].name == typesBasedOnFilter[_ot4].name) {
                                                                                if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(timeMatchedTypes[tmt]) == "object") {
                                                                                    typesByTimes[timeMatchedTypes[tmt].name] = timeMatchedTypes[tmt];
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }

                                                    var typesOther = [];
                                                    var availableTypes = [];

                                                    if (otherTypes.length > 0) {
                                                        for (var _ot5 in otherTypes) {
                                                            var inAvailable = false;

                                                            for (var tbt in typesByTimes) {
                                                                if (typesByTimes[tbt] != null && typesByTimes[tbt] != undefined && otherTypes[_ot5] != undefined && otherTypes[_ot5] != null) {
                                                                    if (typesByTimes[tbt].name == otherTypes[_ot5].name) {
                                                                        inAvailable = true;
                                                                    }
                                                                }
                                                            }

                                                            if (!inAvailable) {
                                                                typesOther.push(otherTypes[_ot5]);
                                                            }
                                                        }

                                                        otherTypes = typesOther;
                                                    }

                                                    for (var _tbt in typesByTimes) {
                                                        if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(typesByTimes[_tbt]) == "object") {
                                                            availableTypes.push(typesByTimes[_tbt]);
                                                        }
                                                    }

                                                    typesBasedOnFilter = availableTypes;
                                                }
                                            }
                                        }
                                    }
                                }

                                if (_this9.formData.experienceName == null || _this9.formData.experienceName == undefined) {
                                    var setDefaultType = false;

                                    if (typesBasedOnFilter != undefined && typesBasedOnFilter != null) {
                                        if (typesBasedOnFilter.length > 0) {
                                            for (var _t3 in typesBasedOnFilter) {
                                                if (!setDefaultType) {
                                                    _this9.formData.experienceName = typesBasedOnFilter[_t3];
                                                    setDefaultType = true;
                                                }
                                            }
                                        }
                                    }

                                    if (otherTypes && !setDefaultType && otherTypes != undefined && otherTypes != null) {
                                        for (var _t4 in otherTypes) {
                                            if (!setDefaultType) {
                                                _this9.formData.experienceName = otherTypes[_t4];
                                            }
                                        }
                                    }
                                }

                                var cleanOthers = [];
                                var cleanFiltered = [];

                                if (otherTypes.length > 0) {
                                    for (var _ot6 in otherTypes) {
                                        var _exists4 = false;
                                        if (cleanOthers.length > 0) {
                                            for (var co in cleanOthers) {
                                                if (cleanOthers[co].name == otherTypes[_ot6].name) {
                                                    _exists4 = true;
                                                }
                                            }
                                        }

                                        if (!_exists4) {
                                            if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(otherTypes[_ot6]) == "object") {
                                                cleanOthers.push(otherTypes[_ot6]);
                                            }
                                        }
                                    }

                                    otherTypes = cleanOthers;
                                }

                                if (typesBasedOnFilter.length > 0) {
                                    for (var _tf in typesBasedOnFilter) {
                                        var _exists5 = false;

                                        if (cleanFiltered.length > 0) {
                                            for (var cf in cleanFiltered) {
                                                if (cleanFiltered[cf].name == typesBasedOnFilter[_tf].name) {
                                                    _exists5 = true;
                                                }
                                            }
                                        }

                                        if (!_exists5) {
                                            if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(typesBasedOnFilter[_tf]) == "object") {
                                                cleanFiltered.push(typesBasedOnFilter[_tf]);
                                            }
                                        }
                                    }

                                    typesBasedOnFilter = cleanFiltered;
                                    if (_this9.route_types) {
                                        if (_this9.route_types.length == 0) {
                                            _this9.formData.experienceName = typesBasedOnFilter[0];
                                        }
                                    }
                                }

                                _this9.typesForCinemas = [{ name: "Cinema types based on filter", items: typesBasedOnFilter }, { name: "Other cinema types", items: otherTypes }];
                                return _this9.typesForCinemas;
                            }
                        });
                    }

                    _this9.typesForCinemas = [{ name: "Cinema Types", items: types }];
                    return _this9.typesForCinemas;
                });

                this.setSelectedType = true;
            } else {
                this.typesForCinemas = [];
                return [];
            }
        },
        getSessionsForCinema: function getSessionsForCinema() {
            this.Movie;
        },
        getDatesForCinemaType: function getDatesForCinemaType() {
            var _this10 = this;

            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovies()).then(function (movies) {
                __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["j" /* MovieService */].generateTimeRanges()).then(function (time_ranges) {
                    var sessionSelections = [];
                    var sessionOptions = [];
                    var filteredOptions = { name: "Shows based on your filters", items: [] };

                    for (var ad in _this10.availableDates) {
                        var sessionsForDate = _this10.getAvailableSessionsForDate(_this10.availableDates[ad]);

                        var timestamp = null;
                        if (_this10.availableDates[ad].show_time != undefined && _this10.availableDates[ad].show_time != null) {
                            if (_this10.availableDates[ad].show_time.timestamp != undefined && _this10.availableDates[ad].show_time.timestamp != null) {
                                timestamp = _this10.availableDates[ad].show_time.timestamp;
                            }
                        }

                        var DatesData = { name: _this10.availableDates[ad].string, timestamp: timestamp, items: [] };
                        for (var s in sessionsForDate) {
                            if (sessionsForDate[s] != undefined && sessionsForDate[s] != null) {
                                if (sessionsForDate[s].show_time != undefined && sessionsForDate[s].show_time != null) {
                                    var item = { id: sessionsForDate[s].id, name: sessionsForDate[s].show_time.additional.no_zero_hour_24 + ":" + sessionsForDate[s].show_time.additional.minute + " (" + sessionsForDate[s].screen_name + ")", time_tag: sessionsForDate[s].time_tag };
                                    if (_this10.selected_time_range) {
                                        if (sessionsForDate[s].time_tag != undefined && sessionsForDate[s].time_tag != null && typeof sessionsForDate[s].time_tag == "string") {
                                            if (sessionsForDate[s].time_tag.includes(_this10.selected_time_range.hour)) {
                                                var filter_item = { id: sessionsForDate[s].id, name: _this10.availableDates[ad].string + " @ " + sessionsForDate[s].show_time.additional.no_zero_hour_24 + ":" + sessionsForDate[s].show_time.additional.minute + " (" + sessionsForDate[s].screen_name + ")", time_tag: sessionsForDate[s].time_tag };
                                                filteredOptions.items.push(filter_item);
                                            } else {
                                                DatesData.items.push(item);
                                            }
                                        }
                                    } else {
                                        DatesData.items.push(item);
                                    }
                                }
                            }
                        }

                        sessionOptions.push(DatesData);
                    }

                    sessionSelections.push(filteredOptions);
                    for (var so in sessionOptions) {
                        sessionSelections.push(sessionOptions[so]);
                    }

                    _this10.dateAndSessionOptionsForSelect = sessionSelections;
                });
            });
        },
        getAvailableSessionsForDate: function getAvailableSessionsForDate(date) {
            var sessions = this.sessionsForCinema.filter(function (session) {
                if (session != undefined && session != null && date != undefined && date != null) {
                    if (session.show_time != null && session.show_time != undefined && date.show_time != undefined && date.show_time != null) {
                        if (session.show_time.date != null && session.show_time.date != undefined && date.show_time.date != null && date.show_time != undefined) {
                            if (session.show_time.date.format('YYYY-MM-DD') === date.show_time.date.format('YYYY-MM-DD')) {
                                return true;
                            }
                        }
                    }
                }

                return false;
            });

            for (var s in sessions) {
                if (this.selected_time_range) {
                    for (var t in this.selected_time_range.ranges) {
                        if (sessions[s].time_tag != undefined && sessions[s].time_tag != null && typeof sessions[s].time_tag == "string") {
                            if (sessions[s].time_tag.includes(this.selected_time_range.ranges[t].hour + ":")) {
                                this.matching_time_tags.push(sessions[s].time_tag);
                            }
                        }
                    }
                }
            }

            return sessions;
        },
        generateExperienceGroups: function generateExperienceGroups(experiences) {
            var group_config = [{
                name: "2D",
                types: ["2D", "2D Prestige", "2D Kids", "2D DBOX OR 2D"]
            }, {
                name: "3D",
                types: ["3D", "3D IMAX", "3D Prestige", "3D DBOX OR 3D"]
            }, {
                name: "IMAX",
                types: ["3D IMAX", "2D IMAX"]
            }, {
                name: "Prestige",
                types: ["2D Prestige", "3D Prestige"]
            }, {
                name: "Kids",
                types: ["2D Kids"]
            }, {
                name: "DBOX",
                types: ["2D DBOX OR DEBOX", "3D DBOX OR 3D"]
            }, {
                name: "Nouveau",
                types: ["Nouveau", "nouveau", "Nouveau 2D"]
            }, {
                name: "Subs",
                types: ["2D SUBS", "3D SUBS"]
            }];

            var groups = [];

            for (var gc in group_config) {
                var group = { name: group_config[gc].name, types: [] };
                for (var t in group_config[gc].types) {
                    for (var e in experiences) {
                        if (experiences[e] != undefined && experiences[e]) if (experiences[e].name.trim() == group_config[gc].types[t]) {
                            group.types.push(experiences[e]);
                        }
                    }
                }

                var exists = false;
                for (var g in groups) {
                    if (groups[g].name == group.name) {
                        exists = true;
                    }
                }

                if (!exists) {
                    groups.push(group);
                }
            }

            this.type_groups = groups;

            if (this.$route.params.types && this.$route.params.types != undefined && this.$route.params.types != null) {
                var route_types = this.$route.params.types.split(",");

                for (var _g2 in groups) {
                    for (var r in route_types) {
                        if (groups[_g2].name == route_types[r]) {
                            this.route_types.push(groups[_g2]);
                        }
                    }
                }
            }

            return groups;
        },
        getCinemasForTypes: function getCinemasForTypes(movies, type_groups) {
            var cinemas = [];
            if (this.movie != null) {
                for (var m in movies) {
                    if (movies[m].id == this.movie.id) {
                        for (var c in movies[m].cinemas) {
                            for (var s in movies[m].cinemas[c]) {
                                for (var e in movies[m].cinemas[c][s].experiences) {
                                    for (var g in type_groups) {
                                        for (var t in type_groups[g].types) {
                                            var exists = false;

                                            if (movies[m].cinemas[c][s].experiences[e].name != undefined && movies[m].cinemas[c][s].experiences[e].name != null && typeof movies[m].cinemas[c][s].experiences[e].name == "string") {
                                                if (type_groups[g].types[t].name == movies[m].cinemas[c][s].experiences[e].name) {
                                                    if (cinemas != undefined && cinemas != null) {
                                                        if (cinemas.length > 0) {
                                                            for (var ct in cinemas) {
                                                                if (cinemas[ct].id == movies[m].cinemas[c][s].cinema.id) {
                                                                    exists = true;
                                                                }
                                                            }
                                                        }
                                                    }

                                                    if (!exists) {
                                                        cinemas.push(movies[m].cinemas[c][s].cinema);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                return cinemas;
            }
        },
        regionsForThisMovie: function regionsForThisMovie(thisMovie, time_ranges) {
            if (thisMovie.cinemas != undefined && thisMovie.cinemas != null) {
                var cinemasForTime = [];
                var cinemasForType = [];
                var cinemas = {};

                for (var c in thisMovie.cinemas) {
                    if (thisMovie.cinemas[c] != undefined && thisMovie.cinemas[c] != null) {
                        for (var s in thisMovie.cinemas[c]) {
                            if (thisMovie.cinemas[c][s] != undefined && thisMovie.cinemas[c][s] != null) {
                                if (this.route_time_range != undefined && this.route_time_range != null) {
                                    if (this.route_time_range.config_ranges != undefined && this.route_time_range.config_ranges != null) {
                                        for (var cr in this.route_time_range.config_ranges) {
                                            if (this.route_time_range.config_ranges[cr] != undefined && this.route_time_range.config_ranges[cr] != null && typeof this.route_time_range.config_ranges[cr] == "string") {
                                                if (thisMovie.cinemas[c][s].time_tag != undefined && thisMovie.cinemas[c][s].time_tag != null && typeof thisMovie.cinemas[c][s].time_tag == "string") {

                                                    if (thisMovie.cinemas[c][s].time_tag.includes(this.route_time_range.config_ranges[cr])) {
                                                        if (this.route_types != undefined && this.route_types != null && this.route_types.length > 0) {
                                                            for (var rt in this.route_types) {
                                                                if (this.route_types[rt] != undefined && this.route_types[rt] != null) {
                                                                    for (var t in this.route_types[rt].types) {
                                                                        if (this.route_types[rt].types[t] != undefined && this.route_types[rt].types[t] != null) {
                                                                            for (var e in thisMovie.cinemas[c][s].experiences) {
                                                                                if (thisMovie.cinemas[c][s].experiences[e] != undefined && thisMovie.cinemas[c][s].experiences[e] != null) {
                                                                                    if (this.route_types[rt].types[t].name == thisMovie.cinemas[c][s].experiences[e].name) {
                                                                                        cinemas[thisMovie.cinemas[c][s].cinema.id] = thisMovie.cinemas[c][s].cinema;
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        } else {
                                                            var exists = false;
                                                            if (cinemasForTime != undefined && cinemasForTime != null) {
                                                                if (cinemasForTime.length > 0) {
                                                                    for (var cft in cinemasForTime) {
                                                                        if (cinemasForTime[cft] != undefined && cinemasForTime[cft] != null) {
                                                                            if (cinemasForTime[cft].id == thisMovie.cinemas[c][s].cinema.id) {
                                                                                exists = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }

                                                            if (!exists) {
                                                                cinemasForTime.push(thisMovie.cinemas[c][s].cinema);
                                                                cinemas[thisMovie.cinemas[c][s].cinema.id] = thisMovie.cinemas[c][s].cinema;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }

                                if (this.route_types != undefined && this.route_types != null) {
                                    for (var _rt2 in this.route_types) {
                                        if (this.route_types[_rt2] != undefined && this.route_types[_rt2] != null) {
                                            for (var _t5 in this.route_types[_rt2].types) {
                                                if (this.route_types[_rt2].types[_t5] != undefined && this.route_types[_rt2].types[_t5] != null) {
                                                    for (var _e4 in thisMovie.cinemas[c][s].experiences) {
                                                        if (thisMovie.cinemas[c][s].experiences[_e4] != undefined && thisMovie.cinemas[c][s].experiences[_e4] != null) {
                                                            if (this.route_types[_rt2].types[_t5].name == thisMovie.cinemas[c][s].experiences[_e4].name) {
                                                                cinemas[thisMovie.cinemas[c][s].cinema.id] = thisMovie.cinemas[c][s].cinema;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                var cinemasFiltered = [];
                for (var oc in cinemas) {
                    cinemasFiltered.push(cinemas[oc]);
                }
                this.cinemasForTime = cinemasFiltered;
            }
        },
        compareSessionDates: function compareSessionDates(session_show_time, selectedDate_show_time, second_show_time) {
            return false;
        },
        compareDates: function compareDates(session_show, selected_date) {
            if (session_show != null && selected_date != null) {
                if (session_show.format('YYYY-MM-DD') == selected_date.format('YYYY-MM-DD')) {
                    return true;
                }
            }

            return false;
        },
        setAppropriateDate: function setAppropriateDate(experience, availableDates) {
            var time_range = null;
            var set_date = true;
            if (this.route_time_range != undefined && this.route_time_range != null) {
                if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(this.route_time_range) == "object") {
                    time_range = this.route_time_range;
                }
            }

            var DatetoSet = null;
            for (var ad in availableDates) {
                var sessions = this.getAvailableSessionsForDate(availableDates[ad]);

                if (sessions != undefined && sessions != null) {
                    if (sessions.length > 0) {
                        for (var s in sessions) {
                            if (time_range != null) {
                                for (var tr in time_range.config_ranges) {
                                    if (time_range.config_ranges[tr] != undefined && time_range.config_ranges[tr] != null && typeof time_range.config_ranges[tr] == "string") {
                                        if (sessions[s].time_tag != undefined && sessions[s].time_tag != null && typeof sessions[s].time_tag == "string") {

                                            if (sessions[s].time_tag.includes(time_range.config_ranges[tr])) {

                                                for (var e in sessions[s].experiences) {
                                                    if (sessions[s].experiences != null && sessions[s].experiences != undefined) {
                                                        if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(sessions[s].experiences) == "object") {

                                                            if (sessions[s].experiences[e].name == experience.name && set_date) {
                                                                this.setSelectedDate(sessions[s].show_time.date);
                                                                DatetoSet = sessions[s].show_time.date.format('YYYY/MM/DD');
                                                                set_date = false;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            } else {
                                for (var _e5 in sessions[s].experiences) {
                                    if (sessions[s].experiences != null && sessions[s].experiences != undefined) {
                                        if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(sessions[s].experiences) == "object") {
                                            if (sessions[s].experiences[_e5].name == experience.name && set_date) {
                                                this.setSelectedDate(sessions[s].show_time.date);
                                                DatetoSet = sessions[s].show_time.date;
                                                set_date = false;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return DatetoSet;
        },
        facebookPixelSK: function facebookPixelSK(thisMovie) {
            return false;
        },
        facebookPixelWB: function facebookPixelWB(thisMovie) {
            return false;
        },
        facebookPixelStarWars: function facebookPixelStarWars(thisMovie) {
            return false;
        },
        floodlightBlackWidow: function floodlightBlackWidow(thisMovie) {
            return false;
        }
    },

    watch: {
        formData: {
            handler: function handler(n) {
                var _this11 = this;

                this.resetForm();
                this.selectedDateSet = null;

                this.first_date_set = false;
                this.second_date_set = false;
                this.setSelectedType = false;
                this.selectedSessionDate = null;


                if (this.previousCinemaID != n.cinema_id) {
                    var setExperience = true;
                    if (this.$route.params.experiences) {
                        var availableExperiences = this.experiencesForCinemas.filter(function (e) {
                            return ~_this11.$route.params.experiences.indexOf(e);
                        });
                        if (availableExperiences != null && availableExperiences != undefined) {
                            if (availableExperiences.length > 0) {
                                this.formData.experienceName = availableExperiences[0];
                                this.setAppropriateDate(availableExperiences[0]);
                                setExperience = false;
                            }
                        }
                    }
                    if (setExperience) {
                        this.formData.experienceName = null;
                        if (this.experiencesForCinemas != undefined && this.experiencesForCinemas != null) {
                            if (this.experiencesForCinemas.length > 0) {
                                this.formData.experienceName = { name: this.experiencesForCinemas[0] };
                                this.setAppropriateDate(this.formData.experienceName);
                            }
                        }

                        this.first_date_set = false;
                    }
                }

                this.getDatesForCinemaType();

                this.previousCinemaID = n.cinema_id;
                if (this.formData.cinema != undefined && this.formData.cinema != null) {
                    this.formData.cinema_id = this.formData.cinema.id;
                }
                if (this.formData.cinema_id) {
                    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getCinema(this.formData.cinema_id)).then(function (cinema) {
                        _this11.selectedCinema = cinema;
                    });

                    this.selected_cinema_id = this.formData.cinema_id;
                    window.scroll({ top: 400, left: 0, behavior: 'smooth' });
                }
            },

            deep: true
        },

        selectedSession: {
            handler: function handler(n) {
                if (this.availableDates != undefined && this.availableDates != null) {
                    for (var ad in this.availableDates) {
                        if (this.availableDates[ad] != null && this.availableDates[ad] != undefined) {
                            var sessionsForDate = this.getAvailableSessionsForDate(this.availableDates[ad]);
                            if (sessionsForDate != null && sessionsForDate != undefined) {

                                for (var s in sessionsForDate) {
                                    if (sessionsForDate[s] != undefined && sessionsForDate[s] != null && this.selectedSession != null && this.selectedSession != undefined) {
                                        if (sessionsForDate[s].id != null && sessionsForDate[s] != undefined && this.selectedSession.id != null && this.selectedSession.id != undefined) {
                                            if (sessionsForDate[s].id == this.selectedSession.id) {
                                                this.sessionData.selectedSession = sessionsForDate[s];
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },

            deep: true
        },

        selected_cinema_id: {
            handler: function handler(n) {
                this.formData.cinema_id = this.selected_cinema_id;
                this.selectedCinema = __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getCinema(this.selected_cinema_id);
                this.selectedSession = { id: null };
                this.sessionData.selectedSession = {};
                this.gettypesForCinemas();
            },

            deep: true
        },

        '$route': function $route(to, from) {
            if (from === '/nouveau') {
                this.$root.$el.classList.add('nouveau');
            } else {
                this.$root.$el.classList.remove('nouveau');
            }
            if (from.name.indexOf('Movie Details') > -1) this.getMovies();
        }
    },

    created: function created() {
        var _this12 = this;

        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["i" /* MovieMetaService */].getMovieMeta()]).then(function (_ref9) {
            var _ref10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref9, 1),
                meta = _ref10[0];

            var movie_id = _this12.$route.params.id;
            var expired = meta.expired_movies;

            if (expired && expired.length > 0) {
                for (var i = 0; i <= expired.length; i++) {
                    if (expired[i] != undefined) {
                        if (movie_id == expired[i].field_movie_id) {
                            window.location.replace(_this12.InjectFrontendURL + "/middleware/redirect-url/movies/" + expired[i].field_movie_id);
                        }
                    }
                }
            }
        });

        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([this.getMovies(), __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovies(), __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["i" /* MovieMetaService */].getMovieMeta(), this.setUser()]).then(function (_ref11) {
            var _ref12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref11, 4),
                thisMovie = _ref12[0],
                movies = _ref12[1],
                meta = _ref12[2],
                user = _ref12[3];

            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["j" /* MovieService */].generateTimeRanges(), _this12.generateTimeRanges(movies.data), _this12.generateRangeGroups(), __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["j" /* MovieService */].generateExperienceGroups(meta.experiences)]).then(function (_ref13) {
                var _ref14 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref13, 4),
                    time_ranges = _ref14[0],
                    mtime = _ref14[1],
                    groups = _ref14[2],
                    type_groups = _ref14[3];

                __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([_this12.setOptionsFromRoute(movies.data, time_ranges), _this12.gettypesForCinemas(), _this12.getDatesForCinemaType()]).then(function (_ref15) {
                    var _ref16 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref15, 3),
                        filter_data = _ref16[0],
                        types_for_cinemas = _ref16[1],
                        dates_for_types = _ref16[2];

                    if (_this12.$route.params.title == undefined || _this12.$route.params.title == null) {
                        if (_this12.$route.params.festival_id == undefined || _this12.$route.params.festival_id == null) {
                            _this12.titleSlugSet = false;

                            _this12.$router.push({ path: _this12.$route.path + "/" + thisMovie.title_slug, redirectParams: { responseCode: 301 } });
                        }
                    } else {
                        if (_this12.$route.params.title != undefined && _this12.$route.params.title != null) {
                            _this12.titleSlugSet = true;
                        }
                    }

                    _this12.metaExperiences = meta.experiences;
                    _this12.type_groups = type_groups;
                    _this12.timeRanges = time_ranges;
                    var first_date_with_time = null;
                    var first_date_available = null;
                    if (_this12.$route.params.time != undefined && _this12.$route.params.time != null) {

                        for (var t in time_ranges.items) {
                            if (time_ranges.items[t] != undefined && time_ranges.items[t] != null) {
                                if (time_ranges.items[t].id == _this12.$route.params.time) {
                                    _this12.route_time_range = time_ranges.items[t];
                                    var dates = _this12.dateAndSessionOptionsForSelect;

                                    for (var d in dates) {
                                        if (dates[d] != undefined && dates[d] != null) {
                                            for (var i in dates[d].items) {
                                                if (dates[d].items != undefined && dates[d].items != null) {
                                                    if (dates[d].items.length > 0) {
                                                        for (var cr in _this12.route_time_range.config_ranges) {
                                                            if (_this12.route_time_range.config_ranges[cr] != undefined && _this12.route_time_range.config_ranges[cr] != null) {
                                                                if (dates[d].items[i].time_tag != undefined && dates[d].items[i].time_tag != null && typeof dates[d].items[i].time_tag == "string") {
                                                                    if (dates[d].items[i].time_tag.includes(_this12.route_time_range.config_ranges[cr])) {
                                                                        if (first_date_with_time == null) {
                                                                            first_date_with_time = dates[d].timestamp;
                                                                            first_date_available = dates[d];
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    _this12.first_date_with_time = first_date_with_time;
                    _this12.first_date_available = first_date_available;

                    if (_this12.$route.params.types && _this12.type_groups) {
                        var _groups = _this12.type_groups;
                        var route_types = [];
                        if (_this12.$route.params.types != undefined && _this12.$route.params.types != null) {
                            route_types = _this12.$route.params.types.split(",");

                            for (var g in _groups) {
                                for (var r in route_types) {
                                    if (_groups[g].name == route_types[r]) {
                                        _this12.route_types.push(_groups[g]);
                                    }
                                }
                            }
                        }

                        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(_this12.getCinemasForTypes(movies.data, _this12.route_types)).then(function (type_cinemas) {
                            _this12.filteredCinemas = type_cinemas;
                        });
                    }

                    _this12.regionsForThisMovie(thisMovie, time_ranges);

                    _this12.facebookPixelSK(thisMovie);
                    _this12.facebookPixelWB(thisMovie);
                    _this12.facebookPixelStarWars(thisMovie);

                    if (_this12.$route.params.festival_id) {
                        __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["l" /* PageService */].getFilmFestivals().then(function (festivals) {
                            _this12.festival = festivals.find(function (f) {
                                return f.nid === _this12.$route.params.festival_id;
                            });
                            if (_this12.festival) {}
                        });
                    }

                    _this12.movieCinemas = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(thisMovie.cinemas);

                    if (_this12.$route.params.session_id) {
                        for (var c in _this12.movie.cinemas) {
                            for (var s in _this12.movie.cinemas[c]) {
                                if (_this12.movie.cinemas[c][s].id == _this12.$route.params.session_id) {

                                    var session_id = _this12.$route.params.session_id;
                                    var cinema_id = _this12.movie.cinemas[c][s].cinema_id;
                                    var movie_id = _this12.$route.params.id;

                                    _this12.startDirectOrder(session_id, cinema_id, movie_id);
                                }
                            }
                        }
                    }
                });
            });
        });
    },
    mounted: function mounted() {
        if (window.__PRERENDER_INJECTED) {
            this.loading = false;
            this.prerender = true;

            if (window.__PRERENDER_INJECTED.movies) {
                var movie_id = this.$route.params.id;
                this.movie_id = movie_id;

                var _injected_movies = __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["j" /* MovieService */].setPreRenderMovies(window.__PRERENDER_INJECTED.movies);

                var movies = _injected_movies;
                this.injected_movies = movies;
                this.movies = movies;
                this.movie = movies.findById(movie_id);

                document.title = this.movie.title + " | Ster-Kinekor";

                this.getAsyncData();
            } else {
                injected_movies = undefined;
                this.injected_movies = injected_movies;
            }

            if (window.__PRERENDER_INJECTED.regions) {
                var _injected_regions = __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["n" /* RegionService */].setPreRenderRegions(window.__PRERENDER_INJECTED.regions);
                this.injected_regions = _injected_regions;
                var regions = _injected_regions.data;

                if (!empty(this.movie)) {
                    this.regionsRaW = regions.findByCinemas(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.movie.cinemas));
                }
            } else {
                injected_regions = undefined;
            }

            if (window.__PRERENDER_INJECTED.cinemas) {
                var _injected_cinemas = __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["n" /* RegionService */].setPreRenderRegionsDictionary(window.__PRERENDER_INJECTED.cinemas);
                this.injected_cinemas = window.__PRERENDER_INJECTED.cinemas;
            } else {
                injected_cinemas = undefined;
            }

            if (window.__PRERENDER_INJECTED.meta) {
                var _injected_meta = __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_service__["i" /* MovieMetaService */].setPreRenderMovieMeta(window.__PRERENDER_INJECTED.meta);
                this.injected_meta = _injected_meta;

                var meta = _injected_meta;

                this.metaExperiences = meta.experiences;

                if (meta != undefined && meta != null && meta.experiences != undefined && meta.experiences != null && meta.genres != undefined && meta.genres != null) {
                    if (this.setTypeOptions(meta.experiences) && this.setGenreOptions(meta.genres)) {
                        this.setFormDataFromRoute();
                    }
                }
            } else {
                injected_meta = undefined;
                this.injected_meta = undefined;
            }
        }
    }
});

/***/ }),
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "movie-details-page"
  }, [(_vm.prerender) ? _c('div', [_c('div', {
    staticClass: "detail-movie__header-img"
  }, [(_vm.movie && _vm.movie.images) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.images.standard && _vm.movie.images.standard.banner.url),
      expression: "movie.images.standard && movie.images.standard.banner.url"
    }]
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.images.standard.banner.url),
      expression: "movie.images.standard.banner.url"
    }],
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.images.standard.banner.url,
      "alt": _vm.movie.images.standard.banner.alt
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.movie && _vm.movie.featured) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.featured.banner && _vm.movie.featured.banner.url),
      expression: "movie.featured.banner && movie.featured.banner.url"
    }]
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.images.featured.banner.url),
      expression: "movie.images.featured.banner.url"
    }],
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.images.featured.banner.url,
      "alt": _vm.movie.images.featured.banner.alt
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.movie.featured.banner && !_vm.movie.images.standard),
      expression: "!movie.featured.banner && !movie.images.standard"
    }]
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/movie-summary-default-bg.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-container', {
    staticClass: "detail-movie__info"
  }, [(_vm.movie && _vm.movie.hasPromos && _vm.movie.images) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.hasPromos && _vm.movie.images.promo && _vm.movie.images.promo.banner.url),
      expression: "movie.hasPromos && movie.images.promo && movie.images.promo.banner.url"
    }],
    staticClass: "detail-movie__info-promo"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie && _vm.movie.images.promo.banner.url,
      "alt": _vm.movie.images.promo.alt
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.movie && _vm.movie.hasEvents && _vm.movie.images) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.hasEvents && _vm.movie.images.event && _vm.movie.images.event.banner.url),
      expression: "movie.hasEvents && movie.images.event && movie.images.event.banner.url"
    }],
    staticClass: "detail-movie__info-event"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie && _vm.movie.images.event.banner.url,
      "alt": _vm.movie.images.event.alt
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "movie-detail"
  }, [_c('sk-panel', [_c('sk-layout', {
    class: (!_vm.$breakpoints.xs ? 'gutter-40' : ''),
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs5": "",
      "sm4": "",
      "md3": "",
      "lg2": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogActive = true
      }
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [(_vm.movie && _vm.movie.poster) ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.poster,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-icon', {
    staticClass: "movie-detail__poster-play",
    attrs: {
      "play": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('sk-video', {
    staticClass: "dialog-video",
    attrs: {
      "content": _vm.movie.youtube_id
    },
    model: {
      value: (_vm.dialogActive),
      callback: function($$v) {
        _vm.dialogActive = $$v
      },
      expression: "dialogActive"
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs7": "",
      "sm8": "",
      "md7": "",
      "lg8": ""
    }
  }, [_c('h3', {
    staticClass: "movie-detail__releasing"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._showing),
      expression: "_showing"
    }]
  }, [_vm._v("\n                                    Now Showing\n                                ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.movie.now_showing),
      expression: "!movie.now_showing"
    }]
  }, [_vm._v("\n                                    Releasing: " + _vm._s(_vm.movie.opening_date.additional.string_nth_day) + "\n                                    " + _vm._s(_vm.movie.opening_date.additional.string_long_month) + " " + _vm._s(_vm.movie.opening_date.additional.year) + "\n                                ")])]), _vm._v(" "), _c('h1', {
    staticClass: "movie-detail__title"
  }, [_vm._v("\n                                " + _vm._s(_vm.movie.title) + "\n                                "), _c('sk-social-share', {
    attrs: {
      "id": _vm.movie.id,
      "movie-title": _vm.movie.title,
      "twitter-text": "Let's go watch this movie at Ster-Kinekor!"
    }
  })], 1), _vm._v(" "), (_vm.$breakpoints.xs) ? _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogActive = true
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "play-button": ""
    }
  }), _vm._v("\n                                Play Trailer\n                            ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs"
  }, [_c('div', {
    staticClass: "list-inline movie-detail__labels"
  }, [_c('span', {
    staticClass: "label label--invert"
  }, [_vm._v(_vm._s(_vm.movie.rating))]), _vm._v(" "), _vm._l((_vm.movie.genres), function(genre) {
    return _c('span', {
      key: genre.id
    }, [_vm._v(_vm._s(genre.name))])
  }), _vm._v(" "), _c('span', [_vm._v("•\n                                        " + _vm._s(_vm.movie.runtime_hour_minute.hours) + "h " + _vm._s(_vm.movie.runtime_hour_minute.minutes) + "m")])], 2), _vm._v(" "), _c('div', {
    staticClass: "list-inline movie-detail__labels"
  }, [_vm._l((_vm.movie.experiences), function(experience) {
    return [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(experience))])]
  }), _vm._v(" "), _vm._l((_vm.movie.flags), function(flags) {
    return [_c('span', {
      staticClass: "label "
    }, [_vm._v(_vm._s(flags))])]
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "movie-detail__synopsis "
  }, [_vm._v("\n                                    " + _vm._s(_vm._f("truncate")(_vm.movie.synopsis, _vm.truncAmount, '...')) + "\n                                    "), (_vm.movie.synopsis.length >= _vm.truncAmount) ? _c('sk-button', {
    attrs: {
      "link": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.truncToggle($event.currentTarget)
      }
    }
  }, [_vm._v("\n                                        Read more\n                                    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.movie.cast.actors.length > 0) ? [_c('div', {
    staticClass: "list-inline white--text"
  }, [_c('span', [_vm._v("ACTORS: ")]), _vm._v(" "), _vm._l((_vm.movie.cast.actors), function(actor, index) {
    return _c('span', [_vm._v(_vm._s(actor.FirstName) + " " + _vm._s(actor.LastName)), ((index + 1) < _vm.movie.cast.actors.length) ? _c('span', [_vm._v(",")]) : _vm._e()])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.movie.cast.directors.length > 0) ? [_c('div', {
    staticClass: "list-inline white--text"
  }, [_c('span', [_vm._v("DIRECTORS: ")]), _vm._v(" "), _vm._l((_vm.movie.cast.directors), function(director, index) {
    return _c('span', [_vm._v(_vm._s(director.FirstName) + " " + _vm._s(director.LastName)), ((index + 1) < _vm.movie.cast.directors.length) ? _c('span', [_vm._v(",")]) : _vm._e()])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.buttons) ? _c('div', {
    staticClass: "movie-detail__buttons"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'Movie Details',
        params: {
          id: _vm.movie.id
        }
      }
    }
  }, [_vm._v("Book to win\n                                    ")])], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('sk-spacer')], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "visible-xs"
  }, [_c('sk-spacer', {
    attrs: {
      "height": "20"
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "list-inline movie-detail__labels"
  }, [_c('span', {
    staticClass: "label label--invert"
  }, [_vm._v(_vm._s(_vm.movie.rating))]), _vm._v(" "), _vm._l((_vm.movie.genres), function(genre) {
    return _c('span', {
      key: genre.id
    }, [_vm._v(_vm._s(genre.name))])
  }), _vm._v(" "), _c('span', [_vm._v("• " + _vm._s(_vm.movie.runtime_hour_minute.hours) + "h " + _vm._s(_vm.movie.runtime_hour_minute.minutes) + "m")])], 2), _vm._v(" "), _c('div', {
    staticClass: "list-inline movie-detail__labels"
  }, [_vm._l((_vm.movie.experiences), function(experience) {
    return [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(experience))])]
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "movie-detail__synopsis"
  }, [_vm._v("\n                                " + _vm._s(_vm._f("truncate")(_vm.movie.synopsis, _vm.truncAmount, '...')) + "\n                                "), (_vm.movie.synopsis.length >= _vm.truncAmount) ? _c('sk-button', {
    attrs: {
      "link": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.truncToggle($event.currentTarget)
      }
    }
  }, [_vm._v("\n                                    Read more\n                                ")]) : _vm._e()], 1), _vm._v(" "), (_vm.movie.cast.actors.length > 0) ? [_c('div', {
    staticClass: "list-inline white--text"
  }, [_c('span', [_vm._v("ACTORS: ")]), _vm._v(" "), _vm._l((_vm.movie.cast.actors), function(actor, index) {
    return _c('span', [_vm._v(_vm._s(actor.FirstName) + " " + _vm._s(actor.LastName)), ((index + 1) < _vm.movie.cast.actors.length) ? _c('span', [_vm._v(",")]) : _vm._e()])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.movie.cast.directors.length > 0) ? [_c('div', {
    staticClass: "list-inline white--text"
  }, [_c('span', [_vm._v("DIRECTORS: ")]), _vm._v(" "), _vm._l((_vm.movie.cast.directors), function(director, index) {
    return _c('span', [_vm._v(_vm._s(director.FirstName) + " " + _vm._s(director.LastName)), ((index + 1) < _vm.movie.cast.directors.length) ? _c('span', [_vm._v(",")]) : _vm._e()])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.buttons) ? _c('div', {
    staticClass: "movie-detail__buttons"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'Movie Details',
        params: {
          id: _vm.movie.id
        }
      }
    }
  }, [_vm._v("Book to win\n                                ")])], 1) : _vm._e()], 2)], 1)], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (!_vm.prerender) ? _c('div', {
    staticClass: "detail main-view--no-margin"
  }, [_c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.showHandleGenericError),
      callback: function($$v) {
        _vm.showHandleGenericError = $$v
      },
      expression: "showHandleGenericError"
    }
  }, [_c('h3', [_vm._v("Oops, something went wrong")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "loading": _vm.loadingContinue
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.backToMovie()
      }
    }
  }, [_vm._v("Back to Movie")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.cancelOrderLoad
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goHome()
      }
    }
  }, [_vm._v("Take me home")])], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.showHandleNoSeatsAvailableError),
      callback: function($$v) {
        _vm.showHandleNoSeatsAvailableError = $$v
      },
      expression: "showHandleNoSeatsAvailableError"
    }
  }, [_c('h3', [_vm._v("Oops, something went wrong")]), _vm._v(" "), _c('p', [_vm._v("There are no seats available for this time slot, please select another.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "loading": _vm.loadingContinue
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showHandleNoSeatsAvailableError = false;
        _vm.loading = false
      }
    }
  }, [_vm._v("Back to Movie")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.cancelOrderLoad
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goHome()
      }
    }
  }, [_vm._v("Take me home")])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.movie && _vm.movie != undefined),
      expression: "!loading && movie && movie != undefined"
    }]
  }, [_c('div', {
    staticClass: "detail-movie__header-img"
  }, [(_vm.movie && _vm.movie.images) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.images.standard && _vm.movie.images.standard.banner.url),
      expression: "movie.images.standard && movie.images.standard.banner.url"
    }]
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.images.standard.banner.url),
      expression: "movie.images.standard.banner.url"
    }],
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.images.standard.banner.url,
      "alt": _vm.movie.images.standard.banner.alt
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.movie && _vm.movie.featured) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.featured.banner && _vm.movie.featured.banner.url),
      expression: "movie.featured.banner && movie.featured.banner.url"
    }]
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.images.featured.banner.url),
      expression: "movie.images.featured.banner.url"
    }],
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.images.featured.banner.url,
      "alt": _vm.movie.images.featured.banner.alt
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.movie) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.movie.featured.banner && !_vm.movie.images.standard),
      expression: "!movie.featured.banner && !movie.images.standard"
    }]
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/movie-summary-default-bg.jpg",
      "alt": ""
    }
  })]) : _vm._e()]), _vm._v(" "), _c('sk-container', {
    staticClass: "detail-movie__info"
  }, [(_vm.movie && _vm.movie.hasPromos && _vm.movie.images) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie && _vm.movie.hasPromos && _vm.movie.images.promo && _vm.movie.images.promo.banner.url),
      expression: "movie && movie.hasPromos && movie.images.promo && movie.images.promo.banner.url"
    }],
    staticClass: "detail-movie__info-promo"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie && _vm.movie.images.promo.banner.url,
      "alt": _vm.movie.images.promo.alt
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.movie && _vm.movie.hasEvents && _vm.movie.images) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie && _vm.movie.hasEvents && _vm.movie.images.event && _vm.movie.images.event.banner.url),
      expression: "movie && movie.hasEvents && movie.images.event && movie.images.event.banner.url"
    }],
    staticClass: "detail-movie__info-event"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie && _vm.movie.images.event.banner.url,
      "alt": _vm.movie.images.event.alt
    }
  })]) : _vm._e(), _vm._v(" "), _c('sk-movie-detail', {
    attrs: {
      "movie": _vm.movie
    }
  })], 1), _vm._v(" "), (_vm.movie && _vm.movie.has_sessions_available) ? _c('sk-container', [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "detail-start-booking__title"
  }, [_c('h2', {
    staticClass: "detail-start-booking__copy"
  }, [_vm._v("\n                                    Start your booking\n                                ")]), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-start-booking__back",
    attrs: {
      "primary": "",
      "router": "",
      "to": _vm.previousPath
    }
  }, [_c('sk-icon', {
    attrs: {
      "arrow-left": ""
    }
  }), _vm._v("\n                                    Back\n                                ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-cinema"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.selectedCinemaId) ? _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a Cinema")])]) : _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a Cinema")])]), _vm._v(" "), (_vm.selectedCinemaId && !_vm.$breakpoints.xs) ? _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a Cinema Type")])]) : _vm._e(), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-google-places-input', {
    ref: "location_input",
    staticClass: "location-search",
    attrs: {
      "placeholder": "Seach location",
      "geolocation": "",
      "autocomplete": "",
      "pinOnly": ""
    },
    on: {
      "place-selected": _vm.placeSelected
    },
    model: {
      value: (_vm.formData.place_query),
      callback: function($$v) {
        _vm.$set(_vm.formData, "place_query", $$v)
      },
      expression: "formData.place_query"
    }
  }), _vm._v(" "), _c('sk-multi-select-regions', {
    staticClass: "cinema-select form-group",
    attrs: {
      "val": _vm.formData.cinema,
      "items": _vm.regions
    },
    model: {
      value: (_vm.formData.cinema),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cinema", $$v)
      },
      expression: "formData.cinema"
    }
  })], 1) : _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-google-places-input', {
    ref: "location_input",
    staticClass: "location-search",
    attrs: {
      "placeholder": "Seach location",
      "geolocation": "",
      "autocomplete": "",
      "pinOnly": ""
    },
    on: {
      "place-selected": _vm.placeSelected
    },
    model: {
      value: (_vm.formData.place_query),
      callback: function($$v) {
        _vm.$set(_vm.formData, "place_query", $$v)
      },
      expression: "formData.place_query"
    }
  }), _vm._v(" "), _c('sk-multi-select-regions', {
    staticClass: "cinema-select form-group",
    attrs: {
      "val": _vm.formData.cinema,
      "items": _vm.regions
    },
    model: {
      value: (_vm.formData.cinema),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cinema", $$v)
      },
      expression: "formData.cinema"
    }
  })], 1), _vm._v(" "), (_vm.selectedCinemaId && _vm.$breakpoints.xs) ? _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a Cinema Type")])]) : _vm._e(), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(_vm.formData.cinema) ? _c('sk-multi-select-types', {
    staticClass: "cinema-select form-group",
    attrs: {
      "val": _vm.formData.experienceName,
      "items": _vm.typesForCinemas,
      "multiple": false
    },
    model: {
      value: (_vm.formData.experienceName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "experienceName", $$v)
      },
      expression: "formData.experienceName"
    }
  }) : _vm._e()], 1) : _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.formData.cinema) ? _c('sk-multi-select-types', {
    staticClass: "cinema-select form-group",
    attrs: {
      "val": _vm.formData.experienceName,
      "items": _vm.typesForCinemas,
      "multiple": false
    },
    model: {
      value: (_vm.formData.experienceName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "experienceName", $$v)
      },
      expression: "formData.experienceName"
    }
  }) : _vm._e()], 1)], 1)], 1)])], 1), _vm._v(" "), (_vm.selectedCinemaId && _vm.availableDates != undefined && _vm.availableDates != null) ? _c('div', {
    staticClass: "detail-movie-select-date",
    attrs: {
      "id": "select-date-time"
    }
  }, [(_vm.availableDates.length > 0) ? [_c('hr'), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a Date and Time")]), _vm._v(" "), (_vm.availableDates.length <= 6 && !_vm.$breakpoints.xs) ? [(_vm.availableDates.length > 0) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.availableDates), function(session, index) {
    return _c('sk-flex', {
      key: session.id,
      attrs: {
        "sm2": "",
        "md2": "",
        "lg2": "",
        "grow": ""
      }
    }, [(session != undefined && session != null) ? [
      [((session.show_time.additional.day == '01' || index == 0)) ? _c('div', {
        staticClass: "label__month"
      }, [(_vm.$breakpoints.smDown) ? [_vm._v("\n                                                        " + _vm._s(session.show_time.additional.string_short_month) + "\n                                                    ")] : [_vm._v("\n                                                        " + _vm._s(session.show_time.additional.string_long_month) + "\n                                                    ")], _vm._v("\n                                                    " + _vm._s(session.show_time.additional.year) + "\n\n                                                ")], 2) : _vm._e(), _vm._v(" "), _c('div', {
        ref: "session_time",
        refInFor: true,
        staticClass: "label label--lg",
        class: {
          active: _vm.compareDates(session.show_time.date, _vm.sessionData.selectedDate), 'btn-mask': true, 'disabled': !_vm.getStatus(session)
        },
        attrs: {
          "id": session.id
        },
        on: {
          "click": function($event) {
            _vm.setSelectedDate(session.show_time.date);
          }
        }
      }, [_c('div', {
        staticClass: "detail-movie-select-date--date"
      }, [_c('div', {
        staticClass: "detail-movie-select-date--day"
      }, [_vm._v("\n                                                                " + _vm._s(session.show_time.additional.day) + "\n                                                            ")]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-date--month"
      }, [_vm._v("\n                                                                " + _vm._s(session.show_time.additional.string_long_day_of_week) + "\n                                                            ")])])])]
    ] : _vm._e()], 2)
  })) : _vm._e()] : [_c('sk-carousel', {
    attrs: {
      "slides-per-page": (_vm.$breakpoints.xs ? 3 : 6)
    }
  }, _vm._l((_vm.availableDates), function(session, index) {
    return _c('div', {
      key: session.id,
      staticClass: "slide",
      attrs: {
        "slot": "slides"
      },
      slot: "slides"
    }, [(session != undefined && session != null) ? [(session.show_time != undefined && session.show_time != null) ? [((session.show_time.additional.day == '01' || index == 0)) ? _c('div', {
      staticClass: "label__month"
    }, [(_vm.$breakpoints.smDown) ? [_vm._v("\n                                                        " + _vm._s(session.show_time.additional.string_short_month) + "\n                                                    ")] : [_vm._v("\n                                                        " + _vm._s(session.show_time.additional.string_long_month) + "\n                                                    ")], _vm._v("\n                                                    " + _vm._s(session.show_time.additional.year) + "\n                                                ")], 2) : _vm._e(), _vm._v(" "), _c('div', {
      ref: "session_time",
      refInFor: true,
      staticClass: "label label--lg",
      class: {
        active: _vm.compareDates(session.show_time.date, _vm.sessionData.selectedDate), 'btn-mask': true, 'disabled': !_vm.getStatus(session)
      },
      attrs: {
        "id": session.id
      },
      on: {
        "click": function($event) {
          _vm.setSelectedDate(session.show_time.date);
        }
      }
    }, [_c('div', {
      staticClass: "detail-movie-select-date--date"
    }, [_c('div', {
      staticClass: "detail-movie-select-date--day"
    }, [_vm._v("\n                                                            " + _vm._s(session.show_time.additional.day) + "\n                                                        ")]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-date--month"
    }, [_vm._v("\n                                                            " + _vm._s(session.show_time.additional.string_short_day_of_week) + "\n                                                        ")])])])] : _vm._e()] : _vm._e()], 2)
  }))], _vm._v(" "), (_vm.sessionData.selectedDate) ? _c('div', {
    staticClass: "detail-movie-select-time",
    class: (_vm.availableSessions.length >= 6) ? 'carousel' : ''
  }, [(_vm.availableSessions.length <= 6 && !_vm.$breakpoints.xs) ? [_c('sk-layout', _vm._l((_vm.availableSessions), function(session) {
    return _c('sk-flex', {
      key: session.id,
      attrs: {
        "wrap": ""
      }
    }, [(session != undefined && session != null) ? [
      [(_vm.matching_time_tags.includes(session.time_tag)) ? _c('span', {
        ref: "session_time",
        refInFor: true,
        staticClass: "active label label--lg",
        class: {
          active: session == _vm.sessionData.selectedSession, 'btn-mask': true, 'disabled': !_vm.getStatus(session)
        },
        attrs: {
          "id": session.id
        },
        on: {
          "click": function($event) {
            _vm.setSelectedSession(session);
          }
        }
      }, [_c('div', {
        staticClass: "detail-movie-select-time--time"
      }, [_vm._v(_vm._s(session.show_time.additional.no_zero_hour_24) + ":" + _vm._s(session.show_time.additional.minute))]), _vm._v(" "), (_vm.getStatusString(session) == 'Sold Out') ? [_c('div', {
        staticClass: "detail-movie-select-time--info sold-out-label"
      }, [_vm._v(_vm._s(_vm.getStatusString(session)))])] : [_c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(_vm.getStatusString(session)))])], _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(session.screen_name))]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(session.experiences.map(function (e) { return e.name; }).join(', ')))])], 2) : _c('span', {
        ref: "session_time",
        refInFor: true,
        staticClass: "label label--lg not-selected",
        class: {
          active: session == _vm.sessionData.selectedSession, 'btn-mask': true, 'disabled': !_vm.getStatus(session)
        },
        attrs: {
          "id": session.id
        },
        on: {
          "click": function($event) {
            _vm.setSelectedSession(session);
          }
        }
      }, [_c('div', {
        staticClass: "detail-movie-select-time--time"
      }, [_vm._v(_vm._s(session.show_time.additional.no_zero_hour_24) + ":" + _vm._s(session.show_time.additional.minute))]), _vm._v(" "), (_vm.getStatusString(session) == 'Sold Out') ? [_c('div', {
        staticClass: "detail-movie-select-time--info sold-out-label"
      }, [_vm._v(_vm._s(_vm.getStatusString(session)))])] : [_c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(_vm.getStatusString(session)))])], _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(session.screen_name))]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(session.experiences.map(function (e) { return e.name; }).join(', ')))])], 2)]
    ] : _vm._e()], 2)
  }))] : [_c('sk-carousel', {
    attrs: {
      "data": _vm.availableSessions,
      "slides-per-page": (_vm.$breakpoints.xs ? 3 : 6)
    }
  }, _vm._l((_vm.availableSessions), function(session) {
    return _c('div', {
      key: session.id,
      staticClass: "slide",
      attrs: {
        "slot": "slides"
      },
      slot: "slides"
    }, [(session != undefined && session != null) ? [
      [(_vm.matching_time_tags.includes(session.time_tag)) ? _c('div', {
        ref: "session_time",
        refInFor: true,
        staticClass: "active label label--lg",
        class: {
          active: session == _vm.sessionData.selectedSession, 'btn-mask': true, 'disabled': !_vm.getStatus(session)
        },
        attrs: {
          "id": session.id
        },
        on: {
          "click": function($event) {
            _vm.setSelectedSession(session);
          }
        }
      }, [_c('div', {
        staticClass: "detail-movie-select-time--time"
      }, [_vm._v("\n                                                            " + _vm._s(session.show_time.additional.no_zero_hour_24) + ":" + _vm._s(session.show_time.additional.minute) + "\n                                                        ")]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(_vm.getStatusString(session)) + "\n                                                        ")]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(session.screen_name))]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v("\n                                                            " + _vm._s(session.experiences.map(function (e) { return e.name; }).join(', ')) + "\n                                                        ")])]) : _c('div', {
        ref: "session_time",
        refInFor: true,
        staticClass: "label label--lg",
        class: {
          active: session == _vm.sessionData.selectedSession, 'btn-mask': true, 'disabled': !_vm.getStatus(session)
        },
        attrs: {
          "id": session.id
        },
        on: {
          "click": function($event) {
            _vm.setSelectedSession(session);
          }
        }
      }, [_c('div', {
        staticClass: "detail-movie-select-time--time"
      }, [_vm._v("\n                                                            " + _vm._s(session.show_time.additional.no_zero_hour_24) + ":" + _vm._s(session.show_time.additional.minute) + "\n                                                        ")]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(_vm.getStatusString(session)) + "\n                                                        ")]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(session.screen_name))]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v("\n                                                            " + _vm._s(session.experiences.map(function (e) { return e.name; }).join(', ')) + "\n                                                        ")])])]
    ] : _vm._e()], 2)
  }))]], 2) : _vm._e()] : _vm._e()], 2) : (_vm.selectedCinemaId && _vm.availableDates != undefined && _vm.availableDates != null) ? _c('div', [(_vm.availableDates.length == 0) ? [_vm._v("\n                            Whoops, it seems we can't find any shows for based on your current filter, please select a Cinema type to find shows.\n                        ")] : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), _c('sk-signin', {
    ref: "signUp",
    attrs: {
      "signUp": _vm.signUp
    },
    on: {
      "changed": _vm.toggleSignUp
    }
  }), _vm._v(" "), (!_vm.festival && _vm.related_movies) ? _c('sk-related-movies', {
    attrs: {
      "movies": _vm.related_movies
    }
  }) : (_vm.festival && _vm.festival.Movies.length > 0) ? _c('sk-related-movies', {
    attrs: {
      "label": ("Other Movies For: " + (_vm.festival.title) + " "),
      "link": ("/film-festival-details/" + (_vm.festival.nid)),
      "movies": _vm.festival.Movies.filter(function (m) { return m.id !== _vm.$route.params.id; })
    }
  }) : _vm._e()], 1) : _c('sk-container', [_c('sk-panel', [_c('p', [_vm._v("Excited to see this movie? Hold tight, bookings will be available soon.")])])], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(541),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_meta_data_js__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({

    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_meta_data_js__["a" /* default */]],

    data: function data() {
        return {
            loading: true,
            order: null,
            movie: {},
            regions: null,
            session: undefined,
            stepType: "booking",
            stepNames: [{
                step: 1,
                text: 'Your Seats'
            }, {
                step: 2,
                text: 'Your Extras'
            }, {
                step: 3,
                text: 'Confirm Booking'
            }, {
                step: 4,
                text: 'Checkout'
            }],
            loadingContinue: false,
            cancelOrderLoad: false,
            showHandleGenericError: false
        };
    },


    computed: {
        step: function step() {

            return parseInt(this.$route.path.replace('/booking/', '').split('/')[0]);
        },
        cinema: function cinema() {
            return this.order && this.regions ? this.regions.findCimema(this.order.Session.CinemaId) : {};
        }
    },

    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        var _this = this;

        var fromIsConcessionStep = Boolean(~from.path.indexOf('booking/2'));
        var toIsSeatingStep = Boolean(~to.path.indexOf('booking/1'));
        if (fromIsConcessionStep && toIsSeatingStep) {
            if (this.order.modified) {
                this.loading = true;
                return __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].saveOrderConcessionsOnly().then(function (order) {
                    _this.loading = false;
                    return next();
                });
            } else return next();
        } else return next();
    },


    methods: {
        setOrder: function setOrder(eventKey, order) {
            this.order = order;
        },
        handleOrderError: function handleOrderError(error) {
            this.showHandleGenericError = true;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
        },
        getOrder: function getOrder() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getOrder().then(function (order) {
                _this2.order = order;
                __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].addObserver(_this2, __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].ORDER_CHANGED_EVENT, _this2.setOrder);
                __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getRegions().then(function (regions) {
                    return _this2.regions = regions;
                });
                _this2.loading = false;
                _this2.isNouveau(order);
            }, this.handleOrderError);
        },
        isNouveau: function isNouveau(order) {
            var _this3 = this;

            order.Session.MoviePromise.then(function () {
                order.Experiences.forEach(function (exp) {
                    if (exp && exp.name.includes('Nouveau')) _this3.cinemaType = exp.name;
                });
                if (_this3.cinemaType) {
                    _this3.$root.$el.classList.add('nouveau');
                    _this3.$parent.$refs['site-header'].logoSrc = '/static/img/nouveau-logo.png';
                } else {
                    _this3.$root.$el.classList.remove('nouveau');
                    _this3.$parent.$refs['site-header'].logoSrc = '/static/img/sk-logo.png';
                }
            });
        },
        setMetaData: function setMetaData() {
            var _this4 = this;

            var currentURL = this.$route.path.replace('/booking/', '');
            this.stepNames.forEach(function (e) {
                if (e.step === parseInt(currentURL.replace('/booking/', ''))) {
                    _this4.metaTitle = 'Booking Step ' + e.step;
                }
            });
            this.$emit('updateHead');
        },
        backToMovie: function backToMovie() {
            this.showTimeout = false;
            this.loadingContinue = true;
            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].tearDown();
            this.showHandleGenericError = false;
            this.$router.push("/details/" + this.movie.id);
        },
        goHome: function goHome() {
            this.showTimeout = false;
            this.cancelOrderLoad = true;
            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].tearDown();
            this.showHandleGenericError = false;
            this.$router.push('/');
        }
    },

    created: function created() {
        this.loading = true;
        this.setMetaData();
        this.getOrder();
    },
    updated: function updated() {
        if (this.order) this.isNouveau(this.order);
        this.setMetaData();
    }
});

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "context": "Booking"
    }
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.showHandleGenericError),
      callback: function($$v) {
        _vm.showHandleGenericError = $$v
      },
      expression: "showHandleGenericError"
    }
  }, [_c('h3', [_vm._v("Oops, something went wrong")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "loading": _vm.loadingContinue
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.backToMovie()
      }
    }
  }, [_vm._v("Start again")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.cancelOrderLoad
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goHome()
      }
    }
  }, [_vm._v("Take me home")])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.order.Session) ? _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('sk-progress-steps', {
    attrs: {
      "num-steps": 4,
      "current-step": _vm.step,
      "step-names": _vm.stepNames,
      "step-type": _vm.stepType
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('sk-flex', {
    staticClass: "text-right",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-countdown', {
    attrs: {
      "timer": "0"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.order.Session) ? [(_vm.step == '3') ? [_c('transition', {
    attrs: {
      "name": "sk-slide-x-transition"
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('router-view')], 1)], 1)] : [_c('transition', {
    attrs: {
      "name": "sk-slide-x-transition"
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "lg9": ""
    }
  }, [_c('router-view')], 1)], 1)]] : _vm._e(), _vm._v(" "), (_vm.order && _vm.order.Tickets && _vm.step != 3 && _vm.order.Session) ? _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "lg3": ""
    }
  }, [_c('sk-ticket', {
    attrs: {
      "order": _vm.order,
      "cinema": _vm.cinema
    }
  })], 1) : _vm._e()], 2)]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(544),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_http__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_model__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_meta_data_js__ = __webpack_require__(5);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'user',
    props: {
        signUp: Boolean
    },

    data: function data() {
        return {
            msg: 'User',
            content: null,
            errors: [],
            loading: false,
            User: new __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_model__["j" /* User */]({ SendNewsletter: true }),
            months: __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_ui_core__["Utils"].MonthMeta(),
            days: [],
            years: [],
            userLinkCards: false,
            userJoinSK: true,
            userSB1: false,
            userSB2: false,
            userNewsletter: false,
            isSKClub: false,
            userSKClubGroup: '',
            cardSKClub: false,
            cardVitality: false,
            cardEdgars: false,
            cardSKClubNumber: "",
            cardVitalityNumber: "",
            cardEdgarsNumber: "",
            idNumber: "",
            signInType: this.$route.params.signInType || false,
            tooltip: false,
            disabled: 0,
            activationCode: this.$route.params.activationCode,
            codeActivated: false,
            signUpChange: this.signUp || false,
            signUpLoading: false,
            generalErrors: [],
            passwordRegex: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})"),
            subsClub: null,
            countryCode: null,
            mobilePhone: null,
            countryCodes: [],
            countryCodeIndex: [{ id: "South Africa (+27)", value: "+27" }, { id: "Zambia (+260)", value: "+260" }, { id: "Zimbabwe (+263)", value: "+263" }, { id: "Namibia (+264)", value: "+264" }],
            FbLogin: function FbLogin() {}
        };
    },

    methods: {
        signup: function signup() {
            var _this = this;

            this.signUpLoading = true;

            if (this.disabled) return;

            this.disabled = 1;

            this.User.MemberLevelId = 1;

            this.User.save().then(function (response) {
                _this.loading = false;
                window.location.href = '/user/profile';
                window.scroll({ top: 0, left: 0 });
            }, function (error) {
                _this.signUpLoading = false;
                _this.disabled = 0;
            });
        },
        login: function login() {
            var _this2 = this;

            this.loading = true;
            this.disabled = 1;
            __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].signIn(this.User.Email, this.User.Password).then(function (user) {
                _this2.loading = false;

                localStorage.removeItem("firstLogin");
                localStorage.setItem("firstLogin", "true");

                __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].firstLogin = true;

                if (_this2.$route.query.redirect) _this2.$router.push({ path: _this2.$route.query.redirect });else _this2.$router.push({ path: '/user/profile' });
            }, function (error) {
                _this2.loading = false;
            });
        },
        loginState: function loginState() {
            this.loading = true;
            this.disabled = 1;

            checkLoginState();
        },
        activateCode: function activateCode() {
            var _this3 = this;

            this.loading = true;
            if (this.activationCode.length === 15) {

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_http__["a" /* default */].post('/check-activation', {
                    activationCode: this.activationCode
                })).then(function (res) {
                    if (res.status) {
                        _this3.codeActivated = true;
                        _this3.$toaster.show('You have successfully confirmed your account. Log in to continue to your profile page.', {
                            top: true,
                            timeout: 5000,
                            primary: true
                        });
                        _this3.loading = false;
                    }
                });
            }
        },
        signOut: function signOut() {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].signOut()).then(function (result) {
                _this4.$router.push("/");
            }, function (error) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
            });
        },
        fbSignIn: function fbSignIn(r) {
            var _this5 = this;

            __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].facebookSignUp(r).then(function (result) {
                _this5.loading = false;
                _this5.$router.push({ path: '/user/profile' });
            });
        },
        getSubsData: function getSubsData() {
            var subsClubRaw = window.localStorage.getItem('subsClub');

            var subsClub = null;
            if (subsClubRaw && subsClubRaw != undefined) {
                subsClub = JSON.parse(subsClubRaw);
            }

            this.subsClub = subsClub;
            return subsClub;
        }
    },

    created: function created() {
        if (!this.signInType) {
            this.signInType = 'signup';
        }

        for (var d = 1; d <= 31; d++) {
            this.days.push(d);
        }

        var year = new Date().getFullYear();

        this.countryCodes.push("South Africa (+27)");
        this.countryCodes.push("Zambia (+260)");
        this.countryCodes.push("Zimbabwe (+263)");
        this.countryCodes.push("Namibia (+264)");

        for (var y = year; y >= year - 110; y--) {
            this.years.push(y);
        }

        this.getSubsData();

        window.fbAsyncInit = function () {

            FB.init({
                appId: '933552150135286',
                cookie: true,
                xfbml: true,
                version: 'v2.8'
            });

            FB.AppEvents.logPageView();

            var fbResponse = this.fbSignIn;

            window.checkLoginState = function () {
                var _this6 = this;

                FB.login(function (resp) {
                    if (resp && resp.authResponse) {
                        var access_token = resp.authResponse.accessToken;
                        var fbUrl = '/me?fields=email,name,first_name,last_name,birthday';
                        FB.api(fbUrl, function (response) {
                            if (response.error === undefined) {
                                response.tkn = access_token;
                                fbResponse(response);
                            }
                        });
                    } else {
                        _this6.loading = false;
                    }
                }, { scope: 'email,public_profile,user_birthday' });
            }.bind(this);
        }.bind(this);

        (function (d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
    },


    computed: {
        currentYear: function currentYear() {
            return __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY');
        },
        activateRedirect: function activateRedirect() {
            if (this.$route.query && this.$route.query.redirect) return this.$route.query.redirect.includes('/user/activate/');else return false;
        },
        emailChangeRedirect: function emailChangeRedirect() {
            if (this.$route.query && this.$route.query.redirect) return this.$route.query.redirect.includes('/user/confirm-email-change/');else return false;
        }
    },

    mounted: function mounted() {
        if (this.signInType === 'reset') {
            this.$toaster.show('Your password has been reset. Please log in below', {
                top: true,
                timeout: 5000,
                primary: true
            });
        }

        if (this.signInType === 'welcome') {
            this.$toaster.show('Sign up to SK successful. Please check your email for the activation link', {
                top: true,
                timeout: null,
                primary: true
            });
        }

        if (this.signInType === "sign-out") {
            this.signOut();
        }

        if (this.activationCode !== undefined) {
            if (this.activationCode.length === 15) {
                this.codeActivated = false;
                this.activateCode();
            }
        }
        window.scrollTo(0, 0);
        window.scroll({ top: 0, left: 0 });
    },
    updated: function updated() {},


    watch: {
        signUpChange: {

            handler: __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_ui_core__["Utils"].debounce(function () {
                this.$emit('changed', [this.signUpChange]);
            }, 300),
            deep: true
        },

        countryCode: function countryCode() {
            var value = null;

            for (var i = 0; i < this.countryCodeIndex.length; i++) {
                if (this.countryCodeIndex[i].id == this.countryCode) {
                    value = this.countryCodeIndex[i].value;
                }
            }

            if (this.mobilePhone != undefined && this.mobilePhone != null) {
                this.User.MobilePhone = value + this.mobilePhone;
            }
        },
        mobilePhone: function mobilePhone() {
            var value = null;

            if (this.countryCode != undefined && this.countryCode != null) {
                for (var i = 0; i < this.countryCodeIndex.length; i++) {
                    if (this.countryCodeIndex[i].id == this.countryCode) {
                        value = this.countryCodeIndex[i].value;
                    }
                }
                this.User.MobilePhone = value + this.mobilePhone;
            }
        },
        '$route': function $route(to, from, el) {
            if (from.name === to.name) window.location.reload();
        }
    }
});

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [(_vm.signInType === 'signup') ? _c('h1', [_vm._v("Create a profile")]) : _vm._e(), _vm._v(" "), (_vm.signInType === 'login') ? _c('h1', [(_vm.activateRedirect) ? [_vm._v("\n          Sign In to verify your email\n        ")] : (_vm.emailChangeRedirect) ? [_vm._v("\n          Sign In to verify your change of email\n        ")] : [_vm._v("\n          Sign In to SK\n        ")]], 2) : _vm._e()]), _vm._v(" "), _c('sk-panel', [(_vm.signInType === 'signup') ? _c('div', {
    staticClass: "user-signup"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('sk-form', {
    attrs: {
      "id": "user-signup-form"
    },
    on: {
      "submit": function($event) {
        _vm.signup()
      }
    }
  }, [_c('p', {
    staticClass: "form-alert"
  }, [_vm._v("All fields are mandatory")]), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "First Name",
      "required": "",
      "error-message": {
        valueMissing: 'Please tell us your name.'
      }
    },
    model: {
      value: (_vm.User.FirstName),
      callback: function($$v) {
        _vm.$set(_vm.User, "FirstName", $$v)
      },
      expression: "User.FirstName"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Surname",
      "required": "",
      "error-message": {
        valueMissing: 'What\'s your surname?'
      }
    },
    model: {
      value: (_vm.User.LastName),
      callback: function($$v) {
        _vm.$set(_vm.User, "LastName", $$v)
      },
      expression: "User.LastName"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Email",
      "type": "email",
      "placeholder": "e.g. xxx@gmail.com",
      "autocomplete": "false",
      "required": "",
      "error-message": {
        valueMissing: 'Please make sure your email address follows this format: example@email.com'
      }
    },
    model: {
      value: (_vm.User.Email),
      callback: function($$v) {
        _vm.$set(_vm.User, "Email", $$v)
      },
      expression: "User.Email"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Password",
      "type": "password",
      "autocomplete": "false",
      "required": "",
      "error-message": {
        patternMismatch: 'Your password must contain a minimum of 8 characters containing both numbers and letters, with at least one uppercase letter and a special character (!@#$%&).'
      },
      "pattern": "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!%*?&])[A-Za-z\\d$@#$!%*?&]{8,}"
    },
    model: {
      value: (_vm.User.Password),
      callback: function($$v) {
        _vm.$set(_vm.User, "Password", $$v)
      },
      expression: "User.Password"
    }
  }), _vm._v(" "), _c('sk-layout', {
    staticClass: "radio-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "gender-label",
    attrs: {
      "for": "gender"
    }
  }, [_vm._v("Gender")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('sk-radio', {
    attrs: {
      "name": "radio-gender",
      "radio-value": "Female",
      "label": "Female"
    },
    model: {
      value: (_vm.User.Gender),
      callback: function($$v) {
        _vm.$set(_vm.User, "Gender", $$v)
      },
      expression: "User.Gender"
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('sk-radio', {
    attrs: {
      "name": "radio-gender",
      "radio-value": "Male",
      "label": "Male"
    },
    model: {
      value: (_vm.User.Gender),
      callback: function($$v) {
        _vm.$set(_vm.User, "Gender", $$v)
      },
      expression: "User.Gender"
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('sk-radio', {
    attrs: {
      "name": "radio-gender",
      "radio-value": "Unknown",
      "label": "I'd rather not say"
    },
    model: {
      value: (_vm.User.Gender),
      callback: function($$v) {
        _vm.$set(_vm.User, "Gender", $$v)
      },
      expression: "User.Gender"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Mobile Number")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('sk-combo-select', {
    attrs: {
      "options": _vm.countryCodes,
      "placeholder": "Country Code",
      "validation-value": _vm.countryCode,
      "error-message": "Please choose a country code",
      "required": ""
    },
    model: {
      value: (_vm.countryCode),
      callback: function($$v) {
        _vm.countryCode = $$v
      },
      expression: "countryCode"
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('sk-input', {
    attrs: {
      "name": "mobile",
      "placeholder": "eg. 827804800",
      "type": "tel",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter your mobile number',
        patternMismatch: 'Please double check you\'ve entered 9 digits excluding your country code.'
      },
      "pattern": "^\\+?\\d{11,11}|\\d{10,10}|\\d{9,9}$"
    },
    model: {
      value: (_vm.mobilePhone),
      callback: function($$v) {
        _vm.mobilePhone = $$v
      },
      expression: "mobilePhone"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "select-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "birthday-label",
    attrs: {
      "for": "birthday"
    }
  }, [_vm._v("\n                    Birthday "), _c('sk-tooltip', {
    key: "birthday-tooltip",
    attrs: {
      "content": "Based on your age, we'll send you updates you will enjoy.",
      "standalone": ""
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "day"
  }, [_c('sk-combo-select', {
    attrs: {
      "options": _vm.days,
      "placeholder": "Day",
      "validation-value": _vm.User._DobDay,
      "error-message": "Please choose a day",
      "required": ""
    },
    model: {
      value: (_vm.User._DobDay),
      callback: function($$v) {
        _vm.$set(_vm.User, "_DobDay", $$v)
      },
      expression: "User._DobDay"
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "month"
  }, [_c('sk-combo-select', {
    attrs: {
      "options": _vm.months,
      "placeholder": "Month",
      "validation-value": _vm.User._DobMonth,
      "error-message": "Please choose a month",
      "required": ""
    },
    model: {
      value: (_vm.User._DobMonth),
      callback: function($$v) {
        _vm.$set(_vm.User, "_DobMonth", $$v)
      },
      expression: "User._DobMonth"
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "year"
  }, [_c('sk-combo-select', {
    attrs: {
      "options": _vm.years,
      "placeholder": "Year",
      "validation-value": _vm.User._DobYear,
      "error-message": "Please choose a year",
      "required": ""
    },
    model: {
      value: (_vm.User._DobYear),
      callback: function($$v) {
        _vm.$set(_vm.User, "_DobYear", $$v)
      },
      expression: "User._DobYear"
    }
  })], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-button"
  }, [(_vm.subsClub == undefined || _vm.subsClub == null) ? _c('p', {
    staticClass: "form__suffix"
  }, [_vm._v("By creating an SK profile "), (_vm.userJoinSK) ? _c('span', [_vm._v("and joining SK Club")]) : _vm._e(), _vm._v(", you agree to our "), _c('a', {
    attrs: {
      "href": "/content/legal/online-booking-terms-and-conditions",
      "target": "_blank"
    }
  }, [_vm._v("Ts & Cs")]), _vm._v(" "), (_vm.userJoinSK) ? _c('span', [_vm._v("and "), _c('a', {
    attrs: {
      "href": "/content/legal/club-terms-and-conditions",
      "target": "_blank"
    }
  }, [_vm._v("SK Club Ts & Cs")]), _c('br'), _vm._v(" Want to find out more? Check out our "), _c('a', {
    attrs: {
      "href": "/faq",
      "target": "_blank"
    }
  }, [_vm._v("FAQs")]), _vm._v(". ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.subsClub != undefined && _vm.subsClub != null) ? [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit"
    }
  }, [_vm._v("Create a Profile to join")])] : [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit"
    }
  }, [_vm._v("Create a Profile")])], _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "form__suffix"
  }, [_vm._v("Already have an SK profile? "), _c('a', {
    attrs: {
      "href": "/user/login"
    }
  }, [_vm._v("Sign In")])])], 2)], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.signInType === 'login' || _vm.signInType === 'reset' || _vm.signInType === 'welcome' || _vm.codeActivated)) ? _c('div', {
    staticClass: "user-signup"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('sk-form', {
    attrs: {
      "id": "user-login-form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        _vm.login()
      }
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('sk-input', {
    attrs: {
      "label": "Email",
      "type": "email",
      "autocomplete": "false",
      "placeholder": "e.g. xxx@gmail.com",
      "required": "",
      "error-message": {
        valueMissing: 'Please make sure your email address follows this format: example@email.com'
      }
    },
    model: {
      value: (_vm.User.Email),
      callback: function($$v) {
        _vm.$set(_vm.User, "Email", $$v)
      },
      expression: "User.Email"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Password",
      "type": "password",
      "autocomplete": "false",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter your password.',
        patternMismatch: 'Your password must contain a minimum of 8 characters containing both numbers and letters, with at least one uppercase letter and a special character (!@#$%&).'
      }
    },
    model: {
      value: (_vm.User.Password),
      callback: function($$v) {
        _vm.$set(_vm.User, "Password", $$v)
      },
      expression: "User.Password"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "forgotten-password",
    attrs: {
      "href": "/user/password-reset/email"
    }
  }, [_vm._v("Forgotten your password?")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-button"
  }, [(_vm.subsClub != undefined && _vm.subsClub != null) ? [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit"
    }
  }, [_vm._v("Sign in to join")])] : [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit"
    }
  }, [_vm._v("Sign in")])], _vm._v(" "), _c('p', [_vm._v("Don't have an SK profile yet? "), _c('br'), _c('a', {
    attrs: {
      "href": "/user/signup"
    }
  }, [_vm._v("Create one now")])])], 2)], 1)], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(547),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_meta_data_js__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'activate',
    data: function data() {
        return {
            loading: true,
            related_movies: [],
            movies: [],
            activationLoading: false,
            activationDialog: false
        };
    },


    methods: {
        resendActivation: function resendActivation() {
            var _this = this;

            this.activationLoading = false;
            __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].resendActivation().then(function () {
                _this.activationDialog = true;
                _this.activationLoading = false;
            });
        },
        getRelatedMovies: function getRelatedMovies(movies, user) {

            if (!user || user.isGuest() || user.PreferredGenres.length == 0) {
                var m = movies.data;
                return m;
            };

            var filteredMovies = [];
            movies.data.reduce(function (c, movie) {
                movie.genres.forEach(function (genre) {
                    user.PreferredGenres.forEach(function (prefGen) {
                        if (genre.id == prefGen) {
                            filteredMovies.push(movie);
                        }
                    });
                });
            });
            return filteredMovies;
        }
    },

    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user(), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovies()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                user = _ref2[0],
                movies = _ref2[1];

            _this2.related_movies = _this2.getRelatedMovies(movies, user);
            _this2.movies = movies.data;

            __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["f" /* ErrorHandler */].ignoreNextError();
            if (user.isGuest()) {
                _this2.$router.push("/user/login?redirect=/user/activate/" + _this2.$route.params.activationCode);
            } else __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].activateMember(_this2.$route.params.activationCode).then(function (r) {
                _this2.loading = false;
                if (!r.success) _this2.error = true;
                user.setActivated(true);
            }, function (e) {
                _this2.loading = false;
                _this2.error = true;
            });
        });
    }
});

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Please wait while we activate your profile")])], 1) : (!_vm.error) ? _c('div', [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "check-ticket"
  }, [_c('sk-title-heading', {
    attrs: {
      "h2": "",
      "label": "Congratulations, you're all done!"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "check-ticket--right"
  }, [_c('div', {
    staticClass: "movie-details"
  }, [_c('div', {
    staticClass: "confirmation-error"
  }, [_c('p', [_vm._v("Activation completed successfully.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "router": "",
      "to": "/user/profile"
    }
  }, [_vm._v("\n                                        Dashboard\n                                    ")]), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "tertiary": "",
      "router": "",
      "to": "/"
    }
  }, [_vm._v("\n                                        Take me home\n                                    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.related_movies.length > 0) ? _c('sk-related-movies', {
    attrs: {
      "limit": "6",
      "movies": _vm.related_movies,
      "label": "Movies we think you'll like"
    }
  }) : _c('sk-related-movies', {
    attrs: {
      "limit": "6",
      "movies": _vm.movies,
      "label": "Recommended Movies"
    }
  })], 1)])], 1)])], 1)], 1) : _c('div', [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "check-ticket"
  }, [_c('sk-title-heading', {
    attrs: {
      "h2": "",
      "label": "Oops! Something went wrong..."
    }
  }), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs10": "",
      "sm10": ""
    }
  }, [_c('div', {
    staticClass: "check-ticket--right"
  }, [_c('div', {
    staticClass: "movie-details"
  }, [(_vm.error != undefined) ? [_c('div', {
    staticClass: "confirmation-error"
  }, [_vm._v("\n                                                    We were unable to activate your account, please try again later.\n                                                ")])] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resendActivation()
      }
    }
  }, [_vm._v("\n                                                Resend Activation Code\n                                            ")]), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "tertiary": "",
      "router": "",
      "to": "/"
    }
  }, [_vm._v("\n                                                Take Me Home\n                                            ")])], 2)])])], 1)], 1)])], 1)], 1)])], 1), _vm._v(" "), _c('sk-dialog', {
    staticClass: "video",
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.activationDialog),
      callback: function($$v) {
        _vm.activationDialog = $$v
      },
      expression: "activationDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.activationDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.activationDialog = false
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Activation Code Sent")]), _vm._v(" "), _c('p', [_vm._v("Please check your mail in order to activate your account.")]), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "router": "",
      "to": "/"
    }
  }, [_vm._v("Show me home")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(550),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_meta_data_js__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'passwordreset',
  data: function data() {
    return {
      loading: false,
      loadingReset: false,
      codeVerified: null,
      passwordReset: null,
      userEmail: '',
      newPassword: '',
      emailsent: false,
      disabled: 0,
      showPasswordForm: false,

      resetCodeUrl: this.$route.params.resetCode,
      memberId: '',
      toastChecked: false,
      noEmailDialog: false
    };
  },

  methods: {
    verifyCode: function verifyCode(resetCode) {
      var _this = this;

      if (resetCode !== 'email' && resetCode.length === 36) {
        this.loading = true;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(ApiHttp.post(url + 'verify-password-reset-code', {
          reset_code: this.$route.params.resetCode
        })).then(function (res) {
          if (res.status) {
            _this.codeVerified = res;
            _this.memberId = res.data.MemberId;
          } else {}
          _this.loading = false;
        });
      }
    },

    initiatePasswordReset: function initiatePasswordReset(userEmail) {
      var _this2 = this;

      if (!this.disabled) {
        this.loadingReset = true;
        this.disabled = 1;
        var refUrl = document.location.hostname;
        var refPort = document.location.port;
        if (refPort > 0) {
          refUrl = document.location.hostname + ":" + document.location.port;
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].initiatePasswordReset(userEmail)).then(function (data) {
          if (!data.data.MemberNotFound) {

            _this2.emailsent = true;
            _this2.userEmail = userEmail;
          } else {
            _this2.noEmailDialog = true;
            _this2.disabled = 0;
          }
          _this2.loadingReset = false;
        });
      }
    },
    completePasswordReset: function completePasswordReset(newPassword, resetToken) {
      var _this3 = this;

      if (!this.disabled) {
        this.loadingReset = true;
        this.disabled = 1;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(ApiHttp.post(url + 'complete-password-reset', {
          new_password: newPassword,
          reset_token: resetToken,
          member_id: this.memberId
        })).then(function (data) {
          if (data.status || _this3.resetCodeUrl === 'dev') {
            window.location.href = '/user/reset';
          } else {
            _this3.disabled = 0;
          }
          _this3.loadingReset = false;
        });
      }
    }
  },

  mounted: function mounted() {
    this.verifyCode(this.resetCodeUrl);
  },


  computed: {
    isRequestCard: function isRequestCard() {
      if (this.$route.name === 'requestcard') return true;else return false;
    }
  }
});

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up reset-password"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', {
    attrs: {
      "user-signup": ""
    }
  }, [_c('sk-panel', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : [(_vm.resetCodeUrl == 'email') ? _c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "user-password-reset-code-form"
    },
    on: {
      "submit": function($event) {
        _vm.initiatePasswordReset(_vm.userEmail)
      }
    }
  }, [(_vm.emailsent) ? [_c('h3', {
    staticClass: "form-heading"
  }, [_vm._v("You've got mail!")]), _vm._v(" "), _c('p', [_vm._v("We sent an email to " + _vm._s(_vm.userEmail) + ". Please click on the link in your email to "), (_vm.isRequestCard) ? [_vm._v("activate your account and")] : _vm._e(), _vm._v(" reset your password.")], 2), _vm._v(" "), _c('p', [_vm._v("If you cannot access this email, please contact Customer Care on 0861 668 437 for further assistance.")])] : [(_vm.isRequestCard) ? [_c('h3', {
    staticClass: "form-heading"
  }, [_vm._v("Send activation link")]), _vm._v(" "), _c('p', [_vm._v("If you joined SK Club at one of our cinemas, please enter your email address and we will send you a link to activate your membership.")])] : [_c('h3', {
    staticClass: "form-heading"
  }, [_vm._v("Password Reset")]), _vm._v(" "), _c('p', [_vm._v("Please enter your email address and we'll send you a link to create a new password.")])], _vm._v(" "), _c('sk-input', {
    attrs: {
      "type": "email",
      "name": "email",
      "autocomplete": "email",
      "label": "Email",
      "placeholder": "e.g. xxx@gmail.com",
      "disabled": _vm.disabled == 1 ? true : false,
      "required": ""
    },
    model: {
      value: (_vm.userEmail),
      callback: function($$v) {
        _vm.userEmail = $$v
      },
      expression: "userEmail"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-button"
  }, [(_vm.isRequestCard) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "loading": _vm.loadingReset
    }
  }, [_vm._v("Send Activation email")]) : _c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "loading": _vm.loadingReset
    }
  }, [_vm._v("Reset My Password")])], 1), _vm._v(" "), _c('p', [(_vm.isRequestCard) ? [_vm._v("\n                Having trouble receiving your SK Club Activation email?\n              ")] : [_vm._v("\n                Can't access this email address?\n              ")], _vm._v("\n               Please contact Customer Care on "), (_vm.$breakpoints.xs) ? _c('a', {
    attrs: {
      "href": "tel:0861668437"
    }
  }, [_vm._v("0861 668 437")]) : _c('span', [_vm._v("0861 668 437")]), _vm._v(" for further assistance.")], 2)]], 2) : _vm._e(), _vm._v(" "), (_vm.codeVerified || _vm.resetCodeUrl == 'dev') ? _c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "user-password-reset-code-form"
    },
    on: {
      "submit": function($event) {
        _vm.completePasswordReset(_vm.newPassword, _vm.resetCodeUrl)
      }
    }
  }, [_c('h3', {
    staticClass: "form-heading"
  }, [_vm._v("Enter your new password")]), _vm._v(" "), _c('sk-input', {
    staticClass: "dark-input",
    attrs: {
      "name": "password",
      "autocomplete": "new-password",
      "label": "New Password",
      "disabled": _vm.disabled == 1 ? true : false,
      "type": "password",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter your password.',
        patternMismatch: 'Your password must contain a minimum of 8 characters containing both numbers and letters, with at least one uppercase letter and a special character (!@#$%&). '
      },
      "pattern": "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{8,}"
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-button"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "loading": _vm.loadingReset
    }
  }, [_vm._v("Reset My Password")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  })], 1)], 1) : _vm._e()]], 2)], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.noEmailDialog),
      callback: function($$v) {
        _vm.noEmailDialog = $$v
      },
      expression: "noEmailDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.noEmailDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.noEmailDialog = false
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Whoops!")]), _vm._v(" "), _c('p', [(_vm.isRequestCard) ? [_vm._v("\n          This email does not exist on our site. Please contact Customer Care on 0861 668 437 for further assistance.\n        ")] : [_vm._v("\n          This email does not exist on our site. Please create a profile.\n        ")]], 2), _vm._v(" "), (_vm.isRequestCard) ? [_c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.noEmailDialog = false
      }
    }
  }, [_vm._v("Got it")])] : [_c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": "/user/signup"
    }
  }, [_vm._v("Create a profile")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.noEmailDialog = false
      }
    }
  }, [_vm._v("Got it")])]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(553),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_meta_data_js__ = __webpack_require__(5);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            loadingReset: false,
            valid: false,
            complete: false,
            validateUser: null,
            newPassword: '',
            isGuest: true
        };
    },


    computed: {
        resetCodeUrl: function resetCodeUrl() {
            return this.$route.params.resetCode;
        }
    },

    methods: {
        completePasswordReset: function completePasswordReset(newPassword, confirmPassword) {
            var _this = this;

            this.loadingReset = true;
            var MemberId = this.validateUser.Member.MemberId;
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].completePasswordReset(newPassword, this.$route.params.resetCode, MemberId)).then(function (result) {

                if (result.success) {
                    _this.loadingReset = false;
                    if (_this.isGuest) _this.complete = true;else _this.$router.push("/user/profile");
                }
            }, function (error) {
                _this.loadingReset = false;
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
            });
        },
        continueToSignIn: function continueToSignIn() {
            this.$router.push("/user/login");
        }
    },

    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].validateResetCode(this.resetCodeUrl), __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].isGuestUser()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                result = _ref2[0],
                guest = _ref2[1];

            if (result.data.IsResetCodeValid) {
                _this2.valid = true;
                _this2.loading = false;
                _this2.validateUser = result.data;
                _this2.isGuest = guest;
            }
        }, function (error) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
        });
    }
});

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up reset-password"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', {
    attrs: {
      "user-signup": ""
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : (!_vm.loading && _vm.valid && !_vm.complete) ? _c('sk-panel', [_c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "user-password-reset-code-form"
    },
    on: {
      "submit": function($event) {
        _vm.completePasswordReset(_vm.newPassword, _vm.resetCodeUrl)
      }
    }
  }, [_c('h3', {
    staticClass: "form-heading"
  }, [_vm._v("Enter your new password")]), _vm._v(" "), _c('sk-input', {
    staticClass: "dark-input",
    attrs: {
      "name": "password",
      "autocomplete": "new-password",
      "label": "Your New Password",
      "type": "password",
      "required": "",
      "error-message": {
        patternMismatch: 'Your password must contain a minimum of 8 characters containing both numbers and letters, with at least one uppercase letter and a special character (!@#$%&). '
      },
      "pattern": "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{8,}"
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-button"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "loading": _vm.loadingReset
    }
  }, [_vm._v("Reset My Password")])], 1)], 1)], 1) : (!_vm.loading && _vm.valid && _vm.complete) ? _c('sk-panel', [_c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "user-password-reset-code-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h4', {
    staticClass: "form-heading"
  }, [_vm._v("Yay! Your new password has successfully been updated.")]), _vm._v(" "), _c('div', {
    staticClass: "form-button"
  }, [_c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.continueToSignIn()
      }
    }
  }, [_vm._v("Sign In")])], 1)])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(559),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__badgeConfig__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(7);










var TOTAL_VIP_MOVIES_REQUIREMENT = 15;
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'profile',
    data: function data() {
        var _ref;

        return _ref = {
            disabled: false,
            loading: false,
            loggedInUser: {},
            related_movies: [],
            relatedMoviesLabel: '',
            profile: false,
            showBookings: false,
            pointStatement: false,
            showUserActivation: false,
            activationLoading: false,
            BookingHistory: [],
            months: __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_ui_core__["Utils"].MonthMeta(),
            h1Active: true,
            preferences: {
                place_query: null,
                selected_cinema: [],
                selected_genres: [],
                selected_experiences: []
            },
            place: null,
            regions: [],
            genres: [],
            experiences: [],
            cinemasNearBy: [],
            search: 'sandton',
            updateLoader: false,
            loadBookings: true,
            skBadges: __WEBPACK_IMPORTED_MODULE_7__badgeConfig__["a" /* default */],
            movies: [],
            rewards: null,
            tierMoviesToGo: TOTAL_VIP_MOVIES_REQUIREMENT,
            tierMoviesPercentage: 0,
            changedEmail: null,
            nextReward: 400,
            linkingSkClub: false,
            linkingSB: false,
            loadingDelete: false,
            toggleJoinDialog: false,
            toggleActivateDialog: false,
            termsChecked: false,
            loadingUser: false,
            subsClub: null,
            subsClubColour: "primary",
            subsClubInactiveColour: "grey",
            subsClubIcon: "free-movieticket",
            subsClubSecondaryIcon: null,
            subsClubData: null,
            subsClubRenewDate: null,
            limitedSubsCinemas: ["3001", "6121", "6451", "5801", "1691", "1101", "4201", "4231", "1351", "5451", "6101"],
            unlimitedSubsCinemas: ["3001", "6121", "6451", "5801", "1691", "1101", "4201", "4231", "1351", "5451", "6101"],
            showConfirmReplaceCard: false,
            managePayment: false,
            card: { cardHolder: null, cardNumber: null, expiryMonth: null, expiryYear: null, cvvNumber: null, debitOrderDay: null, amount: 0, WorkZipCode: null },
            years: []
        }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'months', [{ name: "January", value: "1" }, { name: "February", value: "2" }, { name: "March", value: "3" }, { name: "April", value: "4" }, { name: "May", value: "5" }, { name: "June", value: "6" }, { name: "July", value: "7" },, { name: "August", value: "8" }, { name: "September", value: "9" }, { name: "October", value: "10" }, { name: "November", value: "11" }, { name: "December", value: "12" }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'processingUpdatePayment', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'updatePaymentStatus', undefined), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'subsClubitems', undefined), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'signedUpSubsClubItem', undefined), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'TermUrl', undefined), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'cancelSubLoading', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'toggleCancelSubDialog', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'toggleCardUpdate', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'loadingUpdateCard', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'adumoCardUpdate', {
            PaReq: '',
            TermUrl: "https://www.sterkinekor.com/middleware" + '/content/subscription?type=cardUpdateResponse',
            MD: '',
            postURL: ''
        }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'canCancelSub', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'canCancelSubErrorMessage', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'toggleDeleteAccountPrompt', false), _ref;
    },


    methods: {
        setUser: function setUser() {
            var _this = this;

            this.loadingUser = true;
            return __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user().then(function (user) {
                if (user != undefined && user != null) {
                    if (!user.isGuest() && user.MembershipActivated === false && _this.first_time) {
                        _this.showUserActivation = true;
                    } else {
                        _this.showUserActivation = false;
                    }

                    if (user.isGuest()) {
                        window.location.href = '/user/login';
                    } else {
                        _this.loggedInUser = user;
                        _this.loggedInUser.Password = null;
                        _this.loggedInUser.OldPassword = null;
                        if (localStorage.getItem('firstTimeDashboard') == null) _this.firstTimeUser(_this.loggedInUser);
                        _this.loadingUser = false;
                    }
                }

                return _this.loggedInUser;
            });
        },
        firstTimeUser: function firstTimeUser(user) {
            var today = new Date();
            var isToday = user.CreatedDate.isSame(today);

            if (isToday) {
                sessionStorage.setItem('firstTimeDashboard', true);
                if (sessionStorage.getItem('firstTimeDashboard')) {
                    this.$toaster.show('<strong>Congratulations, ' + this.loggedInUser.FirstName + '!</strong><br> You\uFFFDve earned 200 points just for joining SK Club! You can now view and keep track of your points on your dashboard.', this.$breakpoints.xs ? { fixed: true, timeout: 5000 } : {
                        top: true,
                        fullwidth: true,
                        timeout: 10000
                    });
                }
            }
        },
        linkCard: function linkCard(card) {
            console.warn('link card is deprecated');
        },
        linkSb: function linkSb(idNumber) {
            var _this2 = this;

            if (this.loggedInUser != undefined) {
                this.linkingSB = true;
                this.loggedInUser.NationalID = idNumber;
                this.loggedInUser.StandardBankBenefit = true;
                this.loggedInUser.save().then(function () {
                    _this2.linkingSB = false;
                }, function () {
                    _this2.linkingSB = false;
                    _this2.loggedInUser.NationalID = undefined;
                    _this2.loggedInUser.StandardBankBenefit = false;
                });
            }
        },
        linkSkClub: function linkSkClub(card) {
            var _this3 = this;

            this.linkingSkClub = true;
            this.loggedInUser.addCard(card, 'skClub');
            this.loggedInUser.saveCards().then(function (d) {
                _this3.loggedInUser.CardNumber = card;
                _this3.loggedInUser.MemberLevelId = 1;
                _this3.linkingSkClub = false;
            }, function (e) {
                _this3.linkingSkClub = false;
            });
        },
        checkSlClub: function checkSlClub() {
            this.toggleJoinDialog = true;
        },
        joinSkClub: function joinSkClub() {
            var _this4 = this;

            this.loadingDelete = true;
            this.loggedInUser.MemberLevelId = 1;
            this.updateUser().then(function () {
                _this4.loadingDelete = false;
                window.location.reload();
            });
        },


        placeSelected: function placeSelected(place) {
            this.place = place;
            this.getClosestCinema('cinemas/:latitude/:longitude');
        },

        getClosestCinema: function getClosestCinema() {
            var _this5 = this;

            __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getCinemasNearBy(this.place.latitude, this.place.longitude).then(function (cinemasNearBy) {

                cinemasNearBy.length = 5;

                _this5.cinemasNearBy = cinemasNearBy;
            });
        },
        selectSavedGenre: function selectSavedGenre(genre) {
            var newGenres = [];
            if (this.preferences.selected_genres.includes(genre.name)) {
                this.preferences.selected_genres.filter(function (arr) {
                    if (arr != genre.name) newGenres.push(arr);
                });
                this.preferences.selected_genres = newGenres;
            } else {
                this.preferences.selected_genres.push(genre.name);
            }
        },
        selectGenre: function selectGenre(genre, event) {
            var newGenres = [];
            if (this.preferences.selected_genres.includes(genre.name)) {
                this.preferences.selected_genres.filter(function (arr) {
                    if (arr != genre.name) newGenres.push(arr);else event.currentTarget.classList.remove('active');
                });
                this.preferences.selected_genres = newGenres;
            } else {
                this.preferences.selected_genres.push(genre.name);
                event.currentTarget.classList.add('active');
            }
        },
        selectExperience: function selectExperience(experience, event) {
            var newExp = [];
            if (this.preferences.selected_experiences.includes(experience.name)) {
                this.preferences.selected_experiences.filter(function (arr) {
                    if (arr != experience.name) newExp.push(arr);else event.currentTarget.classList.remove('active');
                });
                this.preferences.selected_experiences = newExp;
            } else {
                this.preferences.selected_experiences.push(experience.name);
                event.currentTarget.classList.add('active');
            }
        },
        updateUser: function updateUser() {
            var _this6 = this;

            this.updateLoader = true;
            return this.loggedInUser.save().then(function () {
                _this6.updateLoader = false, _this6.profile = false;
                window.scroll({ top: 0, left: 0 });
            });
        },
        allBookings: function allBookings(currentTarget) {
            this.pointStatement = false;
            this.showBookings = true;
            window.scroll({ top: currentTarget.offsetTop + 200, left: 0, behavior: 'smooth' });
        },
        togglePoints: function togglePoints(currentTarget) {
            this.pointStatement = !this.pointStatement;
            if (this.pointStatement) window.scroll({ top: currentTarget.offsetTop + 200, left: 0, behavior: 'smooth' });
        },
        saveProfile: function saveProfile() {
            var _this7 = this;

            var genreIds = [];

            for (var g = 0; g < this.genres.length; g++) {
                for (var sg = 0; sg < this.preferences.selected_genres.length; sg++) {
                    if (this.genres[g].name == this.preferences.selected_genres[sg]) {
                        genreIds.push(this.genres[g].id);
                    }
                }
            }

            if (this.loggedInUser.Email != this.changedEmail) {
                __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["b" /* AuthService */].initiateEmailChange(this.changedEmail, this.loggedInUser.MemberId).then(function (result) {});
            }

            this.loggedInUser.PreferredGenres = genreIds;

            this.updateLoader = true;

            __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["b" /* AuthService */].updateUser(this.loggedInUser).then(function () {

                _this7.updateLoader = false;
                window.scroll({ top: 0 });
                _this7.$toaster.show('Thanks for the update! Your info has successfully been saved.', _this7.$breakpoints.xs ? { fixed: true, timeout: 5000 } : {
                    top: true,
                    fullwidth: true,
                    timeout: 5000
                });
            });
        },
        getRelatedMovies: function getRelatedMovies(movies, user) {
            if (!user || user.isGuest() || user.PreferredGenres.length == 0) {
                return movies.data;
            }
            ;
            var filteredMovies = [];
            movies.data.reduce(function (c, movie) {
                movie.genres.forEach(function (genre) {
                    user.PreferredGenres.forEach(function (prefGen) {
                        if (genre.id == prefGen) {
                            filteredMovies.push(movie);
                        }
                    });
                });
            });
            return filteredMovies;
        },
        goToResetPassword: function goToResetPassword() {
            this.$router.push("/user/password-reset/email");
        },
        getSubsData: function getSubsData() {
            var subsClubRaw = window.localStorage.getItem('subsClub');

            var subsClub = null;
            if (subsClubRaw && subsClubRaw != undefined) {
                subsClub = JSON.parse(subsClubRaw);
            }

            this.subsClub = subsClub;
            return subsClub;
        },
        sendWelcomeMailFan: function sendWelcomeMailFan(user) {
            var _this8 = this;

            var formData = {
                "FirstName": user.FirstName,
                "LastName": user.LastName,
                "Email": user.Email,
                "CardNumber": user.CardNumber
            };

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["c" /* ContactUsService */].sendWelcomeMailFan(formData)).then(function (data) {
                _this8.loggedInUser.ZipCode = "True";
                _this8.saveProfile();
            });
        },
        sendWelcomeMailMorvies: function sendWelcomeMailMorvies(user) {
            var _this9 = this;

            var formData = {
                "FirstName": user.FirstName,
                "LastName": user.LastName,
                "Email": user.Email,
                "CardNumber": user.CardNumber
            };

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["c" /* ContactUsService */].sendWelcomeMailMORvies(formData)).then(function (data) {
                _this9.loggedInUser.ZipCode = "True";
                _this9.saveProfile();
            });
        },
        resendVerification: function resendVerification() {
            var _this10 = this;

            this.activationLoading = true;
            __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["b" /* AuthService */].resendActivation().then(function () {
                _this10.$emit('change', true);
                _this10.showUserActivation = false;
                _this10.activationLoading = false;
            });
        },
        confirmReplaceCard: function confirmReplaceCard() {
            this.showConfirmReplaceCard = true;
        },
        replaceCard: function replaceCard() {},
        setDateData: function setDateData() {
            var today = new Date();

            var year = today.getFullYear();
            var yearEnd = year + 10;

            for (var y = year; y <= yearEnd; y++) {
                this.years.push({ year: y });
            }

            return this.years;
        },
        updateCardSubscription: function updateCardSubscription() {
            var _this11 = this;

            this.loadingUpdateCard = true;
            __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["a" /* AdumoService */].updateCardSubscription(this.loggedInUser.MemberId, this.card).then(function (result) {
                if (result.success == true) {
                    if (result.data.status == true) {
                        _this11.adumoCardUpdate.MD = result.data.response.acsMD;
                        _this11.adumoCardUpdate.PaReq = result.data.response.acsPayload;
                        _this11.adumoCardUpdate.postURL = result.data.response.acsUrl;
                        __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].nextTick(function () {
                            _this11.$refs.frmLaunchACS.$el.submit();
                            _this11.loadingUpdateCard = false;
                        });
                    } else {
                        _this11.$toaster.show('Card details could not be updated, please try again or contact customer support.', _this11.$breakpoints.xs ? { fixed: true, timeout: 5000 } : {
                            top: true,
                            fullwidth: true,
                            timeout: 10000
                        });
                        _this11.loadingUpdateCard = false;
                    }
                } else {
                    _this11.$toaster.show('Card details could not be updated, please try again or contact customer support.', _this11.$breakpoints.xs ? { fixed: true, timeout: 5000 } : {
                        top: true,
                        fullwidth: true,
                        timeout: 10000
                    });
                    _this11.loadingUpdateCard = false;
                }
            });
        },
        prepareUpdateDetails: function prepareUpdateDetails() {
            var _this12 = this;

            this.card.WorkZipCode = this.loggedInUser.WorkZipCode;
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].prepareSubsUpdateDetails(this.card)).then(function (result) {
                if (result.data != undefined && result.data != null) {
                    var md_decoded = atob(result.data.md);

                    if (result.success == true) {
                        if (result.data.status == true) {
                            document.getElementById('frmLaunchACS').action = result.data.lookup.acsUrl;
                            document.getElementById('PaReq').value = result.data.lookup.payload;
                            document.getElementById('TermUrl').value = _this12.TermUrl;
                            document.getElementById('MD').value = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(result.data.md);
                            document.getElementById('frmLaunchACS').submit();
                        } else {
                            _this12.$toaster.show('Payment details could not be updated, please try again or contact customer support.', _this12.$breakpoints.xs ? { fixed: true, timeout: 5000 } : {
                                top: true,
                                fullwidth: true,
                                timeout: 10000
                            });
                        }
                    } else {
                        _this12.$toaster.show('Payment details could not be updated, please try again or contact customer support.', _this12.$breakpoints.xs ? { fixed: true, timeout: 5000 } : {
                            top: true,
                            fullwidth: true,
                            timeout: 10000
                        });
                    }
                }
            });
        },
        updatePaymentDetails: function updatePaymentDetails() {
            var _this13 = this;

            this.processingUpdatePayment = true;
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].updateSubsPaymentDetails(this.card)).then(function (result) {

                if (result.data.success) {
                    _this13.updatePaymentStatus = true;
                    _this13.$toaster.show('Payment details updated successfully.', _this13.$breakpoints.xs ? { fixed: true, timeout: 5000 } : {
                        top: true,
                        fullwidth: true,
                        timeout: 10000
                    });

                    _this13.managePayment = false;
                    window.scroll({ top: 0, left: 0 });
                } else {
                    _this13.$toaster.show('Payment details could not be updated, please try again or contact customer support.', _this13.$breakpoints.xs ? { fixed: true, timeout: 5000 } : {
                        top: true,
                        fullwidth: true,
                        timeout: 10000
                    });

                    window.scroll({ top: 0, left: 0 });
                }

                _this13.processingUpdatePayment = false;
            });
        },
        getConcessionItems: function getConcessionItems(concessionItems) {
            var items = [];
            for (var k = 0; k < concessionItems.length; k++) {
                var item = concessionItems[k];
                item.Price = "R " + concessionItems[k].PriceInCents / 100;
                item.Quantity = 1;
                items[k] = item;
            }

            return items;
        },
        cancelSubscription: function cancelSubscription(memberId) {
            var _this14 = this;

            this.cancelSubLoading = true;
            __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["a" /* AdumoService */].cancelSubscription(memberId, this.loggedInUser.UserSessionId).then(function (response) {
                _this14.loggedInUser.MemberLevelId = 0;
                var unLimitSub = _this14.loggedInUser.PreferenceList.indexOf(5);
                var limitSub = _this14.loggedInUser.PreferenceList.indexOf(6);
                var cancelledTrigger = false;
                if (unLimitSub !== -1) {
                    _this14.loggedInUser.PreferenceList.splice(unLimitSub, 1);
                    cancelledTrigger = true;
                } else if (limitSub !== -1) {
                    _this14.loggedInUser.PreferenceList.splice(limitSub, 1);
                    cancelledTrigger = true;
                }
                if (cancelledTrigger) {
                    _this14.updateUser().then(function () {
                        _this14.cancelSubLoading = false;
                        window.localStorage.setItem('cancelledSub', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(response));
                    });
                }
            }).catch(function (error) {
                _this14.cancelSubLoading = false;
                throw Error(error.error_string);
            });
        },
        tiktokPixel: function tiktokPixel() {
            !function (w, d, t) {
                w.TiktokAnalyticsObject = t;var ttq = w[t] = w[t] || [];ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"], ttq.setAndDefer = function (t, e) {
                    t[e] = function () {
                        t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                    };
                };for (var i = 0; i < ttq.methods.length; i++) {
                    ttq.setAndDefer(ttq, ttq.methods[i]);
                }ttq.instance = function (t) {
                    for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) {
                        ttq.setAndDefer(e, ttq.methods[n]);
                    }return e;
                }, ttq.load = function (e, n) {
                    var i = "https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = i, ttq._t = ttq._t || {}, ttq._t[e] = +new Date(), ttq._o = ttq._o || {}, ttq._o[e] = n || {};n = document.createElement("script");n.type = "text/javascript", n.async = !0, n.src = i + "?sdkid=" + e + "&lib=" + t;e = document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n, e);
                };
                ttq.load('CI0O5VBC77UDF7B222DG');
                ttq.page();
            }(window, document, 'ttq');
        },
        doDeleteAccount: function doDeleteAccount() {
            var _this15 = this;

            this.loading = true;
            this.toggleDeleteAccountPrompt = false;

            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["b" /* AuthService */].deleteAccount()).then(function (result) {
                console.log(result.data);
                _this15.loading = false;
                _this15.$router.push({ path: '/user/sign-out' });
            });
        }
    },

    created: function created() {
        var _this16 = this;

        this.loading = true;
        window.scrollTo(top);
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getBookingHistory(), __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getRegions(), __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["i" /* MovieMetaService */].getMovieMeta(), __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovies(), __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["b" /* AuthService */].getRewards(), this.setUser(), __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getTransactionHistory(), this.getSubsData(), __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getConsessionsByCinemaId("standalone"), __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getApiHttpDefaultBaseLinkUrl()]).then(function (_ref2) {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 10),
                bookingHistory = _ref3[0],
                regions = _ref3[1],
                meta = _ref3[2],
                movies = _ref3[3],
                UserRewards = _ref3[4],
                user = _ref3[5],
                history = _ref3[6],
                subs = _ref3[7],
                standAloneConcessions = _ref3[8],
                httpData = _ref3[9];

            if (_this16.loggedInUser.PreferredGenres == undefined) {
                location.reload();
            } else {
                _this16.setDateData();

                _this16.TermUrl = httpData + "/payment/manage/update-details";

                for (var _i = 0; _i < standAloneConcessions.length; _i++) {
                    if (standAloneConcessions[_i].Name == "Subs") {
                        _this16.subsClubitems = _this16.getConcessionItems(standAloneConcessions[_i].ConcessionItems);
                    }
                }

                if (_this16.loggedInUser != undefined && _this16.loggedInUser != null) {
                    if (_this16.loggedInUser.ZipCode != undefined && _this16.loggedInUser.ZipCode != null) {
                        if (_this16.loggedInUser.ZipCode != "True") {
                            if (_this16.loggedInUser.CardNumber != undefined && _this16.loggedInUser.CardNumber != null) {
                                if (_this16.loggedInUser.PreferenceList != undefined && _this16.loggedInUser.PreferenceList != null) {
                                    if (_this16.loggedInUser.PreferenceList.includes(5)) {
                                        _this16.sendWelcomeMailMorvies(_this16.loggedInUser);
                                    }

                                    if (_this16.loggedInUser.PreferenceList.includes(6)) {
                                        _this16.sendWelcomeMailFan(_this16.loggedInUser);
                                    }
                                }
                            }
                        }
                    }
                }

                if (_this16.$route.params.managepayment != undefined && _this16.$route.params.managepayment != null) {

                    if (_this16.$route.params.managepayment == "success") {
                        _this16.updatePaymentStatus = true;
                        _this16.$toaster.show('Payment details updated successfully.', _this16.$breakpoints.xs ? { fixed: true, timeout: 5000 } : {
                            top: true,
                            fullwidth: true,
                            timeout: 10000
                        });

                        _this16.managePayment = false;
                        window.scroll({ top: 0, left: 0 });
                    } else if (_this16.$route.params.managepayment == "failure") {
                        _this16.$toaster.show('Payment details could not be updated, please try again or contact customer support.', _this16.$breakpoints.xs ? { fixed: true, timeout: 5000 } : {
                            top: true,
                            fullwidth: true,
                            timeout: 10000
                        });
                        window.scroll({ top: 0, left: 0 });
                    }
                }

                if (_this16.subsClubitems != undefined) {
                    for (var _i2 = 0; _i2 < _this16.subsClubitems.length; _i2++) {
                        if (_this16.subsClubitems[_i2].Description == "Unlimited Subs") {
                            if (_this16.loggedInUser.PreferenceList != undefined && _this16.loggedInUser.PreferenceList != null) {
                                if (_this16.loggedInUser.PreferenceList.includes(5)) {
                                    _this16.signedUpSubsClubItem = _this16.subsClubitems[_i2];
                                }
                            }
                        }

                        if (_this16.subsClubitems[_i2].Description == "Limited Subs") {
                            if (_this16.loggedInUser.PreferenceList != undefined && _this16.loggedInUser.PreferenceList != null) {
                                if (_this16.loggedInUser.PreferenceList.includes(6)) {
                                    _this16.signedUpSubsClubItem = _this16.subsClubitems[_i2];
                                }
                            }
                        }
                    }
                }

                if (_this16.signedUpSubsClubItem != undefined) {
                    _this16.card.amount = _this16.signedUpSubsClubItem.PriceInCents / 100;
                }

                var skClubReplaceCard = window.localStorage.getItem('skClubReplaceCard');
                if (skClubReplaceCard != undefined) {
                    if (skClubReplaceCard) {
                        window.scroll({ top: 0, left: 0 });
                        _this16.$toaster.show('SK Club card has been replaced successfully.', _this16.$breakpoints.xs ? { fixed: true, timeout: 5000 } : {
                            top: true,
                            fullwidth: true,
                            timeout: 10000
                        });
                        window.localStorage.removeItem('skClubReplaceCard');
                    }
                }

                if (_this16.subsClub != null && _this16.subsClub != undefined) {
                    if (_this16.loggedInUser != undefined && _this16.loggedInUser != null) {
                        if (_this16.loggedInUser.PreferenceList != undefined && _this16.loggedInUser.PreferenceList != null) {
                            if (!_this16.loggedInUser.PreferenceList.includes(5) && !_this16.loggedInUser.PreferenceList.includes(6)) {
                                _this16.$router.push("/subscribe/1");
                            } else {
                                window.localStorage.removeItem("subsClub");
                            }
                        }
                    }
                }

                var firstLogin = localStorage.getItem("firstLogin");
                if (firstLogin !== null) {
                    _this16.tiktokPixel();
                    localStorage.removeItem("firstLogin");
                }

                if (_this16.loggedInUser.MembershipActivated && __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["b" /* AuthService */].firstLogin == true) {

                    __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["b" /* AuthService */].firstLogin = false;
                    _this16.$toaster.show('Welcome back! You are now signed in.', _this16.$breakpoints.xs ? {
                        fixed: true,
                        timeout: 5000
                    } : {
                        top: true,
                        fullwidth: true,
                        timeout: 5000,
                        fixed: false
                    });
                }

                _this16.BookingHistory = bookingHistory;
                _this16.regions = regions.data;
                _this16.genres = meta.genres;
                _this16.experiences = meta.experiences;
                _this16.changedEmail = _this16.loggedInUser.Email;

                if (_this16.loggedInUser.PreferredGenres != undefined) {
                    for (var g = 0; g < _this16.genres.length; g++) {
                        if (_this16.loggedInUser.PreferredGenres != undefined) if (_this16.loggedInUser.PreferredGenres.includes(parseInt(_this16.genres[g].id))) {
                            _this16.selectSavedGenre(_this16.genres[g]);
                        }
                        _this16.BookingHistory = bookingHistory;
                        _this16.regions = regions.data;
                        _this16.genres = meta.genres;
                        _this16.experiences = meta.experiences;
                        _this16.changedEmail = _this16.loggedInUser.Email;
                        for (var g = 0; g < _this16.genres.length; g++) {
                            if (_this16.loggedInUser.PreferredGenres.includes(parseInt(_this16.genres[g].id))) {
                                _this16.selectSavedGenre(_this16.genres[g]);
                            }
                        }

                        if (_this16.loggedInUser.PreferredGenres.length > 0) {
                            _this16.related_movies = _this16.getRelatedMovies(movies, user);
                            _this16.relatedMoviesLabel = 'Movies we think you\'ll enjoy';
                        } else {
                            _this16.related_movies = movies.data;
                            _this16.relatedMoviesLabel = 'Movies now showing';
                        }
                    }
                }

                var rewards = UserRewards.ConcessionList.concat(UserRewards.TicketTypeList);
                _this16.rewards = rewards;

                for (var i = 0; i < rewards.length; i++) {
                    var reward = rewards[i];
                    for (var j = 0; j < _this16.skBadges.length; j++) {
                        var badge = _this16.skBadges[j];
                        if (badge.test(reward)) {
                            badge.active = true;
                            badge.alt = reward.NameAlt !== "" ? reward.NameAlt : undefined;
                            _this16.nextReward = badge.nextPoints !== undefined ? badge.nextPoints : _this16.nextReward;
                        }
                    }
                }

                var year = new Date().getFullYear(),
                    num_movies_watched = history.filter(function (h) {
                    return h.year == year && h.MovieId;
                }).length;
                _this16.tierMoviesToGo = TOTAL_VIP_MOVIES_REQUIREMENT - num_movies_watched;
                _this16.tierMoviesPercentage = num_movies_watched / TOTAL_VIP_MOVIES_REQUIREMENT * 100;

                if (_this16.loggedInUser.ExpiryPointsList != undefined) {
                    for (var i = 0; i < _this16.loggedInUser.ExpiryPointsList.length; i++) {
                        var point = _this16.loggedInUser.ExpiryPointsList[i];
                        if (point.ExpiringSoon === true) {
                            _this16.$toaster.show('<strong>Don\'t let your points go to waste!</strong><br> <strong>' + point.PointsExpiring + '</strong> Points will Expire on ' + point.friendlyExpiryDate + ' ', {
                                dismissable: true,
                                fullwidth: true,

                                timeout: 0
                            }, document.body.querySelector('.points-display'));
                            break;
                        }
                    }
                }

                if (_this16.$route.query.cardUpdate) {
                    if (_this16.$route.query.cardUpdate == 'success') {
                        __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["a" /* AdumoService */].updateCardSubscriptionTokens(_this16.loggedInUser.MemberId).then(function () {
                            _this16.$toaster.show('Card details have been updated successfully.', _this16.$breakpoints.xs ? { fixed: true, timeout: 5000 } : {
                                top: true,
                                fullwidth: true,
                                timeout: 10000
                            });
                            _this16.$router.replace({ path: _this16.$route.path });
                        });
                    }
                    if (_this16.$route.query.cardUpdate == 'failed') {
                        _this16.$toaster.show('Card details could not be updated, please try again or contact customer support.', _this16.$breakpoints.xs ? { fixed: true, timeout: 5000 } : {
                            top: true,
                            fullwidth: true,
                            timeout: 10000
                        });
                    }
                }

                __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["a" /* AdumoService */].checkCancelSubscription(_this16.loggedInUser.MemberId).then(function (res) {
                    _this16.canCancelSub = res.data.success;
                    if (!_this16.canCancelSub) _this16.canCancelSubErrorMessage = res.data.error;
                }).catch(function (error) {
                    throw Error(error.error_string);
                });

                _this16.loading = false;

                if (window.localStorage.getItem('cancelledSub')) {
                    var cancelledSubStorage = window.localStorage.getItem('cancelledSub');
                    var parseCancelledSubStorage = JSON.parse(cancelledSubStorage);
                    window.localStorage.removeItem('cancelledSub');
                    _this16.$toaster.show(parseCancelledSubStorage.data.success ? 'Subscription has been cancelled' : parseCancelledSubStorage.data.error, _this16.$breakpoints.xs ? { fixed: true, timeout: 5000 } : {
                        top: true,
                        fullwidth: true,
                        timeout: 10000
                    });
                }

                __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].nextTick(function () {
                    if (_this16.$route.hash === '#cards') {
                        window.scroll({ top: document.querySelector('#cards').offsetTop, left: 0, behavior: 'smooth' });
                    }
                    if (_this16.$route.hash === '#join') {
                        _this16.toggleJoinDialog = true;
                        window.location.hash = '';
                    }
                });
            }
        });
    },
    beforeMount: function beforeMount() {
        __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["b" /* AuthService */].addObserver(this, __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["b" /* AuthService */].PROFILE_CHANGED, this.setUser);
    },


    computed: {
        slidesPerPage: function slidesPerPage() {
            if (this.$breakpoints.xs) return 1;else if (this.$breakpoints.sm || this.$breakpoints.md) return 2;else return 3;
        },
        mostRecentBooking: function mostRecentBooking() {
            var earliest = this.BookingHistory ? this.BookingHistory.sort(function (a, b) {
                return a.BookingDate.date.diff(b.BookingDate.date);
            }) : [];
            return earliest.length > 0 ? earliest[0] : {};
        },
        cinemasByRegion: function cinemasByRegion() {
            return [{ name: 'Nearby', cinemas: this.cinemasNearBy }].concat(this.regions);
        },
        currentYear: function currentYear() {
            return __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY');
        },
        isUsersBirthday: function isUsersBirthday() {
            var now = new Date();
            var today = new Date(now.getDate() + '/' + now.getMonth() + '/' + now.getFullYear());
            var usersDOB = new Date(this.loggedInUser.DateOfBirth);
            return today.getTime() === usersDOB.getTime();
        }
    },

    watch: {
        '$route': function $route(to, from) {
            if (to.hash == '#join') {
                this.toggleJoinDialog = true;
                window.location.hash = '';
            }
        }
    }
});

/***/ }),
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), (_vm.loading || _vm.loadingUser) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('sk-container', [_c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleJoinDialog),
      callback: function($$v) {
        _vm.toggleJoinDialog = $$v
      },
      expression: "toggleJoinDialog"
    }
  }, [_c('h3', [_vm._v("Join SK Club")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-checkbox', {
    staticClass: "checkbox--light-input",
    attrs: {
      "label": "I want to join SK Club now",
      "value": "termsChecked"
    },
    model: {
      value: (_vm.termsChecked),
      callback: function($$v) {
        _vm.termsChecked = $$v
      },
      expression: "termsChecked"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('sk-tooltip', {
    key: "join-tooltip",
    attrs: {
      "content": "SK Club roles out the red carpet for those who are serious about experiencing movies the best way possible! Join the SK Club now to unlock great discounts, earn points and get special treatment!"
    }
  })], 1)], 2), _vm._v(" "), _c('span', [_vm._v("By joining SK Club, you agree to our "), _c('a', {
    attrs: {
      "href": "/content/legal/club-terms-and-conditions",
      "target": "_blank"
    }
  }, [_vm._v("SK Club Ts & Cs")])]), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": 20
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "disabled": !_vm.termsChecked,
      "loading": _vm.loadingDelete
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.joinSkClub()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "disabled": _vm.loadingDelete
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleJoinDialog = false
      }
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleActivateDialog),
      callback: function($$v) {
        _vm.toggleActivateDialog = $$v
      },
      expression: "toggleActivateDialog"
    }
  }, [_c('h3', [_vm._v("Activate your account")]), _vm._v(" "), _c('hr'), _vm._v("\n            Please activate your account before attempting to join Sk Club\n            "), _c('sk-spacer', {
    attrs: {
      "height": 20
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleActivateDialog = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleDeleteAccountPrompt),
      callback: function($$v) {
        _vm.toggleDeleteAccountPrompt = $$v
      },
      expression: "toggleDeleteAccountPrompt"
    }
  }, [_c('h3', [_vm._v("Are you sure?")]), _vm._v(" "), _c('hr'), _vm._v("\n            Are you sure you want to delete your account?\n            "), _c('sk-spacer', {
    attrs: {
      "height": 20
    }
  }), _vm._v(" "), _c('sk-button', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDeleteAccountPrompt = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.doDeleteAccount()
      }
    }
  }, [_vm._v("Yes")])], 1), _vm._v(" "), _c('div', {
    staticClass: "profile-header"
  }, [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "welcome-message"
  }, [_c('h2', {
    staticClass: "profile-heading"
  }, [(_vm.isUsersBirthday) ? [_vm._v("\n                                    Happy Birthday " + _vm._s(_vm.loggedInUser.FirstName) + "! Enjoy a movie on us for your Birthday\n                                ")] : [_vm._v("\n                                    Hi " + _vm._s(_vm.loggedInUser.FirstName) + "! Welcome To Your Dashboard\n                                ")]], 2), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('sk-icon', {
    attrs: {
      "email": ""
    }
  }), _vm._v("\n                                " + _vm._s(_vm.loggedInUser.Email) + " "), _c('br'), _vm._v(" "), (_vm.loggedInUser.CardNumber != undefined && _vm.loggedInUser.CardNumber != null) ? [(_vm.loggedInUser.CardNumber.length > 0) ? _c('span', [_vm._v("SK Club card number: " + _vm._s(_vm.loggedInUser.CardNumber))]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (_vm.showUserActivation) ? _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#dddee0"
    }
  }, [_vm._v("\n                                Thanks for creating an SK profile! Please activate your account by checking your email for your verification link. Haven't received it? "), _c('sk-button', {
    staticClass: "btn--reactivate",
    attrs: {
      "link": "",
      "loading": _vm.activationLoading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resendVerification()
      }
    }
  }, [_vm._v("Resend the verification email now")]), _vm._v(".\n                            ")], 1) : _vm._e()])])], 1), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "view-profile"
  }, [_c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.profile = !_vm.profile;
        _vm.managePayment = !_vm.profile
      }
    }
  }, [_vm._v("Edit Profile")]), _vm._v(" "), ((_vm.loggedInUser.PreferenceList.includes(5) || _vm.loggedInUser.PreferenceList.includes(6)) && (_vm.loggedInUser.WorkZipCode != undefined && _vm.loggedInUser.WorkZipCode != null)) ? _c('sk-button', {
    attrs: {
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.managePayment = !_vm.managePayment;
        _vm.profile = !_vm.managePayment
      }
    }
  }, [_vm._v("Manage Payments")]) : _vm._e()], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "profile-content-body"
  }, [_c('div', {
    staticClass: "profile-content-body--wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "slide-y-transition"
    }
  }, [(_vm.profile) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "profile-content"
  }, [_c('sk-form', {
    staticClass: "profile-form",
    attrs: {
      "id": "user-signup-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('sk-panel', [_c('sk-title-heading', {
    attrs: {
      "h3": "",
      "label": "Personal Details"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('sk-icon', {
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.profile = false
      }
    }
  })], 1)], 2), _vm._v(" "), _c('p', {
    staticClass: "manditory-fields"
  }, [_vm._v("All Fields are manditory")]), _vm._v(" "), _c('div', {
    staticClass: "profile-form--wrapper"
  }, [_c('sk-input', {
    staticClass: "dark-input",
    attrs: {
      "value": "",
      "label": "First Name",
      "placeholder": "John",
      "name": "fname",
      "autocomplete": "given-name",
      "prepend": ""
    },
    model: {
      value: (_vm.loggedInUser.FirstName),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "FirstName", $$v)
      },
      expression: "loggedInUser.FirstName"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "value": "",
      "label": "Surname",
      "placeholder": "Doe",
      "name": "lname",
      "autocomplete": "family-name"
    },
    model: {
      value: (_vm.loggedInUser.LastName),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "LastName", $$v)
      },
      expression: "loggedInUser.LastName"
    }
  }), _vm._v(" "), _c('sk-layout', {
    staticClass: "radio-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "gender-label",
    attrs: {
      "for": "gender"
    }
  }, [_vm._v("Gender")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('sk-radio', {
    attrs: {
      "name": "radio-gender",
      "radio-value": "Female",
      "label": "Female"
    },
    model: {
      value: (_vm.loggedInUser.Gender),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "Gender", $$v)
      },
      expression: "loggedInUser.Gender"
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('sk-radio', {
    attrs: {
      "name": "radio-gender",
      "radio-value": "Male",
      "label": "Male"
    },
    model: {
      value: (_vm.loggedInUser.Gender),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "Gender", $$v)
      },
      expression: "loggedInUser.Gender"
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('sk-radio', {
    attrs: {
      "name": "radio-gender",
      "radio-value": "Unknown",
      "label": "I'd rather not say"
    },
    model: {
      value: (_vm.loggedInUser.Gender),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "Gender", $$v)
      },
      expression: "loggedInUser.Gender"
    }
  })], 1)], 1), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Household Size")]), _vm._v(" "), _c('sk-select', {
    attrs: {
      "placeholder": "Household Size",
      "type": "number"
    },
    model: {
      value: (_vm.loggedInUser.PersonsInHousehold),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "PersonsInHousehold", $$v)
      },
      expression: "loggedInUser.PersonsInHousehold"
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Household Size")]), _vm._v(" "), _vm._l((10), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i))])
  })], 2)], 1)], 1), _vm._v(" "), _c('sk-panel', [_c('sk-title-heading', {
    attrs: {
      "h3": "",
      "label": "Contact Details"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "profile-form--wrapper"
  }, [_c('sk-input', {
    attrs: {
      "label": "Email",
      "value": "",
      "placeholder": "e.g. xxx@gmail.com",
      "autocomplete": "email",
      "name": "email",
      "type": "email",
      "required": "",
      "error-message": {
        valueMissing: 'Please make sure your email address follows this format: example@email.com'
      }
    },
    model: {
      value: (_vm.changedEmail),
      callback: function($$v) {
        _vm.changedEmail = $$v
      },
      expression: "changedEmail"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Mobile Number",
      "autocomplete": "tel",
      "name": "mobile",
      "placeholder": "eg. +27827804800",
      "type": "tel",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter your mobile number',
        patternMismatch: 'Please double check you\'ve entered 9 digits excluding your country code.'
      },
      "pattern": "^\\+?\\d{11,11}|\\d{10,10}$"
    },
    model: {
      value: (_vm.loggedInUser.MobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "MobilePhone", $$v)
      },
      expression: "loggedInUser.MobilePhone"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-panel', {
    staticClass: "form"
  }, [_c('sk-title-heading', {
    attrs: {
      "h3": "",
      "label": "Your Movie Preferences"
    }
  }), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Make this my default cinema")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "profile-cinema form--inline"
  }, [_c('sk-google-places-input', {
    ref: "location_input",
    staticClass: "location-search",
    attrs: {
      "placeholder": "Seach location",
      "geolocation": "",
      "autocomplete": "",
      "pinOnly": ""
    },
    on: {
      "place-selected": _vm.placeSelected
    },
    model: {
      value: (_vm.preferences.place_query),
      callback: function($$v) {
        _vm.$set(_vm.preferences, "place_query", $$v)
      },
      expression: "preferences.place_query"
    }
  }), _vm._v(" "), _c('sk-combo-select', {
    staticClass: "cinema-select form-group",
    attrs: {
      "options": _vm.cinemasByRegion,
      "group-values": "cinemas",
      "group-label": "name",
      "track-by": "id",
      "search": _vm.search,
      "label": "name",
      "searchable": true,
      "placeholder": "Choose a cinema",
      "multiple": false
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.$groupLabel) ? [_vm._v("\n                                                        " + _vm._s(props.option.$groupLabel) + "\n                                                    ")] : [_c('span', {
          staticClass: "option__title",
          class: {
            'genres': props.option.loyalty_cinema_id
          }
        }, [_vm._v(_vm._s(props.option.name) + " "), (props.option.distance) ? [_vm._v("- " + _vm._s(props.option.distance) + "KM")] : _vm._e()], 2)]]
      }
    }]),
    model: {
      value: (_vm.loggedInUser.PreferredComplex),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "PreferredComplex", $$v)
      },
      expression: "loggedInUser.PreferredComplex"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_vm._v("\n                                                    No cinema found, please try a different cinema\n                                                ")])], 2)], 1), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Prefered Genres")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "preferences__labels"
  }, _vm._l((_vm.genres), function(genre) {
    return _c('span', {
      key: genre.id,
      staticClass: "preferences__labels-item"
    }, [(_vm.loggedInUser.PreferredGenres.includes(parseInt(genre.id))) ? [_c('span', {
      staticClass: "label label--lg active",
      on: {
        "click": function($event) {
          _vm.selectGenre(genre, $event)
        }
      }
    }, [_vm._v(_vm._s(genre.name))])] : [_c('span', {
      staticClass: "label label--lg",
      on: {
        "click": function($event) {
          _vm.selectGenre(genre, $event)
        }
      }
    }, [_vm._v(_vm._s(genre.name))])]], 2)
  }))], 1), _vm._v(" "), _c('sk-panel', [_c('h3', [_vm._v("Your Email Subscription Settings")]), _vm._v(" "), _c('hr', {
    staticClass: "hr--transparent"
  }), _vm._v(" "), _c('div', {
    staticClass: "profile-form--wrapper"
  }, [_c('sk-checkbox', {
    staticClass: "checkbox--light newsletter__subscribe",
    attrs: {
      "id": "subscribe",
      "value": "subscribe",
      "label": "Subscibe me to the SK Newsletter"
    },
    model: {
      value: (_vm.loggedInUser.SendNewsletter),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "SendNewsletter", $$v)
      },
      expression: "loggedInUser.SendNewsletter"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("\n                                                     You'll get to enter our competitions first and receive invitations to exclusive events.\n                                                 ")])], 2)], 1)]), _vm._v(" "), (_vm.loggedInUser.PreferenceList.indexOf(5) !== -1 || _vm.loggedInUser.PreferenceList.indexOf(6) !== -1) ? _c('sk-panel', [_c('h3', [_vm._v("Your SK Subscription Club Settings")]), _vm._v(" "), _c('hr', {
    staticClass: "hr--transparent"
  }), _vm._v(" "), _c('sk-button', {
    staticStyle: {
      "margin-right": "10px",
      "margin-bottom": "10px"
    },
    attrs: {
      "secondary": "",
      "disabled": !_vm.canCancelSub
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleCancelSubDialog = true
      }
    }
  }, [_vm._v("\n                                            Cancel Subscription\n                                        ")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleCardUpdate = true
      }
    }
  }, [_vm._v("Update Credit Card")]), _vm._v(" "), _c('p', [_vm._v("Please note that cancellations are immediate and benefits will be revoked.")]), _vm._v(" "), (!_vm.canCancelSub) ? _c('p', [_vm._v(_vm._s(_vm.canCancelSubErrorMessage))]) : _vm._e(), _vm._v(" "), (_vm.toggleCardUpdate) ? [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Your New Card Details")]), _vm._v(" "), _c('p', [_vm._v("Please update your payment information")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "checkout",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "checkout-form"
    },
    on: {
      "submit": function($event) {
        _vm.updateCardSubscription()
      }
    }
  }, [_c('p', {
    staticClass: "form-alert"
  }, [_vm._v("All fields are mandatory")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "cardHolder",
      "autocomplete": "cardHolder",
      "label": "Cardholder Name",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter the name on the card.'
      }
    },
    model: {
      value: (_vm.card.cardHolder),
      callback: function($$v) {
        _vm.$set(_vm.card, "cardHolder", $$v)
      },
      expression: "card.cardHolder"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "cardNumber",
      "type": "number",
      "label": "Credit Card Number",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter your credit card number.'
      }
    },
    model: {
      value: (_vm.card.cardNumber),
      callback: function($$v) {
        _vm.$set(_vm.card, "cardNumber", $$v)
      },
      expression: "card.cardNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Expiry Date")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-select', {
    attrs: {
      "placeholder": "Month",
      "type": "number"
    },
    model: {
      value: (_vm.card.expiryMonth),
      callback: function($$v) {
        _vm.$set(_vm.card, "expiryMonth", $$v)
      },
      expression: "card.expiryMonth"
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Expiry Month")]), _vm._v(" "), _vm._l((_vm.months), function(month) {
    return (month != undefined && month != null) ? _c('option', {
      domProps: {
        "value": month.value
      }
    }, [_vm._v(_vm._s(month.name))]) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-select', {
    attrs: {
      "placeholder": "Year",
      "type": "number"
    },
    model: {
      value: (_vm.card.expiryYear),
      callback: function($$v) {
        _vm.$set(_vm.card, "expiryYear", $$v)
      },
      expression: "card.expiryYear"
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Expiry Year")]), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return (year != undefined && year != null) ? _c('option', {
      domProps: {
        "value": year.year
      }
    }, [_vm._v(_vm._s(year.year))]) : _vm._e()
  })], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "cvvNumber",
      "type": "number",
      "autocomplete": "cvvNumber",
      "label": "CVV Number",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter the CVV number at the back of the card.'
      }
    },
    model: {
      value: (_vm.card.cvvNumber),
      callback: function($$v) {
        _vm.$set(_vm.card, "cvvNumber", $$v)
      },
      expression: "card.cvvNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "payment-info": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "text-right": ""
    }
  }, [_c('p', {
    staticClass: "text--small"
  }, [_vm._v("Ster-Kinekor is secure. For credit card payments we accept")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm6": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/visa.png",
      "alt": "Visa"
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm6": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/master-card.png",
      "alt": "Master Card"
    }
  })])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    class: _vm.$breakpoints.smDown ? 'text-right' : '',
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "payment-footer": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm10": "",
      "grow": "",
      "text-right": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleCardUpdate = false
      }
    }
  }, [_vm._v("Undo")])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": "",
      "md2": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "loading": _vm.loadingUpdateCard,
      "primary": "",
      "type": "submit"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('sk-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "frmLaunchACS",
    attrs: {
      "id": "frmLaunchACS",
      "name": "frmLaunchACS",
      "action": _vm.adumoCardUpdate.postURL,
      "method": "POST"
    }
  }, [_c('textarea', {
    attrs: {
      "id": "PaReq",
      "name": "PaReq"
    }
  }, [_vm._v(_vm._s(_vm.adumoCardUpdate.PaReq))]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "TermUrl",
      "name": "TermUrl"
    },
    domProps: {
      "value": _vm.adumoCardUpdate.TermUrl
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "MD",
      "name": "MD"
    },
    domProps: {
      "value": _vm.adumoCardUpdate.MD
    }
  })])], 1)] : _vm._e(), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleCancelSubDialog),
      callback: function($$v) {
        _vm.toggleCancelSubDialog = $$v
      },
      expression: "toggleCancelSubDialog"
    }
  }, [_c('h3', [_vm._v("Cancel your SK Subscription Club membership")]), _vm._v(" "), _c('hr'), _vm._v("\n                                            Are you sure you want to cancel your SK Subscription Club membership\n                                            "), _c('sk-spacer', {
    attrs: {
      "height": 20
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "secondary": "",
      "loading": _vm.cancelSubLoading,
      "disabled": !_vm.canCancelSub,
      "contextValue": "Subscription Funnel",
      "dataValue": "Cancel Subscription"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelSubscription(_vm.loggedInUser.MemberId)
      }
    }
  }, [_vm._v("Cancel Subscription")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleCancelSubDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 2) : _vm._e(), _vm._v(" "), _c('sk-panel', [_c('h3', [_vm._v("Change Password")]), _vm._v(" "), _c('sk-form', {
    staticClass: "change-password-form",
    attrs: {
      "id": "user-password-reset-code-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('p', [_vm._v("We'll send you a link to your email address to create a new password.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goToResetPassword()
      }
    }
  }, [_vm._v("\n                                                Change My Password\n                                            ")])], 1)], 1), _vm._v(" "), _c('sk-panel', [_c('h3', [_vm._v("Delete Loyalty Account")]), _vm._v(" "), _c('sk-form', {
    staticClass: "change-password-form",
    attrs: {
      "id": "user-password-reset-code-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.loggedInUser.PreferenceList.indexOf(5) !== -1 || _vm.loggedInUser.PreferenceList.indexOf(6) !== -1) ? [_c('p', [_vm._v("Please cancel your subscription club subscription before attempting to delete your account.")])] : [_c('p', [_vm._v("Would like to delete your account? Please note, this is permanent, and will lose all loyalty benefits.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDeleteAccountPrompt = true
      }
    }
  }, [_vm._v("\n                                                    Delete Account\n                                                ")])]], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-buttons"
  }, [_c('sk-button', {
    attrs: {
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.profile = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "loading": _vm.updateLoader
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.saveProfile()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)])], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.loggedInUser.PreferenceList.includes(5) && !_vm.loggedInUser.PreferenceList.includes(6)) ? _c('sk-panel', [_c('sk-layout', {
    staticClass: "subs-club-header",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-club-cards.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h3', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("SK Subscription Club")]), _vm._v(" "), _c('div', {
    staticClass: "club-movie-cards"
  }, [_c('div', {
    staticClass: "article__content"
  }, [_c('p', [_vm._v("Join SK Subscription Club to get more than you paid for today!")]), _vm._v(" "), _c('p', [_vm._v("\n                                        As a SK Subscription Club member, you can get a subscription for a Limited or Unlimited \n                                        amount of movies per month at a set cost, which you pay per month. This means \n                                        you can now watch more movies at a lower price, whilst also enjoying the benefits \n                                        of the SK Club\n                                    ")]), _vm._v(" "), _c('sk-button', {
    staticClass: "sk-club__join-steps-btn",
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/subscription-club"
    }
  }, [_vm._v("Join Now")])], 1)])])], 1)], 1) : [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "profile-dashboard",
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [(_vm.loggedInUser.PreferenceList.includes(5)) ? _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', [_vm._v("SK MORvies CLUB")]), _c('br'), _c('br')])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive fan-img img-option",
    attrs: {
      "src": "/static/img/morvies_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('h3', [_vm._v("Watch more movies for less")]), _vm._v(" "), _c('p', [_vm._v("\n                                            Let's get going! You can watch up to 5 movies per day for free and claim 20% off on a medium soda and popcorn combo. You can use your eCard at the checkout to redeem both SK MORvies CLUB benefits and SK Club points and rewards.\n                                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                                            *T's & C's apply\n                                        ")]), _vm._v(" "), _c('sk-button', {
    staticClass: "sk-club__join-steps-btn",
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/type/Subs"
    }
  }, [_vm._v("Book now")])], 1)], 1)], 1) : [(_vm.loggedInUser.PreferenceList.includes(6)) ? _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', [_vm._v("SK FAN CLUB")]), _c('br'), _c('br')])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive fan-img img-option",
    attrs: {
      "src": "/static/img/fan_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('h3', [_vm._v("Watch more movies for less")]), _vm._v(" "), _c('p', [_vm._v("\n                                                Let's get going! You can use all 4 tickets at once to start booking for you and your family. You can use your eCard at the checkout to redeem both SK FAN CLUB benefits and SK Club points and rewards.\n                                            ")]), _vm._v(" "), _c('p', [_vm._v("\n                                                *T's & C's apply\n                                            ")]), _vm._v(" "), _c('sk-button', {
    staticClass: "sk-club__join-steps-btn",
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/type/Subs"
    }
  }, [_vm._v("Book now")])], 1)], 1)], 1) : _vm._e()]], 2), _vm._v(" "), _c('sk-flex', {
    staticClass: "profile-dashboard profile-subs-club-benefits",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', [_vm._v("YOUR BENEFITS")]), _c('br'), _c('br')])], 1), _vm._v(" "), (_vm.loggedInUser.PreferenceList.includes(5)) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "gutter-30": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('sk-badge', {
    attrs: {
      "color": _vm.subsClubColour,
      "secondaryIcon": !_vm.subsClubSecondaryIcon
    }
  }, [_c('template', {
    slot: "front"
  }, [_c('div', {
    staticClass: "badge_icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/subs/ticket-active-icon.png"
    }
  })])]), _vm._v(" "), _c('template', {
    slot: "back"
  }, [_vm._v("\n                                                             \n                                                                ")]), _vm._v(" "), _c('template', {
    slot: "points"
  }, [_vm._v("Unlimited")])], 2)], 1), _vm._v(" "), (_vm.subsClubRenewDate != null && _vm.subsClubRenewDate != undefined) ? _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('p', [_vm._v("SUBSCRIPTION RENEWED ON")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.subsClubRenewDate.getDate()) + "/" + _vm._s(_vm.subsClubRenewDate.getMonth() + 1) + "/" + _vm._s(_vm.subsClubRenewDate.getFullYear()))])]) : _vm._e()], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "information",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('p', [_vm._v("20% off a medium popcorn and soda combo")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h5', [_vm._v("Book now at any Cinema")])])], 1)] : [(_vm.loggedInUser.PreferenceList.includes(5)) ? [(_vm.rewards != undefined && _vm.rewards != null) ? [_vm._l((_vm.rewards), function(reward) {
    return (reward.Name.includes('Limited')) ? [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "gutter-30": ""
      }
    }, _vm._l((4), function(n) {
      return _c('sk-flex', {
        key: n,
        attrs: {
          "xs6": "",
          "sm6": "",
          "md3": ""
        }
      }, [(n <= reward.QtyAvailable) ? [_c('sk-badge', {
        attrs: {
          "color": _vm.subsClubColour,
          "secondaryIcon": !_vm.subsClubSecondaryIcon
        }
      }, [_c('template', {
        slot: "front"
      }, [_c('div', {
        staticClass: "badge_icon"
      }, [_c('img', {
        attrs: {
          "src": "/static/img/subs/ticket-active-icon.png"
        }
      })])]), _vm._v(" "), _c('template', {
        slot: "back"
      }, [_vm._v(" \n                                                                    ")]), _vm._v(" "), _c('template', {
        slot: "points"
      }, [_vm._v("Movie " + _vm._s(n))])], 2)] : [_c('sk-badge', {
        staticClass: "claimed",
        class: _vm.subsClubInactiveColour,
        attrs: {
          "secondaryIcon": !_vm.subsClubSecondaryIcon
        }
      }, [_c('template', {
        slot: "front"
      }, [_c('div', {
        staticClass: "badge_icon"
      }, [_c('img', {
        attrs: {
          "src": "/static/img/subs/ticket-inactive-icon.png"
        }
      })])]), _vm._v(" "), _c('template', {
        slot: "back"
      }, [_vm._v(" \n                                                                    ")]), _vm._v(" "), _c('template', {
        slot: "points"
      }, [_vm._v("Movie " + _vm._s(n))])], 2)]], 2)
    }))] : _vm._e()
  }), _vm._v(" "), _c('sk-layout', {
    staticClass: "information",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('p', [_vm._v("20% off a medium popcorn and soda combo")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('p', [_vm._v("SUBSCRIPTION RENEWED ON")]), _vm._v(" "), _c('p')])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h5', [_vm._v("Book now at any Cinema")])])], 1)] : _vm._e()] : _vm._e()]], 2)], 1)], 1)], _vm._v(" "), (_vm.loggedInUser.MemberLevelId != 19) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "profile-dashboard",
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md7": ""
    }
  }, [_c('h2', {
    staticClass: "profile-heading"
  }, [_vm._v("Your Rewards")]), _vm._v(" "), _c('div', {
    staticClass: "profile-dashboard-rewards"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "gutter-30": ""
    }
  }, _vm._l((_vm.skBadges), function(badge) {
    return (badge.available == true) ? _c('sk-flex', {
      key: badge.title,
      attrs: {
        "xs6": "",
        "sm6": "",
        "md4": ""
      }
    }, [_c('sk-badge', {
      attrs: {
        "color": badge.color,
        "secondaryIcon": !badge.active
      }
    }, [_c('template', {
      slot: "front"
    }, [_c('sk-icon', {
      attrs: {
        "icon": badge.icon
      }
    })], 1), _vm._v(" "), _c('template', {
      slot: "back"
    }, [(badge.active) ? _c('a', {
      attrs: {
        "href": badge.redirect || '/',
        "data-track-context": "rewards",
        "data-track-value": badge.title
      }
    }, [_vm._v("Book\n                                                            Now")]) : _c('span', [_vm._v("No Reward Yet")])]), _vm._v(" "), _c('template', {
      slot: "points"
    }, [_vm._v(_vm._s(badge.title))]), _vm._v(" "), _c('template', {
      slot: "text"
    }, [_vm._v("\n                                                        " + _vm._s(badge.description) + "\n                                                        "), (badge.alt) ? [_c('br'), _vm._v(" "), _c('span', {
      staticClass: "text--small"
    }, [_vm._v(_vm._s(badge.alt))])] : _vm._e()], 2)], 2)], 1) : _vm._e()
  }))], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md5": ""
    }
  }, [_c('h2', {
    staticClass: "profile-heading points-heading"
  }, [_vm._v("Your Points")]), _vm._v(" "), _c('div', {
    staticClass: "profile-dashboard-points"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "points-block-wrapper",
    attrs: {
      "xs6": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "points-block"
  }, [_c('h4', {
    staticClass: "points-block--total-points"
  }, [_vm._v(_vm._s(_vm.loggedInUser.PointsBalance))]), _vm._v(" "), _c('h6', [_vm._v("your total points")])])]), _vm._v(" "), _c('sk-flex', {
    staticClass: "points-block-wrapper",
    attrs: {
      "xs6": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "points-block last"
  }, [_c('h4', {
    staticClass: "points-block--total-points next-points"
  }, [_vm._v("\n                                                        " + _vm._s(_vm.nextReward))]), _vm._v(" "), _c('h6', [_vm._v("points to your"), _c('br'), _vm._v("\n                                                        next reward")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "view-points"
  }, [_c('sk-button', {
    staticClass: "btn--link",
    attrs: {
      "tag": "a"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePoints($event.currentTarget)
      }
    }
  }, [_vm._v("\n                                                        Your Points Statement\n                                                    ")])], 1)])], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    staticClass: "profile-dashboard",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('sk-panel', [_c('h2', {
    staticClass: "profile-heading"
  }, [_vm._v("Your Bookings")]), _vm._v(" "), (_vm.mostRecentBooking.MovieName) ? _c('div', {
    staticClass: "profile-dashboard-bookings"
  }, [_c('h4', {
    staticClass: "movie-name"
  }, [_vm._v(_vm._s(_vm.mostRecentBooking.MovieName))]), _vm._v(" "), _vm._l((_vm.mostRecentBooking.MovieSession.experiences), function(exp, index) {
    return _c('p', {
      key: index,
      staticClass: "experience"
    }, [_vm._v(_vm._s(exp.name))])
  }), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h4', {
    staticClass: "schedule"
  }, [_vm._v("Date")]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info"
  }, [_vm._v("\n                                            " + _vm._s(_vm.mostRecentBooking.BookingDate.additional.string_long_day_of_week))]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info--bold"
  }, [_vm._v("\n                                            " + _vm._s(_vm.mostRecentBooking.BookingDate.additional.string_nth_day))]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info"
  }, [_vm._v("\n                                            " + _vm._s(_vm.mostRecentBooking.BookingDate.additional.string_long_month))])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h4', {
    staticClass: "schedule"
  }, [_vm._v("Time")]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info"
  }, [_vm._v("Starts")]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info--bold"
  }, [_vm._v("\n                                            " + _vm._s(_vm.mostRecentBooking.BookingDate.additional.no_zero_hour_24) + ":" + _vm._s(_vm.mostRecentBooking.BookingDate.additional.minute))]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info"
  }, [_vm._v(" Ends " + _vm._s(_vm.mostRecentBooking.EndDate.additional.no_zero_hour_24) + ":" + _vm._s(_vm.mostRecentBooking.EndDate.additional.minute))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "location"
  }, [_c('p', [_c('sk-icon', {
    attrs: {
      "location-pin": ""
    }
  }), _vm._v("\n                                        " + _vm._s(_vm.mostRecentBooking.CinemaName) + "\n                                    ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "view-all"
  }, [_c('sk-button', {
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.allBookings($event.currentTarget)
      }
    }
  }, [_vm._v("\n                                        See All Upcoming Bookings\n                                    ")])], 1)], 2) : _c('div', {
    staticClass: "profile-dashboard-bookings profile-dashboard-bookings--no-bookings"
  }, [_c('p', {
    staticClass: "text-grey text-bold--700"
  }, [_vm._v("No Upcoming Bookings")]), _vm._v(" "), _c('p', {
    staticClass: "text-grey text-bold--400"
  }, [_vm._v("Check out movies that are Now Showing and Coming Soon.")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "block": "",
      "secondary": "",
      "router": "",
      "to": {
        name: 'Home'
      }
    }
  }, [_vm._v("See all movies now")])], 1)], 1)], 1)])], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-y-transition"
    }
  }, [(_vm.pointStatement) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "profile-dashboard",
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-points', {
    attrs: {
      "user-points": _vm.loggedInUser.LifeTimePoints
    }
  }, [_c('sk-title-heading', {
    attrs: {
      "slot": "heading",
      "h2": "",
      "label": "Your Points Statement"
    },
    slot: "heading",
    model: {
      value: (_vm.h1Active),
      callback: function($$v) {
        _vm.h1Active = $$v
      },
      expression: "h1Active"
    }
  }, [_c('sk-icon', {
    attrs: {
      "slot": "append",
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.pointStatement = false
      }
    },
    slot: "append"
  })], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showBookings) ? _c('sk-layout', {
    staticClass: "profile-dashboard",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-panel', [_c('sk-title-heading', {
    staticClass: "title-heading",
    attrs: {
      "h2": !_vm.$breakpoints.xs,
      "h4": _vm.$breakpoints.xs,
      "label": "Your Bookings"
    },
    model: {
      value: (_vm.h1Active),
      callback: function($$v) {
        _vm.h1Active = $$v
      },
      expression: "h1Active"
    }
  }, [_c('sk-icon', {
    attrs: {
      "slot": "append",
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showBookings = false
      }
    },
    slot: "append"
  })], 1), _vm._v(" "), _c('sk-booking', {
    attrs: {
      "bookingHistory": _vm.BookingHistory
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "status"
    }
  }), _vm._v(" "), _c('sk-flex', {
    staticClass: "profile-dashboard",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', [_c('h2', [_vm._v("Your Status")]), _vm._v(" "), _c('sk-tiers', {
    attrs: {
      "percentage": _vm.tierMoviesPercentage,
      "is-vip": _vm.loggedInUser.isVip(),
      "to-go": _vm.tierMoviesToGo,
      "fill": "ffffff"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cards"
    }
  }), _vm._v(" "), (_vm.loggedInUser) ? _c('sk-flex', {
    staticClass: "profile-dashboard",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md8": ""
    }
  }, [_c('sk-panel', [_c('h2', {
    staticClass: "profile-heading"
  }, [_vm._v("Your Cards")]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-carousel', {
    staticClass: "club-carousel",
    attrs: {
      "pageMarkers": "",
      "slides-per-page": _vm.slidesPerPage,
      "wrap": false
    }
  }, [_c('div', {
    staticClass: "cards",
    attrs: {
      "slot": "slides"
    },
    slot: "slides"
  }, [_c('sk-card', {
    attrs: {
      "path": "/static/img/loyalty-sk-club.png",
      "title": "SK Club",
      "loading": _vm.linkingSkClub,
      "type": "sk-club",
      "card-number": _vm.loggedInUser.CardNumber,
      "joined": _vm.loggedInUser.MemberLevelId != 19,
      "linked": _vm.loggedInUser.CardNumber != null
    },
    on: {
      "link": _vm.linkSkClub,
      "join": function($event) {
        _vm.toggleJoinDialog = true
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cards",
    attrs: {
      "slot": "slides"
    },
    slot: "slides"
  }, [_c('sk-card', {
    attrs: {
      "path": "/static/img/loyalty-vitality.png",
      "title": "Discovery Vitality",
      "type": "generic",
      "generic-message": "Need a Discovery Vitality SK digital Movie Card?",
      "more-info-link": "/club-loyalty/Discovery_Vitality#discovery-form"
    },
    on: {
      "link": _vm.linkCard
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cards",
    attrs: {
      "slot": "slides"
    },
    slot: "slides"
  }, [_c('sk-card', {
    attrs: {
      "path": "/static/img/loyalty-edgars-club.png",
      "title": "Edgars Club",
      "type": "generic",
      "generic-message": "Get movie and popcorn & soda benefits with Edgars Club.",
      "more-info-link": "https://edgarsclub.co.za/membership-options"
    },
    on: {
      "link": _vm.linkCard
    }
  })], 1)])], 1)], 1)], 1) : _vm._e()], 1)] : [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "cards"
    }
  }), _vm._v(" "), (_vm.loggedInUser) ? _c('sk-flex', {
    staticClass: "profile-dashboard",
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('sk-panel', [_c('h2', {
    staticClass: "profile-heading"
  }, [_vm._v("Your Cards")]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-carousel', {
    staticClass: "club-carousel",
    attrs: {
      "pageMarkers": "",
      "slides-per-page": _vm.slidesPerPage
    }
  }, [_c('div', {
    staticClass: "cards",
    attrs: {
      "slot": "slides"
    },
    slot: "slides"
  }, [_c('sk-card', {
    attrs: {
      "path": "/static/img/loyalty-sk-club.png",
      "title": "SK Club",
      "loading": _vm.linkingSkClub,
      "type": "sk-club",
      "card-number": _vm.loggedInUser.CardNumber,
      "joined": _vm.loggedInUser.MemberLevelId != 19,
      "linked": (_vm.loggedInUser.CardNumber != null)
    },
    on: {
      "link": _vm.linkSkClub,
      "join": _vm.checkSlClub
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cards",
    attrs: {
      "slot": "slides"
    },
    slot: "slides"
  }, [_c('sk-card', {
    attrs: {
      "path": "/static/img/loyalty-vitality.png",
      "title": "Discovery Vitality",
      "type": "generic",
      "generic-message": "Need a Discovery Vitality SK digital Movie Card?",
      "more-info-link": "/club-loyalty/Discovery_Vitality#discovery-form"
    },
    on: {
      "link": _vm.linkCard
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cards",
    attrs: {
      "slot": "slides"
    },
    slot: "slides"
  }, [_c('sk-card', {
    attrs: {
      "path": "/static/img/loyalty-edgars-club.png",
      "title": "Edgars Club",
      "type": "generic",
      "generic-message": "Get movie and popcorn & soda benefits with Edgars Club.",
      "more-info-link": "https://edgarsclub.co.za/membership-options"
    },
    on: {
      "link": _vm.linkCard
    }
  })], 1)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('sk-flex', {
    staticClass: "profile-dashboard",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('sk-panel', [_c('h2', {
    staticClass: "profile-heading"
  }, [_vm._v("Your Bookings")]), _vm._v(" "), (_vm.mostRecentBooking.MovieName) ? _c('div', {
    staticClass: "profile-dashboard-bookings"
  }, [_c('h4', {
    staticClass: "movie-name"
  }, [_vm._v(_vm._s(_vm.mostRecentBooking.MovieName))]), _vm._v(" "), _c('p', {
    staticClass: "experience"
  }, [_vm._v(_vm._s(_vm.mostRecentBooking.Movie.experiencesString))]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h4', {
    staticClass: "schedule"
  }, [_vm._v("Date")]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info"
  }, [_vm._v("\n                                            " + _vm._s(_vm.mostRecentBooking.BookingDate.additional.string_long_day_of_week))]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info--bold"
  }, [_vm._v("\n                                            " + _vm._s(_vm.mostRecentBooking.BookingDate.additional.string_nth_day))]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info"
  }, [_vm._v("\n                                            " + _vm._s(_vm.mostRecentBooking.BookingDate.additional.string_long_month))])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h4', {
    staticClass: "schedule"
  }, [_vm._v("Time")]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info"
  }, [_vm._v("Starts")]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info--bold"
  }, [_vm._v("\n                                            " + _vm._s(_vm.mostRecentBooking.BookingDate.additional.no_zero_hour_24) + ":" + _vm._s(_vm.mostRecentBooking.BookingDate.additional.minute))]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info"
  }, [_vm._v(" Ends " + _vm._s(_vm.mostRecentBooking.EndDate.additional.no_zero_hour_24) + ":" + _vm._s(_vm.mostRecentBooking.EndDate.additional.minute))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "location"
  }, [_c('p', [_c('sk-icon', {
    attrs: {
      "location-pin": ""
    }
  }), _vm._v("\n                                        " + _vm._s(_vm.mostRecentBooking.CinemaName) + "\n                                    ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "view-all"
  }, [_c('sk-button', {
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.allBookings($event.currentTarget)
      }
    }
  }, [_vm._v("\n                                        View All Bookings\n                                    ")])], 1)], 1) : _c('div', {
    staticClass: "profile-dashboard-bookings profile-dashboard-bookings--no-bookings"
  }, [_c('p', {
    staticClass: "text-grey text-bold--500"
  }, [_vm._v("No Upcoming Bookings")]), _vm._v(" "), _c('p', {
    staticClass: "text-grey text-bold--400"
  }, [_vm._v("Check out movies that are Now Showing and Coming Soon.")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "block": "",
      "secondary": "",
      "router": "",
      "to": {
        name: 'Home'
      }
    }
  }, [_vm._v("See all movies now")])], 1)], 1)], 1)])], 1)], 1)], _vm._v(" "), (_vm.related_movies.length > 0) ? _c('sk-related-movies', {
    attrs: {
      "limit": "6",
      "movies": _vm.related_movies,
      "label": _vm.relatedMoviesLabel
    }
  }) : _vm._e()], 2)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(562),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'seats',

    computed: {
        cinema_id: function cinema_id() {
            return this.$route.params.cinema_id;
        },
        session_id: function session_id() {
            return this.$route.params.session_id;
        }
    },

    created: function created() {}
});

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seats"
  }, [_c('sk-seating', {
    attrs: {
      "cinema_id": _vm.cinema_id,
      "session_id": _vm.session_id
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(565),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_meta_data_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_http__ = __webpack_require__(53);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'payment',
    data: function data() {
        return {
            msg: 'Payments',
            items: [],
            errors: [],
            txnToken: this.$route.query.txnToken,
            paymentType: this.$route.params.paymentType,
            amount: null,
            bookingNum: null,
            bookingId: null,
            cinemaId: null,
            bookingCinemaId: null,
            vistaSessionId: null,
            vistaAmount: null,
            ticketCode: null,
            userSessionId: null,
            loggedInUser: null,
            paymentError: { extendedResultCode: undefined, errorDescription: "", Result: undefined },
            loading: true,
            retries: 40,
            retry_count: 0
        };
    },

    methods: {
        validatePayment: function validatePayment() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["b" /* AuthService */].getUserOrderInfo().then(function (user) {
                var tj_validate = _this.$route.query.tj_validate || false;

                if (!tj_validate) {
                    var payload = {
                        TxnToken: _this.$route.query.token,
                        TransactionId: _this.$route.query.transaction_id,
                        TransactionStatus: _this.$route.query.success,
                        CustomerName: user.FullName,
                        CustomerPhone: user.MobilePhone,
                        CustomerEmail: user.Email
                    };

                    __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["f" /* ErrorHandler */].ignoreNextError();
                    if (_this.amount === null) {
                        __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].completeOrder(payload).then(function (booking) {
                            if (booking === undefined) {
                                _this.$router.push('/booking-unsuccessful');
                            } else {
                                window.location.href = '/booking-successful/' + booking.bookingId + '/' + booking.bookingNumber + '/' + booking.CinemaId;
                            }
                        });
                    } else {
                        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getBooking(_this.bookingNum, _this.bookingId, _this.bookingCinemaId)).then(function (booking) {
                            if (booking === undefined) {
                                _this.$router.push('/booking-unsuccessful');
                            } else {
                                window.location.href = '/booking-successful/' + _this.bookingNum + '/' + _this.bookingId + '/' + _this.bookingCinemaId;
                            }
                        });
                    }
                } else {

                    var sessionId = _this.$route.query.session_id;

                    var delay = function delay() {
                        var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3000;

                        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                            setTimeout(function () {
                                return resolve();
                            }, time);
                        });
                    };

                    _this.retry_count = _this.retry_count + 1;
                    console.log(_this.retry_count);
                    __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_http__["a" /* default */].get('/payment/poll-tj-payment?sessionId=' + sessionId, {}).then(function (response) {

                        if (response.data.Booking.IsPaid === true) {
                            window.location.href = '/booking-successful/' + response.data.Booking.BookingId + '/' + response.data.Booking.BookingNumber + '/' + response.data.Booking.CinemaId;
                        } else if (response.data.Booking.IsPaid === false && _this.retry_count < _this.retries) {
                            return delay(1000).then(function () {
                                return _this.validatePayment();
                            });
                        } else {
                            _this.$router.push('/booking-unsuccessful');
                        }
                    });
                }
            });
        }
    },
    created: function created() {
        this.loading = true;
        if (this.$route.query.amount) {
            this.amount = this.$route.query.amount;
        }

        if (this.$route.query.bookingNum) {
            this.bookingNum = this.$route.query.bookingNum;
        }

        if (this.$route.query.bookingId) {
            this.bookingId = this.$route.query.bookingId;
        }

        if (this.$route.query.cinemaId) {
            this.bookingCinemaId = this.$route.query.cinemaId;
        }
    },
    mounted: function mounted() {
        this.validatePayment();
    }
});

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Just a sec, we're finalising your booking.")])], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(571),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_http__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_meta_data_js__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'payment',
    data: function data() {
        return {
            msg: 'Payments',
            items: [],
            errors: [],
            txnToken: this.$route.query.txnToken,
            paymentType: this.$route.params.paymentType,
            cinemaId: null,
            vistaSessionId: null,
            vistaAmount: null,
            ticketCode: null,
            userSessionId: null,
            loggedInUser: null,
            paymentError: { extendedResultCode: undefined, errorDescription: "", Result: undefined },
            loading: true
        };
    },


    methods: {
        validateToken: function validateToken() {
            var _this = this;

            if (this.txnToken.length === 64) {
                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_http__["a" /* default */].post('/payment/validatePayment', {
                    txnToken: this.txnToken
                })).then(function (data) {
                    var debug = false;
                    var transactionData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(_this.checkTransaction(data, "payment", debug)).then(function (transactionData) {
                        if (transactionData.status) {

                            var expiryDate = transactionData.metadata[1].expiryDate;
                            var expiryArray = expiryDate.split("/");

                            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getOrder(), __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user()]).then(function (_ref) {
                                var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                                    order = _ref2[0],
                                    user = _ref2[1];

                                _this.loggedInUser = user;

                                var paymentObject = {
                                    cardNumber: transactionData.metadata[0].maskedPan,
                                    CardType: "CARD",
                                    month: expiryArray[0],
                                    year: expiryArray[1],
                                    amount: order.totalInCents,
                                    customerName: _this.loggedInUser.FullName,
                                    customerPhone: _this.loggedInUser.MobilePhone,
                                    customerEmail: _this.loggedInUser.Email
                                };

                                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_http__["a" /* default */].post('/payment/complete', paymentObject)).then(function (vistaData) {
                                    var booking = vistaData;

                                    if (vistaData.ExtendedResultCode > 0) {
                                        _this.paymentError = { extendedResultCode: vistaData.ExtendedResultCode, errorDescription: vistaData.errorDescription, Result: vistaData.Result };

                                        var p = __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].pendingSession();
                                        booking.SessionDetails = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, p);
                                        booking.Tickets = order.Tickets;
                                        booking.Concessions = order.Concessions;
                                        booking.SessionDate = order.SessionDate;
                                        booking.paymentError = _this.paymentError;
                                        __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].setBooking(booking);
                                        __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].clearPendingSessions();

                                        _this.$router.push('/booking-unsuccessful');
                                    } else {
                                        var p = __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].pendingSession();
                                        booking.SessionDetails = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, p);
                                        booking.Tickets = order.Tickets;
                                        booking.Concessions = order.Concessions;
                                        booking.SessionDate = order.SessionDate;
                                        __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].setBooking(booking);
                                        __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].clearPendingSessions();

                                        var bookingId = booking.data.VistaBookingNumberBase64;
                                        _this.$router.push('/donation-successful/' + encodeURIComponent(bookingId));
                                    }
                                });
                            });
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getOrder()).then(function (order) {
                                var booking = {};
                                _this.loggedInUser = JSON.parse(localStorage.getItem('ORDER_USER'));
                                _this.paymentError = { extendedResultCode: transactionData.responseCode, errorDescription: transactionData.errorDescription, Result: transactionData.responseCode };
                                var p = __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].pendingSession();
                                booking.SessionDetails = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, p);
                                booking.Tickets = order.Tickets;
                                booking.Concessions = order.Concessions;
                                booking.SessionDate = order.SessionDate;
                                booking.paymentError = _this.paymentError;

                                __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].setBooking(booking);

                                _this.$router.push('/donation-unsuccessful');
                            });
                        }
                    });
                });
            }
        },
        checkTransaction: function checkTransaction(data, type, bypass) {
            var toasterMessage = "";
            var returnStatus = false;
            var returnObject = {
                "status": returnStatus,
                "metadata": {}
            };

            data = data.data;
            if (data.status || bypass) {
                var statusArray = data.status.split(":");

                if (statusArray[0] === "APPROVED" || bypass) {
                    toasterMessage = "Transaction Approved";

                    if (type === "payment") {
                        returnObject.status = true;
                        returnObject.metadata = data.metadata;
                    } else if (type === "reverse") {
                        returnObject.status = true;
                        toasterMessage = "Payment successfully reversed";
                    }
                } else {
                    toasterMessage = data.status;
                    returnObject.status = false;
                    returnObject.responseCode = data.responseCode;
                    returnObject.errorDescription = data.status;
                }

                return returnObject;
            }
        },
        validatePayment: function validatePayment() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["b" /* AuthService */].getUserOrderInfo().then(function (user) {
                var payload = {
                    TxnToken: _this2.$route.query.txnToken,
                    TransactionId: _this2.$route.query.transaction_id,
                    TransactionStatus: _this2.$route.query.success,
                    CustomerName: user.FullName,
                    CustomerPhone: user.MobilePhone,
                    CustomerEmail: user.Email
                };
                __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].completeOrder(payload).then(function (booking) {
                    if (booking === undefined) {
                        _this2.$router.push('/donation-unsuccessful');
                    } else {
                        _this2.$router.push('/donation-successful/' + booking.bookingId + '/' + booking.bookingNumber);
                    }
                });
            });
        }
    },

    created: function created() {
        this.loading = true;
    },
    mounted: function mounted() {
        if (this.paymentType === "validatePayment") {
            this.validatePayment();
        }
    }
});

/***/ }),
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "about-us "
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(575),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ua_parser_js__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ua_parser_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ua_parser_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_meta_data_js__ = __webpack_require__(5);






/* harmony default export */ __webpack_exports__["default"] = ({

	mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_meta_data_js__["a" /* default */]],

	data: function data() {
		return {
			isGuest: false,
			user: null,
			isActive: false,
			help: null,
			help_options: [{ id: 1, name: 'I\'d Just Like to Leave a Message' }, { id: 2, name: 'Browsing Movies' }, { id: 3, name: 'Booking Tickets' }, { id: 4, name: 'SK Clubs and Movie Cards' }, { id: 5, name: 'SK Fan Club or MORvies Club Cancellation' }],
			isBrowsing: false,
			browsing_selected: null,
			browsing_options: ['Filters', 'Trailers', 'Cinema-Related Issues', 'Movies Now Showing', 'Movies Coming Soon', 'Incorrect Information'],
			isTicketing: false,
			ticketing_movie_name: null,
			ticketing_selected: null,
			ticketing_options: ['Choosing Tickets', 'Booking Multiple Tickets', 'Booking Multiple Movies', 'Payment', 'Confirmation Email'],
			ticketing_date_day: null,
			ticketing_date_month: __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_ui_core__["Utils"].MonthMeta(),
			ticketing_date_month_selected: null,
			ticketing_date_year: null,
			ticketing_movie_time: ["08:00 - 10:00", "10:00 - 12:00", "12:00 - 14:00", "14:00 - 16:00", "16:00 - 18:00", "18:00 - 20:00", "20:00 - 22:00", "22:00 - 00:00"],
			ticketing_movie_time_selected: null,
			ticketing_cinema: null,
			ticketing_ticket_type: null,
			isClubLoyalty: false,
			club_loyalty_options: ['SK Club Movie Card', 'Discovery Vitality Movie Benefit Card', 'Edgars Club Movie Card', 'Pick n Pay Card', 'Standard Bank'],
			club_loyalty_selected: null,
			club_loyalty_struggles: ['Points and Reward', 'Password Reset'],
			club_loyalty_struggles_selected: null,
			first_name: '',
			surname: '',
			email: '',
			mobile: '',
			contact_message: '',
			formData: {},
			ua_result: {
				browser: { name: null, version: null },
				device: { model: null, type: null, vendor: null },
				engine: { name: null, version: null },
				os: { name: null, version: null }
			},
			isSubsClub: false,
			loadingSubmit: false,
			successDialog: false,
			card_number: null,
			tmp_card_number: null,
			compiled_value: null,
			member_id: null,
			mobileNumber: null
		};
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].addObserver(this, __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].PROFILE_CHANGED, this.checkUser);
		this.checkUser();
		window.scroll({ top: 0, left: 0 });
	},


	methods: {
		help_selected: function help_selected(selectOption) {
			this.isActive = true;
			this.isMessage = false;
			this.isBrowsing = false;
			this.isTicketing = false;
			this.isClubLoyalty = false;
			this.isSubsClub = false;
			switch (selectOption.id) {
				case 2:
					this.browsingActivation = selectOption.name;
					this.isBrowsing = true;
					this.isMessage = false;
					this.isTicketing = false;
					this.isClubLoyalty = false;
					this.isSubsClub = false;
					break;
				case 3:
					this.ticketingValidation = selectOption.name;
					this.isTicketing = true;
					this.isMessage = false;
					this.isBrowsing = false;
					this.isClubLoyalty = false;
					this.isSubsClub = false;
					break;
				case 4:
					this.isClubLoyalty = true;
					this.isMessage = false;
					this.isBrowsing = false;
					this.isTicketing = false;
					this.isSubsClub = false;
					break;
				case 5:
					this.isSubsClub = true;
					this.isMessage = false;
					this.isBrowsing = false;
					this.isTicketing = false;
					this.isClubLoyalty = false;
					break;
				default:
					this.helpValidation = selectOption.name;
					this.isMessage = true;
					this.isSubsClub = false;
					this.isMessage = false;
					this.isBrowsing = false;
					this.isTicketing = false;
					this.isClubLoyalty = false;

					break;
			}
		},
		help_removed: function help_removed(removedOption) {
			this.isActive = false;
			this.help = '';
			switch (removedOption.id) {
				case 2:
					this.isBrowsing = false;
					break;
				case 3:
					this.isTicketing = false;
					break;
				case 4:
					this.isClubLoyalty = false;
					break;
				case 5:
					this.isBrowsing = false;
					this.isTicketing = false;
					this.isSubsClub = true;
					this.isClubLoyalty = true;
				default:
					this.isMessage = false;
					break;
			}
		},
		checkUser: function checkUser() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user().then(function (user) {
				_this.user = user;
				_this.isGuest = user.isGuest();
			});
		},
		setUser: function setUser() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user().then(function (user) {
				_this2.user = user;
				_this2.isGuest = user.isGuest();
				if (!user.isGuest() && user.MembershipActivated === false && _this2.first_time) {} else {}

				return _this2.user;
			});
		},
		onSubmit: function onSubmit() {
			var _this3 = this;

			this.loadingSubmit = true;
			this.formData = {
				ContactType: "Message",
				Surname: this.isGuest ? this.surname : this.user.LastName,
				FirstName: this.isGuest ? this.first_name : this.user.FirstName,
				Email: this.isGuest ? this.email : this.user.Email,
				Mobile: this.isGuest ? this.mobile : this.user.MobilePhone,
				Message: this.contact_message,
				UaResult: this.ua_result
			};

			if (this.isTicketing) {
				this.formData = {
					ContactType: "Ticketing",
					Surname: this.isGuest ? this.surname : this.user.LastName,
					FirstName: this.isGuest ? this.first_name : this.user.FirstName,
					Email: this.isGuest ? this.email : this.user.Email,
					Mobile: this.isGuest ? this.mobile : this.user.MobilePhone,
					Message: this.contact_message,
					UaResult: this.ua_result,
					TicketingSelected: this.ticketing_selected,
					MovieName: this.ticketing_movie_name,
					DateDay: this.ticketing_date_day,
					DateMonth: this.ticketing_date_month_selected,
					DateYear: this.ticketing_date_year,
					MovieTime: this.ticketing_movie_time_selected,
					Cinema: this.ticketing_cinema,
					TicketType: this.ticketing_ticket_type
				};
			}

			if (this.isClubLoyalty) {
				this.formData = {
					ContactType: "ClubLoyalty",
					Surname: this.isGuest ? this.surname : this.user.LastName,
					FirstName: this.isGuest ? this.first_name : this.user.FirstName,
					Email: this.isGuest ? this.email : this.user.Email,
					Mobile: this.isGuest ? this.mobile : this.user.MobilePhone,
					Message: this.contact_message,
					UaResult: this.ua_result,
					LoyaltySelected: this.club_loyalty_selected,
					Struggles: this.club_loyalty_struggles_selected
				};
			}

			if (this.isBrowsing) {
				this.formData = {
					ContactType: "Browsing", Surname: this.isGuest ? this.surname : this.user.LastName,
					FirstName: this.isGuest ? this.first_name : this.user.FirstName,
					Email: this.isGuest ? this.email : this.user.Email,
					Mobile: this.isGuest ? this.mobile : this.user.MobilePhone,
					Message: this.contact_message,
					UaResult: this.ua_result,
					BrowsingSelected: this.browsing_selected
				};
			}

			if (this.isSubsClub) {
				this.formData = {
					ContactType: "FanClubCancellation",
					Surname: this.surname,
					FirstName: this.first_name,
					Email: this.email,
					MemberId: this.member_id,
					CardNumber: this.card_number,
					CompiledValue: "|" + this.compiled_value + "|",
					Message: this.contact_message,
					MobileNumber: this.mobileNumber
				};

				if (this.card_number != null || this.card_number != undefined) {
					if (this.card_number.length == 0) {
						this.formData.CardNumber = this.tmp_card_number;
					}
				}
			}

			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["c" /* ContactUsService */].sendContactUs(this.formData)).then(function (result) {
				_this3.loadingSubmit = false;
				_this3.successDialog = true;
				_this3.help_removed({ id: 0, name: '' });
			}, function (error) {
				_this3.loadingSubmit = false;
			});
		}
	},

	created: function created() {
		var _this4 = this;

		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.setUser()).then(function (user) {

			if (user != null && user != undefined) {
				_this4.first_name = user.FirstName;
				_this4.surname = user.LastName;
				_this4.email = user.Email;
				_this4.card_number = user.CardNumber;
				_this4.tmp_card_number = user.CardNumber;
				_this4.compiled_value = user.WorkZipCode;
				_this4.member_id = user.MemberId;
				_this4.mobileNumber = user.MobilePhone;
			}

			if (_this4.$route.params != null && _this4.$route.params != undefined) {
				if (_this4.$route.params.type != null && _this4.$route.params != undefined) {
					if (_this4.$route.params.type == "cancellation") {
						_this4.help = { id: 5, name: 'SK Fan Club or MORvies Club Cancellation' };

						_this4.help_selected(_this4.help);
					}
				}
			}

			var parser = new __WEBPACK_IMPORTED_MODULE_3_ua_parser_js__["UAParser"]();
			var ua_result = parser.getResult();

			_this4.ua_result.browser.name = ua_result.browser.name;
			_this4.ua_result.browser.version = ua_result.browser.version;

			_this4.ua_result.device.model = ua_result.device.model;
			_this4.ua_result.device.type = ua_result.device.type;
			_this4.ua_result.device.vendor = ua_result.device.vendor;

			_this4.ua_result.engine.name = ua_result.engine.name;
			_this4.ua_result.engine.version = ua_result.engine.version;

			_this4.ua_result.os.name = ua_result.os.name;
			_this4.ua_result.os.version = ua_result.os.version;

			_this4.metaTitle = 'Contact Us | South Africa\'s Largest Cinema Exhibitor';
			_this4.metaDescription = 'Browse the latest movies and book your tickets online. If you are interested in block bookings you can contact us directly. View our contact details.';
		});
	}
});

/***/ }),
/* 574 */,
/* 575 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Contact us")]), _vm._v(" "), _c('h3', [_vm._v("We'd Love to Hear From You.")])]), _vm._v(" "), _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "gutter-40": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('sk-form', {
    on: {
      "submit": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("What can we help you with?")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.help_options,
      "label": "name",
      "track-by": "id",
      "searchable": false,
      "placeholder": "Please choose an option",
      "multiple": false
    },
    on: {
      "select": _vm.help_selected,
      "remove": _vm.help_removed
    },
    model: {
      value: (_vm.help),
      callback: function($$v) {
        _vm.help = $$v
      },
      expression: "help"
    }
  })], 1), _vm._v(" "), (_vm.isActive) ? [(_vm.isBrowsing) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("What Part of Browsing Tickets Can We Help You With?")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.browsing_options,
      "searchable": false,
      "placeholder": "Please choose an option",
      "multiple": false,
      "validation-value": _vm.browsing_selected,
      "required": ""
    },
    model: {
      value: (_vm.browsing_selected),
      callback: function($$v) {
        _vm.browsing_selected = $$v
      },
      expression: "browsing_selected"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.isTicketing) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Which Movie Card do you need help with?")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.ticketing_options,
      "searchable": false,
      "placeholder": "Please choose an option",
      "multiple": false,
      "validation-value": _vm.ticketing_selected,
      "required": ""
    },
    model: {
      value: (_vm.ticketing_selected),
      callback: function($$v) {
        _vm.ticketing_selected = $$v
      },
      expression: "ticketing_selected"
    }
  })], 1), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Name of Movie(s)",
      "required": ""
    },
    model: {
      value: (_vm.ticketing_movie_name),
      callback: function($$v) {
        _vm.ticketing_movie_name = $$v
      },
      expression: "ticketing_movie_name"
    }
  }), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date of booking")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-input', {
    attrs: {
      "max": "31",
      "min": "1",
      "type": "number",
      "placeholder": "Day",
      "required": ""
    },
    model: {
      value: (_vm.ticketing_date_day),
      callback: function($$v) {
        _vm.ticketing_date_day = $$v
      },
      expression: "ticketing_date_day"
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('sk-combo-select', {
    attrs: {
      "options": _vm.ticketing_date_month,
      "searchable": false,
      "placeholder": "Month"
    },
    model: {
      value: (_vm.ticketing_date_month_selected),
      callback: function($$v) {
        _vm.ticketing_date_month_selected = $$v
      },
      expression: "ticketing_date_month_selected"
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-input', {
    attrs: {
      "min": "2015",
      "type": "number",
      "placeholder": "Year",
      "required": ""
    },
    model: {
      value: (_vm.ticketing_date_year),
      callback: function($$v) {
        _vm.ticketing_date_year = $$v
      },
      expression: "ticketing_date_year"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Time of movie")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.ticketing_movie_time,
      "searchable": false,
      "placeholder": "Choose time of movie",
      "validation-value": _vm.ticketing_date_month_selected,
      "required": ""
    },
    model: {
      value: (_vm.ticketing_date_month_selected),
      callback: function($$v) {
        _vm.ticketing_date_month_selected = $$v
      },
      expression: "ticketing_date_month_selected"
    }
  })], 1)]), _vm._v(" "), _c('sk-spacer')], 1), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Cinema",
      "placeholder": "e.g Sandton",
      "required": ""
    },
    model: {
      value: (_vm.ticketing_cinema),
      callback: function($$v) {
        _vm.ticketing_cinema = $$v
      },
      expression: "ticketing_cinema"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Type of Ticket",
      "placeholder": "e.g SK Club Card Ticket",
      "required": ""
    },
    model: {
      value: (_vm.ticketing_ticket_type),
      callback: function($$v) {
        _vm.ticketing_ticket_type = $$v
      },
      expression: "ticketing_ticket_type"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.isClubLoyalty) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Which Movie Card do you Need Help With?")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.club_loyalty_options,
      "searchable": false,
      "placeholder": "Please choose an option",
      "multiple": false,
      "validation-value": _vm.club_loyalty_selected,
      "required": ""
    },
    model: {
      value: (_vm.club_loyalty_selected),
      callback: function($$v) {
        _vm.club_loyalty_selected = $$v
      },
      expression: "club_loyalty_selected"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("What Can We Help You With?")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.club_loyalty_struggles,
      "searchable": false,
      "placeholder": "Please choose an club or movie card",
      "multiple": false,
      "validation-value": _vm.club_loyalty_struggles_selected,
      "required": ""
    },
    model: {
      value: (_vm.club_loyalty_struggles_selected),
      callback: function($$v) {
        _vm.club_loyalty_struggles_selected = $$v
      },
      expression: "club_loyalty_struggles_selected"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.isSubsClub) ? [(_vm.isGuest) ? [_c('sk-panel', [_c('h2', [_vm._v("SK FAN CLUB")]), _vm._v(" "), _c('sk-layout', {
    staticClass: "subs-club-header",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "lg6": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-club-cards.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('div', {
    staticClass: "club-movie-cards"
  }, [_c('div', {
    staticClass: "article__content"
  }, [_c('p', [_vm._v("Watch more movies, for less!")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tAs a SK Subscription Club member, you can get a subscription for a Limited or Unlimited\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tamount of movies per month at a set cost, which you pay per month. This means\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tyou can now watch more movies at a lower price, whilst also enjoying the benefits\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tof the SK Club\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/subscription-club",
      "contextValue": "Contact Us Type",
      "dataValue": "VIEW PRICING OPTIONS"
    }
  }, [_vm._v("VIEW PRICING OPTIONS")])], 1)])])], 1)], 1)] : [(_vm.user.PreferenceList.includes(5) || _vm.user.PreferenceList.includes(6)) ? [_c('sk-input', {
    attrs: {
      "label": "First name",
      "required": ""
    },
    model: {
      value: (_vm.first_name),
      callback: function($$v) {
        _vm.first_name = $$v
      },
      expression: "first_name"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Surname",
      "required": ""
    },
    model: {
      value: (_vm.surname),
      callback: function($$v) {
        _vm.surname = $$v
      },
      expression: "surname"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Your mobile number",
      "type": "tel",
      "name": "mobile",
      "required": "",
      "placeholder": "eg. +27827804800",
      "error-message": {
        valueMissing: 'Please enter your mobile number',
        patternMismatch: 'Please double check you\'ve entered 9 digits excluding your country code.'
      },
      "pattern": "^\\+?\\d{11,11}|\\d{10,10}$"
    },
    model: {
      value: (_vm.mobileNumber),
      callback: function($$v) {
        _vm.mobileNumber = $$v
      },
      expression: "mobileNumber"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Your email",
      "type": "email",
      "required": "",
      "placeholder": "e.g. xxx@gmail.com",
      "error-message": {
        valueMissing: 'Please make sure your email address follows this format: example@email.com'
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Card number",
      "required": ""
    },
    model: {
      value: (_vm.tmp_card_number),
      callback: function($$v) {
        _vm.tmp_card_number = $$v
      },
      expression: "tmp_card_number"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "type": "hidden"
    },
    model: {
      value: (_vm.card_number),
      callback: function($$v) {
        _vm.card_number = $$v
      },
      expression: "card_number"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "type": "hidden"
    },
    model: {
      value: (_vm.compiled_value),
      callback: function($$v) {
        _vm.compiled_value = $$v
      },
      expression: "compiled_value"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "type": "hidden"
    },
    model: {
      value: (_vm.member_id),
      callback: function($$v) {
        _vm.member_id = $$v
      },
      expression: "member_id"
    }
  })] : [_c('sk-panel', [_c('h2', [_vm._v("SK FAN CLUB")]), _vm._v(" "), _c('sk-layout', {
    staticClass: "subs-club-header",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "lg6": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-club-cards.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('div', {
    staticClass: "club-movie-cards"
  }, [_c('div', {
    staticClass: "article__content"
  }, [_c('p', [_vm._v("Watch more movies, for less!")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tAs a SK Subscription Club member, you can get a subscription for a Limited or Unlimited\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tamount of movies per month at a set cost, which you pay per month. This means\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tyou can now watch more movies at a lower price, whilst also enjoying the benefits\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tof the SK Club\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/subscription-club",
      "contextValue": "Contact Us Type",
      "dataValue": "VIEW PRICING OPTIONS"
    }
  }, [_vm._v("VIEW PRICING OPTIONS")])], 1)])])], 1)], 1)]]] : _vm._e(), _vm._v(" "), (_vm.isGuest && !_vm.isSubsClub) ? [_c('sk-input', {
    attrs: {
      "label": "First name",
      "required": ""
    },
    model: {
      value: (_vm.first_name),
      callback: function($$v) {
        _vm.first_name = $$v
      },
      expression: "first_name"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Surname",
      "required": ""
    },
    model: {
      value: (_vm.surname),
      callback: function($$v) {
        _vm.surname = $$v
      },
      expression: "surname"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Your email",
      "type": "email",
      "required": "",
      "placeholder": "e.g. xxx@gmail.com",
      "error-message": {
        valueMissing: 'Please make sure your email address follows this format: example@email.com'
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Your mobile number",
      "type": "tel",
      "name": "mobile",
      "required": "",
      "placeholder": "eg. +27827804800",
      "error-message": {
        valueMissing: 'Please enter your mobile number',
        patternMismatch: 'Please double check you\'ve entered 9 digits excluding your country code.'
      },
      "pattern": "^\\+?\\d{11,11}|\\d{10,10}$"
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.isSubsClub) ? [(!_vm.isGuest) ? [(_vm.user.PreferenceList.includes(5) || _vm.user.PreferenceList.includes(6)) ? [_c('sk-textarea', {
    staticClass: "dark-area",
    attrs: {
      "label": "Leave Us a Comment"
    },
    model: {
      value: (_vm.contact_message),
      callback: function($$v) {
        _vm.contact_message = $$v
      },
      expression: "contact_message"
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "loading": _vm.loadingSubmit
    }
  }, [_vm._v("Send us your feedback")])] : _vm._e()] : _vm._e()] : [_c('sk-textarea', {
    staticClass: "dark-area",
    attrs: {
      "label": "Leave Us a Comment"
    },
    model: {
      value: (_vm.contact_message),
      callback: function($$v) {
        _vm.contact_message = $$v
      },
      expression: "contact_message"
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "loading": _vm.loadingSubmit
    }
  }, [_vm._v("Send us your feedback")])]] : _vm._e()], 2)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('address', [_c('h4', [_vm._v("Customer Care")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("South Africa:")]), _vm._v(" 0861 MOVIES (668437)")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Namibia:")]), _vm._v(" 0860 0095 05")])]), _vm._v(" "), _c('address', [_c('h4', [_vm._v("Email")]), _vm._v(" "), _c('p', [_vm._v("info@sterkinekor.com")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("For corporate or block bookings please contact us on:")])]), _vm._v(" "), _c('p', [_vm._v("corporate@sterkinekor.com")])]), _vm._v(" "), _c('address', [_c('h4', [_vm._v("Whistle-Blowers")]), _vm._v(" "), _c('p', [_vm._v("0800 225 111")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": " https://www.whistleblowing.co.za/make-a-report-steps/",
      "target": "_blank"
    }
  }, [_vm._v("Make a report online")])])]), _vm._v(" "), _c('address', [_c('h4', [_vm._v("Postal Address")]), _vm._v(" "), _c('p', [_vm._v("PO Box 76461")]), _vm._v(" "), _c('p', [_vm._v("Wendywood")]), _vm._v(" "), _c('p', [_vm._v("2144")])]), _vm._v(" "), _c('address', [_c('h4', [_vm._v("Physical Address")]), _vm._v(" "), _c('p', [_vm._v("Ster-Kinekor Office Park")]), _vm._v(" "), _c('p', [_vm._v("185 Katherine Street")]), _vm._v(" "), _c('p', [_vm._v("Eastgate Ext.4")]), _vm._v(" "), _c('p', [_vm._v("Sandton")])])])], 1)], 1)], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.successDialog),
      callback: function($$v) {
        _vm.successDialog = $$v
      },
      expression: "successDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.successDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.successDialog = false
      }
    }
  }), _vm._v(" "), (_vm.isSubsClub) ? [_c('h3', [_vm._v("Thank you")]), _vm._v(" "), _c('p', [_vm._v("You will be contacted shortly.")])] : [_c('h3', [_vm._v("Thank you")]), _vm._v(" "), _c('p', [_vm._v("Thank you for giving us your feedback!")])], _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.successDialog = false
      }
    }
  }, [_vm._v("Close")])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(578),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_meta_data_js__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_meta_data_js__["a" /* default */]],
    data: function data() {
        return {
            promo: {},
            movie: null,
            loading: true,
            dialogActive: false
        };
    },


    methods: {
        getAsyncData: function getAsyncData() {
            this.metaTitle = this.promo.title;
            this.metaDescription = this.promo.strapline;
            this.$emit('updateHead');
        },
        processPromo: function processPromo(promo) {
            var _this = this;

            promo.srcsets = promo.mobile_image + ' 700w, ' + promo.image + ' 2000w';
            this.promo = promo;
            this.loading = true;
            if (this.promo.related_movie) this.getMovie(this.promo.related_movie).then(function () {
                return _this.loading = false;
            });else this.loading = false;
        },
        getContent: function getContent() {
            var _this2 = this;

            this.loading = true;
            if (__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].hasPreviewContent('promotion') && __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent().nid == this.$route.params.id) {
                this.processPromo(__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent('promotion'));
            } else __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getPromo().then(function (response) {
                response.data.forEach(function (el) {
                    if (el.nid === _this2.$route.params.id) {
                        _this2.processPromo(el);
                    }
                });
                _this2.getAsyncData();
            });
        },
        getMovie: function getMovie(id) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovieDetail(id).then(function (response) {
                _this3.movie = response;
            });
        }
    },

    created: function created() {
        this.getContent();
    },
    mounted: function mounted() {
        var _this4 = this;

        if (window.__PRERENDER_INJECTED) {
            this.loading = false;
            this.prerender = true;

            if (window.__PRERENDER_INJECTED.promos) {

                var promos = window.__PRERENDER_INJECTED.promos;
                promos.forEach(function (promo) {
                    if (promo.nid === _this4.$route.params.id) {
                        _this4.processPromo(promo);
                    }
                });

                this.getAsyncData();
            }
        }
    }
});

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "promo"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), [_c('sk-panel', [_c('sk-layout', [(_vm.movie && _vm.promo.use_movie_poster == '1') ? _c('sk-flex', {
    attrs: {
      "xs5": "",
      "md3": ""
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "movie-detail__poster",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogActive = true
      }
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.poster,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-icon', {
    staticClass: "movie-detail__poster-play",
    attrs: {
      "play": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('sk-video', {
    staticClass: "dialog-video",
    attrs: {
      "content": _vm.movie.youtube_id
    },
    model: {
      value: (_vm.dialogActive),
      callback: function($$v) {
        _vm.dialogActive = $$v
      },
      expression: "dialogActive"
    }
  })], 1)])]) : ((!_vm.promo.use_movie_poster || _vm.promo.use_movie_poster == '0') && _vm.promo.poster_image) ? _c('sk-flex', {
    attrs: {
      "xs5": "",
      "md3": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster movie-detail__poster-img--no-trailer"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.promo.poster_image.url,
      "alt": ""
    }
  })])])]) : (_vm.promo.images.desktop) ? _c('sk-flex', {
    attrs: {
      "xs5": "",
      "md3": ""
    }
  }, [_c('div', {}, [_c('div', {}, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.promo.images.desktop.url,
      "alt": ""
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs7": "",
      "md9": ""
    }
  }, [_c('div', {
    staticClass: "promo__content"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.promo.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.promo.detail || _vm.promo.promotion_strapline)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "promo__content-btns"
  }, [(_vm.movie && (!_vm.promo.button_text || !_vm.promo.button_link)) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'Movie Details',
        params: {
          id: _vm.movie.id
        }
      }
    }
  }, [_vm._v("Book to Win")]) : (_vm.promo.button_link && _vm.promo.button_link) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.promo.button_link
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.promo.button_text) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.promo.button_2_text && _vm.promo.button_2_link) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "tag": "a",
      "href": _vm.promo.button_2_link
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.promo.button_2_text) + "\n                                ")]) : _vm._e()], 1)])])], 1)], 1), _vm._v(" "), _vm._l((_vm.promo.questions), function(item, index) {
    return _c('sk-accordian', {
      key: index,
      attrs: {
        "auto-expand-first": index == 0
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('h4', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('template', {
      slot: "content"
    }, [_c('sk-panel', {
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    })], 1)], 2)
  })]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(581),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_meta_data_js__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_meta_data_js__["a" /* default */]],
    data: function data() {
        return {
            event: {},
            movie: null,
            loading: true,
            dialogActive: false
        };
    },


    methods: {
        getAsyncData: function getAsyncData() {
            this.metaTitle = this.event.title;
            this.metaImage = this.event.og_image;
            this.metaDescription = this.event.og_description;
            this.schemaDataSrc = {
                "@context": "http://schema.org",
                "@type": "Event",
                "image": this.metaImage,
                "description": this.metaDescription,

                "name": this.metaTitle,

                "startDate": this.event.event_date
            };
            this.$emit('updateHead');
        },
        processEvent: function processEvent(event) {
            var _this = this;

            event.srcsets = event.mobile_image + ' 700w, ' + event.image + ' 2000w';
            this.event = event;
            if (this.event.related_movie) this.getMovie(this.event.related_movie).then(function () {
                return _this.loading = false;
            }, function () {
                return _this.loading = false;
            });else this.loading = false;
        },
        getContent: function getContent() {
            var _this2 = this;

            this.loading = true;
            if (__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].hasPreviewContent('event') && __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent().nid === this.$route.params.id) {
                this.processEvent(__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent('event'));
            } else __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getEvent().then(function (response) {
                response.forEach(function (el) {
                    if (el.nid === _this2.$route.params.id) {
                        _this2.processEvent(el);
                    }
                    _this2.getAsyncData();
                });
            });
        },
        getMovie: function getMovie(id) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovieDetail(id).then(function (response) {
                _this3.movie = response;
            });
        }
    },

    created: function created() {
        this.getContent();
    },
    mounted: function mounted() {
        var _this4 = this;

        if (window.__PRERENDER_INJECTED) {
            this.loading = false;
            this.prerender = true;

            if (window.__PRERENDER_INJECTED.events) {

                var events = window.__PRERENDER_INJECTED.events;
                events.forEach(function (event) {
                    if (event.nid === _this4.$route.params.id) {
                        _this4.processEvent(event);
                    }
                });

                this.getAsyncData();
            }
        }
    }
});

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), [_c('sk-panel', [_c('sk-layout', [(_vm.movie && _vm.event.use_movie_poster == '1') ? _c('sk-flex', {
    attrs: {
      "xs5": "",
      "md3": ""
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "movie-detail__poster",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogActive = true
      }
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.poster,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-icon', {
    staticClass: "movie-detail__poster-play",
    attrs: {
      "play": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('sk-video', {
    staticClass: "dialog-video",
    attrs: {
      "content": _vm.movie.youtube_id
    },
    model: {
      value: (_vm.dialogActive),
      callback: function($$v) {
        _vm.dialogActive = $$v
      },
      expression: "dialogActive"
    }
  })], 1)])]) : ((!_vm.event.use_movie_poster || _vm.event.use_movie_poster == '0') && _vm.event.poster_image) ? _c('sk-flex', {
    attrs: {
      "xs5": "",
      "md3": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster movie-detail__poster-img--no-trailer"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.event.poster_image.url,
      "alt": ""
    }
  })])])]) : (_vm.event.images.desktop) ? _c('sk-flex', {
    attrs: {
      "xs5": "",
      "md3": ""
    }
  }, [_c('div', {}, [_c('div', {}, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.event.images.desktop.url,
      "alt": ""
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs7": "",
      "md9": ""
    }
  }, [_c('div', {
    staticClass: "event__content"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.event.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.event.detail || _vm.event.strapline)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "event__content-btns"
  }, [(_vm.movie && (!_vm.event.button_text || !_vm.event.button_link)) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "inline-block": "",
      "to": {
        name: 'Movie Details',
        params: {
          id: _vm.movie.id
        }
      }
    }
  }, [_vm._v("Book to Win")]) : (_vm.event.button_link && _vm.event.button_link) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.event.button_link,
      "inline-block": ""
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.event.button_text) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.event.button_2_text && _vm.event.button_2_link) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "inline-block": "",
      "tag": "a",
      "href": _vm.event.button_2_link
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.event.button_2_text) + "\n                                ")]) : _vm._e()], 1)])])], 1)], 1), _vm._v(" "), _vm._l((_vm.event.questions), function(item, index) {
    return _c('sk-accordian', {
      key: index
    }, [_c('template', {
      slot: "header"
    }, [_c('h4', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('template', {
      slot: "content"
    }, [_c('sk-panel', {
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    })], 1)], 2)
  })]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(584),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'about',
    data: function data() {
        return {
            tabs: [],
            currentIndex: 0
        };
    },


    methods: {
        computeTabs: function computeTabs() {
            var parentRoute = this.$route.matched.find(function (route) {
                return route.parent == undefined;
            });
            this.tabs = this.$router.options.routes.find(function (r) {
                return r.name === parentRoute.name;
            }).children || [];
        },
        isActive: function isActive(index) {
            return index == this.currentIndex;
        },
        pushRoute: function pushRoute(el, event) {
            this.$router.push({ name: el.name });
        }
    },

    computed: {
        activeTab: {
            get: function get() {
                var _this = this;

                return this.tabs ? this.tabs.findIndex(function (tab) {
                    return tab.name === _this.$route.name;
                }) : 0;
            },
            set: function set($tabIndex) {
                var tab = this.tabs[$tabIndex];
                if (this.$route.name !== tab.name) {
                    this.$router.push({ name: tab.name });
                }
            }
        }
    },

    beforeUpdate: function beforeUpdate() {
        this.computeTabs();
    },
    beforeMount: function beforeMount() {
        this.computeTabs();
    }
});

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("About SK")])]), _vm._v(" "), (_vm.$breakpoints.xs || _vm.$breakpoints.sm) ? _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-accordian', {
      key: index,
      attrs: {
        "active": _vm.activeTab == index
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.pushRoute(tab, $event)
        }
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('h2', {
      staticClass: "faq__cat-title"
    }, [_vm._v(_vm._s(tab.name))])]), _vm._v(" "), _c('template', {
      slot: "content"
    }, [_c('sk-panel', [_c('router-view')], 1)], 1)], 2)
  }) : [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-tabs', {
    attrs: {
      "size": _vm.tabs.length
    }
  }, [_c('template', {
    slot: "tab-title"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-tab', {
      key: tab.name,
      class: (_vm.activeTab == index ? 'active' : ''),
      attrs: {
        "item": tab.title || tab.name
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.activeTab = index
        }
      }
    })
  })), _vm._v(" "), _c('template', {
    slot: "tab-content"
  }, [_c('sk-panel', [_c('router-view')], 1)], 1)], 2)], 1)], 1)]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(587),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_meta_data_js__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_meta_data_js__["a" /* default */]],

    data: function data() {
        return {
            newsItems: [],
            loading: true,
            newsFilter: 'All'
        };
    },
    created: function created() {
        var _this = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getNews().then(function (newsItems) {
            _this.newsItems = __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].addPreviewToContentArrayIfAvailable('news', newsItems);
            var newsFilter = _this.$route.params.filter ? _this.$route.params.filter : 'All';

            _this.newsFilter = newsFilter;
            _this.loading = false;
        });
        this.metaTitle = 'Movie and Entertainment News | The Latest in Cinema';
        this.metaDescription = 'Stay up to date with the latest Ster-Kinekor movie and entertainment news. Browse our corporate news articles and press releases.';
    },
    mounted: function mounted() {
        window.scroll({ top: 0, left: 0 });
        if (window.__PRERENDER_INJECTED) {
            if (window.__PRERENDER_INJECTED.news) {
                this.newsItems = __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].addPreviewToContentArrayIfAvailable('news', window.__PRERENDER_INJECTED.news);
                var newsFilter = 'All';
                this.metaTitle = 'Movie and Entertainment News | The Latest in Cinema';
                this.metaDescription = 'Stay up to date with the latest Ster-Kinekor movie and entertainment news. Browse our corporate news articles and press releases.';
            }
        }
    }
});

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Articles")])])], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : [(_vm.$breakpoints.xs) ? [_c('sk-accordian', [_c('template', {
    slot: "header"
  }, [_c('h4', [_vm._v("All")])]), _vm._v(" "), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "panel"
  }, _vm._l((_vm.newsItems), function(news, index) {
    return ((news.general.type == _vm.newsFilter || _vm.newsFilter == 'All')) ? _c('div', {
      key: news.general.id
    }, [(index != 0) ? _c('sk-divider') : _vm._e(), _vm._v(" "), _c('sk-layout', {
      staticClass: "article article--summary",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "md3": ""
      }
    }, [_c('div', {
      staticClass: "article__image"
    }, [(news.general.type == 'Genres') ? [_c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": ("/news/genres/detail/" + (news.general.id) + "/" + (news.general.slug))
      }
    }, [_c('img', {
      attrs: {
        "alt": news.top_section.image.alt ? news.top_section.image.alt : '',
        "src": news.top_section.image ? news.top_section.image.url : '/static/img/news-placeholder.jpg'
      }
    })])] : (news.general.type == 'Blogs') ? [_c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": ("/news/blogs/detail/" + (news.general.id) + "/" + (news.general.slug))
      }
    }, [_c('img', {
      attrs: {
        "alt": news.top_section.image.alt ? news.top_section.image.alt : '',
        "src": news.top_section.image ? news.top_section.image.url : '/static/img/news-placeholder.jpg'
      }
    })])] : [_c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": ("/news/detail/" + (news.general.id) + "/" + (news.general.slug))
      }
    }, [_c('img', {
      attrs: {
        "alt": news.top_section.image.alt ? news.top_section.image.alt : '',
        "src": news.top_section.image ? news.top_section.image.url : '/static/img/news-placeholder.jpg'
      }
    })])]], 2)]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "md9": ""
      }
    }, [_c('h6', [(news.general.type == 'Genres') ? [_c('sk-button', {
      staticClass: "article__title",
      attrs: {
        "tag": "a",
        "href": ("/news/genres/detail/" + (news.general.id) + "/" + (news.general.slug))
      },
      domProps: {
        "innerHTML": _vm._s(news.general.title)
      }
    })] : (news.general.type == 'Blogs') ? [_c('sk-button', {
      staticClass: "article__title",
      attrs: {
        "tag": "a",
        "href": ("/news/blogs/detail/" + (news.general.id) + "/" + (news.general.slug))
      },
      domProps: {
        "innerHTML": _vm._s(news.general.title)
      }
    })] : [_c('sk-button', {
      staticClass: "article__title",
      attrs: {
        "tag": "a",
        "href": ("/news/detail/" + (news.general.id) + "/" + (news.general.slug))
      },
      domProps: {
        "innerHTML": _vm._s(news.general.title)
      }
    })]], 2), _vm._v(" "), _c('span', {
      staticClass: "article__author",
      domProps: {
        "innerHTML": _vm._s(news.general.author)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "article__date"
    }, [_vm._v(_vm._s(news.general.date))]), _vm._v(" "), _c('div', {
      staticClass: "article__summary"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s((news.top_section.summary))
      }
    }), _vm._v(" "), (news.general.type == 'Genres') ? [_c('sk-button', {
      attrs: {
        "link": "",
        "small": "",
        "tag": "a",
        "href": ("/news/genres/detail/" + (news.general.id) + "/" + (news.general.slug))
      }
    }, [_vm._v(" Read more")])] : (news.general.type == 'Blogs') ? [_c('sk-button', {
      attrs: {
        "link": "",
        "small": "",
        "tag": "a",
        "href": ("/news/blogs/detail/" + (news.general.id) + "/" + (news.general.slug))
      }
    }, [_vm._v(" Read more")])] : [_c('sk-button', {
      attrs: {
        "link": "",
        "small": "",
        "tag": "a",
        "href": ("/news/detail/" + (news.general.id) + "/" + (news.general.slug))
      }
    }, [_vm._v(" Read more")])]], 2)])], 1)], 1) : _vm._e()
  }))])], 2)] : [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-tabs', {
    attrs: {
      "size": 4
    }
  }, [_c('template', {
    slot: "tab-title"
  }, [_c('sk-tab', {
    class: {
      active: _vm.newsFilter == 'All'
    },
    attrs: {
      "item": "All"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.newsFilter = 'All'
      }
    }
  }), _vm._v(" "), _c('sk-tab', {
    class: {
      active: _vm.newsFilter == 'Corporate'
    },
    attrs: {
      "item": "Corporate"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.newsFilter = 'Corporate'
      }
    }
  }), _vm._v(" "), _c('sk-tab', {
    class: {
      active: _vm.newsFilter == 'Press_Release'
    },
    attrs: {
      "item": "Press Release"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.newsFilter = 'Press_Release'
      }
    }
  }), _vm._v(" "), _c('sk-tab', {
    class: {
      active: _vm.newsFilter == 'Blogs'
    },
    attrs: {
      "item": "Blogs"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.newsFilter = 'Blogs'
      }
    }
  }), _vm._v(" "), _c('sk-tab', {
    class: {
      active: _vm.newsFilter == 'Genres'
    },
    attrs: {
      "item": "Genres"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.newsFilter = 'Genres'
      }
    }
  }), _vm._v(" "), _c('sk-tab', {
    class: {
      active: _vm.newsFilter == 'Experiences'
    },
    attrs: {
      "item": "Experiences"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.newsFilter = 'Experiences'
      }
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "tab-content"
  }, [_c('sk-panel', _vm._l((_vm.newsItems), function(news, index) {
    return ((news.general.type == _vm.newsFilter || _vm.newsFilter == 'All')) ? _c('div', {
      key: news.general.id
    }, [_c('hr'), _vm._v(" "), _c('sk-layout', {
      staticClass: "article article--summary",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "md3": ""
      }
    }, [_c('div', {
      staticClass: "article__image"
    }, [(news.general.type == 'Genres') ? [_c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: 'NewsGenresDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": news.top_section.image.alt ? news.top_section.image.alt : '',
        "src": news.top_section.image ? news.top_section.image.url : '/static/img/news-placeholder.jpg'
      }
    })])] : (news.general.type == 'Blogs') ? [_c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: 'NewsBlogDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": news.top_section.image.alt ? news.top_section.image.alt : '',
        "src": news.top_section.image ? news.top_section.image.url : '/static/img/news-placeholder.jpg'
      }
    })])] : [_c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: 'NewsDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": news.top_section.image.alt ? news.top_section.image.alt : '',
        "src": news.top_section.image ? news.top_section.image.url : '/static/img/news-placeholder.jpg'
      }
    })])]], 2)]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "md9": ""
      }
    }, [_c('h6', [(news.general.type == 'Genres') ? [_c('sk-button', {
      staticClass: "article__title",
      attrs: {
        "flat": "",
        "router": "",
        "to": {
          name: 'NewsGenresDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_vm._v(_vm._s(news.general.title))])] : (news.general.type == 'Blogs') ? [_c('sk-button', {
      staticClass: "article__title",
      attrs: {
        "flat": "",
        "router": "",
        "to": {
          name: 'NewsBlogDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_vm._v(_vm._s(news.general.title))])] : [_c('sk-button', {
      staticClass: "article__title",
      attrs: {
        "flat": "",
        "router": "",
        "to": {
          name: 'NewsDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_vm._v(_vm._s(news.general.title))])]], 2), _vm._v(" "), _c('span', {
      staticClass: "article__author",
      domProps: {
        "innerHTML": _vm._s(news.general.author)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "article__date"
    }, [_vm._v(_vm._s(news.general.date))]), _vm._v(" "), _c('div', {
      staticClass: "article__summary"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s((news.top_section.summary))
      }
    }), _vm._v(" "), (news.general.type == 'Genres') ? [_c('sk-button', {
      attrs: {
        "link": "",
        "small": "",
        "router": "",
        "to": {
          name: 'NewsGenresDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_vm._v(" Read more")])] : (news.general.type == 'Blogs') ? [_c('sk-button', {
      attrs: {
        "link": "",
        "small": "",
        "router": "",
        "to": {
          name: 'NewsBlogDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_vm._v(" Read more")])] : [_c('sk-button', {
      attrs: {
        "link": "",
        "small": "",
        "router": "",
        "to": {
          name: 'NewsDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_vm._v(" Read more")])]], 2)])], 1)], 1) : _vm._e()
  }))], 1)], 2)], 1)], 1)]]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(589),
  /* template */
  __webpack_require__(590),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_meta_data_js__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'vouchers',
    data: function data() {
        return {
            tabs: []
        };
    },


    computed: {
        activeTab: {
            get: function get() {
                var _this = this;

                return this.tabs ? this.tabs.findIndex(function (tab) {
                    return tab.name === _this.$route.name;
                }) : 0;
            },
            set: function set($tabIndex) {
                var tab = this.tabs[$tabIndex];
                if (this.$route.name !== tab.name) {
                    this.$router.push({ name: tab.name });
                }
            }
        }
    },

    beforeMount: function beforeMount() {
        var parentRoute = this.$route.matched.find(function (route) {
            return route.parent == undefined;
        });
        this.tabs = this.$router.options.routes.find(function (r) {
            return r.name === parentRoute.name;
        }).children || [];
    }
});

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-layout', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Sk gift vouchers")])])], 1), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-tabs', {
    attrs: {
      "size": _vm.tabs.length
    }
  }, [_c('template', {
    slot: "tab-title"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-tab', {
      key: tab.name,
      class: (_vm.activeTab == index ? 'active' : ''),
      attrs: {
        "item": tab.title || tab.name
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.activeTab = index
        }
      }
    })
  })), _vm._v(" "), _c('template', {
    slot: "tab-content"
  }, [_c('sk-panel', [_c('router-view')], 1)], 1)], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(592),
  /* template */
  __webpack_require__(593),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'careers',
    data: function data() {
        return {
            tabs: []
        };
    },


    computed: {
        activeTab: {
            get: function get() {
                var _this = this;

                return this.tabs ? this.tabs.findIndex(function (tab) {
                    return tab.name === _this.$route.name;
                }) : 0;
            },
            set: function set($tabIndex) {
                var tab = this.tabs[$tabIndex];
                if (this.$route.name !== tab.name) {
                    this.$router.push({ name: tab.name });
                }
            }
        }
    },

    methods: {
        pushRoute: function pushRoute(el) {
            this.$router.push({ name: el.name });
        }
    },

    beforeMount: function beforeMount() {
        var parentRoute = this.$route.matched.find(function (route) {
            return route.parent == undefined;
        });
        this.tabs = this.$router.options.routes.find(function (r) {
            return r.name === parentRoute.name;
        }).children || [];
    }
});

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "careers"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Careers")])]), _vm._v(" "), (_vm.$breakpoints.xs || _vm.$breakpoints.sm) ? _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-accordian', {
      key: index,
      attrs: {
        "active": _vm.activeTab == index
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.pushRoute(tab)
        }
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('h2', {
      staticClass: "faq__cat-title",
      attrs: {
        "data-url": tab.path
      }
    }, [_vm._v(_vm._s(tab.name))])]), _vm._v(" "), _c('template', {
      slot: "content"
    }, [_c('sk-panel', [_c('router-view')], 1)], 1)], 2)
  }) : [_c('sk-tabs', {
    attrs: {
      "size": _vm.tabs.length
    }
  }, [_c('template', {
    slot: "tab-title"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-tab', {
      key: tab.name,
      class: (_vm.activeTab == index ? 'active' : ''),
      attrs: {
        "item": tab.title || tab.name
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.activeTab = index
        }
      }
    })
  })), _vm._v(" "), _c('template', {
    slot: "tab-content"
  }, [_c('sk-panel', [_c('router-view')], 1)], 1)], 2)]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(595),
  /* template */
  __webpack_require__(596),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_meta_data_js__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'procurement',
    data: function data() {
        return {
            tabs: []
        };
    },


    computed: {
        activeTab: {
            get: function get() {
                var _this = this;

                return this.tabs ? this.tabs.findIndex(function (tab) {
                    return tab.name === _this.$route.name;
                }) : 0;
            },
            set: function set($tabIndex) {
                var tab = this.tabs[$tabIndex];
                if (this.$route.name !== tab.name) {
                    this.$router.push({ name: tab.name });
                }
            }
        }
    },

    methods: {
        pushRoute: function pushRoute(el) {
            this.$router.push({ name: el.name });
        }
    },

    beforeMount: function beforeMount() {
        var parentRoute = this.$route.matched.find(function (route) {
            return route.parent == undefined;
        });
        this.tabs = this.$router.options.routes.find(function (r) {
            return r.name === parentRoute.name;
        }).children || [];
    }
});

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Procurement")])]), _vm._v(" "), (_vm.$breakpoints.xs || _vm.$breakpoints.sm) ? _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-accordian', {
      key: index,
      attrs: {
        "active": _vm.activeTab == index
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.pushRoute(tab)
        }
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('h2', {
      staticClass: "faq__cat-title",
      attrs: {
        "data-url": tab.path
      }
    }, [_vm._v(_vm._s(tab.name))])]), _vm._v(" "), _c('template', {
      slot: "content"
    }, [_c('sk-panel', [_c('router-view')], 1)], 1)], 2)
  }) : [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-tabs', {
    attrs: {
      "size": _vm.tabs.length
    }
  }, [_c('template', {
    slot: "tab-title"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-tab', {
      key: tab.name,
      class: (_vm.activeTab == index ? 'active' : ''),
      attrs: {
        "item": tab.title || tab.name
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.activeTab = index
        }
      }
    })
  })), _vm._v(" "), _c('template', {
    slot: "tab-content"
  }, [_c('sk-panel', [_c('router-view')], 1)], 1)], 2)], 1)], 1)]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(598),
  /* template */
  __webpack_require__(599),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_meta_data_js__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'vision-mission',
    data: function data() {
        return {
            tabs: []
        };
    },


    methods: {
        computeTabs: function computeTabs() {
            var parentRoute = this.$route.matched.find(function (route) {
                return route.parent == undefined;
            });
            this.tabs = this.$router.options.routes.find(function (r) {
                return r.name === parentRoute.name;
            }).children || [];
        },
        pushRoute: function pushRoute(el) {
            this.$router.push({ name: el.name });
        }
    },

    computed: {
        activeTab: {
            get: function get() {
                var _this = this;

                return this.tabs ? this.tabs.findIndex(function (tab) {
                    return tab.name === _this.$route.name;
                }) : 0;
            },
            set: function set($tabIndex) {
                var tab = this.tabs[$tabIndex];
                if (this.$route.name !== tab.name) {
                    this.$router.push({ name: tab.name });
                }
            }
        }
    },

    beforeMount: function beforeMount() {
        this.computeTabs();
    }
});

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Vision mission")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.$breakpoints.xs || _vm.$breakpoints.sm) ? _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-accordian', {
      key: index,
      attrs: {
        "active": _vm.activeTab == index
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.pushRoute(tab)
        }
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('h2', {
      staticClass: "faq__cat-title",
      attrs: {
        "data-url": tab.path
      }
    }, [_vm._v(_vm._s(tab.name))])]), _vm._v(" "), _c('template', {
      slot: "content"
    }, [_c('sk-panel', [_c('router-view')], 1)], 1)], 2)
  }) : [_c('sk-tabs', {
    attrs: {
      "size": _vm.tabs.length
    }
  }, [_c('template', {
    slot: "tab-title"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-tab', {
      key: tab.name,
      class: (_vm.activeTab == index ? 'active' : ''),
      attrs: {
        "item": tab.title || tab.name
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.activeTab = index
        }
      }
    })
  })), _vm._v(" "), _c('template', {
    slot: "tab-content"
  }, [_c('sk-panel', [_c('router-view')], 1)], 1)], 2)]], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(602),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'discovery-vitality',

    data: function data() {
        return {
            discovery: {
                day: null,
                month: null,
                year: null,
                number: null,
                name: null,
                email: null,
                gender: null
            },
            months: __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core__["Utils"].MonthMeta(),
            result: null,
            loading: false,
            tried: false,
            success: false,
            status: "",
            tmp_surname: null
        };
    },


    watch: {
        result: {
            handler: function handler() {
                this.tried = true;
                if (this.result.data) {
                    this.success = this.result.data.success;
                    this.status = this.result.data.response;

                    this.$toaster.show(this.status, {
                        top: true,
                        timeout: 1000,
                        primary: true
                    });
                }
                this.loading = false;
            },

            deep: true
        }
    },

    computed: {
        currentYear: function currentYear() {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY');
        }
    },

    methods: {
        onSubmit: function onSubmit() {
            var _this = this;

            this.loading = true;
            var dateOfBirth = this.discovery.year + "/" + this.discovery.month + "/" + this.discovery.day;
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["h" /* LoyaltyCardService */].activateVitalityCard(dateOfBirth, this.discovery.number, this.discovery.gender, this.discovery.name)).then(function (activate) {
                _this.result = activate;
            }, function (error) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
                _this.result = {
                    data: {
                        "success": false,
                        "response": "Hmm, looks like the card number you've entered is invalid. Please double check you’ve entered the right number."
                    }
                };
            });
        },
        retry: function retry() {
            this.tried = false;
        },
        bookNow: function bookNow() {
            this.$router.push('/');
        }
    },

    created: function created() {
        var _this2 = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user().then(function (user) {

            if (!user.isGuest()) {
                _this2.discovery.email = user.Email || null;
                _this2.discovery.gender = user.Gender && user.Gender == "Unknown" ? "Other" : user.Gender || null;
                _this2.discovery.name = user.FirstName.charAt(0);
                _this2.tmp_surname = user.LastName || null;
                _this2.discovery.day = user._DobDay || null;
                _this2.discovery.month = user._DobMonth || null;
                _this2.discovery.year = user._DobYear || null;
            }
            _this2.loading = false;
        });
    }
});

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_c('sk-panel', [_c('h3', [_vm._v("Activate Your Discovery Vitality Movie Benefit")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [(_vm.tried) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), (!_vm.success) ? _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.retry()
      }
    }
  }, [_vm._v("Retry")]) : _vm._e(), _vm._v(" "), (_vm.success) ? [_c('p', [_vm._v("You can now use your benefit when booking movies.")]), _vm._v(" "), (_vm.success) ? _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.bookNow()
      }
    }
  }, [_vm._v("Book Now")]) : _vm._e()] : _vm._e()], 2) : _c('sk-form', {
    on: {
      "submit": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('p', [_vm._v("Please fill out your details below.")]), _vm._v(" "), _c('p', [_vm._v("All fields are mandatory.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('sk-input', {
    attrs: {
      "label": "Discovery Membership Number",
      "placeholder": "e.g 123456789",
      "required": ""
    },
    model: {
      value: (_vm.discovery.number),
      callback: function($$v) {
        _vm.$set(_vm.discovery, "number", $$v)
      },
      expression: "discovery.number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('sk-input', {
    attrs: {
      "label": "Initial of First Name",
      "placeholder": "e.g R",
      "required": "",
      "maxLength": "5"
    },
    model: {
      value: (_vm.discovery.name),
      callback: function($$v) {
        _vm.$set(_vm.discovery, "name", $$v)
      },
      expression: "discovery.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('sk-input', {
    attrs: {
      "label": "Your Surname",
      "value": "",
      "placeholder": "e.g Doe",
      "required": ""
    },
    model: {
      value: (_vm.tmp_surname),
      callback: function($$v) {
        _vm.tmp_surname = $$v
      },
      expression: "tmp_surname"
    }
  })], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "select-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date of Birth")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "day"
  }, [_c('sk-input', {
    attrs: {
      "placeholder": "Day",
      "max": "31",
      "min": "1",
      "type": "number",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter a day'
      }
    },
    model: {
      value: (_vm.discovery.day),
      callback: function($$v) {
        _vm.$set(_vm.discovery, "day", $$v)
      },
      expression: "discovery.day"
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "month"
  }, [_c('sk-combo-select', {
    attrs: {
      "options": _vm.months,
      "searchable": false,
      "placeholder": "Month",
      "validation-value": _vm.discovery.month,
      "error-message": "Please choose a month",
      "required": ""
    },
    model: {
      value: (_vm.discovery.month),
      callback: function($$v) {
        _vm.$set(_vm.discovery, "month", $$v)
      },
      expression: "discovery.month"
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "year"
  }, [_c('sk-input', {
    attrs: {
      "placeholder": "Year",
      "type": "number",
      "required": "",
      "min": _vm.currentYear - 120,
      "max": _vm.currentYear,
      "error-message": {
        valueMissing: 'Please enter a year'
      }
    },
    model: {
      value: (_vm.discovery.year),
      callback: function($$v) {
        _vm.$set(_vm.discovery, "year", $$v)
      },
      expression: "discovery.year"
    }
  })], 1)])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "form-group",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Gender")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('sk-combo-select', {
    attrs: {
      "options": ['Male', 'Female', 'Other'],
      "searchable": false,
      "placeholder": "Gender",
      "validation-value": _vm.discovery.gender,
      "error-message": "Please choose a gender",
      "required": ""
    },
    model: {
      value: (_vm.discovery.gender),
      callback: function($$v) {
        _vm.$set(_vm.discovery, "gender", $$v)
      },
      expression: "discovery.gender"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('sk-input', {
    attrs: {
      "type": "email",
      "name": "email",
      "autocomplete": "email",
      "label": "Email Address",
      "placeholder": "e.g jodndoe@gmail.com",
      "required": ""
    },
    model: {
      value: (_vm.discovery.email),
      callback: function($$v) {
        _vm.$set(_vm.discovery, "email", $$v)
      },
      expression: "discovery.email"
    }
  })], 1), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit"
    }
  }, [_vm._v("Activate Discovery Vitality Now")]), _vm._v(" "), _c('p', [_vm._v("There is no activation fee for the digital card.")])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(604),
  /* template */
  __webpack_require__(605),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_meta_data_js__ = __webpack_require__(5);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'club-loyalty-info',

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_meta_data_js__["a" /* default */]],

  data: function data() {
    return {
      page: [],
      cinemas: [],
      loading: true,
      movies: null,
      discoveryMembershipNumber: '',
      UserName: '',
      UserEmail: '',
      month: '',
      day: '',
      year: '',
      cinema_selected: null,
      fullPrice: '',
      edgarsPrice: '',
      vitalityPrice: '',
      active2d: false,
      active3d: false,
      user: true,
      isGuest: true,
      url: this.$route.params.card_name,
      showOtherPricing: false,
      loadingResendActivation: false
    };
  },


  computed: {
    cinemaType: function cinemaType() {
      return ['2D', '3D'];
    }
  },

  methods: {
    getAsyncData: function getAsyncData() {
      if (this.url === 'SK_Club') {
        this.metaTitle = 'Join Our Movie Club';
        this.metaDescription = 'SK Club members enjoy Access Rewards such as exclusive invitations to pre-screenings and events, the SK Club lounge at Gateway and Eastgate, and pre-bookings for SK Club exclusive events. Join today!';
      }
      if (this.url === 'Discovery_Vitality') {
        this.metaTitle = 'Discovery Vitality Movie Discounts | Movie Loyalty Programmes';
        this.metaDescription = 'Discovery Vitality members, experience the latest movies at discounted prices when you activate your Vitality Ster-Kinekor movie benefit. Find out more and activate your Vitality Ster-Kinekor movie benefit today!';
      }
      if (this.url === 'Edgars_Club') {
        this.metaTitle = 'Edgars Club Movie Discounts | Movie Loyalty Programmes';
        this.metaDescription = 'Edgars Club Life and Club VIP Members receive exciting movie discounts. If you don\'t have an Edgars Club Card yet, get one at an Edgars store today or call 0800 20 39 25 to join. Find out more!';
      }
      this.$emit('updateHead');
    },
    getContent: function getContent() {
      var _this = this;

      this.loading = true;

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["l" /* PageService */].getGeneralPage("Movie_Cards", null), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovies(), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["l" /* PageService */].getCinemaPrices(null), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].isGuestUser(), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user()]).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 5),
            cards = _ref2[0],
            movies = _ref2[1],
            cinemaPrices = _ref2[2],
            guest = _ref2[3],
            user = _ref2[4];

        _this.page = cards[0].Movie_Cards[_this.url];
        _this.cinemas = cinemaPrices.data;
        _this.movies = movies.byRelease();
        _this.loading = false;
        _this.isGuest = guest;
        _this.user = user;

        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].nextTick(function () {
          if (_this.$route.hash) {
            window.scroll({ top: _this.$el.querySelector(_this.$route.hash).offsetTop, left: 0 });
          }
        });
      });
      this.getAsyncData();
    },
    selectCinemaType: function selectCinemaType(vitality, edgars, fullprice) {
      this.vitalityPrice = vitality;
      this.edgarsPrice = edgars;
      this.fullPrice = fullprice;
    },
    resendVerification: function resendVerification() {
      var _this2 = this;

      this.loadingResendActivation = true;
      __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].resendActivation().then(function () {
        _this2.loadingResendActivation = false;
      });
    }
  },

  created: function created() {
    this.getContent();
  },
  mounted: function mounted() {
    window.scroll({ top: 0, left: 0 });
  },


  watch: {
    '$route': function $route(to, from) {
      if (from.path != to.path && !to.hash) {
        this.url = to.params.card_name;
        this.getContent();
        this.getAsyncData();
      }
    },
    cinema_selected: function cinema_selected(e) {
      this.selectCinemaType(e['2d_vitality'], e['2d_edgars'], e['2d_full_price'], this.active2d = true, this.active3d = false);
    }
  }
});

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', {
    staticClass: "static-info--heading"
  }, [_vm._v("sk club and Movie Cards")]), _vm._v(" "), _c('h3', [_vm._v("Get the most out of all ster-kinekor movie benefits")])]), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Discovery_Vitality') ? [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("DISCOVERY VITALITY")]), _vm._v(" "), _c('p', [_vm._v("\n                    Experience the latest movies for half the price after activating your Vitality Ster-Kinekor movie benefit.\n                  ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "vitality-club-benefits",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "benefit",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('div', {
    staticClass: "sk-club__join"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_vm._v("\n                                    GET 50% OFF A 2D, "), _c('br'), _vm._v(" \n                                    A 3D AND A "), _c('br'), _vm._v(" \n                                    CINEMA NOUVEAU "), _c('br'), _vm._v("\n                                    TICKET.\n                                  ")])])])])], 1), _vm._v(" "), _c('sk-flex', {
    staticClass: "benefit",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('div', {
    staticClass: "sk-club__join"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_vm._v("\n                                    VITALITY KIDS BETWEEN "), _c('br'), _vm._v("\n                                    2 AND 18 YEARS OLD "), _c('br'), _vm._v("\n                                    CAN WATCH 2D AND 3D MOVIES \n                                    FOR FREE AT SELECTED \n                                    CINEMAS BEFORE 7PM.*\n                                  ")])])])])], 1), _vm._v(" "), _c('sk-flex', {
    staticClass: "benefit",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('div', {
    staticClass: "sk-club__join"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_vm._v("\n                                    GET 25% OFF CINE PRESTIGE, NT LIVE OR IMAX MOVIE TICKETS.\n                                  ")])])])])], 1)], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "vitality-club-benefits",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', [_vm._v("\n                    *Complete the Kids Vitality Health Review every 12 months to keep the Vitality Kids movie "), _c('br'), _vm._v("\n                    benefit. You can access the Kids Vitality Health Review assessment on the \"Know your "), _c('br'), _vm._v("\n                    Health\" page on "), _c('a', {
    attrs: {
      "href": "http://www.discovery.co.za",
      "target": "_blank"
    }
  }, [_vm._v("www.discovery.co.za")])]), _vm._v(" "), _c('p', [_vm._v("\n                    *Vitality Kids get 25% off Cine Prestige, NT Live or IMAX movie tickets.\n                  ")]), _vm._v(" "), _c('p', [_c('br'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tag": "a",
      "primary": "",
      "href": "https://www.discovery.co.za/discovery_coza/web/linked_content/pdfs/vitality/benefit_rules/ster_kinekor_benefit_guide.pdf",
      "target": "_blank"
    }
  }, [_vm._v("View the Vitality Movie Benefit Guide")])], 1)])], 1)], 1), _vm._v(" "), _c('sk-panel', {
    staticClass: "vitality-black-panel",
    attrs: {
      "black": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {}, [_vm._v("\n                    Get the Vitality Ster-Kinekor digital card and always have your movie card "), _c('br'), _vm._v("\n                    on your iPhone or Android smartphone.\n                  ")])])], 1)], 1), _vm._v(" "), _c('sk-panel', [_c('h3', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("HOW TO GET YOUR DIGITAL CARD")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.$breakpoints.xs || _vm.$breakpoints.sm || _vm.$breakpoints.md) ? [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [_c('ol', [_c('li', [_vm._v("Download the latest version of the Discovery app and activate the Vitality Ster-Kinekor movie benefit.")]), _vm._v(" "), _c('li', [_vm._v("Once you've activated the benefit, you can access your digital Vitality Ster-Kinekor movie card in the digital cards section on the main menu.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("IOS users")]), _vm._v(" can view their digital cards on the Apple Wallet app.\n                      ")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/vitality-phone.png"
    }
  })])] : [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [_c('ol', [_c('li', [_vm._v("Download the latest version of the Discovery app and activate the Vitality Ster-Kinekor movie benefit.")]), _vm._v(" "), _c('li', [_vm._v("Once you've activated the benefit, you can access your digital Vitality Ster-Kinekor movie card in the digital cards section on the main menu.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("IOS users")]), _vm._v(" can view their digital cards on the Apple Wallet app.\n                      ")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/vitality-phone.png"
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md1": ""
    }
  })]], 2)], 1), _vm._v(" "), _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.$route.path === '/club-loyalty/Discovery_Vitality') ? _c('h3', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Have a look at our vitality pricing guide")]) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Edgars_Club') ? _c('h3', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Have a look at our Edgars Club price list")]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "select-cinema"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a cinema")]), _vm._v(" "), (_vm.cinemas) ? _c('sk-combo-select', {
    staticClass: "cinema-select form-group",
    attrs: {
      "options": _vm.cinemas,
      "track-by": "cinema",
      "label": "cinema",
      "searchable": false,
      "placeholder": "Choose A Cinema",
      "multiple": false
    },
    model: {
      value: (_vm.cinema_selected),
      callback: function($$v) {
        _vm.cinema_selected = $$v
      },
      expression: "cinema_selected"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.cinema_selected != null) ? _c('div', {
    staticClass: "select-cinema-type"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a cinema type")]), _vm._v(" "), _c('div', {
    staticClass: "detail-experience"
  }, [_c('sk-list', [_c('sk-list-tile', [_c('sk-list-tile-action', [_c('span', {
    staticClass: "label label--large",
    class: _vm.active2d ? 'label--active' : '',
    on: {
      "click": function($event) {
        _vm.selectCinemaType(_vm.cinema_selected['2d_vitality'], _vm.cinema_selected['2d_edgars'], _vm.cinema_selected['2d_full_price'], _vm.active2d = true, _vm.active3d = false)
      }
    }
  }, [_vm._v("2D")])])], 1), _vm._v(" "), _c('sk-list-tile', [_c('sk-list-tile-action', [_c('span', {
    staticClass: "label label--large",
    class: _vm.active3d ? 'label--active' : '',
    on: {
      "click": function($event) {
        _vm.selectCinemaType(_vm.cinema_selected['3d_vitality'], _vm.cinema_selected['3d_edgars'], _vm.cinema_selected['3d_full_price'], _vm.active3d = true, _vm.active2d = false)
      }
    }
  }, [_vm._v("3D")])])], 1)], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs2": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "prices"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Prices")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "prices-box"
  }, [_c('span', [_vm._v("Full Price")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fullPrice))])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "prices-box card-name-block"
  }, [(_vm.$route.path == '/club-loyalty/Edgars_Club') ? [_c('span', [_vm._v("Edgars Price")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.edgarsPrice))])] : _vm._e(), _vm._v(" "), (_vm.$route.path == '/club-loyalty/Discovery_Vitality') ? [_c('span', [_vm._v("Vitality Price")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.vitalityPrice))])] : _vm._e()], 2)])], 1)], 1)])], 1), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Discovery_Vitality' && _vm.showOtherPricing) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Other pricing")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Cinema Nouveau")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_c('strong', [_vm._v("Full Price")])]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R80,00")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_c('strong', [_vm._v("Vitality")])]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R40,00")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item"
  }, [_vm._v("Opera")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("NT Live")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Prestige 2D/3D")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("IMAX 2D/3D")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R110,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R156,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R140,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R129,00")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R60,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R105,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R76,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R72,00")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("IMAX 3D Glasses")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Vitality Welcome Pack")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Vitality Replacement Pack")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Standard 3D Glasses (Adults)")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Standard 3D Glasses (Kids)")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R16,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R44,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R32,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R12,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R11,00")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "inline-block": "",
      "primary": "",
      "tag": "a",
      "href": "#discovery-form"
    }
  }, [_vm._v("Activate Discovery Vitality Now")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Edgars_Club' && _vm.showOtherPricing) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Other pricing")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Cinema Nouveau")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_c('strong', [_vm._v("Full Price")])]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R80,00")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_c('strong', [_vm._v("Edgars Club")])]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R40,00")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item"
  }, [_vm._v("Opera")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("NT Live")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Prestige 2D/3D")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("IMAX 2D/3D")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R110,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R156,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R140,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R129,00")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R68,50")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R118,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R86,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R86,00")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("IMAX 3D Glasses")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Standard 3D Glasses (Adults)")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Standard 3D Glasses (Kids)")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Edgars Activation")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R16,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R12,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R11,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R30,00")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "inline-block": "",
      "primary": "",
      "tag": "a",
      "href": "http://www.edgarsclub.co.za/benefits/do-more/ster-kinekor/",
      "target": "_blank"
    }
  }, [_vm._v("Visit Edgars Online To Find Out More")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('sk-signin')] : [(_vm.page.section_1) ? _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('h3', {
    staticClass: "static-info--sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "club-movie-cards"
  }, [_c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_1.body)
    }
  }), _vm._v(" "), (_vm.page.section_1.button_text) ? _c('div', {
    staticClass: "club-movie-cards__buttons"
  }, [(_vm.isGuest) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'user',
        params: {
          signInType: 'signup'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.page.section_1.button_text))]) : (_vm.user.MemberLevelId == '19') ? _c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": "/user/profile#join"
    }
  }, [_vm._v(_vm._s(_vm.page.section_1.button_text))]) : _c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'profile'
      }
    }
  }, [_vm._v("Dashboard")]), _vm._v(" "), (!_vm.isGuest) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "router": "",
      "loading": _vm.loadingResendActivation
    },
    on: {
      "native": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "click", undefined, $event.key)) { return null; }
        _vm.resendVerification()
      }
    }
  }, [_vm._v("Send Activation link")]) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [(_vm.page.section_1.image != undefined && _vm.page.section_1.image != null) ? [(_vm.page.section_1.image.url) ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.page.section_1.image.url
    }
  })]) : _vm._e()] : [(_vm.page.section_1.mobile_image != undefined && _vm.page.section_1.mobile_image != null) ? [(_vm.page.section_1.mobile_image.url) ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.page.section_1.mobile_image.url
    }
  })]) : _vm._e()] : _vm._e()]], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.page.section_2) ? _c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "featured-info"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_2.body)
    }
  })])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.page.section_3) ? _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('h3', {
    staticClass: "static-info--sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_3.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "club-movie-cards"
  }, [_c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_3.body)
    }
  }), _vm._v(" "), (_vm.page.section_3.button_text) ? _c('div', {
    staticClass: "club-movie-cards__buttons"
  }, [_c('sk-button', {
    attrs: {
      "block": _vm.$breakpoints.xs,
      "tertiary": "",
      "tag": "a",
      "target": _vm.$route.path === '/club-loyalty/Edgars_Club' ? '_blank' : '',
      "href": _vm.page.section_3.button_link
    }
  }, [_vm._v(_vm._s(_vm.page.section_3.button_text))]), _vm._v(" "), (_vm.page.section_3.additional_button_text) ? _c('sk-button', {
    attrs: {
      "block": _vm.$breakpoints.xs,
      "primary": "",
      "tag": "a",
      "href": _vm.page.section_3.additional_button_link
    }
  }, [_vm._v(_vm._s(_vm.page.section_3.additional_button_text))]) : _vm._e()], 1) : _vm._e()])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.page.section_4) ? _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "static-info--sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_4.heading)
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content "
  }, [(_vm.page.section_5.image.url) ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.page.section_5.image.url
    }
  })]) : _vm._e(), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_5.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_5.body)
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content "
  }, [(_vm.page.section_6.image.url) ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.page.section_6.image.url
    }
  })]) : _vm._e(), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_6.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_6.body)
    }
  })])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/club-loyalty/SK_Club') ? _c('div', [_c('div', {
    staticClass: "sk-club__section"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__join"
  }, [_c('h3', [_vm._v("Join For Free")]), _vm._v(" "), _c('h2', {
    staticClass: "h1"
  }, [_vm._v("200 Points")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "inline-block": "",
      "tertiary": "",
      "router": "",
      "to": {
        path: '/user/signup'
      }
    }
  }, [_vm._v("Join Now")])], 1)])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__special-treatment"
  }, [_c('h2', [_vm._v("Get special treatment")]), _vm._v(" "), _c('p', [_vm._v("SK Club members enjoy "), _c('strong', [_vm._v("Access Rewards")]), _vm._v(" such as exclusive invitations to pre-screenings and events, the SK Club lounge at Gateway and Eastgate, and pre-bookings for SK Club exclusive events.")])])])], 1)], 1), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": "10"
    }
  }), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/sk-club/half-price-tuesdays.png",
      "alt": "1/2 Price Tuesdays"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--title"
  }, [_vm._v("1/2 Price Tuesdays")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--sub-title"
  }, [_vm._v("Get 50% off any movie (excluding D-Box seats), all day on Tuesday")])])])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/sk-club/birthday-ticket.png",
      "alt": "Birthday Ticket"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--title"
  }, [_vm._v("Birthday Ticket")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--sub-title"
  }, [_vm._v("Get a free 2D / 3D ticket on your birthday (Valid for 7 Days)  "), _c('a', {
    attrs: {
      "href": "/content/legal/club-terms-and-conditions"
    }
  }, [_vm._v("T&C apply")])])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-club__section sk-club__points"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "sk-club__points--heading"
  }, [_vm._v("How to burn and earn points")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('sk-panel', [_c('div', {
    staticClass: "sk-club__points-burn"
  }, [_c('h3', {
    staticClass: "sk-club__points--heading"
  }, [_vm._v("Burn Points")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__points-wrapper"
  }, [_c('div', {
    staticClass: "sk-club__points-icon"
  }, [_c('sk-icon', {
    attrs: {
      "popcorn": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-copy"
  }, [_c('h5', {
    staticClass: "sk-club__points--title"
  }, [_vm._v("400 Points")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points--sub-title"
  }, [_vm._v("Free Regular Popcorn")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-wrapper"
  }, [_c('div', {
    staticClass: "sk-club__points-icon"
  }, [_c('sk-icon', {
    attrs: {
      "combo": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-copy"
  }, [_c('h5', {
    staticClass: "sk-club__points--title"
  }, [_vm._v("800 Points")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points--sub-title"
  }, [_vm._v("Free Regular Combo")])])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__points-wrapper"
  }, [_c('div', {
    staticClass: "sk-club__points-icon"
  }, [_c('sk-icon', {
    attrs: {
      "free-movieticket": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-copy"
  }, [_c('h5', {
    staticClass: "sk-club__points--title"
  }, [_vm._v("1000 Points")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points--sub-title"
  }, [_vm._v("Free Movie Ticket")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-wrapper"
  }, [_c('div', {
    staticClass: "sk-club__points-icon"
  }, [_c('sk-icon', {
    attrs: {
      "prestige-movieticket": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-copy"
  }, [_c('h5', {
    staticClass: "sk-club__points--title"
  }, [_vm._v("1500 Points")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points--sub-title"
  }, [_vm._v("Free Cine Prestige Movie Ticket")])])])])], 1)], 1)])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('sk-panel', [_c('div', {
    staticClass: "sk-club__points-earn"
  }, [_c('h3', {
    staticClass: "sk-club__points--heading"
  }, [_vm._v("Earn Points")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-wrapper"
  }, [_c('div', {
    staticClass: "sk-club__points-copy"
  }, [_c('div', {
    staticClass: "h1 sk-club__points--title"
  }, [_vm._v("100")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points--sub-title"
  }, [_c('div', [_c('strong', [_vm._v("Points")]), _vm._v(" per Movie Booked")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Points")]), _vm._v(" per Regular Combo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-wrapper"
  }, [_c('div', {
    staticClass: "sk-club__points-copy"
  }, [_c('div', {
    staticClass: "h1 sk-club__points--title"
  }, [_vm._v("200")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points--sub-title"
  }, [_c('div', [_c('strong', [_vm._v("Points")]), _vm._v(" per Must See Movie booked")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Points")]), _vm._v(" per Cine Prestige ticket bought")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Points")]), _vm._v(" per Double Take (sharing) combo")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Points")]), _vm._v(" per DBox Ticket bought")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-wrapper"
  }, [_c('div', {
    staticClass: "sk-club__points-copy"
  }, [_c('div', {
    staticClass: "h1 sk-club__points--title"
  }, [_vm._v("2X")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points--sub-title"
  }, [_c('div', [_c('strong', [_vm._v("Double your points")]), _vm._v(" each Thursday for each movie booked")])])])])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-club__section sk-club__join-steps"
  }, [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('h2', {
    staticClass: "h1 sk-club__join-steps-heading"
  }, [_vm._v("JOIN NOW! IT'S FREE!")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('h5', {
    staticClass: "sk-club__join-steps-heading"
  }, [_vm._v("Join the SK Club online")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Create a profile and join SK Club")]), _vm._v(" "), _c('li', [_vm._v("Click on the activation link")]), _vm._v(" "), _c('li', [_vm._v("Go to your dashboard")]), _vm._v(" "), _c('li', [_vm._v("Link your card")])]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__join-steps--btns"
  }, [_c('sk-button', {
    staticClass: "sk-club__join-steps-btn",
    attrs: {
      "primary": "",
      "router": "",
      "to": _vm.isGuest ? {
        name: 'user',
        params: {
          signInType: 'signup'
        }
      } : {
        name: 'profile'
      }
    }
  }, [_vm._v("Join now")])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-club__section"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/sk-club/kids.png",
      "alt": "Kids"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--title"
  }, [_vm._v("Kids")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--sub-title"
  }, [_vm._v("\n                          Enjoy a bespoke birthday party experience at any Ster-Kinekor Theatre. "), _c('a', {
    attrs: {
      "href": "mailto:leads@sterkinekor.com"
    }
  }, [_vm._v("Enquire here")])])])])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/sk-club/over-60.png",
      "alt": "Over 60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--title"
  }, [_vm._v("Over 60")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--sub-title"
  }, [_vm._v("22% Off Every Day")])])])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/sk-club/vip.png",
      "alt": "VIP"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--title"
  }, [_vm._v("VIP")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--sub-title"
  }, [_vm._v("As an SK Club VIP member you get to enjoy exclusive SK CLUB screenings & events, as well as exclusive advanced bookings.")])])])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Discovery_Vitality') ? _c('div', {
    attrs: {
      "id": "discovery-form",
      "data-jump-link-target": ""
    }
  }, [_c('sk-discovery-vitality')], 1) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Discovery_Vitality' || _vm.$route.path === '/club-loyalty/Edgars_Club') ? _c('div', [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.$route.path === '/club-loyalty/Discovery_Vitality') ? _c('h3', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Have a look at our vitality pricing guide")]) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Edgars_Club') ? _c('h3', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Have a look at our Edgars Club price list")]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "select-cinema"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a cinema")]), _vm._v(" "), (_vm.cinemas) ? _c('sk-combo-select', {
    staticClass: "cinema-select form-group",
    attrs: {
      "options": _vm.cinemas,
      "track-by": "cinema",
      "label": "cinema",
      "searchable": false,
      "placeholder": "Choose A Cinema",
      "multiple": false
    },
    model: {
      value: (_vm.cinema_selected),
      callback: function($$v) {
        _vm.cinema_selected = $$v
      },
      expression: "cinema_selected"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.cinema_selected != null) ? _c('div', {
    staticClass: "select-cinema-type"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a cinema type")]), _vm._v(" "), _c('div', {
    staticClass: "detail-experience"
  }, [_c('sk-list', [_c('sk-list-tile', [_c('sk-list-tile-action', [_c('span', {
    staticClass: "label label--large",
    class: _vm.active2d ? 'label--active' : '',
    on: {
      "click": function($event) {
        _vm.selectCinemaType(_vm.cinema_selected['2d_vitality'], _vm.cinema_selected['2d_edgars'], _vm.cinema_selected['2d_full_price'], _vm.active2d = true, _vm.active3d = false)
      }
    }
  }, [_vm._v("2D")])])], 1), _vm._v(" "), _c('sk-list-tile', [_c('sk-list-tile-action', [_c('span', {
    staticClass: "label label--large",
    class: _vm.active3d ? 'label--active' : '',
    on: {
      "click": function($event) {
        _vm.selectCinemaType(_vm.cinema_selected['3d_vitality'], _vm.cinema_selected['3d_edgars'], _vm.cinema_selected['3d_full_price'], _vm.active3d = true, _vm.active2d = false)
      }
    }
  }, [_vm._v("3D")])])], 1)], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs2": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "prices"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Prices")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "prices-box"
  }, [_c('span', [_vm._v("Full Price")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fullPrice))])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "prices-box card-name-block"
  }, [(_vm.$route.path == '/club-loyalty/Edgars_Club') ? [_c('span', [_vm._v("Edgars Price")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.edgarsPrice))])] : _vm._e(), _vm._v(" "), (_vm.$route.path == '/club-loyalty/Discovery_Vitality') ? [_c('span', [_vm._v("Vitality Price")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.vitalityPrice))])] : _vm._e()], 2)])], 1)], 1)])], 1), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Discovery_Vitality' && _vm.showOtherPricing) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Other pricing")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Cinema Nouveau")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_c('strong', [_vm._v("Full Price")])]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R80,00")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_c('strong', [_vm._v("Vitality")])]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R40,00")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item"
  }, [_vm._v("Opera")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("NT Live")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Prestige 2D/3D")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("IMAX 2D/3D")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R110,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R156,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R140,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R129,00")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R60,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R105,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R76,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R72,00")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("IMAX 3D Glasses")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Vitality Welcome Pack")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Vitality Replacement Pack")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Standard 3D Glasses (Adults)")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Standard 3D Glasses (Kids)")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R16,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R44,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R32,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R12,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R11,00")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "inline-block": "",
      "primary": "",
      "tag": "a",
      "href": "#discovery-form"
    }
  }, [_vm._v("Activate Discovery Vitality Now")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Edgars_Club' && _vm.showOtherPricing) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Other pricing")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Cinema Nouveau")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_c('strong', [_vm._v("Full Price")])]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R80,00")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_c('strong', [_vm._v("Edgars Club")])]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R40,00")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item"
  }, [_vm._v("Opera")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("NT Live")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Prestige 2D/3D")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("IMAX 2D/3D")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R110,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R156,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R140,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R129,00")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R68,50")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R118,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R86,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R86,00")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("IMAX 3D Glasses")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Standard 3D Glasses (Adults)")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Standard 3D Glasses (Kids)")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Edgars Activation")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R16,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R12,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R11,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R30,00")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "inline-block": "",
      "primary": "",
      "tag": "a",
      "href": "http://www.edgarsclub.co.za/benefits/do-more/ster-kinekor/",
      "target": "_blank"
    }
  }, [_vm._v("Visit Edgars Online To Find Out More")])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('sk-signin'), _vm._v(" "), (_vm.movies.now_showing.length > 0) ? [(_vm.movies.now_showing) ? _c('sk-related-movies', {
    attrs: {
      "limit": "6",
      "label": "Now Showing",
      "movies": _vm.movies.now_showing
    }
  }) : _vm._e()] : _vm._e()]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(608),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_meta_data_js__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'club-loyalty',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_meta_data_js__["a" /* default */]],

  data: function data() {
    return {
      article: [],
      loading: true,
      user: {},
      isGuest: true,
      loadingResendActivation: false
    };
  },


  methods: {
    getContent: function getContent() {
      var _this = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["l" /* PageService */].getGeneralPage("Movie_Cards"), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user(), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].isGuestUser()]).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
            article = _ref2[0],
            user = _ref2[1],
            guest = _ref2[2];

        _this.user = user;
        _this.article = article;
        _this.loading = false;
        _this.isGuest = guest;
      });
    },
    resendVerification: function resendVerification() {
      var _this2 = this;

      this.loadingResendActivation = true;
      __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].resendActivation().then(function () {
        _this2.loadingResendActivation = false;
      });
    }
  },

  created: function created() {
    this.getContent();
    this.metaTitle = 'Join our Movie Club | Enjoy Discount Movie Tickets ';
    this.metaDescription = 'Want to watch more movies more often? SK CLUB rolls out the red carpet for those that love to experience movies the best way possible! As a SK CLUB member you unlock Value Rewards, Points Rewards and Access Rewards.';
    this.metaImage = '/static/img/sk-logo.png';
  },
  mounted: function mounted() {
    window.scroll({ top: 0, left: 0 });
    if (window.__PRERENDER_INJECTED) {
      this.loading = false;
      this.prerender = true;

      if (window.__PRERENDER_INJECTED.movie_cards) {

        var movie_cards = window.__PRERENDER_INJECTED.movie_cards;
        this.article = movie_cards;

        this.metaTitle = 'Join our Movie Club | Enjoy Discount Movie Tickets ';
        this.metaDescription = 'Want to watch more movies more often? SK CLUB rolls out the red carpet for those that love to experience movies the best way possible! As a SK CLUB member you unlock Value Rewards, Points Rewards and Access Rewards.';
        this.metaImage = '/static/img/sk-logo.png';
      }
    }
  }
});

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', {
    staticClass: "static-info--heading"
  }, [_vm._v("sk club and Movie Cards")]), _vm._v(" "), _c('h3', [_vm._v("Get the most out of all ster-kinekor movie benefits")])]), _vm._v(" "), _vm._l((_vm.article), function(article) {
    return _c('div', [_c('sk-panel', [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('h2', {
      staticClass: "static-info--sub-heading",
      domProps: {
        "innerHTML": _vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_1.heading)
      }
    })])], 1), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (article.Movie_Cards.Club_and_Movie_Cards.section_1.image.url),
        expression: "article.Movie_Cards.Club_and_Movie_Cards.section_1.image.url"
      }],
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": article.Movie_Cards.Club_and_Movie_Cards.section_1.image.url
      }
    })])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "md8": ""
      }
    }, [_c('div', {
      staticClass: "club-movie-cards"
    }, [_c('div', {
      staticClass: "article__content",
      domProps: {
        "innerHTML": _vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_1.body)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "club-movie-cards__buttons"
    }, [_c('sk-button', {
      attrs: {
        "tertiary": "",
        "router": "",
        "to": {
          name: 'SK Club & loyalty Info',
          params: {
            card_name: 'SK_Club'
          }
        }
      }
    }, [_vm._v(_vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_1.button_text))]), _vm._v(" "), (_vm.isGuest) ? _c('sk-button', {
      attrs: {
        "primary": "",
        "router": "",
        "to": {
          name: 'user',
          params: {
            signInType: 'signup'
          }
        }
      }
    }, [_vm._v(_vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_1.additional_button_text))]) : (_vm.user.MemberLevelId == '19') ? _c('sk-button', {
      attrs: {
        "primary": "",
        "router": "",
        "to": "/user/profile#join"
      }
    }, [_vm._v(_vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_1.additional_button_text))]) : _c('sk-button', {
      attrs: {
        "primary": "",
        "router": "",
        "to": {
          name: 'profile'
        }
      }
    }, [_vm._v("Dashboard")]), _vm._v(" "), _c('sk-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isGuest),
        expression: "!isGuest"
      }],
      attrs: {
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.resendVerification(_vm.CardNumber);
        }
      }
    }, [_vm._v("\n                                        Send Activation link\n                                    ")])], 1)])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs6": "",
        "md4": ""
      }
    }, [_c('div', {
      staticClass: "movie-card"
    }, [_c('h4', [_vm._v("\n                                 Kids\n                              ")]), _vm._v(" "), _c('div', {
      staticClass: "movie-card--image"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/sk-club/kids.png",
        "alt": "Kids"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "movie-card--description"
    }, [_vm._v("\n                                  Enjoy a bespoke birthday party experience at any Ster-Kinekor Theatre. "), _c('a', {
      attrs: {
        "href": "mailto:leads@sterkinekor.com"
      }
    }, [_vm._v("Enquire here")])])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "md4": ""
      }
    }, [_c('div', {
      staticClass: "movie-card"
    }, [_c('h4', [_vm._v("\n                                 OVER 60\n                              ")]), _vm._v(" "), _c('div', {
      staticClass: "movie-card--image"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/sk-club/over-60.png",
        "alt": "Over 60"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "movie-card--description"
    }, [_vm._v("\n                                Seniors enjoy 22% discount on all ticket types except Tuesday for Half Price Tuesdays. Seniors also receive access to exclusive SK CLUB screenings and the SK Club Lounge.\n                              ")])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "md4": ""
      }
    }, [_c('div', {
      staticClass: "movie-card"
    }, [_c('h4', [_vm._v("\n                                 VIP\n                              ")]), _vm._v(" "), _c('div', {
      staticClass: "movie-card--image"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/sk-club/vip.png",
        "alt": "VIP"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "movie-card--description"
    }, [_vm._v("\n                                As an SK Club VIP member you get to enjoy exclusive SK CLUB screenings & events, as well as exclusive advanced bookings.\n                              ")])])])], 1)], 1), _vm._v(" "), _c('sk-panel', [_c('h2', [_vm._v("SK SUBSCRIPTION CLUB")]), _vm._v(" "), _c('sk-layout', {
      staticClass: "subs-club-header",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-club-cards.png",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('div', {
      staticClass: "club-movie-cards"
    }, [_c('div', {
      staticClass: "article__content"
    }, [_c('p', [_vm._v("Watch more movies, for less!")]), _vm._v(" "), _c('p', [_vm._v("\n                                        As a SK Subscription Club member, you can get a subscription for a Limited or Unlimited \n                                        amount of movies per month at a set cost, which you pay per month. This means \n                                        you can now watch more movies at a lower price, whilst also enjoying the benefits \n                                        of the SK Club\n                                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('sk-button', {
      attrs: {
        "primary": "",
        "tag": "a",
        "href": "/subscription-club"
      }
    }, [_vm._v("VIEW PRICING OPTIONS")])], 1)])])], 1)], 1), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('sk-panel', [_c('div', {
      staticClass: "club-movie-cards"
    }, [_c('h3', {
      staticClass: "club-movie-cards__heading",
      domProps: {
        "innerHTML": _vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_2.heading)
      }
    }), _vm._v(" "), (article.Movie_Cards.Club_and_Movie_Cards.section_2.image.url) ? _c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": "/static/img/digital-discovery-card.png"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "club-movie-cards__wrapper"
    }, [_c('div', {
      staticClass: "article__content",
      domProps: {
        "innerHTML": _vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_2.body)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "club-movie-cards__buttons"
    }, [_c('sk-button', {
      attrs: {
        "tertiary": "",
        "router": "",
        "to": {
          name: 'SK Club & loyalty Info',
          params: {
            card_name: 'Discovery_Vitality'
          }
        }
      }
    }, [_vm._v(_vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_2.button_text))])], 1)])])], 1), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('sk-panel', [_c('div', {
      staticClass: "club-movie-cards"
    }, [_c('h3', {
      staticClass: "club-movie-cards__heading",
      domProps: {
        "innerHTML": _vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_3.heading)
      }
    }), _vm._v(" "), (article.Movie_Cards.Club_and_Movie_Cards.section_3.image.url) ? _c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": article.Movie_Cards.Club_and_Movie_Cards.section_3.image.url
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "club-movie-cards__wrapper"
    }, [_c('div', {
      staticClass: "article__content",
      domProps: {
        "innerHTML": _vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_3.body)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "club-movie-cards__buttons"
    }, [_c('sk-button', {
      attrs: {
        "tertiary": "",
        "router": "",
        "to": {
          name: 'SK Club & loyalty Info',
          params: {
            card_name: 'Edgars_Club'
          }
        }
      }
    }, [_vm._v(_vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_3.button_text))])], 1)])])], 1), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('sk-panel', [_c('div', {
      staticClass: "club-movie-cards"
    }, [_c('h3', {
      staticClass: "club-movie-cards__heading",
      domProps: {
        "innerHTML": _vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_4.heading)
      }
    }), _vm._v(" "), (article.Movie_Cards.Club_and_Movie_Cards.section_4.image.url) ? _c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": article.Movie_Cards.Club_and_Movie_Cards.section_4.image.url
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "club-movie-cards__wrapper"
    }, [_c('div', {
      staticClass: "article__content",
      domProps: {
        "innerHTML": _vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_4.body)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "club-movie-cards__buttons"
    }, [_c('sk-button', {
      attrs: {
        "tertiary": "",
        "tag": "a",
        "href": article.Movie_Cards.Club_and_Movie_Cards.section_4.button_link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(article.Movie_Cards.Club_and_Movie_Cards.section_4.button_text))])], 1)])])], 1)], 1)], 1)
  })], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(610),
  /* template */
  __webpack_require__(675),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_sections__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_meta_data_js__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'content_page',
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_meta_data_js__["a" /* default */]],
    data: function data() {
        return {
            loading: true,
            page: undefined,
            tabIndex: this.$route.params.content_url_two
        };
    },

    computed: {
        title: function title() {
            return this.page.page_title;
        },
        activeTab: function activeTab() {
            var _this = this;

            return this.page && this.page.tabs ? this.page.tabs.find(function (t) {
                return _this.isActiveTab(t);
            }) : {};
        }
    },
    components: { ContentSection: __WEBPACK_IMPORTED_MODULE_1__content_sections__["a" /* default */] },

    methods: {
        getAsyncData: function getAsyncData() {
            this.metaTitle = this.activeTab.og_title || '';
            this.metaImage = this.activeTab.og_image || '';
            this.metaDescription = this.activeTab.og_description || '';
            this.$emit('updateHead');
        },
        setTab: function setTab(tab) {
            var tab_url = this.getTabUrl(tab);
            this.tabIndex = tab_url;
            this.$router.push({ params: { content_url_two: tab_url } });
        },
        getTabUrl: function getTabUrl(tab) {
            return tab.route ? tab.route.replace('/', '') : tab.page_title.toLowerCase().replace(new RegExp(' ', 'g'), '-');
        },
        isActiveTab: function isActiveTab(tab) {
            if (this.tabIndex === this.getTabUrl(tab)) {
                if (tab.page_title != undefined) {
                    if (tab.page_title == "Profile Payments") {
                        this.schemaDataSrc = '{"@context": "https://schema.org","@type": "FAQPage","mainEntity": [{"@type": "Question","name": "CAN I MAKE A BOOKING ONLINE WITHOUT REGISTERING?","acceptedAnswer": {"@type": "Answer","text": "<p>Most unopened items in new condition and returned within <strong>90 days</strong> will receive a refund or exchange. Some items have a modified return policy noted on the receipt or packing slip. Items that are opened or damaged or do not have a receipt may be denied a refund or exchange. Items purchased online or in-store may be returned to any store.</p><p>Online purchases may be returned via a major parcel carrier. <a href=http://example.com/returns> Click here </a> to initiate a return.</p>"}}, {"@type": "Question","name": "HOW DO I REGISTER OR CREATE AN ONLINE PROFILE ON THE WEBSITE?","acceptedAnswer": {"@type": "Answer","text": "To register/create a profile, you can either Register using the Facebook option on our site. This will auto-populate basic details such as your name, surname, and email address, which also help speed up your registration process. Note, this will only work if you have a Facebook account and are logged in. The alternative option is to fill in our short registration form which requires you to provide details such as name, surname, email address, mobile number, etc. You will also be required to create your own password. "}}, {"@type": "Question","name": "CAN I ADD AND STORE MY LOYALTY AND CLUB CARDS ONLINE?","acceptedAnswer": {"@type": "Answer","text": "<p>Yes, if you already own a SK Club card and/or loyalty card such as the Edgars Movie card and/or Discovery Vitality Movie cards, and are registered on our site, you need to login, then click through to your profile. Your profile page allows you to either link or activate your SK Club and loyalty cards. Just look for each card image and select the appropriate (link) button that corresponds with your club or loyalty card. </p>"}}, {"@type": "Question","name": "ARE MY PAYMENT DETAILS SECURE AND CONFIDENTIAL?","acceptedAnswer": {"@type": "Answer","text": "Your payment details remain confidential. We take certain details on payments of tickets only to enable a secure transaction via your banking institution. We have employed the very latest security and encryption technology to protect you and your credit card. "}}, {"@type":"Question","name": "WILL I BE CHARGED A BOOKING FEE WHEN I BOOK ONLINE OR VIA THE APP?","acceptedAnswer": {"@type": "Answer ","text": "No, you will not be charged. All bookings made using our website (both using the desktop and mobile phone) and our mobile application do not carry a booking fee. "}}, {"@type": "Question","name": "HOW DO I SUBSCRIBE TO THE NEWSLETTER?","acceptedAnswer": {"@type": "Answer","text":"You don’t have to be a SK CLUB member; or even a Ster-Kinekor customer to get our newsletter.  Just visit www.sterkinekor.com and subscribe."}}]}';
                    }

                    if (tab.page_title == "SK Club") {
                        this.schemaDataSrc = '{"@context": "https://schema.org","@type": "FAQPage","mainEntity": [{"@type": "Question","name": "DO HALF-PRICE TUESDAYS STILL APPLY?","acceptedAnswer": {"@type": "Answer","text": "<p>Yes! Half-price Tuesdays are Exclusive to SK CLUB Members at Ster-Kinekor Theatres. Enjoy more movies more often. Remember to swipe your SK CLUB card when booking in order to pay only 50% of your movie ticket including IMAX & Cine Prestige, on a Tuesday.</p>"}}, {"@type": "Question","name": "HOW DO I JOIN THE LOYALTY CLUB?","acceptedAnswer": {"@type": "Answer","text": "</p>Join SK CLUB online via www.sterkinekor.com and complete the online application form. It is Free to join and you can collect your NEW SK CLUB card from your nearest SKT cinema at your earliest convenience.You can join the Movie Club at your nearest Ster-Kinekor cinema - for free. For every movie you see, you earn 100 points, and as soon as you have accumulated 1 000 points you qualify for a free movie ticket. On Tuesdays’ movie, SK club members pay half price for their movies. A validation e-mail will be sent to you after you have joined, on which you can confirm/update your details. If you follow the link and complete all three steps you will receive 200 bonus points on your card, and double points on Thursdays.</p>"}}, {"@type": "Question","name": "WHAT ARE THE SK CLUB BENEFITS?","acceptedAnswer": {"@type": "Answer","text": "<p>As an SK Club member, you can look forward to benefits such as earning Double points on Thursdays, earning points when you purchase catering items and more. View our SK Club benefits page for more details. </p>"}}, {"@type": "Question","name": "CAN I USE MY POINTS EARNED AT ANY CINEMA WITHIN ANY STER-KINEKOR OR CINEMA NOUVEAU OF MY CHOICE?","acceptedAnswer": {"@type": "Answer","text": "</p>You can redeem your 1000 points at any South African based SKT cinema for a 2D or 3D movie ticket as long as you have enough points to redeem for a free ticket, except for Prestige and IMAX - for these cinemas you need 1 500 points.</p>"}}]}';
                    }

                    if (tab.page_title == "Other Movie Cards") {
                        this.schemaDataSrc = '{"@context": "https://schema.org","@type": "FAQPage","mainEntity": [{"@type": "Question","name": "HOW DO I GET THE EDGARS CLUB STER-KINEKOR MOVIE BENEFIT?","acceptedAnswer": {"@type": "Answer","text": "<p>Edgars Club is open to all Edcon account holders Edgars Club has 3 options: Club Classic, Club Life and Club VIP The Ster-Kinekor movie benefit is part of the Life and VIP Clubs Edgars Club membership is R45.00 per month for Club VIP, R32.00 per month for Club Life and R26.00 per Month for Club Classic To subscribe to the movie benefit a once-off registration fee of R30 applies</p>"}}, {"@type": "Question","name": "HOW DO I GET THE DISCOVERY VITALITY - STER-KINEKOR MOVIE BENEFIT?","acceptedAnswer": {"@type": "Answer","text": "</p>Digital Card: Download the Discovery app onto your iPhone or Android smartphone and then log in to activate your Vitality Ster-Kinekor digital card for FREE. Children older than 13 can also get a digital card on the Passbook app on their iPhone or in the Discovery app on their Android smartphone. Physical Card: Pay a once-off activation fee of R42 for you and each dependent who wants a physical movie card. You must show your Vitality Ster-Kinekor membership card when you make a booking.</p>"}}, {"@type": "Question","name": "WHY DO I HAVE TO PRESENT MY DISCOVERY VITALITY MOVIE BENEFIT CARD WHEN I GO TO THE MOVIES?","acceptedAnswer": {"@type": "Answer","text": "<p>The Discovery Vitality movie benefit is exclusive to the individual member and in order to ensure that you are the member who is enjoying your benefit it is essential that we check your benefit card before you enter the cinema.</p>"}}, {"@type": "Question","name": "DO I GET THE DISCOVERY KIDS’ DISCOUNT IF I PURCHASE TICKETS ONLINE?","acceptedAnswer": {"@type": "Answer","text": "</p>Yes, if you have completed the Vitality Kids assessment and have a valid Vitality Kids Movie card, you can get the Vitality kid’s discount for bookings made online and as well at the cinema for movies in IMAX, Cine Prestige or after 19h00.</p>"}}]}';
                    }

                    if (tab.page_title == "Movies") {
                        this.schemaDataSrc = '{"@context": "https://schema.org","@type": "FAQPage","mainEntity": [{"@type": "Question","name": "HOW LONG WILL A PARTICULAR MOVIE PLAY AT A CERTAIN CINEMA?","acceptedAnswer": {"@type": "Answer","text": "<p>Before a particular movie is released, we have an extensive screening process to decide, based on current trends, which movies would be best-suited for which cinemas.</p>"}}, {"@type": "Question","name": "WHAT DO THE AGE RESTRICTION INDICATORS STAND FOR?","acceptedAnswer": {"@type": "Answer","text": "</p>S - Sex, L - Language, N - Nudity, V - Violence, P - Prejudice, M - Mature Accompaniment, D - Drug use, PG - Parental Guidance, TBA -  To Be Announced</p>"}}, {"@type": "Question","name": "WHAT IS CINEMA NOUVEAU?","acceptedAnswer": {"@type": "Answer","text": "<p>As a sub-division of Ster-Kinekor Theatres, Ster-Kinekor Cinema Nouveau operates 34 screens, 15 digital cinema houses and has almost 3 580 seats in 5 sites, spreading over Joburg, Cape Town and Durban. Cinema Nouveau holds the prestige of being one of the world’s only dedicated “art cinema” chains, screening ‘art’ titles from cultures all over the world.It is a differentiated cinema experience and a destination for the discerning film lover, whose passion is the beauty and artistry of the art of film.</p>"}}, {"@type": "Question","name": "WHERE CAN I ACCESS A SCHEDULE TO SEE WHAT IS SCREENING?","acceptedAnswer": {"@type": "Answer","text": "</p>There are various ways to do this: Your newspaper directory, On www.sterkinekor.com, Via your cellular telephone on our mobisite, Call our Call Centre on 086 166 8437, On our mobile application, available for Android or iOS users</p>"}}, {"@type": "Question","name": "IF A MOVIE IS AGE-RESTRICTED, WILL KIDS BE ALLOWED TO WATCH THE MOVIE WITH MY PERMISSION?","acceptedAnswer": {"@type": "Answer","text": "</p>No. The age restriction placed on movies will be strictly enforced. The age restrictions are set by the Film & Publications Board (FPB). Ster-Kinekor is obligated by law to adhere to these age restrictions.</p>"}}, {"@type": "Question","name": "WHAT CINEMA TYPES ARE AVAILABLE AT STER-KINEKOR","acceptedAnswer": {"@type": "Answer","text": "</p>2D: A \'two-dimensional\' or 2D image, projects height and width - but not depth - when used in reference to moving pictures or graphic image technology. These images are projected onto the big screen to fill the height and width, but without the depth perception of a 3D format. All the latest films screened at Ster-Kinekor\'s more than 470 large-scale digital screens are available in 2D format. 3D: A \'three-dimensional\' or 3D image that is projected onto the cinema screen displays height, width and the perception of depth. 3D imagery cannot be created without duplicating the effect of two eyes working in tandem, which allows three-dimensional perceptive effects such as depth perception. A 3D movie has two versions of every frame, each one from a slightly different angle, which mimics the way we see the world through our two eyes. This gives the illusion of three dimensions. Ster-Kinekor currently has the largest 3D footprint and features 140 state-of-the-art 3D screens at its 58 complexes across the country. To fully appreciate the impact and effect of a film\'s 3D images, 3D glasses are required to watch a film in 3D. Cine Prestige: Welcome to, what we call, the business class of cinema where luxury meets the magic of the big screen. Sit back and sink into a fully reclining, leather sofa which is big enough for you, me and Dupree! Select one of our gourmet snack platters and have it delivered to your seat whilst you escape into the latest blockbuster! To cap off the perfect movie experience, how about a choice of our finest desserts and coffee blends? Seats are limited and pre-booking is essential, so go on, select a movie and experience the exceptional with Ster-Kinekor’s Cine Prestige. MAX: Ster-Kinekor currently offers the immersive IMAX® cinema experience in bespoke IMAX® theatres at seven of its sites countrywide. Here, you get to enjoy the maximum movie experience, either in 2D or the larger-than-life, in-your-face IMAX 3D® Experience that makes you feel as if you are part of the action playing out on the massive ceiling-to-floor and wall-to-wall screen. With two 2K IMAX projectors and surround sound, IMAX theatres are defined by heart-pounding audio, awe-inspiring images and an overall immersive cinema experience. Every note of the soundtrack and every scuff of a shoe is clearer in IMAX, and all of this pristine sound is then pumped into a theatre that has been customised for an optimal experience. Clarity, detail and size make IMAX more than a movie. The remastering - or DMR - process fully transforms every frame of a film to produce the best possible version of a filmmaker\'s vision. I LOVE MOVIES. IMAX MOVIES. Nouveau: Nouveau is a division of Ster-Kinekor Theatres (South Africa’s largest cinema exhibitor) and operates 26 digital cinema houses with just under 3 000 seats. The four theatre sites are situated in Johannesburg, Pretoria, Cape Town and Durban. Nouveau holds the prestige of being one of the world’s only dedicated “art cinema” chains, screening independent, alternative and art cinema content from cultures across the globe, including film festivals, concerts and ‘live’ theatre, opera, art and ballet productions. Nouveau promises a unique and inspiring cinema experience - a destination for film lovers with a passion for and appreciation of the beauty and artistry of film. D-BOX: Ster-Kinekor is now offering the immersive and kinetic D-BOX cinema experience, at select cinemas in JHB, Durban & Cape Town. D-BOX is the hyper-realistic entertainment experience that moves the body and sparks the imagination through motion. With D-BOX, you control the intensity to move with the movie and feel every scene as if you were in it. Using extraordinary precision and hyper-realistic vibrations, D-BOX delivers a whole new level of immersive entertainment that connects you to the movie like never before. Because you control the intensity, you can move with the movie as if you were part of the action. By blurring the line between you and the screen, we create highly believable, one-of-a-kind movie-watching experiences that pull you into the story in ways you never thought imaginable. Don’t just watch a movie, live the action with D-BOX.</p>"}}]}';
                    }

                    if (tab.page_title == "Standard Bank") {
                        this.schemaDataSrc = '';
                    }

                    if (tab.page_title == "Call Centre") {
                        this.schemaDataSrc = '';
                    }
                }
                this.$emit('updateHead');
            }

            return this.tabIndex === this.getTabUrl(tab);
        },
        loadData: function loadData() {
            var _this2 = this;

            this.loading = true;
            var page = undefined;
            if (__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].hasPreviewContent('general_page')) {
                page = __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent('general_page');
                if (page.route === '/' + this.$route.params.content_url) {
                    this.page = page;
                    this.loading = false;
                    return;
                }
            }

            if (this.$route.params.content_url === __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewUrl()) {
                page = __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent();
                this.page = page;
                this.loading = false;
                return;
            }

            return __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getPage(this.$route.params.content_url).then(function (pageData) {
                _this2.page = pageData;

                if (page && _this2.page.tabs && _this2.page.tabs.length > 0 && !~_this2.page.tabs.indexOf(page)) {
                    _this2.page.tabs.unshift(page);
                }

                if (_this2.page.tabs && _this2.page.tabs.length > 0 && !_this2.activeTab) {
                    _this2.setTab(_this2.page.tabs[0]);
                }

                _this2.getAsyncData();
                _this2.loading = false;
            });
        }
    },

    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        next();
        if (to.params.content_url != from.params.content_url) {
            this.tabIndex = to.params.content_url_two;

            this.loadData();
        }
        this.getAsyncData();
    },
    created: function created() {
        this.loadData();
    },
    mounted: function mounted() {
        window.scroll({ top: 0, left: 0 });
    }
});

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(612),
  /* template */
  __webpack_require__(674),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(613);


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'content_sections',
    components: __WEBPACK_IMPORTED_MODULE_0____,
    props: {
        sections: { type: Array, required: true }
    },
    created: function created() {}
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__image_left_text_right_image_left_text_right_vue__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__image_left_text_right_image_left_text_right_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__image_left_text_right_image_left_text_right_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__image_right_text_left_image_right_text_left_vue__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__image_right_text_left_image_right_text_left_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__image_right_text_left_image_right_text_left_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__heading_heading_vue__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__heading_heading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__heading_heading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__centered_content_centered_content_vue__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__centered_content_centered_content_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__centered_content_centered_content_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__image_block_image_block_vue__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__image_block_image_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__image_block_image_block_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__text_block_text_block_vue__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__text_block_text_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__text_block_text_block_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__video_block_video_block_vue__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__video_block_video_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__video_block_video_block_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__step_block_step_block_vue__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__step_block_step_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__step_block_step_block_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__person_management_team_person_management_team_vue__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__person_management_team_person_management_team_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__person_management_team_person_management_team_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__person_management_team_block_person_management_team_block_vue__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__person_management_team_block_person_management_team_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__person_management_team_block_person_management_team_block_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__person_shareholders_person_shareholders_vue__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__person_shareholders_person_shareholders_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__person_shareholders_person_shareholders_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__person_shareholders_block_person_shareholders_block_vue__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__person_shareholders_block_person_shareholders_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__person_shareholders_block_person_shareholders_block_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__procurement_procurement_vue__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__procurement_procurement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__procurement_procurement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__related_movies_related_movies_vue__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__related_movies_related_movies_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__related_movies_related_movies_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__link_banner_link_banner_vue__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__link_banner_link_banner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__link_banner_link_banner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__partners_block_partners_block_vue__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__partners_block_partners_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__partners_block_partners_block_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__accolades_block_accolades_block_vue__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__accolades_block_accolades_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__accolades_block_accolades_block_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__image_full_width_image_full_width_vue__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__image_full_width_image_full_width_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__image_full_width_image_full_width_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__two_column_text_block_two_column_text_block_vue__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__two_column_text_block_two_column_text_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__two_column_text_block_two_column_text_block_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__sign_in_banner_sign_in_banner_vue__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__sign_in_banner_sign_in_banner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__sign_in_banner_sign_in_banner_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "image_left_text_right", function() { return __WEBPACK_IMPORTED_MODULE_0__image_left_text_right_image_left_text_right_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "image_right_text_left", function() { return __WEBPACK_IMPORTED_MODULE_1__image_right_text_left_image_right_text_left_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "image_full_width", function() { return __WEBPACK_IMPORTED_MODULE_17__image_full_width_image_full_width_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "person_management_team", function() { return __WEBPACK_IMPORTED_MODULE_8__person_management_team_person_management_team_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "person_management_team_block", function() { return __WEBPACK_IMPORTED_MODULE_9__person_management_team_block_person_management_team_block_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "two_column_text_block", function() { return __WEBPACK_IMPORTED_MODULE_18__two_column_text_block_two_column_text_block_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "person_shareholders_block", function() { return __WEBPACK_IMPORTED_MODULE_11__person_shareholders_block_person_shareholders_block_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "person_shareholders", function() { return __WEBPACK_IMPORTED_MODULE_10__person_shareholders_person_shareholders_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "centered_content", function() { return __WEBPACK_IMPORTED_MODULE_3__centered_content_centered_content_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "related_movies", function() { return __WEBPACK_IMPORTED_MODULE_13__related_movies_related_movies_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "partners_block", function() { return __WEBPACK_IMPORTED_MODULE_15__partners_block_partners_block_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "accolades_block", function() { return __WEBPACK_IMPORTED_MODULE_16__accolades_block_accolades_block_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "image_block", function() { return __WEBPACK_IMPORTED_MODULE_4__image_block_image_block_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "video_block", function() { return __WEBPACK_IMPORTED_MODULE_6__video_block_video_block_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "step_block", function() { return __WEBPACK_IMPORTED_MODULE_7__step_block_step_block_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "text_block", function() { return __WEBPACK_IMPORTED_MODULE_5__text_block_text_block_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "procurement", function() { return __WEBPACK_IMPORTED_MODULE_12__procurement_procurement_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "link_banner", function() { return __WEBPACK_IMPORTED_MODULE_14__link_banner_link_banner_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return __WEBPACK_IMPORTED_MODULE_2__heading_heading_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "sign_in_banner", function() { return __WEBPACK_IMPORTED_MODULE_19__sign_in_banner_sign_in_banner_vue___default.a; });























/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(615),
  /* template */
  __webpack_require__(616),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'image_left_text_right',
    props: {
        section: Object
    }
});

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.section.image.url) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.section.image.url
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.section.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__buttons"
  }, [((_vm.section.button_link || (_vm.section.file_link && _vm.section.file_link.url)) && _vm.section.button_text) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.section.button_link || _vm.section.file_link.url
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.section.button_text) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": "10"
    }
  }), _vm._v(" "), ((_vm.section.additional_button_link || (_vm.section.file_link_2 && _vm.section.file_link_2.url)) && _vm.section.additional_button_text) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "tag": "a",
      "href": _vm.section.additional_button_link || _vm.section.file_link_2.url
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.section.additional_button_text) + "\n                ")]) : _vm._e()], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(618),
  /* template */
  __webpack_require__(619),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'image_left_text_right',
    props: {
        section: Object
    }
});

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.section.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__buttons"
  }, [((_vm.section.button_link || (_vm.section.file_link && _vm.section.file_link.url)) && _vm.section.button_text) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.section.button_link || _vm.section.file_link.url
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.section.button_text) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": "10"
    }
  }), _vm._v(" "), ((_vm.section.additional_button_link || (_vm.section.file_link_2 && _vm.section.file_link_2.url)) && _vm.section.additional_button_text) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "tag": "a",
      "href": _vm.section.additional_button_link || _vm.section.file_link_2.url
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.section.additional_button_text) + "\n                ")]) : _vm._e()], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.section.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.section.image.url
    }
  })]) : _vm._e()])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(621),
  /* template */
  __webpack_require__(622),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'content_heading',
    props: {
        section: Object,
        first: Boolean
    }
});

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.first) ? _c('hr') : _vm._e(), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs7": "",
      "sm8": ""
    }
  }, [_c('h2', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v(_vm._s(_vm.section.heading))]), _vm._v(" "), (_vm.section.body) ? _c('p', {
    staticClass: "static-info--sub-teaser",
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  }) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs5": "",
      "sm4": "",
      "text-right": ""
    }
  }, [((_vm.section.button_link || (_vm.section.file_link && _vm.section.file_link.url)) && _vm.section.button_text) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "inline-block": "",
      "tag": "a",
      "href": _vm.section.button_link || _vm.section.file_link.url
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.section.button_text) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": "10"
    }
  }), _vm._v(" "), ((_vm.section.additional_button_link || (_vm.section.file_link_2 && _vm.section.file_link_2.url)) && _vm.section.additional_button_text) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "inline-block": "",
      "tag": "a",
      "href": _vm.section.additional_button_link || _vm.section.file_link_2.url
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.section.additional_button_text) + "\n                ")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(624),
  /* template */
  __webpack_require__(625),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'centered_content',
    props: {
        section: Object,
        first: Boolean
    }
});

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.first) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.section.heading || _vm.section.body) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "featured-content-heading"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.section.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  })])])], 1) : _vm._e(), _vm._v(" "), ((_vm.section.button_link && _vm.section.button_text) || (_vm.section.additional_button_link && _vm.section.additional_button_text)) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "featured-donate-button"
  }, [((_vm.section.button_link || (_vm.section.file_link && _vm.section.file_link.url)) && _vm.section.button_text) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.section.button_link || _vm.section.file_link.url
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.section.button_text) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": "10"
    }
  }), _vm._v(" "), ((_vm.section.additional_button_link || (_vm.section.file_link_2 && _vm.section.file_link_2.url)) && _vm.section.additional_button_text) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "tag": "a",
      "href": _vm.section.additional_button_link || _vm.section.file_link_2.url
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.section.additional_button_text) + "\n                ")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(627),
  /* template */
  __webpack_require__(628),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'content_image_block',
    props: {
        section: Object
    }
});

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content article__our-partners"
  }, [(_vm.section.image) ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.section.image.url
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.section.heading) ? _c('h6', {
    domProps: {
      "innerHTML": _vm._s(_vm.section.heading)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section.body) ? _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(630),
  /* template */
  __webpack_require__(631),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'text_block',
    props: {
        section: Object,
        first: Boolean
    }
});

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.first) ? _c('hr') : _vm._e(), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "article__content",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [(_vm.section.heading) ? _c('h3', [_vm._v(_vm._s(_vm.section.heading))]) : _vm._e(), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  }), _vm._v(" "), ((_vm.section.button_link || (_vm.section.file_link && _vm.section.file_link.url)) && _vm.section.button_text) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "inline-block": "",
      "tag": "a",
      "href": _vm.section.button_link || _vm.section.file_link.url
    }
  }, [_vm._v("\n            " + _vm._s(_vm.section.button_text) + "\n        ")]) : _vm._e(), _vm._v(" "), ((_vm.section.additional_button_link || (_vm.section.file_link_2 && _vm.section.file_link_2.url)) && _vm.section.additional_button_text) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "inline-block": "",
      "tag": "a",
      "href": _vm.section.additional_button_link || _vm.section.file_link_2.url
    }
  }, [_vm._v("\n            " + _vm._s(_vm.section.additional_button_text) + "\n        ")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(633),
  /* template */
  __webpack_require__(634),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'content_video_block',
    props: {
        section: Object,
        first: Boolean
    }
});

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.first) ? _c('hr') : _vm._e(), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.section.heading) ? _c('h3', {
    staticClass: "static-info--sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.section.heading)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section.video_link) ? _c('div', {
    staticClass: "article__feature embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    attrs: {
      "src": ("" + (_vm.section.video_link)),
      "frameborder": "0",
      "gesture": "media",
      "allow": "encrypted-media",
      "allowfullscreen": ""
    }
  })]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(637),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'step_block',
    props: {
        section: Object
    }
});

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "featured-donate-block"
  }, [_c('div', {
    staticClass: "featured-donate-block__number"
  }, [_vm._v("\n            " + _vm._s(_vm.section.heading) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "featured-donate-block__content",
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(639),
  /* template */
  __webpack_require__(640),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'person_management_team',
    props: {
        section: Object,
        first: Boolean
    },

    data: function data() {
        return {
            previewSection: undefined
        };
    },
    created: function created() {
        if (__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].hasPreviewContent('person') && __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent().original_item.person_type == 'Management_Team') {
            this.previewSection = __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent().original_item;
        }
    },


    computed: {
        page_content: function page_content() {
            return this.section.page_content.filter(function (p) {
                return p.person_type == 'Management_Team';
            });
        }
    }
});

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.first) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.section.heading || _vm.section.body) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.section.heading) ? _c('h2', {
    staticClass: "static-info--sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.section.heading)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section.body) ? _c('p', {
    staticClass: "static-info--sub-teaser",
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.previewSection) ? [_c('sk-layout', {
    staticClass: "management__content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "management__image"
  }, [_c('img', {
    attrs: {
      "src": _vm.previewSection.person_image.url
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "md10": ""
    }
  }, [_c('h6', {
    staticClass: "management__person-name",
    domProps: {
      "innerHTML": _vm._s(_vm.previewSection.title)
    }
  }), _vm._v(" "), (_vm.previewSection.position) ? _c('span', {
    staticClass: "management__job-description",
    domProps: {
      "innerHTML": _vm._s(_vm.previewSection.position)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "management__summary"
  }, [_c('p', [_vm._v(_vm._s(_vm.previewSection.person_description))])])])], 1)] : _vm._e(), _vm._v(" "), _vm._l((_vm.page_content), function(person, index) {
    return [(index != 0 || _vm.previewSection) ? _c('hr') : _vm._e(), _vm._v(" "), _c('sk-layout', {
      staticClass: "management__content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "md2": ""
      }
    }, [_c('div', {
      staticClass: "management__image"
    }, [_c('img', {
      attrs: {
        "src": person.person_image.url
      }
    })])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "md10": ""
      }
    }, [_c('h6', {
      staticClass: "management__person-name",
      domProps: {
        "innerHTML": _vm._s(person.title)
      }
    }), _vm._v(" "), (person.position) ? _c('span', {
      staticClass: "management__job-description",
      domProps: {
        "innerHTML": _vm._s(person.position)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "management__summary"
    }, [_c('p', [_vm._v(_vm._s(person.person_description))])])])], 1)]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(643),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'person_management_team_block',
    props: {
        section: Object,
        first: Boolean
    },

    data: function data() {
        return {
            previewSection: undefined
        };
    },
    created: function created() {
        if (__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].hasPreviewContent('person') && __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent().original_item.person_type == 'Management_Team') {
            this.previewSection = __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent().original_item;
        }
    },

    computed: {
        page_content: function page_content() {
            return this.section.page_content.filter(function (p) {
                return p.person_type == 'Management_Team';
            });
        }
    }
});

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.first) ? _c('hr') : _vm._e(), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.section.heading) ? _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-title-heading', {
    staticClass: "sharedolders-heading",
    attrs: {
      "h3": "",
      "no-border": "",
      "label": _vm.section.heading
    }
  }, [_c('template', {
    slot: "append"
  }, [((_vm.section.button_link || (_vm.section.file_link && _vm.section.file_link.url)) && _vm.section.button_text) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "small": "",
      "tag": "a",
      "href": _vm.section.button_link || _vm.section.file_link.url
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.section.button_text) + "\n                    ")]) : _vm._e(), _vm._v(" "), ((_vm.section.additional_button_link || (_vm.section.file_link_2 && _vm.section.file_link_2.url)) && _vm.section.additional_button_text) ? _c('sk-button', {
    attrs: {
      "tertiary": "",
      "small": "",
      "tag": "a",
      "href": _vm.section.additional_button_link || _vm.section.file_link_2.url
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.section.additional_button_text) + "\n                    ")]) : _vm._e()], 1)], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.previewSection) ? _c('sk-flex', {
    attrs: {
      "xs6": "",
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "shareholder"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.previewSection.person_image.url
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.page_content), function(person, index) {
    return _c('sk-flex', {
      key: index,
      attrs: {
        "xs6": "",
        "md2": ""
      }
    }, [_c('div', {
      staticClass: "shareholder"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": person.person_image.url
      }
    })])])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(646),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'person_shareholders',
    props: {
        section: Object,
        first: Boolean
    },

    data: function data() {
        return {
            previewSection: undefined
        };
    },
    created: function created() {
        if (__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].hasPreviewContent('person') && __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent().original_item.person_type == 'Shareholder') {
            this.previewSection = __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent().original_item;
        }
    },

    computed: {
        page_content: function page_content() {
            return this.section.page_content ? this.section.page_content.filter(function (p) {
                return p.person_type == 'Shareholder';
            }) : [];
        }
    }
});

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.first) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.section.heading || _vm.section.body) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.section.heading) ? _c('h2', {
    staticClass: "static-info--sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.section.heading)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section.body) ? _c('p', {
    staticClass: "static-info--sub-teaser",
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.previewSection) ? [_c('sk-layout', {
    staticClass: "management__content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "management__image"
  }, [_c('img', {
    attrs: {
      "src": _vm.previewSection.person_image.url
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "md10": ""
    }
  }, [_c('h6', {
    staticClass: "management__person-name",
    domProps: {
      "innerHTML": _vm._s(_vm.previewSection.title)
    }
  }), _vm._v(" "), (_vm.previewSection.position) ? _c('span', {
    staticClass: "management__job-description",
    domProps: {
      "innerHTML": _vm._s(_vm.previewSection.position)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "management__summary"
  }, [_c('p', [_vm._v(_vm._s(_vm.previewSection.person_description))])])])], 1)] : _vm._e(), _vm._v(" "), _vm._l((_vm.page_content), function(person, index) {
    return [(index != 0) ? _c('hr') : _vm._e(), _vm._v(" "), _c('sk-layout', {
      staticClass: "management__content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "md2": ""
      }
    }, [_c('div', {
      staticClass: "management__image"
    }, [_c('img', {
      attrs: {
        "src": person.person_image.url
      }
    })])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "md10": ""
      }
    }, [_c('h6', {
      staticClass: "management__person-name",
      domProps: {
        "innerHTML": _vm._s(person.title)
      }
    }), _vm._v(" "), (person.position) ? _c('span', {
      staticClass: "management__job-description",
      domProps: {
        "innerHTML": _vm._s(person.position)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "management__summary"
    }, [_c('p', [_vm._v(_vm._s(person.person_description))])])])], 1)]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(649),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'person_shareholders_block',
    props: {
        section: Object,
        first: Boolean
    },

    data: function data() {
        return {
            previewSection: undefined
        };
    },
    created: function created() {
        if (__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].hasPreviewContent('person') && __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent().original_item.person_type == 'Shareholder') {
            this.previewSection = __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent().original_item;
        }
    },

    computed: {
        page_content: function page_content() {
            return this.section.page_content.filter(function (p) {
                return p.person_type == 'Shareholder';
            });
        }
    }
});

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.first) ? _c('hr') : _vm._e(), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.section.heading) ? _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-title-heading', {
    staticClass: "sharedolders-heading",
    attrs: {
      "h3": "",
      "no-border": "",
      "label": _vm.section.heading
    }
  }, [_c('template', {
    slot: "append"
  }, [((_vm.section.button_link || (_vm.section.file_link && _vm.section.file_link.url)) && _vm.section.button_text) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "small": "",
      "tag": "a",
      "href": _vm.section.button_link || _vm.section.file_link.url
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.section.button_text) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": "10"
    }
  }), _vm._v(" "), ((_vm.section.additional_button_link || (_vm.section.file_link_2 && _vm.section.file_link_2.url)) && _vm.section.additional_button_text) ? _c('sk-button', {
    attrs: {
      "tertiary": "",
      "small": "",
      "tag": "a",
      "href": _vm.section.additional_button_link || _vm.section.file_link_2.url
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.section.additional_button_text) + "\n                    ")]) : _vm._e()], 1)], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.previewSection) ? _c('sk-flex', {
    attrs: {
      "xs6": "",
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "shareholder"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.previewSection.person_image.url
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.page_content), function(person, index) {
    return _c('sk-flex', {
      key: index,
      attrs: {
        "xs6": "",
        "md2": ""
      }
    }, [_c('div', {
      staticClass: "shareholder"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": person.person_image.url
      }
    })])])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(652),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'procurement',
    props: {
        section: Object,
        first: Boolean
    }
});

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.section.page_content.length > 0) ? _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.first) ? _c('hr') : _vm._e(), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v(_vm._s(_vm.section.heading))]), _vm._v(" "), (_vm.section.body) ? _c('p', {
    staticClass: "static-info--sub-teaser",
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  }) : _vm._e()])], 1), _vm._v(" "), _vm._l((_vm.section.page_content), function(procurement, index) {
    return _c('sk-layout', {
      key: index,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('h3', {
      staticClass: "static-info--heading"
    }, [_vm._v(_vm._s(procurement.title))])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Tender number")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.tender_number))])]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Tender publication date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.tender_publication_date))])]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Tender description")]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(procurement.tender_description)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Sk Procurement representive")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.representative_name))]), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.representative_phone))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.representative_email))])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Date of modification of tender invitation")]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(procurement.modification_date)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Tender collection time")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.tender_collection_time))])]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Physical Address for tender response")]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(procurement.physical_address)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Special conditions (if any)")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.special_conditions))])])])], 1)
  })], 2) : _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-panel', {
    staticClass: "panel panel--black"
  }, [_vm._v("\n            There are no open tender invitations at the moment. Please check back as Ster-Kinekor will publish open\n            tenders as they become available.\n        ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(655),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'related_movies',
    props: {
        section: Object,
        first: Boolean
    },
    data: function data() {
        return {
            movies: null,
            loading: true,
            heading: "Movies now showing"
        };
    },


    methods: {
        getRelatedMovies: function getRelatedMovies(movies, user) {
            if (!user || user.isGuest() || user.PreferredGenres.length == 0) {
                return movies;
            };
            this.heading = "Movies we think you'll enjoy";
            var filteredMovies = [];
            movies.reduce(function (c, movie) {
                movie.genres.forEach(function (genre) {
                    user.PreferredGenres.forEach(function (prefGen) {
                        if (genre.id == prefGen) {
                            filteredMovies.push(movie);
                        }
                    });
                });
            });
            return filteredMovies;
        }
    },

    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user(), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovies()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                user = _ref2[0],
                m = _ref2[1];

            _this.movies = _this.getRelatedMovies(m.byRelease().now_showing, user);
            _this.loading = false;
        });
    }
});

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.first) ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), (!_vm.loading) ? _c('sk-related-movies', {
    attrs: {
      "limit": "6",
      "label": _vm.heading,
      "movies": _vm.movies
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(657),
  /* template */
  __webpack_require__(658),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'link_banner',
    props: {
        section: Object,
        first: Boolean
    }
});

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.first) ? _c('hr') : _vm._e(), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-panel', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "black": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "featured-info"
  }, [(_vm.section.heading) ? _c('h5', [_vm._v(_vm._s(_vm.section.heading))]) : _vm._e(), _vm._v(" "), (_vm.section.body) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "md1": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "featured-button"
  }, [((_vm.section.button_link || (_vm.section.file_link && _vm.section.file_link.url)) && _vm.section.button_text) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.section.button_link || _vm.section.file_link.url
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.section.button_text) + "\n                        ")]) : _vm._e(), _vm._v(" "), ((_vm.section.additional_button_link || (_vm.section.file_link_2 && _vm.section.file_link_2.url)) && _vm.section.additional_button_text) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "tag": "a",
      "href": _vm.section.additional_button_link || _vm.section.file_link_2.url
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.section.additional_button_text) + "\n                        ")]) : _vm._e()], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(660),
  /* template */
  __webpack_require__(661),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'partners_block',
    props: {
        section: Object
    },

    data: function data() {
        return {
            previewSection: undefined
        };
    },
    created: function created() {
        if (__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].hasPreviewContent('partners')) {
            this.previewSection = __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent().original_item;
        }
    }
});

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.previewSection) ? _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [(_vm.previewSection.partner_image) ? _c('div', {
    staticClass: "featured_block__image"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.previewSection.partner_image.url,
      "alt": "previewSection.partner_image.alt"
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.previewSection.title)
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.section.page_content), function(partner) {
    return (_vm.section.page_content) ? _c('sk-flex', {
      key: partner.nid,
      attrs: {
        "grow": ""
      }
    }, [_c('div', {
      staticClass: "featured_block"
    }, [(partner.partner_image) ? _c('div', {
      staticClass: "featured_block__image"
    }, [_c('img', {
      staticClass: "img-responsive-height",
      attrs: {
        "src": partner.partner_image.url,
        "alt": "partner.partner_image.alt"
      }
    })]) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(partner.title)
      }
    })])]) : _vm._e()
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(663),
  /* template */
  __webpack_require__(664),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'accolades_block',
    props: {
        section: Object
    },

    data: function data() {
        return {
            previewSection: undefined
        };
    },
    created: function created() {
        if (__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].hasPreviewContent('accolades')) {
            this.previewSection = __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent().original_item;
        }
    }
});

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.previewSection) ? _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [(_vm.previewSection.accolade_image) ? _c('div', {
    staticClass: "featured_block__image"
  }, [_c('img', {
    staticClass: "img-responsive-height ",
    attrs: {
      "src": _vm.previewSection.accolade_image.url,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.previewSection.title)
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.section.page_content), function(accolade) {
    return _c('sk-flex', {
      key: accolade.nid,
      attrs: {
        "grow": ""
      }
    }, [_c('div', {
      staticClass: "featured_block"
    }, [(accolade.accolade_image) ? _c('div', {
      staticClass: "featured_block__image"
    }, [_c('img', {
      staticClass: "img-responsive-height ",
      attrs: {
        "src": accolade.accolade_image.url,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(accolade.title)
      }
    })])])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(666),
  /* template */
  __webpack_require__(667),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'image_full_width',
    props: {
        section: Object,
        first: Boolean
    }
});

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.first) ? _c('hr') : _vm._e(), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.section.heading) ? _c('h3', {
    staticClass: "static-info--sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.section.heading)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section.image.url) ? _c('div', {
    staticClass: "article__feature embed-responsive embed-responsive-16by9",
    staticStyle: {
      "height": "auto",
      "padding-bottom": "0"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.section.image.url
    }
  })]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(669),
  /* template */
  __webpack_require__(670),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'two_column_text_block',
    props: {
        section: Object,
        first: Boolean
    }
});

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "legal"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "reverse": "",
      "align-center": "",
      "gutter-40": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [(_vm.section.body_2) ? [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.section.heading_2)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.section.body_2)
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('sk-flex', {
    class: _vm.section.body_2 ? 'summary' : '',
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.section.heading)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  }), _vm._v(" "), ((_vm.section.button_link || (_vm.section.file_link && _vm.section.file_link.url)) && _vm.section.button_text) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "inline-block": "",
      "tag": "a",
      "href": _vm.section.button_link || _vm.section.file_link.url
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.section.button_text) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": "10"
    }
  }), _vm._v(" "), ((_vm.section.additional_button_link || (_vm.section.file_link_2 && _vm.section.file_link_2.url)) && _vm.section.additional_button_text) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "inline-block": "",
      "tag": "a",
      "href": _vm.section.additional_button_link || _vm.section.file_link_2.url
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.section.additional_button_text) + "\n                ")]) : _vm._e()], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(672),
  /* template */
  __webpack_require__(673),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'sign_in_banner',
    props: {
        section: Object
    },

    data: function data() {
        return { signUp: true };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user().then(function (user) {
            if (user.isGuest) _this.signUp = false;
        });
    }
});

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.signUp) ? _c('sk-signin', {
    ref: "signUp",
    attrs: {
      "signUp": _vm.signUp
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-container', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.sections), function(section, index) {
    return (section.page_layout || section.section_layout) ? [_c(section.page_layout || section.section_layout, {
      tag: "component",
      attrs: {
        "first": index === 0,
        "section": section
      }
    })] : _vm._e()
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "static-info"
  }, [_c('sk-container', [(_vm.title != 'General') ? _c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))])]) : _c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.activeTab.page_title))])]), _vm._v(" "), (_vm.page.tabs) ? [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.title != 'General') ? [(_vm.$breakpoints.xs || _vm.$breakpoints.sm) ? _vm._l((_vm.page.tabs), function(tab, index) {
    return _c('sk-accordian', {
      key: index,
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.setTab(tab)
        }
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('h2', {
      staticClass: "faq__cat-title",
      attrs: {
        "data-url": tab.path
      }
    }, [_vm._v(_vm._s(tab.page_title))])]), _vm._v(" "), _c('template', {
      slot: "content"
    }, [_c('sk-panel', [_c('content-section', {
      attrs: {
        "sections": _vm.activeTab.sections
      }
    })], 1)], 1)], 2)
  }) : _c('sk-tabs', {
    attrs: {
      "size": _vm.page.tabs.length
    }
  }, [_c('template', {
    slot: "tab-title"
  }, _vm._l((_vm.page.tabs), function(tab, index) {
    return _c('sk-tab', {
      key: tab.page_title,
      class: (_vm.isActiveTab(tab) ? 'active' : ''),
      attrs: {
        "item": tab.page_title
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.setTab(tab)
        }
      }
    })
  })), _vm._v(" "), _c('template', {
    slot: "tab-content"
  }, [_c('sk-panel', [_c('content-section', {
    attrs: {
      "sections": _vm.activeTab.sections
    }
  })], 1)], 1)], 2)] : [_c('sk-panel', {
    staticClass: "general-page-content"
  }, [_c('content-section', {
    attrs: {
      "sections": _vm.activeTab.sections
    }
  })], 1)]], 2)], 1)] : (_vm.page.sections) ? [_c('sk-panel', [_c('content-section', {
    attrs: {
      "sections": _vm.page.sections
    }
  })], 1)] : _vm._e()], 2)], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__content_sections__ = __webpack_require__(389);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'content_page',

    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].clear();

        if (this.$route.params.content_type && this.$route.params.node_id) {
            __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["l" /* PageService */].getNode(this.$route.params.node_id).then(function (pageContent) {
                if (pageContent && (typeof pageContent === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(pageContent)) === 'object' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(pageContent).length > 0) {

                    __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].setContent(_this.$route.params.content_type, pageContent);
                    __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].loadPimaryRoute(_this.$router);
                }
            });
        }
    },


    template: '<div class="payment">\n\t\t<div class="default__bg"></div>\n\t\t<sk-container>\n\t\t\t<sk-panel>\n\t\t    <div  class="loading">\n\t\t        <sk-progress-circular indeterminate size="100" :width="2" primary></sk-progress-circular>\n\t\t        <h4>Loading Preview data.</h4>\n\t\t    </div>\n\t\t\t</sk-panel>\n\t\t</sk-container>\n\t</div>'

});

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(678),
  /* template */
  __webpack_require__(679),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_meta_data_js__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'exclusive-to-sk',
    data: function data() {
        return {
            tabs: [],
            routeName: this.$route.name,
            googleAds:  true ? {
                left: '/40862963/SK-EventsAndExperiences-Wallpaper-Left',
                right: '/40862963/SK-EventsAndExperiences-Wallpaper-Right',
                top: '/40862963/SK-HomeP-320x50',
                topLg: '/40862963/SK-HomeP-728x90'
            } : {
                left: '/40862963/SK-EventsAndExperiences-Wallpaper-Left',
                right: '/40862963/SK-EventsAndExperiences-Wallpaper-Right',
                top: '/40862963/SK-HomeP-320x50',
                topLg: '/40862963/SK-HomeP-728x90'
            }
        };
    },


    computed: {
        activeTab: {
            get: function get() {
                var _this = this;

                return this.tabs ? this.tabs.findIndex(function (tab) {
                    return tab.name === _this.$route.name;
                }) : 0;
            },
            set: function set($tabIndex) {
                var tab = this.tabs[$tabIndex];
                if (this.$route.name !== tab.name) {
                    this.$router.push({ name: tab.name });
                }
            }
        }
    },

    methods: {
        getAsyncData: function getAsyncData() {
            if (this.routeName === 'Promotions') {
                this.metaTitle = 'Promotions';
                this.metaDescription = 'Promotions at Ster-Kinekor';
            }
            if (this.routeName === 'Events') {
                this.metaTitle = 'Film Events and Screenings | Book Today';
                this.metaDescription = 'Browse our range of upcoming film events and screenings, exclusive to Ster-Kinekor. View event details and book today!';
            }
            if (this.routeName === 'Film Festivals & Live') {
                this.metaTitle = 'Upcoming Film Festivals and Live Theatre Shows | Book Today';
                this.metaDescription = 'Browse our range of exciting upcoming film festivals and theatre shows. Take a look at the various ticket prices and book today!';
            }
            this.$emit('updateHead');
        },
        pushRoute: function pushRoute(el) {
            this.$router.push({ name: el.name });
        },
        getGoogleAds: function getGoogleAds() {
            var _this2 = this;

            googletag.cmd.push(function () {
                googletag.display(_this2.adId);
                googletag.display(_this2.adIdMobile);
                googletag.display(_this2.adBGLeft);
                googletag.display(_this2.adBGRight);
                googletag.pubads().refresh();
            });
        }
    },

    beforeMount: function beforeMount() {
        var parentRoute = this.$route.matched.find(function (route) {
            return route.parent == undefined;
        });
        this.tabs = this.$router.options.routes.find(function (r) {
            return r.name === parentRoute.name;
        }).children || [];
    },
    mounted: function mounted() {
        this.getGoogleAds();
    },


    watch: {
        '$route': function $route(to) {
            this.routeName = to.name;
            this.getAsyncData();
        }
    }
});

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about exclusive-seo"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container'), _vm._v(" "), _c('sk-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('sk-layout', [(!_vm.$breakpoints.xs) ? _c('sk-flex', {
    attrs: {
      "sm2": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Exclusive to SK")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$breakpoints.mdUp) ? _c('sk-google-ad', {
    staticClass: "text-center",
    attrs: {
      "advert-id": _vm.googleAds.topLg,
      "width": 728,
      "height": 90
    }
  }) : _c('sk-google-ad', {
    staticClass: "text-center",
    attrs: {
      "advert-id": _vm.googleAds.top,
      "width": 320,
      "height": 50
    }
  })], 1)], 1), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-flex', {
    attrs: {
      "sm2": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "sm2": ""
    }
  }, [(_vm.$breakpoints.mdUp) ? _c('sk-google-ad', {
    staticClass: "exclusive-lefty",
    attrs: {
      "advert-id": _vm.googleAds.left,
      "width": 280,
      "height": 800
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs == true || _vm.$breakpoints.sm == true),
      expression: "$breakpoints.xs == true || $breakpoints.sm == true"
    }]
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-accordian', {
      key: index,
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.pushRoute(tab)
        }
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('h2', {
      staticClass: "faq__cat-title",
      attrs: {
        "data-url": tab.path
      }
    }, [_vm._v(_vm._s(tab.name))])]), _vm._v(" "), _c('template', {
      slot: "content"
    }, [_c('sk-panel', [_c('router-view')], 1)], 1)], 2)
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs == false && _vm.$breakpoints.sm == false),
      expression: "$breakpoints.xs == false && $breakpoints.sm == false"
    }]
  }, [_c('sk-tabs', {
    attrs: {
      "size": _vm.tabs.length
    }
  }, [_c('template', {
    slot: "tab-title"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-tab', {
      key: tab.name,
      class: (_vm.activeTab == index ? 'active' : ''),
      attrs: {
        "item": tab.name
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.activeTab = index
        }
      }
    })
  })), _vm._v(" "), _c('template', {
    slot: "tab-content"
  }, [_c('sk-panel', [_c('router-view')], 1)], 1)], 2)], 1)])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sm2": ""
    }
  }, [(_vm.$breakpoints.mdUp) ? _c('sk-google-ad', {
    staticClass: "exclusive-righty",
    attrs: {
      "advert-id": _vm.googleAds.right,
      "width": 280,
      "height": 800
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(681),
  /* template */
  __webpack_require__(682),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_meta_data_js__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'film-festival-details',
	mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_meta_data_js__["a" /* default */]],
	data: function data() {
		return {
			loading: true,
			filmFestival: {},
			activeMovie: null,
			movieSummary: null,
			bottomOffset: null,
			selected_cinema_id: null,
			top: 0,
			movies: null
		};
	},


	methods: {
		getAsyncData: function getAsyncData() {
			this.metaTitle = this.filmFestival.Name;
			this.metaImage = this.filmFestival.images.poster.url;
			this.metaDescription = this.filmFestival.Description;
			this.schemaDataSrc = {
				"@context": "http://schema.org",
				"@type": "Event",
				"image": this.metaImage,
				"description": this.metaDescription,

				"name": this.metaTitle,

				"startDate": this.filmFestival.StartDate._i
			};
			this.$emit('updateHead');
		}
	},

	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["g" /* FilmFestivalService */].getFilmFestivalById(this.$route.params.id)]).then(function (filmFestival) {
			for (var i = 0; i < filmFestival.length; i++) {
				_this.filmFestival = filmFestival[i];
			}
			_this.getAsyncData();
			_this.loading = false;
		}, function (error) {
			_this.filmFestival = undefined;
			_this.loading = true;
		});
	}
});

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "film-festival"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', {
    staticClass: "movie-detail"
  }, [_c('sk-panel', [_c('sk-layout', {
    class: (!_vm.$breakpoints.xs ? 'gutter-40' : ''),
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "md3": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail-poster"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.filmFestival.images.poster.url,
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md7": ""
    }
  }, [(_vm.$breakpoints.xs) ? _c('sk-spacer', {
    attrs: {
      "height": "20"
    }
  }) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "movie-detail__releasing"
  }, [_vm._v("\n                            " + _vm._s(_vm.filmFestival.StartDate.format('dddd Do MMMM YYYY')) + "\n                        ")]), _vm._v(" "), _c('h1', {
    staticClass: "movie-detail__title"
  }, [_vm._v("\n                            " + _vm._s(_vm.filmFestival.Name) + " \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs"
  }, [_c('p', {
    staticClass: "movie-detail__summary"
  }, [(_vm.filmFestival.Description) ? [_vm._v("\n                                    " + _vm._s(_vm.filmFestival.Description) + "\n                                ")] : _vm._e()], 2)])], 1)], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "visible-xs"
  }, [_c('sk-spacer', {
    attrs: {
      "height": "20"
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "movie-detail__summary"
  }, [_vm._v("\n                            " + _vm._s(_vm.filmFestival.Description) + "\n                        ")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.filmFestival.Movies.length > 0) ? [_c('h3', {
    staticClass: "featured-heading"
  }, [_vm._v("Features")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    staticClass: "movie-listing__list",
    class: (_vm.activeMovie ? 'movie-listing__list--active' : ''),
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.filmFestival.Movies), function(movie) {
    return (_vm.filmFestival.Movies) ? _c('sk-flex', {
      key: movie.id,
      attrs: {
        "xs6": "",
        "sm4": "",
        "md2": "",
        "lg2": ""
      }
    }, [(_vm.filmFestival.Movies) ? _c('sk-movie-thumbnail', {
      style: ({
        marginBottom: _vm.activeMovie == movie ? _vm.bottomOffset : ''
      }),
      attrs: {
        "now-showing": "",
        "content": movie
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.$router.push(("/details/" + (movie.id) + "/film-festival/" + (_vm.$route.params.id)))
        }
      }
    }) : _vm._e()], 1) : _vm._e()
  }))] : _vm._e(), _vm._v(" "), _c('sk-signin')], 2)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(684),
  /* template */
  __webpack_require__(685),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_meta_data_js__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            tabs: []
        };
    },


    computed: {
        isActive: {
            get: function get() {
                var _this = this;

                return this.tabs ? this.tabs.findIndex(function (tab) {
                    return tab.name === _this.$route.name;
                }) : 0;
            },
            set: function set($tabIndex) {
                var tab = this.tabs[$tabIndex];
                if (this.$route.name !== tab.name) {
                    this.$router.push({ name: tab.name });
                }
            }
        }
    },

    methods: {
        pushRoute: function pushRoute(el) {
            this.$router.push({ name: el.name });
        }
    },

    beforeMount: function beforeMount() {
        var parentRoute = this.$route.matched.find(function (route) {
            return route.parent == undefined;
        });
        this.tabs = this.$router.options.routes.find(function (r) {
            return r.name === parentRoute.name;
        }).children || [];
    }
});

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sales-at-sk"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Sales at SK")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.$breakpoints.xs || _vm.$breakpoints.sm) ? _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-accordian', {
      key: index,
      attrs: {
        "active": _vm.isActive == index
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.pushRoute(tab)
        }
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('h2', {
      staticClass: "faq__cat-title",
      attrs: {
        "data-url": tab.path
      }
    }, [_vm._v(_vm._s(tab.name))])]), _vm._v(" "), _c('template', {
      slot: "content"
    }, [_c('sk-panel', [_c('router-view')], 1)], 1)], 2)
  }) : [_c('sk-tabs', {
    attrs: {
      "size": _vm.tabs.length
    }
  }, [_c('template', {
    slot: "tab-title"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-tab', {
      key: tab.name,
      class: (_vm.isActive == index ? 'active' : ''),
      attrs: {
        "item": tab.name
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.isActive = index
        }
      }
    })
  })), _vm._v(" "), _c('template', {
    slot: "tab-content"
  }, [_c('sk-panel', [_c('router-view')], 1)], 1)], 2)]], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(687),
  /* template */
  __webpack_require__(688),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_meta_data_js__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({

    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_meta_data_js__["a" /* default */]],

    data: function data() {
        return {
            loading: true,
            competitions: [],
            movies: []
        };
    },


    methods: {
        getAsyncData: function getAsyncData() {
            this.metaTitle = 'Competitions | Win Exciting Prizes';
            this.metaDescription = 'Attention movie-lovers: take a look at the competitions we are currently running. Enter today and stand a chance to win exciting prizes.';
            this.$emit('updateHead');
        }
    },

    created: function created() {
        var _this = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovies(), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["l" /* PageService */].getCompetitions()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                movies = _ref2[0],
                response = _ref2[1];

            _this.competitions = __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].addPreviewToContentArrayIfAvailable('competition', response.data);
            _this.competitions.forEach(function (el) {
                if (el.related_movie) {
                    el.movie = movies.findById(el.related_movie);
                }
                if (el.mobile_image && el.image) el.srcsets = el.mobile_image.url + ' 700w, ' + el.image.url + ' 2000w';
            });
            _this.getAsyncData();
            _this.loading = false;
        });
    },
    mounted: function mounted() {
        if (window.__PRERENDER_INJECTED) {
            this.loading = false;
            this.prerender = true;

            if (window.__PRERENDER_INJECTED.competitions) {

                this.competitions = __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].addPreviewToContentArrayIfAvailable('competition', window.__PRERENDER_INJECTED.competitions);
                this.getAsyncData();
            }
        }
    }
});

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "competitions"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Competitions")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), [(_vm.competitions.length > 0) ? _vm._l((_vm.competitions), function(competition, index) {
    return _c('div', {
      key: index
    }, [_c('sk-exclusive-list', {
      attrs: {
        "competition": "",
        "item": competition
      }
    })], 1)
  }) : [_c('sk-panel', [_c('p', [_vm._v("There are no competitions at Ster-Kinekor at the moment.")]), _vm._v(" "), _c('p', [_vm._v("Please check back again soon or sign up our newsletter to keep up to date on what's on!")])])]]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(690),
  /* template */
  __webpack_require__(691),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_meta_data_js__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["default"] = ({

    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_meta_data_js__["a" /* default */]],

    data: function data() {
        return {
            comp: {},
            movie: null,
            loading: true,
            dialogActive: false
        };
    },


    methods: {
        getAsyncData: function getAsyncData() {
            this.metaTitle = this.comp.title || '';
            this.metaImage = this.comp.poster_image || '';
            this.metaDescription = this.comp.strapline || '';
            this.$emit('updateHead');
        },
        processComp: function processComp(comp) {
            var _this = this;

            this.loading = true;
            comp.srcsets = comp.mobile_image + ' 700w, ' + comp.image + ' 2000w';
            this.comp = comp;
            if (this.comp.related_movie) this.getMovie(this.comp.related_movie).then(function () {
                return _this.loading = false;
            }, function () {
                return _this.loading = false;
            });else this.loading = false;
        },
        getContent: function getContent() {
            var _this2 = this;

            this.loading = true;
            if (__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].hasPreviewContent('competition') && __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent().nid === this.$route.params.id) {
                this.processComp(__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent('competition'));
            } else __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getCompetitions().then(function (response) {
                response.data.forEach(function (el) {
                    if (el.nid === _this2.$route.params.id) {
                        _this2.processComp(el);
                    }
                });
                _this2.getAsyncData();
            });
        },
        getMovie: function getMovie(id) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovieDetail(id).then(function (response) {
                _this3.movie = response;
            });
        }
    },

    created: function created() {
        this.getContent();
    }
});

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "competition"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.movie && _vm.comp.use_movie_poster == '0') ? _c('sk-flex', {
    attrs: {
      "xs5": "",
      "md3": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogActive = true
      }
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.poster,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-icon', {
    staticClass: "movie-detail__poster-play",
    attrs: {
      "play": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('sk-video', {
    staticClass: "dialog-video",
    attrs: {
      "content": _vm.movie.youtube_id
    },
    model: {
      value: (_vm.dialogActive),
      callback: function($$v) {
        _vm.dialogActive = $$v
      },
      expression: "dialogActive"
    }
  })], 1)]) : ((!_vm.comp.use_movie_poster || _vm.comp.use_movie_poster == '0') && _vm.comp.poster_image) ? _c('sk-flex', {
    attrs: {
      "xs5": "",
      "md3": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster movie-detail__poster-img--no-trailer"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.comp.poster_image.url,
      "alt": ""
    }
  })])])]) : _vm._e(), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-flex', {
    attrs: {
      "xs7": "",
      "md9": ""
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.comp.title))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.comp.detail)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "promo__content-btns"
  }, [(!_vm.comp.button_link && !_vm.comp.button_text) ? _c('div', {
    staticClass: "promo__content-btns"
  }, [(_vm.movie) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'Movie Details',
        params: {
          id: _vm.movie.id
        }
      }
    }
  }, [_vm._v("Book to Win\n                                ")]) : _vm._e()], 1) : _c('div', {
    staticClass: "promo__content-btns"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.comp.button_link
    }
  }, [_vm._v(_vm._s(_vm.comp.button_text) + "\n                                ")])], 1), _vm._v(" "), _c('span', [_vm._v(" ")]), _vm._v(" "), ((_vm.comp.button_2_link || _vm.comp.button_2_text)) ? _c('div', {
    staticClass: "promo__content-btns"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "tag": "a",
      "href": _vm.comp.button_2_link
    }
  }, [_vm._v(_vm._s(_vm.comp.button_2_text) + "\n                                ")])], 1) : _vm._e()])]) : [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.comp.title))])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.comp.detail)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "promo__content-btns"
  }, [(!_vm.comp.button_link && !_vm.comp.button_text) ? _c('div', {
    staticClass: "promo__content-btns"
  }, [(_vm.movie) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'Movie Details',
        params: {
          id: _vm.movie.id
        }
      }
    }
  }, [_vm._v("Book to Win\n                                    ")]) : _vm._e()], 1) : _c('div', {
    staticClass: "promo__content-btns"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.comp.button_link
    }
  }, [_vm._v(_vm._s(_vm.comp.button_text) + "\n                                    ")])], 1), _vm._v(" "), _c('span', [_vm._v(" ")]), _vm._v(" "), ((_vm.comp.button_2_link || _vm.comp.button_2_text)) ? _c('div', {
    staticClass: "promo__content-btns"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "tag": "a",
      "href": _vm.comp.button_2_link
    }
  }, [_vm._v(_vm._s(_vm.comp.button_2_text) + "\n                                    ")])], 1) : _vm._e()])])]], 2)], 1), _vm._v(" "), _vm._l((_vm.comp.questions), function(item, index) {
    return _c('sk-accordian', {
      key: index,
      attrs: {
        "active": "",
        "auto-expand-first": index == 0
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('h4', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('template', {
      slot: "content"
    }, [_c('sk-panel', {
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    })], 1)], 2)
  })]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(693),
  /* template */
  __webpack_require__(694),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_meta_data_js__ = __webpack_require__(5);

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-not-found"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    staticClass: "text-center",
    staticStyle: {
      "height": "50vh"
    },
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Page not Found")]), _vm._v(" "), _c('h4', [_vm._v("Looks like you're the only one here.")]), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": "20"
    }
  }), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "block": "",
      "router": "",
      "to": {
        name: 'Home'
      }
    }
  }, [_vm._v("Time to go home")])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_meta_data_js__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["default"] = ({

    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_meta_data_js__["a" /* default */]],

    data: function data() {
        return {
            order: null,
            movie: {},
            cinema: {},
            session: undefined,
            stepType: "donate",
            stepNames: [{
                step: 1,
                text: 'Choose Your Amount'
            }, {
                step: 2,
                text: 'Confirm Your Details'
            }, {
                step: 3,
                text: 'Make Donation'
            }]
        };
    },


    computed: {
        step: function step() {
            return parseInt(this.$route.path.split('/').pop());
        }
    },
    methods: {},
    created: function created() {
        if (this.step < 1 || !this.step || this.step == NaN) {
            this.$router.push('/donate/1');
        }
        this.metaTitle = 'Corporate Social Responsibility | Donate Today';
        this.metaDescription = 'Through our Corporate Social Investment (CSI) initiatives, we aim to help youngsters in underprivileged communities by identifying and helping those with visual problems nationwide. Contribute to this cause and donate today.';
    },
    mounted: function mounted() {
        window.scroll({ top: 0, left: 0 });
    }
});

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-progress-steps', {
    attrs: {
      "num-steps": 3,
      "current-step": _vm.step,
      "step-names": _vm.stepNames,
      "step-type": _vm.stepType
    }
  })], 1)], 1), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": "20"
    }
  }), _vm._v(" "), _c('sk-layout', {
    staticClass: "gutter-30",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "sk-slide-x-transition"
    }
  }, [(_vm.step == '3') ? [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('router-view')], 1)] : _vm._e(), _vm._v(" "), [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('router-view')], 1)]], 2), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "lg3": ""
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(698),
  /* template */
  __webpack_require__(699),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            valid: false,
            complete: false,
            error: null,
            validateUser: null
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].isGuestUser()).then(function (guest) {
            if (guest) {
                _this.$router.push("/user/login?redirect=/user/confirm-email-change/" + _this.$route.params.changeCode);
            } else {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].validateChangeEmail(_this.$route.params.changeCode)).then(function (result) {

                    if (result.success) {
                        _this.complete = true;
                        if (result.data.ResultCode === 0) {
                            _this.valid = true;
                        } else {
                            _this.valid = false;

                            _this.error = "The email address could not be changed, the email address might already by in use. Please try using another email address.";
                        }
                        _this.loading = false;
                    }
                }, function (error) {
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
                });
            }
        });
    }
});

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', {
    attrs: {
      "user-signup": ""
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : (!_vm.loading && _vm.complete && !_vm.valid) ? _c('sk-panel', [_c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "user-password-reset-code-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h3', {
    staticClass: "form-heading"
  }, [_vm._v("Confirm Email Change")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))])])], 1) : (!_vm.loading && _vm.complete && _vm.valid) ? _c('sk-panel', [_c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "user-password-reset-code-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h3', {
    staticClass: "form-heading"
  }, [_vm._v("Confirm Email Change")]), _vm._v(" "), _c('p', [_vm._v("Your email has been updated successfully.")])])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(701),
  /* template */
  __webpack_require__(704),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_meta_data_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap__ = __webpack_require__(702);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'subs-club',

    mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_meta_data_js__["a" /* default */]],

    data: function data() {
        return {
            cinema_type: "standalone",
            items: [],
            loading: true,
            selectedItem: null,
            lsItem: null,
            user: null,
            guest: true,
            subsOptionsVisible: false,
            fanClubOptionsVisible: false
        };
    },


    methods: {
        getConcessionItems: function getConcessionItems(concessionItems) {
            var items = [];
            for (var k = 0; k < concessionItems.length; k++) {
                var item = concessionItems[k];
                item.Price = "R " + concessionItems[k].PriceInCents / 100;
                item.Quantity = 1;
                items[k] = item;
            }

            return items;
        },
        setSubsOption: function setSubsOption(itemId) {
            var registering = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            for (var i in this.items) {

                if (this.items[i].Id == itemId) {
                    this.selectedItem = this.items[i];
                    var nextStep = "requires-auth";
                    var nextUrl = registering ? "/user/signup" : "/user/login";

                    if (!this.user.isGuest()) {
                        nextStep = "confirm-details";
                        nextUrl = "/subscribe/1";
                    }

                    this.lsItem = {
                        'item': this.selectedItem,
                        'progress': { 'currentStep': 0, 'currentStepName': "select-option", "currentStepUrl": "/subscription-club", 'nextStep': 1, "nextStepName": nextStep, "nextStepUrl": nextUrl }
                    };
                    window.localStorage.setItem('subsClub', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.lsItem));

                    this.$router.push(nextUrl);
                }
            }
        },
        toggleSubsOptions: function toggleSubsOptions() {
            if (this.fanClubOptionsVisible) {
                this.toggleFanClubOptions();
            }

            this.subsOptionsVisible = !this.subsOptionsVisible;

            if (this.subsOptionsVisible) {
                __WEBPACK_IMPORTED_MODULE_6_gsap__["a" /* default */].set(this.$refs.subsOptions, { height: 'auto' });
                __WEBPACK_IMPORTED_MODULE_6_gsap__["a" /* default */].from(this.$refs.subsOptions, {
                    duration: 0.1,
                    height: 0
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_6_gsap__["a" /* default */].to(this.$refs.subsOptions, {
                    duration: 0.1,
                    height: 0
                });
            }
        },
        toggleFanClubOptions: function toggleFanClubOptions() {
            if (this.subsOptionsVisible) {
                this.toggleSubsOptions();
            }

            this.fanClubOptionsVisible = !this.fanClubOptionsVisible;

            if (this.fanClubOptionsVisible) {
                __WEBPACK_IMPORTED_MODULE_6_gsap__["a" /* default */].set(this.$refs.fanClubOptions, { height: 'auto' });
                __WEBPACK_IMPORTED_MODULE_6_gsap__["a" /* default */].from(this.$refs.fanClubOptions, {
                    duration: 0.1,
                    height: 0
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_6_gsap__["a" /* default */].to(this.$refs.fanClubOptions, {
                    duration: 0.1,
                    height: 0
                });
            }
        },
        setUser: function setUser() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user().then(function (user) {
                _this.user = user;
                _this.guest = user.isGuest();
                if (!user.isGuest() && user.MembershipActivated === false && _this.first_time) {} else {}
            });
        }
    },

    created: function created() {
        var _this2 = this;

        this.metaTitle = 'SK Subscription Club';
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getConsessionsByCinemaId(this.cinema_type), this.setUser()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                concessions = _ref2[0],
                user = _ref2[1];

            window.localStorage.removeItem('subsClub');
            for (var i = 0; i < concessions.length; i++) {
                if (concessions[i].Name == "Subs") {
                    _this2.items = _this2.getConcessionItems(concessions[i].ConcessionItems);
                }
            }
            _this2.loading = false;
        }, function (error) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
        });
    },
    mounted: function mounted() {
        window.scroll({ top: 0, left: 0 });
    }
});

/***/ }),
/* 702 */,
/* 703 */,
/* 704 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('sk-container', {
    staticClass: "sk-club__section"
  }, [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', {
    staticClass: "static-info--heading"
  }, [_vm._v("SK Subscription Club "), _c('span', [_vm._v("(Only available in South Africa)")])]), _vm._v(" "), _c('h3', [_vm._v("Get the most out of all ster-kinekor movie benefits")])]), _vm._v(" "), _c('sk-panel', [_c('sk-layout', {
    staticClass: "subs-club-header",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "club-movie-cards"
  }, [_c('div', {
    staticClass: "article__content"
  }, [_c('p', [_vm._v("Join SK Subscription Club to get more than you paid for today!")]), _vm._v(" "), _c('p', [_vm._v("\n                            As a SK Subscription Club member, you can get a subscription for a Limited or Unlimited\n                            amount of movies per month at a set cost, which you pay per month. This means\n                            you can now watch more movies at a lower price, whilst also enjoying the benefits\n                            of SK Club\n                        ")])])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-club-cards.png",
      "alt": ""
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-club__join-steps"
  }, [_c('sk-panel', [_c('h4', [_vm._v("Get the subscription plan that is right for you.")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('sk-flex', {
      key: item.Description,
      staticClass: "subs-club-options",
      attrs: {
        "xs12": "",
        "sm12": "",
        "md6": ""
      }
    }, [(item.Description == 'Limited Subs') ? [_c('div', {
      staticClass: "limited-subs"
    }, [_c('div', {
      staticClass: "img-container"
    }, [_c('img', {
      staticClass: "img-responsive fan-img img-option",
      attrs: {
        "src": "/static/img/fan_club_card.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('h3', {
      staticClass: "sk-club__join-steps-heading"
    }, [_vm._v("LIMITED MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('h4', [_vm._v("Get 4 2D or 3D movie tickets per month for you and your family.")]), _vm._v(" "), _c('div', {
      staticClass: "sk-club__join"
    }, [_c('h2', {
      staticClass: "h1"
    }, [_vm._v(_vm._s(item.Price) + " "), _c('span', [_vm._v("p/month")])])]), _vm._v(" "), _c('sk-layout', {
      staticClass: "benefit benefit-item",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs2": "",
        "sx2": "",
        "md2": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-limited-tickets-icon.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "description",
      attrs: {
        "xs9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_c('span', [_vm._v("4 MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                        You watch more for less\n                                    ")])])], 1), _vm._v(" "), _c('sk-layout', {
      staticClass: "benefit benefit-item",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs2": "",
        "sx2": "",
        "md2": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-combo-icon.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "description",
      attrs: {
        "xs9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                        20% off a regular combo\n                                    ")])])], 1), _vm._v(" "), _c('sk-layout', {
      staticClass: "benefit benefit-item",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs2": "",
        "sx2": "",
        "md2": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-limited-users-icon.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "description",
      attrs: {
        "xs9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_c('span', [_vm._v("IDEAL FOR THE FAMILY")]), _vm._v(" "), _c('br'), _vm._v("\n                                        Use one or all four tickets at once\n                                    ")])])], 1), _vm._v(" "), _c('sk-layout', {
      staticClass: "benefit",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs2": "",
        "sx2": "",
        "md2": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-location-icon.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "description",
      attrs: {
        "xs9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "sk-club__join-steps--btns"
    }, [(_vm.user != undefined && _vm.user != null && !_vm.user.isGuest()) ? [(_vm.user.PreferenceList.includes(6)) ? [_c('sk-button', {
      staticClass: "sk-club__join-steps-btn",
      attrs: {
        "primary": "",
        "tag": "a",
        "href": "/user/profile"
      }
    }, [_vm._v("MY CURRENT SUBSCRIPTION")])] : [(!_vm.user.PreferenceList.includes(5)) ? [_c('sk-button', {
      staticClass: "sk-club__join-steps-btn",
      attrs: {
        "primary": "",
        "dataContext": "Subscription Funnel",
        "dataValue": "Join Fan Club"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.setSubsOption(item.Id)
        }
      }
    }, [_vm._v("JOIN FAN CLUB NOW")])] : _vm._e()]] : [_c('sk-button', {
      staticClass: "sk-club__join-steps-btn",
      attrs: {
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleFanClubOptions()
        }
      }
    }, [_vm._v("JOIN FAN CLUB NOW")])]], 2), _vm._v(" "), _c('div', {
      ref: "fanClubOptions",
      refInFor: true,
      staticClass: "sk-club__join-suffix-container sk-club__join-suffix-container--left",
      staticStyle: {
        "height": "0"
      }
    }, [_c('div', {
      staticClass: "sk-club__join-suffix"
    }, [_c('div', {
      staticClass: "sk-club__join-suffix-item"
    }, [_c('div', {
      staticClass: "sk-club__join-suffix-heading"
    }, [_vm._v("\n                                            I am already a SK Club member\n                                        ")]), _vm._v(" "), _c('sk-button', {
      attrs: {
        "primary": "",
        "dataContext": "Subscription Funnel",
        "dataValue": "Join Fan Club"
      },
      nativeOn: {
        "click": function($event) {
          _vm.setSubsOption(item.Id)
        }
      }
    }, [_c('u', [_vm._v("Log in")]), _vm._v(" to subscribe to Subs Club\n                                        ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "sk-club__join-suffix-item"
    }, [_c('div', {
      staticClass: "sk-club__join-suffix-heading"
    }, [_vm._v("\n                                            I am "), _c('u', [_vm._v("NOT")]), _vm._v(" a SK Club member\n                                        ")]), _vm._v(" "), _c('sk-button', {
      attrs: {
        "primary": "",
        "dataContext": "Subscription Funnel",
        "dataValue": "Join Fan Club"
      },
      nativeOn: {
        "click": function($event) {
          _vm.setSubsOption(item.Id, true)
        }
      }
    }, [_c('u', [_vm._v("Sign up")]), _vm._v(" to subscribe to Subs Club\n                                        ")])], 1)])])], 1)] : _vm._e(), _vm._v(" "), (item.Description == 'Unlimited Subs') ? [_c('div', {
      staticClass: "unlimited-subs"
    }, [_c('div', {
      staticClass: "img-container"
    }, [_c('img', {
      staticClass: "img-responsive img-option",
      attrs: {
        "src": "/static/img/morvies_club_card.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('h3', {
      staticClass: "sk-club__join-steps-heading"
    }, [_vm._v("UNLIMITED MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('h4', [_vm._v("Watch as many 2D or 3D movies as you want all month long.")]), _vm._v(" "), _c('div', {
      staticClass: "sk-club__join"
    }, [_c('h2', {
      staticClass: "h1"
    }, [_vm._v(_vm._s(item.Price) + " "), _c('span', [_vm._v("p/month")])])]), _vm._v(" "), _c('sk-layout', {
      staticClass: "benefit benefit-item",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs2": "",
        "sx2": "",
        "md2": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-unlimited-tickets-icon.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "description",
      attrs: {
        "xs9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_c('span', [_vm._v("UNLIMITED MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                        Watch up to 5 movies a day, every day!\n                                    ")])])], 1), _vm._v(" "), _c('sk-layout', {
      staticClass: "benefit benefit-item",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs2": "",
        "sx2": "",
        "md2": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-combo-icon.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "description",
      attrs: {
        "xs9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                        20% off a regular combo\n                                    ")])])], 1), _vm._v(" "), _c('sk-layout', {
      staticClass: "benefit benefit-item",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs2": "",
        "sx2": "",
        "md2": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-unlimited-users-icon.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "description",
      attrs: {
        "xs9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_c('span', [_vm._v("COME AS OFTEN AS YOU CAN")]), _vm._v(" "), _c('br'), _vm._v("\n                                        1 ticket per movie per card holder\n\n                                    ")])])], 1), _vm._v(" "), _c('sk-layout', {
      staticClass: "benefit",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs2": "",
        "sx2": "",
        "md2": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/subs/subs-location-icon.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "description",
      attrs: {
        "xs9": "",
        "sm9": "",
        "md9": ""
      }
    }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "sk-club__join-steps--btns"
    }, [(_vm.user != undefined && _vm.user != null && !_vm.user.isGuest()) ? [(_vm.user.PreferenceList.includes(5)) ? [_c('sk-button', {
      staticClass: "sk-club__join-steps-btn",
      attrs: {
        "primary": "",
        "tag": "a",
        "href": "/user/profile"
      }
    }, [_vm._v("MY CURRENT SUBSCRIPTION")])] : [(!_vm.user.PreferenceList.includes(6)) ? [_c('sk-button', {
      staticClass: "sk-club__join-steps-btn",
      attrs: {
        "primary": "",
        "dataContext": "Subscription Funnel",
        "dataValue": "Join Morvies Club"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.setSubsOption(item.Id)
        }
      }
    }, [_vm._v("JOIN MORVIES CLUB NOW")])] : _vm._e()]] : [_c('sk-button', {
      staticClass: "sk-club__join-steps-btn",
      attrs: {
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleSubsOptions()
        }
      }
    }, [_vm._v("JOIN MORVIES CLUB NOW")])]], 2), _vm._v(" "), _c('div', {
      ref: "subsOptions",
      refInFor: true,
      staticClass: "sk-club__join-suffix-container sk-club__join-suffix-container--right",
      staticStyle: {
        "height": "0"
      }
    }, [_c('div', {
      staticClass: "sk-club__join-suffix"
    }, [_c('div', {
      staticClass: "sk-club__join-suffix-item"
    }, [_c('div', {
      staticClass: "sk-club__join-suffix-heading"
    }, [_vm._v("\n                                            I am already a SK Club member\n                                        ")]), _vm._v(" "), _c('sk-button', {
      attrs: {
        "primary": "",
        "dataContext": "Subscription Funnel",
        "dataValue": "Join Morvies Club"
      },
      nativeOn: {
        "click": function($event) {
          _vm.setSubsOption(item.Id)
        }
      }
    }, [_c('u', [_vm._v("Log in")]), _vm._v(" to subscribe to Subs Club\n                                        ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "sk-club__join-suffix-item"
    }, [_c('div', {
      staticClass: "sk-club__join-suffix-heading"
    }, [_vm._v("\n                                            I am "), _c('u', [_vm._v("NOT")]), _vm._v(" a SK Club member\n                                        ")]), _vm._v(" "), _c('sk-button', {
      attrs: {
        "primary": "",
        "dataContext": "Subscription Funnel",
        "dataValue": "Join Morvies Club"
      },
      nativeOn: {
        "click": function($event) {
          _vm.setSubsOption(item.Id, true)
        }
      }
    }, [_c('u', [_vm._v("Sign up")]), _vm._v(" to subscribe to Subs Club\n                                        ")])], 1)])])], 1)] : _vm._e()], 2)
  }))], 1)], 1), _vm._v(" "), _c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('sk-layout', {
    staticClass: "subs-club-benefits",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "benefit",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('div', {
    staticClass: "sk-club__reward-icons--title"
  }, [_c('h2', [_vm._v("Be one of the first")])]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--sub-title"
  }, [_vm._v("\n                            Experience the brand-new way of enjoying movies and cinema.\n                            Valid for the standard 2D and 3D shows only.\n                        ")]), _vm._v(" "), _c('div', [_vm._v("Available for online bookings.")])])])], 1), _vm._v(" "), _c('sk-flex', {
    staticClass: "benefit",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('h3', [_vm._v("EACH TICKET GETS YOU")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__join"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_vm._v("20% OFF A REGULAR COMBO")])])])])], 1), _vm._v(" "), _c('sk-flex', {
    staticClass: "benefit",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('div', {
    staticClass: "sk-club__reward-icons--title"
  }, [_c('h2', [_vm._v("SK CLUB BENEFITS")])]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--sub-title"
  }, [_vm._v("\n                            By being part of Subscription Club you will automatically be eligible for SK Club benefits!\n                            So not only can you watch more movies for less, but you get points every time you do.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "fine-print"
  }, [_vm._v("T's & C's apply (60+ do not earn points)")])])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(706),
  /* template */
  __webpack_require__(707),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_meta_data_js__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["default"] = ({

    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_meta_data_js__["a" /* default */]],

    data: function data() {
        return {
            order: null,
            movie: {},
            cinema: {},
            session: undefined,
            stepType: "subscribe",
            stepNames: [{
                step: 1,
                text: 'Subscription Summary'
            }, {
                step: 2,
                text: 'Confirm Your Details'
            }]
        };
    },


    computed: {
        step: function step() {
            return parseInt(this.$route.path.split('/').pop());
        }
    },
    methods: {},
    created: function created() {
        if (this.step < 1 || !this.step || this.step == NaN) {
            this.$router.push('/donate/1');
        }
        this.metaTitle = '';
        this.metaDescription = '';
    }
});

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-progress-steps', {
    attrs: {
      "step-type": _vm.stepType,
      "num-steps": 2,
      "current-step": _vm.step,
      "step-names": _vm.stepNames
    }
  })], 1)], 1), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": "20"
    }
  }), _vm._v(" "), _c('sk-layout', {
    staticClass: "gutter-30",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "sk-slide-x-transition"
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "grow": ""
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(709),
  /* template */
  __webpack_require__(710),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_meta_data_js__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            user: null,
            subsClub: null,
            showFacebookPixel: false
        };
    },


    methods: {
        setUser: function setUser() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user().then(function (user) {
                _this.user = user;
                _this.isGuest = user.isGuest();
                if (!user.isGuest() && user.MembershipActivated === false && _this.first_time) {} else {}

                return _this.user;
            });
        },
        getSubsData: function getSubsData() {
            var subsClubRaw = window.localStorage.getItem('subsClub');

            var subsClub = null;
            if (subsClubRaw && subsClubRaw != undefined) {
                subsClub = JSON.parse(subsClubRaw);
            }

            this.subsClub = subsClub;
            return subsClub;
        },
        continueToBook: function continueToBook() {
            this.$router.push('/');
        },
        continueToDashboard: function continueToDashboard() {
            this.$router.push('/user/profile');
        },
        faceBookPixel: function faceBookPixel() {
            !function (f, b, e, v, n, t, s) {
                if (f.fbq) return;n = f.fbq = function () {
                    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;n.push = n;n.loaded = !0;n.version = '2.0';
                n.queue = [];t = b.createElement(e);t.async = !0;
                t.src = v;s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
            }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1442556416455138');
            fbq('track', 'PageView');

            this.showFacebookPixel = true;

            return this.showFacebookPixel;
        }
    },

    created: function created() {
        var _this2 = this;

        console.log(this.$route);
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.setUser(), this.getSubsData(), this.faceBookPixel()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
                user = _ref2[0],
                subs = _ref2[1],
                faceBookPixel = _ref2[2];

            _this2.loading = false;
        });
    }
});

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [(_vm.showFacebookPixel) ? _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "src": "https://www.facebook.com/tr?id=1442556416455138&ev=PageView&noscript=1"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "subscription-summary"
  }, [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('h2', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Thank you, " + _vm._s(_vm.user.FirstName) + " " + _vm._s(_vm.user.LastName))]), _vm._v(" "), (_vm.subsClub.item.Description.includes('Unlimited')) ? [_c('h4', [_vm._v("You're officially part of the MORvies Club!")]), _vm._v(" "), _c('p', [_vm._v("Check your mails. We'll be sending your eCard, which you can use to redeem your SK MORvies Club benefits when booking online.")])] : [_c('h4', [_vm._v("You're officially part of the Fan Club!")]), _vm._v(" "), _c('p', [_vm._v("Check your mails. We'll be sending your eCard, which you can use to redeem your SK Fan Club benefits when booking online.")])]], 2), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('sk-button', {
    staticClass: "subs-summary-dashboard-link",
    attrs: {
      "primary": "",
      "block": (_vm.$breakpoints.xs)
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.continueToDashboard()
      }
    }
  }, [_vm._v("VIEW MY DASHBOARD")])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.subsClub.item != undefined) ? [(_vm.subsClub.item.Description.includes('Unlimited')) ? [_c('h3', [_vm._v("Unlimited movie tickets per month")]), _vm._v(" "), _c('h5', [_vm._v("Watch as many 2D or 3D movies as you want all month long.")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive fan-img img-option",
    attrs: {
      "src": "/static/img/morvies_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("UNLIMITED MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                                Watch up to 5 movies a day, every day!\n                                            ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("COME AS OFTEN AS YOU CAN")]), _vm._v(" "), _c('br'), _vm._v("\n                                                1 ticket per movie per card holder\n                                            ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                                20% off a regular combo\n                                            ")])])], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")]), _vm._v(" "), _c('br')])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "sx12": "",
      "md8": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sx12": "",
      "md4": ""
    }
  }, [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "block": (_vm.$breakpoints.xs)
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.continueToBook()
      }
    }
  }, [_vm._v("BOOK WITH SK MORVIES CLUB")])], 1)], 1)] : [(_vm.subsClub.item.Description.includes('Limited')) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h3', [_vm._v("Limited movies per month")]), _vm._v(" "), _c('h5', [_vm._v("Get 4 2D or 3D movie tickets per month for you and your family.")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__join"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.subsClub.item.Price) + " "), _c('span', [_vm._v("per month")])])])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive fan-img img-option",
    attrs: {
      "src": "/static/img/fan_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("4 MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                                    You watch more for less\n                                                ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("IDEAL FOR THE FAMILY")]), _vm._v(" "), _c('br'), _vm._v("\n                                                    Use one or all four tickets at once\n                                                ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                                    20% off a regular combo\n                                                ")])])], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")])])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "sx12": "",
      "md8": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sx12": "",
      "md4": ""
    }
  }, [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "block": (_vm.$breakpoints.xs)
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.continueToBook()
      }
    }
  }, [_vm._v("BOOK WITH SK FAN CLUB")])], 1)], 1)] : _vm._e()]] : _vm._e()], 2)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(712),
  /* template */
  __webpack_require__(713),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_meta_data_js__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            user: null,
            subsClub: null
        };
    },


    methods: {
        setUser: function setUser() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user().then(function (user) {
                _this.user = user;
                _this.isGuest = user.isGuest();
                if (!user.isGuest() && user.MembershipActivated === false && _this.first_time) {} else {}

                return _this.user;
            });
        },
        getSubsData: function getSubsData() {
            var subsClubRaw = window.localStorage.getItem('subsClub');

            var subsClub = null;
            if (subsClubRaw && subsClubRaw != undefined) {
                subsClub = JSON.parse(subsClubRaw);
            }

            this.subsClub = subsClub;
            return subsClub;
        },
        backToPayment: function backToPayment() {
            this.$router.push('/subscribe/2?debitDay=' + this.$route.query.debitDay);
        },
        backToDetails: function backToDetails() {
            this.$router.push('/subscription-club');
        }
    },

    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.setUser(), this.getSubsData()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                user = _ref2[0],
                subs = _ref2[1];

            _this2.loading = false;
        });
    }
});

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "subscription-summary"
  }, [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('h2', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Sorry, " + _vm._s(_vm.user.FirstName) + " " + _vm._s(_vm.user.LastName))]), _vm._v(" "), _c('h4', [_vm._v("Something appears to have gone wrong with the payment.")]), _vm._v(" "), _c('p', [_vm._v("Please try again, or contact our customer care line at 0861 MOVIES.")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.subsClub != undefined && _vm.subsClub != null) ? [(_vm.subsClub.item != undefined) ? [(_vm.subsClub.item.Description.includes('Unlimited')) ? [_c('h3', [_vm._v("Unlimited movie tickets per month")]), _vm._v(" "), _c('h5', [_vm._v("Watch as many 2D or 3D movies as you want all month long.")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive fan-img img-option",
    attrs: {
      "src": "/static/img/morvies_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("UNLIMITED MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t                                                    Watch up to 5 movies a day, every day!\n\t\t\t                                                ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("COME AS OFTEN AS YOU CAN")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t                                                    1 ticket per movie per card holder\n\t\t\t                                                ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t                                                    20% off a regular combo\n\t\t\t                                                ")])])], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")]), _vm._v(" "), _c('br')])])], 1)], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "sx12": "",
      "md8": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sx12": "",
      "md4": ""
    }
  }, [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "block": (_vm.$breakpoints.xs)
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.backToPayment()
      }
    }
  }, [_vm._v("BACK TO PAYMENT")])], 1)], 1)], 1)], 1)] : [(_vm.subsClub.item.Description.includes('Limited')) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h3', [_vm._v("Limited movies per month")]), _vm._v(" "), _c('h5', [_vm._v("Get 4 2D or 3D movie tickets per month for you and your family.")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__join"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.subsClub.item.Price) + " "), _c('span', [_vm._v("per month")])])])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive fan-img img-option",
    attrs: {
      "src": "/static/img/fan_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("4 MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t                                                        You watch more for less\n\t\t\t                                                    ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("IDEAL FOR THE FAMILY")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t                                                        Use one or all four tickets at once\n\t\t\t                                                    ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t                                                        20% off a regular combo\n\t\t\t                                                    ")])])], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CIMENAS")])])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "sx12": "",
      "md7": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sx12": "",
      "md5": ""
    }
  }, [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "block": (_vm.$breakpoints.xs)
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.backToPayment()
      }
    }
  }, [_vm._v("BACK TO PAYMENT")])], 1)], 1)] : _vm._e()]] : _vm._e()] : [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "sx12": "",
      "md7": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sx12": "",
      "md5": ""
    }
  }, [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "block": (_vm.$breakpoints.xs)
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.backToDetails()
      }
    }
  }, [_vm._v("BACK TO DETAILS")])], 1)], 1)]], 2)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(715),
  /* template */
  __webpack_require__(716),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ua_parser_js__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ua_parser_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ua_parser_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_meta_data_js__ = __webpack_require__(5);









/* harmony default export */ __webpack_exports__["default"] = ({

    mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_meta_data_js__["a" /* default */]],

    data: function data() {
        return {
            selected_cinema: null,
            selected_region: null,
            regions: null,
            filtered_regions: null,
            availableCinemas: [],
            cinemasByRegion: [],
            allowedRegions: null,
            cinemasNearby: null,
            injected_regions: null,
            loading: true
        };
    },


    methods: {
        setCinemasByRegion: function setCinemasByRegion(raw_regions) {
            var _this = this;

            var filter_cinemas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var allowedRegions = [];

            if (raw_regions && raw_regions != null && raw_regions != undefined) {

                if ((typeof raw_regions === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(raw_regions)) == "object" && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(raw_regions).length) {

                    allowedRegions = raw_regions.map(function (r) {
                        var cinemas = r.cinemas.filter(function (c) {
                            return ~_this.availableCinemas.indexOf(c.id.toString()) || _this.availableCinemas.length == 0;
                        });
                        return {
                            id: r.id,
                            name: r.name,
                            cinemas: cinemas
                        };
                    }).filter(function (r) {
                        return r.cinemas.length > 0;
                    });
                }
            }

            var regions = [];
            if (filter_cinemas != null) {
                if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(filter_cinemas).length > 0) {
                    var sorted_filter_cineams = null;
                    var sorted_regions = null;
                    filter_cinemas = __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_middleware_api_service__["j" /* MovieService */].filterCinemasToRegionModel(filter_cinemas, allowedRegions);
                    sorted_filter_cineams = __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_middleware_api_service__["j" /* MovieService */].sortfilteredCinemasByDistance(filter_cinemas);

                    sorted_regions = __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_middleware_api_service__["j" /* MovieService */].sortRegionsByDistance(allowedRegions);

                    if (sorted_filter_cineams != null && sorted_filter_cineams != undefined) {
                        regions = [{ name: 'Cinemas', cinemas: sorted_filter_cineams }];
                    }

                    if (this.cinemasNearby != null) {
                        regions = [{ name: 'Cinemas Nearby', cinemas: this.cinemasNearby }].concat(regions);
                    }
                }
            } else {
                regions = allowedRegions;
                if (this.cinemasNearby != null) {
                    regions = [{ name: 'Cinemas Nearby', cinemas: this.cinemasNearby }].concat(regions);
                }
            }

            this.cinemasByRegion = regions;
        },
        filterRegionsAndCinemas: function filterRegionsAndCinemas() {
            if (!this.selected_cinema || this.selected_cinema == null) {
                this.filtered_regions = this.regions;
                window.history.pushState({}, null, "/find-cinemas");
                this.$router.push("/find-cinemas");
                return true;
            } else {
                var tmp_region = [];
                var tmp_cinema = null;

                for (var i = 0; i <= this.regions.length; i++) {
                    if (this.regions[i] != undefined) {
                        if (this.regions[i].cinemas != undefined) {
                            for (var c = 0; c <= this.regions[i].cinemas.length; c++) {
                                if (this.regions[i].cinemas[c] != undefined) {
                                    if (this.regions[i].cinemas[c].id == this.selected_cinema.id) {

                                        tmp_region.push(this.regions[i]);
                                        tmp_cinema = this.regions[i].cinemas[c];

                                        tmp_region[0].cinemas = new Array();
                                        tmp_region[0].cinemas.push(tmp_cinema);

                                        this.filtered_regions = tmp_region;

                                        console.log("filterred regions", tmp_region);
                                        this.setURL();
                                        return true;
                                    }
                                }
                            }
                        }
                    }
                }

                this.filtered_regions = this.regions;

                return true;
            }
        },
        setURL: function setURL() {
            if (this.selected_cinema || this.selected_cinema != null) {
                var path = window.location.path;

                console.log("URL path", path);

                var newPath = "/find-cinemas/" + this.selected_cinema.slug;

                console.log("new URL path", newPath);

                if (path == undefined || path != newPath) {

                    window.history.pushState({}, null, newPath);
                    this.$router.push(newPath);
                }
            }
        }
    },

    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getRegions()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
                regions = _ref2[0];

            if (regions.data) {
                _this2.regions = regions.data;
                _this2.loading = false;

                if (_this2.$route.params.cinema && _this2.$route.params.cinema != undefined && _this2.$route.params.cinema != null) {
                    console.log("route cinema", _this2.$route.params.cinema);
                    _this2.loading = true;

                    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getCinemaBySlug(_this2.$route.params.cinema)]).then(function (_ref3) {
                        var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 1),
                            selected_cinema = _ref4[0];

                        _this2.selected_cinema = selected_cinema;
                        _this2.filterRegionsAndCinemas();
                        _this2.setCinemasByRegion(regions.data);
                        _this2.loading = false;
                    });
                } else {
                    if (_this2.selected_cinema) {} else {
                        _this2.filtered_regions = regions.data;
                        _this2.setCinemasByRegion(regions.data);
                    }
                }
            }
        });
    },
    mounted: function mounted() {
        window.scroll({ top: 0, left: 0 });
        if (window.__PRERENDER_INJECTED) {
            if (window.__PRERENDER_INJECTED.regions) {
                var _injected_regions = __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_middleware_api_service__["n" /* RegionService */].setPreRenderRegions(window.__PRERENDER_INJECTED.regions);
                this.selected_cinema = __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getCinemaBySlug(this.$route.params.cinema);
                if (this.selected_cinema) {
                    this.metaTitle = this.selected_cinema.name;
                    this.metaDescription = 'View information about ' + this.selected_cinema.name + ' at Ster-Kinekor';
                    this.metaCanonicalURL = "https://www.sterkinekor.com/find-cinemas/" + this.selected_cinema.slug;
                }

                this.injected_regions = _injected_regions;
                this.regions = _injected_regions.data;
                if (this.regions != undefined && this.regions != null) {
                    this.setCinemasByRegion(this.regions);
                    this.filterRegionsAndCinemas();
                }
            } else {
                injected_regions = undefined;
            }
        }
    },


    watch: {
        selected_cinema: {
            handler: __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_ui_core__["Utils"].debounce(function () {
                this.metaTitle = this.selected_cinema.name;
                this.metaDescription = 'View information about ' + this.selected_cinema.name + ' at Ster-Kinekor';
                this.metaCanonicalURL = "https://www.sterkinekor.com/find-cinemas/" + this.selected_cinema.slug;
                this.$emit('updateHead');
                this.filterRegionsAndCinemas();
            }, 300)
        }
    }
});

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Find a Cinema")]), _vm._v(" "), _c('h3', [_vm._v("Below you can find all our cinemas and the relevant contact information for each.")])]), _vm._v(" "), _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "gutter-40": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "gutter-40": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Select a Cinema")]), _vm._v(" "), (_vm.cinemasByRegion) ? _c('sk-multi-select-regions', {
    staticClass: "filter-select form-group",
    attrs: {
      "val": _vm.selected_cinema,
      "items": _vm.cinemasByRegion
    },
    model: {
      value: (_vm.selected_cinema),
      callback: function($$v) {
        _vm.selected_cinema = $$v
      },
      expression: "selected_cinema"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sm6": ""
    }
  })], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br'), _vm._v(" "), (_vm.regions && _vm.regions != undefined) ? [_vm._l((_vm.filtered_regions), function(region) {
    return [_c('address', [_c('h4', [_vm._v(_vm._s(region.name))]), _vm._v(" "), (region.cinemas) ? [(region.cinemas != undefined) ? [(region.cinemas.length > 0) ? _vm._l((region.cinemas), function(cinema) {
      return _c('sk-panel', {
        key: cinema.id,
        attrs: {
          "transparent": ""
        }
      }, [_c('h5', [_c('a', {
        staticStyle: {
          "text-decoration": "none"
        },
        attrs: {
          "href": '/find-cinemas/' + cinema.slug
        }
      }, [_vm._v(_vm._s(cinema.name))])]), _vm._v(" "), (cinema.address_1 != undefined && cinema.address_2 != undefined && cinema.city != undefined) ? _c('p', [(cinema.address_1 && cinema.address_2 && cinema.city) ? [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tAddress: "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(cinema.address_1) + ", "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(cinema.address_2) + ", "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(cinema.city) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")] : [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tAddress: "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t185 Katerine Street, "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEastgate Ext.4, "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tSandton\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]], 2) : _vm._e(), _vm._v(" "), (cinema.phone != undefined) ? _c('p', [(cinema.phone) ? [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tContact the cinema: " + _vm._s(cinema.phone) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")] : [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tContact the cinema: 0861 MOVIES (668437)\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]], 2) : _vm._e()])
    }) : [_c('p', [_vm._v("No cinemas available for this region.")])]] : _vm._e()] : _vm._e(), _vm._v(" "), _c('hr')], 2)]
  })] : _vm._e()], 2)], 1)], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(718),
  /* template */
  __webpack_require__(719),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		numSteps: Number,
		currentStep: Number,
		stepNames: Array,
		noTick: Boolean,
		stepType: String
	},

	computed: {
		progress: function progress() {
			return this.currentStep / this.numSteps * 100;
		}
	},

	methods: {
		back: function back(step) {
			if (this.stepType == "booking") {
				if (step < this.currentStep) {
					this.$router.push('/booking/' + step + (this.$route.params.festival_id ? '/film-festival/' + this.$route.params.festival_id : ''));
				}
			} else {
				this.$router.push("/" + this.stepType + "/" + step);
			}
		}
	}
});

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-steps"
  }, [_c('sk-progress-linear', {
    staticClass: "progress-steps__bar",
    attrs: {
      "height": (_vm.$breakpoints.xs ? 6 : 10),
      "value": _vm.progress
    }
  }), _vm._v(" "), _vm._l((_vm.numSteps), function(step) {
    return [_c('div', {
      staticClass: "progress-steps__wrapper",
      class: {
        'progress-steps__step--active': step <= _vm.currentStep, 'progress-steps__step--current': step == _vm.currentStep, 'progress-steps__step--complete': step < _vm.currentStep
      }
    }, [_c('div', {
      staticClass: "progress-steps__step"
    }, [(_vm.noTick) ? [_c('h4', {
      staticClass: "progress-steps__step-number"
    }, [_vm._v(_vm._s(step))])] : [(step < _vm.currentStep) ? _c('sk-icon', {
      attrs: {
        "tick-check": ""
      }
    }) : _c('h4', {
      staticClass: "progress-steps__step-number"
    }, [_vm._v(_vm._s(step))])]], 2), _vm._v(" "), (_vm.stepNames) ? _c('div', _vm._l((_vm.stepNames), function(name) {
      return (step == name.step) ? _c('span', {
        staticClass: "progress-steps__title",
        domProps: {
          "innerHTML": _vm._s(name.text)
        }
      }) : _vm._e()
    })) : _vm._e()])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(721)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(722),
  /* template */
  __webpack_require__(723),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hasta_la_vista_middleware_api_model__ = __webpack_require__(19);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            loading: false,
            loadingLoyalties: false,
            loadingAnotherMovie: false,
            loadingUpdateOrder: false,
            updateOrderLoading: false,
            toggleDialog: false,
            cancelAddOrderDialog: false,
            dialogMsg: undefined,
            seatingDialog: false,
            order: null,
            seats: null,
            seatGrid: [],
            movies: [],
            areas: null,
            maxTickets: 19,
            selectedSeats: [],
            showMovieAdder: false,
            selectedMovie: null,
            selectedExperience: null,
            selectedDate: null,
            selectedSession: null,
            cinemaType: null,
            rows: [],
            currentCinema: null,
            cinema_id: null,
            session_id: null,
            seatSelectable: true,
            maxTotal: 5000,
            screen_name: null,
            cinema_name: null,
            subsComboDialog: false,
            facebookPixelSKShow: false,
            floodLightShow: false,
            floodlightPixel: null,
            validators: [{
                message: "<strong>Movies are best enjoyed together</strong>. Please choose seats that don’t leave a single space.",
                test: function test() {
                    for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this.order.Session.positions).length; i++) {
                        var row = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this.order.Session.positions)[i];

                        var position = _this.order.Session.positions[row];
                        position.sort(function (a, b) {
                            return parseFloat(a) - parseFloat(b);
                        });
                        var lastPos = undefined;
                        for (var j = 0; j < position.length; j++) {
                            var thisPos = position[j];
                            if (lastPos) {
                                var Difference = Math.abs(thisPos - lastPos);
                                if (Difference > 1) return false;
                            }
                            lastPos = thisPos;
                        }
                    }

                    return true;
                }
            }, {
                message: "The companion seat is for a wheelchair assistant. You unfortunately cannot book this seat without booking a wheelchair seat as well.",
                test: function test() {

                    return true;
                    var foundWheelChair = false;
                    var foundCompanion = false;
                    for (var i = 0; i < _this.order.Session.Tickets.length; i++) {
                        var ticket = _this.order.Session.Tickets[i];
                        if (ticket.status.wheelchair == true) foundWheelChair = true;
                        if (ticket.status.companion == true) foundCompanion = true;
                    }
                    if (foundCompanion && !foundWheelChair) return false;else return true;
                }
            }, {
                message: "Hmm, looks like there are more Movie Cards than seats. Please add seats or remove Movie Cards to continue with your booking.",
                test: function test() {
                    return !(_this.order.Session.Loyalties.length > _this.order.Session.Tickets.length);
                }

            }, {
                message: "You can only use your Edgars card for two movie tickets.",
                test: function test() {
                    var numTicketsPerCard = {};
                    for (var i = 0; i < _this.order.Session.Loyalties.length; i++) {
                        var loyalty = _this.order.Session.Loyalties[i];
                        if (loyalty.TicketType.ThirdPartyMembershipName == "Edgars Redemption") {
                            numTicketsPerCard[loyalty.MemberCard] = numTicketsPerCard[loyalty.MemberCard] || 0;
                            numTicketsPerCard[loyalty.MemberCard]++;
                            if (numTicketsPerCard[loyalty.MemberCard] > 2) return false;
                        }
                    }
                    return true;
                }

            }, {
                message: "You can only use your Vitality card once per Movie.",
                test: function test() {
                    var numTicketsPerCard = {};
                    for (var i = 0; i < _this.order.Session.Loyalties.length; i++) {
                        var loyalty = _this.order.Session.Loyalties[i];
                        if (~loyalty.TicketType.ThirdPartyMembershipName.toLowerCase().indexOf("vitality")) {
                            numTicketsPerCard[loyalty.MemberCard] = numTicketsPerCard[loyalty.MemberCard] || 0;
                            numTicketsPerCard[loyalty.MemberCard]++;
                            if (numTicketsPerCard[loyalty.MemberCard] > 1) return false;
                        }
                    }
                    return true;
                }

            }, {
                message: "Please select at least one seat to continue.",
                test: function test() {
                    return _this.order.Session.Tickets.length > 0;
                }
            }, {
                test: function test() {
                    var success = true,
                        message = "One or more cards requires more seats than you have available";
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this.order.Session.Loyalties), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var loyalty = _step.value;

                            var requirements = loyalty.TicketType.PackageContent;
                            if (requirements && requirements.Tickets.length > 0) {
                                var quantity = 1;
                                var fourForThree = false;
                                for (var i in requirements.Tickets) {
                                    if (requirements.Tickets[i].Description.includes("4FOR3")) {
                                        fourForThree = true;
                                    }
                                }

                                if (fourForThree) {
                                    var _iteratorNormalCompletion2 = true;
                                    var _didIteratorError2 = false;
                                    var _iteratorError2 = undefined;

                                    try {
                                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(requirements.Tickets), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                            var requirement = _step2.value;

                                            if (requirement.Quantity) quantity += requirement.Quantity;
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                                _iterator2.return();
                                            }
                                        } finally {
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }

                                    if (_this.order.Session.Tickets.length < quantity) {
                                        success = false;
                                        var qMessage = ' ' + quantity + ' tickets, in addition to any other loyalty seats you have selected.';
                                        message = 'In order to use the ' + loyalty.TicketType.Description + ' recognition, you need at least ' + qMessage;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    return { success: success, message: message };
                }
            }],
            festival: null
        };
    },


    computed: {
        regions: function regions() {
            return [{ name: 'Nearby', cinemas: this.cinemasNearBy }].concat(this.regionsRaW);
        },
        sessionsForCinema: function sessionsForCinema() {
            var _this2 = this;

            return this.selectedExperience ? this.selectedMovie.cinemas[this.cinema_id].filter(function (s) {
                return ~s.experiences.findIndex(function (e) {
                    return e.name == _this2.selectedExperience;
                });
            }) : [];
        },
        availableDates: function availableDates() {
            var avail = this.sessionsForCinema.reduce(function (c, session) {
                var obj = {
                    string: session.show_time.additional.string_long_day_of_week + ' ' + session.show_time.additional.string_nth_day + ' ' + session.show_time.additional.string_long_month,
                    show_time: session.show_time
                };
                !~c.findIndex(function (c) {
                    return c.string === obj.string;
                }) && c.push(obj);
                return c;
            }, []);

            if (!this.selectedDate && avail.length > 0) this.setSelectedDate(avail[0].show_time.date);
            return avail;
        },
        availableSessions: function availableSessions() {
            var _this3 = this;

            var sessions = this.selectedDate && this.sessionsForCinema.length > 0 ? this.sessionsForCinema.filter(function (session) {
                return session.show_time.date.format('YYYY-MM-DD') === _this3.selectedDate.format('YYYY-MM-DD');
            }) : [];
            if (!this.selectedSession && sessions.length > 0) this.setSelectedSession(sessions[0]);
            return sessions;
        },
        canBook: function canBook() {
            return !!this.selectedSession;
        },
        seatCount: function seatCount() {
            return this.maxTickets - this.order.Tickets.length;
        },
        moviesGrouped: function moviesGrouped() {
            var filmFestivals = this.order ? this.order.Sessions.reduce(function (c, s) {
                if (s.movie) c = c.concat(s.movie.film_festivals);
                return c;
            }, []) : [];

            if (filmFestivals.length > 0) {
                var sessionMovies = this.order.Sessions.map(function (s) {
                    return s.movie.id;
                });
                var ffMovies = this.movies.filter(function (m) {
                    return filmFestivals.find(function (f) {
                        return m.film_festivals.includes(f);
                    }) && !~sessionMovies.indexOf(m.id);
                });
                var nMovies = this.movies.filter(function (m) {
                    return !ffMovies.includes(m) && !~sessionMovies.indexOf(m.id);
                });
                return [{ name: 'Related Film Festival Movies:', movies: ffMovies }, {
                    name: 'Other Movies Now Showing',
                    movies: nMovies
                }];
            }

            return [];
        },
        fanLoyaltyCountAdded: function fanLoyaltyCountAdded() {
            var count = 0;

            if (this.order != undefined && this.order != null) {
                if (this.order.Session.Loyalties != undefined && this.order.Session.Loyalties != null) {
                    for (var i = 0; i <= this.order.Session.Loyalties.length; i++) {
                        if (this.order.Session.Loyalties[i] != undefined && this.order.Session.Loyalties[i] != null) {

                            if (this.order.Session.Loyalties[i].TicketType.Description.includes('Fan Club') && this.order.Session.Loyalties[i].TicketType.Description.includes('Combo')) {
                                count++;
                            }
                        }
                    }
                }
            }

            return count;
        },
        morviesLoyaltyCountAdded: function morviesLoyaltyCountAdded() {
            var count = 0;

            if (this.order != undefined && this.order != null) {
                if (this.order.Session.Loyalties != undefined && this.order.Session.Loyalties != null) {
                    for (var i = 0; i <= this.order.Session.Loyalties.length; i++) {
                        if (this.order.Session.Loyalties[i] != undefined && this.order.Session.Loyalties[i] != null) {

                            if (this.order.Session.Loyalties[i].TicketType.Description.includes('MORvies') && this.order.Session.Loyalties[i].TicketType.Description.includes('Combo')) {
                                count++;
                            }
                        }
                    }
                }
            }

            return count;
        }
    },

    methods: {
        getStatus: function getStatus(session) {
            var status = true;
            if (session.seats_available == 0) {
                status = false;
            }
            return status;
        },
        getStatusString: function getStatusString(session) {
            var status = '';
            if (session.seats_available <= 10) {
                status = 'Limited Seats Available';
            } else if (session.seats_available == 0) {
                status = 'Sold Out';
            }
            return status;
        },
        setNearByCinemas: function setNearByCinemas(place) {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getCinemasNearBy(place.latitude, place.longitude).then(function (cinemasNearBy) {

                cinemasNearBy.length = 5;

                _this4.cinemasNearBy = cinemasNearBy;
            });
        },
        setSelectedDate: function setSelectedDate(date) {
            this.selectedDate = this.selectedDate === date ? null : date;
            this.selectedSession = null;
        },
        setSelectedSession: function setSelectedSession(session) {
            if (this.getStatus(session)) this.selectedSession = this.selectedSession === session ? null : session;
        },
        selectable: function selectable(seat) {
            if (this.seatSelectable) {
                if (this.seatCount > 0 && ~(this.seatCount - seat.seats.length)) {
                    this.seatSelectable = true;
                    return true;
                } else {
                    this.seatingDialog = true;
                    this.seatSelectable = false;
                    return false;
                }
            } else {
                return false;
            }
        },
        setSeat: function setSeat(seat, isActive, canceller) {
            var _this5 = this;

            this.loading = true;
            this.order._loading = true;
            for (var i = 0; i < seat.seats.length; i++) {
                var thisSeat = seat.seats[i];
                if (!thisSeat.ticket && isActive) {
                    if (thisSeat.SeatStyle !== 3 && thisSeat.SeatsInGroup == null) {
                        this.order.addVistaSeatsForTicket(thisSeat, seat).then(function (order) {
                            _this5.order = order;
                            _this5.order.loadSeatGrid().then(function () {
                                _this5.order.Session.SeatGrid.mapTicketsToGrid(_this5.order.Tickets);
                                _this5.loading = false;
                                _this5.order._loading = false;
                            });
                        });
                    } else if (thisSeat.SeatStyle === 3 && thisSeat.SeatsInGroup.length > 0) {

                        if (thisSeat.SeatsInGroup.length > 1) {
                            var thisSeatOne = thisSeat;
                            thisSeatOne.Position.AreaNumber = thisSeat.SeatsInGroup[0].AreaNumber;
                            thisSeatOne.Position.ColumnIndex = thisSeat.SeatsInGroup[0].ColumnIndex;
                            thisSeatOne.Position.RowIndex = thisSeat.SeatsInGroup[0].RowIndex;

                            this.order.addVistaSeatsForTicket(thisSeatOne, seat).then(function (order) {
                                var thisSeatTwo = thisSeat;
                                thisSeatTwo.Position.AreaNumber = thisSeat.SeatsInGroup[1].AreaNumber;
                                thisSeatTwo.Position.ColumnIndex = thisSeat.SeatsInGroup[1].ColumnIndex;
                                thisSeatTwo.Position.RowIndex = thisSeat.SeatsInGroup[1].RowIndex;
                                _this5.order.addVistaSeatsForTicket(thisSeatTwo, seat).then(function (order) {
                                    _this5.order = order;
                                    _this5.order.loadSeatGrid().then(function () {
                                        _this5.order.Session.SeatGrid.mapTicketsToGrid(_this5.order.Tickets);
                                        _this5.loading = false;
                                        _this5.order._loading = false;
                                    });
                                });
                            });
                        }
                    }
                } else if (thisSeat.ticket && !isActive) {
                    if (thisSeat.SeatStyle !== 3 && thisSeat.SeatsInGroup == null) {
                        this.order.removeVistaSeatsForTicket(thisSeat, seat, thisSeat.ticket.TicketTypeCode).then(function (order) {
                            _this5.order = order;
                            _this5.order.loadSeatGrid().then(function () {
                                _this5.order.Session.SeatGrid.mapTicketsToGrid(_this5.order.Tickets);
                                _this5.loading = false;
                                _this5.order._loading = false;
                            });
                        });
                    } else if (thisSeat.SeatStyle === 3 && thisSeat.SeatsInGroup.length > 0) {
                        var _thisSeatOne = thisSeat;
                        _thisSeatOne.Position.AreaNumber = thisSeat.SeatsInGroup[0].AreaNumber;
                        _thisSeatOne.Position.ColumnIndex = thisSeat.SeatsInGroup[0].ColumnIndex;
                        _thisSeatOne.Position.RowIndex = thisSeat.SeatsInGroup[0].RowIndex;
                        this.order.removeVistaSeatsForTicket(_thisSeatOne, seat, _thisSeatOne.ticket.TicketTypeCode).then(function (order) {
                            var thisSeatTwo = thisSeat;
                            thisSeatTwo.Position.AreaNumber = thisSeat.SeatsInGroup[1].AreaNumber;
                            thisSeatTwo.Position.ColumnIndex = thisSeat.SeatsInGroup[1].ColumnIndex;
                            thisSeatTwo.Position.RowIndex = thisSeat.SeatsInGroup[1].RowIndex;
                            _this5.order.removeVistaSeatsForTicket(thisSeatTwo, seat, thisSeatTwo.ticket.TicketTypeCode).then(function (order) {
                                _this5.order = order;
                                _this5.order.loadSeatGrid().then(function () {
                                    _this5.order.Session.SeatGrid.mapTicketsToGrid(_this5.order.Tickets);
                                    _this5.loading = false;
                                });
                            });
                        });
                    }
                }
            }

            if (!this.seatSelectable) {
                this.seatSelectable = true;
            }
        },
        setSelectedExperience: function setSelectedExperience(exp) {
            this.selectedExperience = exp;
            this.selectedDate = null;
            this.selectedSession = null;
        },
        tearDownAddOrder: function tearDownAddOrder() {
            this.selectedSession = null;
            this.selectedMovie = null;
            this.selectedExperience = null;
            this.selectedDate = null;
            this.selectedDate = null;
        },
        addOrder: function addOrder() {
            var _this6 = this;

            this.loading = true;
            this.showMovieAdder = false;
            window.scroll({ top: 0, left: 0 });
            __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].addToOrder(this.selectedSession.id, this.cinema_id, this.selectedMovie.id).then(function (order) {

                if (!_this6.order.Session.SeatGridPromise) _this6.order.loadSeatGrid().then(function () {
                    return _this6.loading = false;
                }, function () {
                    return _this6.loading = false;
                });else _this6.loading = false;
                _this6.tearDownAddOrder();
            }, function () {
                _this6.loading = false;
                _this6.updateOrderLoading = false;
            });
        },
        cancelAddOrder: function cancelAddOrder() {
            this.tearDownAddOrder();
            this.showMovieAdder = false;
            this.cancelAddOrderDialog = false;
        },
        showAddMovieForm: function showAddMovieForm() {
            var _this7 = this;

            __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getCinema(this.cinema_id).then(function (cinema) {
                _this7.currentCinema = cinema.name;
            });
            this.loadingAnotherMovie = true;
            this.validate().then(function () {
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getRegions(), __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovies(), __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getFilteredMovies({ cinemas: [_this7.cinema_id] })]).then(function (_ref) {
                    var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                        regions = _ref2[0],
                        movieDetails = _ref2[1];

                    var sessionMovies = _this7.order.Sessions.map(function (s) {
                        return s.movie.id;
                    });
                    _this7.movies = movieDetails.data.filter(function (m) {
                        return !~sessionMovies.indexOf(m.id) && m.cinemas[_this7.cinema_id] && m.cinemas[_this7.cinema_id].length > 0;
                    });
                    if (_this7.$route.params.festival_id) {
                        _this7.movies = movieDetails.data.filter(function (m) {
                            return m && ~m.film_festivals.indexOf(_this7.$route.params.festival_id) ? true : false;
                        });
                    }

                    if (_this7.order.modified) {
                        __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].saveTickets().then(function (order) {
                            window.scroll({ top: 0, left: 0 });
                            _this7.loadingAnotherMovie = false;
                            _this7.showMovieAdder = true;
                            _this7.order.loadSeatGrid();
                        });
                    } else {
                        window.scroll({ top: 0, left: 0 });
                        _this7.loadingAnotherMovie = false;
                        _this7.showMovieAdder = true;
                    }
                });
            }, function (error) {
                _this7.loading = false;
                _this7.loadingAnotherMovie = false;
                _this7.dialogMsg = "Please ensure your booking is valid before adding another movie <br> " + error;
                _this7.toggleDialog = true;
            });
        },
        validate: function validate() {
            var _this8 = this;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                for (var i = 0; i < _this8.validators.length; i++) {
                    var validator = _this8.validators[i];
                    var passed = validator.test();
                    var message = passed.message || validator.message;
                    var passedTest = typeof passed === 'boolean' ? passed : passed.success;

                    if (passedTest === false) {
                        return reject(message);
                    }
                }
                resolve(true);
            });
        },
        updateOrder: function updateOrder() {
            var _this9 = this;

            this.updateOrderLoading = true;
            this.subsComboDialog = false;
            if (!this.order.modified && this.order.hasTickets) {
                this.$router.push('/booking/2' + (this.$route.params.festival_id ? '/film-festival/' + this.$route.params.festival_id : ''));
            } else {

                this.validate().then(function () {
                    __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].saveTickets().then(function (order) {
                        _this9.loading = false;
                        _this9.$router.push('/booking/2' + (_this9.$route.params.festival_id ? '/film-festival/' + _this9.$route.params.festival_id : ''));
                    });
                }, function (error) {
                    _this9.updateOrderLoading = false;
                    _this9.dialogMsg = error;
                    _this9.toggleDialog = true;
                });
            }
        },
        facebookPixelSK: function facebookPixelSK() {
            !function (f, b, e, v, n, t, s) {
                if (f.fbq) return;n = f.fbq = function () {
                    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;n.push = n;n.loaded = !0;n.version = '2.0';
                n.queue = [];t = b.createElement(e);t.async = !0;
                t.src = v;s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
            }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1442556416455138');
            fbq('track', 'PageView');

            this.facebookPixelSKShow = true;
        },
        floodlightBlackWidow: function floodlightBlackWidow(movie_id) {
            if (movie_id == "HO00001971") {
                this.blackWidowFloodLightShow = true;
                gtag('event', 'conversion', {
                    'allow_custom_scripts': true,
                    'send_to': 'DC-4347362/sterk00/sterk0+unique'
                });
            } else {
                this.blackWidowFloodLightShow = false;
            }
        },
        floodlightInit: function floodlightInit(movie) {
            if (movie.floodlight_tag != undefined) {
                if (movie.floodlight_tag.length > 0) {
                    var a = eval(movie.floodlight_tag);
                    this.floodLightShow = true;
                    this.floodlightPixel = movie.floodlight_pixel;
                } else {
                    this.floodLightShow = true;
                }
            } else {
                this.floodLightShow = false;
            }
        }
    },

    created: function created() {
        var _this10 = this;

        this.loading = true;
        this.loadingLoyalties = true;
        this.updateOrderLoading = false;

        __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getOrder().then(function (order) {
            _this10.order = order;
            _this10.cinema_id = order.CinemaId;
            _this10.session_id = order.SessionId;

            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["j" /* MovieService */].findBySessionId(order.SessionId, order.CinemaId)).then(function (movie) {
                _this10.floodlightInit(movie);
            });

            _this10.facebookPixelSK();

            if (order.Session.MovieSession.cinema != undefined) _this10.screen_name = order.Session.MovieSession.screen_name;

            if (order.Session.MovieSession.cinema != undefined) _this10.cinema_name = order.Session.MovieSession.cinema.name;

            _this10.order.loadSeatGrid().then(function () {
                var tickets = _this10.order.TicketsForSeating;

                _this10.order.Session.SeatGrid.mapTicketsToGrid(tickets);


                _this10.loading = false;
            });

            if (_this10.$route.params.festival_id) {
                __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["l" /* PageService */].getFilmFestivals().then(function (festivals) {
                    _this10.festival = festivals.find(function (f) {
                        return f.nid === _this10.$route.params.festival_id;
                    });
                });
            }

            if (_this10.cinema_id == '1851' || _this10.cinema_id == '7871') {
                _this10.dialogMsg = 'Kindly be aware that there is a Visa/MasterCard administrative fee when booking.';
                _this10.toggleDialog = true;
            }
        });
    },
    mounted: function mounted() {
        window.scroll({ top: 0, left: 0 });
    },


    watch: {
        selectedMovie: function selectedMovie(el) {
            if (el) this.selectedExperience = el.getExperienceForCinema(this.cinema_id)[0];else this.selectedExperience = null;

            this.selectedDate = null;
            this.selectedSession = null;
        }
    }
});

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.showMovieAdder) ? _c('div', {
    staticClass: "seating"
  }, [_c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleDialog),
      callback: function($$v) {
        _vm.toggleDialog = $$v
      },
      expression: "toggleDialog"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.dialogMsg)
    }
  }), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": 20
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDialog = false;
      }
    }
  }, [_vm._v("Ok")])], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.seatingDialog),
      callback: function($$v) {
        _vm.seatingDialog = $$v
      },
      expression: "seatingDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.seatingDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.seatingDialog = false
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Thank you")]), _vm._v(" "), _c('p', [_vm._v("You've selected the maximum number of seats per single transaction. Should you wish to book more seats, please note you will have to make a separate transaction. Alternatively you can contact us on 0861 MOVIES (668437) and select Option 3 to book more than 19 seats in one transaction")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.seatingDialog = false
      }
    }
  }, [_vm._v("Got it")])], 1), _vm._v(" "), _c('div', {
    staticClass: "covid-message"
  }, [_c('sk-layout', {
    staticClass: "covid-wrapper",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-panel', {
    staticClass: "covid-panel"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "covid-icon-container",
    attrs: {
      "lg1": "",
      "md2": "",
      "sm2": "",
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "icon icon-combo"
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "covid-message-container",
    attrs: {
      "lg11": "",
      "md10": "",
      "sm10": "",
      "xs9": ""
    }
  }, [_c('p', [_vm._v("\n                                Reminder: You can order your snacks online after you have selected your seat or order them in cinema\n                            ")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), (_vm.floodLightShow) ? _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.floodlightPixel) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('sk-panel', [_c('h2', [_vm._v("Choose Your Seats")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.cinema_name) + " - " + _vm._s(_vm.screen_name))]), _vm._v(" "), (_vm.loading || (_vm.order && _vm.order.loading === true)) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', {
    staticClass: "seat_grid"
  }, [_c('p', {
    staticClass: "seating__screen seating__screen--top"
  }, [_vm._v("\n                    Screen\n                    "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/screen.png",
      "alt": "screen"
    }
  })]), _vm._v(" "), (_vm.order && _vm.order.Session && !_vm.loading && (_vm.order && !_vm.order.loading)) ? [(_vm.order && _vm.order.Session && !_vm.loading && (_vm.order && !_vm.order.loading)) ? _c('sk-seat-grid', {
    attrs: {
      "validate-changefn": _vm.selectable,
      "seat-grid": _vm.order.Session.SeatGrid.grid
    },
    on: {
      "seatChange": _vm.setSeat
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "seating__screen seating__screen--bottom"
  }, [_vm._v("\n                    Back of Cinema\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "seat-plan"
  }, [_c('p', [_vm._v("Seating Key")]), _vm._v(" "), _c('sk-list', {
    staticClass: "seat-grid",
    attrs: {
      "inline": ""
    }
  }, [_c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "selected": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("Selected")])], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "available": "",
      "empty": true
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("Available")])], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "sold": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("Sold")])], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "love-nest": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("Love nest")])], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "wheelchair": "",
      "available": "",
      "empty": true
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("Wheelchair")])], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "companion": "",
      "available": "",
      "empty": true
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("Companion")])], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "dbox": "",
      "available": "",
      "empty": true
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("DBox")])], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "kids": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("Kid's seat")])], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "selected_unavailable": "",
      "empty": true
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("Voucher or Loyalty")])], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "seating__content"
  }, [_vm._v("You've chosen " + _vm._s(_vm.order.Tickets.length) + " seat"), (_vm.order.Tickets.length != 1) ? [_vm._v("s")] : _vm._e()], 2)], 2)]), _vm._v(" "), (_vm.order && !_vm.loading && (_vm.order && !_vm.order.loading)) ? _c('sk-panel', [(_vm.order) ? _c('sk-loyalty', {
    attrs: {
      "order": _vm.order
    }
  }) : _vm._e(), _vm._v(" "), _c('sk-layout', {
    staticClass: "seating__btns",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.$breakpoints.smDown) ? _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": true,
      "block": _vm.$breakpoints.smDown,
      "loading": _vm.loadingAnotherMovie
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showAddMovieForm()
      }
    }
  }, [_vm._v("Add\n                    Another Movie\n                ")]), _vm._v(" "), (_vm.fanLoyaltyCountAdded > 0 || _vm.morviesLoyaltyCountAdded > 0) ? [_c('sk-button', {
    attrs: {
      "primary": true,
      "block": _vm.$breakpoints.smDown,
      "loading": _vm.updateOrderLoading
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.subsComboDialog = true
      }
    }
  }, [_vm._v("Continue\n                    ")])] : [_c('sk-button', {
    attrs: {
      "primary": true,
      "block": _vm.$breakpoints.smDown,
      "loading": _vm.updateOrderLoading
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.updateOrder()
      }
    }
  }, [_vm._v("Continue\n                    ")])]], 2)], 1) : _vm._e(), _vm._v(" "), _c('sk-dialog', {
    staticClass: "video",
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.subsComboDialog),
      callback: function($$v) {
        _vm.subsComboDialog = $$v
      },
      expression: "subsComboDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.subsComboDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.subsComboDialog = false
      }
    }
  }), _vm._v(" "), (_vm.morviesLoyaltyCountAdded > 0) ? _c('h3', [_vm._v("Subscription Club Combo")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Your subscription club combo has been successfully added to this booking.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.subsComboDialog = false;
        _vm.updateOrder();
      }
    }
  }, [_vm._v("\n                Okay\n            ")])], 1), _vm._v(" "), [(_vm.facebookPixelSKShow) ? _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "src": "https://www.facebook.com/tr?id=1442556416455138&ev=PageView&noscript=1"
    }
  }) : _vm._e()]], 2)], 1) : _c('div', {
    staticClass: "addMovie detail"
  }, [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "detail-cinema"
  }, [(_vm.festival) ? _c('h2', {
    staticClass: "detail-start-booking"
  }, [_vm._v("Add another " + _vm._s(_vm.festival.title) + " movie")]) : _c('h2', {
    staticClass: "detail-start-booking"
  }, [_vm._v("Add another movie")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('label', [_vm._v("Choose a Movie at " + _vm._s(_vm.currentCinema))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.festival) ? [(_vm.moviesGrouped[0].movies.length > 0) ? _c('sk-combo-select', {
    attrs: {
      "options": _vm.moviesGrouped,
      "group-values": "movies",
      "group-label": "name",
      "track-by": "name",
      "label": "name",
      "searchable": true,
      "placeholder": "Choose a movie"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.$groupLabel) ? [_vm._v("\n                                            " + _vm._s(props.option.$groupLabel) + "\n                                        ")] : _c('span', {
          staticClass: "option__title"
        }, [_c('span', {
          staticClass: "loyalty-card__form-option"
        }, [_c('img', {
          staticClass: "img-responsive",
          attrs: {
            "src": props.option.poster
          }
        })]), _vm._v("\n                                                " + _vm._s(props.option.title) + "\n                                        ")])]
      }
    }]),
    model: {
      value: (_vm.selectedMovie),
      callback: function($$v) {
        _vm.selectedMovie = $$v
      },
      expression: "selectedMovie"
    }
  }) : _c('p', [_vm._v("There are no available movies to add to the booking.")])] : [(_vm.moviesGrouped.length > 0) ? _c('sk-combo-select', {
    attrs: {
      "options": _vm.moviesGrouped,
      "group-values": "movies",
      "group-label": "name",
      "track-by": "name",
      "label": "name",
      "searchable": true,
      "placeholder": "Choose a movie"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.$groupLabel) ? [_vm._v("\n                                            " + _vm._s(props.option.$groupLabel) + "\n                                        ")] : _c('span', {
          staticClass: "option__title"
        }, [_c('span', {
          staticClass: "loyalty-card__form-option"
        }, [_c('img', {
          staticClass: "img-responsive",
          attrs: {
            "src": props.option.poster
          }
        })]), _vm._v("\n                                                " + _vm._s(props.option.title) + "\n                                        ")])]
      }
    }]),
    model: {
      value: (_vm.selectedMovie),
      callback: function($$v) {
        _vm.selectedMovie = $$v
      },
      expression: "selectedMovie"
    }
  }) : _c('sk-combo-select', {
    attrs: {
      "options": _vm.movies,
      "track-by": "id",
      "label": "title",
      "placeholder": "Choose a movie",
      "multiple": false
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', {
          staticClass: "option__title"
        }, [_c('span', {
          staticClass: "loyalty-card__form-option"
        }, [_c('img', {
          staticClass: "img-responsive",
          attrs: {
            "src": props.option.poster
          }
        })]), _vm._v("\n                                            " + _vm._s(props.option.title) + "\n                                    ")])]
      }
    }]),
    model: {
      value: (_vm.selectedMovie),
      callback: function($$v) {
        _vm.selectedMovie = $$v
      },
      expression: "selectedMovie"
    }
  })]], 2)], 1)], 1)]), _vm._v(" "), (_vm.selectedMovie) ? _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a Cinema Type")]), _vm._v(" "), _c('div', {
    staticClass: "detail-experience"
  }, [_c('sk-list', _vm._l((_vm.selectedMovie.getExperienceForCinema(_vm.cinema_id)), function(experience) {
    return _c('sk-list-tile', {
      key: experience.name,
      attrs: {
        "value": experience == _vm.selectedExperience
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.setSelectedExperience(experience)
        }
      }
    }, [_c('span', {
      staticClass: "label label--lg"
    }, [_vm._v(_vm._s(experience))])])
  }))], 1), _vm._v(" "), _c('hr')]) : _vm._e()], 1), _vm._v(" "), (_vm.availableDates.length > 0) ? _c('div', {
    staticClass: "detail-movie-select-date"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a Date and Time")]), _vm._v(" "), (_vm.availableDates.length <= 6 && !_vm.$breakpoints.xs) ? [_c('sk-layout', _vm._l((_vm.availableDates), function(session, index) {
    return _c('sk-flex', {
      key: session.id,
      attrs: {
        "sm2": "",
        "md2": "",
        "lg2": "",
        "grow": ""
      }
    }, [((session.show_time.additional.day == '01' || index == 0)) ? _c('div', {
      staticClass: "label__month"
    }, [(_vm.$breakpoints.mdDown) ? [_vm._v("\n                                " + _vm._s(session.show_time.additional.string_short_month) + "\n                            ")] : [_vm._v("\n                                " + _vm._s(session.show_time.additional.string_long_month) + "\n                            ")], _vm._v("\n                            " + _vm._s(session.show_time.additional.year) + "\n                        ")], 2) : _vm._e(), _vm._v(" "), _c('div', {
      ref: "session_time",
      refInFor: true,
      staticClass: "label label--lg",
      class: {
        active: session.show_time.date == _vm.selectedDate, 'btn-mask': true
      },
      attrs: {
        "id": session.id
      },
      on: {
        "click": function($event) {
          _vm.setSelectedDate(session.show_time.date);
        }
      }
    }, [_c('div', {
      staticClass: "detail-movie-select-date--date"
    }, [_c('div', {
      staticClass: "detail-movie-select-date--day"
    }, [_vm._v("\n                                    " + _vm._s(session.show_time.additional.day) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-date--month"
    }, [_vm._v("\n                                    " + _vm._s(session.show_time.additional.string_short_day_of_week) + "\n                                ")])])])])
  }))] : [_c('sk-carousel', {
    attrs: {
      "slides-per-page": (_vm.$breakpoints.smDown ? 3 : 6)
    }
  }, _vm._l((_vm.availableDates), function(session, index) {
    return _c('div', {
      key: session.id,
      staticClass: "slide",
      attrs: {
        "slot": "slides"
      },
      slot: "slides"
    }, [((session.show_time.additional.day == '01' || index == 0)) ? _c('div', {
      staticClass: "label__month"
    }, [(_vm.$breakpoints.mdDown) ? [_vm._v("\n                                " + _vm._s(session.show_time.additional.string_short_month) + "\n                            ")] : [_vm._v("\n                                " + _vm._s(session.show_time.additional.string_long_month) + "\n                            ")], _vm._v("\n                            " + _vm._s(session.show_time.additional.year) + "\n                        ")], 2) : _vm._e(), _vm._v(" "), _c('div', {
      ref: "session_time",
      refInFor: true,
      staticClass: "label label--lg",
      class: {
        active: session.show_time.date == _vm.selectedDate, 'btn-mask': true
      },
      attrs: {
        "id": session.id
      },
      on: {
        "click": function($event) {
          _vm.setSelectedDate(session.show_time.date);
        }
      }
    }, [_c('div', {
      staticClass: "detail-movie-select-date--date"
    }, [_c('div', {
      staticClass: "detail-movie-select-date--day"
    }, [_vm._v("\n                                    " + _vm._s(session.show_time.additional.day) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-date--month"
    }, [_vm._v("\n                                    " + _vm._s(session.show_time.additional.string_short_day_of_week) + "\n                                ")])])])])
  }))], _vm._v(" "), (_vm.selectedDate) ? _c('div', {
    staticClass: "detail-movie-select-time",
    class: (_vm.availableSessions.length >= 6) ? 'carousel' : ''
  }, [(_vm.availableSessions.length <= 6 && !_vm.$breakpoints.xs) ? [_c('sk-layout', _vm._l((_vm.availableSessions), function(session) {
    return _c('sk-flex', {
      key: session.id,
      attrs: {
        "grow": ""
      }
    }, [_c('span', {
      ref: "session_time",
      refInFor: true,
      staticClass: "label label--lg",
      class: {
        active: session == _vm.selectedSession, 'btn-mask': true, 'disabled': !_vm.getStatus(session)
      },
      attrs: {
        "id": session.id
      },
      on: {
        "click": function($event) {
          _vm.setSelectedSession(session);
        }
      }
    }, [_c('div', {
      staticClass: "detail-movie-select-time--time"
    }, [_vm._v("\n                                " + _vm._s(session.show_time.additional.no_zero_hour_24) + ":" + _vm._s(session.show_time.additional.minute) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-time--info"
    }, [_vm._v(_vm._s(_vm.getStatusString(session)))]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-time--info"
    }, [_vm._v(_vm._s(session.screen_name))]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-time--info"
    }, [_vm._v(_vm._s(session.experiences.map(function (e) { return e.name; }).join(', ')))])])])
  }))] : [_c('sk-carousel', {
    attrs: {
      "data": _vm.availableSessions,
      "slides-per-page": (_vm.$breakpoints.smDown ? 3 : 6)
    }
  }, _vm._l((_vm.availableSessions), function(session) {
    return _c('div', {
      key: session.id,
      staticClass: "slide",
      attrs: {
        "slot": "slides"
      },
      slot: "slides"
    }, [_c('div', {
      ref: "session_time",
      refInFor: true,
      staticClass: "label label--lg",
      class: {
        active: session == _vm.selectedSession, 'btn-mask': true, 'disabled': !_vm.getStatus(session)
      },
      attrs: {
        "id": session.id
      },
      on: {
        "click": function($event) {
          _vm.setSelectedSession(session);
        }
      }
    }, [_c('div', {
      staticClass: "detail-movie-select-time--time"
    }, [_vm._v("\n                                    " + _vm._s(session.show_time.additional.no_zero_hour_24) + ":" + _vm._s(session.show_time.additional.minute) + "\n\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-time--info"
    }, [_vm._v(_vm._s(_vm.getStatusString(session)))]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-time--info"
    }, [_vm._v(_vm._s(session.screen_name))]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-time--info"
    }, [_vm._v("\n                                    " + _vm._s(session.experiences.map(function (e) { return e.name; }).join(', ')) + "\n                                ")])])])
  }))]], 2) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "detail__book-ticket"
  }, [(!_vm.$breakpoints.smDown) ? _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "tertiary": "",
      "block": (_vm.$breakpoints.xs)
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelAddOrderDialog = true
      }
    }
  }, [_vm._v("Cancel\n            ")]), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    class: (!_vm.canBook ? 'btn--disabled' : ''),
    attrs: {
      "primary": "",
      "block": (_vm.$breakpoints.xs)
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addOrder()
      }
    }
  }, [_vm._v("\n                Add movie to booking\n            ")])], 1)], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.cancelAddOrderDialog),
      callback: function($$v) {
        _vm.cancelAddOrderDialog = $$v
      },
      expression: "cancelAddOrderDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelAddOrderDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelAddOrderDialog = false
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Are you sure you want to cancel this addition to your booking? ")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelAddOrderDialog = false
      }
    }
  }, [_vm._v("Wait, take me back")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelAddOrder();
        _vm.cancelAddOrderDialog = false;
      }
    }
  }, [_vm._v("I'm sure")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(725),
  /* template */
  __webpack_require__(726),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_user_badgeConfig__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(7);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _ref;

        return _ref = {
            loading: true,
            donationDialog: false,
            loadingBackOrder: false,
            order: null,
            concessionGroups: null,
            currentIndex: 0,

            concessionsLogic: {
                "3D Glasses": function DGlasses(val) {
                    return !!~val.toLowerCase().indexOf('3d') && !~val.toLowerCase().indexOf('imax');
                },
                "Imax 3D Gl": function Imax3DGl(val) {
                    return !!~val.toLowerCase().indexOf('imax') && !!~val.toLowerCase().indexOf('3d');
                }
            },
            movies: null,
            promoCombos: [],
            rewards: [],
            glassesDialog: false
        }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'donationDialog', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'badgeConfig', __WEBPACK_IMPORTED_MODULE_5__pages_user_badgeConfig__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'lastConcession', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'loadingUpdateOrder', false), _ref;
    },


    computed: {
        experience: function experience() {
            return this.order && this.order.Experiences ? this.order.Experiences.map(function (e) {
                return e ? e.name : undefined;
            }).join() : "2D";
        },
        concessionsFiltered: function concessionsFiltered() {
            var _this = this;

            return this.concessionGroups ? this.concessionGroups.filter(function (group) {
                var passed = false;
                if (group.Name != 'Subs') {
                    if (!_this.concessionsLogic.hasOwnProperty(group.Name)) {
                        return !_this.concessionsLogic.hasOwnProperty(group.Name);
                    }

                    for (var i = 0; i < _this.order.Experiences.length; i++) {
                        var exp = _this.order.Experiences[i].name;
                        if (_this.concessionsLogic[group.Name](exp)) {
                            passed = true;
                        }
                    }

                    return passed;
                } else {
                    return passed;
                }
            }) : this.concessionGroups;
        },
        concessionsRaw: function concessionsRaw() {
            return this.concessionGroups ? this.concessionGroups.reduce(function (c, g) {
                return c = c.concat(g.ConcessionItems);
            }, []) : [];
        }
    },

    methods: {
        getSortedConcessions: function getSortedConcessions(items) {
            return items.sort(function (a, b) {
                return a.Description < b.Description ? -1 : a.Description > b.Description ? 1 : 0;
            });
        },
        getBadgeIcon: function getBadgeIcon(reward) {
            for (var i = 0; i < this.badgeConfig.length; i++) {
                var _badgeConfig = this.badgeConfig[i];
                if (_badgeConfig.test(reward)) return _badgeConfig;
            }
        },
        isActive: function isActive(index) {
            return index == this.currentIndex;
        },
        setConcession: function setConcession(concession, qty) {
            this.order.setConcession(concession, qty);
        },
        updateOrder: function updateOrder() {
            var _this2 = this;

            console.log("updateOrder", this.order);

            if (!this.order.modified) {
                this.hasConsessions = true;
                __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].saveOrderConcessionsOnly().then(function (order) {
                    var filmTitle = order.Sessions[0].FilmTitle;
                    console.log(filmTitle);
                    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["d" /* EcomTrackingService */].doDataLayerCommitBasket(order._ticketFlow, filmTitle)).then(function (result) {
                        _this2.$router.push('/booking/3' + (_this2.$route.params.festival_id ? '/film-festival/' + _this2.$route.params.festival_id : ''));
                    });
                });
            } else {
                this.loadingUpdateOrder = true;
                __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].saveOrderConcessionsOnly().then(function (order) {
                    var filmTitle = order.Sessions[0].FilmTitle;
                    console.log(filmTitle);
                    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["d" /* EcomTrackingService */].doDataLayerCommitBasket(order._ticketFlow, filmTitle)).then(function (result) {
                        _this2.$router.push('/booking/3');
                    });
                });
            }
        },
        nextConsession: function nextConsession(group, index) {
            var _this3 = this;

            this.currentIndex = index;
            this.currentConcession = index + 1;

            if (index + 1 == this.concessionsFiltered.length) {
                this.lastConcession = true;
                if (group.Name == '3D Glasses' || group.Name == 'Imax 3D Gl') {
                    this.toggleConcessionDialogs('glasses', group, index);
                } else if (group.Name == 'Donations') {
                    this.toggleConcessionDialogs('donate', group, index);
                } else {
                    this.updateOrder();
                }
            } else {
                if (group.Name == '3D Glasses' || group.Name == 'Imax 3D Gl') {
                    this.toggleConcessionDialogs('glasses', group, index);
                } else if (group.Name == 'Donations') {
                    this.toggleConcessionDialogs('donate', group, index);
                } else {
                    this.nextAccordionIndex(index + 1);
                }
                window.scroll({ top: 0 });
                __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].nextTick(function () {
                    _this3.$refs.acorn.forEach(function (el) {
                        if (el.$el.classList.contains('accordian--active')) {
                            window.scroll(0, el.$el.offsetTop);
                        }
                    });
                });
            }
        },
        toggleConcessionDialogs: function toggleConcessionDialogs(dialog, group, index) {
            var hasConcession = false;
            group.ConcessionItems.forEach(function (el) {
                if (el.Quantity > 0) {
                    hasConcession = true;
                }
            });
            if (hasConcession) {
                if (this.lastConcession) this.updateOrder();else this.nextAccordionIndex(index + 1);
            } else {
                if (dialog == 'glasses') this.glassesDialog = true;
                if (dialog == 'donate') this.donationDialog = true;
            }
        },
        nextAccordionIndex: function nextAccordionIndex(index) {
            var _this4 = this;

            if (index == this.concessionsFiltered.length) {
                this.donationDialog = false;
            }
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].nextTick(function () {
                if (_this4.glassesDialog) _this4.glassesDialog = false;
                if (_this4.donationDialog) _this4.donationDialog = false;
                if (index == _this4.concessionsFiltered.length) {
                    _this4.updateOrder();
                } else {
                    _this4.currentIndex = index;
                }
            });
        },
        applyReward: function applyReward(linked, reward) {
            var concession = this.concessionsRaw.find(function (c) {
                return c.HeadOfficeItemCode == reward.VistaID;
            });
            if (concession) {
                var comboConcession = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, concession, {
                    PriceInCents: 0,
                    Description: reward.Name,
                    RecognitionId: reward.RecognitionID,
                    RecognitionSequenceNumber: reward.SequenceNumber
                });
                this.order.setConcession(comboConcession, linked ? 1 : 0);
            }
        }
    },

    created: function created() {
        var _this5 = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getOrder(), __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getConcessionsForCinema(), __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovies(), __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["b" /* AuthService */].getRewards()]).then(function (_ref2) {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 4),
                order = _ref3[0],
                concessionGroups = _ref3[1],
                movies = _ref3[2],
                rewards = _ref3[3];

            _this5.order = order;

            _this5.concessionGroups = concessionGroups.sort(function (a, b) {
                return +!b.Name.localeCompare('Kids');
            }).sort(function (a, b) {
                if (a.ConcessionItems) {
                    a.ConcessionItems = _this5.getSortedConcessions(a.ConcessionItems);
                }
                return +!a.Name.localeCompare('Combos');
            }).sort(function (a, b) {

                return +!a.Name.localeCompare('Donations');
            });
            _this5.movies = movies;

            _this5.rewards = rewards.ConcessionList ? rewards.ConcessionList.map(function (b) {
                b.badge = _this5.getBadgeIcon(b);
                b.linked = false;
                return b;
            }) : [];

            _this5.loading = false;

            var OrderMovies = order.Sessions.reduce(function (c, s) {
                c.push(s.movie.id);
                return c;
            }, []);
            _this5.concessionsRaw.map(function (item) {
                item.movie = movies.findById(item.DescriptionAlt);
                item.isRelatedPromo = item.DescriptionAlt ? Boolean(~OrderMovies.indexOf(item.DescriptionAlt)) : false;
                var concession = _this5.order.Concessions.find(function (c) {
                    return c.Id == item.Id;
                });
                item.Quantity = concession ? concession.Quantity : 0;
                return item;
            });
        });
    },
    mounted: function mounted() {
        window.scroll({ top: 0, left: 0 });
    }
});

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "extras"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_vm._l((_vm.concessionsFiltered), function(group, index) {
    return (group.Name != 'PromoCombos' && group.Name != 'Subs') ? _c('sk-accordian', {
      key: index,
      ref: "acorn",
      refInFor: true,
      attrs: {
        "active": _vm.isActive(index)
      }
    }, [_c('template', {
      slot: "header"
    }, [(group.Name === 'Combos') ? _c('h2', [_vm._v("Choose Snacks")]) : _vm._e(), _vm._v(" "), (group.Name === '3D Glasses') ? _c('h2', [_vm._v("Add 3D Glasses")]) : _vm._e(), _vm._v(" "), (group.Name === 'Imax 3D Gl') ? _c('h2', [_vm._v("Add 3D IMAX Glasses")]) : _vm._e(), _vm._v(" "), (group.Name === 'Donations') ? _c('h2', [_vm._v("Donate to Vision Mission")]) : _vm._e()]), _vm._v(" "), _c('template', {
      slot: "content"
    }, [(group.Name !== 'Donations') ? [_c('sk-panel', [(group.Name == '3D Glasses') ? [_c('p', [_vm._v("Please choose the type of 3D glasses you need and how many.")])] : _vm._e(), _vm._v(" "), (group.Name == 'Combos') ? [_c('div', {
      staticClass: "covid-message"
    }, [_c('sk-layout', {
      staticClass: "covid-wrapper",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('sk-panel', {
      staticClass: "covid-panel"
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      staticClass: "covid-icon-container",
      attrs: {
        "lg1": "",
        "md2": "",
        "sm2": "",
        "xs3": ""
      }
    }, [_c('div', {
      staticClass: "icon icon-combo"
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "covid-message-container",
      attrs: {
        "lg11": "",
        "md10": "",
        "sm10": "",
        "xs9": ""
      }
    }, [_c('p', [(_vm.order != undefined || _vm.order != null) ? [_c('strong', [_vm._v("What's a movie without popcorn? Can't decide which snacks to buy online now? Don't fret! Snacks can now be purchased in the cinema.")]), _c('br'), _vm._v("\n                                                                Sweet and drink options are subject to availability\n                                                        ")] : _vm._e()], 2)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })], 1)], 1)] : _vm._e(), _vm._v(" "), (group.Name == 'Donations') ? [_c('p', [_c('strong', [_vm._v("Donate to Vision Mission now by adding R2.50 or more to your ticket\n                                price.")])]), _vm._v(" "), _c('p', [_vm._v("Vision Mission is a Ster-Kinekor initiative which helps children with visual\n                                impairments by improving their vision, so that they can enjoy movies too. ")])] : _vm._e(), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l(((group.ConcessionItems)), function(concession) {
      return ((concession.isRelatedPromo || concession.movie ? true : false) && concession.PriceInCents > 0) ? _c('sk-flex', {
        key: concession.Id,
        attrs: {
          "xs6": "",
          "md4": "",
          "lg3": ""
        }
      }, [_vm._v("\n                                " + _vm._s(concession.quantity) + "\n                                "), _c('sk-counter-box', {
        attrs: {
          "concession": concession,
          "type": concession.ItemClassCode
        },
        on: {
          "concessionChange": _vm.setConcession
        },
        model: {
          value: (concession.quantity),
          callback: function($$v) {
            _vm.$set(concession, "quantity", $$v)
          },
          expression: "concession.quantity"
        }
      })], 1) : _vm._e()
    })), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l(((group.ConcessionItems)), function(concession) {
      return (!concession.isRelatedPromo && (concession.movie ? false : true) && (concession.Description != 'DONATION R100' && concession.Description != 'DONATION R200' && concession.Description != 'DONATION R250' && concession.Description != 'DONATION R2500' && concession.Description != 'DONATION R300' && concession.Description != 'DONATION R5000' && concession.Description != 'DONATION R750' && concession.Description != 'DONATION R500') && concession.PriceInCents > 0) ? _c('sk-flex', {
        key: concession.Id,
        attrs: {
          "xs6": "",
          "md4": "",
          "lg3": ""
        }
      }, [_c('sk-counter-box', {
        attrs: {
          "concession": concession,
          "type": concession.ItemClassCode
        },
        on: {
          "concessionChange": _vm.setConcession
        },
        model: {
          value: (concession.quantity),
          callback: function($$v) {
            _vm.$set(concession, "quantity", $$v)
          },
          expression: "concession.quantity"
        }
      })], 1) : _vm._e()
    })), _vm._v(" "), (group.Name == 'Combos' && _vm.rewards.length > 0) ? _c('sk-panel', {
      staticClass: "extras-points"
    }, [_c('h5', [_vm._v("Your Available Rewards")]), _vm._v(" "), _c('p', [_vm._v("You Have " + _vm._s(_vm.rewards.length) + " Available Free COMBO" + _vm._s(_vm.rewards.length > 1 && 's' || '') + ".\n                                You can use " + _vm._s(_vm.rewards.length > 1 && 'them' || 'it') + " now or save " + _vm._s(_vm.rewards.length >
      1 && 'them' || 'it') + " for later.")]), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": ""
      }
    }, _vm._l((_vm.rewards), function(reward) {
      return _c('sk-flex', {
        key: reward.VistaID,
        attrs: {
          "grow": ""
        }
      }, [_c('hr'), _vm._v(" "), _c('sk-checkbox', {
        staticClass: "linked-combo",
        attrs: {
          "label": "I'd rather not say"
        },
        on: {
          "input": function($event) {
            _vm.applyReward(reward.linked, reward)
          }
        },
        model: {
          value: (reward.linked),
          callback: function($$v) {
            _vm.$set(reward, "linked", $$v)
          },
          expression: "reward.linked"
        }
      }, [_c('div', {
        staticClass: "linked-combo__description",
        attrs: {
          "slot": "label"
        },
        slot: "label"
      }, [_c('sk-badge', {
        attrs: {
          "small": "",
          "no-backface": "",
          "color": reward.badge.color
        }
      }, [_c('template', {
        slot: "front"
      }, [_c('sk-icon', {
        attrs: {
          "icon": reward.badge.icon
        }
      })], 1), _vm._v(" "), _c('template', {
        slot: "back"
      })], 2), _vm._v(" "), _c('div', {
        staticClass: "linked-combo__card-content btn-mask"
      }, [_c('div', {
        staticClass: "linked-combo__club-cards-title"
      }, [_vm._v("\n                                                    " + _vm._s(reward.badge.description) + "\n                                                ")]), _vm._v(" "), _c('p', {
        staticClass: "linked-combo__club-cards-copy"
      }, [_vm._v("\n                                                    " + _vm._s(reward.badge.title) + "\n                                                ")])])], 1)])], 1)
    }))], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": "/booking/1"
      }
    }, [_vm._v("Back")]), _vm._v(" "), _c('sk-spacer'), _vm._v(" "), _c('sk-button', {
      attrs: {
        "primary": "",
        "loading": _vm.loadingUpdateOrder
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.nextConsession(group, index)
        }
      }
    }, [(group.Name === 'Imax 3D Gl') ? [_vm._v("Continue")] : _vm._e(), _vm._v(" "), (group.Name === '3D Glasses') ? [_vm._v("Continue")] : _vm._e(), _vm._v(" "), (group.Name === 'Combos') ? [_vm._v("Continue")] : _vm._e(), _vm._v(" "), (group.Name === 'Donations') ? [_vm._v("Continue")] : _vm._e()], 2)], 1)], 2)] : _vm._e(), _vm._v(" "), (group.Name === 'Donations') ? [_c('sk-panel', [_c('sk-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "sm9": "",
        "xs9": ""
      }
    }, [_c('p', [_vm._v("Vision Mission Helps Children With vision impairments by "), _c('br'), _vm._v(" improving their\n                                    vision, so that they can enjoy movies too.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Donate to Vision Mission now by adding R2.50 to your ticket\n                                    price.")])]), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((group.ConcessionItems), function(concession) {
      return (!concession.isRelatedPromo && (concession.Description != 'DONATION R100' && concession.Description != 'DONATION R200' && concession.Description != 'DONATION R250' && concession.Description != 'DONATION R2500' && concession.Description != 'DONATION R300' && concession.Description != 'DONATION R5000' && concession.Description != 'DONATION R750' && concession.Description != 'DONATION R500') && concession.PriceInCents > 0) ? _c('sk-flex', {
        key: concession.Id,
        attrs: {
          "xs12": "",
          "md6": "",
          "lg4": ""
        }
      }, [_c('sk-counter-box', {
        attrs: {
          "smallCounter": "",
          "showRandValue": "",
          "concession": concession,
          "type": concession.ItemClassCode
        },
        on: {
          "concessionChange": _vm.setConcession
        },
        model: {
          value: (concession.quantity),
          callback: function($$v) {
            _vm.$set(concession, "quantity", $$v)
          },
          expression: "concession.quantity"
        }
      })], 1) : _vm._e()
    })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("What is Vision Mission")]), _vm._v(" "), _c('h5', [_vm._v("Eyes On A Brighter Future")]), _vm._v(" "), _c('p', [_vm._v("\n                                    In South Africa, millions of young learners suffer from vision impairment. The majority of these\n                                    conditions are correctable but the tragedy is that many children, especially those from underprivileged areas,\n                                    have no access to affordable treatment."), _c('br'), _vm._v("\n                                    As a company that specialises in movie and digital gaming, we know just how important sight is\n                                    to the experiences of live. We've committed to helping these children by improving their vision,\n                                    so that they can enjoy movies too.\n                                ")])], 1), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "sm3": "",
        "xs3": ""
      }
    }, [_c('div', {}, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/vision_mission.png"
      }
    })])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": "/booking/1"
      }
    }, [_vm._v("Back")]), _vm._v(" "), _c('sk-spacer'), _vm._v(" "), _c('sk-button', {
      attrs: {
        "primary": "",
        "loading": _vm.loadingUpdateOrder
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.nextConsession(group, index)
        }
      }
    }, [
      [_vm._v("Continue to Checkout")]
    ], 2)], 1)], 1)] : _vm._e()], 2)], 2) : _vm._e()
  }), _vm._v(" "), _c('sk-dialog', {
    staticClass: "video",
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.glassesDialog),
      callback: function($$v) {
        _vm.glassesDialog = $$v
      },
      expression: "glassesDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.glassesDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.glassesDialog = false
      }
    }
  }), _vm._v(" "), (_vm.order.CinemaId == '6171' && _vm.experience == '3D IMAX') ? [_c('h3', [_vm._v("THIS IS AN IMAX® WITH LASER 3D MOVIE")]), _vm._v(" "), _c('p', [_vm._v("This cinema is equipped with new laser technology and requires state-of-the-art 3D glasses.  Kindly note that regular IMAX glasses are not compatible with the new IMAX Laser system.")])] : [_c('h3', [_vm._v("This is a 3D Movie")]), _vm._v(" "), _c('p', [_vm._v("3D glasses will ensure you enjoy the best experience! Things will get pretty blurry without them.")])], _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.glassesDialog = false
      }
    }
  }, [_vm._v("Wait, go back")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.loadingUpdateOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.nextAccordionIndex(_vm.currentConcession)
      }
    }
  }, [_vm._v("\n                Yes, I'm sure\n            ")])], 2), _vm._v(" "), _c('sk-dialog', {
    staticClass: "video",
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.donationDialog),
      callback: function($$v) {
        _vm.donationDialog = $$v
      },
      expression: "donationDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.donationDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.donationDialog = false
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Looks like you missed the Vision Mission Donation")]), _vm._v(" "), _c('p', [_vm._v("Help visually impaired children by adding R2.50 to your booking.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.donationDialog = false
      }
    }
  }, [_vm._v("Donate")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.loadingUpdateOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.nextAccordionIndex(_vm.currentConcession)
      }
    }
  }, [_vm._v("\n                No, thanks\n            ")])], 1)], 2)])
},staticRenderFns: []}

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(728),
  /* template */
  __webpack_require__(729),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            movie: {},
            cinema: {},
            order: {},
            toggleDialog: false,
            cancelOrderLoad: false,
            currency: "R"
        };
    },


    computed: {
        total: function total() {

            var ticketTotal = this.order && this.order.Tickets ? this.order.Tickets.reduce(function (c, t) {
                return c += t.PriceCents;
            }, 0) : 0;
            var ConcessionTotal = this.order && this.order.Concessions ? this.order.Concessions.reduce(function (c, t) {
                return c += t.PriceInCents * t.Quantity;
            }, 0) : 0;

            var priceFormatted = ((ticketTotal + ConcessionTotal) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            console.log(this.currency + ('' + priceFormatted));
            return this.currency + ('' + priceFormatted);
        },
        bookingDate: function bookingDate() {
            return this.order.SessionDate.additional.string_long_day_of_week + ' ' + this.order.SessionDate.additional.day;
        },
        movieStartTime: function movieStartTime() {
            return this.order.SessionDate.additional.no_zero_hour_24 + ':' + this.order.SessionDate.additional.minute;
        },
        movieEndTime: function movieEndTime() {
            return this.order.SessionDate.date.add(this.movie.runtime, 'minutes').format('h:m:a');
        }
    },

    methods: {
        formatVistaTime: function formatVistaTime(VistaDate) {
            return VistaDate.additional.no_zero_hour_24 + ':' + VistaDate.additional.minute;
        },
        formatVistaDate: function formatVistaDate(VistaDate) {
            return VistaDate.additional.string_long_day_of_week + ' ' + VistaDate.additional.day + ' ' + VistaDate.additional.string_long_month;
        },
        getTicketsGrouped: function getTicketsGrouped(tickets) {
            if (!tickets) return [];
            var tickets = tickets.reduce(function (collection, ticket) {
                var key = ticket.Description;
                collection[key] = collection[key] || { Description: ticket.Description, PriceInCents: 0, Quantity: 0 };
                collection[key].Quantity++;
                collection[key].PriceInCents += ticket.PriceCents;
                return collection;
            }, {});

            return tickets;
        },
        groupConcessions: function groupConcessions(concessions) {
            var c = concessions.map(function (con) {
                var c = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, con);
                c.PriceInCents = c.PriceInCents * c.Quantity;
                return c;
            });
            return c;
        },
        cancelOrder: function cancelOrder() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["f" /* ErrorHandler */].ignoreNextError();
            this.cancelOrderLoad = true;
            var session = __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["k" /* OrderService */].pendingSession();
            var result = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["k" /* OrderService */].cancelOrder()).then(function (result) {
                __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["k" /* OrderService */].clearPendingSessions();
                __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["k" /* OrderService */].tearDown();
                _this.$toaster.show('Your booking was successfully cancelled.', {
                    top: true,
                    fullwidth: true,
                    timeout: 5000
                });
                _this.$router.push('/details/' + session.MovieId);
                _this.cancelOrderLoad = false;
            }, function (e) {
                var session = __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["k" /* OrderService */].pendingSession();
                __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["k" /* OrderService */].tearDown();
                _this.$router.push('/details/' + session.MovieId);
            });
        },
        confirmCancelOrder: function confirmCancelOrder() {
            this.toggleDialog = true;
        }
    },

    created: function created() {
        var _this2 = this;

        var session = __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["k" /* OrderService */].pendingSession();

        if (session) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovieDetail(session.MovieId), __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getCinema(session.CinemaId), __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getOrder(), __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["i" /* MovieMetaService */].getMovieMeta()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 4),
                movie = _ref2[0],
                cinema = _ref2[1],
                order = _ref2[2],
                meta = _ref2[3];

            _this2.order = order;
            if (meta.extended_regions_data != undefined) {
                for (var i = 0; i < meta.extended_regions_data.length; i++) {
                    if (meta.extended_regions_data[i] != undefined) {
                        if (meta.extended_regions_data[i].cinema_id == cinema.id) {
                            _this2.currency = meta.extended_regions_data[i].currency_symbol;
                        }
                    }
                }
            }

            _this2.loading = false;
        });
    },
    mounted: function mounted() {
        window.scroll({ top: 0, left: 0 });
    }
});

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('h2', [_vm._v("Your Booking")]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sm1": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "tertiary": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.confirmCancelOrder($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleDialog),
      callback: function($$v) {
        _vm.toggleDialog = $$v
      },
      expression: "toggleDialog"
    }
  }, [(_vm.cancelOrderLoad) ? _c('div', {
    staticClass: "text-center"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "50",
      "width": 2,
      "primary": ""
    }
  })], 1) : [_c('h4', [_vm._v("Are you sure you want to cancel your booking?")]), _vm._v(" "), _c('p', [_vm._v("By clicking cancel you'll lose your seats and might not get them back again.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDialog = false
      }
    }
  }, [_vm._v("Wait, take me back")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.cancelOrderLoad
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelOrder();
        _vm.toggleDialog = false;
      }
    }
  }, [_vm._v("I'm sure\n            ")])]], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "check-ticket"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_vm._l((_vm.order.Sessions), function(session) {
    return [(session.movie) ? [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs5": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('div', {
      staticClass: "movie-poster"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": session.movie.poster
      }
    })])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs7": "",
        "sm9": "",
        "md10": ""
      }
    }, [_c('div', {
      staticClass: "check-ticket--right"
    }, [_c('div', {
      staticClass: "movie-details"
    }, [_c('div', {
      staticClass: "movie-title"
    }, [_c('h4', [_vm._v(_vm._s(session.movie.title))])]), _vm._v(" "), _c('div', {
      staticClass: "movie-info--tags"
    }, [_c('span', [_vm._v(_vm._s(session.movie.rating))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(session.movie.runtime_hour_minute.hours) + "h" + _vm._s(session.movie.runtime_hour_minute.minutes) + "m")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(session.movie.genresString))])]), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('div', {
      staticClass: "movie-info--details"
    }, [_c('h5', {
      staticClass: "cart-items__heading"
    }, [_vm._v("Cinema Type")]), _vm._v(" "), _c('h5', {
      staticClass: "cart-items__sub-heading"
    }, [_vm._v(_vm._s(session.MovieSession.experiencesString))]), _vm._v(" "), _c('h5', {
      staticClass: "cart-items__heading"
    }, [_vm._v("Where")]), _vm._v(" "), _c('h5', {
      staticClass: "cart-items__sub-heading"
    }, [_vm._v(_vm._s(session.MovieSession.cinema.name))]), _vm._v(" "), _c('h5', {
      staticClass: "cart-items__heading"
    }, [_vm._v("When")]), _vm._v(" "), _c('h5', {
      staticClass: "cart-items__sub-heading"
    }, [_vm._v(_vm._s(_vm.formatVistaDate(session.MovieSession.show_time)))]), _vm._v(" "), _c('h5', {
      staticClass: "cart-items__heading"
    }, [_vm._v("Estimated Run Time")]), _vm._v(" "), _c('h5', {
      staticClass: "cart-items__sub-heading"
    }, [_vm._v(_vm._s(_vm.formatVistaTime(session.MovieSession.show_time)) + " -\n                                                                    " + _vm._s((session.MovieSession.show_time.date.clone().add(session.movie.runtime, 'minutes').format('h:mm a'))))])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [(session.Tickets) ? _c('div', {
      staticClass: "cart-items cart--tickets"
    }, [_c('h5', {
      staticClass: "cart-items__heading"
    }, [_vm._v("Your Tickets")]), _vm._v(" "), _c('sk-list', _vm._l((_vm.getTicketsGrouped(session.Tickets)), function(ticketObject, TicketType) {
      return _c('sk-list-item', {
        key: TicketType
      }, [_c('sk-ticket-seats', {
        attrs: {
          "ticket-obj": ticketObject,
          "ticket-type": TicketType,
          "currency": _vm.currency
        }
      })], 1)
    }))], 1) : _vm._e()])], 1)], 1)])])], 1)] : _vm._e()]
  }), _vm._v(" "), (_vm.order.Concessions.length > 0) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs7": "",
      "sm9": "",
      "md10": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "cart-items cart--extras"
  }, [_c('h5', {
    staticClass: "cart-items__heading"
  }, [_vm._v("Your Extras")]), _vm._v(" "), _c('sk-list', _vm._l((_vm.groupConcessions(_vm.order.Concessions)), function(concession) {
    return _c('sk-list-item', {
      key: concession.Description
    }, [_c('sk-ticket-seats', {
      attrs: {
        "ticket-obj": concession,
        "ticket-type": concession.Description,
        "currency": _vm.currency
      }
    })], 1)
  }))], 1)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs9": "",
      "sm9": ""
    }
  }, [_c('sk-layout', [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "cart-items cart--total"
  }, [_c('span', {
    staticClass: "cart-items__total"
  }, [_vm._v("Total")]), _vm._v(" "), _c('span', {
    staticClass: "cart-items__total-price"
  }, [_vm._v(_vm._s(_vm.total))])])])], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    staticClass: "check-ticket__btns",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "link": "",
      "router": "",
      "to": "/booking/2"
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('sk-spacer'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "router": "",
      "to": "/booking/1"
    }
  }, [_vm._v("Edit Booking")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": ("/booking/4" + (_vm.$route.params.festival_id ? '/film-festival/' + _vm.$route.params.festival_id : ''))
    }
  }, [_vm._v("Checkout")])], 1)], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(731),
  /* template */
  __webpack_require__(732),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            user: { FullName: null, Email: null, MobilePhone: null },
            order: {},
            saveUserData: false,
            saveNewsLetter: false,
            eft: false,
            leaveSite: false,
            isGuest: true,
            tmpEmail: null,
            originalEmail: null,
            confirmEmail: undefined,
            facebookPixelSKShow: false,
            prepareError: false
        };
    },


    methods: {
        checkPayment: function checkPayment() {
            if (this.order.totalInCents == 0) {
                this.makePayment();
            } else {
                this.leaveSite = true;
            }
        },
        makePayment: function makePayment() {
            var _this = this;

            var EFT = this.eft;
            this.leaveSite = false;
            this.loading = true;
            if (this.saveUserData) {
                __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].storeLocalUserOrderInfo(this.user);
            } else if (this.user.isTemp) {
                __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].storeLocalUserOrderInfo(this.user, true);
            } else {
                console.log("not saving User Data", this.user);
            }
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["k" /* OrderService */].makePayment(EFT, this.user)).then(function (preparePayment) {
                console.log("preparePayment", preparePayment);
                if (preparePayment.success === false) {
                    _this.prepareError = true;
                }
            });
        },
        facebookPixelSK: function facebookPixelSK() {
            !function (f, b, e, v, n, t, s) {
                if (f.fbq) return;n = f.fbq = function () {
                    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;n.push = n;n.loaded = !0;n.version = '2.0';
                n.queue = [];t = b.createElement(e);t.async = !0;
                t.src = v;s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
            }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1442556416455138');
            fbq('track', 'PageView');

            this.facebookPixelSKShow = true;
        }
    },

    created: function created() {
        var _this2 = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].getUserOrderInfo(), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getOrder(), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].isGuestUser(), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["d" /* EcomTrackingService */].doCheckoutBasketStepTwo()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
                userData = _ref2[0],
                order = _ref2[1],
                guest = _ref2[2];

            if (userData) _this2.user = userData;
            _this2.isGuest = guest;
            _this2.order = order;
            console.log(_this2.order);
            _this2.facebookPixelSK();
            _this2.loading = false;
        });
    },


    watch: {
        tmpEmail: function tmpEmail() {
            this.user.Email = this.originalEmail;
            if (this.user.Email != this.tmpEmail) {
                this.confirmEmail = false;
            } else {
                this.confirmEmail = true;
            }
        },
        originalEmail: function originalEmail() {
            this.user.Email = this.originalEmail;
            if (this.user.Email != this.tmpEmail) {
                this.confirmEmail = false;
            } else {
                this.confirmEmail = true;
            }
        }
    },
    mounted: function mounted() {
        window.scroll({ top: 0, left: 0 });
    }
});

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), (!_vm.loading) ? _c('sk-panel', [_c('h3', [_vm._v("Confirm Your Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "checkout",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [
    [(_vm.facebookPixelSKShow) ? _c('img', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "height": "1",
        "width": "1",
        "src": "https://www.facebook.com/tr?id=1442556416455138&ev=PageView&noscript=1"
      }
    }) : _vm._e()], _vm._v(" "), _c('sk-form', {
      staticClass: "form",
      attrs: {
        "id": "checkout-form"
      },
      on: {
        "submit": function($event) {
          _vm.checkPayment()
        }
      }
    }, [_c('p', {
      staticClass: "form-alert"
    }, [_vm._v("All fields are mandatory")]), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('sk-input', {
      staticClass: "light-input",
      attrs: {
        "name": "name",
        "autocomplete": "name",
        "label": "Your name",
        "required": "",
        "error-message": {
          valueMissing: 'Please tell us your name.'
        }
      },
      on: {
        "input": function($event) {
          _vm.user.isTemp = true
        }
      },
      model: {
        value: (_vm.user.FullName),
        callback: function($$v) {
          _vm.$set(_vm.user, "FullName", $$v)
        },
        expression: "user.FullName"
      }
    })], 1)], 1), _vm._v(" "), _c('sk-input', {
      staticClass: "light-input",
      attrs: {
        "name": "email",
        "type": "email",
        "autocomplete": "email",
        "label": "Your email",
        "required": "",
        "error-message": {
          valueMissing: 'Please make sure your email address follows this format: example@email.com'
        }
      },
      on: {
        "input": function($event) {
          _vm.user.isTemp = true
        }
      },
      model: {
        value: (_vm.originalEmail),
        callback: function($$v) {
          _vm.originalEmail = $$v
        },
        expression: "originalEmail"
      }
    }, [_c('template', {
      slot: "help"
    }, [_c('sk-tooltip', {
      attrs: {
        "content": _vm.isGuest ? 'We\'ll email your booking confirmation to you.' : 'We\'ll email your booking confirmation to you. Changing your email address here will not affect your profile.',
        "action-text": "Why do I need to provide my email address?"
      }
    })], 1)], 2), _vm._v(" "), _c('sk-flex', {
      staticStyle: {
        "padding-left": "0px"
      },
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('sk-input', {
      attrs: {
        "name": "tmpEmail",
        "type": "email",
        "label": "Confirm email",
        "required": "",
        "error-message": {
          valueMissing: 'Please make sure your email address follows this format: example@email.com'
        }
      },
      model: {
        value: (_vm.tmpEmail),
        callback: function($$v) {
          _vm.tmpEmail = $$v
        },
        expression: "tmpEmail"
      }
    }, [(_vm.confirmEmail != undefined) ? [(!_vm.confirmEmail) ? _c('div', {
      staticClass: "form-group__error"
    }, [_vm._v("Email addresses do not match.")]) : _vm._e()] : _vm._e()], 2)], 1), _vm._v(" "), _c('sk-input', {
      staticClass: "light-input",
      attrs: {
        "type": "tel",
        "name": "mobile",
        "autocomplete": "tel",
        "label": "Your mobile number",
        "required": "",
        "error-message": {
          valueMissing: 'Please enter your mobile number',
          patternMismatch: 'Please double check you\'ve entered 9 digits excluding your country code.'
        },
        "pattern": "^\\+?\\d{11,11}|\\d{10,10}$"
      },
      on: {
        "input": function($event) {
          _vm.user.isTemp = true
        }
      },
      model: {
        value: (_vm.user.MobilePhone),
        callback: function($$v) {
          _vm.$set(_vm.user, "MobilePhone", $$v)
        },
        expression: "user.MobilePhone"
      }
    }, [_c('template', {
      slot: "help"
    }, [_c('sk-tooltip', {
      attrs: {
        "content": _vm.isGuest ? 'We might need to reach you should there be changes that impact your booking.' : 'We might need to reach you should there be changes that impact your booking. Changing your number here will not affect your profile.',
        "action-text": "Why do I need to provide my mobile number?"
      }
    })], 1)], 2), _vm._v(" "), (_vm.isGuest && _vm.user.isTemp) ? _c('sk-checkbox', {
      attrs: {
        "id": "userLinkCards",
        "label": "Save this information for next time"
      },
      model: {
        value: (_vm.saveUserData),
        callback: function($$v) {
          _vm.saveUserData = $$v
        },
        expression: "saveUserData"
      }
    }, [_c('template', {
      slot: "append"
    }, [_c('sk-tooltip', {
      attrs: {
        "content": "We use cookies to store your details and speed up your booking the next time you visit."
      }
    })], 1)], 2) : _vm._e(), _vm._v(" "), _c('sk-checkbox', {
      staticClass: "newsletter__subscribe",
      attrs: {
        "id": "userLinkCards",
        "label": "Use my email to subscribe me to the SK newsletter"
      },
      model: {
        value: (_vm.saveNewsLetter),
        callback: function($$v) {
          _vm.saveNewsLetter = $$v
        },
        expression: "saveNewsLetter"
      }
    }, [_c('template', {
      slot: "prepend"
    }, [_vm._v("Be the first to enter our competitions and receive invitations to exclusive events.")])], 2), _vm._v(" "), _c('p', [_vm._v("By clicking pay, you agree to our "), _c('a', {
      attrs: {
        "href": "/content/legal/online-booking-terms-and-conditions",
        "target": "_blank"
      }
    }, [_vm._v("Terms & Conditions")])]), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "payment-info": ""
      }
    }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "md9": ""
      }
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm8": "",
        "text-right": ""
      }
    }, [_c('p', {
      staticClass: "text--small"
    }, [_vm._v("Ster-Kinekor is secure. For credit card payments we accept")])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs3": "",
        "sm6": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/visa.png",
        "alt": "Visa"
      }
    })]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs3": "",
        "sm6": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/master-card.png",
        "alt": "Master Card"
      }
    })])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
      class: _vm.$breakpoints.smDown ? 'text-right' : '',
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "payment-footer": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "md2": ""
      }
    }, [(!_vm.$breakpoints.smDown) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": "/booking/3"
      }
    }, [_vm._v("Back")]) : _vm._e()], 1), _vm._v(" "), _c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm10": "",
        "grow": "",
        "text-right": ""
      }
    }, [(_vm.confirmEmail) ? _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "payment-footer-btns": ""
      }
    }, [(_vm.order.totalInCents !== 0) ? [_c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('sk-button', {
      attrs: {
        "primary": "",
        "type": "submit"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.eft = false
        }
      }
    }, [_c('sk-icon', {
      attrs: {
        "lock": ""
      }
    }), _vm._v(" Pay With Credit Card\n                                        ")], 1)], 1)] : [_c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('sk-button', {
      attrs: {
        "primary": "",
        "type": "submit"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.eft = false;
        }
      }
    }, [_vm._v("Complete Order")])], 1)]], 2) : _vm._e()], 1), _vm._v(" "), (_vm.$breakpoints.smDown) ? _c('sk-flex', {
      attrs: {
        "xs12": "",
        "md2": ""
      }
    }, [_c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": "/booking/3"
      }
    }, [_vm._v("Back")])], 1) : _vm._e()], 1)], 1)
  ], 2)]) : _vm._e(), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.leaveSite),
      callback: function($$v) {
        _vm.leaveSite = $$v
      },
      expression: "leaveSite"
    }
  }, [_c('h3', [_vm._v("Payment notice")]), _vm._v(" "), _c('p', [_vm._v("By clicking PAY, you'll be redirected to our payment page. Please don’t close your browser until you’ve received your booking reference.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.makePayment()
      }
    }
  }, [_vm._v("Got it!")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.leaveSite = false
      }
    }
  }, [_vm._v("Wait! Take me back")])], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.prepareError),
      callback: function($$v) {
        _vm.prepareError = $$v
      },
      expression: "prepareError"
    }
  }, [_c('h3', [_vm._v("Oops!")]), _vm._v(" "), _c('p', [_vm._v("Something went wrong, please try again!")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.prepareError = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(734),
  /* template */
  __webpack_require__(735),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(7);




var zeroPad = function zeroPad(num, places) {
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join("0") + num;
};

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        timer: null
    },

    data: function data() {
        return {
            now: new Date().getMinutes(),
            date: null,
            diff: 0,
            expires: null,
            currentTime: 0,
            session: undefined,
            CountDownTimer: undefined,
            loading: true,
            minutes: undefined,
            seconds: undefined,
            cancelOrderLoad: false,
            toggleDialog: false,
            warningTime: "06:00",
            showWarning: false,
            showTimeout: false,
            loadingContinue: false,
            order: null
        };
    },


    methods: {
        confirmCancelOrder: function confirmCancelOrder() {
            this.toggleDialog = true;
        },
        cancelOrder: function cancelOrder() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["f" /* ErrorHandler */].ignoreNextError();
            this.cancelOrderLoad = true;
            var session = __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].pendingSession();
            var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].cancelOrder()).then(function (result) {
                _this.showWarning = false;
                __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].clearPendingSessions();
                __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].tearDown();
                _this.$toaster.show('Your booking was successfully cancelled.', {
                    top: true,
                    fullwidth: true,
                    timeout: 5000
                });
                _this.cancelOrderLoad = false;
                __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick(function () {
                    _this.$router.push('/details/' + session.MovieId);
                });
            }, function (e) {
                _this.showWarning = false;
                var session = __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].pendingSession();
                __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].tearDown();
                __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick(function () {
                    _this.$router.push('/details/' + session.MovieId);
                });
            });
        },
        goHome: function goHome() {
            var _this2 = this;

            this.showTimeout = false;
            this.cancelOrderLoad = true;
            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].tearDown();
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick(function () {
                _this2.$router.push('/');
            });
        },
        continueOrder: function continueOrder() {
            var _this3 = this;

            this.loadingContinue = true;
            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].continueOrder().then(function (continued) {
                _this3.showWarning = false;
                _this3.loadingContinue = false;
            });
        },
        restartOrder: function restartOrder() {
            var _this4 = this;

            this.loadingContinue = true;
            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].restartOrder().then(function (order) {
                _this4.loadingContinue = false;
                _this4.showTimeout = false;
                _this4.showWarning = false;
                order.loadSeatGrid();
                _this4.order = order;
                _this4.setExpiry(order.ExpiryDate.date);
                window.location.href = '/booking/1 ' + (_this4.$route.params.festival_id ? '/film-festival/' + _this4.$route.params.festival_id : '');
                _this4.startTimer();
            });
        },
        calcExpiry: function calcExpiry() {
            if (this.expires) {
                var now = new Date();
                var secs = this.expires.diff(now, 'seconds');
                var min = Math.floor(secs / 60);
                min = min < 0 ? 0 : min;
                secs = secs - min * 60;
                secs = secs < 0 ? 0 : secs;

                this.minutes = zeroPad(min, 2);
                this.seconds = zeroPad(secs, 2);
            } else {
                this.minutes = zeroPad(0, 2);
                this.seconds = zeroPad(0, 2);
            }
            if (!this.cancelOrderLoad) {
                if (this.minutes + ':' + this.seconds === this.warningTime) this.showWarning = true;
                if (this.minutes + ':' + this.seconds === "00:00") {
                    this.showWarning = false;
                    this.showTimeout = true;
                }
            }
        },
        setExpiry: function setExpiry(updatedDate) {
            var exp = this.expires = updatedDate;
            return exp;
        },
        startTimer: function startTimer() {
            this.CountDownTimer = setInterval(this.calcExpiry, 1000);
        },
        stopTimer: function stopTimer() {
            if (this.CountDownTimer) clearInterval(this.CountDownTimer);
        }
    },

    beforeDestroy: function beforeDestroy() {
        this.stopTimer();
    },
    created: function created() {
        var _this5 = this;

        this.loading = true;
        try {
            if (!__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].pendingSession()) {
                this.$toaster.show('Oops, it looks like we cannot find a booking for you. here\'s what\'s on', {
                    top: true,
                    fullwidth: true,
                    timeout: 5000
                });
                this.$router.push('/');
            } else __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getOrder().then(function (order) {
                _this5.order = order;
                if (order.Session && !order.VistaBookingNumber) {
                    _this5.setExpiry(order.ExpiryDate.date);
                    __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].addObserver(_this5, __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].ORDER_CHANGED_EVENT, function (evt, order) {
                        _this5.setExpiry(order.ExpiryDate.date);
                    });
                    _this5.startTimer();
                }
                if (!order.Sessions || order.Sessions.length == 0) {
                    if (__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].pendingSession()) {
                        _this5.showTimeout = true;
                    } else {
                        _this5.$toaster.show('Oops, it looks like we cannot find a booking for you. here\'s what\'s on', {
                            top: true,
                            fullwidth: true,
                            timeout: 5000
                        });
                        _this5.$router.push('/');
                    }
                }
                _this5.loading = false;
            }, function (error) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
            });
        } catch (e) {
            this.$toaster.show('An Unexpected error has occured, please try again later.', {
                top: true,
                fullwidth: true,
                timeout: 5000
            });
            this.$router.push('/');
        }
    }
});

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "countdown"
  }, [(_vm.minutes && _vm.seconds) ? [_c('h6', {
    staticClass: "countdown__title"
  }, [_vm._v("Time Remaining")]), _vm._v(" "), (!_vm.loading) ? _c('h1', {
    staticClass: "countdown__timer"
  }, [_vm._v(_vm._s(_vm.minutes) + ":" + _vm._s(_vm.seconds))]) : _c('h1', {
    staticClass: "countdown__timer"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "30",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), _c('sk-dialog', {
    staticClass: "video",
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.showWarning),
      callback: function($$v) {
        _vm.showWarning = $$v
      },
      expression: "showWarning"
    }
  }, [_c('h3', [_vm._v("Your booking session will expire in\n                "), (_vm.minutes != '00') ? [_vm._v(_vm._s(_vm.minutes) + " minutes!")] : [_vm._v(_vm._s(_vm.seconds) + " seconds!")]], 2), _vm._v(" "), _c('p', [_vm._v("\n                Please click continue to carry on.\n            ")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "loading": _vm.loadingContinue
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.continueOrder()
      }
    }
  }, [_vm._v("Continue With Booking")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.cancelOrderLoad
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelOrder()
      }
    }
  }, [_vm._v("Cancel")])], 1)] : _vm._e(), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.showTimeout),
      callback: function($$v) {
        _vm.showTimeout = $$v
      },
      expression: "showTimeout"
    }
  }, [_c('h3', [_vm._v("Looks like your booking session has expired.")]), _vm._v(" "), _c('p', [_vm._v(" Don't worry, it's easy to start again.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "loading": _vm.loadingContinue
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.restartOrder()
      }
    }
  }, [_vm._v("Start again")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.cancelOrderLoad
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goHome()
      }
    }
  }, [_vm._v("Take me home")])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(737),
  /* template */
  __webpack_require__(738),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_middleware_api_model__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_user_badgeConfig__ = __webpack_require__(81);








/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        order: Object
    },

    data: function data() {
        var _this = this;

        return {
            loading: false,
            cards: [],

            newCard: new __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_middleware_api_model__["e" /* LoyaltyCard */](),
            newCardLoading: false,
            validating: false,
            linkCard: false,
            cardNumberPlaceholder: "Movie Card Number",

            badgeConfig: __WEBPACK_IMPORTED_MODULE_6__pages_user_badgeConfig__["a" /* default */],
            rewardSelected: false,
            rewardsList: {},
            showRewards: false,
            outside: undefined,
            fanClubSingle: null,
            fanClubCombo: null,
            allowedSKClubLinkecCards: ["SKCT", "SKC", "SKCS"],
            cinemaType: '',
            defaultTicketType: undefined,
            ticketImageMapping: {
                "loyalty-edgars-club.png": function loyaltyEdgarsClubPng(ticketType) {
                    return ~ticketType.Description.toLowerCase().indexOf('edgars');
                },
                "loyalty-sk-club-premier.png": function loyaltySkClubPremierPng(ticketType) {
                    return ~ticketType.Description.toLowerCase().indexOf('sk') && ~ticketType.Description.toLowerCase().indexOf('premier');
                },
                "loyalty-sk-club.png": function loyaltySkClubPng(ticketType) {
                    return ~ticketType.Description.toLowerCase().indexOf('sk');
                },
                "loyalty-vitality.png": function loyaltyVitalityPng(ticketType) {
                    return ~ticketType.Description.toLowerCase().indexOf('vitality') && !~ticketType.Description.toLowerCase().indexOf('kids');
                },
                "loyalty-vitality-prestige-logo.jpg": function loyaltyVitalityPrestigeLogoJpg(ticketType) {
                    return ~ticketType.Description.toLowerCase().indexOf('vitality') && ~ticketType.Description.toLowerCase().indexOf('prestige');
                },
                "loyalty-vitality-prestige-nouveau-logo.jpg": function loyaltyVitalityPrestigeNouveauLogoJpg(ticketType) {
                    return ~ticketType.Description.toLowerCase().indexOf('vitality') && ~ticketType.Description.toLowerCase().indexOf('prestige') && _this.cinemaType.includes('Nouveau');
                },
                "loyalty-vitality-kids.png": function loyaltyVitalityKidsPng(ticketType) {
                    return ~ticketType.Description.toLowerCase().indexOf('vitality') && ~ticketType.Description.toLowerCase().indexOf('kids');
                },
                "loyalty-voucher.png": function loyaltyVoucherPng(ticketType) {
                    return ~ticketType.Description.toLowerCase().indexOf('voucher') && !~ticketType.Description.toLowerCase().indexOf('ebucks');
                },
                "loyalty-ebucks.png": function loyaltyEbucksPng(ticketType) {
                    return ~ticketType.Description.toLowerCase().indexOf('ebucks');
                },
                "morvies_club_card.png": function morvies_club_cardPng(ticketType) {
                    return ~ticketType.Description.toLowerCase().indexOf('morvies');
                },
                "fan_club_card.png": function fan_club_cardPng(ticketType) {
                    return ~ticketType.Description.toLowerCase().indexOf('fan');
                }
            }
        };
    },


    watch: {
        newCard: {
            handler: function handler() {

                if (this.newCard.TicketType != undefined) {
                    if ((this.newCard.TicketType.Description.includes('Voucher') || this.newCard.TicketType.Description.includes('(V)') || this.newCard.TicketType.Description.includes('Re-Admission')) && !this.newCard.TicketType.Description.includes('EBucks')) {
                        this.cardNumberPlaceholder = "Voucher Number";
                    } else {
                        this.cardNumberPlaceholder = "Movie Card Number";
                    }
                } else {
                    this.cardNumberPlaceholder = "Movie Card Number";
                }
            },

            deep: true
        }
    },

    computed: {
        seatNames: function seatNames() {
            return this.order.Tickets.map(function (Ticket) {
                return Ticket.SeatData;
            });
        },
        newCardSubmittable: function newCardSubmittable() {
            return this.newCard.MemberCard && this.newCard.MemberCard != '' && this.newCard.TicketType != undefined;
        },
        selectedTicketType: function selectedTicketType() {
            return this.newCard.TicketType != undefined ? this.newCard.TicketType : null;
        },
        isStandardPackageTicket: function isStandardPackageTicket() {
            if (this.newCard.TicketType != undefined) {
                if (this.newCard.TicketType.IsPackageTicket && !this.newCard.TicketType.IsThirdPartyMemberTicket && !this.newCard.TicketType.IsRedemptionTicket) {
                    return true;
                }
            }

            return false;
        },
        ticketTypes: function ticketTypes() {
            var loyalty = this.order && this.order.TicketTypes ? this.order.TicketTypes.filter(function (type) {
                return type.IsThirdPartyMemberTicket || type.IsRedemptionTicket;
            }) : [];

            var packageTickets = this.order && this.order.TicketTypes ? this.order.TicketTypes.filter(function (type) {
                return !type.IsThirdPartyMemberTicket && !type.IsRedemptionTicket && type.IsPackageTicket == true && !type.Description.includes("SK Fan Club");
            }) : [];

            var ticketTypes = loyalty.concat(packageTickets);
            ticketTypes.sort(function (a, b) {
                return a.DisplaySequence - b.DisplaySequence;
            });

            return ticketTypes;
        },
        availableLoyalties: function availableLoyalties() {
            var _this2 = this;

            var addedNonStandardTickets = this.addedNonStandardTickets;
            var addedTicketTypeCodes = [];
            for (var i = 0; i < addedNonStandardTickets.length; i++) {
                addedTicketTypeCodes.push(addedNonStandardTickets[i].TicketTypeCode);
            }

            return this.ticketTypes && this.user ? this.ticketTypes.reduce(function (c, t) {

                if (~_this2.allowedSKClubLinkecCards.indexOf(t.ThirdPartyMembershipName.split(' ')[0])) {
                    if (t.ThirdPartyMembershipName.split(' ')[0] == "SKCS" && _this2.user.MemberLevelId == 3 || t.ThirdPartyMembershipName.split(' ')[0] != "SKCS" && _this2.user.MemberLevelId != 3) {
                        var cardNUmber = _this2.user.CardNumber;
                        var card = new __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_middleware_api_model__["e" /* LoyaltyCard */]({
                            MemberCard: cardNUmber,
                            TicketType: t,
                            MemberProviderName: _this2.user.FirstName
                        });
                        card.linked = false;
                        if (addedTicketTypeCodes.includes(t.TicketTypeCode)) card.linked = true;
                        c.push(card);
                    }
                }

                if (_this2.user.PreferenceList.includes(5)) {
                    if (t.Description.includes("SK MORvies") && !t.Description.includes("Combo")) {
                        var _cardNUmber = _this2.user.CardNumber;
                        var _card = new __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_middleware_api_model__["e" /* LoyaltyCard */]({
                            MemberCard: _cardNUmber,
                            TicketType: t,
                            MemberProviderName: _this2.user.FirstName
                        });
                        _card.linked = false;
                        if (addedTicketTypeCodes.includes(t.TicketTypeCode)) _card.linked = true;
                        c.push(_card);
                    }
                }

                if (_this2.user.PreferenceList.includes(5)) {
                    if (t.Description.includes("SK MORvies") && t.Description.includes("Combo")) {
                        var _cardNUmber2 = _this2.user.CardNumber;
                        var _card2 = new __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_middleware_api_model__["e" /* LoyaltyCard */]({
                            MemberCard: _cardNUmber2,
                            TicketType: t,
                            MemberProviderName: _this2.user.FirstName
                        });
                        _card2.linked = false;
                        if (addedTicketTypeCodes.includes(t.TicketTypeCode)) _card2.linked = true;
                        c.push(_card2);
                    }
                }

                if (_this2.user.PreferenceList.includes(6)) {
                    if (t.Description.includes("SK Fan") && !t.Description.includes("Combo")) {
                        var _cardNUmber3 = _this2.user.CardNumber;
                        var _card3 = new __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_middleware_api_model__["e" /* LoyaltyCard */]({
                            MemberCard: _cardNUmber3,
                            TicketType: t,
                            MemberProviderName: _this2.user.FirstName
                        });
                        _card3.linked = false;
                        if (addedTicketTypeCodes.includes(t.TicketTypeCode)) _card3.linked = true;
                        c.push(_card3);

                        _this2.fanClubSingle = _card3;
                    }
                }

                if (_this2.user.PreferenceList.includes(6)) {
                    if (t.Description.includes("SK Fan") && t.Description.includes("Combo")) {
                        var _cardNUmber4 = _this2.user.CardNumber;
                        var _card4 = new __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_middleware_api_model__["e" /* LoyaltyCard */]({
                            MemberCard: _cardNUmber4,
                            TicketType: t,
                            MemberProviderName: _this2.user.FirstName
                        });
                        _card4.linked = false;
                        if (addedTicketTypeCodes.includes(t.TicketTypeCode)) _card4.linked = true;
                        c.push(_card4);

                        _this2.fanClubCombo = _card4;
                    }
                }

                return c;
            }, []) : [];
        },
        rewards: function rewards() {
            var _this3 = this;

            return this.rewardsList && this.rewardsList.TicketTypeList && this.order && this.order.TicketTypes ? this.rewardsList.TicketTypeList.reduce(function (c, r) {
                var TicketType = _this3.order.TicketTypes.find(function (t) {
                    return t.HeadOfficeGroupingCode == r.VistaID;
                });
                if (TicketType) {
                    r.badge = _this3.getBadgeIcon(r);
                    c.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, r, { TicketType: TicketType }));
                }
                return c;
            }, []) : [];
        },
        fanLoyaltyCountAvailable: function fanLoyaltyCountAvailable() {
            var count = 0;
            if (this.rewardsList != undefined && this.rewardsList != null) {
                if (this.rewardsList.TicketTypeList != undefined && this.rewardsList.TicketTypeList != null) {
                    for (var i = 0; i <= this.rewardsList.TicketTypeList.length; i++) {
                        if (this.rewardsList.TicketTypeList[i] != undefined && this.rewardsList.TicketTypeList[i] != null) {
                            if (this.rewardsList.TicketTypeList[i].Name.includes("Limited Subs")) {
                                if (this.rewardsList.TicketTypeList[i].QtyAvailable > 0) {
                                    count = this.rewardsList.TicketTypeList[i].QtyAvailable;
                                }
                            }
                        }
                    }
                }
            }

            return count;
        },
        fanLoyaltyCountAdded: function fanLoyaltyCountAdded() {
            var count = 0;

            if (this.order.Session.Loyalties != undefined && this.order.Session.Loyalties != null) {
                for (var i = 0; i <= this.order.Session.Loyalties.length; i++) {
                    if (this.order.Session.Loyalties[i] != undefined && this.order.Session.Loyalties[i] != null) {

                        if (this.order.Session.Loyalties[i].TicketType.Description.includes('Fan Club')) {
                            count++;
                        }
                    }
                }
            }

            return count;
        },
        addedVoucherTickets: function addedVoucherTickets() {
            var addedVouchers = [];
            if (this.order.Session.Tickets.length > 0) {
                for (var i = 0; i < this.order.Session.Tickets.length; i++) {
                    var ticket = this.order.Session.Tickets[i];

                    if (ticket.Barcode !== null && (ticket.Description.toLowerCase().includes('bundle') || ticket.Description.toLowerCase().includes('voucher') || ticket.Description.toLowerCase().includes('(v)') || ticket.Description.toLowerCase().includes('re-admission') || ticket.Description.toLowerCase().includes('readmission'))) {
                        addedVouchers.push(ticket);
                    }
                }
            }
            return addedVouchers;
        },
        addedLoyaltyTickets: function addedLoyaltyTickets() {
            var addedLoyalties = [];
            if (this.order.Session.Tickets.length > 0) {
                for (var i = 0; i < this.order.Session.Tickets.length; i++) {
                    var ticket = this.order.Session.Tickets[i];
                    for (var t = 0; t < this.order.Session.TicketTypes.length; t++) {
                        var ticketType = this.order.Session.TicketTypes[t];

                        if (ticketType.TicketTypeCode === ticket.TicketTypeCode && ticket.Description.toLowerCase().includes('bundle') === false && ticket.Description.toLowerCase().includes('voucher') === false && ticket.Description.toLowerCase().includes('(v)') === false && ticket.Description.toLowerCase().includes('re-admission') === false && ticket.Description.toLowerCase().includes('readmission') === false) {
                            if (ticketType.IsThirdPartyMemberTicket || ticketType.IsRedemptionTicket) {
                                addedLoyalties.push(ticket);
                            } else if (ticketType.LoyaltyRecognitionId !== undefined && ticketType.LoyaltyRecognitionId !== null) {
                                addedLoyalties.push(ticket);
                            }
                        }
                    }
                }
            }
            return addedLoyalties;
        },
        addedNonStandardTickets: function addedNonStandardTickets() {
            var addedLoyalties = this.addedLoyaltyTickets;
            var addedVouchers = this.addedVoucherTickets;
            return addedLoyalties.concat(addedVouchers);
        }
    },

    methods: {
        getBadgeIcon: function getBadgeIcon(reward) {
            for (var i = 0; i < this.badgeConfig.length; i++) {
                var _badgeConfig = this.badgeConfig[i];
                if (_badgeConfig.test(reward)) return _badgeConfig;
            }
        },
        onSubmit: function onSubmit() {
            var _this4 = this;

            if (this.newCardSubmittable && !this.isStandardPackageTicket) {
                this.validating = true;
                this.order._loading = true;
                this.loading = true;

                __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].validateLoyaltyForOrder(this.newCard).then(function (ValidCardResponse) {

                    if (ValidCardResponse.Barcode) {
                        var updatedOrder = __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */]._processOrder(ValidCardResponse.order);

                        _this4.order.loadSeatGrid().then(function () {
                            var tickets = updatedOrder.TicketsForSeating;
                            _this4.order.Session.SeatGrid.mapTicketsToGrid(tickets);
                            _this4.loading = false;
                            _this4.order._loading = false;
                        });

                        _this4.newCard.clear();
                        _this4.validating = false;
                        _this4.order._loading = false;
                    } else {
                        var _updatedOrder = __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */]._processOrder(ValidCardResponse.order);
                        _this4.order.loadSeatGrid().then(function () {
                            var tickets = _updatedOrder.TicketsForSeating;
                            _this4.order.Session.SeatGrid.mapTicketsToGrid(tickets);
                            _this4.loading = false;
                            _this4.order._loading = false;
                        });

                        _this4.validating = false;
                    }
                }, function (error) {
                    _this4.newCard.Error = error.error_string || "Unknown Error, Please try again later.";
                    _this4.validating = false;
                    _this4.order._loading = false;
                    _this4.loading = false;
                });
            }
        },
        deleteCard: function deleteCard(card) {
            this.rewardSelected = false;
            this.order.removeLoyalty(card);
        },
        toggleLoyalty: function toggleLoyalty(thisCard) {
            var _this5 = this;

            if (thisCard.linked) {
                this.validating = true;
                this.order._loading = true;
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].validateLoyaltyForOrder(thisCard).then(function (ValidCardResponse) {
                    var card = null;

                    if (ValidCardResponse.Barcode) {
                        var updatedOrder = __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */]._processOrder(ValidCardResponse.order);
                        _this5.order.loadSeatGrid().then(function () {
                            var tickets = updatedOrder.TicketsForSeating;
                            _this5.order.Session.SeatGrid.mapTicketsToGrid(tickets);
                            _this5.loading = false;
                            _this5.order._loading = false;
                        });

                        _this5.newCard.clear();
                        _this5.validating = false;
                        _this5.order._loading = false;
                        _this5.loading = false;
                    } else {
                        var _updatedOrder2 = __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */]._processOrder(ValidCardResponse.order);
                        _this5.order.loadSeatGrid().then(function () {
                            var tickets = _updatedOrder2.TicketsForSeating;
                            _this5.order.Session.SeatGrid.mapTicketsToGrid(tickets);
                            _this5.loading = false;
                            _this5.order._loading = false;
                        });

                        _this5.newCard.clear();
                        _this5.validating = false;
                        _this5.order._loading = false;
                        _this5.loading = false;
                    }
                }, function (error) {
                    if (error.error_string.includes("DB Exception")) {
                        error.error_string = "Unable to validate Loyalty, please try again later.";
                    }

                    _this5.newCard.Error = error.error_string || "Unable to validate Loyalty, please try again later.";
                    _this5.validating = false;
                    _this5.order._loading = false;
                    _this5.loading = false;
                    thisCard.linked = false;
                });
            } else {

                var addedLoyaltyTickets = this.addedLoyaltyTickets;

                var ticketTypeCode = thisCard.TicketType.TicketTypeCode;
                var removeTicket = null;
                for (var i = 0; i < addedLoyaltyTickets.length; i++) {
                    if (addedLoyaltyTickets[i].TicketTypeCode == ticketTypeCode) {
                        removeTicket = addedLoyaltyTickets[i];
                    }
                }

                return this.deleteVistaLoyaltyTicket(removeTicket);
            }
        },
        toggelReward: function toggelReward(thisCard, originalTicket) {
            var _this6 = this;

            console.log("toggelReward", thisCard, originalTicket);

            this.validating = true;
            this.order._loading = true;
            this.loading = true;

            __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].toggleRewardForOrder(thisCard, originalTicket).then(function (ValidCardResponse) {
                var card = null;

                var updatedOrder = __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */]._processOrder(ValidCardResponse);
                _this6.order.loadSeatGrid().then(function () {
                    var tickets = updatedOrder.TicketsForSeating;
                    _this6.order.Session.SeatGrid.mapTicketsToGrid(tickets);
                    _this6.loading = false;
                    _this6.order._loading = false;
                });

                _this6.newCard.clear();
                _this6.validating = false;
                _this6.order._loading = false;
                _this6.loading = false;
            }, function (error) {
                if (error.error_string.includes("DB Exception")) {
                    error.error_string = "Unable to validate Loyalty, please try again later.";
                }

                _this6.newCard.Error = error.error_string || "Unable to validate Loyalty, please try again later.";
                _this6.validating = false;
                _this6.order._loading = false;
                _this6.loading = false;
                thisCard.linked = false;
            });
        },
        toggleFanLoyalty: function toggleFanLoyalty(thisCard) {
            var _this7 = this;

            this.validating = true;
            __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].validateLoyaltyForOrder(thisCard).then(function (ValidCardResponse) {
                var card = null;

                if (ValidCardResponse.Barcode) {
                    card = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(ValidCardResponse, {
                        TicketType: thisCard.TicketType,
                        MemberProviderName: thisCard.Name,
                        Barcode: ValidCardResponse.Barcode,
                        Name: thisCard.Name
                    });
                } else {
                    card = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(ValidCardResponse, {
                        TicketType: thisCard.TicketType,
                        MemberProviderName: thisCard.Name,
                        MemberCard: ValidCardResponse.CardNumber,
                        Name: thisCard.Name
                    });
                }

                _this7.order.addLoyalty(card);
                _this7.validating = false;
            }, function (error) {
                _this7.newCard.Error = error.error_string || "Unknown Error, Please try again later.";
                _this7.validating = false;
                thisCard.linked = false;
            });
        },
        toggleRewards: function toggleRewards($e) {
            $e.stopImmediatePropagation();
            this.showRewards = !this.showRewards;
            if (this.showRewards && this.outside) {
                this.outside._click = this.toggleRewards;
                this.outside.addEventListener("click", this.toggleRewards);
            } else if (this.outside) {
                this.outside.removeEventListener("click", this.outside._click);
            }
        },
        addReward: function addReward(reward, card) {
            card.RecognitionID = reward.RecognitionID;
            card.SequenceNumber = reward.SequenceNumber;
            card.TicketType = reward.TicketType;
            this.rewardSelected = true;
        },
        getLoyalty: function getLoyalty(ticketType) {
            var uri = '/static/img/';
            var img = 'loyalty-voucher.png';
            for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.ticketImageMapping).length; i++) {
                var key = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.ticketImageMapping)[i];
                if (this.ticketImageMapping[key](ticketType)) img = key;
            }
            return uri + img;
        },
        isNouveau: function isNouveau(order) {
            var _this8 = this;

            order.Session.MoviePromise.then(function () {
                order.Experiences.forEach(function (exp) {
                    if (exp && exp.name.includes('Nouveau')) _this8.cinemaType = exp.name;
                });
            });
        },
        deleteVistaVoucherTicket: function deleteVistaVoucherTicket(ticket) {
            var _this9 = this;

            this.loading = true;
            this.order._loading = true;
            __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].removeVistaVoucherTicket(this.order.SessionId, this.order.CinemaId, ticket).then(function (order) {
                var updatedOrder = __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */]._processOrder(order);
                _this9.order.loadSeatGrid().then(function () {
                    var tickets = updatedOrder.TicketsForSeating;

                    _this9.order.Session.SeatGrid.mapTicketsToGrid(tickets);
                    _this9.loading = false;
                    _this9.order._loading = false;
                });
            });
        },
        deleteVistaLoyaltyTicket: function deleteVistaLoyaltyTicket(ticket) {
            var _this10 = this;

            this.loading = true;
            this.order._loading = true;
            __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].removeVistaLoyaltyTicket(this.order.SessionId, this.order.CinemaId, ticket).then(function (order) {
                var updatedOrder = __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */]._processOrder(order);
                _this10.order.loadSeatGrid().then(function () {
                    var tickets = updatedOrder.TicketsForSeating;
                    _this10.order.Session.SeatGrid.mapTicketsToGrid(tickets);
                    _this10.loading = false;
                    _this10.order._loading = false;
                });
            });
        }
    },

    beforeDestroy: function beforeDestroy() {
        if (this.outside && this.outside._click) {
            this.outside.removeEventListener("click", this.outside._click);
        }
    },
    created: function created() {
        var _this11 = this;

        this.loading = true;
        this.outside = document.getElementById('app') || document.body;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user(), __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["b" /* AuthService */].getRewards()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                user = _ref2[0],
                rewards = _ref2[1];

            _this11.user = user;
            _this11.rewardsList = rewards;
            _this11.isNouveau(_this11.order);

            _this11.loading = false;
        });
    }
});

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ticketTypes != undefined && _vm.ticketTypes.length > 0) ? _c('sk-form', {
    staticClass: "loyalty",
    attrs: {
      "inline": ""
    },
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('h2', [_vm._v("Add Movie cards and vouchers")]), _vm._v(" "), _c('p', [_vm._v("Do you have an SK Club, Discovery Vitality or Edgars Club Movie Card?")]), _vm._v(" "), (_vm.newCard.TicketType != null) ? [(_vm.newCard.TicketType.Description.includes('Edgars') || _vm.newCard.TicketType.Description.includes('Primedia') || _vm.newCard.TicketType.Description.includes('Employee') || _vm.newCard.TicketType.Description.includes('Premier')) ? _c('p', [_vm._v("Capture your card details and add to order a ticket. Repeat step for 2 tickets.")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: " loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : [(_vm.availableLoyalties.length > 0 && _vm.user.CardNumber) ? [_c('p', [_vm._v("Choose your linked cards")]), _vm._v(" "), _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.availableLoyalties), function(card, index) {
    return _c('sk-flex', {
      key: index,
      attrs: {
        "sm12": "",
        "md7": "",
        "lg4": ""
      }
    }, [_c('sk-checkbox', {
      staticClass: "linked-card",
      attrs: {
        "name": 'radio-gender-' + index,
        "label": "I'd rather not say"
      },
      on: {
        "input": function($event) {
          _vm.toggleLoyalty(card)
        }
      },
      model: {
        value: (card.linked),
        callback: function($$v) {
          _vm.$set(card, "linked", $$v)
        },
        expression: "card.linked"
      }
    }, [_c('div', {
      staticClass: "linked-card__description",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [(card.TicketType.Description.includes('SK Club')) ? [_c('img', {
      staticStyle: {
        "height": "100%",
        "width": "auto"
      },
      attrs: {
        "src": "/static/img/loyalty-sk-club.png",
        "alt": "Sk Club"
      }
    })] : [(card.TicketType.Description.includes('SK MORvies')) ? [_c('img', {
      staticStyle: {
        "height": "100%",
        "width": "auto"
      },
      attrs: {
        "src": "/static/img/morvies_club_card.png",
        "alt": "Sk Club"
      }
    })] : [(card.TicketType.Description.includes('SK Fan')) ? [_c('img', {
      staticStyle: {
        "height": "100%",
        "width": "auto"
      },
      attrs: {
        "src": "/static/img/fan_club_card.png",
        "alt": "Sk Club"
      }
    })] : _vm._e()]], _vm._v(" "), _c('div', {
      staticClass: "linked-card__card-content"
    }, [_c('div', {
      staticClass: "linked-card__club-cards-title"
    }, [_vm._v("\n                                        " + _vm._s(card.TicketType.Description) + "\n                                    ")]), _vm._v(" "), _c('p', {
      staticClass: "linked-card__club-cards-copy"
    }, [_vm._v("\n                                        " + _vm._s(card.CardNumber) + "\n                                    ")])])], 2)])], 1)
  })), _vm._v(" "), _c('br')], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "loyalty-card-add"
  }, [(_vm.ticketTypes.length > 0) ? _c('div', {
    staticClass: "form-group loyalty-card__movie-card"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Add Movie Card Number or Voucher Code")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.ticketTypes,
      "track-by": "TicketTypeCode",
      "label": "Description",
      "placeholder": "Choose Card or Voucher",
      "multiple": false
    },
    scopedSlots: _vm._u([{
      key: "preLabel",
      fn: function(internalValue) {
        return [(internalValue.option[0].length === undefined) ? _c('span', {
          staticClass: "loyalty-card__form-option"
        }, [_c('img', {
          staticClass: "img-responsive",
          attrs: {
            "src": _vm.getLoyalty(internalValue.option[0])
          }
        })]) : _vm._e()]
      }
    }, {
      key: "option",
      fn: function(props) {
        return [_c('span', {
          staticClass: "option__title"
        }, [(props) ? _c('span', {
          staticClass: "loyalty-card__form-option"
        }, [_c('img', {
          staticClass: "img-responsive",
          attrs: {
            "src": _vm.getLoyalty(props.option)
          }
        })]) : _vm._e(), _vm._v("\n                                    " + _vm._s(props.option.Description) + "\n                                ")])]
      }
    }]),
    model: {
      value: (_vm.newCard.TicketType),
      callback: function($$v) {
        _vm.$set(_vm.newCard, "TicketType", $$v)
      },
      expression: "newCard.TicketType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isStandardPackageTicket) ? [_c('sk-input', {
    class: _vm.$breakpoints.smDown ? '' : 'loyalty-card__no-label',
    attrs: {
      "placeholder": _vm.cardNumberPlaceholder == 'Movie Card Number' ? 'Movie Card Number' : 'Voucher Number'
    },
    model: {
      value: (_vm.newCard.MemberCard),
      callback: function($$v) {
        _vm.$set(_vm.newCard, "MemberCard", $$v)
      },
      expression: "newCard.MemberCard"
    }
  }), _vm._v(" "), _c('sk-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "First Name",
      "placeholder": "Enter a Name"
    },
    model: {
      value: (_vm.newCard.Name),
      callback: function($$v) {
        _vm.$set(_vm.newCard, "Name", $$v)
      },
      expression: "newCard.Name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.validating) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "50",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_vm._v("\n                                Almost there! We're validating your card.\n                            ")])], 1)] : _c('sk-button', {
    class: _vm.$breakpoints.xs ? 'btn--block' : 'loyalty-card__no-label',
    attrs: {
      "primary": "",
      "disabled": !_vm.newCardSubmittable,
      "type": "submit"
    }
  }, [_vm._v("Add\n                    ")])], 2)] : [(_vm.isStandardPackageTicket) ? _c('div', {
    staticClass: "form-group"
  }, [_c('sk-button', {
    class: _vm.$breakpoints.xs ? 'btn--block' : 'loyalty-card__no-label',
    attrs: {
      "primary": "",
      "disabled": !_vm.isStandardPackageTicket && _vm.newCardSubmittable,
      "type": "submit"
    }
  }, [_vm._v("Add\n                    ")])], 1) : _vm._e()]], 2), _vm._v(" "), (_vm.order.Session.Loyalties.length > 0) ? _c('div', {
    staticClass: "loyalty-cards"
  }, [_vm._l((_vm.order.Session.Loyalties), function(card, index) {
    return _c('sk-layout', {
      key: index,
      staticClass: "loyalty-card__preview",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm8": "",
        "md6": ""
      }
    }, [_c('div', {
      staticClass: "loyalty-card__reward-name",
      class: _vm.rewardSelected ? 'selected' : ''
    }, [_vm._v(_vm._s(card.Description))]), _vm._v(" "), (card.MemberProviderName) ? _c('div', {
      staticClass: "loyalty-card__name"
    }, [_vm._v(_vm._s(card.MemberProviderName))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "loyalty-card__number"
    }, [_vm._v(_vm._s(card.CardNumber))]), _vm._v(" "), (_vm.rewards && _vm.rewards.length > 0 && card.CardNumber == _vm.user.CardNumber && _vm.$breakpoints.smDown) ? _c('div', {
      staticClass: "points-selector",
      class: _vm.rewardSelected ? 'redeemed' : ''
    }, [(card.TicketType.Description.includes('SK Club')) ? [_c('sk-button', {
      staticClass: "points-selector__button",
      attrs: {
        "icon": "",
        "light": "",
        "small": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleRewards($event)
        }
      }
    }, [_c('sk-icon', {
      attrs: {
        "flame": ""
      }
    }), (_vm.rewardSelected) ? [_vm._v("Redeemed")] : [_vm._v("Use Rewards")]], 2), _vm._v(" "), (_vm.showRewards) ? _c('div', {
      staticClass: "points-selector__menu"
    }, _vm._l((_vm.rewards), function(reward) {
      return _c('div', {
        key: reward.VistaID
      }, [_c('div', {
        staticClass: "btn-mask points-selector__point",
        on: {
          "click": function($event) {
            _vm.addReward(reward, card)
          }
        }
      }, [_c('sk-badge', {
        attrs: {
          "small": "",
          "no-backface": "",
          "color": reward.badge.color
        }
      }, [_c('template', {
        slot: "front"
      }, [_c('sk-icon', {
        attrs: {
          "icon": reward.badge.icon
        }
      })], 1)], 2), _vm._v(" "), _vm._v("\n                                    " + _vm._s(reward.Description) + "\n                                    ")], 1)])
    })) : _vm._e()] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (false) ? _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm4": "",
        "md6": "",
        "text-right": ""
      }
    }, [(_vm.rewards && _vm.rewards.length > 0 && card.CardNumber == _vm.user.CardNumber && !_vm.$breakpoints.smDown) ? _c('div', {
      staticClass: "points-selector",
      class: _vm.rewardSelected ? 'redeemed' : ''
    }, [(card.TicketType.Description.includes('SK Club')) ? [_c('sk-button', {
      staticClass: "points-selector__button",
      attrs: {
        "icon": "",
        "light": "",
        "small": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleRewards($event)
        }
      }
    }, [_c('sk-icon', {
      attrs: {
        "flame": ""
      }
    }), (_vm.rewardSelected) ? [_vm._v("Redeemed")] : [_vm._v("Use Rewards")]], 2), _vm._v(" "), (_vm.showRewards) ? _c('div', {
      staticClass: "points-selector__menu"
    }, _vm._l((_vm.rewards), function(reward) {
      return _c('div', {
        key: reward.VistaID
      }, [(reward && reward.badge && reward.badge.title && reward.badge.color && reward.badge.icon) ? [_c('div', {
        staticClass: "btn-mask points-selector__point",
        attrs: {
          "data-track-context": "rewards",
          "data-track-value": reward.badge.title
        },
        on: {
          "click": function($event) {
            _vm.addReward(reward, card)
          }
        }
      }, [_c('sk-badge', {
        attrs: {
          "small": "",
          "no-backface": "",
          "color": reward.badge.color
        }
      }, [_c('template', {
        slot: "front"
      }, [_c('sk-icon', {
        attrs: {
          "icon": reward.badge.icon
        }
      })], 1)], 2), _vm._v("\n                                            " + _vm._s(reward.Description) + "\n                                        ")], 1)] : _vm._e()], 2)
    })) : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "loyalty-card__btn-delete"
    }, [_c('sk-button', {
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteCard(card)
        }
      }
    }, [_vm._v("\n                            Delete\n                        ")])], 1)]) : _vm._e()], 1)
  }), _vm._v(" "), _c('hr')], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "loyalty-cards"
  }, [_vm._l((_vm.addedVoucherTickets), function(ticket) {
    return (_vm.addedVoucherTickets.length > 0) ? _c('sk-layout', {
      key: ticket.Id,
      staticClass: "loyalty-card__preview",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm8": "",
        "md6": ""
      }
    }, [_c('div', {
      staticClass: "loyalty-card__reward-name"
    }, [_vm._v(_vm._s(ticket.Description) + " - Seat: " + _vm._s(ticket.SeatData))])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm4": "",
        "md6": "",
        "text-right": ""
      }
    }, [_c('div', {
      staticClass: "loyalty-card__btn-delete"
    }, [_c('sk-button', {
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteVistaVoucherTicket(ticket)
        }
      }
    }, [_vm._v("\n                            Delete\n                        ")])], 1)])], 1) : _vm._e()
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.addedLoyaltyTickets), function(ticket) {
    return (_vm.addedLoyaltyTickets.length > 0) ? _c('sk-layout', {
      key: ticket.Id,
      staticClass: "loyalty-card__preview",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm8": "",
        "md6": ""
      }
    }, [_c('div', {
      staticClass: "loyalty-card__reward-name"
    }, [_vm._v(_vm._s(ticket.Description) + " - Seat: " + _vm._s(ticket.SeatData))])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm4": "",
        "md6": "",
        "text-right": ""
      }
    }, [(_vm.rewards && _vm.rewards.length > 0) ? _c('div', {
      staticClass: "points-selector"
    }, [(ticket.Description.includes('SK Club')) ? [_c('sk-button', {
      staticClass: "points-selector__button",
      attrs: {
        "icon": "",
        "light": "",
        "small": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleRewards($event)
        }
      }
    }, [_c('sk-icon', {
      attrs: {
        "flame": ""
      }
    }), (_vm.rewardSelected) ? [_vm._v("Redeemed")] : [_vm._v("Use Rewards")]], 2), _vm._v(" "), (_vm.showRewards) ? _c('div', {
      staticClass: "points-selector__menu"
    }, _vm._l((_vm.rewards), function(reward) {
      return _c('div', {
        key: reward.VistaID
      }, [(reward && reward.badge && reward.badge.title && reward.badge.color && reward.badge.icon) ? [_c('div', {
        staticClass: "btn-mask points-selector__point",
        attrs: {
          "data-track-context": "rewards",
          "data-track-value": reward.badge.title
        },
        on: {
          "click": function($event) {
            _vm.toggelReward(reward, ticket)
          }
        }
      }, [_c('sk-badge', {
        attrs: {
          "small": "",
          "no-backface": "",
          "color": reward.badge.color
        }
      }, [_c('template', {
        slot: "front"
      }, [_c('sk-icon', {
        attrs: {
          "icon": reward.badge.icon
        }
      })], 1)], 2), _vm._v("\n                                            " + _vm._s(reward.Description) + "\n                                        ")], 1)] : _vm._e()], 2)
    })) : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "loyalty-card__btn-delete"
    }, [_c('sk-button', {
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteVistaLoyaltyTicket(ticket)
        }
      }
    }, [_vm._v("\n                            Delete\n                        ")])], 1)])], 1) : _vm._e()
  })], 2)]], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(740)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(741),
  /* template */
  __webpack_require__(742),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({

	props: {
		card: {
			type: Object,
			required: true
		},

		ticketTypes: Array,
		seatName: String
	},

	data: function data() {
		return {
			changed_default: true,
			selected_card: undefined,
			isDisabled: true
		};
	},


	watch: {
		selected_card: function selected_card() {
			if (this.selected_card != undefined) {
				this.card.type = this.selected_card.TicketTypeCode;
			} else {
				this.card.type = undefined;
			}

			this.selected_card != undefined && this.card.number != '' ? this.isDisabled = false : this.isDisabled = true;
		},
		'card.number': function cardNumber() {
			if (this.selected_card != undefined && this.card.number != '') {
				this.isDisabled = false;
			} else {
				this.isDisabled = true;
			}
		}
	},

	methods: {
		editCard: function editCard() {
			this.card.valid = false;
			this.$parent.$parent.newCard = true;
		},
		deleteCard: function deleteCard() {
			this.$parent.$parent.deleteCard(this.card);
		}
	}
});

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loyalty-card"
  }, [_c('div', {
    staticClass: "loyalty-card__form"
  }, [_c('hr'), _vm._v(" "), (_vm.card.loading) ? [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "50",
      "width": 2,
      "primary": ""
    }
  })] : _vm._e(), _vm._v(" "), (!_vm.card.loading) ? [(_vm.ticketTypes.length > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('sk-combo-select', {
    attrs: {
      "options": _vm.ticketTypes,
      "track-by": "TicketTypeCode",
      "label": "Description",
      "placeholder": "Choose Movie Card",
      "multiple": false
    },
    scopedSlots: _vm._u([{
      key: "preLabel",
      fn: function(internalValue) {
        return [(internalValue.option[0].length === undefined) ? _c('span', {
          staticClass: "loyalty-card__form-option"
        }, [_c('img', {
          staticClass: "img-responsive",
          attrs: {
            "src": '/static/img/loyalty-' + internalValue.option[0].Description.replace(/^\s+|\s+$/gm, '').toLowerCase().replace('+', '').replace(' ', '-').replace('3d', '').replace('prestige', '').replace(' ', '').replace(' ', '') + '.png'
          }
        })]) : _vm._e()]
      }
    }, {
      key: "option",
      fn: function(props) {
        return [_c('span', {
          staticClass: "option__title"
        }, [_c('span', {
          staticClass: "loyalty-card__form-option"
        }, [_c('img', {
          staticClass: "img-responsive",
          attrs: {
            "src": '/static/img/loyalty-' + props.option.Description.replace(/^\s+|\s+$/gm, '').toLowerCase().replace('+', '').replace(' ', '-').replace('3d', '').replace('prestige', '').replace(' ', '').replace(' ', '') + '.png'
          }
        })]), _vm._v("\n                                    " + _vm._s(props.option.Description) + "\n                                ")])]
      }
    }]),
    model: {
      value: (_vm.selected_card),
      callback: function($$v) {
        _vm.selected_card = $$v
      },
      expression: "selected_card"
    }
  })], 1) : _c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "50",
      "width": 2,
      "primary": ""
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "placeholder": "Card Number"
    },
    model: {
      value: (_vm.card.number),
      callback: function($$v) {
        _vm.$set(_vm.card, "number", $$v)
      },
      expression: "card.number"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "placeholder": "Name of Card Holder"
    },
    model: {
      value: (_vm.card.name),
      callback: function($$v) {
        _vm.$set(_vm.card, "name", $$v)
      },
      expression: "card.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('sk-button', {
    class: _vm.$breakpoints.xs ? 'btn--block' : '',
    attrs: {
      "primary": "",
      "disabled": _vm.isDisabled,
      "type": "submit"
    }
  }, [_vm._v("Add")])], 1)] : _vm._e()], 2), _vm._v(" "), (_vm.card.validated) ? _c('div', [_c('hr'), _vm._v(" "), _c('sk-layout', {
    staticClass: "loyalty-card__preview",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.$breakpoints.xs) ? [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "loyalty-card__name sd"
  }, [_vm._v(_vm._s(_vm.card.data.MemberProviderName))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "loyalty-card__name"
  }, [_vm._v("\n                        " + _vm._s(_vm.card.name) + " "), _c('span', {
    staticClass: "loyalty-card__number"
  }, [_vm._v(_vm._s(_vm.card.number))])])]), _vm._v(" "), _c('sk-flex', {
    staticClass: "text-right",
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.deleteCard($event)
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "close": ""
    }
  }), _vm._v(" Delete\n                    ")], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "secondary": "",
      "small": ""
    }
  }, [_vm._v("Burn Points")])], 1)] : [_c('sk-flex', {
    attrs: {
      "xs3": "",
      "loyalty-card__name": ""
    }
  }, [_vm._v(_vm._s(_vm.card.data.MemberProviderName))]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": "",
      "loyalty-card__name": ""
    }
  }, [_vm._v(_vm._s(_vm.card.name) + " "), _c('span', {
    staticClass: "loyalty-card__number"
  }, [_vm._v(_vm._s(_vm.card.number))])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "small": ""
    }
  }, [_vm._v("Burn Points")])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs2": "",
      "loyalty-card__btn-delete": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.deleteCard($event)
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "close": ""
    }
  }), _vm._v(" Delete\n                    ")], 1)], 1)]], 2)], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(744),
  /* template */
  __webpack_require__(745),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(7);









/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        search_filter: [],
        filters: Object,
        filter: Object,
        doSearch: Boolean,
        activeMovie: Object
    },

    data: function data() {
        return {
            hasOpened: false,
            movies: undefined,
            loading: false,
            openForm: this.$breakpoints.smDown ? false : true,
            selected_movie: null,
            lastSelected: null,
            movie_selected_here: false,
            cinema_slected_here: false,
            cinemasNearBy: [],
            place: null,
            selected_cinema_id: '',
            selected_cinema: '',
            selected_cinema_type: null,
            movieCinemas: [],
            form_data: {
                place_query: null,
                keyword: null,
                selected_cinema: null,
                genres: null,
                cinema_types: null,
                filter_group: {
                    genres: null,
                    cinema_types: null
                },
                selected_time_range: null
            },
            search: 'sandton',
            regions: [],
            cinemaType: [],
            allCinemaTypes: [],
            all_movies: [],
            selected_date: '',
            selected_time: null,
            isActive: this.$breakpoints.smDown ? false : true,
            times: [],
            elm: null,
            timer: null,
            covidConfirm: false
        };
    },


    computed: {
        filterVals: function filterVals() {
            var genre_ids = [];
            var collection = { genre_ids: [], experiences: [] };
            if (this.form_data.genres) {
                for (var g in this.form_data.genres) {
                    collection.genre_ids.push(this.form_data.genres[g].id);
                }
            }

            if (this.form_data.cinema_types) {
                for (var c in this.form_data.cinema_types) {
                    collection.experiences.push(this.form_data.cinema_types[c].name);
                }
            }
            var cineams = undefined;
            if (this.form_data.selected_cinema && this.form_data.selected_cinema.id) {
                var cinemas = this.form_data.selected_cinema.id;
            }

            return {
                title: undefined,
                cinemas: cinemas,
                genres: collection.genre_ids || undefined,
                experiences: collection.experiences || undefined,
                time_range: this.form_data.selected_time_range || undefined
            };
        },
        classes: function classes() {
            return {
                'quick-book': true,
                'quick-book--open': this.isActive
            };
        },
        cinemasByRegion: function cinemasByRegion() {
            var allowedCinemas = this.selected_movie ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.selected_movie.cinemas) : this.movieCinemas;

            var allowedRegions = this.regions.map(function (r) {
                var cinemas = r.cinemas.filter(function (c) {
                    return ~allowedCinemas.indexOf(c.id.toString()) || allowedCinemas.length == 0;
                });
                return {
                    id: r.id,
                    name: r.name,
                    cinemas: cinemas
                };
            }).filter(function (r) {
                return r.cinemas.length > 0;
            });

            return [{ name: 'Nearby', cinemas: this.cinemasNearBy }].concat(allowedRegions);
        },
        cinema: function cinema() {
            return this.form_data.selected_cinema;
        },
        cinema_type: function cinema_type() {
            var default_cinema_type = null;

            if (this.selected_movie) default_cinema_type = this.selected_movie.experiences[0];
            return this.selected_cinema_type || default_cinema_type;
        },
        sessions: function sessions() {
            var _this = this;

            return this.selected_movie && this.cinema && this.cinema.id && this.selected_movie.cinemas[this.cinema.id] ? this.selected_movie.cinemas[this.cinema.id].filter(function (s) {
                return ~s.experiences.findIndex(function (e) {
                    return e.name == _this.cinema_type || !_this.cinema_type;
                }) && !s.show_time.additional.is_passed;
            }) : [];
        },
        availableDates: function availableDates() {
            var availableDates = this.sessions.reduce(function (c, session) {
                var obj = {
                    string: session.show_time.additional.string_short_day_of_week + ', ' + session.show_time.additional.string_nth_day + ' ' + session.show_time.additional.string_short_month,
                    show_time: session.show_time
                };
                !~c.findIndex(function (c) {
                    return c.string === obj.string;
                }) && c.push(obj);


                return c;
            }, []);
            if (!this.selected_date) this.selected_date = availableDates[0];

            return availableDates;
        },
        availableSessions: function availableSessions() {
            var _this2 = this;

            var availableSessions = this.sessions.filter(function (session) {
                return session.show_time.date.format('YYYY-MM-DD') === _this2.selected_date.show_time.date.format('YYYY-MM-DD');
            }).map(function (s) {
                s.time = s.show_time.additional.no_zero_hour_24 + ':' + s.show_time.additional.minute;
                return s;
            });
            if (!this.selected_time) this.selected_time = availableSessions[0];

            return availableSessions;
        },
        cinemaExperiences: function cinemaExperiences() {
            return this.selected_movie && this.form_data.selected_cinema ? this.selected_movie.getExperienceForCinema(this.form_data.selected_cinema.id) : [];
        },
        canBook: function canBook() {
            return true;
        }
    },

    created: function created() {
        var _this3 = this;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getRegions(), this.filterMovies()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                regions = _ref2[0],
                filtered = _ref2[1];

            _this3.regions = regions.data;

            if (_this3.activeMovie) {
                _this3.selected_movie = _this3.activeMovie;
            }
            __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].nextTick(function () {
                _this3.startAutoClose();
            });
        });
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.form_data, this.filters);
    },


    methods: {
        filterMovies: function filterMovies() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getFilteredMovies(this.filterVals).then(function (movies) {
                _this4.lastSelected = _this4.movie_selected_here ? _this4.selected_movie : undefined;
                _this4.movies = movies.byHasSessions();
                _this4.movieCinemas = movies.getCinemaIds();
                _this4.selected_movie = _this4.lastSelected || _this4.selected_movie;
            });
        },
        toggleForm: function toggleForm() {
            this.isActive = !this.isActive;
        },
        startAutoClose: function startAutoClose() {
            if (!this.$breakpoints.smDown) {
                this.elm = this.$el;
                this.elm.addEventListener('mousedown', this.stopAutoClose);
                this.timer = window.setTimeout(this.toggleForm, 8000);
            }
        },
        stopAutoClose: function stopAutoClose() {
            window.clearTimeout(this.timer);
            window.removeEventListener('mousedown', this.elm);
        },
        toggleCinemaType: function toggleCinemaType(el, experience) {},
        startOrder: function startOrder() {
            var _this5 = this;

            this.loading = true;
            window.scroll({ top: 0, left: 0 });
            __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_middleware_api_service__["k" /* OrderService */].newOrder(this.selected_time.id, this.cinema.id, this.selected_movie.id).then(function (order) {
                _this5.$router.push('/booking/1');
            });
        }
    },

    watch: {
        activeMovie: function activeMovie() {

            if (!this.hasOpened && this.form_data.selected_cinema && !this.$breakpoints.smDown) {
                this.isActive = true;
                this.hasOpened = true;
            }
            if ((!this.movie_selected_here || !this.selected_movie) && this.activeMovie) {
                this.movie_selected_here = false;

                this.selected_movie = this.activeMovie;
            }
        },

        form_data: {
            handler: function handler() {
                this.filterMovies();
                this.selected_date = undefined;
                this.selected_time = undefined;
            },

            deep: true
        },
        filters: {
            handler: function handler() {
                if (!this.cinema_selected_here || !this.form_data.selected_cinema) {
                    this.cinema_selected_here = false;
                    this.form_data.selected_cinema = this.filters.selected_cinema;
                }
            },
            deep: true
        },
        selected_movie: function selected_movie() {
            this.selected_date = undefined;
            this.selected_time = undefined;
        },
        selected_date: function selected_date() {
            this.selected_time = undefined;
        }
    }
});

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.regions.length > 0) ? _c('div', {
    class: _vm.classes
  }, [(_vm.$breakpoints.smDown) ? _c('sk-dialog', {
    attrs: {
      "light": "",
      "width": "80%",
      "lazy": "",
      "fullscreen": true,
      "overlay": false
    },
    model: {
      value: (_vm.isActive),
      callback: function($$v) {
        _vm.isActive = $$v
      },
      expression: "isActive"
    }
  }, [_c('div', {
    staticClass: "dialog__header"
  }, [_c('div', {
    staticClass: "dialog__header-title"
  }, [_c('sk-icon', {
    attrs: {
      "quick-book": ""
    }
  }), _vm._v(" QUICK BOOK")], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isActive = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleForm($event)
      }
    }
  }), _vm._v(" "), _c('sk-container', [_c('sk-layout', {
    staticClass: "quickbook-form",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-form', {
    attrs: {
      "inline": ""
    }
  }, [_c('div', {
    staticClass: "form-group quick-book__select"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cinema")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.cinemasByRegion,
      "group-values": "cinemas",
      "group-label": "name",
      "track-by": "name",
      "search": _vm.search,
      "label": "name",
      "searchable": true,
      "placeholder": "Choose A Cinema",
      "multiple": false
    },
    on: {
      "input": function($event) {
        _vm.cinema_selected_here = true
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.$groupLabel) ? [_vm._v("\n                                    " + _vm._s(props.option.$groupLabel) + "\n                                ")] : [_c('span', {
          staticClass: "option__title",
          class: {
            'genres': props.option.id
          }
        }, [_vm._v(_vm._s(props.option.name) + " "), (props.option.distance) ? [_vm._v("- " + _vm._s(props.option.distance) + "KM")] : _vm._e()], 2)]]
      }
    }]),
    model: {
      value: (_vm.form_data.selected_cinema),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "selected_cinema", $$v)
      },
      expression: "form_data.selected_cinema"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_vm._v("\n                                No cinema found, try a different cinema\n                            ")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__select"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Movie / Event")]), _vm._v(" "), (_vm.movies) ? [(_vm.movies.now_showing.length > 0) ? _c('sk-combo-select', {
    attrs: {
      "options": _vm.movies.now_showing,
      "search": _vm.search,
      "searchable": true,
      "placeholder": "Choose A Movie",
      "multiple": false,
      "track-by": "title",
      "label": "title"
    },
    on: {
      "input": function($event) {
        _vm.movie_selected_here = true
      }
    },
    model: {
      value: (_vm.selected_movie),
      callback: function($$v) {
        _vm.selected_movie = $$v
      },
      expression: "selected_movie"
    }
  }) : (!_vm.form_data.selected_cinema) ? _c('div', [_vm._v("No Movies Found")]) : _c('div', [_vm._v("choose a different cinema")])] : _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("Choose a Cinema")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__labels"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cinema Type")]), _vm._v(" "), (_vm.selected_movie && _vm.form_data.selected_cinema) ? [_c('sk-list', {
    attrs: {
      "inline": ""
    }
  }, _vm._l((_vm.cinemaExperiences), function(i, index) {
    return _c('sk-list-item', {
      key: index
    }, [_c('span', {
      staticClass: "label",
      class: {
        'label--active': _vm.cinema_type == i
      },
      on: {
        "click": function($event) {
          _vm.selected_cinema_type = i;
        }
      }
    }, [_vm._v(_vm._s(i))])])
  }))] : (!this.selected_movie) ? _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("\n                            Choose A Movie\n                        ")]) : (!_vm.selected_cinema) ? _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("\n                            Choose A Cinema\n                        ")]) : _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("\n                            No Performances available\n                        ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__select quick-book__select--small"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date")]), _vm._v(" "), (_vm.cinema_type && _vm.form_data.selected_cinema && _vm.selected_movie && _vm.sessions) ? [(_vm.availableDates.length > 0) ? [_c('sk-combo-select', {
    attrs: {
      "options": _vm.availableDates,
      "search": _vm.search,
      "label": "string",
      "searchable": false,
      "placeholder": "Date",
      "multiple": false
    },
    model: {
      value: (_vm.selected_date),
      callback: function($$v) {
        _vm.selected_date = $$v
      },
      expression: "selected_date"
    }
  })] : _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("\n                                Choose A Movie\n                            ")])] : [_c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("Choose a Cinema Type")])]], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__select quick-book__select--small"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Time")]), _vm._v(" "), (_vm.cinema_type && _vm.form_data.selected_cinema && _vm.selected_movie && _vm.selected_date != null) ? [(_vm.selected_date) ? [_c('sk-combo-select', {
    attrs: {
      "options": _vm.availableSessions,
      "search": _vm.search,
      "searchable": false,
      "placeholder": "Time",
      "multiple": false,
      "label": "time"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', {
          staticClass: "option__title"
        }, [_vm._v(_vm._s(props.option.time) + " - " + _vm._s(props.option.screen_name))])]
      }
    }]),
    model: {
      value: (_vm.selected_time),
      callback: function($$v) {
        _vm.selected_time = $$v
      },
      expression: "selected_time"
    }
  })] : _vm._e()] : _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("Choose a Date")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__btn--book"
  }, [_c('sk-button', {
    attrs: {
      "block": "",
      "disabled": (_vm.canBook && _vm.selected_time != null) ? false : true,
      "primary": "",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.startOrder()
      }
    }
  }, [_vm._v("\n                            Book now\n                        ")])], 1)])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "quick_book_container",
    staticClass: "quick-book__form"
  }, [_c('sk-container', [_c('div', {
    staticClass: "quick-book__wrap-btn"
  }, [_c('sk-button', {
    staticClass: "quick-book__btn--toggle",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleForm($event)
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "quick-book": ""
    }
  }), _vm._v(" QUICK BOOK "), _c('sk-icon', {
    attrs: {
      "up-open": !_vm.isActive,
      "down-open": _vm.isActive
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "quickbook-form",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-form', {
    attrs: {
      "inline": ""
    }
  }, [_c('div', {
    staticClass: "form-group quick-book__select"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cinema")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.cinemasByRegion,
      "group-values": "cinemas",
      "group-label": "name",
      "track-by": "name",
      "search": _vm.search,
      "label": "name",
      "searchable": true,
      "placeholder": "Choose A Cinema",
      "multiple": false
    },
    on: {
      "input": function($event) {
        _vm.cinema_selected_here = true
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.$groupLabel) ? [_vm._v("\n                                " + _vm._s(props.option.$groupLabel) + "\n                            ")] : [_c('span', {
          staticClass: "option__title",
          class: {
            'genres': props.option.id
          }
        }, [_vm._v(_vm._s(props.option.name) + " "), (props.option.distance) ? [_vm._v("- " + _vm._s(props.option.distance) + "KM")] : _vm._e()], 2)]]
      }
    }]),
    model: {
      value: (_vm.form_data.selected_cinema),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "selected_cinema", $$v)
      },
      expression: "form_data.selected_cinema"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_vm._v("\n                            No cinema found, try a different cinema\n                        ")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__select"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Movie / Event")]), _vm._v(" "), (_vm.movies) ? [(_vm.movies.now_showing.length > 0) ? _c('sk-combo-select', {
    attrs: {
      "options": _vm.movies.now_showing,
      "search": _vm.search,
      "searchable": true,
      "placeholder": "Choose A Movie",
      "multiple": false,
      "track-by": "title",
      "label": "title"
    },
    on: {
      "input": function($event) {
        _vm.movie_selected_here = true
      }
    },
    model: {
      value: (_vm.selected_movie),
      callback: function($$v) {
        _vm.selected_movie = $$v
      },
      expression: "selected_movie"
    }
  }) : (!_vm.form_data.selected_cinema) ? _c('div', [_vm._v("No Movies Found")]) : _c('div', [_vm._v("choose a different cinema")])] : _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("Choose a Cinema")])], 2), _vm._v(" "), (_vm.$breakpoints.lg) ? _c('div', {
    staticClass: "form-group quick-book__labels"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cinema Type")]), _vm._v(" "), (_vm.selected_movie && _vm.form_data.selected_cinema) ? [_c('sk-list', {
    attrs: {
      "inline": ""
    }
  }, _vm._l((_vm.cinemaExperiences), function(i, index) {
    return _c('sk-list-item', {
      key: index
    }, [_c('span', {
      staticClass: "label",
      class: {
        'label--active': _vm.cinema_type == i
      },
      on: {
        "click": function($event) {
          _vm.selected_cinema_type = i;
        }
      }
    }, [_vm._v(_vm._s(i))])])
  }))] : (!this.selected_movie) ? _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("\n                        Choose A Movie\n                    ")]) : (!_vm.selected_cinema) ? _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("\n                        Choose A Cinema\n                    ")]) : _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("\n                        No Performances available\n                    ")])], 2) : _c('div', {
    staticClass: "form-group quick-book__select"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cinema Type")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.cinemaExperiences,
      "search": _vm.search,
      "searchable": true,
      "placeholder": "Choose A Cinema Type",
      "multiple": false
    },
    on: {
      "input": function($event) {
        _vm.movie_selected_here = true
      }
    },
    model: {
      value: (_vm.selected_cinema_type),
      callback: function($$v) {
        _vm.selected_cinema_type = $$v
      },
      expression: "selected_cinema_type"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__select quick-book__select--small"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date")]), _vm._v(" "), (_vm.cinema_type && _vm.form_data.selected_cinema && _vm.selected_movie && _vm.sessions) ? [(_vm.availableDates.length > 0) ? [_c('sk-combo-select', {
    attrs: {
      "options": _vm.availableDates,
      "search": _vm.search,
      "label": "string",
      "searchable": false,
      "placeholder": "Date",
      "multiple": false
    },
    model: {
      value: (_vm.selected_date),
      callback: function($$v) {
        _vm.selected_date = $$v
      },
      expression: "selected_date"
    }
  })] : _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("\n                            Choose A Movie\n                        ")])] : [_c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("Choose a Date")])]], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__select quick-book__select--smaller"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Time")]), _vm._v(" "), (_vm.cinema_type && _vm.form_data.selected_cinema && _vm.selected_movie && _vm.selected_date != null) ? [(_vm.selected_date) ? [_c('sk-combo-select', {
    attrs: {
      "options": _vm.availableSessions,
      "search": _vm.search,
      "searchable": false,
      "placeholder": "Time",
      "multiple": false,
      "label": "time"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', {
          staticClass: "option__title"
        }, [_vm._v(_vm._s(props.option.time) + " - " + _vm._s(props.option.screen_name))])]
      }
    }]),
    model: {
      value: (_vm.selected_time),
      callback: function($$v) {
        _vm.selected_time = $$v
      },
      expression: "selected_time"
    }
  })] : _vm._e()] : _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("Choose a Time")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__btn--book"
  }, [_c('sk-button', {
    attrs: {
      "disabled": (_vm.canBook && _vm.selected_time != null) ? false : true,
      "primary": "",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.startOrder()
      }
    }
  }, [_vm._v("\n                        Book now\n                    ")])], 1)])], 1)], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(747),
  /* template */
  __webpack_require__(748),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_model__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_ui_core__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            booking: [],
            related_movies: [],
            movie: {},
            cinema: {},
            generateLoader: false,
            pdfUrl: "",
            facebookPixelWBShow: false,
            facebookPixelSKShow: false,
            facebookPixelSWShow: false
        };
    },


    computed: {
        seatsString: function seatsString() {
            return this.booking.Tickets.map(function (t) {
                return t.SeatData;
            }).join(',');
        },
        bookingDate: function bookingDate() {
            return '' + this.booking.opening_date;
        },
        movieStartTime: function movieStartTime() {
            return '' + this.booking.opening_date;
        },
        movieEndTime: function movieEndTime() {
            return 'TODO';
        }
    },
    methods: {
        downloadPDF: function downloadPDF() {
            return __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["k" /* OrderService */].generateConfirmationPDF(this.$route.params.booking_number, this.$route.params.booking_id, this.$route.params.cinema_id);
        },
        print: function print() {
            window.print();
        },
        facebookPixelSK: function facebookPixelSK(thisMovie) {
            !function (f, b, e, v, n, t, s) {
                if (f.fbq) return;n = f.fbq = function () {
                    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;n.push = n;n.loaded = !0;n.version = '2.0';
                n.queue = [];t = b.createElement(e);t.async = !0;
                t.src = v;s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
            }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1442556416455138');
            fbq('track', 'PageView');
            this.facebookPixelSKShow = true;
        },
        facebookPixelWB: function facebookPixelWB(thisMovie) {
            if (thisMovie == "ANNA" || thisMovie == "IT: CHAPTER 2" || thisMovie == "JOKER") {
                !function (f, b, e, v, n, t, s) {
                    if (f.fbq) return;n = f.fbq = function () {
                        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                    };
                    if (!f._fbq) f._fbq = n;n.push = n;n.loaded = !0;n.version = '2.0';
                    n.queue = [];t = b.createElement(e);t.async = !0;
                    t.src = v;s = b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t, s);
                }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '492438917984256');
                fbq('track', 'PageView');
                this.facebookPixelWBShow = true;
            }
        },
        facebookPixelStarWars: function facebookPixelStarWars(thisMovie) {
            if (thisMovie == "STAR WARS: THE RISE OF SKYWALKER") {
                !function (f, b, e, v, n, t, s) {
                    if (f.fbq) return;n = f.fbq = function () {
                        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                    };
                    if (!f._fbq) f._fbq = n;n.push = n;n.loaded = !0;n.version = '2.0';
                    n.queue = [];t = b.createElement(e);t.async = !0;
                    t.src = v;s = b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t, s);
                }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '482871855641247');
                fbq('track', 'PageView');
                this.facebookPixelSWShow = true;
            }
        },
        adsrvrPixel: function adsrvrPixel() {
            ttd_dom_ready(function () {
                if (typeof TTDUniversalPixelApi === 'function') {
                    var universalPixelApi = new TTDUniversalPixelApi();
                    universalPixelApi.init("mxyqca6", ["ytaat3z"], "https://insight.adsrvr.org/track/up");
                }
            });
        }
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getBooking(this.$route.params.booking_number, this.$route.params.booking_id, this.$route.params.cinema_id), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovies(), this.downloadPDF()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
                booking = _ref2[0],
                movies = _ref2[1],
                pdfUrl = _ref2[2];

            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["d" /* EcomTrackingService */].doSuccessfulTransaction(booking)).then(function (result) {});
            _this.pdfUrl = pdfUrl;
            _this.booking = booking;

            for (var i = 0; i <= booking.length; i++) {
                if (booking[i] != undefined) {
                    _this.facebookPixelWB(booking[i].MovieName);

                    _this.facebookPixelStarWars(booking[i].MovieName);
                }
            }

            _this.facebookPixelSK();

            _this.related_movies = movies.data;
            __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["k" /* OrderService */].commitGenreCount().then(function () {
                return _this.loading = false;
            }, function () {
                return _this.loading = false;
            });

            var fireEpicDealPixel = false;
            if (booking[0] !== undefined) {
                if (booking[0].Tickets !== undefined) {
                    for (var _i = 0; _i < booking[0].Tickets.length; _i++) {
                        if (booking[0].Tickets[_i].Description.includes('Epic')) {
                            fireEpicDealPixel = true;
                        }
                    }
                }
            }

            if (fireEpicDealPixel) {
                _this.adsrvrPixel();
            }

            _this.loading = false;
        }, function (error) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
        });
    }
});

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('sk-panel', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', {
    staticClass: "booking-successful"
  }, [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "check-ticket"
  }, [_c('sk-title-heading', {
    attrs: {
      "h2": "",
      "label": "See you at the movies!"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('a', {
    attrs: {
      "href": _vm.pdfUrl,
      "target": "_blank"
    }
  }, [_c('sk-button', {
    staticClass: "no-print",
    attrs: {
      "secondary": "",
      "small": "",
      "loading": _vm.generateLoader
    }
  }, [_vm._v("Download\n                                            "), _c('template', {
    slot: "loader"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "20",
      "width": 2
    }
  })], 1)], 2)], 1)])], 2), _vm._v(" "), _c('sk-layout', {
    staticClass: "covid-messaging",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-panel', [_c('p', {
    staticClass: "covid-headline"
  }, [_vm._v("\n                                       Thanks for booking with us! We've missed you and look forward to providing a safe cinematic experience!\n                                    ")])])], 1), _vm._v(" "), (!_vm.booking || _vm.booking.length <= 0) ? [_c('sk-panel', [_vm._v("\n                                    Sorry! We cant seem to find that booking. please contact Customer Care on: 0861 MOVIES (668437) for assistance.\n                                    "), _c('hr'), _vm._v("\n                                    your booking number is: " + _vm._s(_vm.$route.params.booking_number) + "\n                                    and your booking Id is: " + _vm._s(_vm.$route.params.booking_id) + "\n\n                                ")])] : _c('sk-booking', {
    attrs: {
      "bookingHistory": _vm.booking,
      "show-view": false,
      "show-download": false,
      "is-single-booking": true
    }
  })], 2)])], 1)], 1)]), _vm._v(" "), (!_vm.loading) ? [_c('sk-signin', {
    staticClass: "no-print"
  }), _vm._v(" "), _c('sk-related-movies', {
    staticClass: "no-print",
    attrs: {
      "movies": _vm.related_movies,
      "limit": "6"
    }
  })] : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(750),
  /* template */
  __webpack_require__(751),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'BookingUnsuccessful',

    data: function data() {
        return {
            loading: true,
            booking: __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getBookings(),
            error: undefined,
            order: undefined,
            related_movies: []
        };
    },


    methods: {
        returnToBookingFlow: function returnToBookingFlow() {
            var _this = this;

            if (this.order.Tickets.length > 0) this.$router.push('/booking/4');else __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["k" /* OrderService */].restartOrder().then(function () {
                _this.$router.push('/booking/1');
            });
        }
    },
    created: function created() {
        var _this2 = this;

        try {
            __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getOrder().then(function (order) {
                _this2.loading = false;
                _this2.order = order;
            }, function (e) {
                _this2.loading = false;
            });
        } catch (e) {
            this.loading = false;
        }
    }
});

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('sk-panel', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', {
    staticClass: "booking-successful"
  }, [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "check-ticket"
  }, [_c('sk-title-heading', {
    attrs: {
      "h2": "",
      "label": "Payment Status"
    }
  }), _vm._v(" "), _c('p', [_vm._v("We're sorry, but this payment could not be processed. Please contact your financial institution and try again or use a different card. ")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs10": "",
      "sm10": ""
    }
  }, [_c('div', {
    staticClass: "check-ticket--right"
  }, [_c('div', {
    staticClass: "movie-details"
  }, [(_vm.error != undefined) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.errorDescription != undefined),
      expression: "error.errorDescription != undefined"
    }],
    staticClass: "confirmation-error"
  }, [_c('p', [_vm._v(_vm._s(_vm.error.errorDescription))])])] : _vm._e(), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "inline-block": "",
      "router": "",
      "to": "/"
    }
  }, [_vm._v("\n                                                Cancel Booking\n                                            ")]), _vm._v(" "), (_vm.order != undefined) ? [_c('sk-button', {
    attrs: {
      "primary": "",
      "inline-block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.returnToBookingFlow()
      }
    }
  }, [_vm._v("\n                                                    Try Again\n                                                ")])] : _vm._e()], 2)])])], 1)], 1)])], 1)], 1)]), _vm._v(" "), _c('sk-signin'), _vm._v(" "), _c('sk-related-movies', {
    attrs: {
      "movies": _vm.related_movies
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(753),
  /* template */
  __webpack_require__(754),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({

    props: {
        order: Object,
        movie: Object,
        cinema: Object
    },

    data: function data() {
        return {
            ticketMobile: false,
            toggleDialog: false,
            cancelOrderLoad: false,
            maxTotal: 5000,
            subsClubComboPrice: 51.84,
            subsClubComboPriceInCents: 5184,
            currency: "R"
        };
    },


    computed: {
        ticketsGrouped: function ticketsGrouped() {
            var _this = this;

            if (!this.order || !this.order.Tickets) {
                return [];
            }

            var tickets = this.order.Tickets.reduce(function (collection, ticket) {
                var key = ticket.Description;
                collection[key] = collection[key] || {
                    Description: ticket.Description,
                    PriceInCents: ticket.PriceCents,
                    Quantity: 0
                };

                if (collection[key].Description.includes('SK MORvies') && collection[key].Description.includes('Combo') || collection[key].Description.includes('SK Fan') && collection[key].Description.includes('Combo')) {
                    if (collection[key].PriceInCents == 0) {
                        collection[key].PriceInCents = _this.subsClubComboPriceInCents;
                    }
                }
                collection[key].Quantity++;
                return collection;
            }, {});

            return tickets;
        },
        total: function total() {
            if (!this.order || !this.order.Tickets) {
                return this.currency + '0.00';
            }

            var ConcessionTotal = this.order && this.order.Concessions ? this.order.Concessions.reduce(function (c, t) {
                return c += t.PriceInCents * t.Quantity;
            }, 0) : 0;

            var totalTicketPrice = this.order.Sessions ? this.order.Sessions.reduce(function (collection, session) {
                var totalTicketPrice = session.Tickets ? session.Tickets.reduce(function (v, t) {
                    return v += t.PriceCents / 100;
                }, 0) : 0;
                return collection += totalTicketPrice;
            }, 0) : 0;

            totalTicketPrice += ConcessionTotal / 100;

            var priceFormatted = totalTicketPrice.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            return this.currency + ('' + priceFormatted);
        },
        isConcessionStep: function isConcessionStep() {
            return ~this.$route.path.indexOf('booking/2');
        },
        orderTotal: function orderTotal() {
            var hasSubsCombo = false;
            var comboCount = 0;
            var orderTotal = 0;

            if (this.order != undefined && this.order != null) {

                if (this.order.Concessions != undefined && this.order.Concessions != null) {
                    for (var i = 0; i <= this.order.Concessions.length; i++) {
                        if (this.order.Concessions[i] != undefined && this.order.Concessions[i] != null) {

                            orderTotal += this.order.Concessions[i].PriceInCents ? this.order.Concessions[i].PriceInCents * this.order.Concessions[i].Quantity : this.order.Concessions[i].PriceInCents * this.order.Concessions[i].Quantity;
                        }
                    }
                }

                if (this.order.Tickets != undefined && this.order.Tickets != null) {
                    for (var _i = 0; _i <= this.order.Tickets.length; _i++) {
                        var ticket = this.order.Tickets[_i];

                        if (this.order.Tickets[_i] != undefined && this.order.Tickets[_i] != null) {

                            orderTotal += this.order.Tickets[_i].PriceCents ? this.order.Tickets[_i].PriceCents : this.order.Tickets[_i].PriceCents;
                        }
                    }
                }
            }

            var totalTicketPrice = orderTotal / 100;
            var priceFormatted = totalTicketPrice.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            return this.currency + ('' + priceFormatted);
        }
    },

    methods: {
        setSessionsToNull: function setSessionsToNull() {
            this.order.Sessions = null;
        },
        openDialog: function openDialog() {
            if (this.$breakpoints.xs) this.ticketMobile = true;else this.ticketMobile = false;
        },
        cancelOrder: function cancelOrder() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["f" /* ErrorHandler */].ignoreNextError();
            this.cancelOrderLoad = true;
            var session = __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].pendingSession();
            var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].cancelOrder()).then(function (result) {
                __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].clearPendingSessions();
                __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].tearDown();
                _this2.$toaster.show('Your booking was successfully cancelled.', {
                    top: true,
                    fullwidth: true,
                    timeout: 5000
                });
                if (session.MovieId) _this2.$router.push('/details/' + session.MovieId);else {
                    _this2.$router.push('/');
                }
                _this2.cancelOrderLoad = false;
            }, function (e) {
                var session = __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].pendingSession();
                __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].tearDown();
                _this2.$router.push('/details/' + session.MovieId);
            });
        },
        confirmCancelOrder: function confirmCancelOrder() {
            this.toggleDialog = true;
        }
    },

    created: function created() {
        var _this3 = this;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["i" /* MovieMetaService */].getMovieMeta()).then(function (meta) {
            if (meta.extended_regions_data != undefined) {
                for (var i = 0; i < meta.extended_regions_data.length; i++) {
                    if (meta.extended_regions_data[i] != undefined) {
                        if (meta.extended_regions_data[i].cinema_id == _this3.order.CinemaId) {
                            _this3.currency = meta.extended_regions_data[i].currency_symbol;
                        }
                    }
                }
            }
        });

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getPaymentConfig()).then(function (result) {

            if (result.data) {
                _this3.maxTotal = parseInt(result.data[0].max_amount);
            }
        });
    }
});

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-component"
  }, [((!_vm.$breakpoints.xs)) ? _c('div', [_c('div', {
    staticClass: "ticket-title"
  }, [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('h3', [_vm._v("Your Booking")]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.confirmCancelOrder($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1), _vm._v(" "), _c('sk-performance-info-main', {
    attrs: {
      "order": _vm.order,
      "active-order": true,
      "cinema": _vm.cinema
    },
    on: {
      "closeDialog": function($event) {
        _vm.ticketMobile = false;
        _vm.loading = true
      }
    }
  }), _vm._v(" "), _vm._l((_vm.order.Sessions), function(session, index) {
    return (_vm.order.Sessions && session.SessionId !== _vm.order.Session.SessionId) ? _c('sk-performance-info', {
      key: index,
      attrs: {
        "order": _vm.order,
        "index": index,
        "session": session,
        "cinema": _vm.cinema
      },
      on: {
        "closeDialog": function($event) {
          _vm.ticketMobile = false;
          _vm.loading = true
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.order.Concessions.length > 0) ? _c('div', {
    staticClass: "ticket-component-wrapper"
  }, [_c('div', {
    staticClass: "ticket-component-content"
  }, [_c('sk-title-heading', {
    staticClass: "ticket-component-content--heading",
    attrs: {
      "h6": "",
      "label": "Your Extras as"
    }
  }, [_c('template', {
    slot: "append"
  }, [(!_vm.isConcessionStep) ? _c('sk-button', {
    attrs: {
      "link": "",
      "small": "",
      "router": "",
      "to": "/booking/2"
    }
  }, [_vm._v("Edit")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('sk-list', _vm._l((_vm.order.Concessions), function(concession, index) {
    return _c('sk-list-item', {
      key: index
    }, [_c('sk-ticket-seats', {
      attrs: {
        "add-quantity": true,
        "ticket-obj": concession,
        "ticket-type": concession.Description,
        "currency": _vm.currency
      }
    })], 1)
  }))], 1)]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.$breakpoints.xs) ? _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "fullscreen": true,
      "overlay": false
    },
    model: {
      value: (_vm.ticketMobile),
      callback: function($$v) {
        _vm.ticketMobile = $$v
      },
      expression: "ticketMobile"
    }
  }, [_c('div', {
    staticClass: "dialog__header"
  }, [_c('div', {
    staticClass: "dialog__header-title"
  }, [_vm._v("Your Booking")]), _vm._v(" "), _c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.ticketMobile = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.confirmCancelOrder($event)
      }
    }
  }, [_vm._v("Cancel")])], 1), _vm._v(" "), _c('sk-performance-info-main', {
    attrs: {
      "order": _vm.order,
      "active-order": true,
      "cinema": _vm.cinema
    },
    on: {
      "closeDialog": function($event) {
        _vm.ticketMobile = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.order.Sessions), function(session, index) {
    return (_vm.order.Sessions && session.SessionId !== _vm.order.Session.SessionId) ? _c('sk-performance-info', {
      key: index,
      attrs: {
        "session": session,
        "order": _vm.order,
        "index": index,
        "cinema": _vm.cinema
      },
      on: {
        "closeDialog": function($event) {
          _vm.ticketMobile = false
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.order.Concessions.length > 0) ? _c('div', {
    staticClass: "ticket-component-wrapper"
  }, [_c('div', {
    staticClass: "ticket-component-content"
  }, [_c('sk-title-heading', {
    staticClass: "ticket-component-content--heading",
    attrs: {
      "h6": "",
      "label": "Your Extras as"
    }
  }, [_c('template', {
    slot: "append"
  }, [(!_vm.isConcessionStep) ? _c('sk-button', {
    attrs: {
      "link": "",
      "small": "",
      "router": "",
      "to": "/booking/2"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.ticketMobile = false
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('sk-list', _vm._l((_vm.order.Concessions), function(concession, index) {
    return _c('sk-list-item', {
      key: index
    }, [_c('sk-ticket-seats', {
      attrs: {
        "ticket-obj": concession,
        "add-quantity": true,
        "ticket-type": concession.Description,
        "currency": _vm.currency
      }
    })], 1)
  }))], 1)]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleDialog),
      callback: function($$v) {
        _vm.toggleDialog = $$v
      },
      expression: "toggleDialog"
    }
  }, [(_vm.cancelOrderLoad) ? _c('div', {
    staticClass: "text-center"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "50",
      "width": 2,
      "primary": ""
    }
  })], 1) : [_c('h4', [_vm._v("Are you sure you want to cancel your booking?")]), _vm._v(" "), _c('p', [_vm._v("By clicking cancel you'll lose your seats and might not get them back again.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDialog = false
      }
    }
  }, [_vm._v("Wait, take me back")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.cancelOrderLoad
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelOrder();
        _vm.toggleDialog = false;
      }
    }
  }, [_vm._v("I'm sure\n            ")])]], 2), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.order.toggleMaxAmountPurchaseDialog),
      callback: function($$v) {
        _vm.$set(_vm.order, "toggleMaxAmountPurchaseDialog", $$v)
      },
      expression: "order.toggleMaxAmountPurchaseDialog"
    }
  }, [(_vm.cancelOrderLoad) ? _c('div', {
    staticClass: "text-center"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "50",
      "width": 2,
      "primary": ""
    }
  })], 1) : [_c('h4', [_vm._v("Maximum Booking Total")]), _vm._v(" "), _c('p', [_vm._v("This item could not be added to the order because the maximum booking total of " + _vm._s(_vm.currency) + _vm._s(_vm.maxTotal) + " has been exceeded.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.order.toggleMaxAmountPurchaseDialog = false
      }
    }
  }, [_vm._v("Wait, take me back")])]], 2), _vm._v(" "), _c('div', {
    staticClass: "ticket-component-wrapper ticket-component-total",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openDialog($event)
      }
    }
  }, [_c('div', {
    staticClass: "ticket-total"
  }, [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-flex', {
    staticClass: "text-left visible-xs",
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-icon', {
    attrs: {
      "arrow-up": ""
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm12": ""
    }
  }, [_c('span', [_vm._v("Total")]), _vm._v(" " + _vm._s(_vm.orderTotal) + "\n                ")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(756),
  /* template */
  __webpack_require__(757),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        config: Object
    }
});

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-footer"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "sm3": ""
    }
  }, [_c('p', [_vm._v("Previewing: " + _vm._s(_vm._f("truncate")((_vm.config.title), 40, '...')))])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('nav', {
    staticClass: "nav-header"
  }, [_c('ul', {
    staticClass: "nav nav--condensed"
  }, [_c('li', [_c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Available Pages")])]), _vm._v(" "), _vm._l((_vm.config.routes), function(item) {
    return _c('li', [(item.route) ? _c('router-link', {
      attrs: {
        "to": item.route,
        "exact": ""
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.config.cms_url) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.config.cms_url
    }
  }, [_vm._v("Back To Edit")])]) : _vm._e()], 2)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(759),
  /* template */
  __webpack_require__(760),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_meta_data_js__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["default"] = ({
	mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_meta_data_js__["a" /* default */]],
	props: {
		item: Object,
		promo: Boolean,
		competition: Boolean,
		event: Boolean,
		movie: Object,
		festival: Boolean
	},

	data: function data() {
		return {
			dialogActive: false,
			imgSrc: ''
		};
	},


	methods: {
		continueToDetails: function continueToDetails(id) {
			this.$router.push('/film-festival-details/' + id);
		},
		getImages: function getImages() {
			if (this.competition) {
				if (this.item.image) {
					if (this.item.image.url) this.imgSrc = 'background-image:url(' + this.item.image.url + ')';else this.imgSrc = 'background-image:url(/static/img/movie-summary-default-bg.jpg)';
				}
			} else {
				if (this.item.images.background) {
					if (this.item.images.background.url) this.imgSrc = 'background-image:url(' + this.item.images.background.url + ')';else this.imgSrc = 'background-image:url(/static/img/movie-summary-default-bg.jpg)';
				}
			}
		}
	},
	created: function created() {
		if (this.promo) {
			this.metaTitle = 'Promotions';
			this.metaDescription = 'Promotions';
		}
		if (this.competition) {
			this.metaTitle = 'Competitions';
			this.metaDescription = 'Competition';
		}
		if (this.event) {
			this.metaTitle = 'Events';
			this.metaDescription = 'Events';
		}
		this.getImages();
	}
});

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "exclusive"
  }, [(_vm.competition) ? [_c('div', {
    staticClass: "exclusive__img",
    style: (_vm.imgSrc)
  }, [(!_vm.$breakpoints.smDown) ? [_c('div', {
    staticClass: "exclusive__content"
  }, [_c('sk-layout', [(_vm.item.movie && _vm.item.use_movie_poster == '1') ? _c('sk-flex', {
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster ",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        (_vm.item.movie.youtube_id) ? _vm.dialogActive = true: _vm.dialogActive = false
      }
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.item.movie.poster,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-icon', {
    staticClass: "movie-detail__poster-play",
    attrs: {
      "play": ""
    }
  }) : _vm._e()], 1)]) : ((!_vm.item.use_movie_poster || _vm.item.use_movie_poster == '0') && _vm.item.poster_image) ? _c('sk-flex', {
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster movie-detail__poster-img--no-trailer"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.item.poster_image.url,
      "alt": ""
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [(_vm.item.big_title) ? _c('h2', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.item.big_title))]) : _vm._e(), _vm._v(" "), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.strapline)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "exclusive__content-btns"
  }, [(_vm.item.vista_movie_id && !_vm.item.button_link && !_vm.item.button_text) ? _c('sk-button', {
    attrs: {
      "primary": _vm.item.vista_movie_id ? true : false,
      "tag": "a",
      "href": ("/details/" + (_vm.item.vista_movie_id))
    }
  }, [_vm._v("Book to Win\n                                ")]) : (!_vm.item.vista_movie_id && _vm.item.button_link && _vm.item.button_text) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.item.button_link
    }
  }, [_vm._v(_vm._s(_vm.item.button_text) + "\n                                ")]) : _c('div', {
    staticClass: "promo__content-btns"
  }, [(_vm.movie) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.comp.button_link
    }
  }, [_vm._v(_vm._s(_vm.comp.button_text) + "\n                                    ")]) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v(" ")]), _vm._v(" "), [((_vm.item.button_2_link || _vm.item.button_2_text)) ? _c('sk-button', {
    attrs: {
      "tertiary": "",
      "tag": "a",
      "href": _vm.item.button_2_link
    }
  }, [_vm._v(_vm._s(_vm.item.button_2_text) + "\n                                    ")]) : _c('sk-button', {
    attrs: {
      "tertiary": "",
      "tag": "a",
      "href": ("/competition/" + (_vm.item.nid))
    }
  }, [_vm._v("View Competition\n                                        Details\n                                    ")])]], 2)])], 1)], 1)] : [(_vm.item.movie && _vm.item.use_movie_poster == '1') ? _c('div', {
    staticClass: "movie-detail__poster"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.item.movie.poster,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-icon', {
    staticClass: "movie-detail__poster-play",
    attrs: {
      "play": ""
    }
  }) : _vm._e()], 1) : ((!_vm.item.use_movie_poster || _vm.item.use_movie_poster == '0') && _vm.item.images && _vm.item.images.poster && _vm.item.images.poster.url) ? _c('div', {
    staticClass: "movie-detail__poster movie-detail__poster-img--no-trailer"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.item.images.poster.url,
      "alt": ""
    }
  })])]) : _vm._e()]], 2), _vm._v(" "), (_vm.$breakpoints.smDown) ? _c('div', {
    staticClass: "exclusive__content"
  }, [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [(_vm.item.big_title) ? _c('h2', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.item.big_title))]) : _vm._e(), _vm._v(" "), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.strapline)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "exclusive__content-btns"
  }, [(_vm.item.vista_movie_id && !_vm.item.button_link && !_vm.item.button_text) ? _c('sk-button', {
    attrs: {
      "primary": _vm.item.vista_movie_id ? true : false,
      "tag": "a",
      "href": ("/details/" + (_vm.item.vista_movie_id))
    }
  }, [_vm._v("Book to Win\n                        ")]) : (!_vm.item.vista_movie_id && _vm.item.button_link && _vm.item.button_text) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.item.button_link
    }
  }, [_vm._v(_vm._s(_vm.item.button_text) + "\n                        ")]) : _c('div', {
    staticClass: "promo__content-btns"
  }, [(_vm.movie) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.comp.button_link
    }
  }, [_vm._v(_vm._s(_vm.comp.button_text) + "\n                            ")]) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v(" ")]), _vm._v(" "), [((_vm.item.button_2_link || _vm.item.button_2_text)) ? _c('sk-button', {
    attrs: {
      "tertiary": "",
      "tag": "a",
      "href": _vm.item.button_2_link
    }
  }, [_vm._v(_vm._s(_vm.item.button_2_text) + "\n                            ")]) : _c('sk-button', {
    attrs: {
      "tertiary": "",
      "tag": "a",
      "href": ("/competition/" + (_vm.item.nid))
    }
  }, [_vm._v("View Competition\n                                Details\n                            ")])]], 2)])], 1)], 1) : _vm._e()] : [_c('div', {
    staticClass: "exclusive__img",
    style: (_vm.imgSrc)
  }, [(!_vm.$breakpoints.smDown) ? [_c('div', {
    staticClass: "exclusive__content"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.item.movie && _vm.item.use_movie_poster == '1') ? _c('sk-flex', {
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.item.movie.poster,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-icon', {
    staticClass: "movie-detail__poster-play",
    attrs: {
      "play": ""
    }
  }) : _vm._e()], 1)]) : ((!_vm.item.use_movie_poster || _vm.item.use_movie_poster == '0') && _vm.item.images && _vm.item.images.poster && _vm.item.images.poster.url) ? _c('sk-flex', {
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster movie-detail__poster-img--no-trailer"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.item.images.poster.url,
      "alt": ""
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs8": "",
      "sm8": "",
      "md6": "",
      "lg6": ""
    }
  }, [(_vm.item.big_title) ? _c('h2', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.item.big_title))]) : _vm._e(), _vm._v(" "), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.strapline)
    }
  }), _vm._v(" "), (!_vm.festival) ? _c('div', {
    staticClass: "exclusive__content-btns"
  }, [(!_vm.item.vista_movie_id && (_vm.item.button_link || _vm.item.button_text)) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.item.button_link,
      "block": ""
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.item.button_text) + "\n                                ")]) : ((_vm.item.vista_movie_id && (!_vm.item.button_link || !_vm.item.button_text)) || _vm.item.vista_movie_id && (_vm.item.button_link || _vm.item.button_text)) ? _c('sk-button', {
    attrs: {
      "block": _vm.$breakpoints.xs,
      "primary": _vm.item.vista_movie_id ? true : false,
      "tag": "a",
      "href": ("/details/" + (_vm.item.vista_movie_id))
    }
  }, [_vm._v(_vm._s(_vm.item.button_text || 'Book to Win') + "\n                                ")]) : _vm._e(), _vm._v(" "), ((_vm.item.button_2_link || _vm.item.button_2_text)) ? _c('sk-button', {
    attrs: {
      "tertiary": _vm.item.vista_movie_id != '',
      "primary": _vm.item.vista_movie_id == '',
      "tag": "a",
      "href": _vm.item.button_2_link
    }
  }, [_vm._v(_vm._s(_vm.item.button_2_text) + "\n                                ")]) : (_vm.promo) ? _c('sk-button', {
    attrs: {
      "tertiary": _vm.item.vista_movie_id != '',
      "primary": _vm.item.vista_movie_id == '',
      "tag": "a",
      "href": ("/promotion/" + (_vm.item.nid))
    }
  }, [_vm._v("View Promotion Details\n                                ")]) : (_vm.event) ? _c('sk-button', {
    attrs: {
      "tertiary": _vm.item.vista_movie_id != '',
      "primary": _vm.item.vista_movie_id == '',
      "tag": "a",
      "href": ("/event/" + (_vm.item.nid))
    }
  }, [_vm._v("View Event Details\n                                ")]) : _vm._e()], 1) : _c('div', {
    staticClass: "exclusive__content-btns"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": ("/film-festival-details/" + (_vm.item.nid))
    }
  }, [_vm._v("See Features\n                                ")])], 1)])], 1)], 1)] : [(_vm.item.movie && _vm.item.use_movie_poster == '1') ? _c('div', {
    staticClass: "movie-detail__poster"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.item.movie.poster,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-icon', {
    staticClass: "movie-detail__poster-play",
    attrs: {
      "play": ""
    }
  }) : _vm._e()], 1) : ((!_vm.item.use_movie_poster || _vm.item.use_movie_poster == '0') && _vm.item.images && _vm.item.images.poster && _vm.item.images.poster.url) ? _c('div', {
    staticClass: "movie-detail__poster movie-detail__poster-img--no-trailer"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.item.images.poster.url,
      "alt": ""
    }
  })])]) : _vm._e()]], 2), _vm._v(" "), (_vm.$breakpoints.smDown) ? _c('div', {
    staticClass: "exclusive__content"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": "",
      "lg6": ""
    }
  }, [(_vm.item.big_title) ? _c('h2', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.item.big_title))]) : _vm._e(), _vm._v(" "), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.strapline)
    }
  }), _vm._v(" "), (!_vm.festival) ? _c('div', {
    staticClass: "exclusive__content-btns"
  }, [(!_vm.item.vista_movie_id && (_vm.item.button_link || _vm.item.button_text)) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.item.button_link,
      "block": ""
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.item.button_text) + "\n                        ")]) : ((_vm.item.vista_movie_id && (!_vm.item.button_link || !_vm.item.button_text)) || _vm.item.vista_movie_id && (_vm.item.button_link || _vm.item.button_text)) ? _c('sk-button', {
    attrs: {
      "block": _vm.$breakpoints.xs,
      "primary": _vm.item.vista_movie_id ? true : false,
      "tag": "a",
      "href": ("/details/" + (_vm.item.vista_movie_id))
    }
  }, [_vm._v(_vm._s(_vm.item.button_text || 'Book to Win') + "\n                        ")]) : _vm._e(), _vm._v(" "), ((_vm.item.button_2_link || _vm.item.button_2_text)) ? _c('sk-button', {
    attrs: {
      "block": _vm.$breakpoints.xs,
      "tertiary": _vm.item.vista_movie_id != '',
      "primary": _vm.item.vista_movie_id == '',
      "tag": "a",
      "href": _vm.item.button_2_link
    }
  }, [_vm._v(_vm._s(_vm.item.button_2_text) + "\n                        ")]) : (_vm.promo) ? _c('sk-button', {
    attrs: {
      "tertiary": _vm.item.vista_movie_id != '',
      "block": _vm.$breakpoints.xs,
      "primary": _vm.item.vista_movie_id == '',
      "tag": "a",
      "href": ("/promotion/" + (_vm.item.nid))
    }
  }, [_vm._v("View Promotion Details\n                        ")]) : (_vm.event) ? _c('sk-button', {
    attrs: {
      "tertiary": _vm.item.vista_movie_id != '',
      "block": _vm.$breakpoints.xs,
      "primary": _vm.item.vista_movie_id == '',
      "tag": "a",
      "href": ("/event/" + (_vm.item.nid))
    }
  }, [_vm._v("View Event Details\n                        ")]) : _vm._e()], 1) : _c('div', {
    staticClass: "exclusive__content-btns"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "block": _vm.$breakpoints.xs,
      "href": ("/film-festival-details/" + (_vm.item.nid))
    }
  }, [_vm._v("See Features\n                        ")])], 1)])], 1)], 1) : _vm._e()]], 2)
},staticRenderFns: []}

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(762),
  /* template */
  __webpack_require__(763),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Promotions',

    data: function data() {
        return {
            loading: true,
            promos: []
        };
    },


    methods: {
        getContent: function getContent() {
            var _this = this;

            this.loading = true;
            if (this.$breakpoints.xs || this.$breakpoints.sm) {
                __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].nextTick(function () {
                    if (_this.$parent.$el != undefined) window.scroll({
                        top: _this.$parent.$el.offsetTop - 100,
                        left: 0,
                        behavior: 'smooth'
                    });
                });
            }

            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["l" /* PageService */].getPromo(), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovies()]).then(function (_ref) {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                    promo = _ref2[0],
                    movies = _ref2[1];

                _this.promos = __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].addPreviewToContentArrayIfAvailable('promotion', promo.data);
                _this.promos.forEach(function (el) {
                    if (el.related_movie) {
                        el.movie = movies.findById(el.related_movie);
                    }

                    if (el.mobile_image_listing) {
                        el.srcsets = el.mobile_image_listing + ' 700w, ' + el.image_listing + ' 2000w';
                    } else {
                        el.srcsets = el.image_listing + ' 2000w';
                    }
                });
                _this.loading = false;
            });
        }
    },

    created: function created() {
        this.getContent();
    },
    mounted: function mounted() {
        if (window.__PRERENDER_INJECTED) {
            this.loading = false;
            this.prerender = true;

            if (window.__PRERENDER_INJECTED.promos) {

                this.promos = __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].addPreviewToContentArrayIfAvailable('promotion', window.__PRERENDER_INJECTED.promos);
                this.getAsyncData();
            }
        }
    }
});

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "promotions promotions-seo"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.promos.length > 0),
      expression: "promos.length > 0"
    }]
  }, _vm._l((_vm.promos), function(promo, index) {
    return _c('div', [_c('sk-exclusive-list', {
      attrs: {
        "promo": "",
        "item": promo
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.promos.length == 0),
      expression: "promos.length == 0"
    }]
  }, [_c('p', [_vm._v("There are no promotions at Ster-Kinekor at the moment.")]), _vm._v(" "), _c('p', [_vm._v("Please check back again soon or sign up our newsletter to keep up to date on what's on!")])])])])
},staticRenderFns: []}

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(765),
  /* template */
  __webpack_require__(766),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'events',
    data: function data() {
        return {
            events: [],
            movieId: '',
            loading: true
        };
    },


    methods: {
        getContent: function getContent() {
            var _this = this;

            this.loading = true;

            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["l" /* PageService */].getEvent(), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovies()]).then(function (_ref) {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                    event = _ref2[0],
                    movie = _ref2[1];

                var events = [];
                event.forEach(function (e) {
                    movie.data.forEach(function (m) {
                        if (m.id == e.related_movie) {
                            e.movie = m;
                        }
                    });
                    events.push(e);
                });
                _this.events = __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].addPreviewToContentArrayIfAvailable('event', events);
                _this.loading = false;

                __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].nextTick(function () {
                    if (_this.$breakpoints.xs || _this.$breakpoints.sm) {
                        window.scroll({ top: 0, left: 0 });
                        if (_this.$parent.$el.offsetTop != undefined) {
                            window.scroll({
                                top: _this.$parent.$el.offsetTop - _this.$parent.$el.previousSibling.offsetHeight,
                                left: 0,
                                behavior: 'smooth'
                            });
                        }
                    }
                });
            });
        }
    },

    mounted: function mounted() {
        this.getContent();

        if (window.__PRERENDER_INJECTED) {
            this.loading = false;
            this.prerender = true;

            if (window.__PRERENDER_INJECTED.events) {

                this.events = __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].addPreviewToContentArrayIfAvailable('event', window.__PRERENDER_INJECTED.events);
                this.getAsyncData();
            }
        }
    }
});

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.events.length > 0),
      expression: "events.length > 0"
    }]
  }, _vm._l((_vm.events), function(event, index) {
    return _c('div', [_c('sk-exclusive-list', {
      attrs: {
        "event": "",
        "item": event,
        "movie": event.movie
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.events.length == 0),
      expression: "events.length == 0"
    }]
  }, [_c('p', [_vm._v("There are no events at Ster-Kinekor at the moment.")]), _vm._v(" "), _c('p', [_vm._v("Please check again later or subscribe to our newsletter to keep up to date with what's on!")])])])])
},staticRenderFns: []}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(768),
  /* template */
  __webpack_require__(769),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'film-festivals',
    data: function data() {
        return {
            filmFestivals: [],
            loading: true
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["l" /* PageService */].getFilmFestivals()).then(function (result) {
            _this.filmFestivals = result;
            _this.loading = false;
            if (_this.$breakpoints.xs || _this.$breakpoints.sm) {
                __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick(function () {
                    if (_this.$parent.$el != undefined) window.scroll({
                        top: _this.$parent.$el.offsetTop - 100,
                        left: 0,
                        behavior: 'smooth'
                    });
                });
            }
        }, function (error) {
            console.log(error);
        });
    }
});

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [(_vm.filmFestivals.length > 0) ? _vm._l((_vm.filmFestivals), function(filmFestival, index) {
    return _c('sk-exclusive-list', {
      key: index,
      attrs: {
        "festival": "",
        "item": filmFestival
      }
    })
  }) : [_c('p', [_vm._v("There are no film festivals at Ster-Kinekor at the moment.")]), _vm._v(" "), _c('p', [_vm._v("Please check back again soon or sign up our newsletter to keep up to date on what's on!")])]], 2)])
},staticRenderFns: []}

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(771),
  /* template */
  __webpack_require__(772),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        filmFestival: Object
    },

    data: function data() {
        return {
            loading: true
        };
    },


    name: 'film-festival-list-item',
    methods: {
        continueToDetails: function continueToDetails(id) {
            this.$router.push('/film-festival-details/' + id);
        }
    },
    created: function created() {}
});

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "film-festival__item"
  })
},staticRenderFns: []}

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(774),
  /* template */
  __webpack_require__(775),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_meta_data_js__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_meta_data_js__["a" /* default */]],

    data: function data() {
        return {
            article: {},
            loading: true
        };
    },


    methods: {
        getAsyncData: function getAsyncData() {
            this.metaTitle = this.article.meta_title || '';
            this.metaDescription = this.article.meta_description || '';
            this.$emit('updateHead');
        }
    },
    created: function created() {
        var _this = this;

        if (!this.$route.params || !this.$route.params.nid) {
            window.location.href = '/news';
        }
        this.loading = true;

        if (__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].hasPreviewContent('news') && __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent().nid == this.$route.params.nid) {
            this.article = __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["m" /* PreviewService */].getPreviewContent();
            this.loading = false;
            return;
        }

        __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getNewsArticle(this.$route.params.nid).then(function (article) {
            _this.article = article;
            _this.getAsyncData();
            _this.loading = false;
        });
    },
    mounted: function mounted() {
        var _this2 = this;

        window.scroll({ top: 0, left: 0 });
        if (window.__PRERENDER_INJECTED) {
            if (window.__PRERENDER_INJECTED.news) {
                var news = window.__PRERENDER_INJECTED.news;

                var article = news.find(function (newsItem) {
                    return newsItem.general.id == _this2.$route.params.nid;
                });
                if (article.related_movie) {
                    article.movie = {};
                    __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovieDetail(article.related_movie).then(function (movie) {
                        return article.movie = movie;
                    });
                }
                this.article = article;

                this.metaTitle = this.article.meta_title || '';
                this.metaDescription = this.article.meta_description || '';
                this.$emit('updateHead');
            }
        }
    }
});

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info news--detail"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), _c('sk-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('sk-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.article),
      expression: "article"
    }]
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-panel', {
    staticClass: "article article--detailed"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs10": "",
      "md6": ""
    }
  }, [(_vm.article.general != undefined) ? _c('h4', [_vm._v(_vm._s(_vm.article.general.title))]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs2": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__buttons"
  }, [(_vm.article.general != undefined) ? _c('sk-social-share', {
    staticClass: "article__buttons--share",
    attrs: {
      "id": _vm.article.general.id,
      "movie-title": _vm.article.general.title,
      "twitter-text": "What's new at Ster-Kinekor?"
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(_vm.article.general != undefined) ? [_c('p', {
    staticClass: "article__type",
    domProps: {
      "innerHTML": _vm._s(_vm.article.general.type)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "article__date"
  }, [_vm._v(_vm._s(_vm.article.general.date))]), _vm._v(" "), (_vm.article.top_section != undefined) ? [_c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.article.top_section.copy || _vm.article.top_section.copy)
    }
  })] : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.article.top_section != undefined) ? [(_vm.article.top_section.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": _vm.article.top_section.image.alt ? _vm.article.top_section.image.alt : '',
      "src": _vm.article.top_section.image.url
    }
  })]) : _vm._e()] : _vm._e()], 2)])], 1), _vm._v(" "), (_vm.article.top_section != undefined) ? [(_vm.article.top_section.pdf_file.length > 0) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "small": "",
      "primary": "",
      "tag": "a",
      "href": ("" + (_vm.article.top_section.pdf_file)),
      "target": "_blank"
    }
  }, [_vm._v("More Information")])], 1)], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.article.feature_section != undefined) ? [(_vm.article.feature_section.link) ? _c('div', {
    staticClass: "article__feature embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    attrs: {
      "src": ("" + (_vm.article.feature_section.link)),
      "frameborder": "0",
      "gesture": "media",
      "allow": "encrypted-media",
      "allowfullscreen": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.article.feature_section.image) ? _c('div', {
    staticClass: "article__feature"
  }, [_c('img', {
    attrs: {
      "alt": _vm.article.feature_section.image.alt ? _vm.article.feature_section.image.alt : '',
      "src": _vm.article.feature_section.image.url,
      "alt": ""
    }
  })]) : _vm._e()] : _vm._e()], 2)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(_vm.article.bottom_section != undefined) ? [_c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.article.bottom_section.copy)
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.article.bottom_section != undefined) ? [(_vm.article.bottom_section.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": _vm.article.bottom_section.image.alt ? _vm.article.bottom_section.image.alt : '',
      "src": _vm.article.bottom_section.image.url
    }
  })]) : _vm._e()] : _vm._e()], 2)])], 1), _vm._v(" "), (_vm.article.general != undefined) ? [(_vm.article.general.related_movie) ? _c('sk-button', {
    attrs: {
      "tertiary": "",
      "router": "",
      "to": {
        name: 'Movie Details',
        params: {
          id: _vm.article.general.related_movie
        }
      }
    }
  }, [_vm._v("More info")]) : _vm._e()] : _vm._e()], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_steps_progress_steps_vue__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_steps_progress_steps_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__progress_steps_progress_steps_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__choose_amount_choose_amount_vue__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__choose_amount_choose_amount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__choose_amount_choose_amount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__confirm_details_confirm_details_vue__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__confirm_details_confirm_details_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__confirm_details_confirm_details_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__donate_donate_vue__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__donate_donate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__donate_donate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__summary_summary_vue__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__summary_summary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__summary_summary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__donation_successful_donation_successful_vue__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__donation_successful_donation_successful_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__donation_successful_donation_successful_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__donation_unsuccessful_donation_unsuccessful_vue__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__donation_unsuccessful_donation_unsuccessful_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__donation_unsuccessful_donation_unsuccessful_vue__);
/* unused harmony reexport ProgressSteps */
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__choose_amount_choose_amount_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__confirm_details_confirm_details_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__donate_donate_vue___default.a; });
/* unused harmony reexport Summary */
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__donation_successful_donation_successful_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__donation_unsuccessful_donation_unsuccessful_vue___default.a; });










/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(778),
  /* template */
  __webpack_require__(779),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		numSteps: Number,
		currentStep: Number,
		stepNames: Array
	},

	computed: {
		progress: function progress() {
			return this.currentStep / this.numSteps * 100;
		}
	},

	methods: {
		back: function back(step) {
			if (step < this.currentStep) {
				this.$router.push('/booking/' + step);
			}
		}
	}

});

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-steps"
  }, [_c('sk-progress-linear', {
    staticClass: "progress-steps__bar",
    attrs: {
      "height": (_vm.$breakpoints.xs ? 6 : 10),
      "value": _vm.progress
    }
  }), _vm._v(" "), _vm._l((_vm.numSteps), function(step) {
    return [_c('div', {
      staticClass: "progress-steps__wrapper",
      class: {
        'progress-steps__step--active': step <= _vm.currentStep, 'progress-steps__step--current': step == _vm.currentStep
      }
    }, [_c('div', {
      staticClass: "progress-steps__step",
      on: {
        "click": function($event) {
          _vm.back(step)
        }
      }
    }, [(step < _vm.currentStep) ? _c('sk-icon', {
      attrs: {
        "tick-check": ""
      }
    }) : _c('h4', {
      staticClass: "progress-steps__step-number"
    }, [_vm._v(_vm._s(step))])], 1), _vm._v(" "), (_vm.stepNames) ? _c('div', _vm._l((_vm.stepNames), function(name) {
      return (step == name.step) ? _c('span', {
        staticClass: "progress-steps__title"
      }, [_vm._v(_vm._s(name.text))]) : _vm._e()
    })) : _vm._e()])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(781),
  /* template */
  __webpack_require__(782),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            selected_concession: null,
            cinema_type: "standalone",
            cinema_id: "",
            donation_name: "Donations",
            cancelAlert: false,
            items: [],
            order: null
        };
    },


    methods: {
        confirmAmount: function confirmAmount() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["k" /* OrderService */].newConcessionOrder(this.selected_concession, this.cinema_id)).then(function (order) {
                if (order) {
                    _this.order = order;
                    _this.$router.push('/donate/2');
                } else {}
            }, function (error) {
                _this.loading = false;
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
            });
        },
        getConcessionItems: function getConcessionItems(concessionItems) {
            var items = [];
            for (var k = 0; k < concessionItems.length; k++) {
                if (concessionItems[k].Description != "DONATION R2.50") {
                    var item = concessionItems[k];
                    item.Price = "R " + concessionItems[k].PriceInCents / 100;
                    item.Quantity = 1;
                    items[k] = item;
                }
            }

            return items;
        }
    },

    created: function created() {
        var _this2 = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getConsessionsByCinemaId(this.cinema_type), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["k" /* OrderService */].cancelConcessionOrder(this.cinema_id), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getStandAloneCinemaId(this.cinema_type)]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
                concessions = _ref2[0],
                cancel_order = _ref2[1],
                cinema_id = _ref2[2];

            _this2.cinema_id = cinema_id;

            for (var i = 0; i < concessions.length; i++) {
                if (concessions[i].Name == _this2.donation_name) {
                    _this2.items = _this2.getConcessionItems(concessions[i].ConcessionItems);
                }
            }
            _this2.loading = false;
        }, function (error) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
        });
    }
});

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sk-panel', [_c('h2', [_vm._v("Vision mission donation")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "checkout-form"
    },
    on: {
      "submit": function($event) {
        _vm.confirmAmount()
      }
    }
  }, [_c('p', [_vm._v("\n                    Thank you for deciding to donate to Vision Mission. "), _c('br'), _vm._v(" \n                    By donating you help others enjoy a great movie experience.\n                ")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Amount")]), _vm._v(" "), _c('sk-combo-select', {
    staticClass: "form-group",
    attrs: {
      "options": _vm.items,
      "label": "Price",
      "searchable": false,
      "placeholder": "Choose an amount",
      "multiple": false,
      "track-by": "Price",
      "validationValue": _vm.selected_concession ? _vm.selected_concession.Price : '',
      "error-message": "Please choose a month",
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [
          [_c('span', {
            staticClass: "option__title"
          }, [_vm._v(_vm._s(props.option.Price))])]
        ]
      }
    }]),
    model: {
      value: (_vm.selected_concession),
      callback: function($$v) {
        _vm.selected_concession = $$v
      },
      expression: "selected_concession"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Minimum donation amount R 100")])], 1)], 1), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit"
    }
  }, [_vm._v("Confirm Amount")]), _vm._v("\n                     \n                    "), _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelAlert = true
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.cancelAlert),
      callback: function($$v) {
        _vm.cancelAlert = $$v
      },
      expression: "cancelAlert"
    }
  }, [_c('p', [_vm._v("Are you sure you want to cancel your donation?")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelAlert = false
      }
    }
  }, [_vm._v("Wait, take me back")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "router": "",
      "to": "/"
    }
  }, [_vm._v("I'm sure")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(784),
  /* template */
  __webpack_require__(785),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            user: { FullName: null, Email: null, MobilePhone: null },
            order: {},
            saveUserData: false,
            saveNewsLetter: false,
            eft: false,
            leaveSite: false,
            isGuest: true
        };
    },


    methods: {
        checkPayment: function checkPayment() {
            if (this.order.totalInCents == 0) {
                this.makePayment();
            } else {
                this.leaveSite = true;
            }
        },
        makePayment: function makePayment() {
            var EFT = this.eft;
            this.leaveSite = false;
            this.loading = true;
            if (this.saveUserData) {
                __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].storeLocalUserOrderInfo(this.user);
            } else if (this.user.isTemp) {
                __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].storeLocalUserOrderInfo(this.user, true);
            } else {
                console.log("not saving User Data", this.user);
            }
            __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["k" /* OrderService */].makePayment(EFT, this.user);
        }
    },

    created: function created() {
        var _this = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].getUserOrderInfo(), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getOrder(), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].isGuestUser()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
                userData = _ref2[0],
                order = _ref2[1],
                guest = _ref2[2];

            if (userData) _this.user = userData;
            _this.isGuest = guest;
            _this.order = order;

            _this.loading = false;
        });
    },
    mounted: function mounted() {
        window.scroll({ top: 0, left: 0 });
    }
});

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), (!_vm.loading) ? _c('sk-panel', [_c('h3', [_vm._v("Confirm Your Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "checkout",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "checkout-form"
    },
    on: {
      "submit": function($event) {
        _vm.checkPayment()
      }
    }
  }, [_c('p', {
    staticClass: "form-alert"
  }, [_vm._v("All fields are mandatory")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "name",
      "autocomplete": "name",
      "label": "Your name",
      "required": "",
      "error-message": {
        valueMissing: 'Please tell us your name.'
      }
    },
    on: {
      "input": function($event) {
        _vm.user.isTemp = true
      }
    },
    model: {
      value: (_vm.user.FullName),
      callback: function($$v) {
        _vm.$set(_vm.user, "FullName", $$v)
      },
      expression: "user.FullName"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "email",
      "type": "email",
      "autocomplete": "email",
      "label": "Your email",
      "required": "",
      "error-message": {
        valueMissing: 'Please make sure your email address follows this format: example@email.com'
      }
    },
    on: {
      "input": function($event) {
        _vm.user.isTemp = true
      }
    },
    model: {
      value: (_vm.user.Email),
      callback: function($$v) {
        _vm.$set(_vm.user, "Email", $$v)
      },
      expression: "user.Email"
    }
  }, [_c('template', {
    slot: "help"
  }, [_c('sk-tooltip', {
    attrs: {
      "content": _vm.isGuest ? 'We\'ll email your booking confirmation to you.' : 'We\'ll email your booking confirmation to you. Changing your email address here will not affect your profile.',
      "action-text": "Why do I need to provide my email address?"
    }
  })], 1)], 2), _vm._v(" "), _c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "type": "tel",
      "name": "mobile",
      "autocomplete": "tel",
      "label": "Your mobile number",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter your mobile number',
        patternMismatch: 'Please double check you\'ve entered 9 digits excluding your country code.'
      },
      "pattern": "^\\+?\\d{11,11}|\\d{10,10}$"
    },
    on: {
      "input": function($event) {
        _vm.user.isTemp = true
      }
    },
    model: {
      value: (_vm.user.MobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.user, "MobilePhone", $$v)
      },
      expression: "user.MobilePhone"
    }
  }, [_c('template', {
    slot: "help"
  }, [_c('sk-tooltip', {
    attrs: {
      "content": _vm.isGuest ? 'We might need to reach you should there be changes that impact your booking.' : 'We might need to reach you should there be changes that impact your booking. Changing your number here will not affect your profile.',
      "action-text": "Why do I need to provide my mobile number?"
    }
  })], 1)], 2), _vm._v(" "), (_vm.isGuest && _vm.user.isTemp) ? _c('sk-checkbox', {
    attrs: {
      "id": "userLinkCards",
      "label": "Save this information for next time"
    },
    model: {
      value: (_vm.saveUserData),
      callback: function($$v) {
        _vm.saveUserData = $$v
      },
      expression: "saveUserData"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('sk-tooltip', {
    attrs: {
      "content": "We use cookies to store your details and speed up your booking the next time you visit."
    }
  })], 1)], 2) : _vm._e(), _vm._v(" "), _c('sk-checkbox', {
    staticClass: "newsletter__subscribe",
    attrs: {
      "id": "userLinkCards",
      "label": "Use my email to subscribe me to the SK newsletter"
    },
    model: {
      value: (_vm.saveNewsLetter),
      callback: function($$v) {
        _vm.saveNewsLetter = $$v
      },
      expression: "saveNewsLetter"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("Be the first to enter our competitions and receive invitations to exclusive events.")])], 2), _vm._v(" "), _c('p', [_vm._v("By clicking pay, you agree to our "), _c('a', {
    attrs: {
      "href": "/content/legal/online-booking-terms-and-conditions",
      "target": "_blank"
    }
  }, [_vm._v("Terms & Conditions")])]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "payment-info": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "text-right": ""
    }
  }, [_c('p', {
    staticClass: "text--small"
  }, [_vm._v("Ster-Kinekor is secure. For credit card payments we accept")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm6": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/visa.png",
      "alt": "Visa"
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm6": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/master-card.png",
      "alt": "Master Card"
    }
  })])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    class: _vm.$breakpoints.smDown ? 'text-right' : '',
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "payment-footer": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [(!_vm.$breakpoints.smDown) ? _c('sk-button', {
    attrs: {
      "link": "",
      "router": "",
      "to": "/booking/3"
    }
  }, [_vm._v("Back")]) : _vm._e()], 1), _vm._v(" "), _c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "grow": "",
      "text-right": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "payment-footer-btns": ""
    }
  }, [(_vm.order.totalInCents !== 0) ? [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.eft = false
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "lock": ""
    }
  }), _vm._v(" Pay With Credit Card\n                                        ")], 1)], 1)] : [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.eft = false;
      }
    }
  }, [_vm._v("Complete Order")])], 1)]], 2)], 1), _vm._v(" "), (_vm.$breakpoints.smDown) ? _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "link": "",
      "router": "",
      "to": "/booking/3"
    }
  }, [_vm._v("Back")])], 1) : _vm._e()], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.leaveSite),
      callback: function($$v) {
        _vm.leaveSite = $$v
      },
      expression: "leaveSite"
    }
  }, [_c('h3', [_vm._v("Payment notice")]), _vm._v(" "), _c('p', [_vm._v("By clicking PAY, you'll be redirected to our payment page. Please don’t close your browser until you’ve received your booking reference.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.makePayment()
      }
    }
  }, [_vm._v("Got it!")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.leaveSite = false
      }
    }
  }, [_vm._v("Wait! Take me back")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(787),
  /* template */
  __webpack_require__(788),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            user: {},
            order: {}
        };
    },
    created: function created() {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].getUserOrderInfo(), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getConcessionOrder()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                user = _ref2[0],
                order = _ref2[1];

            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["k" /* OrderService */].makePaymentConcessions(user)).then(function (order) {
                console.log(order);
            });
        });
    }
});

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(790),
  /* template */
  __webpack_require__(791),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "summary",

    data: function data() {
        return {
            loading: true,
            movie: {},
            cinema: {},
            order: {}
        };
    },


    computed: {},

    created: function created() {
        this.loading = false;
    },
    mounted: function mounted() {
        window.scroll({ top: 0, left: 0 });
    }
});

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-panel', [_c('h2', [_vm._v("Donation Summary")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "check-ticket"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "check-ticket"
  }, [_c('sk-layout', [_vm._v("\n                test\n            ")])], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(793),
  /* template */
  __webpack_require__(794),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            booking: [],
            related_movies: [],
            movie: {},
            cinema: {},
            donationAmount: ''
        };
    },


    computed: {
        seatsString: function seatsString() {
            return this.booking.Tickets.map(function (t) {
                return t.SeatData;
            }).join(',');
        },
        bookingDate: function bookingDate() {
            return '' + this.booking.opening_date;
        },
        movieStartTime: function movieStartTime() {
            return '' + this.booking.opening_date;
        },
        movieEndTime: function movieEndTime() {
            return 'TODO';
        }
    },
    methods: {
        getRelatedMovies: function getRelatedMovies(movies, user) {
            if (!user || user.isGuest() || user.PreferredGenres.length == 0) {
                var m = movies.data;
                return m;
            };

            var filteredMovies = [];
            movies.data.reduce(function (c, movie) {
                movie.genres.forEach(function (genre) {
                    user.PreferredGenres.forEach(function (prefGen) {
                        if (genre.id == prefGen) {
                            filteredMovies.push(movie);
                        }
                    });
                });
            });
            return filteredMovies;
        },
        downloadPDF: function downloadPDF() {
            this.generateLoader = true;
            window.open(__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["k" /* OrderService */].generateConfirmationPDF(this.$route.params.booking_number, this.$route.params.booking_id));
            this.generateLoader = false;
        }
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getBooking(this.$route.params.booking_number, this.$route.params.booking_id), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovies(), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
                booking = _ref2[0],
                movies = _ref2[1],
                user = _ref2[2];

            _this.booking = booking[0];
            _this.donationAmount = _this.booking.Concessions[0].PriceInCents / 100;
            _this.related_movies = _this.getRelatedMovies(movies, user);

            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getCinema(_this.booking.CinemaId)]).then(function (_ref3) {
                var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 1),
                    cinema = _ref4[0];

                _this.cinema = cinema;
                _this.loading = false;
            });
        }, function (error) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
        });
    }
});

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Donation Successful")]), _vm._v(" "), _c('sk-panel', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', {
    staticClass: "booking-successful"
  }, [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "check-ticket"
  }, [_c('h3', [_vm._v("Thank you! your donation is greatly appreciated!")]), _vm._v(" "), _vm._l((_vm.booking.Concessions), function(concession) {
    return _c('div', [_c('p', [_vm._v("Your contribution of "), _c('strong', {
      staticClass: "secondary--text"
    }, [_vm._v("R" + _vm._s(_vm.donationAmount))]), _vm._v("\n                                        has successfully gone through. Check your inbox for the receipt of payment.\n                                    ")])])
  })], 2)])], 1)], 1), _vm._v(" "), _c('sk-signin', {
    staticClass: "no-print"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.related_movies.length > 0) ? _c('sk-related-movies', {
    attrs: {
      "limit": "6",
      "movies": _vm.related_movies,
      "label": "Recommended Movies"
    }
  }) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "router": "",
      "to": "/"
    }
  }, [_vm._v("\n                        Take me home\n                    ")])]], 2)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(796),
  /* template */
  __webpack_require__(797),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'DonationUnsuccessful',

    data: function data() {
        return {
            loading: true,
            booking: __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getBookings(),
            error: undefined,
            order: undefined,
            related_movies: []
        };
    },


    methods: {
        returnToBookingFlow: function returnToBookingFlow() {
            this.$router.push('/donate');
        }
    },
    created: function created() {
        var _this = this;

        try {
            __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getOrder().then(function (order) {
                _this.loading = false;
                _this.order = order;
            }, function (e) {
                _this.loading = false;
            });
        } catch (e) {
            this.loading = false;
        }
    }
});

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('sk-panel', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "booking-successful"
  }, [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "check-ticket"
  }, [_c('sk-title-heading', {
    attrs: {
      "h2": "",
      "label": "Payment Status"
    }
  }), _vm._v(" "), _c('p', [_vm._v("We're sorry, but this payment could not be processed. Please contact your financial institution and try again or use a different card. ")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs10": "",
      "sm10": ""
    }
  }, [_c('div', {
    staticClass: "check-ticket--right"
  }, [_c('div', {
    staticClass: "movie-details"
  }, [(_vm.error != undefined) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.errorDescription != undefined),
      expression: "error.errorDescription != undefined"
    }],
    staticClass: "confirmation-error"
  }, [_vm._v("\n                                                " + _vm._s(_vm.error.errorDescription) + "\n                                            ")])] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.order != undefined) ? [_c('sk-button', {
    attrs: {
      "tertiary": "",
      "inline-block": "",
      "router": "",
      "to": "/"
    }
  }, [_vm._v("\n                                                Cancel\n                                            ")]), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "inline-block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.returnToBookingFlow()
      }
    }
  }, [_vm._v("\n                                                Try Again\n                                            ")])] : [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "router": "",
      "to": "/"
    }
  }, [_vm._v("\n                                                Take Me Home\n                                            ")])]], 2)])])], 1)], 1)])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('sk-signin'), _vm._v(" "), _c('sk-related-movies', {
    attrs: {
      "movies": _vm.related_movies
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_steps_progress_steps_vue__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_steps_progress_steps_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__progress_steps_progress_steps_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscription_summary_subscription_summary_vue__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscription_summary_subscription_summary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__subscription_summary_subscription_summary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__confirm_details_confirm_details_vue__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__confirm_details_confirm_details_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__confirm_details_confirm_details_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__payment_payment_vue__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__payment_payment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__payment_payment_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__confirm_details_confirm_details_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__subscription_summary_subscription_summary_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__payment_payment_vue___default.a; });
/* unused harmony reexport SubsProgressSteps */







/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(800),
  /* template */
  __webpack_require__(801),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		numSteps: Number,
		currentStep: Number,
		stepNames: Array,
		stepType: String
	},

	computed: {
		progress: function progress() {
			return this.currentStep / this.numSteps * 100;
		}
	},

	methods: {
		back: function back(step) {
			if (step < this.currentStep) {}
		}
	}

});

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-steps"
  }, [_c('sk-progress-linear', {
    staticClass: "progress-steps__bar",
    attrs: {
      "height": (_vm.$breakpoints.xs ? 6 : 10),
      "value": _vm.progress
    }
  }), _vm._v(" "), _vm._l((_vm.numSteps), function(step) {
    return [_c('div', {
      staticClass: "progress-steps__wrapper",
      class: {
        'progress-steps__step--active': step <= _vm.currentStep, 'progress-steps__step--current': step == _vm.currentStep
      }
    }, [_c('div', {
      staticClass: "progress-steps__step",
      on: {
        "click": function($event) {
          _vm.back(step)
        }
      }
    }, [(step < _vm.currentStep) ? _c('sk-icon', {
      attrs: {
        "tick-check": ""
      }
    }) : _c('h4', {
      staticClass: "progress-steps__step-number"
    }, [_vm._v(_vm._s(step) + " a")])], 1), _vm._v(" "), (_vm.stepNames) ? _c('div', _vm._l((_vm.stepNames), function(name) {
      return (step == name.step) ? _c('span', {
        staticClass: "progress-steps__title"
      }, [_vm._v(_vm._s(name.text))]) : _vm._e()
    })) : _vm._e()])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(803),
  /* template */
  __webpack_require__(804),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            cancelAlert: false,
            items: [],
            order: null,
            user: null,
            guest: true,
            subsClub: undefined
        };
    },


    methods: {
        setUser: function setUser() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user().then(function (user) {
                _this.user = user;
                _this.guest = user.isGuest();
                if (_this.guest) window.location.href = '/user/login';
                if (!user.isGuest() && user.MembershipActivated === false && _this.first_time) {} else {}
            });
        },
        getSubsData: function getSubsData() {
            var subsClubRaw = window.localStorage.getItem('subsClub');

            var subsClub = null;
            if (subsClubRaw && subsClubRaw != undefined) {
                subsClub = JSON.parse(subsClubRaw);
            }

            this.subsClub = subsClub;
            return subsClub;
        },
        cancelSubscription: function cancelSubscription() {
            window.localStorage.removeItem('subsClub');
            this.$router.push('/subscription-club');
        },
        continueToNextStep: function continueToNextStep() {
            var lsItem = {
                'item': this.subsClub.item,
                'progress': { 'current-step': 1, 'current-step-name': "subscription-summary", "current-step-url": "/subscribe/1", 'next-step': 2, "next-step-name": "confirm-details", "next-step-url": "/subscribe/2" }
            };

            window.localStorage.setItem('subsClub', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(lsItem));
            this.$router.push('/subscribe/2');
        }
    },

    created: function created() {
        var _this2 = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.setUser(), this.getSubsData()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                user = _ref2[0],
                subs = _ref2[1];

            _this2.loading = false;
        }, function (error) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
        });
    },
    mounted: function mounted() {
        window.scrollTo(0, 0);
        window.scroll({ top: 0, left: 0 });
    }
});

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subscription-summary"
  }, [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('h2', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Subscription Summary")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.subsClub.item != undefined) ? [(_vm.subsClub.item.Description.includes('Unlimited')) ? [_c('h3', [_vm._v("Unlimited movie tickets per month")]), _vm._v(" "), _c('h5', [_vm._v("Watch as many 2D or 3D movies as you want all month long.")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive fan-img img-option",
    attrs: {
      "src": "/static/img/morvies_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("UNLIMITED MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                                Watch up to 5 movies a day, every day!\n                                            ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("COME AS OFTEN AS YOU CAN")]), _vm._v(" "), _c('br'), _vm._v("\n                                                1 ticket per movie per card holder\n                                            ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                                20% off a regular combo\n                                            ")])])], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")])])])], 1)], 1)], 1)], 1)], 1)] : [(_vm.subsClub.item.Description.includes('Limited')) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h3', [_vm._v("Limited movies per month")]), _vm._v(" "), _c('h5', [_vm._v("Get 4 2D or 3D movie tickets per month for you and your family.")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__join"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.subsClub.item.Price) + " "), _c('span', [_vm._v("per month")])])])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive fan-img img-option",
    attrs: {
      "src": "/static/img/fan_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("4 MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                                    You watch more for less\n                                                ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("IDEAL FOR THE FAMILY")]), _vm._v(" "), _c('br'), _vm._v("\n                                                    Use one or all four tickets at once\n                                                ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                                    20% off a regular combo\n                                                ")])])], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")])])])], 1)], 1)], 1)], 1)], 1)] : _vm._e()], _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "sx12": "",
      "md8": ""
    }
  }), _vm._v(" "), (_vm.subsClub.item.Description.includes('Unlimited')) ? [_c('sk-flex', {
    attrs: {
      "sx6": "",
      "md2": ""
    }
  }, [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "tertiary": "",
      "block": (_vm.$breakpoints.xs),
      "contextValue": "Subscription Summary",
      "dataValue": "Cancel Morvies Club"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelSubscription()
      }
    }
  }, [_vm._v("Cancel")])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": "",
      "md2": ""
    }
  }, [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "block": (_vm.$breakpoints.xs),
      "contextValue": "Subscription Summary",
      "dataValue": "Continue Morvies Club"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.continueToNextStep()
      }
    }
  }, [_vm._v("NEXT")])], 1)] : [(_vm.subsClub.item.Description.includes('Limited')) ? [_c('sk-flex', {
    attrs: {
      "sx6": "",
      "md2": ""
    }
  }, [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "tertiary": "",
      "block": (_vm.$breakpoints.xs),
      "contextValue": "Subscription Summary",
      "dataValue": "Cancel Fan Club"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelSubscription()
      }
    }
  }, [_vm._v("Cancel")])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": "",
      "md2": ""
    }
  }, [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "block": (_vm.$breakpoints.xs),
      "contextValue": "Subscription Summary",
      "dataValue": "Continue Fan Club"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.continueToNextStep()
      }
    }
  }, [_vm._v("NEXT")])], 1)] : _vm._e()]], 2)] : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(806),
  /* template */
  __webpack_require__(807),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            user: { FullName: null, Email: null, MobilePhone: null },
            userObj: null,
            isGuest: true,
            saveUserData: false,
            saveNewsLetter: false,
            showFacebookPixel: false,
            paymentDetails: null,
            debitDays: [{ day: 15, name: "15th" }, { day: 25, name: "25th" }, { day: 30, name: "30th" }],
            debitOrderDay: null
        };
    },


    computed: {
        adumoAPI: function adumoAPI() {
            return "https://apiv2.adumoonline.com/product/payment/v1/initialisevirtual";
        }
    },

    methods: {
        setUser: function setUser() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user().then(function (user) {
                _this.userObj = user;
                _this.isGuest = user.isGuest();
                if (_this.isGuest) window.location.href = '/user/login';
                if (!user.isGuest() && user.MembershipActivated === false && _this.first_time) {} else {}

                return _this.userObj;
            });
        },
        getSubsData: function getSubsData() {
            var subsClubRaw = window.localStorage.getItem('subsClub');

            var subsClub = null;
            if (subsClubRaw && subsClubRaw != undefined) {
                subsClub = JSON.parse(subsClubRaw);
            }

            this.subsClub = subsClub;
            return subsClub;
        },
        cancelSubscription: function cancelSubscription() {
            window.localStorage.removeItem('subsClub');
            this.$router.push('/subscription-club');
        },
        continueToNextStep: function continueToNextStep() {
            var lsItem = {
                'item': this.subsClub.item,
                'userData': this.user,
                'progress': { 'currentStep': 2, 'currentStepName': "confirm-details", "currentStepUrl": "/subscribe/2", 'nextStep': 3, "nextStepName": "payment", "nextStepUrl": "/subscribe/3" }
            };

            if (this.saveUserData) {
                __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].storeLocalUserOrderInfo(this.user);
            } else if (this.user.isTemp) {
                __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].storeLocalUserOrderInfo(this.user, true);
            } else {}
            window.localStorage.setItem('subsClub', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(lsItem));

            this.$router.push('/subscribe/3');
        },
        faceBookPixel: function faceBookPixel() {
            !function (f, b, e, v, n, t, s) {
                if (f.fbq) return;n = f.fbq = function () {
                    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;n.push = n;n.loaded = !0;n.version = '2.0';
                n.queue = [];t = b.createElement(e);t.async = !0;
                t.src = v;s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
            }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1442556416455138');
            fbq('track', 'PageView');

            this.showFacebookPixel = true;

            return this.showFacebookPixel;
        },
        prepAdumoDetails: function prepAdumoDetails() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["a" /* AdumoService */].prepareSubscription({
                memberEmail: this.user.Email,
                memberName: this.user.FullName,
                vistaMemberID: this.userObj.MemberId,
                vistaSubscriptionID: this.subsClub.item.Id,
                amount: parseFloat(this.subsClub.item.PriceInCents / 100)
            }).then(function (response) {
                var _response$data = response.data,
                    ApplicationID = _response$data.ApplicationID,
                    MerchantID = _response$data.MerchantID,
                    MerchantReference = _response$data.MerchantReference,
                    Mode = _response$data.Mode,
                    Token = _response$data.Token,
                    txtCurrencyCode = _response$data.txtCurrencyCode,
                    ShippingCountryCode = _response$data.ShippingCountryCode;


                _this2.paymentDetails = {
                    Mode: Mode,
                    MerchantID: MerchantID,
                    ApplicationID: ApplicationID,
                    MerchantReference: MerchantReference,
                    Amount: parseFloat(_this2.subsClub.item.PriceInCents / 100),
                    Token: Token,
                    txtCurrencyCode: txtCurrencyCode,
                    RedirectSuccessfulURL: "https://www.sterkinekor.com/middleware" + "/content/subscription?type=subPaymentSuccess",
                    RedirectFailedURL: "https://www.sterkinekor.com/middleware" + "/content/subscription?type=subPaymentFail",
                    ShippingCountryCode: ShippingCountryCode,
                    sessionToken: _this2.userObj.UserSessionId,
                    memberID: _this2.userObj.MemberId,
                    email: _this2.user.Email,
                    firstname: _this2.userObj.FirstName,
                    lastname: _this2.userObj.LastName,
                    subscriptionType: _this2.subsClub.item.Description,
                    subscriptionId: _this2.subsClub.item.Id
                };
            });
        }
    },

    created: function created() {
        var _this3 = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.setUser(), this.getSubsData(), this.faceBookPixel()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
                user = _ref2[0],
                subs = _ref2[1],
                pixel = _ref2[2];

            if (_this3.userObj && !_this3.userObj.isGuest()) {
                _this3.user.FullName = _this3.userObj.FirstName + " " + _this3.userObj.LastName;
                _this3.user.Email = _this3.userObj.Email;
                _this3.user.MobilePhone = _this3.userObj.MobilePhone;
                _this3.prepAdumoDetails();
            }
            _this3.debitOrderDay = _this3.$route.query.debitDay ? _this3.$route.query.debitDay : _this3.debitDays[0].day;
            _this3.loading = false;
        });
    },
    mounted: function mounted() {
        window.scrollTo(0, 0);
        window.scroll({ top: 0, left: 0 });
    },


    watch: {
        paymentDetails: function paymentDetails(val) {
            return val;
        }
    }
});

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), (!_vm.loading) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.showFacebookPixel) ? _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "src": "https://www.facebook.com/tr?id=1442556416455138&ev=PageView&noscript=1"
    }
  }) : _vm._e(), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md8": ""
    }
  }, [_c('sk-panel', [_c('h3', [_vm._v("Confirm Your Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "checkout",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('p', {
    staticClass: "form-alert"
  }, [_vm._v("All fields are mandatory")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "name",
      "autocomplete": "name",
      "label": "Your name",
      "required": "",
      "error-message": {
        valueMissing: 'Please tell us your name.'
      }
    },
    on: {
      "input": function($event) {
        _vm.user.isTemp = true
      }
    },
    model: {
      value: (_vm.user.FullName),
      callback: function($$v) {
        _vm.$set(_vm.user, "FullName", $$v)
      },
      expression: "user.FullName"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "email",
      "type": "email",
      "autocomplete": "email",
      "label": "Your email",
      "required": "",
      "error-message": {
        valueMissing: 'Please make sure your email address follows this format: example@email.com'
      }
    },
    on: {
      "input": function($event) {
        _vm.user.isTemp = true
      }
    },
    model: {
      value: (_vm.user.Email),
      callback: function($$v) {
        _vm.$set(_vm.user, "Email", $$v)
      },
      expression: "user.Email"
    }
  }, [_c('template', {
    slot: "help"
  }, [_c('sk-tooltip', {
    attrs: {
      "content": _vm.isGuest ? 'We\'ll email your booking confirmation to you.' : 'We\'ll email your booking confirmation to you. Changing your email address here will not affect your profile.',
      "action-text": "Why do I need to provide my email address?"
    }
  })], 1)], 2), _vm._v(" "), _c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "type": "tel",
      "name": "mobile",
      "autocomplete": "tel",
      "label": "Your mobile number",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter your mobile number',
        patternMismatch: 'Please double check you\'ve entered 9 digits excluding your country code.'
      },
      "pattern": "^\\+?\\d{11,11}|\\d{10,10}$"
    },
    on: {
      "input": function($event) {
        _vm.user.isTemp = true
      }
    },
    model: {
      value: (_vm.user.MobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.user, "MobilePhone", $$v)
      },
      expression: "user.MobilePhone"
    }
  }, [_c('template', {
    slot: "help"
  }, [_c('sk-tooltip', {
    attrs: {
      "content": _vm.isGuest ? 'We might need to reach you should there be changes that impact your booking.' : 'We might need to reach you should there be changes that impact your booking. Changing your number here will not affect your profile.',
      "action-text": "Why do I need to provide my mobile number?"
    }
  })], 1)], 2), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "subscribe-payment-debit-day",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "debit-order-label",
    attrs: {
      "for": "debitOrderDay"
    }
  }, [_vm._v("\n                                  Debit OrderDay "), _c('sk-tooltip', {
    key: "debit-order-tooltip",
    attrs: {
      "content": "This should probably be on payday. The subscription is for a minimum of three months and the second month will be deducted on this day.",
      "standalone": ""
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-select', {
    attrs: {
      "placeholder": "Month",
      "type": "number",
      "required": "",
      "error-message": {
        valueMissing: 'Please select a debit order day.'
      }
    },
    model: {
      value: (_vm.debitOrderDay),
      callback: function($$v) {
        _vm.debitOrderDay = $$v
      },
      expression: "debitOrderDay"
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Debit Order Day")]), _vm._v(" "), _vm._l((_vm.debitDays), function(day) {
    return (day != undefined && day != null) ? _c('option', {
      domProps: {
        "value": day.day
      }
    }, [_vm._v(_vm._s(day.name))]) : _vm._e()
  })], 2)], 1)], 1), _vm._v(" "), (_vm.isGuest && _vm.user.isTemp) ? _c('sk-checkbox', {
    attrs: {
      "id": "userLinkCards",
      "label": "Save this information for next time"
    },
    model: {
      value: (_vm.saveUserData),
      callback: function($$v) {
        _vm.saveUserData = $$v
      },
      expression: "saveUserData"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('sk-tooltip', {
    attrs: {
      "content": "We use cookies to store your details and speed up your booking the next time you visit."
    }
  })], 1)], 2) : _vm._e(), _vm._v(" "), _c('sk-checkbox', {
    staticClass: "newsletter__subscribe",
    attrs: {
      "id": "userLinkCards",
      "label": "Use my email to subscribe me to the SK newsletter"
    },
    model: {
      value: (_vm.saveNewsLetter),
      callback: function($$v) {
        _vm.saveNewsLetter = $$v
      },
      expression: "saveNewsLetter"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("Be the first to enter our competitions and receive invitations to exclusive events.")])], 2), _vm._v(" "), _c('p', [_vm._v("By clicking pay, you agree to our "), _c('a', {
    attrs: {
      "href": "/content/legal/online-booking-terms-and-conditions",
      "target": "_blank"
    }
  }, [_vm._v("Terms & Conditions")]), _vm._v(". Valid for standard 2D and 3D shows only.")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "payment-info": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "text-right": ""
    }
  }, [_c('p', {
    staticClass: "text--small"
  }, [_vm._v("Ster-Kinekor is secure. For credit card payments we accept")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm6": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/visa.png",
      "alt": "Visa"
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm6": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/master-card.png",
      "alt": "Master Card"
    }
  })])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    class: _vm.$breakpoints.smDown ? 'text-right' : '',
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "payment-footer": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm10": "",
      "grow": "",
      "text-right": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "payment-footer-btns": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "name": "Post",
      "action": _vm.adumoAPI,
      "method": "post"
    }
  }, [(_vm.paymentDetails) ? [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "Mode"
    },
    domProps: {
      "value": _vm.paymentDetails.Mode
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "MerchantID"
    },
    domProps: {
      "value": _vm.paymentDetails.MerchantID
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "ApplicationID"
    },
    domProps: {
      "value": _vm.paymentDetails.ApplicationID
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "MerchantReference"
    },
    domProps: {
      "value": _vm.paymentDetails.MerchantReference
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Amount"
    },
    domProps: {
      "value": _vm.paymentDetails.Amount
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Token"
    },
    domProps: {
      "value": _vm.paymentDetails.Token
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "txtCurrencyCode"
    },
    domProps: {
      "value": _vm.paymentDetails.txtCurrencyCode
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "RedirectSuccessfulURL"
    },
    domProps: {
      "value": _vm.paymentDetails.RedirectSuccessfulURL
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "RedirectFailedURL"
    },
    domProps: {
      "value": _vm.paymentDetails.RedirectFailedURL
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "ShippingCountryCode",
      "value": "ZA"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Variable1"
    },
    domProps: {
      "value": _vm.paymentDetails.memberID
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Variable2"
    },
    domProps: {
      "value": _vm.paymentDetails.email
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Variable3"
    },
    domProps: {
      "value": _vm.debitOrderDay
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Variable4"
    },
    domProps: {
      "value": _vm.paymentDetails.sessionToken
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Variable5"
    },
    domProps: {
      "value": _vm.paymentDetails.firstname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Variable6"
    },
    domProps: {
      "value": _vm.paymentDetails.lastname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Variable7"
    },
    domProps: {
      "value": _vm.paymentDetails.subscriptionType
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Variable8"
    },
    domProps: {
      "value": _vm.paymentDetails.subscriptionId
    }
  })] : _vm._e(), _vm._v(" "), (_vm.subsClub.item.Description == 'Limited Subs') ? [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "contextValue": "Subscription make payment",
      "dataValue": "Pay for Fan club"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.eft = false
      }
    }
  }, [_vm._v("MAKE PAYMENT")])] : _vm._e(), _vm._v(" "), (_vm.subsClub.item.Description == 'Unlimited Subs') ? [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "contextValue": "Subscription make payment",
      "dataValue": "Pay for Morvies club"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.eft = false
      }
    }
  }, [_vm._v("MAKE PAYMENT")])] : _vm._e()], 2)])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": "",
      "md2": ""
    }
  }, [(_vm.subsClub.item.Description == 'Limited Subs') ? [_c('sk-button', {
    attrs: {
      "link": "",
      "router": "",
      "to": "/subscribe/1",
      "contextValue": "Subscription Confirm Details",
      "dataValue": "Back to Fanclub subscription summary"
    }
  }, [_vm._v("Back")])] : _vm._e(), _vm._v(" "), (_vm.subsClub.item.Description == 'Unlimited Subs') ? [_c('sk-button', {
    attrs: {
      "link": "",
      "router": "",
      "to": "/subscribe/1",
      "contextValue": "Subscription Confirm Details",
      "dataValue": "Back to Morvies club subscription summary"
    }
  }, [_vm._v("Back")])] : _vm._e()], 2)], 1)], 1)])])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', [(_vm.subsClub.item.Description == 'Limited Subs') ? [_c('div', {
    staticClass: "limited-subs"
  }, [_c('h3', [_vm._v("Subscription Summary")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    staticClass: "img-responsive img-option",
    attrs: {
      "src": "/static/img/fan_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    staticClass: "subscription-summary-heading",
    attrs: {
      "xs7": ""
    }
  }, [_c('p', [_c('span', [_vm._v("LIMITED MOVIE TICKETS PER MONTH")]), _c('br'), _vm._v("\n                                    You get 4 2D or 3D movie tickets per month for you and your family.\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("4 MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                    You watch more for less\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                    20% off a regular combo\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("IDEAL FOR THE FAMILY")]), _vm._v(" "), _c('br'), _vm._v("\n                                    Use one or all four tickets at once\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ticket-component"
  }, [_c('div', {
    staticClass: "ticket-component-wrapper ticket-component-total"
  }, [_c('div', {
    staticClass: "ticket-total"
  }, [_c('div', {
    staticClass: "layout row"
  }, [_c('div', {
    staticClass: "flex xs12 sm12"
  }, [_c('p', [_vm._v("Total " + _vm._s(_vm.subsClub.item.Price) + " "), _c('span', [_vm._v("per month")])])])])])])])], 1)] : _vm._e(), _vm._v(" "), (_vm.subsClub.item.Description == 'Unlimited Subs') ? [_c('div', {
    staticClass: "unlimited-subs"
  }, [_c('h3', [_vm._v("Subscription Summary")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    staticClass: "img-responsive img-option",
    attrs: {
      "src": "/static/img/morvies_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    staticClass: "subscription-summary-heading",
    attrs: {
      "xs7": ""
    }
  }, [_c('p', [_c('span', [_vm._v("UNLIMITED MOVIES PER MONTH")]), _c('br'), _vm._v("\n                                    Watch as many 2D or 3D movies as you want all month long.\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("UNLIMITED MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                    Watch up to 5 movies a day, every day!\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                    20% off a regular combo\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("COME AS OFTEN AS YOU CAN")]), _vm._v(" "), _c('br'), _vm._v("\n                                    1 ticket per movie per card holder\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")])])])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "ticket-component-wrapper ticket-component-total"
  }, [_c('div', {
    staticClass: "ticket-total"
  }, [_c('div', {
    staticClass: "layout row"
  }, [_c('div', {
    staticClass: "flex xs12 sm12"
  }, [_c('p', [_vm._v("Total " + _vm._s(_vm.subsClub.item.Price) + " "), _c('span', [_vm._v("per month")])])])])])])])], 1)] : _vm._e()], 2)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(809),
  /* template */
  __webpack_require__(810),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            dsLookup: { action: "", TermUrl: "", PaReq: "", MD: null },
            user: { FullName: null, Email: null, MobilePhone: null },
            card: { cardHolder: null, cardNumber: null, expiryMonth: null, expiryYear: null, cvvNumber: null, debitOrderDay: null, amount: 0 },
            years: [],
            months: [{ name: "January", value: "1" }, { name: "February", value: "2" }, { name: "March", value: "3" }, { name: "April", value: "4" }, { name: "May", value: "5" }, { name: "June", value: "6" }, { name: "July", value: "7" },, { name: "August", value: "8" }, { name: "September", value: "9" }, { name: "October", value: "10" }, { name: "November", value: "11" }, { name: "December", value: "12" }],
            debitDays: [{ day: 15, name: "15th" }, { day: 25, name: "25th" }, { day: 30, name: "30th" }],
            debitOrderTooltip: "",
            userObj: null,
            isGuest: true,
            saveUserData: false,
            subsClub: null,
            saveNewsLetter: false,
            loadingPayment: false,
            showFacebookPixel: false
        };
    },


    methods: {
        setUser: function setUser() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user().then(function (user) {
                _this.userObj = user;
                _this.isGuest = user.isGuest();
                if (_this.isGuest) window.location.href = '/user/login';
                if (!user.isGuest() && user.MembershipActivated === false && _this.first_time) {} else {}

                return _this.userObj;
            });
        },
        getSubsData: function getSubsData() {
            var subsClubRaw = window.localStorage.getItem('subsClub');

            var subsClub = null;
            if (subsClubRaw && subsClubRaw != undefined) {
                subsClub = JSON.parse(subsClubRaw);
            }

            this.subsClub = subsClub;
            return subsClub;
        },
        cancelSubscription: function cancelSubscription() {
            window.localStorage.removeItem('subsClub');
            this.$router.push('/subscription-club');
        },
        continueToNextStep: function continueToNextStep() {
            var _this2 = this;

            this.loadingPayment = true;
            var lsItem = {
                'item': this.subsClub.item,
                'userData': this.user,
                'progress': { 'currentStep': 3, 'currentStepName': "payment", "currentStepUrl": "/subscribe/3", 'nextStep': 4, "nextStepName": "makePayment", "nextStepUrl": "/subscribe/3" }
            };

            if (this.saveUserData) {
                __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].storeLocalUserOrderInfo(this.user);
            } else if (this.user.isTemp) {
                __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].storeLocalUserOrderInfo(this.user, true);
            } else {}

            window.localStorage.setItem('subsClub', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(lsItem));
            var itemName = "";
            if (this.subsClub.item.Description == "Unlimited") {
                itemName = "MORvies Subscription";
            } else {
                itemName = "Fan Club Subscription";
            }
            var userDetails = {
                "customerID": this.userObj.MemberId,
                "invoiceID": this.userObj.MemberId,
                "invoiceDescription": "Invoice for " + itemName,
                "contact": {
                    "firstName": this.user.FullName,
                    "lastName": this.userObj.LastName,
                    "company": "",
                    "contactNumber": this.user.MobilePhone,
                    "email": this.user.Email
                }
            };

            var pin = this.userObj.MemberId;

            this.card.amount = this.subsClub.item.PriceInCents;

            lsItem.userDetails = userDetails;
            lsItem.pin = pin;

            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["k" /* OrderService */].prepareSubs(this.card, this.subsClub.item, userDetails, pin)).then(function (result) {

                if (result.data != undefined && result.data != null) {
                    var md_decoded = atob(result.data.md);

                    if (result.success == true) {
                        if (result.data.status == true) {
                            lsItem.currentStepUrl = "/subscribe/3";
                            lsItem.currentStep = 4;
                            lsItem.currentStepName = "make-payment";
                            lsItem.nextStep = 5;
                            lsItem.nextStepName = "confirm-payment";
                            lsItem.nextStepUrl = "";
                            lsItem.psRef = md_decoded.reference;
                            lsItem.debitOrderDay = _this2.card.debitOrderDay;
                            window.localStorage.setItem('subsClub', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(lsItem));
                            document.getElementById('frmLaunchACS').action = result.data.lookup.acsUrl;
                            document.getElementById('PaReq').value = result.data.lookup.payload;
                            document.getElementById('TermUrl').value = _this2.dsLookup.TermUrl;
                            document.getElementById('MD').value = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(result.data.md);
                            document.getElementById('frmLaunchACS').submit();
                            _this2.loadingPayment = false;
                        } else {
                            _this2.$router.push("/subscribe-failure");
                        }
                    } else {
                        _this2.$router.push("/subscribe-failure");
                    }
                }
            });
        },
        setDateData: function setDateData() {
            var today = new Date();

            var year = today.getFullYear();
            var yearEnd = year + 10;

            for (var y = year; y <= yearEnd; y++) {
                this.years.push({ year: y });
            }

            return this.years;
        }
    },

    created: function created() {
        var _this3 = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.setUser(), this.getSubsData(), this.setDateData(), __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getApiHttpDefaultBaseLinkUrl()]).then(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 4),
                user = _ref2[0],
                subs = _ref2[1],
                dateData = _ref2[2],
                httpData = _ref2[3];

            _this3.dsLookup.TermUrl = httpData + "/payment/authenticate";

            if (_this3.userObj && !_this3.userObj.isGuest()) {
                _this3.user.FullName = _this3.userObj.FirstName + " " + _this3.userObj.LastName;
                _this3.user.Email = _this3.userObj.Email;
                _this3.user.MobilePhone = _this3.userObj.MobilePhone;
            }

            _this3.debitOrderTooltip = "This should probably be on payday. The subscription is for a minimum of three months and the second month will be deducted on this day.";

            _this3.loading = false;
        });
    },
    mounted: function mounted() {
        window.scrollTo(0, 0);
        window.scroll({ top: 0, left: 0 });
    }
});

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), (!_vm.loading) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md8": ""
    }
  }, [_c('sk-panel', [_c('h3', [_vm._v("Your Payment Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "checkout",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "checkout-form"
    },
    on: {
      "submit": function($event) {
        _vm.continueToNextStep()
      }
    }
  }, [_c('p', {
    staticClass: "form-alert"
  }, [_vm._v("All fields are mandatory")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "cardHolder",
      "autocomplete": "cardHolder",
      "label": "Cardholder Name",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter the name on the card.'
      }
    },
    model: {
      value: (_vm.card.cardHolder),
      callback: function($$v) {
        _vm.$set(_vm.card, "cardHolder", $$v)
      },
      expression: "card.cardHolder"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "cardNumber",
      "type": "number",
      "label": "Credit Card Number",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter your credit card number.'
      }
    },
    model: {
      value: (_vm.card.cardNumber),
      callback: function($$v) {
        _vm.$set(_vm.card, "cardNumber", $$v)
      },
      expression: "card.cardNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Expiry Date")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-select', {
    attrs: {
      "placeholder": "Month",
      "type": "number"
    },
    model: {
      value: (_vm.card.expiryMonth),
      callback: function($$v) {
        _vm.$set(_vm.card, "expiryMonth", $$v)
      },
      expression: "card.expiryMonth"
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Expiry Month")]), _vm._v(" "), _vm._l((_vm.months), function(month) {
    return (month != undefined && month != null) ? _c('option', {
      domProps: {
        "value": month.value
      }
    }, [_vm._v(_vm._s(month.name))]) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-select', {
    attrs: {
      "placeholder": "Year",
      "type": "number"
    },
    model: {
      value: (_vm.card.expiryYear),
      callback: function($$v) {
        _vm.$set(_vm.card, "expiryYear", $$v)
      },
      expression: "card.expiryYear"
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Expiry Year")]), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return (year != undefined && year != null) ? _c('option', {
      domProps: {
        "value": year.year
      }
    }, [_vm._v(_vm._s(year.year))]) : _vm._e()
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "cvvNumber",
      "type": "number",
      "autocomplete": "cvvNumber",
      "label": "CVV Number",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter the CVV number at the back of the card.'
      }
    },
    model: {
      value: (_vm.card.cvvNumber),
      callback: function($$v) {
        _vm.$set(_vm.card, "cvvNumber", $$v)
      },
      expression: "card.cvvNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "subscribe-payment-debit-day",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "debit-order-label",
    attrs: {
      "for": "debitOrderDay"
    }
  }, [_vm._v("\n                                  Debit OrderDay "), _c('sk-tooltip', {
    key: "debit-order-tooltip",
    attrs: {
      "content": "This should probably be on payday. The subscription is for a minimum of three months and the second month will be deducted on this day.",
      "standalone": ""
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-select', {
    attrs: {
      "placeholder": "Month",
      "type": "number",
      "required": "",
      "error-message": {
        valueMissing: 'Please select a debit order day.'
      }
    },
    model: {
      value: (_vm.card.debitOrderDay),
      callback: function($$v) {
        _vm.$set(_vm.card, "debitOrderDay", $$v)
      },
      expression: "card.debitOrderDay"
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Debit Order Day")]), _vm._v(" "), _vm._l((_vm.debitDays), function(day) {
    return (day != undefined && day != null) ? _c('option', {
      domProps: {
        "value": day.day
      }
    }, [_vm._v(_vm._s(day.name))]) : _vm._e()
  })], 2)], 1)], 1), _vm._v(" "), _c('p', [_vm._v("By clicking pay, you agree to our "), _c('a', {
    attrs: {
      "href": "/content/legal/Fan%20Club%20T's%20and%20C's",
      "target": "_blank"
    }
  }, [_vm._v("Terms & Conditions")])]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "payment-info": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "text-right": ""
    }
  }, [_c('p', {
    staticClass: "text--small"
  }, [_vm._v("Ster-Kinekor is secure. For credit card payments we accept")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm6": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/visa.png",
      "alt": "Visa"
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm6": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/master-card.png",
      "alt": "Master Card"
    }
  })])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    class: _vm.$breakpoints.smDown ? 'text-right' : '',
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "payment-footer": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm10": "",
      "grow": "",
      "text-right": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "payment-footer-btns": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.subsClub.item.Description == 'Limited Subs') ? [(!_vm.loadingPayment) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "contextValue": "Subscription make payment",
      "dataValue": "Pay for Fan club"
    }
  }, [_vm._v("PAY " + _vm._s(_vm.subsClub.item.Price))]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.subsClub.item.Description == 'Unlimited Subs') ? [(!_vm.loadingPayment) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "contextValue": "Subscription make payment",
      "dataValue": "Pay for Morvies club"
    }
  }, [_vm._v("PAY " + _vm._s(_vm.subsClub.item.Price))]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.loadingPayment) ? _c('sk-button', {
    attrs: {
      "disabled": "",
      "primary": ""
    }
  }, [_vm._v("PAY " + _vm._s(_vm.subsClub.item.Price))]) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": "",
      "md2": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "link": "",
      "router": "",
      "to": "/subscribe/2",
      "contextValue": "Subscription make payment",
      "dataValue": "Back to confirm details"
    }
  }, [_vm._v("Back")])], 1)], 1)], 1), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "id": "frmLaunchACS",
      "name": "frmLaunchACS",
      "action": "",
      "method": "POST"
    }
  }, [_c('textarea', {
    attrs: {
      "id": "PaReq",
      "name": "PaReq"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "TermUrl",
      "name": "TermUrl",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "MD",
      "name": "MD",
      "value": ""
    }
  })])], 1)])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', [(_vm.subsClub.item.Description == 'Limited Subs') ? [_c('div', {
    staticClass: "limited-subs"
  }, [_c('h3', [_vm._v("Subscription Summary")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    staticClass: "img-responsive img-option",
    attrs: {
      "src": "/static/img/fan_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    staticClass: "subscription-summary-heading",
    attrs: {
      "xs7": ""
    }
  }, [_c('p', [_c('span', [_vm._v("LIMITED MOVIE TICKETS PER MONTH")]), _c('br'), _vm._v("\n                                    You get 4 2D or 3D movie tickets per month for you and your family.\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("4 MOVIE TICKETS TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                    You watch more for less\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                    20% off a regular combo\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("IDEAL FOR THE FAMILY")]), _vm._v(" "), _c('br'), _vm._v("\n                                    Use one or all four tickets at once\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Eastgate Shopping Centre (GAU)")]), _vm._v(" "), _c('li', [_vm._v("Sandton City (GAU)")]), _vm._v(" "), _c('li', [_vm._v("Cresta Shopping Centre (GAU)")]), _vm._v(" "), _c('li', [_vm._v("Brooklyn Mall (GAU)")]), _vm._v(" "), _c('li', [_vm._v("Brooklyn Mall Nouveau (GAU)")]), _vm._v(" "), _c('li', [_vm._v("I'langa Mall (MPL)")]), _vm._v(" "), _c('li', [_vm._v("Gateway Mall (KZN)")]), _vm._v(" "), _c('li', [_vm._v("Watercrest Mall (KZN)")]), _vm._v(" "), _c('li', [_vm._v("Blue Route (WC)")]), _vm._v(" "), _c('li', [_vm._v("Somerset Mall (WC)")]), _vm._v(" "), _c('li', [_vm._v("Garden Route Mall (WC)")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ticket-component"
  }, [_c('div', {
    staticClass: "ticket-component-wrapper ticket-component-total"
  }, [_c('div', {
    staticClass: "ticket-total"
  }, [_c('div', {
    staticClass: "layout row"
  }, [_c('div', {
    staticClass: "flex xs12 sm12"
  }, [_c('p', [_vm._v("Total " + _vm._s(_vm.subsClub.item.Price) + " "), _c('span', [_vm._v("per month")])])])])])])])], 1)] : _vm._e(), _vm._v(" "), (_vm.subsClub.item.Description == 'Unlimited Subs') ? [_c('div', {
    staticClass: "unlimited-subs"
  }, [_c('h3', [_vm._v("Subscription Summary")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    staticClass: "img-responsive img-option",
    attrs: {
      "src": "/static/img/morvies_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    staticClass: "subscription-summary-heading",
    attrs: {
      "xs7": ""
    }
  }, [_c('p', [_c('span', [_vm._v("UNLIMITED MOVIES PER MONTH")]), _c('br'), _vm._v("\n                                    Watch as many 2D or 3D movies as you want all month long.\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("UNLIMITED MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                    Watch up to 5 movies a day, every day!\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                    20% off a regular combo\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("COME AS OFTEN AS YOU CAN")]), _vm._v(" "), _c('br'), _vm._v("\n                                    1 ticket per movie per card holder \n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Eastgate Shopping Centre (GAU)")]), _vm._v(" "), _c('li', [_vm._v("Sandton City (GAU)")]), _vm._v(" "), _c('li', [_vm._v("Cresta Shopping Centre (GAU)")]), _vm._v(" "), _c('li', [_vm._v("Brooklyn Mall (GAU)")]), _vm._v(" "), _c('li', [_vm._v("Brooklyn Mall Nouveau (GAU)")]), _vm._v(" "), _c('li', [_vm._v("I'langa Mall (MPL)")]), _vm._v(" "), _c('li', [_vm._v("Gateway Mall (KZN)")]), _vm._v(" "), _c('li', [_vm._v("Watercrest Mall (KZN)")]), _vm._v(" "), _c('li', [_vm._v("Blue Route (WC)")]), _vm._v(" "), _c('li', [_vm._v("Somerset Mall (WC)")]), _vm._v(" "), _c('li', [_vm._v("Garden Route Mall (WC)")])])])])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "ticket-component-wrapper ticket-component-total"
  }, [_c('div', {
    staticClass: "ticket-total"
  }, [_c('div', {
    staticClass: "layout row"
  }, [_c('div', {
    staticClass: "flex xs12 sm12"
  }, [_c('p', [_vm._v("Total " + _vm._s(_vm.subsClub.item.Price) + " "), _c('span', [_vm._v("per month")])])])])])])])], 1)] : _vm._e()], 2)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 811 */,
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core___ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages___ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__generic___ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__booking___ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__about___ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vision_mission___ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__profile___ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__club_loyalty__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_page__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__news__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vouchers__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__exclusive_to_sk__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__procurement_tabs__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__careers_tabs__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__performance__ = __webpack_require__(947);

















/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_1__core___, __WEBPACK_IMPORTED_MODULE_2__pages___, __WEBPACK_IMPORTED_MODULE_3__generic___, __WEBPACK_IMPORTED_MODULE_4__booking___, __WEBPACK_IMPORTED_MODULE_5__about___, __WEBPACK_IMPORTED_MODULE_7__profile___, __WEBPACK_IMPORTED_MODULE_8__club_loyalty__, __WEBPACK_IMPORTED_MODULE_9__static_page__, __WEBPACK_IMPORTED_MODULE_6__vision_mission___, __WEBPACK_IMPORTED_MODULE_10__news__, __WEBPACK_IMPORTED_MODULE_11__vouchers__, __WEBPACK_IMPORTED_MODULE_12__exclusive_to_sk__, __WEBPACK_IMPORTED_MODULE_14__careers_tabs__, __WEBPACK_IMPORTED_MODULE_15__performance__));

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__site_header_site_header_vue__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__site_header_site_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__site_header_site_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__site_footer_site_footer_vue__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__site_footer_site_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__site_footer_site_footer_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SiteHeader", function() { return __WEBPACK_IMPORTED_MODULE_0__site_header_site_header_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SiteFooter", function() { return __WEBPACK_IMPORTED_MODULE_1__site_footer_site_footer_vue___default.a; });





/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(815),
  /* template */
  __webpack_require__(816),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_main_nav__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'site-header',

    data: function data() {
        return {
            logoSrc: '/static/img/sk-logo.png',
            navItems: __WEBPACK_IMPORTED_MODULE_0__router_main_nav__["a" /* default */],
            header: null,
            mobileNavActive: false,
            user: null,
            guest: null,
            active: false,
            nouveauLogo: false,
            toggleDialog: false,
            cookieActive: true,
            showUserActivation: false,
            activationLoading: false,
            first_time: true,
            toast: '',
            covidSnack: true
        };
    },


    methods: {
        resendVerification: function resendVerification() {
            var _this = this;

            this.activationLoading = true;
            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["b" /* AuthService */].resendActivation().then(function () {
                _this.$emit('change', true);
                _this.showUserActivation = false;
                _this.activationLoading = false;
            });
        },
        closeVerificationSnack: function closeVerificationSnack() {
            this.showUserActivation = false;
            this.activationLoading = false;
        },
        setUser: function setUser() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user().then(function (user) {
                if (user != undefined && user != null) {
                    _this2.user = user;
                    _this2.guest = user.isGuest();
                    if (!user.isGuest() && user.MembershipActivated === false && _this2.first_time) {
                        _this2.cookieActive = false;
                        _this2.showUserActivation = true;
                        _this2.first_time = false;
                    } else {
                        _this2.showUserActivation = false;
                    }
                }
            });
        },
        checkScroll: function checkScroll() {
            if (window.scrollY > this.$el.clientHeight) this.$el.classList.add('sticky');
            if (window.scrollY == 0) this.$el.classList.remove('sticky');
        },
        toggle: function toggle(el) {
            el.target.nextElementSibling.classList.toggle('hidden-xs');
        },
        setNouveau: function setNouveau(to, from) {},
        addNouveau: function addNouveau() {
            this.$root.$el.classList.add('nouveau');
            this.logoSrc = '/static/img/nouveau-logo.png';
            this.navItems.forEach(function (e) {
                if (e.name === 'Home') {
                    e.path = '/type/Nouveau';
                }
                if (e.name === 'Cinema Nouveau') {
                    e.name = 'Classic SK';
                    e.path = '/';
                }
            });
        },
        removeNouveau: function removeNouveau() {
            this.$root.$el.classList.remove('nouveau');
            this.logoSrc = '/static/img/sk-logo.png';
            this.navItems.forEach(function (e) {
                if (e.name === 'Home') {
                    e.path = '/';
                }
                if (e.name === 'Classic SK') {
                    e.name = 'Cinema Nouveau';
                    e.path = '/type/Nouveau';
                }
            });
        },
        closeCookie: function closeCookie() {
            this.cookieActive = false;
            if (!sessionStorage.getItem('cookie')) sessionStorage.setItem('cookie', true);
        },
        closeCovid: function closeCovid() {
            this.covidSnack = false;
        },
        addNouveauLogo: function addNouveauLogo() {
            this.logoSrc = '/static/img/nouveau-logo.png';
            this.navItems.forEach(function (e) {
                if (e.name === 'Home') {
                    e.path = '/type/Nouveau';
                }
                if (e.name === 'Cinema Nouveau') {
                    e.name = 'Classic SK';
                    e.path = '/';
                }
            });
        },
        removeNouveauLogo: function removeNouveauLogo() {
            this.logoSrc = '/static/img/sk-logo.png';
            this.navItems.forEach(function (e) {
                if (e.name === 'Home') {
                    e.path = '/';
                }
                if (e.name === 'Classic SK') {
                    e.name = 'Cinema Nouveau';
                    e.path = '/type/Nouveau';
                }
            });
        },
        toastToggle: function toastToggle() {
            this.toast = document.querySelector('.snack');
            if (this.toast) {
                document.querySelector('.main-view').removeAttribute('style');
                var marTop = parseInt(window.getComputedStyle(document.querySelector('.main-view')).getPropertyValue('margin-top'));
                document.querySelector('.main-view').setAttribute('style', 'margin-top:' + (this.toast.offsetHeight + marTop) + 'px');
            } else {
                if (document.querySelector('.main-view')) document.querySelector('.main-view').removeAttribute('style');
            }
        }
    },

    computed: {
        classList: function classList() {
            return this.$root.$el.classList.value;
        },
        isNouveau: function isNouveau() {
            var _this3 = this;

            if (this.$route.path.includes('/type') && this.$route.path.includes("Nouveau")) {
                __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].nextTick(function () {
                    _this3.addNouveau();
                });
                this.nouveauLogo = true;
                return { name: 'Cinema Nouveau' };
            } else {
                this.nouveauLogo = false;
                return { name: 'Home' };
            }
        }
    },

    created: function created() {
        var _this4 = this;

        __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["b" /* AuthService */].addObserver(this, __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["b" /* AuthService */].PROFILE_CHANGED, this.setUser);
        this.setUser();

        document.addEventListener('scroll', this.checkScroll, false);
        if (sessionStorage.getItem('cookie')) this.cookieActive = false;else {
            if (!this.$breakpoints.xs) {
                __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].nextTick(function () {
                    _this4.toastToggle();
                });
            }
        }
    },
    updated: function updated() {
        if (!this.$breakpoints.xs) {
            this.toastToggle();
        }
    },
    destroy: function destroy() {
        document.removeEventListener('scroll', this.checkScroll);
    },


    watch: {
        '$route': function $route(to, from, el) {
            if (this.cookieActive) {
                this.closeCookie();
            }
        }
    }
});

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-header container--fluid",
    attrs: {
      "id": "site-header",
      "context": "site-header"
    }
  }, [(_vm.cookieActive) ? _c('sk-snackbar', {
    attrs: {
      "top": (_vm.$breakpoints.xs ? false : true),
      "fixed": (_vm.$breakpoints.xs ? true : false),
      "multi-line": "",
      "fullwidth": true,
      "timeout": null
    },
    model: {
      value: (_vm.cookieActive),
      callback: function($$v) {
        _vm.cookieActive = $$v
      },
      expression: "cookieActive"
    }
  }, [_c('sk-container', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs10": "",
      "grow": ""
    }
  }, [_vm._v("\n         We use cookies to improve your experience. By continuing on our website, you agree to this. "), _c('a', {
    attrs: {
      "href": "/content/legal/privacy-policy"
    }
  }, [_vm._v("Find more information on Ster-Kinekor's Privacy Policy")]), _vm._v(".\n        ")]), _vm._v(" "), _c('sk-flex', {
    staticClass: "text-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeCookie($event)
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "close": ""
    }
  }), _vm._v(" Close\n          ")], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.$breakpoints.xs)) ? [(_vm.showUserActivation) ? _c('sk-snackbar', {
    attrs: {
      "top": (_vm.$breakpoints.xs ? false : true),
      "fixed": (_vm.$breakpoints.xs ? true : false),
      "multi-line": "",
      "fullwidth": true,
      "timeout": null
    },
    model: {
      value: (_vm.showUserActivation),
      callback: function($$v) {
        _vm.showUserActivation = $$v
      },
      expression: "showUserActivation"
    }
  }, [_c('sk-container', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs10": "",
      "grow": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "xs6": "",
      "grow": ""
    }
  }, [_c('b', [_vm._v("THANKS FOR CREATING A SK PROFILE!")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n                    Please activate your account by checking your email for your verification link.\n                  ")])]), _vm._v(" "), _c('sk-flex', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "xs6": "",
      "grow": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-bottom": "5px"
    }
  }, [_vm._v("Haven't received it?")]), _vm._v(" "), _c('sk-button', {
    staticClass: "btn--reactivate",
    attrs: {
      "small": "",
      "primary": "",
      "loading": _vm.activationLoading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resendVerification()
      }
    }
  }, [_vm._v("RESEND VERIFICATION EMAIL NOW")]), _vm._v(".\n                ")], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    staticClass: "text-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeVerificationSnack($event)
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "close": ""
    }
  }), _vm._v(" Close\n              ")], 1)], 1)], 1)], 1)], 1) : _vm._e()] : [((_vm.$breakpoints.md)) ? [(_vm.showUserActivation) ? _c('sk-snackbar', {
    attrs: {
      "top": (_vm.$breakpoints.xs ? false : true),
      "fixed": (_vm.$breakpoints.xs ? true : false),
      "multi-line": "",
      "fullwidth": true,
      "timeout": null
    },
    model: {
      value: (_vm.showUserActivation),
      callback: function($$v) {
        _vm.showUserActivation = $$v
      },
      expression: "showUserActivation"
    }
  }, [_c('sk-container', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs10": "",
      "grow": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "xs6": "",
      "grow": ""
    }
  }, [_c('b', [_vm._v("THANKS FOR CREATING A SK PROFILE!")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n                        Please activate your account by checking your email for your verification link.\n                      ")])]), _vm._v(" "), _c('sk-flex', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "xs6": "",
      "grow": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-bottom": "5px"
    }
  }, [_vm._v("Haven't received it?")]), _vm._v(" "), _c('sk-button', {
    staticClass: "btn--reactivate",
    attrs: {
      "small": "",
      "primary": "",
      "loading": _vm.activationLoading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resendVerification()
      }
    }
  }, [_vm._v("RESEND VERIFICATION EMAIL NOW")]), _vm._v(".\n                    ")], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    staticClass: "text-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeVerificationSnack($event)
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "close": ""
    }
  }), _vm._v(" Close\n                  ")], 1)], 1)], 1)], 1)], 1) : _vm._e()] : [(_vm.showUserActivation) ? _c('sk-snackbar', {
    attrs: {
      "top": (_vm.$breakpoints.xs ? false : true),
      "fixed": (_vm.$breakpoints.xs ? true : false),
      "multi-line": "",
      "fullwidth": true,
      "timeout": null
    },
    model: {
      value: (_vm.showUserActivation),
      callback: function($$v) {
        _vm.showUserActivation = $$v
      },
      expression: "showUserActivation"
    }
  }, [_c('sk-container', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs10": "",
      "grow": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "xs7": "",
      "grow": ""
    }
  }, [_c('b', [_vm._v("THANKS FOR CREATING A SK PROFILE!")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n                        Please activate your account by checking your email for your verification link.\n                      ")])]), _vm._v(" "), _c('sk-flex', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "xs5": "",
      "grow": ""
    }
  }, [_vm._v("\n                        Haven't received it? "), _c('sk-button', {
    staticClass: "btn--reactivate",
    attrs: {
      "small": "",
      "primary": "",
      "loading": _vm.activationLoading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resendVerification()
      }
    }
  }, [_vm._v("RESEND VERIFICATION EMAIL NOW")]), _vm._v(".\n                    ")], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    staticClass: "text-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeVerificationSnack($event)
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "close": ""
    }
  }), _vm._v(" Close\n                  ")], 1)], 1)], 1)], 1)], 1) : _vm._e()]], _vm._v(" "), _c('nav', {
    staticClass: "main-nav"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sm2": "",
      "md2": ""
    }
  }, [(_vm.$breakpoints.xs || _vm.$breakpoints.sm) ? _c('div', [_c('nav', {
    staticClass: "nav-header"
  }, [_c('sk-dialog', {
    attrs: {
      "transition": "sk-slide-x-transition",
      "fullscreen": "",
      "overlay": false,
      "lazy": ""
    },
    model: {
      value: (_vm.mobileNavActive),
      callback: function($$v) {
        _vm.mobileNavActive = $$v
      },
      expression: "mobileNavActive"
    }
  }, [_c('div', {
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mobileNavActive = false
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-mobile--action",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('i', {
    staticClass: "icon icon-menu"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-mobile--target"
  }, [(_vm.guest) ? [_c('li', [_c('a', {
    attrs: {
      "href": "/user/signup",
      "tertiary": ""
    }
  }, [_vm._v("Create Profile")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/user/login",
      "secondary": ""
    }
  }, [_vm._v("Sign In")])])] : _vm._e(), _vm._v(" "), (!_vm.guest) ? [_c('div', {
    staticClass: "member-login"
  }, [_c('sk-profile-toolbar', {
    attrs: {
      "user": _vm.user,
      "click-outside": "",
      "active": _vm.active
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.guest === false) ? _c('li', [
    [_c('a', {
      attrs: {
        "href": "/user/profile"
      }
    }, [_vm._v("My Dashboard")])]
  ], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.navItems), function(item) {
    return (item != undefined && item != null) ? [(item.topNav) ? _c('li', [(item.topNav) ? _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.path,
        "contextValue": "Header Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()], 1) : _vm._e()] : _vm._e()
  }), _vm._v(" "), (_vm.guest === false) ? _c('li', [
    [_c('a', {
      attrs: {
        "href": "/user/sign-out"
      }
    }, [_vm._v("Sign Out")])]
  ], 2) : _vm._e()], 2)])], 1)]) : _c('div', {
    staticClass: "desktop-logo"
  }, [(!_vm.isNouveau.path) ? _c('a', {
    attrs: {
      "href": "/",
      "data-track-context": "Header Navigation",
      "data-track-value": "Nouveau"
    }
  }, [_c('img', {
    staticClass: "img-responsive logo",
    attrs: {
      "src": _vm.logoSrc,
      "alt": "Ster Kinekor"
    }
  })]) : _c('a', {
    attrs: {
      "href": _vm.isNouveau.path,
      "data-track-context": "Header Navigation",
      "data-track-value": "Nouveau"
    }
  }, [_c('img', {
    staticClass: "img-responsive logo",
    attrs: {
      "src": _vm.logoSrc
    }
  })])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs8": "",
      "sm7": "",
      "md7": ""
    }
  }, [(_vm.$breakpoints.xs || _vm.$breakpoints.sm) ? _c('div', {
    staticClass: "mobile-logo"
  }, [_c('sk-button', {
    attrs: {
      "router": "",
      "tag": "a",
      "contextValue": "Header Navigation",
      "dataValue": "Nouveau",
      "to": _vm.isNouveau
    }
  }, [_c('img', {
    staticClass: "img-responsive logo",
    attrs: {
      "src": _vm.logoSrc
    }
  })])], 1) : _c('div', [_c('nav', {
    staticClass: "nav-header"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_vm._l((_vm.navItems), function(item) {
    return (item != undefined && item != null) ? [(item.topNav) ? _c('li', [(item.topNav) ? _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.path,
        "contextValue": "Header Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()], 1) : _vm._e()] : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs2": "",
      "sm3": "",
      "md3": ""
    }
  }, [(_vm.$breakpoints.md || _vm.$breakpoints.lg || _vm.$breakpoints.lgUp) ? _c('div', [_c('sk-profile-toolbar', {
    attrs: {
      "user": _vm.user,
      "click-outside": "",
      "active": _vm.active,
      "guest": _vm.guest
    }
  })], 1) : _vm._e()])], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(818),
  /* template */
  __webpack_require__(819),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_footer_nav__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'site-footer',
    data: function data() {
        return {
            items: __WEBPACK_IMPORTED_MODULE_0__router_footer_nav__["a" /* default */],
            isGuest: true,
            newsletter_email: '',
            subscribedDialog: false,
            loadingSubscribe: false,
            memberLevel: null,
            cardNumber: null,
            sb4for3: null,
            isSubs: false,
            isFanClub: false,
            isMorviesClub: false,
            PreviewService: __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["m" /* PreviewService */]
        };
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["b" /* AuthService */].addObserver(this, __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["b" /* AuthService */].PROFILE_CHANGED, this.checkUser);
        this.checkUser();
    },


    methods: {
        checkUser: function checkUser() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user().then(function (user) {
                if (user != undefined && user != null) {
                    _this.sb4for3 = user.StandardBankBenefit;
                    if (user.PreferenceList.includes(5) || user.PreferenceList.includes(6)) {
                        _this.isSubs = true;
                        if (user.PreferenceList.includes(5)) {
                            _this.isMorviesClub = true;
                        }

                        if (user.PreferenceList.includes(6)) {
                            _this.isFanClub = true;
                        }
                    }
                    _this.memberLevel = user.MemberLevelId;
                    _this.cardNumber = user.CardNumber;
                    _this.isGuest = user.isGuest();
                }
            });
        },
        subscribe: function subscribe(email) {
            var _this2 = this;

            this.loadingSubscribe = true;
            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["b" /* AuthService */].subscribeToNewsletter(email).then(function () {
                _this2.subscribedDialog = true;
                _this2.loadingSubscribe = false;
            }, function () {
                return _this2.loadingSubscribe = false;
            });
        }
    }
});

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "site-footer",
    attrs: {
      "context": "site-footer"
    }
  }, [(_vm.PreviewService.getPreviewConfig()) ? [_c('sk-preview-footer', {
    attrs: {
      "config": _vm.PreviewService.getPreviewConfig()
    }
  })] : _vm._e(), _vm._v(" "), _c('sk-container', [_c('sk-layout', {
    staticClass: "site-footer__top",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "site-footer__club-cards"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "site-footer__club-cards-img"
  }, [(_vm.isGuest) ? [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-club-cards.png",
      "alt": ""
    }
  })] : [(_vm.isFanClub) ? [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/fan_club_card.png",
      "alt": ""
    }
  })] : [(_vm.isMorviesClub) ? [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/morvies_club_card.png",
      "alt": ""
    }
  })] : [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs_club_cards.png",
      "alt": ""
    }
  })]]]], 2)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "site-footer__club-cards-content"
  }, [(_vm.isGuest) ? [_c('div', {
    staticClass: "site-footer__club-cards-title"
  }, [_vm._v("\n                                      Ready for SK Subscription Club?\n                                  ")]), _vm._v(" "), _c('p', {
    staticClass: "site-footer__club-cards-copy"
  }, [_vm._v("\n                                      Subscribe today and watch even more movies, for less.\n                                  ")])] : [(_vm.isFanClub) ? [_c('div', {
    staticClass: "site-footer__club-cards-title"
  }, [_vm._v("\n                                          The fine print and the nitty gritties\n                                      ")]), _vm._v(" "), _c('p', {
    staticClass: "site-footer__club-cards-copy"
  }, [_vm._v("\n                                          Get clued up on the SK Subscription CLUB Ts & Cs to understand exactly how your subscription works.\n                                      ")])] : [(_vm.isMorviesClub) ? [_c('div', {
    staticClass: "site-footer__club-cards-title"
  }, [_vm._v("\n                                              The fine print and the nitty gritties\n                                          ")]), _vm._v(" "), _c('p', {
    staticClass: "site-footer__club-cards-copy"
  }, [_vm._v("\n                                              Get clued up on the SK Subscription CLUB Ts & Cs to understand exactly how your subscription works.\n                                          ")])] : [_c('div', {
    staticClass: "site-footer__club-cards-title"
  }, [_vm._v("\n                                              Ready for SK Subscription Club?\n                                          ")]), _vm._v(" "), _c('p', {
    staticClass: "site-footer__club-cards-copy"
  }, [_vm._v("\n                                              Subscribe today and watch even more movies, for less.\n                                          ")])]]]], 2), _vm._v(" "), _c('div', {
    staticClass: "site-footer__club-cards-btns"
  }, [(_vm.isGuest) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "tertiary": "",
      "block": "",
      "tag": "a",
      "href": "/subscription-club"
    }
  }, [_vm._v("Tell Me More")])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "block": "",
      "tag": "a",
      "href": "/subscription-club"
    }
  }, [_vm._v("Join Subscription Club")])], 1)], 1)] : [(_vm.isFanClub) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "block": "",
      "tag": "a",
      "href": "/content/legal/Fan%20Club%20T's%20and%20C's"
    }
  }, [_vm._v("View the SK Subscription CLUB Ts & Cs")])], 1)], 1)] : [(_vm.isMorviesClub) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "block": "",
      "tag": "a",
      "href": "/content/legal/Fan%20Club%20T's%20and%20C's"
    }
  }, [_vm._v("View the SK Subscription CLUB Ts & Cs")])], 1)], 1)] : [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "tertiary": "",
      "block": "",
      "tag": "a",
      "href": "/subscription-club"
    }
  }, [_vm._v("Tell Me More")])], 1)], 1)]]]], 2)])], 1)], 1)])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "site-footer__nav"
  }, [_c('sk-layout', {
    staticClass: "hidden-xs",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer--heading"
  }, [_vm._v("Get in Touch")]), _vm._v(" "), _c('sk-list', {
    staticClass: "footer--list"
  }, _vm._l((_vm.items), function(item, index) {
    return (item.footer == 1) ? _c('sk-list-item', {
      key: index
    }, [(!item.url) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: item.name
        },
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.url,
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer--heading"
  }, [_c('a', {
    staticClass: "footer--heading--link",
    attrs: {
      "href": "/content/sales-at-sk/advertising"
    }
  }, [_vm._v("Sales at SK")])]), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return (item.footer == 2) ? _c('sk-list', {
      key: index,
      staticClass: "footer--list"
    }, _vm._l((item.children), function(child, index) {
      return _c('sk-list-item', {
        key: index
      }, [(!child.url) ? _c('sk-button', {
        attrs: {
          "link": "",
          "router": "",
          "to": {
            name: child.name
          },
          "contextValue": "Footer Navigation"
        }
      }, [_vm._v(_vm._s(child.name))]) : _c('sk-button', {
        attrs: {
          "link": "",
          "tag": "a",
          "href": child.url,
          "contextValue": "Footer Navigation"
        }
      }, [_vm._v(_vm._s(child.name))])], 1)
    })) : _vm._e()
  })], 2)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer--heading"
  }, [_vm._v("SK Corporate")]), _vm._v(" "), _c('sk-list', {
    staticClass: "footer--list"
  }, _vm._l((_vm.items), function(item, index) {
    return (item.footer == 3) ? _c('sk-list-item', {
      key: index
    }, [(!item.url) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: item.name
        },
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.url,
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer--heading"
  }, [_vm._v("SK Clubs & Movie Cards")]), _vm._v(" "), _c('sk-list', {
    staticClass: "footer--list"
  }, _vm._l((_vm.items), function(item, index) {
    return (item.footer == 4) ? _c('sk-list-item', {
      key: index
    }, [(!item.url) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: item.name
        },
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.url,
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer--heading"
  }, [_vm._v("Share the Experience")]), _vm._v(" "), _c('sk-list', {
    staticClass: "footer--list"
  }, _vm._l((_vm.items), function(item, index) {
    return (item.footer == 5) ? _c('sk-list-item', {
      key: index
    }, [(!item.url) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: item.name
        },
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.url,
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('div', {
    staticClass: "footer footer-social"
  }, [_c('div', {
    staticClass: "footer--heading"
  }, [_vm._v("Social")]), _vm._v(" "), _c('sk-list', [_c('sk-list-item', [_c('sk-list-tile', {
    attrs: {
      "href": "https://www.facebook.com/sterkinekortheatres/",
      "target": "_blank"
    }
  }, [_c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "facebook": ""
    }
  })], 1), _vm._v(" "), _c('sk-list-tile-content', [_vm._v("\n                        Facebook\n                      ")])], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', {
    attrs: {
      "href": "https://twitter.com/sterkinekor",
      "target": "_blank"
    }
  }, [_c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "twitter": ""
    }
  })], 1), _vm._v(" "), _c('sk-list-tile-content', [_vm._v("\n                        Twitter\n                      ")])], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', {
    attrs: {
      "href": "https://www.instagram.com/sterkinekor/?hl=en",
      "target": "_blank"
    }
  }, [_c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "instagram": ""
    }
  })], 1), _vm._v(" "), _c('sk-list-tile-content', [_vm._v("\n                        Instagram\n                      ")])], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', {
    attrs: {
      "href": "https://www.youtube.com/user/SterKinekorTheatres",
      "target": "_blank"
    }
  }, [_c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "youtube": ""
    }
  })], 1), _vm._v(" "), _c('sk-list-tile-content', [_vm._v("\n                        Youtube\n                      ")])], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('sk-layout', [_c('sk-spacer', {
    attrs: {
      "height": "20"
    }
  })], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "hidden-xs"
  }, [_c('sk-flex', {
    staticClass: "footer-container",
    attrs: {
      "grow": ""
    }
  }, _vm._l((_vm.items), function(item, index) {
    return (item.footer == 6) ? _c('sk-list', {
      key: index,
      staticClass: "footer--list",
      attrs: {
        "inline": ""
      }
    }, [_c('sk-list-item', {}, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child, index) {
      return _c('sk-list-item', {
        key: index
      }, [(child.target != undefined) ? [(!child.url) ? _c('sk-button', {
        attrs: {
          "link": "",
          "router": "",
          "to": {
            name: child.name
          },
          "contextValue": "Footer Navigation",
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.name))]) : _c('sk-button', {
        attrs: {
          "link": "",
          "tag": "a",
          "href": child.url,
          "contextValue": "Footer Navigation",
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.name))])] : [(!child.url) ? _c('sk-button', {
        attrs: {
          "link": "",
          "router": "",
          "to": {
            name: child.name
          },
          "contextValue": "Footer Navigation"
        }
      }, [_vm._v(_vm._s(child.name))]) : _c('sk-button', {
        attrs: {
          "link": "",
          "tag": "a",
          "href": child.url,
          "contextValue": "Footer Navigation"
        }
      }, [_vm._v(_vm._s(child.name))])]], 2)
    })], 2) : _vm._e()
  }))], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "visible-xs",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-list', [_c('sk-list-group', [_c('sk-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('sk-list-tile-content', [_c('sk-list-tile-title', [_vm._v("Get in Touch")])], 1), _vm._v(" "), _c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "arrowDown": ""
    }
  })], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', [_c('sk-list-tile-content', _vm._l((_vm.items), function(item, index) {
    return (item.footer == 1) ? _c('sk-list-tile-title', {
      key: index
    }, [(!item.url) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: item.name
        },
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.url,
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-list', [_c('sk-list-group', [_c('sk-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('sk-list-tile-content', [_c('sk-list-tile-title', [_c('a', {
    attrs: {
      "href": "/content/sales-at-sk/advertising"
    }
  }, [_vm._v("Sales at SK")])])], 1), _vm._v(" "), _c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "arrowDown": ""
    }
  })], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', [_c('sk-list-tile-content', _vm._l((_vm.items), function(item, index) {
    return (item.footer == 2) ? _c('sk-list-tile-title', {
      key: index
    }, _vm._l((item.children), function(child, index) {
      return _c('div', [(!child.url) ? _c('sk-button', {
        attrs: {
          "link": "",
          "router": "",
          "to": {
            name: child.name
          },
          "contextValue": "Footer Navigation"
        }
      }, [_vm._v(_vm._s(child.name))]) : _c('sk-button', {
        attrs: {
          "link": "",
          "tag": "a",
          "href": child.url,
          "contextValue": "Footer Navigation"
        }
      }, [_vm._v(_vm._s(child.name))])], 1)
    })) : _vm._e()
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-list', [_c('sk-list-group', [_c('sk-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('sk-list-tile-content', [_c('sk-list-tile-title', [_vm._v("SK Corporate")])], 1), _vm._v(" "), _c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "arrowDown": ""
    }
  })], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', [_c('sk-list-tile-content', _vm._l((_vm.items), function(item, index) {
    return (item.footer == 3) ? _c('sk-list-tile-title', {
      key: index
    }, [(!item.url) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: item.name
        },
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.url,
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-list', [_c('sk-list-group', [_c('sk-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('sk-list-tile-content', [_c('sk-list-tile-title', [_vm._v("SK Clubs & Movie Cards")])], 1), _vm._v(" "), _c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "arrowDown": ""
    }
  })], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', [_c('sk-list-tile-content', _vm._l((_vm.items), function(item, index) {
    return (item.footer == 4) ? _c('sk-list-tile-title', {
      key: index
    }, [(!item.url) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: item.name
        },
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.url,
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-list', [_c('sk-list-group', [_c('sk-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('sk-list-tile-content', [_c('sk-list-tile-title', [_vm._v("Share the Experience")])], 1), _vm._v(" "), _c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "arrowDown": ""
    }
  })], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', [_c('sk-list-tile-content', _vm._l((_vm.items), function(item, index) {
    return (item.footer == 5) ? _c('sk-list-tile-title', {
      key: index
    }, [(!item.url) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: item.name
        },
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.url,
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-list', [_c('sk-list-group', [_c('sk-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('sk-list-tile-content', [_c('sk-list-tile-title', [_vm._v("Legal")])], 1), _vm._v(" "), _c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "arrowDown": ""
    }
  })], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', _vm._l((_vm.items), function(item, index) {
    return (item.footer == 6) ? _c('sk-list-tile-content', {
      key: index
    }, _vm._l((item.children), function(child, index) {
      return _c('sk-list-tile-title', {
        key: index
      }, [(child.target != undefined) ? [(!child.url) ? _c('sk-button', {
        attrs: {
          "link": "",
          "router": "",
          "to": {
            name: child.name
          },
          "contextValue": "Footer Navigation",
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.name))]) : _c('sk-button', {
        attrs: {
          "link": "",
          "tag": "a",
          "href": child.url,
          "contextValue": "Footer Navigation",
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.name))])] : [(!child.url) ? _c('sk-button', {
        attrs: {
          "link": "",
          "router": "",
          "to": {
            name: child.name
          },
          "contextValue": "Footer Navigation"
        }
      }, [_vm._v(_vm._s(child.name))]) : _c('sk-button', {
        attrs: {
          "link": "",
          "tag": "a",
          "href": child.url,
          "contextValue": "Footer Navigation"
        }
      }, [_vm._v(_vm._s(child.name))])]], 2)
    })) : _vm._e()
  }))], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('sk-list', {
    staticClass: "footer-social-icons"
  }, [_c('sk-list-tile', {
    attrs: {
      "href": "https://www.facebook.com/sterkinekortheatres/",
      "target": "_blank"
    }
  }, [_c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "facebook": ""
    }
  })], 1), _vm._v(" "), _c('sk-list-tile-content', {
    staticClass: "hidden-xs"
  }, [_vm._v("\n                    Facebook\n                  ")])], 1), _vm._v(" "), _c('sk-list-tile', {
    attrs: {
      "href": "https://twitter.com/sterkinekor",
      "target": "_blank"
    }
  }, [_c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "twitter": ""
    }
  })], 1), _vm._v(" "), _c('sk-list-tile-content', {
    staticClass: "hidden-xs"
  }, [_vm._v("\n                    Twitter\n                  ")])], 1), _vm._v(" "), _c('sk-list-tile', {
    attrs: {
      "href": "https://www.instagram.com/sterkinekor/?hl=en",
      "target": "_blank"
    }
  }, [_c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "instagram": ""
    }
  })], 1), _vm._v(" "), _c('sk-list-tile-content', {
    staticClass: "hidden-xs"
  }, [_vm._v("\n                    Instagram\n                  ")])], 1), _vm._v(" "), _c('sk-list-tile', {
    attrs: {
      "href": "https://www.youtube.com/user/SterKinekorTheatres",
      "target": "_blank"
    }
  }, [_c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "youtube": ""
    }
  })], 1), _vm._v(" "), _c('sk-list-tile-content', {
    staticClass: "hidden-xs"
  }, [_vm._v("\n                    Youtube\n                  ")])], 1)], 1)], 1)], 1)], 1)], 1)], 2), _vm._v(" "), _c('sk-dialog', {
    staticClass: "video",
    attrs: {
      "width": "50%",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.subscribedDialog),
      callback: function($$v) {
        _vm.subscribedDialog = $$v
      },
      expression: "subscribedDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.subscribedDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.subscribedDialog = false
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Thank You!")]), _vm._v(" "), _c('p', [_vm._v("Your email " + _vm._s(_vm.newsletter_email) + " has successfully been subscribed.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.subscribedDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__search_filter_search_filter_vue__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__search_filter_search_filter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__search_filter_search_filter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__related_movies_related_movies_vue__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__related_movies_related_movies_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__related_movies_related_movies_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SearchFilter", function() { return __WEBPACK_IMPORTED_MODULE_0__search_filter_search_filter_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "RelatedMovies", function() { return __WEBPACK_IMPORTED_MODULE_1__related_movies_related_movies_vue___default.a; });





/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(822),
  /* template */
  __webpack_require__(827),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        DatePicker: __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__["a" /* default */]
    },
    props: {
        form_data: Object,
        search_filter: Object,
        doSearch: Boolean,
        availableCinemas: { type: Array, default: [] },
        cinemasByRegion: Array,
        timeRanges: Array,
        dates: Array,
        cinemaTypes: Array,
        movieGenres: Array,
        filterOptions: Array,
        loading: Boolean,
        isNouveau: Boolean,
        predictiveText: Array,
        searchResultCount: Number,
        lastAvailableDate: String
    },

    data: function data() {
        return {
            last_form_data: {},
            resetVal: null,
            cinemasNearBy: [],
            cinemas_data: [],
            search: 'sandton',
            filterSelects: [],
            typeSelects: [],
            genreSelects: [],
            cinemaType: [],
            regionsByLabel: [],
            place: null,
            isLoading: true,
            regions: [],
            search_query: null,
            cinemaActive: false,
            filterActive: false,
            cinemasFiltered: null,
            movies: [],
            cinemas_by_region: [],
            cinemaSelectLoading: false,
            created: true,
            genreSearchable: true,
            typeSearchable: true,
            mobile_cinema_types: [],
            mobile_genres: [],
            mobile_time_range: null,
            mobile_dates: null,
            selected_cinema: null,
            selected_time_range: null,
            selected_types: null,
            movieDatePickerOpen: false
        };
    },


    computed: {
        filter: function filter() {
            var result = {
                title: null,
                cinemas: null,
                genres: null,
                experiences: null,
                dates: this.form_data.dates
            };

            if (this.form_data.selected_cinema != null && this.form_data.selected_cinema != undefined) {
                result.cinemas = this.form_data.selected_cinema;
            }

            return result;
        },
        selectedCinema: function selectedCinema() {
            return {
                name: this.form_data.selected_cinema && this.form_data.selected_cinema.name ? this.form_data.selected_cinema.name : undefined,
                id: this.form_data.selected_cinema && this.form_data.selected_cinema.id ? this.form_data.selected_cinema.id : undefined
            };
        },
        selectedOptions: function selectedOptions() {
            if (this.form_data != undefined && this.form_data != null) {
                if (this.form_data.selected_cinema != undefined && this.form_data.selected_cinema != null) {
                    if (this.form_data.selected_cinema.id != undefined && this.form_data.selected_cinema.id != null) {
                        this.selected_cinema = this.form_data.selected_cinema;
                    }
                }

                if (this.form_data.cinema_types != undefined && this.form_data.cinema_types != null) {
                    this.selected_types = this.form_data.cinema_types;
                }
            }

            return this.form_data;
        }
    },

    methods: {
        placeSelected: function placeSelected(place) {
            this.place = place;
            this.getClosestCinema('cinemas/:latitude/:longitude');
        },

        getClosestCinema: function getClosestCinema() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["n" /* RegionService */].getCinemasNearBy(this.place.latitude, this.place.longitude).then(function (cinemasNearBy) {
                cinemasNearBy = cinemasNearBy.filter(function (c) {
                    return ~_this.availableCinemas.indexOf(c.id.toString());
                });

                _this.cinemasNearBy = cinemasNearBy;
                _this.$emit("setCinemasNearby", _this.cinemasNearBy);
            });
        },
        resetForm: function resetForm() {
            this.form_data.place_query = null;
            this.form_data.keyword = null;
            this.form_data.selected_cinema = {};
            this.form_data.filter_group = null;
            this.form_data.cinema_types = null;
            this.form_data.genres = null;
            this.form_data.selected_time_range = null;
            this.form_data.dates = null;

            this.selected_time_range = null;
            this.mobile_cinema_types = null;
            this.mobile_genres = null;
            this.mobile_time_range = null;
            this.selected_types = null;
            this.selected_cinema = null;
            this.cinemaActive = false;
            this.filterActive = false;

            this.$emit('changed', this.filter);
        },
        nouveauFilter: function nouveauFilter() {
            if (this.$route.path === '/nouveau') {
                this.filterSelects.shift();
                this.form_data.filter_group = [{ name: 'Nouveau' }];
            } else {
                if (this.filterSelects.length < 2) this.filterSelects.unshift(this.cinemaType);
                this.form_data.filter_group = [];
            }
        },
        generateSelectedRouteCinemaTypes: function generateSelectedRouteCinemaTypes(route_types) {
            var selected_cinema_types = [];

            if (typeof route_types === 'string') {
                if (route_types && route_types.length > 0) {
                    for (var r in route_types) {
                        if (route_types[r] != undefined) {
                            var rtype = route_types[r].split("-").join(" ");

                            selected_cinema_types.push({ name: rtype.trim() });
                        }
                    }
                }
            }

            return selected_cinema_types;
        },
        setDisabledDates: function setDisabledDates(date) {
            var today = new Date();
            today.setHours(0, 0, 0, 0);

            if (date < today) {
                return true;
            }

            var lastDate = new Date(__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.lastAvailableDate, 'YYYY-MM-DD HH:mm').format('D MMMM YYYY').toString());

            if (date > lastDate) {
                return true;
            }

            return false;
        }
    },

    created: function created() {
        this.form_data.doInitialSearch = true;
    },


    watch: {
        form_data: {
            handler: __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_ui_core__["Utils"].debounce(function () {
                this.$emit('changed', this.filter);
            }, 300),
            deep: true
        },

        selected_cinema: {
            handler: __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_ui_core__["Utils"].debounce(function () {
                var empty_cinema = null;

                if (this.selected_cinema != null) {
                    this.form_data.selected_cinema = this.selected_cinema;
                } else {
                    this.form_data.selected_cinema = empty_cinema;
                }

                this.form_data.count++;
            }, 300)
        },

        selectedOptions: {
            handler: __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_ui_core__["Utils"].debounce(function () {
                return true;
            }, 300)
        },

        selected_types: {
            handler: __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_ui_core__["Utils"].debounce(function () {
                if (this.selected_types != null && this.selected_types != undefined) {
                    this.form_data.cinema_types = this.selected_types;
                } else {
                    this.form_data.cinema_types = null;
                }

                this.form_data.count++;
            }, 300)
        },

        mobile_cinema_types: {
            handler: __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_ui_core__["Utils"].debounce(function () {
                if (this.mobile_cinema_types != null && this.mobile_cinema_types != undefined) {
                    if (this.mobile_cinema_types.length > 0) {
                        var cinema_types = [];

                        for (var mt in this.mobile_cinema_types) {
                            if (this.mobile_cinema_types[mt] != undefined && this.mobile_cinema_types[mt] != null) {
                                for (var t in this.mobile_cinema_types[mt]) {
                                    if (this.mobile_cinema_types[mt][t]) {
                                        cinema_types.push(this.mobile_cinema_types[mt][t]);
                                    }
                                }
                            }
                        }

                        if (cinema_types.length > 0) {
                            this.form_data.cinema_types = cinema_types;
                        } else {
                            this.form_data.cinema_types = null;
                        }

                        this.form_data.count++;
                    }
                }
            })
        },

        mobile_genres: {
            handler: __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_ui_core__["Utils"].debounce(function () {

                if (this.mobile_genres != null) {
                    if (this.mobile_genres.length > 0 && this.mobile_genres != this.form_data.genres) {

                        var genres = [];

                        for (var mg in this.mobile_genres) {
                            if (this.mobile_genres[mg]) {
                                for (var g in this.mobile_genres[mg]) {
                                    if (this.mobile_genres[mg][g]) {
                                        genres.push(this.mobile_genres[mg][g]);
                                    }
                                }
                            }
                        }

                        if (genres.length > 0) {
                            this.form_data.genres = genres;
                        } else {
                            this.form_data.genres = null;
                        }

                        this.form_data.count++;
                    }
                }
            })
        },

        '$route': function $route(to, from) {
            this.nouveauFilter();
        }
    }
});

/***/ }),
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-form', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "keyword-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.keyword),
      expression: "form_data.keyword"
    }],
    staticClass: "keyword-search form-control",
    attrs: {
      "list": "search-keyword",
      "type": "text",
      "placeholder": "Search for a movie"
    },
    domProps: {
      "value": (_vm.form_data.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form_data, "keyword", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.form_data.keyword && _vm.form_data.keyword.length > 2) ? _c('datalist', {
    attrs: {
      "id": "search-keyword"
    }
  }, _vm._l((_vm.predictiveText), function(text) {
    return _c('option', {
      domProps: {
        "value": text
      }
    }, [_vm._v(_vm._s(text))])
  })) : _vm._e(), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('label', {
    staticClass: "filter-label"
  }, [_vm._v("Filter by:")]) : _vm._e(), _vm._v(" "), (_vm.$breakpoints.xs) ? _c('div', {
    staticClass: "filter-mobile-btns"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-button', {
    staticClass: "filter-mobile",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cinemaActive = true
      }
    }
  }, [_vm._v("Cinema")])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('sk-button', {
    staticClass: "filter-mobile",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.filterActive = true
      }
    }
  }, [_vm._v("Filter")])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('sk-button', {
    staticClass: "reset-label",
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resetForm()
      }
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.$breakpoints.xs) ? [_c('sk-google-places-input', {
    ref: "location_input",
    staticClass: "location-search",
    attrs: {
      "placeholder": "Seach location",
      "geolocation": "",
      "autocomplete": "",
      "pinOnly": ""
    },
    on: {
      "place-selected": _vm.placeSelected
    },
    model: {
      value: (_vm.form_data.place_query),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "place_query", $$v)
      },
      expression: "form_data.place_query"
    }
  }), _vm._v(" "), _c('sk-multi-select-regions', {
    staticClass: "filter-select form-group",
    attrs: {
      "val": _vm.selected_cinema,
      "items": _vm.cinemasByRegion
    },
    model: {
      value: (_vm.selected_cinema),
      callback: function($$v) {
        _vm.selected_cinema = $$v
      },
      expression: "selected_cinema"
    }
  }), _vm._v(" "), _c('sk-multi-select-types', {
    staticClass: "filter-select form-group",
    attrs: {
      "val": _vm.form_data.cinema_types,
      "items": _vm.cinemaTypes,
      "multiple": true
    },
    model: {
      value: (_vm.form_data.cinema_types),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "cinema_types", $$v)
      },
      expression: "form_data.cinema_types"
    }
  }), _vm._v(" "), _c('sk-multi-select-genres', {
    staticClass: "filter-select form-group",
    attrs: {
      "val": _vm.form_data.genres,
      "items": _vm.movieGenres,
      "multiple": true
    },
    model: {
      value: (_vm.form_data.genres),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "genres", $$v)
      },
      expression: "form_data.genres"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "filter-select form-group datepicker-container"
  }, [_c('date-picker', {
    ref: "movieDatePicker",
    class: _vm.movieDatePickerOpen ? 'datepicker--active' : 'datepicker--inactive',
    attrs: {
      "type": "date",
      "placeholder": "Select date",
      "disabled-date": _vm.setDisabledDates,
      "editable": false,
      "append-to-body": false,
      "format": "D MMMM YYYY",
      "input-class": "datepicker__input",
      "popup-class": "datepicker__popup",
      "prefix-class": "datepicker"
    },
    on: {
      "open": function($event) {
        _vm.movieDatePickerOpen = true
      },
      "close": function($event) {
        _vm.movieDatePickerOpen = false
      }
    },
    model: {
      value: (_vm.form_data.dates),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "dates", $$v)
      },
      expression: "form_data.dates"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('sk-button', {
    staticClass: "hidden-xs reset-label",
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resetForm()
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), (_vm.$breakpoints.xs) ? _c('sk-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "sk-dialog-bottom-transition"
    },
    model: {
      value: (_vm.cinemaActive),
      callback: function($$v) {
        _vm.cinemaActive = $$v
      },
      expression: "cinemaActive"
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "dialog__header"
  }, [_c('div', {
    staticClass: "dialog__header-title"
  }, [_vm._v("Filter your movies")]), _vm._v(" "), _c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cinemaActive = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-google-places-input', {
    ref: "location_input",
    staticClass: "location-search",
    attrs: {
      "placeholder": "Seach location",
      "geolocation": "",
      "autocomplete": "",
      "pinOnly": ""
    },
    on: {
      "place-selected": _vm.placeSelected
    },
    model: {
      value: (_vm.form_data.place_query),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "place_query", $$v)
      },
      expression: "form_data.place_query"
    }
  }), _vm._v(" "), _c('sk-multi-select-regions', {
    staticClass: "cinema-select form-group",
    attrs: {
      "val": _vm.selected_cinema,
      "items": _vm.cinemasByRegion
    },
    model: {
      value: (_vm.selected_cinema),
      callback: function($$v) {
        _vm.selected_cinema = $$v
      },
      expression: "selected_cinema"
    }
  }), _vm._v(" "), (_vm.searchResultCount != null) ? _c('div', [(_vm.searchResultCount > 0) ? [_vm._v("\n                        Results for selection: " + _vm._s(_vm.searchResultCount)), _c('br'), _c('br')] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cinemaActive = false
      }
    }
  }, [_vm._v("Show Results")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resetForm()
      }
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$breakpoints.xs) ? _c('sk-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "sk-dialog-bottom-transition"
    },
    model: {
      value: (_vm.filterActive),
      callback: function($$v) {
        _vm.filterActive = $$v
      },
      expression: "filterActive"
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "dialog__header"
  }, [_c('div', {
    staticClass: "dialog__header-title"
  }, [_vm._v("Filter your movies")]), _vm._v(" "), _c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.filterActive = false
      }
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("\n                   Cinema Types\n                ")]), _vm._v(" "), _c('sk-multi-select-types', {
    staticClass: "filter-select form-group",
    attrs: {
      "val": _vm.form_data.cinema_types,
      "items": _vm.cinemaTypes,
      "multiple": true
    },
    model: {
      value: (_vm.form_data.cinema_types),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "cinema_types", $$v)
      },
      expression: "form_data.cinema_types"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n                   Genres\n                ")]), _vm._v(" "), _c('sk-multi-select-genres', {
    staticClass: "filter-select form-group",
    attrs: {
      "val": _vm.form_data.genres,
      "items": _vm.movieGenres,
      "multiple": true
    },
    model: {
      value: (_vm.form_data.genres),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "genres", $$v)
      },
      expression: "form_data.genres"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n                   Show dates\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "filter-select form-group datepicker-container"
  }, [_c('date-picker', {
    ref: "movieDatePicker",
    class: _vm.movieDatePickerOpen ? 'datepicker--active' : 'datepicker--inactive',
    attrs: {
      "type": "date",
      "placeholder": "Select date",
      "disabled-date": _vm.setDisabledDates,
      "editable": false,
      "append-to-body": false,
      "format": "D MMMM YYYY",
      "input-class": "datepicker__input",
      "popup-class": "datepicker__popup",
      "prefix-class": "datepicker"
    },
    on: {
      "open": function($event) {
        _vm.movieDatePickerOpen = true
      },
      "close": function($event) {
        _vm.movieDatePickerOpen = false
      }
    },
    model: {
      value: (_vm.form_data.dates),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "dates", $$v)
      },
      expression: "form_data.dates"
    }
  })], 1), _vm._v(" "), (_vm.searchResultCount != null) ? _c('div', [(_vm.searchResultCount > 0) ? [_vm._v("\n                        Results for selection: " + _vm._s(_vm.searchResultCount)), _c('br'), _c('br')] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.filterActive = false
      }
    }
  }, [_vm._v("Show Results")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resetForm()
      }
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(829),
  /* template */
  __webpack_require__(830),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		movies: Array,
		label: {
			type: String,
			default: 'Related movies'
		},
		link: { type: String, default: "/" },
		limit: { "type": String, default: "6" }
	},

	computed: {
		slicedMovies: function slicedMovies() {
			var movies = this.movies.slice(0);
			if (this.limit !== undefined && parseInt(this.limit) !== 0) {
				movies.splice(parseInt(this.limit), movies.length);
			}

			return movies;
		}
	},

	methods: {
		showMovieDetail: function showMovieDetail(id) {

			if (this.$route.params.festival_id) {
				this.$router.push('/details/' + id + '/film-festival/' + this.$route.params.festival_id);
			} else this.$router.push({ name: 'Movie Details', params: { id: id } });
		}
	}

});

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.movies.length > 0) ? _c('div', {
    staticClass: "related-movies"
  }, [_c('sk-title-heading', {
    attrs: {
      "h2": "",
      "label": _vm.label
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('sk-button', {
    attrs: {
      "tag": "a",
      "secondary": "",
      "small": "",
      "inline-block": "",
      "href": _vm.link
    }
  }, [_vm._v("View All Movies")])], 1)], 2), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.slicedMovies), function(item, index) {
    return _c('sk-flex', {
      key: item.id,
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": "",
        "lg2": ""
      }
    }, [(_vm.$route.params.festival_id != undefined && _vm.$route.params.festival_id != null) ? [_c('a', {
      attrs: {
        "href": '/details/' + item.id + (_vm.$route.params.festival_id ? '/film-festival/' + _vm.$route.params.festival_id : '')
      }
    }, [_c('sk-movie-thumbnail', {
      ref: "movie",
      refInFor: true,
      attrs: {
        "now-showing": "",
        "content": item
      }
    })], 1)] : [_c('a', {
      attrs: {
        "href": '/details/' + item.id + '/' + item.title_slug
      }
    }, [_c('sk-movie-thumbnail', {
      ref: "movie",
      refInFor: true,
      attrs: {
        "now-showing": "",
        "content": item
      }
    })], 1)]], 2)
  }))], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__about_us_about_us_vue__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__about_us_about_us_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__about_us_about_us_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__our_history_our_history_vue__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__our_history_our_history_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__our_history_our_history_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__management_team_management_team_vue__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__management_team_management_team_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__management_team_management_team_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shareholders_shareholders_vue__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shareholders_shareholders_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shareholders_shareholders_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AboutUs", function() { return __WEBPACK_IMPORTED_MODULE_0__about_us_about_us_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "OurHistory", function() { return __WEBPACK_IMPORTED_MODULE_1__our_history_our_history_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ManagementTeam", function() { return __WEBPACK_IMPORTED_MODULE_2__management_team_management_team_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Shareholders", function() { return __WEBPACK_IMPORTED_MODULE_3__shareholders_shareholders_vue___default.a; });







/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(833),
  /* template */
  __webpack_require__(834),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      content: [],
      loading: true
    };
  },

  methods: {
    getContent: function getContent() {
      var _this = this;

      this.loading = true;
      if (this.$breakpoints.xs || this.$breakpoints.sm) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
          if (_this.$parent.$el != undefined) window.scroll({ top: _this.$parent.$el.offsetTop - 100, left: 0, behavior: 'smooth' });
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getGeneralPage("About", null).then(function (response) {
        _this.content = response[0].About.About;
        _this.loading = false;
      });
    }
  },
  created: function created() {
    this.getContent();
  },

  watch: {
    '$route': function $route() {
      this.getContent();
    }
  },

  beforeMounted: function beforeMounted() {
    this.getContent();
  }
});

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-container', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.body)
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.content.section_1.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.content.section_1.image
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Our Partners")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content article__our-partners"
  }, [(_vm.content.section_2.image) ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.content.section_2.image
    }
  })]) : _vm._e(), _vm._v(" "), _c('h6', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_2.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_2.body)
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content article__our-partners"
  }, [(_vm.content.section_3.image) ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.content.section_3.image
    }
  })]) : _vm._e(), _vm._v(" "), _c('h6', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_3.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_3.body)
    }
  })])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.content.section_1.video_link) ? _c('div', {
    staticClass: "article__feature embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    attrs: {
      "src": ("" + (_vm.content.section_1.video_link)),
      "frameborder": "0",
      "gesture": "media",
      "allow": "encrypted-media",
      "allowfullscreen": ""
    }
  })]) : _vm._e()])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(836),
  /* template */
  __webpack_require__(837),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      content: [],
      loading: true
    };
  },

  methods: {
    getContent: function getContent() {
      var _this = this;

      this.loading = true;
      if (this.$breakpoints.xs || this.$breakpoints.sm) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
          if (_this.$parent.$el != undefined) window.scroll({ top: _this.$parent.$el.offsetTop - 100, left: 0, behavior: 'smooth' });
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getGeneralPage("History", null).then(function (response) {
        _this.content = response[0].History.History;
        _this.loading = false;
      });
    }
  },
  created: function created() {
    this.getContent();
  },

  watch: {
    '$route': function $route() {
      this.getContent();
    }
  },

  beforeMounted: function beforeMounted() {
    this.getContent();
  }
});

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-container', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [(_vm.content.section_1) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.body)
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.content.section_1.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.content.section_1.image
    }
  })]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.content.section_2) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "static-info--sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_2.heading)
    }
  }), _vm._v(" "), (_vm.content.section_2.video_link) ? _c('div', {
    staticClass: "article__feature embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    attrs: {
      "src": ("" + (_vm.content.section_2.video_link)),
      "frameborder": "0",
      "gesture": "media",
      "allow": "encrypted-media",
      "allowfullscreen": ""
    }
  })]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_2.body)
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.content.section_3) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('h3', {
    staticClass: "static-info--sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_3.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_3.body)
    }
  })])], 1) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(839),
  /* template */
  __webpack_require__(840),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      people: [],
      loading: true
    };
  },

  methods: {
    getContent: function getContent() {
      var _this = this;

      this.loading = true;
      if (this.$breakpoints.xs || this.$breakpoints.sm) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
          if (_this.$parent.$el != undefined) window.scroll({ top: _this.$parent.$el.offsetTop - 100, left: 0, behavior: 'smooth' });
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getPeople("all", null).then(function (people) {
        _this.people = people;
        _this.loading = false;
      });
    }
  },
  created: function created() {
    this.getContent();
  },

  watch: {
    '$route': function $route() {
      this.getContent();
    }
  },

  beforeMounted: function beforeMounted() {
    this.getContent();
  }
});

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-container', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Management Team")]), _vm._v(" "), _c('p', {
    staticClass: "static-info--sub-teaser"
  }, [_vm._v("Meat the team that bring you the best in cinema entertainment ")])])], 1), _vm._v(" "), _vm._l((_vm.people), function(person, index) {
    return _c('div', {
      key: index
    }, [(person.type === 'Management_Team') ? _c('div', [_c('sk-layout', {
      staticClass: "management__content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "md2": ""
      }
    }, [_c('div', {
      staticClass: "management__image"
    }, [_c('img', {
      attrs: {
        "src": person.image
      }
    })])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "md10": ""
      }
    }, [_c('h6', {
      staticClass: "management__person-name",
      domProps: {
        "innerHTML": _vm._s(person.name)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "management__job-description",
      domProps: {
        "innerHTML": _vm._s(person.position)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "management__summary"
    }, [_c('p', [_vm._v(_vm._s(person.description))])])])], 1), _vm._v(" "), _c('hr')], 1) : _vm._e()])
  }), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-title-heading', {
    staticClass: "sharedolders-heading",
    attrs: {
      "h3": "",
      "no-border": "",
      "label": "Meet our Shareholders"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('sk-button', {
    attrs: {
      "tag": "a",
      "secondary": "",
      "small": "",
      "href": "/"
    }
  }, [_vm._v("Read More")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.people), function(person, index) {
    return _c('sk-flex', {
      key: index,
      attrs: {
        "xs6": "",
        "md2": ""
      }
    }, [(person.type === 'Shareholder') ? _c('div', {
      staticClass: "shareholder"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": person.image
      }
    })]) : _vm._e()])
  }))], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(842),
  /* template */
  __webpack_require__(843),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      people: [],
      loading: true
    };
  },

  methods: {
    getContent: function getContent() {
      var _this = this;

      this.loading = true;
      if (this.$breakpoints.xs || this.$breakpoints.sm) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
          if (_this.$parent.$el != undefined) window.scroll({ top: _this.$parent.$el.offsetTop - 100, left: 0, behavior: 'smooth' });
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getPeople("all", null).then(function (people) {
        _this.people = people;
        console.log(_this.people);
        _this.loading = false;
      });
    }
  },
  created: function created() {
    this.getContent();
  },

  watch: {
    '$route': function $route() {
      this.getContent();
    }
  },

  beforeMounted: function beforeMounted() {
    this.getContent();
  }
});

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-container', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Shareholders")]), _vm._v(" "), _c('p', {
    staticClass: "static-info--sub-teaser"
  }, [_vm._v("Meet the key shareholders driving the future of Ster-Kinekor Theatres")])])], 1), _vm._v(" "), _vm._l((_vm.people), function(person) {
    return _c('div', {
      key: person.name
    }, [(person.type === 'Shareholder') ? _c('div', [_c('sk-layout', {
      staticClass: "management__content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "md2": ""
      }
    }, [_c('div', {
      staticClass: "management__image"
    }, [_c('img', {
      attrs: {
        "src": person.image
      }
    })])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "md10": ""
      }
    }, [_c('h6', {
      staticClass: "management__person-name",
      domProps: {
        "innerHTML": _vm._s(person.name)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "management__job-description",
      domProps: {
        "innerHTML": _vm._s(person.position)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "management__summary"
    }, [_c('p', [_vm._v(_vm._s(person.description))])])])], 1), _vm._v(" "), _c('hr')], 1) : _vm._e()])
  }), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-title-heading', {
    staticClass: "sharedolders-heading",
    attrs: {
      "h3": "",
      "no-border": "",
      "label": "Meet our Management Team"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('sk-button', {
    attrs: {
      "tag": "a",
      "secondary": "",
      "small": "",
      "href": "/"
    }
  }, [_vm._v("Read More")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('sk-layout', _vm._l((_vm.people), function(person) {
    return (person.type === 'Management_Team') ? _c('sk-flex', {
      key: person.name,
      attrs: {
        "xs6": "",
        "md2": ""
      }
    }, [_c('div', {
      staticClass: "shareholder"
    }, [_c('img', {
      attrs: {
        "src": person.image
      }
    })])]) : _vm._e()
  }))], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__how_it_works_how_it_works_vue__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__how_it_works_how_it_works_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__how_it_works_how_it_works_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__our_success_our_success_vue__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__our_success_our_success_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__our_success_our_success_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__overview_overview_vue__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__overview_overview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__overview_overview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partners_partners_vue__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partners_partners_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__partners_partners_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__the_objective_the_objective_vue__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__the_objective_the_objective_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__the_objective_the_objective_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HowItWorks", function() { return __WEBPACK_IMPORTED_MODULE_0__how_it_works_how_it_works_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "OurSuccess", function() { return __WEBPACK_IMPORTED_MODULE_1__our_success_our_success_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Overview", function() { return __WEBPACK_IMPORTED_MODULE_2__overview_overview_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Partners", function() { return __WEBPACK_IMPORTED_MODULE_3__partners_partners_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "TheObjective", function() { return __WEBPACK_IMPORTED_MODULE_4__the_objective_the_objective_vue___default.a; });








/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(846),
  /* template */
  __webpack_require__(847),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'how-it-works',
  data: function data() {
    return {
      content: [],
      loading: true,
      movies: null
    };
  },


  methods: {
    getContent: function getContent() {
      var _this = this;

      this.loading = true;
      if (this.$breakpoints.xs || this.$breakpoints.sm) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].nextTick(function () {
          if (_this.$parent.$el != undefined) window.scroll({ top: _this.$parent.$el.offsetTop - 100, left: 0, behavior: 'smooth' });
        });
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["l" /* PageService */].getGeneralPage("Vision"), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["j" /* MovieService */].getMovies()]).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            response = _ref2[0],
            movies = _ref2[1];

        _this.content = response[0].Vision.How_It_Works;
        _this.movies = movies.byRelease();
        _this.loading = false;
      });
    }
  },

  created: function created() {
    this.getContent();
  }
});

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.body)
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/donate/1"
    }
  }, [_vm._v(_vm._s(_vm.content.section_1.button_text))])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.content.section_1.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.content.section_1.image
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "featured-content-heading"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_2.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_2.body)
    }
  })])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "featured-donate-block"
  }, [_c('div', {
    staticClass: "featured-donate-block__number"
  }, [_vm._v("\n                1\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "featured-donate-block__content"
  }, [_c('sk-button', {
    attrs: {
      "link": "",
      "tag": "a",
      "href": "/donate/1"
    }
  }, [_c('p', [_c('strong', [_vm._v("Donate")]), _vm._v(" R100 or more online now")])])], 1)])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "featured-donate-block"
  }, [_c('div', {
    staticClass: "parent"
  }, [_c('div', {
    staticClass: "featured-donate-block__number"
  }, [_vm._v("\n                    2\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "featured-donate-block__content"
  }, [_c('p', [_vm._v("Donate R2.50 or more when you "), _c('sk-button', {
    attrs: {
      "link": "",
      "router": "",
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("book a movie")]), _vm._v(" or using "), _c('strong', [_vm._v("Quick Book")])], 1)])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "featured-donate-block"
  }, [_c('div', {
    staticClass: "featured-donate-block__number"
  }, [_vm._v("\n                  3\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "featured-donate-block__content"
  }, [_c('p', [_vm._v("You can use the Self-Service terminals in our cinema foyers to donate. See "), _c('sk-button', {
    attrs: {
      "link": "",
      "router": "",
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("what's on.")])], 1)])])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "featured-donate-button"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/donate/1"
    }
  }, [_vm._v(_vm._s(_vm.content.section_1.button_text))])], 1)])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-related-movies', {
    attrs: {
      "limit": "6",
      "label": "Book and Donate",
      "movies": _vm.movies.now_showing
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(849),
  /* template */
  __webpack_require__(850),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'our-success',
  data: function data() {
    return {
      content: [],
      loading: true
    };
  },


  methods: {
    getContent: function getContent() {
      var _this = this;

      this.loading = true;
      if (this.$breakpoints.xs || this.$breakpoints.sm) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
          if (_this.$parent.$el != undefined) window.scroll({ top: _this.$parent.$el.offsetTop - 100, left: 0, behavior: 'smooth' });
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getGeneralPage("Vision").then(function (response) {
        _this.content = response[0].Vision.Our_Success;
        _this.loading = false;
      });
    }
  },

  created: function created() {
    this.getContent();
  }
});

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.body)
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/donate/1"
    }
  }, [_vm._v(_vm._s(_vm.content.section_1.button_text))])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.content.section_1.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.content.section_1.image
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.content.section_2.video_link) ? _c('div', {
    staticClass: "article__feature embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    attrs: {
      "src": ("" + (_vm.content.section_2.video_link)),
      "frameborder": "0",
      "gesture": "media",
      "allow": "encrypted-media",
      "allowfullscreen": ""
    }
  })]) : _vm._e()])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_2.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_2.body)
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/donate/1"
    }
  }, [_vm._v(_vm._s(_vm.content.section_2.button_text))])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.content.section_2.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.content.section_2.image
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "featured-content-heading"
  }, [_c('h3', [_vm._v("Vision Mission Accolades")])])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [_c('div', {
    staticClass: "featured_block__image"
  }), _vm._v(" "), _c('p', [_vm._v("Loerie Grand prix")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [_c('div', {
    staticClass: "featured_block__image"
  }), _vm._v(" "), _c('p', [_vm._v("Loerie 3 x Gold winner")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [_c('div', {
    staticClass: "featured_block__image"
  }), _vm._v(" "), _c('p', [_vm._v("Bookmarks Gold 3 x Silver winner")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [_c('div', {
    staticClass: "featured_block__image"
  }), _vm._v(" "), _c('p', [_vm._v("One Show Bronze Pencil, Merit (The One)")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [_c('div', {
    staticClass: "featured_block__image"
  }), _vm._v(" "), _c('p', [_vm._v("Creative Circle 2 x Ad of the Month")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(852),
  /* template */
  __webpack_require__(853),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'overview',
  data: function data() {
    return {
      content: [],
      loading: true
    };
  },


  methods: {
    getContent: function getContent() {
      var _this = this;

      this.loading = true;
      if (this.$breakpoints.xs || this.$breakpoints.sm) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
          if (_this.$parent.$el != undefined) window.scroll({ top: _this.$parent.$el.offsetTop - 100, left: 0, behavior: 'smooth' });
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getGeneralPage("Vision").then(function (response) {
        _this.content = response[0].Vision.Overview;
        _this.loading = false;
      });
    }
  },

  created: function created() {
    this.getContent();
  }
});

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.body)
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/donate/1"
    }
  }, [_vm._v(_vm._s(_vm.content.section_1.button_text))])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.content.section_1.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.content.section_1.image
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.content.section_2.video_link) ? _c('div', {
    staticClass: "article__feature embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    attrs: {
      "src": ("" + (_vm.content.section_2.video_link)),
      "frameborder": "0",
      "gesture": "media",
      "allow": "encrypted-media",
      "allowfullscreen": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.content.section_2.heading) ? _c('h3', {
    staticClass: "article__video-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_2.heading)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.section_2.body) ? _c('p', {
    staticClass: "article__video-content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_2.body)
    }
  }) : _vm._e()])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(855),
  /* template */
  __webpack_require__(856),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'partners',
  data: function data() {
    return {
      content: [],
      loading: true
    };
  },


  methods: {
    getContent: function getContent() {
      var _this = this;

      this.loading = true;
      if (this.$breakpoints.xs || this.$breakpoints.sm) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
          if (_this.$parent.$el != undefined) window.scroll({ top: _this.$parent.$el.offsetTop - 100, left: 0, behavior: 'smooth' });
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getGeneralPage("Vision").then(function (response) {
        _this.content = response[0].Vision.Our_Partners;
        _this.loading = false;
      });
    }
  },

  created: function created() {
    this.getContent();
  }
});

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.body)
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        path: '/donate/1'
      }
    }
  }, [_vm._v(_vm._s(_vm.content.section_1.button_text))])], 1)])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [_c('div', {
    staticClass: "featured_block__image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/love-life.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("LoveLife")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [_c('div', {
    staticClass: "featured_block__image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/spec-savers.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Spec Savers")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [_c('div', {
    staticClass: "featured_block__image"
  }), _vm._v(" "), _c('p', [_vm._v("Department of Education")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [_c('div', {
    staticClass: "featured_block__image"
  }), _vm._v(" "), _c('p', [_vm._v("Health and Social Development")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [_c('div', {
    staticClass: "featured_block__image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/afda.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Afda")])])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "featured-info"
  }, [_c('h6', [_vm._v("Read more about ster-kinekor")]), _vm._v(" "), _c('p', [_vm._v("Stay on top of all the latest updates from Ster-kinekor and be the ﬁrst to know about future CSI initiatives")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "md1": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "featured-button"
  }, [_c('sk-button', {
    attrs: {
      "tag": "a",
      "primary": "",
      "href": "/news"
    }
  }, [_vm._v("View SK News")])], 1)])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(858),
  /* template */
  __webpack_require__(859),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'the-objective',
  data: function data() {
    return {
      content: [],
      loading: true
    };
  },


  methods: {
    getContent: function getContent() {
      var _this = this;

      this.loading = true;
      if (this.$breakpoints.xs || this.$breakpoints.sm) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
          if (_this.$parent.$el != undefined) window.scroll({ top: _this.$parent.$el.offsetTop - 100, left: 0, behavior: 'smooth' });
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getGeneralPage("Vision").then(function (response) {
        _this.content = response[0].Vision.theObjective;
        _this.loading = false;
      });
    }
  },

  created: function created() {
    this.getContent();
  }
});

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.body)
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'Donate'
      }
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.button_text)
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.content.section_1.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.content.section_1.image
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.content.section_2.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.content.section_2.image
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_2.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_2.body)
    }
  })])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "featured-info"
  }, [_c('h5', [_vm._v("Read more about ster-kinekor")]), _vm._v(" "), _c('p', [_vm._v("Stay on top of all the latest updates from Ster-kinekor and be the ﬁrst to know about future CSI initiatives")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "md1": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "featured-button"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'News'
      }
    }
  }, [_vm._v("View SK News")])], 1)])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__booking_booking_vue__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__booking_booking_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__booking_booking_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__points_points_vue__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__points_points_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__points_points_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__card_card_vue__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__card_card_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__card_card_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__profile_toolbar_profile_toolbar_vue__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__profile_toolbar_profile_toolbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__profile_toolbar_profile_toolbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__signin_signin_vue__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__signin_signin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__signin_signin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__badge_badge_vue__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__badge_badge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__badge_badge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tiers_tiers_vue__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tiers_tiers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tiers_tiers_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return __WEBPACK_IMPORTED_MODULE_2__card_card_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ProfileToolbar", function() { return __WEBPACK_IMPORTED_MODULE_3__profile_toolbar_profile_toolbar_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Signin", function() { return __WEBPACK_IMPORTED_MODULE_4__signin_signin_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_5__badge_badge_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Booking", function() { return __WEBPACK_IMPORTED_MODULE_0__booking_booking_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Points", function() { return __WEBPACK_IMPORTED_MODULE_1__points_points_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Tiers", function() { return __WEBPACK_IMPORTED_MODULE_6__tiers_tiers_vue___default.a; });










/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(862),
  /* template */
  __webpack_require__(863),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'booking',

    props: {
        bookings: false,
        bookingHistory: Array,
        showView: { type: Boolean, default: true },
        showDownload: { type: Boolean, default: true },
        isSingleBooking: { type: Boolean, default: false }

    },

    methods: {
        showSuccessfulPage: function showSuccessfulPage(bookin_id, booking_number) {
            this.$router.push("/booking-successful/" + bookin_id + '/' + booking_number);
        },
        downloadPDF: function downloadPDF(bookingNumber, bookingId) {
            var booking = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            booking.loadingPdf = true;
            window.open(__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].generateConfirmationPDF(bookingNumber, bookingId));
            booking.loadingPdf = false;
        }
    },

    created: function created() {},


    computed: {
        classes: function classes() {
            return {};
        }
    }
});

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.bookingHistory) ? _c('div', {
    staticClass: "bookings"
  }, [(_vm.$breakpoints.xs) ? [_c('sk-carousel', {
    attrs: {
      "pageMarkers": ""
    }
  }, _vm._l((_vm.bookingHistory), function(booking, index) {
    return _c('div', {
      key: booking.VistaTransactionId + '-' + booking.SessionId,
      staticClass: "slide",
      attrs: {
        "slot": "slides"
      },
      slot: "slides"
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "bookings--header"
    }, [_c('h4', {
      staticClass: "movie-title"
    }, [_vm._v(" " + _vm._s(booking.Movie.title))]), _vm._v(" "), _vm._t("list", [_c('ul', {
      staticClass: "list text-bold--500"
    }, [_c('li', [_vm._v(_vm._s(booking.Movie.rating))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(booking.Movie.runtime_string))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(booking.Movie.genresString))])])]), _vm._v(" "), _c('div', {
      staticClass: "qr-code visible-xs"
    }, [_c('div', {
      staticClass: "qr-code--block"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": booking.Barcode,
        "alt": "QR Code"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "qr-code--ticket-reference"
    }, [_c('span', [_vm._v("Booking reference no " + _vm._s(booking.BookingId))])])])], 2), _vm._v(" "), _c('div', {
      staticClass: "bookings--content"
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm3": ""
      }
    }, [_c('div', {
      staticClass: "bookings-details"
    }, [_c('p', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("Tickets")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(booking.Tickets.length))])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm3": ""
      }
    }, [_c('div', {
      staticClass: "bookings-details"
    }, [_c('p', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("Cinema type")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(booking.MovieSession.experiencesString))])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm3": ""
      }
    }, [_c('div', {
      staticClass: "bookings-details"
    }, [_c('p', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("Seats")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(booking.SeatString))])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm3": ""
      }
    }, [(booking.MovieSession) ? _c('div', {
      staticClass: "bookings-details"
    }, [_c('p', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("Cinema")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(booking.MovieSession.screen_name))])]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm3": ""
      }
    }, [_c('div', {
      staticClass: "bookings-details"
    }, [_c('p', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("Where")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(booking.CinemaName.substring(0, booking.CinemaName.lastIndexOf(" "))))])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm3": ""
      }
    }, [_c('div', {
      staticClass: "bookings-details"
    }, [_c('p', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("When")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(booking.BookingDate.additional.string_long_day_of_week) + " " + _vm._s(booking.BookingDate.additional.string_nth_day) + " " + _vm._s(booking.BookingDate.additional.string_long_month))])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm3": ""
      }
    }, [_c('div', {
      staticClass: "bookings-details"
    }, [_c('p', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("What time")]), _vm._v(" "), _c('p', [_vm._v("Starts " + _vm._s(booking.BookingDate.date.format("h:mm A")) + ", Ends " + _vm._s(booking.EndDate.date.format("h:mm A")))])])]), _vm._v(" "), (booking.Concessions.length > 0) ? _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm2": ""
      }
    }, [_c('div', {
      staticClass: "bookings-details"
    }, [_c('p', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("Your extras")]), _vm._v(" "), _vm._l((booking.Concessions), function(concession) {
      return _c('p', [_vm._v(_vm._s(concession.QuantityBooked) + " x " + _vm._s(concession.Description))])
    })], 2)]) : _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm2": ""
      }
    }), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "sm1": ""
      }
    }, [(_vm.showDownload) ? _c('sk-button', {
      attrs: {
        "secondary": "",
        "loading": booking.loadingPdf
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.downloadPDF(booking.BookingId, booking.BookingNumber, booking)
        }
      }
    }, [_vm._v("Download")]) : _vm._e()], 1), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('p', [_vm._v("* This confirms your booking")]), _vm._v(" "), _c('div', {
      staticClass: "bookings-notification"
    }, [_c('p', [_vm._v("* You can collect your snacks and 3D glasses at the Online Collections Counter")])])])], 1)], 1)]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "bookings--share"
    }, [_c('sk-list', [_c('sk-list-item', [_c('sk-icon', {
      attrs: {
        "download": ""
      }
    })], 1)], 1)], 1)])], 1)], 1)
  }))] : [_c('hr'), _vm._v(" "), _vm._l((_vm.bookingHistory), function(booking, index) {
    return _c('sk-layout', {
      key: booking.VistaTransactionId + '-' + booking.SessionId,
      staticClass: "booking-history-item",
      attrs: {
        "row": "",
        "wrap": "",
        "gutter-30": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm2": ""
      }
    }, [_c('div', {
      staticClass: "bookings--movie-poster"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": booking.Movie.poster,
        "alt": ""
      }
    })])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm10": ""
      }
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "sm8": ""
      }
    }, [_c('div', {
      staticClass: "bookings--header"
    }, [_c('h4', {
      staticClass: "movie-title"
    }, [_vm._v(" " + _vm._s(booking.Movie.title))]), _vm._v(" "), _vm._t("list", [_c('ul', {
      staticClass: "list text-bold--500"
    }, [_c('li', [_vm._v(_vm._s(booking.CinemaName.substring(0, booking.CinemaName.lastIndexOf(" ")))), _c('span', {
      staticClass: "bookings--header-separate"
    }, [_vm._v("|")])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(booking.BookingDate.additional.string_long_day_of_week) + " " + _vm._s(booking.BookingDate.additional.string_nth_day) + " " + _vm._s(booking.BookingDate.additional.string_long_month)), _c('span', {
      staticClass: "bookings--header-separate"
    }, [_vm._v("|")])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(booking.BookingDate.date.format("h:mm A")) + " - " + _vm._s(booking.EndDate.date.format("h:mm A")))])])])], 2), _vm._v(" "), _c('div', {
      staticClass: "bookings--content"
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "sm12": "",
        "md6": ""
      }
    }, [_c('div', {
      staticClass: "h5"
    }, [_c('span', {
      staticClass: "text-bold--500"
    }, [_vm._v("Tickets")]), _vm._v(" "), _c('span', [_vm._v("x " + _vm._s(booking.Tickets.length))])]), _vm._v(" "), _c('div', {
      staticClass: "h5"
    }, [_c('span', {
      staticClass: "text-bold--500"
    }, [_vm._v("Seats")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(booking.SeatString))])]), _vm._v(" "), (booking.MovieSession) ? _c('div', {
      staticClass: "h5"
    }, [_c('span', {
      staticClass: "text-bold--500"
    }, [_vm._v("Cinema")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(booking.MovieSession.screen_name))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "h5"
    }, [_c('span', {
      staticClass: "text-bold--500"
    }, [_vm._v("Cinema type")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(booking.MovieSession.experiencesString))])])]), _vm._v(" "), (booking.Concessions.length > 0 && !_vm.isSingleBooking) ? _c('sk-flex', {
      staticClass: "bookings--content-extras",
      attrs: {
        "sm12": "",
        "md6": ""
      }
    }, [_c('div', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("Your extras")]), _vm._v(" "), _vm._l((booking.Concessions), function(concession) {
      return _c('div', {
        staticClass: "h5"
      }, [_vm._v(_vm._s(concession.QuantityBooked) + " x " + _vm._s(concession.Description))])
    })], 2) : _vm._e(), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    })], 1)], 1)]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "sm4": ""
      }
    }, [_c('p', {
      staticClass: "bookings__ref-title"
    }, [_vm._v("Booking Reference no:")]), _vm._v(" "), _c('p', {
      staticClass: "bookings__ref-number"
    }, [_vm._v(_vm._s(booking.BookingId))]), _vm._v(" "), _c('p', [_vm._v("If you are unable to download or print, use your booking reference number above at the Online Collections Counter to collect your tickets and snacks.")]), _vm._v(" "), _c('p', [_vm._v("Enjoy your movie!")]), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [(_vm.showView) ? _c('sk-flex', {
      attrs: {
        "xs12": "",
        "lg6": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.$breakpoints.mdDown) ? _c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('sk-spacer', {
      attrs: {
        "height": "10"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.showDownload) ? _c('sk-flex', {
      attrs: {
        "xs12": "",
        "lg6": ""
      }
    }, [_c('sk-button', {
      attrs: {
        "block": "",
        "secondary": "",
        "loading": booking.loadingPdf
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.downloadPDF(booking.BookingId, booking.BookingNumber, booking)
        }
      }
    }, [_vm._v("Download")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.bookingHistory[0].Concessions), function(concession, index) {
    return (_vm.isSingleBooking) ? _c('sk-layout', {
      key: concession.ItemId,
      staticClass: "booking-history-item",
      staticStyle: {
        "page-break-before": "always"
      },
      attrs: {
        "row": "",
        "wrap": "",
        "gutter-30": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm2": ""
      }
    }, [_c('div', {
      staticClass: "counter-box counter-box--no-backface"
    }, [_c('div', {
      staticClass: "bookings--movie-poster counter-box__icon",
      class: (concession.Description.toLowerCase().includes('large') ? 'icon--large' : '') || (concession.Description.toLowerCase().includes('small') ? 'icon--small' : '') || (concession.Description.toLowerCase().includes('voucher') ? 'icon--small' : '')
    }, [_c('sk-icon', {
      attrs: {
        "type": (concession.ItemClassCode) ? concession.ItemClassCode : '0014'
      }
    })], 1)])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm10": ""
      }
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "sm8": ""
      }
    }, [_c('div', {
      staticClass: "bookings--header"
    }, [_c('h4', {
      staticClass: "movie-title"
    }, [_vm._v(" " + _vm._s(concession.Description))])]), _vm._v(" "), _c('div', {
      staticClass: "bookings--content"
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "sm8": ""
      }
    }, [_c('div', {
      staticClass: "h5"
    }, [_c('span', {
      staticClass: "text-bold--500"
    }, [_vm._v(" " + _vm._s(concession.QuantityBooked))]), _vm._v(" "), _c('span', [_vm._v("x " + _vm._s(concession.Description))])]), _vm._v(" "), (~concession.Description.toLowerCase().indexOf('3d')) ? _c('p', [_vm._v("*You can collect your snacks and 3D glasses at the Online Collections Counter")]) : (~concession.Description.toLowerCase().indexOf('imax')) ? _c('p', [_vm._v("*You can collect your snacks and IMAX 3D glasses at the Online Collections Counter")]) : _vm._e()])], 1)], 1)]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "sm4": ""
      }
    })], 1)], 1)], 1) : _vm._e()
  })]], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(865),
  /* template */
  __webpack_require__(866),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'points',

    props: {
        userPoints: Number
    },

    data: function data() {
        return {
            loading: false,
            transactions: {},
            activeTab: null

        };
    },
    created: function created() {
        var _this = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].getTransactionHistory().then(function (history) {
            var points = 0;

            _this.transactions = history.sort(function (a, b) {
                return a.TransactionDate.date.diff(b.TransactionDate.date);
            }).reduce(function (col, item) {
                col[item.year] = col[item.year] || [];
                col[item.year].push(item);
                points = points + (item.PointsEarned - item.PointsRedeemed);
                item.pointsTotal = points;

                return col;
            }, {});

            _this.loading = false;
            _this.activeTab = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.transactions)[0];
        });
    },


    computed: {
        activeTabGrouped: function activeTabGrouped() {

            return this.transactions[this.activeTab].reduce(function (col, item) {

                col[item.month] = col[item.month] || [];

                col[item.month].push(item);

                return col;
            }, {});
        }
    }
});

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "points-statement"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-panel', [_vm._t("heading"), _vm._v(" "), (Object.keys(_vm.transactions).length > 0) ? _c('sk-tabs', {
    attrs: {
      "flat": "",
      "size": Object.keys(_vm.transactions).length
    }
  }, [_c('template', {
    slot: "tab-title"
  }, _vm._l((Object.keys(_vm.transactions)), function(tab) {
    return _c('sk-tab', {
      key: tab,
      staticClass: "year-filter",
      class: (_vm.activeTab == tab ? 'active' : ''),
      attrs: {
        "item": tab
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.activeTab = tab
        }
      }
    })
  })), _vm._v(" "), _c('template', {
    slot: "tab-content"
  }, [(_vm.transactions[_vm.activeTab]) ? _c('div', {
    staticClass: "filter-content"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "filter-content--head"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('h5', {
    staticClass: "filter-content--month active-month"
  }, [_vm._v(_vm._s(Object.keys(_vm.activeTabGrouped)[0]))])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sm2": ""
    }
  }, [_c('h5', {
    staticClass: "filter-content--month hidden-xs hidden-sm"
  }, [_vm._v("Movie")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sm2": ""
    }
  }, [_c('h5', {
    staticClass: "filter-content--month hidden-xs hidden-sm"
  }, [_vm._v("Cinema")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sm2": ""
    }
  }, [_c('h5', {
    staticClass: "filter-content--month hidden-xs hidden-sm"
  }, [_vm._v("Points Earned")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sm2": ""
    }
  }, [_c('h5', {
    staticClass: "filter-content--month hidden-xs hidden-sm"
  }, [_vm._v("Points Burnt")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sm2": ""
    }
  }, [_c('h5', {
    staticClass: "filter-content--month hidden-xs hidden-sm"
  }, [_vm._v("Points Total")])])], 1)], 1)]), _vm._v(" "), _vm._l((Object.keys(_vm.activeTabGrouped)), function(month, index) {
    return [(index > 0) ? _c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('h5', {
      staticClass: "filter-content--month active-month"
    }, [_vm._v(_vm._s(month))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeTabGrouped[month]), function(item, index) {
      return (item.PointsEarned != 0 || item.PointsRedeemed != 0) ? _c('sk-flex', {
        key: month + '-' + index,
        attrs: {
          "xs12": ""
        }
      }, [_c('div', {
        staticClass: "filter-content--block"
      }, [(_vm.$breakpoints.smDown) ? _c('sk-layout', {
        attrs: {
          "row": "",
          "wrap": ""
        }
      }, [_c('sk-flex', {
        attrs: {
          "xs2": ""
        }
      }, [_c('div', {
        staticClass: "filter-content--text"
      }, [_vm._v(_vm._s(item.TransactionDate.additional.string_nth_day))])]), _vm._v(" "), _c('sk-flex', {
        attrs: {
          "xs7": ""
        }
      }, [_c('div', {
        staticClass: "filter-content--text"
      }, [_vm._v(_vm._s(item.CinemaName))]), _vm._v(" "), _c('div', {
        staticClass: "filter-content--text"
      }, [_vm._v(_vm._s(item.MovieName || item.ItemName))])]), _vm._v(" "), _c('sk-flex', {
        attrs: {
          "xs3": ""
        }
      }, [_c('div', {
        staticClass: "filter-content--text"
      }, [_c('span', {
        staticClass: "stand-out-text",
        class: (item.PointsEarned - (item.PointsRedeemed || 0)) < 0 ? 'points-burnt' : ''
      }, [_vm._v(_vm._s(item.PointsEarned - (item.PointsRedeemed || 0)) + "\n                                                        ")])]), _vm._v(" "), _c('div', {
        staticClass: "filter-content--text"
      }, [_vm._v(_vm._s(item.pointsTotal))])])], 1) : _c('sk-layout', {
        attrs: {
          "row": "",
          "wrap": ""
        }
      }, [_c('sk-flex', {
        attrs: {
          "xs4": "",
          "sm2": ""
        }
      }, [_c('div', {
        staticClass: "filter-content--text"
      }, [_vm._v(_vm._s(item.TransactionDate.additional.string_nth_day))])]), _vm._v(" "), _c('sk-flex', {
        attrs: {
          "xs4": "",
          "sm2": ""
        }
      }, [_c('div', {
        staticClass: "filter-content--text"
      }, [_vm._v(_vm._s(item.MovieName || item.ItemName))])]), _vm._v(" "), _c('sk-flex', {
        attrs: {
          "xs4": "",
          "sm2": ""
        }
      }, [_c('div', {
        staticClass: "filter-content--text"
      }, [_vm._v(_vm._s(item.CinemaName))])]), _vm._v(" "), _c('sk-flex', {
        attrs: {
          "xs4": "",
          "sm2": ""
        }
      }, [((item.PointsEarned - (item.PointsRedeemed || 0)) > 0) ? _c('div', {
        staticClass: "filter-content--text"
      }, [_c('span', {
        staticClass: "stand-out-text"
      }, [_vm._v(_vm._s((item.PointsEarned - (item.PointsRedeemed || 0))))])]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
        attrs: {
          "xs4": "",
          "sm2": ""
        }
      }, [((item.PointsEarned - (item.PointsRedeemed || 0)) < 0) ? _c('div', {
        staticClass: "filter-content--text"
      }, [_c('span', {
        staticClass: "stand-out-text points-burnt"
      }, [_vm._v(_vm._s((item.PointsEarned - (item.PointsRedeemed || 0))))])]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
        attrs: {
          "xs4": "",
          "sm2": ""
        }
      }, [_c('div', {
        staticClass: "filter-content--text"
      }, [_vm._v(_vm._s(item.pointsTotal))])])], 1)], 1)]) : _vm._e()
    })]
  })], 2)], 1) : _vm._e()])], 2) : (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', {
    staticClass: "form-group__error"
  }, [_vm._v("\n                    No Transactions Found\n                ")]), _vm._v(" "), (Object.keys(_vm.transactions).length > 10) ? _c('div', {
    staticClass: "load-more"
  }, [_c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v(" load more")])], 1) : _vm._e()], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(868),
  /* template */
  __webpack_require__(878),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card_sb4for3_vue__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card_sb4for3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__card_sb4for3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__card_sk_club_vue__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__card_sk_club_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__card_sk_club_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__card_generic_vue__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__card_generic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__card_generic_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'card',
    components: { cardSb: __WEBPACK_IMPORTED_MODULE_0__card_sb4for3_vue___default.a, cardSkClub: __WEBPACK_IMPORTED_MODULE_1__card_sk_club_vue___default.a, cardGeneric: __WEBPACK_IMPORTED_MODULE_2__card_generic_vue___default.a },
    props: {
        path: String,
        title: String,
        cardNumber: String,
        type: String,
        joined: Boolean,
        linked: Boolean,
        loading: { type: Boolean, default: false },
        isDisabled: Boolean,
        disabled: Boolean,
        genericMessage: String,
        activationLink: String,
        moreInfoLink: String
    },
    data: function data() {
        return {
            showConfirmReplaceCard: false
        };
    },


    computed: {
        activated: function activated() {
            return this.linked && this.joined;
        }
    },

    methods: {
        link: function link(cardNumber) {
            this.$emit('link', cardNumber);
        },
        join: function join() {
            this.$emit('join');
        },
        replaceCard: function replaceCard() {}
    }
});

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(870),
  /* template */
  __webpack_require__(871),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardMixin__ = __webpack_require__(83);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'cardSb',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__cardMixin__["a" /* default */]]
});

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-buttons"
  }, [(!_vm.isJoined) ? [_c('div', {
    staticClass: "card-btn__copy"
  }, [_vm._v("\n            Join SK Club now to activate your SK Club\n            Standard Bank 4FOR3 Benefit.\n        ")]), _vm._v(" "), (_vm.moreInfoLink) ? _c('div', {
    staticClass: "card-btn__copy"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "block": "",
      "tag": "a",
      "href": _vm.moreInfoLink,
      "target": "_blank"
    }
  }, [_vm._v("More Info")])], 1) : _vm._e(), _vm._v(" "), (_vm.activationLink) ? _c('div', {
    staticClass: "card-btn__copy"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "block": "",
      "tag": "a",
      "href": _vm.activationLink,
      "target": "_blank"
    }
  }, [_vm._v("Get A\n                Card\n            ")])], 1) : _vm._e()] : (_vm.isJoined && _vm.isLinked) ? [_c('div', {
    staticClass: "membership"
  }, [
    [_vm._v("\n                Book a movie now and get 4 tickets for the price of 3 when paying with any Standard Bank Credit Card.\n            ")]
  ], 2)] : [_c('sk-form', {
    attrs: {
      "id": "link-card-form-sk-club"
    },
    on: {
      "submit": function($event) {
        _vm.onLink(_vm.thisCardNumber)
      }
    }
  }, [(!_vm.isLinked) ? _c('div', {
    staticClass: "card-btn__copy"
  }, [_vm._v("\n                Have a Standard Bank Credit Card? Activate this\n                exclusive benefit by entering your ID number now.\n            ")]) : _vm._e(), _vm._v(" "), [(!_vm.isLinked) ? [_c('div', {
    staticClass: "card-btn__copy"
  }, [_c('sk-input', {
    attrs: {
      "placeholder": "ID Number",
      "required": ""
    },
    model: {
      value: (_vm.thisCardNumber),
      callback: function($$v) {
        _vm.thisCardNumber = $$v
      },
      expression: "thisCardNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-btn__copy"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "block": "",
      "type": "submit",
      "loading": _vm.linking
    }
  }, [_vm._v("\n                            Activate\n                        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-btn__copy"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "block": "",
      "tag": "a",
      "href": "https://www.standardbank.co.za/southafrica/personal/products-and-services/bank-with-us/credit-cards/our-cards",
      "target": "_blank"
    }
  }, [_vm._v("\n                            Get A Card\n                        ")])], 1)] : _vm._e()]], 2)]], 2)
},staticRenderFns: []}

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(873),
  /* template */
  __webpack_require__(874),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cardMixin__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'cardSkClub',

    data: function data() {
        return {
            showReplaceCardError: false,
            showConfirmReplaceCard: false
        };
    },

    methods: {
        replaceCard: function replaceCard(CardNumber) {
            var _this = this;

            this.showReplaceCardError = false;

            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].replaceCard(CardNumber)]).then(function (replaceCard) {
                if (replaceCard != undefined && replaceCard != null) {
                    if (replaceCard[0].replacedCard) {
                        var replacedCard = true;
                        window.localStorage.setItem('skClubReplaceCard', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(replacedCard));
                        location.reload();
                    } else {
                        _this.showReplaceCardError = true;
                    }
                } else {
                    _this.showReplaceCardError = true;
                }
            });
            this.showConfirmReplaceCard = false;
        }
    },
    created: function created() {
        this.showConfirmReplaceCard = false;
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_2__cardMixin__["a" /* default */]]

});

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-buttons"
  }, [(!_vm.isJoined) ? [_c('div', {
    staticClass: "card-btn__copy"
  }, [_vm._v("\n            Not a member yet?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-btn__copy"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onActivate()
      }
    }
  }, [_vm._v("Join")])], 1)] : (_vm.isLinked) ? [_c('div', {
    staticClass: "membership"
  }, [
    [_vm._v("\n                SK Club card number\n                "), _c('div', {
      staticClass: "membership-number"
    }, [_vm._v("\n                    " + _vm._s(_vm.CardNumber) + "\n                ")])], _vm._v(" "), (_vm.CardNumber != null) ? [(!_vm.showConfirmReplaceCard) ? _c('sk-button', {
      attrs: {
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showConfirmReplaceCard = true
        }
      }
    }, [_vm._v("Replace Card")]) : _vm._e(), _vm._v(" "), (_vm.showConfirmReplaceCard) ? _c('div', [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Replace Card")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.CardNumber))]), _vm._v(" "), _c('p', [_vm._v("By replacing this card number your old card number will no longer work and you will receive an email with a new card number.")]), _vm._v(" "), _c('p', [_vm._v("Are you sure you want to replace your card number now?")]), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('sk-button', {
      attrs: {
        "secondary": "",
        "close": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showConfirmReplaceCard = false;
        }
      }
    }, [_vm._v("\n                                Wait, take me back.\n                            ")])], 1)], 1), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('sk-button', {
      attrs: {
        "primary": "",
        "close": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showConfirmReplaceCard = false;
          _vm.replaceCard(_vm.CardNumber);
        }
      }
    }, [_vm._v("\n                                Yes. I'm sure.\n                            ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showReplaceCardError) ? _c('div', [_c('p', [_vm._v("Your card number could not be replaced at the moment. Please try again later.")])]) : _vm._e()] : _vm._e()
  ], 2)] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(876),
  /* template */
  __webpack_require__(877),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardMixin__ = __webpack_require__(83);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'card-discovery',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__cardMixin__["a" /* default */]]

});

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-buttons"
  }, [(_vm.genericMessage) ? _c('div', {
    staticClass: "card-btn__copy",
    domProps: {
      "innerHTML": _vm._s(_vm.genericMessage)
    }
  }, [_vm._v("\n        Join SK Club now to activate your SK Club\n        Standard Bank 4for3 Benefit.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.moreInfoLink) ? _c('div', {
    staticClass: "card-btn__copy"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "block": "",
      "tag": "a",
      "href": _vm.moreInfoLink,
      "target": "_blank"
    }
  }, [_vm._v("More Info")])], 1) : _vm._e(), _vm._v(" "), (_vm.activationLink) ? _c('div', {
    staticClass: "card-btn__copy"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "block": "",
      "tag": "a",
      "href": _vm.activationLink,
      "target": "_blank"
    }
  }, [_vm._v("Activate\n        ")])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h6', {
    staticClass: "card-content--name hidden-xs"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "card-content--img",
    class: (_vm.activated || _vm.type == 'generic') ? '' : 'card--disabled',
    staticStyle: {
      "background": "none"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.path,
      "alt": ""
    }
  })]), _vm._v(" "), _c('h6', {
    staticClass: "card-content--name visible-xs"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), [_c(("card-" + _vm.type), {
    tag: "component",
    attrs: {
      "activationLink": _vm.activationLink,
      "moreInfoLink": _vm.moreInfoLink,
      "disabled": _vm.disabled,
      "genericMessage": _vm.genericMessage,
      "isJoined": _vm.joined,
      "isLinked": _vm.linked,
      "CardNumber": _vm.cardNumber,
      "onLink": _vm.link,
      "onActivate": _vm.join,
      "linking": _vm.loading
    }
  })]], 2)], 1), _vm._v(" "), (false) ? [_c('div', {
    staticClass: "card"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h6', {
    staticClass: "card-content--name hidden-xs"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "card-content--img",
    class: _vm.activated ? '' : 'card--disabled',
    staticStyle: {
      "background": "none"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.path,
      "alt": ""
    }
  })]), _vm._v(" "), _c('h6', {
    staticClass: "card-content--name visible-xs"
  }, [_vm._v(_vm._s(_vm.title))])])])], 1), _vm._v(" "), (_vm.loading) ? _c('sk-layout', {
    staticClass: "loader"
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "50",
      "width": 2,
      "primary": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  })], 1) : _c('div', {
    staticClass: "card-buttons"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.activated && _vm.joined && _vm.linked) ? _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "membership"
  }, [(_vm.type == 'skClub') ? [_vm._v("\n                                        SK Club card number\n                                        "), _c('div', {
    staticClass: "membership-number"
  }, [_vm._v("\n                                            " + _vm._s(_vm.CardNumber) + "\n                                        ")])] : _vm._e(), _vm._v(" "), (_vm.type == 'sb') ? [_vm._v("\n                                        Book a movie now and get 4 tickets for the price of 3 when paying with any Standard Bank Credit Card.\n                                    ")] : _vm._e()], 2)]) : [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.joined) ? [_c('div', {
    staticClass: "card-btn__copy"
  }, [(_vm.type == 'skClub') ? [_vm._v("Not a member yet?")] : _vm._e(), _vm._v(" "), (_vm.type == 'sb') ? [_vm._v("Join SK Club now to activate your SK Club\n                                                Standard Bank 4for3 Benefit.\n                                            ")] : _vm._e(), _vm._v(" "), (_vm.type == 'vitality') ? [_vm._v("Need a Discovery Vitality SK digital\n                                                movie card?\n                                            ")] : _vm._e(), _vm._v(" "), (_vm.type == 'edgarsClub') ? [_vm._v("Get movie benefits with Edgars\n                                                Club.\n                                            ")] : _vm._e()], 2)] : [_c('div', {
    staticClass: "card-btn__copy"
  }, [(_vm.type == 'sb') ? [_vm._v("\n                                                Have a Standard Bank Credit Card? Activate this\n                                                exclusive benefit by entering your ID number now.\n                                            ")] : _vm._e()], 2)]], 2), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.type != 'sb') ? _c('div', {
    staticClass: "card-button"
  }, [(!_vm.activated && _vm.type == 'vitality' && !_vm.CardNumber) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "block": "",
      "router": "",
      "to": {
        path: '/club-loyalty/Discovery_Vitality#discovery-form'
      }
    }
  }, [_vm._v("Activate Vitality Benefit\n                                        ")]) : _vm._e(), _vm._v(" "), (!_vm.activated && _vm.type == 'edgarsClub' && !_vm.CardNumber) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "block": "",
      "router": "",
      "to": {
        path: '/club-loyalty/Edgars_Club'
      }
    }
  }, [_vm._v("More\n                                            Info\n                                        ")]) : _vm._e(), _vm._v(" "), (!_vm.joined && _vm.type == 'skClub') ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.join()
      }
    }
  }, [_vm._v("Join\n                                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.joined && _vm.activated && _vm.type == 'sb') ? [_c('div', {
    staticClass: "card-button"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.getSBCard()
      }
    }
  }, [_vm._v("Get a Card\n                                            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-button"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sbMoreInfo()
      }
    }
  }, [_vm._v("More info\n                                            ")])], 1)] : _vm._e(), _vm._v(" "), (_vm.type == 'sb' && !_vm.activated && _vm.joined) ? [_c('div', {
    staticClass: "card-button"
  }, [(_vm.sbShowActivate && !_vm.activated && _vm.type == 'sb') ? _c('sk-input', {
    attrs: {
      "type": "number",
      "placeholder": "ID number",
      "required": "",
      "idNumber": ""
    },
    model: {
      value: (_vm.IdNumber),
      callback: function($$v) {
        _vm.IdNumber = $$v
      },
      expression: "IdNumber"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.sbShowActivate) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sbShowActivateInput()
      }
    }
  }, [_vm._v("\n                                                Activate\n                                            ")]) : _c('sk-button', {
    attrs: {
      "primary": "",
      "block": "",
      "loading": _vm.activating
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.link($event)
      }
    }
  }, [_vm._v("\n                                                Activate Now\n                                            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-button"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sbMoreInfo()
      }
    }
  }, [_vm._v("More info\n                                            ")])], 1)] : _vm._e()], 2)]], 2), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.linkedActive) ? _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.activated && _vm.type == 'skClub') ? _c('sk-input', {
    attrs: {
      "placeholder": "Card Number"
    },
    model: {
      value: (_vm.CardNumber),
      callback: function($$v) {
        _vm.CardNumber = $$v
      },
      expression: "CardNumber"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.activated && _vm.type == 'sb') ? _c('sk-input', {
    attrs: {
      "type": "number",
      "placeholder": "ID number",
      "required": "",
      "idNumber": ""
    },
    model: {
      value: (_vm.IdNumber),
      callback: function($$v) {
        _vm.IdNumber = $$v
      },
      expression: "IdNumber"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.joined) ? [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.type == 'skClub') ? _c('div', {
    staticClass: "card-btn__copy"
  }, [_vm._v("Haven't linked your\n                                        " + _vm._s(_vm.title) + " Movie Card yet?\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "card-button"
  }, [(_vm.type == 'sb') ? [_c('sk-button', {
    attrs: {
      "primary": "",
      "block": "",
      "loading": _vm.activating
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.link($event)
      }
    }
  }, [(_vm.idNumber == undefined) ? [_vm._v("\n                                                    Activate\n                                                ")] : [_vm._v("\n                                                    Activate Now\n                                                ")]], 2)] : _vm._e(), _vm._v(" "), (_vm.type == 'sb') ? [_c('sk-spacer', {
    attrs: {
      "height": "10"
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "secondary": "",
      "block": "",
      "tag": "a",
      "href": "https://www.standardbank.co.za/standardbank/About-Us/Your-next-million/apply%20here",
      "target": "_blank"
    }
  }, [_vm._v("Get a Card\n                                            ")])] : _vm._e()], 2)])] : _vm._e()], 2)], 1)], 1)], 1)], 1)] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(880),
  /* template */
  __webpack_require__(881),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_model__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hasta_la_vista_ui_core__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'profile-toolbar',

    props: {
        active: Boolean,
        guest: true,
        user: null
    },

    methods: {
        signOut: function signOut() {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_3_hasta_la_vista_middleware_api_service__["b" /* AuthService */].signOut()]).then(function (_ref) {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
                    result = _ref2[0];
            }, function (error) {
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
            });
        },
        setUser: function setUser() {}
    }
});

/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((_vm.$breakpoints.md || _vm.$breakpoints.lg || _vm.$breakpoints.lgUp) && _vm.user) ? _c('div', {
    staticClass: "profile-toolbar",
    attrs: {
      "context": "Profile Toolbar"
    }
  }, [(_vm.guest) ? [_c('ul', {
    staticClass: "member-login"
  }, [_c('li', [_c('sk-button', {
    attrs: {
      "small": "",
      "tag": "a",
      "href": "/user/signup",
      "tertiary": ""
    }
  }, [_vm._v("Create a profile")])], 1), _vm._v(" "), _c('li', [_c('sk-button', {
    attrs: {
      "small": "",
      "tag": "a",
      "href": "/user/login",
      "secondary": ""
    }
  }, [_vm._v("Sign in")])], 1)])] : [_c('div', {
    staticClass: "member-login"
  }, [(_vm.user.MemberLevelId != 19 && _vm.$breakpoints.lgUp) ? _c('span', {
    staticClass: "points-balance"
  }, [((_vm.$breakpoints.xs || _vm.$breakpoints.sm)) ? _c('h5', {
    staticClass: "points-balance__name"
  }, [_vm._v(_vm._s(_vm.user.FullName))]) : _vm._e(), _vm._v(" "), (_vm.$breakpoints.lgUp) ? [_c('span', {
    staticClass: "points"
  }, [_vm._v(_vm._s(_vm.user.PointsBalance))]), _vm._v(" POINTS\n            ")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), ((_vm.$breakpoints.md || _vm.$breakpoints.lg || _vm.$breakpoints.lgUp)) ? [_c('sk-accordian', {
    attrs: {
      "select": "true",
      "active": _vm.active,
      "click-outside": "true"
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('div', [_vm._v(_vm._s(_vm.user.FullName))])]), _vm._v(" "), _c('template', {
    slot: "content"
  }, [_c('ul', {
    staticClass: "profile-items"
  }, [(_vm.$breakpoints.mdDown) ? _c('li', {
    staticClass: "points-balance in-dropdown"
  }, [_c('span', {
    staticClass: "points"
  }, [_vm._v(_vm._s(_vm.user.PointsBalance))]), _vm._v(" POINTS\n                    ")]) : _vm._e(), _vm._v(" "), _c('li', [_c('sk-button', {
    attrs: {
      "link": "",
      "tag": "a",
      "to": "/user/profile"
    }
  }, [_vm._v("My Dashboard")])], 1), _vm._v(" "), _c('li', [_c('sk-button', {
    attrs: {
      "link": "",
      "tag": "a"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.signOut()
      }
    }
  }, [_vm._v("Sign Out")])], 1)])])], 2)] : _vm._e()], 2)]], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(883),
  /* template */
  __webpack_require__(884),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_ui_core__);



/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		signUp: Boolean
	},
	data: function data() {
		return {
			loading: false,
			username: null,
			password: null,
			isGuest: true,
			signUpChange: this.signUp
		};
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["b" /* AuthService */].addObserver(this, __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["b" /* AuthService */].PROFILE_CHANGED, this.checkUser);
		this.checkUser();
	},


	methods: {
		checkUser: function checkUser() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["b" /* AuthService */].user().then(function (user) {
				return _this.isGuest = user.isGuest();
			});
		},


		login: function login() {
			var _this2 = this;

			this.loading = true;

			__WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["b" /* AuthService */].signIn(this.username, this.password).then(function (user) {
				_this2.loading = false;
				window.scroll({ top: 0, left: 0 });
			}, function (error) {
				_this2.loading = false;
			});
		},

		toggleSignUp: function toggleSignUp() {
			if (this.signUp) {
				this.signUpChange = false;
			} else {
				this.signUpChange = true;
			}
		}
	},

	watch: {
		signUpChange: {

			handler: __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_ui_core__["Utils"].debounce(function () {
				this.$emit('changed', [this.signUpChange]);
				this.loading = false;
			}, 300),
			deep: true
		}
	}
});

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isGuest) ? _c('div', {
    staticClass: "sign-in"
  }, [_c('sk-panel', [_c('sk-form', {
    attrs: {
      "inline": ""
    }
  }, [_c('h3', {
    staticClass: "sign-in__heading"
  }, [_vm._v("Sign in for a personalised experience")]), _vm._v(" "), _c('sk-input', {
    attrs: {
      "light": "",
      "placeholder": "Email",
      "name": "email",
      "type": "email",
      "error-message": {
        valueMissing: 'Please enter your email address'
      }
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "light": "",
      "type": "password",
      "placeholder": "Password",
      "error-message": {
        valueMissing: 'Please enter your password.'
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.login()
      }
    }
  }, [_vm._v("Sign in")])], 1), _vm._v(" "), _c('p', [_vm._v("Haven't created an SK profile yet? Create one now to customise your movie preferences and enjoy quick bookings. "), _c('sk-button', {
    attrs: {
      "small": "",
      "link": "",
      "router": "",
      "to": {
        path: '/user/signup'
      }
    }
  }, [_vm._v("Create a profile")])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "no-gutter": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs10": "",
      "lg7": ""
    }
  }), _vm._v(" "), _c('sk-spacer')], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(886),
  /* template */
  __webpack_require__(887),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'badge',

    props: {
        red: Boolean,
        orange: Boolean,
        green: Boolean,
        purple: Boolean,
        secondaryIcon: Boolean,
        points: Number,
        label: String,
        icon: String,
        color: String,
        small: Boolean,
        noBackface: Boolean,
        grey: String
    },

    computed: {
        classes: function classes() {
            return {
                'red': this.red || this.color == 'red',
                'grey': this.grey || this.colour == 'grey',
                'orange': this.orange || this.color == 'orange',
                'green': this.green || this.color == 'green',
                'purple': this.purple || this.color == 'purple',
                'yellow': this.purple || this.color == 'yellow',
                'secondary-icon': this.secondaryIcon,
                'badge--small': this.small,
                'badge--no-backface': this.noBackface
            };
        }
    }
});

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "badge",
    class: _vm.classes
  }, [_c('div', {
    class: {
      badge__icon: true, 'badge__icon--no-backface': _vm.noBackface
    }
  }, [_vm._t("front", [_c('sk-icon', {
    class: _vm.icon
  })]), _vm._v(" "), (!_vm.noBackface) ? _c('span', {
    staticClass: "badge__back"
  }, [_vm._t("back", [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Redeem now")])])], 2) : _vm._e()], 2), _vm._v(" "), _c('h6', {
    staticClass: "badge__points"
  }, [_vm._t("points")], 2), _vm._v(" "), _c('p', {
    staticClass: "badge__text"
  }, [_vm._t("text")], 2)])
},staticRenderFns: []}

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(889),
  /* template */
  __webpack_require__(890),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		percentage: Number,
		toGo: Number,
		isVip: Boolean
	},
	data: function data() {
		return {
			monthsLeft: 11 - new Date().getMonth()
		};
	},
	created: function created() {
		this.pe;
	}
});

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile__tiers"
  }, [(!_vm.isVip) ? [_c('h5', [_vm._v("You can do it!")]), _vm._v(" "), _c('h5', {
    staticClass: "profile__tiers-copy"
  }, [_vm._v("Watch 15 movies to reach VIP Status.")])] : [_c('h5', [_vm._v("You did it!")]), _vm._v(" "), _c('h5', {
    staticClass: "profile__tiers-copy"
  }, [_vm._v("You have reached VIP Status.")])], _vm._v(" "), _c('div', {
    staticClass: "profile__tiers-circle"
  }, [_c('sk-progress-circular', {
    attrs: {
      "secondary": _vm.isVip,
      "primary": !_vm.isVip,
      "rotate": -90,
      "value": _vm.isVip ? 100 : _vm.percentage,
      "size": 230,
      "width": 20
    }
  }), _vm._v(" "), (!_vm.isVip) ? _c('h5', {
    staticClass: "profile__tiers-circle-copy"
  }, [_c('h1', {
    staticClass: "profile__tiers-circle-number"
  }, [_vm._v(_vm._s(_vm.toGo))]), _vm._v(" Movies to go")]) : _c('h1', {
    staticClass: "profile__tiers-circle-copy"
  }, [_vm._v("VIP")])], 1), _vm._v(" "), (!_vm.isVip) ? _c('h5', {
    staticClass: "profile__tiers-copy"
  }, [_vm._v(_vm._s(_vm.monthsLeft) + " Months left to watch")]) : _c('h5', {
    staticClass: "profile__tiers-copy"
  }, [_vm._v("Watch " + _vm._s(_vm.toGo < 0 && _vm.toGo > (-15) ? 15 + _vm.toGo : 15) + " movies in the next 12 months to stay on VIP.")])], 2)
},staticRenderFns: []}

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__club_loyalty_listing_club_loyalty_listing_vue__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__club_loyalty_listing_club_loyalty_listing_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__club_loyalty_listing_club_loyalty_listing_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__club_loyalty_detail_club_loyalty_detail_vue__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__club_loyalty_detail_club_loyalty_detail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__club_loyalty_detail_club_loyalty_detail_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ClubLoyaltyListing", function() { return __WEBPACK_IMPORTED_MODULE_0__club_loyalty_listing_club_loyalty_listing_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ClubLoyaltyDetail", function() { return __WEBPACK_IMPORTED_MODULE_1__club_loyalty_detail_club_loyalty_detail_vue___default.a; });





/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(893),
  /* template */
  __webpack_require__(894),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},

  data: function data() {
    return {};
  }
});

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', {
    staticClass: "card-name"
  }, [_vm._v("card name")])])], 1), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "club-card"
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('h2', {
    staticClass: "card-title"
  }, [_vm._v("What is Sk Club")]), _vm._v(" "), _c('p', {
    staticClass: "card-teaser"
  }, [_vm._v("Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptas, deserunt esse? Adipisci est ipsum provident voluptas asperiores id eius a, voluptate quod, recusandae rem. Quaerat quibusdam consequatur voluptatem voluptas exercitationem?")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("get more info")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(896),
  /* template */
  __webpack_require__(897),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    timer: null
  },

  data: function data() {
    return {};
  }
});

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', {
    staticClass: "card-name"
  }, [_vm._v("card name")])])], 1), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('h2', {
    staticClass: "card-title"
  }, [_vm._v("What is Sk Club")]), _vm._v(" "), _c('p', {
    staticClass: "card-teaser"
  }, [_vm._v("Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptas, deserunt esse? Adipisci est ipsum provident voluptas asperiores id eius a, voluptate quod, recusandae rem. Quaerat quibusdam consequatur voluptatem voluptas exercitationem?")]), _vm._v(" "), _c('sk-input'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("get more info")])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "club-card"
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_info_right_image_static_info_right_image_vue__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_info_right_image_static_info_right_image_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_info_right_image_static_info_right_image_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_info_left_image_static_info_left_image_vue__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_info_left_image_static_info_left_image_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_info_left_image_static_info_left_image_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__featured_movie_card_featured_movie_card_vue__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__featured_movie_card_featured_movie_card_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__featured_movie_card_featured_movie_card_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__featured_club_card_featured_club_card_vue__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__featured_club_card_featured_club_card_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__featured_club_card_featured_club_card_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__featured_points_earned_featured_points_earned_vue__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__featured_points_earned_featured_points_earned_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__featured_points_earned_featured_points_earned_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__featured_points_burned_featured_points_burned_vue__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__featured_points_burned_featured_points_burned_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__featured_points_burned_featured_points_burned_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "StaticInfoRightImage", function() { return __WEBPACK_IMPORTED_MODULE_0__static_info_right_image_static_info_right_image_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "StaticInfoLeftImage", function() { return __WEBPACK_IMPORTED_MODULE_1__static_info_left_image_static_info_left_image_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FeaturedMovieCard", function() { return __WEBPACK_IMPORTED_MODULE_2__featured_movie_card_featured_movie_card_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FeaturedClubCard", function() { return __WEBPACK_IMPORTED_MODULE_3__featured_club_card_featured_club_card_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FeaturedPointsEarned", function() { return __WEBPACK_IMPORTED_MODULE_4__featured_points_earned_featured_points_earned_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FeaturedPointsBurned", function() { return __WEBPACK_IMPORTED_MODULE_5__featured_points_burned_featured_points_burned_vue___default.a; });









/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(900),
  /* template */
  __webpack_require__(901),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
   props: {
      staticTitle: {
         type: String,
         default: 'Overview'
      },
      staticSubTitle: String,
      staticCopy: String,
      buttonsGroup: Boolean,
      staticImage: Boolean
   },

   data: function data() {
      return {};
   }
});

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', {
    staticClass: "static-info--title"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.staticTitle) + "\n\t\t")])])], 1), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs8": ""
    }
  }, [(_vm.staticSubTitle) ? _c('h3', {
    staticClass: "static-info--sub-title"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.staticSubTitle) + "\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "static-info--teaser"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.staticCopy) + "\n\t\t\t\t\n\t\t\t")]), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.buttonsGroup) ? [_c('sk-button', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("Download Nda Document")])] : _vm._e()], 2), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [(_vm.staticImage) ? [_c('div', {
    staticClass: "static-info--image"
  })] : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(903),
  /* template */
  __webpack_require__(904),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
   props: {
      staticTitle: {
         type: String,
         default: 'Overview'
      },
      staticSubTitle: String,
      staticCopy: String,
      buttonsGroup: Boolean,
      staticImage: Boolean
   },

   data: function data() {
      return {};
   }
});

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', {
    staticClass: "static-info--title"
  }, [_vm._v("\n        " + _vm._s(_vm.staticTitle) + "\n      ")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [(_vm.staticImage) ? [_c('div', {
    staticClass: "static-info--image"
  })] : _vm._e()], 2), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [(_vm.staticSubTitle) ? _c('h3', {
    staticClass: "static-info--sub-title"
  }, [_vm._v("\n        " + _vm._s(_vm.staticSubTitle) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show"
    }],
    staticClass: "static-info--teaser",
    attrs: {
      "staticCopy": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.staticCopy) + "\n\n      ")]), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.buttonsGroup) ? [_c('sk-button', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("Dowload Nda Document")])] : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(906),
  /* template */
  __webpack_require__(907),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},

  data: function data() {
    return {};
  }
});

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "movie-card"
  }, [_c('h5', [_vm._t("card-name")], 2), _vm._v(" "), _c('div', {
    staticClass: "movie-card--image"
  }), _vm._v(" "), _c('p', {
    staticClass: "movie-card--description"
  }, [_vm._v("\n                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n                    "), _c('sk-button', {
    attrs: {
      "link": "",
      "small": ""
    }
  }, [_vm._v("Read more")])], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(909),
  /* template */
  __webpack_require__(910),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    buttons: Boolean
  },

  data: function data() {
    return {};
  }
});

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "featured-club-card"
  }, [_c('h5', [_vm._t("club-card-name")], 2), _vm._v(" "), _c('div', {
    staticClass: "featured-club-card--image"
  }), _vm._v(" "), _c('h3', [_vm._t("club-card-titte")], 2), _vm._v(" "), _c('p', {
    staticClass: "featured-club-card--description"
  }, [_vm._t("club-card-description")], 2), _vm._v(" "), (_vm.buttons) ? [_c('sk-button', {
    attrs: {
      "tertiary": ""
    }
  }, [_vm._v("More Info")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("activate")])] : _vm._e()], 2)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(912),
  /* template */
  __webpack_require__(913),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},

  data: function data() {

    return {
      darkBackground: true
    };
  }
});

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "points-earned",
    class: {
      darkBackground: _vm.darkBackground
    }
  }, [_c('div', [_c('sk-icon', {
    class: _vm.icon
  })], 1), _vm._v(" "), _c('h2', [_vm._t("points")], 2), _vm._v(" "), _c('span', [_vm._v("Points")]), _vm._v(" "), _c('p', [_vm._t("description")], 2)])
},staticRenderFns: []}

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(915),
  /* template */
  __webpack_require__(916),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},

  data: function data() {
    return {};
  }
});

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "points-burned"
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Points")]), _vm._v(" "), _c('p', [_vm._t("description")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i')])
}]}

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__all_all_vue__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__all_all_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__all_all_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bundles_bundles_vue__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bundles_bundles_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__bundles_bundles_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__combos_combos_vue__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__combos_combos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__combos_combos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickets_tickets_vue__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickets_tickets_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tickets_tickets_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "All", function() { return __WEBPACK_IMPORTED_MODULE_0__all_all_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Bundles", function() { return __WEBPACK_IMPORTED_MODULE_1__bundles_bundles_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Combos", function() { return __WEBPACK_IMPORTED_MODULE_2__combos_combos_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Tickets", function() { return __WEBPACK_IMPORTED_MODULE_3__tickets_tickets_vue___default.a; });







/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(919),
  /* template */
  __webpack_require__(920),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'all',
    created: function created() {}
});

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-static-info-right-image', [_c('h2', {
    staticClass: "static-info--name",
    attrs: {
      "slot": "static-name"
    },
    slot: "static-name"
  }, [_vm._v("All")])]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-divider')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(922),
  /* template */
  __webpack_require__(923),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'bundles',
    created: function created() {}
});

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-static-info-right-image', [_c('h2', {
    staticClass: "static-info--name",
    attrs: {
      "slot": "static-name"
    },
    slot: "static-name"
  }, [_vm._v("Bundles")])]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-divider')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(925),
  /* template */
  __webpack_require__(926),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'combos',
    created: function created() {}
});

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-static-info-right-image', [_c('h2', {
    staticClass: "static-info--name",
    attrs: {
      "slot": "static-name"
    },
    slot: "static-name"
  }, [_vm._v("Combos")])]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-divider')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(928),
  /* template */
  __webpack_require__(929),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'tickets',
    created: function created() {}
});

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-static-info-right-image', [_c('h2', {
    staticClass: "static-info--name",
    attrs: {
      "slot": "static-name"
    },
    slot: "static-name"
  }, [_vm._v("Tickets")])]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-divider')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__archive_archive_vue__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__archive_archive_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__archive_archive_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__business_code_ethics_business_code_ethics_vue__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__business_code_ethics_business_code_ethics_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__business_code_ethics_business_code_ethics_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tender_invitation_tender_invitation_vue__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tender_invitation_tender_invitation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__tender_invitation_tender_invitation_vue__);
/* unused harmony reexport Archive */
/* unused harmony reexport BusinessCodeEthics */
/* unused harmony reexport TenderInvitation */






/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(932),
  /* template */
  __webpack_require__(933),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'archive',
    data: function data() {
        return {
            title: 'Archive',
            subTitle: 'hello i am sub ',
            staticCopy: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. At accusamus neque, illo velit officia aperiam magnam! Facere',
            buttonsGroup: Boolean,
            staticImage: Boolean
        };
    },
    created: function created() {
        var _this = this;

        if (this.$breakpoints.xs || this.$breakpoints.sm) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
                if (_this.$parent.$el != undefined) window.scroll({ top: _this.$parent.$el.offsetTop - 100, left: 0, behavior: 'smooth' });
            });
        }
    }
});

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-static-info-right-image', {
    attrs: {
      "static-title": _vm.title
    }
  }), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr')])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(935),
  /* template */
  __webpack_require__(936),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      page: [],
      loading: true
    };
  },
  created: function created() {
    this.getContent();
  },


  methods: {
    getContent: function getContent() {
      var _this = this;

      this.loading = true;
      if (this.$breakpoints.xs || this.$breakpoints.sm) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
          if (_this.$parent.$el != undefined) window.scroll({ top: _this.$parent.$el.offsetTop - 100, left: 0, behavior: 'smooth' });
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getGeneralPage("Procurement_Content").then(function (content) {
        _this.page = content[0].Procurement_Content.Business_Code_Of_Ethics;

        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-container', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1)])], 1), _vm._v(" "), _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_1.body)
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.page.section_1.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.page.section_1.image
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('hr')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(938),
  /* template */
  __webpack_require__(939),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      page: [],
      procurement: [],
      loading: true
    };
  },
  created: function created() {
    this.getContent();
  },


  methods: {
    getContent: function getContent() {
      var _this = this;

      this.loading = true;
      if (this.$breakpoints.xs || this.$breakpoints.sm) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].nextTick(function () {
          if (_this.$parent.$el != undefined) window.scroll({ top: _this.$parent.$el.offsetTop - 100, left: 0, behavior: 'smooth' });
        });
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["l" /* PageService */].getGeneralPage("Procurement_Content"), __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_middleware_api_service__["l" /* PageService */].getProcurement()]).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            pageContent = _ref2[0],
            procurement = _ref2[1];

        _this.page = pageContent[0].Procurement_Content.Procurement_Content;
        _this.procurement = procurement.data;
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-container', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "static-info--heading"
  }, [_vm._v("Tender Bulletin")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_1.body)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__buttons"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.page.section_1.button_link
    }
  }, [_vm._v(_vm._s(_vm.page.section_1.button_text))]), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": "10"
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.page.section_1.additional_button_link
    }
  }, [_vm._v(_vm._s(_vm.page.section_1.additional_button_text))])], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.page.section_1.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.page.section_1.image
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.procurement), function(procurement, index) {
    return _c('sk-layout', {
      key: index,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('h3', {
      staticClass: "static-info--heading"
    }, [_vm._v("Tender Invitation")])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Tender number")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.tender_number))])]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Tender publication date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.tender_publication_date))])]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Tender description")]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(procurement.tender_description)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Sk Procurement representive")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.representative_name))]), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.representative_phone))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.representative_email))])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Date of modification of tender invitation")]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(procurement.modification_date)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Tender collection time")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.tender_collection_time))])]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Physical Address for tender response")]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(procurement.physical_address)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Special conditions (if any)")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.special_conditions))])])])], 1)
  })], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__careers_opportunities_careers_opportunities_vue__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__careers_opportunities_careers_opportunities_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__careers_opportunities_careers_opportunities_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__working_at_ster_kinekor_working_at_ster_kinekor_vue__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__working_at_ster_kinekor_working_at_ster_kinekor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__working_at_ster_kinekor_working_at_ster_kinekor_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CareersOpportunities", function() { return __WEBPACK_IMPORTED_MODULE_0__careers_opportunities_careers_opportunities_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "WorkingAtSterKinekor", function() { return __WEBPACK_IMPORTED_MODULE_1__working_at_ster_kinekor_working_at_ster_kinekor_vue___default.a; });





/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(942),
  /* template */
  __webpack_require__(943),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'career-opportunities',
  data: function data() {
    return {
      careers: [],
      loading: true
    };
  },

  methods: {
    getContent: function getContent() {
      var _this = this;

      this.loading = true;
      if (this.$breakpoints.xs || this.$breakpoints.sm) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
          if (_this.$parent.$el != undefined) window.scroll({ top: _this.$parent.$el.offsetTop - 100, left: 0, behavior: 'smooth' });
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getGeneralPage("Careers").then(function (careers) {
        _this.careers = careers[0].Careers.Career_Opportunities;
        _this.loading = false;
      });
    }
  },
  created: function created() {
    this.getContent();
  }
});

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-container', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.careers.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.careers.section_1.body)
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "inline-block": "",
      "tag": "a",
      "href": _vm.careers.section_1.button_link
    }
  }, [_vm._v(_vm._s(_vm.careers.section_1.button_text))])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.careers.section_1.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.careers.section_1.image
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), (_vm.careers.section_2.heading) ? [_c('hr'), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.careers.section_2.heading) ? _c('h3', {
    staticClass: "article__video-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.careers.section_2.heading)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.careers.section_2.body) ? _c('p', {
    staticClass: "article__video-content",
    domProps: {
      "innerHTML": _vm._s(_vm.careers.section_2.body)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.careers.section_2.video_link) ? _c('div', {
    staticClass: "article__feature embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    attrs: {
      "src": ("" + (_vm.careers.section_2.video_link)),
      "frameborder": "0",
      "gesture": "media",
      "allow": "encrypted-media",
      "allowfullscreen": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('sk-button', {
    staticClass: "article__video-button",
    attrs: {
      "inline-block": "",
      "primary": "",
      "tag": "a",
      "href": _vm.careers.section_2.button_link
    }
  }, [_vm._v(_vm._s(_vm.careers.section_2.button_text))])], 1)], 1)] : _vm._e()]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(945),
  /* template */
  __webpack_require__(946),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'working-at-ster-kinekor',
  data: function data() {
    return {
      careers: [],
      loading: true
    };
  },


  methods: {
    getContent: function getContent() {
      var _this = this;

      this.loading = true;
      if (this.$breakpoints.xs || this.$breakpoints.sm) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
          if (_this.$parent.$el != undefined) window.scroll({ top: _this.$parent.$el.offsetTop - 100, left: 0, behavior: 'smooth' });
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_hasta_la_vista_middleware_api_service__["l" /* PageService */].getGeneralPage("Careers").then(function (careers) {
        _this.careers = careers[0].Careers.Working_At_Ster_Kinekor;
        _this.loading = false;
      });
    }
  },

  created: function created() {
    this.getContent();
  }
});

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-container', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.careers.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.careers.section_1.body)
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.careers.section_1.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.careers.section_1.image
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.careers.section_2.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.careers.section_2.body)
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.careers.section_2.button_link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.careers.section_2.button_text))])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.careers.section_2.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.careers.section_2.image
    }
  })]) : _vm._e()])])], 1)]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__performance_info_performance_info_vue__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__performance_info_performance_info_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__performance_info_performance_info_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__performance_info_main_performance_info_main_vue__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__performance_info_main_performance_info_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__performance_info_main_performance_info_main_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PerformanceInfo", function() { return __WEBPACK_IMPORTED_MODULE_0__performance_info_performance_info_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PerformanceInfoMain", function() { return __WEBPACK_IMPORTED_MODULE_1__performance_info_main_performance_info_main_vue___default.a; });





/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(949),
  /* template */
  __webpack_require__(950),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({

    props: {
        order: Object,
        session: Object,
        cinema: Object,
        activeOrder: Boolean,
        index: null
    },

    data: function data() {
        return {
            movie: {},
            expanded: false,
            seeBtn: 'See more',
            toggleDeleteDialog: false,
            deleteId: null,
            showWarning: false,
            loading: false,
            loadingDelete: false,
            currency: "R"
        };
    },


    methods: {
        promtDelete: function promtDelete(deleteId) {
            this.toggleDeleteDialog = true;
            this.deleteId = deleteId;
        },
        cancelDelete: function cancelDelete() {
            this.toggleDeleteDialog = false;

            this.deleteId = null;
        },
        confirmDelete: function confirmDelete() {
            var _this = this;

            this.loadingDelete = true;
            this.toggleDeleteDialog = false;

            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].removeSession(this.session.SessionId).then(function (cancelled) {
                _this.loadingDelete = false;
                _this.$emit('closeDialog');
            });
        },
        setBasketItem: function setBasketItem() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].setPendingSession(this.session.SessionId, this.session.CinemaId, this.movie.id);
            if (!this.order.Session.SeatGridPromise) this.order.Session.getSeatGrid();
            setTimeout(function () {
                _this2.order._loading = false;
                if (_this2.$route.path != '/booking/1') {
                    _this2.$router.push({ path: '/booking/1' });
                }
            }, 100);
        },
        editBasketItem: function editBasketItem(index) {
            var _this3 = this;

            if (this.order.Session.Tickets.length == 0) return this.showWarning = true;
            this.order._loading = true;
            this.$emit('closeDialog');
            if (this.order.modified) {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].saveTickets().then(function (order) {
                    _this3.order.setOrder(order);
                    _this3.loading = false;
                    _this3.setBasketItem();
                }, function () {
                    return _this3.loading = false;
                });
            } else {
                this.setBasketItem();
            }
        },
        expandTickets: function expandTickets() {
            if (this.expanded) {
                this.seeBtn = 'See more';
                this.expanded = false;
            } else {
                this.seeBtn = 'See less';
                this.expanded = true;
            }
        }
    },

    created: function created() {
        var _this4 = this;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["i" /* MovieMetaService */].getMovieMeta()).then(function (meta) {

            if (meta.extended_regions_data != undefined) {
                for (var i = 0; i < meta.extended_regions_data.length; i++) {
                    if (meta.extended_regions_data[i] != undefined) {
                        if (meta.extended_regions_data[i].cinema_id == _this4.order.CinemaId) {
                            _this4.currency = meta.extended_regions_data[i].currency_symbol;
                        }
                    }
                }
            }
        });
    },


    computed: {
        ticketsGrouped: function ticketsGrouped() {},
        classes: function classes() {
            return {
                'ticket-component-ticket': true,
                'ticket-component-ticket--active': this.expanded
            };
        }
    }
});

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleDeleteDialog),
      callback: function($$v) {
        _vm.toggleDeleteDialog = $$v
      },
      expression: "toggleDeleteDialog"
    }
  }, [_c('span', [_vm._v("Are you sure you want to delete this movie?")]), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": 20
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.confirmDelete()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDeleteDialog = false
      }
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), (_vm.session && _vm.session.movie) ? _c('div', {
    staticClass: "ticket-component-wrapper"
  }, [_c('div', {
    staticClass: "ticket-component-content"
  }, [_c('sk-title-heading', {
    attrs: {
      "h6": "",
      "label": _vm.session.movie.title
    }
  }, [_c('template', {
    slot: "append"
  }, [(!_vm.activeOrder) ? _c('sk-button', {
    attrs: {
      "link": "",
      "small": "",
      "block": _vm.$breakpoints.sm,
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.editBasketItem(_vm.session.SessionId)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), _c('sk-button', {
    attrs: {
      "link": "",
      "small": "",
      "block": _vm.$breakpoints.sm,
      "loading": _vm.loadingDelete
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.promtDelete(_vm.order.Session.SessionId)
      }
    }
  }, [_vm._v("Delete")])], 1)], 2), _vm._v(" "), _c('span', {
    staticClass: "label label--invert"
  }, [_vm._v(_vm._s(_vm.order.Session.movie.rating))]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "movie-poster"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.session.movie.poster,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "movie-details"
  }, [_c('div', {
    staticClass: "movie-details--content"
  }, [_vm._l((_vm.ticketsGrouped), function(ticketObject, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(ticketObject.Quantity) + " x Ticket"), ((ticketObject.Quantity > 1)) ? _c('span', [_vm._v("s")]) : _vm._e()])
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cinema.name))])], 2), _vm._v(" "), (_vm.session.SessionDate) ? _c('div', {
    staticClass: "movie-details--content"
  }, [_c('p', [_vm._v(_vm._s(_vm.session.SessionDate.additional.string_short_day_of_week) + " " + _vm._s(_vm.session.SessionDate.additional.day) + " " + _vm._s(_vm.session.SessionDate.additional.string_long_month))]), _vm._v(" "), (_vm.session.SessionDate && _vm.session.SessionEndDate) ? _c('span', [_vm._v(_vm._s(_vm.session.SessionDate.additional.no_zero_hour_24) + ":" + _vm._s(_vm.session.SessionDate.additional.minute) + " - " + _vm._s(_vm.session.SessionEndDate.additional.no_zero_hour_24) + ":" + _vm._s(_vm.session.SessionEndDate.additional.minute))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.expandTickets($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.seeBtn))])], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-y-transition"
    }
  }, [(_vm.ticketsGrouped && _vm.expanded) ? _c('div', {
    staticClass: "ticket-component-seats"
  }, [_c('h6', {
    staticClass: "ticket-component-content--heading"
  }, [_vm._v("Your Seats")]), _vm._v(" "), _c('sk-list', _vm._l((_vm.ticketsGrouped), function(ticketObject, TicketType) {
    return _c('sk-list-item', {
      key: TicketType
    }, [_c('sk-ticket-seats', {
      attrs: {
        "ticket-obj": ticketObject,
        "ticket-type": TicketType,
        "seat": "F1",
        "currency": _vm.currency
      }
    })], 1)
  }))], 1) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), _c('sk-dialog', {
    staticClass: "video",
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.showWarning),
      callback: function($$v) {
        _vm.showWarning = $$v
      },
      expression: "showWarning"
    }
  }, [_c('h3', [_vm._v("Please add tickets to your current movie first!")]), _vm._v(" "), _c('p', [_vm._v("you need to add tickets to this movie first before editing the other.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showWarning = false
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(952),
  /* template */
  __webpack_require__(953),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hasta_la_vista_ui_core__);



/* harmony default export */ __webpack_exports__["default"] = ({

    props: {
        order: Object,
        cinema: Object,
        activeOrder: Boolean
    },

    data: function data() {
        return {
            movie: {},

            toggleDeleteDialog: false,
            deleteId: null,
            regions: null,
            loadingDelete: false,
            currency: "R"
        };
    },


    methods: {
        promtDelete: function promtDelete(deleteId) {
            this.toggleDeleteDialog = true;
            this.deleteId = deleteId;
        },
        cancelDelete: function cancelDelete() {
            this.toggleDeleteDialog = false;
            this.deleteId = null;
        },
        confirmDelete: function confirmDelete() {
            var _this = this;

            this.loadingDelete = true;
            this.toggleDeleteDialog = false;
            __WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["k" /* OrderService */].removeSession(this.order.Session.SessionId).then(function (cancelled) {
                _this.loadingDelete = false;
                _this.$emit('deleteMovie');
            });
        }
    },

    computed: {
        ticketsGrouped: function ticketsGrouped() {
            if (!this.order || !this.order.Tickets) return [];

            var tickets = this.order.Tickets.reduce(function (collection, ticket) {

                var key = ticket.Description;
                collection[key] = collection[key] || {
                    Description: ticket.Description,
                    PriceInCents: 0,
                    Quantity: 0
                };
                collection[key].PriceInCents += ticket.PriceCents;
                collection[key].Quantity++;
                return collection;
            }, {});

            return tickets;
        },
        total: function total() {
            if (!this.order || !this.order.Tickets) return 'R0.00';

            for (var t = 0; t <= this.order.Tickets.length; t++) {
                var ticket = this.order.Tickets[t];
            }

            var totalTicketPrice = this.order.Tickets.reduce(function (v, t) {
                return v += t.price;
            }, 0);
            var ConcessionTotal = this.order && this.order.Concessions ? this.order.Concessions.reduce(function (c, t) {
                return c += t.PriceInCents * t.Quantity;
            }, 0) : 0;
            totalTicketPrice += ConcessionTotal / 100;
            var priceFormatted = totalTicketPrice.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            return 'R' + priceFormatted;
        }
    },
    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_1_hasta_la_vista_middleware_api_service__["i" /* MovieMetaService */].getMovieMeta()).then(function (meta) {

            if (meta.extended_regions_data != undefined) {
                for (var i = 0; i < meta.extended_regions_data.length; i++) {
                    if (meta.extended_regions_data[i] != undefined) {
                        if (meta.extended_regions_data[i].cinema_id == _this2.order.CinemaId) {
                            _this2.currency = meta.extended_regions_data[i].currency_symbol;
                        }
                    }
                }
            }
        });
    }
});

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleDeleteDialog),
      callback: function($$v) {
        _vm.toggleDeleteDialog = $$v
      },
      expression: "toggleDeleteDialog"
    }
  }, [_c('span', [_vm._v("Are you sure you want to delete this movie?")]), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": 20
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.confirmDelete()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDeleteDialog = false
      }
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), (_vm.order && _vm.order.Session && _vm.order.Session.movie) ? _c('div', {
    staticClass: "ticket-component-wrapper"
  }, [_c('div', {
    staticClass: "ticket-component-content"
  }, [_c('sk-title-heading', {
    attrs: {
      "h6": "",
      "label": _vm.order.Session.movie.title
    }
  }, [_c('template', {
    slot: "append"
  }, [(!_vm.activeOrder) ? _c('sk-button', {
    attrs: {
      "link": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.editBasketItem(_vm.order.Session.SessionId)
      }
    }
  }, [_vm._v("Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.order.Sessions.length > 1) ? _c('sk-button', {
    attrs: {
      "link": "",
      "small": "",
      "loading": _vm.loadingDelete
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.promtDelete(_vm.order.Session.SessionId)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('span', {
    staticClass: "label label--invert"
  }, [_vm._v(_vm._s(_vm.order.Session.movie.rating))]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "movie-poster"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.order.Session.movie.poster,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "movie-details"
  }, [_c('div', {
    staticClass: "movie-details--content"
  }, [(_vm.order.Tickets.length > 0) ? _c('p', [_vm._v(_vm._s(_vm.order.Tickets.length) + " x Ticket"), ((_vm.order.Tickets.length > 1)) ? _c('span', [_vm._v("s")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cinema.name))])]), _vm._v(" "), (_vm.order.SessionDate) ? _c('div', {
    staticClass: "movie-details--content"
  }, [(_vm.order.SessionDate) ? _c('p', [_vm._v(_vm._s(_vm.order.SessionDate.additional.string_short_day_of_week) + "\n                                " + _vm._s(_vm.order.SessionDate.additional.day) + "\n                                " + _vm._s(_vm.order.SessionDate.additional.string_long_month))]) : _vm._e(), _vm._v(" "), (_vm.order.SessionDate && _vm.order.SessionEndDate) ? _c('span', [_vm._v(_vm._s(_vm.order.SessionDate.additional.no_zero_hour_24) + ":" + _vm._s(_vm.order.SessionDate.additional.minute) + "  - " + _vm._s(_vm.order.SessionEndDate.additional.no_zero_hour_24) + ":" + _vm._s(_vm.order.SessionEndDate.additional.minute) + " ")]) : _vm._e()]) : _vm._e()])])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.ticketsGrouped) ? _c('div', {
    staticClass: "ticket-component-wrapper"
  }, [_c('div', {
    staticClass: "ticket-component-content"
  }, [_c('h6', {
    staticClass: "ticket-component-content--heading"
  }, [_vm._v("Your Seats")]), _vm._v(" "), _vm._l((_vm.ticketsGrouped), function(ticketObject, TicketType) {
    return _c('div', {
      key: TicketType
    }, [_c('sk-ticket-seats', {
      attrs: {
        "ticket-obj": ticketObject,
        "ticket-type": TicketType,
        "seat": "F1",
        "currency": _vm.currency
      }
    })], 1)
  })], 2)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })
],[397]);


// WEBPACK FOOTER //
// static/js/app.2f1849ec613537f285b4.js